import { a as __toESM, i as __esmMin, n as init_dist$1, r as __commonJSMin, t as global } from "./dist-zSRDLftX.js";
//#region ../../../../packages/models/dist/moderation/abuse/abuse-reason.model.js
var AbusePredefinedReasons = {
	VIOLENT_OR_REPULSIVE: 1,
	HATEFUL_OR_ABUSIVE: 2,
	SPAM_OR_MISLEADING: 3,
	PRIVACY: 4,
	RIGHTS: 5,
	SERVER_RULES: 6,
	THUMBNAILS: 7,
	CAPTIONS: 8
};
Object.assign({}, {
	"filter:api.trending-videos.videos.list.params": true,
	"filter:api.trending-videos.videos.list.result": true,
	"filter:api.most-liked-videos.videos.list.params": true,
	"filter:api.most-liked-videos.videos.list.result": true,
	"filter:api.local-videos.videos.list.params": true,
	"filter:api.local-videos.videos.list.result": true,
	"filter:api.recently-added-videos.videos.list.params": true,
	"filter:api.recently-added-videos.videos.list.result": true,
	"filter:api.browse-videos.videos.list.params": true,
	"filter:api.browse-videos.videos.list.result": true,
	"filter:api.user-subscriptions-videos.videos.list.params": true,
	"filter:api.user-subscriptions-videos.videos.list.result": true,
	"filter:api.video-watch.video.get.params": true,
	"filter:api.video-watch.video.get.result": true,
	"filter:api.video-watch.video-playlist-elements.get.params": true,
	"filter:api.video-watch.video-playlist-elements.get.result": true,
	"filter:api.video-watch.video-threads.list.params": true,
	"filter:api.video-watch.video-threads.list.result": true,
	"filter:api.video-watch.video-thread-replies.list.params": true,
	"filter:api.video-watch.video-thread-replies.list.result": true,
	"filter:api.search.videos.list.params": true,
	"filter:api.search.videos.list.result": true,
	"filter:api.search.video-channels.list.params": true,
	"filter:api.search.video-channels.list.result": true,
	"filter:api.search.video-playlists.list.params": true,
	"filter:api.search.video-playlists.list.result": true,
	"filter:api.signup.registration.create.params": true,
	"filter:api.my-library.video-playlist-elements.list.params": true,
	"filter:api.my-library.video-playlist-elements.list.result": true,
	"filter:internal.video-watch.player.build-options.params": true,
	"filter:internal.video-watch.player.build-options.result": true,
	"filter:internal.video-watch.player.load-options.params": true,
	"filter:internal.video-watch.player.load-options.result": true,
	"filter:internal.common.svg-icons.get-content.params": true,
	"filter:internal.common.svg-icons.get-content.result": true,
	"filter:left-menu.links.create.result": true,
	"filter:upload.messages.create.result": true,
	"filter:login.instance-about-plugin-panels.create.result": true,
	"filter:signup.instance-about-plugin-panels.create.result": true,
	"filter:share.video-embed-code.build.params": true,
	"filter:share.video-embed-code.build.result": true,
	"filter:share.video-playlist-embed-code.build.params": true,
	"filter:share.video-playlist-embed-code.build.result": true,
	"filter:share.video-embed-url.build.params": true,
	"filter:share.video-embed-url.build.result": true,
	"filter:share.video-playlist-embed-url.build.params": true,
	"filter:share.video-playlist-embed-url.build.result": true,
	"filter:share.video-url.build.params": true,
	"filter:share.video-url.build.result": true,
	"filter:share.video-playlist-url.build.params": true,
	"filter:share.video-playlist-url.build.result": true,
	"filter:video-watch.video-plugin-metadata.result": true,
	"filter:internal.player.videojs.options.result": true,
	"filter:internal.player.p2p-media-loader.options.result": true,
	"filter:admin-users-list.bulk-actions.create.result": true,
	"filter:admin-video-comments-list.actions.create.result": true,
	"filter:admin-video-comments-list.bulk-actions.create.result": true,
	"filter:user-moderation.actions.create.result": true,
	"filter:admin-abuse-list.actions.create.result": true
}, {
	"action:application.init": true,
	"action:video-watch.init": true,
	"action:video-watch.video.loaded": true,
	"action:video-watch.player.loaded": true,
	"action:video-watch.video-threads.loaded": true,
	"action:video-watch.video-thread-replies.loaded": true,
	"action:video-channel-create.init": true,
	"action:video-channel-update.init": true,
	"action:video-channel-update.video-channel.loaded": true,
	"action:video-channel-videos.init": true,
	"action:video-channel-videos.video-channel.loaded": true,
	"action:video-channel-videos.videos.loaded": true,
	"action:video-channel-playlists.init": true,
	"action:video-channel-playlists.video-channel.loaded": true,
	"action:video-channel-playlists.playlists.loaded": true,
	"action:video-edit.init": true,
	"action:video-edit.form.updated": true,
	"action:login.init": true,
	"action:search.init": true,
	"action:router.navigation-end": true,
	"action:signup.register.init": true,
	"action:admin-plugin-settings.init": true,
	"action:video-upload.init": true,
	"action:video-url-import.init": true,
	"action:video-torrent-import.init": true,
	"action:go-live.init": true,
	"action:auth-user.logged-in": true,
	"action:auth-user.logged-out": true,
	"action:auth-user.information-loaded": true,
	"action:modal.video-download.shown": true,
	"action:modal.share.shown": true,
	"action:embed.player.loaded": true
});
Object.assign({}, {
	"filter:api.videos.list.params": true,
	"filter:api.videos.list.result": true,
	"filter:api.video-playlist.videos.list.params": true,
	"filter:api.video-playlist.videos.list.result": true,
	"filter:api.accounts.videos.list.params": true,
	"filter:api.accounts.videos.list.result": true,
	"filter:api.video-channels.videos.list.params": true,
	"filter:api.video-channels.videos.list.result": true,
	"filter:api.user.me.videos.list.params": true,
	"filter:api.user.me.videos.list.result": true,
	"filter:api.overviews.videos.list.params": true,
	"filter:api.overviews.videos.list.result": true,
	"filter:api.user.me.subscription-videos.list.params": true,
	"filter:api.user.me.subscription-videos.list.result": true,
	"filter:api.search.videos.local.list.params": true,
	"filter:api.search.videos.local.list.result": true,
	"filter:api.search.videos.index.list.params": true,
	"filter:api.search.videos.index.list.result": true,
	"filter:api.search.video-channels.local.list.params": true,
	"filter:api.search.video-channels.local.list.result": true,
	"filter:api.search.video-channels.index.list.params": true,
	"filter:api.search.video-channels.index.list.result": true,
	"filter:api.search.video-playlists.local.list.params": true,
	"filter:api.search.video-playlists.local.list.result": true,
	"filter:api.search.video-playlists.index.list.params": true,
	"filter:api.search.video-playlists.index.list.result": true,
	"filter:api.video.get.result": true,
	"filter:api.video-channels.list.params": true,
	"filter:api.video-channels.list.result": true,
	"filter:api.video-channel.get.result": true,
	"filter:api.video.upload.accept.result": true,
	"filter:api.live-video.create.accept.result": true,
	"filter:api.video.pre-import-url.accept.result": true,
	"filter:api.video.pre-import-torrent.accept.result": true,
	"filter:api.video.post-import-url.accept.result": true,
	"filter:api.video.post-import-torrent.accept.result": true,
	"filter:api.video.update-file.accept.result": true,
	"filter:api.video.user-import.accept.result": true,
	"filter:api.video-thread.create.accept.result": true,
	"filter:api.video-comment-reply.create.accept.result": true,
	"filter:api.video.upload.video-attribute.result": true,
	"filter:api.video.import-url.video-attribute.result": true,
	"filter:api.video.import-torrent.video-attribute.result": true,
	"filter:api.video.live.video-attribute.result": true,
	"filter:api.video.user-import.video-attribute.result": true,
	"filter:api.video-threads.list.params": true,
	"filter:api.video-threads.list.result": true,
	"filter:api.video-thread-comments.list.params": true,
	"filter:api.video-thread-comments.list.result": true,
	"filter:api.server.stats.get.result": true,
	"filter:video.auto-blacklist.result": true,
	"filter:api.user.signup.allowed.result": true,
	"filter:api.user.signup.requires-approval.result": true,
	"filter:api.user.request-signup.allowed.result": true,
	"filter:api.download.video.allowed.result": true,
	"filter:api.download.generated-video.allowed.result": true,
	"filter:api.download.torrent.allowed.result": true,
	"filter:html.embed.video.allowed.result": true,
	"filter:html.embed.video-playlist.allowed.result": true,
	"filter:html.client.json-ld.result": true,
	"filter:job-queue.process.params": true,
	"filter:job-queue.process.result": true,
	"filter:transcoding.manual.resolutions-to-transcode.result": true,
	"filter:transcoding.auto.resolutions-to-transcode.result": true,
	"filter:activity-pub.remote-video-comment.create.accept.result": true,
	"filter:activity-pub.activity.context.build.result": true,
	"filter:activity-pub.video.json-ld.build.result": true,
	"filter:feed.podcast.rss.create-custom-xmlns.result": true,
	"filter:feed.podcast.channel.create-custom-tags.result": true,
	"filter:feed.podcast.video-playlist.create-custom-tags.result": true,
	"filter:feed.podcast.video.create-custom-tags.result": true,
	"filter:api.user.me.get.result": true,
	"filter:oauth.password-grant.get-user.params": true,
	"filter:api.email-verification.ask-send-verify-email.body": true,
	"filter:api.users.ask-reset-password.body": true,
	"filter:email.subject.result": true,
	"filter:email.template-path.result": true,
	"filter:notifier.notification.enabled.result": true,
	"filter:feed.videos.list.result": true
}, {
	"action:application.listening": true,
	"action:notifier.notification.created": true,
	"action:api.video.updated": true,
	"action:api.video.deleted": true,
	"action:api.video.uploaded": true,
	"action:api.video.viewed": true,
	"action:api.video.file-updated": true,
	"action:api.video-channel.created": true,
	"action:api.video-channel.updated": true,
	"action:api.video-channel.deleted": true,
	"action:api.live-video.created": true,
	"action:live.video.state.updated": true,
	"action:api.video-thread.created": true,
	"action:api.video-comment-reply.created": true,
	"action:api.video-comment.deleted": true,
	"action:api.video-caption.created": true,
	"action:api.video-caption.deleted": true,
	"action:api.user.blocked": true,
	"action:api.user.unblocked": true,
	"action:api.user.registered": true,
	"action:api.user.requested-registration": true,
	"action:api.user.created": true,
	"action:api.user.deleted": true,
	"action:api.user.updated": true,
	"action:api.user.oauth2-got-token": true,
	"action:api.video-playlist-element.created": true,
	"action:activity-pub.remote-video.created": true,
	"action:activity-pub.remote-video.updated": true
});
//#endregion
//#region ../../../../packages/models/dist/users/user-right.enum.js
var UserRight = {
	ALL: 0,
	MANAGE_USERS: 1,
	MANAGE_SERVER_FOLLOW: 2,
	MANAGE_LOGS: 3,
	MANAGE_DEBUG: 4,
	MANAGE_SERVER_REDUNDANCY: 5,
	MANAGE_ABUSES: 6,
	MANAGE_JOBS: 7,
	MANAGE_CONFIGURATION: 8,
	MANAGE_INSTANCE_CUSTOM_PAGE: 9,
	MANAGE_ACCOUNTS_BLOCKLIST: 10,
	MANAGE_SERVERS_BLOCKLIST: 11,
	MANAGE_VIDEO_BLACKLIST: 12,
	MANAGE_ANY_VIDEO_CHANNEL: 13,
	REMOVE_ANY_VIDEO: 14,
	REMOVE_ANY_VIDEO_PLAYLIST: 15,
	MANAGE_ANY_VIDEO_COMMENT: 16,
	UPDATE_ANY_VIDEO: 17,
	UPDATE_ANY_VIDEO_PLAYLIST: 18,
	GET_ANY_LIVE: 19,
	SEE_ALL_VIDEOS: 20,
	SEE_ALL_COMMENTS: 21,
	CHANGE_VIDEO_OWNERSHIP: 22,
	MANAGE_PLUGINS: 23,
	MANAGE_VIDEOS_REDUNDANCIES: 24,
	MANAGE_VIDEO_FILES: 25,
	RUN_VIDEO_TRANSCODING: 26,
	MANAGE_VIDEO_IMPORTS: 27,
	MANAGE_REGISTRATIONS: 28,
	MANAGE_RUNNERS: 29,
	MANAGE_USER_EXPORTS: 30,
	MANAGE_USER_IMPORTS: 31,
	MANAGE_INSTANCE_WATCHED_WORDS: 32,
	MANAGE_INSTANCE_AUTO_TAGS: 33
};
//#endregion
//#region ../../../../packages/models/dist/users/user-role.js
var UserRole = {
	ADMINISTRATOR: 0,
	MODERATOR: 1,
	USER: 2
};
//#endregion
//#region ../../../../packages/models/dist/videos/live/live-video-latency-mode.enum.js
var LiveVideoLatencyMode = {
	DEFAULT: 1,
	HIGH_LATENCY: 2,
	SMALL_LATENCY: 3
};
//#endregion
//#region ../../../../packages/models/dist/videos/file/video-resolution.enum.js
var VideoResolution = {
	H_NOVIDEO: 0,
	H_144P: 144,
	H_240P: 240,
	H_360P: 360,
	H_480P: 480,
	H_720P: 720,
	H_1080P: 1080,
	H_1440P: 1440,
	H_4K: 2160
};
//#endregion
//#region ../../../../packages/models/dist/videos/nsfw-flag.enum.js
var NSFWFlag = {
	NONE: 0,
	VIOLENT: 1,
	EXPLICIT_SEX: 2
};
NSFWFlag.VIOLENT, NSFWFlag.EXPLICIT_SEX;
NSFWFlag.VIOLENT, NSFWFlag.EXPLICIT_SEX;
AbusePredefinedReasons.VIOLENT_OR_REPULSIVE, AbusePredefinedReasons.HATEFUL_OR_ABUSIVE, AbusePredefinedReasons.SPAM_OR_MISLEADING, AbusePredefinedReasons.PRIVACY, AbusePredefinedReasons.RIGHTS, AbusePredefinedReasons.SERVER_RULES, AbusePredefinedReasons.THUMBNAILS, AbusePredefinedReasons.CAPTIONS;
//#endregion
//#region ../../../../packages/core-utils/dist/common/array.js
function shuffle(elements) {
	const shuffled = [...elements];
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	return shuffled;
}
function maxBy(arr, property) {
	let result;
	for (const obj of arr) if (!result || result[property] < obj[property]) result = obj;
	return result;
}
//#endregion
//#region ../../../../packages/core-utils/dist/common/date.js
var timecodeRegexString = `(\\d+[h:])?(\\d+[m:])?\\d+s?`;
function timeToInt(time) {
	if (!time) return 0;
	if (typeof time === "number") return Math.floor(time);
	const reg = new RegExp(`^((?<hours>\\d+)h)?((?<minutes>\\d+)m)?((?<seconds>\\d+)s?)?$`);
	const matches = time.match(reg);
	if (matches) {
		const hours = parseInt(matches.groups["hours"] || "0", 10);
		const minutes = parseInt(matches.groups["minutes"] || "0", 10);
		const seconds = parseInt(matches.groups["seconds"] || "0", 10);
		return hours * 3600 + minutes * 60 + seconds;
	}
	const parts = time.split(":").reverse();
	const iMultiplier = {
		0: 1,
		1: 60,
		2: 3600
	};
	let result = 0;
	for (let i = 0; i < parts.length; i++) {
		const partInt = parseInt(parts[i], 10);
		if (isNaN(partInt)) return 0;
		result += iMultiplier[i] * partInt;
	}
	return result;
}
function secondsToTime(options) {
	let seconds;
	let format = "short";
	let symbol;
	if (typeof options === "number") seconds = options;
	else {
		seconds = options.seconds;
		format = options.format ?? "short";
		symbol = options.symbol;
	}
	let time = "";
	if (seconds === 0 && format !== "full") return "0s";
	const formatNumber = (value) => {
		if (format === "locale-string") return value.toLocaleString();
		return value;
	};
	const hourSymbol = symbol || "h";
	const minuteSymbol = symbol || "m";
	const secondsSymbol = format === "full" ? "" : "s";
	const hours = Math.floor(seconds / 3600);
	if (hours >= 1 && hours < 10 && format === "full") time = "0" + hours + hourSymbol;
	else if (hours >= 1) time = formatNumber(hours) + hourSymbol;
	else if (format === "full") time = "00" + hourSymbol;
	seconds %= 3600;
	const minutes = Math.floor(seconds / 60);
	if (minutes >= 1 && minutes < 10 && format === "full") time += "0" + minutes + minuteSymbol;
	else if (minutes >= 1) time += formatNumber(minutes) + minuteSymbol;
	else if (format === "full") time += "00" + minuteSymbol;
	seconds = Math.round(seconds) % 60;
	if (seconds >= 1 && seconds < 10 && format === "full") time += "0" + seconds + secondsSymbol;
	else if (seconds >= 1) time += formatNumber(seconds) + secondsSymbol;
	else if (format === "full") time += "00";
	return time;
}
//#endregion
//#region ../../../../packages/core-utils/dist/common/image.js
function findAppropriateThumbnail(images, wantedWidth, ratio) {
	if (!images) return null;
	return findAppropriateImage(images.filter((img) => img.aspectRatio === ratio), wantedWidth);
}
function findAppropriateImage(images, wantedWidth) {
	if (!wantedWidth) throw new Error("Invalid width to find appropriate image");
	if (!images || images.length === 0) return void 0;
	let candidate;
	for (const img of images) if (img.width >= wantedWidth && (!candidate || img.width < candidate.width)) candidate = img;
	return candidate || maxBy(images, "width");
}
//#endregion
//#region ../../../../packages/core-utils/dist/common/object.js
function pick(object, keys) {
	const result = {};
	for (const key of keys) if (Object.prototype.hasOwnProperty.call(object, key)) result[key] = object[key];
	return result;
}
function omit(object, keys) {
	const result = {};
	const keysSet = new Set(keys);
	for (const [key, value] of Object.entries(object)) {
		if (keysSet.has(key)) continue;
		result[key] = value;
	}
	return result;
}
function exists(value) {
	return value !== void 0 && value !== null;
}
//#endregion
//#region ../../../../packages/core-utils/dist/common/url.js
function addQueryParams(url, params, baseUrl) {
	const objUrl = new URL(url, baseUrl);
	for (const key of Object.keys(params)) objUrl.searchParams.append(key, params[key]);
	return objUrl.toString();
}
function removeQueryParams(url, baseUrl) {
	const objUrl = new URL(url, baseUrl);
	objUrl.searchParams.forEach((_v, k) => objUrl.searchParams.delete(k));
	return objUrl.toString();
}
function buildVideoWatchPath(video) {
	return "/w/" + video.shortUUID;
}
function buildVideoLink(video, base) {
	return (base ?? window.location.origin) + buildVideoWatchPath(video);
}
function decorateVideoLink(options) {
	const { url } = options;
	const params = new URLSearchParams();
	if (options.startTime !== void 0 && options.startTime !== null) {
		const startTimeInt = Math.floor(options.startTime);
		params.set("start", secondsToTime(startTimeInt));
	}
	if (options.stopTime) {
		const stopTimeInt = Math.floor(options.stopTime);
		params.set("stop", secondsToTime(stopTimeInt));
	}
	if (options.subtitle) params.set("subtitle", options.subtitle);
	if (options.loop === true) params.set("loop", "1");
	if (options.autoplay === true) params.set("autoplay", "1");
	if (options.muted === true) params.set("muted", "1");
	if (options.title === false) params.set("title", "0");
	if (options.warningTitle === false) params.set("warningTitle", "0");
	if (options.controls === false) params.set("controls", "0");
	if (options.controlBar === false) params.set("controlBar", "0");
	if (options.peertubeLink === false) params.set("peertubeLink", "0");
	if (options.p2p !== void 0) params.set("p2p", options.p2p ? "1" : "0");
	if (options.api !== void 0) params.set("api", options.api ? "1" : "0");
	if (options.version !== void 0) params.set("v", options.version + "");
	return buildUrl(url, params);
}
function buildUrl(url, params) {
	let hasParams = false;
	params.forEach(() => {
		hasParams = true;
	});
	if (hasParams) return url + "?" + params.toString();
	return url;
}
//#endregion
//#region ../../../../packages/core-utils/dist/i18n/i18n.js
var I18N_LOCALES = {
	"en-US": "English",
	"ar": "العربية",
	"ca-ES": "Català",
	"cs-CZ": "Čeština",
	"de-DE": "Deutsch",
	"el-GR": "ελληνικά",
	"eo": "Esperanto",
	"es-ES": "Español",
	"eu-ES": "Euskara",
	"fa-IR": "فارسی",
	"fi-FI": "Suomi",
	"fr-FR": "Français",
	"gd": "Gàidhlig",
	"gl-ES": "Galego",
	"hr": "Hrvatski",
	"hu-HU": "Magyar",
	"is": "Íslenska",
	"it-IT": "Italiano",
	"ja-JP": "日本語",
	"ka": "ქართული ენა",
	"kab": "Taqbaylit",
	"ko-KR": "한국어",
	"nb-NO": "Norsk bokmål",
	"nl-NL": "Nederlands",
	"nn": "Norsk nynorsk",
	"oc": "Occitan",
	"pl-PL": "Polski",
	"pt-BR": "Português (Brasil)",
	"pt-PT": "Português (Portugal)",
	"ro": "Română",
	"ru-RU": "Pусский",
	"sk-SK": "Slovenčina",
	"sq": "Shqip",
	"sv-SE": "Svenska",
	"th-TH": "ไทย",
	"tok": "Toki Pona",
	"tr-TR": "Türkçe",
	"uk-UA": "украї́нська мо́ва",
	"vi-VN": "Tiếng Việt",
	"zh-Hans-CN": "简体中文（中国）",
	"zh-Hant-TW": "繁體中文（台灣）"
};
var I18N_LOCALE_ALIAS = {
	"ar-001": "ar",
	"ca": "ca-ES",
	"cs": "cs-CZ",
	"de": "de-DE",
	"el": "el-GR",
	"en": "en-US",
	"es": "es-ES",
	"eu": "eu-ES",
	"fa": "fa-IR",
	"fi": "fi-FI",
	"fr": "fr-FR",
	"gl": "gl-ES",
	"hu": "hu-HU",
	"it": "it-IT",
	"ja": "ja-JP",
	"ko": "ko-KR",
	"nb": "nb-NO",
	"nl": "nl-NL",
	"pl": "pl-PL",
	"pt": "pt-BR",
	"ru": "ru-RU",
	"sk": "sk-SK",
	"sv": "sv-SE",
	"th": "th-TH",
	"tr": "tr-TR",
	"uk": "uk-UA",
	"vi": "vi-VN",
	"zh-CN": "zh-Hans-CN",
	"zh-Hans": "zh-Hans-CN",
	"zh-Hant": "zh-Hant-TW",
	"zh-TW": "zh-Hant-TW",
	"zh": "zh-Hans-CN"
};
var AVAILABLE_LOCALES = Object.keys(I18N_LOCALES).concat(Object.keys(I18N_LOCALE_ALIAS));
function getDefaultLocale() {
	return "en-US";
}
function isDefaultLocale(locale) {
	return getCompleteLocale(locale) === getCompleteLocale(getDefaultLocale());
}
AVAILABLE_LOCALES.map((l) => "/" + l);
function is18nLocale(locale) {
	return AVAILABLE_LOCALES.includes(locale);
}
function getCompleteLocale(locale) {
	if (!locale) return locale;
	return I18N_LOCALE_ALIAS[locale] || locale;
}
function getShortLocale(locale) {
	if (locale.includes("-") === false) return locale;
	return locale.split("-")[0];
}
//#endregion
//#region ../../../../packages/core-utils/dist/renderer/markdown.js
var TEXT_RULES = [
	"linkify",
	"autolink",
	"emphasis",
	"link",
	"newline",
	"entity",
	"list"
];
var TEXT_WITH_HTML_RULES = TEXT_RULES.concat(["html_inline", "html_block"]);
TEXT_RULES.concat(["image"]);
TEXT_WITH_HTML_RULES.concat(["image"]).concat([
	"block",
	"inline",
	"heading",
	"paragraph"
]);
UserRole.USER, UserRole.MODERATOR, UserRole.ADMINISTRATOR;
UserRole.ADMINISTRATOR, UserRight.ALL, UserRole.MODERATOR, UserRight.MANAGE_VIDEO_BLACKLIST, UserRight.MANAGE_ABUSES, UserRight.MANAGE_ANY_VIDEO_CHANNEL, UserRight.REMOVE_ANY_VIDEO, UserRight.REMOVE_ANY_VIDEO_PLAYLIST, UserRight.MANAGE_ANY_VIDEO_COMMENT, UserRight.UPDATE_ANY_VIDEO, UserRight.SEE_ALL_VIDEOS, UserRight.MANAGE_ACCOUNTS_BLOCKLIST, UserRight.MANAGE_SERVERS_BLOCKLIST, UserRight.MANAGE_USERS, UserRight.SEE_ALL_COMMENTS, UserRight.MANAGE_REGISTRATIONS, UserRight.MANAGE_INSTANCE_WATCHED_WORDS, UserRight.MANAGE_INSTANCE_AUTO_TAGS, UserRole.USER;
VideoResolution.H_NOVIDEO, VideoResolution.H_144P, VideoResolution.H_240P, VideoResolution.H_360P, VideoResolution.H_480P, VideoResolution.H_720P, VideoResolution.H_1080P, VideoResolution.H_1440P, VideoResolution.H_4K;
VideoResolution.H_NOVIDEO, VideoResolution.H_144P, VideoResolution.H_240P, VideoResolution.H_360P, VideoResolution.H_480P, VideoResolution.H_720P, VideoResolution.H_1080P, VideoResolution.H_1440P, VideoResolution.H_4K;
VideoResolution.H_NOVIDEO, VideoResolution.H_144P, VideoResolution.H_240P, VideoResolution.H_360P, VideoResolution.H_480P, VideoResolution.H_720P, VideoResolution.H_1080P, VideoResolution.H_1440P, VideoResolution.H_4K;
//#endregion
//#region ../../../../packages/core-utils/dist/videos/common.js
var classicResolutions = new Set([
	VideoResolution.H_NOVIDEO,
	VideoResolution.H_144P,
	VideoResolution.H_240P,
	VideoResolution.H_360P,
	VideoResolution.H_480P,
	VideoResolution.H_720P,
	VideoResolution.H_1080P,
	VideoResolution.H_1440P,
	VideoResolution.H_4K
]);
var resolutionConverter = {
	3840: VideoResolution.H_4K,
	1920: VideoResolution.H_1080P,
	1280: VideoResolution.H_720P,
	854: VideoResolution.H_480P,
	640: VideoResolution.H_360P,
	426: VideoResolution.H_240P,
	256: VideoResolution.H_144P
};
function getResolutionLabel(options) {
	const { height, width } = options;
	if (options.resolution === 0) return "Audio only";
	let resolution = options.resolution;
	if (!classicResolutions.has(resolution) && typeof height === "number" && typeof width === "number") {
		const max = Math.max(height, width);
		if (resolutionConverter[max]) resolution = resolutionConverter[max];
	}
	return `${resolution}p`;
}
function getResolutionAndFPSLabel(resolutionLabel, fps) {
	if (fps && fps >= 50) return resolutionLabel + fps;
	return resolutionLabel;
}
new RegExp(`^(${timecodeRegexString})\\s`);
//#endregion
//#region ../../root-helpers/peertube-web-storage.ts
var valuesMap = /* @__PURE__ */ new Map();
function proxify(instance) {
	return new Proxy(instance, {
		set: function(obj, prop, value) {
			if (Object.prototype.hasOwnProperty.call(MemoryStorage, prop)) instance[prop] = value;
			else instance.setItem(prop, value);
			return true;
		},
		get: function(target, name) {
			if (typeof instance[name] === "function") return instance[name];
			else if (valuesMap.has(name)) return instance.getItem(name);
		}
	});
}
var MemoryStorage = class {
	getItem(key) {
		const stringKey = String(key);
		if (valuesMap.has(key)) return String(valuesMap.get(stringKey));
		return null;
	}
	setItem(key, val) {
		valuesMap.set(String(key), String(val));
	}
	removeItem(key) {
		valuesMap.delete(key);
	}
	clear() {
		valuesMap.clear();
	}
	key(i) {
		if (arguments.length === 0) throw new TypeError("Failed to execute \"key\" on \"Storage\": 1 argument required, but only 0 present.");
		return Array.from(valuesMap.keys())[i];
	}
	get length() {
		return valuesMap.size;
	}
};
var peertubeLocalStorage;
var peertubeSessionStorage;
function reinitStorage() {
	const instanceLocalStorage = new MemoryStorage();
	const instanceSessionStorage = new MemoryStorage();
	peertubeLocalStorage = proxify(instanceLocalStorage);
	peertubeSessionStorage = proxify(instanceSessionStorage);
}
try {
	peertubeLocalStorage = localStorage;
	peertubeSessionStorage = sessionStorage;
} catch (err) {
	reinitStorage();
}
if (!peertubeLocalStorage || !peertubeSessionStorage) reinitStorage();
//#endregion
//#region ../../root-helpers/users/user-local-storage-keys.ts
var UserTokenLocalStorageKeys = {
	ACCESS_TOKEN: "access_token",
	REFRESH_TOKEN: "refresh_token",
	TOKEN_TYPE: "token_type"
};
//#endregion
//#region ../../root-helpers/users/oauth-user-tokens.ts
var OAuthUserTokens = class OAuthUserTokens {
	accessToken;
	refreshToken;
	tokenType;
	constructor(hash) {
		if (hash) {
			this.accessToken = hash.accessToken;
			this.refreshToken = hash.refreshToken;
			if (hash.tokenType === "bearer") this.tokenType = "Bearer";
			else this.tokenType = hash.tokenType;
		}
	}
	static getUserTokens(localStorage) {
		const accessTokenLocalStorage = localStorage.getItem(UserTokenLocalStorageKeys.ACCESS_TOKEN);
		const refreshTokenLocalStorage = localStorage.getItem(UserTokenLocalStorageKeys.REFRESH_TOKEN);
		const tokenTypeLocalStorage = localStorage.getItem(UserTokenLocalStorageKeys.TOKEN_TYPE);
		if (!accessTokenLocalStorage || !refreshTokenLocalStorage || !tokenTypeLocalStorage) return null;
		return new OAuthUserTokens({
			accessToken: accessTokenLocalStorage,
			refreshToken: refreshTokenLocalStorage,
			tokenType: tokenTypeLocalStorage
		});
	}
	static saveToLocalStorage(localStorage, tokens) {
		localStorage.setItem(UserTokenLocalStorageKeys.ACCESS_TOKEN, tokens.accessToken);
		localStorage.setItem(UserTokenLocalStorageKeys.REFRESH_TOKEN, tokens.refreshToken);
		localStorage.setItem(UserTokenLocalStorageKeys.TOKEN_TYPE, tokens.tokenType);
	}
	static flushLocalStorage(localStorage) {
		localStorage.removeItem(UserTokenLocalStorageKeys.ACCESS_TOKEN);
		localStorage.removeItem(UserTokenLocalStorageKeys.REFRESH_TOKEN);
		localStorage.removeItem(UserTokenLocalStorageKeys.TOKEN_TYPE);
	}
};
//#endregion
//#region ../../root-helpers/logger.ts
var Logger$1 = class {
	hooks = [];
	info(message, meta) {
		this.runHooks("info", message, meta);
		if (meta) console.log(message, meta);
		else console.log(message);
	}
	warn(message, meta) {
		this.runHooks("warn", message, meta);
		this.clientWarn(message, meta);
	}
	clientWarn(message, meta) {
		if (meta) console.warn(message, meta);
		else console.warn(message);
	}
	error(message, meta) {
		this.runHooks("error", message, meta);
		this.clientError(message, meta);
	}
	clientError(message, meta) {
		if (meta) console.error(message, meta);
		else console.error(message);
	}
	addHook(level, hook) {
		this.hooks.push({
			level,
			hook
		});
	}
	registerServerSending(serverUrl) {
		this.addHook("warn", (message, meta) => this.sendClientLog(serverUrl, this.buildServerLogPayload("warn", message, meta)));
		this.addHook("error", (message, meta) => this.sendClientLog(serverUrl, this.buildServerLogPayload("error", message, meta)));
	}
	sendClientLog(serverUrl, payload) {
		if (!payload) return;
		const headers = new Headers({
			"Accept": "application/json",
			"Content-Type": "application/json"
		});
		try {
			const tokens = OAuthUserTokens.getUserTokens(peertubeLocalStorage);
			if (tokens) headers.set("Authorization", `${tokens.tokenType} ${tokens.accessToken}`);
		} catch (err) {
			console.error("Cannot set tokens to client log sender.", { err });
		}
		fetch(serverUrl + "/api/v1/server/logs/client", {
			headers,
			method: "POST",
			body: JSON.stringify(payload)
		}).catch((err) => console.error("Cannot send client warn/error to server.", err));
	}
	buildServerLogPayload(level, message, meta) {
		if (!message) return null;
		return {
			message: this.buildMessageServerLogPayload(message),
			userAgent: navigator.userAgent,
			url: window.location.href,
			level,
			stackTrace: this.buildStackServerLogPayload(message, meta),
			meta: this.buildMetaServerLogPayload(meta)
		};
	}
	buildMessageServerLogPayload(message) {
		if (typeof message === "string") return message;
		if (message instanceof Error) return message.message;
		return JSON.stringify(message);
	}
	buildStackServerLogPayload(message, meta) {
		if (message instanceof Error) return this.buildStack(message);
		if (meta instanceof Error) return this.buildStack(meta);
		if (meta?.err instanceof Error) return this.buildStack(meta.err);
	}
	buildMetaServerLogPayload(meta) {
		if (!meta) return void 0;
		if (meta instanceof Error) return void 0;
		let result;
		try {
			result = JSON.stringify(meta, (key, value) => {
				if (key === "err") return void 0;
				return value;
			});
		} catch (err) {
			console.error("Cannot stringify meta.", err);
		}
		return result;
	}
	runHooks(level, message, meta) {
		for (const hookObj of this.hooks) {
			if (hookObj.level !== level) continue;
			hookObj.hook(message, meta);
		}
	}
	buildStack(err) {
		return `${err.message}\n${err.stack || ""}`;
	}
};
var logger$1 = window.logger || new Logger$1();
window.logger = logger$1;
//#endregion
//#region ../../root-helpers/translations-manager.ts
var TranslationsManager = class TranslationsManager {
	static videojsLocaleCache = {};
	static getServerTranslations(serverUrl, locale) {
		const path = TranslationsManager.getLocalePath(serverUrl, locale);
		if (!path) return Promise.resolve(void 0);
		return fetch(path + "/server.json").then((res) => res.json()).catch((err) => {
			logger$1.error("Cannot get server translations", err);
		});
	}
	static loadLocaleInVideoJS(serverUrl, locale, videojs) {
		const path = TranslationsManager.getLocalePath(serverUrl, locale);
		if (!path) return Promise.resolve(void 0);
		let p;
		if (TranslationsManager.videojsLocaleCache[path]) p = Promise.resolve(TranslationsManager.videojsLocaleCache[path]);
		else p = fetch(path + "/player.json").then((res) => res.json()).then((json) => {
			TranslationsManager.videojsLocaleCache[path] = json;
			return json;
		}).catch((err) => {
			logger$1.error("Cannot get player translations", err);
		});
		const completeLocale = getCompleteLocale(locale);
		return p.then((json) => videojs.addLanguage(getShortLocale(completeLocale), json));
	}
	static getLocalePath(serverUrl, locale) {
		const completeLocale = getCompleteLocale(locale);
		if (!is18nLocale(completeLocale) || isDefaultLocale(completeLocale)) return void 0;
		return serverUrl + "/client/locales/" + completeLocale;
	}
};
//#endregion
//#region ../../root-helpers/utils.ts
function copyToClipboard(text, container) {
	if (!container) container = document.body;
	const el = document.createElement("textarea");
	el.value = text;
	el.setAttribute("readonly", "");
	el.style.position = "absolute";
	el.style.left = "-9999px";
	container.appendChild(el);
	el.select();
	document.execCommand("copy");
	container.removeChild(el);
}
function wait(ms) {
	return new Promise((res) => {
		setTimeout(() => res(), ms);
	});
}
//#endregion
//#region ../../root-helpers/video.ts
function buildVideoOrPlaylistEmbed(options) {
	const { embedUrl, embedTitle, aspectRatio, responsive = false } = options;
	const iframe = document.createElement("iframe");
	iframe.title = embedTitle;
	iframe.width = responsive ? "100%" : "560";
	iframe.height = responsive ? "100%" : "315";
	iframe.src = embedUrl;
	iframe.style.border = "0";
	iframe.allow = "fullscreen";
	iframe.sandbox.add("allow-same-origin", "allow-scripts", "allow-popups", "allow-forms");
	if (responsive) {
		const wrapper = document.createElement("div");
		wrapper.style.position = "relative";
		wrapper.style.paddingTop = aspectRatio ? (1 / aspectRatio * 100).toFixed(2) + "%" : "56.25%";
		iframe.style.position = "absolute";
		iframe.style.inset = "0";
		wrapper.appendChild(iframe);
		return wrapper.outerHTML;
	}
	return iframe.outerHTML;
}
//#endregion
//#region ../../root-helpers/web-browser.ts
function isIOS() {
	if (/iPad|iPhone|iPod/.test(navigator.platform)) return true;
	return !!(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && navigator.platform.includes("MacIntel"));
}
function isSafari() {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function isMobile() {
	return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
//#endregion
//#region ../../../../node_modules/.pnpm/global@4.4.0/node_modules/global/window.js
var require_window = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist$1();
	var win;
	if (typeof window !== "undefined") win = window;
	else if (typeof global !== "undefined") win = global;
	else if (typeof self !== "undefined") win = self;
	else win = {};
	module.exports = win;
}));
//#endregion
//#region __vite-browser-external
var require___vite_browser_external = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = {};
}));
//#endregion
//#region ../../../../node_modules/.pnpm/global@4.4.0/node_modules/global/document.js
var require_document = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist$1();
	var topLevel = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : {};
	var minDoc = require___vite_browser_external();
	var doccy;
	if (typeof document !== "undefined") doccy = document;
	else {
		doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
		if (!doccy) doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = minDoc;
	}
	module.exports = doccy;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/extends.js
var require_extends = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function _extends() {
		return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
			for (var e = 1; e < arguments.length; e++) {
				var t = arguments[e];
				for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
			}
			return n;
		}, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/is-function@1.0.2/node_modules/is-function/index.js
var require_is_function = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = isFunction;
	var toString = Object.prototype.toString;
	function isFunction(fn) {
		if (!fn) return false;
		var string = toString.call(fn);
		return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
	}
}));
//#endregion
//#region ../../../../node_modules/.pnpm/@videojs+xhr@2.7.0/node_modules/@videojs/xhr/lib/interceptors.js
var require_interceptors = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	function _createForOfIteratorHelperLoose(o, allowArrayLike) {
		var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
		if (it) return (it = it.call(o)).next.bind(it);
		if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
			if (it) o = it;
			var i = 0;
			return function() {
				if (i >= o.length) return { done: true };
				return {
					done: false,
					value: o[i++]
				};
			};
		}
		throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function _unsupportedIterableToArray(o, minLen) {
		if (!o) return;
		if (typeof o === "string") return _arrayLikeToArray(o, minLen);
		var n = Object.prototype.toString.call(o).slice(8, -1);
		if (n === "Object" && o.constructor) n = o.constructor.name;
		if (n === "Map" || n === "Set") return Array.from(o);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	function _arrayLikeToArray(arr, len) {
		if (len == null || len > arr.length) len = arr.length;
		for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
		return arr2;
	}
	module.exports = /* @__PURE__ */ function() {
		function InterceptorsStorage() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map();
			this.enabled_ = false;
		}
		var _proto = InterceptorsStorage.prototype;
		_proto.getIsEnabled = function getIsEnabled() {
			return this.enabled_;
		};
		_proto.enable = function enable() {
			this.enabled_ = true;
		};
		_proto.disable = function disable() {
			this.enabled_ = false;
		};
		_proto.reset = function reset() {
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map();
			this.enabled_ = false;
		};
		_proto.addInterceptor = function addInterceptor(type, interceptor) {
			if (!this.typeToInterceptorsMap_.has(type)) this.typeToInterceptorsMap_.set(type, /* @__PURE__ */ new Set());
			var interceptorsSet = this.typeToInterceptorsMap_.get(type);
			if (interceptorsSet.has(interceptor)) return false;
			interceptorsSet.add(interceptor);
			return true;
		};
		_proto.removeInterceptor = function removeInterceptor(type, interceptor) {
			var interceptorsSet = this.typeToInterceptorsMap_.get(type);
			if (interceptorsSet && interceptorsSet.has(interceptor)) {
				interceptorsSet.delete(interceptor);
				return true;
			}
			return false;
		};
		_proto.clearInterceptorsByType = function clearInterceptorsByType(type) {
			if (!this.typeToInterceptorsMap_.get(type)) return false;
			this.typeToInterceptorsMap_.delete(type);
			this.typeToInterceptorsMap_.set(type, /* @__PURE__ */ new Set());
			return true;
		};
		_proto.clear = function clear() {
			if (!this.typeToInterceptorsMap_.size) return false;
			this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map();
			return true;
		};
		_proto.getForType = function getForType(type) {
			return this.typeToInterceptorsMap_.get(type) || /* @__PURE__ */ new Set();
		};
		_proto.execute = function execute(type, payload) {
			for (var _iterator = _createForOfIteratorHelperLoose(this.getForType(type)), _step; !(_step = _iterator()).done;) {
				var interceptor = _step.value;
				try {
					payload = interceptor(payload);
				} catch (e) {}
			}
			return payload;
		};
		return InterceptorsStorage;
	}();
}));
//#endregion
//#region ../../../../node_modules/.pnpm/@videojs+xhr@2.7.0/node_modules/@videojs/xhr/lib/retry.js
var require_retry = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var RetryManager = /* @__PURE__ */ function() {
		function RetryManager() {
			this.maxAttempts_ = 1;
			this.delayFactor_ = .1;
			this.fuzzFactor_ = .1;
			this.initialDelay_ = 1e3;
			this.enabled_ = false;
		}
		var _proto = RetryManager.prototype;
		_proto.getIsEnabled = function getIsEnabled() {
			return this.enabled_;
		};
		_proto.enable = function enable() {
			this.enabled_ = true;
		};
		_proto.disable = function disable() {
			this.enabled_ = false;
		};
		_proto.reset = function reset() {
			this.maxAttempts_ = 1;
			this.delayFactor_ = .1;
			this.fuzzFactor_ = .1;
			this.initialDelay_ = 1e3;
			this.enabled_ = false;
		};
		_proto.getMaxAttempts = function getMaxAttempts() {
			return this.maxAttempts_;
		};
		_proto.setMaxAttempts = function setMaxAttempts(maxAttempts) {
			this.maxAttempts_ = maxAttempts;
		};
		_proto.getDelayFactor = function getDelayFactor() {
			return this.delayFactor_;
		};
		_proto.setDelayFactor = function setDelayFactor(delayFactor) {
			this.delayFactor_ = delayFactor;
		};
		_proto.getFuzzFactor = function getFuzzFactor() {
			return this.fuzzFactor_;
		};
		_proto.setFuzzFactor = function setFuzzFactor(fuzzFactor) {
			this.fuzzFactor_ = fuzzFactor;
		};
		_proto.getInitialDelay = function getInitialDelay() {
			return this.initialDelay_;
		};
		_proto.setInitialDelay = function setInitialDelay(initialDelay) {
			this.initialDelay_ = initialDelay;
		};
		_proto.createRetry = function createRetry(_temp) {
			var _ref = _temp === void 0 ? {} : _temp, maxAttempts = _ref.maxAttempts, delayFactor = _ref.delayFactor, fuzzFactor = _ref.fuzzFactor, initialDelay = _ref.initialDelay;
			return new Retry({
				maxAttempts: maxAttempts || this.maxAttempts_,
				delayFactor: delayFactor || this.delayFactor_,
				fuzzFactor: fuzzFactor || this.fuzzFactor_,
				initialDelay: initialDelay || this.initialDelay_
			});
		};
		return RetryManager;
	}();
	var Retry = /* @__PURE__ */ function() {
		function Retry(options) {
			this.maxAttempts_ = options.maxAttempts;
			this.delayFactor_ = options.delayFactor;
			this.fuzzFactor_ = options.fuzzFactor;
			this.currentDelay_ = options.initialDelay;
			this.currentAttempt_ = 1;
		}
		var _proto2 = Retry.prototype;
		_proto2.moveToNextAttempt = function moveToNextAttempt() {
			this.currentAttempt_++;
			var delayDelta = this.currentDelay_ * this.delayFactor_;
			this.currentDelay_ = this.currentDelay_ + delayDelta;
		};
		_proto2.shouldRetry = function shouldRetry() {
			return this.currentAttempt_ < this.maxAttempts_;
		};
		_proto2.getCurrentDelay = function getCurrentDelay() {
			return this.currentDelay_;
		};
		_proto2.getCurrentMinPossibleDelay = function getCurrentMinPossibleDelay() {
			return (1 - this.fuzzFactor_) * this.currentDelay_;
		};
		_proto2.getCurrentMaxPossibleDelay = function getCurrentMaxPossibleDelay() {
			return (1 + this.fuzzFactor_) * this.currentDelay_;
		};
		_proto2.getCurrentFuzzedDelay = function getCurrentFuzzedDelay() {
			var lowValue = this.getCurrentMinPossibleDelay();
			var highValue = this.getCurrentMaxPossibleDelay();
			return lowValue + Math.random() * (highValue - lowValue);
		};
		return Retry;
	}();
	module.exports = RetryManager;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/@videojs+xhr@2.7.0/node_modules/@videojs/xhr/lib/http-handler.js
var require_http_handler = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var window = require_window();
	var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
		if (decodeResponseBody === void 0) decodeResponseBody = false;
		return function(err, response, responseBody) {
			if (err) {
				callback(err);
				return;
			}
			if (response.statusCode >= 400 && response.statusCode <= 599) {
				var cause = responseBody;
				if (decodeResponseBody) if (window.TextDecoder) {
					var charset = getCharset(response.headers && response.headers["content-type"]);
					try {
						cause = new TextDecoder(charset).decode(responseBody);
					} catch (e) {}
				} else cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
				callback({ cause });
				return;
			}
			callback(null, responseBody);
		};
	};
	function getCharset(contentTypeHeader) {
		if (contentTypeHeader === void 0) contentTypeHeader = "";
		return contentTypeHeader.toLowerCase().split(";").reduce(function(charset, contentType) {
			var _contentType$split = contentType.split("="), type = _contentType$split[0], value = _contentType$split[1];
			if (type.trim() === "charset") return value.trim();
			return charset;
		}, "utf-8");
	}
	module.exports = httpResponseHandler;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/@videojs+xhr@2.7.0/node_modules/@videojs/xhr/lib/index.js
var require_lib = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var window = require_window();
	var _extends = require_extends();
	var isFunction = require_is_function();
	var InterceptorsStorage = require_interceptors();
	var RetryManager = require_retry();
	createXHR.httpHandler = require_http_handler();
	createXHR.requestInterceptorsStorage = new InterceptorsStorage();
	createXHR.responseInterceptorsStorage = new InterceptorsStorage();
	createXHR.retryManager = new RetryManager();
	/**
	* @license
	* slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
	* Copyright (c) 2014 David Björklund
	* Available under the MIT license
	* <https://github.com/kesla/parse-headers/blob/master/LICENCE>
	*/
	var parseHeaders = function parseHeaders(headers) {
		var result = {};
		if (!headers) return result;
		headers.trim().split("\n").forEach(function(row) {
			var index = row.indexOf(":");
			var key = row.slice(0, index).trim().toLowerCase();
			var value = row.slice(index + 1).trim();
			if (typeof result[key] === "undefined") result[key] = value;
			else if (Array.isArray(result[key])) result[key].push(value);
			else result[key] = [result[key], value];
		});
		return result;
	};
	module.exports = createXHR;
	module.exports.default = createXHR;
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
	createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
	forEachArray([
		"get",
		"put",
		"post",
		"patch",
		"head",
		"delete"
	], function(method) {
		createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
			options = initParams(uri, options, callback);
			options.method = method.toUpperCase();
			return _createXHR(options);
		};
	});
	function forEachArray(array, iterator) {
		for (var i = 0; i < array.length; i++) iterator(array[i]);
	}
	function isEmpty(obj) {
		for (var i in obj) if (obj.hasOwnProperty(i)) return false;
		return true;
	}
	function initParams(uri, options, callback) {
		var params = uri;
		if (isFunction(options)) {
			callback = options;
			if (typeof uri === "string") params = { uri };
		} else params = _extends({}, options, { uri });
		params.callback = callback;
		return params;
	}
	function createXHR(uri, options, callback) {
		options = initParams(uri, options, callback);
		return _createXHR(options);
	}
	function _createXHR(options) {
		if (typeof options.callback === "undefined") throw new Error("callback argument missing");
		if (options.requestType && createXHR.requestInterceptorsStorage.getIsEnabled()) {
			var requestInterceptorPayload = {
				uri: options.uri || options.url,
				headers: options.headers || {},
				body: options.body,
				metadata: options.metadata || {},
				retry: options.retry,
				timeout: options.timeout
			};
			var updatedPayload = createXHR.requestInterceptorsStorage.execute(options.requestType, requestInterceptorPayload);
			options.uri = updatedPayload.uri;
			options.headers = updatedPayload.headers;
			options.body = updatedPayload.body;
			options.metadata = updatedPayload.metadata;
			options.retry = updatedPayload.retry;
			options.timeout = updatedPayload.timeout;
		}
		var called = false;
		var callback = function cbOnce(err, response, body) {
			if (!called) {
				called = true;
				options.callback(err, response, body);
			}
		};
		function readystatechange() {
			if (xhr.readyState === 4 && !createXHR.responseInterceptorsStorage.getIsEnabled()) setTimeout(loadFunc, 0);
		}
		function getBody() {
			var body = void 0;
			if (xhr.response) body = xhr.response;
			else body = xhr.responseText || getXml(xhr);
			if (isJson) try {
				body = JSON.parse(body);
			} catch (e) {}
			return body;
		}
		function errorFunc(evt) {
			clearTimeout(timeoutTimer);
			clearTimeout(options.retryTimeout);
			if (!(evt instanceof Error)) evt = /* @__PURE__ */ new Error("" + (evt || "Unknown XMLHttpRequest Error"));
			evt.statusCode = 0;
			if (!aborted && createXHR.retryManager.getIsEnabled() && options.retry && options.retry.shouldRetry()) {
				options.retryTimeout = setTimeout(function() {
					options.retry.moveToNextAttempt();
					options.xhr = xhr;
					_createXHR(options);
				}, options.retry.getCurrentFuzzedDelay());
				return;
			}
			if (options.requestType && createXHR.responseInterceptorsStorage.getIsEnabled()) {
				var responseInterceptorPayload = {
					headers: failureResponse.headers || {},
					body: failureResponse.body,
					responseUrl: xhr.responseURL,
					responseType: xhr.responseType
				};
				var _updatedPayload = createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
				failureResponse.body = _updatedPayload.body;
				failureResponse.headers = _updatedPayload.headers;
			}
			return callback(evt, failureResponse);
		}
		function loadFunc() {
			if (aborted) return;
			var status;
			clearTimeout(timeoutTimer);
			clearTimeout(options.retryTimeout);
			if (options.useXDR && xhr.status === void 0) status = 200;
			else status = xhr.status === 1223 ? 204 : xhr.status;
			var response = failureResponse;
			var err = null;
			if (status !== 0) {
				response = {
					body: getBody(),
					statusCode: status,
					method,
					headers: {},
					url: uri,
					rawRequest: xhr
				};
				if (xhr.getAllResponseHeaders) response.headers = parseHeaders(xhr.getAllResponseHeaders());
			} else err = /* @__PURE__ */ new Error("Internal XMLHttpRequest Error");
			if (options.requestType && createXHR.responseInterceptorsStorage.getIsEnabled()) {
				var responseInterceptorPayload = {
					headers: response.headers || {},
					body: response.body,
					responseUrl: xhr.responseURL,
					responseType: xhr.responseType
				};
				var _updatedPayload2 = createXHR.responseInterceptorsStorage.execute(options.requestType, responseInterceptorPayload);
				response.body = _updatedPayload2.body;
				response.headers = _updatedPayload2.headers;
			}
			return callback(err, response, response.body);
		}
		var xhr = options.xhr || null;
		if (!xhr) if (options.cors || options.useXDR) xhr = new createXHR.XDomainRequest();
		else xhr = new createXHR.XMLHttpRequest();
		var key;
		var aborted;
		var uri = xhr.url = options.uri || options.url;
		var method = xhr.method = options.method || "GET";
		var body = options.body || options.data;
		var headers = xhr.headers = options.headers || {};
		var sync = !!options.sync;
		var isJson = false;
		var timeoutTimer;
		var failureResponse = {
			body: void 0,
			headers: {},
			statusCode: 0,
			method,
			url: uri,
			rawRequest: xhr
		};
		if ("json" in options && options.json !== false) {
			isJson = true;
			headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json");
			if (method !== "GET" && method !== "HEAD") {
				headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json");
				body = JSON.stringify(options.json === true ? body : options.json);
			}
		}
		xhr.onreadystatechange = readystatechange;
		xhr.onload = loadFunc;
		xhr.onerror = errorFunc;
		xhr.onprogress = function() {};
		xhr.onabort = function() {
			aborted = true;
			clearTimeout(options.retryTimeout);
		};
		xhr.ontimeout = errorFunc;
		xhr.open(method, uri, !sync, options.username, options.password);
		if (!sync) xhr.withCredentials = !!options.withCredentials;
		if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
			if (aborted) return;
			aborted = true;
			xhr.abort("timeout");
			var e = /* @__PURE__ */ new Error("XMLHttpRequest timeout");
			e.code = "ETIMEDOUT";
			errorFunc(e);
		}, options.timeout);
		if (xhr.setRequestHeader) {
			for (key in headers) if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
		} else if (options.headers && !isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
		if ("responseType" in options) xhr.responseType = options.responseType;
		if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
		xhr.send(body || null);
		return xhr;
	}
	function getXml(xhr) {
		try {
			if (xhr.responseType === "document") return xhr.responseXML;
			var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
			if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
		} catch (e) {}
		return null;
	}
	function noop() {}
}));
//#endregion
//#region ../../../../node_modules/.pnpm/videojs-vtt.js@0.15.5/node_modules/videojs-vtt.js/lib/vtt.js
var require_vtt = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright 2013 vtt.js Contributors
	*
	* Licensed under the Apache License, Version 2.0 (the "License");
	* you may not use this file except in compliance with the License.
	* You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing, software
	* distributed under the License is distributed on an "AS IS" BASIS,
	* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	* See the License for the specific language governing permissions and
	* limitations under the License.
	*/
	var document = require_document();
	var _objCreate = Object.create || (function() {
		function F() {}
		return function(o) {
			if (arguments.length !== 1) throw new Error("Object.create shim only accepts one parameter.");
			F.prototype = o;
			return new F();
		};
	})();
	function ParsingError(errorData, message) {
		this.name = "ParsingError";
		this.code = errorData.code;
		this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	ParsingError.Errors = {
		BadSignature: {
			code: 0,
			message: "Malformed WebVTT signature."
		},
		BadTimeStamp: {
			code: 1,
			message: "Malformed time stamp."
		}
	};
	function parseTimeStamp(input) {
		function computeSeconds(h, m, s, f) {
			return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1e3;
		}
		var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
		if (!m) return null;
		if (m[3]) return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
		else if (m[1] > 59) return computeSeconds(m[1], m[2], 0, m[4]);
		else return computeSeconds(0, m[1], m[2], m[4]);
	}
	function Settings() {
		this.values = _objCreate(null);
	}
	Settings.prototype = {
		set: function(k, v) {
			if (!this.get(k) && v !== "") this.values[k] = v;
		},
		get: function(k, dflt, defaultKey) {
			if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
			return this.has(k) ? this.values[k] : dflt;
		},
		has: function(k) {
			return k in this.values;
		},
		alt: function(k, v, a) {
			for (var n = 0; n < a.length; ++n) if (v === a[n]) {
				this.set(k, v);
				break;
			}
		},
		integer: function(k, v) {
			if (/^-?\d+$/.test(v)) this.set(k, parseInt(v, 10));
		},
		percent: function(k, v) {
			if (v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
				v = parseFloat(v);
				if (v >= 0 && v <= 100) {
					this.set(k, v);
					return true;
				}
			}
			return false;
		}
	};
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
		var groups = groupDelim ? input.split(groupDelim) : [input];
		for (var i in groups) {
			if (typeof groups[i] !== "string") continue;
			var kv = groups[i].split(keyValueDelim);
			if (kv.length !== 2) continue;
			callback(kv[0].trim(), kv[1].trim());
		}
	}
	function parseCue(input, cue, regionList) {
		var oInput = input;
		function consumeTimeStamp() {
			var ts = parseTimeStamp(input);
			if (ts === null) throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
			input = input.replace(/^[^\sa-zA-Z-]+/, "");
			return ts;
		}
		function consumeCueSettings(input, cue) {
			var settings = new Settings();
			parseOptions(input, function(k, v) {
				switch (k) {
					case "region":
						for (var i = regionList.length - 1; i >= 0; i--) if (regionList[i].id === v) {
							settings.set(k, regionList[i].region);
							break;
						}
						break;
					case "vertical":
						settings.alt(k, v, ["rl", "lr"]);
						break;
					case "line":
						var vals = v.split(","), vals0 = vals[0];
						settings.integer(k, vals0);
						settings.percent(k, vals0) && settings.set("snapToLines", false);
						settings.alt(k, vals0, ["auto"]);
						if (vals.length === 2) settings.alt("lineAlign", vals[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "position":
						vals = v.split(",");
						settings.percent(k, vals[0]);
						if (vals.length === 2) settings.alt("positionAlign", vals[1], [
							"start",
							"center",
							"end"
						]);
						break;
					case "size":
						settings.percent(k, v);
						break;
					case "align":
						settings.alt(k, v, [
							"start",
							"center",
							"end",
							"left",
							"right"
						]);
						break;
				}
			}, /:/, /\s/);
			cue.region = settings.get("region", null);
			cue.vertical = settings.get("vertical", "");
			try {
				cue.line = settings.get("line", "auto");
			} catch (e) {}
			cue.lineAlign = settings.get("lineAlign", "start");
			cue.snapToLines = settings.get("snapToLines", true);
			cue.size = settings.get("size", 100);
			try {
				cue.align = settings.get("align", "center");
			} catch (e) {
				cue.align = settings.get("align", "middle");
			}
			try {
				cue.position = settings.get("position", "auto");
			} catch (e) {
				cue.position = settings.get("position", {
					start: 0,
					left: 0,
					center: 50,
					middle: 50,
					end: 100,
					right: 100
				}, cue.align);
			}
			cue.positionAlign = settings.get("positionAlign", {
				start: "start",
				left: "start",
				center: "center",
				middle: "center",
				end: "end",
				right: "end"
			}, cue.align);
		}
		function skipWhitespace() {
			input = input.replace(/^\s+/, "");
		}
		skipWhitespace();
		cue.startTime = consumeTimeStamp();
		skipWhitespace();
		if (input.substr(0, 3) !== "-->") throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
		input = input.substr(3);
		skipWhitespace();
		cue.endTime = consumeTimeStamp();
		skipWhitespace();
		consumeCueSettings(input, cue);
	}
	var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
	var TAG_NAME = {
		c: "span",
		i: "i",
		b: "b",
		u: "u",
		ruby: "ruby",
		rt: "rt",
		v: "span",
		lang: "span"
	};
	var DEFAULT_COLOR_CLASS = {
		white: "rgba(255,255,255,1)",
		lime: "rgba(0,255,0,1)",
		cyan: "rgba(0,255,255,1)",
		red: "rgba(255,0,0,1)",
		yellow: "rgba(255,255,0,1)",
		magenta: "rgba(255,0,255,1)",
		blue: "rgba(0,0,255,1)",
		black: "rgba(0,0,0,1)"
	};
	var TAG_ANNOTATION = {
		v: "title",
		lang: "lang"
	};
	var NEEDS_PARENT = { rt: "ruby" };
	function parseContent(window, input) {
		function nextToken() {
			if (!input) return null;
			function consume(result) {
				input = input.substr(result.length);
				return result;
			}
			var m = input.match(/^([^<]*)(<[^>]*>?)?/);
			return consume(m[1] ? m[1] : m[2]);
		}
		function unescape(s) {
			TEXTAREA_ELEMENT.innerHTML = s;
			s = TEXTAREA_ELEMENT.textContent;
			TEXTAREA_ELEMENT.textContent = "";
			return s;
		}
		function shouldAdd(current, element) {
			return !NEEDS_PARENT[element.localName] || NEEDS_PARENT[element.localName] === current.localName;
		}
		function createElement(type, annotation) {
			var tagName = TAG_NAME[type];
			if (!tagName) return null;
			var element = window.document.createElement(tagName);
			var name = TAG_ANNOTATION[type];
			if (name && annotation) element[name] = annotation.trim();
			return element;
		}
		var rootDiv = window.document.createElement("div"), current = rootDiv, t, tagStack = [];
		while ((t = nextToken()) !== null) {
			if (t[0] === "<") {
				if (t[1] === "/") {
					if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
						tagStack.pop();
						current = current.parentNode;
					}
					continue;
				}
				var ts = parseTimeStamp(t.substr(1, t.length - 2));
				var node;
				if (ts) {
					node = window.document.createProcessingInstruction("timestamp", ts);
					current.appendChild(node);
					continue;
				}
				var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
				if (!m) continue;
				node = createElement(m[1], m[3]);
				if (!node) continue;
				if (!shouldAdd(current, node)) continue;
				if (m[2]) {
					var classes = m[2].split(".");
					classes.forEach(function(cl) {
						var bgColor = /^bg_/.test(cl);
						var colorName = bgColor ? cl.slice(3) : cl;
						if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
							var propName = bgColor ? "background-color" : "color";
							var propValue = DEFAULT_COLOR_CLASS[colorName];
							node.style[propName] = propValue;
						}
					});
					node.className = classes.join(" ");
				}
				tagStack.push(m[1]);
				current.appendChild(node);
				current = node;
				continue;
			}
			current.appendChild(window.document.createTextNode(unescape(t)));
		}
		return rootDiv;
	}
	var strongRTLRanges = [
		[1470, 1470],
		[1472, 1472],
		[1475, 1475],
		[1478, 1478],
		[1488, 1514],
		[1520, 1524],
		[1544, 1544],
		[1547, 1547],
		[1549, 1549],
		[1563, 1563],
		[1566, 1610],
		[1645, 1647],
		[1649, 1749],
		[1765, 1766],
		[1774, 1775],
		[1786, 1805],
		[1807, 1808],
		[1810, 1839],
		[1869, 1957],
		[1969, 1969],
		[1984, 2026],
		[2036, 2037],
		[2042, 2042],
		[2048, 2069],
		[2074, 2074],
		[2084, 2084],
		[2088, 2088],
		[2096, 2110],
		[2112, 2136],
		[2142, 2142],
		[2208, 2208],
		[2210, 2220],
		[8207, 8207],
		[64285, 64285],
		[64287, 64296],
		[64298, 64310],
		[64312, 64316],
		[64318, 64318],
		[64320, 64321],
		[64323, 64324],
		[64326, 64449],
		[64467, 64829],
		[64848, 64911],
		[64914, 64967],
		[65008, 65020],
		[65136, 65140],
		[65142, 65276],
		[67584, 67589],
		[67592, 67592],
		[67594, 67637],
		[67639, 67640],
		[67644, 67644],
		[67647, 67669],
		[67671, 67679],
		[67840, 67867],
		[67872, 67897],
		[67903, 67903],
		[67968, 68023],
		[68030, 68031],
		[68096, 68096],
		[68112, 68115],
		[68117, 68119],
		[68121, 68147],
		[68160, 68167],
		[68176, 68184],
		[68192, 68223],
		[68352, 68405],
		[68416, 68437],
		[68440, 68466],
		[68472, 68479],
		[68608, 68680],
		[126464, 126467],
		[126469, 126495],
		[126497, 126498],
		[126500, 126500],
		[126503, 126503],
		[126505, 126514],
		[126516, 126519],
		[126521, 126521],
		[126523, 126523],
		[126530, 126530],
		[126535, 126535],
		[126537, 126537],
		[126539, 126539],
		[126541, 126543],
		[126545, 126546],
		[126548, 126548],
		[126551, 126551],
		[126553, 126553],
		[126555, 126555],
		[126557, 126557],
		[126559, 126559],
		[126561, 126562],
		[126564, 126564],
		[126567, 126570],
		[126572, 126578],
		[126580, 126583],
		[126585, 126588],
		[126590, 126590],
		[126592, 126601],
		[126603, 126619],
		[126625, 126627],
		[126629, 126633],
		[126635, 126651],
		[1114109, 1114109]
	];
	function isStrongRTLChar(charCode) {
		for (var i = 0; i < strongRTLRanges.length; i++) {
			var currentRange = strongRTLRanges[i];
			if (charCode >= currentRange[0] && charCode <= currentRange[1]) return true;
		}
		return false;
	}
	function determineBidi(cueDiv) {
		var nodeStack = [], text = "", charCode;
		if (!cueDiv || !cueDiv.childNodes) return "ltr";
		function pushNodes(nodeStack, node) {
			for (var i = node.childNodes.length - 1; i >= 0; i--) nodeStack.push(node.childNodes[i]);
		}
		function nextTextNode(nodeStack) {
			if (!nodeStack || !nodeStack.length) return null;
			var node = nodeStack.pop(), text = node.textContent || node.innerText;
			if (text) {
				var m = text.match(/^.*(\n|\r)/);
				if (m) {
					nodeStack.length = 0;
					return m[0];
				}
				return text;
			}
			if (node.tagName === "ruby") return nextTextNode(nodeStack);
			if (node.childNodes) {
				pushNodes(nodeStack, node);
				return nextTextNode(nodeStack);
			}
		}
		pushNodes(nodeStack, cueDiv);
		while (text = nextTextNode(nodeStack)) for (var i = 0; i < text.length; i++) {
			charCode = text.charCodeAt(i);
			if (isStrongRTLChar(charCode)) return "rtl";
		}
		return "ltr";
	}
	function computeLinePos(cue) {
		if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) return cue.line;
		if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) return -1;
		var track = cue.track, trackList = track.textTrackList, count = 0;
		for (var i = 0; i < trackList.length && trackList[i] !== track; i++) if (trackList[i].mode === "showing") count++;
		return ++count * -1;
	}
	function StyleBox() {}
	StyleBox.prototype.applyStyles = function(styles, div) {
		div = div || this.div;
		for (var prop in styles) if (styles.hasOwnProperty(prop)) div.style[prop] = styles[prop];
	};
	StyleBox.prototype.formatStyle = function(val, unit) {
		return val === 0 ? 0 : val + unit;
	};
	function CueStyleBox(window, cue, styleOptions) {
		StyleBox.call(this);
		this.cue = cue;
		this.cueDiv = parseContent(window, cue.text);
		var styles = {
			color: "rgba(255, 255, 255, 1)",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			position: "relative",
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			display: "inline",
			writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext"
		};
		this.applyStyles(styles, this.cueDiv);
		this.div = window.document.createElement("div");
		styles = {
			direction: determineBidi(this.cueDiv),
			writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
			unicodeBidi: "plaintext",
			textAlign: cue.align === "middle" ? "center" : cue.align,
			font: styleOptions.font,
			whiteSpace: "pre-line",
			position: "absolute"
		};
		this.applyStyles(styles);
		this.div.appendChild(this.cueDiv);
		var textPos = 0;
		switch (cue.positionAlign) {
			case "start":
			case "line-left":
				textPos = cue.position;
				break;
			case "center":
				textPos = cue.position - cue.size / 2;
				break;
			case "end":
			case "line-right":
				textPos = cue.position - cue.size;
				break;
		}
		if (cue.vertical === "") this.applyStyles({
			left: this.formatStyle(textPos, "%"),
			width: this.formatStyle(cue.size, "%")
		});
		else this.applyStyles({
			top: this.formatStyle(textPos, "%"),
			height: this.formatStyle(cue.size, "%")
		});
		this.move = function(box) {
			this.applyStyles({
				top: this.formatStyle(box.top, "px"),
				bottom: this.formatStyle(box.bottom, "px"),
				left: this.formatStyle(box.left, "px"),
				right: this.formatStyle(box.right, "px"),
				height: this.formatStyle(box.height, "px"),
				width: this.formatStyle(box.width, "px")
			});
		};
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	function BoxPosition(obj) {
		var lh, height, width, top;
		if (obj.div) {
			height = obj.div.offsetHeight;
			width = obj.div.offsetWidth;
			top = obj.div.offsetTop;
			var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
			obj = obj.div.getBoundingClientRect();
			lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
		}
		this.left = obj.left;
		this.right = obj.right;
		this.top = obj.top || top;
		this.height = obj.height || height;
		this.bottom = obj.bottom || top + (obj.height || height);
		this.width = obj.width || width;
		this.lineHeight = lh !== void 0 ? lh : obj.lineHeight;
	}
	BoxPosition.prototype.move = function(axis, toMove) {
		toMove = toMove !== void 0 ? toMove : this.lineHeight;
		switch (axis) {
			case "+x":
				this.left += toMove;
				this.right += toMove;
				break;
			case "-x":
				this.left -= toMove;
				this.right -= toMove;
				break;
			case "+y":
				this.top += toMove;
				this.bottom += toMove;
				break;
			case "-y":
				this.top -= toMove;
				this.bottom -= toMove;
				break;
		}
	};
	BoxPosition.prototype.overlaps = function(b2) {
		return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
	};
	BoxPosition.prototype.overlapsAny = function(boxes) {
		for (var i = 0; i < boxes.length; i++) if (this.overlaps(boxes[i])) return true;
		return false;
	};
	BoxPosition.prototype.within = function(container) {
		return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
	};
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
		switch (axis) {
			case "+x": return this.left < container.left;
			case "-x": return this.right > container.right;
			case "+y": return this.top < container.top;
			case "-y": return this.bottom > container.bottom;
		}
	};
	BoxPosition.prototype.intersectPercentage = function(b2) {
		return Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)) * Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)) / (this.height * this.width);
	};
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
		return {
			top: this.top - reference.top,
			bottom: reference.bottom - this.bottom,
			left: this.left - reference.left,
			right: reference.right - this.right,
			height: this.height,
			width: this.width
		};
	};
	BoxPosition.getSimpleBoxPosition = function(obj) {
		var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
		var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
		var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
		obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
		return {
			left: obj.left,
			right: obj.right,
			top: obj.top || top,
			height: obj.height || height,
			bottom: obj.bottom || top + (obj.height || height),
			width: obj.width || width
		};
	};
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
		function findBestPosition(b, axis) {
			var bestPosition, specifiedPosition = new BoxPosition(b), percentage = 1;
			for (var i = 0; i < axis.length; i++) {
				while (b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions)) b.move(axis[i]);
				if (b.within(containerBox)) return b;
				var p = b.intersectPercentage(containerBox);
				if (percentage > p) {
					bestPosition = new BoxPosition(b);
					percentage = p;
				}
				b = new BoxPosition(specifiedPosition);
			}
			return bestPosition || specifiedPosition;
		}
		var boxPosition = new BoxPosition(styleBox), cue = styleBox.cue, linePos = computeLinePos(cue), axis = [];
		if (cue.snapToLines) {
			var size;
			switch (cue.vertical) {
				case "":
					axis = ["+y", "-y"];
					size = "height";
					break;
				case "rl":
					axis = ["+x", "-x"];
					size = "width";
					break;
				case "lr":
					axis = ["-x", "+x"];
					size = "width";
					break;
			}
			var step = boxPosition.lineHeight, position = step * Math.round(linePos), maxPosition = containerBox[size] + step, initialAxis = axis[0];
			if (Math.abs(position) > maxPosition) {
				position = position < 0 ? -1 : 1;
				position *= Math.ceil(maxPosition / step) * step;
			}
			if (linePos < 0) {
				position += cue.vertical === "" ? containerBox.height : containerBox.width;
				axis = axis.reverse();
			}
			boxPosition.move(initialAxis, position);
		} else {
			var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
			switch (cue.lineAlign) {
				case "center":
					linePos -= calculatedPercentage / 2;
					break;
				case "end":
					linePos -= calculatedPercentage;
					break;
			}
			switch (cue.vertical) {
				case "":
					styleBox.applyStyles({ top: styleBox.formatStyle(linePos, "%") });
					break;
				case "rl":
					styleBox.applyStyles({ left: styleBox.formatStyle(linePos, "%") });
					break;
				case "lr":
					styleBox.applyStyles({ right: styleBox.formatStyle(linePos, "%") });
					break;
			}
			axis = [
				"+y",
				"-x",
				"+x",
				"-y"
			];
			boxPosition = new BoxPosition(styleBox);
		}
		var bestPosition = findBestPosition(boxPosition, axis);
		styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	function WebVTT() {}
	WebVTT.StringDecoder = function() {
		return { decode: function(data) {
			if (!data) return "";
			if (typeof data !== "string") throw new Error("Error - expected string data.");
			return decodeURIComponent(encodeURIComponent(data));
		} };
	};
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
		if (!window || !cuetext) return null;
		return parseContent(window, cuetext);
	};
	var FONT_SIZE_PERCENT = .05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	WebVTT.processCues = function(window, cues, overlay) {
		if (!window || !cues || !overlay) return null;
		while (overlay.firstChild) overlay.removeChild(overlay.firstChild);
		var paddedOverlay = window.document.createElement("div");
		paddedOverlay.style.position = "absolute";
		paddedOverlay.style.left = "0";
		paddedOverlay.style.right = "0";
		paddedOverlay.style.top = "0";
		paddedOverlay.style.bottom = "0";
		paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
		overlay.appendChild(paddedOverlay);
		function shouldCompute(cues) {
			for (var i = 0; i < cues.length; i++) if (cues[i].hasBeenReset || !cues[i].displayState) return true;
			return false;
		}
		if (!shouldCompute(cues)) {
			for (var i = 0; i < cues.length; i++) paddedOverlay.appendChild(cues[i].displayState);
			return;
		}
		var boxPositions = [], containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay);
		var styleOptions = { font: Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100 + "px " + FONT_STYLE };
		(function() {
			var styleBox, cue;
			for (var i = 0; i < cues.length; i++) {
				cue = cues[i];
				styleBox = new CueStyleBox(window, cue, styleOptions);
				paddedOverlay.appendChild(styleBox.div);
				moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
				cue.displayState = styleBox.div;
				boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
			}
		})();
	};
	WebVTT.Parser = function(window, vttjs, decoder) {
		if (!decoder) {
			decoder = vttjs;
			vttjs = {};
		}
		if (!vttjs) vttjs = {};
		this.window = window;
		this.vttjs = vttjs;
		this.state = "INITIAL";
		this.buffer = "";
		this.decoder = decoder || new TextDecoder("utf8");
		this.regionList = [];
	};
	WebVTT.Parser.prototype = {
		reportOrThrowError: function(e) {
			if (e instanceof ParsingError) this.onparsingerror && this.onparsingerror(e);
			else throw e;
		},
		parse: function(data) {
			var self = this;
			if (data) self.buffer += self.decoder.decode(data, { stream: true });
			function collectNextLine() {
				var buffer = self.buffer;
				var pos = 0;
				while (pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n") ++pos;
				var line = buffer.substr(0, pos);
				if (buffer[pos] === "\r") ++pos;
				if (buffer[pos] === "\n") ++pos;
				self.buffer = buffer.substr(pos);
				return line;
			}
			function parseRegion(input) {
				var settings = new Settings();
				parseOptions(input, function(k, v) {
					switch (k) {
						case "id":
							settings.set(k, v);
							break;
						case "width":
							settings.percent(k, v);
							break;
						case "lines":
							settings.integer(k, v);
							break;
						case "regionanchor":
						case "viewportanchor":
							var xy = v.split(",");
							if (xy.length !== 2) break;
							var anchor = new Settings();
							anchor.percent("x", xy[0]);
							anchor.percent("y", xy[1]);
							if (!anchor.has("x") || !anchor.has("y")) break;
							settings.set(k + "X", anchor.get("x"));
							settings.set(k + "Y", anchor.get("y"));
							break;
						case "scroll":
							settings.alt(k, v, ["up"]);
							break;
					}
				}, /=/, /\s/);
				if (settings.has("id")) {
					var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
					region.width = settings.get("width", 100);
					region.lines = settings.get("lines", 3);
					region.regionAnchorX = settings.get("regionanchorX", 0);
					region.regionAnchorY = settings.get("regionanchorY", 100);
					region.viewportAnchorX = settings.get("viewportanchorX", 0);
					region.viewportAnchorY = settings.get("viewportanchorY", 100);
					region.scroll = settings.get("scroll", "");
					self.onregion && self.onregion(region);
					self.regionList.push({
						id: settings.get("id"),
						region
					});
				}
			}
			function parseTimestampMap(input) {
				var settings = new Settings();
				parseOptions(input, function(k, v) {
					switch (k) {
						case "MPEGT":
							settings.integer(k + "S", v);
							break;
						case "LOCA":
							settings.set(k + "L", parseTimeStamp(v));
							break;
					}
				}, /[^\d]:/, /,/);
				self.ontimestampmap && self.ontimestampmap({
					"MPEGTS": settings.get("MPEGTS"),
					"LOCAL": settings.get("LOCAL")
				});
			}
			function parseHeader(input) {
				if (input.match(/X-TIMESTAMP-MAP/)) parseOptions(input, function(k, v) {
					switch (k) {
						case "X-TIMESTAMP-MAP":
							parseTimestampMap(v);
							break;
					}
				}, /=/);
				else parseOptions(input, function(k, v) {
					switch (k) {
						case "Region":
							parseRegion(v);
							break;
					}
				}, /:/);
			}
			try {
				var line;
				if (self.state === "INITIAL") {
					if (!/\r\n|\n/.test(self.buffer)) return this;
					line = collectNextLine();
					var m = line.match(/^WEBVTT([ \t].*)?$/);
					if (!m || !m[0]) throw new ParsingError(ParsingError.Errors.BadSignature);
					self.state = "HEADER";
				}
				var alreadyCollectedLine = false;
				while (self.buffer) {
					if (!/\r\n|\n/.test(self.buffer)) return this;
					if (!alreadyCollectedLine) line = collectNextLine();
					else alreadyCollectedLine = false;
					switch (self.state) {
						case "HEADER":
							if (/:/.test(line)) parseHeader(line);
							else if (!line) self.state = "ID";
							continue;
						case "NOTE":
							if (!line) self.state = "ID";
							continue;
						case "ID":
							if (/^NOTE($|[ \t])/.test(line)) {
								self.state = "NOTE";
								break;
							}
							if (!line) continue;
							self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
							try {
								self.cue.align = "center";
							} catch (e) {
								self.cue.align = "middle";
							}
							self.state = "CUE";
							if (line.indexOf("-->") === -1) {
								self.cue.id = line;
								continue;
							}
						case "CUE":
							try {
								parseCue(line, self.cue, self.regionList);
							} catch (e) {
								self.reportOrThrowError(e);
								self.cue = null;
								self.state = "BADCUE";
								continue;
							}
							self.state = "CUETEXT";
							continue;
						case "CUETEXT":
							var hasSubstring = line.indexOf("-->") !== -1;
							if (!line || hasSubstring && (alreadyCollectedLine = true)) {
								self.oncue && self.oncue(self.cue);
								self.cue = null;
								self.state = "ID";
								continue;
							}
							if (self.cue.text) self.cue.text += "\n";
							self.cue.text += line.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
							continue;
						case "BADCUE":
							if (!line) self.state = "ID";
							continue;
					}
				}
			} catch (e) {
				self.reportOrThrowError(e);
				if (self.state === "CUETEXT" && self.cue && self.oncue) self.oncue(self.cue);
				self.cue = null;
				self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
			}
			return this;
		},
		flush: function() {
			var self = this;
			try {
				self.buffer += self.decoder.decode();
				if (self.cue || self.state === "HEADER") {
					self.buffer += "\n\n";
					self.parse();
				}
				if (self.state === "INITIAL") throw new ParsingError(ParsingError.Errors.BadSignature);
			} catch (e) {
				self.reportOrThrowError(e);
			}
			self.onflush && self.onflush();
			return this;
		}
	};
	module.exports = WebVTT;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/videojs-vtt.js@0.15.5/node_modules/videojs-vtt.js/lib/vttcue.js
var require_vttcue = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright 2013 vtt.js Contributors
	*
	* Licensed under the Apache License, Version 2.0 (the "License");
	* you may not use this file except in compliance with the License.
	* You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing, software
	* distributed under the License is distributed on an "AS IS" BASIS,
	* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	* See the License for the specific language governing permissions and
	* limitations under the License.
	*/
	var autoKeyword = "auto";
	var directionSetting = {
		"": 1,
		"lr": 1,
		"rl": 1
	};
	var alignSetting = {
		"start": 1,
		"center": 1,
		"end": 1,
		"left": 1,
		"right": 1,
		"auto": 1,
		"line-left": 1,
		"line-right": 1
	};
	function findDirectionSetting(value) {
		if (typeof value !== "string") return false;
		return directionSetting[value.toLowerCase()] ? value.toLowerCase() : false;
	}
	function findAlignSetting(value) {
		if (typeof value !== "string") return false;
		return alignSetting[value.toLowerCase()] ? value.toLowerCase() : false;
	}
	function VTTCue(startTime, endTime, text) {
		/**
		* Shim implementation specific properties. These properties are not in
		* the spec.
		*/
		this.hasBeenReset = false;
		/**
		* VTTCue and TextTrackCue properties
		* http://dev.w3.org/html5/webvtt/#vttcue-interface
		*/
		var _id = "";
		var _pauseOnExit = false;
		var _startTime = startTime;
		var _endTime = endTime;
		var _text = text;
		var _region = null;
		var _vertical = "";
		var _snapToLines = true;
		var _line = "auto";
		var _lineAlign = "start";
		var _position = "auto";
		var _positionAlign = "auto";
		var _size = 100;
		var _align = "center";
		Object.defineProperties(this, {
			"id": {
				enumerable: true,
				get: function() {
					return _id;
				},
				set: function(value) {
					_id = "" + value;
				}
			},
			"pauseOnExit": {
				enumerable: true,
				get: function() {
					return _pauseOnExit;
				},
				set: function(value) {
					_pauseOnExit = !!value;
				}
			},
			"startTime": {
				enumerable: true,
				get: function() {
					return _startTime;
				},
				set: function(value) {
					if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
					_startTime = value;
					this.hasBeenReset = true;
				}
			},
			"endTime": {
				enumerable: true,
				get: function() {
					return _endTime;
				},
				set: function(value) {
					if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
					_endTime = value;
					this.hasBeenReset = true;
				}
			},
			"text": {
				enumerable: true,
				get: function() {
					return _text;
				},
				set: function(value) {
					_text = "" + value;
					this.hasBeenReset = true;
				}
			},
			"region": {
				enumerable: true,
				get: function() {
					return _region;
				},
				set: function(value) {
					_region = value;
					this.hasBeenReset = true;
				}
			},
			"vertical": {
				enumerable: true,
				get: function() {
					return _vertical;
				},
				set: function(value) {
					var setting = findDirectionSetting(value);
					if (setting === false) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
					_vertical = setting;
					this.hasBeenReset = true;
				}
			},
			"snapToLines": {
				enumerable: true,
				get: function() {
					return _snapToLines;
				},
				set: function(value) {
					_snapToLines = !!value;
					this.hasBeenReset = true;
				}
			},
			"line": {
				enumerable: true,
				get: function() {
					return _line;
				},
				set: function(value) {
					if (typeof value !== "number" && value !== autoKeyword) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
					_line = value;
					this.hasBeenReset = true;
				}
			},
			"lineAlign": {
				enumerable: true,
				get: function() {
					return _lineAlign;
				},
				set: function(value) {
					var setting = findAlignSetting(value);
					if (!setting) console.warn("lineAlign: an invalid or illegal string was specified.");
					else {
						_lineAlign = setting;
						this.hasBeenReset = true;
					}
				}
			},
			"position": {
				enumerable: true,
				get: function() {
					return _position;
				},
				set: function(value) {
					if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
					_position = value;
					this.hasBeenReset = true;
				}
			},
			"positionAlign": {
				enumerable: true,
				get: function() {
					return _positionAlign;
				},
				set: function(value) {
					var setting = findAlignSetting(value);
					if (!setting) console.warn("positionAlign: an invalid or illegal string was specified.");
					else {
						_positionAlign = setting;
						this.hasBeenReset = true;
					}
				}
			},
			"size": {
				enumerable: true,
				get: function() {
					return _size;
				},
				set: function(value) {
					if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
					_size = value;
					this.hasBeenReset = true;
				}
			},
			"align": {
				enumerable: true,
				get: function() {
					return _align;
				},
				set: function(value) {
					var setting = findAlignSetting(value);
					if (!setting) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
					_align = setting;
					this.hasBeenReset = true;
				}
			}
		});
		/**
		* Other <track> spec defined properties
		*/
		this.displayState = void 0;
	}
	/**
	* VTTCue methods
	*/
	VTTCue.prototype.getCueAsHTML = function() {
		return WebVTT.convertCueToDOMTree(window, this.text);
	};
	module.exports = VTTCue;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/videojs-vtt.js@0.15.5/node_modules/videojs-vtt.js/lib/vttregion.js
var require_vttregion = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright 2013 vtt.js Contributors
	*
	* Licensed under the Apache License, Version 2.0 (the "License");
	* you may not use this file except in compliance with the License.
	* You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing, software
	* distributed under the License is distributed on an "AS IS" BASIS,
	* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	* See the License for the specific language governing permissions and
	* limitations under the License.
	*/
	var scrollSetting = {
		"": true,
		"up": true
	};
	function findScrollSetting(value) {
		if (typeof value !== "string") return false;
		return scrollSetting[value.toLowerCase()] ? value.toLowerCase() : false;
	}
	function isValidPercentValue(value) {
		return typeof value === "number" && value >= 0 && value <= 100;
	}
	function VTTRegion() {
		var _width = 100;
		var _lines = 3;
		var _regionAnchorX = 0;
		var _regionAnchorY = 100;
		var _viewportAnchorX = 0;
		var _viewportAnchorY = 100;
		var _scroll = "";
		Object.defineProperties(this, {
			"width": {
				enumerable: true,
				get: function() {
					return _width;
				},
				set: function(value) {
					if (!isValidPercentValue(value)) throw new Error("Width must be between 0 and 100.");
					_width = value;
				}
			},
			"lines": {
				enumerable: true,
				get: function() {
					return _lines;
				},
				set: function(value) {
					if (typeof value !== "number") throw new TypeError("Lines must be set to a number.");
					_lines = value;
				}
			},
			"regionAnchorY": {
				enumerable: true,
				get: function() {
					return _regionAnchorY;
				},
				set: function(value) {
					if (!isValidPercentValue(value)) throw new Error("RegionAnchorX must be between 0 and 100.");
					_regionAnchorY = value;
				}
			},
			"regionAnchorX": {
				enumerable: true,
				get: function() {
					return _regionAnchorX;
				},
				set: function(value) {
					if (!isValidPercentValue(value)) throw new Error("RegionAnchorY must be between 0 and 100.");
					_regionAnchorX = value;
				}
			},
			"viewportAnchorY": {
				enumerable: true,
				get: function() {
					return _viewportAnchorY;
				},
				set: function(value) {
					if (!isValidPercentValue(value)) throw new Error("ViewportAnchorY must be between 0 and 100.");
					_viewportAnchorY = value;
				}
			},
			"viewportAnchorX": {
				enumerable: true,
				get: function() {
					return _viewportAnchorX;
				},
				set: function(value) {
					if (!isValidPercentValue(value)) throw new Error("ViewportAnchorX must be between 0 and 100.");
					_viewportAnchorX = value;
				}
			},
			"scroll": {
				enumerable: true,
				get: function() {
					return _scroll;
				},
				set: function(value) {
					var setting = findScrollSetting(value);
					if (setting === false) console.warn("Scroll: an invalid or illegal string was specified.");
					else _scroll = setting;
				}
			}
		});
	}
	module.exports = VTTRegion;
}));
//#endregion
//#region ../../../../node_modules/.pnpm/videojs-vtt.js@0.15.5/node_modules/videojs-vtt.js/lib/browser-index.js
var require_browser_index = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Copyright 2013 vtt.js Contributors
	*
	* Licensed under the Apache License, Version 2.0 (the "License");
	* you may not use this file except in compliance with the License.
	* You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing, software
	* distributed under the License is distributed on an "AS IS" BASIS,
	* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	* See the License for the specific language governing permissions and
	* limitations under the License.
	*/
	var window = require_window();
	var vttjs = module.exports = {
		WebVTT: require_vtt(),
		VTTCue: require_vttcue(),
		VTTRegion: require_vttregion()
	};
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	vttjs.shim = function() {
		window.VTTCue = cueShim;
		window.VTTRegion = regionShim;
	};
	vttjs.restore = function() {
		window.VTTCue = nativeVTTCue;
		window.VTTRegion = nativeVTTRegion;
	};
	if (!window.VTTCue) vttjs.shim();
}));
//#endregion
//#region ../../root-helpers/string.ts
var import_core = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var window = require_window();
	var document$1 = require_document();
	var XHR = require_lib();
	var vtt = require_browser_index();
	function _interopDefaultLegacy(e) {
		return e && typeof e === "object" && "default" in e ? e : { "default": e };
	}
	var window__default = /* @__PURE__ */ _interopDefaultLegacy(window);
	var document__default = /* @__PURE__ */ _interopDefaultLegacy(document$1);
	var XHR__default = /* @__PURE__ */ _interopDefaultLegacy(XHR);
	var vtt__default = /* @__PURE__ */ _interopDefaultLegacy(vtt);
	var version = "8.23.7";
	/**
	* An Object that contains lifecycle hooks as keys which point to an array
	* of functions that are run when a lifecycle is triggered
	*
	* @private
	*/
	var hooks_ = {};
	/**
	* Get a list of hooks for a specific lifecycle
	*
	* @param  {string} type
	*         the lifecycle to get hooks from
	*
	* @param  {Function|Function[]} [fn]
	*         Optionally add a hook (or hooks) to the lifecycle that your are getting.
	*
	* @return {Array}
	*         an array of hooks, or an empty array if there are none.
	*/
	var hooks = function(type, fn) {
		hooks_[type] = hooks_[type] || [];
		if (fn) hooks_[type] = hooks_[type].concat(fn);
		return hooks_[type];
	};
	/**
	* Add a function hook to a specific videojs lifecycle.
	*
	* @param {string} type
	*        the lifecycle to hook the function to.
	*
	* @param {Function|Function[]}
	*        The function or array of functions to attach.
	*/
	var hook = function(type, fn) {
		hooks(type, fn);
	};
	/**
	* Remove a hook from a specific videojs lifecycle.
	*
	* @param  {string} type
	*         the lifecycle that the function hooked to
	*
	* @param  {Function} fn
	*         The hooked function to remove
	*
	* @return {boolean}
	*         The function that was removed or undef
	*/
	var removeHook = function(type, fn) {
		const index = hooks(type).indexOf(fn);
		if (index <= -1) return false;
		hooks_[type] = hooks_[type].slice();
		hooks_[type].splice(index, 1);
		return true;
	};
	/**
	* Add a function hook that will only run once to a specific videojs lifecycle.
	*
	* @param {string} type
	*        the lifecycle to hook the function to.
	*
	* @param {Function|Function[]}
	*        The function or array of functions to attach.
	*/
	var hookOnce = function(type, fn) {
		hooks(type, [].concat(fn).map((original) => {
			const wrapper = (...args) => {
				removeHook(type, wrapper);
				return original(...args);
			};
			return wrapper;
		}));
	};
	/**
	* @file fullscreen-api.js
	* @module fullscreen-api
	*/
	/**
	* Store the browser-specific methods for the fullscreen API.
	*
	* @type {Object}
	* @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	* @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	*/
	var FullscreenApi = { prefixed: true };
	var apiMap = [[
		"requestFullscreen",
		"exitFullscreen",
		"fullscreenElement",
		"fullscreenEnabled",
		"fullscreenchange",
		"fullscreenerror",
		"fullscreen"
	], [
		"webkitRequestFullscreen",
		"webkitExitFullscreen",
		"webkitFullscreenElement",
		"webkitFullscreenEnabled",
		"webkitfullscreenchange",
		"webkitfullscreenerror",
		"-webkit-full-screen"
	]];
	var specApi = apiMap[0];
	var browserApi;
	for (let i = 0; i < apiMap.length; i++) if (apiMap[i][1] in document__default["default"]) {
		browserApi = apiMap[i];
		break;
	}
	if (browserApi) {
		for (let i = 0; i < browserApi.length; i++) FullscreenApi[specApi[i]] = browserApi[i];
		FullscreenApi.prefixed = browserApi[0] !== specApi[0];
	}
	/**
	* @file create-logger.js
	* @module create-logger
	*/
	var history = [];
	/**
	* Log messages to the console and history based on the type of message
	*
	* @private
	* @param  {string} name
	*         The name of the console method to use.
	*
	* @param  {Object} log
	*         The arguments to be passed to the matching console method.
	*
	* @param {string} [styles]
	*        styles for name
	*/
	var LogByTypeFactory = (name, log, styles) => (type, level, args) => {
		const lvl = log.levels[level];
		const lvlRegExp = new RegExp(`^(${lvl})$`);
		let resultName = name;
		if (type !== "log") args.unshift(type.toUpperCase() + ":");
		if (styles) {
			resultName = `%c${name}`;
			args.unshift(styles);
		}
		args.unshift(resultName + ":");
		if (history) {
			history.push([].concat(args));
			const splice = history.length - 1e3;
			history.splice(0, splice > 0 ? splice : 0);
		}
		if (!window__default["default"].console) return;
		let fn = window__default["default"].console[type];
		if (!fn && type === "debug") fn = window__default["default"].console.info || window__default["default"].console.log;
		if (!fn || !lvl || !lvlRegExp.test(type)) return;
		fn[Array.isArray(args) ? "apply" : "call"](window__default["default"].console, args);
	};
	function createLogger$1(name, delimiter = ":", styles = "") {
		let level = "info";
		let logByType;
		/**
		* Logs plain debug messages. Similar to `console.log`.
		*
		* Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
		* of our JSDoc template, we cannot properly document this as both a function
		* and a namespace, so its function signature is documented here.
		*
		* #### Arguments
		* ##### *args
		* *[]
		*
		* Any combination of values that could be passed to `console.log()`.
		*
		* #### Return Value
		*
		* `undefined`
		*
		* @namespace
		* @param    {...*} args
		*           One or more messages or objects that should be logged.
		*/
		function log(...args) {
			logByType("log", level, args);
		}
		logByType = LogByTypeFactory(name, log, styles);
		/**
		* Create a new subLogger which chains the old name to the new name.
		*
		* For example, doing `mylogger = videojs.log.createLogger('player')` and then using that logger will log the following:
		* ```js
		*  mylogger('foo');
		*  // > VIDEOJS: player: foo
		* ```
		*
		* @param {string} subName
		*        The name to add call the new logger
		* @param {string} [subDelimiter]
		*        Optional delimiter
		* @param {string} [subStyles]
		*        Optional styles
		* @return {Object}
		*/
		log.createLogger = (subName, subDelimiter, subStyles) => {
			const resultDelimiter = subDelimiter !== void 0 ? subDelimiter : delimiter;
			const resultStyles = subStyles !== void 0 ? subStyles : styles;
			return createLogger$1(`${name} ${resultDelimiter} ${subName}`, resultDelimiter, resultStyles);
		};
		/**
		* Create a new logger.
		*
		* @param {string} newName
		*        The name for the new logger
		* @param {string} [newDelimiter]
		*        Optional delimiter
		* @param {string} [newStyles]
		*        Optional styles
		* @return {Object}
		*/
		log.createNewLogger = (newName, newDelimiter, newStyles) => {
			return createLogger$1(newName, newDelimiter, newStyles);
		};
		/**
		* Enumeration of available logging levels, where the keys are the level names
		* and the values are `|`-separated strings containing logging methods allowed
		* in that logging level. These strings are used to create a regular expression
		* matching the function name being called.
		*
		* Levels provided by Video.js are:
		*
		* - `off`: Matches no calls. Any value that can be cast to `false` will have
		*   this effect. The most restrictive.
		* - `all`: Matches only Video.js-provided functions (`debug`, `log`,
		*   `log.warn`, and `log.error`).
		* - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
		* - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
		* - `warn`: Matches `log.warn` and `log.error` calls.
		* - `error`: Matches only `log.error` calls.
		*
		* @type {Object}
		*/
		log.levels = {
			all: "debug|log|warn|error",
			off: "",
			debug: "debug|log|warn|error",
			info: "log|warn|error",
			warn: "warn|error",
			error: "error",
			DEFAULT: level
		};
		/**
		* Get or set the current logging level.
		*
		* If a string matching a key from {@link module:log.levels} is provided, acts
		* as a setter.
		*
		* @param  {'all'|'debug'|'info'|'warn'|'error'|'off'} [lvl]
		*         Pass a valid level to set a new logging level.
		*
		* @return {string}
		*         The current logging level.
		*/
		log.level = (lvl) => {
			if (typeof lvl === "string") {
				if (!log.levels.hasOwnProperty(lvl)) throw new Error(`"${lvl}" in not a valid log level`);
				level = lvl;
			}
			return level;
		};
		/**
		* Returns an array containing everything that has been logged to the history.
		*
		* This array is a shallow clone of the internal history record. However, its
		* contents are _not_ cloned; so, mutating objects inside this array will
		* mutate them in history.
		*
		* @return {Array}
		*/
		log.history = () => history ? [].concat(history) : [];
		/**
		* Allows you to filter the history by the given logger name
		*
		* @param {string} fname
		*        The name to filter by
		*
		* @return {Array}
		*         The filtered list to return
		*/
		log.history.filter = (fname) => {
			return (history || []).filter((historyItem) => {
				return new RegExp(`.*${fname}.*`).test(historyItem[0]);
			});
		};
		/**
		* Clears the internal history tracking, but does not prevent further history
		* tracking.
		*/
		log.history.clear = () => {
			if (history) history.length = 0;
		};
		/**
		* Disable history tracking if it is currently enabled.
		*/
		log.history.disable = () => {
			if (history !== null) {
				history.length = 0;
				history = null;
			}
		};
		/**
		* Enable history tracking if it is currently disabled.
		*/
		log.history.enable = () => {
			if (history === null) history = [];
		};
		/**
		* Logs error messages. Similar to `console.error`.
		*
		* @param {...*} args
		*        One or more messages or objects that should be logged as an error
		*/
		log.error = (...args) => logByType("error", level, args);
		/**
		* Logs warning messages. Similar to `console.warn`.
		*
		* @param {...*} args
		*        One or more messages or objects that should be logged as a warning.
		*/
		log.warn = (...args) => logByType("warn", level, args);
		/**
		* Logs debug messages. Similar to `console.debug`, but may also act as a comparable
		* log if `console.debug` is not available
		*
		* @param {...*} args
		*        One or more messages or objects that should be logged as debug.
		*/
		log.debug = (...args) => logByType("debug", level, args);
		return log;
	}
	/**
	* @file log.js
	* @module log
	*/
	var log = createLogger$1("VIDEOJS");
	var createLogger = log.createLogger;
	/**
	* @file obj.js
	* @module obj
	*/
	/**
	* @callback obj:EachCallback
	*
	* @param {*} value
	*        The current key for the object that is being iterated over.
	*
	* @param {string} key
	*        The current key-value for object that is being iterated over
	*/
	/**
	* @callback obj:ReduceCallback
	*
	* @param {*} accum
	*        The value that is accumulating over the reduce loop.
	*
	* @param {*} value
	*        The current key for the object that is being iterated over.
	*
	* @param {string} key
	*        The current key-value for object that is being iterated over
	*
	* @return {*}
	*         The new accumulated value.
	*/
	var toString = Object.prototype.toString;
	/**
	* Get the keys of an Object
	*
	* @param {Object}
	*        The Object to get the keys from
	*
	* @return {string[]}
	*         An array of the keys from the object. Returns an empty array if the
	*         object passed in was invalid or had no keys.
	*
	* @private
	*/
	var keys = function(object) {
		return isObject(object) ? Object.keys(object) : [];
	};
	/**
	* Array-like iteration for objects.
	*
	* @param {Object} object
	*        The object to iterate over
	*
	* @param {obj:EachCallback} fn
	*        The callback function which is called for each key in the object.
	*/
	function each(object, fn) {
		keys(object).forEach((key) => fn(object[key], key));
	}
	/**
	* Array-like reduce for objects.
	*
	* @param {Object} object
	*        The Object that you want to reduce.
	*
	* @param {Function} fn
	*         A callback function which is called for each key in the object. It
	*         receives the accumulated value and the per-iteration value and key
	*         as arguments.
	*
	* @param {*} [initial = 0]
	*        Starting value
	*
	* @return {*}
	*         The final accumulated value.
	*/
	function reduce(object, fn, initial = 0) {
		return keys(object).reduce((accum, key) => fn(accum, object[key], key), initial);
	}
	/**
	* Returns whether a value is an object of any kind - including DOM nodes,
	* arrays, regular expressions, etc. Not functions, though.
	*
	* This avoids the gotcha where using `typeof` on a `null` value
	* results in `'object'`.
	*
	* @param  {Object} value
	* @return {boolean}
	*/
	function isObject(value) {
		return !!value && typeof value === "object";
	}
	/**
	* Returns whether an object appears to be a "plain" object - that is, a
	* direct instance of `Object`.
	*
	* @param  {Object} value
	* @return {boolean}
	*/
	function isPlain(value) {
		return isObject(value) && toString.call(value) === "[object Object]" && value.constructor === Object;
	}
	/**
	* Merge two objects recursively.
	*
	* Performs a deep merge like
	* {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
	* plain objects (not arrays, elements, or anything else).
	*
	* Non-plain object values will be copied directly from the right-most
	* argument.
	*
	* @param   {Object[]} sources
	*          One or more objects to merge into a new object.
	*
	* @return {Object}
	*          A new object that is the merged result of all sources.
	*/
	function merge(...sources) {
		const result = {};
		sources.forEach((source) => {
			if (!source) return;
			each(source, (value, key) => {
				if (!isPlain(value)) {
					result[key] = value;
					return;
				}
				if (!isPlain(result[key])) result[key] = {};
				result[key] = merge(result[key], value);
			});
		});
		return result;
	}
	/**
	* Returns an array of values for a given object
	*
	* @param  {Object} source - target object
	* @return {Array<unknown>} - object values
	*/
	function values(source = {}) {
		const result = [];
		for (const key in source) if (source.hasOwnProperty(key)) {
			const value = source[key];
			result.push(value);
		}
		return result;
	}
	/**
	* Object.defineProperty but "lazy", which means that the value is only set after
	* it is retrieved the first time, rather than being set right away.
	*
	* @param {Object} obj the object to set the property on
	* @param {string} key the key for the property to set
	* @param {Function} getValue the function used to get the value when it is needed.
	* @param {boolean} setter whether a setter should be allowed or not
	*/
	function defineLazyProperty(obj, key, getValue, setter = true) {
		const set = (value) => Object.defineProperty(obj, key, {
			value,
			enumerable: true,
			writable: true
		});
		const options = {
			configurable: true,
			enumerable: true,
			get() {
				const value = getValue();
				set(value);
				return value;
			}
		};
		if (setter) options.set = set;
		return Object.defineProperty(obj, key, options);
	}
	var Obj = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		each,
		reduce,
		isObject,
		isPlain,
		merge,
		values,
		defineLazyProperty
	});
	/**
	* @file browser.js
	* @module browser
	*/
	/**
	* Whether or not this device is an iPod.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_IPOD = false;
	/**
	* The detected iOS version - or `null`.
	*
	* @static
	* @type {string|null}
	*/
	var IOS_VERSION = null;
	/**
	* Whether or not this is an Android device.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_ANDROID = false;
	/**
	* The detected Android version - or `null` if not Android or indeterminable.
	*
	* @static
	* @type {number|string|null}
	*/
	var ANDROID_VERSION;
	/**
	* Whether or not this is Mozilla Firefox.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_FIREFOX = false;
	/**
	* Whether or not this is Microsoft Edge.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_EDGE = false;
	/**
	* Whether or not this is any Chromium Browser
	*
	* @static
	* @type {Boolean}
	*/
	var IS_CHROMIUM = false;
	/**
	* Whether or not this is any Chromium browser that is not Edge.
	*
	* This will also be `true` for Chrome on iOS, which will have different support
	* as it is actually Safari under the hood.
	*
	* Deprecated, as the behaviour to not match Edge was to prevent Legacy Edge's UA matching.
	* IS_CHROMIUM should be used instead.
	* "Chromium but not Edge" could be explicitly tested with IS_CHROMIUM && !IS_EDGE
	*
	* @static
	* @deprecated
	* @type {Boolean}
	*/
	var IS_CHROME = false;
	/**
	* The detected Chromium version - or `null`.
	*
	* @static
	* @type {number|null}
	*/
	var CHROMIUM_VERSION = null;
	/**
	* The detected Google Chrome version - or `null`.
	* This has always been the _Chromium_ version, i.e. would return on Chromium Edge.
	* Deprecated, use CHROMIUM_VERSION instead.
	*
	* @static
	* @deprecated
	* @type {number|null}
	*/
	var CHROME_VERSION = null;
	/**
	* Whether or not this is a Chromecast receiver application.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_CHROMECAST_RECEIVER = Boolean(window__default["default"].cast && window__default["default"].cast.framework && window__default["default"].cast.framework.CastReceiverContext);
	/**
	* The detected Internet Explorer version - or `null`.
	*
	* @static
	* @deprecated
	* @type {number|null}
	*/
	var IE_VERSION = null;
	/**
	* Whether or not this is desktop Safari.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_SAFARI = false;
	/**
	* Whether or not this is a Windows machine.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_WINDOWS = false;
	/**
	* Whether or not this device is an iPad.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_IPAD = false;
	/**
	* Whether or not this device is an iPhone.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_IPHONE = false;
	/**
	* Whether or not this is a Tizen device.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_TIZEN = false;
	/**
	* Whether or not this is a WebOS device.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_WEBOS = false;
	/**
	* Whether or not this is a Smart TV (Tizen or WebOS) device.
	*
	* @static
	* @type {Boolean}
	*/
	var IS_SMART_TV = false;
	/**
	* Whether or not this device is touch-enabled.
	*
	* @static
	* @const
	* @type {Boolean}
	*/
	var TOUCH_ENABLED = Boolean(isReal() && ("ontouchstart" in window__default["default"] || window__default["default"].navigator.maxTouchPoints || window__default["default"].DocumentTouch && window__default["default"].document instanceof window__default["default"].DocumentTouch));
	var UAD = window__default["default"].navigator && window__default["default"].navigator.userAgentData;
	if (UAD && UAD.platform && UAD.brands) {
		IS_ANDROID = UAD.platform === "Android";
		IS_EDGE = Boolean(UAD.brands.find((b) => b.brand === "Microsoft Edge"));
		IS_CHROMIUM = Boolean(UAD.brands.find((b) => b.brand === "Chromium"));
		IS_CHROME = !IS_EDGE && IS_CHROMIUM;
		CHROMIUM_VERSION = CHROME_VERSION = (UAD.brands.find((b) => b.brand === "Chromium") || {}).version || null;
		IS_WINDOWS = UAD.platform === "Windows";
	}
	if (!IS_CHROMIUM) {
		const USER_AGENT = window__default["default"].navigator && window__default["default"].navigator.userAgent || "";
		IS_IPOD = /iPod/i.test(USER_AGENT);
		IOS_VERSION = function() {
			const match = USER_AGENT.match(/OS (\d+)_/i);
			if (match && match[1]) return match[1];
			return null;
		}();
		IS_ANDROID = /Android/i.test(USER_AGENT);
		ANDROID_VERSION = function() {
			const match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
			if (!match) return null;
			const major = match[1] && parseFloat(match[1]);
			const minor = match[2] && parseFloat(match[2]);
			if (major && minor) return parseFloat(match[1] + "." + match[2]);
			else if (major) return major;
			return null;
		}();
		IS_FIREFOX = /Firefox/i.test(USER_AGENT);
		IS_EDGE = /Edg/i.test(USER_AGENT);
		IS_CHROMIUM = /Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT);
		IS_CHROME = !IS_EDGE && IS_CHROMIUM;
		CHROMIUM_VERSION = CHROME_VERSION = function() {
			const match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
			if (match && match[2]) return parseFloat(match[2]);
			return null;
		}();
		IE_VERSION = function() {
			const result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
			let version = result && parseFloat(result[1]);
			if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) version = 11;
			return version;
		}();
		IS_TIZEN = /Tizen/i.test(USER_AGENT);
		IS_WEBOS = /Web0S/i.test(USER_AGENT);
		IS_SMART_TV = IS_TIZEN || IS_WEBOS;
		IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE && !IS_SMART_TV;
		IS_WINDOWS = /Windows/i.test(USER_AGENT);
		IS_IPAD = /iPad/i.test(USER_AGENT) || IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
		IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	}
	/**
	* Whether or not this is an iOS device.
	*
	* @static
	* @const
	* @type {Boolean}
	*/
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	/**
	* Whether or not this is any flavor of Safari - including iOS.
	*
	* @static
	* @const
	* @type {Boolean}
	*/
	var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
	var browser = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		get IS_IPOD() {
			return IS_IPOD;
		},
		get IOS_VERSION() {
			return IOS_VERSION;
		},
		get IS_ANDROID() {
			return IS_ANDROID;
		},
		get ANDROID_VERSION() {
			return ANDROID_VERSION;
		},
		get IS_FIREFOX() {
			return IS_FIREFOX;
		},
		get IS_EDGE() {
			return IS_EDGE;
		},
		get IS_CHROMIUM() {
			return IS_CHROMIUM;
		},
		get IS_CHROME() {
			return IS_CHROME;
		},
		get CHROMIUM_VERSION() {
			return CHROMIUM_VERSION;
		},
		get CHROME_VERSION() {
			return CHROME_VERSION;
		},
		IS_CHROMECAST_RECEIVER,
		get IE_VERSION() {
			return IE_VERSION;
		},
		get IS_SAFARI() {
			return IS_SAFARI;
		},
		get IS_WINDOWS() {
			return IS_WINDOWS;
		},
		get IS_IPAD() {
			return IS_IPAD;
		},
		get IS_IPHONE() {
			return IS_IPHONE;
		},
		get IS_TIZEN() {
			return IS_TIZEN;
		},
		get IS_WEBOS() {
			return IS_WEBOS;
		},
		get IS_SMART_TV() {
			return IS_SMART_TV;
		},
		TOUCH_ENABLED,
		IS_IOS,
		IS_ANY_SAFARI
	});
	/**
	* @file dom.js
	* @module dom
	*/
	/**
	* Detect if a value is a string with any non-whitespace characters.
	*
	* @private
	* @param  {string} str
	*         The string to check
	*
	* @return {boolean}
	*         Will be `true` if the string is non-blank, `false` otherwise.
	*
	*/
	function isNonBlankString(str) {
		return typeof str === "string" && Boolean(str.trim());
	}
	/**
	* Throws an error if the passed string has whitespace. This is used by
	* class methods to be relatively consistent with the classList API.
	*
	* @private
	* @param  {string} str
	*         The string to check for whitespace.
	*
	* @throws {Error}
	*         Throws an error if there is whitespace in the string.
	*/
	function throwIfWhitespace(str) {
		if (str.indexOf(" ") >= 0) throw new Error("class has illegal whitespace characters");
	}
	/**
	* Whether the current DOM interface appears to be real (i.e. not simulated).
	*
	* @return {boolean}
	*         Will be `true` if the DOM appears to be real, `false` otherwise.
	*/
	function isReal() {
		return document__default["default"] === window__default["default"].document;
	}
	/**
	* Determines, via duck typing, whether or not a value is a DOM element.
	*
	* @param  {*} value
	*         The value to check.
	*
	* @return {boolean}
	*         Will be `true` if the value is a DOM element, `false` otherwise.
	*/
	function isEl(value) {
		return isObject(value) && value.nodeType === 1;
	}
	/**
	* Determines if the current DOM is embedded in an iframe.
	*
	* @return {boolean}
	*         Will be `true` if the DOM is embedded in an iframe, `false`
	*         otherwise.
	*/
	function isInFrame() {
		try {
			return window__default["default"].parent !== window__default["default"].self;
		} catch (x) {
			return true;
		}
	}
	/**
	* Creates functions to query the DOM using a given method.
	*
	* @private
	* @param   {string} method
	*          The method to create the query with.
	*
	* @return  {Function}
	*          The query method
	*/
	function createQuerier(method) {
		return function(selector, context) {
			if (!isNonBlankString(selector)) return document__default["default"][method](null);
			if (isNonBlankString(context)) context = document__default["default"].querySelector(context);
			const ctx = isEl(context) ? context : document__default["default"];
			return ctx[method] && ctx[method](selector);
		};
	}
	/**
	* Creates an element and applies properties, attributes, and inserts content.
	*
	* @param  {string} [tagName='div']
	*         Name of tag to be created.
	*
	* @param  {Object} [properties={}]
	*         Element properties to be applied.
	*
	* @param  {Object} [attributes={}]
	*         Element attributes to be applied.
	*
	* @param {ContentDescriptor} [content]
	*        A content descriptor object.
	*
	* @return {Element}
	*         The element that was created.
	*/
	function createEl(tagName = "div", properties = {}, attributes = {}, content) {
		const el = document__default["default"].createElement(tagName);
		Object.getOwnPropertyNames(properties).forEach(function(propName) {
			const val = properties[propName];
			if (propName === "textContent") textContent(el, val);
			else if (el[propName] !== val || propName === "tabIndex") el[propName] = val;
		});
		Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
			el.setAttribute(attrName, attributes[attrName]);
		});
		if (content) appendContent(el, content);
		return el;
	}
	/**
	* Injects text into an element, replacing any existing contents entirely.
	*
	* @param  {HTMLElement} el
	*         The element to add text content into
	*
	* @param  {string} text
	*         The text content to add.
	*
	* @return {Element}
	*         The element with added text content.
	*/
	function textContent(el, text) {
		if (typeof el.textContent === "undefined") el.innerText = text;
		else el.textContent = text;
		return el;
	}
	/**
	* Insert an element as the first child node of another
	*
	* @param {Element} child
	*        Element to insert
	*
	* @param {Element} parent
	*        Element to insert child into
	*/
	function prependTo(child, parent) {
		if (parent.firstChild) parent.insertBefore(child, parent.firstChild);
		else parent.appendChild(child);
	}
	/**
	* Check if an element has a class name.
	*
	* @param  {Element} element
	*         Element to check
	*
	* @param  {string} classToCheck
	*         Class name to check for
	*
	* @return {boolean}
	*         Will be `true` if the element has a class, `false` otherwise.
	*
	* @throws {Error}
	*         Throws an error if `classToCheck` has white space.
	*/
	function hasClass(element, classToCheck) {
		throwIfWhitespace(classToCheck);
		return element.classList.contains(classToCheck);
	}
	/**
	* Add a class name to an element.
	*
	* @param  {Element} element
	*         Element to add class name to.
	*
	* @param  {...string} classesToAdd
	*         One or more class name to add.
	*
	* @return {Element}
	*         The DOM element with the added class name.
	*/
	function addClass(element, ...classesToAdd) {
		element.classList.add(...classesToAdd.reduce((prev, current) => prev.concat(current.split(/\s+/)), []));
		return element;
	}
	/**
	* Remove a class name from an element.
	*
	* @param  {Element} element
	*         Element to remove a class name from.
	*
	* @param  {...string} classesToRemove
	*         One or more class name to remove.
	*
	* @return {Element}
	*         The DOM element with class name removed.
	*/
	function removeClass(element, ...classesToRemove) {
		if (!element) {
			log.warn("removeClass was called with an element that doesn't exist");
			return null;
		}
		element.classList.remove(...classesToRemove.reduce((prev, current) => prev.concat(current.split(/\s+/)), []));
		return element;
	}
	/**
	* The callback definition for toggleClass.
	*
	* @callback PredicateCallback
	* @param    {Element} element
	*           The DOM element of the Component.
	*
	* @param    {string} classToToggle
	*           The `className` that wants to be toggled
	*
	* @return   {boolean|undefined}
	*           If `true` is returned, the `classToToggle` will be added to the
	*           `element`, but not removed. If `false`, the `classToToggle` will be removed from
	*           the `element`, but not added. If `undefined`, the callback will be ignored.
	*
	*/
	/**
	* Adds or removes a class name to/from an element depending on an optional
	* condition or the presence/absence of the class name.
	*
	* @param  {Element} element
	*         The element to toggle a class name on.
	*
	* @param  {string} classToToggle
	*         The class that should be toggled.
	*
	* @param  {boolean|PredicateCallback} [predicate]
	*         See the return value for {@link module:dom~PredicateCallback}
	*
	* @return {Element}
	*         The element with a class that has been toggled.
	*/
	function toggleClass(element, classToToggle, predicate) {
		if (typeof predicate === "function") predicate = predicate(element, classToToggle);
		if (typeof predicate !== "boolean") predicate = void 0;
		classToToggle.split(/\s+/).forEach((className) => element.classList.toggle(className, predicate));
		return element;
	}
	/**
	* Apply attributes to an HTML element.
	*
	* @param {Element} el
	*        Element to add attributes to.
	*
	* @param {Object} [attributes]
	*        Attributes to be applied.
	*/
	function setAttributes(el, attributes) {
		Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
			const attrValue = attributes[attrName];
			if (attrValue === null || typeof attrValue === "undefined" || attrValue === false) el.removeAttribute(attrName);
			else el.setAttribute(attrName, attrValue === true ? "" : attrValue);
		});
	}
	/**
	* Get an element's attribute values, as defined on the HTML tag.
	*
	* Attributes are not the same as properties. They're defined on the tag
	* or with setAttribute.
	*
	* @param  {Element} tag
	*         Element from which to get tag attributes.
	*
	* @return {Object}
	*         All attributes of the element. Boolean attributes will be `true` or
	*         `false`, others will be strings.
	*/
	function getAttributes(tag) {
		const obj = {};
		const knownBooleans = [
			"autoplay",
			"controls",
			"playsinline",
			"loop",
			"muted",
			"default",
			"defaultMuted"
		];
		if (tag && tag.attributes && tag.attributes.length > 0) {
			const attrs = tag.attributes;
			for (let i = attrs.length - 1; i >= 0; i--) {
				const attrName = attrs[i].name;
				/** @type {boolean|string} */
				let attrVal = attrs[i].value;
				if (knownBooleans.includes(attrName)) attrVal = attrVal !== null ? true : false;
				obj[attrName] = attrVal;
			}
		}
		return obj;
	}
	/**
	* Get the value of an element's attribute.
	*
	* @param {Element} el
	*        A DOM element.
	*
	* @param {string} attribute
	*        Attribute to get the value of.
	*
	* @return {string}
	*         The value of the attribute.
	*/
	function getAttribute(el, attribute) {
		return el.getAttribute(attribute);
	}
	/**
	* Set the value of an element's attribute.
	*
	* @param {Element} el
	*        A DOM element.
	*
	* @param {string} attribute
	*        Attribute to set.
	*
	* @param {string} value
	*        Value to set the attribute to.
	*/
	function setAttribute(el, attribute, value) {
		el.setAttribute(attribute, value);
	}
	/**
	* Remove an element's attribute.
	*
	* @param {Element} el
	*        A DOM element.
	*
	* @param {string} attribute
	*        Attribute to remove.
	*/
	function removeAttribute(el, attribute) {
		el.removeAttribute(attribute);
	}
	/**
	* Attempt to block the ability to select text.
	*/
	function blockTextSelection() {
		document__default["default"].body.focus();
		document__default["default"].onselectstart = function() {
			return false;
		};
	}
	/**
	* Turn off text selection blocking.
	*/
	function unblockTextSelection() {
		document__default["default"].onselectstart = function() {
			return true;
		};
	}
	/**
	* Identical to the native `getBoundingClientRect` function, but ensures that
	* the method is supported at all (it is in all browsers we claim to support)
	* and that the element is in the DOM before continuing.
	*
	* This wrapper function also shims properties which are not provided by some
	* older browsers (namely, IE8).
	*
	* Additionally, some browsers do not support adding properties to a
	* `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
	* properties (except `x` and `y` which are not widely supported). This helps
	* avoid implementations where keys are non-enumerable.
	*
	* @param  {Element} el
	*         Element whose `ClientRect` we want to calculate.
	*
	* @return {Object|undefined}
	*         Always returns a plain object - or `undefined` if it cannot.
	*/
	function getBoundingClientRect(el) {
		if (el && el.getBoundingClientRect && el.parentNode) {
			const rect = el.getBoundingClientRect();
			const result = {};
			[
				"bottom",
				"height",
				"left",
				"right",
				"top",
				"width"
			].forEach((k) => {
				if (rect[k] !== void 0) result[k] = rect[k];
			});
			if (!result.height) result.height = parseFloat(computedStyle(el, "height"));
			if (!result.width) result.width = parseFloat(computedStyle(el, "width"));
			return result;
		}
	}
	/**
	* Represents the position of a DOM element on the page.
	*
	* @typedef  {Object} module:dom~Position
	*
	* @property {number} left
	*           Pixels to the left.
	*
	* @property {number} top
	*           Pixels from the top.
	*/
	/**
	* Get the position of an element in the DOM.
	*
	* Uses `getBoundingClientRect` technique from John Resig.
	*
	* @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	*
	* @param  {Element} el
	*         Element from which to get offset.
	*
	* @return {module:dom~Position}
	*         The position of the element that was passed in.
	*/
	function findPosition(el) {
		if (!el || el && !el.offsetParent) return {
			left: 0,
			top: 0,
			width: 0,
			height: 0
		};
		const width = el.offsetWidth;
		const height = el.offsetHeight;
		let left = 0;
		let top = 0;
		while (el.offsetParent && el !== document__default["default"][FullscreenApi.fullscreenElement]) {
			left += el.offsetLeft;
			top += el.offsetTop;
			el = el.offsetParent;
		}
		return {
			left,
			top,
			width,
			height
		};
	}
	/**
	* Represents x and y coordinates for a DOM element or mouse pointer.
	*
	* @typedef  {Object} module:dom~Coordinates
	*
	* @property {number} x
	*           x coordinate in pixels
	*
	* @property {number} y
	*           y coordinate in pixels
	*/
	/**
	* Get the pointer position within an element.
	*
	* The base on the coordinates are the bottom left of the element.
	*
	* @param  {Element} el
	*         Element on which to get the pointer position on.
	*
	* @param  {Event} event
	*         Event object.
	*
	* @return {module:dom~Coordinates}
	*         A coordinates object corresponding to the mouse position.
	*
	*/
	function getPointerPosition(el, event) {
		const translated = {
			x: 0,
			y: 0
		};
		if (IS_IOS) {
			let item = el;
			while (item && item.nodeName.toLowerCase() !== "html") {
				const transform = computedStyle(item, "transform");
				if (/^matrix/.test(transform)) {
					const values = transform.slice(7, -1).split(/,\s/).map(Number);
					translated.x += values[4];
					translated.y += values[5];
				} else if (/^matrix3d/.test(transform)) {
					const values = transform.slice(9, -1).split(/,\s/).map(Number);
					translated.x += values[12];
					translated.y += values[13];
				}
				if (item.assignedSlot && item.assignedSlot.parentElement && window__default["default"].WebKitCSSMatrix) {
					const transformValue = window__default["default"].getComputedStyle(item.assignedSlot.parentElement).transform;
					const matrix = new window__default["default"].WebKitCSSMatrix(transformValue);
					translated.x += matrix.m41;
					translated.y += matrix.m42;
				}
				item = item.parentNode || item.host;
			}
		}
		const position = {};
		const boxTarget = findPosition(event.target);
		const box = findPosition(el);
		const boxW = box.width;
		const boxH = box.height;
		let offsetY = event.offsetY - (box.top - boxTarget.top);
		let offsetX = event.offsetX - (box.left - boxTarget.left);
		if (event.changedTouches) {
			offsetX = event.changedTouches[0].pageX - box.left;
			offsetY = event.changedTouches[0].pageY + box.top;
			if (IS_IOS) {
				offsetX -= translated.x;
				offsetY -= translated.y;
			}
		}
		position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
		position.x = Math.max(0, Math.min(1, offsetX / boxW));
		return position;
	}
	/**
	* Determines, via duck typing, whether or not a value is a text node.
	*
	* @param  {*} value
	*         Check if this value is a text node.
	*
	* @return {boolean}
	*         Will be `true` if the value is a text node, `false` otherwise.
	*/
	function isTextNode(value) {
		return isObject(value) && value.nodeType === 3;
	}
	/**
	* Empties the contents of an element.
	*
	* @param  {Element} el
	*         The element to empty children from
	*
	* @return {Element}
	*         The element with no children
	*/
	function emptyEl(el) {
		while (el.firstChild) el.removeChild(el.firstChild);
		return el;
	}
	/**
	* This is a mixed value that describes content to be injected into the DOM
	* via some method. It can be of the following types:
	*
	* Type       | Description
	* -----------|-------------
	* `string`   | The value will be normalized into a text node.
	* `Element`  | The value will be accepted as-is.
	* `Text`     | A TextNode. The value will be accepted as-is.
	* `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
	* `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
	*
	* @typedef {string|Element|Text|Array|Function} ContentDescriptor
	*/
	/**
	* Normalizes content for eventual insertion into the DOM.
	*
	* This allows a wide range of content definition methods, but helps protect
	* from falling into the trap of simply writing to `innerHTML`, which could
	* be an XSS concern.
	*
	* The content for an element can be passed in multiple types and
	* combinations, whose behavior is as follows:
	*
	* @param {ContentDescriptor} content
	*        A content descriptor value.
	*
	* @return {Array}
	*         All of the content that was passed in, normalized to an array of
	*         elements or text nodes.
	*/
	function normalizeContent(content) {
		if (typeof content === "function") content = content();
		return (Array.isArray(content) ? content : [content]).map((value) => {
			if (typeof value === "function") value = value();
			if (isEl(value) || isTextNode(value)) return value;
			if (typeof value === "string" && /\S/.test(value)) return document__default["default"].createTextNode(value);
		}).filter((value) => value);
	}
	/**
	* Normalizes and appends content to an element.
	*
	* @param  {Element} el
	*         Element to append normalized content to.
	*
	* @param {ContentDescriptor} content
	*        A content descriptor value.
	*
	* @return {Element}
	*         The element with appended normalized content.
	*/
	function appendContent(el, content) {
		normalizeContent(content).forEach((node) => el.appendChild(node));
		return el;
	}
	/**
	* Normalizes and inserts content into an element; this is identical to
	* `appendContent()`, except it empties the element first.
	*
	* @param {Element} el
	*        Element to insert normalized content into.
	*
	* @param {ContentDescriptor} content
	*        A content descriptor value.
	*
	* @return {Element}
	*         The element with inserted normalized content.
	*/
	function insertContent(el, content) {
		return appendContent(emptyEl(el), content);
	}
	/**
	* Check if an event was a single left click.
	*
	* @param  {MouseEvent} event
	*         Event object.
	*
	* @return {boolean}
	*         Will be `true` if a single left click, `false` otherwise.
	*/
	function isSingleLeftClick(event) {
		if (event.button === void 0 && event.buttons === void 0) return true;
		if (event.button === 0 && event.buttons === void 0) return true;
		if (event.type === "mouseup" && event.button === 0 && event.buttons === 0) return true;
		if (event.type === "mousedown" && event.button === 0 && event.buttons === 0) return true;
		if (event.button !== 0 || event.buttons !== 1) return false;
		return true;
	}
	/**
	* Finds a single DOM element matching `selector` within the optional
	* `context` of another DOM element (defaulting to `document`).
	*
	* @param  {string} selector
	*         A valid CSS selector, which will be passed to `querySelector`.
	*
	* @param  {Element|String} [context=document]
	*         A DOM element within which to query. Can also be a selector
	*         string in which case the first matching element will be used
	*         as context. If missing (or no element matches selector), falls
	*         back to `document`.
	*
	* @return {Element|null}
	*         The element that was found or null.
	*/
	var $ = createQuerier("querySelector");
	/**
	* Finds a all DOM elements matching `selector` within the optional
	* `context` of another DOM element (defaulting to `document`).
	*
	* @param  {string} selector
	*         A valid CSS selector, which will be passed to `querySelectorAll`.
	*
	* @param  {Element|String} [context=document]
	*         A DOM element within which to query. Can also be a selector
	*         string in which case the first matching element will be used
	*         as context. If missing (or no element matches selector), falls
	*         back to `document`.
	*
	* @return {NodeList}
	*         A element list of elements that were found. Will be empty if none
	*         were found.
	*
	*/
	var $$ = createQuerier("querySelectorAll");
	/**
	* A safe getComputedStyle.
	*
	* This is needed because in Firefox, if the player is loaded in an iframe with
	* `display:none`, then `getComputedStyle` returns `null`, so, we do a
	* null-check to make sure that the player doesn't break in these cases.
	*
	* @param    {Element} el
	*           The element you want the computed style of
	*
	* @param    {string} prop
	*           The property name you want
	*
	* @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	*/
	function computedStyle(el, prop) {
		if (!el || !prop) return "";
		if (typeof window__default["default"].getComputedStyle === "function") {
			let computedStyleValue;
			try {
				computedStyleValue = window__default["default"].getComputedStyle(el);
			} catch (e) {
				return "";
			}
			return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : "";
		}
		return "";
	}
	/**
	* Copy document style sheets to another window.
	*
	* @param    {Window} win
	*           The window element you want to copy the document style sheets to.
	*
	*/
	function copyStyleSheetsToWindow(win) {
		[...document__default["default"].styleSheets].forEach((styleSheet) => {
			try {
				const cssRules = [...styleSheet.cssRules].map((rule) => rule.cssText).join("");
				const style = document__default["default"].createElement("style");
				style.textContent = cssRules;
				win.document.head.appendChild(style);
			} catch (e) {
				const link = document__default["default"].createElement("link");
				link.rel = "stylesheet";
				link.type = styleSheet.type;
				link.media = styleSheet.media.mediaText;
				link.href = styleSheet.href;
				win.document.head.appendChild(link);
			}
		});
	}
	var Dom = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		isReal,
		isEl,
		isInFrame,
		createEl,
		textContent,
		prependTo,
		hasClass,
		addClass,
		removeClass,
		toggleClass,
		setAttributes,
		getAttributes,
		getAttribute,
		setAttribute,
		removeAttribute,
		blockTextSelection,
		unblockTextSelection,
		getBoundingClientRect,
		findPosition,
		getPointerPosition,
		isTextNode,
		emptyEl,
		normalizeContent,
		appendContent,
		insertContent,
		isSingleLeftClick,
		$,
		$$,
		computedStyle,
		copyStyleSheetsToWindow
	});
	/**
	* @file setup.js - Functions for setting up a player without
	* user interaction based on the data-setup `attribute` of the video tag.
	*
	* @module setup
	*/
	var _windowLoaded = false;
	var videojs$1;
	/**
	* Set up any tags that have a data-setup `attribute` when the player is started.
	*/
	var autoSetup = function() {
		if (videojs$1.options.autoSetup === false) return;
		const vids = Array.prototype.slice.call(document__default["default"].getElementsByTagName("video"));
		const audios = Array.prototype.slice.call(document__default["default"].getElementsByTagName("audio"));
		const divs = Array.prototype.slice.call(document__default["default"].getElementsByTagName("video-js"));
		const mediaEls = vids.concat(audios, divs);
		if (mediaEls && mediaEls.length > 0) for (let i = 0, e = mediaEls.length; i < e; i++) {
			const mediaEl = mediaEls[i];
			if (mediaEl && mediaEl.getAttribute) {
				if (mediaEl.player === void 0) {
					if (mediaEl.getAttribute("data-setup") !== null) videojs$1(mediaEl);
				}
			} else {
				autoSetupTimeout(1);
				break;
			}
		}
		else if (!_windowLoaded) autoSetupTimeout(1);
	};
	/**
	* Wait until the page is loaded before running autoSetup. This will be called in
	* autoSetup if `hasLoaded` returns false.
	*
	* @param {number} wait
	*        How long to wait in ms
	*
	* @param {module:videojs} [vjs]
	*        The videojs library function
	*/
	function autoSetupTimeout(wait, vjs) {
		if (!isReal()) return;
		if (vjs) videojs$1 = vjs;
		window__default["default"].setTimeout(autoSetup, wait);
	}
	/**
	* Used to set the internal tracking of window loaded state to true.
	*
	* @private
	*/
	function setWindowLoaded() {
		_windowLoaded = true;
		window__default["default"].removeEventListener("load", setWindowLoaded);
	}
	if (isReal()) if (document__default["default"].readyState === "complete") setWindowLoaded();
	else
 /**
	* Listen for the load event on window, and set _windowLoaded to true.
	*
	* We use a standard event listener here to avoid incrementing the GUID
	* before any players are created.
	*
	* @listens load
	*/
	window__default["default"].addEventListener("load", setWindowLoaded);
	/**
	* @file stylesheet.js
	* @module stylesheet
	*/
	/**
	* Create a DOM style element given a className for it.
	*
	* @param {string} className
	*        The className to add to the created style element.
	*
	* @return {Element}
	*         The element that was created.
	*/
	var createStyleElement = function(className) {
		const style = document__default["default"].createElement("style");
		style.className = className;
		return style;
	};
	/**
	* Add text to a DOM element.
	*
	* @param {Element} el
	*        The Element to add text content to.
	*
	* @param {string} content
	*        The text to add to the element.
	*/
	var setTextContent = function(el, content) {
		if (el.styleSheet) el.styleSheet.cssText = content;
		else el.textContent = content;
	};
	/**
	* @file dom-data.js
	* @module dom-data
	*/
	/**
	* Element Data Store.
	*
	* Allows for binding data to an element without putting it directly on the
	* element. Ex. Event listeners are stored here.
	* (also from jsninja.com, slightly modified and updated for closure compiler)
	*
	* @type {Object}
	* @private
	*/
	var DomData = /* @__PURE__ */ new WeakMap();
	/**
	* Unique ID for an element or function
	*
	* @type {Number}
	*/
	var _guid = 3;
	/**
	* Get a unique auto-incrementing ID by number that has not been returned before.
	*
	* @return {number}
	*         A new unique ID.
	*/
	function newGUID() {
		return _guid++;
	}
	/**
	* @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	* (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	* This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	* robust as jquery's, so there's probably some differences.
	*
	* @file events.js
	* @module events
	*/
	/**
	* Clean up the listener cache and dispatchers
	*
	* @param {Element|Object} elem
	*        Element to clean up
	*
	* @param {string} type
	*        Type of event to clean up
	*/
	function _cleanUpEvents(elem, type) {
		if (!DomData.has(elem)) return;
		const data = DomData.get(elem);
		if (data.handlers[type].length === 0) {
			delete data.handlers[type];
			if (elem.removeEventListener) elem.removeEventListener(type, data.dispatcher, false);
			else if (elem.detachEvent) elem.detachEvent("on" + type, data.dispatcher);
		}
		if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
			delete data.handlers;
			delete data.dispatcher;
			delete data.disabled;
		}
		if (Object.getOwnPropertyNames(data).length === 0) DomData.delete(elem);
	}
	/**
	* Loops through an array of event types and calls the requested method for each type.
	*
	* @param {Function} fn
	*        The event method we want to use.
	*
	* @param {Element|Object} elem
	*        Element or object to bind listeners to
	*
	* @param {string[]} types
	*        Type of event to bind to.
	*
	* @param {Function} callback
	*        Event listener.
	*/
	function _handleMultipleEvents(fn, elem, types, callback) {
		types.forEach(function(type) {
			fn(elem, type, callback);
		});
	}
	/**
	* Fix a native event to have standard property values
	*
	* @param {Object} event
	*        Event object to fix.
	*
	* @return {Object}
	*         Fixed event object.
	*/
	function fixEvent(event) {
		if (event.fixed_) return event;
		function returnTrue() {
			return true;
		}
		function returnFalse() {
			return false;
		}
		if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
			const old = event || window__default["default"].event;
			event = {};
			const deprecatedProps = [
				"layerX",
				"layerY",
				"keyLocation",
				"path",
				"webkitMovementX",
				"webkitMovementY",
				"mozPressure",
				"mozInputSource"
			];
			for (const key in old) if (!deprecatedProps.includes(key)) {
				if (!(key === "returnValue" && old.preventDefault)) event[key] = old[key];
			}
			if (!event.target) event.target = event.srcElement || document__default["default"];
			if (!event.relatedTarget) event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
			event.preventDefault = function() {
				if (old.preventDefault) old.preventDefault();
				event.returnValue = false;
				old.returnValue = false;
				event.defaultPrevented = true;
			};
			event.defaultPrevented = false;
			event.stopPropagation = function() {
				if (old.stopPropagation) old.stopPropagation();
				event.cancelBubble = true;
				old.cancelBubble = true;
				event.isPropagationStopped = returnTrue;
			};
			event.isPropagationStopped = returnFalse;
			event.stopImmediatePropagation = function() {
				if (old.stopImmediatePropagation) old.stopImmediatePropagation();
				event.isImmediatePropagationStopped = returnTrue;
				event.stopPropagation();
			};
			event.isImmediatePropagationStopped = returnFalse;
			if (event.clientX !== null && event.clientX !== void 0) {
				const doc = document__default["default"].documentElement;
				const body = document__default["default"].body;
				event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
				event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
			}
			event.which = event.charCode || event.keyCode;
			if (event.button !== null && event.button !== void 0) event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
		}
		event.fixed_ = true;
		return event;
	}
	/**
	* Whether passive event listeners are supported
	*/
	var _supportsPassive;
	var supportsPassive = function() {
		if (typeof _supportsPassive !== "boolean") {
			_supportsPassive = false;
			try {
				const opts = Object.defineProperty({}, "passive", { get() {
					_supportsPassive = true;
				} });
				window__default["default"].addEventListener("test", null, opts);
				window__default["default"].removeEventListener("test", null, opts);
			} catch (e) {}
		}
		return _supportsPassive;
	};
	/**
	* Touch events Chrome expects to be passive
	*/
	var passiveEvents = ["touchstart", "touchmove"];
	/**
	* Add an event listener to element
	* It stores the handler function in a separate cache object
	* and adds a generic handler to the element's event,
	* along with a unique id (guid) to the element.
	*
	* @param {Element|Object} elem
	*        Element or object to bind listeners to
	*
	* @param {string|string[]} type
	*        Type of event to bind to.
	*
	* @param {Function} fn
	*        Event listener.
	*/
	function on(elem, type, fn) {
		if (Array.isArray(type)) return _handleMultipleEvents(on, elem, type, fn);
		if (!DomData.has(elem)) DomData.set(elem, {});
		const data = DomData.get(elem);
		if (!data.handlers) data.handlers = {};
		if (!data.handlers[type]) data.handlers[type] = [];
		if (!fn.guid) fn.guid = newGUID();
		data.handlers[type].push(fn);
		if (!data.dispatcher) {
			data.disabled = false;
			data.dispatcher = function(event, hash) {
				if (data.disabled) return;
				event = fixEvent(event);
				const handlers = data.handlers[event.type];
				if (handlers) {
					const handlersCopy = handlers.slice(0);
					for (let m = 0, n = handlersCopy.length; m < n; m++) if (event.isImmediatePropagationStopped()) break;
					else try {
						handlersCopy[m].call(elem, event, hash);
					} catch (e) {
						log.error(e);
					}
				}
			};
		}
		if (data.handlers[type].length === 1) {
			if (elem.addEventListener) {
				let options = false;
				if (supportsPassive() && passiveEvents.indexOf(type) > -1) options = { passive: true };
				elem.addEventListener(type, data.dispatcher, options);
			} else if (elem.attachEvent) elem.attachEvent("on" + type, data.dispatcher);
		}
	}
	/**
	* Removes event listeners from an element
	*
	* @param {Element|Object} elem
	*        Object to remove listeners from.
	*
	* @param {string|string[]} [type]
	*        Type of listener to remove. Don't include to remove all events from element.
	*
	* @param {Function} [fn]
	*        Specific listener to remove. Don't include to remove listeners for an event
	*        type.
	*/
	function off(elem, type, fn) {
		if (!DomData.has(elem)) return;
		const data = DomData.get(elem);
		if (!data.handlers) return;
		if (Array.isArray(type)) return _handleMultipleEvents(off, elem, type, fn);
		const removeType = function(el, t) {
			data.handlers[t] = [];
			_cleanUpEvents(el, t);
		};
		if (type === void 0) {
			for (const t in data.handlers) if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) removeType(elem, t);
			return;
		}
		const handlers = data.handlers[type];
		if (!handlers) return;
		if (!fn) {
			removeType(elem, type);
			return;
		}
		if (fn.guid) {
			for (let n = 0; n < handlers.length; n++) if (handlers[n].guid === fn.guid) handlers.splice(n--, 1);
		}
		_cleanUpEvents(elem, type);
	}
	/**
	* Trigger an event for an element
	*
	* @param {Element|Object} elem
	*        Element to trigger an event on
	*
	* @param {EventTarget~Event|string} event
	*        A string (the type) or an event object with a type attribute
	*
	* @param {Object} [hash]
	*        data hash to pass along with the event
	*
	* @return {boolean|undefined}
	*         Returns the opposite of `defaultPrevented` if default was
	*         prevented. Otherwise, returns `undefined`
	*/
	function trigger(elem, event, hash) {
		const elemData = DomData.has(elem) ? DomData.get(elem) : {};
		const parent = elem.parentNode || elem.ownerDocument;
		if (typeof event === "string") event = {
			type: event,
			target: elem
		};
		else if (!event.target) event.target = elem;
		event = fixEvent(event);
		if (elemData.dispatcher) elemData.dispatcher.call(elem, event, hash);
		if (parent && !event.isPropagationStopped() && event.bubbles === true) trigger.call(null, parent, event, hash);
		else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
			if (!DomData.has(event.target)) DomData.set(event.target, {});
			const targetData = DomData.get(event.target);
			if (event.target[event.type]) {
				targetData.disabled = true;
				if (typeof event.target[event.type] === "function") event.target[event.type]();
				targetData.disabled = false;
			}
		}
		return !event.defaultPrevented;
	}
	/**
	* Trigger a listener only once for an event.
	*
	* @param {Element|Object} elem
	*        Element or object to bind to.
	*
	* @param {string|string[]} type
	*        Name/type of event
	*
	* @param {Event~EventListener} fn
	*        Event listener function
	*/
	function one(elem, type, fn) {
		if (Array.isArray(type)) return _handleMultipleEvents(one, elem, type, fn);
		const func = function() {
			off(elem, type, func);
			fn.apply(this, arguments);
		};
		func.guid = fn.guid = fn.guid || newGUID();
		on(elem, type, func);
	}
	/**
	* Trigger a listener only once and then turn if off for all
	* configured events
	*
	* @param {Element|Object} elem
	*        Element or object to bind to.
	*
	* @param {string|string[]} type
	*        Name/type of event
	*
	* @param {Event~EventListener} fn
	*        Event listener function
	*/
	function any(elem, type, fn) {
		const func = function() {
			off(elem, type, func);
			fn.apply(this, arguments);
		};
		func.guid = fn.guid = fn.guid || newGUID();
		on(elem, type, func);
	}
	var Events = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		fixEvent,
		on,
		off,
		trigger,
		one,
		any
	});
	/**
	* @file fn.js
	* @module fn
	*/
	var UPDATE_REFRESH_INTERVAL = 30;
	/**
	* A private, internal-only function for changing the context of a function.
	*
	* It also stores a unique id on the function so it can be easily removed from
	* events.
	*
	* @private
	* @function
	* @param    {*} context
	*           The object to bind as scope.
	*
	* @param    {Function} fn
	*           The function to be bound to a scope.
	*
	* @param    {number} [uid]
	*           An optional unique ID for the function to be set
	*
	* @return   {Function}
	*           The new function that will be bound into the context given
	*/
	var bind_ = function(context, fn, uid) {
		if (!fn.guid) fn.guid = newGUID();
		const bound = fn.bind(context);
		bound.guid = uid ? uid + "_" + fn.guid : fn.guid;
		return bound;
	};
	/**
	* Wraps the given function, `fn`, with a new function that only invokes `fn`
	* at most once per every `wait` milliseconds.
	*
	* @function
	* @param    {Function} fn
	*           The function to be throttled.
	*
	* @param    {number}   wait
	*           The number of milliseconds by which to throttle.
	*
	* @return   {Function}
	*/
	var throttle = function(fn, wait) {
		let last = window__default["default"].performance.now();
		const throttled = function(...args) {
			const now = window__default["default"].performance.now();
			if (now - last >= wait) {
				fn(...args);
				last = now;
			}
		};
		return throttled;
	};
	/**
	* Creates a debounced function that delays invoking `func` until after `wait`
	* milliseconds have elapsed since the last time the debounced function was
	* invoked.
	*
	* Inspired by lodash and underscore implementations.
	*
	* @function
	* @param    {Function} func
	*           The function to wrap with debounce behavior.
	*
	* @param    {number} wait
	*           The number of milliseconds to wait after the last invocation.
	*
	* @param    {boolean} [immediate]
	*           Whether or not to invoke the function immediately upon creation.
	*
	* @param    {Object} [context=window]
	*           The "context" in which the debounced function should debounce. For
	*           example, if this function should be tied to a Video.js player,
	*           the player can be passed here. Alternatively, defaults to the
	*           global `window` object.
	*
	* @return   {Function}
	*           A debounced function.
	*/
	var debounce = function(func, wait, immediate, context = window__default["default"]) {
		let timeout;
		const cancel = () => {
			context.clearTimeout(timeout);
			timeout = null;
		};
		const debounced = function() {
			const self = this;
			const args = arguments;
			let later = function() {
				timeout = null;
				later = null;
				if (!immediate) func.apply(self, args);
			};
			if (!timeout && immediate) func.apply(self, args);
			context.clearTimeout(timeout);
			timeout = context.setTimeout(later, wait);
		};
		debounced.cancel = cancel;
		return debounced;
	};
	var Fn = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		UPDATE_REFRESH_INTERVAL,
		bind_,
		throttle,
		debounce
	});
	/**
	* @file src/js/event-target.js
	*/
	var EVENT_MAP;
	/**
	* `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	* adds shorthand functions that wrap around lengthy functions. For example:
	* the `on` function is a wrapper around `addEventListener`.
	*
	* @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	* @class EventTarget
	*/
	var EventTarget = class {
		/**
		* Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
		* function that will get called when an event with a certain name gets triggered.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to call with `EventTarget`s
		*/
		on(type, fn) {
			const ael = this.addEventListener;
			this.addEventListener = () => {};
			on(this, type, fn);
			this.addEventListener = ael;
		}
		/**
		* Removes an `event listener` for a specific event from an instance of `EventTarget`.
		* This makes it so that the `event listener` will no longer get called when the
		* named event happens.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to remove.
		*/
		off(type, fn) {
			off(this, type, fn);
		}
		/**
		* This function will add an `event listener` that gets triggered only once. After the
		* first trigger it will get removed. This is like adding an `event listener`
		* with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to be called once for each event name.
		*/
		one(type, fn) {
			const ael = this.addEventListener;
			this.addEventListener = () => {};
			one(this, type, fn);
			this.addEventListener = ael;
		}
		/**
		* This function will add an `event listener` that gets triggered only once and is
		* removed from all events. This is like adding an array of `event listener`s
		* with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
		* first time it is triggered.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to be called once for each event name.
		*/
		any(type, fn) {
			const ael = this.addEventListener;
			this.addEventListener = () => {};
			any(this, type, fn);
			this.addEventListener = ael;
		}
		/**
		* This function causes an event to happen. This will then cause any `event listeners`
		* that are waiting for that event, to get called. If there are no `event listeners`
		* for an event then nothing will happen.
		*
		* If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
		* Trigger will also call the `on` + `uppercaseEventName` function.
		*
		* Example:
		* 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
		* `onClick` if it exists.
		*
		* @param {string|EventTarget~Event|Object} event
		*        The name of the event, an `Event`, or an object with a key of type set to
		*        an event name.
		*/
		trigger(event) {
			const type = event.type || event;
			if (typeof event === "string") event = { type };
			event = fixEvent(event);
			if (this.allowedEvents_[type] && this["on" + type]) this["on" + type](event);
			trigger(this, event);
		}
		queueTrigger(event) {
			if (!EVENT_MAP) EVENT_MAP = /* @__PURE__ */ new Map();
			const type = event.type || event;
			let map = EVENT_MAP.get(this);
			if (!map) {
				map = /* @__PURE__ */ new Map();
				EVENT_MAP.set(this, map);
			}
			const oldTimeout = map.get(type);
			map.delete(type);
			window__default["default"].clearTimeout(oldTimeout);
			const timeout = window__default["default"].setTimeout(() => {
				map.delete(type);
				if (map.size === 0) {
					map = null;
					EVENT_MAP.delete(this);
				}
				this.trigger(event);
			}, 0);
			map.set(type, timeout);
		}
	};
	/**
	* A Custom DOM event.
	*
	* @typedef {CustomEvent} Event
	* @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	*/
	/**
	* All event listeners should follow the following format.
	*
	* @callback EventListener
	* @this {EventTarget}
	*
	* @param {Event} event
	*        the event that triggered this function
	*
	* @param {Object} [hash]
	*        hash of data sent during the event
	*/
	/**
	* An object containing event names as keys and booleans as values.
	*
	* > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	*         will have extra functionality. See that function for more information.
	*
	* @property EventTarget.prototype.allowedEvents_
	* @protected
	*/
	EventTarget.prototype.allowedEvents_ = {};
	/**
	* An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	* the standard DOM API.
	*
	* @function
	* @see {@link EventTarget#on}
	*/
	EventTarget.prototype.addEventListener = EventTarget.prototype.on;
	/**
	* An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	* the standard DOM API.
	*
	* @function
	* @see {@link EventTarget#off}
	*/
	EventTarget.prototype.removeEventListener = EventTarget.prototype.off;
	/**
	* An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	* the standard DOM API.
	*
	* @function
	* @see {@link EventTarget#trigger}
	*/
	EventTarget.prototype.dispatchEvent = EventTarget.prototype.trigger;
	/**
	* @file mixins/evented.js
	* @module evented
	*/
	var objName = (obj) => {
		if (typeof obj.name === "function") return obj.name();
		if (typeof obj.name === "string") return obj.name;
		if (obj.name_) return obj.name_;
		if (obj.constructor && obj.constructor.name) return obj.constructor.name;
		return typeof obj;
	};
	/**
	* Returns whether or not an object has had the evented mixin applied.
	*
	* @param  {Object} object
	*         An object to test.
	*
	* @return {boolean}
	*         Whether or not the object appears to be evented.
	*/
	var isEvented = (object) => object instanceof EventTarget || !!object.eventBusEl_ && [
		"on",
		"one",
		"off",
		"trigger"
	].every((k) => typeof object[k] === "function");
	/**
	* Adds a callback to run after the evented mixin applied.
	*
	* @param  {Object} target
	*         An object to Add
	* @param  {Function} callback
	*         The callback to run.
	*/
	var addEventedCallback = (target, callback) => {
		if (isEvented(target)) callback();
		else {
			if (!target.eventedCallbacks) target.eventedCallbacks = [];
			target.eventedCallbacks.push(callback);
		}
	};
	/**
	* Whether a value is a valid event type - non-empty string or array.
	*
	* @private
	* @param  {string|Array} type
	*         The type value to test.
	*
	* @return {boolean}
	*         Whether or not the type is a valid event type.
	*/
	var isValidEventType = (type) => typeof type === "string" && /\S/.test(type) || Array.isArray(type) && !!type.length;
	/**
	* Validates a value to determine if it is a valid event target. Throws if not.
	*
	* @private
	* @throws {Error}
	*         If the target does not appear to be a valid event target.
	*
	* @param  {Object} target
	*         The object to test.
	*
	* @param  {Object} obj
	*         The evented object we are validating for
	*
	* @param  {string} fnName
	*         The name of the evented mixin function that called this.
	*/
	var validateTarget = (target, obj, fnName) => {
		if (!target || !target.nodeName && !isEvented(target)) throw new Error(`Invalid target for ${objName(obj)}#${fnName}; must be a DOM node or evented object.`);
	};
	/**
	* Validates a value to determine if it is a valid event target. Throws if not.
	*
	* @private
	* @throws {Error}
	*         If the type does not appear to be a valid event type.
	*
	* @param  {string|Array} type
	*         The type to test.
	*
	* @param  {Object} obj
	*         The evented object we are validating for
	*
	* @param  {string} fnName
	*         The name of the evented mixin function that called this.
	*/
	var validateEventType = (type, obj, fnName) => {
		if (!isValidEventType(type)) throw new Error(`Invalid event type for ${objName(obj)}#${fnName}; must be a non-empty string or array.`);
	};
	/**
	* Validates a value to determine if it is a valid listener. Throws if not.
	*
	* @private
	* @throws {Error}
	*         If the listener is not a function.
	*
	* @param  {Function} listener
	*         The listener to test.
	*
	* @param  {Object} obj
	*         The evented object we are validating for
	*
	* @param  {string} fnName
	*         The name of the evented mixin function that called this.
	*/
	var validateListener = (listener, obj, fnName) => {
		if (typeof listener !== "function") throw new Error(`Invalid listener for ${objName(obj)}#${fnName}; must be a function.`);
	};
	/**
	* Takes an array of arguments given to `on()` or `one()`, validates them, and
	* normalizes them into an object.
	*
	* @private
	* @param  {Object} self
	*         The evented object on which `on()` or `one()` was called. This
	*         object will be bound as the `this` value for the listener.
	*
	* @param  {Array} args
	*         An array of arguments passed to `on()` or `one()`.
	*
	* @param  {string} fnName
	*         The name of the evented mixin function that called this.
	*
	* @return {Object}
	*         An object containing useful values for `on()` or `one()` calls.
	*/
	var normalizeListenArgs = (self, args, fnName) => {
		const isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
		let target;
		let type;
		let listener;
		if (isTargetingSelf) {
			target = self.eventBusEl_;
			if (args.length >= 3) args.shift();
			[type, listener] = args;
		} else {
			target = args[0];
			type = args[1];
			listener = args[2];
		}
		validateTarget(target, self, fnName);
		validateEventType(type, self, fnName);
		validateListener(listener, self, fnName);
		listener = bind_(self, listener);
		return {
			isTargetingSelf,
			target,
			type,
			listener
		};
	};
	/**
	* Adds the listener to the event type(s) on the target, normalizing for
	* the type of target.
	*
	* @private
	* @param  {Element|Object} target
	*         A DOM node or evented object.
	*
	* @param  {string} method
	*         The event binding method to use ("on" or "one").
	*
	* @param  {string|Array} type
	*         One or more event type(s).
	*
	* @param  {Function} listener
	*         A listener function.
	*/
	var listen = (target, method, type, listener) => {
		validateTarget(target, target, method);
		if (target.nodeName) Events[method](target, type, listener);
		else target[method](type, listener);
	};
	/**
	* Contains methods that provide event capabilities to an object which is passed
	* to {@link module:evented|evented}.
	*
	* @mixin EventedMixin
	*/
	var EventedMixin = {
		/**
		* Add a listener to an event (or events) on this object or another evented
		* object.
		*
		* @param  {string|Array|Element|Object} targetOrType
		*         If this is a string or array, it represents the event type(s)
		*         that will trigger the listener.
		*
		*         Another evented object can be passed here instead, which will
		*         cause the listener to listen for events on _that_ object.
		*
		*         In either case, the listener's `this` value will be bound to
		*         this object.
		*
		* @param  {string|Array|Function} typeOrListener
		*         If the first argument was a string or array, this should be the
		*         listener function. Otherwise, this is a string or array of event
		*         type(s).
		*
		* @param  {Function} [listener]
		*         If the first argument was another evented object, this will be
		*         the listener function.
		*/
		on(...args) {
			const { isTargetingSelf, target, type, listener } = normalizeListenArgs(this, args, "on");
			listen(target, "on", type, listener);
			if (!isTargetingSelf) {
				const removeListenerOnDispose = () => this.off(target, type, listener);
				removeListenerOnDispose.guid = listener.guid;
				const removeRemoverOnTargetDispose = () => this.off("dispose", removeListenerOnDispose);
				removeRemoverOnTargetDispose.guid = listener.guid;
				listen(this, "on", "dispose", removeListenerOnDispose);
				listen(target, "on", "dispose", removeRemoverOnTargetDispose);
			}
		},
		/**
		* Add a listener to an event (or events) on this object or another evented
		* object. The listener will be called once per event and then removed.
		*
		* @param  {string|Array|Element|Object} targetOrType
		*         If this is a string or array, it represents the event type(s)
		*         that will trigger the listener.
		*
		*         Another evented object can be passed here instead, which will
		*         cause the listener to listen for events on _that_ object.
		*
		*         In either case, the listener's `this` value will be bound to
		*         this object.
		*
		* @param  {string|Array|Function} typeOrListener
		*         If the first argument was a string or array, this should be the
		*         listener function. Otherwise, this is a string or array of event
		*         type(s).
		*
		* @param  {Function} [listener]
		*         If the first argument was another evented object, this will be
		*         the listener function.
		*/
		one(...args) {
			const { isTargetingSelf, target, type, listener } = normalizeListenArgs(this, args, "one");
			if (isTargetingSelf) listen(target, "one", type, listener);
			else {
				const wrapper = (...largs) => {
					this.off(target, type, wrapper);
					listener.apply(null, largs);
				};
				wrapper.guid = listener.guid;
				listen(target, "one", type, wrapper);
			}
		},
		/**
		* Add a listener to an event (or events) on this object or another evented
		* object. The listener will only be called once for the first event that is triggered
		* then removed.
		*
		* @param  {string|Array|Element|Object} targetOrType
		*         If this is a string or array, it represents the event type(s)
		*         that will trigger the listener.
		*
		*         Another evented object can be passed here instead, which will
		*         cause the listener to listen for events on _that_ object.
		*
		*         In either case, the listener's `this` value will be bound to
		*         this object.
		*
		* @param  {string|Array|Function} typeOrListener
		*         If the first argument was a string or array, this should be the
		*         listener function. Otherwise, this is a string or array of event
		*         type(s).
		*
		* @param  {Function} [listener]
		*         If the first argument was another evented object, this will be
		*         the listener function.
		*/
		any(...args) {
			const { isTargetingSelf, target, type, listener } = normalizeListenArgs(this, args, "any");
			if (isTargetingSelf) listen(target, "any", type, listener);
			else {
				const wrapper = (...largs) => {
					this.off(target, type, wrapper);
					listener.apply(null, largs);
				};
				wrapper.guid = listener.guid;
				listen(target, "any", type, wrapper);
			}
		},
		/**
		* Removes listener(s) from event(s) on an evented object.
		*
		* @param  {string|Array|Element|Object} [targetOrType]
		*         If this is a string or array, it represents the event type(s).
		*
		*         Another evented object can be passed here instead, in which case
		*         ALL 3 arguments are _required_.
		*
		* @param  {string|Array|Function} [typeOrListener]
		*         If the first argument was a string or array, this may be the
		*         listener function. Otherwise, this is a string or array of event
		*         type(s).
		*
		* @param  {Function} [listener]
		*         If the first argument was another evented object, this will be
		*         the listener function; otherwise, _all_ listeners bound to the
		*         event type(s) will be removed.
		*/
		off(targetOrType, typeOrListener, listener) {
			if (!targetOrType || isValidEventType(targetOrType)) off(this.eventBusEl_, targetOrType, typeOrListener);
			else {
				const target = targetOrType;
				const type = typeOrListener;
				validateTarget(target, this, "off");
				validateEventType(type, this, "off");
				validateListener(listener, this, "off");
				listener = bind_(this, listener);
				this.off("dispose", listener);
				if (target.nodeName) {
					off(target, type, listener);
					off(target, "dispose", listener);
				} else if (isEvented(target)) {
					target.off(type, listener);
					target.off("dispose", listener);
				}
			}
		},
		/**
		* Fire an event on this evented object, causing its listeners to be called.
		*
		* @param   {string|Object} event
		*          An event type or an object with a type property.
		*
		* @param   {Object} [hash]
		*          An additional object to pass along to listeners.
		*
		* @return {boolean}
		*          Whether or not the default behavior was prevented.
		*/
		trigger(event, hash) {
			validateTarget(this.eventBusEl_, this, "trigger");
			if (!isValidEventType(event && typeof event !== "string" ? event.type : event)) throw new Error(`Invalid event type for ${objName(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
			return trigger(this.eventBusEl_, event, hash);
		}
	};
	/**
	* Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
	*
	* @param  {Object} target
	*         The object to which to add event methods.
	*
	* @param  {Object} [options={}]
	*         Options for customizing the mixin behavior.
	*
	* @param  {string} [options.eventBusKey]
	*         By default, adds a `eventBusEl_` DOM element to the target object,
	*         which is used as an event bus. If the target object already has a
	*         DOM element that should be used, pass its key here.
	*
	* @return {Object}
	*         The target object.
	*/
	function evented(target, options = {}) {
		const { eventBusKey } = options;
		if (eventBusKey) {
			if (!target[eventBusKey].nodeName) throw new Error(`The eventBusKey "${eventBusKey}" does not refer to an element.`);
			target.eventBusEl_ = target[eventBusKey];
		} else target.eventBusEl_ = createEl("span", { className: "vjs-event-bus" });
		Object.assign(target, EventedMixin);
		if (target.eventedCallbacks) target.eventedCallbacks.forEach((callback) => {
			callback();
		});
		target.on("dispose", () => {
			target.off();
			[
				target,
				target.el_,
				target.eventBusEl_
			].forEach(function(val) {
				if (val && DomData.has(val)) DomData.delete(val);
			});
			window__default["default"].setTimeout(() => {
				target.eventBusEl_ = null;
			}, 0);
		});
		return target;
	}
	/**
	* @file mixins/stateful.js
	* @module stateful
	*/
	/**
	* Contains methods that provide statefulness to an object which is passed
	* to {@link module:stateful}.
	*
	* @mixin StatefulMixin
	*/
	var StatefulMixin = {
		/**
		* A hash containing arbitrary keys and values representing the state of
		* the object.
		*
		* @type {Object}
		*/
		state: {},
		/**
		* Set the state of an object by mutating its
		* {@link module:stateful~StatefulMixin.state|state} object in place.
		*
		* @fires   module:stateful~StatefulMixin#statechanged
		* @param   {Object|Function} stateUpdates
		*          A new set of properties to shallow-merge into the plugin state.
		*          Can be a plain object or a function returning a plain object.
		*
		* @return {Object|undefined}
		*          An object containing changes that occurred. If no changes
		*          occurred, returns `undefined`.
		*/
		setState(stateUpdates) {
			if (typeof stateUpdates === "function") stateUpdates = stateUpdates();
			let changes;
			each(stateUpdates, (value, key) => {
				if (this.state[key] !== value) {
					changes = changes || {};
					changes[key] = {
						from: this.state[key],
						to: value
					};
				}
				this.state[key] = value;
			});
			if (changes && isEvented(this))
 /**
			* An event triggered on an object that is both
			* {@link module:stateful|stateful} and {@link module:evented|evented}
			* indicating that its state has changed.
			*
			* @event    module:stateful~StatefulMixin#statechanged
			* @type     {Object}
			* @property {Object} changes
			*           A hash containing the properties that were changed and
			*           the values they were changed `from` and `to`.
			*/
			this.trigger({
				changes,
				type: "statechanged"
			});
			return changes;
		}
	};
	/**
	* Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
	* object.
	*
	* If the target object is {@link module:evented|evented} and has a
	* `handleStateChanged` method, that method will be automatically bound to the
	* `statechanged` event on itself.
	*
	* @param   {Object} target
	*          The object to be made stateful.
	*
	* @param   {Object} [defaultState]
	*          A default set of properties to populate the newly-stateful object's
	*          `state` property.
	*
	* @return {Object}
	*          Returns the `target`.
	*/
	function stateful(target, defaultState) {
		Object.assign(target, StatefulMixin);
		target.state = Object.assign({}, target.state, defaultState);
		if (typeof target.handleStateChanged === "function" && isEvented(target)) target.on("statechanged", target.handleStateChanged);
		return target;
	}
	/**
	* @file str.js
	* @module to-lower-case
	*/
	/**
	* Lowercase the first letter of a string.
	*
	* @param {string} string
	*        String to be lowercased
	*
	* @return {string}
	*         The string with a lowercased first letter
	*/
	var toLowerCase = function(string) {
		if (typeof string !== "string") return string;
		return string.replace(/./, (w) => w.toLowerCase());
	};
	/**
	* Uppercase the first letter of a string.
	*
	* @param {string} string
	*        String to be uppercased
	*
	* @return {string}
	*         The string with an uppercased first letter
	*/
	var toTitleCase = function(string) {
		if (typeof string !== "string") return string;
		return string.replace(/./, (w) => w.toUpperCase());
	};
	/**
	* Compares the TitleCase versions of the two strings for equality.
	*
	* @param {string} str1
	*        The first string to compare
	*
	* @param {string} str2
	*        The second string to compare
	*
	* @return {boolean}
	*         Whether the TitleCase versions of the strings are equal
	*/
	var titleCaseEquals = function(str1, str2) {
		return toTitleCase(str1) === toTitleCase(str2);
	};
	var Str = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		toLowerCase,
		toTitleCase,
		titleCaseEquals
	});
	/**
	* Player Component - Base class for all UI objects
	*
	* @file component.js
	*/
	/** @import Player from './player' */
	/**
	* A callback to be called if and when the component is ready.
	* `this` will be the Component instance.
	*
	* @callback ReadyCallback
	* @returns  {void}
	*/
	/**
	* Base class for all UI Components.
	* Components are UI objects which represent both a javascript object and an element
	* in the DOM. They can be children of other components, and can have
	* children themselves.
	*
	* Components can also use methods from {@link EventTarget}
	*/
	var Component = class Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of component options.
		*
		* @param {Object[]} [options.children]
		*        An array of children objects to initialize this component with. Children objects have
		*        a name property that will be used if more than one component of the same type needs to be
		*        added.
		*
		* @param  {string} [options.className]
		*         A class or space separated list of classes to add the component
		*
		* @param {ReadyCallback} [ready]
		*        Function that gets called when the `Component` is ready.
		*/
		constructor(player, options, ready) {
			if (!player && this.play) this.player_ = player = this;
			else this.player_ = player;
			this.isDisposed_ = false;
			this.parentComponent_ = null;
			this.options_ = merge({}, this.options_);
			options = this.options_ = merge(this.options_, options);
			this.id_ = options.id || options.el && options.el.id;
			if (!this.id_) {
				const id = player && player.id && player.id() || "no_player";
				this.id_ = `${id}_component_${newGUID()}`;
			}
			this.name_ = options.name || null;
			if (options.el) this.el_ = options.el;
			else if (options.createEl !== false) this.el_ = this.createEl();
			if (options.className && this.el_) options.className.split(" ").forEach((c) => this.addClass(c));
			[
				"on",
				"off",
				"one",
				"any",
				"trigger"
			].forEach((fn) => {
				this[fn] = void 0;
			});
			if (options.evented !== false) {
				evented(this, { eventBusKey: this.el_ ? "el_" : null });
				this.handleLanguagechange = this.handleLanguagechange.bind(this);
				this.on(this.player_, "languagechange", this.handleLanguagechange);
			}
			stateful(this, this.constructor.defaultState);
			this.children_ = [];
			this.childIndex_ = {};
			this.childNameIndex_ = {};
			this.setTimeoutIds_ = /* @__PURE__ */ new Set();
			this.setIntervalIds_ = /* @__PURE__ */ new Set();
			this.rafIds_ = /* @__PURE__ */ new Set();
			this.namedRafs_ = /* @__PURE__ */ new Map();
			this.clearingTimersOnDispose_ = false;
			if (options.initChildren !== false) this.initChildren();
			this.ready(ready);
			if (options.reportTouchActivity !== false) this.enableTouchActivity();
		}
		/**
		* Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
		* function that will get called when an event with a certain name gets triggered.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to call with `EventTarget`s
		*/
		/**
		* Removes an `event listener` for a specific event from an instance of `EventTarget`.
		* This makes it so that the `event listener` will no longer get called when the
		* named event happens.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} [fn]
		*        The function to remove. If not specified, all listeners managed by Video.js will be removed.
		*/
		/**
		* This function will add an `event listener` that gets triggered only once. After the
		* first trigger it will get removed. This is like adding an `event listener`
		* with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to be called once for each event name.
		*/
		/**
		* This function will add an `event listener` that gets triggered only once and is
		* removed from all events. This is like adding an array of `event listener`s
		* with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
		* first time it is triggered.
		*
		* @param {string|string[]} type
		*        An event name or an array of event names.
		*
		* @param {Function} fn
		*        The function to be called once for each event name.
		*/
		/**
		* This function causes an event to happen. This will then cause any `event listeners`
		* that are waiting for that event, to get called. If there are no `event listeners`
		* for an event then nothing will happen.
		*
		* If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
		* Trigger will also call the `on` + `uppercaseEventName` function.
		*
		* Example:
		* 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
		* `onClick` if it exists.
		*
		* @param {string|Event|Object} event
		*        The name of the event, an `Event`, or an object with a key of type set to
		*        an event name.
		*
		* @param {Object} [hash]
		*        Optionally extra argument to pass through to an event listener
		*/
		/**
		* Dispose of the `Component` and all child components.
		*
		* @fires Component#dispose
		*
		* @param {Object} options
		* @param {Element} options.originalEl element with which to replace player element
		*/
		dispose(options = {}) {
			if (this.isDisposed_) return;
			if (this.readyQueue_) this.readyQueue_.length = 0;
			/**
			* Triggered when a `Component` is disposed.
			*
			* @event Component#dispose
			* @type {Event}
			*
			* @property {boolean} [bubbles=false]
			*           set to false so that the dispose event does not
			*           bubble up
			*/
			this.trigger({
				type: "dispose",
				bubbles: false
			});
			this.isDisposed_ = true;
			if (this.children_) {
				for (let i = this.children_.length - 1; i >= 0; i--) if (this.children_[i].dispose) this.children_[i].dispose();
			}
			this.children_ = null;
			this.childIndex_ = null;
			this.childNameIndex_ = null;
			this.parentComponent_ = null;
			if (this.el_) {
				if (this.el_.parentNode) if (options.restoreEl) this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
				else this.el_.parentNode.removeChild(this.el_);
				this.el_ = null;
			}
			this.player_ = null;
		}
		/**
		* Determine whether or not this component has been disposed.
		*
		* @return {boolean}
		*         If the component has been disposed, will be `true`. Otherwise, `false`.
		*/
		isDisposed() {
			return Boolean(this.isDisposed_);
		}
		/**
		* Return the {@link Player} that the `Component` has attached to.
		*
		* @return {Player}
		*         The player that this `Component` has attached to.
		*/
		player() {
			return this.player_;
		}
		/**
		* Deep merge of options objects with new options.
		* > Note: When both `obj` and `options` contain properties whose values are objects.
		*         The two properties get merged using {@link module:obj.merge}
		*
		* @param {Object} obj
		*        The object that contains new options.
		*
		* @return {Object}
		*         A new object of `this.options_` and `obj` merged together.
		*/
		options(obj) {
			if (!obj) return this.options_;
			this.options_ = merge(this.options_, obj);
			return this.options_;
		}
		/**
		* Get the `Component`s DOM element
		*
		* @return {Element}
		*         The DOM element for this `Component`.
		*/
		el() {
			return this.el_;
		}
		/**
		* Create the `Component`s DOM element.
		*
		* @param {string} [tagName]
		*        Element's DOM node type. e.g. 'div'
		*
		* @param {Object} [properties]
		*        An object of properties that should be set.
		*
		* @param {Object} [attributes]
		*        An object of attributes that should be set.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl(tagName, properties, attributes) {
			return createEl(tagName, properties, attributes);
		}
		/**
		* Localize a string given the string in english.
		*
		* If tokens are provided, it'll try and run a simple token replacement on the provided string.
		* The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
		*
		* If a `defaultValue` is provided, it'll use that over `string`,
		* if a value isn't found in provided language files.
		* This is useful if you want to have a descriptive key for token replacement
		* but have a succinct localized string and not require `en.json` to be included.
		*
		* Currently, it is used for the progress bar timing.
		* ```js
		* {
		*   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
		* }
		* ```
		* It is then used like so:
		* ```js
		* this.localize('progress bar timing: currentTime={1} duration{2}',
		*               [this.player_.currentTime(), this.player_.duration()],
		*               '{1} of {2}');
		* ```
		*
		* Which outputs something like: `01:23 of 24:56`.
		*
		*
		* @param {string} string
		*        The string to localize and the key to lookup in the language files.
		* @param {string[]} [tokens]
		*        If the current item has token replacements, provide the tokens here.
		* @param {string} [defaultValue]
		*        Defaults to `string`. Can be a default value to use for token replacement
		*        if the lookup key is needed to be separate.
		*
		* @return {string}
		*         The localized string or if no localization exists the english string.
		*/
		localize(string, tokens, defaultValue = string) {
			const code = this.player_.language && this.player_.language();
			const languages = this.player_.languages && this.player_.languages();
			const language = languages && languages[code];
			const primaryCode = code && code.split("-")[0];
			const primaryLang = languages && languages[primaryCode];
			let localizedString = defaultValue;
			if (language && language[string]) localizedString = language[string];
			else if (primaryLang && primaryLang[string]) localizedString = primaryLang[string];
			if (tokens) localizedString = localizedString.replace(/\{(\d+)\}/g, function(match, index) {
				const value = tokens[index - 1];
				let ret = value;
				if (typeof value === "undefined") ret = match;
				return ret;
			});
			return localizedString;
		}
		/**
		* Handles language change for the player in components. Should be overridden by sub-components.
		*
		* @abstract
		*/
		handleLanguagechange() {}
		/**
		* Return the `Component`s DOM element. This is where children get inserted.
		* This will usually be the the same as the element returned in {@link Component#el}.
		*
		* @return {Element}
		*         The content element for this `Component`.
		*/
		contentEl() {
			return this.contentEl_ || this.el_;
		}
		/**
		* Get this `Component`s ID
		*
		* @return {string}
		*         The id of this `Component`
		*/
		id() {
			return this.id_;
		}
		/**
		* Get the `Component`s name. The name gets used to reference the `Component`
		* and is set during registration.
		*
		* @return {string}
		*         The name of this `Component`.
		*/
		name() {
			return this.name_;
		}
		/**
		* Get an array of all child components
		*
		* @return {Array}
		*         The children
		*/
		children() {
			return this.children_;
		}
		/**
		* Returns the child `Component` with the given `id`.
		*
		* @param {string} id
		*        The id of the child `Component` to get.
		*
		* @return {Component|undefined}
		*         The child `Component` with the given `id` or undefined.
		*/
		getChildById(id) {
			return this.childIndex_[id];
		}
		/**
		* Returns the child `Component` with the given `name`.
		*
		* @param {string} name
		*        The name of the child `Component` to get.
		*
		* @return {Component|undefined}
		*         The child `Component` with the given `name` or undefined.
		*/
		getChild(name) {
			if (!name) return;
			return this.childNameIndex_[name];
		}
		/**
		* Returns the descendant `Component` following the givent
		* descendant `names`. For instance ['foo', 'bar', 'baz'] would
		* try to get 'foo' on the current component, 'bar' on the 'foo'
		* component and 'baz' on the 'bar' component and return undefined
		* if any of those don't exist.
		*
		* @param {...string[]|...string} names
		*        The name of the child `Component` to get.
		*
		* @return {Component|undefined}
		*         The descendant `Component` following the given descendant
		*         `names` or undefined.
		*/
		getDescendant(...names) {
			names = names.reduce((acc, n) => acc.concat(n), []);
			let currentChild = this;
			for (let i = 0; i < names.length; i++) {
				currentChild = currentChild.getChild(names[i]);
				if (!currentChild || !currentChild.getChild) return;
			}
			return currentChild;
		}
		/**
		* Adds an SVG icon element to another element or component.
		*
		* @param {string} iconName
		*        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
		*
		* @param {Element} [el=this.el()]
		*        Element to set the title on. Defaults to the current Component's element.
		*
		* @return {Element}
		*        The newly created icon element.
		*/
		setIcon(iconName, el = this.el()) {
			if (!this.player_.options_.experimentalSvgIcons) return;
			const xmlnsURL = "http://www.w3.org/2000/svg";
			const iconContainer = createEl("span", { className: "vjs-icon-placeholder vjs-svg-icon" }, { "aria-hidden": "true" });
			const svgEl = document__default["default"].createElementNS(xmlnsURL, "svg");
			svgEl.setAttributeNS(null, "viewBox", "0 0 512 512");
			const useEl = document__default["default"].createElementNS(xmlnsURL, "use");
			svgEl.appendChild(useEl);
			useEl.setAttributeNS(null, "href", `#vjs-icon-${iconName}`);
			iconContainer.appendChild(svgEl);
			if (this.iconIsSet_) el.replaceChild(iconContainer, el.querySelector(".vjs-icon-placeholder"));
			else el.appendChild(iconContainer);
			this.iconIsSet_ = true;
			return iconContainer;
		}
		/**
		* Add a child `Component` inside the current `Component`.
		*
		* @param {string|Component} child
		*        The name or instance of a child to add.
		*
		* @param {Object} [options={}]
		*        The key/value store of options that will get passed to children of
		*        the child.
		*
		* @param {number} [index=this.children_.length]
		*        The index to attempt to add a child into.
		*
		*
		* @return {Component}
		*         The `Component` that gets added as a child. When using a string the
		*         `Component` will get created by this process.
		*/
		addChild(child, options = {}, index = this.children_.length) {
			let component;
			let componentName;
			if (typeof child === "string") {
				componentName = toTitleCase(child);
				const componentClassName = options.componentClass || componentName;
				options.name = componentName;
				const ComponentClass = Component.getComponent(componentClassName);
				if (!ComponentClass) throw new Error(`Component ${componentClassName} does not exist`);
				if (typeof ComponentClass !== "function") return null;
				component = new ComponentClass(this.player_ || this, options);
			} else component = child;
			if (component.parentComponent_) component.parentComponent_.removeChild(component);
			this.children_.splice(index, 0, component);
			component.parentComponent_ = this;
			if (typeof component.id === "function") this.childIndex_[component.id()] = component;
			componentName = componentName || component.name && toTitleCase(component.name());
			if (componentName) {
				this.childNameIndex_[componentName] = component;
				this.childNameIndex_[toLowerCase(componentName)] = component;
			}
			if (typeof component.el === "function" && component.el()) {
				let refNode = null;
				if (this.children_[index + 1]) {
					if (this.children_[index + 1].el_) refNode = this.children_[index + 1].el_;
					else if (isEl(this.children_[index + 1])) refNode = this.children_[index + 1];
				}
				this.contentEl().insertBefore(component.el(), refNode);
			}
			return component;
		}
		/**
		* Remove a child `Component` from this `Component`s list of children. Also removes
		* the child `Component`s element from this `Component`s element.
		*
		* @param {string|Component} component
		*       The name or instance of a child to remove.
		*/
		removeChild(component) {
			if (typeof component === "string") component = this.getChild(component);
			if (!component || !this.children_) return;
			let childFound = false;
			for (let i = this.children_.length - 1; i >= 0; i--) if (this.children_[i] === component) {
				childFound = true;
				this.children_.splice(i, 1);
				break;
			}
			if (!childFound) return;
			component.parentComponent_ = null;
			this.childIndex_[component.id()] = null;
			this.childNameIndex_[toTitleCase(component.name())] = null;
			this.childNameIndex_[toLowerCase(component.name())] = null;
			const compEl = component.el();
			if (compEl && compEl.parentNode === this.contentEl()) this.contentEl().removeChild(component.el());
		}
		/**
		* Add and initialize default child `Component`s based upon options.
		*/
		initChildren() {
			const children = this.options_.children;
			if (children) {
				const parentOptions = this.options_;
				const handleAdd = (child) => {
					const name = child.name;
					let opts = child.opts;
					if (parentOptions[name] !== void 0) opts = parentOptions[name];
					if (opts === false) return;
					if (opts === true) opts = {};
					opts.playerOptions = this.options_.playerOptions;
					const newChild = this.addChild(name, opts);
					if (newChild) this[name] = newChild;
				};
				let workingChildren;
				const Tech = Component.getComponent("Tech");
				if (Array.isArray(children)) workingChildren = children;
				else workingChildren = Object.keys(children);
				workingChildren.concat(Object.keys(this.options_).filter(function(child) {
					return !workingChildren.some(function(wchild) {
						if (typeof wchild === "string") return child === wchild;
						return child === wchild.name;
					});
				})).map((child) => {
					let name;
					let opts;
					if (typeof child === "string") {
						name = child;
						opts = children[name] || this.options_[name] || {};
					} else {
						name = child.name;
						opts = child;
					}
					return {
						name,
						opts
					};
				}).filter((child) => {
					const c = Component.getComponent(child.opts.componentClass || toTitleCase(child.name));
					return c && !Tech.isTech(c);
				}).forEach(handleAdd);
			}
		}
		/**
		* Builds the default DOM class name. Should be overridden by sub-components.
		*
		* @return {string}
		*         The DOM class name for this object.
		*
		* @abstract
		*/
		buildCSSClass() {
			return "";
		}
		/**
		* Bind a listener to the component's ready state.
		* Different from event listeners in that if the ready event has already happened
		* it will trigger the function immediately.
		*
		* @param {ReadyCallback} fn
		*        Function that gets called when the `Component` is ready.
		*/
		ready(fn, sync = false) {
			if (!fn) return;
			if (!this.isReady_) {
				this.readyQueue_ = this.readyQueue_ || [];
				this.readyQueue_.push(fn);
				return;
			}
			if (sync) fn.call(this);
			else this.setTimeout(fn, 1);
		}
		/**
		* Trigger all the ready listeners for this `Component`.
		*
		* @fires Component#ready
		*/
		triggerReady() {
			this.isReady_ = true;
			this.setTimeout(function() {
				const readyQueue = this.readyQueue_;
				this.readyQueue_ = [];
				if (readyQueue && readyQueue.length > 0) readyQueue.forEach(function(fn) {
					fn.call(this);
				}, this);
				/**
				* Triggered when a `Component` is ready.
				*
				* @event Component#ready
				* @type {Event}
				*/
				this.trigger("ready");
			}, 1);
		}
		/**
		* Find a single DOM element matching a `selector`. This can be within the `Component`s
		* `contentEl()` or another custom context.
		*
		* @param {string} selector
		*        A valid CSS selector, which will be passed to `querySelector`.
		*
		* @param {Element|string} [context=this.contentEl()]
		*        A DOM element within which to query. Can also be a selector string in
		*        which case the first matching element will get used as context. If
		*        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
		*        nothing it falls back to `document`.
		*
		* @return {Element|null}
		*         the dom element that was found, or null
		*
		* @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
		*/
		$(selector, context) {
			return $(selector, context || this.contentEl());
		}
		/**
		* Finds all DOM element matching a `selector`. This can be within the `Component`s
		* `contentEl()` or another custom context.
		*
		* @param {string} selector
		*        A valid CSS selector, which will be passed to `querySelectorAll`.
		*
		* @param {Element|string} [context=this.contentEl()]
		*        A DOM element within which to query. Can also be a selector string in
		*        which case the first matching element will get used as context. If
		*        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
		*        nothing it falls back to `document`.
		*
		* @return {NodeList}
		*         a list of dom elements that were found
		*
		* @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
		*/
		$$(selector, context) {
			return $$(selector, context || this.contentEl());
		}
		/**
		* Check if a component's element has a CSS class name.
		*
		* @param {string} classToCheck
		*        CSS class name to check.
		*
		* @return {boolean}
		*         - True if the `Component` has the class.
		*         - False if the `Component` does not have the class`
		*/
		hasClass(classToCheck) {
			return hasClass(this.el_, classToCheck);
		}
		/**
		* Add a CSS class name to the `Component`s element.
		*
		* @param {...string} classesToAdd
		*        One or more CSS class name to add.
		*/
		addClass(...classesToAdd) {
			addClass(this.el_, ...classesToAdd);
		}
		/**
		* Remove a CSS class name from the `Component`s element.
		*
		* @param {...string} classesToRemove
		*        One or more CSS class name to remove.
		*/
		removeClass(...classesToRemove) {
			removeClass(this.el_, ...classesToRemove);
		}
		/**
		* Add or remove a CSS class name from the component's element.
		* - `classToToggle` gets added when {@link Component#hasClass} would return false.
		* - `classToToggle` gets removed when {@link Component#hasClass} would return true.
		*
		* @param  {string} classToToggle
		*         The class to add or remove. Passed to DOMTokenList's toggle()
		*
		* @param  {boolean|Dom.PredicateCallback} [predicate]
		*         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
		*/
		toggleClass(classToToggle, predicate) {
			toggleClass(this.el_, classToToggle, predicate);
		}
		/**
		* Show the `Component`s element if it is hidden by removing the
		* 'vjs-hidden' class name from it.
		*/
		show() {
			this.removeClass("vjs-hidden");
		}
		/**
		* Hide the `Component`s element if it is currently showing by adding the
		* 'vjs-hidden` class name to it.
		*/
		hide() {
			this.addClass("vjs-hidden");
		}
		/**
		* Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
		* class name to it. Used during fadeIn/fadeOut.
		*
		* @private
		*/
		lockShowing() {
			this.addClass("vjs-lock-showing");
		}
		/**
		* Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
		* class name from it. Used during fadeIn/fadeOut.
		*
		* @private
		*/
		unlockShowing() {
			this.removeClass("vjs-lock-showing");
		}
		/**
		* Get the value of an attribute on the `Component`s element.
		*
		* @param {string} attribute
		*        Name of the attribute to get the value from.
		*
		* @return {string|null}
		*         - The value of the attribute that was asked for.
		*         - Can be an empty string on some browsers if the attribute does not exist
		*           or has no value
		*         - Most browsers will return null if the attribute does not exist or has
		*           no value.
		*
		* @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
		*/
		getAttribute(attribute) {
			return getAttribute(this.el_, attribute);
		}
		/**
		* Set the value of an attribute on the `Component`'s element
		*
		* @param {string} attribute
		*        Name of the attribute to set.
		*
		* @param {string} value
		*        Value to set the attribute to.
		*
		* @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
		*/
		setAttribute(attribute, value) {
			setAttribute(this.el_, attribute, value);
		}
		/**
		* Remove an attribute from the `Component`s element.
		*
		* @param {string} attribute
		*        Name of the attribute to remove.
		*
		* @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
		*/
		removeAttribute(attribute) {
			removeAttribute(this.el_, attribute);
		}
		/**
		* Get or set the width of the component based upon the CSS styles.
		* See {@link Component#dimension} for more detailed information.
		*
		* @param {number|string} [num]
		*        The width that you want to set postfixed with '%', 'px' or nothing.
		*
		* @param {boolean} [skipListeners]
		*        Skip the componentresize event trigger
		*
		* @return {number|undefined}
		*         The width when getting, zero if there is no width
		*/
		width(num, skipListeners) {
			return this.dimension("width", num, skipListeners);
		}
		/**
		* Get or set the height of the component based upon the CSS styles.
		* See {@link Component#dimension} for more detailed information.
		*
		* @param {number|string} [num]
		*        The height that you want to set postfixed with '%', 'px' or nothing.
		*
		* @param {boolean} [skipListeners]
		*        Skip the componentresize event trigger
		*
		* @return {number|undefined}
		*         The height when getting, zero if there is no height
		*/
		height(num, skipListeners) {
			return this.dimension("height", num, skipListeners);
		}
		/**
		* Set both the width and height of the `Component` element at the same time.
		*
		* @param  {number|string} width
		*         Width to set the `Component`s element to.
		*
		* @param  {number|string} height
		*         Height to set the `Component`s element to.
		*/
		dimensions(width, height) {
			this.width(width, true);
			this.height(height);
		}
		/**
		* Get or set width or height of the `Component` element. This is the shared code
		* for the {@link Component#width} and {@link Component#height}.
		*
		* Things to know:
		* - If the width or height in an number this will return the number postfixed with 'px'.
		* - If the width/height is a percent this will return the percent postfixed with '%'
		* - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
		*   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
		*   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
		*   for more information
		* - If you want the computed style of the component, use {@link Component#currentWidth}
		*   and {@link {Component#currentHeight}
		*
		* @fires Component#componentresize
		*
		* @param {string} widthOrHeight
		8        'width' or 'height'
		*
		* @param  {number|string} [num]
		8         New dimension
		*
		* @param  {boolean} [skipListeners]
		*         Skip componentresize event trigger
		*
		* @return {number|undefined}
		*         The dimension when getting or 0 if unset
		*/
		dimension(widthOrHeight, num, skipListeners) {
			if (num !== void 0) {
				if (num === null || num !== num) num = 0;
				if (("" + num).indexOf("%") !== -1 || ("" + num).indexOf("px") !== -1) this.el_.style[widthOrHeight] = num;
				else if (num === "auto") this.el_.style[widthOrHeight] = "";
				else this.el_.style[widthOrHeight] = num + "px";
				if (!skipListeners)
 /**
				* Triggered when a component is resized.
				*
				* @event Component#componentresize
				* @type {Event}
				*/
				this.trigger("componentresize");
				return;
			}
			if (!this.el_) return 0;
			const val = this.el_.style[widthOrHeight];
			const pxIndex = val.indexOf("px");
			if (pxIndex !== -1) return parseInt(val.slice(0, pxIndex), 10);
			return parseInt(this.el_["offset" + toTitleCase(widthOrHeight)], 10);
		}
		/**
		* Get the computed width or the height of the component's element.
		*
		* Uses `window.getComputedStyle`.
		*
		* @param {string} widthOrHeight
		*        A string containing 'width' or 'height'. Whichever one you want to get.
		*
		* @return {number}
		*         The dimension that gets asked for or 0 if nothing was set
		*         for that dimension.
		*/
		currentDimension(widthOrHeight) {
			let computedWidthOrHeight = 0;
			if (widthOrHeight !== "width" && widthOrHeight !== "height") throw new Error("currentDimension only accepts width or height value");
			computedWidthOrHeight = computedStyle(this.el_, widthOrHeight);
			computedWidthOrHeight = parseFloat(computedWidthOrHeight);
			if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
				const rule = `offset${toTitleCase(widthOrHeight)}`;
				computedWidthOrHeight = this.el_[rule];
			}
			return computedWidthOrHeight;
		}
		/**
		* An object that contains width and height values of the `Component`s
		* computed style. Uses `window.getComputedStyle`.
		*
		* @typedef {Object} Component~DimensionObject
		*
		* @property {number} width
		*           The width of the `Component`s computed style.
		*
		* @property {number} height
		*           The height of the `Component`s computed style.
		*/
		/**
		* Get an object that contains computed width and height values of the
		* component's element.
		*
		* Uses `window.getComputedStyle`.
		*
		* @return {Component~DimensionObject}
		*         The computed dimensions of the component's element.
		*/
		currentDimensions() {
			return {
				width: this.currentDimension("width"),
				height: this.currentDimension("height")
			};
		}
		/**
		* Get the computed width of the component's element.
		*
		* Uses `window.getComputedStyle`.
		*
		* @return {number}
		*         The computed width of the component's element.
		*/
		currentWidth() {
			return this.currentDimension("width");
		}
		/**
		* Get the computed height of the component's element.
		*
		* Uses `window.getComputedStyle`.
		*
		* @return {number}
		*         The computed height of the component's element.
		*/
		currentHeight() {
			return this.currentDimension("height");
		}
		/**
		* Retrieves the position and size information of the component's element.
		*
		* @return {Object} An object with `boundingClientRect` and `center` properties.
		*         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
		*           `height`, `top`, `right`, `bottom`, and `left`, representing
		*           the bounding rectangle of the element.
		*         - `center`: An object with properties `x` and `y`, representing
		*           the center point of the element. `width` and `height` are set to 0.
		*/
		getPositions() {
			const rect = this.el_.getBoundingClientRect();
			return {
				boundingClientRect: {
					x: rect.x,
					y: rect.y,
					width: rect.width,
					height: rect.height,
					top: rect.top,
					right: rect.right,
					bottom: rect.bottom,
					left: rect.left
				},
				center: {
					x: rect.left + rect.width / 2,
					y: rect.top + rect.height / 2,
					width: 0,
					height: 0,
					top: rect.top + rect.height / 2,
					right: rect.left + rect.width / 2,
					bottom: rect.top + rect.height / 2,
					left: rect.left + rect.width / 2
				}
			};
		}
		/**
		* Set the focus to this component
		*/
		focus() {
			this.el_.focus();
		}
		/**
		* Remove the focus from this component
		*/
		blur() {
			this.el_.blur();
		}
		/**
		* When this Component receives a `keydown` event which it does not process,
		*  it passes the event to the Player for handling.
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*/
		handleKeyDown(event) {
			if (this.player_) {
				if (event.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) event.stopPropagation();
				this.player_.handleKeyDown(event);
			}
		}
		/**
		* Many components used to have a `handleKeyPress` method, which was poorly
		* named because it listened to a `keydown` event. This method name now
		* delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
		* will not see their method calls stop working.
		*
		* @param {KeyboardEvent} event
		*        The event that caused this function to be called.
		*/
		handleKeyPress(event) {
			this.handleKeyDown(event);
		}
		/**
		* Emit a 'tap' events when touch event support gets detected. This gets used to
		* support toggling the controls through a tap on the video. They get enabled
		* because every sub-component would have extra overhead otherwise.
		*
		* @protected
		* @fires Component#tap
		* @listens Component#touchstart
		* @listens Component#touchmove
		* @listens Component#touchleave
		* @listens Component#touchcancel
		* @listens Component#touchend
		*/
		emitTapEvents() {
			let touchStart = 0;
			let firstTouch = null;
			const tapMovementThreshold = 10;
			const touchTimeThreshold = 200;
			let couldBeTap;
			this.on("touchstart", function(event) {
				if (event.touches.length === 1) {
					firstTouch = {
						pageX: event.touches[0].pageX,
						pageY: event.touches[0].pageY
					};
					touchStart = window__default["default"].performance.now();
					couldBeTap = true;
				}
			});
			this.on("touchmove", function(event) {
				if (event.touches.length > 1) couldBeTap = false;
				else if (firstTouch) {
					const xdiff = event.touches[0].pageX - firstTouch.pageX;
					const ydiff = event.touches[0].pageY - firstTouch.pageY;
					if (Math.sqrt(xdiff * xdiff + ydiff * ydiff) > tapMovementThreshold) couldBeTap = false;
				}
			});
			const noTap = function() {
				couldBeTap = false;
			};
			this.on("touchleave", noTap);
			this.on("touchcancel", noTap);
			this.on("touchend", function(event) {
				firstTouch = null;
				if (couldBeTap === true) {
					if (window__default["default"].performance.now() - touchStart < touchTimeThreshold) {
						event.preventDefault();
						/**
						* Triggered when a `Component` is tapped.
						*
						* @event Component#tap
						* @type {MouseEvent}
						*/
						this.trigger("tap");
					}
				}
			});
		}
		/**
		* This function reports user activity whenever touch events happen. This can get
		* turned off by any sub-components that wants touch events to act another way.
		*
		* Report user touch activity when touch events occur. User activity gets used to
		* determine when controls should show/hide. It is simple when it comes to mouse
		* events, because any mouse event should show the controls. So we capture mouse
		* events that bubble up to the player and report activity when that happens.
		* With touch events it isn't as easy as `touchstart` and `touchend` toggle player
		* controls. So touch events can't help us at the player level either.
		*
		* User activity gets checked asynchronously. So what could happen is a tap event
		* on the video turns the controls off. Then the `touchend` event bubbles up to
		* the player. Which, if it reported user activity, would turn the controls right
		* back on. We also don't want to completely block touch events from bubbling up.
		* Furthermore a `touchmove` event and anything other than a tap, should not turn
		* controls back on.
		*
		* @listens Component#touchstart
		* @listens Component#touchmove
		* @listens Component#touchend
		* @listens Component#touchcancel
		*/
		enableTouchActivity() {
			if (!this.player() || !this.player().reportUserActivity) return;
			const report = bind_(this.player(), this.player().reportUserActivity);
			let touchHolding;
			this.on("touchstart", function() {
				report();
				this.clearInterval(touchHolding);
				touchHolding = this.setInterval(report, 250);
			});
			const touchEnd = function(event) {
				report();
				this.clearInterval(touchHolding);
			};
			this.on("touchmove", report);
			this.on("touchend", touchEnd);
			this.on("touchcancel", touchEnd);
		}
		/**
		* A callback that has no parameters and is bound into `Component`s context.
		*
		* @callback Component~GenericCallback
		* @this Component
		*/
		/**
		* Creates a function that runs after an `x` millisecond timeout. This function is a
		* wrapper around `window.setTimeout`. There are a few reasons to use this one
		* instead though:
		* 1. It gets cleared via  {@link Component#clearTimeout} when
		*    {@link Component#dispose} gets called.
		* 2. The function callback will gets turned into a {@link Component~GenericCallback}
		*
		* > Note: You can't use `window.clearTimeout` on the id returned by this function. This
		*         will cause its dispose listener not to get cleaned up! Please use
		*         {@link Component#clearTimeout} or {@link Component#dispose} instead.
		*
		* @param {Component~GenericCallback} fn
		*        The function that will be run after `timeout`.
		*
		* @param {number} timeout
		*        Timeout in milliseconds to delay before executing the specified function.
		*
		* @return {number}
		*         Returns a timeout ID that gets used to identify the timeout. It can also
		*         get used in {@link Component#clearTimeout} to clear the timeout that
		*         was set.
		*
		* @listens Component#dispose
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
		*/
		setTimeout(fn, timeout) {
			var timeoutId;
			fn = bind_(this, fn);
			this.clearTimersOnDispose_();
			timeoutId = window__default["default"].setTimeout(() => {
				if (this.setTimeoutIds_.has(timeoutId)) this.setTimeoutIds_.delete(timeoutId);
				fn();
			}, timeout);
			this.setTimeoutIds_.add(timeoutId);
			return timeoutId;
		}
		/**
		* Clears a timeout that gets created via `window.setTimeout` or
		* {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
		* use this function instead of `window.clearTimout`. If you don't your dispose
		* listener will not get cleaned up until {@link Component#dispose}!
		*
		* @param {number} timeoutId
		*        The id of the timeout to clear. The return value of
		*        {@link Component#setTimeout} or `window.setTimeout`.
		*
		* @return {number}
		*         Returns the timeout id that was cleared.
		*
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
		*/
		clearTimeout(timeoutId) {
			if (this.setTimeoutIds_.has(timeoutId)) {
				this.setTimeoutIds_.delete(timeoutId);
				window__default["default"].clearTimeout(timeoutId);
			}
			return timeoutId;
		}
		/**
		* Creates a function that gets run every `x` milliseconds. This function is a wrapper
		* around `window.setInterval`. There are a few reasons to use this one instead though.
		* 1. It gets cleared via  {@link Component#clearInterval} when
		*    {@link Component#dispose} gets called.
		* 2. The function callback will be a {@link Component~GenericCallback}
		*
		* @param {Component~GenericCallback} fn
		*        The function to run every `x` seconds.
		*
		* @param {number} interval
		*        Execute the specified function every `x` milliseconds.
		*
		* @return {number}
		*         Returns an id that can be used to identify the interval. It can also be be used in
		*         {@link Component#clearInterval} to clear the interval.
		*
		* @listens Component#dispose
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
		*/
		setInterval(fn, interval) {
			fn = bind_(this, fn);
			this.clearTimersOnDispose_();
			const intervalId = window__default["default"].setInterval(fn, interval);
			this.setIntervalIds_.add(intervalId);
			return intervalId;
		}
		/**
		* Clears an interval that gets created via `window.setInterval` or
		* {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
		* use this function instead of `window.clearInterval`. If you don't your dispose
		* listener will not get cleaned up until {@link Component#dispose}!
		*
		* @param {number} intervalId
		*        The id of the interval to clear. The return value of
		*        {@link Component#setInterval} or `window.setInterval`.
		*
		* @return {number}
		*         Returns the interval id that was cleared.
		*
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
		*/
		clearInterval(intervalId) {
			if (this.setIntervalIds_.has(intervalId)) {
				this.setIntervalIds_.delete(intervalId);
				window__default["default"].clearInterval(intervalId);
			}
			return intervalId;
		}
		/**
		* Queues up a callback to be passed to requestAnimationFrame (rAF), but
		* with a few extra bonuses:
		*
		* - Supports browsers that do not support rAF by falling back to
		*   {@link Component#setTimeout}.
		*
		* - The callback is turned into a {@link Component~GenericCallback} (i.e.
		*   bound to the component).
		*
		* - Automatic cancellation of the rAF callback is handled if the component
		*   is disposed before it is called.
		*
		* @param  {Component~GenericCallback} fn
		*         A function that will be bound to this component and executed just
		*         before the browser's next repaint.
		*
		* @return {number}
		*         Returns an rAF ID that gets used to identify the timeout. It can
		*         also be used in {@link Component#cancelAnimationFrame} to cancel
		*         the animation frame callback.
		*
		* @listens Component#dispose
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
		*/
		requestAnimationFrame(fn) {
			this.clearTimersOnDispose_();
			var id;
			fn = bind_(this, fn);
			id = window__default["default"].requestAnimationFrame(() => {
				if (this.rafIds_.has(id)) this.rafIds_.delete(id);
				fn();
			});
			this.rafIds_.add(id);
			return id;
		}
		/**
		* Request an animation frame, but only one named animation
		* frame will be queued. Another will never be added until
		* the previous one finishes.
		*
		* @param {string} name
		*        The name to give this requestAnimationFrame
		*
		* @param  {Component~GenericCallback} fn
		*         A function that will be bound to this component and executed just
		*         before the browser's next repaint.
		*/
		requestNamedAnimationFrame(name, fn) {
			if (this.namedRafs_.has(name)) this.cancelNamedAnimationFrame(name);
			this.clearTimersOnDispose_();
			fn = bind_(this, fn);
			const id = this.requestAnimationFrame(() => {
				fn();
				if (this.namedRafs_.has(name)) this.namedRafs_.delete(name);
			});
			this.namedRafs_.set(name, id);
			return name;
		}
		/**
		* Cancels a current named animation frame if it exists.
		*
		* @param {string} name
		*        The name of the requestAnimationFrame to cancel.
		*/
		cancelNamedAnimationFrame(name) {
			if (!this.namedRafs_.has(name)) return;
			this.cancelAnimationFrame(this.namedRafs_.get(name));
			this.namedRafs_.delete(name);
		}
		/**
		* Cancels a queued callback passed to {@link Component#requestAnimationFrame}
		* (rAF).
		*
		* If you queue an rAF callback via {@link Component#requestAnimationFrame},
		* use this function instead of `window.cancelAnimationFrame`. If you don't,
		* your dispose listener will not get cleaned up until {@link Component#dispose}!
		*
		* @param {number} id
		*        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
		*
		* @return {number}
		*         Returns the rAF ID that was cleared.
		*
		* @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
		*/
		cancelAnimationFrame(id) {
			if (this.rafIds_.has(id)) {
				this.rafIds_.delete(id);
				window__default["default"].cancelAnimationFrame(id);
			}
			return id;
		}
		/**
		* A function to setup `requestAnimationFrame`, `setTimeout`,
		* and `setInterval`, clearing on dispose.
		*
		* > Previously each timer added and removed dispose listeners on it's own.
		* For better performance it was decided to batch them all, and use `Set`s
		* to track outstanding timer ids.
		*
		* @private
		*/
		clearTimersOnDispose_() {
			if (this.clearingTimersOnDispose_) return;
			this.clearingTimersOnDispose_ = true;
			this.one("dispose", () => {
				[
					["namedRafs_", "cancelNamedAnimationFrame"],
					["rafIds_", "cancelAnimationFrame"],
					["setTimeoutIds_", "clearTimeout"],
					["setIntervalIds_", "clearInterval"]
				].forEach(([idName, cancelName]) => {
					this[idName].forEach((val, key) => this[cancelName](key));
				});
				this.clearingTimersOnDispose_ = false;
			});
		}
		/**
		* Decide whether an element is actually disabled or not.
		*
		* @function isActuallyDisabled
		* @param element {Node}
		* @return {boolean}
		*
		* @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
		*/
		getIsDisabled() {
			return Boolean(this.el_.disabled);
		}
		/**
		* Decide whether the element is expressly inert or not.
		*
		* @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
		* @function isExpresslyInert
		* @param element {Node}
		* @return {boolean}
		*/
		getIsExpresslyInert() {
			return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
		}
		/**
		* Determine whether or not this component can be considered as focusable component.
		*
		* @param {HTMLElement} el - The HTML element representing the component.
		* @return {boolean}
		*         If the component can be focused, will be `true`. Otherwise, `false`.
		*/
		getIsFocusable(el) {
			return (el || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
		}
		/**
		* Determine whether or not this component is currently visible/enabled/etc...
		*
		* @param {HTMLElement} el - The HTML element representing the component.
		* @return {boolean}
		*         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
		*/
		getIsAvailableToBeFocused(el) {
			/**
			* Decide the style property of this element is specified whether it's visible or not.
			*
			* @function isVisibleStyleProperty
			* @param element {CSSStyleDeclaration}
			* @return {boolean}
			*/
			function isVisibleStyleProperty(element) {
				const elementStyle = window__default["default"].getComputedStyle(element, null);
				const thisVisibility = elementStyle.getPropertyValue("visibility");
				return elementStyle.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(thisVisibility);
			}
			/**
			* Decide whether the element is being rendered or not.
			* 1. If an element has the style as "visibility: hidden | collapse" or "display: none", it is not being rendered.
			* 2. If an element has the style as "opacity: 0", it is not being rendered.(that is, invisible).
			* 3. If width and height of an element are explicitly set to 0, it is not being rendered.
			* 4. If a parent element is hidden, an element itself is not being rendered.
			* (CSS visibility property and display property are inherited.)
			*
			* @see {@link https://html.spec.whatwg.org/multipage/rendering.html#being-rendered}
			* @function isBeingRendered
			* @param element {Node}
			* @return {boolean}
			*/
			function isBeingRendered(element) {
				if (!isVisibleStyleProperty(element.parentElement)) return false;
				if (!isVisibleStyleProperty(element) || element.style.opacity === "0" || window__default["default"].getComputedStyle(element).height === "0px" || window__default["default"].getComputedStyle(element).width === "0px") return false;
				return true;
			}
			/**
			* Determine if the element is visible for the user or not.
			* 1. If an element sum of its offsetWidth, offsetHeight, height and width is less than 1 is not visible.
			* 2. If elementCenter.x is less than is not visible.
			* 3. If elementCenter.x is more than the document's width is not visible.
			* 4. If elementCenter.y is less than 0 is not visible.
			* 5. If elementCenter.y is the document's height is not visible.
			*
			* @function isVisible
			* @param element {Node}
			* @return {boolean}
			*/
			function isVisible(element) {
				if (element.offsetWidth + element.offsetHeight + element.getBoundingClientRect().height + element.getBoundingClientRect().width === 0) return false;
				const elementCenter = {
					x: element.getBoundingClientRect().left + element.offsetWidth / 2,
					y: element.getBoundingClientRect().top + element.offsetHeight / 2
				};
				if (elementCenter.x < 0) return false;
				if (elementCenter.x > (document__default["default"].documentElement.clientWidth || window__default["default"].innerWidth)) return false;
				if (elementCenter.y < 0) return false;
				if (elementCenter.y > (document__default["default"].documentElement.clientHeight || window__default["default"].innerHeight)) return false;
				let pointContainer = document__default["default"].elementFromPoint(elementCenter.x, elementCenter.y);
				while (pointContainer) {
					if (pointContainer === element) return true;
					if (pointContainer.parentNode) pointContainer = pointContainer.parentNode;
					else return false;
				}
			}
			if (!el) el = this.el();
			if (isVisible(el) && isBeingRendered(el) && (!el.parentElement || el.tabIndex >= 0)) return true;
			return false;
		}
		/**
		* Register a `Component` with `videojs` given the name and the component.
		*
		* > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
		*         should be registered using {@link Tech.registerTech} or
		*         {@link videojs:videojs.registerTech}.
		*
		* > NOTE: This function can also be seen on videojs as
		*         {@link videojs:videojs.registerComponent}.
		*
		* @param {string} name
		*        The name of the `Component` to register.
		*
		* @param {Component} ComponentToRegister
		*        The `Component` class to register.
		*
		* @return {Component}
		*         The `Component` that was registered.
		*/
		static registerComponent(name, ComponentToRegister) {
			if (typeof name !== "string" || !name) throw new Error(`Illegal component name, "${name}"; must be a non-empty string.`);
			const Tech = Component.getComponent("Tech");
			const isTech = Tech && Tech.isTech(ComponentToRegister);
			const isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);
			if (isTech || !isComp) {
				let reason;
				if (isTech) reason = "techs must be registered using Tech.registerTech()";
				else reason = "must be a Component subclass";
				throw new Error(`Illegal component, "${name}"; ${reason}.`);
			}
			name = toTitleCase(name);
			if (!Component.components_) Component.components_ = {};
			const Player = Component.getComponent("Player");
			if (name === "Player" && Player && Player.players) {
				const players = Player.players;
				const playerNames = Object.keys(players);
				if (players && playerNames.length > 0) {
					for (let i = 0; i < playerNames.length; i++) if (players[playerNames[i]] !== null) throw new Error("Can not register Player component after player has been created.");
				}
			}
			Component.components_[name] = ComponentToRegister;
			Component.components_[toLowerCase(name)] = ComponentToRegister;
			return ComponentToRegister;
		}
		/**
		* Get a `Component` based on the name it was registered with.
		*
		* @param {string} name
		*        The Name of the component to get.
		*
		* @return {typeof Component}
		*         The `Component` that got registered under the given name.
		*/
		static getComponent(name) {
			if (!name || !Component.components_) return;
			return Component.components_[name];
		}
	};
	Component.registerComponent("Component", Component);
	/**
	* @file time.js
	* @module time
	*/
	/**
	* Returns the time for the specified index at the start or end
	* of a TimeRange object.
	*
	* @typedef    {Function} TimeRangeIndex
	*
	* @param      {number} [index=0]
	*             The range number to return the time for.
	*
	* @return     {number}
	*             The time offset at the specified index.
	*
	* @deprecated The index argument must be provided.
	*             In the future, leaving it out will throw an error.
	*/
	/**
	* An object that contains ranges of time, which mimics {@link TimeRanges}.
	*
	* @typedef  {Object} TimeRange
	*
	* @property {number} length
	*           The number of time ranges represented by this object.
	*
	* @property {module:time~TimeRangeIndex} start
	*           Returns the time offset at which a specified time range begins.
	*
	* @property {module:time~TimeRangeIndex} end
	*           Returns the time offset at which a specified time range ends.
	*
	* @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	*/
	/**
	* Check if any of the time ranges are over the maximum index.
	*
	* @private
	* @param   {string} fnName
	*          The function name to use for logging
	*
	* @param   {number} index
	*          The index to check
	*
	* @param   {number} maxIndex
	*          The maximum possible index
	*
	* @throws  {Error} if the timeRanges provided are over the maxIndex
	*/
	function rangeCheck(fnName, index, maxIndex) {
		if (typeof index !== "number" || index < 0 || index > maxIndex) throw new Error(`Failed to execute '${fnName}' on 'TimeRanges': The index provided (${index}) is non-numeric or out of bounds (0-${maxIndex}).`);
	}
	/**
	* Get the time for the specified index at the start or end
	* of a TimeRange object.
	*
	* @private
	* @param      {string} fnName
	*             The function name to use for logging
	*
	* @param      {string} valueIndex
	*             The property that should be used to get the time. should be
	*             'start' or 'end'
	*
	* @param      {Array} ranges
	*             An array of time ranges
	*
	* @param      {Array} [rangeIndex=0]
	*             The index to start the search at
	*
	* @return     {number}
	*             The time that offset at the specified index.
	*
	* @deprecated rangeIndex must be set to a value, in the future this will throw an error.
	* @throws     {Error} if rangeIndex is more than the length of ranges
	*/
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
		rangeCheck(fnName, rangeIndex, ranges.length - 1);
		return ranges[rangeIndex][valueIndex];
	}
	/**
	* Create a time range object given ranges of time.
	*
	* @private
	* @param   {Array} [ranges]
	*          An array of time ranges.
	*
	* @return  {TimeRange}
	*/
	function createTimeRangesObj(ranges) {
		let timeRangesObj;
		if (ranges === void 0 || ranges.length === 0) timeRangesObj = {
			length: 0,
			start() {
				throw new Error("This TimeRanges object is empty");
			},
			end() {
				throw new Error("This TimeRanges object is empty");
			}
		};
		else timeRangesObj = {
			length: ranges.length,
			start: getRange.bind(null, "start", 0, ranges),
			end: getRange.bind(null, "end", 1, ranges)
		};
		if (window__default["default"].Symbol && window__default["default"].Symbol.iterator) timeRangesObj[window__default["default"].Symbol.iterator] = () => (ranges || []).values();
		return timeRangesObj;
	}
	/**
	* Create a `TimeRange` object which mimics an
	* {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
	*
	* @param {number|Array[]} start
	*        The start of a single range (a number) or an array of ranges (an
	*        array of arrays of two numbers each).
	*
	* @param {number} end
	*        The end of a single range. Cannot be used with the array form of
	*        the `start` argument.
	*
	* @return {TimeRange}
	*/
	function createTimeRanges(start, end) {
		if (Array.isArray(start)) return createTimeRangesObj(start);
		else if (start === void 0 || end === void 0) return createTimeRangesObj();
		return createTimeRangesObj([[start, end]]);
	}
	/**
	* Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
	* seconds) will force a number of leading zeros to cover the length of the
	* guide.
	*
	* @private
	* @param  {number} seconds
	*         Number of seconds to be turned into a string
	*
	* @param  {number} guide
	*         Number (in seconds) to model the string after
	*
	* @return {string}
	*         Time formatted as H:MM:SS or M:SS
	*/
	var defaultImplementation = function(seconds, guide) {
		seconds = seconds < 0 ? 0 : seconds;
		let s = Math.floor(seconds % 60);
		let m = Math.floor(seconds / 60 % 60);
		let h = Math.floor(seconds / 3600);
		const gm = Math.floor(guide / 60 % 60);
		const gh = Math.floor(guide / 3600);
		if (isNaN(seconds) || seconds === Infinity) h = m = s = "-";
		h = h > 0 || gh > 0 ? h + ":" : "";
		m = ((h || gm >= 10) && m < 10 ? "0" + m : m) + ":";
		s = s < 10 ? "0" + s : s;
		return h + m + s;
	};
	var implementation = defaultImplementation;
	/**
	* Replaces the default formatTime implementation with a custom implementation.
	*
	* @param {Function} customImplementation
	*        A function which will be used in place of the default formatTime
	*        implementation. Will receive the current time in seconds and the
	*        guide (in seconds) as arguments.
	*/
	function setFormatTime(customImplementation) {
		implementation = customImplementation;
	}
	/**
	* Resets formatTime to the default implementation.
	*/
	function resetFormatTime() {
		implementation = defaultImplementation;
	}
	/**
	* Delegates to either the default time formatting function or a custom
	* function supplied via `setFormatTime`.
	*
	* Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
	* guide (in seconds) will force a number of leading zeros to cover the
	* length of the guide.
	*
	* @example  formatTime(125, 600) === "02:05"
	* @param    {number} seconds
	*           Number of seconds to be turned into a string
	*
	* @param    {number} guide
	*           Number (in seconds) to model the string after
	*
	* @return   {string}
	*           Time formatted as H:MM:SS or M:SS
	*/
	function formatTime(seconds, guide = seconds) {
		return implementation(seconds, guide);
	}
	var Time = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		createTimeRanges,
		createTimeRange: createTimeRanges,
		setFormatTime,
		resetFormatTime,
		formatTime
	});
	/**
	* @file buffer.js
	* @module buffer
	*/
	/** @import { TimeRange } from './time' */
	/**
	* Compute the percentage of the media that has been buffered.
	*
	* @param {TimeRange} buffered
	*        The current `TimeRanges` object representing buffered time ranges
	*
	* @param {number} duration
	*        Total duration of the media
	*
	* @return {number}
	*         Percent buffered of the total duration in decimal form.
	*/
	function bufferedPercent(buffered, duration) {
		let bufferedDuration = 0;
		let start;
		let end;
		if (!duration) return 0;
		if (!buffered || !buffered.length) buffered = createTimeRanges(0, 0);
		for (let i = 0; i < buffered.length; i++) {
			start = buffered.start(i);
			end = buffered.end(i);
			if (end > duration) end = duration;
			bufferedDuration += end - start;
		}
		return bufferedDuration / duration;
	}
	/**
	* @file media-error.js
	*/
	/**
	* A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	*
	* @param {number|string|Object|MediaError} value
	*        This can be of multiple types:
	*        - number: should be a standard error code
	*        - string: an error message (the code will be 0)
	*        - Object: arbitrary properties
	*        - `MediaError` (native): used to populate a video.js `MediaError` object
	*        - `MediaError` (video.js): will return itself if it's already a
	*          video.js `MediaError` object.
	*
	* @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	* @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	*
	* @class MediaError
	*/
	function MediaError(value) {
		if (value instanceof MediaError) return value;
		if (typeof value === "number") this.code = value;
		else if (typeof value === "string") this.message = value;
		else if (isObject(value)) {
			if (typeof value.code === "number") this.code = value.code;
			Object.assign(this, value);
		}
		if (!this.message) this.message = MediaError.defaultMessages[this.code] || "";
	}
	/**
	* The error code that refers two one of the defined `MediaError` types
	*
	* @type {Number}
	*/
	MediaError.prototype.code = 0;
	/**
	* An optional message that to show with the error. Message is not part of the HTML5
	* video spec but allows for more informative custom errors.
	*
	* @type {String}
	*/
	MediaError.prototype.message = "";
	/**
	* An optional status code that can be set by plugins to allow even more detail about
	* the error. For example a plugin might provide a specific HTTP status code and an
	* error message for that code. Then when the plugin gets that error this class will
	* know how to display an error message for it. This allows a custom message to show
	* up on the `Player` error overlay.
	*
	* @type {Array}
	*/
	MediaError.prototype.status = null;
	/**
	* An object containing an error type, as well as other information regarding the error.
	*
	* @typedef {{errorType: string, [key: string]: any}} ErrorMetadata
	*/
	/**
	* An optional object to give more detail about the error. This can be used to give
	* a higher level of specificity to an error versus the more generic MediaError codes.
	* `metadata` expects an `errorType` string that should align with the values from videojs.Error.
	*
	* @type {ErrorMetadata}
	*/
	MediaError.prototype.metadata = null;
	/**
	* Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	* specification listed under {@link MediaError} for more information.
	*
	* @enum {array}
	* @readonly
	* @property {string} 0 - MEDIA_ERR_CUSTOM
	* @property {string} 1 - MEDIA_ERR_ABORTED
	* @property {string} 2 - MEDIA_ERR_NETWORK
	* @property {string} 3 - MEDIA_ERR_DECODE
	* @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	* @property {string} 5 - MEDIA_ERR_ENCRYPTED
	*/
	MediaError.errorTypes = [
		"MEDIA_ERR_CUSTOM",
		"MEDIA_ERR_ABORTED",
		"MEDIA_ERR_NETWORK",
		"MEDIA_ERR_DECODE",
		"MEDIA_ERR_SRC_NOT_SUPPORTED",
		"MEDIA_ERR_ENCRYPTED"
	];
	/**
	* The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	*
	* @type {Array}
	* @constant
	*/
	MediaError.defaultMessages = {
		1: "You aborted the media playback",
		2: "A network error caused the media download to fail part-way.",
		3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
		4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
		5: "The media is encrypted and we do not have the keys to decrypt it."
	};
	/**
	* W3C error code for any custom error.
	*
	* @member MediaError#MEDIA_ERR_CUSTOM
	* @constant {number}
	* @default 0
	*/
	MediaError.MEDIA_ERR_CUSTOM = 0;
	/**
	* W3C error code for any custom error.
	*
	* @member MediaError.MEDIA_ERR_CUSTOM
	* @constant {number}
	* @default 0
	*/
	MediaError.prototype.MEDIA_ERR_CUSTOM = 0;
	/**
	* W3C error code for media error aborted.
	*
	* @member MediaError#MEDIA_ERR_ABORTED
	* @constant {number}
	* @default 1
	*/
	MediaError.MEDIA_ERR_ABORTED = 1;
	/**
	* W3C error code for media error aborted.
	*
	* @member MediaError.MEDIA_ERR_ABORTED
	* @constant {number}
	* @default 1
	*/
	MediaError.prototype.MEDIA_ERR_ABORTED = 1;
	/**
	* W3C error code for any network error.
	*
	* @member MediaError#MEDIA_ERR_NETWORK
	* @constant {number}
	* @default 2
	*/
	MediaError.MEDIA_ERR_NETWORK = 2;
	/**
	* W3C error code for any network error.
	*
	* @member MediaError.MEDIA_ERR_NETWORK
	* @constant {number}
	* @default 2
	*/
	MediaError.prototype.MEDIA_ERR_NETWORK = 2;
	/**
	* W3C error code for any decoding error.
	*
	* @member MediaError#MEDIA_ERR_DECODE
	* @constant {number}
	* @default 3
	*/
	MediaError.MEDIA_ERR_DECODE = 3;
	/**
	* W3C error code for any decoding error.
	*
	* @member MediaError.MEDIA_ERR_DECODE
	* @constant {number}
	* @default 3
	*/
	MediaError.prototype.MEDIA_ERR_DECODE = 3;
	/**
	* W3C error code for any time that a source is not supported.
	*
	* @member MediaError#MEDIA_ERR_SRC_NOT_SUPPORTED
	* @constant {number}
	* @default 4
	*/
	MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	/**
	* W3C error code for any time that a source is not supported.
	*
	* @member MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
	* @constant {number}
	* @default 4
	*/
	MediaError.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	/**
	* W3C error code for any time that a source is encrypted.
	*
	* @member MediaError#MEDIA_ERR_ENCRYPTED
	* @constant {number}
	* @default 5
	*/
	MediaError.MEDIA_ERR_ENCRYPTED = 5;
	/**
	* W3C error code for any time that a source is encrypted.
	*
	* @member MediaError.MEDIA_ERR_ENCRYPTED
	* @constant {number}
	* @default 5
	*/
	MediaError.prototype.MEDIA_ERR_ENCRYPTED = 5;
	/**
	* Returns whether an object is `Promise`-like (i.e. has a `then` method).
	*
	* @param  {Object}  value
	*         An object that may or may not be `Promise`-like.
	*
	* @return {boolean}
	*         Whether or not the object is `Promise`-like.
	*/
	function isPromise(value) {
		return value !== void 0 && value !== null && typeof value.then === "function";
	}
	/**
	* Silence a Promise-like object.
	*
	* This is useful for avoiding non-harmful, but potentially confusing "uncaught
	* play promise" rejection error messages.
	*
	* @param  {Object} value
	*         An object that may or may not be `Promise`-like.
	*/
	function silencePromise(value) {
		if (isPromise(value)) value.then(null, (e) => {});
	}
	/**
	* @file text-track-list-converter.js Utilities for capturing text track state and
	* re-creating tracks based on a capture.
	*
	* @module text-track-list-converter
	*/
	/** @import Tech from '../tech/tech' */
	/**
	* Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	* represents the {@link TextTrack}'s state.
	*
	* @param {TextTrack} track
	*        The text track to query.
	*
	* @return {Object}
	*         A serializable javascript representation of the TextTrack.
	* @private
	*/
	var trackToJson = function(track) {
		return [
			"kind",
			"label",
			"language",
			"id",
			"inBandMetadataTrackDispatchType",
			"mode",
			"src"
		].reduce((acc, prop, i) => {
			if (track[prop]) acc[prop] = track[prop];
			return acc;
		}, { cues: track.cues && Array.prototype.map.call(track.cues, function(cue) {
			return {
				startTime: cue.startTime,
				endTime: cue.endTime,
				text: cue.text,
				id: cue.id
			};
		}) });
	};
	/**
	* Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	* state of all {@link TextTrack}s currently configured. The return array is compatible with
	* {@link text-track-list-converter:jsonToTextTracks}.
	*
	* @param {Tech} tech
	*        The tech object to query
	*
	* @return {Array}
	*         A serializable javascript representation of the {@link Tech}s
	*         {@link TextTrackList}.
	*/
	var textTracksToJson = function(tech) {
		const trackEls = tech.$$("track");
		const trackObjs = Array.prototype.map.call(trackEls, (t) => t.track);
		return Array.prototype.map.call(trackEls, function(trackEl) {
			const json = trackToJson(trackEl.track);
			if (trackEl.src) json.src = trackEl.src;
			return json;
		}).concat(Array.prototype.filter.call(tech.textTracks(), function(track) {
			return trackObjs.indexOf(track) === -1;
		}).map(trackToJson));
	};
	/**
	* Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	* object {@link TextTrack} representations.
	*
	* @param {Array} json
	*        An array of `TextTrack` representation objects, like those that would be
	*        produced by `textTracksToJson`.
	*
	* @param {Tech} tech
	*        The `Tech` to create the `TextTrack`s on.
	*/
	var jsonToTextTracks = function(json, tech) {
		json.forEach(function(track) {
			const addedTrack = tech.addRemoteTextTrack(track).track;
			if (!track.src && track.cues) track.cues.forEach((cue) => addedTrack.addCue(cue));
		});
		return tech.textTracks();
	};
	var textTrackConverter = {
		textTracksToJson,
		jsonToTextTracks,
		trackToJson
	};
	/**
	* @file modal-dialog.js
	*/
	/** @import Player from './player' */
	/** @import { ContentDescriptor } from './utils/dom' */
	var MODAL_CLASS_NAME = "vjs-modal-dialog";
	/**
	* The `ModalDialog` displays over the video and its controls, which blocks
	* interaction with the player until it is closed.
	*
	* Modal dialogs include a "Close" button and will close when that button
	* is activated - or when ESC is pressed anywhere.
	*
	* @extends Component
	*/
	var ModalDialog = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {ContentDescriptor} [options.content=undefined]
		*        Provide customized content for this modal.
		*
		* @param {string} [options.description]
		*        A text description for the modal, primarily for accessibility.
		*
		* @param {boolean} [options.fillAlways=false]
		*        Normally, modals are automatically filled only the first time
		*        they open. This tells the modal to refresh its content
		*        every time it opens.
		*
		* @param {string} [options.label]
		*        A text label for the modal, primarily for accessibility.
		*
		* @param {boolean} [options.pauseOnOpen=true]
		*        If `true`, playback will will be paused if playing when
		*        the modal opens, and resumed when it closes.
		*
		* @param {boolean} [options.temporary=true]
		*        If `true`, the modal can only be opened once; it will be
		*        disposed as soon as it's closed.
		*
		* @param {boolean} [options.uncloseable=false]
		*        If `true`, the user will not be able to close the modal
		*        through the UI in the normal ways. Programmatic closing is
		*        still possible.
		*/
		constructor(player, options) {
			super(player, options);
			this.handleKeyDown_ = (e) => this.handleKeyDown(e);
			this.close_ = (e) => this.close(e);
			this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = false;
			this.closeable(!this.options_.uncloseable);
			this.content(this.options_.content);
			this.contentEl_ = createEl("div", { className: `${MODAL_CLASS_NAME}-content` }, { role: "document" });
			this.descEl_ = createEl("p", {
				className: `${MODAL_CLASS_NAME}-description vjs-control-text`,
				id: this.el().getAttribute("aria-describedby")
			});
			textContent(this.descEl_, this.description());
			this.el_.appendChild(this.descEl_);
			this.el_.appendChild(this.contentEl_);
		}
		/**
		* Create the `ModalDialog`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				tabIndex: -1
			}, {
				"aria-describedby": `${this.id()}_description`,
				"aria-hidden": "true",
				"aria-label": this.label(),
				"role": "dialog",
				"aria-live": "polite"
			});
		}
		dispose() {
			this.contentEl_ = null;
			this.descEl_ = null;
			this.previouslyActiveEl_ = null;
			super.dispose();
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `${MODAL_CLASS_NAME} vjs-hidden ${super.buildCSSClass()}`;
		}
		/**
		* Returns the label string for this modal. Primarily used for accessibility.
		*
		* @return {string}
		*         the localized or raw label of this modal.
		*/
		label() {
			return this.localize(this.options_.label || "Modal Window");
		}
		/**
		* Returns the description string for this modal. Primarily used for
		* accessibility.
		*
		* @return {string}
		*         The localized or raw description of this modal.
		*/
		description() {
			let desc = this.options_.description || this.localize("This is a modal window.");
			if (this.closeable()) desc += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.");
			return desc;
		}
		/**
		* Opens the modal.
		*
		* @fires ModalDialog#beforemodalopen
		* @fires ModalDialog#modalopen
		*/
		open() {
			if (this.opened_) {
				if (this.options_.fillAlways) this.fill();
				return;
			}
			const player = this.player();
			/**
			* Fired just before a `ModalDialog` is opened.
			*
			* @event ModalDialog#beforemodalopen
			* @type {Event}
			*/
			this.trigger("beforemodalopen");
			this.opened_ = true;
			if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) this.fill();
			this.wasPlaying_ = !player.paused();
			if (this.options_.pauseOnOpen && this.wasPlaying_) player.pause();
			this.on("keydown", this.handleKeyDown_);
			this.hadControls_ = player.controls();
			player.controls(false);
			this.show();
			this.conditionalFocus_();
			this.el().setAttribute("aria-hidden", "false");
			/**
			* Fired just after a `ModalDialog` is opened.
			*
			* @event ModalDialog#modalopen
			* @type {Event}
			*/
			this.trigger("modalopen");
			this.hasBeenOpened_ = true;
		}
		/**
		* If the `ModalDialog` is currently open or closed.
		*
		* @param  {boolean} [value]
		*         If given, it will open (`true`) or close (`false`) the modal.
		*
		* @return {boolean}
		*         the current open state of the modaldialog
		*/
		opened(value) {
			if (typeof value === "boolean") this[value ? "open" : "close"]();
			return this.opened_;
		}
		/**
		* Closes the modal, does nothing if the `ModalDialog` is
		* not open.
		*
		* @fires ModalDialog#beforemodalclose
		* @fires ModalDialog#modalclose
		*/
		close() {
			if (!this.opened_) return;
			const player = this.player();
			/**
			* Fired just before a `ModalDialog` is closed.
			*
			* @event ModalDialog#beforemodalclose
			* @type {Event}
			*/
			this.trigger("beforemodalclose");
			this.opened_ = false;
			if (this.wasPlaying_ && this.options_.pauseOnOpen) player.play();
			this.off("keydown", this.handleKeyDown_);
			if (this.hadControls_) player.controls(true);
			this.hide();
			this.el().setAttribute("aria-hidden", "true");
			/**
			* Fired just after a `ModalDialog` is closed.
			*
			* @event ModalDialog#modalclose
			* @type {Event}
			*
			* @property {boolean} [bubbles=true]
			*/
			this.trigger({
				type: "modalclose",
				bubbles: true
			});
			this.conditionalBlur_();
			if (this.options_.temporary) this.dispose();
		}
		/**
		* Check to see if the `ModalDialog` is closeable via the UI.
		*
		* @param  {boolean} [value]
		*         If given as a boolean, it will set the `closeable` option.
		*
		* @return {boolean}
		*         Returns the final value of the closable option.
		*/
		closeable(value) {
			if (typeof value === "boolean") {
				const closeable = this.closeable_ = !!value;
				let close = this.getChild("closeButton");
				if (closeable && !close) {
					const temp = this.contentEl_;
					this.contentEl_ = this.el_;
					close = this.addChild("closeButton", { controlText: "Close Modal Dialog" });
					this.contentEl_ = temp;
					this.on(close, "close", this.close_);
				}
				if (!closeable && close) {
					this.off(close, "close", this.close_);
					this.removeChild(close);
					close.dispose();
				}
			}
			return this.closeable_;
		}
		/**
		* Fill the modal's content element with the modal's "content" option.
		* The content element will be emptied before this change takes place.
		*/
		fill() {
			this.fillWith(this.content());
		}
		/**
		* Fill the modal's content element with arbitrary content.
		* The content element will be emptied before this change takes place.
		*
		* @fires ModalDialog#beforemodalfill
		* @fires ModalDialog#modalfill
		*
		* @param {ContentDescriptor} [content]
		*        The same rules apply to this as apply to the `content` option.
		*/
		fillWith(content) {
			const contentEl = this.contentEl();
			const parentEl = contentEl.parentNode;
			const nextSiblingEl = contentEl.nextSibling;
			/**
			* Fired just before a `ModalDialog` is filled with content.
			*
			* @event ModalDialog#beforemodalfill
			* @type {Event}
			*/
			this.trigger("beforemodalfill");
			this.hasBeenFilled_ = true;
			parentEl.removeChild(contentEl);
			this.empty();
			insertContent(contentEl, content);
			/**
			* Fired just after a `ModalDialog` is filled with content.
			*
			* @event ModalDialog#modalfill
			* @type {Event}
			*/
			this.trigger("modalfill");
			if (nextSiblingEl) parentEl.insertBefore(contentEl, nextSiblingEl);
			else parentEl.appendChild(contentEl);
			const closeButton = this.getChild("closeButton");
			if (closeButton) parentEl.appendChild(closeButton.el_);
			/**
			* Fired after `ModalDialog` is re-filled with content & close button is appended.
			*
			* @event ModalDialog#aftermodalfill
			* @type {Event}
			*/
			this.trigger("aftermodalfill");
		}
		/**
		* Empties the content element. This happens anytime the modal is filled.
		*
		* @fires ModalDialog#beforemodalempty
		* @fires ModalDialog#modalempty
		*/
		empty() {
			/**
			* Fired just before a `ModalDialog` is emptied.
			*
			* @event ModalDialog#beforemodalempty
			* @type {Event}
			*/
			this.trigger("beforemodalempty");
			emptyEl(this.contentEl());
			/**
			* Fired just after a `ModalDialog` is emptied.
			*
			* @event ModalDialog#modalempty
			* @type {Event}
			*/
			this.trigger("modalempty");
		}
		/**
		* Gets or sets the modal content, which gets normalized before being
		* rendered into the DOM.
		*
		* This does not update the DOM or fill the modal, but it is called during
		* that process.
		*
		* @param  {ContentDescriptor} [value]
		*         If defined, sets the internal content value to be used on the
		*         next call(s) to `fill`. This value is normalized before being
		*         inserted. To "clear" the internal content value, pass `null`.
		*
		* @return {ContentDescriptor}
		*         The current content of the modal dialog
		*/
		content(value) {
			if (typeof value !== "undefined") this.content_ = value;
			return this.content_;
		}
		/**
		* conditionally focus the modal dialog if focus was previously on the player.
		*
		* @private
		*/
		conditionalFocus_() {
			const activeEl = document__default["default"].activeElement;
			const playerEl = this.player_.el_;
			this.previouslyActiveEl_ = null;
			if (playerEl.contains(activeEl) || playerEl === activeEl) {
				this.previouslyActiveEl_ = activeEl;
				this.focus();
			}
		}
		/**
		* conditionally blur the element and refocus the last focused element
		*
		* @private
		*/
		conditionalBlur_() {
			if (this.previouslyActiveEl_) {
				this.previouslyActiveEl_.focus();
				this.previouslyActiveEl_ = null;
			}
		}
		/**
		* Keydown handler. Attached when modal is focused.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			/**
			* Fired a custom keyDown event that bubbles.
			*
			* @event ModalDialog#modalKeydown
			* @type {Event}
			*/
			this.trigger({
				type: "modalKeydown",
				originalEvent: event,
				target: this,
				bubbles: true
			});
			event.stopPropagation();
			if (event.key === "Escape" && this.closeable()) {
				event.preventDefault();
				this.close();
				return;
			}
			if (event.key !== "Tab") return;
			const focusableEls = this.focusableEls_();
			const activeEl = this.el_.querySelector(":focus");
			let focusIndex;
			for (let i = 0; i < focusableEls.length; i++) if (activeEl === focusableEls[i]) {
				focusIndex = i;
				break;
			}
			if (document__default["default"].activeElement === this.el_) focusIndex = 0;
			if (event.shiftKey && focusIndex === 0) {
				focusableEls[focusableEls.length - 1].focus();
				event.preventDefault();
			} else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
				focusableEls[0].focus();
				event.preventDefault();
			}
		}
		/**
		* get all focusable elements
		*
		* @private
		*/
		focusableEls_() {
			const allChildren = this.el_.querySelectorAll("*");
			return Array.prototype.filter.call(allChildren, (child) => {
				return (child instanceof window__default["default"].HTMLAnchorElement || child instanceof window__default["default"].HTMLAreaElement) && child.hasAttribute("href") || (child instanceof window__default["default"].HTMLInputElement || child instanceof window__default["default"].HTMLSelectElement || child instanceof window__default["default"].HTMLTextAreaElement || child instanceof window__default["default"].HTMLButtonElement) && !child.hasAttribute("disabled") || child instanceof window__default["default"].HTMLIFrameElement || child instanceof window__default["default"].HTMLObjectElement || child instanceof window__default["default"].HTMLEmbedElement || child.hasAttribute("tabindex") && child.getAttribute("tabindex") !== -1 || child.hasAttribute("contenteditable");
			});
		}
	};
	/**
	* Default options for `ModalDialog` default options.
	*
	* @type {Object}
	* @private
	*/
	ModalDialog.prototype.options_ = {
		pauseOnOpen: true,
		temporary: true
	};
	Component.registerComponent("ModalDialog", ModalDialog);
	/**
	* @file track-list.js
	*/
	/** @import Track from './track' */
	/**
	* Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	* {@link VideoTrackList}
	*
	* @extends EventTarget
	*/
	var TrackList = class extends EventTarget {
		/**
		* Create an instance of this class
		*
		* @param { Track[] } tracks
		*        A list of tracks to initialize the list with.
		*
		* @abstract
		*/
		constructor(tracks = []) {
			super();
			this.tracks_ = [];
			for (let i = 0; i < tracks.length; i++) this.addTrack(tracks[i]);
		}
		/**
		* The current number of `Track`s in this TrackList.
		*
		* @type {number}
		*/
		get length() {
			return this.tracks_.length;
		}
		/**
		* Add a {@link Track} to the `TrackList`
		*
		* @param {Track} track
		*        The audio, video, or text track to add to the list.
		*
		* @fires TrackList#addtrack
		*/
		addTrack(track) {
			const index = this.tracks_.length;
			if (!("" + index in this)) Object.defineProperty(this, index, { get() {
				return this.tracks_[index];
			} });
			if (this.tracks_.indexOf(track) === -1) {
				this.tracks_.push(track);
				/**
				* Triggered when a track is added to a track list.
				*
				* @event TrackList#addtrack
				* @type {Event}
				* @property {Track} track
				*           A reference to track that was added.
				*/
				this.trigger({
					track,
					type: "addtrack",
					target: this
				});
			}
			/**
			* Triggered when a track label is changed.
			*
			* @event TrackList#labelchange
			* @type {Event}
			* @property {Track} track
			*           A reference to track whose label was changed.
			*/
			track.labelchange_ = () => {
				this.trigger({
					track,
					type: "labelchange",
					target: this
				});
			};
			if (isEvented(track)) track.addEventListener("labelchange", track.labelchange_);
		}
		/**
		* Remove a {@link Track} from the `TrackList`
		*
		* @param {Track} rtrack
		*        The audio, video, or text track to remove from the list.
		*
		* @fires TrackList#removetrack
		*/
		removeTrack(rtrack) {
			let track;
			for (let i = 0, l = this.length; i < l; i++) if (this[i] === rtrack) {
				track = this[i];
				if (track.off) track.off();
				this.tracks_.splice(i, 1);
				break;
			}
			if (!track) return;
			/**
			* Triggered when a track is removed from track list.
			*
			* @event TrackList#removetrack
			* @type {Event}
			* @property {Track} track
			*           A reference to track that was removed.
			*/
			this.trigger({
				track,
				type: "removetrack",
				target: this
			});
		}
		/**
		* Get a Track from the TrackList by a tracks id
		*
		* @param {string} id - the id of the track to get
		* @method getTrackById
		* @return {Track}
		* @private
		*/
		getTrackById(id) {
			let result = null;
			for (let i = 0, l = this.length; i < l; i++) {
				const track = this[i];
				if (track.id === id) {
					result = track;
					break;
				}
			}
			return result;
		}
	};
	/**
	* Triggered when a different track is selected/enabled.
	*
	* @event TrackList#change
	* @type {Event}
	*/
	/**
	* Events that can be called with on + eventName. See {@link EventHandler}.
	*
	* @property {Object} TrackList#allowedEvents_
	* @protected
	*/
	TrackList.prototype.allowedEvents_ = {
		change: "change",
		addtrack: "addtrack",
		removetrack: "removetrack",
		labelchange: "labelchange"
	};
	for (const event in TrackList.prototype.allowedEvents_) TrackList.prototype["on" + event] = null;
	/**
	* @file audio-track-list.js
	*/
	/** @import AudioTrack from './audio-track' */
	/**
	* Anywhere we call this function we diverge from the spec
	* as we only support one enabled audiotrack at a time
	*
	* @param {AudioTrackList} list
	*        list to work on
	*
	* @param {AudioTrack} track
	*        The track to skip
	*
	* @private
	*/
	var disableOthers$1 = function(list, track) {
		for (let i = 0; i < list.length; i++) {
			if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
			list[i].enabled = false;
		}
	};
	/**
	* The current list of {@link AudioTrack} for a media file.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	* @extends TrackList
	*/
	var AudioTrackList = class extends TrackList {
		/**
		* Create an instance of this class.
		*
		* @param {AudioTrack[]} [tracks=[]]
		*        A list of `AudioTrack` to instantiate the list with.
		*/
		constructor(tracks = []) {
			for (let i = tracks.length - 1; i >= 0; i--) if (tracks[i].enabled) {
				disableOthers$1(tracks, tracks[i]);
				break;
			}
			super(tracks);
			this.changing_ = false;
		}
		/**
		* Add an {@link AudioTrack} to the `AudioTrackList`.
		*
		* @param {AudioTrack} track
		*        The AudioTrack to add to the list
		*
		* @fires TrackList#addtrack
		*/
		addTrack(track) {
			if (track.enabled) disableOthers$1(this, track);
			super.addTrack(track);
			if (!track.addEventListener) return;
			track.enabledChange_ = () => {
				if (this.changing_) return;
				this.changing_ = true;
				disableOthers$1(this, track);
				this.changing_ = false;
				this.trigger("change");
			};
			/**
			* @listens AudioTrack#enabledchange
			* @fires TrackList#change
			*/
			track.addEventListener("enabledchange", track.enabledChange_);
		}
		removeTrack(rtrack) {
			super.removeTrack(rtrack);
			if (rtrack.removeEventListener && rtrack.enabledChange_) {
				rtrack.removeEventListener("enabledchange", rtrack.enabledChange_);
				rtrack.enabledChange_ = null;
			}
		}
	};
	/**
	* @file video-track-list.js
	*/
	/** @import VideoTrack from './video-track' */
	/**
	* Un-select all other {@link VideoTrack}s that are selected.
	*
	* @param {VideoTrackList} list
	*        list to work on
	*
	* @param {VideoTrack} track
	*        The track to skip
	*
	* @private
	*/
	var disableOthers = function(list, track) {
		for (let i = 0; i < list.length; i++) {
			if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
			list[i].selected = false;
		}
	};
	/**
	* The current list of {@link VideoTrack} for a video.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	* @extends TrackList
	*/
	var VideoTrackList = class extends TrackList {
		/**
		* Create an instance of this class.
		*
		* @param {VideoTrack[]} [tracks=[]]
		*        A list of `VideoTrack` to instantiate the list with.
		*/
		constructor(tracks = []) {
			for (let i = tracks.length - 1; i >= 0; i--) if (tracks[i].selected) {
				disableOthers(tracks, tracks[i]);
				break;
			}
			super(tracks);
			this.changing_ = false;
			/**
			* @member {number} VideoTrackList#selectedIndex
			*         The current index of the selected {@link VideoTrack`}.
			*/
			Object.defineProperty(this, "selectedIndex", {
				get() {
					for (let i = 0; i < this.length; i++) if (this[i].selected) return i;
					return -1;
				},
				set() {}
			});
		}
		/**
		* Add a {@link VideoTrack} to the `VideoTrackList`.
		*
		* @param {VideoTrack} track
		*        The VideoTrack to add to the list
		*
		* @fires TrackList#addtrack
		*/
		addTrack(track) {
			if (track.selected) disableOthers(this, track);
			super.addTrack(track);
			if (!track.addEventListener) return;
			track.selectedChange_ = () => {
				if (this.changing_) return;
				this.changing_ = true;
				disableOthers(this, track);
				this.changing_ = false;
				this.trigger("change");
			};
			/**
			* @listens VideoTrack#selectedchange
			* @fires TrackList#change
			*/
			track.addEventListener("selectedchange", track.selectedChange_);
		}
		removeTrack(rtrack) {
			super.removeTrack(rtrack);
			if (rtrack.removeEventListener && rtrack.selectedChange_) {
				rtrack.removeEventListener("selectedchange", rtrack.selectedChange_);
				rtrack.selectedChange_ = null;
			}
		}
	};
	/**
	* @file text-track-list.js
	*/
	/** @import TextTrack from './text-track' */
	/**
	* The current list of {@link TextTrack} for a media file.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	* @extends TrackList
	*/
	var TextTrackList = class extends TrackList {
		/**
		* Add a {@link TextTrack} to the `TextTrackList`
		*
		* @param {TextTrack} track
		*        The text track to add to the list.
		*
		* @fires TrackList#addtrack
		*/
		addTrack(track) {
			super.addTrack(track);
			if (!this.queueChange_) this.queueChange_ = () => this.queueTrigger("change");
			if (!this.triggerSelectedlanguagechange) this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange");
			/**
			* @listens TextTrack#modechange
			* @fires TrackList#change
			*/
			track.addEventListener("modechange", this.queueChange_);
			if (["metadata", "chapters"].indexOf(track.kind) === -1) track.addEventListener("modechange", this.triggerSelectedlanguagechange_);
		}
		removeTrack(rtrack) {
			super.removeTrack(rtrack);
			if (rtrack.removeEventListener) {
				if (this.queueChange_) rtrack.removeEventListener("modechange", this.queueChange_);
				if (this.selectedlanguagechange_) rtrack.removeEventListener("modechange", this.triggerSelectedlanguagechange_);
			}
		}
		/**
		* Creates a serializable array of objects that contains serialized copies
		* of each text track.
		*
		* @return {Object[]} A serializable list of objects for the text track list
		*/
		toJSON() {
			return this.tracks_.map((track) => track.toJSON());
		}
	};
	/**
	* @file html-track-element-list.js
	*/
	/**
	* The current list of {@link HtmlTrackElement}s.
	*/
	var HtmlTrackElementList = class {
		/**
		* Create an instance of this class.
		*
		* @param {HtmlTrackElement[]} [tracks=[]]
		*        A list of `HtmlTrackElement` to instantiate the list with.
		*/
		constructor(trackElements = []) {
			this.trackElements_ = [];
			/**
			* @memberof HtmlTrackElementList
			* @member {number} length
			*         The current number of `Track`s in the this Trackist.
			* @instance
			*/
			Object.defineProperty(this, "length", { get() {
				return this.trackElements_.length;
			} });
			for (let i = 0, length = trackElements.length; i < length; i++) this.addTrackElement_(trackElements[i]);
		}
		/**
		* Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
		*
		* @param {HtmlTrackElement} trackElement
		*        The track element to add to the list.
		*
		* @private
		*/
		addTrackElement_(trackElement) {
			const index = this.trackElements_.length;
			if (!("" + index in this)) Object.defineProperty(this, index, { get() {
				return this.trackElements_[index];
			} });
			if (this.trackElements_.indexOf(trackElement) === -1) this.trackElements_.push(trackElement);
		}
		/**
		* Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
		* {@link TextTrack}.
		*
		* @param {TextTrack} track
		*        The track associated with a track element.
		*
		* @return {HtmlTrackElement|undefined}
		*         The track element that was found or undefined.
		*
		* @private
		*/
		getTrackElementByTrack_(track) {
			let trackElement_;
			for (let i = 0, length = this.trackElements_.length; i < length; i++) if (track === this.trackElements_[i].track) {
				trackElement_ = this.trackElements_[i];
				break;
			}
			return trackElement_;
		}
		/**
		* Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
		*
		* @param {HtmlTrackElement} trackElement
		*        The track element to remove from the list.
		*
		* @private
		*/
		removeTrackElement_(trackElement) {
			for (let i = 0, length = this.trackElements_.length; i < length; i++) if (trackElement === this.trackElements_[i]) {
				if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === "function") this.trackElements_[i].track.off();
				if (typeof this.trackElements_[i].off === "function") this.trackElements_[i].off();
				this.trackElements_.splice(i, 1);
				break;
			}
		}
	};
	/**
	* @file text-track-cue-list.js
	*/
	/**
	* @typedef {Object} TextTrackCueList~TextTrackCue
	*
	* @property {string} id
	*           The unique id for this text track cue
	*
	* @property {number} startTime
	*           The start time for this text track cue
	*
	* @property {number} endTime
	*           The end time for this text track cue
	*
	* @property {boolean} pauseOnExit
	*           Pause when the end time is reached if true.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	*/
	/**
	* A List of TextTrackCues.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	*/
	var TextTrackCueList = class TextTrackCueList {
		/**
		* Create an instance of this class..
		*
		* @param {Array} cues
		*        A list of cues to be initialized with
		*/
		constructor(cues) {
			TextTrackCueList.prototype.setCues_.call(this, cues);
			/**
			* @memberof TextTrackCueList
			* @member {number} length
			*         The current number of `TextTrackCue`s in the TextTrackCueList.
			* @instance
			*/
			Object.defineProperty(this, "length", { get() {
				return this.length_;
			} });
		}
		/**
		* A setter for cues in this list. Creates getters
		* an an index for the cues.
		*
		* @param {Array} cues
		*        An array of cues to set
		*
		* @private
		*/
		setCues_(cues) {
			const oldLength = this.length || 0;
			let i = 0;
			const l = cues.length;
			this.cues_ = cues;
			this.length_ = cues.length;
			const defineProp = function(index) {
				if (!("" + index in this)) Object.defineProperty(this, "" + index, { get() {
					return this.cues_[index];
				} });
			};
			if (oldLength < l) {
				i = oldLength;
				for (; i < l; i++) defineProp.call(this, i);
			}
		}
		/**
		* Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
		*
		* @param {string} id
		*        The id of the cue that should be searched for.
		*
		* @return {TextTrackCueList~TextTrackCue|null}
		*         A single cue or null if none was found.
		*/
		getCueById(id) {
			let result = null;
			for (let i = 0, l = this.length; i < l; i++) {
				const cue = this[i];
				if (cue.id === id) {
					result = cue;
					break;
				}
			}
			return result;
		}
	};
	/**
	* @file track-kinds.js
	*/
	/**
	* All possible `VideoTrackKind`s
	*
	* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	* @typedef VideoTrack~Kind
	* @enum
	*/
	var VideoTrackKind = {
		alternative: "alternative",
		captions: "captions",
		main: "main",
		sign: "sign",
		subtitles: "subtitles",
		commentary: "commentary"
	};
	/**
	* All possible `AudioTrackKind`s
	*
	* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	* @typedef AudioTrack~Kind
	* @enum
	*/
	var AudioTrackKind = {
		"alternative": "alternative",
		"descriptions": "descriptions",
		"main": "main",
		"main-desc": "main-desc",
		"translation": "translation",
		"commentary": "commentary"
	};
	/**
	* All possible `TextTrackKind`s
	*
	* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	* @typedef TextTrack~Kind
	* @enum
	*/
	var TextTrackKind = {
		subtitles: "subtitles",
		captions: "captions",
		descriptions: "descriptions",
		chapters: "chapters",
		metadata: "metadata"
	};
	/**
	* All possible `TextTrackMode`s
	*
	* @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	* @typedef TextTrack~Mode
	* @enum
	*/
	var TextTrackMode = {
		disabled: "disabled",
		hidden: "hidden",
		showing: "showing"
	};
	/**
	* @file track.js
	*/
	/**
	* A Track class that contains all of the common functionality for {@link AudioTrack},
	* {@link VideoTrack}, and {@link TextTrack}.
	*
	* > Note: This class should not be used directly
	*
	* @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	* @extends EventTarget
	* @abstract
	*/
	var Track = class extends EventTarget {
		/**
		* Create an instance of this class.
		*
		* @param {Object} [options={}]
		*        Object of option names and values
		*
		* @param {string} [options.kind='']
		*        A valid kind for the track type you are creating.
		*
		* @param {string} [options.id='vjs_track_' + Guid.newGUID()]
		*        A unique id for this AudioTrack.
		*
		* @param {string} [options.label='']
		*        The menu label for this track.
		*
		* @param {string} [options.language='']
		*        A valid two character language code.
		*
		* @abstract
		*/
		constructor(options = {}) {
			super();
			const trackProps = {
				id: options.id || "vjs_track_" + newGUID(),
				kind: options.kind || "",
				language: options.language || ""
			};
			let label = options.label || "";
			/**
			* @memberof Track
			* @member {string} id
			*         The id of this track. Cannot be changed after creation.
			* @instance
			*
			* @readonly
			*/
			/**
			* @memberof Track
			* @member {string} kind
			*         The kind of track that this is. Cannot be changed after creation.
			* @instance
			*
			* @readonly
			*/
			/**
			* @memberof Track
			* @member {string} language
			*         The two letter language code for this track. Cannot be changed after
			*         creation.
			* @instance
			*
			* @readonly
			*/
			for (const key in trackProps) Object.defineProperty(this, key, {
				get() {
					return trackProps[key];
				},
				set() {}
			});
			/**
			* @memberof Track
			* @member {string} label
			*         The label of this track. Cannot be changed after creation.
			* @instance
			*
			* @fires Track#labelchange
			*/
			Object.defineProperty(this, "label", {
				get() {
					return label;
				},
				set(newLabel) {
					if (newLabel !== label) {
						label = newLabel;
						/**
						* An event that fires when label changes on this track.
						*
						* > Note: This is not part of the spec!
						*
						* @event Track#labelchange
						* @type {Event}
						*/
						this.trigger("labelchange");
					}
				}
			});
		}
	};
	/**
	* @file url.js
	* @module url
	*/
	/**
	* Resolve and parse the elements of a URL.
	*
	* @function
	* @param    {string} url
	*           The url to parse
	*
	* @return   {URL}
	*           An object of url details
	*/
	var parseUrl = function(url) {
		return new URL(url, document__default["default"].baseURI);
	};
	/**
	* Get absolute version of relative URL.
	*
	* @function
	* @param    {string} url
	*           URL to make absolute
	*
	* @return   {string}
	*           Absolute URL
	*/
	var getAbsoluteURL = function(url) {
		return new URL(url, document__default["default"].baseURI).href;
	};
	/**
	* Returns the extension of the passed file name. It will return an empty string
	* if passed an invalid path.
	*
	* @function
	* @param    {string} path
	*           The fileName path like '/path/to/file.mp4'
	*
	* @return  {string}
	*           The extension in lower case or an empty string if no
	*           extension could be found.
	*/
	var getFileExtension = function(path) {
		if (typeof path === "string") {
			const match = path.split("?")[0].replace(/\/+$/, "").match(/\.([^.\/]+)$/);
			return match ? match[1].toLowerCase() : "";
		}
		return "";
	};
	/**
	* Returns whether the url passed is a cross domain request or not.
	*
	* @function
	* @param    {string} url
	*           The url to check.
	*
	* @param    {URL} [winLoc]
	*           the domain to check the url against, defaults to window.location
	*
	* @return   {boolean}
	*           Whether it is a cross domain request or not.
	*/
	var isCrossOrigin = function(url, winLoc = window__default["default"].location) {
		return parseUrl(url).origin !== winLoc.origin;
	};
	var Url = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		parseUrl,
		getAbsoluteURL,
		getFileExtension,
		isCrossOrigin
	});
	/**
	* @file text-track.js
	*/
	/** @import Tech from '../tech/tech' */
	/**
	* Takes a webvtt file contents and parses it into cues
	*
	* @param {string} srcContent
	*        webVTT file contents
	*
	* @param {TextTrack} track
	*        TextTrack to add cues to. Cues come from the srcContent.
	*
	* @private
	*/
	var parseCues = function(srcContent, track) {
		const parser = new window__default["default"].WebVTT.Parser(window__default["default"], window__default["default"].vttjs, window__default["default"].WebVTT.StringDecoder());
		const errors = [];
		parser.oncue = function(cue) {
			track.addCue(cue);
		};
		parser.onparsingerror = function(error) {
			errors.push(error);
		};
		parser.onflush = function() {
			track.trigger({
				type: "loadeddata",
				target: track
			});
		};
		parser.parse(srcContent);
		if (errors.length > 0) {
			if (window__default["default"].console && window__default["default"].console.groupCollapsed) window__default["default"].console.groupCollapsed(`Text Track parsing errors for ${track.src}`);
			errors.forEach((error) => log.error(error));
			if (window__default["default"].console && window__default["default"].console.groupEnd) window__default["default"].console.groupEnd();
		}
		parser.flush();
	};
	/**
	* Load a `TextTrack` from a specified url.
	*
	* @param {string} src
	*        Url to load track from.
	*
	* @param {TextTrack} track
	*        Track to add cues to. Comes from the content at the end of `url`.
	*
	* @private
	*/
	var loadTrack = function(src, track) {
		const opts = { uri: src };
		const crossOrigin = isCrossOrigin(src);
		if (crossOrigin) opts.cors = crossOrigin;
		const withCredentials = track.tech_.crossOrigin() === "use-credentials";
		if (withCredentials) opts.withCredentials = withCredentials;
		XHR__default["default"](opts, bind_(this, function(err, response, responseBody) {
			if (err) return log.error(err, response);
			track.loaded_ = true;
			if (typeof window__default["default"].WebVTT !== "function") {
				if (track.tech_) track.tech_.any(["vttjsloaded", "vttjserror"], (event) => {
					if (event.type === "vttjserror") {
						log.error(`vttjs failed to load, stopping trying to process ${track.src}`);
						return;
					}
					return parseCues(responseBody, track);
				});
			} else parseCues(responseBody, track);
		}));
	};
	/**
	* A representation of a single `TextTrack`.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	* @extends Track
	*/
	var TextTrack = class extends Track {
		/**
		* Create an instance of this class.
		*
		* @param {Object} options={}
		*        Object of option names and values
		*
		* @param {Tech} options.tech
		*        A reference to the tech that owns this TextTrack.
		*
		* @param {TextTrack~Kind} [options.kind='subtitles']
		*        A valid text track kind.
		*
		* @param {TextTrack~Mode} [options.mode='disabled']
		*        A valid text track mode.
		*
		* @param {string} [options.id='vjs_track_' + Guid.newGUID()]
		*        A unique id for this TextTrack.
		*
		* @param {string} [options.label='']
		*        The menu label for this track.
		*
		* @param {string} [options.language='']
		*        A valid two character language code.
		*
		* @param {string} [options.srclang='']
		*        A valid two character language code. An alternative, but deprioritized
		*        version of `options.language`
		*
		* @param {string} [options.src]
		*        A url to TextTrack cues.
		*
		* @param {boolean} [options.default]
		*        If this track should default to on or off.
		*/
		constructor(options = {}) {
			if (!options.tech) throw new Error("A tech was not provided.");
			const settings = merge(options, {
				kind: TextTrackKind[options.kind] || "subtitles",
				language: options.language || options.srclang || ""
			});
			let mode = TextTrackMode[settings.mode] || "disabled";
			const default_ = settings.default;
			if (settings.kind === "metadata" || settings.kind === "chapters") mode = "hidden";
			super(settings);
			this.tech_ = settings.tech;
			this.cues_ = [];
			this.activeCues_ = [];
			this.preload_ = this.tech_.preloadTextTracks !== false;
			const cues = new TextTrackCueList(this.cues_);
			const activeCues = new TextTrackCueList(this.activeCues_);
			let changed = false;
			this.timeupdateHandler = bind_(this, function(event = {}) {
				if (this.tech_.isDisposed()) return;
				if (!this.tech_.isReady_) {
					if (event.type !== "timeupdate") this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
					return;
				}
				this.activeCues = this.activeCues;
				if (changed) {
					this.trigger("cuechange");
					changed = false;
				}
				if (event.type !== "timeupdate") this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
			});
			const disposeHandler = () => {
				this.stopTracking();
			};
			this.tech_.one("dispose", disposeHandler);
			if (mode !== "disabled") this.startTracking();
			Object.defineProperties(this, {
				/**
				* @memberof TextTrack
				* @member {boolean} default
				*         If this track was set to be on or off by default. Cannot be changed after
				*         creation.
				* @instance
				*
				* @readonly
				*/
				default: {
					get() {
						return default_;
					},
					set() {}
				},
				/**
				* @memberof TextTrack
				* @member {string} mode
				*         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
				*         not be set if setting to an invalid mode.
				* @instance
				*
				* @fires TextTrack#modechange
				*/
				mode: {
					get() {
						return mode;
					},
					set(newMode) {
						if (!TextTrackMode[newMode]) return;
						if (mode === newMode) return;
						mode = newMode;
						if (!this.preload_ && mode !== "disabled" && this.cues.length === 0) loadTrack(this.src, this);
						this.stopTracking();
						if (mode !== "disabled") this.startTracking();
						/**
						* An event that fires when mode changes on this track. This allows
						* the TextTrackList that holds this track to act accordingly.
						*
						* > Note: This is not part of the spec!
						*
						* @event TextTrack#modechange
						* @type {Event}
						*/
						this.trigger("modechange");
					}
				},
				/**
				* @memberof TextTrack
				* @member {TextTrackCueList} cues
				*         The text track cue list for this TextTrack.
				* @instance
				*/
				cues: {
					get() {
						if (!this.loaded_) return null;
						return cues;
					},
					set() {}
				},
				/**
				* @memberof TextTrack
				* @member {TextTrackCueList} activeCues
				*         The list text track cues that are currently active for this TextTrack.
				* @instance
				*/
				activeCues: {
					get() {
						if (!this.loaded_) return null;
						if (this.cues.length === 0) return activeCues;
						const ct = this.tech_.currentTime();
						const active = [];
						for (let i = 0, l = this.cues.length; i < l; i++) {
							const cue = this.cues[i];
							if (cue.startTime <= ct && cue.endTime >= ct) active.push(cue);
						}
						changed = false;
						if (active.length !== this.activeCues_.length) changed = true;
						else for (let i = 0; i < active.length; i++) if (this.activeCues_.indexOf(active[i]) === -1) changed = true;
						this.activeCues_ = active;
						activeCues.setCues_(this.activeCues_);
						return activeCues;
					},
					set() {}
				}
			});
			if (settings.src) {
				this.src = settings.src;
				if (!this.preload_) this.loaded_ = true;
				if (this.preload_ || settings.kind !== "subtitles" && settings.kind !== "captions") loadTrack(this.src, this);
			} else this.loaded_ = true;
		}
		startTracking() {
			this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
			this.tech_.on("timeupdate", this.timeupdateHandler);
		}
		stopTracking() {
			if (this.rvf_) {
				this.tech_.cancelVideoFrameCallback(this.rvf_);
				this.rvf_ = void 0;
			}
			this.tech_.off("timeupdate", this.timeupdateHandler);
		}
		/**
		* Add a cue to the internal list of cues.
		*
		* @param {TextTrack~Cue} cue
		*        The cue to add to our internal list
		*/
		addCue(originalCue) {
			let cue = originalCue;
			if (!("getCueAsHTML" in cue)) {
				cue = new window__default["default"].vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
				for (const prop in originalCue) if (!(prop in cue)) cue[prop] = originalCue[prop];
				cue.id = originalCue.id;
				cue.originalCue_ = originalCue;
			}
			const tracks = this.tech_.textTracks();
			for (let i = 0; i < tracks.length; i++) if (tracks[i] !== this) tracks[i].removeCue(cue);
			this.cues_.push(cue);
			this.cues.setCues_(this.cues_);
		}
		/**
		* Creates a copy of the text track and makes it serializable
		* by removing circular dependencies.
		*
		* @return {Object} The track information as a serializable object
		*/
		toJSON() {
			return textTrackConverter.trackToJson(this);
		}
		/**
		* Remove a cue from our internal list
		*
		* @param {TextTrack~Cue} removeCue
		*        The cue to remove from our internal list
		*/
		removeCue(removeCue) {
			let i = this.cues_.length;
			while (i--) {
				const cue = this.cues_[i];
				if (cue === removeCue || cue.originalCue_ && cue.originalCue_ === removeCue) {
					this.cues_.splice(i, 1);
					this.cues.setCues_(this.cues_);
					break;
				}
			}
		}
	};
	/**
	* cuechange - One or more cues in the track have become active or stopped being active.
	*
	* @protected
	*/
	TextTrack.prototype.allowedEvents_ = { cuechange: "cuechange" };
	/**
	* A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	* only one `AudioTrack` in the list will be enabled at a time.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	* @extends Track
	*/
	var AudioTrack = class extends Track {
		/**
		* Create an instance of this class.
		*
		* @param {Object} [options={}]
		*        Object of option names and values
		*
		* @param {AudioTrack~Kind} [options.kind='']
		*        A valid audio track kind
		*
		* @param {string} [options.id='vjs_track_' + Guid.newGUID()]
		*        A unique id for this AudioTrack.
		*
		* @param {string} [options.label='']
		*        The menu label for this track.
		*
		* @param {string} [options.language='']
		*        A valid two character language code.
		*
		* @param {boolean} [options.enabled]
		*        If this track is the one that is currently playing. If this track is part of
		*        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
		*/
		constructor(options = {}) {
			const settings = merge(options, { kind: AudioTrackKind[options.kind] || "" });
			super(settings);
			let enabled = false;
			/**
			* @memberof AudioTrack
			* @member {boolean} enabled
			*         If this `AudioTrack` is enabled or not. When setting this will
			*         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
			* @instance
			*
			* @fires VideoTrack#selectedchange
			*/
			Object.defineProperty(this, "enabled", {
				get() {
					return enabled;
				},
				set(newEnabled) {
					if (typeof newEnabled !== "boolean" || newEnabled === enabled) return;
					enabled = newEnabled;
					/**
					* An event that fires when enabled changes on this track. This allows
					* the AudioTrackList that holds this track to act accordingly.
					*
					* > Note: This is not part of the spec! Native tracks will do
					*         this internally without an event.
					*
					* @event AudioTrack#enabledchange
					* @type {Event}
					*/
					this.trigger("enabledchange");
				}
			});
			if (settings.enabled) this.enabled = settings.enabled;
			this.loaded_ = true;
		}
	};
	/**
	* A representation of a single `VideoTrack`.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	* @extends Track
	*/
	var VideoTrack = class extends Track {
		/**
		* Create an instance of this class.
		*
		* @param {Object} [options={}]
		*        Object of option names and values
		*
		* @param {string} [options.kind='']
		*        A valid {@link VideoTrack~Kind}
		*
		* @param {string} [options.id='vjs_track_' + Guid.newGUID()]
		*        A unique id for this AudioTrack.
		*
		* @param {string} [options.label='']
		*        The menu label for this track.
		*
		* @param {string} [options.language='']
		*        A valid two character language code.
		*
		* @param {boolean} [options.selected]
		*        If this track is the one that is currently playing.
		*/
		constructor(options = {}) {
			const settings = merge(options, { kind: VideoTrackKind[options.kind] || "" });
			super(settings);
			let selected = false;
			/**
			* @memberof VideoTrack
			* @member {boolean} selected
			*         If this `VideoTrack` is selected or not. When setting this will
			*         fire {@link VideoTrack#selectedchange} if the state of selected changed.
			* @instance
			*
			* @fires VideoTrack#selectedchange
			*/
			Object.defineProperty(this, "selected", {
				get() {
					return selected;
				},
				set(newSelected) {
					if (typeof newSelected !== "boolean" || newSelected === selected) return;
					selected = newSelected;
					/**
					* An event that fires when selected changes on this track. This allows
					* the VideoTrackList that holds this track to act accordingly.
					*
					* > Note: This is not part of the spec! Native tracks will do
					*         this internally without an event.
					*
					* @event VideoTrack#selectedchange
					* @type {Event}
					*/
					this.trigger("selectedchange");
				}
			});
			if (settings.selected) this.selected = settings.selected;
		}
	};
	/**
	* @file html-track-element.js
	*/
	/** @import Tech from '../tech/tech' */
	/**
	* A single track represented in the DOM.
	*
	* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	* @extends EventTarget
	*/
	var HTMLTrackElement = class HTMLTrackElement extends EventTarget {
		/**
		* Create an instance of this class.
		*
		* @param {Object} options={}
		*        Object of option names and values
		*
		* @param {Tech} options.tech
		*        A reference to the tech that owns this HTMLTrackElement.
		*
		* @param {TextTrack~Kind} [options.kind='subtitles']
		*        A valid text track kind.
		*
		* @param {TextTrack~Mode} [options.mode='disabled']
		*        A valid text track mode.
		*
		* @param {string} [options.id='vjs_track_' + Guid.newGUID()]
		*        A unique id for this TextTrack.
		*
		* @param {string} [options.label='']
		*        The menu label for this track.
		*
		* @param {string} [options.language='']
		*        A valid two character language code.
		*
		* @param {string} [options.srclang='']
		*        A valid two character language code. An alternative, but deprioritized
		*        version of `options.language`
		*
		* @param {string} [options.src]
		*        A url to TextTrack cues.
		*
		* @param {boolean} [options.default]
		*        If this track should default to on or off.
		*/
		constructor(options = {}) {
			super();
			let readyState;
			const track = new TextTrack(options);
			this.kind = track.kind;
			this.src = track.src;
			this.srclang = track.language;
			this.label = track.label;
			this.default = track.default;
			Object.defineProperties(this, {
				/**
				* @memberof HTMLTrackElement
				* @member {HTMLTrackElement~ReadyState} readyState
				*         The current ready state of the track element.
				* @instance
				*/
				readyState: { get() {
					return readyState;
				} },
				/**
				* @memberof HTMLTrackElement
				* @member {TextTrack} track
				*         The underlying TextTrack object.
				* @instance
				*
				*/
				track: { get() {
					return track;
				} }
			});
			readyState = HTMLTrackElement.NONE;
			/**
			* @listens TextTrack#loadeddata
			* @fires HTMLTrackElement#load
			*/
			track.addEventListener("loadeddata", () => {
				readyState = HTMLTrackElement.LOADED;
				this.trigger({
					type: "load",
					target: this
				});
			});
		}
	};
	/**
	* @protected
	*/
	HTMLTrackElement.prototype.allowedEvents_ = { load: "load" };
	/**
	* The text track not loaded state.
	*
	* @type {number}
	* @static
	*/
	HTMLTrackElement.NONE = 0;
	/**
	* The text track loading state.
	*
	* @type {number}
	* @static
	*/
	HTMLTrackElement.LOADING = 1;
	/**
	* The text track loaded state.
	*
	* @type {number}
	* @static
	*/
	HTMLTrackElement.LOADED = 2;
	/**
	* The text track failed to load state.
	*
	* @type {number}
	* @static
	*/
	HTMLTrackElement.ERROR = 3;
	var NORMAL = {
		audio: {
			ListClass: AudioTrackList,
			TrackClass: AudioTrack,
			capitalName: "Audio"
		},
		video: {
			ListClass: VideoTrackList,
			TrackClass: VideoTrack,
			capitalName: "Video"
		},
		text: {
			ListClass: TextTrackList,
			TrackClass: TextTrack,
			capitalName: "Text"
		}
	};
	Object.keys(NORMAL).forEach(function(type) {
		NORMAL[type].getterName = `${type}Tracks`;
		NORMAL[type].privateName = `${type}Tracks_`;
	});
	var REMOTE = {
		remoteText: {
			ListClass: TextTrackList,
			TrackClass: TextTrack,
			capitalName: "RemoteText",
			getterName: "remoteTextTracks",
			privateName: "remoteTextTracks_"
		},
		remoteTextEl: {
			ListClass: HtmlTrackElementList,
			TrackClass: HTMLTrackElement,
			capitalName: "RemoteTextTrackEls",
			getterName: "remoteTextTrackEls",
			privateName: "remoteTextTrackEls_"
		}
	};
	var ALL = Object.assign({}, NORMAL, REMOTE);
	REMOTE.names = Object.keys(REMOTE);
	NORMAL.names = Object.keys(NORMAL);
	ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
	/**
	* @file tech.js
	*/
	/** @import { TimeRange } from '../utils/time' */
	/**
	* An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	* that just contains the src url alone.
	* * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	* `var SourceString = 'http://example.com/some-video.mp4';`
	*
	* @typedef {Object|string} SourceObject
	*
	* @property {string} src
	*           The url to the source
	*
	* @property {string} type
	*           The mime type of the source
	*/
	/**
	* A function used by {@link Tech} to create a new {@link TextTrack}.
	*
	* @private
	*
	* @param {Tech} self
	*        An instance of the Tech class.
	*
	* @param {string} kind
	*        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	*
	* @param {string} [label]
	*        Label to identify the text track
	*
	* @param {string} [language]
	*        Two letter language abbreviation
	*
	* @param {Object} [options={}]
	*        An object with additional text track options
	*
	* @return {TextTrack}
	*          The text track that was created.
	*/
	function createTrackHelper(self, kind, label, language, options = {}) {
		const tracks = self.textTracks();
		options.kind = kind;
		if (label) options.label = label;
		if (language) options.language = language;
		options.tech = self;
		const track = new ALL.text.TrackClass(options);
		tracks.addTrack(track);
		return track;
	}
	/**
	* This is the base class for media playback technology controllers, such as
	* {@link HTML5}
	*
	* @extends Component
	*/
	var Tech = class Tech extends Component {
		/**
		* Create an instance of this Tech.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        Callback function to call when the `HTML5` Tech is ready.
		*/
		constructor(options = {}, ready = function() {}) {
			options.reportTouchActivity = false;
			super(null, options, ready);
			this.onDurationChange_ = (e) => this.onDurationChange(e);
			this.trackProgress_ = (e) => this.trackProgress(e);
			this.trackCurrentTime_ = (e) => this.trackCurrentTime(e);
			this.stopTrackingCurrentTime_ = (e) => this.stopTrackingCurrentTime(e);
			this.disposeSourceHandler_ = (e) => this.disposeSourceHandler(e);
			this.queuedHanders_ = /* @__PURE__ */ new Set();
			this.hasStarted_ = false;
			this.on("playing", function() {
				this.hasStarted_ = true;
			});
			this.on("loadstart", function() {
				this.hasStarted_ = false;
			});
			ALL.names.forEach((name) => {
				const props = ALL[name];
				if (options && options[props.getterName]) this[props.privateName] = options[props.getterName];
			});
			if (!this.featuresProgressEvents) this.manualProgressOn();
			if (!this.featuresTimeupdateEvents) this.manualTimeUpdatesOn();
			[
				"Text",
				"Audio",
				"Video"
			].forEach((track) => {
				if (options[`native${track}Tracks`] === false) this[`featuresNative${track}Tracks`] = false;
			});
			if (options.nativeCaptions === false || options.nativeTextTracks === false) this.featuresNativeTextTracks = false;
			else if (options.nativeCaptions === true || options.nativeTextTracks === true) this.featuresNativeTextTracks = true;
			if (!this.featuresNativeTextTracks) this.emulateTextTracks();
			this.preloadTextTracks = options.preloadTextTracks !== false;
			this.autoRemoteTextTracks_ = new ALL.text.ListClass();
			this.initTrackListeners();
			if (!options.nativeControlsForTouch) this.emitTapEvents();
			if (this.constructor) this.name_ = this.constructor.name || "Unknown Tech";
		}
		/**
		* A special function to trigger source set in a way that will allow player
		* to re-trigger if the player or tech are not ready yet.
		*
		* @fires Tech#sourceset
		* @param {string} src The source string at the time of the source changing.
		*/
		triggerSourceset(src) {
			if (!this.isReady_) this.one("ready", () => this.setTimeout(() => this.triggerSourceset(src), 1));
			/**
			* Fired when the source is set on the tech causing the media element
			* to reload.
			*
			* @see {@link Player#event:sourceset}
			* @event Tech#sourceset
			* @type {Event}
			*/
			this.trigger({
				src,
				type: "sourceset"
			});
		}
		/**
		* Polyfill the `progress` event for browsers that don't support it natively.
		*
		* @see {@link Tech#trackProgress}
		*/
		manualProgressOn() {
			this.on("durationchange", this.onDurationChange_);
			this.manualProgress = true;
			this.one("ready", this.trackProgress_);
		}
		/**
		* Turn off the polyfill for `progress` events that was created in
		* {@link Tech#manualProgressOn}
		*/
		manualProgressOff() {
			this.manualProgress = false;
			this.stopTrackingProgress();
			this.off("durationchange", this.onDurationChange_);
		}
		/**
		* This is used to trigger a `progress` event when the buffered percent changes. It
		* sets an interval function that will be called every 500 milliseconds to check if the
		* buffer end percent has changed.
		*
		* > This function is called by {@link Tech#manualProgressOn}
		*
		* @param {Event} event
		*        The `ready` event that caused this to run.
		*
		* @listens Tech#ready
		* @fires Tech#progress
		*/
		trackProgress(event) {
			this.stopTrackingProgress();
			this.progressInterval = this.setInterval(bind_(this, function() {
				const numBufferedPercent = this.bufferedPercent();
				if (this.bufferedPercent_ !== numBufferedPercent)
 /**
				* See {@link Player#progress}
				*
				* @event Tech#progress
				* @type {Event}
				*/
				this.trigger("progress");
				this.bufferedPercent_ = numBufferedPercent;
				if (numBufferedPercent === 1) this.stopTrackingProgress();
			}), 500);
		}
		/**
		* Update our internal duration on a `durationchange` event by calling
		* {@link Tech#duration}.
		*
		* @param {Event} event
		*        The `durationchange` event that caused this to run.
		*
		* @listens Tech#durationchange
		*/
		onDurationChange(event) {
			this.duration_ = this.duration();
		}
		/**
		* Get and create a `TimeRange` object for buffering.
		*
		* @return {TimeRange}
		*         The time range object that was created.
		*/
		buffered() {
			return createTimeRanges(0, 0);
		}
		/**
		* Get the percentage of the current video that is currently buffered.
		*
		* @return {number}
		*         A number from 0 to 1 that represents the decimal percentage of the
		*         video that is buffered.
		*
		*/
		bufferedPercent() {
			return bufferedPercent(this.buffered(), this.duration_);
		}
		/**
		* Turn off the polyfill for `progress` events that was created in
		* {@link Tech#manualProgressOn}
		* Stop manually tracking progress events by clearing the interval that was set in
		* {@link Tech#trackProgress}.
		*/
		stopTrackingProgress() {
			this.clearInterval(this.progressInterval);
		}
		/**
		* Polyfill the `timeupdate` event for browsers that don't support it.
		*
		* @see {@link Tech#trackCurrentTime}
		*/
		manualTimeUpdatesOn() {
			this.manualTimeUpdates = true;
			this.on("play", this.trackCurrentTime_);
			this.on("pause", this.stopTrackingCurrentTime_);
		}
		/**
		* Turn off the polyfill for `timeupdate` events that was created in
		* {@link Tech#manualTimeUpdatesOn}
		*/
		manualTimeUpdatesOff() {
			this.manualTimeUpdates = false;
			this.stopTrackingCurrentTime();
			this.off("play", this.trackCurrentTime_);
			this.off("pause", this.stopTrackingCurrentTime_);
		}
		/**
		* Sets up an interval function to track current time and trigger `timeupdate` every
		* 250 milliseconds.
		*
		* @listens Tech#play
		* @triggers Tech#timeupdate
		*/
		trackCurrentTime() {
			if (this.currentTimeInterval) this.stopTrackingCurrentTime();
			this.currentTimeInterval = this.setInterval(function() {
				/**
				* Triggered at an interval of 250ms to indicated that time is passing in the video.
				*
				* @event Tech#timeupdate
				* @type {Event}
				*/
				this.trigger({
					type: "timeupdate",
					target: this,
					manuallyTriggered: true
				});
			}, 250);
		}
		/**
		* Stop the interval function created in {@link Tech#trackCurrentTime} so that the
		* `timeupdate` event is no longer triggered.
		*
		* @listens {Tech#pause}
		*/
		stopTrackingCurrentTime() {
			this.clearInterval(this.currentTimeInterval);
			this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: true
			});
		}
		/**
		* Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
		* {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
		*
		* @fires Component#dispose
		*/
		dispose() {
			this.clearTracks(NORMAL.names);
			if (this.manualProgress) this.manualProgressOff();
			if (this.manualTimeUpdates) this.manualTimeUpdatesOff();
			super.dispose();
		}
		/**
		* Clear out a single `TrackList` or an array of `TrackLists` given their names.
		*
		* > Note: Techs without source handlers should call this between sources for `video`
		*         & `audio` tracks. You don't want to use them between tracks!
		*
		* @param {string[]|string} types
		*        TrackList names to clear, valid names are `video`, `audio`, and
		*        `text`.
		*/
		clearTracks(types) {
			types = [].concat(types);
			types.forEach((type) => {
				const list = this[`${type}Tracks`]() || [];
				let i = list.length;
				while (i--) {
					const track = list[i];
					if (type === "text") this.removeRemoteTextTrack(track);
					list.removeTrack(track);
				}
			});
		}
		/**
		* Remove any TextTracks added via addRemoteTextTrack that are
		* flagged for automatic garbage collection
		*/
		cleanupAutoTextTracks() {
			const list = this.autoRemoteTextTracks_ || [];
			let i = list.length;
			while (i--) {
				const track = list[i];
				this.removeRemoteTextTrack(track);
			}
		}
		/**
		* Reset the tech, which will removes all sources and reset the internal readyState.
		*
		* @abstract
		*/
		reset() {}
		/**
		* Get the value of `crossOrigin` from the tech.
		*
		* @abstract
		*
		* @see {Html5#crossOrigin}
		*/
		crossOrigin() {}
		/**
		* Set the value of `crossOrigin` on the tech.
		*
		* @abstract
		*
		* @param {string} crossOrigin the crossOrigin value
		* @see {Html5#setCrossOrigin}
		*/
		setCrossOrigin() {}
		/**
		* Get or set an error on the Tech.
		*
		* @param {MediaError} [err]
		*        Error to set on the Tech
		*
		* @return {MediaError|null}
		*         The current error object on the tech, or null if there isn't one.
		*/
		error(err) {
			if (err !== void 0) {
				this.error_ = new MediaError(err);
				this.trigger("error");
			}
			return this.error_;
		}
		/**
		* Returns the `TimeRange`s that have been played through for the current source.
		*
		* > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
		*         It only checks whether the source has played at all or not.
		*
		* @return {TimeRange}
		*         - A single time range if this video has played
		*         - An empty set of ranges if not.
		*/
		played() {
			if (this.hasStarted_) return createTimeRanges(0, 0);
			return createTimeRanges();
		}
		/**
		* Start playback
		*
		* @abstract
		*
		* @see {Html5#play}
		*/
		play() {}
		/**
		* Set whether we are scrubbing or not
		*
		* @abstract
		* @param {boolean} _isScrubbing
		*                  - true for we are currently scrubbing
		*                  - false for we are no longer scrubbing
		*
		* @see {Html5#setScrubbing}
		*/
		setScrubbing(_isScrubbing) {}
		/**
		* Get whether we are scrubbing or not
		*
		* @abstract
		*
		* @see {Html5#scrubbing}
		*/
		scrubbing() {}
		/**
		* Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
		* previously called.
		*
		* @param {number} _seconds
		*        Set the current time of the media to this.
		* @fires Tech#timeupdate
		*/
		setCurrentTime(_seconds) {
			if (this.manualTimeUpdates)
 /**
			* A manual `timeupdate` event.
			*
			* @event Tech#timeupdate
			* @type {Event}
			*/
			this.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: true
			});
		}
		/**
		* Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
		* {@link TextTrackList} events.
		*
		* This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
		*
		* @fires Tech#audiotrackchange
		* @fires Tech#videotrackchange
		* @fires Tech#texttrackchange
		*/
		initTrackListeners() {
			/**
			* Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
			*
			* @event Tech#audiotrackchange
			* @type {Event}
			*/
			/**
			* Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
			*
			* @event Tech#videotrackchange
			* @type {Event}
			*/
			/**
			* Triggered when tracks are added or removed on the Tech {@link TextTrackList}
			*
			* @event Tech#texttrackchange
			* @type {Event}
			*/
			NORMAL.names.forEach((name) => {
				const props = NORMAL[name];
				const trackListChanges = () => {
					this.trigger(`${name}trackchange`);
				};
				const tracks = this[props.getterName]();
				tracks.addEventListener("removetrack", trackListChanges);
				tracks.addEventListener("addtrack", trackListChanges);
				this.on("dispose", () => {
					tracks.removeEventListener("removetrack", trackListChanges);
					tracks.removeEventListener("addtrack", trackListChanges);
				});
			});
		}
		/**
		* Emulate TextTracks using vtt.js if necessary
		*
		* @fires Tech#vttjsloaded
		* @fires Tech#vttjserror
		*/
		addWebVttScript_() {
			if (window__default["default"].WebVTT) return;
			if (document__default["default"].body.contains(this.el())) {
				if (!this.options_["vtt.js"] && isPlain(vtt__default["default"]) && Object.keys(vtt__default["default"]).length > 0) {
					this.trigger("vttjsloaded");
					return;
				}
				const script = document__default["default"].createElement("script");
				script.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js";
				script.onload = () => {
					/**
					* Fired when vtt.js is loaded.
					*
					* @event Tech#vttjsloaded
					* @type {Event}
					*/
					this.trigger("vttjsloaded");
				};
				script.onerror = () => {
					/**
					* Fired when vtt.js was not loaded due to an error
					*
					* @event Tech#vttjsloaded
					* @type {Event}
					*/
					this.trigger("vttjserror");
				};
				this.on("dispose", () => {
					script.onload = null;
					script.onerror = null;
				});
				window__default["default"].WebVTT = true;
				this.el().parentNode.appendChild(script);
			} else this.ready(this.addWebVttScript_);
		}
		/**
		* Emulate texttracks
		*
		*/
		emulateTextTracks() {
			const tracks = this.textTracks();
			const remoteTracks = this.remoteTextTracks();
			const handleAddTrack = (e) => tracks.addTrack(e.track);
			const handleRemoveTrack = (e) => tracks.removeTrack(e.track);
			remoteTracks.on("addtrack", handleAddTrack);
			remoteTracks.on("removetrack", handleRemoveTrack);
			this.addWebVttScript_();
			const updateDisplay = () => this.trigger("texttrackchange");
			const textTracksChanges = () => {
				updateDisplay();
				for (let i = 0; i < tracks.length; i++) {
					const track = tracks[i];
					track.removeEventListener("cuechange", updateDisplay);
					if (track.mode === "showing") track.addEventListener("cuechange", updateDisplay);
				}
			};
			textTracksChanges();
			tracks.addEventListener("change", textTracksChanges);
			tracks.addEventListener("addtrack", textTracksChanges);
			tracks.addEventListener("removetrack", textTracksChanges);
			this.on("dispose", function() {
				remoteTracks.off("addtrack", handleAddTrack);
				remoteTracks.off("removetrack", handleRemoveTrack);
				tracks.removeEventListener("change", textTracksChanges);
				tracks.removeEventListener("addtrack", textTracksChanges);
				tracks.removeEventListener("removetrack", textTracksChanges);
				for (let i = 0; i < tracks.length; i++) tracks[i].removeEventListener("cuechange", updateDisplay);
			});
		}
		/**
		* Create and returns a remote {@link TextTrack} object.
		*
		* @param {string} kind
		*        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
		*
		* @param {string} [label]
		*        Label to identify the text track
		*
		* @param {string} [language]
		*        Two letter language abbreviation
		*
		* @return {TextTrack}
		*         The TextTrack that gets created.
		*/
		addTextTrack(kind, label, language) {
			if (!kind) throw new Error("TextTrack kind is required but was not provided");
			return createTrackHelper(this, kind, label, language);
		}
		/**
		* Create an emulated TextTrack for use by addRemoteTextTrack
		*
		* This is intended to be overridden by classes that inherit from
		* Tech in order to create native or custom TextTracks.
		*
		* @param {Object} options
		*        The object should contain the options to initialize the TextTrack with.
		*
		* @param {string} [options.kind]
		*        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
		*
		* @param {string} [options.label].
		*        Label to identify the text track
		*
		* @param {string} [options.language]
		*        Two letter language abbreviation.
		*
		* @return {HTMLTrackElement}
		*         The track element that gets created.
		*/
		createRemoteTextTrack(options) {
			const track = merge(options, { tech: this });
			return new REMOTE.remoteTextEl.TrackClass(track);
		}
		/**
		* Creates a remote text track object and returns an html track element.
		*
		* > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
		*
		* @param {Object} options
		*        See {@link Tech#createRemoteTextTrack} for more detailed properties.
		*
		* @param {boolean} [manualCleanup=false]
		*        - When false: the TextTrack will be automatically removed from the video
		*          element whenever the source changes
		*        - When True: The TextTrack will have to be cleaned up manually
		*
		* @return {HTMLTrackElement}
		*         An Html Track Element.
		*
		*/
		addRemoteTextTrack(options = {}, manualCleanup) {
			const htmlTrackElement = this.createRemoteTextTrack(options);
			if (typeof manualCleanup !== "boolean") manualCleanup = false;
			this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
			this.remoteTextTracks().addTrack(htmlTrackElement.track);
			if (manualCleanup === false) this.ready(() => this.autoRemoteTextTracks_.addTrack(htmlTrackElement.track));
			return htmlTrackElement;
		}
		/**
		* Remove a remote text track from the remote `TextTrackList`.
		*
		* @param {TextTrack} track
		*        `TextTrack` to remove from the `TextTrackList`
		*/
		removeRemoteTextTrack(track) {
			const trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
			this.remoteTextTrackEls().removeTrackElement_(trackElement);
			this.remoteTextTracks().removeTrack(track);
			this.autoRemoteTextTracks_.removeTrack(track);
		}
		/**
		* Gets available media playback quality metrics as specified by the W3C's Media
		* Playback Quality API.
		*
		* @see [Spec]{@link https://wicg.github.io/media-playback-quality}
		*
		* @return {Object}
		*         An object with supported media playback quality metrics
		*
		* @abstract
		*/
		getVideoPlaybackQuality() {
			return {};
		}
		/**
		* Attempt to create a floating video window always on top of other windows
		* so that users may continue consuming media while they interact with other
		* content sites, or applications on their device.
		*
		* @see [Spec]{@link https://wicg.github.io/picture-in-picture}
		*
		* @return {Promise|undefined}
		*         A promise with a Picture-in-Picture window if the browser supports
		*         Promises (or one was passed in as an option). It returns undefined
		*         otherwise.
		*
		* @abstract
		*/
		requestPictureInPicture() {
			return Promise.reject();
		}
		/**
		* A method to check for the value of the 'disablePictureInPicture' <video> property.
		* Defaults to true, as it should be considered disabled if the tech does not support pip
		*
		* @abstract
		*/
		disablePictureInPicture() {
			return true;
		}
		/**
		* A method to set or unset the 'disablePictureInPicture' <video> property.
		*
		* @abstract
		*/
		setDisablePictureInPicture() {}
		/**
		* A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
		*
		* @param {function} cb
		* @return {number} request id
		*/
		requestVideoFrameCallback(cb) {
			const id = newGUID();
			if (!this.isReady_ || this.paused()) {
				this.queuedHanders_.add(id);
				this.one("playing", () => {
					if (this.queuedHanders_.has(id)) {
						this.queuedHanders_.delete(id);
						cb();
					}
				});
			} else this.requestNamedAnimationFrame(id, cb);
			return id;
		}
		/**
		* A fallback implementation of cancelVideoFrameCallback
		*
		* @param {number} id id of callback to be cancelled
		*/
		cancelVideoFrameCallback(id) {
			if (this.queuedHanders_.has(id)) this.queuedHanders_.delete(id);
			else this.cancelNamedAnimationFrame(id);
		}
		/**
		* A method to set a poster from a `Tech`.
		*
		* @abstract
		*/
		setPoster() {}
		/**
		* A method to check for the presence of the 'playsinline' <video> attribute.
		*
		* @abstract
		*/
		playsinline() {}
		/**
		* A method to set or unset the 'playsinline' <video> attribute.
		*
		* @abstract
		*/
		setPlaysinline() {}
		/**
		* Attempt to force override of native audio tracks.
		*
		* @param {boolean} override - If set to true native audio will be overridden,
		* otherwise native audio will potentially be used.
		*
		* @abstract
		*/
		overrideNativeAudioTracks(override) {}
		/**
		* Attempt to force override of native video tracks.
		*
		* @param {boolean} override - If set to true native video will be overridden,
		* otherwise native video will potentially be used.
		*
		* @abstract
		*/
		overrideNativeVideoTracks(override) {}
		/**
		* Check if the tech can support the given mime-type.
		*
		* The base tech does not support any type, but source handlers might
		* overwrite this.
		*
		* @param  {string} _type
		*         The mimetype to check for support
		*
		* @return {string}
		*         'probably', 'maybe', or empty string
		*
		* @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
		*
		* @abstract
		*/
		canPlayType(_type) {
			return "";
		}
		/**
		* Check if the type is supported by this tech.
		*
		* The base tech does not support any type, but source handlers might
		* overwrite this.
		*
		* @param {string} _type
		*        The media type to check
		* @return {string} Returns the native video element's response
		*/
		static canPlayType(_type) {
			return "";
		}
		/**
		* Check if the tech can support the given source
		*
		* @param {Object} srcObj
		*        The source object
		* @param {Object} options
		*        The options passed to the tech
		* @return {string} 'probably', 'maybe', or '' (empty string)
		*/
		static canPlaySource(srcObj, options) {
			return Tech.canPlayType(srcObj.type);
		}
		static isTech(component) {
			return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
		}
		/**
		* Registers a `Tech` into a shared list for videojs.
		*
		* @param {string} name
		*        Name of the `Tech` to register.
		*
		* @param {Object} tech
		*        The `Tech` class to register.
		*/
		static registerTech(name, tech) {
			if (!Tech.techs_) Tech.techs_ = {};
			if (!Tech.isTech(tech)) throw new Error(`Tech ${name} must be a Tech`);
			if (!Tech.canPlayType) throw new Error("Techs must have a static canPlayType method on them");
			if (!Tech.canPlaySource) throw new Error("Techs must have a static canPlaySource method on them");
			name = toTitleCase(name);
			Tech.techs_[name] = tech;
			Tech.techs_[toLowerCase(name)] = tech;
			if (name !== "Tech") Tech.defaultTechOrder_.push(name);
			return tech;
		}
		/**
		* Get a `Tech` from the shared list by name.
		*
		* @param {string} name
		*        `camelCase` or `TitleCase` name of the Tech to get
		*
		* @return {Tech|undefined}
		*         The `Tech` or undefined if there was no tech with the name requested.
		*/
		static getTech(name) {
			if (!name) return;
			if (Tech.techs_ && Tech.techs_[name]) return Tech.techs_[name];
			name = toTitleCase(name);
			if (window__default["default"] && window__default["default"].videojs && window__default["default"].videojs[name]) {
				log.warn(`The ${name} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`);
				return window__default["default"].videojs[name];
			}
		}
	};
	/**
	* Get the {@link VideoTrackList}
	*
	* @returns {VideoTrackList}
	* @method Tech.prototype.videoTracks
	*/
	/**
	* Get the {@link AudioTrackList}
	*
	* @returns {AudioTrackList}
	* @method Tech.prototype.audioTracks
	*/
	/**
	* Get the {@link TextTrackList}
	*
	* @returns {TextTrackList}
	* @method Tech.prototype.textTracks
	*/
	/**
	* Get the remote element {@link TextTrackList}
	*
	* @returns {TextTrackList}
	* @method Tech.prototype.remoteTextTracks
	*/
	/**
	* Get the remote element {@link HtmlTrackElementList}
	*
	* @returns {HtmlTrackElementList}
	* @method Tech.prototype.remoteTextTrackEls
	*/
	ALL.names.forEach(function(name) {
		const props = ALL[name];
		Tech.prototype[props.getterName] = function() {
			this[props.privateName] = this[props.privateName] || new props.ListClass();
			return this[props.privateName];
		};
	});
	/**
	* List of associated text tracks
	*
	* @type {TextTrackList}
	* @private
	* @property Tech#textTracks_
	*/
	/**
	* List of associated audio tracks.
	*
	* @type {AudioTrackList}
	* @private
	* @property Tech#audioTracks_
	*/
	/**
	* List of associated video tracks.
	*
	* @type {VideoTrackList}
	* @private
	* @property Tech#videoTracks_
	*/
	/**
	* Boolean indicating whether the `Tech` supports volume control.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresVolumeControl = true;
	/**
	* Boolean indicating whether the `Tech` supports muting volume.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresMuteControl = true;
	/**
	* Boolean indicating whether the `Tech` supports fullscreen resize control.
	* Resizing plugins using request fullscreen reloads the plugin
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresFullscreenResize = false;
	/**
	* Boolean indicating whether the `Tech` supports changing the speed at which the video
	* plays. Examples:
	*   - Set player to play 2x (twice) as fast
	*   - Set player to play 0.5x (half) as fast
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresPlaybackRate = false;
	/**
	* Boolean indicating whether the `Tech` supports the `progress` event.
	* This will be used to determine if {@link Tech#manualProgressOn} should be called.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresProgressEvents = false;
	/**
	* Boolean indicating whether the `Tech` supports the `sourceset` event.
	*
	* A tech should set this to `true` and then use {@link Tech#triggerSourceset}
	* to trigger a {@link Tech#event:sourceset} at the earliest time after getting
	* a new source.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresSourceset = false;
	/**
	* Boolean indicating whether the `Tech` supports the `timeupdate` event.
	* This will be used to determine if {@link Tech#manualTimeUpdates} should be called.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresTimeupdateEvents = false;
	/**
	* Boolean indicating whether the `Tech` supports the native `TextTrack`s.
	* This will help us integrate with native `TextTrack`s if the browser supports them.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresNativeTextTracks = false;
	/**
	* Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
	*
	* @type {boolean}
	* @default
	*/
	Tech.prototype.featuresVideoFrameCallback = false;
	/**
	* A functional mixin for techs that want to use the Source Handler pattern.
	* Source handlers are scripts for handling specific formats.
	* The source handler pattern is used for adaptive formats (HLS, DASH) that
	* manually load video data and feed it into a Source Buffer (Media Source Extensions)
	* Example: `Tech.withSourceHandlers.call(MyTech);`
	*
	* @param {Tech} _Tech
	*        The tech to add source handler functions to.
	*
	* @mixes Tech~SourceHandlerAdditions
	*/
	Tech.withSourceHandlers = function(_Tech) {
		/**
		* Register a source handler
		*
		* @param {Function} handler
		*        The source handler class
		*
		* @param {number} [index]
		*        Register it at the following index
		*/
		_Tech.registerSourceHandler = function(handler, index) {
			let handlers = _Tech.sourceHandlers;
			if (!handlers) handlers = _Tech.sourceHandlers = [];
			if (index === void 0) index = handlers.length;
			handlers.splice(index, 0, handler);
		};
		/**
		* Check if the tech can support the given type. Also checks the
		* Techs sourceHandlers.
		*
		* @param {string} type
		*         The mimetype to check.
		*
		* @return {string}
		*         'probably', 'maybe', or '' (empty string)
		*/
		_Tech.canPlayType = function(type) {
			const handlers = _Tech.sourceHandlers || [];
			let can;
			for (let i = 0; i < handlers.length; i++) {
				can = handlers[i].canPlayType(type);
				if (can) return can;
			}
			return "";
		};
		/**
		* Returns the first source handler that supports the source.
		*
		* TODO: Answer question: should 'probably' be prioritized over 'maybe'
		*
		* @param {SourceObject} source
		*        The source object
		*
		* @param {Object} options
		*        The options passed to the tech
		*
		* @return {SourceHandler|null}
		*          The first source handler that supports the source or null if
		*          no SourceHandler supports the source
		*/
		_Tech.selectSourceHandler = function(source, options) {
			const handlers = _Tech.sourceHandlers || [];
			let can;
			for (let i = 0; i < handlers.length; i++) {
				can = handlers[i].canHandleSource(source, options);
				if (can) return handlers[i];
			}
			return null;
		};
		/**
		* Check if the tech can support the given source.
		*
		* @param {SourceObject} srcObj
		*        The source object
		*
		* @param {Object} options
		*        The options passed to the tech
		*
		* @return {string}
		*         'probably', 'maybe', or '' (empty string)
		*/
		_Tech.canPlaySource = function(srcObj, options) {
			const sh = _Tech.selectSourceHandler(srcObj, options);
			if (sh) return sh.canHandleSource(srcObj, options);
			return "";
		};
		/**
		* A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
		* function if it exists, with a fallback to the Techs seekable function.
		*
		* @method _Tech.seekable
		*/
		/**
		* A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
		* function if it exists, otherwise it will fallback to the techs duration function.
		*
		* @method _Tech.duration
		*/
		[
			"seekable",
			"seeking",
			"duration"
		].forEach(function(fnName) {
			const originalFn = this[fnName];
			if (typeof originalFn !== "function") return;
			this[fnName] = function() {
				if (this.sourceHandler_ && this.sourceHandler_[fnName]) return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
				return originalFn.apply(this, arguments);
			};
		}, _Tech.prototype);
		/**
		* Create a function for setting the source using a source object
		* and source handlers.
		* Should never be called unless a source handler was found.
		*
		* @param {SourceObject} source
		*        A source object with src and type keys
		*/
		_Tech.prototype.setSource = function(source) {
			let sh = _Tech.selectSourceHandler(source, this.options_);
			if (!sh) if (_Tech.nativeSourceHandler) sh = _Tech.nativeSourceHandler;
			else log.error("No source handler found for the current source.");
			this.disposeSourceHandler();
			this.off("dispose", this.disposeSourceHandler_);
			if (sh !== _Tech.nativeSourceHandler) this.currentSource_ = source;
			this.sourceHandler_ = sh.handleSource(source, this, this.options_);
			this.one("dispose", this.disposeSourceHandler_);
		};
		/**
		* Clean up any existing SourceHandlers and listeners when the Tech is disposed.
		*
		* @listens Tech#dispose
		*/
		_Tech.prototype.disposeSourceHandler = function() {
			if (this.currentSource_) {
				this.clearTracks(["audio", "video"]);
				this.currentSource_ = null;
			}
			this.cleanupAutoTextTracks();
			if (this.sourceHandler_) {
				if (this.sourceHandler_.dispose) this.sourceHandler_.dispose();
				this.sourceHandler_ = null;
			}
		};
	};
	Component.registerComponent("Tech", Tech);
	Tech.registerTech("Tech", Tech);
	/**
	* A list of techs that should be added to techOrder on Players
	*
	* @private
	*/
	Tech.defaultTechOrder_ = [];
	/**
	* @file middleware.js
	* @module middleware
	*/
	/** @import Player from '../player' */
	/** @import Tech from '../tech/tech' */
	var middlewares = {};
	var middlewareInstances = {};
	var TERMINATOR = {};
	/**
	* A middleware object is a plain JavaScript object that has methods that
	* match the {@link Tech} methods found in the lists of allowed
	* {@link module:middleware.allowedGetters|getters},
	* {@link module:middleware.allowedSetters|setters}, and
	* {@link module:middleware.allowedMediators|mediators}.
	*
	* @typedef {Object} MiddlewareObject
	*/
	/**
	* A middleware factory function that should return a
	* {@link module:middleware~MiddlewareObject|MiddlewareObject}.
	*
	* This factory will be called for each player when needed, with the player
	* passed in as an argument.
	*
	* @callback MiddlewareFactory
	* @param {Player} player
	*        A Video.js player.
	*/
	/**
	* Define a middleware that the player should use by way of a factory function
	* that returns a middleware object.
	*
	* @param  {string} type
	*         The MIME type to match or `"*"` for all MIME types.
	*
	* @param  {MiddlewareFactory} middleware
	*         A middleware factory function that will be executed for
	*         matching types.
	*/
	function use(type, middleware) {
		middlewares[type] = middlewares[type] || [];
		middlewares[type].push(middleware);
	}
	/**
	* Asynchronously sets a source using middleware by recursing through any
	* matching middlewares and calling `setSource` on each, passing along the
	* previous returned value each time.
	*
	* @param  {Player} player
	*         A {@link Player} instance.
	*
	* @param  {Tech~SourceObject} src
	*         A source object.
	*
	* @param  {Function}
	*         The next middleware to run.
	*/
	function setSource(player, src, next) {
		player.setTimeout(() => setSourceHelper(src, middlewares[src.type], next, player), 1);
	}
	/**
	* When the tech is set, passes the tech to each middleware's `setTech` method.
	*
	* @param {Object[]} middleware
	*        An array of middleware instances.
	*
	* @param {Tech} tech
	*        A Video.js tech.
	*/
	function setTech(middleware, tech) {
		middleware.forEach((mw) => mw.setTech && mw.setTech(tech));
	}
	/**
	* Calls a getter on the tech first, through each middleware
	* from right to left to the player.
	*
	* @param  {Object[]} middleware
	*         An array of middleware instances.
	*
	* @param  {Tech} tech
	*         The current tech.
	*
	* @param  {string} method
	*         A method name.
	*
	* @return {*}
	*         The final value from the tech after middleware has intercepted it.
	*/
	function get(middleware, tech, method) {
		return middleware.reduceRight(middlewareIterator(method), tech[method]());
	}
	/**
	* Takes the argument given to the player and calls the setter method on each
	* middleware from left to right to the tech.
	*
	* @param  {Object[]} middleware
	*         An array of middleware instances.
	*
	* @param  {Tech} tech
	*         The current tech.
	*
	* @param  {string} method
	*         A method name.
	*
	* @param  {*} arg
	*         The value to set on the tech.
	*
	* @return {*}
	*         The return value of the `method` of the `tech`.
	*/
	function set(middleware, tech, method, arg) {
		return tech[method](middleware.reduce(middlewareIterator(method), arg));
	}
	/**
	* Takes the argument given to the player and calls the `call` version of the
	* method on each middleware from left to right.
	*
	* Then, call the passed in method on the tech and return the result unchanged
	* back to the player, through middleware, this time from right to left.
	*
	* @param  {Object[]} middleware
	*         An array of middleware instances.
	*
	* @param  {Tech} tech
	*         The current tech.
	*
	* @param  {string} method
	*         A method name.
	*
	* @param  {*} arg
	*         The value to set on the tech.
	*
	* @return {*}
	*         The return value of the `method` of the `tech`, regardless of the
	*         return values of middlewares.
	*/
	function mediate(middleware, tech, method, arg = null) {
		const callMethod = "call" + toTitleCase(method);
		const middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
		const terminated = middlewareValue === TERMINATOR;
		const returnValue = terminated ? null : tech[method](middlewareValue);
		executeRight(middleware, method, returnValue, terminated);
		return returnValue;
	}
	/**
	* Enumeration of allowed getters where the keys are method names.
	*
	* @type {Object}
	*/
	var allowedGetters = {
		buffered: 1,
		currentTime: 1,
		duration: 1,
		muted: 1,
		played: 1,
		paused: 1,
		seekable: 1,
		volume: 1,
		ended: 1
	};
	/**
	* Enumeration of allowed setters where the keys are method names.
	*
	* @type {Object}
	*/
	var allowedSetters = {
		setCurrentTime: 1,
		setMuted: 1,
		setVolume: 1
	};
	/**
	* Enumeration of allowed mediators where the keys are method names.
	*
	* @type {Object}
	*/
	var allowedMediators = {
		play: 1,
		pause: 1
	};
	function middlewareIterator(method) {
		return (value, mw) => {
			if (value === TERMINATOR) return TERMINATOR;
			if (mw[method]) return mw[method](value);
			return value;
		};
	}
	function executeRight(mws, method, value, terminated) {
		for (let i = mws.length - 1; i >= 0; i--) {
			const mw = mws[i];
			if (mw[method]) mw[method](terminated, value);
		}
	}
	/**
	* Clear the middleware cache for a player.
	*
	* @param  {Player} player
	*         A {@link Player} instance.
	*/
	function clearCacheForPlayer(player) {
		if (middlewareInstances.hasOwnProperty(player.id())) delete middlewareInstances[player.id()];
	}
	/**
	* {
	*  [playerId]: [[mwFactory, mwInstance], ...]
	* }
	*
	* @private
	*/
	function getOrCreateFactory(player, mwFactory) {
		const mws = middlewareInstances[player.id()];
		let mw = null;
		if (mws === void 0 || mws === null) {
			mw = mwFactory(player);
			middlewareInstances[player.id()] = [[mwFactory, mw]];
			return mw;
		}
		for (let i = 0; i < mws.length; i++) {
			const [mwf, mwi] = mws[i];
			if (mwf !== mwFactory) continue;
			mw = mwi;
		}
		if (mw === null) {
			mw = mwFactory(player);
			mws.push([mwFactory, mw]);
		}
		return mw;
	}
	function setSourceHelper(src = {}, middleware = [], next, player, acc = [], lastRun = false) {
		const [mwFactory, ...mwrest] = middleware;
		if (typeof mwFactory === "string") setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun);
		else if (mwFactory) {
			const mw = getOrCreateFactory(player, mwFactory);
			if (!mw.setSource) {
				acc.push(mw);
				return setSourceHelper(src, mwrest, next, player, acc, lastRun);
			}
			mw.setSource(Object.assign({}, src), function(err, _src) {
				if (err) return setSourceHelper(src, mwrest, next, player, acc, lastRun);
				acc.push(mw);
				setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
			});
		} else if (mwrest.length) setSourceHelper(src, mwrest, next, player, acc, lastRun);
		else if (lastRun) next(src, acc);
		else setSourceHelper(src, middlewares["*"], next, player, acc, true);
	}
	/** @import Player from '../player' */
	/**
	* Mimetypes
	*
	* @see https://www.iana.org/assignments/media-types/media-types.xhtml
	* @typedef Mimetypes~Kind
	* @enum
	*/
	var MimetypesKind = {
		opus: "video/ogg",
		ogv: "video/ogg",
		mp4: "video/mp4",
		mov: "video/mp4",
		m4v: "video/mp4",
		mkv: "video/x-matroska",
		m4a: "audio/mp4",
		mp3: "audio/mpeg",
		aac: "audio/aac",
		caf: "audio/x-caf",
		flac: "audio/flac",
		oga: "audio/ogg",
		wav: "audio/wav",
		m3u8: "application/x-mpegURL",
		mpd: "application/dash+xml",
		jpg: "image/jpeg",
		jpeg: "image/jpeg",
		gif: "image/gif",
		png: "image/png",
		svg: "image/svg+xml",
		webp: "image/webp"
	};
	/**
	* Get the mimetype of a given src url if possible
	*
	* @param {string} src
	*        The url to the src
	*
	* @return {string}
	*         return the mimetype if it was known or empty string otherwise
	*/
	var getMimetype = function(src = "") {
		return MimetypesKind[getFileExtension(src).toLowerCase()] || "";
	};
	/**
	* Find the mime type of a given source string if possible. Uses the player
	* source cache.
	*
	* @param {Player} player
	*        The player object
	*
	* @param {string} src
	*        The source string
	*
	* @return {string}
	*         The type that was found
	*/
	var findMimetype = (player, src) => {
		if (!src) return "";
		if (player.cache_.source.src === src && player.cache_.source.type) return player.cache_.source.type;
		const matchingSources = player.cache_.sources.filter((s) => s.src === src);
		if (matchingSources.length) return matchingSources[0].type;
		const sources = player.$$("source");
		for (let i = 0; i < sources.length; i++) {
			const s = sources[i];
			if (s.type && s.src && s.src === src) return s.type;
		}
		return getMimetype(src);
	};
	/**
	* @module filter-source
	*/
	/**
	* Filter out single bad source objects or multiple source objects in an
	* array. Also flattens nested source object arrays into a 1 dimensional
	* array of source objects.
	*
	* @param {Tech~SourceObject|Tech~SourceObject[]} src
	*        The src object to filter
	*
	* @return {Tech~SourceObject[]}
	*         An array of sourceobjects containing only valid sources
	*
	* @private
	*/
	var filterSource = function(src) {
		if (Array.isArray(src)) {
			let newsrc = [];
			src.forEach(function(srcobj) {
				srcobj = filterSource(srcobj);
				if (Array.isArray(srcobj)) newsrc = newsrc.concat(srcobj);
				else if (isObject(srcobj)) newsrc.push(srcobj);
			});
			src = newsrc;
		} else if (typeof src === "string" && src.trim()) src = [fixSource({ src })];
		else if (isObject(src) && typeof src.src === "string" && src.src && src.src.trim()) src = [fixSource(src)];
		else src = [];
		return src;
	};
	/**
	* Checks src mimetype, adding it when possible
	*
	* @param {Tech~SourceObject} src
	*        The src object to check
	* @return {Tech~SourceObject}
	*        src Object with known type
	*/
	function fixSource(src) {
		if (!src.type) {
			const mimetype = getMimetype(src.src);
			if (mimetype) src.type = mimetype;
		}
		return src;
	}
	var icons = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play\">\n      <path d=\"M16 10v28l22-14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-pause\">\n      <path d=\"M12 38h8V10h-8v28zm16-28v28h8V10h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-audio\">\n      <path d=\"M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-captions\">\n      <path d=\"M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-subtitles\">\n      <path d=\"M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-enter\">\n      <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-fullscreen-exit\">\n      <path d=\"M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-play-circle\">\n      <path d=\"M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-mute\">\n      <path d=\"M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-low\">\n      <path d=\"M14 18v12h8l10 10V8L22 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-medium\">\n      <path d=\"M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-volume-high\">\n      <path d=\"M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-spinner\">\n      <path d=\"M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 24 24\" id=\"vjs-icon-hd\">\n      <path d=\"M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-chapters\">\n      <path d=\"M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 40 40\" id=\"vjs-icon-downloading\">\n      <path d=\"M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download\">\n      <path d=\"M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-done\">\n      <path d=\"M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-file-download-off\">\n      <path d=\"M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-share\">\n      <path d=\"M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cog\">\n      <path d=\"M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-square\">\n      <path d=\"M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle\">\n      <circle cx=\"24\" cy=\"24\" r=\"20\"></circle>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-outline\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-circle-inner-circle\">\n      <path d=\"M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cancel\">\n      <path d=\"M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-replay\">\n      <path d=\"M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-repeat\">\n      <path d=\"M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-5\">\n      <path d=\"M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-10\">\n      <path d=\"M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-replay-30\">\n      <path d=\"M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-5\">\n      <path d=\"M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-10\">\n      <path d=\"M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 96 48 48\" id=\"vjs-icon-forward-30\">\n      <path d=\"M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 512 512\" id=\"vjs-icon-audio-description\">\n      <g fill-rule=\"evenodd\"><path d=\"M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57\"></path><path d=\"M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894\"></path><path d=\"M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z\"></path></g>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-next-item\">\n      <path d=\"M12 36l17-12-17-12v24zm20-24v24h4V12h-4z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-previous-item\">\n      <path d=\"M12 12h4v24h-4zm7 12l17 12V12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-shuffle\">\n      <path d=\"M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-cast\">\n      <path d=\"M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 48 48\" id=\"vjs-icon-picture-in-picture-enter\">\n      <path d=\"M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 22 18\" id=\"vjs-icon-picture-in-picture-exit\">\n      <path d=\"M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z\"></path>\n      <path fill=\"none\" d=\"M-1-3h24v24H-1z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-facebook\">\n      <path d=\"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-linkedin\">\n      <path d=\"M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1200 1227\" id=\"vjs-icon-twitter\">\n      <path d=\"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z\"/>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-tumblr\">\n      <path d=\"M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z\"></path>\n    </symbol>\n    <symbol viewBox=\"0 0 1792 1792\" id=\"vjs-icon-pinterest\">\n      <path d=\"M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z\"></path>\n    </symbol>\n  </defs>\n</svg>";
	var backKeyCode = IS_TIZEN ? 10009 : IS_WEBOS ? 461 : 8;
	var SpatialNavKeyCodes = {
		codes: {
			play: 415,
			pause: 19,
			ff: 417,
			rw: 412,
			back: backKeyCode
		},
		names: {
			415: "play",
			19: "pause",
			417: "ff",
			412: "rw",
			[backKeyCode]: "back"
		},
		isEventKey(event, keyName) {
			keyName = keyName.toLowerCase();
			if (this.names[event.keyCode] && this.names[event.keyCode] === keyName) return true;
			return false;
		},
		getEventName(event) {
			if (this.names[event.keyCode]) return this.names[event.keyCode];
			else if (this.codes[event.code]) {
				const code = this.codes[event.code];
				return this.names[code];
			}
			return null;
		}
	};
	/**
	* @file spatial-navigation.js
	*/
	/** @import Component from './component' */
	/** @import Player from './player' */
	var STEP_SECONDS = 5;
	/**
	* Spatial Navigation in Video.js enhances user experience and accessibility on smartTV devices,
	* enabling seamless navigation through interactive elements within the player using remote control arrow keys.
	* This functionality allows users to effortlessly navigate through focusable components.
	*
	* @extends EventTarget
	*/
	var SpatialNavigation = class extends EventTarget {
		/**
		* Constructs a SpatialNavigation instance with initial settings.
		* Sets up the player instance, and prepares the spatial navigation system.
		*
		* @class
		* @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
		*/
		constructor(player) {
			super();
			this.player_ = player;
			this.focusableComponents = [];
			this.isListening_ = false;
			this.isPaused_ = false;
			this.onKeyDown_ = this.onKeyDown_.bind(this);
			this.lastFocusedComponent_ = null;
		}
		/**
		* Starts the spatial navigation by adding a keydown event listener to the video container.
		* This method ensures that the event listener is added only once.
		*/
		start() {
			if (this.isListening_) return;
			this.player_.on("keydown", this.onKeyDown_);
			this.player_.on("modalKeydown", this.onKeyDown_);
			this.player_.on("loadedmetadata", () => {
				this.focus(this.updateFocusableComponents()[0]);
			});
			this.player_.on("modalclose", () => {
				this.refocusComponent();
			});
			this.player_.on("focusin", this.handlePlayerFocus_.bind(this));
			this.player_.on("focusout", this.handlePlayerBlur_.bind(this));
			this.isListening_ = true;
			if (this.player_.errorDisplay) this.player_.errorDisplay.on("aftermodalfill", () => {
				this.updateFocusableComponents();
				if (this.focusableComponents.length) if (this.focusableComponents.length > 1) this.focusableComponents[1].focus();
				else this.focusableComponents[0].focus();
			});
		}
		/**
		* Stops the spatial navigation by removing the keydown event listener from the video container.
		* Also sets the `isListening_` flag to false.
		*/
		stop() {
			this.player_.off("keydown", this.onKeyDown_);
			this.isListening_ = false;
		}
		/**
		* Responds to keydown events for spatial navigation and media control.
		*
		* Determines if spatial navigation or media control is active and handles key inputs accordingly.
		*
		* @param {KeyboardEvent} event - The keydown event to be handled.
		*/
		onKeyDown_(event) {
			const actualEvent = event.originalEvent ? event.originalEvent : event;
			if ([
				"ArrowLeft",
				"ArrowRight",
				"ArrowUp",
				"ArrowDown"
			].includes(actualEvent.key)) {
				if (this.isPaused_) return;
				actualEvent.preventDefault();
				const direction = actualEvent.key.substring(5).toLowerCase();
				this.move(direction);
			} else if (SpatialNavKeyCodes.isEventKey(actualEvent, "play") || SpatialNavKeyCodes.isEventKey(actualEvent, "pause") || SpatialNavKeyCodes.isEventKey(actualEvent, "ff") || SpatialNavKeyCodes.isEventKey(actualEvent, "rw")) {
				actualEvent.preventDefault();
				const action = SpatialNavKeyCodes.getEventName(actualEvent);
				this.performMediaAction_(action);
			} else if (SpatialNavKeyCodes.isEventKey(actualEvent, "Back") && event.target && typeof event.target.closeable === "function" && event.target.closeable()) {
				actualEvent.preventDefault();
				event.target.close();
			}
		}
		/**
		* Performs media control actions based on the given key input.
		*
		* Controls the playback and seeking functionalities of the media player.
		*
		* @param {string} key - The key representing the media action to be performed.
		*   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
		*/
		performMediaAction_(key) {
			if (this.player_) switch (key) {
				case "play":
					if (this.player_.paused()) this.player_.play();
					break;
				case "pause":
					if (!this.player_.paused()) this.player_.pause();
					break;
				case "ff":
					this.userSeek_(this.player_.currentTime() + STEP_SECONDS);
					break;
				case "rw":
					this.userSeek_(this.player_.currentTime() - STEP_SECONDS);
					break;
			}
		}
		/**
		* Prevent liveThreshold from causing seeks to seem like they
		* are not happening from a user perspective.
		*
		* @param {number} ct
		*        current time to seek to
		*/
		userSeek_(ct) {
			if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
			this.player_.currentTime(ct);
		}
		/**
		* Pauses the spatial navigation functionality.
		* This method sets a flag that can be used to temporarily disable the navigation logic.
		*/
		pause() {
			this.isPaused_ = true;
		}
		/**
		* Resumes the spatial navigation functionality if it has been paused.
		* This method resets the pause flag, re-enabling the navigation logic.
		*/
		resume() {
			this.isPaused_ = false;
		}
		/**
		* Handles Player Blur.
		*
		* @param {string|Event|Object} event
		*        The name of the event, an `Event`, or an object with a key of type set to
		*        an event name.
		*
		* Calls for handling of the Player Blur if:
		* *The next focused element is not a child of current focused element &
		* The next focused element is not a child of the Player.
		* *There is no next focused element
		*/
		handlePlayerBlur_(event) {
			const nextFocusedElement = event.relatedTarget;
			let isChildrenOfPlayer = null;
			const currentComponent = this.getCurrentComponent(event.target);
			if (nextFocusedElement) {
				isChildrenOfPlayer = Boolean(nextFocusedElement.closest(".video-js"));
				if (nextFocusedElement.classList.contains("vjs-text-track-settings") && !this.isPaused_) this.searchForTrackSelect_();
			}
			if (!event.currentTarget.contains(event.relatedTarget) && !isChildrenOfPlayer || !nextFocusedElement) if (currentComponent && currentComponent.name() === "CloseButton") this.refocusComponent();
			else {
				this.pause();
				if (currentComponent && currentComponent.el()) this.lastFocusedComponent_ = currentComponent;
			}
		}
		/**
		* Handles the Player focus event.
		*
		* Calls for handling of the Player Focus if current element is focusable.
		*/
		handlePlayerFocus_() {
			if (this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable()) this.resume();
		}
		/**
		* Gets a set of focusable components.
		*
		* @return {Array}
		*         Returns an array of focusable components.
		*/
		updateFocusableComponents() {
			const player = this.player_;
			const focusableComponents = [];
			/**
			* Searches for children candidates.
			*
			* Pushes Components to array of 'focusableComponents'.
			* Calls itself if there is children elements inside iterated component.
			*
			* @param {Array} componentsArray - The array of components to search for focusable children.
			*/
			function searchForChildrenCandidates(componentsArray) {
				for (const i of componentsArray) {
					if (i.hasOwnProperty("el_") && i.getIsFocusable() && i.getIsAvailableToBeFocused(i.el())) focusableComponents.push(i);
					if (i.hasOwnProperty("children_") && i.children_.length > 0) searchForChildrenCandidates(i.children_);
				}
			}
			player.children_.forEach((value) => {
				if (value.hasOwnProperty("el_")) {
					if (value.getIsFocusable && value.getIsAvailableToBeFocused && value.getIsFocusable() && value.getIsAvailableToBeFocused(value.el())) {
						focusableComponents.push(value);
						return;
					} else if (value.hasOwnProperty("children_") && value.children_.length > 0) searchForChildrenCandidates(value.children_);
					else if (value.hasOwnProperty("items") && value.items.length > 0) searchForChildrenCandidates(value.items);
					else if (this.findSuitableDOMChild(value)) focusableComponents.push(value);
				}
				if (value.name_ === "ErrorDisplay" && value.opened_) {
					const buttonContainer = value.el_.querySelector(".vjs-errors-ok-button-container");
					if (buttonContainer) buttonContainer.querySelectorAll("button").forEach((element, index) => {
						focusableComponents.push({
							name: () => {
								return "ModalButton" + (index + 1);
							},
							el: () => element,
							getPositions: () => {
								const rect = element.getBoundingClientRect();
								return {
									boundingClientRect: {
										x: rect.x,
										y: rect.y,
										width: rect.width,
										height: rect.height,
										top: rect.top,
										right: rect.right,
										bottom: rect.bottom,
										left: rect.left
									},
									center: {
										x: rect.left + rect.width / 2,
										y: rect.top + rect.height / 2,
										width: 0,
										height: 0,
										top: rect.top + rect.height / 2,
										right: rect.left + rect.width / 2,
										bottom: rect.top + rect.height / 2,
										left: rect.left + rect.width / 2
									}
								};
							},
							getIsAvailableToBeFocused: () => true,
							getIsFocusable: (el) => true,
							focus: () => element.focus()
						});
					});
				}
			});
			this.focusableComponents = focusableComponents;
			return this.focusableComponents;
		}
		/**
		* Finds a suitable child element within the provided component's DOM element.
		*
		* @param {Object} component - The component containing the DOM element to search within.
		* @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
		*/
		findSuitableDOMChild(component) {
			/**
			* Recursively searches for a suitable child node that can be focused within a given component.
			* It first checks if the provided node itself can be focused according to the component's
			* `getIsFocusable` and `getIsAvailableToBeFocused` methods. If not, it recursively searches
			* through the node's children to find a suitable child node that meets the focusability criteria.
			*
			* @param {HTMLElement} node - The DOM node to start the search from.
			* @return {HTMLElement|null} The first child node that is focusable and available to be focused,
			* or `null` if no suitable child is found.
			*/
			function searchForSuitableChild(node) {
				if (component.getIsFocusable(node) && component.getIsAvailableToBeFocused(node)) return node;
				for (let i = 0; i < node.children.length; i++) {
					const child = node.children[i];
					const suitableChild = searchForSuitableChild(child);
					if (suitableChild) return suitableChild;
				}
				return null;
			}
			if (component.el()) return searchForSuitableChild(component.el());
			return null;
		}
		/**
		* Gets the currently focused component from the list of focusable components.
		* If a target element is provided, it uses that element to find the corresponding
		* component. If no target is provided, it defaults to using the document's currently
		* active element.
		*
		* @param {HTMLElement} [target] - The DOM element to check against the focusable components.
		*                                 If not provided, `document.activeElement` is used.
		* @return {Component|null} - Returns the focused component if found among the focusable components,
		*                            otherwise returns null if no matching component is found.
		*/
		getCurrentComponent(target) {
			this.updateFocusableComponents();
			const curComp = target || document.activeElement;
			if (this.focusableComponents.length) {
				for (const i of this.focusableComponents) if (i.el() === curComp) return i;
			}
		}
		/**
		* Adds a component to the array of focusable components.
		*
		* @param {Component} component
		*        The `Component` to be added.
		*/
		add(component) {
			const focusableComponents = [...this.focusableComponents];
			if (component.hasOwnProperty("el_") && component.getIsFocusable() && component.getIsAvailableToBeFocused(component.el())) focusableComponents.push(component);
			this.focusableComponents = focusableComponents;
			this.trigger({
				type: "focusableComponentsChanged",
				focusableComponents: this.focusableComponents
			});
		}
		/**
		* Removes component from the array of focusable components.
		*
		* @param {Component} component - The component to be removed from the focusable components array.
		*/
		remove(component) {
			for (let i = 0; i < this.focusableComponents.length; i++) if (this.focusableComponents[i].name() === component.name()) {
				this.focusableComponents.splice(i, 1);
				this.trigger({
					type: "focusableComponentsChanged",
					focusableComponents: this.focusableComponents
				});
				return;
			}
		}
		/**
		* Clears array of focusable components.
		*/
		clear() {
			if (this.focusableComponents.length > 0) {
				this.focusableComponents = [];
				this.trigger({
					type: "focusableComponentsChanged",
					focusableComponents: this.focusableComponents
				});
			}
		}
		/**
		* Navigates to the next focusable component based on the specified direction.
		*
		* @param {string} direction 'up', 'down', 'left', 'right'
		*/
		move(direction) {
			const currentFocusedComponent = this.getCurrentComponent();
			if (!currentFocusedComponent) return;
			const currentPositions = currentFocusedComponent.getPositions();
			const candidates = this.focusableComponents.filter((component) => component !== currentFocusedComponent && this.isInDirection_(currentPositions.boundingClientRect, component.getPositions().boundingClientRect, direction));
			const bestCandidate = this.findBestCandidate_(currentPositions.center, candidates, direction);
			if (bestCandidate) this.focus(bestCandidate);
			else this.trigger({
				type: "endOfFocusableComponents",
				direction,
				focusedComponent: currentFocusedComponent
			});
		}
		/**
		* Finds the best candidate on the current center position,
		* the list of candidates, and the specified navigation direction.
		*
		* @param {Object} currentCenter The center position of the current focused component element.
		* @param {Array} candidates An array of candidate components to receive focus.
		* @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
		* @return {Object|null} The component that is the best candidate for receiving focus.
		*/
		findBestCandidate_(currentCenter, candidates, direction) {
			let minDistance = Infinity;
			let bestCandidate = null;
			for (const candidate of candidates) {
				const candidateCenter = candidate.getPositions().center;
				const distance = this.calculateDistance_(currentCenter, candidateCenter, direction);
				if (distance < minDistance) {
					minDistance = distance;
					bestCandidate = candidate;
				}
			}
			return bestCandidate;
		}
		/**
		* Determines if a target rectangle is in the specified navigation direction
		* relative to a source rectangle.
		*
		* @param {Object} srcRect The bounding rectangle of the source element.
		* @param {Object} targetRect The bounding rectangle of the target element.
		* @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
		* @return {boolean} True if the target is in the specified direction relative to the source.
		*/
		isInDirection_(srcRect, targetRect, direction) {
			switch (direction) {
				case "right": return targetRect.left >= srcRect.right;
				case "left": return targetRect.right <= srcRect.left;
				case "down": return targetRect.top >= srcRect.bottom;
				case "up": return targetRect.bottom <= srcRect.top;
				default: return false;
			}
		}
		/**
		* Focus the last focused component saved before blur on player.
		*/
		refocusComponent() {
			if (this.lastFocusedComponent_) {
				if (!this.player_.userActive()) this.player_.userActive(true);
				this.updateFocusableComponents();
				for (let i = 0; i < this.focusableComponents.length; i++) if (this.focusableComponents[i].name() === this.lastFocusedComponent_.name()) {
					this.focus(this.focusableComponents[i]);
					return;
				}
			} else this.focus(this.updateFocusableComponents()[0]);
		}
		/**
		* Focuses on a given component.
		* If the component is available to be focused, it focuses on the component.
		* If not, it attempts to find a suitable DOM child within the component and focuses on it.
		*
		* @param {Component} component - The component to be focused.
		*/
		focus(component) {
			if (typeof component !== "object") return;
			if (component.getIsAvailableToBeFocused(component.el())) component.focus();
			else if (this.findSuitableDOMChild(component)) this.findSuitableDOMChild(component).focus();
		}
		/**
		* Calculates the distance between two points, adjusting the calculation based on
		* the specified navigation direction.
		*
		* @param {Object} center1 The center point of the first element.
		* @param {Object} center2 The center point of the second element.
		* @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
		* @return {number} The calculated distance between the two centers.
		*/
		calculateDistance_(center1, center2, direction) {
			const dx = Math.abs(center1.x - center2.x);
			const dy = Math.abs(center1.y - center2.y);
			let distance;
			switch (direction) {
				case "right":
				case "left":
					distance = dx + dy * 100;
					break;
				case "up":
					distance = dy * 2 + dx * .5;
					break;
				case "down":
					distance = dy * 5 + dx;
					break;
				default: distance = dx + dy;
			}
			return distance;
		}
		/**
		* This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
		* Searches for the first 'TextTrackSelect' inside of modal to focus.
		*
		* @private
		*/
		searchForTrackSelect_() {
			const spatialNavigation = this;
			for (const component of spatialNavigation.updateFocusableComponents()) if (component.constructor.name === "TextTrackSelect") {
				spatialNavigation.focus(component);
				break;
			}
		}
	};
	/**
	* @file loader.js
	*/
	/** @import Player from '../player' */
	/**
	* The `MediaLoader` is the `Component` that decides which playback technology to load
	* when a player is initialized.
	*
	* @extends Component
	*/
	var MediaLoader = class extends Component {
		/**
		* Create an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should attach to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function that is run when this component is ready.
		*/
		constructor(player, options, ready) {
			const options_ = merge({ createEl: false }, options);
			super(player, options_, ready);
			if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) for (let i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
				const techName = toTitleCase(j[i]);
				let tech = Tech.getTech(techName);
				if (!techName) tech = Component.getComponent(techName);
				if (tech && tech.isSupported()) {
					player.loadTech_(techName);
					break;
				}
			}
			else player.src(options.playerOptions.sources);
		}
	};
	Component.registerComponent("MediaLoader", MediaLoader);
	/**
	* @file clickable-component.js
	*/
	/** @import Player from './player' */
	/**
	* Component which is clickable or keyboard actionable, but is not a
	* native HTML button.
	*
	* @extends Component
	*/
	var ClickableComponent = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param  {Player} player
		*         The `Player` that this class should be attached to.
		*
		* @param  {Object} [options]
		*         The key/value store of component options.
		*
		* @param  {function} [options.clickHandler]
		*         The function to call when the button is clicked / activated
		*
		* @param  {string} [options.controlText]
		*         The text to set on the button
		*
		* @param  {string} [options.className]
		*         A class or space separated list of classes to add the component
		*
		*/
		constructor(player, options) {
			super(player, options);
			if (this.options_.controlText) this.controlText(this.options_.controlText);
			this.handleMouseOver_ = (e) => this.handleMouseOver(e);
			this.handleMouseOut_ = (e) => this.handleMouseOut(e);
			this.handleClick_ = (e) => this.handleClick(e);
			this.handleKeyDown_ = (e) => this.handleKeyDown(e);
			this.emitTapEvents();
			this.enable();
		}
		/**
		* Create the `ClickableComponent`s DOM element.
		*
		* @param {string} [tag=div]
		*        The element's node type.
		*
		* @param {Object} [props={}]
		*        An object of properties that should be set on the element.
		*
		* @param {Object} [attributes={}]
		*        An object of attributes that should be set on the element.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl(tag = "div", props = {}, attributes = {}) {
			props = Object.assign({
				className: this.buildCSSClass(),
				tabIndex: 0
			}, props);
			if (tag === "button") log.error(`Creating a ClickableComponent with an HTML element of ${tag} is not supported; use a Button instead.`);
			attributes = Object.assign({ role: "button" }, attributes);
			this.tabIndex_ = props.tabIndex;
			const el = createEl(tag, props, attributes);
			if (!this.player_.options_.experimentalSvgIcons) el.appendChild(createEl("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": true }));
			this.createControlTextEl(el);
			return el;
		}
		dispose() {
			this.controlTextEl_ = null;
			super.dispose();
		}
		/**
		* Create a control text element on this `ClickableComponent`
		*
		* @param {Element} [el]
		*        Parent element for the control text.
		*
		* @return {Element}
		*         The control text element that gets created.
		*/
		createControlTextEl(el) {
			this.controlTextEl_ = createEl("span", { className: "vjs-control-text" }, { "aria-live": "polite" });
			if (el) el.appendChild(this.controlTextEl_);
			this.controlText(this.controlText_, el);
			return this.controlTextEl_;
		}
		/**
		* Get or set the localize text to use for the controls on the `ClickableComponent`.
		*
		* @param {string} [text]
		*        Control text for element.
		*
		* @param {Element} [el=this.el()]
		*        Element to set the title on.
		*
		* @return {string}
		*         - The control text when getting
		*/
		controlText(text, el = this.el()) {
			if (text === void 0) return this.controlText_ || "Need Text";
			const localizedText = this.localize(text);
			/** @protected */
			this.controlText_ = text;
			textContent(this.controlTextEl_, localizedText);
			if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) el.setAttribute("title", localizedText);
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-control vjs-button ${super.buildCSSClass()}`;
		}
		/**
		* Enable this `ClickableComponent`
		*/
		enable() {
			if (!this.enabled_) {
				this.enabled_ = true;
				this.removeClass("vjs-disabled");
				this.el_.setAttribute("aria-disabled", "false");
				if (typeof this.tabIndex_ !== "undefined") this.el_.setAttribute("tabIndex", this.tabIndex_);
				this.on(["tap", "click"], this.handleClick_);
				this.on("keydown", this.handleKeyDown_);
			}
		}
		/**
		* Disable this `ClickableComponent`
		*/
		disable() {
			this.enabled_ = false;
			this.addClass("vjs-disabled");
			this.el_.setAttribute("aria-disabled", "true");
			if (typeof this.tabIndex_ !== "undefined") this.el_.removeAttribute("tabIndex");
			this.off("mouseover", this.handleMouseOver_);
			this.off("mouseout", this.handleMouseOut_);
			this.off(["tap", "click"], this.handleClick_);
			this.off("keydown", this.handleKeyDown_);
		}
		/**
		* Handles language change in ClickableComponent for the player in components
		*
		*
		*/
		handleLanguagechange() {
			this.controlText(this.controlText_);
		}
		/**
		* Event handler that is called when a `ClickableComponent` receives a
		* `click` or `tap` event.
		*
		* @param {Event} event
		*        The `tap` or `click` event that caused this function to be called.
		*
		* @listens tap
		* @listens click
		* @abstract
		*/
		handleClick(event) {
			if (this.options_.clickHandler) this.options_.clickHandler.call(this, arguments);
		}
		/**
		* Event handler that is called when a `ClickableComponent` receives a
		* `keydown` event.
		*
		* By default, if the key is Space or Enter, it will trigger a `click` event.
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (event.key === " " || event.key === "Enter") {
				event.preventDefault();
				event.stopPropagation();
				this.trigger("click");
			} else super.handleKeyDown(event);
		}
	};
	Component.registerComponent("ClickableComponent", ClickableComponent);
	/**
	* @file poster-image.js
	*/
	/** @import Player from './player' */
	/**
	* A `ClickableComponent` that handles showing the poster image for the player.
	*
	* @extends ClickableComponent
	*/
	var PosterImage = class extends ClickableComponent {
		/**
		* Create an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should attach to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.update();
			this.update_ = (e) => this.update(e);
			player.on("posterchange", this.update_);
		}
		/**
		* Clean up and dispose of the `PosterImage`.
		*/
		dispose() {
			this.player().off("posterchange", this.update_);
			super.dispose();
		}
		/**
		* Create the `PosterImage`s DOM element.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl() {
			return createEl("div", { className: "vjs-poster" });
		}
		/**
		* Get or set the `PosterImage`'s crossOrigin option.
		*
		* @param {string|null} [value]
		*        The value to set the crossOrigin to. If an argument is
		*        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
		*
		* @return {string|null}
		*         - The current crossOrigin value of the `Player` when getting.
		*         - undefined when setting
		*/
		crossOrigin(value) {
			if (typeof value === "undefined") {
				if (this.$("img")) return this.$("img").crossOrigin;
				else if (this.player_.tech_ && this.player_.tech_.isReady_) return this.player_.crossOrigin();
				return this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
			}
			if (value !== null && value !== "anonymous" && value !== "use-credentials") {
				this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
				return;
			}
			if (this.$("img")) this.$("img").crossOrigin = value;
		}
		/**
		* An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
		*
		* @listens Player#posterchange
		*
		* @param {Event} [event]
		*        The `Player#posterchange` event that triggered this function.
		*/
		update(event) {
			const url = this.player().poster();
			this.setSrc(url);
			if (url) this.show();
			else this.hide();
		}
		/**
		* Set the source of the `PosterImage` depending on the display method. (Re)creates
		* the inner picture and img elementss when needed.
		*
		* @param {string} [url]
		*        The URL to the source for the `PosterImage`. If not specified or falsy,
		*        any source and ant inner picture/img are removed.
		*/
		setSrc(url) {
			if (!url) {
				this.el_.textContent = "";
				return;
			}
			if (!this.$("img")) this.el_.appendChild(createEl("picture", {
				className: "vjs-poster",
				tabIndex: -1
			}, {}, createEl("img", {
				loading: "lazy",
				crossOrigin: this.crossOrigin()
			}, { alt: "" })));
			this.$("img").src = url;
		}
		/**
		* An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
		* {@link ClickableComponent#handleClick} for instances where this will be triggered.
		*
		* @listens tap
		* @listens click
		* @listens keydown
		*
		* @param {Event} event
		+        The `click`, `tap` or `keydown` event that caused this function to be called.
		*/
		handleClick(event) {
			if (!this.player_.controls()) return;
			if (this.player_.tech(true)) this.player_.tech(true).focus();
			if (this.player_.paused()) silencePromise(this.player_.play());
			else this.player_.pause();
		}
	};
	/**
	* Get or set the `PosterImage`'s crossorigin option. For the HTML5 player, this
	* sets the `crossOrigin` property on the `<img>` tag to control the CORS
	* behavior.
	*
	* @param {string|null} [value]
	*        The value to set the `PosterImages`'s crossorigin to. If an argument is
	*        given, must be one of `anonymous` or `use-credentials`.
	*
	* @return {string|null|undefined}
	*         - The current crossorigin value of the `Player` when getting.
	*         - undefined when setting
	*/
	PosterImage.prototype.crossorigin = PosterImage.prototype.crossOrigin;
	Component.registerComponent("PosterImage", PosterImage);
	/**
	* @file text-track-display.js
	*/
	/** @import Player from '../player' */
	var darkGray = "#222";
	var lightGray = "#ccc";
	var fontMap = {
		monospace: "monospace",
		sansSerif: "sans-serif",
		serif: "serif",
		monospaceSansSerif: "\"Andale Mono\", \"Lucida Console\", monospace",
		monospaceSerif: "\"Courier New\", monospace",
		proportionalSansSerif: "sans-serif",
		proportionalSerif: "serif",
		casual: "\"Comic Sans MS\", Impact, fantasy",
		script: "\"Monotype Corsiva\", cursive",
		smallcaps: "\"Andale Mono\", \"Lucida Console\", monospace, sans-serif"
	};
	/**
	* Construct an rgba color from a given hex color code.
	*
	* @param {number} color
	*        Hex number for color, like #f0e or #f604e2.
	*
	* @param {number} opacity
	*        Value for opacity, 0.0 - 1.0.
	*
	* @return {string}
	*         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	*/
	function constructColor(color, opacity) {
		let hex;
		if (color.length === 4) hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
		else if (color.length === 7) hex = color.slice(1);
		else throw new Error("Invalid color code provided, " + color + "; must be formatted as e.g. #f0e or #f604e2.");
		return "rgba(" + parseInt(hex.slice(0, 2), 16) + "," + parseInt(hex.slice(2, 4), 16) + "," + parseInt(hex.slice(4, 6), 16) + "," + opacity + ")";
	}
	/**
	* Try to update the style of a DOM element. Some style changes will throw an error,
	* particularly in IE8. Those should be noops.
	*
	* @param {Element} el
	*        The DOM element to be styled.
	*
	* @param {string} style
	*        The CSS property on the element that should be styled.
	*
	* @param {string} rule
	*        The style rule that should be applied to the property.
	*
	* @private
	*/
	function tryUpdateStyle(el, style, rule) {
		try {
			el.style[style] = rule;
		} catch (e) {
			return;
		}
	}
	/**
	* Converts the CSS top/right/bottom/left property numeric value to string in pixels.
	*
	* @param {number} position
	*        The CSS top/right/bottom/left property value.
	*
	* @return {string}
	*          The CSS property value that was created, like '10px'.
	*
	* @private
	*/
	function getCSSPositionValue(position) {
		return position ? `${position}px` : "";
	}
	/**
	* The component for displaying text track cues.
	*
	* @extends Component
	*/
	var TextTrackDisplay = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when `TextTrackDisplay` is ready.
		*/
		constructor(player, options, ready) {
			super(player, options, ready);
			const updateDisplayTextHandler = (e) => this.updateDisplay(e);
			const updateDisplayHandler = (e) => {
				this.updateDisplayOverlay();
				this.updateDisplay(e);
			};
			player.on("loadstart", (e) => this.toggleDisplay(e));
			player.on("useractive", updateDisplayTextHandler);
			player.on("userinactive", updateDisplayTextHandler);
			player.on("texttrackchange", updateDisplayTextHandler);
			player.on("loadedmetadata", (e) => {
				this.updateDisplayOverlay();
				this.preselectTrack(e);
			});
			player.ready(bind_(this, function() {
				if (player.tech_ && player.tech_.featuresNativeTextTracks) {
					this.hide();
					return;
				}
				player.on("fullscreenchange", updateDisplayHandler);
				player.on("playerresize", updateDisplayHandler);
				const screenOrientation = window__default["default"].screen.orientation || window__default["default"];
				const changeOrientationEvent = window__default["default"].screen.orientation ? "change" : "orientationchange";
				screenOrientation.addEventListener(changeOrientationEvent, updateDisplayHandler);
				player.on("dispose", () => screenOrientation.removeEventListener(changeOrientationEvent, updateDisplayHandler));
				const tracks = this.options_.playerOptions.tracks || [];
				for (let i = 0; i < tracks.length; i++) this.player_.addRemoteTextTrack(tracks[i], true);
				this.preselectTrack();
			}));
		}
		/**
		* Preselect a track following this precedence:
		* - matches the previously selected {@link TextTrack}'s language and kind
		* - matches the previously selected {@link TextTrack}'s language only
		* - is the first default captions track
		* - is the first default descriptions track
		*
		* @listens Player#loadstart
		*/
		preselectTrack() {
			const modes = {
				captions: 1,
				subtitles: 1
			};
			const trackList = this.player_.textTracks();
			const userPref = this.player_.cache_.selectedLanguage;
			let firstDesc;
			let firstCaptions;
			let preferredTrack;
			for (let i = 0; i < trackList.length; i++) {
				const track = trackList[i];
				if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
					if (track.kind === userPref.kind) preferredTrack = track;
					else if (!preferredTrack) preferredTrack = track;
				} else if (userPref && !userPref.enabled) {
					preferredTrack = null;
					firstDesc = null;
					firstCaptions = null;
				} else if (track.default) {
					if (track.kind === "descriptions" && !firstDesc) firstDesc = track;
					else if (track.kind in modes && !firstCaptions) firstCaptions = track;
				}
			}
			if (preferredTrack) preferredTrack.mode = "showing";
			else if (firstCaptions) firstCaptions.mode = "showing";
			else if (firstDesc) firstDesc.mode = "showing";
		}
		/**
		* Turn display of {@link TextTrack}'s from the current state into the other state.
		* There are only two states:
		* - 'shown'
		* - 'hidden'
		*
		* @listens Player#loadstart
		*/
		toggleDisplay() {
			if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) this.hide();
			else this.show();
		}
		/**
		* Create the {@link Component}'s DOM element.
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-text-track-display" }, {
				"translate": "yes",
				"aria-live": "off",
				"aria-atomic": "true"
			});
		}
		/**
		* Clear all displayed {@link TextTrack}s.
		*/
		clearDisplay() {
			if (typeof window__default["default"].WebVTT === "function") window__default["default"].WebVTT.processCues(window__default["default"], [], this.el_);
		}
		/**
		* Update the displayed {@link TextTrack} when either a {@link Player#texttrackchange},
		* a {@link Player#fullscreenchange}, a {@link Player#useractive}, or a
		* {@link Player#userinactive} is fired.
		*
		* @listens Player#texttrackchange
		* @listens Player#fullscreenchange
		* @listens Player#useractive
		* @listens Player#userinactive
		*/
		updateDisplay() {
			const tracks = this.player_.textTracks();
			const allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
			this.clearDisplay();
			if (allowMultipleShowingTracks) {
				const showingTracks = [];
				for (let i = 0; i < tracks.length; ++i) {
					const track = tracks[i];
					if (track.mode !== "showing") continue;
					showingTracks.push(track);
				}
				this.updateForTrack(showingTracks);
				return;
			}
			let descriptionsTrack = null;
			let captionsSubtitlesTrack = null;
			let i = tracks.length;
			while (i--) {
				const track = tracks[i];
				if (track.mode === "showing") if (track.kind === "descriptions") descriptionsTrack = track;
				else captionsSubtitlesTrack = track;
			}
			if (captionsSubtitlesTrack) {
				if (this.getAttribute("aria-live") !== "off") this.setAttribute("aria-live", "off");
				this.updateForTrack(captionsSubtitlesTrack);
			} else if (descriptionsTrack) {
				if (this.getAttribute("aria-live") !== "assertive") this.setAttribute("aria-live", "assertive");
				this.updateForTrack(descriptionsTrack);
			}
			if (!(window__default["default"].CSS !== void 0 && window__default["default"].CSS.supports("inset", "10px"))) {
				const textTrackDisplay = this.el_;
				const vjsTextTrackCues = textTrackDisplay.querySelectorAll(".vjs-text-track-cue");
				const controlBarHeight = this.player_.controlBar.el_.getBoundingClientRect().height;
				const playerHeight = this.player_.el_.getBoundingClientRect().height;
				textTrackDisplay.style = "";
				tryUpdateStyle(textTrackDisplay, "position", "relative");
				tryUpdateStyle(textTrackDisplay, "height", playerHeight - controlBarHeight + "px");
				tryUpdateStyle(textTrackDisplay, "top", "unset");
				if (IS_SMART_TV) tryUpdateStyle(textTrackDisplay, "bottom", playerHeight + "px");
				else tryUpdateStyle(textTrackDisplay, "bottom", "0px");
				if (vjsTextTrackCues.length > 0) vjsTextTrackCues.forEach((vjsTextTrackCue) => {
					if (vjsTextTrackCue.style.inset) {
						const insetStyles = vjsTextTrackCue.style.inset.split(" ");
						if (insetStyles.length === 3) Object.assign(vjsTextTrackCue.style, {
							top: insetStyles[0],
							right: insetStyles[1],
							bottom: insetStyles[2],
							left: "unset"
						});
					}
				});
			}
		}
		/**
		* Updates the displayed TextTrack to be sure it overlays the video when a either
		* a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
		*/
		updateDisplayOverlay() {
			if (!this.player_.videoHeight() || !(window__default["default"].CSS !== void 0 && window__default["default"].CSS.supports("inset-inline: 10px"))) return;
			const playerWidth = this.player_.currentWidth();
			const playerHeight = this.player_.currentHeight();
			const playerAspectRatio = playerWidth / playerHeight;
			const videoAspectRatio = this.player_.videoWidth() / this.player_.videoHeight();
			let insetInlineMatch = 0;
			let insetBlockMatch = 0;
			if (Math.abs(playerAspectRatio - videoAspectRatio) > .1) if (playerAspectRatio > videoAspectRatio) insetInlineMatch = Math.round((playerWidth - playerHeight * videoAspectRatio) / 2);
			else insetBlockMatch = Math.round((playerHeight - playerWidth / videoAspectRatio) / 2);
			tryUpdateStyle(this.el_, "insetInline", getCSSPositionValue(insetInlineMatch));
			tryUpdateStyle(this.el_, "insetBlock", getCSSPositionValue(insetBlockMatch));
		}
		/**
		* Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
		*
		* @param {TextTrack} track
		*        Text track object containing active cues to style.
		*/
		updateDisplayState(track) {
			const overrides = this.player_.textTrackSettings.getValues();
			const cues = track.activeCues;
			let i = cues.length;
			while (i--) {
				const cue = cues[i];
				if (!cue) continue;
				const cueDiv = cue.displayState;
				if (overrides.color) cueDiv.firstChild.style.color = overrides.color;
				if (overrides.textOpacity) tryUpdateStyle(cueDiv.firstChild, "color", constructColor(overrides.color || "#fff", overrides.textOpacity));
				if (overrides.backgroundColor) cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
				if (overrides.backgroundOpacity) tryUpdateStyle(cueDiv.firstChild, "backgroundColor", constructColor(overrides.backgroundColor || "#000", overrides.backgroundOpacity));
				if (overrides.windowColor) if (overrides.windowOpacity) tryUpdateStyle(cueDiv, "backgroundColor", constructColor(overrides.windowColor, overrides.windowOpacity));
				else cueDiv.style.backgroundColor = overrides.windowColor;
				if (overrides.edgeStyle) {
					if (overrides.edgeStyle === "dropshadow") cueDiv.firstChild.style.textShadow = `2px 2px 3px ${darkGray}, 2px 2px 4px ${darkGray}, 2px 2px 5px ${darkGray}`;
					else if (overrides.edgeStyle === "raised") cueDiv.firstChild.style.textShadow = `1px 1px ${darkGray}, 2px 2px ${darkGray}, 3px 3px ${darkGray}`;
					else if (overrides.edgeStyle === "depressed") cueDiv.firstChild.style.textShadow = `1px 1px ${lightGray}, 0 1px ${lightGray}, -1px -1px ${darkGray}, 0 -1px ${darkGray}`;
					else if (overrides.edgeStyle === "uniform") cueDiv.firstChild.style.textShadow = `0 0 4px ${darkGray}, 0 0 4px ${darkGray}, 0 0 4px ${darkGray}, 0 0 4px ${darkGray}`;
				}
				if (overrides.fontPercent && overrides.fontPercent !== 1) {
					const fontSize = window__default["default"].parseFloat(cueDiv.style.fontSize);
					cueDiv.style.fontSize = fontSize * overrides.fontPercent + "px";
					cueDiv.style.height = "auto";
					cueDiv.style.top = "auto";
				}
				if (overrides.fontFamily && overrides.fontFamily !== "default") if (overrides.fontFamily === "small-caps") cueDiv.firstChild.style.fontVariant = "small-caps";
				else cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
			}
		}
		/**
		* Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
		*
		* @param {TextTrack|TextTrack[]} tracks
		*        Text track object or text track array to be added to the list.
		*/
		updateForTrack(tracks) {
			if (!Array.isArray(tracks)) tracks = [tracks];
			if (typeof window__default["default"].WebVTT !== "function" || tracks.every((track) => {
				return !track.activeCues;
			})) return;
			const cues = [];
			for (let i = 0; i < tracks.length; ++i) {
				const track = tracks[i];
				for (let j = 0; j < track.activeCues.length; ++j) cues.push(track.activeCues[j]);
			}
			window__default["default"].WebVTT.processCues(window__default["default"], cues, this.el_);
			for (let i = 0; i < tracks.length; ++i) {
				const track = tracks[i];
				for (let j = 0; j < track.activeCues.length; ++j) {
					const cueEl = track.activeCues[j].displayState;
					addClass(cueEl, "vjs-text-track-cue", "vjs-text-track-cue-" + (track.language ? track.language : i));
					if (track.language) setAttribute(cueEl, "lang", track.language);
				}
				if (this.player_.textTrackSettings) this.updateDisplayState(track);
			}
		}
	};
	Component.registerComponent("TextTrackDisplay", TextTrackDisplay);
	/**
	* @file loading-spinner.js
	*/
	/**
	* A loading spinner for use during waiting/loading events.
	*
	* @extends Component
	*/
	var LoadingSpinner = class extends Component {
		/**
		* Create the `LoadingSpinner`s DOM element.
		*
		* @return {Element}
		*         The dom element that gets created.
		*/
		createEl() {
			const isAudio = this.player_.isAudio();
			const playerType = this.localize(isAudio ? "Audio Player" : "Video Player");
			const controlText = createEl("span", {
				className: "vjs-control-text",
				textContent: this.localize("{1} is loading.", [playerType])
			});
			const el = super.createEl("div", {
				className: "vjs-loading-spinner",
				dir: "ltr"
			});
			el.appendChild(controlText);
			return el;
		}
		/**
		* Update control text on languagechange
		*/
		handleLanguagechange() {
			this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
		}
	};
	Component.registerComponent("LoadingSpinner", LoadingSpinner);
	/**
	* @file button.js
	*/
	/**
	* Base class for all buttons.
	*
	* @extends ClickableComponent
	*/
	var Button = class extends ClickableComponent {
		/**
		* Create the `Button`s DOM element.
		*
		* @param {string} [tag="button"]
		*        The element's node type. This argument is IGNORED: no matter what
		*        is passed, it will always create a `button` element.
		*
		* @param {Object} [props={}]
		*        An object of properties that should be set on the element.
		*
		* @param {Object} [attributes={}]
		*        An object of attributes that should be set on the element.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl(tag, props = {}, attributes = {}) {
			tag = "button";
			props = Object.assign({ className: this.buildCSSClass() }, props);
			attributes = Object.assign({ type: "button" }, attributes);
			const el = createEl(tag, props, attributes);
			if (!this.player_.options_.experimentalSvgIcons) el.appendChild(createEl("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": true }));
			this.createControlTextEl(el);
			return el;
		}
		/**
		* Add a child `Component` inside of this `Button`.
		*
		* @param {string|Component} child
		*        The name or instance of a child to add.
		*
		* @param {Object} [options={}]
		*        The key/value store of options that will get passed to children of
		*        the child.
		*
		* @return {Component}
		*         The `Component` that gets added as a child. When using a string the
		*         `Component` will get created by this process.
		*
		* @deprecated since version 5
		*/
		addChild(child, options = {}) {
			const className = this.constructor.name;
			log.warn(`Adding an actionable (user controllable) child to a Button (${className}) is not supported; use a ClickableComponent instead.`);
			return Component.prototype.addChild.call(this, child, options);
		}
		/**
		* Enable the `Button` element so that it can be activated or clicked. Use this with
		* {@link Button#disable}.
		*/
		enable() {
			super.enable();
			this.el_.removeAttribute("disabled");
		}
		/**
		* Disable the `Button` element so that it cannot be activated or clicked. Use this with
		* {@link Button#enable}.
		*/
		disable() {
			super.disable();
			this.el_.setAttribute("disabled", "disabled");
		}
		/**
		* This gets called when a `Button` has focus and `keydown` is triggered via a key
		* press.
		*
		* @param {KeyboardEvent} event
		*        The event that caused this function to get called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (event.key === " " || event.key === "Enter") {
				event.stopPropagation();
				return;
			}
			super.handleKeyDown(event);
		}
	};
	Component.registerComponent("Button", Button);
	/**
	* @file big-play-button.js
	*/
	/**
	* The initial play button that shows before the video has played. The hiding of the
	* `BigPlayButton` get done via CSS and `Player` states.
	*
	* @extends Button
	*/
	var BigPlayButton = class extends Button {
		constructor(player, options) {
			super(player, options);
			this.mouseused_ = false;
			this.setIcon("play");
			this.on("mousedown", (e) => this.handleMouseDown(e));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
		*/
		buildCSSClass() {
			return "vjs-big-play-button";
		}
		/**
		* This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
		* for more detailed information on what a click can be.
		*
		* @param {KeyboardEvent|MouseEvent|TouchEvent} event
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			const playPromise = this.player_.play();
			if (event.type === "tap" || this.mouseused_ && "clientX" in event && "clientY" in event) {
				silencePromise(playPromise);
				if (this.player_.tech(true)) this.player_.tech(true).focus();
				return;
			}
			const cb = this.player_.getChild("controlBar");
			const playToggle = cb && cb.getChild("playToggle");
			if (!playToggle) {
				this.player_.tech(true).focus();
				return;
			}
			const playFocus = () => playToggle.focus();
			if (isPromise(playPromise)) playPromise.then(playFocus, () => {});
			else this.setTimeout(playFocus, 1);
		}
		/**
		* Event handler that is called when a `BigPlayButton` receives a
		* `keydown` event.
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			this.mouseused_ = false;
			super.handleKeyDown(event);
		}
		/**
		* Handle `mousedown` events on the `BigPlayButton`.
		*
		* @param {MouseEvent} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousedown
		*/
		handleMouseDown(event) {
			this.mouseused_ = true;
		}
	};
	/**
	* The text that should display over the `BigPlayButton`s controls. Added to for localization.
	*
	* @type {string}
	* @protected
	*/
	BigPlayButton.prototype.controlText_ = "Play Video";
	Component.registerComponent("BigPlayButton", BigPlayButton);
	/**
	* @file close-button.js
	*/
	/** @import Player from './player' */
	/**
	* The `CloseButton` is a `{@link Button}` that fires a `close` event when
	* it gets clicked.
	*
	* @extends Button
	*/
	var CloseButton = class extends Button {
		/**
		* Creates an instance of the this class.
		*
		* @param  {Player} player
		*         The `Player` that this class should be attached to.
		*
		* @param  {Object} [options]
		*         The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.setIcon("cancel");
			this.controlText(options && options.controlText || this.localize("Close"));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-close-button ${super.buildCSSClass()}`;
		}
		/**
		* This gets called when a `CloseButton` gets clicked. See
		* {@link ClickableComponent#handleClick} for more information on when
		* this will be triggered
		*
		* @param {Event} event
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		* @fires CloseButton#close
		*/
		handleClick(event) {
			/**
			* Triggered when the a `CloseButton` is clicked.
			*
			* @event CloseButton#close
			* @type {Event}
			*
			* @property {boolean} [bubbles=false]
			*           set to false so that the close event does not
			*           bubble up to parents if there is no listener
			*/
			this.trigger({
				type: "close",
				bubbles: false
			});
		}
		/**
		* Event handler that is called when a `CloseButton` receives a
		* `keydown` event.
		*
		* By default, if the key is Esc, it will trigger a `click` event.
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (event.key === "Escape") {
				event.preventDefault();
				event.stopPropagation();
				this.trigger("click");
			} else super.handleKeyDown(event);
		}
	};
	Component.registerComponent("CloseButton", CloseButton);
	/**
	* @file play-toggle.js
	*/
	/** @import Player from './player' */
	/**
	* Button to toggle between play and pause.
	*
	* @extends Button
	*/
	var PlayToggle = class extends Button {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			super(player, options);
			options.replay = options.replay === void 0 || options.replay;
			this.setIcon("play");
			this.on(player, "play", (e) => this.handlePlay(e));
			this.on(player, "pause", (e) => this.handlePause(e));
			if (options.replay) this.on(player, "ended", (e) => this.handleEnded(e));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-play-control ${super.buildCSSClass()}`;
		}
		/**
		* This gets called when an `PlayToggle` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			if (this.player_.paused()) silencePromise(this.player_.play());
			else this.player_.pause();
		}
		/**
		* This gets called once after the video has ended and the user seeks so that
		* we can change the replay button back to a play button.
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#seeked
		*/
		handleSeeked(event) {
			this.removeClass("vjs-ended");
			if (this.player_.paused()) this.handlePause(event);
			else this.handlePlay(event);
		}
		/**
		* Add the vjs-playing class to the element so it can change appearance.
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#play
		*/
		handlePlay(event) {
			this.removeClass("vjs-ended", "vjs-paused");
			this.addClass("vjs-playing");
			this.setIcon("pause");
			this.controlText("Pause");
		}
		/**
		* Add the vjs-paused class to the element so it can change appearance.
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#pause
		*/
		handlePause(event) {
			this.removeClass("vjs-playing");
			this.addClass("vjs-paused");
			this.setIcon("play");
			this.controlText("Play");
		}
		/**
		* Add the vjs-ended class to the element so it can change appearance
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#ended
		*/
		handleEnded(event) {
			this.removeClass("vjs-playing");
			this.addClass("vjs-ended");
			this.setIcon("replay");
			this.controlText("Replay");
			this.one(this.player_, "seeked", (e) => this.handleSeeked(e));
		}
	};
	/**
	* The text that should display over the `PlayToggle`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	PlayToggle.prototype.controlText_ = "Play";
	Component.registerComponent("PlayToggle", PlayToggle);
	/**
	* @file time-display.js
	*/
	/** @import Player from '../../player' */
	/**
	* Displays time information about the video
	*
	* @extends Component
	*/
	var TimeDisplay = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.on(player, [
				"timeupdate",
				"ended",
				"seeking"
			], (e) => this.update(e));
			this.updateTextNode_();
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const className = this.buildCSSClass();
			const el = super.createEl("div", { className: `${className} vjs-time-control vjs-control` });
			const span = createEl("span", {
				className: "vjs-control-text",
				textContent: `${this.localize(this.labelText_)}\u00a0`
			}, { role: "presentation" });
			el.appendChild(span);
			this.contentEl_ = createEl("span", { className: `${className}-display` }, { role: "presentation" });
			el.appendChild(this.contentEl_);
			return el;
		}
		dispose() {
			this.contentEl_ = null;
			this.textNode_ = null;
			super.dispose();
		}
		/**
		* Updates the displayed time according to the `updateContent` function which is defined in the child class.
		*
		* @param {Event} [event]
		*          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
		*/
		update(event) {
			if (!this.player_.options_.enableSmoothSeeking && event.type === "seeking") return;
			this.updateContent(event);
		}
		/**
		* Updates the time display text node with a new time
		*
		* @param {number} [time=0] the time to update to
		*
		* @private
		*/
		updateTextNode_(time = 0) {
			time = formatTime(time);
			if (this.formattedTime_ === time) return;
			this.formattedTime_ = time;
			this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
				if (!this.contentEl_) return;
				let oldNode = this.textNode_;
				if (oldNode && this.contentEl_.firstChild !== oldNode) {
					oldNode = null;
					log.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.");
				}
				this.textNode_ = document__default["default"].createTextNode(this.formattedTime_);
				if (!this.textNode_) return;
				if (oldNode) this.contentEl_.replaceChild(this.textNode_, oldNode);
				else this.contentEl_.appendChild(this.textNode_);
			});
		}
		/**
		* To be filled out in the child class, should update the displayed time
		* in accordance with the fact that the current time has changed.
		*
		* @param {Event} [event]
		*        The `timeupdate`  event that caused this to run.
		*
		* @listens Player#timeupdate
		*/
		updateContent(event) {}
	};
	/**
	* The text that is added to the `TimeDisplay` for screen reader users.
	*
	* @type {string}
	* @private
	*/
	TimeDisplay.prototype.labelText_ = "Time";
	/**
	* The text that should display over the `TimeDisplay`s controls. Added to for localization.
	*
	* @type {string}
	* @protected
	*
	* @deprecated in v7; controlText_ is not used in non-active display Components
	*/
	TimeDisplay.prototype.controlText_ = "Time";
	Component.registerComponent("TimeDisplay", TimeDisplay);
	/**
	* @file current-time-display.js
	*/
	/**
	* Displays the current time
	*
	* @extends Component
	*/
	var CurrentTimeDisplay = class extends TimeDisplay {
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return "vjs-current-time";
		}
		/**
		* Update current time display
		*
		* @param {Event} [event]
		*        The `timeupdate` event that caused this function to run.
		*
		* @listens Player#timeupdate
		*/
		updateContent(event) {
			let time;
			if (this.player_.ended()) time = this.player_.duration();
			else if (event && event.target && typeof event.target.pendingSeekTime === "function" && event.target.pendingSeekTime() !== null) time = event.target.pendingSeekTime();
			else time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
			this.updateTextNode_(time);
		}
	};
	/**
	* The text that is added to the `CurrentTimeDisplay` for screen reader users.
	*
	* @type {string}
	* @private
	*/
	CurrentTimeDisplay.prototype.labelText_ = "Current Time";
	/**
	* The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
	*
	* @type {string}
	* @protected
	*
	* @deprecated in v7; controlText_ is not used in non-active display Components
	*/
	CurrentTimeDisplay.prototype.controlText_ = "Current Time";
	Component.registerComponent("CurrentTimeDisplay", CurrentTimeDisplay);
	/**
	* @file duration-display.js
	*/
	/** @import Player from '../../player' */
	/**
	* Displays the duration
	*
	* @extends Component
	*/
	var DurationDisplay = class extends TimeDisplay {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			const updateContent = (e) => this.updateContent(e);
			this.on(player, "durationchange", updateContent);
			this.on(player, "loadstart", updateContent);
			this.on(player, "loadedmetadata", updateContent);
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return "vjs-duration";
		}
		/**
		* Update duration time display.
		*
		* @param {Event} [event]
		*        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
		*        this function to be called.
		*
		* @listens Player#durationchange
		* @listens Player#timeupdate
		* @listens Player#loadedmetadata
		*/
		updateContent(event) {
			const duration = this.player_.duration();
			this.updateTextNode_(duration);
		}
	};
	/**
	* The text that is added to the `DurationDisplay` for screen reader users.
	*
	* @type {string}
	* @private
	*/
	DurationDisplay.prototype.labelText_ = "Duration";
	/**
	* The text that should display over the `DurationDisplay`s controls. Added to for localization.
	*
	* @type {string}
	* @protected
	*
	* @deprecated in v7; controlText_ is not used in non-active display Components
	*/
	DurationDisplay.prototype.controlText_ = "Duration";
	Component.registerComponent("DurationDisplay", DurationDisplay);
	/**
	* @file time-divider.js
	*/
	/**
	* The separator between the current time and duration.
	* Can be hidden if it's not needed in the design.
	*
	* @extends Component
	*/
	var TimeDivider = class extends Component {
		/**
		* Create the component's DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl("div", { className: "vjs-time-control vjs-time-divider" }, { "aria-hidden": true });
			const div = super.createEl("div");
			const span = super.createEl("span", { textContent: "/" });
			div.appendChild(span);
			el.appendChild(div);
			return el;
		}
	};
	Component.registerComponent("TimeDivider", TimeDivider);
	/**
	* @file remaining-time-display.js
	*/
	/** @import Player from '../../player' */
	/**
	* Displays the time left in the video
	*
	* @extends Component
	*/
	var RemainingTimeDisplay = class extends TimeDisplay {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.on(player, "durationchange", (e) => this.updateContent(e));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return "vjs-remaining-time";
		}
		/**
		* Create the `Component`'s DOM element with the "minus" character prepend to the time
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl();
			if (this.options_.displayNegative !== false) el.insertBefore(createEl("span", {}, { "aria-hidden": true }, "-"), this.contentEl_);
			return el;
		}
		/**
		* Update remaining time display.
		*
		* @param {Event} [event]
		*        The `timeupdate` or `durationchange` event that caused this to run.
		*
		* @listens Player#timeupdate
		* @listens Player#durationchange
		*/
		updateContent(event) {
			if (typeof this.player_.duration() !== "number") return;
			let time;
			if (this.player_.ended()) time = 0;
			else if (this.player_.remainingTimeDisplay) time = this.player_.remainingTimeDisplay();
			else time = this.player_.remainingTime();
			this.updateTextNode_(time);
		}
	};
	/**
	* The text that is added to the `RemainingTimeDisplay` for screen reader users.
	*
	* @type {string}
	* @private
	*/
	RemainingTimeDisplay.prototype.labelText_ = "Remaining Time";
	/**
	* The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
	*
	* @type {string}
	* @protected
	*
	* @deprecated in v7; controlText_ is not used in non-active display Components
	*/
	RemainingTimeDisplay.prototype.controlText_ = "Remaining Time";
	Component.registerComponent("RemainingTimeDisplay", RemainingTimeDisplay);
	/**
	* @file live-display.js
	*/
	/** @import Player from './player' */
	/**
	* Displays the live indicator when duration is Infinity.
	*
	* @extends Component
	*/
	var LiveDisplay = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.updateShowing();
			this.on(this.player(), "durationchange", (e) => this.updateShowing(e));
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl("div", { className: "vjs-live-control vjs-control" });
			this.contentEl_ = createEl("div", { className: "vjs-live-display" }, { "aria-live": "off" });
			this.contentEl_.appendChild(createEl("span", {
				className: "vjs-control-text",
				textContent: `${this.localize("Stream Type")}\u00a0`
			}));
			this.contentEl_.appendChild(document__default["default"].createTextNode(this.localize("LIVE")));
			el.appendChild(this.contentEl_);
			return el;
		}
		dispose() {
			this.contentEl_ = null;
			super.dispose();
		}
		/**
		* Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
		* it accordingly
		*
		* @param {Event} [event]
		*        The {@link Player#durationchange} event that caused this function to run.
		*
		* @listens Player#durationchange
		*/
		updateShowing(event) {
			if (this.player().duration() === Infinity) this.show();
			else this.hide();
		}
	};
	Component.registerComponent("LiveDisplay", LiveDisplay);
	/**
	* @file seek-to-live.js
	*/
	/** @import Player from './player' */
	/**
	* Displays the live indicator when duration is Infinity.
	*
	* @extends Component
	*/
	var SeekToLive = class extends Button {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.updateLiveEdgeStatus();
			if (this.player_.liveTracker) {
				this.updateLiveEdgeStatusHandler_ = (e) => this.updateLiveEdgeStatus(e);
				this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_);
			}
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl("button", { className: "vjs-seek-to-live-control vjs-control" });
			this.setIcon("circle", el);
			this.textEl_ = createEl("span", {
				className: "vjs-seek-to-live-text",
				textContent: this.localize("LIVE")
			}, { "aria-hidden": "true" });
			el.appendChild(this.textEl_);
			return el;
		}
		/**
		* Update the state of this button if we are at the live edge
		* or not
		*/
		updateLiveEdgeStatus() {
			if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
				this.setAttribute("aria-disabled", true);
				this.addClass("vjs-at-live-edge");
				this.controlText("Seek to live, currently playing live");
			} else {
				this.setAttribute("aria-disabled", false);
				this.removeClass("vjs-at-live-edge");
				this.controlText("Seek to live, currently behind live");
			}
		}
		/**
		* On click bring us as near to the live point as possible.
		* This requires that we wait for the next `live-seekable-change`
		* event which will happen every segment length seconds.
		*/
		handleClick() {
			this.player_.liveTracker.seekToLiveEdge();
		}
		/**
		* Dispose of the element and stop tracking
		*/
		dispose() {
			if (this.player_.liveTracker) this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_);
			this.textEl_ = null;
			super.dispose();
		}
	};
	/**
	* The text that should display over the `SeekToLive`s control. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	SeekToLive.prototype.controlText_ = "Seek to live, currently playing live";
	Component.registerComponent("SeekToLive", SeekToLive);
	/**
	* @file num.js
	* @module num
	*/
	/**
	* Keep a number between a min and a max value
	*
	* @param {number} number
	*        The number to clamp
	*
	* @param {number} min
	*        The minimum value
	* @param {number} max
	*        The maximum value
	*
	* @return {number}
	*         the clamped number
	*/
	function clamp(number, min, max) {
		number = Number(number);
		return Math.min(max, Math.max(min, isNaN(number) ? min : number));
	}
	var Num = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		clamp
	});
	/**
	* @file slider.js
	*/
	/** @import Player from '../player' */
	/**
	* The base functionality for a slider. Can be vertical or horizontal.
	* For instance the volume bar or the seek bar on a video is a slider.
	*
	* @extends Component
	*/
	var Slider = class extends Component {
		/**
		* Create an instance of this class
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.handleMouseDown_ = (e) => this.handleMouseDown(e);
			this.handleMouseUp_ = (e) => this.handleMouseUp(e);
			this.handleKeyDown_ = (e) => this.handleKeyDown(e);
			this.handleClick_ = (e) => this.handleClick(e);
			this.handleMouseMove_ = (e) => this.handleMouseMove(e);
			this.update_ = (e) => this.update(e);
			this.bar = this.getChild(this.options_.barName);
			this.vertical(!!this.options_.vertical);
			this.enable();
		}
		/**
		* Are controls are currently enabled for this slider or not.
		*
		* @return {boolean}
		*         true if controls are enabled, false otherwise
		*/
		enabled() {
			return this.enabled_;
		}
		/**
		* Enable controls for this slider if they are disabled
		*/
		enable() {
			if (this.enabled()) return;
			this.on("mousedown", this.handleMouseDown_);
			this.on("touchstart", this.handleMouseDown_);
			this.on("keydown", this.handleKeyDown_);
			this.on("click", this.handleClick_);
			this.on(this.player_, "controlsvisible", this.update);
			if (this.playerEvent) this.on(this.player_, this.playerEvent, this.update);
			this.removeClass("disabled");
			this.setAttribute("tabindex", 0);
			this.enabled_ = true;
		}
		/**
		* Disable controls for this slider if they are enabled
		*/
		disable() {
			if (!this.enabled()) return;
			const doc = this.bar.el_.ownerDocument;
			this.off("mousedown", this.handleMouseDown_);
			this.off("touchstart", this.handleMouseDown_);
			this.off("keydown", this.handleKeyDown_);
			this.off("click", this.handleClick_);
			this.off(this.player_, "controlsvisible", this.update_);
			this.off(doc, "mousemove", this.handleMouseMove_);
			this.off(doc, "mouseup", this.handleMouseUp_);
			this.off(doc, "touchmove", this.handleMouseMove_);
			this.off(doc, "touchend", this.handleMouseUp_);
			this.removeAttribute("tabindex");
			this.addClass("disabled");
			if (this.playerEvent) this.off(this.player_, this.playerEvent, this.update);
			this.enabled_ = false;
		}
		/**
		* Create the `Slider`s DOM element.
		*
		* @param {string} type
		*        Type of element to create.
		*
		* @param {Object} [props={}]
		*        List of properties in Object form.
		*
		* @param {Object} [attributes={}]
		*        list of attributes in Object form.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl(type, props = {}, attributes = {}) {
			props.className = props.className + " vjs-slider";
			props = Object.assign({ tabIndex: 0 }, props);
			attributes = Object.assign({
				"role": "slider",
				"aria-valuenow": 0,
				"aria-valuemin": 0,
				"aria-valuemax": 100
			}, attributes);
			return super.createEl(type, props, attributes);
		}
		/**
		* Handle `mousedown` or `touchstart` events on the `Slider`.
		*
		* @param {MouseEvent} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousedown
		* @listens touchstart
		* @fires Slider#slideractive
		*/
		handleMouseDown(event) {
			const doc = this.bar.el_.ownerDocument;
			if (event.type === "mousedown") event.preventDefault();
			if (event.type === "touchstart" && !IS_CHROME) event.preventDefault();
			blockTextSelection();
			this.addClass("vjs-sliding");
			/**
			* Triggered when the slider is in an active state
			*
			* @event Slider#slideractive
			* @type {MouseEvent}
			*/
			this.trigger("slideractive");
			this.on(doc, "mousemove", this.handleMouseMove_);
			this.on(doc, "mouseup", this.handleMouseUp_);
			this.on(doc, "touchmove", this.handleMouseMove_);
			this.on(doc, "touchend", this.handleMouseUp_);
			this.handleMouseMove(event, true);
		}
		/**
		* Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
		* The `mousemove` and `touchmove` events will only only trigger this function during
		* `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
		* {@link Slider#handleMouseUp}.
		*
		* @param {MouseEvent} event
		*        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
		*        this function
		* @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
		*
		* @listens mousemove
		* @listens touchmove
		*/
		handleMouseMove(event) {}
		/**
		* Handle `mouseup` or `touchend` events on the `Slider`.
		*
		* @param {MouseEvent} event
		*        `mouseup` or `touchend` event that triggered this function.
		*
		* @listens touchend
		* @listens mouseup
		* @fires Slider#sliderinactive
		*/
		handleMouseUp(event) {
			const doc = this.bar.el_.ownerDocument;
			unblockTextSelection();
			this.removeClass("vjs-sliding");
			/**
			* Triggered when the slider is no longer in an active state.
			*
			* @event Slider#sliderinactive
			* @type {Event}
			*/
			this.trigger("sliderinactive");
			this.off(doc, "mousemove", this.handleMouseMove_);
			this.off(doc, "mouseup", this.handleMouseUp_);
			this.off(doc, "touchmove", this.handleMouseMove_);
			this.off(doc, "touchend", this.handleMouseUp_);
			this.update();
		}
		/**
		* Update the progress bar of the `Slider`.
		*
		* @return {number}
		*          The percentage of progress the progress bar represents as a
		*          number from 0 to 1.
		*/
		update() {
			if (!this.el_ || !this.bar) return;
			const progress = this.getProgress();
			if (progress === this.progress_) return progress;
			this.progress_ = progress;
			this.requestNamedAnimationFrame("Slider#update", () => {
				const sizeKey = this.vertical() ? "height" : "width";
				this.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + "%";
			});
			return progress;
		}
		/**
		* Get the percentage of the bar that should be filled
		* but clamped and rounded.
		*
		* @return {number}
		*         percentage filled that the slider is
		*/
		getProgress() {
			return Number(clamp(this.getPercent(), 0, 1).toFixed(4));
		}
		/**
		* Calculate distance for slider
		*
		* @param {Event} event
		*        The event that caused this function to run.
		*
		* @return {number}
		*         The current position of the Slider.
		*         - position.x for vertical `Slider`s
		*         - position.y for horizontal `Slider`s
		*/
		calculateDistance(event) {
			const position = getPointerPosition(this.el_, event);
			if (this.vertical()) return position.y;
			return position.x;
		}
		/**
		* Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
		* arrow keys. This function will only be called when the slider has focus. See
		* {@link Slider#handleFocus} and {@link Slider#handleBlur}.
		*
		* @param {KeyboardEvent} event
		*        the `keydown` event that caused this function to run.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			const spatialNavOptions = this.options_.playerOptions.spatialNavigation;
			const spatialNavEnabled = spatialNavOptions && spatialNavOptions.enabled;
			const horizontalSeek = spatialNavOptions && spatialNavOptions.horizontalSeek;
			if (spatialNavEnabled) if (horizontalSeek && event.key === "ArrowLeft" || !horizontalSeek && event.key === "ArrowDown") {
				event.preventDefault();
				event.stopPropagation();
				this.stepBack();
			} else if (horizontalSeek && event.key === "ArrowRight" || !horizontalSeek && event.key === "ArrowUp") {
				event.preventDefault();
				event.stopPropagation();
				this.stepForward();
			} else {
				if (this.pendingSeekTime()) {
					this.pendingSeekTime(null);
					this.userSeek_(this.player_.currentTime());
				}
				super.handleKeyDown(event);
			}
			else if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
				event.preventDefault();
				event.stopPropagation();
				this.stepBack();
			} else if (event.key === "ArrowUp" || event.key === "ArrowRight") {
				event.preventDefault();
				event.stopPropagation();
				this.stepForward();
			} else super.handleKeyDown(event);
		}
		/**
		* Listener for click events on slider, used to prevent clicks
		*   from bubbling up to parent elements like button menus.
		*
		* @param {Object} event
		*        Event that caused this object to run
		*/
		handleClick(event) {
			event.stopPropagation();
			event.preventDefault();
		}
		/**
		* Get/set if slider is horizontal for vertical
		*
		* @param {boolean} [bool]
		*        - true if slider is vertical,
		*        - false is horizontal
		*
		* @return {boolean}
		*         - true if slider is vertical, and getting
		*         - false if the slider is horizontal, and getting
		*/
		vertical(bool) {
			if (bool === void 0) return this.vertical_ || false;
			this.vertical_ = !!bool;
			if (this.vertical_) this.addClass("vjs-slider-vertical");
			else this.addClass("vjs-slider-horizontal");
		}
	};
	Component.registerComponent("Slider", Slider);
	/**
	* @file load-progress-bar.js
	*/
	/** @import Player from '../../player' */
	var percentify = (time, end) => clamp(time / end * 100, 0, 100).toFixed(2) + "%";
	/**
	* Shows loading progress
	*
	* @extends Component
	*/
	var LoadProgressBar = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.partEls_ = [];
			this.on(player, "progress", (e) => this.update(e));
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl("div", { className: "vjs-load-progress" });
			const wrapper = createEl("span", { className: "vjs-control-text" });
			const loadedText = createEl("span", { textContent: this.localize("Loaded") });
			const separator = document__default["default"].createTextNode(": ");
			this.percentageEl_ = createEl("span", {
				className: "vjs-control-text-loaded-percentage",
				textContent: "0%"
			});
			el.appendChild(wrapper);
			wrapper.appendChild(loadedText);
			wrapper.appendChild(separator);
			wrapper.appendChild(this.percentageEl_);
			return el;
		}
		dispose() {
			this.partEls_ = null;
			this.percentageEl_ = null;
			super.dispose();
		}
		/**
		* Update progress bar
		*
		* @param {Event} [event]
		*        The `progress` event that caused this function to run.
		*
		* @listens Player#progress
		*/
		update(event) {
			this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
				const liveTracker = this.player_.liveTracker;
				const buffered = this.player_.buffered();
				const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
				const bufferedEnd = this.player_.bufferedEnd();
				const children = this.partEls_;
				const percent = percentify(bufferedEnd, duration);
				if (this.percent_ !== percent) {
					this.el_.style.width = percent;
					textContent(this.percentageEl_, percent);
					this.percent_ = percent;
				}
				for (let i = 0; i < buffered.length; i++) {
					const start = buffered.start(i);
					const end = buffered.end(i);
					let part = children[i];
					if (!part) {
						part = this.el_.appendChild(createEl());
						children[i] = part;
					}
					if (part.dataset.start === start && part.dataset.end === end) continue;
					part.dataset.start = start;
					part.dataset.end = end;
					part.style.left = percentify(start, bufferedEnd);
					part.style.width = percentify(end - start, bufferedEnd);
				}
				for (let i = children.length; i > buffered.length; i--) this.el_.removeChild(children[i - 1]);
				children.length = buffered.length;
			});
		}
	};
	Component.registerComponent("LoadProgressBar", LoadProgressBar);
	/**
	* @file time-tooltip.js
	*/
	/** @import Player from '../../player' */
	/**
	* Time tooltips display a time above the progress bar.
	*
	* @extends Component
	*/
	var TimeTooltip = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The {@link Player} that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.update = throttle(bind_(this, this.update), UPDATE_REFRESH_INTERVAL);
		}
		/**
		* Create the time tooltip DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-time-tooltip" }, { "aria-hidden": "true" });
		}
		/**
		* Updates the position of the time tooltip relative to the `SeekBar`.
		*
		* @param {Object} seekBarRect
		*        The `ClientRect` for the {@link SeekBar} element.
		*
		* @param {number} seekBarPoint
		*        A number from 0 to 1, representing a horizontal reference point
		*        from the left edge of the {@link SeekBar}
		*/
		update(seekBarRect, seekBarPoint, content) {
			const tooltipRect = findPosition(this.el_);
			const playerRect = getBoundingClientRect(this.player_.el());
			const seekBarPointPx = seekBarRect.width * seekBarPoint;
			if (!playerRect || !tooltipRect) return;
			let spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
			let spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
			if (!spaceRightOfPoint) {
				spaceRightOfPoint = seekBarRect.width - seekBarPointPx;
				spaceLeftOfPoint = seekBarPointPx;
			}
			let pullTooltipBy = tooltipRect.width / 2;
			if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
			else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
			if (pullTooltipBy < 0) pullTooltipBy = 0;
			else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
			pullTooltipBy = Math.round(pullTooltipBy);
			this.el_.style.right = `-${pullTooltipBy}px`;
			this.write(content);
		}
		/**
		* Write the time to the tooltip DOM element.
		*
		* @param {string} content
		*        The formatted time for the tooltip.
		*/
		write(content) {
			textContent(this.el_, content);
		}
		/**
		* Updates the position of the time tooltip relative to the `SeekBar`.
		*
		* @param {Object} seekBarRect
		*        The `ClientRect` for the {@link SeekBar} element.
		*
		* @param {number} seekBarPoint
		*        A number from 0 to 1, representing a horizontal reference point
		*        from the left edge of the {@link SeekBar}
		*
		* @param {number} time
		*        The time to update the tooltip to, not used during live playback
		*
		* @param {Function} cb
		*        A function that will be called during the request animation frame
		*        for tooltips that need to do additional animations from the default
		*/
		updateTime(seekBarRect, seekBarPoint, time, cb) {
			this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
				let content;
				const duration = this.player_.duration();
				if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
					const liveWindow = this.player_.liveTracker.liveWindow();
					const secondsBehind = liveWindow - seekBarPoint * liveWindow;
					content = (secondsBehind < 1 ? "" : "-") + formatTime(secondsBehind, liveWindow);
				} else content = formatTime(time, duration);
				this.update(seekBarRect, seekBarPoint, content);
				if (cb) cb();
			});
		}
	};
	Component.registerComponent("TimeTooltip", TimeTooltip);
	/**
	* @file play-progress-bar.js
	*/
	/**
	* Used by {@link SeekBar} to display media playback progress as part of the
	* {@link ProgressControl}.
	*
	* @extends Component
	*/
	var PlayProgressBar = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The {@link Player} that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.setIcon("circle");
			this.update = throttle(bind_(this, this.update), UPDATE_REFRESH_INTERVAL);
		}
		/**
		* Create the the DOM element for this class.
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-play-progress vjs-slider-bar" }, { "aria-hidden": "true" });
		}
		/**
		* Enqueues updates to its own DOM as well as the DOM of its
		* {@link TimeTooltip} child.
		*
		* @param {Object} seekBarRect
		*        The `ClientRect` for the {@link SeekBar} element.
		*
		* @param {number} seekBarPoint
		*        A number from 0 to 1, representing a horizontal reference point
		*        from the left edge of the {@link SeekBar}
		*
		* @param {Event} [event]
		*        The `timeupdate` event that caused this function to run.
		*/
		update(seekBarRect, seekBarPoint, event) {
			const timeTooltip = this.getChild("timeTooltip");
			if (!timeTooltip) return;
			const time = event && event.target && typeof event.target.pendingSeekTime === "function" ? event.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
			timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
		}
	};
	/**
	* Default options for {@link PlayProgressBar}.
	*
	* @type {Object}
	* @private
	*/
	PlayProgressBar.prototype.options_ = { children: [] };
	if (!IS_IOS && !IS_ANDROID) PlayProgressBar.prototype.options_.children.push("timeTooltip");
	Component.registerComponent("PlayProgressBar", PlayProgressBar);
	/**
	* @file mouse-time-display.js
	*/
	/**
	* The {@link MouseTimeDisplay} component tracks mouse movement over the
	* {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
	* indicating the time which is represented by a given point in the
	* {@link ProgressControl}.
	*
	* @extends Component
	*/
	var MouseTimeDisplay = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The {@link Player} that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.update = throttle(bind_(this, this.update), UPDATE_REFRESH_INTERVAL);
		}
		/**
		* Create the DOM element for this class.
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		/**
		* Enqueues updates to its own DOM as well as the DOM of its
		* {@link TimeTooltip} child.
		*
		* @param {Object} seekBarRect
		*        The `ClientRect` for the {@link SeekBar} element.
		*
		* @param {number} seekBarPoint
		*        A number from 0 to 1, representing a horizontal reference point
		*        from the left edge of the {@link SeekBar}
		*/
		update(seekBarRect, seekBarPoint) {
			const time = seekBarPoint * this.player_.duration();
			this.getChild("timeTooltip").updateTime(seekBarRect, seekBarPoint, time, () => {
				this.el_.style.left = `${seekBarRect.width * seekBarPoint}px`;
			});
		}
	};
	/**
	* Default options for `MouseTimeDisplay`
	*
	* @type {Object}
	* @private
	*/
	MouseTimeDisplay.prototype.options_ = { children: ["timeTooltip"] };
	Component.registerComponent("MouseTimeDisplay", MouseTimeDisplay);
	/**
	* @file seek-bar.js
	*/
	/**
	* Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
	* as its `bar`.
	*
	* @extends Slider
	*/
	var SeekBar = class SeekBar extends Slider {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		* @param {number} [options.stepSeconds=5]
		*        The number of seconds to increment on keyboard control
		* @param {number} [options.pageMultiplier=12]
		*        The multiplier of stepSeconds that PgUp/PgDown move the timeline.
		*/
		constructor(player, options) {
			options = merge(SeekBar.prototype.options_, options);
			options.children = [...options.children];
			const shouldDisableSeekWhileScrubbing = player.options_.disableSeekWhileScrubbingOnMobile && (IS_IOS || IS_ANDROID) || player.options_.disableSeekWhileScrubbingOnSTV;
			if (!IS_IOS && !IS_ANDROID || shouldDisableSeekWhileScrubbing) options.children.splice(1, 0, "mouseTimeDisplay");
			super(player, options);
			this.shouldDisableSeekWhileScrubbing_ = shouldDisableSeekWhileScrubbing;
			this.pendingSeekTime_ = null;
			this.setEventHandlers_();
		}
		/**
		* Sets the event handlers
		*
		* @private
		*/
		setEventHandlers_() {
			this.update_ = bind_(this, this.update);
			this.update = throttle(this.update_, UPDATE_REFRESH_INTERVAL);
			this.on(this.player_, ["durationchange", "timeupdate"], this.update);
			this.on(this.player_, ["ended"], this.update_);
			if (this.player_.liveTracker) this.on(this.player_.liveTracker, "liveedgechange", this.update);
			this.updateInterval = null;
			this.enableIntervalHandler_ = (e) => this.enableInterval_(e);
			this.disableIntervalHandler_ = (e) => this.disableInterval_(e);
			this.on(this.player_, ["playing"], this.enableIntervalHandler_);
			this.on(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_);
			if ("hidden" in document__default["default"] && "visibilityState" in document__default["default"]) this.on(document__default["default"], "visibilitychange", this.toggleVisibility_);
		}
		toggleVisibility_(e) {
			if (document__default["default"].visibilityState === "hidden") {
				this.cancelNamedAnimationFrame("SeekBar#update");
				this.cancelNamedAnimationFrame("Slider#update");
				this.disableInterval_(e);
			} else {
				if (!this.player_.ended() && !this.player_.paused()) this.enableInterval_();
				this.update();
			}
		}
		enableInterval_() {
			if (this.updateInterval) return;
			this.updateInterval = this.setInterval(this.update, UPDATE_REFRESH_INTERVAL);
		}
		disableInterval_(e) {
			if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended") return;
			if (!this.updateInterval) return;
			this.clearInterval(this.updateInterval);
			this.updateInterval = null;
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-progress-holder" }, { "aria-label": this.localize("Progress Bar") });
		}
		/**
		* This function updates the play progress bar and accessibility
		* attributes to whatever is passed in.
		*
		* @param {Event} [event]
		*        The `timeupdate` or `ended` event that caused this to run.
		*
		* @listens Player#timeupdate
		*
		* @return {number}
		*          The current percent at a number from 0-1
		*/
		update(event) {
			if (document__default["default"].visibilityState === "hidden") return;
			const percent = super.update();
			this.requestNamedAnimationFrame("SeekBar#update", () => {
				const currentTime = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_();
				const liveTracker = this.player_.liveTracker;
				let duration = this.player_.duration();
				if (liveTracker && liveTracker.isLive()) duration = this.player_.liveTracker.liveCurrentTime();
				if (this.percent_ !== percent) {
					this.el_.setAttribute("aria-valuenow", (percent * 100).toFixed(2));
					this.percent_ = percent;
				}
				if (this.currentTime_ !== currentTime || this.duration_ !== duration) {
					this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [formatTime(currentTime, duration), formatTime(duration, duration)], "{1} of {2}"));
					this.currentTime_ = currentTime;
					this.duration_ = duration;
				}
				if (this.bar) this.bar.update(getBoundingClientRect(this.el()), this.getProgress(), event);
			});
			return percent;
		}
		/**
		* Prevent liveThreshold from causing seeks to seem like they
		* are not happening from a user perspective.
		*
		* @param {number} ct
		*        current time to seek to
		*/
		userSeek_(ct) {
			if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
			this.player_.currentTime(ct);
		}
		/**
		* Get the value of current time but allows for smooth scrubbing,
		* when player can't keep up.
		*
		* @return {number}
		*         The current time value to display
		*
		* @private
		*/
		getCurrentTime_() {
			return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
		}
		/**
		* Getter and setter for pendingSeekTime.
		* Ensures the value is clamped between 0 and duration.
		*
		* @param {number|null} [time] - Optional. The new pending seek time, can be a number or null.
		* @return {number|null} - The current pending seek time.
		*/
		pendingSeekTime(time) {
			if (time !== void 0) if (time !== null) {
				const duration = this.player_.duration();
				this.pendingSeekTime_ = Math.max(0, Math.min(time, duration));
			} else this.pendingSeekTime_ = null;
			return this.pendingSeekTime_;
		}
		/**
		* Get the percentage of media played so far.
		*
		* @return {number}
		*         The percentage of media played so far (0 to 1).
		*/
		getPercent() {
			if (this.pendingSeekTime() !== null) return this.pendingSeekTime() / this.player_.duration();
			const currentTime = this.getCurrentTime_();
			let percent;
			const liveTracker = this.player_.liveTracker;
			if (liveTracker && liveTracker.isLive()) {
				percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow();
				if (liveTracker.atLiveEdge()) percent = 1;
			} else percent = currentTime / this.player_.duration();
			return percent;
		}
		/**
		* Handle mouse down on seek bar
		*
		* @param {MouseEvent} event
		*        The `mousedown` event that caused this to run.
		*
		* @listens mousedown
		*/
		handleMouseDown(event) {
			if (!isSingleLeftClick(event)) return;
			event.stopPropagation();
			this.videoWasPlaying = !this.player_.paused();
			if (!this.shouldDisableSeekWhileScrubbing_) this.player_.pause();
			super.handleMouseDown(event);
		}
		/**
		* Handle mouse move on seek bar
		*
		* @param {MouseEvent} event
		*        The `mousemove` event that caused this to run.
		* @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
		*
		* @listens mousemove
		*/
		handleMouseMove(event, mouseDown = false) {
			if (!isSingleLeftClick(event) || isNaN(this.player_.duration())) return;
			if (!mouseDown && !this.player_.scrubbing()) this.player_.scrubbing(true);
			let newTime;
			const distance = this.calculateDistance(event);
			const liveTracker = this.player_.liveTracker;
			if (!liveTracker || !liveTracker.isLive()) {
				newTime = distance * this.player_.duration();
				if (newTime === this.player_.duration()) newTime = newTime - .1;
			} else {
				if (distance >= .99) {
					liveTracker.seekToLiveEdge();
					return;
				}
				const seekableStart = liveTracker.seekableStart();
				const seekableEnd = liveTracker.liveCurrentTime();
				newTime = seekableStart + distance * liveTracker.liveWindow();
				if (newTime >= seekableEnd) newTime = seekableEnd;
				if (newTime <= seekableStart) newTime = seekableStart + .1;
				if (newTime === Infinity) return;
			}
			if (this.shouldDisableSeekWhileScrubbing_) this.pendingSeekTime(newTime);
			else this.userSeek_(newTime);
			if (this.player_.options_.enableSmoothSeeking) this.update();
		}
		enable() {
			super.enable();
			const mouseTimeDisplay = this.getChild("mouseTimeDisplay");
			if (!mouseTimeDisplay) return;
			mouseTimeDisplay.show();
		}
		disable() {
			super.disable();
			const mouseTimeDisplay = this.getChild("mouseTimeDisplay");
			if (!mouseTimeDisplay) return;
			mouseTimeDisplay.hide();
		}
		/**
		* Handle mouse up on seek bar
		*
		* @param {MouseEvent} event
		*        The `mouseup` event that caused this to run.
		*
		* @listens mouseup
		*/
		handleMouseUp(event) {
			super.handleMouseUp(event);
			if (event) event.stopPropagation();
			this.player_.scrubbing(false);
			if (this.pendingSeekTime() !== null) {
				this.userSeek_(this.pendingSeekTime());
				this.pendingSeekTime(null);
			}
			/**
			* Trigger timeupdate because we're done seeking and the time has changed.
			* This is particularly useful for if the player is paused to time the time displays.
			*
			* @event Tech#timeupdate
			* @type {Event}
			*/
			this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: true
			});
			if (this.videoWasPlaying) silencePromise(this.player_.play());
			else this.update_();
		}
		/**
		* Handles pending seek time when `disableSeekWhileScrubbingOnSTV` is enabled.
		*
		* @param {number} stepAmount - The number of seconds to step (positive for forward, negative for backward).
		*/
		handlePendingSeek_(stepAmount) {
			if (!this.player_.paused()) this.player_.pause();
			const currentPos = this.pendingSeekTime() !== null ? this.pendingSeekTime() : this.player_.currentTime();
			this.pendingSeekTime(currentPos + stepAmount);
			this.player_.trigger({
				type: "timeupdate",
				target: this,
				manuallyTriggered: true
			});
		}
		/**
		* Move more quickly fast forward for keyboard-only users
		*/
		stepForward() {
			if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(this.options().stepSeconds);
			else this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
		}
		/**
		* Move more quickly rewind for keyboard-only users
		*/
		stepBack() {
			if (this.shouldDisableSeekWhileScrubbing_) this.handlePendingSeek_(-this.options().stepSeconds);
			else this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
		}
		/**
		* Toggles the playback state of the player
		* This gets called when enter or space is used on the seekbar
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called
		*
		*/
		handleAction(event) {
			if (this.pendingSeekTime() !== null) {
				this.userSeek_(this.pendingSeekTime());
				this.pendingSeekTime(null);
			}
			if (this.player_.paused()) this.player_.play();
			else this.player_.pause();
		}
		/**
		* Called when this SeekBar has focus and a key gets pressed down.
		* Supports the following keys:
		*
		*   Space or Enter key fire a click event
		*   Home key moves to start of the timeline
		*   End key moves to end of the timeline
		*   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
		*   PageDown key moves back a larger step than ArrowDown
		*   PageUp key moves forward a large step
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			const liveTracker = this.player_.liveTracker;
			if (event.key === " " || event.key === "Enter") {
				event.preventDefault();
				event.stopPropagation();
				this.handleAction(event);
			} else if (event.key === "Home") {
				event.preventDefault();
				event.stopPropagation();
				this.userSeek_(0);
			} else if (event.key === "End") {
				event.preventDefault();
				event.stopPropagation();
				if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.liveCurrentTime());
				else this.userSeek_(this.player_.duration());
			} else if (/^[0-9]$/.test(event.key)) {
				event.preventDefault();
				event.stopPropagation();
				const gotoFraction = parseInt(event.key, 10) * .1;
				if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
				else this.userSeek_(this.player_.duration() * gotoFraction);
			} else if (event.key === "PageDown") {
				event.preventDefault();
				event.stopPropagation();
				this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier);
			} else if (event.key === "PageUp") {
				event.preventDefault();
				event.stopPropagation();
				this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier);
			} else super.handleKeyDown(event);
		}
		dispose() {
			this.disableInterval_();
			this.off(this.player_, ["durationchange", "timeupdate"], this.update);
			this.off(this.player_, ["ended"], this.update_);
			if (this.player_.liveTracker) this.off(this.player_.liveTracker, "liveedgechange", this.update);
			this.off(this.player_, ["playing"], this.enableIntervalHandler_);
			this.off(this.player_, [
				"ended",
				"pause",
				"waiting"
			], this.disableIntervalHandler_);
			if ("hidden" in document__default["default"] && "visibilityState" in document__default["default"]) this.off(document__default["default"], "visibilitychange", this.toggleVisibility_);
			super.dispose();
		}
	};
	/**
	* Default options for the `SeekBar`
	*
	* @type {Object}
	* @private
	*/
	SeekBar.prototype.options_ = {
		children: ["loadProgressBar", "playProgressBar"],
		barName: "playProgressBar",
		stepSeconds: 5,
		pageMultiplier: 12
	};
	Component.registerComponent("SeekBar", SeekBar);
	/**
	* @file progress-control.js
	*/
	/**
	* The Progress Control component contains the seek bar, load progress,
	* and play progress.
	*
	* @extends Component
	*/
	var ProgressControl = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.handleMouseMove = throttle(bind_(this, this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
			this.throttledHandleMouseSeek = throttle(bind_(this, this.handleMouseSeek), UPDATE_REFRESH_INTERVAL);
			this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e);
			this.handleMouseDownHandler_ = (e) => this.handleMouseDown(e);
			this.enable();
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-progress-control vjs-control" });
		}
		/**
		* When the mouse moves over the `ProgressControl`, the pointer position
		* gets passed down to the `MouseTimeDisplay` component.
		*
		* @param {Event} event
		*        The `mousemove` event that caused this function to run.
		*
		* @listen mousemove
		*/
		handleMouseMove(event) {
			const seekBar = this.getChild("seekBar");
			if (!seekBar) return;
			const playProgressBar = seekBar.getChild("playProgressBar");
			const mouseTimeDisplay = seekBar.getChild("mouseTimeDisplay");
			if (!playProgressBar && !mouseTimeDisplay) return;
			const seekBarEl = seekBar.el();
			const seekBarRect = findPosition(seekBarEl);
			let seekBarPoint = getPointerPosition(seekBarEl, event).x;
			seekBarPoint = clamp(seekBarPoint, 0, 1);
			if (mouseTimeDisplay) mouseTimeDisplay.update(seekBarRect, seekBarPoint);
			if (playProgressBar) playProgressBar.update(seekBarRect, seekBar.getProgress());
		}
		/**
		* A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
		*
		* @method ProgressControl#throttledHandleMouseSeek
		* @param {Event} event
		*        The `mousemove` event that caused this function to run.
		*
		* @listen mousemove
		* @listen touchmove
		*/
		/**
		* Handle `mousemove` or `touchmove` events on the `ProgressControl`.
		*
		* @param {Event} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousemove
		* @listens touchmove
		*/
		handleMouseSeek(event) {
			const seekBar = this.getChild("seekBar");
			if (seekBar) seekBar.handleMouseMove(event);
		}
		/**
		* Are controls are currently enabled for this progress control.
		*
		* @return {boolean}
		*         true if controls are enabled, false otherwise
		*/
		enabled() {
			return this.enabled_;
		}
		/**
		* Disable all controls on the progress control and its children
		*/
		disable() {
			this.children().forEach((child) => child.disable && child.disable());
			if (!this.enabled()) return;
			this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_);
			this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove);
			this.removeListenersAddedOnMousedownAndTouchstart();
			this.addClass("disabled");
			this.enabled_ = false;
			if (this.player_.scrubbing()) {
				const seekBar = this.getChild("seekBar");
				this.player_.scrubbing(false);
				if (seekBar.videoWasPlaying) silencePromise(this.player_.play());
			}
		}
		/**
		* Enable all controls on the progress control and its children
		*/
		enable() {
			this.children().forEach((child) => child.enable && child.enable());
			if (this.enabled()) return;
			this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_);
			this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove);
			this.removeClass("disabled");
			this.enabled_ = true;
		}
		/**
		* Cleanup listeners after the user finishes interacting with the progress controls
		*/
		removeListenersAddedOnMousedownAndTouchstart() {
			const doc = this.el_.ownerDocument;
			this.off(doc, "mousemove", this.throttledHandleMouseSeek);
			this.off(doc, "touchmove", this.throttledHandleMouseSeek);
			this.off(doc, "mouseup", this.handleMouseUpHandler_);
			this.off(doc, "touchend", this.handleMouseUpHandler_);
		}
		/**
		* Handle `mousedown` or `touchstart` events on the `ProgressControl`.
		*
		* @param {Event} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousedown
		* @listens touchstart
		*/
		handleMouseDown(event) {
			const doc = this.el_.ownerDocument;
			const seekBar = this.getChild("seekBar");
			if (seekBar) seekBar.handleMouseDown(event);
			this.on(doc, "mousemove", this.throttledHandleMouseSeek);
			this.on(doc, "touchmove", this.throttledHandleMouseSeek);
			this.on(doc, "mouseup", this.handleMouseUpHandler_);
			this.on(doc, "touchend", this.handleMouseUpHandler_);
		}
		/**
		* Handle `mouseup` or `touchend` events on the `ProgressControl`.
		*
		* @param {Event} event
		*        `mouseup` or `touchend` event that triggered this function.
		*
		* @listens touchend
		* @listens mouseup
		*/
		handleMouseUp(event) {
			const seekBar = this.getChild("seekBar");
			if (seekBar) seekBar.handleMouseUp(event);
			this.removeListenersAddedOnMousedownAndTouchstart();
		}
	};
	/**
	* Default options for `ProgressControl`
	*
	* @type {Object}
	* @private
	*/
	ProgressControl.prototype.options_ = { children: ["seekBar"] };
	Component.registerComponent("ProgressControl", ProgressControl);
	/**
	* @file picture-in-picture-toggle.js
	*/
	/** @import Player from './player' */
	/**
	* Toggle Picture-in-Picture mode
	*
	* @extends Button
	*/
	var PictureInPictureToggle = class extends Button {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @listens Player#enterpictureinpicture
		* @listens Player#leavepictureinpicture
		*/
		constructor(player, options) {
			super(player, options);
			this.setIcon("picture-in-picture-enter");
			this.on(player, ["enterpictureinpicture", "leavepictureinpicture"], (e) => this.handlePictureInPictureChange(e));
			this.on(player, ["disablepictureinpicturechanged", "loadedmetadata"], (e) => this.handlePictureInPictureEnabledChange(e));
			this.on(player, [
				"loadedmetadata",
				"audioonlymodechange",
				"audiopostermodechange"
			], () => this.handlePictureInPictureAudioModeChange());
			this.disable();
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
		}
		/**
		* Displays or hides the button depending on the audio mode detection.
		* Exits picture-in-picture if it is enabled when switching to audio mode.
		*/
		handlePictureInPictureAudioModeChange() {
			if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
				this.show();
				return;
			}
			if (this.player_.isInPictureInPicture()) this.player_.exitPictureInPicture();
			this.hide();
		}
		/**
		* Enables or disables button based on availability of a Picture-In-Picture mode.
		*
		* Enabled if
		* - `player.options().enableDocumentPictureInPicture` is true and
		*   window.documentPictureInPicture is available; or
		* - `player.disablePictureInPicture()` is false and
		*   element.requestPictureInPicture is available
		*/
		handlePictureInPictureEnabledChange() {
			if (document__default["default"].pictureInPictureEnabled && this.player_.disablePictureInPicture() === false || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in window__default["default"]) this.enable();
			else this.disable();
		}
		/**
		* Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
		*
		* @param {Event} [event]
		*        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
		*        called.
		*
		* @listens Player#enterpictureinpicture
		* @listens Player#leavepictureinpicture
		*/
		handlePictureInPictureChange(event) {
			if (this.player_.isInPictureInPicture()) {
				this.setIcon("picture-in-picture-exit");
				this.controlText("Exit Picture-in-Picture");
			} else {
				this.setIcon("picture-in-picture-enter");
				this.controlText("Picture-in-Picture");
			}
			this.handlePictureInPictureEnabledChange();
		}
		/**
		* This gets called when an `PictureInPictureToggle` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			if (!this.player_.isInPictureInPicture()) this.player_.requestPictureInPicture();
			else this.player_.exitPictureInPicture();
		}
		/**
		* Show the `Component`s element if it is hidden by removing the
		* 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
		*/
		show() {
			if (typeof document__default["default"].exitPictureInPicture !== "function") return;
			super.show();
		}
	};
	/**
	* The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	PictureInPictureToggle.prototype.controlText_ = "Picture-in-Picture";
	Component.registerComponent("PictureInPictureToggle", PictureInPictureToggle);
	/**
	* @file fullscreen-toggle.js
	*/
	/** @import Player from './player' */
	/**
	* Toggle fullscreen video
	*
	* @extends Button
	*/
	var FullscreenToggle = class extends Button {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.setIcon("fullscreen-enter");
			this.on(player, "fullscreenchange", (e) => this.handleFullscreenChange(e));
			if (document__default["default"][player.fsApi_.fullscreenEnabled] === false) this.disable();
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-fullscreen-control ${super.buildCSSClass()}`;
		}
		/**
		* Handles fullscreenchange on the player and change control text accordingly.
		*
		* @param {Event} [event]
		*        The {@link Player#fullscreenchange} event that caused this function to be
		*        called.
		*
		* @listens Player#fullscreenchange
		*/
		handleFullscreenChange(event) {
			if (this.player_.isFullscreen()) {
				this.controlText("Exit Fullscreen");
				this.setIcon("fullscreen-exit");
			} else {
				this.controlText("Fullscreen");
				this.setIcon("fullscreen-enter");
			}
		}
		/**
		* This gets called when an `FullscreenToggle` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			if (!this.player_.isFullscreen()) this.player_.requestFullscreen();
			else this.player_.exitFullscreen();
		}
	};
	/**
	* The text that should display over the `FullscreenToggle`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	FullscreenToggle.prototype.controlText_ = "Fullscreen";
	Component.registerComponent("FullscreenToggle", FullscreenToggle);
	/** @import Component from '../../component' */
	/** @import Player from '../../player' */
	/**
	* Check if volume control is supported and if it isn't hide the
	* `Component` that was passed  using the `vjs-hidden` class.
	*
	* @param {Component} self
	*        The component that should be hidden if volume is unsupported
	*
	* @param {Player} player
	*        A reference to the player
	*
	* @private
	*/
	var checkVolumeSupport = function(self, player) {
		if (player.tech_ && !player.tech_.featuresVolumeControl) self.addClass("vjs-hidden");
		self.on(player, "loadstart", function() {
			if (!player.tech_.featuresVolumeControl) self.addClass("vjs-hidden");
			else self.removeClass("vjs-hidden");
		});
	};
	/**
	* @file volume-level.js
	*/
	/**
	* Shows volume level
	*
	* @extends Component
	*/
	var VolumeLevel = class extends Component {
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl("div", { className: "vjs-volume-level" });
			this.setIcon("circle", el);
			el.appendChild(super.createEl("span", { className: "vjs-control-text" }));
			return el;
		}
	};
	Component.registerComponent("VolumeLevel", VolumeLevel);
	/**
	* @file volume-level-tooltip.js
	*/
	/** @import Player from '../../player' */
	/**
	* Volume level tooltips display a volume above or side by side the volume bar.
	*
	* @extends Component
	*/
	var VolumeLevelTooltip = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The {@link Player} that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.update = throttle(bind_(this, this.update), UPDATE_REFRESH_INTERVAL);
		}
		/**
		* Create the volume tooltip DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-volume-tooltip" }, { "aria-hidden": "true" });
		}
		/**
		* Updates the position of the tooltip relative to the `VolumeBar` and
		* its content text.
		*
		* @param {Object} rangeBarRect
		*        The `ClientRect` for the {@link VolumeBar} element.
		*
		* @param {number} rangeBarPoint
		*        A number from 0 to 1, representing a horizontal/vertical reference point
		*        from the left edge of the {@link VolumeBar}
		*
		* @param {boolean} vertical
		*        Referees to the Volume control position
		*        in the control bar{@link VolumeControl}
		*
		*/
		update(rangeBarRect, rangeBarPoint, vertical, content) {
			if (!vertical) {
				const tooltipRect = getBoundingClientRect(this.el_);
				const playerRect = getBoundingClientRect(this.player_.el());
				const volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
				if (!playerRect || !tooltipRect) return;
				const spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
				const spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
				let pullTooltipBy = tooltipRect.width / 2;
				if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
				else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
				if (pullTooltipBy < 0) pullTooltipBy = 0;
				else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
				this.el_.style.right = `-${pullTooltipBy}px`;
			}
			this.write(`${content}%`);
		}
		/**
		* Write the volume to the tooltip DOM element.
		*
		* @param {string} content
		*        The formatted volume for the tooltip.
		*/
		write(content) {
			textContent(this.el_, content);
		}
		/**
		* Updates the position of the volume tooltip relative to the `VolumeBar`.
		*
		* @param {Object} rangeBarRect
		*        The `ClientRect` for the {@link VolumeBar} element.
		*
		* @param {number} rangeBarPoint
		*        A number from 0 to 1, representing a horizontal/vertical reference point
		*        from the left edge of the {@link VolumeBar}
		*
		* @param {boolean} vertical
		*        Referees to the Volume control position
		*        in the control bar{@link VolumeControl}
		*
		* @param {number} volume
		*        The volume level to update the tooltip to
		*
		* @param {Function} cb
		*        A function that will be called during the request animation frame
		*        for tooltips that need to do additional animations from the default
		*/
		updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
			this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
				this.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
				if (cb) cb();
			});
		}
	};
	Component.registerComponent("VolumeLevelTooltip", VolumeLevelTooltip);
	/**
	* @file mouse-volume-level-display.js
	*/
	/**
	* The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
	* {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
	* indicating the volume level which is represented by a given point in the
	* {@link VolumeBar}.
	*
	* @extends Component
	*/
	var MouseVolumeLevelDisplay = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The {@link Player} that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.update = throttle(bind_(this, this.update), UPDATE_REFRESH_INTERVAL);
		}
		/**
		* Create the DOM element for this class.
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-mouse-display" });
		}
		/**
		* Enquires updates to its own DOM as well as the DOM of its
		* {@link VolumeLevelTooltip} child.
		*
		* @param {Object} rangeBarRect
		*        The `ClientRect` for the {@link VolumeBar} element.
		*
		* @param {number} rangeBarPoint
		*        A number from 0 to 1, representing a horizontal/vertical reference point
		*        from the left edge of the {@link VolumeBar}
		*
		* @param {boolean} vertical
		*        Referees to the Volume control position
		*        in the control bar{@link VolumeControl}
		*
		*/
		update(rangeBarRect, rangeBarPoint, vertical) {
			const volume = 100 * rangeBarPoint;
			this.getChild("volumeLevelTooltip").updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, () => {
				if (vertical) this.el_.style.bottom = `${rangeBarRect.height * rangeBarPoint}px`;
				else this.el_.style.left = `${rangeBarRect.width * rangeBarPoint}px`;
			});
		}
	};
	/**
	* Default options for `MouseVolumeLevelDisplay`
	*
	* @type {Object}
	* @private
	*/
	MouseVolumeLevelDisplay.prototype.options_ = { children: ["volumeLevelTooltip"] };
	Component.registerComponent("MouseVolumeLevelDisplay", MouseVolumeLevelDisplay);
	/**
	* @file volume-bar.js
	*/
	/**
	* The bar that contains the volume level and can be clicked on to adjust the level
	*
	* @extends Slider
	*/
	var VolumeBar = class extends Slider {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.on("slideractive", (e) => this.updateLastVolume_(e));
			this.on(player, "volumechange", (e) => this.updateARIAAttributes(e));
			player.ready(() => this.updateARIAAttributes());
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", { className: "vjs-volume-bar vjs-slider-bar" }, {
				"aria-label": this.localize("Volume Level"),
				"aria-live": "polite"
			});
		}
		/**
		* Handle mouse down on volume bar
		*
		* @param {Event} event
		*        The `mousedown` event that caused this to run.
		*
		* @listens mousedown
		*/
		handleMouseDown(event) {
			if (!isSingleLeftClick(event)) return;
			super.handleMouseDown(event);
		}
		/**
		* Handle movement events on the {@link VolumeMenuButton}.
		*
		* @param {Event} event
		*        The event that caused this function to run.
		*
		* @listens mousemove
		*/
		handleMouseMove(event) {
			const mouseVolumeLevelDisplay = this.getChild("mouseVolumeLevelDisplay");
			if (mouseVolumeLevelDisplay) {
				const volumeBarEl = this.el();
				const volumeBarRect = getBoundingClientRect(volumeBarEl);
				const vertical = this.vertical();
				let volumeBarPoint = getPointerPosition(volumeBarEl, event);
				volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x;
				volumeBarPoint = clamp(volumeBarPoint, 0, 1);
				mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
			}
			if (!isSingleLeftClick(event)) return;
			this.checkMuted();
			this.player_.volume(this.calculateDistance(event));
		}
		/**
		* If the player is muted unmute it.
		*/
		checkMuted() {
			if (this.player_.muted()) this.player_.muted(false);
		}
		/**
		* Get percent of volume level
		*
		* @return {number}
		*         Volume level percent as a decimal number.
		*/
		getPercent() {
			if (this.player_.muted()) return 0;
			return this.player_.volume();
		}
		/**
		* Increase volume level for keyboard users
		*/
		stepForward() {
			this.checkMuted();
			this.player_.volume(this.player_.volume() + .1);
		}
		/**
		* Decrease volume level for keyboard users
		*/
		stepBack() {
			this.checkMuted();
			this.player_.volume(this.player_.volume() - .1);
		}
		/**
		* Update ARIA accessibility attributes
		*
		* @param {Event} [event]
		*        The `volumechange` event that caused this function to run.
		*
		* @listens Player#volumechange
		*/
		updateARIAAttributes(event) {
			const ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
			this.el_.setAttribute("aria-valuenow", ariaValue);
			this.el_.setAttribute("aria-valuetext", ariaValue + "%");
		}
		/**
		* Returns the current value of the player volume as a percentage
		*
		* @private
		*/
		volumeAsPercentage_() {
			return Math.round(this.player_.volume() * 100);
		}
		/**
		* When user starts dragging the VolumeBar, store the volume and listen for
		* the end of the drag. When the drag ends, if the volume was set to zero,
		* set lastVolume to the stored volume.
		*
		* @listens slideractive
		* @private
		*/
		updateLastVolume_() {
			const volumeBeforeDrag = this.player_.volume();
			this.one("sliderinactive", () => {
				if (this.player_.volume() === 0) this.player_.lastVolume_(volumeBeforeDrag);
			});
		}
	};
	/**
	* Default options for the `VolumeBar`
	*
	* @type {Object}
	* @private
	*/
	VolumeBar.prototype.options_ = {
		children: ["volumeLevel"],
		barName: "volumeLevel"
	};
	if (!IS_IOS && !IS_ANDROID) VolumeBar.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
	/**
	* Call the update event for this Slider when this event happens on the player.
	*
	* @type {string}
	*/
	VolumeBar.prototype.playerEvent = "volumechange";
	Component.registerComponent("VolumeBar", VolumeBar);
	/**
	* @file volume-control.js
	*/
	/**
	* The component for controlling the volume level
	*
	* @extends Component
	*/
	var VolumeControl = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			options.vertical = options.vertical || false;
			if (typeof options.volumeBar === "undefined" || isPlain(options.volumeBar)) {
				options.volumeBar = options.volumeBar || {};
				options.volumeBar.vertical = options.vertical;
			}
			super(player, options);
			checkVolumeSupport(this, player);
			this.throttledHandleMouseMove = throttle(bind_(this, this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
			this.handleMouseUpHandler_ = (e) => this.handleMouseUp(e);
			this.on("mousedown", (e) => this.handleMouseDown(e));
			this.on("touchstart", (e) => this.handleMouseDown(e));
			this.on("mousemove", (e) => this.handleMouseMove(e));
			this.on(this.volumeBar, ["focus", "slideractive"], () => {
				this.volumeBar.addClass("vjs-slider-active");
				this.addClass("vjs-slider-active");
				this.trigger("slideractive");
			});
			this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
				this.volumeBar.removeClass("vjs-slider-active");
				this.removeClass("vjs-slider-active");
				this.trigger("sliderinactive");
			});
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			let orientationClass = "vjs-volume-horizontal";
			if (this.options_.vertical) orientationClass = "vjs-volume-vertical";
			return super.createEl("div", { className: `vjs-volume-control vjs-control ${orientationClass}` });
		}
		/**
		* Handle `mousedown` or `touchstart` events on the `VolumeControl`.
		*
		* @param {Event} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousedown
		* @listens touchstart
		*/
		handleMouseDown(event) {
			const doc = this.el_.ownerDocument;
			this.on(doc, "mousemove", this.throttledHandleMouseMove);
			this.on(doc, "touchmove", this.throttledHandleMouseMove);
			this.on(doc, "mouseup", this.handleMouseUpHandler_);
			this.on(doc, "touchend", this.handleMouseUpHandler_);
		}
		/**
		* Handle `mouseup` or `touchend` events on the `VolumeControl`.
		*
		* @param {Event} event
		*        `mouseup` or `touchend` event that triggered this function.
		*
		* @listens touchend
		* @listens mouseup
		*/
		handleMouseUp(event) {
			const doc = this.el_.ownerDocument;
			this.off(doc, "mousemove", this.throttledHandleMouseMove);
			this.off(doc, "touchmove", this.throttledHandleMouseMove);
			this.off(doc, "mouseup", this.handleMouseUpHandler_);
			this.off(doc, "touchend", this.handleMouseUpHandler_);
		}
		/**
		* Handle `mousedown` or `touchstart` events on the `VolumeControl`.
		*
		* @param {Event} event
		*        `mousedown` or `touchstart` event that triggered this function
		*
		* @listens mousedown
		* @listens touchstart
		*/
		handleMouseMove(event) {
			this.volumeBar.handleMouseMove(event);
		}
	};
	/**
	* Default options for the `VolumeControl`
	*
	* @type {Object}
	* @private
	*/
	VolumeControl.prototype.options_ = { children: ["volumeBar"] };
	Component.registerComponent("VolumeControl", VolumeControl);
	/** @import Component from '../../component' */
	/** @import Player from '../../player' */
	/**
	* Check if muting volume is supported and if it isn't hide the mute toggle
	* button.
	*
	* @param {Component} self
	*        A reference to the mute toggle button
	*
	* @param {Player} player
	*        A reference to the player
	*
	* @private
	*/
	var checkMuteSupport = function(self, player) {
		if (player.tech_ && !player.tech_.featuresMuteControl) self.addClass("vjs-hidden");
		self.on(player, "loadstart", function() {
			if (!player.tech_.featuresMuteControl) self.addClass("vjs-hidden");
			else self.removeClass("vjs-hidden");
		});
	};
	/**
	* @file mute-toggle.js
	*/
	/** @import Player from './player' */
	/**
	* A button component for muting the audio.
	*
	* @extends Button
	*/
	var MuteToggle = class extends Button {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			checkMuteSupport(this, player);
			this.on(player, ["loadstart", "volumechange"], (e) => this.update(e));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-mute-control ${super.buildCSSClass()}`;
		}
		/**
		* This gets called when an `MuteToggle` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			const vol = this.player_.volume();
			const lastVolume = this.player_.lastVolume_();
			if (vol === 0) {
				const volumeToSet = lastVolume < .1 ? .1 : lastVolume;
				this.player_.volume(volumeToSet);
				this.player_.muted(false);
			} else this.player_.muted(this.player_.muted() ? false : true);
		}
		/**
		* Update the `MuteToggle` button based on the state of `volume` and `muted`
		* on the player.
		*
		* @param {Event} [event]
		*        The {@link Player#loadstart} event if this function was called
		*        through an event.
		*
		* @listens Player#loadstart
		* @listens Player#volumechange
		*/
		update(event) {
			this.updateIcon_();
			this.updateControlText_();
		}
		/**
		* Update the appearance of the `MuteToggle` icon.
		*
		* Possible states (given `level` variable below):
		* - 0: crossed out
		* - 1: zero bars of volume
		* - 2: one bar of volume
		* - 3: two bars of volume
		*
		* @private
		*/
		updateIcon_() {
			const vol = this.player_.volume();
			let level = 3;
			this.setIcon("volume-high");
			if (IS_IOS && this.player_.tech_ && this.player_.tech_.el_) this.player_.muted(this.player_.tech_.el_.muted);
			if (vol === 0 || this.player_.muted()) {
				this.setIcon("volume-mute");
				level = 0;
			} else if (vol < .33) {
				this.setIcon("volume-low");
				level = 1;
			} else if (vol < .67) {
				this.setIcon("volume-medium");
				level = 2;
			}
			removeClass(this.el_, [
				0,
				1,
				2,
				3
			].reduce((str, i) => str + `${i ? " " : ""}vjs-vol-${i}`, ""));
			addClass(this.el_, `vjs-vol-${level}`);
		}
		/**
		* If `muted` has changed on the player, update the control text
		* (`title` attribute on `vjs-mute-control` element and content of
		* `vjs-control-text` element).
		*
		* @private
		*/
		updateControlText_() {
			const text = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
			if (this.controlText() !== text) this.controlText(text);
		}
	};
	/**
	* The text that should display over the `MuteToggle`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	MuteToggle.prototype.controlText_ = "Mute";
	Component.registerComponent("MuteToggle", MuteToggle);
	/**
	* @file volume-control.js
	*/
	/**
	* A Component to contain the MuteToggle and VolumeControl so that
	* they can work together.
	*
	* @extends Component
	*/
	var VolumePanel = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			if (typeof options.inline !== "undefined") options.inline = options.inline;
			else options.inline = true;
			if (typeof options.volumeControl === "undefined" || isPlain(options.volumeControl)) {
				options.volumeControl = options.volumeControl || {};
				options.volumeControl.vertical = !options.inline;
			}
			super(player, options);
			this.handleKeyPressHandler_ = (e) => this.handleKeyPress(e);
			this.on(player, ["loadstart"], (e) => this.volumePanelState_(e));
			this.on(this.muteToggle, "keyup", (e) => this.handleKeyPress(e));
			this.on(this.volumeControl, "keyup", (e) => this.handleVolumeControlKeyUp(e));
			this.on("keydown", (e) => this.handleKeyPress(e));
			this.on("mouseover", (e) => this.handleMouseOver(e));
			this.on("mouseout", (e) => this.handleMouseOut(e));
			this.on(this.volumeControl, ["slideractive"], this.sliderActive_);
			this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
		}
		/**
		* Add vjs-slider-active class to the VolumePanel
		*
		* @listens VolumeControl#slideractive
		* @private
		*/
		sliderActive_() {
			this.addClass("vjs-slider-active");
		}
		/**
		* Removes vjs-slider-active class to the VolumePanel
		*
		* @listens VolumeControl#sliderinactive
		* @private
		*/
		sliderInactive_() {
			this.removeClass("vjs-slider-active");
		}
		/**
		* Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
		* depending on MuteToggle and VolumeControl state
		*
		* @listens Player#loadstart
		* @private
		*/
		volumePanelState_() {
			if (this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden")) this.addClass("vjs-hidden");
			if (this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden")) this.addClass("vjs-mute-toggle-only");
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			let orientationClass = "vjs-volume-panel-horizontal";
			if (!this.options_.inline) orientationClass = "vjs-volume-panel-vertical";
			return super.createEl("div", { className: `vjs-volume-panel vjs-control ${orientationClass}` });
		}
		/**
		* Dispose of the `volume-panel` and all child components.
		*/
		dispose() {
			this.handleMouseOut();
			super.dispose();
		}
		/**
		* Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
		* the volume panel and sets focus on `MuteToggle`.
		*
		* @param {Event} event
		*        The `keyup` event that caused this function to be called.
		*
		* @listens keyup
		*/
		handleVolumeControlKeyUp(event) {
			if (event.key === "Escape") this.muteToggle.focus();
		}
		/**
		* This gets called when a `VolumePanel` gains hover via a `mouseover` event.
		* Turns on listening for `mouseover` event. When they happen it
		* calls `this.handleMouseOver`.
		*
		* @param {Event} event
		*        The `mouseover` event that caused this function to be called.
		*
		* @listens mouseover
		*/
		handleMouseOver(event) {
			this.addClass("vjs-hover");
			on(document__default["default"], "keyup", this.handleKeyPressHandler_);
		}
		/**
		* This gets called when a `VolumePanel` gains hover via a `mouseout` event.
		* Turns on listening for `mouseout` event. When they happen it
		* calls `this.handleMouseOut`.
		*
		* @param {Event} event
		*        The `mouseout` event that caused this function to be called.
		*
		* @listens mouseout
		*/
		handleMouseOut(event) {
			this.removeClass("vjs-hover");
			off(document__default["default"], "keyup", this.handleKeyPressHandler_);
		}
		/**
		* Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
		* looking for ESC, which hides the `VolumeControl`.
		*
		* @param {Event} event
		*        The keypress that triggered this event.
		*
		* @listens keydown | keyup
		*/
		handleKeyPress(event) {
			if (event.key === "Escape") this.handleMouseOut();
		}
	};
	/**
	* Default options for the `VolumeControl`
	*
	* @type {Object}
	* @private
	*/
	VolumePanel.prototype.options_ = { children: ["muteToggle", "volumeControl"] };
	Component.registerComponent("VolumePanel", VolumePanel);
	/**
	* Button to skip forward a configurable amount of time
	* through a video. Renders in the control bar.
	*
	* e.g. options: {controlBar: {skipButtons: forward: 5}}
	*
	* @extends Button
	*/
	var SkipForward = class extends Button {
		constructor(player, options) {
			super(player, options);
			this.validOptions = [
				5,
				10,
				30
			];
			this.skipTime = this.getSkipForwardTime();
			if (this.skipTime && this.validOptions.includes(this.skipTime)) {
				this.setIcon(`forward-${this.skipTime}`);
				this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(player.language())]));
				this.show();
			} else this.hide();
		}
		getSkipForwardTime() {
			const playerOptions = this.options_.playerOptions;
			return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.forward;
		}
		buildCSSClass() {
			return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
		}
		/**
		* On click, skips forward in the duration/seekable range by a configurable amount of seconds.
		* If the time left in the duration/seekable range is less than the configured 'skip forward' time,
		* skips to end of duration/seekable range.
		*
		* Handle a click on a `SkipForward` button
		*
		* @param {EventTarget~Event} event
		*        The `click` event that caused this function
		*        to be called
		*/
		handleClick(event) {
			if (isNaN(this.player_.duration())) return;
			const currentVideoTime = this.player_.currentTime();
			const liveTracker = this.player_.liveTracker;
			const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
			let newTime;
			if (currentVideoTime + this.skipTime <= duration) newTime = currentVideoTime + this.skipTime;
			else newTime = duration;
			this.player_.currentTime(newTime);
		}
		/**
		* Update control text on languagechange
		*/
		handleLanguagechange() {
			this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
		}
	};
	SkipForward.prototype.controlText_ = "Skip Forward";
	Component.registerComponent("SkipForward", SkipForward);
	/**
	* Button to skip backward a configurable amount of time
	* through a video. Renders in the control bar.
	*
	*  * e.g. options: {controlBar: {skipButtons: backward: 5}}
	*
	* @extends Button
	*/
	var SkipBackward = class extends Button {
		constructor(player, options) {
			super(player, options);
			this.validOptions = [
				5,
				10,
				30
			];
			this.skipTime = this.getSkipBackwardTime();
			if (this.skipTime && this.validOptions.includes(this.skipTime)) {
				this.setIcon(`replay-${this.skipTime}`);
				this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(player.language())]));
				this.show();
			} else this.hide();
		}
		getSkipBackwardTime() {
			const playerOptions = this.options_.playerOptions;
			return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.backward;
		}
		buildCSSClass() {
			return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
		}
		/**
		* On click, skips backward in the video by a configurable amount of seconds.
		* If the current time in the video is less than the configured 'skip backward' time,
		* skips to beginning of video or seekable range.
		*
		* Handle a click on a `SkipBackward` button
		*
		* @param {EventTarget~Event} event
		*        The `click` event that caused this function
		*        to be called
		*/
		handleClick(event) {
			const currentVideoTime = this.player_.currentTime();
			const liveTracker = this.player_.liveTracker;
			const seekableStart = liveTracker && liveTracker.isLive() && liveTracker.seekableStart();
			let newTime;
			if (seekableStart && currentVideoTime - this.skipTime <= seekableStart) newTime = seekableStart;
			else if (currentVideoTime >= this.skipTime) newTime = currentVideoTime - this.skipTime;
			else newTime = 0;
			this.player_.currentTime(newTime);
		}
		/**
		* Update control text on languagechange
		*/
		handleLanguagechange() {
			this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
		}
	};
	SkipBackward.prototype.controlText_ = "Skip Backward";
	Component.registerComponent("SkipBackward", SkipBackward);
	/**
	* @file menu.js
	*/
	/** @import Player from '../player' */
	/**
	* The Menu component is used to build popup menus, including subtitle and
	* captions selection menus.
	*
	* @extends Component
	*/
	var Menu = class extends Component {
		/**
		* Create an instance of this class.
		*
		* @param {Player} player
		*        the player that this component should attach to
		*
		* @param {Object} [options]
		*        Object of option names and values
		*
		*/
		constructor(player, options) {
			super(player, options);
			if (options) this.menuButton_ = options.menuButton;
			this.focusedChild_ = -1;
			this.on("keydown", (e) => this.handleKeyDown(e));
			this.boundHandleBlur_ = (e) => this.handleBlur(e);
			this.boundHandleTapClick_ = (e) => this.handleTapClick(e);
		}
		/**
		* Add event listeners to the {@link MenuItem}.
		*
		* @param {Object} component
		*        The instance of the `MenuItem` to add listeners to.
		*
		*/
		addEventListenerForItem(component) {
			if (!(component instanceof Component)) return;
			this.on(component, "blur", this.boundHandleBlur_);
			this.on(component, ["tap", "click"], this.boundHandleTapClick_);
		}
		/**
		* Remove event listeners from the {@link MenuItem}.
		*
		* @param {Object} component
		*        The instance of the `MenuItem` to remove listeners.
		*
		*/
		removeEventListenerForItem(component) {
			if (!(component instanceof Component)) return;
			this.off(component, "blur", this.boundHandleBlur_);
			this.off(component, ["tap", "click"], this.boundHandleTapClick_);
		}
		/**
		* This method will be called indirectly when the component has been added
		* before the component adds to the new menu instance by `addItem`.
		* In this case, the original menu instance will remove the component
		* by calling `removeChild`.
		*
		* @param {Object} component
		*        The instance of the `MenuItem`
		*/
		removeChild(component) {
			if (typeof component === "string") component = this.getChild(component);
			this.removeEventListenerForItem(component);
			super.removeChild(component);
		}
		/**
		* Add a {@link MenuItem} to the menu.
		*
		* @param {Object|string} component
		*        The name or instance of the `MenuItem` to add.
		*
		*/
		addItem(component) {
			const childComponent = this.addChild(component);
			if (childComponent) this.addEventListenerForItem(childComponent);
		}
		/**
		* Create the `Menu`s DOM element.
		*
		* @return {Element}
		*         the element that was created
		*/
		createEl() {
			const contentElType = this.options_.contentElType || "ul";
			this.contentEl_ = createEl(contentElType, { className: "vjs-menu-content" });
			this.contentEl_.setAttribute("role", "menu");
			const el = super.createEl("div", {
				append: this.contentEl_,
				className: "vjs-menu"
			});
			el.appendChild(this.contentEl_);
			on(el, "click", function(event) {
				event.preventDefault();
				event.stopImmediatePropagation();
			});
			return el;
		}
		dispose() {
			this.contentEl_ = null;
			this.boundHandleBlur_ = null;
			this.boundHandleTapClick_ = null;
			super.dispose();
		}
		/**
		* Called when a `MenuItem` loses focus.
		*
		* @param {Event} event
		*        The `blur` event that caused this function to be called.
		*
		* @listens blur
		*/
		handleBlur(event) {
			const relatedTarget = event.relatedTarget || document__default["default"].activeElement;
			if (!this.children().some((element) => {
				return element.el() === relatedTarget;
			})) {
				const btn = this.menuButton_;
				if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) btn.unpressButton();
			}
		}
		/**
		* Called when a `MenuItem` gets clicked or tapped.
		*
		* @param {Event} event
		*        The `click` or `tap` event that caused this function to be called.
		*
		* @listens click,tap
		*/
		handleTapClick(event) {
			if (this.menuButton_) {
				this.menuButton_.unpressButton();
				const childComponents = this.children();
				if (!Array.isArray(childComponents)) return;
				const foundComponent = childComponents.filter((component) => component.el() === event.target)[0];
				if (!foundComponent) return;
				if (foundComponent.name() !== "CaptionSettingsMenuItem") this.menuButton_.focus();
			}
		}
		/**
		* Handle a `keydown` event on this menu. This listener is added in the constructor.
		*
		* @param {KeyboardEvent} event
		*        A `keydown` event that happened on the menu.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
				event.preventDefault();
				event.stopPropagation();
				this.stepForward();
			} else if (event.key === "ArrowRight" || event.key === "ArrowUp") {
				event.preventDefault();
				event.stopPropagation();
				this.stepBack();
			}
		}
		/**
		* Move to next (lower) menu item for keyboard users.
		*/
		stepForward() {
			let stepChild = 0;
			if (this.focusedChild_ !== void 0) stepChild = this.focusedChild_ + 1;
			this.focus(stepChild);
		}
		/**
		* Move to previous (higher) menu item for keyboard users.
		*/
		stepBack() {
			let stepChild = 0;
			if (this.focusedChild_ !== void 0) stepChild = this.focusedChild_ - 1;
			this.focus(stepChild);
		}
		/**
		* Set focus on a {@link MenuItem} in the `Menu`.
		*
		* @param {Object|string} [item=0]
		*        Index of child item set focus on.
		*/
		focus(item = 0) {
			const children = this.children().slice();
			if (children.length && children[0].hasClass("vjs-menu-title")) children.shift();
			if (children.length > 0) {
				if (item < 0) item = 0;
				else if (item >= children.length) item = children.length - 1;
				this.focusedChild_ = item;
				children[item].el_.focus();
			}
		}
	};
	Component.registerComponent("Menu", Menu);
	/**
	* @file menu-button.js
	*/
	/** @import Player from '../player' */
	/**
	* A `MenuButton` class for any popup {@link Menu}.
	*
	* @extends Component
	*/
	var MenuButton = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			super(player, options);
			this.menuButton_ = new Button(player, options);
			this.menuButton_.controlText(this.controlText_);
			this.menuButton_.el_.setAttribute("aria-haspopup", "true");
			const buttonClass = Button.prototype.buildCSSClass();
			this.menuButton_.el_.className = this.buildCSSClass() + " " + buttonClass;
			this.menuButton_.removeClass("vjs-control");
			this.addChild(this.menuButton_);
			this.update();
			this.enabled_ = true;
			const handleClick = (e) => this.handleClick(e);
			this.handleMenuKeyUp_ = (e) => this.handleMenuKeyUp(e);
			this.on(this.menuButton_, "tap", handleClick);
			this.on(this.menuButton_, "click", handleClick);
			this.on(this.menuButton_, "keydown", (e) => this.handleKeyDown(e));
			this.on(this.menuButton_, "mouseenter", () => {
				this.addClass("vjs-hover");
				this.menu.show();
				on(document__default["default"], "keyup", this.handleMenuKeyUp_);
			});
			this.on("mouseleave", (e) => this.handleMouseLeave(e));
			this.on("keydown", (e) => this.handleSubmenuKeyDown(e));
		}
		/**
		* Update the menu based on the current state of its items.
		*/
		update() {
			const menu = this.createMenu();
			if (this.menu) {
				this.menu.dispose();
				this.removeChild(this.menu);
			}
			this.menu = menu;
			this.addChild(menu);
			/**
			* Track the state of the menu button
			*
			* @type {Boolean}
			* @private
			*/
			this.buttonPressed_ = false;
			this.menuButton_.el_.setAttribute("aria-expanded", "false");
			if (this.items && this.items.length <= this.hideThreshold_) {
				this.hide();
				this.menu.contentEl_.removeAttribute("role");
			} else {
				this.show();
				this.menu.contentEl_.setAttribute("role", "menu");
			}
		}
		/**
		* Create the menu and add all items to it.
		*
		* @return {Menu}
		*         The constructed menu
		*/
		createMenu() {
			const menu = new Menu(this.player_, { menuButton: this });
			/**
			* Hide the menu if the number of items is less than or equal to this threshold. This defaults
			* to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
			* it here because every time we run `createMenu` we need to reset the value.
			*
			* @protected
			* @type {Number}
			*/
			this.hideThreshold_ = 0;
			if (this.options_.title) {
				const titleEl = createEl("li", {
					className: "vjs-menu-title",
					textContent: toTitleCase(this.options_.title),
					tabIndex: -1
				});
				const titleComponent = new Component(this.player_, { el: titleEl });
				menu.addItem(titleComponent);
			}
			this.items = this.createItems();
			if (this.items) for (let i = 0; i < this.items.length; i++) menu.addItem(this.items[i]);
			return menu;
		}
		/**
		* Create the list of menu items. Specific to each subclass.
		*
		* @abstract
		*/
		createItems() {}
		/**
		* Create the `MenuButtons`s DOM element.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl() {
			return super.createEl("div", { className: this.buildWrapperCSSClass() }, {});
		}
		/**
		* Overwrites the `setIcon` method from `Component`.
		* In this case, we want the icon to be appended to the menuButton.
		*
		* @param {string} name
		*         The icon name to be added.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		setIcon(name) {
			return super.setIcon(name, this.menuButton_.el_);
		}
		/**
		* Allow sub components to stack CSS class names for the wrapper element
		*
		* @return {string}
		*         The constructed wrapper DOM `className`
		*/
		buildWrapperCSSClass() {
			let menuButtonClass = "vjs-menu-button";
			if (this.options_.inline === true) menuButtonClass += "-inline";
			else menuButtonClass += "-popup";
			const buttonClass = Button.prototype.buildCSSClass();
			return `vjs-menu-button ${menuButtonClass} ${buttonClass} ${super.buildCSSClass()}`;
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			let menuButtonClass = "vjs-menu-button";
			if (this.options_.inline === true) menuButtonClass += "-inline";
			else menuButtonClass += "-popup";
			return `vjs-menu-button ${menuButtonClass} ${super.buildCSSClass()}`;
		}
		/**
		* Get or set the localized control text that will be used for accessibility.
		*
		* > NOTE: This will come from the internal `menuButton_` element.
		*
		* @param {string} [text]
		*        Control text for element.
		*
		* @param {Element} [el=this.menuButton_.el()]
		*        Element to set the title on.
		*
		* @return {string}
		*         - The control text when getting
		*/
		controlText(text, el = this.menuButton_.el()) {
			return this.menuButton_.controlText(text, el);
		}
		/**
		* Dispose of the `menu-button` and all child components.
		*/
		dispose() {
			this.handleMouseLeave();
			super.dispose();
		}
		/**
		* Handle a click on a `MenuButton`.
		* See {@link ClickableComponent#handleClick} for instances where this is called.
		*
		* @param {Event} event
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			if (this.buttonPressed_) this.unpressButton();
			else this.pressButton();
		}
		/**
		* Handle `mouseleave` for `MenuButton`.
		*
		* @param {Event} event
		*        The `mouseleave` event that caused this function to be called.
		*
		* @listens mouseleave
		*/
		handleMouseLeave(event) {
			this.removeClass("vjs-hover");
			off(document__default["default"], "keyup", this.handleMenuKeyUp_);
		}
		/**
		* Set the focus to the actual button, not to this element
		*/
		focus() {
			this.menuButton_.focus();
		}
		/**
		* Remove the focus from the actual button, not this element
		*/
		blur() {
			this.menuButton_.blur();
		}
		/**
		* Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
		* {@link ClickableComponent#handleKeyDown} for instances where this is called.
		*
		* @param {Event} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (event.key === "Escape" || event.key === "Tab") {
				if (this.buttonPressed_) this.unpressButton();
				if (!event.key === "Tab") {
					event.preventDefault();
					this.menuButton_.focus();
				}
			} else if (event.key === "Up" || event.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) {
				if (!this.buttonPressed_) {
					event.preventDefault();
					this.pressButton();
				}
			}
		}
		/**
		* Handle a `keyup` event on a `MenuButton`. The listener for this is added in
		* the constructor.
		*
		* @param {Event} event
		*        Key press event
		*
		* @listens keyup
		*/
		handleMenuKeyUp(event) {
			if (event.key === "Escape" || event.key === "Tab") this.removeClass("vjs-hover");
		}
		/**
		* This method name now delegates to `handleSubmenuKeyDown`. This means
		* anyone calling `handleSubmenuKeyPress` will not see their method calls
		* stop working.
		*
		* @param {Event} event
		*        The event that caused this function to be called.
		*/
		handleSubmenuKeyPress(event) {
			this.handleSubmenuKeyDown(event);
		}
		/**
		* Handle a `keydown` event on a sub-menu. The listener for this is added in
		* the constructor.
		*
		* @param {Event} event
		*        Key press event
		*
		* @listens keydown
		*/
		handleSubmenuKeyDown(event) {
			if (event.key === "Escape" || event.key === "Tab") {
				if (this.buttonPressed_) this.unpressButton();
				if (!event.key === "Tab") {
					event.preventDefault();
					this.menuButton_.focus();
				}
			}
		}
		/**
		* Put the current `MenuButton` into a pressed state.
		*/
		pressButton() {
			if (this.enabled_) {
				this.buttonPressed_ = true;
				this.menu.show();
				this.menu.lockShowing();
				this.menuButton_.el_.setAttribute("aria-expanded", "true");
				if (IS_IOS && isInFrame()) return;
				this.menu.focus();
			}
		}
		/**
		* Take the current `MenuButton` out of a pressed state.
		*/
		unpressButton() {
			if (this.enabled_) {
				this.buttonPressed_ = false;
				this.menu.unlockShowing();
				this.menu.hide();
				this.menuButton_.el_.setAttribute("aria-expanded", "false");
			}
		}
		/**
		* Disable the `MenuButton`. Don't allow it to be clicked.
		*/
		disable() {
			this.unpressButton();
			this.enabled_ = false;
			this.addClass("vjs-disabled");
			this.menuButton_.disable();
		}
		/**
		* Enable the `MenuButton`. Allow it to be clicked.
		*/
		enable() {
			this.enabled_ = true;
			this.removeClass("vjs-disabled");
			this.menuButton_.enable();
		}
	};
	Component.registerComponent("MenuButton", MenuButton);
	/**
	* @file track-button.js
	*/
	/** @import Player from './player' */
	/**
	* The base class for buttons that toggle specific  track types (e.g. subtitles).
	*
	* @extends MenuButton
	*/
	var TrackButton = class extends MenuButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			const tracks = options.tracks;
			super(player, options);
			if (this.items.length <= 1) this.hide();
			if (!tracks) return;
			const updateHandler = bind_(this, this.update);
			tracks.addEventListener("removetrack", updateHandler);
			tracks.addEventListener("addtrack", updateHandler);
			tracks.addEventListener("labelchange", updateHandler);
			this.player_.on("ready", updateHandler);
			this.player_.on("dispose", function() {
				tracks.removeEventListener("removetrack", updateHandler);
				tracks.removeEventListener("addtrack", updateHandler);
				tracks.removeEventListener("labelchange", updateHandler);
			});
		}
	};
	Component.registerComponent("TrackButton", TrackButton);
	/**
	* @file menu-item.js
	*/
	/** @import Player from '../player' */
	/**
	* The component for a menu item. `<li>`
	*
	* @extends ClickableComponent
	*/
	var MenuItem = class extends ClickableComponent {
		/**
		* Creates an instance of the this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*
		*/
		constructor(player, options) {
			super(player, options);
			this.selectable = options.selectable;
			this.isSelected_ = options.selected || false;
			this.multiSelectable = options.multiSelectable;
			this.selected(this.isSelected_);
			if (this.selectable) if (this.multiSelectable) this.el_.setAttribute("role", "menuitemcheckbox");
			else this.el_.setAttribute("role", "menuitemradio");
			else this.el_.setAttribute("role", "menuitem");
		}
		/**
		* Create the `MenuItem's DOM element
		*
		* @param {string} [type=li]
		*        Element's node type, not actually used, always set to `li`.
		*
		* @param {Object} [props={}]
		*        An object of properties that should be set on the element
		*
		* @param {Object} [attrs={}]
		*        An object of attributes that should be set on the element
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl(type, props, attrs) {
			this.nonIconControl = true;
			const el = super.createEl("li", Object.assign({
				className: "vjs-menu-item",
				tabIndex: -1
			}, props), attrs);
			const menuItemEl = createEl("span", {
				className: "vjs-menu-item-text",
				textContent: this.localize(this.options_.label)
			});
			if (this.player_.options_.experimentalSvgIcons) el.appendChild(menuItemEl);
			else el.replaceChild(menuItemEl, el.querySelector(".vjs-icon-placeholder"));
			return el;
		}
		/**
		* Ignore keys which are used by the menu, but pass any other ones up. See
		* {@link ClickableComponent#handleKeyDown} for instances where this is called.
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			if (![
				"Tab",
				"Escape",
				"ArrowUp",
				"ArrowLeft",
				"ArrowRight",
				"ArrowDown"
			].includes(event.key)) super.handleKeyDown(event);
		}
		/**
		* Any click on a `MenuItem` puts it into the selected state.
		* See {@link ClickableComponent#handleClick} for instances where this is called.
		*
		* @param {Event} event
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			this.selected(true);
		}
		/**
		* Set the state for this menu item as selected or not.
		*
		* @param {boolean} selected
		*        if the menu item is selected or not
		*/
		selected(selected) {
			if (this.selectable) if (selected) {
				this.addClass("vjs-selected");
				this.el_.setAttribute("aria-checked", "true");
				this.controlText(", selected");
				this.isSelected_ = true;
			} else {
				this.removeClass("vjs-selected");
				this.el_.setAttribute("aria-checked", "false");
				this.controlText("");
				this.isSelected_ = false;
			}
		}
	};
	Component.registerComponent("MenuItem", MenuItem);
	/**
	* @file text-track-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* The specific menu item type for selecting a language within a text track kind
	*
	* @extends MenuItem
	*/
	var TextTrackMenuItem = class extends MenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			const track = options.track;
			const tracks = player.textTracks();
			options.label = track.label || track.language || "Unknown";
			options.selected = track.mode === "showing";
			super(player, options);
			this.track = track;
			this.kinds = (options.kinds || [options.kind || this.track.kind]).filter(Boolean);
			const changeHandler = (...args) => {
				this.handleTracksChange.apply(this, args);
			};
			const selectedLanguageChangeHandler = (...args) => {
				this.handleSelectedLanguageChange.apply(this, args);
			};
			player.on(["loadstart", "texttrackchange"], changeHandler);
			tracks.addEventListener("change", changeHandler);
			tracks.addEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
			this.on("dispose", function() {
				player.off(["loadstart", "texttrackchange"], changeHandler);
				tracks.removeEventListener("change", changeHandler);
				tracks.removeEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
			});
			if (tracks.onchange === void 0) {
				let event;
				this.on(["tap", "click"], function() {
					if (typeof window__default["default"].Event !== "object") try {
						event = new window__default["default"].Event("change");
					} catch (err) {}
					if (!event) {
						event = document__default["default"].createEvent("Event");
						event.initEvent("change", true, true);
					}
					tracks.dispatchEvent(event);
				});
			}
			this.handleTracksChange();
		}
		/**
		* This gets called when an `TextTrackMenuItem` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} event
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			const referenceTrack = this.track;
			const tracks = this.player_.textTracks();
			super.handleClick(event);
			if (!tracks) return;
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				if (this.kinds.indexOf(track.kind) === -1) continue;
				if (track === referenceTrack) {
					if (track.mode !== "showing") track.mode = "showing";
				} else if (track.mode !== "disabled") track.mode = "disabled";
			}
		}
		/**
		* Handle text track list change
		*
		* @param {Event} event
		*        The `change` event that caused this function to be called.
		*
		* @listens TextTrackList#change
		*/
		handleTracksChange(event) {
			const shouldBeSelected = this.track.mode === "showing";
			if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
		}
		handleSelectedLanguageChange(event) {
			if (this.track.mode === "showing") {
				const selectedLanguage = this.player_.cache_.selectedLanguage;
				if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) return;
				this.player_.cache_.selectedLanguage = {
					enabled: true,
					language: this.track.language,
					kind: this.track.kind
				};
			}
		}
		dispose() {
			this.track = null;
			super.dispose();
		}
	};
	Component.registerComponent("TextTrackMenuItem", TextTrackMenuItem);
	/**
	* @file off-text-track-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* A special menu item for turning off a specific type of text track
	*
	* @extends TextTrackMenuItem
	*/
	var OffTextTrackMenuItem = class extends TextTrackMenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			options.track = {
				player,
				kind: options.kind,
				kinds: options.kinds,
				default: false,
				mode: "disabled"
			};
			if (!options.kinds) options.kinds = [options.kind];
			if (options.label) options.track.label = options.label;
			else options.track.label = options.kinds.join(" and ") + " off";
			options.selectable = true;
			options.multiSelectable = false;
			super(player, options);
		}
		/**
		* Handle text track change
		*
		* @param {Event} event
		*        The event that caused this function to run
		*/
		handleTracksChange(event) {
			const tracks = this.player().textTracks();
			let shouldBeSelected = true;
			for (let i = 0, l = tracks.length; i < l; i++) {
				const track = tracks[i];
				if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === "showing") {
					shouldBeSelected = false;
					break;
				}
			}
			if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
		}
		handleSelectedLanguageChange(event) {
			const tracks = this.player().textTracks();
			let allHidden = true;
			for (let i = 0, l = tracks.length; i < l; i++) {
				const track = tracks[i];
				if ([
					"captions",
					"descriptions",
					"subtitles"
				].indexOf(track.kind) > -1 && track.mode === "showing") {
					allHidden = false;
					break;
				}
			}
			if (allHidden) this.player_.cache_.selectedLanguage = { enabled: false };
		}
		/**
		* Update control text and label on languagechange
		*/
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label);
			super.handleLanguagechange();
		}
	};
	Component.registerComponent("OffTextTrackMenuItem", OffTextTrackMenuItem);
	/**
	* @file text-track-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The base class for buttons that toggle specific text track types (e.g. subtitles)
	*
	* @extends MenuButton
	*/
	var TextTrackButton = class extends TrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			options.tracks = player.textTracks();
			super(player, options);
		}
		/**
		* Create a menu item for each text track
		*
		* @param {TextTrackMenuItem[]} [items=[]]
		*        Existing array of items to use during creation
		*
		* @return {TextTrackMenuItem[]}
		*         Array of menu items that were created
		*/
		createItems(items = [], TrackMenuItem = TextTrackMenuItem) {
			let label;
			if (this.label_) label = `${this.label_} off`;
			items.push(new OffTextTrackMenuItem(this.player_, {
				kinds: this.kinds_,
				kind: this.kind_,
				label
			}));
			this.hideThreshold_ += 1;
			const tracks = this.player_.textTracks();
			if (!Array.isArray(this.kinds_)) this.kinds_ = [this.kind_];
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				if (this.kinds_.indexOf(track.kind) > -1) {
					const item = new TrackMenuItem(this.player_, {
						track,
						kinds: this.kinds_,
						kind: this.kind_,
						selectable: true,
						multiSelectable: false
					});
					item.addClass(`vjs-${track.kind}-menu-item`);
					items.push(item);
				}
			}
			return items;
		}
	};
	Component.registerComponent("TextTrackButton", TextTrackButton);
	/**
	* @file chapters-track-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* The chapter track menu item
	*
	* @extends MenuItem
	*/
	var ChaptersTrackMenuItem = class extends MenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			const track = options.track;
			const cue = options.cue;
			const currentTime = player.currentTime();
			options.selectable = true;
			options.multiSelectable = false;
			options.label = cue.text;
			options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
			super(player, options);
			this.track = track;
			this.cue = cue;
		}
		/**
		* This gets called when an `ChaptersTrackMenuItem` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			super.handleClick();
			this.player_.currentTime(this.cue.startTime);
		}
	};
	Component.registerComponent("ChaptersTrackMenuItem", ChaptersTrackMenuItem);
	/**
	* @file chapters-button.js
	*/
	/** @import Player from '../../player' */
	/** @import Menu from '../../menu/menu' */
	/** @import TextTrack from '../../tracks/text-track' */
	/** @import TextTrackMenuItem from '../text-track-controls/text-track-menu-item' */
	/**
	* The button component for toggling and selecting chapters
	* Chapters act much differently than other text tracks
	* Cues are navigation vs. other tracks of alternative languages
	*
	* @extends TextTrackButton
	*/
	var ChaptersButton = class extends TextTrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when this function is ready.
		*/
		constructor(player, options, ready) {
			super(player, options, ready);
			this.setIcon("chapters");
			this.selectCurrentItem_ = () => {
				this.items.forEach((item) => {
					item.selected(this.track_.activeCues[0] === item.cue);
				});
			};
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-chapters-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
		}
		/**
		* Update the menu based on the current state of its items.
		*
		* @param {Event} [event]
		*        An event that triggered this function to run.
		*
		* @listens TextTrackList#addtrack
		* @listens TextTrackList#removetrack
		* @listens TextTrackList#change
		*/
		update(event) {
			if (event && event.track && event.track.kind !== "chapters") return;
			const track = this.findChaptersTrack();
			if (track !== this.track_) {
				this.setTrack(track);
				super.update();
			} else if (!this.items || track && track.cues && track.cues.length !== this.items.length) super.update();
		}
		/**
		* Set the currently selected track for the chapters button.
		*
		* @param {TextTrack} track
		*        The new track to select. Nothing will change if this is the currently selected
		*        track.
		*/
		setTrack(track) {
			if (this.track_ === track) return;
			if (!this.updateHandler_) this.updateHandler_ = this.update.bind(this);
			if (this.track_) {
				const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
				if (remoteTextTrackEl) remoteTextTrackEl.removeEventListener("load", this.updateHandler_);
				this.track_.removeEventListener("cuechange", this.selectCurrentItem_);
				this.track_ = null;
			}
			this.track_ = track;
			if (this.track_) {
				this.track_.mode = "hidden";
				const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
				if (remoteTextTrackEl) remoteTextTrackEl.addEventListener("load", this.updateHandler_);
				this.track_.addEventListener("cuechange", this.selectCurrentItem_);
			}
		}
		/**
		* Find the track object that is currently in use by this ChaptersButton
		*
		* @return {TextTrack|undefined}
		*         The current track or undefined if none was found.
		*/
		findChaptersTrack() {
			const tracks = this.player_.textTracks() || [];
			for (let i = tracks.length - 1; i >= 0; i--) {
				const track = tracks[i];
				if (track.kind === this.kind_) return track;
			}
		}
		/**
		* Get the caption for the ChaptersButton based on the track label. This will also
		* use the current tracks localized kind as a fallback if a label does not exist.
		*
		* @return {string}
		*         The tracks current label or the localized track kind.
		*/
		getMenuCaption() {
			if (this.track_ && this.track_.label) return this.track_.label;
			return this.localize(toTitleCase(this.kind_));
		}
		/**
		* Create menu from chapter track
		*
		* @return {Menu}
		*         New menu for the chapter buttons
		*/
		createMenu() {
			this.options_.title = this.getMenuCaption();
			return super.createMenu();
		}
		/**
		* Create a menu item for each text track
		*
		* @return  {TextTrackMenuItem[]}
		*         Array of menu items
		*/
		createItems() {
			const items = [];
			if (!this.track_) return items;
			const cues = this.track_.cues;
			if (!cues) return items;
			for (let i = 0, l = cues.length; i < l; i++) {
				const cue = cues[i];
				const mi = new ChaptersTrackMenuItem(this.player_, {
					track: this.track_,
					cue
				});
				items.push(mi);
			}
			return items;
		}
	};
	/**
	* `kind` of TextTrack to look for to associate it with this menu.
	*
	* @type {string}
	* @private
	*/
	ChaptersButton.prototype.kind_ = "chapters";
	/**
	* The text that should display over the `ChaptersButton`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	ChaptersButton.prototype.controlText_ = "Chapters";
	Component.registerComponent("ChaptersButton", ChaptersButton);
	/**
	* @file descriptions-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The button component for toggling and selecting descriptions
	*
	* @extends TextTrackButton
	*/
	var DescriptionsButton = class extends TextTrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when this component is ready.
		*/
		constructor(player, options, ready) {
			super(player, options, ready);
			this.setIcon("audio-description");
			const tracks = player.textTracks();
			const changeHandler = bind_(this, this.handleTracksChange);
			tracks.addEventListener("change", changeHandler);
			this.on("dispose", function() {
				tracks.removeEventListener("change", changeHandler);
			});
		}
		/**
		* Handle text track change
		*
		* @param {Event} event
		*        The event that caused this function to run
		*
		* @listens TextTrackList#change
		*/
		handleTracksChange(event) {
			const tracks = this.player().textTracks();
			let disabled = false;
			for (let i = 0, l = tracks.length; i < l; i++) {
				const track = tracks[i];
				if (track.kind !== this.kind_ && track.mode === "showing") {
					disabled = true;
					break;
				}
			}
			if (disabled) this.disable();
			else this.enable();
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-descriptions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
		}
	};
	/**
	* `kind` of TextTrack to look for to associate it with this menu.
	*
	* @type {string}
	* @private
	*/
	DescriptionsButton.prototype.kind_ = "descriptions";
	/**
	* The text that should display over the `DescriptionsButton`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	DescriptionsButton.prototype.controlText_ = "Descriptions";
	Component.registerComponent("DescriptionsButton", DescriptionsButton);
	/**
	* @file subtitles-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The button component for toggling and selecting subtitles
	*
	* @extends TextTrackButton
	*/
	var SubtitlesButton = class extends TextTrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when this component is ready.
		*/
		constructor(player, options, ready) {
			super(player, options, ready);
			this.setIcon("subtitles");
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-subtitles-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
		}
	};
	/**
	* `kind` of TextTrack to look for to associate it with this menu.
	*
	* @type {string}
	* @private
	*/
	SubtitlesButton.prototype.kind_ = "subtitles";
	/**
	* The text that should display over the `SubtitlesButton`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	SubtitlesButton.prototype.controlText_ = "Subtitles";
	Component.registerComponent("SubtitlesButton", SubtitlesButton);
	/**
	* @file caption-settings-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* The menu item for caption track settings menu
	*
	* @extends TextTrackMenuItem
	*/
	var CaptionSettingsMenuItem = class extends TextTrackMenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			options.track = {
				player,
				kind: options.kind,
				label: options.kind + " settings",
				selectable: false,
				default: false,
				mode: "disabled"
			};
			options.selectable = false;
			options.name = "CaptionSettingsMenuItem";
			super(player, options);
			this.addClass("vjs-texttrack-settings");
			this.controlText(", opens " + options.kind + " settings dialog");
		}
		/**
		* This gets called when an `CaptionSettingsMenuItem` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			this.player().getChild("textTrackSettings").open();
		}
		/**
		* Update control text and label on languagechange
		*/
		handleLanguagechange() {
			this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings");
			super.handleLanguagechange();
		}
	};
	Component.registerComponent("CaptionSettingsMenuItem", CaptionSettingsMenuItem);
	/**
	* @file captions-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The button component for toggling and selecting captions
	*
	* @extends TextTrackButton
	*/
	var CaptionsButton = class extends TextTrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when this component is ready.
		*/
		constructor(player, options, ready) {
			super(player, options, ready);
			this.setIcon("captions");
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-captions-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
		}
		/**
		* Create caption menu items
		*
		* @return {CaptionSettingsMenuItem[]}
		*         The array of current menu items.
		*/
		createItems() {
			const items = [];
			if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
				items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.kind_ }));
				this.hideThreshold_ += 1;
			}
			return super.createItems(items);
		}
	};
	/**
	* `kind` of TextTrack to look for to associate it with this menu.
	*
	* @type {string}
	* @private
	*/
	CaptionsButton.prototype.kind_ = "captions";
	/**
	* The text that should display over the `CaptionsButton`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	CaptionsButton.prototype.controlText_ = "Captions";
	Component.registerComponent("CaptionsButton", CaptionsButton);
	/**
	* @file subs-caps-menu-item.js
	*/
	/**
	* SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
	* in the SubsCapsMenu.
	*
	* @extends TextTrackMenuItem
	*/
	var SubsCapsMenuItem = class extends TextTrackMenuItem {
		createEl(type, props, attrs) {
			const el = super.createEl(type, props, attrs);
			const parentSpan = el.querySelector(".vjs-menu-item-text");
			if (this.options_.track.kind === "captions") {
				if (this.player_.options_.experimentalSvgIcons) this.setIcon("captions", el);
				else parentSpan.appendChild(createEl("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": true }));
				parentSpan.appendChild(createEl("span", {
					className: "vjs-control-text",
					textContent: ` ${this.localize("Captions")}`
				}));
			}
			return el;
		}
	};
	Component.registerComponent("SubsCapsMenuItem", SubsCapsMenuItem);
	/**
	* @file sub-caps-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The button component for toggling and selecting captions and/or subtitles
	*
	* @extends TextTrackButton
	*/
	var SubsCapsButton = class extends TextTrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        The function to call when this component is ready.
		*/
		constructor(player, options = {}) {
			super(player, options);
			this.label_ = "subtitles";
			this.setIcon("subtitles");
			if ([
				"en",
				"en-us",
				"en-ca",
				"fr-ca"
			].indexOf(this.player_.language_) > -1) {
				this.label_ = "captions";
				this.setIcon("captions");
			}
			this.menuButton_.controlText(toTitleCase(this.label_));
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-subs-caps-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
		}
		/**
		* Create caption/subtitles menu items
		*
		* @return {CaptionSettingsMenuItem[]}
		*         The array of current menu items.
		*/
		createItems() {
			let items = [];
			if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
				items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.label_ }));
				this.hideThreshold_ += 1;
			}
			items = super.createItems(items, SubsCapsMenuItem);
			return items;
		}
	};
	/**
	* `kind`s of TextTrack to look for to associate it with this menu.
	*
	* @type {array}
	* @private
	*/
	SubsCapsButton.prototype.kinds_ = ["captions", "subtitles"];
	/**
	* The text that should display over the `SubsCapsButton`s controls.
	*
	*
	* @type {string}
	* @protected
	*/
	SubsCapsButton.prototype.controlText_ = "Subtitles";
	Component.registerComponent("SubsCapsButton", SubsCapsButton);
	/**
	* @file audio-track-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* An {@link AudioTrack} {@link MenuItem}
	*
	* @extends MenuItem
	*/
	var AudioTrackMenuItem = class extends MenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			const track = options.track;
			const tracks = player.audioTracks();
			options.label = track.label || track.language || "Unknown";
			options.selected = track.enabled;
			super(player, options);
			this.track = track;
			this.addClass(`vjs-${track.kind}-menu-item`);
			const changeHandler = (...args) => {
				this.handleTracksChange.apply(this, args);
			};
			tracks.addEventListener("change", changeHandler);
			this.on("dispose", () => {
				tracks.removeEventListener("change", changeHandler);
			});
		}
		createEl(type, props, attrs) {
			const el = super.createEl(type, props, attrs);
			const parentSpan = el.querySelector(".vjs-menu-item-text");
			if (["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0) {
				parentSpan.appendChild(createEl("span", { className: "vjs-icon-placeholder" }, { "aria-hidden": true }));
				parentSpan.appendChild(createEl("span", {
					className: "vjs-control-text",
					textContent: " " + this.localize("Descriptions")
				}));
			}
			return el;
		}
		/**
		* This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
		* for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			super.handleClick(event);
			this.track.enabled = true;
			if (this.player_.tech_.featuresNativeAudioTracks) {
				const tracks = this.player_.audioTracks();
				for (let i = 0; i < tracks.length; i++) {
					const track = tracks[i];
					if (track === this.track) continue;
					track.enabled = track === this.track;
				}
			}
		}
		/**
		* Handle any {@link AudioTrack} change.
		*
		* @param {Event} [event]
		*        The {@link AudioTrackList#change} event that caused this to run.
		*
		* @listens AudioTrackList#change
		*/
		handleTracksChange(event) {
			this.selected(this.track.enabled);
		}
	};
	Component.registerComponent("AudioTrackMenuItem", AudioTrackMenuItem);
	/**
	* @file audio-track-button.js
	*/
	/**
	* The base class for buttons that toggle specific {@link AudioTrack} types.
	*
	* @extends TrackButton
	*/
	var AudioTrackButton = class extends TrackButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options={}]
		*        The key/value store of player options.
		*/
		constructor(player, options = {}) {
			options.tracks = player.audioTracks();
			super(player, options);
			this.setIcon("audio");
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-audio-button ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
		}
		/**
		* Create a menu item for each audio track
		*
		* @param {AudioTrackMenuItem[]} [items=[]]
		*        An array of existing menu items to use.
		*
		* @return {AudioTrackMenuItem[]}
		*         An array of menu items
		*/
		createItems(items = []) {
			this.hideThreshold_ = 1;
			const tracks = this.player_.audioTracks();
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				items.push(new AudioTrackMenuItem(this.player_, {
					track,
					selectable: true,
					multiSelectable: false
				}));
			}
			return items;
		}
	};
	/**
	* The text that should display over the `AudioTrackButton`s controls. Added for localization.
	*
	* @type {string}
	* @protected
	*/
	AudioTrackButton.prototype.controlText_ = "Audio Track";
	Component.registerComponent("AudioTrackButton", AudioTrackButton);
	/**
	* @file playback-rate-menu-item.js
	*/
	/** @import Player from '../../player' */
	/**
	* The specific menu item type for selecting a playback rate.
	*
	* @extends MenuItem
	*/
	var PlaybackRateMenuItem = class extends MenuItem {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			const label = options.rate;
			const rate = parseFloat(label, 10);
			options.label = label;
			options.selected = rate === player.playbackRate();
			options.selectable = true;
			options.multiSelectable = false;
			super(player, options);
			this.label = label;
			this.rate = rate;
			this.on(player, "ratechange", (e) => this.update(e));
		}
		/**
		* This gets called when an `PlaybackRateMenuItem` is "clicked". See
		* {@link ClickableComponent} for more detailed information on what a click can be.
		*
		* @param {Event} [event]
		*        The `keydown`, `tap`, or `click` event that caused this function to be
		*        called.
		*
		* @listens tap
		* @listens click
		*/
		handleClick(event) {
			super.handleClick();
			this.player().playbackRate(this.rate);
		}
		/**
		* Update the PlaybackRateMenuItem when the playbackrate changes.
		*
		* @param {Event} [event]
		*        The `ratechange` event that caused this function to run.
		*
		* @listens Player#ratechange
		*/
		update(event) {
			this.selected(this.player().playbackRate() === this.rate);
		}
	};
	/**
	* The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	*
	* @type {string}
	* @private
	*/
	PlaybackRateMenuItem.prototype.contentElType = "button";
	Component.registerComponent("PlaybackRateMenuItem", PlaybackRateMenuItem);
	/**
	* @file playback-rate-menu-button.js
	*/
	/** @import Player from '../../player' */
	/**
	* The component for controlling the playback rate.
	*
	* @extends MenuButton
	*/
	var PlaybackRateMenuButton = class extends MenuButton {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_);
			this.updateVisibility();
			this.updateLabel();
			this.on(player, "loadstart", (e) => this.updateVisibility(e));
			this.on(player, "ratechange", (e) => this.updateLabel(e));
			this.on(player, "playbackrateschange", (e) => this.handlePlaybackRateschange(e));
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			const el = super.createEl();
			this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_;
			this.labelEl_ = createEl("div", {
				className: "vjs-playback-rate-value",
				id: this.labelElId_,
				textContent: "1x"
			});
			el.appendChild(this.labelEl_);
			return el;
		}
		dispose() {
			this.labelEl_ = null;
			super.dispose();
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-playback-rate ${super.buildCSSClass()}`;
		}
		buildWrapperCSSClass() {
			return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
		}
		/**
		* Create the list of menu items. Specific to each subclass.
		*
		*/
		createItems() {
			const rates = this.playbackRates();
			const items = [];
			for (let i = rates.length - 1; i >= 0; i--) items.push(new PlaybackRateMenuItem(this.player(), { rate: rates[i] + "x" }));
			return items;
		}
		/**
		* On playbackrateschange, update the menu to account for the new items.
		*
		* @listens Player#playbackrateschange
		*/
		handlePlaybackRateschange(event) {
			this.update();
		}
		/**
		* Get possible playback rates
		*
		* @return {Array}
		*         All possible playback rates
		*/
		playbackRates() {
			const player = this.player();
			return player.playbackRates && player.playbackRates() || [];
		}
		/**
		* Get whether playback rates is supported by the tech
		* and an array of playback rates exists
		*
		* @return {boolean}
		*         Whether changing playback rate is supported
		*/
		playbackRateSupported() {
			return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
		}
		/**
		* Hide playback rate controls when they're no playback rate options to select
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#loadstart
		*/
		updateVisibility(event) {
			if (this.playbackRateSupported()) this.removeClass("vjs-hidden");
			else this.addClass("vjs-hidden");
		}
		/**
		* Update button label when rate changed
		*
		* @param {Event} [event]
		*        The event that caused this function to run.
		*
		* @listens Player#ratechange
		*/
		updateLabel(event) {
			if (this.playbackRateSupported()) this.labelEl_.textContent = this.player().playbackRate() + "x";
		}
	};
	/**
	* The text that should display over the `PlaybackRateMenuButton`s controls.
	*
	* Added for localization.
	*
	* @type {string}
	* @protected
	*/
	PlaybackRateMenuButton.prototype.controlText_ = "Playback Rate";
	Component.registerComponent("PlaybackRateMenuButton", PlaybackRateMenuButton);
	/**
	* @file spacer.js
	*/
	/**
	* Just an empty spacer element that can be used as an append point for plugins, etc.
	* Also can be used to create space between elements when necessary.
	*
	* @extends Component
	*/
	var Spacer = class extends Component {
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-spacer ${super.buildCSSClass()}`;
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl(tag = "div", props = {}, attributes = {}) {
			if (!props.className) props.className = this.buildCSSClass();
			return super.createEl(tag, props, attributes);
		}
	};
	Component.registerComponent("Spacer", Spacer);
	/**
	* @file custom-control-spacer.js
	*/
	/**
	* Spacer specifically meant to be used as an insertion point for new plugins, etc.
	*
	* @extends Spacer
	*/
	var CustomControlSpacer = class extends Spacer {
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*/
		buildCSSClass() {
			return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
		}
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", {
				className: this.buildCSSClass(),
				textContent: "\xA0"
			});
		}
	};
	Component.registerComponent("CustomControlSpacer", CustomControlSpacer);
	/**
	* @file control-bar.js
	*/
	/**
	* Container of main controls.
	*
	* @extends Component
	*/
	var ControlBar = class extends Component {
		/**
		* Create the `Component`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			return super.createEl("div", {
				className: "vjs-control-bar",
				dir: "ltr"
			});
		}
	};
	/**
	* Default options for `ControlBar`
	*
	* @type {Object}
	* @private
	*/
	ControlBar.prototype.options_ = { children: [
		"playToggle",
		"skipBackward",
		"skipForward",
		"volumePanel",
		"currentTimeDisplay",
		"timeDivider",
		"durationDisplay",
		"progressControl",
		"liveDisplay",
		"seekToLive",
		"remainingTimeDisplay",
		"customControlSpacer",
		"playbackRateMenuButton",
		"chaptersButton",
		"descriptionsButton",
		"subsCapsButton",
		"audioTrackButton",
		"pictureInPictureToggle",
		"fullscreenToggle"
	] };
	Component.registerComponent("ControlBar", ControlBar);
	/**
	* @file error-display.js
	*/
	/** @import Player from './player' */
	/**
	* A display that indicates an error has occurred. This means that the video
	* is unplayable.
	*
	* @extends ModalDialog
	*/
	var ErrorDisplay = class extends ModalDialog {
		/**
		* Creates an instance of this class.
		*
		* @param  {Player} player
		*         The `Player` that this class should be attached to.
		*
		* @param  {Object} [options]
		*         The key/value store of player options.
		*/
		constructor(player, options) {
			super(player, options);
			this.on(player, "error", (e) => {
				this.open(e);
			});
		}
		/**
		* Builds the default DOM `className`.
		*
		* @return {string}
		*         The DOM `className` for this object.
		*
		* @deprecated Since version 5.
		*/
		buildCSSClass() {
			return `vjs-error-display ${super.buildCSSClass()}`;
		}
		/**
		* Gets the localized error message based on the `Player`s error.
		*
		* @return {string}
		*         The `Player`s error message localized or an empty string.
		*/
		content() {
			const error = this.player().error();
			return error ? this.localize(error.message) : "";
		}
	};
	/**
	* The default options for an `ErrorDisplay`.
	*
	* @private
	*/
	ErrorDisplay.prototype.options_ = Object.assign({}, ModalDialog.prototype.options_, {
		pauseOnOpen: false,
		fillAlways: true,
		temporary: false,
		uncloseable: true
	});
	Component.registerComponent("ErrorDisplay", ErrorDisplay);
	/** @import Player from './player' */
	/** @import { ContentDescriptor } from  '../utils/dom' */
	/**
	* Creates DOM element of 'select' & its options.
	*
	* @extends Component
	*/
	var TextTrackSelect = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {ContentDescriptor} [options.content=undefined]
		*        Provide customized content for this modal.
		*
		* @param {string} [options.legendId]
		*        A text with part of an string to create atribute of aria-labelledby.
		*
		* @param {string} [options.id]
		*        A text with part of an string to create atribute of aria-labelledby.
		*
		* @param {Array} [options.SelectOptions]
		*        Array that contains the value & textContent of for each of the
		*        options elements.
		*/
		constructor(player, options = {}) {
			super(player, options);
			this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
		}
		/**
		* Create the `TextTrackSelect`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim();
			return createEl("select", { id: this.options_.id }, {}, this.options_.SelectOptions.map((optionText) => {
				const optionId = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${newGUID()}`) + "-" + optionText[1].replace(/\W+/g, "");
				const option = createEl("option", {
					id: optionId,
					value: this.localize(optionText[0]),
					textContent: this.localize(optionText[1])
				});
				option.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${optionId}`);
				return option;
			}));
		}
	};
	Component.registerComponent("TextTrackSelect", TextTrackSelect);
	/** @import Player from './player' */
	/** @import { ContentDescriptor } from '../utils/dom' */
	/**
	* Creates fieldset section of 'TextTrackSettings'.
	* Manganes two versions of fieldsets, one for type of 'colors'
	* & the other for 'font', Component adds diferent DOM elements
	* to that fieldset  depending on the type.
	*
	* @extends Component
	*/
	var TextTrackFieldset = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {ContentDescriptor} [options.content=undefined]
		*        Provide customized content for this modal.
		*
		* @param {string} [options.legendId]
		*        A text with part of an string to create atribute of aria-labelledby.
		*        It passes to 'TextTrackSelect'.
		*
		* @param {string} [options.id]
		*        A text with part of an string to create atribute of aria-labelledby.
		*        It passes to 'TextTrackSelect'.
		*
		* @param {string} [options.legendText]
		*        A text to use as the text content of the legend element.
		*
		* @param {Array} [options.selects]
		*        Array that contains the selects that are use to create 'selects'
		*        components.
		*
		* @param {Array} [options.SelectOptions]
		*        Array that contains the value & textContent of for each of the
		*        options elements, it passes to 'TextTrackSelect'.
		*
		* @param {string} [options.type]
		*        Conditions if some DOM elements will be added to the fieldset
		*        component.
		*
		* @param {Object} [options.selectConfigs]
		*        Object with the following properties that are the selects configurations:
		*        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
		*        fontPercent, textOpacity, windowColor, windowOpacity.
		*        These properties are use to configure the 'TextTrackSelect' Component.
		*/
		constructor(player, options = {}) {
			super(player, options);
			const legendElement = createEl("legend", {
				textContent: this.localize(this.options_.legendText),
				id: this.options_.legendId
			});
			this.el().appendChild(legendElement);
			const selects = this.options_.selects;
			for (const i of selects) {
				const selectConfig = this.options_.selectConfigs[i];
				const selectClassName = selectConfig.className;
				const id = selectConfig.id.replace("%s", this.options_.id_);
				let span = null;
				const guid = `vjs_select_${newGUID()}`;
				if (this.options_.type === "colors") {
					span = createEl("span", { className: selectClassName });
					const label = createEl("label", {
						id,
						className: "vjs-label",
						textContent: this.localize(selectConfig.label)
					});
					label.setAttribute("for", guid);
					span.appendChild(label);
				}
				const textTrackSelect = new TextTrackSelect(player, {
					SelectOptions: selectConfig.options,
					legendId: this.options_.legendId,
					id: guid,
					labelId: id
				});
				this.addChild(textTrackSelect);
				if (this.options_.type === "colors") {
					span.appendChild(textTrackSelect.el());
					this.el().appendChild(span);
				}
			}
		}
		/**
		* Create the `TextTrackFieldset`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			return createEl("fieldset", { className: this.options_.className });
		}
	};
	Component.registerComponent("TextTrackFieldset", TextTrackFieldset);
	/** @import Player from './player' */
	/** @import { ContentDescriptor } from  '../utils/dom' */
	/**
	* The component 'TextTrackSettingsColors' displays a set of 'fieldsets'
	* using the component 'TextTrackFieldset'.
	*
	* @extends Component
	*/
	var TextTrackSettingsColors = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {ContentDescriptor} [options.content=undefined]
		*        Provide customized content for this modal.
		*
		* @param {Array} [options.fieldSets]
		*        Array that contains the configurations for the selects.
		*
		* @param {Object} [options.selectConfigs]
		*        Object with the following properties that are the select confugations:
		*        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
		*        fontPercent, textOpacity, windowColor, windowOpacity.
		*        it passes to 'TextTrackFieldset'.
		*/
		constructor(player, options = {}) {
			super(player, options);
			const id_ = this.options_.textTrackComponentid;
			const ElFgColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-text-legend-${id_}`,
				legendText: this.localize("Text"),
				className: "vjs-fg vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(ElFgColorFieldset);
			const ElBgColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-background-${id_}`,
				legendText: this.localize("Text Background"),
				className: "vjs-bg vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(ElBgColorFieldset);
			const ElWinColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-window-${id_}`,
				legendText: this.localize("Caption Area Background"),
				className: "vjs-window vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "colors"
			});
			this.addChild(ElWinColorFieldset);
		}
		/**
		* Create the `TextTrackSettingsColors`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			return createEl("div", { className: "vjs-track-settings-colors" });
		}
	};
	Component.registerComponent("TextTrackSettingsColors", TextTrackSettingsColors);
	/** @import Player from './player' */
	/** @import { ContentDescriptor } from  '../utils/dom' */
	/**
	* The component 'TextTrackSettingsFont' displays a set of 'fieldsets'
	* using the component 'TextTrackFieldset'.
	*
	* @extends Component
	*/
	var TextTrackSettingsFont = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {ContentDescriptor} [options.content=undefined]
		*        Provide customized content for this modal.
		*
		* @param {Array} [options.fieldSets]
		*        Array that contains the configurations for the selects.
		*
		* @param {Object} [options.selectConfigs]
		*        Object with the following properties that are the select confugations:
		*        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
		*        fontPercent, textOpacity, windowColor, windowOpacity.
		*        it passes to 'TextTrackFieldset'.
		*/
		constructor(player, options = {}) {
			super(player, options);
			const id_ = this.options_.textTrackComponentid;
			const ElFgColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-font-size-${id_}`,
				legendText: "Font Size",
				className: "vjs-font-percent vjs-track-setting",
				selects: this.options_.fieldSets[0],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(ElFgColorFieldset);
			const ElBgColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-edge-style-${id_}`,
				legendText: this.localize("Text Edge Style"),
				className: "vjs-edge-style vjs-track-setting",
				selects: this.options_.fieldSets[1],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(ElBgColorFieldset);
			const ElWinColorFieldset = new TextTrackFieldset(player, {
				id_,
				legendId: `captions-font-family-${id_}`,
				legendText: this.localize("Font Family"),
				className: "vjs-font-family vjs-track-setting",
				selects: this.options_.fieldSets[2],
				selectConfigs: this.options_.selectConfigs,
				type: "font"
			});
			this.addChild(ElWinColorFieldset);
		}
		/**
		* Create the `TextTrackSettingsFont`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			return createEl("div", { className: "vjs-track-settings-font" });
		}
	};
	Component.registerComponent("TextTrackSettingsFont", TextTrackSettingsFont);
	/**
	* Buttons of reset & done that modal 'TextTrackSettings'
	* uses as part of its content.
	*
	* 'Reset': Resets all settings on 'TextTrackSettings'.
	* 'Done': Closes 'TextTrackSettings' modal.
	*
	* @extends Component
	*/
	var TrackSettingsControls = class extends Component {
		constructor(player, options = {}) {
			super(player, options);
			const resetButton = new Button(player, {
				controlText: this.localize("restore all settings to the default values"),
				className: "vjs-default-button"
			});
			resetButton.el().classList.remove("vjs-control", "vjs-button");
			resetButton.el().textContent = this.localize("Reset");
			this.addChild(resetButton);
			const doneText = this.localize("Done");
			const doneButton = new Button(player, {
				controlText: doneText,
				className: "vjs-done-button"
			});
			doneButton.el().classList.remove("vjs-control", "vjs-button");
			doneButton.el().textContent = doneText;
			this.addChild(doneButton);
		}
		/**
		* Create the `TrackSettingsControls`'s DOM element
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			return createEl("div", { className: "vjs-track-settings-controls" });
		}
	};
	Component.registerComponent("TrackSettingsControls", TrackSettingsControls);
	/**
	* @file text-track-settings.js
	*/
	/** @import Player from '../player' */
	var LOCAL_STORAGE_KEY = "vjs-text-track-settings";
	var COLOR_BLACK = ["#000", "Black"];
	var COLOR_BLUE = ["#00F", "Blue"];
	var COLOR_CYAN = ["#0FF", "Cyan"];
	var COLOR_GREEN = ["#0F0", "Green"];
	var COLOR_MAGENTA = ["#F0F", "Magenta"];
	var COLOR_RED = ["#F00", "Red"];
	var COLOR_WHITE = ["#FFF", "White"];
	var COLOR_YELLOW = ["#FF0", "Yellow"];
	var OPACITY_OPAQUE = ["1", "Opaque"];
	var OPACITY_SEMI = ["0.5", "Semi-Transparent"];
	var OPACITY_TRANS = ["0", "Transparent"];
	var selectConfigs = {
		backgroundColor: {
			selector: ".vjs-bg-color > select",
			id: "captions-background-color-%s",
			label: "Color",
			options: [
				COLOR_BLACK,
				COLOR_WHITE,
				COLOR_RED,
				COLOR_GREEN,
				COLOR_BLUE,
				COLOR_YELLOW,
				COLOR_MAGENTA,
				COLOR_CYAN
			],
			className: "vjs-bg-color"
		},
		backgroundOpacity: {
			selector: ".vjs-bg-opacity > select",
			id: "captions-background-opacity-%s",
			label: "Opacity",
			options: [
				OPACITY_OPAQUE,
				OPACITY_SEMI,
				OPACITY_TRANS
			],
			className: "vjs-bg-opacity vjs-opacity"
		},
		color: {
			selector: ".vjs-text-color > select",
			id: "captions-foreground-color-%s",
			label: "Color",
			options: [
				COLOR_WHITE,
				COLOR_BLACK,
				COLOR_RED,
				COLOR_GREEN,
				COLOR_BLUE,
				COLOR_YELLOW,
				COLOR_MAGENTA,
				COLOR_CYAN
			],
			className: "vjs-text-color"
		},
		edgeStyle: {
			selector: ".vjs-edge-style > select",
			id: "",
			label: "Text Edge Style",
			options: [
				["none", "None"],
				["raised", "Raised"],
				["depressed", "Depressed"],
				["uniform", "Uniform"],
				["dropshadow", "Drop shadow"]
			]
		},
		fontFamily: {
			selector: ".vjs-font-family > select",
			id: "",
			label: "Font Family",
			options: [
				["proportionalSansSerif", "Proportional Sans-Serif"],
				["monospaceSansSerif", "Monospace Sans-Serif"],
				["proportionalSerif", "Proportional Serif"],
				["monospaceSerif", "Monospace Serif"],
				["casual", "Casual"],
				["script", "Script"],
				["small-caps", "Small Caps"]
			]
		},
		fontPercent: {
			selector: ".vjs-font-percent > select",
			id: "",
			label: "Font Size",
			options: [
				["0.50", "50%"],
				["0.75", "75%"],
				["1.00", "100%"],
				["1.25", "125%"],
				["1.50", "150%"],
				["1.75", "175%"],
				["2.00", "200%"],
				["3.00", "300%"],
				["4.00", "400%"]
			],
			default: 2,
			parser: (v) => v === "1.00" ? null : Number(v)
		},
		textOpacity: {
			selector: ".vjs-text-opacity > select",
			id: "captions-foreground-opacity-%s",
			label: "Opacity",
			options: [OPACITY_OPAQUE, OPACITY_SEMI],
			className: "vjs-text-opacity vjs-opacity"
		},
		windowColor: {
			selector: ".vjs-window-color > select",
			id: "captions-window-color-%s",
			label: "Color",
			className: "vjs-window-color"
		},
		windowOpacity: {
			selector: ".vjs-window-opacity > select",
			id: "captions-window-opacity-%s",
			label: "Opacity",
			options: [
				OPACITY_TRANS,
				OPACITY_SEMI,
				OPACITY_OPAQUE
			],
			className: "vjs-window-opacity vjs-opacity"
		}
	};
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	/**
	* Get the actual value of an option.
	*
	* @param  {string} value
	*         The value to get
	*
	* @param  {Function} [parser]
	*         Optional function to adjust the value.
	*
	* @return {*}
	*         - Will be `undefined` if no value exists
	*         - Will be `undefined` if the given value is "none".
	*         - Will be the actual value otherwise.
	*
	* @private
	*/
	function parseOptionValue(value, parser) {
		if (parser) value = parser(value);
		if (value && value !== "none") return value;
	}
	/**
	* Gets the value of the selected <option> element within a <select> element.
	*
	* @param  {Element} el
	*         the element to look in
	*
	* @param  {Function} [parser]
	*         Optional function to adjust the value.
	*
	* @return {*}
	*         - Will be `undefined` if no value exists
	*         - Will be `undefined` if the given value is "none".
	*         - Will be the actual value otherwise.
	*
	* @private
	*/
	function getSelectedOptionValue(el, parser) {
		const value = el.options[el.options.selectedIndex].value;
		return parseOptionValue(value, parser);
	}
	/**
	* Sets the selected <option> element within a <select> element based on a
	* given value.
	*
	* @param {Element} el
	*        The element to look in.
	*
	* @param {string} value
	*        the property to look on.
	*
	* @param {Function} [parser]
	*        Optional function to adjust the value before comparing.
	*
	* @private
	*/
	function setSelectedOption(el, value, parser) {
		if (!value) return;
		for (let i = 0; i < el.options.length; i++) if (parseOptionValue(el.options[i].value, parser) === value) {
			el.selectedIndex = i;
			break;
		}
	}
	/**
	* Manipulate Text Tracks settings.
	*
	* @extends ModalDialog
	*/
	var TextTrackSettings = class extends ModalDialog {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*         The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*         The key/value store of player options.
		*/
		constructor(player, options) {
			options.temporary = false;
			super(player, options);
			this.updateDisplay = this.updateDisplay.bind(this);
			this.fill();
			this.hasBeenOpened_ = this.hasBeenFilled_ = true;
			this.renderModalComponents(player);
			this.endDialog = createEl("p", {
				className: "vjs-control-text",
				textContent: this.localize("End of dialog window.")
			});
			this.el().appendChild(this.endDialog);
			this.setDefaults();
			if (options.persistTextTrackSettings === void 0) this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings;
			this.bindFunctionsToSelectsAndButtons();
			if (this.options_.persistTextTrackSettings) this.restoreSettings();
		}
		renderModalComponents(player) {
			const textTrackSettingsColors = new TextTrackSettingsColors(player, {
				textTrackComponentid: this.id_,
				selectConfigs,
				fieldSets: [
					["color", "textOpacity"],
					["backgroundColor", "backgroundOpacity"],
					["windowColor", "windowOpacity"]
				]
			});
			this.addChild(textTrackSettingsColors);
			const textTrackSettingsFont = new TextTrackSettingsFont(player, {
				textTrackComponentid: this.id_,
				selectConfigs,
				fieldSets: [
					["fontPercent"],
					["edgeStyle"],
					["fontFamily"]
				]
			});
			this.addChild(textTrackSettingsFont);
			const trackSettingsControls = new TrackSettingsControls(player);
			this.addChild(trackSettingsControls);
		}
		bindFunctionsToSelectsAndButtons() {
			this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
				this.saveSettings();
				this.close();
			});
			this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
				this.setDefaults();
				this.updateDisplay();
			});
			each(selectConfigs, (config) => {
				this.on(this.$(config.selector), "change", this.updateDisplay);
			});
		}
		dispose() {
			this.endDialog = null;
			super.dispose();
		}
		label() {
			return this.localize("Caption Settings Dialog");
		}
		description() {
			return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
		}
		buildCSSClass() {
			return super.buildCSSClass() + " vjs-text-track-settings";
		}
		/**
		* Gets an object of text track settings (or null).
		*
		* @return {Object}
		*         An object with config values parsed from the DOM or localStorage.
		*/
		getValues() {
			return reduce(selectConfigs, (accum, config, key) => {
				const value = getSelectedOptionValue(this.$(config.selector), config.parser);
				if (value !== void 0) accum[key] = value;
				return accum;
			}, {});
		}
		/**
		* Sets text track settings from an object of values.
		*
		* @param {Object} values
		*        An object with config values parsed from the DOM or localStorage.
		*/
		setValues(values) {
			each(selectConfigs, (config, key) => {
				setSelectedOption(this.$(config.selector), values[key], config.parser);
			});
		}
		/**
		* Sets all `<select>` elements to their default values.
		*/
		setDefaults() {
			each(selectConfigs, (config) => {
				const index = config.hasOwnProperty("default") ? config.default : 0;
				this.$(config.selector).selectedIndex = index;
			});
		}
		/**
		* Restore texttrack settings from localStorage
		*/
		restoreSettings() {
			let values;
			try {
				values = JSON.parse(window__default["default"].localStorage.getItem(LOCAL_STORAGE_KEY));
			} catch (err) {
				log.warn(err);
			}
			if (values) this.setValues(values);
		}
		/**
		* Save text track settings to localStorage
		*/
		saveSettings() {
			if (!this.options_.persistTextTrackSettings) return;
			const values = this.getValues();
			try {
				if (Object.keys(values).length) window__default["default"].localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(values));
				else window__default["default"].localStorage.removeItem(LOCAL_STORAGE_KEY);
			} catch (err) {
				log.warn(err);
			}
		}
		/**
		* Update display of text track settings
		*/
		updateDisplay() {
			const ttDisplay = this.player_.getChild("textTrackDisplay");
			if (ttDisplay) ttDisplay.updateDisplay();
		}
		/**
		* Repopulate dialog with new localizations on languagechange
		*/
		handleLanguagechange() {
			this.fill();
			this.renderModalComponents(this.player_);
			this.bindFunctionsToSelectsAndButtons();
		}
	};
	Component.registerComponent("TextTrackSettings", TextTrackSettings);
	/**
	* @file resize-manager.js
	*/
	/**
	* A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
	*
	* It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
	*
	* If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
	* If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
	*
	* @example <caption>How to disable the resize manager</caption>
	* const player = videojs('#vid', {
	*   resizeManager: false
	* });
	*
	* @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
	*
	* @extends Component
	*/
	var ResizeManager = class extends Component {
		/**
		* Create the ResizeManager.
		*
		* @param {Object} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of ResizeManager options.
		*
		* @param {Object} [options.ResizeObserver]
		*        A polyfill for ResizeObserver can be passed in here.
		*        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
		*/
		constructor(player, options) {
			let RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window__default["default"].ResizeObserver;
			if (options.ResizeObserver === null) RESIZE_OBSERVER_AVAILABLE = false;
			const options_ = merge({
				createEl: !RESIZE_OBSERVER_AVAILABLE,
				reportTouchActivity: false
			}, options);
			super(player, options_);
			this.ResizeObserver = options.ResizeObserver || window__default["default"].ResizeObserver;
			this.loadListener_ = null;
			this.resizeObserver_ = null;
			this.debouncedHandler_ = debounce(() => {
				this.resizeHandler();
			}, 100, false, this);
			if (RESIZE_OBSERVER_AVAILABLE) {
				this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_);
				this.resizeObserver_.observe(player.el());
			} else {
				this.loadListener_ = () => {
					if (!this.el_ || !this.el_.contentWindow) return;
					const debouncedHandler_ = this.debouncedHandler_;
					let unloadListener_ = this.unloadListener_ = function() {
						off(this, "resize", debouncedHandler_);
						off(this, "unload", unloadListener_);
						unloadListener_ = null;
					};
					on(this.el_.contentWindow, "unload", unloadListener_);
					on(this.el_.contentWindow, "resize", debouncedHandler_);
				};
				this.one("load", this.loadListener_);
			}
		}
		createEl() {
			return super.createEl("iframe", {
				className: "vjs-resize-manager",
				tabIndex: -1,
				title: this.localize("No content")
			}, { "aria-hidden": "true" });
		}
		/**
		* Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
		*
		* @fires Player#playerresize
		*/
		resizeHandler() {
			/**
			* Called when the player size has changed
			*
			* @event Player#playerresize
			* @type {Event}
			*/
			if (!this.player_ || !this.player_.trigger) return;
			this.player_.trigger("playerresize");
		}
		dispose() {
			if (this.debouncedHandler_) this.debouncedHandler_.cancel();
			if (this.resizeObserver_) {
				if (this.player_.el()) this.resizeObserver_.unobserve(this.player_.el());
				this.resizeObserver_.disconnect();
			}
			if (this.loadListener_) this.off("load", this.loadListener_);
			if (this.el_ && this.el_.contentWindow && this.unloadListener_) this.unloadListener_.call(this.el_.contentWindow);
			this.ResizeObserver = null;
			this.resizeObserver = null;
			this.debouncedHandler_ = null;
			this.loadListener_ = null;
			super.dispose();
		}
	};
	Component.registerComponent("ResizeManager", ResizeManager);
	/** @import Player from './player' */
	var defaults$1 = {
		trackingThreshold: 20,
		liveTolerance: 15
	};
	/**
	* A class for checking live current time and determining when the player
	* is at or behind the live edge.
	*/
	var LiveTracker = class extends Component {
		/**
		* Creates an instance of this class.
		*
		* @param {Player} player
		*        The `Player` that this class should be attached to.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {number} [options.trackingThreshold=20]
		*        Number of seconds of live window (seekableEnd - seekableStart) that
		*        media needs to have before the liveui will be shown.
		*
		* @param {number} [options.liveTolerance=15]
		*        Number of seconds behind live that we have to be
		*        before we will be considered non-live. Note that this will only
		*        be used when playing at the live edge. This allows large seekable end
		*        changes to not effect whether we are live or not.
		*/
		constructor(player, options) {
			const options_ = merge(defaults$1, options, { createEl: false });
			super(player, options_);
			this.trackLiveHandler_ = () => this.trackLive_();
			this.handlePlay_ = (e) => this.handlePlay(e);
			this.handleFirstTimeupdate_ = (e) => this.handleFirstTimeupdate(e);
			this.handleSeeked_ = (e) => this.handleSeeked(e);
			this.seekToLiveEdge_ = (e) => this.seekToLiveEdge(e);
			this.reset_();
			this.on(this.player_, "durationchange", (e) => this.handleDurationchange(e));
			this.on(this.player_, "canplay", () => this.toggleTracking());
		}
		/**
		* all the functionality for tracking when seek end changes
		* and for tracking how far past seek end we should be
		*/
		trackLive_() {
			const seekable = this.player_.seekable();
			if (!seekable || !seekable.length) return;
			const newTime = Number(window__default["default"].performance.now().toFixed(4));
			const deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1e3;
			this.lastTime_ = newTime;
			this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
			const liveCurrentTime = this.liveCurrentTime();
			const currentTime = this.player_.currentTime();
			let isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance;
			if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) isBehind = false;
			if (isBehind !== this.behindLiveEdge_) {
				this.behindLiveEdge_ = isBehind;
				this.trigger("liveedgechange");
			}
		}
		/**
		* handle a durationchange event on the player
		* and start/stop tracking accordingly.
		*/
		handleDurationchange() {
			this.toggleTracking();
		}
		/**
		* start/stop tracking
		*/
		toggleTracking() {
			if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
				if (this.player_.options_.liveui) this.player_.addClass("vjs-liveui");
				this.startTracking();
			} else {
				this.player_.removeClass("vjs-liveui");
				this.stopTracking();
			}
		}
		/**
		* start tracking live playback
		*/
		startTracking() {
			if (this.isTracking()) return;
			if (!this.timeupdateSeen_) this.timeupdateSeen_ = this.player_.hasStarted();
			this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, UPDATE_REFRESH_INTERVAL);
			this.trackLive_();
			this.on(this.player_, ["play", "pause"], this.trackLiveHandler_);
			if (!this.timeupdateSeen_) {
				this.one(this.player_, "play", this.handlePlay_);
				this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_);
			} else this.on(this.player_, "seeked", this.handleSeeked_);
		}
		/**
		* handle the first timeupdate on the player if it wasn't already playing
		* when live tracker started tracking.
		*/
		handleFirstTimeupdate() {
			this.timeupdateSeen_ = true;
			this.on(this.player_, "seeked", this.handleSeeked_);
		}
		/**
		* Keep track of what time a seek starts, and listen for seeked
		* to find where a seek ends.
		*/
		handleSeeked() {
			const timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
			this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
			this.nextSeekedFromUser_ = false;
			this.trackLive_();
		}
		/**
		* handle the first play on the player, and make sure that we seek
		* right to the live edge.
		*/
		handlePlay() {
			this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		/**
		* Stop tracking, and set all internal variables to
		* their initial value.
		*/
		reset_() {
			this.lastTime_ = -1;
			this.pastSeekEnd_ = 0;
			this.lastSeekEnd_ = -1;
			this.behindLiveEdge_ = true;
			this.timeupdateSeen_ = false;
			this.seekedBehindLive_ = false;
			this.nextSeekedFromUser_ = false;
			this.clearInterval(this.trackingInterval_);
			this.trackingInterval_ = null;
			this.off(this.player_, ["play", "pause"], this.trackLiveHandler_);
			this.off(this.player_, "seeked", this.handleSeeked_);
			this.off(this.player_, "play", this.handlePlay_);
			this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_);
			this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
		}
		/**
		* The next seeked event is from the user. Meaning that any seek
		* > 2s behind live will be considered behind live for real and
		* liveTolerance will be ignored.
		*/
		nextSeekedFromUser() {
			this.nextSeekedFromUser_ = true;
		}
		/**
		* stop tracking live playback
		*/
		stopTracking() {
			if (!this.isTracking()) return;
			this.reset_();
			this.trigger("liveedgechange");
		}
		/**
		* A helper to get the player seekable end
		* so that we don't have to null check everywhere
		*
		* @return {number}
		*         The furthest seekable end or Infinity.
		*/
		seekableEnd() {
			const seekable = this.player_.seekable();
			const seekableEnds = [];
			let i = seekable ? seekable.length : 0;
			while (i--) seekableEnds.push(seekable.end(i));
			return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
		}
		/**
		* A helper to get the player seekable start
		* so that we don't have to null check everywhere
		*
		* @return {number}
		*         The earliest seekable start or 0.
		*/
		seekableStart() {
			const seekable = this.player_.seekable();
			const seekableStarts = [];
			let i = seekable ? seekable.length : 0;
			while (i--) seekableStarts.push(seekable.start(i));
			return seekableStarts.length ? seekableStarts.sort()[0] : 0;
		}
		/**
		* Get the live time window aka
		* the amount of time between seekable start and
		* live current time.
		*
		* @return {number}
		*         The amount of seconds that are seekable in
		*         the live video.
		*/
		liveWindow() {
			const liveCurrentTime = this.liveCurrentTime();
			if (liveCurrentTime === Infinity) return 0;
			return liveCurrentTime - this.seekableStart();
		}
		/**
		* Determines if the player is live, only checks if this component
		* is tracking live playback or not
		*
		* @return {boolean}
		*         Whether liveTracker is tracking
		*/
		isLive() {
			return this.isTracking();
		}
		/**
		* Determines if currentTime is at the live edge and won't fall behind
		* on each seekableendchange
		*
		* @return {boolean}
		*         Whether playback is at the live edge
		*/
		atLiveEdge() {
			return !this.behindLiveEdge();
		}
		/**
		* get what we expect the live current time to be
		*
		* @return {number}
		*         The expected live current time
		*/
		liveCurrentTime() {
			return this.pastSeekEnd() + this.seekableEnd();
		}
		/**
		* The number of seconds that have occurred after seekable end
		* changed. This will be reset to 0 once seekable end changes.
		*
		* @return {number}
		*         Seconds past the current seekable end
		*/
		pastSeekEnd() {
			const seekableEnd = this.seekableEnd();
			if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) this.pastSeekEnd_ = 0;
			this.lastSeekEnd_ = seekableEnd;
			return this.pastSeekEnd_;
		}
		/**
		* If we are currently behind the live edge, aka currentTime will be
		* behind on a seekableendchange
		*
		* @return {boolean}
		*         If we are behind the live edge
		*/
		behindLiveEdge() {
			return this.behindLiveEdge_;
		}
		/**
		* Whether live tracker is currently tracking or not.
		*/
		isTracking() {
			return typeof this.trackingInterval_ === "number";
		}
		/**
		* Seek to the live edge if we are behind the live edge
		*/
		seekToLiveEdge() {
			this.seekedBehindLive_ = false;
			if (this.atLiveEdge()) return;
			this.nextSeekedFromUser_ = false;
			this.player_.currentTime(this.liveCurrentTime());
		}
		/**
		* Dispose of liveTracker
		*/
		dispose() {
			this.stopTracking();
			super.dispose();
		}
	};
	Component.registerComponent("LiveTracker", LiveTracker);
	/**
	* Displays an element over the player which contains an optional title and
	* description for the current content.
	*
	* Much of the code for this component originated in the now obsolete
	* videojs-dock plugin: https://github.com/brightcove/videojs-dock/
	*
	* @extends Component
	*/
	var TitleBar = class extends Component {
		constructor(player, options) {
			super(player, options);
			this.on("statechanged", (e) => this.updateDom_());
			this.updateDom_();
		}
		/**
		* Create the `TitleBar`'s DOM element
		*
		* @return {Element}
		*         The element that was created.
		*/
		createEl() {
			this.els = {
				title: createEl("div", {
					className: "vjs-title-bar-title",
					id: `vjs-title-bar-title-${newGUID()}`
				}),
				description: createEl("div", {
					className: "vjs-title-bar-description",
					id: `vjs-title-bar-description-${newGUID()}`
				})
			};
			return createEl("div", { className: "vjs-title-bar" }, {}, values(this.els));
		}
		/**
		* Updates the DOM based on the component's state object.
		*/
		updateDom_() {
			const tech = this.player_.tech_;
			const techEl = tech && tech.el_;
			const techAriaAttrs = {
				title: "aria-labelledby",
				description: "aria-describedby"
			};
			["title", "description"].forEach((k) => {
				const value = this.state[k];
				const el = this.els[k];
				const techAriaAttr = techAriaAttrs[k];
				emptyEl(el);
				if (value) textContent(el, value);
				if (techEl) {
					techEl.removeAttribute(techAriaAttr);
					if (value) techEl.setAttribute(techAriaAttr, el.id);
				}
			});
			if (this.state.title || this.state.description) this.show();
			else this.hide();
		}
		/**
		* Update the contents of the title bar component with new title and
		* description text.
		*
		* If both title and description are missing, the title bar will be hidden.
		*
		* If either title or description are present, the title bar will be visible.
		*
		* NOTE: Any previously set value will be preserved. To unset a previously
		* set value, you must pass an empty string or null.
		*
		* For example:
		*
		* ```
		* update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
		* update({description: 'bar2'}) // title: 'foo', description: 'bar2'
		* update({title: ''}) // title: '', description: 'bar2'
		* update({title: 'foo', description: null}) // title: 'foo', description: null
		* ```
		*
		* @param  {Object} [options={}]
		*         An options object. When empty, the title bar will be hidden.
		*
		* @param  {string} [options.title]
		*         A title to display in the title bar.
		*
		* @param  {string} [options.description]
		*         A description to display in the title bar.
		*/
		update(options) {
			this.setState(options);
		}
		/**
		* Dispose the component.
		*/
		dispose() {
			const tech = this.player_.tech_;
			const techEl = tech && tech.el_;
			if (techEl) {
				techEl.removeAttribute("aria-labelledby");
				techEl.removeAttribute("aria-describedby");
			}
			super.dispose();
			this.els = null;
		}
	};
	Component.registerComponent("TitleBar", TitleBar);
	/** @import Player from './player' */
	/**
	* @typedef {object} TransientButtonOptions
	* @property {string} [controlText] Control text, usually visible for these buttons
	* @property {number} [initialDisplay=4000] Time in ms that button should initially remain visible
	* @property {Array<'top'|'neartop'|'bottom'|'left'|'right'>} [position] Array of position strings to add basic styles for positioning
	* @property {string} [className] Class(es) to add
	* @property {boolean} [takeFocus=false] Whether element sohuld take focus when shown
	* @property {Function} [clickHandler] Function called on button activation
	*/
	/** @type {TransientButtonOptions} */
	var defaults = {
		initialDisplay: 4e3,
		position: [],
		takeFocus: false
	};
	/**
	* A floating transient button.
	* It's recommended to insert these buttons _before_ the control bar with the this argument to `addChild`
	* for a logical tab order.
	*
	* @example
	* ```
	* player.addChild(
	*   'TransientButton',
	*   options,
	*   player.children().indexOf(player.getChild("ControlBar"))
	* )
	* ```
	*
	* @extends Button
	*/
	var TransientButton = class extends Button {
		/**
		* TransientButton constructor
		*
		* @param {Player} player The button's player
		* @param {TransientButtonOptions} options Options for the transient button
		*/
		constructor(player, options) {
			options = merge(defaults, options);
			super(player, options);
			this.controlText(options.controlText);
			this.hide();
			this.on(this.player_, ["useractive", "userinactive"], (e) => {
				this.removeClass("force-display");
			});
		}
		/**
		* Return CSS class including position classes
		*
		* @return {string} CSS class list
		*/
		buildCSSClass() {
			return `vjs-transient-button focus-visible ${this.options_.position.map((c) => `vjs-${c}`).join(" ")}`;
		}
		/**
		* Create the button element
		*
		* @return {HTMLButtonElement} The button element
		*/
		createEl() {
			/** @type HTMLButtonElement */
			const el = createEl("button", {}, {
				type: "button",
				class: this.buildCSSClass()
			}, createEl("span"));
			this.controlTextEl_ = el.querySelector("span");
			return el;
		}
		/**
		* Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
		* and when there is user activity.
		*/
		show() {
			super.show();
			this.addClass("force-display");
			if (this.options_.takeFocus) this.el().focus({ preventScroll: true });
			this.forceDisplayTimeout = this.player_.setTimeout(() => {
				this.removeClass("force-display");
			}, this.options_.initialDisplay);
		}
		/**
		* Hide the display, even if during the `initialDisplay` time.
		*/
		hide() {
			this.removeClass("force-display");
			super.hide();
		}
		/**
		* Dispose the component
		*/
		dispose() {
			this.player_.clearTimeout(this.forceDisplayTimeout);
			super.dispose();
		}
	};
	Component.registerComponent("TransientButton", TransientButton);
	/** @import Html5 from './html5' */
	/**
	* This function is used to fire a sourceset when there is something
	* similar to `mediaEl.load()` being called. It will try to find the source via
	* the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
	* with the source that was found or empty string if we cannot know. If it cannot
	* find a source then `sourceset` will not be fired.
	*
	* @param {Html5} tech
	*        The tech object that sourceset was setup on
	*
	* @return {boolean}
	*         returns false if the sourceset was not fired and true otherwise.
	*/
	var sourcesetLoad = (tech) => {
		const el = tech.el();
		if (el.hasAttribute("src")) {
			tech.triggerSourceset(el.src);
			return true;
		}
		/**
		* Since there isn't a src property on the media element, source elements will be used for
		* implementing the source selection algorithm. This happens asynchronously and
		* for most cases were there is more than one source we cannot tell what source will
		* be loaded, without re-implementing the source selection algorithm. At this time we are not
		* going to do that. There are three special cases that we do handle here though:
		*
		* 1. If there are no sources, do not fire `sourceset`.
		* 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
		* 3. If there is more than one `<source>` but all of them have the same `src` url.
		*    That will be our src.
		*/
		const sources = tech.$$("source");
		const srcUrls = [];
		let src = "";
		if (!sources.length) return false;
		for (let i = 0; i < sources.length; i++) {
			const url = sources[i].src;
			if (url && srcUrls.indexOf(url) === -1) srcUrls.push(url);
		}
		if (!srcUrls.length) return false;
		if (srcUrls.length === 1) src = srcUrls[0];
		tech.triggerSourceset(src);
		return true;
	};
	/**
	* our implementation of an `innerHTML` descriptor for browsers
	* that do not have one.
	*/
	var innerHTMLDescriptorPolyfill = Object.defineProperty({}, "innerHTML", {
		get() {
			return this.cloneNode(true).innerHTML;
		},
		set(v) {
			const dummy = document__default["default"].createElement(this.nodeName.toLowerCase());
			dummy.innerHTML = v;
			const docFrag = document__default["default"].createDocumentFragment();
			while (dummy.childNodes.length) docFrag.appendChild(dummy.childNodes[0]);
			this.innerText = "";
			window__default["default"].Element.prototype.appendChild.call(this, docFrag);
			return this.innerHTML;
		}
	});
	/**
	* Get a property descriptor given a list of priorities and the
	* property to get.
	*/
	var getDescriptor = (priority, prop) => {
		let descriptor = {};
		for (let i = 0; i < priority.length; i++) {
			descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
			if (descriptor && descriptor.set && descriptor.get) break;
		}
		descriptor.enumerable = true;
		descriptor.configurable = true;
		return descriptor;
	};
	var getInnerHTMLDescriptor = (tech) => getDescriptor([
		tech.el(),
		window__default["default"].HTMLMediaElement.prototype,
		window__default["default"].Element.prototype,
		innerHTMLDescriptorPolyfill
	], "innerHTML");
	/**
	* Patches browser internal functions so that we can tell synchronously
	* if a `<source>` was appended to the media element. For some reason this
	* causes a `sourceset` if the the media element is ready and has no source.
	* This happens when:
	* - The page has just loaded and the media element does not have a source.
	* - The media element was emptied of all sources, then `load()` was called.
	*
	* It does this by patching the following functions/properties when they are supported:
	*
	* - `append()` - can be used to add a `<source>` element to the media element
	* - `appendChild()` - can be used to add a `<source>` element to the media element
	* - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
	* - `innerHTML` -  can be used to add a `<source>` element to the media element
	*
	* @param {Html5} tech
	*        The tech object that sourceset is being setup on.
	*/
	var firstSourceWatch = function(tech) {
		const el = tech.el();
		if (el.resetSourceWatch_) return;
		const old = {};
		const innerDescriptor = getInnerHTMLDescriptor(tech);
		const appendWrapper = (appendFn) => (...args) => {
			const retval = appendFn.apply(el, args);
			sourcesetLoad(tech);
			return retval;
		};
		[
			"append",
			"appendChild",
			"insertAdjacentHTML"
		].forEach((k) => {
			if (!el[k]) return;
			old[k] = el[k];
			el[k] = appendWrapper(old[k]);
		});
		Object.defineProperty(el, "innerHTML", merge(innerDescriptor, { set: appendWrapper(innerDescriptor.set) }));
		el.resetSourceWatch_ = () => {
			el.resetSourceWatch_ = null;
			Object.keys(old).forEach((k) => {
				el[k] = old[k];
			});
			Object.defineProperty(el, "innerHTML", innerDescriptor);
		};
		tech.one("sourceset", el.resetSourceWatch_);
	};
	/**
	* our implementation of a `src` descriptor for browsers
	* that do not have one
	*/
	var srcDescriptorPolyfill = Object.defineProperty({}, "src", {
		get() {
			if (this.hasAttribute("src")) return getAbsoluteURL(window__default["default"].Element.prototype.getAttribute.call(this, "src"));
			return "";
		},
		set(v) {
			window__default["default"].Element.prototype.setAttribute.call(this, "src", v);
			return v;
		}
	});
	var getSrcDescriptor = (tech) => getDescriptor([
		tech.el(),
		window__default["default"].HTMLMediaElement.prototype,
		srcDescriptorPolyfill
	], "src");
	/**
	* setup `sourceset` handling on the `Html5` tech. This function
	* patches the following element properties/functions:
	*
	* - `src` - to determine when `src` is set
	* - `setAttribute()` - to determine when `src` is set
	* - `load()` - this re-triggers the source selection algorithm, and can
	*              cause a sourceset.
	*
	* If there is no source when we are adding `sourceset` support or during a `load()`
	* we also patch the functions listed in `firstSourceWatch`.
	*
	* @param {Html5} tech
	*        The tech to patch
	*/
	var setupSourceset = function(tech) {
		if (!tech.featuresSourceset) return;
		const el = tech.el();
		if (el.resetSourceset_) return;
		const srcDescriptor = getSrcDescriptor(tech);
		const oldSetAttribute = el.setAttribute;
		const oldLoad = el.load;
		Object.defineProperty(el, "src", merge(srcDescriptor, { set: (v) => {
			const retval = srcDescriptor.set.call(el, v);
			tech.triggerSourceset(el.src);
			return retval;
		} }));
		el.setAttribute = (n, v) => {
			const retval = oldSetAttribute.call(el, n, v);
			if (/src/i.test(n)) tech.triggerSourceset(el.src);
			return retval;
		};
		el.load = () => {
			const retval = oldLoad.call(el);
			if (!sourcesetLoad(tech)) {
				tech.triggerSourceset("");
				firstSourceWatch(tech);
			}
			return retval;
		};
		if (el.currentSrc) tech.triggerSourceset(el.currentSrc);
		else if (!sourcesetLoad(tech)) firstSourceWatch(tech);
		el.resetSourceset_ = () => {
			el.resetSourceset_ = null;
			el.load = oldLoad;
			el.setAttribute = oldSetAttribute;
			Object.defineProperty(el, "src", srcDescriptor);
			if (el.resetSourceWatch_) el.resetSourceWatch_();
		};
	};
	/**
	* @file html5.js
	*/
	/**
	* HTML5 Media Controller - Wrapper for HTML5 Media API
	*
	* @mixes Tech~SourceHandlerAdditions
	* @extends Tech
	*/
	var Html5 = class Html5 extends Tech {
		/**
		* Create an instance of this Tech.
		*
		* @param {Object} [options]
		*        The key/value store of player options.
		*
		* @param {Function} [ready]
		*        Callback function to call when the `HTML5` Tech is ready.
		*/
		constructor(options, ready) {
			super(options, ready);
			const source = options.source;
			let crossoriginTracks = false;
			this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO";
			if (source && (this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) this.setSource(source);
			else this.handleLateInit_(this.el_);
			if (options.enableSourceset) this.setupSourcesetHandling_();
			this.isScrubbing_ = false;
			if (this.el_.hasChildNodes()) {
				const nodes = this.el_.childNodes;
				let nodesLength = nodes.length;
				const removeNodes = [];
				while (nodesLength--) {
					const node = nodes[nodesLength];
					if (node.nodeName.toLowerCase() === "track") if (!this.featuresNativeTextTracks) removeNodes.push(node);
					else {
						this.remoteTextTrackEls().addTrackElement_(node);
						this.remoteTextTracks().addTrack(node.track);
						this.textTracks().addTrack(node.track);
						if (!crossoriginTracks && !this.el_.hasAttribute("crossorigin") && isCrossOrigin(node.src)) crossoriginTracks = true;
					}
				}
				for (let i = 0; i < removeNodes.length; i++) this.el_.removeChild(removeNodes[i]);
			}
			this.proxyNativeTracks_();
			if (this.featuresNativeTextTracks && crossoriginTracks) log.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading.");
			this.restoreMetadataTracksInIOSNativePlayer_();
			if ((TOUCH_ENABLED || IS_IPHONE) && options.nativeControlsForTouch === true) this.setControls(true);
			this.proxyWebkitFullscreen_();
			this.triggerReady();
		}
		/**
		* Dispose of `HTML5` media element and remove all tracks.
		*/
		dispose() {
			if (this.el_ && this.el_.resetSourceset_) this.el_.resetSourceset_();
			Html5.disposeMediaElement(this.el_);
			this.options_ = null;
			super.dispose();
		}
		/**
		* Modify the media element so that we can detect when
		* the source is changed. Fires `sourceset` just after the source has changed
		*/
		setupSourcesetHandling_() {
			setupSourceset(this);
		}
		/**
		* When a captions track is enabled in the iOS Safari native player, all other
		* tracks are disabled (including metadata tracks), which nulls all of their
		* associated cue points. This will restore metadata tracks to their pre-fullscreen
		* state in those cases so that cue points are not needlessly lost.
		*
		* @private
		*/
		restoreMetadataTracksInIOSNativePlayer_() {
			const textTracks = this.textTracks();
			let metadataTracksPreFullscreenState;
			const takeMetadataTrackSnapshot = () => {
				metadataTracksPreFullscreenState = [];
				for (let i = 0; i < textTracks.length; i++) {
					const track = textTracks[i];
					if (track.kind === "metadata") metadataTracksPreFullscreenState.push({
						track,
						storedMode: track.mode
					});
				}
			};
			takeMetadataTrackSnapshot();
			textTracks.addEventListener("change", takeMetadataTrackSnapshot);
			this.on("dispose", () => textTracks.removeEventListener("change", takeMetadataTrackSnapshot));
			const restoreTrackMode = () => {
				for (let i = 0; i < metadataTracksPreFullscreenState.length; i++) {
					const storedTrack = metadataTracksPreFullscreenState[i];
					if (storedTrack.track.mode === "disabled" && storedTrack.track.mode !== storedTrack.storedMode) storedTrack.track.mode = storedTrack.storedMode;
				}
				textTracks.removeEventListener("change", restoreTrackMode);
			};
			this.on("webkitbeginfullscreen", () => {
				textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
				textTracks.removeEventListener("change", restoreTrackMode);
				textTracks.addEventListener("change", restoreTrackMode);
			});
			this.on("webkitendfullscreen", () => {
				textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
				textTracks.addEventListener("change", takeMetadataTrackSnapshot);
				textTracks.removeEventListener("change", restoreTrackMode);
			});
		}
		/**
		* Attempt to force override of tracks for the given type
		*
		* @param {string} type - Track type to override, possible values include 'Audio',
		* 'Video', and 'Text'.
		* @param {boolean} override - If set to true native audio/video will be overridden,
		* otherwise native audio/video will potentially be used.
		* @private
		*/
		overrideNative_(type, override) {
			if (override !== this[`featuresNative${type}Tracks`]) return;
			const lowerCaseType = type.toLowerCase();
			if (this[`${lowerCaseType}TracksListeners_`]) Object.keys(this[`${lowerCaseType}TracksListeners_`]).forEach((eventName) => {
				this.el()[`${lowerCaseType}Tracks`].removeEventListener(eventName, this[`${lowerCaseType}TracksListeners_`][eventName]);
			});
			this[`featuresNative${type}Tracks`] = !override;
			this[`${lowerCaseType}TracksListeners_`] = null;
			this.proxyNativeTracksForType_(lowerCaseType);
		}
		/**
		* Attempt to force override of native audio tracks.
		*
		* @param {boolean} override - If set to true native audio will be overridden,
		* otherwise native audio will potentially be used.
		*/
		overrideNativeAudioTracks(override) {
			this.overrideNative_("Audio", override);
		}
		/**
		* Attempt to force override of native video tracks.
		*
		* @param {boolean} override - If set to true native video will be overridden,
		* otherwise native video will potentially be used.
		*/
		overrideNativeVideoTracks(override) {
			this.overrideNative_("Video", override);
		}
		/**
		* Proxy native track list events for the given type to our track
		* lists if the browser we are playing in supports that type of track list.
		*
		* @param {string} name - Track type; values include 'audio', 'video', and 'text'
		* @private
		*/
		proxyNativeTracksForType_(name) {
			const props = NORMAL[name];
			const elTracks = this.el()[props.getterName];
			const techTracks = this[props.getterName]();
			if (!this[`featuresNative${props.capitalName}Tracks`] || !elTracks || !elTracks.addEventListener) return;
			const listeners = {
				change: (e) => {
					const event = {
						type: "change",
						target: techTracks,
						currentTarget: techTracks,
						srcElement: techTracks
					};
					techTracks.trigger(event);
					if (name === "text") this[REMOTE.remoteText.getterName]().trigger(event);
				},
				addtrack(e) {
					techTracks.addTrack(e.track);
				},
				removetrack(e) {
					techTracks.removeTrack(e.track);
				}
			};
			const removeOldTracks = function() {
				const removeTracks = [];
				for (let i = 0; i < techTracks.length; i++) {
					let found = false;
					for (let j = 0; j < elTracks.length; j++) if (elTracks[j] === techTracks[i]) {
						found = true;
						break;
					}
					if (!found) removeTracks.push(techTracks[i]);
				}
				while (removeTracks.length) techTracks.removeTrack(removeTracks.shift());
			};
			this[props.getterName + "Listeners_"] = listeners;
			Object.keys(listeners).forEach((eventName) => {
				const listener = listeners[eventName];
				elTracks.addEventListener(eventName, listener);
				this.on("dispose", (e) => elTracks.removeEventListener(eventName, listener));
			});
			this.on("loadstart", removeOldTracks);
			this.on("dispose", (e) => this.off("loadstart", removeOldTracks));
		}
		/**
		* Proxy all native track list events to our track lists if the browser we are playing
		* in supports that type of track list.
		*
		* @private
		*/
		proxyNativeTracks_() {
			NORMAL.names.forEach((name) => {
				this.proxyNativeTracksForType_(name);
			});
		}
		/**
		* Create the `Html5` Tech's DOM element.
		*
		* @return {Element}
		*         The element that gets created.
		*/
		createEl() {
			let el = this.options_.tag;
			if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
				if (el) {
					const clone = el.cloneNode(true);
					if (el.parentNode) el.parentNode.insertBefore(clone, el);
					Html5.disposeMediaElement(el);
					el = clone;
				} else {
					el = document__default["default"].createElement("video");
					const attributes = merge({}, this.options_.tag && getAttributes(this.options_.tag));
					if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) delete attributes.controls;
					setAttributes(el, Object.assign(attributes, {
						id: this.options_.techId,
						class: "vjs-tech"
					}));
				}
				el.playerId = this.options_.playerId;
			}
			if (typeof this.options_.preload !== "undefined") setAttribute(el, "preload", this.options_.preload);
			if (this.options_.disablePictureInPicture !== void 0) el.disablePictureInPicture = this.options_.disablePictureInPicture;
			const settingsAttrs = [
				"loop",
				"muted",
				"playsinline",
				"autoplay"
			];
			for (let i = 0; i < settingsAttrs.length; i++) {
				const attr = settingsAttrs[i];
				const value = this.options_[attr];
				if (typeof value !== "undefined") {
					if (value) setAttribute(el, attr, attr);
					else removeAttribute(el, attr);
					el[attr] = value;
				}
			}
			return el;
		}
		/**
		* This will be triggered if the loadstart event has already fired, before videojs was
		* ready. Two known examples of when this can happen are:
		* 1. If we're loading the playback object after it has started loading
		* 2. The media is already playing the (often with autoplay on) then
		*
		* This function will fire another loadstart so that videojs can catchup.
		*
		* @fires Tech#loadstart
		*
		* @return {undefined}
		*         returns nothing.
		*/
		handleLateInit_(el) {
			if (el.networkState === 0 || el.networkState === 3) return;
			if (el.readyState === 0) {
				let loadstartFired = false;
				const setLoadstartFired = function() {
					loadstartFired = true;
				};
				this.on("loadstart", setLoadstartFired);
				const triggerLoadstart = function() {
					if (!loadstartFired) this.trigger("loadstart");
				};
				this.on("loadedmetadata", triggerLoadstart);
				this.ready(function() {
					this.off("loadstart", setLoadstartFired);
					this.off("loadedmetadata", triggerLoadstart);
					if (!loadstartFired) this.trigger("loadstart");
				});
				return;
			}
			const eventsToTrigger = ["loadstart"];
			eventsToTrigger.push("loadedmetadata");
			if (el.readyState >= 2) eventsToTrigger.push("loadeddata");
			if (el.readyState >= 3) eventsToTrigger.push("canplay");
			if (el.readyState >= 4) eventsToTrigger.push("canplaythrough");
			this.ready(function() {
				eventsToTrigger.forEach(function(type) {
					this.trigger(type);
				}, this);
			});
		}
		/**
		* Set whether we are scrubbing or not.
		* This is used to decide whether we should use `fastSeek` or not.
		* `fastSeek` is used to provide trick play on Safari browsers.
		*
		* @param {boolean} isScrubbing
		*                  - true for we are currently scrubbing
		*                  - false for we are no longer scrubbing
		*/
		setScrubbing(isScrubbing) {
			this.isScrubbing_ = isScrubbing;
		}
		/**
		* Get whether we are scrubbing or not.
		*
		* @return {boolean} isScrubbing
		*                  - true for we are currently scrubbing
		*                  - false for we are no longer scrubbing
		*/
		scrubbing() {
			return this.isScrubbing_;
		}
		/**
		* Set current time for the `HTML5` tech.
		*
		* @param {number} seconds
		*        Set the current time of the media to this.
		*/
		setCurrentTime(seconds) {
			try {
				if (this.isScrubbing_ && this.el_.fastSeek && IS_ANY_SAFARI) this.el_.fastSeek(seconds);
				else this.el_.currentTime = seconds;
			} catch (e) {
				log(e, "Video is not ready. (Video.js)");
			}
		}
		/**
		* Get the current duration of the HTML5 media element.
		*
		* @return {number}
		*         The duration of the media or 0 if there is no duration.
		*/
		duration() {
			if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
				const checkProgress = () => {
					if (this.el_.currentTime > 0) {
						if (this.el_.duration === Infinity) this.trigger("durationchange");
						this.off("timeupdate", checkProgress);
					}
				};
				this.on("timeupdate", checkProgress);
				return NaN;
			}
			return this.el_.duration || NaN;
		}
		/**
		* Get the current width of the HTML5 media element.
		*
		* @return {number}
		*         The width of the HTML5 media element.
		*/
		width() {
			return this.el_.offsetWidth;
		}
		/**
		* Get the current height of the HTML5 media element.
		*
		* @return {number}
		*         The height of the HTML5 media element.
		*/
		height() {
			return this.el_.offsetHeight;
		}
		/**
		* Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
		* `fullscreenchange` event.
		*
		* @private
		* @fires fullscreenchange
		* @listens webkitendfullscreen
		* @listens webkitbeginfullscreen
		* @listens webkitbeginfullscreen
		*/
		proxyWebkitFullscreen_() {
			if (!("webkitDisplayingFullscreen" in this.el_)) return;
			const endFn = function() {
				this.trigger("fullscreenchange", { isFullscreen: false });
				if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) this.el_.controls = false;
			};
			const beginFn = function() {
				if ("webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture") {
					this.one("webkitendfullscreen", endFn);
					this.trigger("fullscreenchange", {
						isFullscreen: true,
						nativeIOSFullscreen: true
					});
				}
			};
			this.on("webkitbeginfullscreen", beginFn);
			this.on("dispose", () => {
				this.off("webkitbeginfullscreen", beginFn);
				this.off("webkitendfullscreen", endFn);
			});
		}
		/**
		* Check if fullscreen is supported on the video el.
		*
		* @return {boolean}
		*         - True if fullscreen is supported.
		*         - False if fullscreen is not supported.
		*/
		supportsFullScreen() {
			return typeof this.el_.webkitEnterFullScreen === "function";
		}
		/**
		* Request that the `HTML5` Tech enter fullscreen.
		*/
		enterFullScreen() {
			const video = this.el_;
			if (video.paused && video.networkState <= video.HAVE_METADATA) {
				silencePromise(this.el_.play());
				this.setTimeout(function() {
					video.pause();
					try {
						video.webkitEnterFullScreen();
					} catch (e) {
						this.trigger("fullscreenerror", e);
					}
				}, 0);
			} else try {
				video.webkitEnterFullScreen();
			} catch (e) {
				this.trigger("fullscreenerror", e);
			}
		}
		/**
		* Request that the `HTML5` Tech exit fullscreen.
		*/
		exitFullScreen() {
			if (!this.el_.webkitDisplayingFullscreen) {
				this.trigger("fullscreenerror", /* @__PURE__ */ new Error("The video is not fullscreen"));
				return;
			}
			this.el_.webkitExitFullScreen();
		}
		/**
		* Create a floating video window always on top of other windows so that users may
		* continue consuming media while they interact with other content sites, or
		* applications on their device.
		*
		* @see [Spec]{@link https://wicg.github.io/picture-in-picture}
		*
		* @return {Promise}
		*         A promise with a Picture-in-Picture window.
		*/
		requestPictureInPicture() {
			return this.el_.requestPictureInPicture();
		}
		/**
		* Native requestVideoFrameCallback if supported by browser/tech, or fallback
		* Don't use rVCF on Safari when DRM is playing, as it doesn't fire
		* Needs to be checked later than the constructor
		* This will be a false positive for clear sources loaded after a Fairplay source
		*
		* @param {function} cb function to call
		* @return {number} id of request
		*/
		requestVideoFrameCallback(cb) {
			if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) return this.el_.requestVideoFrameCallback(cb);
			return super.requestVideoFrameCallback(cb);
		}
		/**
		* Native or fallback requestVideoFrameCallback
		*
		* @param {number} id request id to cancel
		*/
		cancelVideoFrameCallback(id) {
			if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) this.el_.cancelVideoFrameCallback(id);
			else super.cancelVideoFrameCallback(id);
		}
		/**
		* A getter/setter for the `Html5` Tech's source object.
		* > Note: Please use {@link Html5#setSource}
		*
		* @param {Tech~SourceObject} [src]
		*        The source object you want to set on the `HTML5` techs element.
		*
		* @return {Tech~SourceObject|undefined}
		*         - The current source object when a source is not passed in.
		*         - undefined when setting
		*
		* @deprecated Since version 5.
		*/
		src(src) {
			if (src === void 0) return this.el_.src;
			this.setSrc(src);
		}
		/**
		* Add a <source> element to the <video> element.
		*
		* @param {string} srcUrl
		*        The URL of the video source.
		*
		* @param {string} [mimeType]
		*        The MIME type of the video source. Optional but recommended.
		*
		* @return {boolean}
		*         Returns true if the source element was successfully added, false otherwise.
		*/
		addSourceElement(srcUrl, mimeType) {
			if (!srcUrl) {
				log.error("Invalid source URL.");
				return false;
			}
			const sourceAttributes = { src: srcUrl };
			if (mimeType) sourceAttributes.type = mimeType;
			const sourceElement = createEl("source", {}, sourceAttributes);
			this.el_.appendChild(sourceElement);
			return true;
		}
		/**
		* Remove a <source> element from the <video> element by its URL.
		*
		* @param {string} srcUrl
		*        The URL of the source to remove.
		*
		* @return {boolean}
		*         Returns true if the source element was successfully removed, false otherwise.
		*/
		removeSourceElement(srcUrl) {
			if (!srcUrl) {
				log.error("Source URL is required to remove the source element.");
				return false;
			}
			const sourceElements = this.el_.querySelectorAll("source");
			for (const sourceElement of sourceElements) if (sourceElement.src === srcUrl) {
				this.el_.removeChild(sourceElement);
				return true;
			}
			log.warn(`No matching source element found with src: ${srcUrl}`);
			return false;
		}
		/**
		* Reset the tech by removing all sources and then calling
		* {@link Html5.resetMediaElement}.
		*/
		reset() {
			Html5.resetMediaElement(this.el_);
		}
		/**
		* Get the current source on the `HTML5` Tech. Falls back to returning the source from
		* the HTML5 media element.
		*
		* @return {Tech~SourceObject}
		*         The current source object from the HTML5 tech. With a fallback to the
		*         elements source.
		*/
		currentSrc() {
			if (this.currentSource_) return this.currentSource_.src;
			return this.el_.currentSrc;
		}
		/**
		* Set controls attribute for the HTML5 media Element.
		*
		* @param {string} val
		*        Value to set the controls attribute to
		*/
		setControls(val) {
			this.el_.controls = !!val;
		}
		/**
		* Create and returns a remote {@link TextTrack} object.
		*
		* @param {string} kind
		*        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
		*
		* @param {string} [label]
		*        Label to identify the text track
		*
		* @param {string} [language]
		*        Two letter language abbreviation
		*
		* @return {TextTrack}
		*         The TextTrack that gets created.
		*/
		addTextTrack(kind, label, language) {
			if (!this.featuresNativeTextTracks) return super.addTextTrack(kind, label, language);
			return this.el_.addTextTrack(kind, label, language);
		}
		/**
		* Creates either native TextTrack or an emulated TextTrack depending
		* on the value of `featuresNativeTextTracks`
		*
		* @param {Object} options
		*        The object should contain the options to initialize the TextTrack with.
		*
		* @param {string} [options.kind]
		*        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
		*
		* @param {string} [options.label]
		*        Label to identify the text track
		*
		* @param {string} [options.language]
		*        Two letter language abbreviation.
		*
		* @param {boolean} [options.default]
		*        Default this track to on.
		*
		* @param {string} [options.id]
		*        The internal id to assign this track.
		*
		* @param {string} [options.src]
		*        A source url for the track.
		*
		* @return {HTMLTrackElement}
		*         The track element that gets created.
		*/
		createRemoteTextTrack(options) {
			if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(options);
			const htmlTrackElement = document__default["default"].createElement("track");
			if (options.kind) htmlTrackElement.kind = options.kind;
			if (options.label) htmlTrackElement.label = options.label;
			if (options.language || options.srclang) htmlTrackElement.srclang = options.language || options.srclang;
			if (options.default) htmlTrackElement.default = options.default;
			if (options.id) htmlTrackElement.id = options.id;
			if (options.src) htmlTrackElement.src = options.src;
			return htmlTrackElement;
		}
		/**
		* Creates a remote text track object and returns an html track element.
		*
		* @param {Object} options The object should contain values for
		* kind, language, label, and src (location of the WebVTT file)
		* @param {boolean} [manualCleanup=false] if set to true, the TextTrack
		* will not be removed from the TextTrackList and HtmlTrackElementList
		* after a source change
		* @return {HTMLTrackElement} An Html Track Element.
		* This can be an emulated {@link HTMLTrackElement} or a native one.
		*
		*/
		addRemoteTextTrack(options, manualCleanup) {
			const htmlTrackElement = super.addRemoteTextTrack(options, manualCleanup);
			if (this.featuresNativeTextTracks) this.el().appendChild(htmlTrackElement);
			return htmlTrackElement;
		}
		/**
		* Remove remote `TextTrack` from `TextTrackList` object
		*
		* @param {TextTrack} track
		*        `TextTrack` object to remove
		*/
		removeRemoteTextTrack(track) {
			super.removeRemoteTextTrack(track);
			if (this.featuresNativeTextTracks) {
				const tracks = this.$$("track");
				let i = tracks.length;
				while (i--) if (track === tracks[i] || track === tracks[i].track) this.el().removeChild(tracks[i]);
			}
		}
		/**
		* Gets available media playback quality metrics as specified by the W3C's Media
		* Playback Quality API.
		*
		* @see [Spec]{@link https://wicg.github.io/media-playback-quality}
		*
		* @return {Object}
		*         An object with supported media playback quality metrics
		*/
		getVideoPlaybackQuality() {
			if (typeof this.el().getVideoPlaybackQuality === "function") return this.el().getVideoPlaybackQuality();
			const videoPlaybackQuality = {};
			if (typeof this.el().webkitDroppedFrameCount !== "undefined" && typeof this.el().webkitDecodedFrameCount !== "undefined") {
				videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
				videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
			}
			if (window__default["default"].performance) videoPlaybackQuality.creationTime = window__default["default"].performance.now();
			return videoPlaybackQuality;
		}
	};
	/**
	* Element for testing browser HTML5 media capabilities
	*
	* @type {Element}
	* @constant
	* @private
	*/
	defineLazyProperty(Html5, "TEST_VID", function() {
		if (!isReal()) return;
		const video = document__default["default"].createElement("video");
		const track = document__default["default"].createElement("track");
		track.kind = "captions";
		track.srclang = "en";
		track.label = "English";
		video.appendChild(track);
		return video;
	});
	/**
	* Check if HTML5 media is supported by this browser/device.
	*
	* @return {boolean}
	*         - True if HTML5 media is supported.
	*         - False if HTML5 media is not supported.
	*/
	Html5.isSupported = function() {
		try {
			Html5.TEST_VID.volume = .5;
		} catch (e) {
			return false;
		}
		return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	/**
	* Check if the tech can support the given type
	*
	* @param {string} type
	*        The mimetype to check
	* @return {string} 'probably', 'maybe', or '' (empty string)
	*/
	Html5.canPlayType = function(type) {
		return Html5.TEST_VID.canPlayType(type);
	};
	/**
	* Check if the tech can support the given source
	*
	* @param {Object} srcObj
	*        The source object
	* @param {Object} options
	*        The options passed to the tech
	* @return {string} 'probably', 'maybe', or '' (empty string)
	*/
	Html5.canPlaySource = function(srcObj, options) {
		return Html5.canPlayType(srcObj.type);
	};
	/**
	* Check if the volume can be changed in this browser/device.
	* Volume cannot be changed in a lot of mobile devices.
	* Specifically, it can't be changed from 1 on iOS.
	*
	* @return {boolean}
	*         - True if volume can be controlled
	*         - False otherwise
	*/
	Html5.canControlVolume = function() {
		try {
			const volume = Html5.TEST_VID.volume;
			Html5.TEST_VID.volume = volume / 2 + .1;
			const canControl = volume !== Html5.TEST_VID.volume;
			if (canControl && IS_IOS) {
				window__default["default"].setTimeout(() => {
					if (Html5 && Html5.prototype) Html5.prototype.featuresVolumeControl = volume !== Html5.TEST_VID.volume;
				});
				return false;
			}
			return canControl;
		} catch (e) {
			return false;
		}
	};
	/**
	* Check if the volume can be muted in this browser/device.
	* Some devices, e.g. iOS, don't allow changing volume
	* but permits muting/unmuting.
	*
	* @return {boolean}
	*      - True if volume can be muted
	*      - False otherwise
	*/
	Html5.canMuteVolume = function() {
		try {
			const muted = Html5.TEST_VID.muted;
			Html5.TEST_VID.muted = !muted;
			if (Html5.TEST_VID.muted) setAttribute(Html5.TEST_VID, "muted", "muted");
			else removeAttribute(Html5.TEST_VID, "muted", "muted");
			return muted !== Html5.TEST_VID.muted;
		} catch (e) {
			return false;
		}
	};
	/**
	* Check if the playback rate can be changed in this browser/device.
	*
	* @return {boolean}
	*         - True if playback rate can be controlled
	*         - False otherwise
	*/
	Html5.canControlPlaybackRate = function() {
		if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) return false;
		try {
			const playbackRate = Html5.TEST_VID.playbackRate;
			Html5.TEST_VID.playbackRate = playbackRate / 2 + .1;
			return playbackRate !== Html5.TEST_VID.playbackRate;
		} catch (e) {
			return false;
		}
	};
	/**
	* Check if we can override a video/audio elements attributes, with
	* Object.defineProperty.
	*
	* @return {boolean}
	*         - True if builtin attributes can be overridden
	*         - False otherwise
	*/
	Html5.canOverrideAttributes = function() {
		try {
			const noop = () => {};
			Object.defineProperty(document__default["default"].createElement("video"), "src", {
				get: noop,
				set: noop
			});
			Object.defineProperty(document__default["default"].createElement("audio"), "src", {
				get: noop,
				set: noop
			});
			Object.defineProperty(document__default["default"].createElement("video"), "innerHTML", {
				get: noop,
				set: noop
			});
			Object.defineProperty(document__default["default"].createElement("audio"), "innerHTML", {
				get: noop,
				set: noop
			});
		} catch (e) {
			return false;
		}
		return true;
	};
	/**
	* Check to see if native `TextTrack`s are supported by this browser/device.
	*
	* @return {boolean}
	*         - True if native `TextTrack`s are supported.
	*         - False otherwise
	*/
	Html5.supportsNativeTextTracks = function() {
		return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
	};
	/**
	* Check to see if native `VideoTrack`s are supported by this browser/device
	*
	* @return {boolean}
	*        - True if native `VideoTrack`s are supported.
	*        - False otherwise
	*/
	Html5.supportsNativeVideoTracks = function() {
		return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	/**
	* Check to see if native `AudioTrack`s are supported by this browser/device
	*
	* @return {boolean}
	*        - True if native `AudioTrack`s are supported.
	*        - False otherwise
	*/
	Html5.supportsNativeAudioTracks = function() {
		return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	/**
	* An array of events available on the Html5 tech.
	*
	* @private
	* @type {Array}
	*/
	Html5.Events = [
		"loadstart",
		"suspend",
		"abort",
		"error",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"canplay",
		"canplaythrough",
		"playing",
		"waiting",
		"seeking",
		"seeked",
		"ended",
		"durationchange",
		"timeupdate",
		"progress",
		"play",
		"pause",
		"ratechange",
		"resize",
		"volumechange"
	];
	/**
	* Boolean indicating whether the `Tech` supports volume control.
	*
	* @type {boolean}
	* @default {@link Html5.canControlVolume}
	*/
	/**
	* Boolean indicating whether the `Tech` supports muting volume.
	*
	* @type {boolean}
	* @default {@link Html5.canMuteVolume}
	*/
	/**
	* Boolean indicating whether the `Tech` supports changing the speed at which the media
	* plays. Examples:
	*   - Set player to play 2x (twice) as fast
	*   - Set player to play 0.5x (half) as fast
	*
	* @type {boolean}
	* @default {@link Html5.canControlPlaybackRate}
	*/
	/**
	* Boolean indicating whether the `Tech` supports the `sourceset` event.
	*
	* @type {boolean}
	* @default
	*/
	/**
	* Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	*
	* @type {boolean}
	* @default {@link Html5.supportsNativeTextTracks}
	*/
	/**
	* Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	*
	* @type {boolean}
	* @default {@link Html5.supportsNativeVideoTracks}
	*/
	/**
	* Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	*
	* @type {boolean}
	* @default {@link Html5.supportsNativeAudioTracks}
	*/
	[
		["featuresMuteControl", "canMuteVolume"],
		["featuresPlaybackRate", "canControlPlaybackRate"],
		["featuresSourceset", "canOverrideAttributes"],
		["featuresNativeTextTracks", "supportsNativeTextTracks"],
		["featuresNativeVideoTracks", "supportsNativeVideoTracks"],
		["featuresNativeAudioTracks", "supportsNativeAudioTracks"]
	].forEach(function([key, fn]) {
		defineLazyProperty(Html5.prototype, key, () => Html5[fn](), true);
	});
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	/**
	* Boolean indicating whether the `HTML5` tech currently supports the media element
	* moving in the DOM. iOS breaks if you move the media element, so this is set this to
	* false there. Everywhere else this should be true.
	*
	* @type {boolean}
	* @default
	*/
	Html5.prototype.movingMediaElementInDOM = !IS_IOS;
	/**
	* Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	* when going into fullscreen.
	*
	* @type {boolean}
	* @default
	*/
	Html5.prototype.featuresFullscreenResize = true;
	/**
	* Boolean indicating whether the `HTML5` tech currently supports the progress event.
	* If this is false, manual `progress` events will be triggered instead.
	*
	* @type {boolean}
	* @default
	*/
	Html5.prototype.featuresProgressEvents = true;
	/**
	* Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	* If this is false, manual `timeupdate` events will be triggered instead.
	*
	* @default
	*/
	Html5.prototype.featuresTimeupdateEvents = true;
	/**
	* Whether the HTML5 el supports `requestVideoFrameCallback`
	*
	* @type {boolean}
	*/
	Html5.prototype.featuresVideoFrameCallback = !!(Html5.TEST_VID && Html5.TEST_VID.requestVideoFrameCallback);
	Html5.disposeMediaElement = function(el) {
		if (!el) return;
		if (el.parentNode) el.parentNode.removeChild(el);
		while (el.hasChildNodes()) el.removeChild(el.firstChild);
		el.removeAttribute("src");
		if (typeof el.load === "function") (function() {
			try {
				el.load();
			} catch (e) {}
		})();
	};
	Html5.resetMediaElement = function(el) {
		if (!el) return;
		const sources = el.querySelectorAll("source");
		let i = sources.length;
		while (i--) el.removeChild(sources[i]);
		el.removeAttribute("src");
		if (typeof el.load === "function") (function() {
			try {
				el.load();
			} catch (e) {}
		})();
	};
	[
		"muted",
		"defaultMuted",
		"autoplay",
		"controls",
		"loop",
		"playsinline"
	].forEach(function(prop) {
		Html5.prototype[prop] = function() {
			return this.el_[prop] || this.el_.hasAttribute(prop);
		};
	});
	[
		"muted",
		"defaultMuted",
		"autoplay",
		"loop",
		"playsinline"
	].forEach(function(prop) {
		Html5.prototype["set" + toTitleCase(prop)] = function(v) {
			this.el_[prop] = v;
			if (v) this.el_.setAttribute(prop, prop);
			else this.el_.removeAttribute(prop);
		};
	});
	[
		"paused",
		"currentTime",
		"buffered",
		"volume",
		"poster",
		"preload",
		"error",
		"seeking",
		"seekable",
		"ended",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"played",
		"networkState",
		"readyState",
		"videoWidth",
		"videoHeight",
		"crossOrigin"
	].forEach(function(prop) {
		Html5.prototype[prop] = function() {
			return this.el_[prop];
		};
	});
	[
		"volume",
		"src",
		"poster",
		"preload",
		"playbackRate",
		"defaultPlaybackRate",
		"disablePictureInPicture",
		"crossOrigin"
	].forEach(function(prop) {
		Html5.prototype["set" + toTitleCase(prop)] = function(v) {
			this.el_[prop] = v;
		};
	});
	[
		"pause",
		"load",
		"play"
	].forEach(function(prop) {
		Html5.prototype[prop] = function() {
			return this.el_[prop]();
		};
	});
	Tech.withSourceHandlers(Html5);
	/**
	* Native source handler for Html5, simply passes the source to the media element.
	*
	* @property {Tech~SourceObject} source
	*        The source object
	*
	* @property {Html5} tech
	*        The instance of the HTML5 tech.
	*/
	Html5.nativeSourceHandler = {};
	/**
	* Check if the media element can play the given mime type.
	*
	* @param {string} type
	*        The mimetype to check
	*
	* @return {string}
	*         'probably', 'maybe', or '' (empty string)
	*/
	Html5.nativeSourceHandler.canPlayType = function(type) {
		try {
			return Html5.TEST_VID.canPlayType(type);
		} catch (e) {
			return "";
		}
	};
	/**
	* Check if the media element can handle a source natively.
	*
	* @param {Tech~SourceObject} source
	*         The source object
	*
	* @param {Object} [options]
	*         Options to be passed to the tech.
	*
	* @return {string}
	*         'probably', 'maybe', or '' (empty string).
	*/
	Html5.nativeSourceHandler.canHandleSource = function(source, options) {
		if (source.type) return Html5.nativeSourceHandler.canPlayType(source.type);
		else if (source.src) {
			const ext = getFileExtension(source.src);
			return Html5.nativeSourceHandler.canPlayType(`video/${ext}`);
		}
		return "";
	};
	/**
	* Pass the source to the native media element.
	*
	* @param {Tech~SourceObject} source
	*        The source object
	*
	* @param {Html5} tech
	*        The instance of the Html5 tech
	*
	* @param {Object} [options]
	*        The options to pass to the source
	*/
	Html5.nativeSourceHandler.handleSource = function(source, tech, options) {
		tech.setSrc(source.src);
	};
	/**
	* A noop for the native dispose function, as cleanup is not needed.
	*/
	Html5.nativeSourceHandler.dispose = function() {};
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	Tech.registerTech("Html5", Html5);
	/**
	* @file player.js
	*/
	/** @import AudioTrackList from './tracks/audio-track-list' */
	/** @import HtmlTrackElement from './tracks/html-track-element' */
	/** @import HtmlTrackElementList from './tracks/html-track-element-list' */
	/** @import TextTrackList from './tracks/text-track-list' */
	/** @import { TimeRange } from './utils/time' */
	/** @import VideoTrackList from './tracks/video-track-list' */
	/**
	* @callback PlayerReadyCallback
	* @this     {Player}
	* @returns  {void}
	*/
	var TECH_EVENTS_RETRIGGER = [
		"progress",
		"abort",
		"suspend",
		"emptied",
		"stalled",
		"loadedmetadata",
		"loadeddata",
		"timeupdate",
		"resize",
		"volumechange",
		"texttrackchange"
	];
	var TECH_EVENTS_QUEUE = {
		canplay: "CanPlay",
		canplaythrough: "CanPlayThrough",
		playing: "Playing",
		seeked: "Seeked"
	};
	var BREAKPOINT_ORDER = [
		"tiny",
		"xsmall",
		"small",
		"medium",
		"large",
		"xlarge",
		"huge"
	];
	var BREAKPOINT_CLASSES = {};
	BREAKPOINT_ORDER.forEach((k) => {
		BREAKPOINT_CLASSES[k] = `vjs-layout-${k.charAt(0) === "x" ? `x-${k.substring(1)}` : k}`;
	});
	var DEFAULT_BREAKPOINTS = {
		tiny: 210,
		xsmall: 320,
		small: 425,
		medium: 768,
		large: 1440,
		xlarge: 2560,
		huge: Infinity
	};
	/**
	* An instance of the `Player` class is created when any of the Video.js setup methods
	* are used to initialize a video.
	*
	* After an instance has been created it can be accessed globally in three ways:
	* 1. By calling `videojs.getPlayer('example_video_1');`
	* 2. By calling `videojs('example_video_1');` (not recommended)
	* 2. By using it directly via `videojs.players.example_video_1;`
	*
	* @extends Component
	* @global
	*/
	var Player = class Player extends Component {
		/**
		* Create an instance of this class.
		*
		* @param {Element} tag
		*        The original video DOM element used for configuring options.
		*
		* @param {Object} [options]
		*        Object of option names and values.
		*
		* @param {PlayerReadyCallback} [ready]
		*        Ready callback function.
		*/
		constructor(tag, options, ready) {
			tag.id = tag.id || options.id || `vjs_video_${newGUID()}`;
			options = Object.assign(Player.getTagSettings(tag), options);
			options.initChildren = false;
			options.createEl = false;
			options.evented = false;
			options.reportTouchActivity = false;
			if (!options.language) {
				const closest = tag.closest("[lang]");
				if (closest) options.language = closest.getAttribute("lang");
			}
			super(null, options, ready);
			this.boundDocumentFullscreenChange_ = (e) => this.documentFullscreenChange_(e);
			this.boundFullWindowOnEscKey_ = (e) => this.fullWindowOnEscKey(e);
			this.boundUpdateStyleEl_ = (e) => this.updateStyleEl_(e);
			this.boundApplyInitTime_ = (e) => this.applyInitTime_(e);
			this.boundUpdateCurrentBreakpoint_ = (e) => this.updateCurrentBreakpoint_(e);
			this.boundHandleTechClick_ = (e) => this.handleTechClick_(e);
			this.boundHandleTechDoubleClick_ = (e) => this.handleTechDoubleClick_(e);
			this.boundHandleTechTouchStart_ = (e) => this.handleTechTouchStart_(e);
			this.boundHandleTechTouchMove_ = (e) => this.handleTechTouchMove_(e);
			this.boundHandleTechTouchEnd_ = (e) => this.handleTechTouchEnd_(e);
			this.boundHandleTechTap_ = (e) => this.handleTechTap_(e);
			this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (e) => this.updatePlayerHeightOnAudioOnlyMode_(e);
			this.isFullscreen_ = false;
			this.log = createLogger(this.id_);
			this.fsApi_ = FullscreenApi;
			this.isPosterFromTech_ = false;
			this.queuedCallbacks_ = [];
			this.isReady_ = false;
			this.hasStarted_ = false;
			this.userActive_ = false;
			this.debugEnabled_ = false;
			this.audioOnlyMode_ = false;
			this.audioPosterMode_ = false;
			this.audioOnlyCache_ = {
				controlBarHeight: null,
				playerHeight: null,
				hiddenChildren: []
			};
			if (!this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
			this.tag = tag;
			this.tagAttributes = tag && getAttributes(tag);
			this.language(this.options_.language);
			if (options.languages) {
				const languagesToLower = {};
				Object.getOwnPropertyNames(options.languages).forEach(function(name) {
					languagesToLower[name.toLowerCase()] = options.languages[name];
				});
				this.languages_ = languagesToLower;
			} else this.languages_ = Player.prototype.options_.languages;
			this.resetCache_();
			/** @type string */
			this.poster_ = options.poster || "";
			/** @type {boolean} */
			this.controls_ = !!options.controls;
			tag.controls = false;
			tag.removeAttribute("controls");
			this.changingSrc_ = false;
			this.playCallbacks_ = [];
			this.playTerminatedQueue_ = [];
			if (tag.hasAttribute("autoplay")) this.autoplay(true);
			else this.autoplay(this.options_.autoplay);
			if (options.plugins) Object.keys(options.plugins).forEach((name) => {
				if (typeof this[name] !== "function") throw new Error(`plugin "${name}" does not exist`);
			});
			this.scrubbing_ = false;
			this.el_ = this.createEl();
			evented(this, { eventBusKey: "el_" });
			if (this.fsApi_.requestFullscreen) {
				on(document__default["default"], this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
				this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
			}
			if (this.fluid_) this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
			const playerOptionsCopy = merge(this.options_);
			if (options.plugins) Object.keys(options.plugins).forEach((name) => {
				this[name](options.plugins[name]);
			});
			if (options.debug) this.debug(true);
			this.options_.playerOptions = playerOptionsCopy;
			this.middleware_ = [];
			this.playbackRates(options.playbackRates);
			if (options.experimentalSvgIcons) {
				const parsedSVG = new window__default["default"].DOMParser().parseFromString(icons, "image/svg+xml");
				if (parsedSVG.querySelector("parsererror")) {
					log.warn("Failed to load SVG Icons. Falling back to Font Icons.");
					this.options_.experimentalSvgIcons = null;
				} else {
					const sprite = parsedSVG.documentElement;
					sprite.style.display = "none";
					this.el_.appendChild(sprite);
					this.addClass("vjs-svg-icons-enabled");
				}
			}
			this.initChildren();
			this.isAudio(tag.nodeName.toLowerCase() === "audio");
			if (this.controls()) this.addClass("vjs-controls-enabled");
			else this.addClass("vjs-controls-disabled");
			this.el_.setAttribute("role", "region");
			if (this.isAudio()) this.el_.setAttribute("aria-label", this.localize("Audio Player"));
			else this.el_.setAttribute("aria-label", this.localize("Video Player"));
			if (this.isAudio()) this.addClass("vjs-audio");
			if (options.spatialNavigation && options.spatialNavigation.enabled) {
				this.spatialNavigation = new SpatialNavigation(this);
				this.addClass("vjs-spatial-navigation-enabled");
			}
			if (TOUCH_ENABLED) this.addClass("vjs-touch-enabled");
			if (!IS_IOS) this.addClass("vjs-workinghover");
			Player.players[this.id_] = this;
			const majorVersion = version.split(".")[0];
			this.addClass(`vjs-v${majorVersion}`);
			this.userActive(true);
			this.reportUserActivity();
			this.one("play", (e) => this.listenForUserActivity_(e));
			this.on("keydown", (e) => this.handleKeyDown(e));
			this.on("languagechange", (e) => this.handleLanguagechange(e));
			this.breakpoints(this.options_.breakpoints);
			this.responsive(this.options_.responsive);
			this.on("ready", () => {
				this.audioPosterMode(this.options_.audioPosterMode);
				this.audioOnlyMode(this.options_.audioOnlyMode);
			});
		}
		/**
		* Destroys the video player and does any necessary cleanup.
		*
		* This is especially helpful if you are dynamically adding and removing videos
		* to/from the DOM.
		*
		* @fires Player#dispose
		*/
		dispose() {
			/**
			* Called when the player is being disposed of.
			*
			* @event Player#dispose
			* @type {Event}
			*/
			this.trigger("dispose");
			this.off("dispose");
			off(document__default["default"], this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
			off(document__default["default"], "keydown", this.boundFullWindowOnEscKey_);
			if (this.styleEl_ && this.styleEl_.parentNode) {
				this.styleEl_.parentNode.removeChild(this.styleEl_);
				this.styleEl_ = null;
			}
			Player.players[this.id_] = null;
			if (this.tag && this.tag.player) this.tag.player = null;
			if (this.el_ && this.el_.player) this.el_.player = null;
			if (this.tech_) {
				this.tech_.dispose();
				this.isPosterFromTech_ = false;
				this.poster_ = "";
			}
			if (this.playerElIngest_) this.playerElIngest_ = null;
			if (this.tag) this.tag = null;
			clearCacheForPlayer(this);
			ALL.names.forEach((name) => {
				const props = ALL[name];
				const list = this[props.getterName]();
				if (list && list.off) list.off();
			});
			super.dispose({ restoreEl: this.options_.restoreEl });
		}
		/**
		* Create the `Player`'s DOM element.
		*
		* @return {Element}
		*         The DOM element that gets created.
		*/
		createEl() {
			let tag = this.tag;
			let el;
			let playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute("data-vjs-player");
			const divEmbed = this.tag.tagName.toLowerCase() === "video-js";
			if (playerElIngest) el = this.el_ = tag.parentNode;
			else if (!divEmbed) el = this.el_ = super.createEl("div");
			const attrs = getAttributes(tag);
			if (divEmbed) {
				el = this.el_ = tag;
				tag = this.tag = document__default["default"].createElement("video");
				while (el.children.length) tag.appendChild(el.firstChild);
				if (!hasClass(el, "video-js")) addClass(el, "video-js");
				el.appendChild(tag);
				playerElIngest = this.playerElIngest_ = el;
				Object.keys(el).forEach((k) => {
					try {
						tag[k] = el[k];
					} catch (e) {}
				});
			}
			tag.setAttribute("tabindex", "-1");
			attrs.tabindex = "-1";
			if (IS_CHROME && IS_WINDOWS) {
				tag.setAttribute("role", "application");
				attrs.role = "application";
			}
			tag.removeAttribute("width");
			tag.removeAttribute("height");
			if ("width" in attrs) delete attrs.width;
			if ("height" in attrs) delete attrs.height;
			Object.getOwnPropertyNames(attrs).forEach(function(attr) {
				if (!(divEmbed && attr === "class")) el.setAttribute(attr, attrs[attr]);
				if (divEmbed) tag.setAttribute(attr, attrs[attr]);
			});
			tag.playerId = tag.id;
			tag.id += "_html5_api";
			tag.className = "vjs-tech";
			tag.player = el.player = this;
			this.addClass("vjs-paused");
			const deviceClassNames = [
				"IS_SMART_TV",
				"IS_TIZEN",
				"IS_WEBOS",
				"IS_ANDROID",
				"IS_IPAD",
				"IS_IPHONE",
				"IS_CHROMECAST_RECEIVER"
			].filter((key) => browser[key]).map((key) => {
				return "vjs-device-" + key.substring(3).toLowerCase().replace(/\_/g, "-");
			});
			this.addClass(...deviceClassNames);
			if (window__default["default"].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
				this.styleEl_ = createStyleElement("vjs-styles-dimensions");
				const defaultsStyleEl = $(".vjs-styles-defaults");
				const head = $("head");
				head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
			}
			this.fill_ = false;
			this.fluid_ = false;
			this.width(this.options_.width);
			this.height(this.options_.height);
			this.fill(this.options_.fill);
			this.fluid(this.options_.fluid);
			this.aspectRatio(this.options_.aspectRatio);
			this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
			const links = tag.getElementsByTagName("a");
			for (let i = 0; i < links.length; i++) {
				const linkEl = links.item(i);
				addClass(linkEl, "vjs-hidden");
				linkEl.setAttribute("hidden", "hidden");
			}
			tag.initNetworkState_ = tag.networkState;
			if (tag.parentNode && !playerElIngest) tag.parentNode.insertBefore(el, tag);
			prependTo(tag, el);
			this.children_.unshift(tag);
			this.el_.setAttribute("lang", this.language_);
			this.el_.setAttribute("translate", "no");
			this.el_ = el;
			return el;
		}
		/**
		* Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
		* sets the `crossOrigin` property on the `<video>` tag to control the CORS
		* behavior.
		*
		* @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
		*
		* @param {string|null} [value]
		*        The value to set the `Player`'s crossOrigin to. If an argument is
		*        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
		*
		* @return {string|null|undefined}
		*         - The current crossOrigin value of the `Player` when getting.
		*         - undefined when setting
		*/
		crossOrigin(value) {
			if (typeof value === "undefined") return this.techGet_("crossOrigin");
			if (value !== null && value !== "anonymous" && value !== "use-credentials") {
				log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
				return;
			}
			this.techCall_("setCrossOrigin", value);
			if (this.posterImage) this.posterImage.crossOrigin(value);
		}
		/**
		* A getter/setter for the `Player`'s width. Returns the player's configured value.
		* To get the current width use `currentWidth()`.
		*
		* @param {number|string} [value]
		*        CSS value to set the `Player`'s width to.
		*
		* @return {number|undefined}
		*         - The current width of the `Player` when getting.
		*         - Nothing when setting
		*/
		width(value) {
			return this.dimension("width", value);
		}
		/**
		* A getter/setter for the `Player`'s height. Returns the player's configured value.
		* To get the current height use `currentheight()`.
		*
		* @param {number|string} [value]
		*        CSS value to set the `Player`'s height to.
		*
		* @return {number|undefined}
		*         - The current height of the `Player` when getting.
		*         - Nothing when setting
		*/
		height(value) {
			return this.dimension("height", value);
		}
		/**
		* A getter/setter for the `Player`'s width & height.
		*
		* @param {string} dimension
		*        This string can be:
		*        - 'width'
		*        - 'height'
		*
		* @param {number|string} [value]
		*        Value for dimension specified in the first argument.
		*
		* @return {number}
		*         The dimension arguments value when getting (width/height).
		*/
		dimension(dimension, value) {
			const privDimension = dimension + "_";
			if (value === void 0) return this[privDimension] || 0;
			if (value === "" || value === "auto") {
				this[privDimension] = void 0;
				this.updateStyleEl_();
				return;
			}
			const parsedVal = parseFloat(value);
			if (isNaN(parsedVal)) {
				log.error(`Improper value "${value}" supplied for for ${dimension}`);
				return;
			}
			this[privDimension] = parsedVal;
			this.updateStyleEl_();
		}
		/**
		* A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
		*
		* Turning this on will turn off fill mode.
		*
		* @param {boolean} [bool]
		*        - A value of true adds the class.
		*        - A value of false removes the class.
		*        - No value will be a getter.
		*
		* @return {boolean|undefined}
		*         - The value of fluid when getting.
		*         - `undefined` when setting.
		*/
		fluid(bool) {
			if (bool === void 0) return !!this.fluid_;
			this.fluid_ = !!bool;
			if (isEvented(this)) this.off(["playerreset", "resize"], this.boundUpdateStyleEl_);
			if (bool) {
				this.addClass("vjs-fluid");
				this.fill(false);
				addEventedCallback(this, () => {
					this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
				});
			} else this.removeClass("vjs-fluid");
			this.updateStyleEl_();
		}
		/**
		* A getter/setter/toggler for the vjs-fill `className` on the `Player`.
		*
		* Turning this on will turn off fluid mode.
		*
		* @param {boolean} [bool]
		*        - A value of true adds the class.
		*        - A value of false removes the class.
		*        - No value will be a getter.
		*
		* @return {boolean|undefined}
		*         - The value of fluid when getting.
		*         - `undefined` when setting.
		*/
		fill(bool) {
			if (bool === void 0) return !!this.fill_;
			this.fill_ = !!bool;
			if (bool) {
				this.addClass("vjs-fill");
				this.fluid(false);
			} else this.removeClass("vjs-fill");
		}
		/**
		* Get/Set the aspect ratio
		*
		* @param {string} [ratio]
		*        Aspect ratio for player
		*
		* @return {string|undefined}
		*         returns the current aspect ratio when getting
		*/
		/**
		* A getter/setter for the `Player`'s aspect ratio.
		*
		* @param {string} [ratio]
		*        The value to set the `Player`'s aspect ratio to.
		*
		* @return {string|undefined}
		*         - The current aspect ratio of the `Player` when getting.
		*         - undefined when setting
		*/
		aspectRatio(ratio) {
			if (ratio === void 0) return this.aspectRatio_;
			if (!/^\d+\:\d+$/.test(ratio)) throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
			this.aspectRatio_ = ratio;
			this.fluid(true);
			this.updateStyleEl_();
		}
		/**
		* Update styles of the `Player` element (height, width and aspect ratio).
		*
		* @private
		* @listens Tech#loadedmetadata
		*/
		updateStyleEl_() {
			if (window__default["default"].VIDEOJS_NO_DYNAMIC_STYLE === true) {
				const width = typeof this.width_ === "number" ? this.width_ : this.options_.width;
				const height = typeof this.height_ === "number" ? this.height_ : this.options_.height;
				const techEl = this.tech_ && this.tech_.el();
				if (techEl) {
					if (width >= 0) techEl.width = width;
					if (height >= 0) techEl.height = height;
				}
				return;
			}
			let width;
			let height;
			let aspectRatio;
			let idClass;
			if (this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto") aspectRatio = this.aspectRatio_;
			else if (this.videoWidth() > 0) aspectRatio = this.videoWidth() + ":" + this.videoHeight();
			else aspectRatio = "16:9";
			const ratioParts = aspectRatio.split(":");
			const ratioMultiplier = ratioParts[1] / ratioParts[0];
			if (this.width_ !== void 0) width = this.width_;
			else if (this.height_ !== void 0) width = this.height_ / ratioMultiplier;
			else width = this.videoWidth() || 300;
			if (this.height_ !== void 0) height = this.height_;
			else height = width * ratioMultiplier;
			if (/^[^a-zA-Z]/.test(this.id())) idClass = "dimensions-" + this.id();
			else idClass = this.id() + "-dimensions";
			this.addClass(idClass);
			setTextContent(this.styleEl_, `
      .${idClass} {
        width: ${width}px;
        height: ${height}px;
      }

      .${idClass}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${ratioMultiplier * 100}%;
      }
    `);
		}
		/**
		* Load/Create an instance of playback {@link Tech} including element
		* and API methods. Then append the `Tech` element in `Player` as a child.
		*
		* @param {string} techName
		*        name of the playback technology
		*
		* @param {string} source
		*        video source
		*
		* @private
		*/
		loadTech_(techName, source) {
			if (this.tech_) this.unloadTech_();
			const titleTechName = toTitleCase(techName);
			const camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
			if (titleTechName !== "Html5" && this.tag) {
				Tech.getTech("Html5").disposeMediaElement(this.tag);
				this.tag.player = null;
				this.tag = null;
			}
			this.techName_ = titleTechName;
			this.isReady_ = false;
			let autoplay = this.autoplay();
			if (typeof this.autoplay() === "string" || this.autoplay() === true && this.options_.normalizeAutoplay) autoplay = false;
			const techOptions = {
				source,
				autoplay,
				"nativeControlsForTouch": this.options_.nativeControlsForTouch,
				"playerId": this.id(),
				"techId": `${this.id()}_${camelTechName}_api`,
				"playsinline": this.options_.playsinline,
				"preload": this.options_.preload,
				"loop": this.options_.loop,
				"disablePictureInPicture": this.options_.disablePictureInPicture,
				"muted": this.options_.muted,
				"poster": this.poster(),
				"language": this.language(),
				"playerElIngest": this.playerElIngest_ || false,
				"vtt.js": this.options_["vtt.js"],
				"canOverridePoster": !!this.options_.techCanOverridePoster,
				"enableSourceset": this.options_.enableSourceset
			};
			ALL.names.forEach((name) => {
				const props = ALL[name];
				techOptions[props.getterName] = this[props.privateName];
			});
			Object.assign(techOptions, this.options_[titleTechName]);
			Object.assign(techOptions, this.options_[camelTechName]);
			Object.assign(techOptions, this.options_[techName.toLowerCase()]);
			if (this.tag) techOptions.tag = this.tag;
			if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) techOptions.startTime = this.cache_.currentTime;
			const TechClass = Tech.getTech(techName);
			if (!TechClass) throw new Error(`No Tech named '${titleTechName}' exists! '${titleTechName}' should be registered using videojs.registerTech()'`);
			this.tech_ = new TechClass(techOptions);
			this.tech_.ready(bind_(this, this.handleTechReady_), true);
			textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
			TECH_EVENTS_RETRIGGER.forEach((event) => {
				this.on(this.tech_, event, (e) => this[`handleTech${toTitleCase(event)}_`](e));
			});
			Object.keys(TECH_EVENTS_QUEUE).forEach((event) => {
				this.on(this.tech_, event, (eventObj) => {
					if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
						this.queuedCallbacks_.push({
							callback: this[`handleTech${TECH_EVENTS_QUEUE[event]}_`].bind(this),
							event: eventObj
						});
						return;
					}
					this[`handleTech${TECH_EVENTS_QUEUE[event]}_`](eventObj);
				});
			});
			this.on(this.tech_, "loadstart", (e) => this.handleTechLoadStart_(e));
			this.on(this.tech_, "sourceset", (e) => this.handleTechSourceset_(e));
			this.on(this.tech_, "waiting", (e) => this.handleTechWaiting_(e));
			this.on(this.tech_, "ended", (e) => this.handleTechEnded_(e));
			this.on(this.tech_, "seeking", (e) => this.handleTechSeeking_(e));
			this.on(this.tech_, "play", (e) => this.handleTechPlay_(e));
			this.on(this.tech_, "pause", (e) => this.handleTechPause_(e));
			this.on(this.tech_, "durationchange", (e) => this.handleTechDurationChange_(e));
			this.on(this.tech_, "fullscreenchange", (e, data) => this.handleTechFullscreenChange_(e, data));
			this.on(this.tech_, "fullscreenerror", (e, err) => this.handleTechFullscreenError_(e, err));
			this.on(this.tech_, "enterpictureinpicture", (e) => this.handleTechEnterPictureInPicture_(e));
			this.on(this.tech_, "leavepictureinpicture", (e) => this.handleTechLeavePictureInPicture_(e));
			this.on(this.tech_, "error", (e) => this.handleTechError_(e));
			this.on(this.tech_, "posterchange", (e) => this.handleTechPosterChange_(e));
			this.on(this.tech_, "textdata", (e) => this.handleTechTextData_(e));
			this.on(this.tech_, "ratechange", (e) => this.handleTechRateChange_(e));
			this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_);
			this.usingNativeControls(this.techGet_("controls"));
			if (this.controls() && !this.usingNativeControls()) this.addTechControlsListeners_();
			if (this.tech_.el().parentNode !== this.el() && (titleTechName !== "Html5" || !this.tag)) prependTo(this.tech_.el(), this.el());
			if (this.tag) {
				this.tag.player = null;
				this.tag = null;
			}
		}
		/**
		* Unload and dispose of the current playback {@link Tech}.
		*
		* @private
		*/
		unloadTech_() {
			ALL.names.forEach((name) => {
				const props = ALL[name];
				this[props.privateName] = this[props.getterName]();
			});
			this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
			this.isReady_ = false;
			this.tech_.dispose();
			this.tech_ = false;
			if (this.isPosterFromTech_) {
				this.poster_ = "";
				this.trigger("posterchange");
			}
			this.isPosterFromTech_ = false;
		}
		/**
		* Return a reference to the current {@link Tech}.
		* It will print a warning by default about the danger of using the tech directly
		* but any argument that is passed in will silence the warning.
		*
		* @param {*} [safety]
		*        Anything passed in to silence the warning
		*
		* @return {Tech}
		*         The Tech
		*/
		tech(safety) {
			if (safety === void 0) log.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n");
			return this.tech_;
		}
		/**
		* An object that contains Video.js version.
		*
		* @typedef {Object} PlayerVersion
		*
		* @property {string} 'video.js' - Video.js version
		*/
		/**
		* Returns an object with Video.js version.
		*
		* @return {PlayerVersion}
		*          An object with Video.js version.
		*/
		version() {
			return { "video.js": version };
		}
		/**
		* Set up click and touch listeners for the playback element
		*
		* - On desktops: a click on the video itself will toggle playback
		* - On mobile devices: a click on the video toggles controls
		*   which is done by toggling the user state between active and
		*   inactive
		* - A tap can signal that a user has become active or has become inactive
		*   e.g. a quick tap on an iPhone movie should reveal the controls. Another
		*   quick tap should hide them again (signaling the user is in an inactive
		*   viewing state)
		* - In addition to this, we still want the user to be considered inactive after
		*   a few seconds of inactivity.
		*
		* > Note: the only part of iOS interaction we can't mimic with this setup
		* is a touch and hold on the video element counting as activity in order to
		* keep the controls showing, but that shouldn't be an issue. A touch and hold
		* on any controls will still keep the user active
		*
		* @private
		*/
		addTechControlsListeners_() {
			this.removeTechControlsListeners_();
			this.on(this.tech_, "click", this.boundHandleTechClick_);
			this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
			this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
			this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
			this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
			this.on(this.tech_, "tap", this.boundHandleTechTap_);
		}
		/**
		* Remove the listeners used for click and tap controls. This is needed for
		* toggling to controls disabled, where a tap/touch should do nothing.
		*
		* @private
		*/
		removeTechControlsListeners_() {
			this.off(this.tech_, "tap", this.boundHandleTechTap_);
			this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
			this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
			this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
			this.off(this.tech_, "click", this.boundHandleTechClick_);
			this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
		}
		/**
		* Player waits for the tech to be ready
		*
		* @private
		*/
		handleTechReady_() {
			this.triggerReady();
			if (this.cache_.volume) this.techCall_("setVolume", this.cache_.volume);
			this.handleTechPosterChange_();
			this.handleTechDurationChange_();
		}
		/**
		* Retrigger the `loadstart` event that was triggered by the {@link Tech}.
		*
		* @fires Player#loadstart
		* @listens Tech#loadstart
		* @private
		*/
		handleTechLoadStart_() {
			this.removeClass("vjs-ended", "vjs-seeking");
			this.error(null);
			this.handleTechDurationChange_();
			if (!this.paused())
 /**
			* Fired when the user agent begins looking for media data
			*
			* @event Player#loadstart
			* @type {Event}
			*/
			this.trigger("loadstart");
			else {
				this.hasStarted(false);
				this.trigger("loadstart");
			}
			this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? "play" : this.autoplay());
		}
		/**
		* Handle autoplay string values, rather than the typical boolean
		* values that should be handled by the tech. Note that this is not
		* part of any specification. Valid values and what they do can be
		* found on the autoplay getter at Player#autoplay()
		*/
		manualAutoplay_(type) {
			if (!this.tech_ || typeof type !== "string") return;
			const resolveMuted = () => {
				const previouslyMuted = this.muted();
				this.muted(true);
				const restoreMuted = () => {
					this.muted(previouslyMuted);
				};
				this.playTerminatedQueue_.push(restoreMuted);
				const mutedPromise = this.play();
				if (!isPromise(mutedPromise)) return;
				return mutedPromise.catch((err) => {
					restoreMuted();
					throw new Error(`Rejection at manualAutoplay. Restoring muted value. ${err ? err : ""}`);
				});
			};
			let promise;
			if (type === "any" && !this.muted()) {
				promise = this.play();
				if (isPromise(promise)) promise = promise.catch(resolveMuted);
			} else if (type === "muted" && !this.muted()) promise = resolveMuted();
			else promise = this.play();
			if (!isPromise(promise)) return;
			return promise.then(() => {
				this.trigger({
					type: "autoplay-success",
					autoplay: type
				});
			}).catch(() => {
				this.trigger({
					type: "autoplay-failure",
					autoplay: type
				});
			});
		}
		/**
		* Update the internal source caches so that we return the correct source from
		* `src()`, `currentSource()`, and `currentSources()`.
		*
		* > Note: `currentSources` will not be updated if the source that is passed in exists
		*         in the current `currentSources` cache.
		*
		*
		* @param {Tech~SourceObject} srcObj
		*        A string or object source to update our caches to.
		*/
		updateSourceCaches_(srcObj = "") {
			let src = srcObj;
			let type = "";
			if (typeof src !== "string") {
				src = srcObj.src;
				type = srcObj.type;
			}
			this.cache_.source = this.cache_.source || {};
			this.cache_.sources = this.cache_.sources || [];
			if (src && !type) type = findMimetype(this, src);
			this.cache_.source = merge({}, srcObj, {
				src,
				type
			});
			const matchingSources = this.cache_.sources.filter((s) => s.src && s.src === src);
			const sourceElSources = [];
			const sourceEls = this.$$("source");
			const matchingSourceEls = [];
			for (let i = 0; i < sourceEls.length; i++) {
				const sourceObj = getAttributes(sourceEls[i]);
				sourceElSources.push(sourceObj);
				if (sourceObj.src && sourceObj.src === src) matchingSourceEls.push(sourceObj.src);
			}
			if (matchingSourceEls.length && !matchingSources.length) this.cache_.sources = sourceElSources;
			else if (!matchingSources.length) this.cache_.sources = [this.cache_.source];
			this.cache_.src = src;
		}
		/**
		* *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
		* causing the media element to reload.
		*
		* It will fire for the initial source and each subsequent source.
		* This event is a custom event from Video.js and is triggered by the {@link Tech}.
		*
		* The event object for this event contains a `src` property that will contain the source
		* that was available when the event was triggered. This is generally only necessary if Video.js
		* is switching techs while the source was being changed.
		*
		* It is also fired when `load` is called on the player (or media element)
		* because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
		* says that the resource selection algorithm needs to be aborted and restarted.
		* In this case, it is very likely that the `src` property will be set to the
		* empty string `""` to indicate we do not know what the source will be but
		* that it is changing.
		*
		* *This event is currently still experimental and may change in minor releases.*
		* __To use this, pass `enableSourceset` option to the player.__
		*
		* @event Player#sourceset
		* @type {Event}
		* @prop {string} src
		*                The source url available when the `sourceset` was triggered.
		*                It will be an empty string if we cannot know what the source is
		*                but know that the source will change.
		*/
		/**
		* Retrigger the `sourceset` event that was triggered by the {@link Tech}.
		*
		* @fires Player#sourceset
		* @listens Tech#sourceset
		* @private
		*/
		handleTechSourceset_(event) {
			if (!this.changingSrc_) {
				let updateSourceCaches = (src) => this.updateSourceCaches_(src);
				const playerSrc = this.currentSource().src;
				const eventSrc = event.src;
				if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
					if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) updateSourceCaches = () => {};
				}
				updateSourceCaches(eventSrc);
				if (!event.src) this.tech_.any(["sourceset", "loadstart"], (e) => {
					if (e.type === "sourceset") return;
					const techSrc = this.techGet_("currentSrc");
					this.lastSource_.tech = techSrc;
					this.updateSourceCaches_(techSrc);
				});
			}
			this.lastSource_ = {
				player: this.currentSource().src,
				tech: event.src
			};
			this.trigger({
				src: event.src,
				type: "sourceset"
			});
		}
		/**
		* Add/remove the vjs-has-started class
		*
		*
		* @param {boolean} request
		*        - true: adds the class
		*        - false: remove the class
		*
		* @return {boolean}
		*         the boolean value of hasStarted_
		*/
		hasStarted(request) {
			if (request === void 0) return this.hasStarted_;
			if (request === this.hasStarted_) return;
			this.hasStarted_ = request;
			if (this.hasStarted_) this.addClass("vjs-has-started");
			else this.removeClass("vjs-has-started");
		}
		/**
		* Fired whenever the media begins or resumes playback
		*
		* @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
		* @fires Player#play
		* @listens Tech#play
		* @private
		*/
		handleTechPlay_() {
			this.removeClass("vjs-ended", "vjs-paused");
			this.addClass("vjs-playing");
			this.hasStarted(true);
			/**
			* Triggered whenever an {@link Tech#play} event happens. Indicates that
			* playback has started or resumed.
			*
			* @event Player#play
			* @type {Event}
			*/
			this.trigger("play");
		}
		/**
		* Retrigger the `ratechange` event that was triggered by the {@link Tech}.
		*
		* If there were any events queued while the playback rate was zero, fire
		* those events now.
		*
		* @private
		* @method Player#handleTechRateChange_
		* @fires Player#ratechange
		* @listens Tech#ratechange
		*/
		handleTechRateChange_() {
			if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
				this.queuedCallbacks_.forEach((queued) => queued.callback(queued.event));
				this.queuedCallbacks_ = [];
			}
			this.cache_.lastPlaybackRate = this.tech_.playbackRate();
			/**
			* Fires when the playing speed of the audio/video is changed
			*
			* @event Player#ratechange
			* @type {event}
			*/
			this.trigger("ratechange");
		}
		/**
		* Retrigger the `waiting` event that was triggered by the {@link Tech}.
		*
		* @fires Player#waiting
		* @listens Tech#waiting
		* @private
		*/
		handleTechWaiting_() {
			this.addClass("vjs-waiting");
			/**
			* A readyState change on the DOM element has caused playback to stop.
			*
			* @event Player#waiting
			* @type {Event}
			*/
			this.trigger("waiting");
			const timeWhenWaiting = this.currentTime();
			const timeUpdateListener = () => {
				if (timeWhenWaiting !== this.currentTime()) {
					this.removeClass("vjs-waiting");
					this.off("timeupdate", timeUpdateListener);
				}
			};
			this.on("timeupdate", timeUpdateListener);
		}
		/**
		* Retrigger the `canplay` event that was triggered by the {@link Tech}.
		* > Note: This is not consistent between browsers. See #1351
		*
		* @fires Player#canplay
		* @listens Tech#canplay
		* @private
		*/
		handleTechCanPlay_() {
			this.removeClass("vjs-waiting");
			/**
			* The media has a readyState of HAVE_FUTURE_DATA or greater.
			*
			* @event Player#canplay
			* @type {Event}
			*/
			this.trigger("canplay");
		}
		/**
		* Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
		*
		* @fires Player#canplaythrough
		* @listens Tech#canplaythrough
		* @private
		*/
		handleTechCanPlayThrough_() {
			this.removeClass("vjs-waiting");
			/**
			* The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
			* entire media file can be played without buffering.
			*
			* @event Player#canplaythrough
			* @type {Event}
			*/
			this.trigger("canplaythrough");
		}
		/**
		* Retrigger the `playing` event that was triggered by the {@link Tech}.
		*
		* @fires Player#playing
		* @listens Tech#playing
		* @private
		*/
		handleTechPlaying_() {
			this.removeClass("vjs-waiting");
			/**
			* The media is no longer blocked from playback, and has started playing.
			*
			* @event Player#playing
			* @type {Event}
			*/
			this.trigger("playing");
		}
		/**
		* Retrigger the `seeking` event that was triggered by the {@link Tech}.
		*
		* @fires Player#seeking
		* @listens Tech#seeking
		* @private
		*/
		handleTechSeeking_() {
			this.addClass("vjs-seeking");
			/**
			* Fired whenever the player is jumping to a new time
			*
			* @event Player#seeking
			* @type {Event}
			*/
			this.trigger("seeking");
		}
		/**
		* Retrigger the `seeked` event that was triggered by the {@link Tech}.
		*
		* @fires Player#seeked
		* @listens Tech#seeked
		* @private
		*/
		handleTechSeeked_() {
			this.removeClass("vjs-seeking", "vjs-ended");
			/**
			* Fired when the player has finished jumping to a new time
			*
			* @event Player#seeked
			* @type {Event}
			*/
			this.trigger("seeked");
		}
		/**
		* Retrigger the `pause` event that was triggered by the {@link Tech}.
		*
		* @fires Player#pause
		* @listens Tech#pause
		* @private
		*/
		handleTechPause_() {
			this.removeClass("vjs-playing");
			this.addClass("vjs-paused");
			/**
			* Fired whenever the media has been paused
			*
			* @event Player#pause
			* @type {Event}
			*/
			this.trigger("pause");
		}
		/**
		* Retrigger the `ended` event that was triggered by the {@link Tech}.
		*
		* @fires Player#ended
		* @listens Tech#ended
		* @private
		*/
		handleTechEnded_() {
			this.addClass("vjs-ended");
			this.removeClass("vjs-waiting");
			if (this.options_.loop) {
				this.currentTime(0);
				this.play();
			} else if (!this.paused()) this.pause();
			/**
			* Fired when the end of the media resource is reached (currentTime == duration)
			*
			* @event Player#ended
			* @type {Event}
			*/
			this.trigger("ended");
		}
		/**
		* Fired when the duration of the media resource is first known or changed
		*
		* @listens Tech#durationchange
		* @private
		*/
		handleTechDurationChange_() {
			this.duration(this.techGet_("duration"));
		}
		/**
		* Handle a click on the media element to play/pause
		*
		* @param {Event} event
		*        the event that caused this function to trigger
		*
		* @listens Tech#click
		* @private
		*/
		handleTechClick_(event) {
			if (!this.controls_) return;
			if (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== false) if (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click === "function") this.options_.userActions.click.call(this, event);
			else if (this.paused()) silencePromise(this.play());
			else this.pause();
		}
		/**
		* Handle a double-click on the media element to enter/exit fullscreen,
		* or exit documentPictureInPicture mode
		*
		* @param {Event} event
		*        the event that caused this function to trigger
		*
		* @listens Tech#dblclick
		* @private
		*/
		handleTechDoubleClick_(event) {
			if (!this.controls_) return;
			if (!Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (el) => el.contains(event.target))) {
				if (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== false) if (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick === "function") this.options_.userActions.doubleClick.call(this, event);
				else if (this.isInPictureInPicture() && !document__default["default"].pictureInPictureElement) this.exitPictureInPicture();
				else if (this.isFullscreen()) this.exitFullscreen();
				else this.requestFullscreen();
			}
		}
		/**
		* Handle a tap on the media element. It will toggle the user
		* activity state, which hides and shows the controls.
		*
		* @listens Tech#tap
		* @private
		*/
		handleTechTap_() {
			this.userActive(!this.userActive());
		}
		/**
		* Handle touch to start
		*
		* @listens Tech#touchstart
		* @private
		*/
		handleTechTouchStart_() {
			this.userWasActive = this.userActive();
		}
		/**
		* Handle touch to move
		*
		* @listens Tech#touchmove
		* @private
		*/
		handleTechTouchMove_() {
			if (this.userWasActive) this.reportUserActivity();
		}
		/**
		* Handle touch to end
		*
		* @param {Event} event
		*        the touchend event that triggered
		*        this function
		*
		* @listens Tech#touchend
		* @private
		*/
		handleTechTouchEnd_(event) {
			if (event.cancelable) event.preventDefault();
		}
		/**
		* @private
		*/
		toggleFullscreenClass_() {
			if (this.isFullscreen()) this.addClass("vjs-fullscreen");
			else this.removeClass("vjs-fullscreen");
		}
		/**
		* when the document fschange event triggers it calls this
		*/
		documentFullscreenChange_(e) {
			const targetPlayer = e.target.player;
			if (targetPlayer && targetPlayer !== this) return;
			const el = this.el();
			let isFs = document__default["default"][this.fsApi_.fullscreenElement] === el;
			if (!isFs && el.matches) isFs = el.matches(":" + this.fsApi_.fullscreen);
			this.isFullscreen(isFs);
		}
		/**
		* Handle Tech Fullscreen Change
		*
		* @param {Event} event
		*        the fullscreenchange event that triggered this function
		*
		* @param {Object} data
		*        the data that was sent with the event
		*
		* @private
		* @listens Tech#fullscreenchange
		* @fires Player#fullscreenchange
		*/
		handleTechFullscreenChange_(event, data) {
			if (data) {
				if (data.nativeIOSFullscreen) {
					this.addClass("vjs-ios-native-fs");
					this.tech_.one("webkitendfullscreen", () => {
						this.removeClass("vjs-ios-native-fs");
					});
				}
				this.isFullscreen(data.isFullscreen);
			}
		}
		handleTechFullscreenError_(event, err) {
			this.trigger("fullscreenerror", err);
		}
		/**
		* @private
		*/
		togglePictureInPictureClass_() {
			if (this.isInPictureInPicture()) this.addClass("vjs-picture-in-picture");
			else this.removeClass("vjs-picture-in-picture");
		}
		/**
		* Handle Tech Enter Picture-in-Picture.
		*
		* @param {Event} event
		*        the enterpictureinpicture event that triggered this function
		*
		* @private
		* @listens Tech#enterpictureinpicture
		*/
		handleTechEnterPictureInPicture_(event) {
			this.isInPictureInPicture(true);
		}
		/**
		* Handle Tech Leave Picture-in-Picture.
		*
		* @param {Event} event
		*        the leavepictureinpicture event that triggered this function
		*
		* @private
		* @listens Tech#leavepictureinpicture
		*/
		handleTechLeavePictureInPicture_(event) {
			this.isInPictureInPicture(false);
		}
		/**
		* Fires when an error occurred during the loading of an audio/video.
		*
		* @private
		* @listens Tech#error
		*/
		handleTechError_() {
			const error = this.tech_.error();
			if (error) this.error(error);
		}
		/**
		* Retrigger the `textdata` event that was triggered by the {@link Tech}.
		*
		* @fires Player#textdata
		* @listens Tech#textdata
		* @private
		*/
		handleTechTextData_() {
			let data = null;
			if (arguments.length > 1) data = arguments[1];
			/**
			* Fires when we get a textdata event from tech
			*
			* @event Player#textdata
			* @type {Event}
			*/
			this.trigger("textdata", data);
		}
		/**
		* Get object for cached values.
		*
		* @return {Object}
		*         get the current object cache
		*/
		getCache() {
			return this.cache_;
		}
		/**
		* Resets the internal cache object.
		*
		* Using this function outside the player constructor or reset method may
		* have unintended side-effects.
		*
		* @private
		*/
		resetCache_() {
			this.cache_ = {
				currentTime: 0,
				initTime: 0,
				inactivityTimeout: this.options_.inactivityTimeout,
				duration: NaN,
				lastVolume: 1,
				lastPlaybackRate: this.defaultPlaybackRate(),
				media: null,
				src: "",
				source: {},
				sources: [],
				playbackRates: [],
				volume: 1
			};
		}
		/**
		* Pass values to the playback tech
		*
		* @param {string} [method]
		*        the method to call
		*
		* @param {Object} [arg]
		*        the argument to pass
		*
		* @private
		*/
		techCall_(method, arg) {
			this.ready(function() {
				if (method in allowedSetters) return set(this.middleware_, this.tech_, method, arg);
				else if (method in allowedMediators) return mediate(this.middleware_, this.tech_, method, arg);
				try {
					if (this.tech_) this.tech_[method](arg);
				} catch (e) {
					log(e);
					throw e;
				}
			}, true);
		}
		/**
		* Mediate attempt to call playback tech method
		* and return the value of the method called.
		*
		* @param {string} method
		*        Tech method
		*
		* @return {*}
		*         Value returned by the tech method called, undefined if tech
		*         is not ready or tech method is not present
		*
		* @private
		*/
		techGet_(method) {
			if (!this.tech_ || !this.tech_.isReady_) return;
			if (method in allowedGetters) return get(this.middleware_, this.tech_, method);
			else if (method in allowedMediators) return mediate(this.middleware_, this.tech_, method);
			try {
				return this.tech_[method]();
			} catch (e) {
				if (this.tech_[method] === void 0) {
					log(`Video.js: ${method} method not defined for ${this.techName_} playback technology.`, e);
					throw e;
				}
				if (e.name === "TypeError") {
					log(`Video.js: ${method} unavailable on ${this.techName_} playback technology element.`, e);
					this.tech_.isReady_ = false;
					throw e;
				}
				log(e);
				throw e;
			}
		}
		/**
		* Attempt to begin playback at the first opportunity.
		*
		* @return {Promise|undefined}
		*         Returns a promise if the browser supports Promises (or one
		*         was passed in as an option). This promise will be resolved on
		*         the return value of play. If this is undefined it will fulfill the
		*         promise chain otherwise the promise chain will be fulfilled when
		*         the promise from play is fulfilled.
		*/
		play() {
			return new Promise((resolve) => {
				this.play_(resolve);
			});
		}
		/**
		* The actual logic for play, takes a callback that will be resolved on the
		* return value of play. This allows us to resolve to the play promise if there
		* is one on modern browsers.
		*
		* @private
		* @param {Function} [callback]
		*        The callback that should be called when the techs play is actually called
		*/
		play_(callback = silencePromise) {
			this.playCallbacks_.push(callback);
			const isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
			const isSafariOrIOS = Boolean(IS_ANY_SAFARI || IS_IOS);
			if (this.waitToPlay_) {
				this.off(["ready", "loadstart"], this.waitToPlay_);
				this.waitToPlay_ = null;
			}
			if (!this.isReady_ || !isSrcReady) {
				this.waitToPlay_ = (e) => {
					this.play_();
				};
				this.one(["ready", "loadstart"], this.waitToPlay_);
				if (!isSrcReady && isSafariOrIOS) this.load();
				return;
			}
			const val = this.techGet_("play");
			if (isSafariOrIOS && this.hasClass("vjs-ended")) this.resetProgressBar_();
			if (val === null) this.runPlayTerminatedQueue_();
			else this.runPlayCallbacks_(val);
		}
		/**
		* These functions will be run when if play is terminated. If play
		* runPlayCallbacks_ is run these function will not be run. This allows us
		* to differentiate between a terminated play and an actual call to play.
		*/
		runPlayTerminatedQueue_() {
			const queue = this.playTerminatedQueue_.slice(0);
			this.playTerminatedQueue_ = [];
			queue.forEach(function(q) {
				q();
			});
		}
		/**
		* When a callback to play is delayed we have to run these
		* callbacks when play is actually called on the tech. This function
		* runs the callbacks that were delayed and accepts the return value
		* from the tech.
		*
		* @param {undefined|Promise} val
		*        The return value from the tech.
		*/
		runPlayCallbacks_(val) {
			const callbacks = this.playCallbacks_.slice(0);
			this.playCallbacks_ = [];
			this.playTerminatedQueue_ = [];
			callbacks.forEach(function(cb) {
				cb(val);
			});
		}
		/**
		* Pause the video playback
		*/
		pause() {
			this.techCall_("pause");
		}
		/**
		* Check if the player is paused or has yet to play
		*
		* @return {boolean}
		*         - false: if the media is currently playing
		*         - true: if media is not currently playing
		*/
		paused() {
			return this.techGet_("paused") === false ? false : true;
		}
		/**
		* Get a TimeRange object representing the current ranges of time that the user
		* has played.
		*
		* @return {TimeRange}
		*         A time range object that represents all the increments of time that have
		*         been played.
		*/
		played() {
			return this.techGet_("played") || createTimeRanges(0, 0);
		}
		/**
		* Sets or returns whether or not the user is "scrubbing". Scrubbing is
		* when the user has clicked the progress bar handle and is
		* dragging it along the progress bar.
		*
		* @param {boolean} [isScrubbing]
		*        whether the user is or is not scrubbing
		*
		* @return {boolean|undefined}
		*         - The value of scrubbing when getting
		*         - Nothing when setting
		*/
		scrubbing(isScrubbing) {
			if (typeof isScrubbing === "undefined") return this.scrubbing_;
			this.scrubbing_ = !!isScrubbing;
			this.techCall_("setScrubbing", this.scrubbing_);
			if (isScrubbing) this.addClass("vjs-scrubbing");
			else this.removeClass("vjs-scrubbing");
		}
		/**
		* Get or set the current time (in seconds)
		*
		* @param {number|string} [seconds]
		*        The time to seek to in seconds
		*
		* @return {number|undefined}
		*         - the current time in seconds when getting
		*         - Nothing when setting
		*/
		currentTime(seconds) {
			if (seconds === void 0) {
				this.cache_.currentTime = this.techGet_("currentTime") || 0;
				return this.cache_.currentTime;
			}
			if (seconds < 0) seconds = 0;
			if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
				this.cache_.initTime = seconds;
				this.off("canplay", this.boundApplyInitTime_);
				this.one("canplay", this.boundApplyInitTime_);
				return;
			}
			this.techCall_("setCurrentTime", seconds);
			this.cache_.initTime = 0;
			if (isFinite(seconds)) this.cache_.currentTime = Number(seconds);
		}
		/**
		* Apply the value of initTime stored in cache as currentTime.
		*
		* @private
		*/
		applyInitTime_() {
			this.currentTime(this.cache_.initTime);
		}
		/**
		* Normally gets the length in time of the video in seconds;
		* in all but the rarest use cases an argument will NOT be passed to the method
		*
		* > **NOTE**: The video must have started loading before the duration can be
		* known, and depending on preload behaviour may not be known until the video starts
		* playing.
		*
		* @fires Player#durationchange
		*
		* @param {number} [seconds]
		*        The duration of the video to set in seconds
		*
		* @return {number|undefined}
		*         - The duration of the video in seconds when getting
		*         - Nothing when setting
		*/
		duration(seconds) {
			if (seconds === void 0) return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
			seconds = parseFloat(seconds);
			if (seconds < 0) seconds = Infinity;
			if (seconds !== this.cache_.duration) {
				this.cache_.duration = seconds;
				if (seconds === Infinity) this.addClass("vjs-live");
				else this.removeClass("vjs-live");
				if (!isNaN(seconds))
 /**
				* @event Player#durationchange
				* @type {Event}
				*/
				this.trigger("durationchange");
			}
		}
		/**
		* Calculates how much time is left in the video. Not part
		* of the native video API.
		*
		* @return {number}
		*         The time remaining in seconds
		*/
		remainingTime() {
			return this.duration() - this.currentTime();
		}
		/**
		* A remaining time function that is intended to be used when
		* the time is to be displayed directly to the user.
		*
		* @return {number}
		*         The rounded time remaining in seconds
		*/
		remainingTimeDisplay() {
			return Math.floor(this.duration()) - Math.floor(this.currentTime());
		}
		/**
		* Get a TimeRange object with an array of the times of the video
		* that have been downloaded. If you just want the percent of the
		* video that's been downloaded, use bufferedPercent.
		*
		* @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
		*
		* @return {TimeRange}
		*         A mock {@link TimeRanges} object (following HTML spec)
		*/
		buffered() {
			let buffered = this.techGet_("buffered");
			if (!buffered || !buffered.length) buffered = createTimeRanges(0, 0);
			return buffered;
		}
		/**
		* Get the TimeRanges of the media that are currently available
		* for seeking to.
		*
		* @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
		*
		* @return {TimeRange}
		*         A mock {@link TimeRanges} object (following HTML spec)
		*/
		seekable() {
			let seekable = this.techGet_("seekable");
			if (!seekable || !seekable.length) seekable = createTimeRanges(0, 0);
			return seekable;
		}
		/**
		* Returns whether the player is in the "seeking" state.
		*
		* @return {boolean} True if the player is in the seeking state, false if not.
		*/
		seeking() {
			return this.techGet_("seeking");
		}
		/**
		* Returns whether the player is in the "ended" state.
		*
		* @return {boolean} True if the player is in the ended state, false if not.
		*/
		ended() {
			return this.techGet_("ended");
		}
		/**
		* Returns the current state of network activity for the element, from
		* the codes in the list below.
		* - NETWORK_EMPTY (numeric value 0)
		*   The element has not yet been initialised. All attributes are in
		*   their initial states.
		* - NETWORK_IDLE (numeric value 1)
		*   The element's resource selection algorithm is active and has
		*   selected a resource, but it is not actually using the network at
		*   this time.
		* - NETWORK_LOADING (numeric value 2)
		*   The user agent is actively trying to download data.
		* - NETWORK_NO_SOURCE (numeric value 3)
		*   The element's resource selection algorithm is active, but it has
		*   not yet found a resource to use.
		*
		* @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
		* @return {number} the current network activity state
		*/
		networkState() {
			return this.techGet_("networkState");
		}
		/**
		* Returns a value that expresses the current state of the element
		* with respect to rendering the current playback position, from the
		* codes in the list below.
		* - HAVE_NOTHING (numeric value 0)
		*   No information regarding the media resource is available.
		* - HAVE_METADATA (numeric value 1)
		*   Enough of the resource has been obtained that the duration of the
		*   resource is available.
		* - HAVE_CURRENT_DATA (numeric value 2)
		*   Data for the immediate current playback position is available.
		* - HAVE_FUTURE_DATA (numeric value 3)
		*   Data for the immediate current playback position is available, as
		*   well as enough data for the user agent to advance the current
		*   playback position in the direction of playback.
		* - HAVE_ENOUGH_DATA (numeric value 4)
		*   The user agent estimates that enough data is available for
		*   playback to proceed uninterrupted.
		*
		* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
		* @return {number} the current playback rendering state
		*/
		readyState() {
			return this.techGet_("readyState");
		}
		/**
		* Get the percent (as a decimal) of the video that's been downloaded.
		* This method is not a part of the native HTML video API.
		*
		* @return {number}
		*         A decimal between 0 and 1 representing the percent
		*         that is buffered 0 being 0% and 1 being 100%
		*/
		bufferedPercent() {
			return bufferedPercent(this.buffered(), this.duration());
		}
		/**
		* Get the ending time of the last buffered time range
		* This is used in the progress bar to encapsulate all time ranges.
		*
		* @return {number}
		*         The end of the last buffered time range
		*/
		bufferedEnd() {
			const buffered = this.buffered();
			const duration = this.duration();
			let end = buffered.end(buffered.length - 1);
			if (end > duration) end = duration;
			return end;
		}
		/**
		* Get or set the current volume of the media
		*
		* @param  {number} [percentAsDecimal]
		*         The new volume as a decimal percent:
		*         - 0 is muted/0%/off
		*         - 1.0 is 100%/full
		*         - 0.5 is half volume or 50%
		*
		* @return {number|undefined}
		*         The current volume as a percent when getting
		*/
		volume(percentAsDecimal) {
			let vol;
			if (percentAsDecimal !== void 0) {
				vol = Math.max(0, Math.min(1, percentAsDecimal));
				this.cache_.volume = vol;
				this.techCall_("setVolume", vol);
				if (vol > 0) this.lastVolume_(vol);
				return;
			}
			vol = parseFloat(this.techGet_("volume"));
			return isNaN(vol) ? 1 : vol;
		}
		/**
		* Get the current muted state, or turn mute on or off
		*
		* @param {boolean} [muted]
		*        - true to mute
		*        - false to unmute
		*
		* @return {boolean|undefined}
		*         - true if mute is on and getting
		*         - false if mute is off and getting
		*         - nothing if setting
		*/
		muted(muted) {
			if (muted !== void 0) {
				this.techCall_("setMuted", muted);
				return;
			}
			return this.techGet_("muted") || false;
		}
		/**
		* Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
		* indicates the state of muted on initial playback.
		*
		* ```js
		*   var myPlayer = videojs('some-player-id');
		*
		*   myPlayer.src("http://www.example.com/path/to/video.mp4");
		*
		*   // get, should be false
		*   console.log(myPlayer.defaultMuted());
		*   // set to true
		*   myPlayer.defaultMuted(true);
		*   // get should be true
		*   console.log(myPlayer.defaultMuted());
		* ```
		*
		* @param {boolean} [defaultMuted]
		*        - true to mute
		*        - false to unmute
		*
		* @return {boolean|undefined}
		*         - true if defaultMuted is on and getting
		*         - false if defaultMuted is off and getting
		*         - Nothing when setting
		*/
		defaultMuted(defaultMuted) {
			if (defaultMuted !== void 0) this.techCall_("setDefaultMuted", defaultMuted);
			return this.techGet_("defaultMuted") || false;
		}
		/**
		* Get the last volume, or set it
		*
		* @param  {number} [percentAsDecimal]
		*         The new last volume as a decimal percent:
		*         - 0 is muted/0%/off
		*         - 1.0 is 100%/full
		*         - 0.5 is half volume or 50%
		*
		* @return {number|undefined}
		*         - The current value of lastVolume as a percent when getting
		*         - Nothing when setting
		*
		* @private
		*/
		lastVolume_(percentAsDecimal) {
			if (percentAsDecimal !== void 0 && percentAsDecimal !== 0) {
				this.cache_.lastVolume = percentAsDecimal;
				return;
			}
			return this.cache_.lastVolume;
		}
		/**
		* Check if current tech can support native fullscreen
		* (e.g. with built in controls like iOS)
		*
		* @return {boolean}
		*         if native fullscreen is supported
		*/
		supportsFullScreen() {
			return this.techGet_("supportsFullScreen") || false;
		}
		/**
		* Check if the player is in fullscreen mode or tell the player that it
		* is or is not in fullscreen mode.
		*
		* > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
		* property and instead document.fullscreenElement is used. But isFullscreen is
		* still a valuable property for internal player workings.
		*
		* @param  {boolean} [isFS]
		*         Set the players current fullscreen state
		*
		* @return {boolean|undefined}
		*         - true if fullscreen is on and getting
		*         - false if fullscreen is off and getting
		*         - Nothing when setting
		*/
		isFullscreen(isFS) {
			if (isFS !== void 0) {
				const oldValue = this.isFullscreen_;
				this.isFullscreen_ = Boolean(isFS);
				if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed)
 /**
				* @event Player#fullscreenchange
				* @type {Event}
				*/
				this.trigger("fullscreenchange");
				this.toggleFullscreenClass_();
				return;
			}
			return this.isFullscreen_;
		}
		/**
		* Increase the size of the video to full screen
		* In some browsers, full screen is not supported natively, so it enters
		* "full window mode", where the video fills the browser window.
		* In browsers and devices that support native full screen, sometimes the
		* browser's default controls will be shown, and not the Video.js custom skin.
		* This includes most mobile devices (iOS, Android) and older versions of
		* Safari.
		*
		* @param  {Object} [fullscreenOptions]
		*         Override the player fullscreen options
		*
		* @fires Player#fullscreenchange
		*/
		requestFullscreen(fullscreenOptions) {
			if (this.isInPictureInPicture()) this.exitPictureInPicture();
			const self = this;
			return new Promise((resolve, reject) => {
				function offHandler() {
					self.off("fullscreenerror", errorHandler);
					self.off("fullscreenchange", changeHandler);
				}
				function changeHandler() {
					offHandler();
					resolve();
				}
				function errorHandler(e, err) {
					offHandler();
					reject(err);
				}
				self.one("fullscreenchange", changeHandler);
				self.one("fullscreenerror", errorHandler);
				const promise = self.requestFullscreenHelper_(fullscreenOptions);
				if (promise) {
					promise.then(offHandler, offHandler);
					promise.then(resolve, reject);
				}
			});
		}
		requestFullscreenHelper_(fullscreenOptions) {
			let fsOptions;
			if (!this.fsApi_.prefixed) {
				fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
				if (fullscreenOptions !== void 0) fsOptions = fullscreenOptions;
			}
			if (this.fsApi_.requestFullscreen) {
				const promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
				if (promise) promise.then(() => this.isFullscreen(true), () => this.isFullscreen(false));
				return promise;
			} else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) this.techCall_("enterFullScreen");
			else this.enterFullWindow();
		}
		/**
		* Return the video to its normal size after having been in full screen mode
		*
		* @fires Player#fullscreenchange
		*/
		exitFullscreen() {
			const self = this;
			return new Promise((resolve, reject) => {
				function offHandler() {
					self.off("fullscreenerror", errorHandler);
					self.off("fullscreenchange", changeHandler);
				}
				function changeHandler() {
					offHandler();
					resolve();
				}
				function errorHandler(e, err) {
					offHandler();
					reject(err);
				}
				self.one("fullscreenchange", changeHandler);
				self.one("fullscreenerror", errorHandler);
				const promise = self.exitFullscreenHelper_();
				if (promise) {
					promise.then(offHandler, offHandler);
					promise.then(resolve, reject);
				}
			});
		}
		exitFullscreenHelper_() {
			if (this.fsApi_.requestFullscreen) {
				const promise = document__default["default"][this.fsApi_.exitFullscreen]();
				if (promise) silencePromise(promise.then(() => this.isFullscreen(false)));
				return promise;
			} else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) this.techCall_("exitFullScreen");
			else this.exitFullWindow();
		}
		/**
		* When fullscreen isn't supported we can stretch the
		* video container to as wide as the browser will let us.
		*
		* @fires Player#enterFullWindow
		*/
		enterFullWindow() {
			this.isFullscreen(true);
			this.isFullWindow = true;
			this.docOrigOverflow = document__default["default"].documentElement.style.overflow;
			on(document__default["default"], "keydown", this.boundFullWindowOnEscKey_);
			document__default["default"].documentElement.style.overflow = "hidden";
			addClass(document__default["default"].body, "vjs-full-window");
			/**
			* @event Player#enterFullWindow
			* @type {Event}
			*/
			this.trigger("enterFullWindow");
		}
		/**
		* Check for call to either exit full window or
		* full screen on ESC key
		*
		* @param {string} event
		*        Event to check for key press
		*/
		fullWindowOnEscKey(event) {
			if (event.key === "Escape") {
				if (this.isFullscreen() === true) if (!this.isFullWindow) this.exitFullscreen();
				else this.exitFullWindow();
			}
		}
		/**
		* Exit full window
		*
		* @fires Player#exitFullWindow
		*/
		exitFullWindow() {
			this.isFullscreen(false);
			this.isFullWindow = false;
			off(document__default["default"], "keydown", this.boundFullWindowOnEscKey_);
			document__default["default"].documentElement.style.overflow = this.docOrigOverflow;
			removeClass(document__default["default"].body, "vjs-full-window");
			/**
			* @event Player#exitFullWindow
			* @type {Event}
			*/
			this.trigger("exitFullWindow");
		}
		/**
		* Get or set disable Picture-in-Picture mode.
		*
		* @param {boolean} [value]
		*                  - true will disable Picture-in-Picture mode
		*                  - false will enable Picture-in-Picture mode
		*/
		disablePictureInPicture(value) {
			if (value === void 0) return this.techGet_("disablePictureInPicture");
			this.techCall_("setDisablePictureInPicture", value);
			this.options_.disablePictureInPicture = value;
			this.trigger("disablepictureinpicturechanged");
		}
		/**
		* Check if the player is in Picture-in-Picture mode or tell the player that it
		* is or is not in Picture-in-Picture mode.
		*
		* @param  {boolean} [isPiP]
		*         Set the players current Picture-in-Picture state
		*
		* @return {boolean|undefined}
		*         - true if Picture-in-Picture is on and getting
		*         - false if Picture-in-Picture is off and getting
		*         - nothing if setting
		*/
		isInPictureInPicture(isPiP) {
			if (isPiP !== void 0) {
				this.isInPictureInPicture_ = !!isPiP;
				this.togglePictureInPictureClass_();
				return;
			}
			return !!this.isInPictureInPicture_;
		}
		/**
		* Create a floating video window always on top of other windows so that users may
		* continue consuming media while they interact with other content sites, or
		* applications on their device.
		*
		* This can use document picture-in-picture or element picture in picture
		*
		* Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
		* Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
		*
		*
		* @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
		* @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
		*
		* @fires Player#enterpictureinpicture
		*
		* @return {Promise}
		*         A promise with a Picture-in-Picture window.
		*/
		requestPictureInPicture() {
			if (this.options_.enableDocumentPictureInPicture && window__default["default"].documentPictureInPicture) {
				const pipContainer = document__default["default"].createElement(this.el().tagName);
				pipContainer.classList = this.el().classList;
				pipContainer.classList.add("vjs-pip-container");
				if (this.posterImage) pipContainer.appendChild(this.posterImage.el().cloneNode(true));
				if (this.titleBar) pipContainer.appendChild(this.titleBar.el().cloneNode(true));
				pipContainer.appendChild(createEl("p", { className: "vjs-pip-text" }, {}, this.localize("Playing in picture-in-picture")));
				return window__default["default"].documentPictureInPicture.requestWindow({
					width: this.videoWidth(),
					height: this.videoHeight()
				}).then((pipWindow) => {
					copyStyleSheetsToWindow(pipWindow);
					this.el_.parentNode.insertBefore(pipContainer, this.el_);
					pipWindow.document.body.appendChild(this.el_);
					pipWindow.document.body.classList.add("vjs-pip-window");
					this.player_.isInPictureInPicture(true);
					this.player_.trigger({
						type: "enterpictureinpicture",
						pipWindow
					});
					pipWindow.addEventListener("pagehide", (event) => {
						const pipVideo = event.target.querySelector(".video-js");
						pipContainer.parentNode.replaceChild(pipVideo, pipContainer);
						this.player_.isInPictureInPicture(false);
						this.player_.trigger("leavepictureinpicture");
					});
					return pipWindow;
				});
			}
			if ("pictureInPictureEnabled" in document__default["default"] && this.disablePictureInPicture() === false)
 /**
			* This event fires when the player enters picture in picture mode
			*
			* @event Player#enterpictureinpicture
			* @type {Event}
			*/
			return this.techGet_("requestPictureInPicture");
			return Promise.reject("No PiP mode is available");
		}
		/**
		* Exit Picture-in-Picture mode.
		*
		* @see [Spec]{@link https://wicg.github.io/picture-in-picture}
		*
		* @fires Player#leavepictureinpicture
		*
		* @return {Promise}
		*         A promise.
		*/
		exitPictureInPicture() {
			if (window__default["default"].documentPictureInPicture && window__default["default"].documentPictureInPicture.window) {
				window__default["default"].documentPictureInPicture.window.close();
				return Promise.resolve();
			}
			if ("pictureInPictureEnabled" in document__default["default"])
 /**
			* This event fires when the player leaves picture in picture mode
			*
			* @event Player#leavepictureinpicture
			* @type {Event}
			*/
			return document__default["default"].exitPictureInPicture();
		}
		/**
		* Called when this Player has focus and a key gets pressed down, or when
		* any Component of this player receives a key press that it doesn't handle.
		* This allows player-wide hotkeys (either as defined below, or optionally
		* by an external function).
		*
		* @param {KeyboardEvent} event
		*        The `keydown` event that caused this function to be called.
		*
		* @listens keydown
		*/
		handleKeyDown(event) {
			const { userActions } = this.options_;
			if (!userActions || !userActions.hotkeys) return;
			const excludeElement = (el) => {
				const tagName = el.tagName.toLowerCase();
				if (el.isContentEditable) return true;
				const allowedInputTypes = [
					"button",
					"checkbox",
					"hidden",
					"radio",
					"reset",
					"submit"
				];
				if (tagName === "input") return allowedInputTypes.indexOf(el.type) === -1;
				return ["textarea"].indexOf(tagName) !== -1;
			};
			if (excludeElement(this.el_.ownerDocument.activeElement)) return;
			if (typeof userActions.hotkeys === "function") userActions.hotkeys.call(this, event);
			else this.handleHotkeys(event);
		}
		/**
		* Called when this Player receives a hotkey keydown event.
		* Supported player-wide hotkeys are:
		*
		*   f          - toggle fullscreen
		*   m          - toggle mute
		*   k or Space - toggle play/pause
		*
		* @param {Event} event
		*        The `keydown` event that caused this function to be called.
		*/
		handleHotkeys(event) {
			const { fullscreenKey = (keydownEvent) => event.key.toLowerCase() === "f", muteKey = (keydownEvent) => event.key.toLowerCase() === "m", playPauseKey = (keydownEvent) => event.key.toLowerCase() === "k" || event.key.toLowerCase() === " " } = this.options_.userActions ? this.options_.userActions.hotkeys : {};
			if (fullscreenKey.call(this, event)) {
				event.preventDefault();
				event.stopPropagation();
				const FSToggle = Component.getComponent("FullscreenToggle");
				if (document__default["default"][this.fsApi_.fullscreenEnabled] !== false) FSToggle.prototype.handleClick.call(this, event);
			} else if (muteKey.call(this, event)) {
				event.preventDefault();
				event.stopPropagation();
				Component.getComponent("MuteToggle").prototype.handleClick.call(this, event);
			} else if (playPauseKey.call(this, event)) {
				event.preventDefault();
				event.stopPropagation();
				Component.getComponent("PlayToggle").prototype.handleClick.call(this, event);
			}
		}
		/**
		* Check whether the player can play a given mimetype
		*
		* @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
		*
		* @param {string} type
		*        The mimetype to check
		*
		* @return {string}
		*         'probably', 'maybe', or '' (empty string)
		*/
		canPlayType(type) {
			let can;
			for (let i = 0, j = this.options_.techOrder; i < j.length; i++) {
				const techName = j[i];
				let tech = Tech.getTech(techName);
				if (!tech) tech = Component.getComponent(techName);
				if (!tech) {
					log.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
					continue;
				}
				if (tech.isSupported()) {
					can = tech.canPlayType(type);
					if (can) return can;
				}
			}
			return "";
		}
		/**
		* Select source based on tech-order or source-order
		* Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
		* defaults to tech-order selection
		*
		* @param {Array} sources
		*        The sources for a media asset
		*
		* @return {Object|boolean}
		*         Object of source and tech order or false
		*/
		selectSource(sources) {
			const techs = this.options_.techOrder.map((techName) => {
				return [techName, Tech.getTech(techName)];
			}).filter(([techName, tech]) => {
				if (tech) return tech.isSupported();
				log.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
				return false;
			});
			const findFirstPassingTechSourcePair = function(outerArray, innerArray, tester) {
				let found;
				outerArray.some((outerChoice) => {
					return innerArray.some((innerChoice) => {
						found = tester(outerChoice, innerChoice);
						if (found) return true;
					});
				});
				return found;
			};
			let foundSourceAndTech;
			const flip = (fn) => (a, b) => fn(b, a);
			const finder = ([techName, tech], source) => {
				if (tech.canPlaySource(source, this.options_[techName.toLowerCase()])) return {
					source,
					tech: techName
				};
			};
			if (this.options_.sourceOrder) foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
			else foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
			return foundSourceAndTech || false;
		}
		/**
		* Executes source setting and getting logic
		*
		* @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
		*        A SourceObject, an array of SourceObjects, or a string referencing
		*        a URL to a media source. It is _highly recommended_ that an object
		*        or array of objects is used here, so that source selection
		*        algorithms can take the `type` into account.
		*
		*        If not provided, this method acts as a getter.
		* @param {boolean} [isRetry]
		*        Indicates whether this is being called internally as a result of a retry
		*
		* @return {string|undefined}
		*         If the `source` argument is missing, returns the current source
		*         URL. Otherwise, returns nothing/undefined.
		*/
		handleSrc_(source, isRetry) {
			if (typeof source === "undefined") return this.cache_.src || "";
			if (this.resetRetryOnError_) this.resetRetryOnError_();
			const sources = filterSource(source);
			if (!sources.length) {
				this.setTimeout(function() {
					this.error({
						code: 4,
						message: this.options_.notSupportedMessage
					});
				}, 0);
				return;
			}
			this.changingSrc_ = true;
			if (!isRetry) this.cache_.sources = sources;
			this.updateSourceCaches_(sources[0]);
			setSource(this, sources[0], (middlewareSource, mws) => {
				this.middleware_ = mws;
				if (!isRetry) this.cache_.sources = sources;
				this.updateSourceCaches_(middlewareSource);
				if (this.src_(middlewareSource)) {
					if (sources.length > 1) return this.handleSrc_(sources.slice(1));
					this.changingSrc_ = false;
					this.setTimeout(function() {
						this.error({
							code: 4,
							message: this.options_.notSupportedMessage
						});
					}, 0);
					this.triggerReady();
					return;
				}
				setTech(mws, this.tech_);
			});
			if (sources.length > 1) {
				const retry = () => {
					this.error(null);
					this.handleSrc_(sources.slice(1), true);
				};
				const stopListeningForErrors = () => {
					this.off("error", retry);
				};
				this.one("error", retry);
				this.one("playing", stopListeningForErrors);
				this.resetRetryOnError_ = () => {
					this.off("error", retry);
					this.off("playing", stopListeningForErrors);
				};
			}
		}
		/**
		* Get or set the video source.
		*
		* @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
		*        A SourceObject, an array of SourceObjects, or a string referencing
		*        a URL to a media source. It is _highly recommended_ that an object
		*        or array of objects is used here, so that source selection
		*        algorithms can take the `type` into account.
		*
		*        If not provided, this method acts as a getter.
		*
		* @return {string|undefined}
		*         If the `source` argument is missing, returns the current source
		*         URL. Otherwise, returns nothing/undefined.
		*/
		src(source) {
			return this.handleSrc_(source, false);
		}
		/**
		* Set the source object on the tech, returns a boolean that indicates whether
		* there is a tech that can play the source or not
		*
		* @param {Tech~SourceObject} source
		*        The source object to set on the Tech
		*
		* @return {boolean}
		*         - True if there is no Tech to playback this source
		*         - False otherwise
		*
		* @private
		*/
		src_(source) {
			const sourceTech = this.selectSource([source]);
			if (!sourceTech) return true;
			if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
				this.changingSrc_ = true;
				this.loadTech_(sourceTech.tech, sourceTech.source);
				this.tech_.ready(() => {
					this.changingSrc_ = false;
				});
				return false;
			}
			this.ready(function() {
				if (this.tech_.constructor.prototype.hasOwnProperty("setSource")) this.techCall_("setSource", source);
				else this.techCall_("src", source.src);
				this.changingSrc_ = false;
			}, true);
			return false;
		}
		/**
		* Add a <source> element to the <video> element.
		*
		* @param {string} srcUrl
		*        The URL of the video source.
		*
		* @param {string} [mimeType]
		*        The MIME type of the video source. Optional but recommended.
		*
		* @return {boolean}
		*         Returns true if the source element was successfully added, false otherwise.
		*/
		addSourceElement(srcUrl, mimeType) {
			if (!this.tech_) return false;
			return this.tech_.addSourceElement(srcUrl, mimeType);
		}
		/**
		* Remove a <source> element from the <video> element by its URL.
		*
		* @param {string} srcUrl
		*        The URL of the source to remove.
		*
		* @return {boolean}
		*         Returns true if the source element was successfully removed, false otherwise.
		*/
		removeSourceElement(srcUrl) {
			if (!this.tech_) return false;
			return this.tech_.removeSourceElement(srcUrl);
		}
		/**
		* Begin loading the src data.
		*/
		load() {
			if (this.tech_ && this.tech_.vhs) {
				this.src(this.currentSource());
				return;
			}
			this.techCall_("load");
		}
		/**
		* Reset the player. Loads the first tech in the techOrder,
		* removes all the text tracks in the existing `tech`,
		* and calls `reset` on the `tech`.
		*/
		reset() {
			if (this.paused()) this.doReset_();
			else silencePromise(this.play().then(() => this.doReset_()));
		}
		doReset_() {
			if (this.tech_) this.tech_.clearTracks("text");
			this.removeClass("vjs-playing");
			this.addClass("vjs-paused");
			this.resetCache_();
			this.poster("");
			this.loadTech_(this.options_.techOrder[0], null);
			this.techCall_("reset");
			this.resetControlBarUI_();
			this.error(null);
			if (this.titleBar) this.titleBar.update({
				title: void 0,
				description: void 0
			});
			if (isEvented(this)) this.trigger("playerreset");
		}
		/**
		* Reset Control Bar's UI by calling sub-methods that reset
		* all of Control Bar's components
		*/
		resetControlBarUI_() {
			this.resetProgressBar_();
			this.resetPlaybackRate_();
			this.resetVolumeBar_();
		}
		/**
		* Reset tech's progress so progress bar is reset in the UI
		*/
		resetProgressBar_() {
			this.currentTime(0);
			const { currentTimeDisplay, durationDisplay, progressControl, remainingTimeDisplay } = this.controlBar || {};
			const { seekBar } = progressControl || {};
			if (currentTimeDisplay) currentTimeDisplay.updateContent();
			if (durationDisplay) durationDisplay.updateContent();
			if (remainingTimeDisplay) remainingTimeDisplay.updateContent();
			if (seekBar) {
				seekBar.update();
				if (seekBar.loadProgressBar) seekBar.loadProgressBar.update();
			}
		}
		/**
		* Reset Playback ratio
		*/
		resetPlaybackRate_() {
			this.playbackRate(this.defaultPlaybackRate());
			this.handleTechRateChange_();
		}
		/**
		* Reset Volume bar
		*/
		resetVolumeBar_() {
			this.volume(1);
			this.trigger("volumechange");
		}
		/**
		* Returns all of the current source objects.
		*
		* @return {Tech~SourceObject[]}
		*         The current source objects
		*/
		currentSources() {
			const source = this.currentSource();
			const sources = [];
			if (Object.keys(source).length !== 0) sources.push(source);
			return this.cache_.sources || sources;
		}
		/**
		* Returns the current source object.
		*
		* @return {Tech~SourceObject}
		*         The current source object
		*/
		currentSource() {
			return this.cache_.source || {};
		}
		/**
		* Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
		* Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
		*
		* @return {string}
		*         The current source
		*/
		currentSrc() {
			return this.currentSource() && this.currentSource().src || "";
		}
		/**
		* Get the current source type e.g. video/mp4
		* This can allow you rebuild the current source object so that you could load the same
		* source and tech later
		*
		* @return {string}
		*         The source MIME type
		*/
		currentType() {
			return this.currentSource() && this.currentSource().type || "";
		}
		/**
		* Get or set the preload attribute
		*
		* @param {'none'|'auto'|'metadata'} [value]
		*        Preload mode to pass to tech
		*
		* @return {string|undefined}
		*         - The preload attribute value when getting
		*         - Nothing when setting
		*/
		preload(value) {
			if (value !== void 0) {
				this.techCall_("setPreload", value);
				this.options_.preload = value;
				return;
			}
			return this.techGet_("preload");
		}
		/**
		* Get or set the autoplay option. When this is a boolean it will
		* modify the attribute on the tech. When this is a string the attribute on
		* the tech will be removed and `Player` will handle autoplay on loadstarts.
		*
		* @param {boolean|'play'|'muted'|'any'} [value]
		*        - true: autoplay using the browser behavior
		*        - false: do not autoplay
		*        - 'play': call play() on every loadstart
		*        - 'muted': call muted() then play() on every loadstart
		*        - 'any': call play() on every loadstart. if that fails call muted() then play().
		*        - *: values other than those listed here will be set `autoplay` to true
		*
		* @return {boolean|string|undefined}
		*         - The current value of autoplay when getting
		*         - Nothing when setting
		*/
		autoplay(value) {
			if (value === void 0) return this.options_.autoplay || false;
			let techAutoplay;
			if (typeof value === "string" && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
				this.options_.autoplay = value;
				this.manualAutoplay_(typeof value === "string" ? value : "play");
				techAutoplay = false;
			} else if (!value) this.options_.autoplay = false;
			else this.options_.autoplay = true;
			techAutoplay = typeof techAutoplay === "undefined" ? this.options_.autoplay : techAutoplay;
			if (this.tech_) this.techCall_("setAutoplay", techAutoplay);
		}
		/**
		* Set or unset the playsinline attribute.
		* Playsinline tells the browser that non-fullscreen playback is preferred.
		*
		* @param {boolean} [value]
		*        - true means that we should try to play inline by default
		*        - false means that we should use the browser's default playback mode,
		*          which in most cases is inline. iOS Safari is a notable exception
		*          and plays fullscreen by default.
		*
		* @return {string|undefined}
		*         - the current value of playsinline
		*         - Nothing when setting
		*
		* @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
		*/
		playsinline(value) {
			if (value !== void 0) {
				this.techCall_("setPlaysinline", value);
				this.options_.playsinline = value;
			}
			return this.techGet_("playsinline");
		}
		/**
		* Get or set the loop attribute on the video element.
		*
		* @param {boolean} [value]
		*        - true means that we should loop the video
		*        - false means that we should not loop the video
		*
		* @return {boolean|undefined}
		*         - The current value of loop when getting
		*         - Nothing when setting
		*/
		loop(value) {
			if (value !== void 0) {
				this.techCall_("setLoop", value);
				this.options_.loop = value;
				return;
			}
			return this.techGet_("loop");
		}
		/**
		* Get or set the poster image source url
		*
		* @fires Player#posterchange
		*
		* @param {string} [src]
		*        Poster image source URL
		*
		* @return {string|undefined}
		*         - The current value of poster when getting
		*         - Nothing when setting
		*/
		poster(src) {
			if (src === void 0) return this.poster_;
			if (!src) src = "";
			if (src === this.poster_) return;
			this.poster_ = src;
			this.techCall_("setPoster", src);
			this.isPosterFromTech_ = false;
			/**
			* This event fires when the poster image is changed on the player.
			*
			* @event Player#posterchange
			* @type {Event}
			*/
			this.trigger("posterchange");
		}
		/**
		* Some techs (e.g. YouTube) can provide a poster source in an
		* asynchronous way. We want the poster component to use this
		* poster source so that it covers up the tech's controls.
		* (YouTube's play button). However we only want to use this
		* source if the player user hasn't set a poster through
		* the normal APIs.
		*
		* @fires Player#posterchange
		* @listens Tech#posterchange
		* @private
		*/
		handleTechPosterChange_() {
			if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
				const newPoster = this.tech_.poster() || "";
				if (newPoster !== this.poster_) {
					this.poster_ = newPoster;
					this.isPosterFromTech_ = true;
					this.trigger("posterchange");
				}
			}
		}
		/**
		* Get or set whether or not the controls are showing.
		*
		* @fires Player#controlsenabled
		*
		* @param {boolean} [bool]
		*        - true to turn controls on
		*        - false to turn controls off
		*
		* @return {boolean|undefined}
		*         - The current value of controls when getting
		*         - Nothing when setting
		*/
		controls(bool) {
			if (bool === void 0) return !!this.controls_;
			bool = !!bool;
			if (this.controls_ === bool) return;
			this.controls_ = bool;
			if (this.usingNativeControls()) this.techCall_("setControls", bool);
			if (this.controls_) {
				this.removeClass("vjs-controls-disabled");
				this.addClass("vjs-controls-enabled");
				/**
				* @event Player#controlsenabled
				* @type {Event}
				*/
				this.trigger("controlsenabled");
				if (!this.usingNativeControls()) this.addTechControlsListeners_();
			} else {
				this.removeClass("vjs-controls-enabled");
				this.addClass("vjs-controls-disabled");
				/**
				* @event Player#controlsdisabled
				* @type {Event}
				*/
				this.trigger("controlsdisabled");
				if (!this.usingNativeControls()) this.removeTechControlsListeners_();
			}
		}
		/**
		* Toggle native controls on/off. Native controls are the controls built into
		* devices (e.g. default iPhone controls) or other techs
		* (e.g. Vimeo Controls)
		* **This should only be set by the current tech, because only the tech knows
		* if it can support native controls**
		*
		* @fires Player#usingnativecontrols
		* @fires Player#usingcustomcontrols
		*
		* @param {boolean} [bool]
		*        - true to turn native controls on
		*        - false to turn native controls off
		*
		* @return {boolean|undefined}
		*         - The current value of native controls when getting
		*         - Nothing when setting
		*/
		usingNativeControls(bool) {
			if (bool === void 0) return !!this.usingNativeControls_;
			bool = !!bool;
			if (this.usingNativeControls_ === bool) return;
			this.usingNativeControls_ = bool;
			if (this.usingNativeControls_) {
				this.addClass("vjs-using-native-controls");
				/**
				* player is using the native device controls
				*
				* @event Player#usingnativecontrols
				* @type {Event}
				*/
				this.trigger("usingnativecontrols");
			} else {
				this.removeClass("vjs-using-native-controls");
				/**
				* player is using the custom HTML controls
				*
				* @event Player#usingcustomcontrols
				* @type {Event}
				*/
				this.trigger("usingcustomcontrols");
			}
		}
		/**
		* Set or get the current MediaError
		*
		* @fires Player#error
		*
		* @param  {MediaError|string|number} [err]
		*         A MediaError or a string/number to be turned
		*         into a MediaError
		*
		* @return {MediaError|null|undefined}
		*         - The current MediaError when getting (or null)
		*         - Nothing when setting
		*/
		error(err) {
			if (err === void 0) return this.error_ || null;
			hooks("beforeerror").forEach((hookFunction) => {
				const newErr = hookFunction(this, err);
				if (!(isObject(newErr) && !Array.isArray(newErr) || typeof newErr === "string" || typeof newErr === "number" || newErr === null)) {
					this.log.error("please return a value that MediaError expects in beforeerror hooks");
					return;
				}
				err = newErr;
			});
			if (this.options_.suppressNotSupportedError && err && err.code === 4) {
				const triggerSuppressedError = function() {
					this.error(err);
				};
				this.options_.suppressNotSupportedError = false;
				this.any(["click", "touchstart"], triggerSuppressedError);
				this.one("loadstart", function() {
					this.off(["click", "touchstart"], triggerSuppressedError);
				});
				return;
			}
			if (err === null) {
				this.error_ = null;
				this.removeClass("vjs-error");
				if (this.errorDisplay) this.errorDisplay.close();
				return;
			}
			this.error_ = new MediaError(err);
			this.addClass("vjs-error");
			log.error(`(CODE:${this.error_.code} ${MediaError.errorTypes[this.error_.code]})`, this.error_.message, this.error_);
			/**
			* @event Player#error
			* @type {Event}
			*/
			this.trigger("error");
			hooks("error").forEach((hookFunction) => hookFunction(this, this.error_));
		}
		/**
		* Report user activity
		*
		* @param {Object} event
		*        Event object
		*/
		reportUserActivity(event) {
			this.userActivity_ = true;
		}
		/**
		* Get/set if user is active
		*
		* @fires Player#useractive
		* @fires Player#userinactive
		*
		* @param {boolean} [bool]
		*        - true if the user is active
		*        - false if the user is inactive
		*
		* @return {boolean|undefined}
		*         - The current value of userActive when getting
		*         - Nothing when setting
		*/
		userActive(bool) {
			if (bool === void 0) return this.userActive_;
			bool = !!bool;
			if (bool === this.userActive_) return;
			this.userActive_ = bool;
			if (this.userActive_) {
				this.userActivity_ = true;
				this.removeClass("vjs-user-inactive");
				this.addClass("vjs-user-active");
				/**
				* @event Player#useractive
				* @type {Event}
				*/
				this.trigger("useractive");
				return;
			}
			if (this.tech_) this.tech_.one("mousemove", function(e) {
				e.stopPropagation();
				e.preventDefault();
			});
			this.userActivity_ = false;
			this.removeClass("vjs-user-active");
			this.addClass("vjs-user-inactive");
			/**
			* @event Player#userinactive
			* @type {Event}
			*/
			this.trigger("userinactive");
		}
		/**
		* Listen for user activity based on timeout value
		*
		* @private
		*/
		listenForUserActivity_() {
			let mouseInProgress;
			let lastMoveX;
			let lastMoveY;
			const handleActivity = bind_(this, this.reportUserActivity);
			const handleMouseMove = function(e) {
				if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
					lastMoveX = e.screenX;
					lastMoveY = e.screenY;
					handleActivity();
				}
			};
			const handleMouseDown = function() {
				handleActivity();
				this.clearInterval(mouseInProgress);
				mouseInProgress = this.setInterval(handleActivity, 250);
			};
			const handleMouseUpAndMouseLeave = function(event) {
				handleActivity();
				this.clearInterval(mouseInProgress);
			};
			this.on("mousedown", handleMouseDown);
			this.on("mousemove", handleMouseMove);
			this.on("mouseup", handleMouseUpAndMouseLeave);
			this.on("mouseleave", handleMouseUpAndMouseLeave);
			const controlBar = this.getChild("controlBar");
			if (controlBar && !IS_IOS && !IS_ANDROID) {
				controlBar.on("mouseenter", function(event) {
					if (this.player().options_.inactivityTimeout !== 0) this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
					this.player().options_.inactivityTimeout = 0;
				});
				controlBar.on("mouseleave", function(event) {
					this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
				});
			}
			this.on("keydown", handleActivity);
			this.on("keyup", handleActivity);
			let inactivityTimeout;
			/** @this Player */
			const activityCheck = function() {
				if (!this.userActivity_) return;
				this.userActivity_ = false;
				this.userActive(true);
				this.clearTimeout(inactivityTimeout);
				const timeout = this.options_.inactivityTimeout;
				if (timeout <= 0) return;
				inactivityTimeout = this.setTimeout(function() {
					if (!this.userActivity_) this.userActive(false);
				}, timeout);
			};
			this.setInterval(activityCheck, 250);
		}
		/**
		* Gets or sets the current playback rate. A playback rate of
		* 1.0 represents normal speed and 0.5 would indicate half-speed
		* playback, for instance.
		*
		* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
		*
		* @param {number} [rate]
		*       New playback rate to set.
		*
		* @return {number|undefined}
		*         - The current playback rate when getting or 1.0
		*         - Nothing when setting
		*/
		playbackRate(rate) {
			if (rate !== void 0) {
				this.techCall_("setPlaybackRate", rate);
				return;
			}
			if (this.tech_ && this.tech_.featuresPlaybackRate) return this.cache_.lastPlaybackRate || this.techGet_("playbackRate");
			return 1;
		}
		/**
		* Gets or sets the current default playback rate. A default playback rate of
		* 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
		* defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
		* not the current playbackRate.
		*
		* @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
		*
		* @param {number} [rate]
		*       New default playback rate to set.
		*
		* @return {number|undefined}
		*         - The default playback rate when getting or 1.0
		*         - Nothing when setting
		*/
		defaultPlaybackRate(rate) {
			if (rate !== void 0) return this.techCall_("setDefaultPlaybackRate", rate);
			if (this.tech_ && this.tech_.featuresPlaybackRate) return this.techGet_("defaultPlaybackRate");
			return 1;
		}
		/**
		* Gets or sets the audio flag
		*
		* @param {boolean} [bool]
		*        - true signals that this is an audio player
		*        - false signals that this is not an audio player
		*
		* @return {boolean|undefined}
		*         - The current value of isAudio when getting
		*         - Nothing when setting
		*/
		isAudio(bool) {
			if (bool !== void 0) {
				this.isAudio_ = !!bool;
				return;
			}
			return !!this.isAudio_;
		}
		updatePlayerHeightOnAudioOnlyMode_() {
			const controlBar = this.getChild("ControlBar");
			if (!controlBar || this.audioOnlyCache_.controlBarHeight === controlBar.currentHeight()) return;
			this.audioOnlyCache_.controlBarHeight = controlBar.currentHeight();
			this.height(this.audioOnlyCache_.controlBarHeight);
		}
		enableAudioOnlyUI_() {
			this.addClass("vjs-audio-only-mode");
			const playerChildren = this.children();
			const controlBar = this.getChild("ControlBar");
			const controlBarHeight = controlBar && controlBar.currentHeight();
			playerChildren.forEach((child) => {
				if (child === controlBar) return;
				if (child.el_ && !child.hasClass("vjs-hidden")) {
					child.hide();
					this.audioOnlyCache_.hiddenChildren.push(child);
				}
			});
			this.audioOnlyCache_.playerHeight = this.currentHeight();
			this.audioOnlyCache_.controlBarHeight = controlBarHeight;
			this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_);
			this.height(controlBarHeight);
			this.trigger("audioonlymodechange");
		}
		disableAudioOnlyUI_() {
			this.removeClass("vjs-audio-only-mode");
			this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_);
			this.audioOnlyCache_.hiddenChildren.forEach((child) => child.show());
			this.height(this.audioOnlyCache_.playerHeight);
			this.trigger("audioonlymodechange");
		}
		/**
		* Get the current audioOnlyMode state or set audioOnlyMode to true or false.
		*
		* Setting this to `true` will hide all player components except the control bar,
		* as well as control bar components needed only for video.
		*
		* @param {boolean} [value]
		*         The value to set audioOnlyMode to.
		*
		* @return {Promise|boolean}
		*        A Promise is returned when setting the state, and a boolean when getting
		*        the present state
		*/
		audioOnlyMode(value) {
			if (typeof value !== "boolean" || value === this.audioOnlyMode_) return this.audioOnlyMode_;
			this.audioOnlyMode_ = value;
			if (value) {
				const exitPromises = [];
				if (this.isInPictureInPicture()) exitPromises.push(this.exitPictureInPicture());
				if (this.isFullscreen()) exitPromises.push(this.exitFullscreen());
				if (this.audioPosterMode()) exitPromises.push(this.audioPosterMode(false));
				return Promise.all(exitPromises).then(() => this.enableAudioOnlyUI_());
			}
			return Promise.resolve().then(() => this.disableAudioOnlyUI_());
		}
		enablePosterModeUI_() {
			(this.tech_ && this.tech_).hide();
			this.addClass("vjs-audio-poster-mode");
			this.trigger("audiopostermodechange");
		}
		disablePosterModeUI_() {
			(this.tech_ && this.tech_).show();
			this.removeClass("vjs-audio-poster-mode");
			this.trigger("audiopostermodechange");
		}
		/**
		* Get the current audioPosterMode state or set audioPosterMode to true or false
		*
		* @param {boolean} [value]
		*         The value to set audioPosterMode to.
		*
		* @return {Promise|boolean}
		*         A Promise is returned when setting the state, and a boolean when getting
		*        the present state
		*/
		audioPosterMode(value) {
			if (typeof value !== "boolean" || value === this.audioPosterMode_) return this.audioPosterMode_;
			this.audioPosterMode_ = value;
			if (value) {
				if (this.audioOnlyMode()) return this.audioOnlyMode(false).then(() => {
					this.enablePosterModeUI_();
				});
				return Promise.resolve().then(() => {
					this.enablePosterModeUI_();
				});
			}
			return Promise.resolve().then(() => {
				this.disablePosterModeUI_();
			});
		}
		/**
		* A helper method for adding a {@link TextTrack} to our
		* {@link TextTrackList}.
		*
		* In addition to the W3C settings we allow adding additional info through options.
		*
		* @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
		*
		* @param {string} [kind]
		*        the kind of TextTrack you are adding
		*
		* @param {string} [label]
		*        the label to give the TextTrack label
		*
		* @param {string} [language]
		*        the language to set on the TextTrack
		*
		* @return {TextTrack|undefined}
		*         the TextTrack that was added or undefined
		*         if there is no tech
		*/
		addTextTrack(kind, label, language) {
			if (this.tech_) return this.tech_.addTextTrack(kind, label, language);
		}
		/**
		* Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
		*
		* @param {Object} options
		*        Options to pass to {@link HTMLTrackElement} during creation. See
		*        {@link HTMLTrackElement} for object properties that you should use.
		*
		* @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
		*                                        from the TextTrackList and HtmlTrackElementList
		*                                        after a source change
		*
		* @return {HtmlTrackElement}
		*         the HTMLTrackElement that was created and added
		*         to the HtmlTrackElementList and the remote
		*         TextTrackList
		*
		*/
		addRemoteTextTrack(options, manualCleanup) {
			if (this.tech_) return this.tech_.addRemoteTextTrack(options, manualCleanup);
		}
		/**
		* Remove a remote {@link TextTrack} from the respective
		* {@link TextTrackList} and {@link HtmlTrackElementList}.
		*
		* @param {Object} track
		*        Remote {@link TextTrack} to remove
		*
		* @return {undefined}
		*         does not return anything
		*/
		removeRemoteTextTrack(obj = {}) {
			let { track } = obj;
			if (!track) track = obj;
			if (this.tech_) return this.tech_.removeRemoteTextTrack(track);
		}
		/**
		* Gets available media playback quality metrics as specified by the W3C's Media
		* Playback Quality API.
		*
		* @see [Spec]{@link https://wicg.github.io/media-playback-quality}
		*
		* @return {Object|undefined}
		*         An object with supported media playback quality metrics or undefined if there
		*         is no tech or the tech does not support it.
		*/
		getVideoPlaybackQuality() {
			return this.techGet_("getVideoPlaybackQuality");
		}
		/**
		* Get video width
		*
		* @return {number}
		*         current video width
		*/
		videoWidth() {
			return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
		}
		/**
		* Get video height
		*
		* @return {number}
		*         current video height
		*/
		videoHeight() {
			return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
		}
		/**
		* Set or get the player's language code.
		*
		* Changing the language will trigger
		* [languagechange]{@link Player#event:languagechange}
		* which Components can use to update control text.
		* ClickableComponent will update its control text by default on
		* [languagechange]{@link Player#event:languagechange}.
		*
		* @fires Player#languagechange
		*
		* @param {string} [code]
		*        the language code to set the player to
		*
		* @return {string|undefined}
		*         - The current language code when getting
		*         - Nothing when setting
		*/
		language(code) {
			if (code === void 0) return this.language_;
			if (this.language_ !== String(code).toLowerCase()) {
				this.language_ = String(code).toLowerCase();
				if (isEvented(this))
 /**
				* fires when the player language change
				*
				* @event Player#languagechange
				* @type {Event}
				*/
				this.trigger("languagechange");
			}
		}
		/**
		* Get the player's language dictionary
		* Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
		* Languages specified directly in the player options have precedence
		*
		* @return {Array}
		*         An array of of supported languages
		*/
		languages() {
			return merge(Player.prototype.options_.languages, this.languages_);
		}
		/**
		* returns a JavaScript object representing the current track
		* information. **DOES not return it as JSON**
		*
		* @return {Object}
		*         Object representing the current of track info
		*/
		toJSON() {
			const options = merge(this.options_);
			const tracks = options.tracks;
			options.tracks = [];
			for (let i = 0; i < tracks.length; i++) {
				let track = tracks[i];
				track = merge(track);
				track.player = void 0;
				options.tracks[i] = track;
			}
			return options;
		}
		/**
		* Creates a simple modal dialog (an instance of the {@link ModalDialog}
		* component) that immediately overlays the player with arbitrary
		* content and removes itself when closed.
		*
		* @param {string|Function|Element|Array|null} content
		*        Same as {@link ModalDialog#content}'s param of the same name.
		*        The most straight-forward usage is to provide a string or DOM
		*        element.
		*
		* @param {Object} [options]
		*        Extra options which will be passed on to the {@link ModalDialog}.
		*
		* @return {ModalDialog}
		*         the {@link ModalDialog} that was created
		*/
		createModal(content, options) {
			options = options || {};
			options.content = content || "";
			const modal = new ModalDialog(this, options);
			this.addChild(modal);
			modal.on("dispose", () => {
				this.removeChild(modal);
			});
			modal.open();
			return modal;
		}
		/**
		* Change breakpoint classes when the player resizes.
		*
		* @private
		*/
		updateCurrentBreakpoint_() {
			if (!this.responsive()) return;
			const currentBreakpoint = this.currentBreakpoint();
			const currentWidth = this.currentWidth();
			for (let i = 0; i < BREAKPOINT_ORDER.length; i++) {
				const candidateBreakpoint = BREAKPOINT_ORDER[i];
				if (currentWidth <= this.breakpoints_[candidateBreakpoint]) {
					if (currentBreakpoint === candidateBreakpoint) return;
					if (currentBreakpoint) this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);
					this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);
					this.breakpoint_ = candidateBreakpoint;
					break;
				}
			}
		}
		/**
		* Removes the current breakpoint.
		*
		* @private
		*/
		removeCurrentBreakpoint_() {
			const className = this.currentBreakpointClass();
			this.breakpoint_ = "";
			if (className) this.removeClass(className);
		}
		/**
		* Get or set breakpoints on the player.
		*
		* Calling this method with an object or `true` will remove any previous
		* custom breakpoints and start from the defaults again.
		*
		* @param  {Object|boolean} [breakpoints]
		*         If an object is given, it can be used to provide custom
		*         breakpoints. If `true` is given, will set default breakpoints.
		*         If this argument is not given, will simply return the current
		*         breakpoints.
		*
		* @param  {number} [breakpoints.tiny]
		*         The maximum width for the "vjs-layout-tiny" class.
		*
		* @param  {number} [breakpoints.xsmall]
		*         The maximum width for the "vjs-layout-x-small" class.
		*
		* @param  {number} [breakpoints.small]
		*         The maximum width for the "vjs-layout-small" class.
		*
		* @param  {number} [breakpoints.medium]
		*         The maximum width for the "vjs-layout-medium" class.
		*
		* @param  {number} [breakpoints.large]
		*         The maximum width for the "vjs-layout-large" class.
		*
		* @param  {number} [breakpoints.xlarge]
		*         The maximum width for the "vjs-layout-x-large" class.
		*
		* @param  {number} [breakpoints.huge]
		*         The maximum width for the "vjs-layout-huge" class.
		*
		* @return {Object}
		*         An object mapping breakpoint names to maximum width values.
		*/
		breakpoints(breakpoints) {
			if (breakpoints === void 0) return Object.assign(this.breakpoints_);
			this.breakpoint_ = "";
			this.breakpoints_ = Object.assign({}, DEFAULT_BREAKPOINTS, breakpoints);
			this.updateCurrentBreakpoint_();
			return Object.assign(this.breakpoints_);
		}
		/**
		* Get or set a flag indicating whether or not this player should adjust
		* its UI based on its dimensions.
		*
		* @param  {boolean} [value]
		*         Should be `true` if the player should adjust its UI based on its
		*         dimensions; otherwise, should be `false`.
		*
		* @return {boolean|undefined}
		*         Will be `true` if this player should adjust its UI based on its
		*         dimensions; otherwise, will be `false`.
		*         Nothing if setting
		*/
		responsive(value) {
			if (value === void 0) return this.responsive_;
			value = Boolean(value);
			const current = this.responsive_;
			if (value === current) return;
			this.responsive_ = value;
			if (value) {
				this.on("playerresize", this.boundUpdateCurrentBreakpoint_);
				this.updateCurrentBreakpoint_();
			} else {
				this.off("playerresize", this.boundUpdateCurrentBreakpoint_);
				this.removeCurrentBreakpoint_();
			}
			return value;
		}
		/**
		* Get current breakpoint name, if any.
		*
		* @return {string}
		*         If there is currently a breakpoint set, returns a the key from the
		*         breakpoints object matching it. Otherwise, returns an empty string.
		*/
		currentBreakpoint() {
			return this.breakpoint_;
		}
		/**
		* Get the current breakpoint class name.
		*
		* @return {string}
		*         The matching class name (e.g. `"vjs-layout-tiny"` or
		*         `"vjs-layout-large"`) for the current breakpoint. Empty string if
		*         there is no current breakpoint.
		*/
		currentBreakpointClass() {
			return BREAKPOINT_CLASSES[this.breakpoint_] || "";
		}
		/**
		* An object that describes a single piece of media.
		*
		* Properties that are not part of this type description will be retained; so,
		* this can be viewed as a generic metadata storage mechanism as well.
		*
		* @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
		* @typedef  {Object} Player~MediaObject
		*
		* @property {string} [album]
		*           Unused, except if this object is passed to the `MediaSession`
		*           API.
		*
		* @property {string} [artist]
		*           Unused, except if this object is passed to the `MediaSession`
		*           API.
		*
		* @property {Object[]} [artwork]
		*           Unused, except if this object is passed to the `MediaSession`
		*           API. If not specified, will be populated via the `poster`, if
		*           available.
		*
		* @property {string} [poster]
		*           URL to an image that will display before playback.
		*
		* @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
		*           A single source object, an array of source objects, or a string
		*           referencing a URL to a media source. It is _highly recommended_
		*           that an object or array of objects is used here, so that source
		*           selection algorithms can take the `type` into account.
		*
		* @property {string} [title]
		*           Unused, except if this object is passed to the `MediaSession`
		*           API.
		*
		* @property {Object[]} [textTracks]
		*           An array of objects to be used to create text tracks, following
		*           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
		*           For ease of removal, these will be created as "remote" text
		*           tracks and set to automatically clean up on source changes.
		*
		*           These objects may have properties like `src`, `kind`, `label`,
		*           and `language`, see {@link Tech#createRemoteTextTrack}.
		*/
		/**
		* Populate the player using a {@link Player~MediaObject|MediaObject}.
		*
		* @param  {Player~MediaObject} media
		*         A media object.
		*
		* @param  {Function} ready
		*         A callback to be called when the player is ready.
		*/
		loadMedia(media, ready) {
			if (!media || typeof media !== "object") return;
			const crossOrigin = this.crossOrigin();
			this.reset();
			this.cache_.media = merge(media);
			const { artist, artwork, description, poster, src, textTracks, title } = this.cache_.media;
			if (!artwork && poster) this.cache_.media.artwork = [{
				src: poster,
				type: getMimetype(poster)
			}];
			if (crossOrigin) this.crossOrigin(crossOrigin);
			if (src) this.src(src);
			if (poster) this.poster(poster);
			if (Array.isArray(textTracks)) textTracks.forEach((tt) => this.addRemoteTextTrack(tt, false));
			if (this.titleBar) this.titleBar.update({
				title,
				description: description || artist || ""
			});
			this.ready(ready);
		}
		/**
		* Get a clone of the current {@link Player~MediaObject} for this player.
		*
		* If the `loadMedia` method has not been used, will attempt to return a
		* {@link Player~MediaObject} based on the current state of the player.
		*
		* @return {Player~MediaObject}
		*/
		getMedia() {
			if (!this.cache_.media) {
				const poster = this.poster();
				const media = {
					src: this.currentSources(),
					textTracks: Array.prototype.map.call(this.remoteTextTracks(), (tt) => ({
						kind: tt.kind,
						label: tt.label,
						language: tt.language,
						src: tt.src
					}))
				};
				if (poster) {
					media.poster = poster;
					media.artwork = [{
						src: media.poster,
						type: getMimetype(media.poster)
					}];
				}
				return media;
			}
			return merge(this.cache_.media);
		}
		/**
		* Gets tag settings
		*
		* @param {Element} tag
		*        The player tag
		*
		* @return {Object}
		*         An object containing all of the settings
		*         for a player tag
		*/
		static getTagSettings(tag) {
			const baseOptions = {
				sources: [],
				tracks: []
			};
			const tagOptions = getAttributes(tag);
			const dataSetup = tagOptions["data-setup"];
			if (hasClass(tag, "vjs-fill")) tagOptions.fill = true;
			if (hasClass(tag, "vjs-fluid")) tagOptions.fluid = true;
			if (dataSetup !== null) try {
				Object.assign(tagOptions, JSON.parse(dataSetup || "{}"));
			} catch (e) {
				log.error("data-setup", e);
			}
			Object.assign(baseOptions, tagOptions);
			if (tag.hasChildNodes()) {
				const children = tag.childNodes;
				for (let i = 0, j = children.length; i < j; i++) {
					const child = children[i];
					const childName = child.nodeName.toLowerCase();
					if (childName === "source") baseOptions.sources.push(getAttributes(child));
					else if (childName === "track") baseOptions.tracks.push(getAttributes(child));
				}
			}
			return baseOptions;
		}
		/**
		* Set debug mode to enable/disable logs at info level.
		*
		* @param {boolean} enabled
		* @fires Player#debugon
		* @fires Player#debugoff
		* @return {boolean|undefined}
		*/
		debug(enabled) {
			if (enabled === void 0) return this.debugEnabled_;
			if (enabled) {
				this.trigger("debugon");
				this.previousLogLevel_ = this.log.level;
				this.log.level("debug");
				this.debugEnabled_ = true;
			} else {
				this.trigger("debugoff");
				this.log.level(this.previousLogLevel_);
				this.previousLogLevel_ = void 0;
				this.debugEnabled_ = false;
			}
		}
		/**
		* Set or get current playback rates.
		* Takes an array and updates the playback rates menu with the new items.
		* Pass in an empty array to hide the menu.
		* Values other than arrays are ignored.
		*
		* @fires Player#playbackrateschange
		* @param {number[]} [newRates]
		*                   The new rates that the playback rates menu should update to.
		*                   An empty array will hide the menu
		* @return {number[]} When used as a getter will return the current playback rates
		*/
		playbackRates(newRates) {
			if (newRates === void 0) return this.cache_.playbackRates;
			if (!Array.isArray(newRates)) return;
			if (!newRates.every((rate) => typeof rate === "number")) return;
			this.cache_.playbackRates = newRates;
			/**
			* fires when the playback rates in a player are changed
			*
			* @event Player#playbackrateschange
			* @type {Event}
			*/
			this.trigger("playbackrateschange");
		}
	};
	/**
	* Get the {@link VideoTrackList}
	*
	* @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	*
	* @return {VideoTrackList}
	*         the current video track list
	*
	* @method Player.prototype.videoTracks
	*/
	Player.prototype.videoTracks = () => {};
	/**
	* Get the {@link AudioTrackList}
	*
	* @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	*
	* @return {AudioTrackList}
	*         the current audio track list
	*
	* @method Player.prototype.audioTracks
	*/
	Player.prototype.audioTracks = () => {};
	/**
	* Get the {@link TextTrackList}
	*
	* @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	*
	* @return {TextTrackList}
	*         the current text track list
	*
	* @method Player.prototype.textTracks
	*/
	Player.prototype.textTracks = () => {};
	/**
	* Get the remote {@link TextTrackList}
	*
	* @return {TextTrackList}
	*         The current remote text track list
	*
	* @method Player.prototype.remoteTextTracks
	*/
	Player.prototype.remoteTextTracks = () => {};
	/**
	* Get the remote {@link HtmlTrackElementList} tracks.
	*
	* @return {HtmlTrackElementList}
	*         The current remote text track element list
	*
	* @method Player.prototype.remoteTextTrackEls
	*/
	Player.prototype.remoteTextTrackEls = () => {};
	ALL.names.forEach(function(name) {
		const props = ALL[name];
		Player.prototype[props.getterName] = function() {
			if (this.tech_) return this.tech_[props.getterName]();
			this[props.privateName] = this[props.privateName] || new props.ListClass();
			return this[props.privateName];
		};
	});
	/**
	* Get or set the `Player`'s crossorigin option. For the HTML5 player, this
	* sets the `crossOrigin` property on the `<video>` tag to control the CORS
	* behavior.
	*
	* @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	*
	* @param {string} [value]
	*        The value to set the `Player`'s crossorigin to. If an argument is
	*        given, must be one of `anonymous` or `use-credentials`.
	*
	* @return {string|undefined}
	*         - The current crossorigin value of the `Player` when getting.
	*         - undefined when setting
	*/
	Player.prototype.crossorigin = Player.prototype.crossOrigin;
	/**
	* Global enumeration of players.
	*
	* The keys are the player IDs and the values are either the {@link Player}
	* instance or `null` for disposed players.
	*
	* @type {Object}
	*/
	Player.players = {};
	var navigator = window__default["default"].navigator;
	Player.prototype.options_ = {
		techOrder: Tech.defaultTechOrder_,
		html5: {},
		enableSourceset: true,
		inactivityTimeout: 2e3,
		playbackRates: [],
		liveui: false,
		children: [
			"mediaLoader",
			"posterImage",
			"titleBar",
			"textTrackDisplay",
			"loadingSpinner",
			"bigPlayButton",
			"liveTracker",
			"controlBar",
			"errorDisplay",
			"textTrackSettings",
			"resizeManager"
		],
		language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || "en",
		languages: {},
		notSupportedMessage: "No compatible source was found for this media.",
		normalizeAutoplay: false,
		fullscreen: { options: { navigationUI: "hide" } },
		breakpoints: {},
		responsive: false,
		audioOnlyMode: false,
		audioPosterMode: false,
		spatialNavigation: {
			enabled: false,
			horizontalSeek: false
		},
		enableSmoothSeeking: false,
		disableSeekWhileScrubbingOnMobile: false,
		disableSeekWhileScrubbingOnSTV: false
	};
	TECH_EVENTS_RETRIGGER.forEach(function(event) {
		Player.prototype[`handleTech${toTitleCase(event)}_`] = function() {
			return this.trigger(event);
		};
	});
	/**
	* Fired when the player has initial duration and dimension information
	*
	* @event Player#loadedmetadata
	* @type {Event}
	*/
	/**
	* Fired when the player has downloaded data at the current playback position
	*
	* @event Player#loadeddata
	* @type {Event}
	*/
	/**
	* Fired when the current playback position has changed *
	* During playback this is fired every 15-250 milliseconds, depending on the
	* playback technology in use.
	*
	* @event Player#timeupdate
	* @type {Event}
	*/
	/**
	* Fired when the volume changes
	*
	* @event Player#volumechange
	* @type {Event}
	*/
	Component.registerComponent("Player", Player);
	/**
	* @file plugin.js
	*/
	/**
	* The base plugin name.
	*
	* @private
	* @constant
	* @type {string}
	*/
	var BASE_PLUGIN_NAME = "plugin";
	/**
	* The key on which a player's active plugins cache is stored.
	*
	* @private
	* @constant
	* @type     {string}
	*/
	var PLUGIN_CACHE_KEY = "activePlugins_";
	/**
	* Stores registered plugins in a private space.
	*
	* @private
	* @type    {Object}
	*/
	var pluginStorage = {};
	/**
	* Reports whether or not a plugin has been registered.
	*
	* @private
	* @param   {string} name
	*          The name of a plugin.
	*
	* @return {boolean}
	*          Whether or not the plugin has been registered.
	*/
	var pluginExists = (name) => pluginStorage.hasOwnProperty(name);
	/**
	* Get a single registered plugin by name.
	*
	* @private
	* @param   {string} name
	*          The name of a plugin.
	*
	* @return {typeof Plugin|Function|undefined}
	*          The plugin (or undefined).
	*/
	var getPlugin = (name) => pluginExists(name) ? pluginStorage[name] : void 0;
	/**
	* Marks a plugin as "active" on a player.
	*
	* Also, ensures that the player has an object for tracking active plugins.
	*
	* @private
	* @param   {Player} player
	*          A Video.js player instance.
	*
	* @param   {string} name
	*          The name of a plugin.
	*/
	var markPluginAsActive = (player, name) => {
		player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
		player[PLUGIN_CACHE_KEY][name] = true;
	};
	/**
	* Triggers a pair of plugin setup events.
	*
	* @private
	* @param  {Player} player
	*         A Video.js player instance.
	*
	* @param  {PluginEventHash} hash
	*         A plugin event hash.
	*
	* @param  {boolean} [before]
	*         If true, prefixes the event name with "before". In other words,
	*         use this to trigger "beforepluginsetup" instead of "pluginsetup".
	*/
	var triggerSetupEvent = (player, hash, before) => {
		const eventName = (before ? "before" : "") + "pluginsetup";
		player.trigger(eventName, hash);
		player.trigger(eventName + ":" + hash.name, hash);
	};
	/**
	* Takes a basic plugin function and returns a wrapper function which marks
	* on the player that the plugin has been activated.
	*
	* @private
	* @param   {string} name
	*          The name of the plugin.
	*
	* @param   {Function} plugin
	*          The basic plugin.
	*
	* @return {Function}
	*          A wrapper function for the given plugin.
	*/
	var createBasicPlugin = function(name, plugin) {
		const basicPluginWrapper = function() {
			triggerSetupEvent(this, {
				name,
				plugin,
				instance: null
			}, true);
			const instance = plugin.apply(this, arguments);
			markPluginAsActive(this, name);
			triggerSetupEvent(this, {
				name,
				plugin,
				instance
			});
			return instance;
		};
		Object.keys(plugin).forEach(function(prop) {
			basicPluginWrapper[prop] = plugin[prop];
		});
		return basicPluginWrapper;
	};
	/**
	* Takes a plugin sub-class and returns a factory function for generating
	* instances of it.
	*
	* This factory function will replace itself with an instance of the requested
	* sub-class of Plugin.
	*
	* @private
	* @param   {string} name
	*          The name of the plugin.
	*
	* @param   {Plugin} PluginSubClass
	*          The advanced plugin.
	*
	* @return {Function}
	*/
	var createPluginFactory = (name, PluginSubClass) => {
		PluginSubClass.prototype.name = name;
		return function(...args) {
			triggerSetupEvent(this, {
				name,
				plugin: PluginSubClass,
				instance: null
			}, true);
			const instance = new PluginSubClass(...[this, ...args]);
			this[name] = () => instance;
			triggerSetupEvent(this, instance.getEventHash());
			return instance;
		};
	};
	/**
	* Parent class for all advanced plugins.
	*
	* @mixes   module:evented~EventedMixin
	* @mixes   module:stateful~StatefulMixin
	* @fires   Player#beforepluginsetup
	* @fires   Player#beforepluginsetup:$name
	* @fires   Player#pluginsetup
	* @fires   Player#pluginsetup:$name
	* @listens Player#dispose
	* @throws  {Error}
	*          If attempting to instantiate the base {@link Plugin} class
	*          directly instead of via a sub-class.
	*/
	var Plugin = class Plugin {
		/**
		* Creates an instance of this class.
		*
		* Sub-classes should call `super` to ensure plugins are properly initialized.
		*
		* @param {Player} player
		*        A Video.js player instance.
		*/
		constructor(player) {
			if (this.constructor === Plugin) throw new Error("Plugin must be sub-classed; not directly instantiated.");
			this.player = player;
			if (!this.log) this.log = this.player.log.createLogger(this.name);
			evented(this);
			delete this.trigger;
			stateful(this, this.constructor.defaultState);
			markPluginAsActive(player, this.name);
			this.dispose = this.dispose.bind(this);
			player.on("dispose", this.dispose);
		}
		/**
		* Get the version of the plugin that was set on <pluginName>.VERSION
		*/
		version() {
			return this.constructor.VERSION;
		}
		/**
		* Each event triggered by plugins includes a hash of additional data with
		* conventional properties.
		*
		* This returns that object or mutates an existing hash.
		*
		* @param   {Object} [hash={}]
		*          An object to be used as event an event hash.
		*
		* @return {PluginEventHash}
		*          An event hash object with provided properties mixed-in.
		*/
		getEventHash(hash = {}) {
			hash.name = this.name;
			hash.plugin = this.constructor;
			hash.instance = this;
			return hash;
		}
		/**
		* Triggers an event on the plugin object and overrides
		* {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
		*
		* @param   {string|Object} event
		*          An event type or an object with a type property.
		*
		* @param   {Object} [hash={}]
		*          Additional data hash to merge with a
		*          {@link PluginEventHash|PluginEventHash}.
		*
		* @return {boolean}
		*          Whether or not default was prevented.
		*/
		trigger(event, hash = {}) {
			return trigger(this.eventBusEl_, event, this.getEventHash(hash));
		}
		/**
		* Handles "statechanged" events on the plugin. No-op by default, override by
		* subclassing.
		*
		* @abstract
		* @param    {Event} e
		*           An event object provided by a "statechanged" event.
		*
		* @param    {Object} e.changes
		*           An object describing changes that occurred with the "statechanged"
		*           event.
		*/
		handleStateChanged(e) {}
		/**
		* Disposes a plugin.
		*
		* Subclasses can override this if they want, but for the sake of safety,
		* it's probably best to subscribe the "dispose" event.
		*
		* @fires Plugin#dispose
		*/
		dispose() {
			const { name, player } = this;
			/**
			* Signals that a advanced plugin is about to be disposed.
			*
			* @event Plugin#dispose
			* @type  {Event}
			*/
			this.trigger("dispose");
			this.off();
			player.off("dispose", this.dispose);
			player[PLUGIN_CACHE_KEY][name] = false;
			this.player = this.state = null;
			player[name] = createPluginFactory(name, pluginStorage[name]);
		}
		/**
		* Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
		*
		* @param   {string|Function} plugin
		*          If a string, matches the name of a plugin. If a function, will be
		*          tested directly.
		*
		* @return {boolean}
		*          Whether or not a plugin is a basic plugin.
		*/
		static isBasic(plugin) {
			const p = typeof plugin === "string" ? getPlugin(plugin) : plugin;
			return typeof p === "function" && !Plugin.prototype.isPrototypeOf(p.prototype);
		}
		/**
		* Register a Video.js plugin.
		*
		* @param   {string} name
		*          The name of the plugin to be registered. Must be a string and
		*          must not match an existing plugin or a method on the `Player`
		*          prototype.
		*
		* @param   {typeof Plugin|Function} plugin
		*          A sub-class of `Plugin` or a function for basic plugins.
		*
		* @return {typeof Plugin|Function}
		*          For advanced plugins, a factory function for that plugin. For
		*          basic plugins, a wrapper function that initializes the plugin.
		*/
		static registerPlugin(name, plugin) {
			if (typeof name !== "string") throw new Error(`Illegal plugin name, "${name}", must be a string, was ${typeof name}.`);
			if (pluginExists(name)) log.warn(`A plugin named "${name}" already exists. You may want to avoid re-registering plugins!`);
			else if (Player.prototype.hasOwnProperty(name)) throw new Error(`Illegal plugin name, "${name}", cannot share a name with an existing player method!`);
			if (typeof plugin !== "function") throw new Error(`Illegal plugin for "${name}", must be a function, was ${typeof plugin}.`);
			pluginStorage[name] = plugin;
			if (name !== BASE_PLUGIN_NAME) if (Plugin.isBasic(plugin)) Player.prototype[name] = createBasicPlugin(name, plugin);
			else Player.prototype[name] = createPluginFactory(name, plugin);
			return plugin;
		}
		/**
		* De-register a Video.js plugin.
		*
		* @param  {string} name
		*         The name of the plugin to be de-registered. Must be a string that
		*         matches an existing plugin.
		*
		* @throws {Error}
		*         If an attempt is made to de-register the base plugin.
		*/
		static deregisterPlugin(name) {
			if (name === BASE_PLUGIN_NAME) throw new Error("Cannot de-register base plugin.");
			if (pluginExists(name)) {
				delete pluginStorage[name];
				delete Player.prototype[name];
			}
		}
		/**
		* Gets an object containing multiple Video.js plugins.
		*
		* @param   {Array} [names]
		*          If provided, should be an array of plugin names. Defaults to _all_
		*          plugin names.
		*
		* @return {Object|undefined}
		*          An object containing plugin(s) associated with their name(s) or
		*          `undefined` if no matching plugins exist).
		*/
		static getPlugins(names = Object.keys(pluginStorage)) {
			let result;
			names.forEach((name) => {
				const plugin = getPlugin(name);
				if (plugin) {
					result = result || {};
					result[name] = plugin;
				}
			});
			return result;
		}
		/**
		* Gets a plugin's version, if available
		*
		* @param   {string} name
		*          The name of a plugin.
		*
		* @return {string}
		*          The plugin's version or an empty string.
		*/
		static getPluginVersion(name) {
			const plugin = getPlugin(name);
			return plugin && plugin.VERSION || "";
		}
	};
	/**
	* Gets a plugin by name if it exists.
	*
	* @static
	* @method   getPlugin
	* @memberOf Plugin
	* @param    {string} name
	*           The name of a plugin.
	*
	* @returns  {typeof Plugin|Function|undefined}
	*           The plugin (or `undefined`).
	*/
	Plugin.getPlugin = getPlugin;
	/**
	* The name of the base plugin class as it is registered.
	*
	* @type {string}
	*/
	Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
	Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
	/**
	* Documented in player.js
	*
	* @ignore
	*/
	Player.prototype.usingPlugin = function(name) {
		return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
	};
	/**
	* Documented in player.js
	*
	* @ignore
	*/
	Player.prototype.hasPlugin = function(name) {
		return !!pluginExists(name);
	};
	/**
	* Signals that a plugin is about to be set up on a player.
	*
	* @event    Player#beforepluginsetup
	* @type     {PluginEventHash}
	*/
	/**
	* Signals that a plugin is about to be set up on a player - by name. The name
	* is the name of the plugin.
	*
	* @event    Player#beforepluginsetup:$name
	* @type     {PluginEventHash}
	*/
	/**
	* Signals that a plugin has just been set up on a player.
	*
	* @event    Player#pluginsetup
	* @type     {PluginEventHash}
	*/
	/**
	* Signals that a plugin has just been set up on a player - by name. The name
	* is the name of the plugin.
	*
	* @event    Player#pluginsetup:$name
	* @type     {PluginEventHash}
	*/
	/**
	* @typedef  {Object} PluginEventHash
	*
	* @property {string} instance
	*           For basic plugins, the return value of the plugin function. For
	*           advanced plugins, the plugin instance on which the event is fired.
	*
	* @property {string} name
	*           The name of the plugin.
	*
	* @property {string} plugin
	*           For basic plugins, the plugin function. For advanced plugins, the
	*           plugin class/constructor.
	*/
	/**
	* @file deprecate.js
	* @module deprecate
	*/
	/**
	* Decorate a function with a deprecation message the first time it is called.
	*
	* @param  {string}   message
	*         A deprecation message to log the first time the returned function
	*         is called.
	*
	* @param  {Function} fn
	*         The function to be deprecated.
	*
	* @return {Function}
	*         A wrapper function that will log a deprecation warning the first
	*         time it is called. The return value will be the return value of
	*         the wrapped function.
	*/
	function deprecate(message, fn) {
		let warned = false;
		return function(...args) {
			if (!warned) log.warn(message);
			warned = true;
			return fn.apply(this, args);
		};
	}
	/**
	* Internal function used to mark a function as deprecated in the next major
	* version with consistent messaging.
	*
	* @param  {number}   major   The major version where it will be removed
	* @param  {string}   oldName The old function name
	* @param  {string}   newName The new function name
	* @param  {Function} fn      The function to deprecate
	* @return {Function}         The decorated function
	*/
	function deprecateForMajor(major, oldName, newName, fn) {
		return deprecate(`${oldName} is deprecated and will be removed in ${major}.0; please use ${newName} instead.`, fn);
	}
	var VjsErrors = {
		NetworkBadStatus: "networkbadstatus",
		NetworkRequestFailed: "networkrequestfailed",
		NetworkRequestAborted: "networkrequestaborted",
		NetworkRequestTimeout: "networkrequesttimeout",
		NetworkBodyParserFailed: "networkbodyparserfailed",
		StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
		StreamingDashManifestParserError: "streamingdashmanifestparsererror",
		StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
		StreamingVttParserError: "streamingvttparsererror",
		StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
		StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
		StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
		StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
		StreamingCodecsChangeError: "streamingcodecschangeerror"
	};
	/**
	* @file video.js
	* @module videojs
	*/
	/** @import { PlayerReadyCallback } from './player' */
	/**
	* Normalize an `id` value by trimming off a leading `#`
	*
	* @private
	* @param   {string} id
	*          A string, maybe with a leading `#`.
	*
	* @return {string}
	*          The string, without any leading `#`.
	*/
	var normalizeId = (id) => id.indexOf("#") === 0 ? id.slice(1) : id;
	/**
	* The `videojs()` function doubles as the main function for users to create a
	* {@link Player} instance as well as the main library namespace.
	*
	* It can also be used as a getter for a pre-existing {@link Player} instance.
	* However, we _strongly_ recommend using `videojs.getPlayer()` for this
	* purpose because it avoids any potential for unintended initialization.
	*
	* Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	* of our JSDoc template, we cannot properly document this as both a function
	* and a namespace, so its function signature is documented here.
	*
	* #### Arguments
	* ##### id
	* string|Element, **required**
	*
	* Video element or video element ID.
	*
	* ##### options
	* Object, optional
	*
	* Options object for providing settings.
	* See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	*
	* ##### ready
	* {@link Component~ReadyCallback}, optional
	*
	* A function to be called when the {@link Player} and {@link Tech} are ready.
	*
	* #### Return Value
	*
	* The `videojs()` function returns a {@link Player} instance.
	*
	* @namespace
	*
	* @borrows AudioTrack as AudioTrack
	* @borrows Component.getComponent as getComponent
	* @borrows module:events.on as on
	* @borrows module:events.one as one
	* @borrows module:events.off as off
	* @borrows module:events.trigger as trigger
	* @borrows EventTarget as EventTarget
	* @borrows module:middleware.use as use
	* @borrows Player.players as players
	* @borrows Plugin.registerPlugin as registerPlugin
	* @borrows Plugin.deregisterPlugin as deregisterPlugin
	* @borrows Plugin.getPlugins as getPlugins
	* @borrows Plugin.getPlugin as getPlugin
	* @borrows Plugin.getPluginVersion as getPluginVersion
	* @borrows Tech.getTech as getTech
	* @borrows Tech.registerTech as registerTech
	* @borrows TextTrack as TextTrack
	* @borrows VideoTrack as VideoTrack
	*
	* @param  {string|Element} id
	*         Video element or video element ID.
	*
	* @param  {Object} [options]
	*         Options object for providing settings.
	*         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	*
	* @param  {PlayerReadyCallback} [ready]
	*         A function to be called when the {@link Player} and {@link Tech} are
	*         ready.
	*
	* @return {Player}
	*         The `videojs()` function returns a {@link Player|Player} instance.
	*/
	function videojs(id, options, ready) {
		let player = videojs.getPlayer(id);
		if (player) {
			if (options) log.warn(`Player "${id}" is already initialised. Options will not be applied.`);
			if (ready) player.ready(ready);
			return player;
		}
		const el = typeof id === "string" ? $("#" + normalizeId(id)) : id;
		if (!isEl(el)) throw new TypeError("The element or ID supplied is not valid. (videojs)");
		const rootNode = ("getRootNode" in el ? el.getRootNode() instanceof window__default["default"].ShadowRoot : false) ? el.getRootNode() : el.ownerDocument.body;
		if (!el.ownerDocument.defaultView || !rootNode.contains(el)) log.warn("The element supplied is not included in the DOM");
		options = options || {};
		if (options.restoreEl === true) options.restoreEl = (el.parentNode && el.parentNode.hasAttribute && el.parentNode.hasAttribute("data-vjs-player") ? el.parentNode : el).cloneNode(true);
		hooks("beforesetup").forEach((hookFunction) => {
			const opts = hookFunction(el, merge(options));
			if (!isObject(opts) || Array.isArray(opts)) {
				log.error("please return an object in beforesetup hooks");
				return;
			}
			options = merge(options, opts);
		});
		player = new (Component.getComponent("Player"))(el, options, ready);
		hooks("setup").forEach((hookFunction) => hookFunction(player));
		return player;
	}
	videojs.hooks_ = hooks_;
	videojs.hooks = hooks;
	videojs.hook = hook;
	videojs.hookOnce = hookOnce;
	videojs.removeHook = removeHook;
	if (window__default["default"].VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
		let style = $(".vjs-styles-defaults");
		if (!style) {
			style = createStyleElement("vjs-styles-defaults");
			const head = $("head");
			if (head) head.insertBefore(style, head.firstChild);
			setTextContent(style, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
		}
	}
	autoSetupTimeout(1, videojs);
	/**
	* Current Video.js version. Follows [semantic versioning](https://semver.org/).
	*
	* @type {string}
	*/
	videojs.VERSION = version;
	/**
	* The global options object. These are the settings that take effect
	* if no overrides are specified when the player is created.
	*
	* @type {Object}
	*/
	videojs.options = Player.prototype.options_;
	/**
	* Get an object with the currently created players, keyed by player ID
	*
	* @return {Object}
	*         The created players
	*/
	videojs.getPlayers = () => Player.players;
	/**
	* Get a single player based on an ID or DOM element.
	*
	* This is useful if you want to check if an element or ID has an associated
	* Video.js player, but not create one if it doesn't.
	*
	* @param   {string|Element} id
	*          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
	*          or a string matching the `id` of such an element.
	*
	* @return {Player|undefined}
	*          A player instance or `undefined` if there is no player instance
	*          matching the argument.
	*/
	videojs.getPlayer = (id) => {
		const players = Player.players;
		let tag;
		if (typeof id === "string") {
			const nId = normalizeId(id);
			const player = players[nId];
			if (player) return player;
			tag = $("#" + nId);
		} else tag = id;
		if (isEl(tag)) {
			const { player, playerId } = tag;
			if (player || players[playerId]) return player || players[playerId];
		}
	};
	/**
	* Returns an array of all current players.
	*
	* @return {Array}
	*         An array of all players. The array will be in the order that
	*         `Object.keys` provides, which could potentially vary between
	*         JavaScript engines.
	*
	*/
	videojs.getAllPlayers = () => Object.keys(Player.players).map((k) => Player.players[k]).filter(Boolean);
	videojs.players = Player.players;
	videojs.getComponent = Component.getComponent;
	/**
	* Register a component so it can referred to by name. Used when adding to other
	* components, either through addChild `component.addChild('myComponent')` or through
	* default children options  `{ children: ['myComponent'] }`.
	*
	* > NOTE: You could also just initialize the component before adding.
	* `component.addChild(new MyComponent());`
	*
	* @param {string} name
	*        The class name of the component
	*
	* @param {typeof Component} comp
	*        The component class
	*
	* @return {typeof Component}
	*         The newly registered component
	*/
	videojs.registerComponent = (name, comp) => {
		if (Tech.isTech(comp)) log.warn(`The ${name} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`);
		return Component.registerComponent.call(Component, name, comp);
	};
	videojs.getTech = Tech.getTech;
	videojs.registerTech = Tech.registerTech;
	videojs.use = use;
	/**
	* An object that can be returned by a middleware to signify
	* that the middleware is being terminated.
	*
	* @type {object}
	* @property {object} middleware.TERMINATOR
	*/
	Object.defineProperty(videojs, "middleware", {
		value: {},
		writeable: false,
		enumerable: true
	});
	Object.defineProperty(videojs.middleware, "TERMINATOR", {
		value: TERMINATOR,
		writeable: false,
		enumerable: true
	});
	/**
	* A reference to the {@link module:browser|browser utility module} as an object.
	*
	* @type {Object}
	* @see  {@link module:browser|browser}
	*/
	videojs.browser = browser;
	/**
	* A reference to the {@link module:obj|obj utility module} as an object.
	*
	* @type {Object}
	* @see  {@link module:obj|obj}
	*/
	videojs.obj = Obj;
	/**
	* Deprecated reference to the {@link module:obj.merge|merge function}
	*
	* @type {Function}
	* @see {@link module:obj.merge|merge}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.merge instead.
	*/
	videojs.mergeOptions = deprecateForMajor(9, "videojs.mergeOptions", "videojs.obj.merge", merge);
	/**
	* Deprecated reference to the {@link module:obj.defineLazyProperty|defineLazyProperty function}
	*
	* @type {Function}
	* @see {@link module:obj.defineLazyProperty|defineLazyProperty}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.defineLazyProperty instead.
	*/
	videojs.defineLazyProperty = deprecateForMajor(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", defineLazyProperty);
	/**
	* Deprecated reference to the {@link module:fn.bind_|fn.bind_ function}
	*
	* @type {Function}
	* @see {@link module:fn.bind_|fn.bind_}
	* @deprecated Deprecated and will be removed in 9.0. Please use native Function.prototype.bind instead.
	*/
	videojs.bind = deprecateForMajor(9, "videojs.bind", "native Function.prototype.bind", bind_);
	videojs.registerPlugin = Plugin.registerPlugin;
	videojs.deregisterPlugin = Plugin.deregisterPlugin;
	/**
	* Deprecated method to register a plugin with Video.js
	*
	* @deprecated Deprecated and will be removed in 9.0. Use videojs.registerPlugin() instead.
	*
	* @param {string} name
	*        The plugin name
	*
	* @param {typeof Plugin|Function} plugin
	*         The plugin sub-class or function
	*
	* @return {typeof Plugin|Function}
	*/
	videojs.plugin = (name, plugin) => {
		log.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead");
		return Plugin.registerPlugin(name, plugin);
	};
	videojs.getPlugins = Plugin.getPlugins;
	videojs.getPlugin = Plugin.getPlugin;
	videojs.getPluginVersion = Plugin.getPluginVersion;
	/**
	* Adding languages so that they're available to all players.
	* Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	*
	* @param {string} code
	*        The language code or dictionary property
	*
	* @param {Object} data
	*        The data values to be translated
	*
	* @return {Object}
	*         The resulting language dictionary object
	*/
	videojs.addLanguage = function(code, data) {
		code = ("" + code).toLowerCase();
		videojs.options.languages = merge(videojs.options.languages, { [code]: data });
		return videojs.options.languages[code];
	};
	/**
	* A reference to the {@link module:log|log utility module} as an object.
	*
	* @type {Function}
	* @see  {@link module:log|log}
	*/
	videojs.log = log;
	videojs.createLogger = createLogger;
	/**
	* A reference to the {@link module:time|time utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:time|time}
	*/
	videojs.time = Time;
	/**
	* Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
	*
	* @type {Function}
	* @see {@link module:time.createTimeRanges|createTimeRanges}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
	*/
	videojs.createTimeRange = deprecateForMajor(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", createTimeRanges);
	/**
	* Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
	*
	* @type {Function}
	* @see {@link module:time.createTimeRanges|createTimeRanges}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
	*/
	videojs.createTimeRanges = deprecateForMajor(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", createTimeRanges);
	/**
	* Deprecated reference to the {@link module:time.formatTime|formatTime function}
	*
	* @type {Function}
	* @see {@link module:time.formatTime|formatTime}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.format instead.
	*/
	videojs.formatTime = deprecateForMajor(9, "videojs.formatTime", "videojs.time.formatTime", formatTime);
	/**
	* Deprecated reference to the {@link module:time.setFormatTime|setFormatTime function}
	*
	* @type {Function}
	* @see {@link module:time.setFormatTime|setFormatTime}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.setFormat instead.
	*/
	videojs.setFormatTime = deprecateForMajor(9, "videojs.setFormatTime", "videojs.time.setFormatTime", setFormatTime);
	/**
	* Deprecated reference to the {@link module:time.resetFormatTime|resetFormatTime function}
	*
	* @type {Function}
	* @see {@link module:time.resetFormatTime|resetFormatTime}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.resetFormat instead.
	*/
	videojs.resetFormatTime = deprecateForMajor(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", resetFormatTime);
	/**
	* Deprecated reference to the {@link module:url.parseUrl|Url.parseUrl function}
	*
	* @type {Function}
	* @see {@link module:url.parseUrl|parseUrl}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.parseUrl instead.
	*/
	videojs.parseUrl = deprecateForMajor(9, "videojs.parseUrl", "videojs.url.parseUrl", parseUrl);
	/**
	* Deprecated reference to the {@link module:url.isCrossOrigin|Url.isCrossOrigin function}
	*
	* @type {Function}
	* @see {@link module:url.isCrossOrigin|isCrossOrigin}
	* @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.isCrossOrigin instead.
	*/
	videojs.isCrossOrigin = deprecateForMajor(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", isCrossOrigin);
	videojs.EventTarget = EventTarget;
	videojs.any = any;
	videojs.on = on;
	videojs.one = one;
	videojs.off = off;
	videojs.trigger = trigger;
	/**
	* A cross-browser XMLHttpRequest wrapper.
	*
	* @function
	* @param    {Object} options
	*           Settings for the request.
	*
	* @return   {XMLHttpRequest|XDomainRequest}
	*           The request object.
	*
	* @see      https://github.com/Raynos/xhr
	*/
	videojs.xhr = XHR__default["default"];
	videojs.TrackList = TrackList;
	videojs.TextTrack = TextTrack;
	videojs.TextTrackList = TextTrackList;
	videojs.AudioTrack = AudioTrack;
	videojs.AudioTrackList = AudioTrackList;
	videojs.VideoTrack = VideoTrack;
	videojs.VideoTrackList = VideoTrackList;
	[
		"isEl",
		"isTextNode",
		"createEl",
		"hasClass",
		"addClass",
		"removeClass",
		"toggleClass",
		"setAttributes",
		"getAttributes",
		"emptyEl",
		"appendContent",
		"insertContent"
	].forEach((k) => {
		videojs[k] = function() {
			log.warn(`videojs.${k}() is deprecated; use videojs.dom.${k}() instead`);
			return Dom[k].apply(null, arguments);
		};
	});
	videojs.computedStyle = deprecateForMajor(9, "videojs.computedStyle", "videojs.dom.computedStyle", computedStyle);
	/**
	* A reference to the {@link module:dom|DOM utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:dom|dom}
	*/
	videojs.dom = Dom;
	/**
	* A reference to the {@link module:fn|fn utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:fn|fn}
	*/
	videojs.fn = Fn;
	/**
	* A reference to the {@link module:num|num utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:num|num}
	*/
	videojs.num = Num;
	/**
	* A reference to the {@link module:str|str utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:str|str}
	*/
	videojs.str = Str;
	/**
	* A reference to the {@link module:url|URL utility module} as an object.
	*
	* @type {Object}
	* @see {@link module:url|url}
	*/
	videojs.url = Url;
	videojs.Error = VjsErrors;
	module.exports = videojs;
})))(), 1);
function randomString(length) {
	const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	const charsLength = 62;
	const randomArray = new Uint8Array(length);
	let result = "";
	for (const v of crypto.getRandomValues(randomArray)) result += chars[v % charsLength];
	return result;
}
//#endregion
//#region src/peertube-player-local-storage.ts
function getStoredPlaybackRate() {
	return parseLocalStorageFloat(getLocalStorage("playback-rate"));
}
function savePlaybackRateInStore(value) {
	return setLocalStorage("playback-rate", value.toString());
}
function getStoredVolume() {
	return parseLocalStorageFloat(getLocalStorage("volume"));
}
function saveVolumeInStore(value) {
	return setLocalStorage("volume", value.toString());
}
function getStoredMute() {
	return parseLocalStorageBool(getLocalStorage("mute"));
}
function saveMuteInStore(value) {
	return setLocalStorage("mute", value.toString());
}
function getStoredTheater() {
	return parseLocalStorageBool(getLocalStorage("theater-enabled"));
}
function saveTheaterInStore(enabled) {
	return setLocalStorage("theater-enabled", enabled.toString());
}
function saveAverageBandwidth(value) {
	/** used to choose the most fitting resolution */
	return setLocalStorage("average-bandwidth", value.toString());
}
function getAverageBandwidthInStore() {
	return parseLocalStorageInt(getLocalStorage("average-bandwidth"));
}
function savePreferredResolution(resolution) {
	return setLocalStorage("preferred-resolution", resolution.toString());
}
function getStoredPreferredResolution() {
	return parseLocalStorageInt(getLocalStorage("preferred-resolution"));
}
function clearStoredPreferredResolution() {
	return removeLocalStorage("preferred-resolution");
}
function saveLastSubtitle(language) {
	return setLocalStorage("last-subtitle", language);
}
function getStoredLastSubtitle() {
	return getLocalStorage("last-subtitle");
}
function savePreferredSubtitle(language) {
	return setLocalStorage("preferred-subtitle", language);
}
function getStoredPreferredSubtitle() {
	return getLocalStorage("preferred-subtitle");
}
function saveVideoWatchHistory(videoUUID, duration) {
	return setLocalStorage(`video-watch-history`, JSON.stringify({
		...getStoredVideoWatchHistory(),
		[videoUUID]: {
			duration,
			date: `${(/* @__PURE__ */ new Date()).toISOString()}`
		}
	}));
}
function getStoredVideoWatchHistory(videoUUID) {
	let data;
	try {
		const value = getLocalStorage("video-watch-history");
		if (!value) return {};
		data = JSON.parse(value);
	} catch (error) {
		logger$1.error("Cannot parse video watch history from local storage/", error);
	}
	data = data || {};
	if (videoUUID) return data[videoUUID];
	return data;
}
function cleanupVideoWatch() {
	const data = getStoredVideoWatchHistory();
	if (!data) return;
	const newData = Object.keys(data).reduce((acc, videoUUID) => {
		const date = Date.parse(data[videoUUID].date);
		if (Math.ceil(((/* @__PURE__ */ new Date()).getTime() - date) / (1e3 * 3600 * 24)) > 30) return acc;
		return {
			...acc,
			[videoUUID]: data[videoUUID]
		};
	}, {});
	setLocalStorage("video-watch-history", JSON.stringify(newData));
}
function getPlayerSessionId() {
	const key = "session-id";
	let sessionId = getSessionStorage(key);
	if (sessionId) return sessionId;
	sessionId = randomString(32);
	setSessionStorage(key, sessionId);
	return sessionId;
}
var KEY_PREFIX = "peertube-videojs-";
function getLocalStorage(key) {
	return peertubeLocalStorage.getItem(KEY_PREFIX + key);
}
function setLocalStorage(key, value) {
	peertubeLocalStorage.setItem(KEY_PREFIX + key, value);
}
function removeLocalStorage(key) {
	peertubeLocalStorage.removeItem(KEY_PREFIX + key);
}
function getSessionStorage(key) {
	return peertubeSessionStorage.getItem(KEY_PREFIX + key);
}
function setSessionStorage(key, value) {
	peertubeSessionStorage.setItem(KEY_PREFIX + key, value);
}
function parseLocalStorageFloat(value) {
	if (value !== null && value !== void 0) {
		const valueNumber = parseFloat(value);
		if (isNaN(valueNumber)) return void 0;
		return valueNumber;
	}
}
function parseLocalStorageInt(value) {
	if (value !== null && value !== void 0) {
		const valueNumber = parseInt(value, 10);
		if (isNaN(valueNumber)) return void 0;
		return valueNumber;
	}
}
function parseLocalStorageBool(value) {
	if (value !== null && value !== void 0) return value === "true";
}
//#endregion
//#region src/shared/bezels/pause-bezel.ts
function getPauseBezel() {
	return `
  <div class="vjs-bezels-pause">
    <div class="vjs-bezel" role="status" aria-label="Pause">
      <div class="vjs-bezel-icon">
        <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%">
          <use class="vjs-svg-shadow" xlink:href="#vjs-id-1"></use>
          <path class="vjs-svg-fill" d="M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z" id="vjs-id-1"></path>
        </svg>
      </div>
    </div>
  </div>
  `;
}
function getPlayBezel() {
	return `
  <div class="vjs-bezels-play">
    <div class="vjs-bezel" role="status" aria-label="Play">
      <div class="vjs-bezel-icon">
        <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%">
          <use class="vjs-svg-shadow" xlink:href="#vjs-id-2"></use>
          <path class="vjs-svg-fill" d="M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z" id="ytp-id-2"></path>
        </svg>
      </div>
    </div>
  </div>
  `;
}
var Component$14 = import_core.default.getComponent("Component");
var PauseBezel = class extends Component$14 {
	constructor(player, options) {
		super(player, options);
		if (isMobile()) return;
		this.firstPlayDone = false;
		this.paused = false;
		this.playerPauseHandler = () => {
			if (player.seeking()) return;
			this.paused = true;
			if (player.ended()) return;
			this.container.innerHTML = getPauseBezel();
			this.showBezel();
		};
		this.playerPlayHandler = () => {
			if (player.seeking() || !this.firstPlayDone || !this.paused) {
				this.firstPlayDone = true;
				return;
			}
			this.paused = false;
			this.firstPlayDone = true;
			this.container.innerHTML = getPlayBezel();
			this.showBezel();
		};
		this.videoChangeHandler = () => {
			this.firstPlayDone = false;
		};
		player.on("video-change", () => this.videoChangeHandler);
		player.on("pause", this.playerPauseHandler);
		player.on("play", this.playerPlayHandler);
	}
	dispose() {
		if (this.playerPauseHandler) this.player().off("pause", this.playerPauseHandler);
		if (this.playerPlayHandler) this.player().off("play", this.playerPlayHandler);
		if (this.videoChangeHandler) this.player().off("video-change", this.videoChangeHandler);
		super.dispose();
	}
	createEl() {
		this.container = super.createEl("div", { className: "vjs-bezels-content" });
		this.container.style.display = "none";
		return this.container;
	}
	showBezel() {
		this.container.style.display = "inherit";
		setTimeout(() => {
			this.container.style.display = "none";
		}, 500);
	}
};
import_core.default.registerComponent("PauseBezel", PauseBezel);
//#endregion
//#region src/shared/bezels/bezels-plugin.ts
var Plugin$17 = import_core.default.getPlugin("plugin");
var BezelsPlugin = class extends Plugin$17 {
	constructor(player, options) {
		super(player);
		this.player.ready(() => {
			player.addClass("vjs-bezels");
		});
		const component = new PauseBezel(player, options);
		player.addChild(component);
		this.on("dispose", () => player.removeChild(component));
	}
};
import_core.default.registerPlugin("bezels", BezelsPlugin);
//#endregion
//#region src/shared/context-menu/context-menu-item.ts
var MenuItem$3 = import_core.default.getComponent("MenuItem");
var ContextMenuItem = class extends MenuItem$3 {
	constructor(player, options) {
		super(player, options);
	}
	handleClick(e) {
		super.handleClick(e);
		this.options_.listener(e);
		setTimeout(() => {
			this.player().contextMenu().menu.dispose();
		}, 1);
	}
	createEl(type, props, attrs) {
		const el = super.createEl(type, props, attrs);
		const newEl = import_core.default.dom.createEl("span");
		newEl.innerHTML = `<span class="vjs-menu-item-text">${this.localize(this.options_.label)}</span>`;
		el.replaceChild(newEl, el.querySelector(".vjs-menu-item-text"));
		return el;
	}
};
//#endregion
//#region src/shared/context-menu/context-menu.ts
var Menu$3 = import_core.default.getComponent("Menu");
var ContextMenu = class extends Menu$3 {
	constructor(player, options) {
		super(player, {
			...options,
			menuButton: void 0
		});
		this.dispose = this.dispose.bind(this);
		for (const c of options.content()) this.addItem(new ContextMenuItem(player, {
			label: c.label,
			listener: c.listener.bind(player)
		}));
	}
	createEl() {
		const el = super.createEl();
		import_core.default.dom.addClass(el, "vjs-contextmenu-ui-menu");
		el.style.left = this.options_.position.left + "px";
		el.style.top = this.options_.position.top + "px";
		return el;
	}
};
//#endregion
//#region src/shared/context-menu/util.ts
function findElPosition(el) {
	let box;
	if (el.getBoundingClientRect && el.parentNode) box = el.getBoundingClientRect();
	if (!box) return {
		left: 0,
		top: 0
	};
	const docEl = document.documentElement;
	const body = document.body;
	const clientLeft = docEl.clientLeft || body.clientLeft || 0;
	const scrollLeft = window.pageXOffset || body.scrollLeft;
	const left = box.left + scrollLeft - clientLeft;
	const clientTop = docEl.clientTop || body.clientTop || 0;
	const scrollTop = window.pageYOffset || body.scrollTop;
	const top = box.top + scrollTop - clientTop;
	return {
		left: Math.round(left),
		top: Math.round(top)
	};
}
function getPointerPosition(el, event) {
	const position = {};
	const box = findElPosition(el);
	const boxW = el.offsetWidth;
	const boxH = el.offsetHeight;
	const boxY = box.top;
	const boxX = box.left;
	let pageY = event.pageY;
	let pageX = event.pageX;
	if (event.changedTouches) {
		pageX = event.changedTouches[0].pageX;
		pageY = event.changedTouches[0].pageY;
	}
	position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
	position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
	return position;
}
//#endregion
//#region src/shared/context-menu/context-menu-plugin.ts
var Plugin$16 = import_core.default.getPlugin("plugin");
var ContextMenuPlugin = class extends Plugin$16 {
	constructor(player, options) {
		super(player);
		this.options_ = options;
		if (this.menu) {
			this.menu.dispose();
			this.player.off("contextmenu", this.onContextMenuBind);
		}
		this.onContextMenuBind = this.onContextMenu.bind(this);
		this.player.on("contextmenu", this.onContextMenuBind);
		this.player.ready(() => this.player.addClass("vjs-contextmenu-ui"));
	}
	onContextMenu(e) {
		if (hasMenu(this.player)) {
			this.menu.dispose();
			return;
		}
		if (excludeElements(e.target)) return;
		const menuPosition = findMenuPosition(getPointerPosition(this.player.el(), e), this.player.el().getBoundingClientRect());
		const documentEl = import_core.default.browser.IS_FIREFOX ? document.documentElement : document;
		e.preventDefault();
		this.menu = new ContextMenu(this.player, {
			content: this.options_.content,
			position: menuPosition
		});
		this.menu.on("dispose", () => {
			for (const event of ["click", "tap"]) import_core.default.off(documentEl, event, this.menu.dispose);
			this.player.removeChild(this.menu);
			this.menu = void 0;
		});
		this.player.addChild(this.menu);
		const menuEl = this.menu.el();
		const menuSize = menuEl.getBoundingClientRect();
		const bodySize = document.body.getBoundingClientRect();
		if (menuSize.right > bodySize.width || menuSize.bottom > bodySize.height) {
			menuEl.style.left = Math.floor(Math.min(menuPosition.left, this.player.currentWidth() - this.menu.currentWidth())) + "px";
			menuEl.style.top = Math.floor(Math.min(menuPosition.top, this.player.currentHeight() - this.menu.currentHeight())) + "px";
		}
		for (const event of ["click", "tap"]) import_core.default.on(documentEl, event, this.menu.dispose);
	}
};
import_core.default.registerPlugin("contextMenu", ContextMenuPlugin);
function hasMenu(player) {
	if (!player.usingPlugin("contextMenu")) return false;
	return !!player.contextMenu().menu?.el();
}
function excludeElements(targetEl) {
	const tagName = targetEl.tagName.toLowerCase();
	return tagName === "input" || tagName === "textarea";
}
function findMenuPosition(pointerPosition, playerSize) {
	return {
		left: Math.round(playerSize.width * pointerPosition.x),
		top: Math.round(playerSize.height - playerSize.height * pointerPosition.y)
	};
}
//#endregion
//#region src/shared/control-bar/caption-toggle-button.ts
var Button$4 = import_core.default.getComponent("Button");
var CaptionToggleButton = class extends Button$4 {
	constructor(player, options) {
		super(player, options);
		player.on("texttrackchange", () => this.update());
	}
	buildCSSClass() {
		return `vjs-caption-toggle-control vjs-captions-button ${super.buildCSSClass()}`;
	}
	handleClick(event) {
		super.handleClick(event);
		const toEnable = this.getShowing() ? void 0 : this.getCaptionToEnable()?.id;
		for (const track of this.player_.textTracks().tracks_) if (toEnable && track.id === toEnable) track.mode = "showing";
		else track.mode = "disabled";
	}
	update() {
		if (this.getShowing()) {
			this.controlText("Disable subtitles");
			this.addClass("enabled");
			return;
		}
		this.controlText(this.player_.localize("Enable {1} subtitle", [this.getCaptionToEnable()?.label]));
		this.removeClass("enabled");
	}
	getShowing() {
		return this.listCaptions().find((t) => t.mode === "showing");
	}
	getCaptionToEnable() {
		const captionToEnable = getStoredPreferredSubtitle() || this.listCaptions()[0]?.id;
		const captions = this.listCaptions();
		return captions.find((t) => t.id === captionToEnable) || captions[0];
	}
	listCaptions() {
		return this.player_.textTracks().tracks_.filter((t) => t.kind === "captions");
	}
};
import_core.default.registerComponent("CaptionToggleButton", CaptionToggleButton);
//#endregion
//#region src/shared/control-bar/progress-bar-marker-component.ts
var ClickableComponent$2 = import_core.default.getComponent("ClickableComponent");
var ProgressBarMarkerComponent = class extends ClickableComponent$2 {
	constructor(player, options) {
		super(player, options);
		const updateMarker = () => {
			if (!this.hasValidDuration()) return;
			const el = this.el();
			el.style.setProperty("left", this.buildLeftStyle());
			el.style.setProperty("display", "inline");
		};
		this.player().on("durationchange", updateMarker);
		const stopPropagation = (event) => event.stopPropagation();
		this.on(["mousedown", "touchstart"], stopPropagation);
		this.one("dispose", () => {
			if (this.player()) this.player().off("durationchange", updateMarker);
			if (this.el()) this.off(["mousedown", "touchstart"], stopPropagation);
		});
	}
	createEl() {
		return import_core.default.dom.createEl("span", {
			className: "vjs-chapter-marker",
			style: this.hasValidDuration() ? `left: ${this.buildLeftStyle()}` : "display: none;"
		});
	}
	handleClick(event) {
		event.stopPropagation();
		if (this.player()) this.player().currentTime(this.options_.timecode);
	}
	buildLeftStyle() {
		return `${this.options_.timecode / this.player().duration() * 100}%`;
	}
	hasValidDuration() {
		const duration = this.player().duration();
		if (isNaN(duration) || !duration) return false;
		return true;
	}
};
import_core.default.registerComponent("ProgressBarMarkerComponent", ProgressBarMarkerComponent);
//#endregion
//#region src/shared/control-bar/chapters-plugin.ts
var Plugin$15 = import_core.default.getPlugin("plugin");
var ChaptersPlugin = class extends Plugin$15 {
	activeChapter;
	constructor(player, options) {
		super(player);
		this.markers = [];
		this.chapters = options.chapters;
		this.player.ready(() => {
			player.addClass("vjs-chapters");
			for (const chapter of this.chapters) {
				if (chapter.timecode === 0) continue;
				const marker = new ProgressBarMarkerComponent(player, { timecode: chapter.timecode });
				marker.on("mouseenter", () => {
					this.activeChapter = chapter;
				});
				marker.on("mouseleave", () => {
					this.activeChapter = void 0;
				});
				this.markers.push(marker);
				this.getSeekBar().addChild(marker);
			}
		});
	}
	dispose() {
		for (const marker of this.markers) this.getSeekBar().removeChild(marker);
		super.dispose();
	}
	getChapter(timecode) {
		if (this.activeChapter) {
			this.player.addClass("has-chapter");
			return {
				title: this.activeChapter.title,
				fixedTimecode: this.activeChapter.timecode
			};
		}
		if (this.chapters.length !== 0) for (let i = this.chapters.length - 1; i >= 0; i--) {
			const chapter = this.chapters[i];
			if (chapter.timecode <= timecode) {
				this.player.addClass("has-chapter");
				return { title: chapter.title };
			}
		}
		this.player.removeClass("has-chapter");
		return { title: "" };
	}
	getSeekBar() {
		return this.player.getDescendant("ControlBar", "ProgressControl", "SeekBar");
	}
};
import_core.default.registerPlugin("chapters", ChaptersPlugin);
//#endregion
//#region src/shared/control-bar/next-previous-video-button.ts
var Button$3 = import_core.default.getComponent("Button");
var NextPreviousVideoButton = class extends Button$3 {
	constructor(player, options) {
		super(player, options);
		this.player().on("video-change", () => {
			this.updateDisabled();
			this.updateShowing();
		});
		this.updateDisabled();
		this.updateShowing();
	}
	createEl() {
		const type = this.options_.type;
		const button = import_core.default.dom.createEl("button", { className: "vjs-" + type + "-video" });
		const nextIcon = import_core.default.dom.createEl("span", { className: "vjs-icon-placeholder vjs-icon-" + type });
		button.appendChild(nextIcon);
		if (type === "next") button.title = this.player_.localize("Next video");
		else button.title = this.player_.localize("Previous video");
		return button;
	}
	handleClick() {
		this.options_.handler();
	}
	updateDisabled() {
		if (this.options_.isDisabled()) this.addClass("vjs-disabled");
		else this.removeClass("vjs-disabled");
	}
	updateShowing() {
		if (this.options_.isDisplayed()) this.show();
		else this.hide();
	}
};
import_core.default.registerComponent("NextVideoButton", NextPreviousVideoButton);
import_core.default.registerComponent("PreviousVideoButton", NextPreviousVideoButton);
//#endregion
//#region src/shared/common/utils.ts
function toTitleCase(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}
var dictionaryBytes = [
	{
		max: 1024,
		type: "B",
		decimals: 0
	},
	{
		max: 1048576,
		type: "KB",
		decimals: 0
	},
	{
		max: 1073741824,
		type: "MB",
		decimals: 0
	},
	{
		max: 0xffffff9380,
		type: "GB",
		decimals: 1
	}
];
function bytes(value) {
	const format = dictionaryBytes.find((d) => value < d.max) || dictionaryBytes[dictionaryBytes.length - 1];
	return [(value / (format.max / 1024)).toFixed(format.decimals), format.type];
}
function getRtcConfig(stunServers) {
	return { iceServers: shuffle(stunServers.map((s) => ({ urls: s }))).slice(0, 2) };
}
//#endregion
//#region src/shared/control-bar/p2p-info-button.ts
var Button$2 = import_core.default.getComponent("Button");
var P2PInfoButton = class extends Button$2 {
	createEl() {
		const div = import_core.default.dom.createEl("div", { className: "vjs-peertube" });
		const subDivP2P = import_core.default.dom.createEl("div", { className: "vjs-peertube-hidden" });
		div.appendChild(subDivP2P);
		const downloadIcon = import_core.default.dom.createEl("span", { className: "icon icon-download" }, {
			role: "img",
			ariaLabel: this.player().localize("Download speed:")
		});
		subDivP2P.appendChild(downloadIcon);
		const downloadSpeedText = import_core.default.dom.createEl("span", { className: "download-speed-text" });
		const downloadSpeedNumber = import_core.default.dom.createEl("span", { className: "download-speed-number" });
		const downloadSpeedUnit = import_core.default.dom.createEl("span");
		downloadSpeedText.appendChild(downloadSpeedNumber);
		downloadSpeedText.appendChild(downloadSpeedUnit);
		subDivP2P.appendChild(downloadSpeedText);
		const uploadIcon = import_core.default.dom.createEl("span", { className: "icon icon-upload" }, {
			role: "img",
			ariaLabel: this.player().localize("Upload speed:")
		});
		subDivP2P.appendChild(uploadIcon);
		const uploadSpeedText = import_core.default.dom.createEl("span", { className: "upload-speed-text" });
		const uploadSpeedNumber = import_core.default.dom.createEl("span", { className: "upload-speed-number" });
		const uploadSpeedUnit = import_core.default.dom.createEl("span");
		uploadSpeedText.appendChild(uploadSpeedNumber);
		uploadSpeedText.appendChild(uploadSpeedUnit);
		subDivP2P.appendChild(uploadSpeedText);
		const peersText = import_core.default.dom.createEl("span", { className: "peers-text" });
		const peersNumber = import_core.default.dom.createEl("span", { className: "peers-number" });
		subDivP2P.appendChild(peersNumber);
		subDivP2P.appendChild(peersText);
		const subDivHttp = import_core.default.dom.createEl("div", { className: "vjs-peertube-hidden" });
		const subDivHttpText = import_core.default.dom.createEl("span", { className: "http-fallback" });
		subDivHttp.appendChild(subDivHttpText);
		div.appendChild(subDivHttp);
		this.player_.on("network-info", (_event, data) => {
			if (!data.p2p) return;
			subDivP2P.className = "vjs-peertube-displayed";
			subDivHttp.className = "vjs-peertube-hidden";
			const p2pStats = data.p2p;
			const httpStats = data.http;
			const downloadSpeed = bytes(p2pStats.downloadSpeed + httpStats.downloadSpeed);
			const uploadSpeed = bytes(p2pStats.uploadSpeed);
			const totalDownloaded = bytes(p2pStats.downloaded + httpStats.downloaded);
			const totalUploaded = bytes(p2pStats.uploaded);
			const numPeers = p2pStats.peersWithWebSeed;
			subDivP2P.title = this.player().localize("Total downloaded: ") + totalDownloaded.join(" ") + "\n";
			if (data.source === "p2p-media-loader") {
				const downloadedFromServer = bytes(httpStats.downloaded).join(" ");
				const downloadedFromPeers = bytes(p2pStats.downloaded).join(" ");
				subDivP2P.title += " * " + this.player().localize("From servers: ") + downloadedFromServer + "\n * " + this.player().localize("From peers: ") + downloadedFromPeers + "\n";
			}
			subDivP2P.title += this.player().localize("Total uploaded: ") + totalUploaded.join(" ");
			downloadSpeedNumber.textContent = downloadSpeed[0];
			downloadSpeedUnit.textContent = " " + downloadSpeed[1];
			uploadSpeedNumber.textContent = uploadSpeed[0];
			uploadSpeedUnit.textContent = " " + uploadSpeed[1];
			peersNumber.textContent = numPeers.toString();
			peersText.textContent = " " + (numPeers > 1 ? this.player().localize("peers") : this.player_.localize("peer"));
			subDivHttp.className = "vjs-peertube-hidden";
			subDivP2P.className = "vjs-peertube-displayed";
		});
		this.player_.on("network-info", (_event, data) => {
			if (data.p2p) return;
			if (data.source === "web-video") subDivHttpText.textContent = "HTTP";
			else if (data.source === "p2p-media-loader") subDivHttpText.textContent = "HLS";
			subDivHttp.className = "vjs-peertube-displayed";
			subDivP2P.className = "vjs-peertube-hidden";
			subDivHttp.title = this.player().localize("Total downloaded: ") + bytes(data.http.downloaded).join(" ");
		});
		this.player_.on("video-change", () => {
			subDivP2P.className = "vjs-peertube-hidden";
			subDivHttp.className = "vjs-peertube-hidden";
		});
		return div;
	}
};
import_core.default.registerComponent("P2PInfoButton", P2PInfoButton);
//#endregion
//#region src/shared/control-bar/peertube-link-button.ts
var Component$13 = import_core.default.getComponent("Component");
var PeerTubeLinkButton = class extends Component$13 {
	constructor(player, options) {
		super(player, options);
		this.updateShowing();
		this.player().on("video-change", () => this.updateShowing());
	}
	dispose() {
		if (!this.el()) return;
		this.el().removeEventListener("mouseenter", this.mouseEnterHandler);
		this.el().removeEventListener("click", this.clickHandler);
		super.dispose();
	}
	createEl() {
		const el = import_core.default.dom.createEl("a", {
			href: this.buildLink(),
			innerText: this.options_.instanceName,
			title: this.player().localize("Video page (new window)"),
			className: "vjs-peertube-link",
			target: "_blank"
		});
		this.mouseEnterHandler = () => this.updateHref();
		this.clickHandler = () => this.player().pause();
		el.addEventListener("mouseenter", this.mouseEnterHandler);
		el.addEventListener("click", this.clickHandler);
		return el;
	}
	updateShowing() {
		if (this.options_.isDisplayed()) this.show();
		else this.hide();
	}
	updateHref() {
		this.el().setAttribute("href", this.buildLink());
	}
	buildLink() {
		return decorateVideoLink({
			url: buildVideoLink({ shortUUID: this.options_.shortUUID() }),
			startTime: this.player().currentTime()
		});
	}
};
import_core.default.registerComponent("PeerTubeLinkButton", PeerTubeLinkButton);
//#endregion
//#region src/shared/control-bar/peertube-live-display.ts
var ClickableComponent$1 = import_core.default.getComponent("ClickableComponent");
var PeerTubeLiveDisplay = class extends ClickableComponent$1 {
	constructor(player, options) {
		super(player, options);
		this.interval = this.setInterval(() => this.updateClass(), 1e3);
		this.updateSync(true);
	}
	dispose() {
		if (this.interval) {
			this.clearInterval(this.interval);
			this.interval = void 0;
		}
		this.contentEl_ = null;
		super.dispose();
	}
	createEl() {
		const el = super.createEl("div", { className: "vjs-pt-live-control vjs-control" });
		this.contentEl_ = import_core.default.dom.createEl("div", { className: "vjs-live-display" }, { "aria-live": "off" });
		this.contentEl_.appendChild(import_core.default.dom.createEl("span", {
			className: "vjs-control-text",
			textContent: `${this.localize("Stream Type")}\u00a0`
		}));
		this.contentEl_.appendChild(document.createTextNode(this.localize("LIVE")));
		el.appendChild(this.contentEl_);
		return el;
	}
	handleClick() {
		const hlsjs = this.getHLSJS();
		if (!hlsjs) return;
		this.player().currentTime(hlsjs.liveSyncPosition);
		this.player().play();
		this.updateSync(true);
	}
	updateClass() {
		const hlsjs = this.getHLSJS();
		if (!hlsjs) return;
		if (this.player().currentTime() === 0) return;
		const isSync = Math.abs(this.player().currentTime() - hlsjs.liveSyncPosition) < 10;
		this.updateSync(isSync);
	}
	updateSync(isSync) {
		if (isSync) {
			this.addClass("synced-with-live-edge");
			this.removeAttribute("title");
			this.disable();
		} else {
			this.removeClass("synced-with-live-edge");
			this.setAttribute("title", this.localize("Go back to the live"));
			this.enable();
		}
	}
	getHLSJS() {
		if (!this.player()?.usingPlugin("p2pMediaLoader")) return;
		return this.player().p2pMediaLoader().getHLSJS();
	}
};
import_core.default.registerComponent("PeerTubeLiveDisplay", PeerTubeLiveDisplay);
//#endregion
//#region src/shared/control-bar/storyboard-plugin.ts
var Plugin$14 = import_core.default.getPlugin("plugin");
var StoryboardPlugin = class extends Plugin$14 {
	constructor(player, options) {
		super(player);
		this.url = options.url;
		this.height = options.height;
		this.width = options.width;
		this.interval = options.interval;
		this.sprites = {};
		this.boundedHijackMouseTooltip = this.hijackMouseTooltip.bind(this);
		this.init();
		this.player.ready(() => {
			player.addClass("vjs-storyboard");
		});
	}
	init() {
		const controls = this.player.controlBar;
		this.progress = controls?.progressControl;
		this.seekBar = this.progress?.seekBar;
		this.mouseTimeTooltip = this.seekBar?.mouseTimeDisplay?.timeTooltip;
		this.spritePlaceholder = import_core.default.dom.createEl("div", { className: "vjs-storyboard-sprite-placeholder" });
		this.seekBar?.el()?.appendChild(this.spritePlaceholder);
		this.onReadyOrLoadstartHandler = (event) => {
			if (event.type !== "ready") {
				const spriteOpts = this.player.currentSources().find((source) => {
					return Object.prototype.hasOwnProperty.call(source, "storyboard");
				})?.["storyboard"];
				if (spriteOpts) {
					this.url = spriteOpts.url;
					this.height = spriteOpts.height;
					this.width = spriteOpts.width;
					this.interval = spriteOpts.interval;
				}
			}
			this.cached = !!this.sprites[this.url];
			this.load();
		};
		this.player.on(["ready", "loadstart"], this.onReadyOrLoadstartHandler);
	}
	dispose() {
		if (this.onReadyOrLoadstartHandler) this.player.off(["ready", "loadstart"], this.onReadyOrLoadstartHandler);
		if (this.progress) this.progress.off(["mousemove", "touchmove"], this.boundedHijackMouseTooltip);
		this.seekBar?.el()?.removeChild(this.spritePlaceholder);
		super.dispose();
	}
	load() {
		const spriteEvents = ["mousemove", "touchmove"];
		if (this.isReady()) {
			if (!this.cached) this.sprites[this.url] = import_core.default.dom.createEl("img", { src: this.url });
			this.progress.on(spriteEvents, this.boundedHijackMouseTooltip);
		} else {
			this.progress.off(spriteEvents, this.boundedHijackMouseTooltip);
			this.resetMouseTooltip();
		}
	}
	hijackMouseTooltip(evt) {
		const sprite = this.sprites[this.url];
		const imgWidth = sprite.naturalWidth;
		const imgHeight = sprite.naturalHeight;
		const seekBarEl = this.seekBar.el();
		if (!sprite.complete || !imgWidth || !imgHeight) {
			this.resetMouseTooltip();
			return;
		}
		this.player.requestNamedAnimationFrame("StoryBoardPlugin#hijackMouseTooltip", () => {
			const seekBarRect = import_core.default.dom.getBoundingClientRect(seekBarEl);
			const playerRect = import_core.default.dom.getBoundingClientRect(this.player.el());
			if (!seekBarRect || !playerRect) return;
			const seekBarX = import_core.default.dom.getPointerPosition(seekBarEl, evt).x;
			let position = seekBarX * this.player.duration();
			const maxPosition = Math.round(imgHeight / this.height * (imgWidth / this.width)) - 1;
			position = Math.min(position / this.interval, maxPosition);
			const responsive = 600;
			const playerWidth = this.player.currentWidth();
			const scaleFactor = playerWidth < responsive ? playerWidth / responsive : 1;
			const columns = imgWidth / this.width;
			const scaledWidth = this.width * scaleFactor;
			const scaledHeight = this.height * scaleFactor;
			const cleft = Math.floor(position % columns) * -scaledWidth;
			const ctop = Math.floor(position / columns) * -scaledHeight;
			const bgSize = `${imgWidth * scaleFactor}px ${imgHeight * scaleFactor}px`;
			const timeTooltip = this.player.el().querySelector(".vjs-time-tooltip");
			const topOffset = -scaledHeight + parseInt(getComputedStyle(timeTooltip).top.replace("px", "")) - 20;
			const previewHalfSize = Math.round(scaledWidth / 2);
			let left = seekBarRect.width * seekBarX - previewHalfSize;
			const minLeft = playerRect.left - seekBarRect.left;
			const maxLeft = seekBarRect.width - scaledWidth + (playerRect.right - seekBarRect.right);
			if (left < minLeft) left = minLeft;
			if (left > maxLeft) left = maxLeft;
			const tooltipStyle = {
				"background-image": `url("${this.url}")`,
				"background-repeat": "no-repeat",
				"background-position": `${cleft}px ${ctop}px`,
				"background-size": bgSize,
				"color": "#fff",
				"text-shadow": "1px 1px #000",
				"position": "relative",
				"top": `${topOffset}px`,
				"border": "1px solid #000",
				"width": `${scaledWidth + 2}px`,
				"height": `${scaledHeight + 2}px`
			};
			tooltipStyle.left = `${left}px`;
			for (const [key, value] of Object.entries(tooltipStyle)) this.spritePlaceholder.style.setProperty(key, value);
		});
	}
	resetMouseTooltip() {
		if (this.spritePlaceholder) this.spritePlaceholder.style.cssText = "";
	}
	isReady() {
		return this.mouseTimeTooltip && this.width && this.height && this.url;
	}
};
import_core.default.registerPlugin("storyboard", StoryboardPlugin);
//#endregion
//#region src/shared/control-bar/theater-button.ts
var Button$1 = import_core.default.getComponent("Button");
var TheaterButton = class TheaterButton extends Button$1 {
	static THEATER_MODE_CLASS = "vjs-theater-enabled";
	constructor(player, options) {
		super(player, options);
		this.theaterButtonOptions = options;
		const enabled = getStoredTheater();
		if (enabled === true) {
			this.player().addClass(TheaterButton.THEATER_MODE_CLASS);
			this.handleTheaterChange();
		}
		this.controlText("Theater mode");
		this.player().theaterEnabled = enabled;
		this.updateShowing();
		this.player().on("video-change", () => this.updateShowing());
	}
	buildCSSClass() {
		return `vjs-theater-control ${super.buildCSSClass()}`;
	}
	handleTheaterChange() {
		const theaterEnabled = this.isTheaterEnabled();
		if (theaterEnabled) this.controlText("Normal mode");
		else this.controlText("Theater mode");
		saveTheaterInStore(theaterEnabled);
		this.player_.trigger("theater-change", theaterEnabled);
	}
	handleClick() {
		this.player_.toggleClass(TheaterButton.THEATER_MODE_CLASS);
		this.handleTheaterChange();
	}
	isTheaterEnabled() {
		return this.player_.hasClass(TheaterButton.THEATER_MODE_CLASS);
	}
	updateShowing() {
		if (this.theaterButtonOptions.isDisplayed()) this.show();
		else this.hide();
	}
};
import_core.default.registerComponent("TheaterButton", TheaterButton);
//#endregion
//#region src/shared/control-bar/time-tooltip.ts
var TimeToolTip = import_core.default.getComponent("TimeTooltip");
var TimeTooltip = class extends TimeToolTip {
	write(timecode) {
		const player = this.player();
		if (player.usingPlugin("chapters")) {
			if (timecode === this.currentTimecode) return;
			this.currentTimecode = timecode;
			const { title, fixedTimecode } = player.chapters().getChapter(timeToInt(this.currentTimecode));
			if (title) {
				const timecodeStr = fixedTimecode ? import_core.default.formatTime(fixedTimecode, this.player()?.duration()) : this.currentTimecode;
				return super.write(title + "\r\n" + timecodeStr);
			}
		}
		return super.write(timecode);
	}
};
import_core.default.registerComponent("TimeTooltip", TimeTooltip);
//#endregion
//#region src/shared/dock/peertube-dock-component.ts
var Component$12 = import_core.default.getComponent("Component");
var PeerTubeDockComponent = class extends Component$12 {
	constructor(player, options) {
		super(player, options);
	}
	createEl() {
		const el = super.createEl("div", { className: "peertube-dock" });
		if (this.options_.avatarUrl) {
			const avatar = import_core.default.dom.createEl("img", {
				className: "peertube-dock-avatar",
				src: this.options_.avatarUrl
			}, { alt: "" });
			el.appendChild(avatar);
		}
		const elWrapperTitleDescription = super.createEl("div", { className: "peertube-dock-title-description" });
		if (this.options_.title) {
			const title = import_core.default.dom.createEl("h2", {
				className: "peertube-dock-title",
				title: this.options_.title,
				innerText: this.options_.title
			});
			elWrapperTitleDescription.appendChild(title);
		}
		if (this.options_.description) {
			const description = import_core.default.dom.createEl("div", {
				className: "peertube-dock-description",
				title: this.options_.description,
				innerText: this.options_.description
			});
			elWrapperTitleDescription.appendChild(description);
		}
		if (this.options_.title || this.options_.description) el.appendChild(elWrapperTitleDescription);
		return el;
	}
};
import_core.default.registerComponent("PeerTubeDockComponent", PeerTubeDockComponent);
//#endregion
//#region src/shared/dock/peertube-dock-plugin.ts
var Plugin$13 = import_core.default.getPlugin("plugin");
var PeerTubeDockPlugin = class extends Plugin$13 {
	constructor(player, options) {
		super(player);
		player.ready(() => {
			player.addClass("peertube-dock");
		});
		this.dockComponent = new PeerTubeDockComponent(player, options);
		player.addChild(this.dockComponent);
	}
	dispose() {
		this.dockComponent?.dispose();
		this.player.removeChild(this.dockComponent);
		this.player.removeClass("peertube-dock");
		super.dispose();
	}
};
import_core.default.registerPlugin("peertubeDock", PeerTubeDockPlugin);
//#endregion
//#region src/shared/hotkeys/peertube-hotkeys-plugin.ts
var Plugin$12 = import_core.default.getPlugin("plugin");
var PeerTubeHotkeysPlugin = class PeerTubeHotkeysPlugin extends Plugin$12 {
	static VOLUME_STEP = .1;
	static SEEK_STEP = 5;
	constructor(player, options) {
		super(player);
		this.isLive = options.isLive;
		this.liveDvrEnabled = options.liveDvrEnabled === true;
		this.handlers = this.buildHandlers();
		this.handleKeyFunction = (event) => this.onKeyDown(event);
		document.addEventListener("keydown", this.handleKeyFunction);
	}
	dispose() {
		document.removeEventListener("keydown", this.handleKeyFunction);
		super.dispose();
	}
	onKeyDown(event) {
		if (!this.isValidKeyTarget(event.target)) return;
		for (const handler of this.handlers) if (handler.accept(event)) {
			handler.cb(event);
			return;
		}
	}
	buildHandlers() {
		const handlers = [
			{
				accept: (e) => e.key === " " || e.key === "MediaPlayPause" || this.isNaked(e, "k"),
				cb: (e) => {
					e.preventDefault();
					e.stopPropagation();
					if (this.player.paused()) this.player.play();
					else this.player.pause();
				}
			},
			{
				accept: (e) => this.isNaked(e, "ArrowUp"),
				cb: (e) => {
					e.preventDefault();
					this.player.volume(this.player.volume() + PeerTubeHotkeysPlugin.VOLUME_STEP);
				}
			},
			{
				accept: (e) => this.isNaked(e, "ArrowDown"),
				cb: (e) => {
					e.preventDefault();
					this.player.volume(this.player.volume() - PeerTubeHotkeysPlugin.VOLUME_STEP);
				}
			},
			{
				accept: (e) => this.isNaked(e, "f") || !e.altKey && e.ctrlKey && e.key === "Enter",
				cb: (e) => {
					e.preventDefault();
					if (this.player.isFullscreen()) this.player.exitFullscreen();
					else this.player.requestFullscreen();
				}
			},
			{
				accept: (e) => this.isNaked(e, "m"),
				cb: (e) => {
					e.preventDefault();
					this.player.muted(!this.player.muted());
				}
			},
			{
				accept: (e) => e.key === ">",
				cb: () => {
					if (this.isLive) return;
					const target = Math.min(this.player.playbackRate() + .1, 5);
					this.player.playbackRate(parseFloat(target.toFixed(2)));
				}
			},
			{
				accept: (e) => e.key === "<",
				cb: () => {
					if (this.isLive) return;
					const target = Math.max(this.player.playbackRate() - .1, .1);
					this.player.playbackRate(parseFloat(target.toFixed(2)));
				}
			},
			{
				accept: (e) => e.key === ",",
				cb: () => {
					if (this.isLive) return;
					this.player.pause();
					this.player.currentTime(this.player.currentTime() - 1 / 30);
				}
			},
			{
				accept: (e) => e.key === ".",
				cb: () => {
					if (this.isLive) return;
					this.player.pause();
					this.player.currentTime(this.player.currentTime() + 1 / 30);
				}
			},
			{
				accept: (e) => this.isNaked(e, "h"),
				cb: () => {
					if (this.player.usingPlugin("videoFlipHorizontallyPlugin")) this.player.videoFlipHorizontallyPlugin().toggleFlip();
				}
			}
		];
		if (this.isLive && this.liveDvrEnabled !== true) return handlers;
		return handlers.concat(this.buildVODHandlers());
	}
	buildVODHandlers() {
		const handlers = [{
			accept: (e) => this.isNaked(e, "ArrowLeft") || this.isNaked(e, "MediaRewind"),
			cb: (e) => {
				if (!this.canSeek()) return;
				e.preventDefault();
				const target = Math.max(0, this.player.currentTime() - PeerTubeHotkeysPlugin.SEEK_STEP);
				this.player.currentTime(target);
			}
		}, {
			accept: (e) => this.isNaked(e, "ArrowRight") || this.isNaked(e, "MediaForward"),
			cb: (e) => {
				if (!this.canSeek()) return;
				e.preventDefault();
				const target = Math.min(this.player.duration(), this.player.currentTime() + PeerTubeHotkeysPlugin.SEEK_STEP);
				this.player.currentTime(target);
			}
		}];
		for (let i = 0; i < 10; i++) handlers.push({
			accept: (e) => this.isNakedOrShift(e, i + ""),
			cb: (e) => {
				if (!this.canSeek()) return;
				e.preventDefault();
				this.player.currentTime(this.player.duration() * i * .1);
			}
		});
		return handlers;
	}
	isValidKeyTarget(eventEl) {
		const playerEl = this.player.el();
		const activeEl = document.activeElement;
		const currentElTagName = eventEl.tagName.toLowerCase();
		return activeEl === playerEl || activeEl === playerEl.querySelector(".vjs-tech") || activeEl === playerEl.querySelector(".vjs-control-bar") || eventEl.id === "content" || currentElTagName === "body" || currentElTagName === "video";
	}
	isNaked(event, key) {
		if (key.length === 1) key = key.toUpperCase();
		return !event.ctrlKey && !event.altKey && !event.metaKey && !event.shiftKey && this.getLatinKey(event.key, event.code) === key;
	}
	isNakedOrShift(event, key) {
		return !event.ctrlKey && !event.altKey && !event.metaKey && event.key === key;
	}
	getLatinKey(key, code) {
		if (key.length !== 1) return key;
		if (key.charCodeAt(0) >= 880) {
			if (code.startsWith("Key") && code.length === 4) return code.charAt(3);
			if (code.startsWith("Digit") && code.length === 6) return code.charAt(5);
		}
		return key.toUpperCase();
	}
	canSeek() {
		return this.isLive !== true || this.liveDvrEnabled === true;
	}
};
import_core.default.registerPlugin("peerTubeHotkeysPlugin", PeerTubeHotkeysPlugin);
//#endregion
//#region ../../../../node_modules/.pnpm/vite-plugin-node-polyfills@0.25.0_rollup@4.60.4_vite@8.0.10/node_modules/vite-plugin-node-polyfills/shims/process/dist/index.js
function getDefaultExportFromCjs$3(x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function defaultSetTimout$1() {
	throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout$1() {
	throw new Error("clearTimeout has not been defined");
}
function runTimeout$1(fun) {
	if (cachedSetTimeout$1 === setTimeout) return setTimeout(fun, 0);
	if ((cachedSetTimeout$1 === defaultSetTimout$1 || !cachedSetTimeout$1) && setTimeout) {
		cachedSetTimeout$1 = setTimeout;
		return setTimeout(fun, 0);
	}
	try {
		return cachedSetTimeout$1(fun, 0);
	} catch (e) {
		try {
			return cachedSetTimeout$1.call(null, fun, 0);
		} catch (e) {
			return cachedSetTimeout$1.call(this, fun, 0);
		}
	}
}
function runClearTimeout$1(marker) {
	if (cachedClearTimeout$1 === clearTimeout) return clearTimeout(marker);
	if ((cachedClearTimeout$1 === defaultClearTimeout$1 || !cachedClearTimeout$1) && clearTimeout) {
		cachedClearTimeout$1 = clearTimeout;
		return clearTimeout(marker);
	}
	try {
		return cachedClearTimeout$1(marker);
	} catch (e) {
		try {
			return cachedClearTimeout$1.call(null, marker);
		} catch (e) {
			return cachedClearTimeout$1.call(this, marker);
		}
	}
}
function cleanUpNextTick$1() {
	if (!draining$1 || !currentQueue$1) return;
	draining$1 = false;
	if (currentQueue$1.length) queue$1 = currentQueue$1.concat(queue$1);
	else queueIndex$1 = -1;
	if (queue$1.length) drainQueue$1();
}
function drainQueue$1() {
	if (draining$1) return;
	var timeout = runTimeout$1(cleanUpNextTick$1);
	draining$1 = true;
	var len = queue$1.length;
	while (len) {
		currentQueue$1 = queue$1;
		queue$1 = [];
		while (++queueIndex$1 < len) if (currentQueue$1) currentQueue$1[queueIndex$1].run();
		queueIndex$1 = -1;
		len = queue$1.length;
	}
	currentQueue$1 = null;
	draining$1 = false;
	runClearTimeout$1(timeout);
}
function Item$1(fun, array) {
	this.fun = fun;
	this.array = array;
}
function noop$3() {}
var browser$2, process$2, cachedSetTimeout$1, cachedClearTimeout$1, queue$1, draining$1, currentQueue$1, queueIndex$1, browserExports$2, process$1$3;
var init_dist = __esmMin((() => {
	browser$2 = { exports: {} };
	process$2 = browser$2.exports = {};
	(function() {
		try {
			if (typeof setTimeout === "function") cachedSetTimeout$1 = setTimeout;
			else cachedSetTimeout$1 = defaultSetTimout$1;
		} catch (e) {
			cachedSetTimeout$1 = defaultSetTimout$1;
		}
		try {
			if (typeof clearTimeout === "function") cachedClearTimeout$1 = clearTimeout;
			else cachedClearTimeout$1 = defaultClearTimeout$1;
		} catch (e) {
			cachedClearTimeout$1 = defaultClearTimeout$1;
		}
	})();
	queue$1 = [];
	draining$1 = false;
	queueIndex$1 = -1;
	process$2.nextTick = function(fun) {
		var args = new Array(arguments.length - 1);
		if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) args[i - 1] = arguments[i];
		queue$1.push(new Item$1(fun, args));
		if (queue$1.length === 1 && !draining$1) runTimeout$1(drainQueue$1);
	};
	Item$1.prototype.run = function() {
		this.fun.apply(null, this.array);
	};
	process$2.title = "browser";
	process$2.browser = true;
	process$2.env = {};
	process$2.argv = [];
	process$2.version = "";
	process$2.versions = {};
	process$2.on = noop$3;
	process$2.addListener = noop$3;
	process$2.once = noop$3;
	process$2.off = noop$3;
	process$2.removeListener = noop$3;
	process$2.removeAllListeners = noop$3;
	process$2.emit = noop$3;
	process$2.prependListener = noop$3;
	process$2.prependOnceListener = noop$3;
	process$2.listeners = function(name) {
		return [];
	};
	process$2.binding = function(name) {
		throw new Error("process.binding is not supported");
	};
	process$2.cwd = function() {
		return "/";
	};
	process$2.chdir = function(dir) {
		throw new Error("process.chdir is not supported");
	};
	process$2.umask = function() {
		return 0;
	};
	browserExports$2 = browser$2.exports;
	process$1$3 = /* @__PURE__ */ getDefaultExportFromCjs$3(browserExports$2);
}));
//#endregion
//#region ../../../../node_modules/.pnpm/ms@2.1.3/node_modules/ms/index.js
var require_ms = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* Helpers.
	*/
	var s = 1e3;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	/**
	* Parse or format the given `val`.
	*
	* Options:
	*
	*  - `long` verbose formatting [false]
	*
	* @param {String|Number} val
	* @param {Object} [options]
	* @throws {Error} throw an error if val is not a non-empty string or a number
	* @return {String|Number}
	* @api public
	*/
	module.exports = function(val, options) {
		options = options || {};
		var type = typeof val;
		if (type === "string" && val.length > 0) return parse(val);
		else if (type === "number" && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
		throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
	};
	/**
	* Parse the given `str` and return milliseconds.
	*
	* @param {String} str
	* @return {Number}
	* @api private
	*/
	function parse(str) {
		str = String(str);
		if (str.length > 100) return;
		var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
		if (!match) return;
		var n = parseFloat(match[1]);
		switch ((match[2] || "ms").toLowerCase()) {
			case "years":
			case "year":
			case "yrs":
			case "yr":
			case "y": return n * y;
			case "weeks":
			case "week":
			case "w": return n * w;
			case "days":
			case "day":
			case "d": return n * d;
			case "hours":
			case "hour":
			case "hrs":
			case "hr":
			case "h": return n * h;
			case "minutes":
			case "minute":
			case "mins":
			case "min":
			case "m": return n * m;
			case "seconds":
			case "second":
			case "secs":
			case "sec":
			case "s": return n * s;
			case "milliseconds":
			case "millisecond":
			case "msecs":
			case "msec":
			case "ms": return n;
			default: return;
		}
	}
	/**
	* Short format for `ms`.
	*
	* @param {Number} ms
	* @return {String}
	* @api private
	*/
	function fmtShort(ms) {
		var msAbs = Math.abs(ms);
		if (msAbs >= d) return Math.round(ms / d) + "d";
		if (msAbs >= h) return Math.round(ms / h) + "h";
		if (msAbs >= m) return Math.round(ms / m) + "m";
		if (msAbs >= s) return Math.round(ms / s) + "s";
		return ms + "ms";
	}
	/**
	* Long format for `ms`.
	*
	* @param {Number} ms
	* @return {String}
	* @api private
	*/
	function fmtLong(ms) {
		var msAbs = Math.abs(ms);
		if (msAbs >= d) return plural(ms, msAbs, d, "day");
		if (msAbs >= h) return plural(ms, msAbs, h, "hour");
		if (msAbs >= m) return plural(ms, msAbs, m, "minute");
		if (msAbs >= s) return plural(ms, msAbs, s, "second");
		return ms + " ms";
	}
	/**
	* Pluralization helper.
	*/
	function plural(ms, msAbs, n, name) {
		var isPlural = msAbs >= n * 1.5;
		return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
	}
}));
//#endregion
//#region ../../../../node_modules/.pnpm/debug@4.4.3_supports-color@8.1.1/node_modules/debug/src/common.js
var require_common = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/**
	* This is the common logic for both the Node.js and web browser
	* implementations of `debug()`.
	*/
	function setup(env) {
		createDebug.debug = createDebug;
		createDebug.default = createDebug;
		createDebug.coerce = coerce;
		createDebug.disable = disable;
		createDebug.enable = enable;
		createDebug.enabled = enabled;
		createDebug.humanize = require_ms();
		createDebug.destroy = destroy;
		Object.keys(env).forEach((key) => {
			createDebug[key] = env[key];
		});
		/**
		* The currently active debug mode names, and names to skip.
		*/
		createDebug.names = [];
		createDebug.skips = [];
		/**
		* Map of special "%n" handling functions, for the debug "format" argument.
		*
		* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
		*/
		createDebug.formatters = {};
		/**
		* Selects a color for a debug namespace
		* @param {String} namespace The namespace string for the debug instance to be colored
		* @return {Number|String} An ANSI color code for the given namespace
		* @api private
		*/
		function selectColor(namespace) {
			let hash = 0;
			for (let i = 0; i < namespace.length; i++) {
				hash = (hash << 5) - hash + namespace.charCodeAt(i);
				hash |= 0;
			}
			return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
		}
		createDebug.selectColor = selectColor;
		/**
		* Create a debugger with the given `namespace`.
		*
		* @param {String} namespace
		* @return {Function}
		* @api public
		*/
		function createDebug(namespace) {
			let prevTime;
			let enableOverride = null;
			let namespacesCache;
			let enabledCache;
			function debug(...args) {
				if (!debug.enabled) return;
				const self = debug;
				const curr = Number(/* @__PURE__ */ new Date());
				self.diff = curr - (prevTime || curr);
				self.prev = prevTime;
				self.curr = curr;
				prevTime = curr;
				args[0] = createDebug.coerce(args[0]);
				if (typeof args[0] !== "string") args.unshift("%O");
				let index = 0;
				args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
					if (match === "%%") return "%";
					index++;
					const formatter = createDebug.formatters[format];
					if (typeof formatter === "function") {
						const val = args[index];
						match = formatter.call(self, val);
						args.splice(index, 1);
						index--;
					}
					return match;
				});
				createDebug.formatArgs.call(self, args);
				(self.log || createDebug.log).apply(self, args);
			}
			debug.namespace = namespace;
			debug.useColors = createDebug.useColors();
			debug.color = createDebug.selectColor(namespace);
			debug.extend = extend;
			debug.destroy = createDebug.destroy;
			Object.defineProperty(debug, "enabled", {
				enumerable: true,
				configurable: false,
				get: () => {
					if (enableOverride !== null) return enableOverride;
					if (namespacesCache !== createDebug.namespaces) {
						namespacesCache = createDebug.namespaces;
						enabledCache = createDebug.enabled(namespace);
					}
					return enabledCache;
				},
				set: (v) => {
					enableOverride = v;
				}
			});
			if (typeof createDebug.init === "function") createDebug.init(debug);
			return debug;
		}
		function extend(namespace, delimiter) {
			const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
			newDebug.log = this.log;
			return newDebug;
		}
		/**
		* Enables a debug mode by namespaces. This can include modes
		* separated by a colon and wildcards.
		*
		* @param {String} namespaces
		* @api public
		*/
		function enable(namespaces) {
			createDebug.save(namespaces);
			createDebug.namespaces = namespaces;
			createDebug.names = [];
			createDebug.skips = [];
			const split = (typeof namespaces === "string" ? namespaces : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
			for (const ns of split) if (ns[0] === "-") createDebug.skips.push(ns.slice(1));
			else createDebug.names.push(ns);
		}
		/**
		* Checks if the given string matches a namespace template, honoring
		* asterisks as wildcards.
		*
		* @param {String} search
		* @param {String} template
		* @return {Boolean}
		*/
		function matchesTemplate(search, template) {
			let searchIndex = 0;
			let templateIndex = 0;
			let starIndex = -1;
			let matchIndex = 0;
			while (searchIndex < search.length) if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === "*")) if (template[templateIndex] === "*") {
				starIndex = templateIndex;
				matchIndex = searchIndex;
				templateIndex++;
			} else {
				searchIndex++;
				templateIndex++;
			}
			else if (starIndex !== -1) {
				templateIndex = starIndex + 1;
				matchIndex++;
				searchIndex = matchIndex;
			} else return false;
			while (templateIndex < template.length && template[templateIndex] === "*") templateIndex++;
			return templateIndex === template.length;
		}
		/**
		* Disable debug output.
		*
		* @return {String} namespaces
		* @api public
		*/
		function disable() {
			const namespaces = [...createDebug.names, ...createDebug.skips.map((namespace) => "-" + namespace)].join(",");
			createDebug.enable("");
			return namespaces;
		}
		/**
		* Returns true if the given mode name is enabled, false otherwise.
		*
		* @param {String} name
		* @return {Boolean}
		* @api public
		*/
		function enabled(name) {
			for (const skip of createDebug.skips) if (matchesTemplate(name, skip)) return false;
			for (const ns of createDebug.names) if (matchesTemplate(name, ns)) return true;
			return false;
		}
		/**
		* Coerce `val`.
		*
		* @param {Mixed} val
		* @return {Mixed}
		* @api private
		*/
		function coerce(val) {
			if (val instanceof Error) return val.stack || val.message;
			return val;
		}
		/**
		* XXX DO NOT USE. This is a temporary stub function.
		* XXX It WILL be removed in the next major release.
		*/
		function destroy() {
			console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
		}
		createDebug.enable(createDebug.load());
		return createDebug;
	}
	module.exports = setup;
}));
//#endregion
//#region src/shared/metrics/metrics-plugin.ts
var import_browser = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist();
	/**
	* This is the web browser implementation of `debug()`.
	*/
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = localstorage();
	exports.destroy = (() => {
		let warned = false;
		return () => {
			if (!warned) {
				warned = true;
				console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
			}
		};
	})();
	/**
	* Colors.
	*/
	exports.colors = [
		"#0000CC",
		"#0000FF",
		"#0033CC",
		"#0033FF",
		"#0066CC",
		"#0066FF",
		"#0099CC",
		"#0099FF",
		"#00CC00",
		"#00CC33",
		"#00CC66",
		"#00CC99",
		"#00CCCC",
		"#00CCFF",
		"#3300CC",
		"#3300FF",
		"#3333CC",
		"#3333FF",
		"#3366CC",
		"#3366FF",
		"#3399CC",
		"#3399FF",
		"#33CC00",
		"#33CC33",
		"#33CC66",
		"#33CC99",
		"#33CCCC",
		"#33CCFF",
		"#6600CC",
		"#6600FF",
		"#6633CC",
		"#6633FF",
		"#66CC00",
		"#66CC33",
		"#9900CC",
		"#9900FF",
		"#9933CC",
		"#9933FF",
		"#99CC00",
		"#99CC33",
		"#CC0000",
		"#CC0033",
		"#CC0066",
		"#CC0099",
		"#CC00CC",
		"#CC00FF",
		"#CC3300",
		"#CC3333",
		"#CC3366",
		"#CC3399",
		"#CC33CC",
		"#CC33FF",
		"#CC6600",
		"#CC6633",
		"#CC9900",
		"#CC9933",
		"#CCCC00",
		"#CCCC33",
		"#FF0000",
		"#FF0033",
		"#FF0066",
		"#FF0099",
		"#FF00CC",
		"#FF00FF",
		"#FF3300",
		"#FF3333",
		"#FF3366",
		"#FF3399",
		"#FF33CC",
		"#FF33FF",
		"#FF6600",
		"#FF6633",
		"#FF9900",
		"#FF9933",
		"#FFCC00",
		"#FFCC33"
	];
	/**
	* Currently only WebKit-based Web Inspectors, Firefox >= v31,
	* and the Firebug extension (any Firefox version) are known
	* to support "%c" CSS customizations.
	*
	* TODO: add a `localStorage` variable to explicitly enable/disable colors
	*/
	function useColors() {
		if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
		if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
		let m;
		return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	}
	/**
	* Colorize log arguments if enabled.
	*
	* @api public
	*/
	function formatArgs(args) {
		args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
		if (!this.useColors) return;
		const c = "color: " + this.color;
		args.splice(1, 0, c, "color: inherit");
		let index = 0;
		let lastC = 0;
		args[0].replace(/%[a-zA-Z%]/g, (match) => {
			if (match === "%%") return;
			index++;
			if (match === "%c") lastC = index;
		});
		args.splice(lastC, 0, c);
	}
	/**
	* Invokes `console.debug()` when available.
	* No-op when `console.debug` is not a "function".
	* If `console.debug` is not available, falls back
	* to `console.log`.
	*
	* @api public
	*/
	exports.log = console.debug || console.log || (() => {});
	/**
	* Save `namespaces`.
	*
	* @param {String} namespaces
	* @api private
	*/
	function save(namespaces) {
		try {
			if (namespaces) exports.storage.setItem("debug", namespaces);
			else exports.storage.removeItem("debug");
		} catch (error) {}
	}
	/**
	* Load `namespaces`.
	*
	* @return {String} returns the previously persisted debug modes
	* @api private
	*/
	function load() {
		let r;
		try {
			r = exports.storage.getItem("debug") || exports.storage.getItem("DEBUG");
		} catch (error) {}
		if (!r && typeof process$1$3 !== "undefined" && "env" in process$1$3) r = process$1$3.env.DEBUG;
		return r;
	}
	/**
	* Localstorage attempts to return the localstorage.
	*
	* This is necessary because safari throws
	* when a user disables cookies/localstorage
	* and you attempt to access it.
	*
	* @return {LocalStorage}
	* @api private
	*/
	function localstorage() {
		try {
			return localStorage;
		} catch (error) {}
	}
	module.exports = require_common()(exports);
	var { formatters } = module.exports;
	/**
	* Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	*/
	formatters.j = function(v) {
		try {
			return JSON.stringify(v);
		} catch (error) {
			return "[UnexpectedJSONParseError]: " + error.message;
		}
	};
})))(), 1);
var debugLogger$8 = (0, import_browser.default)("peertube:player:metrics");
var Plugin$11 = import_core.default.getPlugin("plugin");
var MetricsPlugin = class extends Plugin$11 {
	constructor(player, options) {
		super(player);
		this.options_ = options;
		this.downloadedBytesP2P = 0;
		this.downloadedBytesHTTP = 0;
		this.uploadedBytesP2P = 0;
		this.resolutionChanges = 0;
		this.errors = 0;
		this.bufferStalled = 0;
		this.p2pPeers = 0;
		this.trackBytes();
		this.trackResolutionChange();
		this.trackErrors();
		this.trackBufferStalled();
		this.one("play", () => {
			this.player.on("video-change", () => {
				this.runMetricsIntervalOnPlay();
			});
		});
		this.runMetricsIntervalOnPlay();
	}
	dispose() {
		if (this.metricsInterval) clearInterval(this.metricsInterval);
		super.dispose();
	}
	runMetricsIntervalOnPlay() {
		this.downloadedBytesP2P = 0;
		this.downloadedBytesHTTP = 0;
		this.uploadedBytesP2P = 0;
		this.resolutionChanges = 0;
		this.errors = 0;
		this.bufferStalled = 0;
		this.lastPlayerNetworkInfo = void 0;
		debugLogger$8("Will track metrics on next play");
		this.player.one("play", () => {
			debugLogger$8("Tracking metrics");
			this.runMetricsInterval();
		});
	}
	runMetricsInterval() {
		if (this.metricsInterval) clearInterval(this.metricsInterval);
		if (!this.options_.metricsUrl()) return;
		this.metricsInterval = setInterval(() => {
			const player = this.player;
			if (!player) return;
			let resolution;
			let fps;
			if (player.usingPlugin("p2pMediaLoader")) {
				const level = player.p2pMediaLoader().getCurrentLevel();
				if (!level) return;
				resolution = Math.min(level.height || 0, level.width || 0);
				const framerate = level?.attrs["FRAME-RATE"];
				fps = framerate ? parseInt(framerate, 10) : void 0;
			} else if (player.usingPlugin("webVideo")) {
				const videoFile = player.webVideo().getCurrentVideoFile();
				if (!videoFile) return;
				resolution = videoFile.resolution.id;
				fps = videoFile.fps && videoFile.fps !== -1 ? videoFile.fps : void 0;
			} else return;
			const body = {
				resolution,
				fps,
				playerMode: this.options_.mode(),
				resolutionChanges: this.resolutionChanges,
				errors: this.errors,
				bufferStalled: this.bufferStalled,
				downloadedBytesHTTP: this.downloadedBytesHTTP,
				downloadedBytesP2P: this.downloadedBytesP2P,
				uploadedBytesP2P: this.uploadedBytesP2P,
				p2pPeers: this.p2pPeers,
				p2pEnabled: this.p2pEnabled,
				videoId: this.options_.videoUUID()
			};
			this.resolutionChanges = 0;
			this.downloadedBytesP2P = 0;
			this.downloadedBytesHTTP = 0;
			this.uploadedBytesP2P = 0;
			this.errors = 0;
			this.bufferStalled = 0;
			const headers = new Headers({ "Content-type": "application/json; charset=UTF-8" });
			return fetch(this.options_.metricsUrl(), {
				method: "POST",
				body: JSON.stringify(body),
				headers
			}).catch((err) => logger$1.clientWarn("Cannot send metrics to the server.", err));
		}, this.options_.metricsInterval());
	}
	trackBytes() {
		this.player.on("network-info", (_event, data) => {
			this.downloadedBytesHTTP += Math.max(Math.round(data.http.downloaded - (this.lastPlayerNetworkInfo?.http.downloaded || 0)), 0);
			this.downloadedBytesP2P += Math.max(Math.round((data.p2p?.downloaded || 0) - (this.lastPlayerNetworkInfo?.p2p?.downloaded || 0)), 0);
			this.uploadedBytesP2P += Math.max(Math.round((data.p2p?.uploaded || 0) - (this.lastPlayerNetworkInfo?.p2p?.uploaded || 0)), 0);
			this.p2pPeers = data.p2p?.peersP2POnly;
			this.p2pEnabled = !!data.p2p;
			this.lastPlayerNetworkInfo = data;
		});
	}
	trackResolutionChange() {
		this.player.on("resolution-change", (_, { initResolutionChange }) => {
			if (initResolutionChange === true) return;
			debugLogger$8("Adding resolution change");
			this.resolutionChanges++;
		});
	}
	trackErrors() {
		this.player.on("error", () => {
			debugLogger$8("Adding player error");
			this.errors++;
		});
	}
	trackBufferStalled() {
		this.player.on("buffer-stalled", () => {
			debugLogger$8("Adding buffer stalled");
			this.bufferStalled++;
		});
	}
};
import_core.default.registerPlugin("metrics", MetricsPlugin);
//#endregion
//#region src/shared/mobile/peertube-mobile-buttons.ts
var Component$11 = import_core.default.getComponent("Component");
var PeerTubeMobileButtons = class extends Component$11 {
	createEl() {
		const container = super.createEl("div", { className: "vjs-mobile-buttons-overlay" });
		this.mainButton = super.createEl("div", { className: "main-button" });
		this.touchStartHandler = (e) => {
			e.stopPropagation();
			if (this.player_.paused() || this.player_.ended()) {
				this.player_.play();
				return;
			}
			this.player_.pause();
		};
		this.mainButton.addEventListener("touchstart", this.touchStartHandler, { passive: true });
		this.rewind = super.createEl("div", { className: "rewind-button vjs-hidden" });
		this.forward = super.createEl("div", { className: "forward-button vjs-hidden" });
		for (let i = 0; i < 3; i++) {
			this.rewind.appendChild(super.createEl("span", { className: "icon" }));
			this.forward.appendChild(super.createEl("span", { className: "icon" }));
		}
		this.rewindText = this.rewind.appendChild(super.createEl("div", { className: "text" }));
		this.forwardText = this.forward.appendChild(super.createEl("div", { className: "text" }));
		container.appendChild(this.rewind);
		container.appendChild(this.mainButton);
		container.appendChild(this.forward);
		return container;
	}
	dispose() {
		if (this.touchStartHandler) this.mainButton.removeEventListener("touchstart", this.touchStartHandler);
		super.dispose();
	}
	displayFastSeek(amount) {
		if (amount === 0) {
			this.hideRewind();
			this.hideForward();
			return;
		}
		if (amount > 0) {
			this.hideRewind();
			this.displayForward(amount);
			return;
		}
		if (amount < 0) {
			this.hideForward();
			this.displayRewind(amount);
			return;
		}
	}
	hideRewind() {
		this.rewind.classList.add("vjs-hidden");
		this.rewindText.textContent = "";
	}
	displayRewind(amount) {
		this.rewind.classList.remove("vjs-hidden");
		this.rewindText.textContent = this.player().localize("{1} seconds", [amount + ""]);
	}
	hideForward() {
		this.forward.classList.add("vjs-hidden");
		this.forwardText.textContent = "";
	}
	displayForward(amount) {
		this.forward.classList.remove("vjs-hidden");
		this.forwardText.textContent = this.player().localize("{1} seconds", [amount + ""]);
	}
};
import_core.default.registerComponent("PeerTubeMobileButtons", PeerTubeMobileButtons);
//#endregion
//#region src/shared/mobile/peertube-mobile-plugin.ts
var debugLogger$7 = (0, import_browser.default)("peertube:player:mobile");
var Plugin$10 = import_core.default.getPlugin("plugin");
var PeerTubeMobilePlugin = class PeerTubeMobilePlugin extends Plugin$10 {
	static DOUBLE_TAP_DELAY_MS = 250;
	static SET_CURRENT_TIME_DELAY = 750;
	constructor(player) {
		super(player);
		this.seekAmount = 0;
		if (import_core.default.browser.IS_ANDROID && screen.orientation) this.handleFullscreenRotation();
		if (!player.controls()) return;
		this.peerTubeMobileButtons = player.addChild("PeerTubeMobileButtons", { reportTouchActivity: false });
		if (!this.player.options_.userActions) this.player.options_.userActions = {};
		this.player.options_.userActions.click = false;
		this.player.options_.userActions.doubleClick = false;
		this.onPlayHandler = () => this.initTouchStartEvents();
		this.player.one("play", this.onPlayHandler);
		this.seekBar = this.player.getDescendant([
			"controlBar",
			"progressControl",
			"seekBar"
		]);
		this.sliderActiveHandler = () => this.player.addClass("vjs-mobile-sliding");
		this.sliderInactiveHandler = () => this.player.removeClass("vjs-mobile-sliding");
		this.seekBar.on("slideractive", this.sliderActiveHandler);
		this.seekBar.on("sliderinactive", this.sliderInactiveHandler);
	}
	dispose() {
		if (this.onPlayHandler) this.player.off("play", this.onPlayHandler);
		if (this.onFullScreenChangeHandler) this.player.off("fullscreenchange", this.onFullScreenChangeHandler);
		if (this.onTouchStartHandler) this.player.off("touchstart", this.onFullScreenChangeHandler);
		if (this.onMobileButtonTouchStartHandler) this.peerTubeMobileButtons?.el().removeEventListener("touchstart", this.onMobileButtonTouchStartHandler);
		super.dispose();
	}
	handleFullscreenRotation() {
		this.onFullScreenChangeHandler = () => {
			if (!this.player.isFullscreen() || this.isPortraitVideo()) return;
			screen.orientation.lock("landscape").catch((err) => logger$1.error("Cannot lock screen to landscape.", err));
		};
		this.player.on("fullscreenchange", this.onFullScreenChangeHandler);
	}
	isPortraitVideo() {
		return this.player.videoWidth() < this.player.videoHeight();
	}
	initTouchStartEvents() {
		const handleTouchStart = (event, onlyDetectDoubleTap = false) => {
			debugLogger$7("Handle touch start");
			if (this.tapTimeout) {
				clearTimeout(this.tapTimeout);
				this.tapTimeout = void 0;
			}
			if (this.doubleTapping || this.lastTapEvent && event.timeStamp - this.lastTapEvent.timeStamp < PeerTubeMobilePlugin.DOUBLE_TAP_DELAY_MS) {
				debugLogger$7("Detected double tap");
				this.lastTapEvent = event;
				this.onDoubleTap(event);
				return;
			}
			if (onlyDetectDoubleTap) return;
			this.newActiveState = !this.player.userActive();
			if (!this.player.paused() && this.newActiveState === true) this.player.addClass("vjs-force-inactive");
			this.tapTimeout = setTimeout(() => {
				debugLogger$7("No double tap detected, set user active state to " + this.newActiveState);
				this.player.removeClass("vjs-force-inactive");
				this.player.userActive(this.newActiveState);
			}, PeerTubeMobilePlugin.DOUBLE_TAP_DELAY_MS);
			this.lastTapEvent = event;
		};
		this.onTouchStartHandler = (event) => {
			handleTouchStart(event, this.player.userActive());
		};
		this.player.on("touchstart", this.onTouchStartHandler);
		this.onMobileButtonTouchStartHandler = (event) => {
			event.preventDefault();
			event.stopPropagation();
			handleTouchStart(event);
		};
		this.peerTubeMobileButtons.el().addEventListener("touchstart", this.onMobileButtonTouchStartHandler, { passive: false });
	}
	onDoubleTap(event) {
		const playerWidth = this.player.currentWidth();
		const rect = this.findPlayerTarget(event.target).getBoundingClientRect();
		const offsetX = event.targetTouches[0].pageX - rect.left;
		debugLogger$7("Calculating double tap zone (player width: %d, offset X: %d)", playerWidth, offsetX);
		if (offsetX > .66 * playerWidth) {
			if (this.seekAmount < 0) this.seekAmount = 0;
			this.seekAmount += 10;
			debugLogger$7("Will forward %d seconds", this.seekAmount);
		} else if (offsetX < .33 * playerWidth) {
			if (this.seekAmount > 0) this.seekAmount = 0;
			this.seekAmount -= 10;
			debugLogger$7("Will rewind %d seconds", this.seekAmount);
		}
		this.peerTubeMobileButtons.displayFastSeek(this.seekAmount);
		this.scheduleSetCurrentTime();
	}
	findPlayerTarget(target) {
		if (target.classList.contains("video-js")) return target;
		return this.findPlayerTarget(target.parentElement);
	}
	scheduleSetCurrentTime() {
		this.player.pause();
		this.player.addClass("vjs-fast-seeking");
		this.doubleTapping = true;
		if (this.setCurrentTimeTimeout) clearTimeout(this.setCurrentTimeTimeout);
		this.setCurrentTimeTimeout = setTimeout(() => {
			let newTime = this.player.currentTime() + this.seekAmount;
			this.seekAmount = 0;
			newTime = Math.max(0, newTime);
			newTime = Math.min(this.player.duration(), newTime);
			this.player.currentTime(newTime);
			this.seekAmount = 0;
			this.peerTubeMobileButtons.displayFastSeek(0);
			this.player.userActive(false);
			this.doubleTapping = false;
			this.player.play();
			setTimeout(() => {
				this.player.removeClass("vjs-fast-seeking");
				this.player.removeClass("vjs-force-inactive");
			}, 100);
		}, PeerTubeMobilePlugin.SET_CURRENT_TIME_DELAY);
	}
};
import_core.default.registerPlugin("peertubeMobile", PeerTubeMobilePlugin);
//#endregion
//#region src/shared/nsfw/peertube-nsfw-info-component.ts
var Component$10 = import_core.default.getComponent("Component");
var PeerTubeNSFWInfoComponent = class extends Component$10 {
	constructor(player, options) {
		super(player, options);
	}
	createEl() {
		const el = super.createEl("div", { className: "nsfw-info" });
		const content = super.createEl("strong");
		content.textContent = this.player().localize("This video contains sensitive content.");
		el.appendChild(content);
		if (this.options_.flags || this.options_.summary) {
			const moreButton = super.createEl("button", { textContent: this.player().localize("Learn more") }, { type: "button" });
			el.appendChild(moreButton);
			moreButton.addEventListener("click", () => {
				this.trigger("showDetails");
			});
		}
		return el;
	}
};
import_core.default.registerComponent("PeerTubeNSFWInfoComponent", PeerTubeNSFWInfoComponent);
//#endregion
//#region src/shared/nsfw/peertube-nsfw-details-component.ts
var Component$9 = import_core.default.getComponent("Component");
var PeerTubeNSFWDetailsComponent = class extends Component$9 {
	constructor(player, options) {
		super(player, options);
	}
	createEl() {
		const el = super.createEl("div", { className: "nsfw-details-container" });
		const nsfwDetails = super.createEl("div", { className: "nsfw-details" });
		el.appendChild(nsfwDetails);
		const closeButton = super.createEl("button", {
			className: "nsfw-details-close",
			title: this.player().localize("Close details"),
			type: "button"
		});
		closeButton.addEventListener("click", () => {
			this.trigger("hideDetails");
		});
		nsfwDetails.appendChild(closeButton);
		const content = super.createEl("div", { className: "nsfw-details-content" });
		nsfwDetails.appendChild(content);
		if (this.options_.flags) {
			const flags = super.createEl("div", { className: "nsfw-details-flags" });
			const label = super.createEl("strong", { textContent: this.player().localize("This video contains sensitive content, including:") });
			flags.appendChild(label);
			flags.appendChild(super.createEl("div", { textContent: this.buildFlagStrings().join(" - ") }));
			content.appendChild(flags);
		}
		if (this.options_.summary) {
			const summary = super.createEl("div", { className: "nsfw-details-summary" });
			const label = super.createEl("strong", { textContent: this.player().localize("Uploader note:") });
			summary.appendChild(label);
			summary.appendChild(super.createEl("div", { textContent: this.options_.summary }));
			content.appendChild(summary);
		}
		return el;
	}
	buildFlagStrings() {
		const flags = this.options_.flags;
		const flagStrings = [];
		if ((flags & NSFWFlag.VIOLENT) === NSFWFlag.VIOLENT) flagStrings.push(this.player().localize(`Potentially violent content`));
		if ((flags & NSFWFlag.EXPLICIT_SEX) === NSFWFlag.EXPLICIT_SEX) flagStrings.push(this.player().localize(`Potentially sexually explicit content`));
		return flagStrings;
	}
};
import_core.default.registerComponent("PeerTubeNSFWDetailsComponent", PeerTubeNSFWDetailsComponent);
//#endregion
//#region src/shared/nsfw/peertube-nsfw-plugin.ts
var Plugin$9 = import_core.default.getPlugin("plugin");
var PeerTubeNSFWPlugin = class extends Plugin$9 {
	constructor(player, options) {
		super(player);
		player.ready(() => {
			player.addClass("peertube-nsfw");
			this.nsfwInfoComponent = new PeerTubeNSFWInfoComponent(player, options);
			player.addChild(this.nsfwInfoComponent);
			this.nsfwDetailsComponent = new PeerTubeNSFWDetailsComponent(player, options);
			this.nsfwDetailsComponent.hide();
			player.addChild(this.nsfwDetailsComponent);
			this.nsfwInfoComponent.on("showDetails", () => {
				this.nsfwDetailsComponent.show();
				this.nsfwInfoComponent.hide();
			});
			this.nsfwDetailsComponent.on("hideDetails", () => {
				this.nsfwInfoComponent.show();
				this.nsfwDetailsComponent.hide();
			});
		});
		player.one("play", () => {
			this.nsfwInfoComponent.hide();
		});
	}
	dispose() {
		this.nsfwInfoComponent?.dispose();
		this.player.removeChild(this.nsfwInfoComponent);
		this.player.removeChild(this.nsfwDetailsComponent);
		this.player.removeClass("peertube-nsfw");
		super.dispose();
	}
};
import_core.default.registerPlugin("peertubeNSFW", PeerTubeNSFWPlugin);
//#endregion
//#region ../../../../node_modules/.pnpm/hls.js@1.6.16/node_modules/hls.js/dist/hls.mjs
var isFiniteNumber = Number.isFinite || function(value) {
	return typeof value === "number" && isFinite(value);
};
var isSafeInteger = Number.isSafeInteger || function(value) {
	return typeof value === "number" && Math.abs(value) <= MAX_SAFE_INTEGER;
};
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
var ErrorTypes = /* @__PURE__ */ function(ErrorTypes) {
	ErrorTypes["NETWORK_ERROR"] = "networkError";
	ErrorTypes["MEDIA_ERROR"] = "mediaError";
	ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
	ErrorTypes["MUX_ERROR"] = "muxError";
	ErrorTypes["OTHER_ERROR"] = "otherError";
	return ErrorTypes;
}({});
var ErrorDetails = /* @__PURE__ */ function(ErrorDetails) {
	ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
	ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
	ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
	ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
	ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
	ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
	ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
	ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
	ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
	ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
	ErrorDetails["KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR"] = "keySystemDestroyMediaKeysError";
	ErrorDetails["KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR"] = "keySystemDestroyCloseSessionError";
	ErrorDetails["KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR"] = "keySystemDestroyRemoveSessionError";
	ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
	ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
	ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
	ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
	ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
	ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
	ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
	ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
	ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
	ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
	ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
	ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
	ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
	ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
	ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
	ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
	ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
	ErrorDetails["FRAG_GAP"] = "fragGap";
	ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
	ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
	ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
	ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
	ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
	ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
	ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
	ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
	ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
	ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
	ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
	ErrorDetails["ASSET_LIST_LOAD_ERROR"] = "assetListLoadError";
	ErrorDetails["ASSET_LIST_LOAD_TIMEOUT"] = "assetListLoadTimeout";
	ErrorDetails["ASSET_LIST_PARSING_ERROR"] = "assetListParsingError";
	ErrorDetails["INTERSTITIAL_ASSET_ITEM_ERROR"] = "interstitialAssetItemError";
	ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
	ErrorDetails["INTERNAL_ABORTED"] = "aborted";
	ErrorDetails["ATTACH_MEDIA_ERROR"] = "attachMediaError";
	ErrorDetails["UNKNOWN"] = "unknown";
	return ErrorDetails;
}({});
var Events = /* @__PURE__ */ function(Events) {
	Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
	Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
	Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
	Events["MEDIA_DETACHED"] = "hlsMediaDetached";
	Events["MEDIA_ENDED"] = "hlsMediaEnded";
	Events["STALL_RESOLVED"] = "hlsStallResolved";
	Events["BUFFER_RESET"] = "hlsBufferReset";
	Events["BUFFER_CODECS"] = "hlsBufferCodecs";
	Events["BUFFER_CREATED"] = "hlsBufferCreated";
	Events["BUFFER_APPENDING"] = "hlsBufferAppending";
	Events["BUFFER_APPENDED"] = "hlsBufferAppended";
	Events["BUFFER_EOS"] = "hlsBufferEos";
	Events["BUFFERED_TO_END"] = "hlsBufferedToEnd";
	Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
	Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
	Events["MANIFEST_LOADING"] = "hlsManifestLoading";
	Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
	Events["MANIFEST_PARSED"] = "hlsManifestParsed";
	Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
	Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
	Events["LEVEL_LOADING"] = "hlsLevelLoading";
	Events["LEVEL_LOADED"] = "hlsLevelLoaded";
	Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
	Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
	Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
	Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
	Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
	Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
	Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
	Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
	Events["AUDIO_TRACK_UPDATED"] = "hlsAudioTrackUpdated";
	Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
	Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
	Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
	Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
	Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
	Events["SUBTITLE_TRACK_UPDATED"] = "hlsSubtitleTrackUpdated";
	Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
	Events["CUES_PARSED"] = "hlsCuesParsed";
	Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
	Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
	Events["FRAG_LOADING"] = "hlsFragLoading";
	Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
	Events["FRAG_LOADED"] = "hlsFragLoaded";
	Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
	Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
	Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
	Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
	Events["FRAG_PARSED"] = "hlsFragParsed";
	Events["FRAG_BUFFERED"] = "hlsFragBuffered";
	Events["FRAG_CHANGED"] = "hlsFragChanged";
	Events["FPS_DROP"] = "hlsFpsDrop";
	Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
	Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
	Events["ERROR"] = "hlsError";
	Events["DESTROYING"] = "hlsDestroying";
	Events["KEY_LOADING"] = "hlsKeyLoading";
	Events["KEY_LOADED"] = "hlsKeyLoaded";
	Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
	Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
	Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
	Events["ASSET_LIST_LOADING"] = "hlsAssetListLoading";
	Events["ASSET_LIST_LOADED"] = "hlsAssetListLoaded";
	Events["INTERSTITIALS_UPDATED"] = "hlsInterstitialsUpdated";
	Events["INTERSTITIALS_BUFFERED_TO_BOUNDARY"] = "hlsInterstitialsBufferedToBoundary";
	Events["INTERSTITIAL_ASSET_PLAYER_CREATED"] = "hlsInterstitialAssetPlayerCreated";
	Events["INTERSTITIAL_STARTED"] = "hlsInterstitialStarted";
	Events["INTERSTITIAL_ASSET_STARTED"] = "hlsInterstitialAssetStarted";
	Events["INTERSTITIAL_ASSET_ENDED"] = "hlsInterstitialAssetEnded";
	Events["INTERSTITIAL_ASSET_ERROR"] = "hlsInterstitialAssetError";
	Events["INTERSTITIAL_ENDED"] = "hlsInterstitialEnded";
	Events["INTERSTITIALS_PRIMARY_RESUMED"] = "hlsInterstitialsPrimaryResumed";
	Events["PLAYOUT_LIMIT_REACHED"] = "hlsPlayoutLimitReached";
	Events["EVENT_CUE_ENTER"] = "hlsEventCueEnter";
	return Events;
}({});
/**
* Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
*/
var PlaylistContextType = {
	MANIFEST: "manifest",
	LEVEL: "level",
	AUDIO_TRACK: "audioTrack",
	SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
	MAIN: "main",
	AUDIO: "audio",
	SUBTITLE: "subtitle"
};
var EWMA = class {
	constructor(halfLife, estimate = 0, weight = 0) {
		this.halfLife = void 0;
		this.alpha_ = void 0;
		this.estimate_ = void 0;
		this.totalWeight_ = void 0;
		this.halfLife = halfLife;
		this.alpha_ = halfLife ? Math.exp(Math.log(.5) / halfLife) : 0;
		this.estimate_ = estimate;
		this.totalWeight_ = weight;
	}
	sample(weight, value) {
		const adjAlpha = Math.pow(this.alpha_, weight);
		this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
		this.totalWeight_ += weight;
	}
	getTotalWeight() {
		return this.totalWeight_;
	}
	getEstimate() {
		if (this.alpha_) {
			const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
			if (zeroFactor) return this.estimate_ / zeroFactor;
		}
		return this.estimate_;
	}
};
var EwmaBandWidthEstimator = class {
	constructor(slow, fast, defaultEstimate, defaultTTFB = 100) {
		this.defaultEstimate_ = void 0;
		this.minWeight_ = void 0;
		this.minDelayMs_ = void 0;
		this.slow_ = void 0;
		this.fast_ = void 0;
		this.defaultTTFB_ = void 0;
		this.ttfb_ = void 0;
		this.defaultEstimate_ = defaultEstimate;
		this.minWeight_ = .001;
		this.minDelayMs_ = 50;
		this.slow_ = new EWMA(slow);
		this.fast_ = new EWMA(fast);
		this.defaultTTFB_ = defaultTTFB;
		this.ttfb_ = new EWMA(slow);
	}
	update(slow, fast) {
		const { slow_, fast_, ttfb_ } = this;
		if (slow_.halfLife !== slow) this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
		if (fast_.halfLife !== fast) this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
		if (ttfb_.halfLife !== slow) this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
	}
	sample(durationMs, numBytes) {
		durationMs = Math.max(durationMs, this.minDelayMs_);
		const numBits = 8 * numBytes;
		const durationS = durationMs / 1e3;
		const bandwidthInBps = numBits / durationS;
		this.fast_.sample(durationS, bandwidthInBps);
		this.slow_.sample(durationS, bandwidthInBps);
	}
	sampleTTFB(ttfb) {
		const seconds = ttfb / 1e3;
		const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
		this.ttfb_.sample(weight, Math.max(ttfb, 5));
	}
	canEstimate() {
		return this.fast_.getTotalWeight() >= this.minWeight_;
	}
	getEstimate() {
		if (this.canEstimate()) return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
		else return this.defaultEstimate_;
	}
	getEstimateTTFB() {
		if (this.ttfb_.getTotalWeight() >= this.minWeight_) return this.ttfb_.getEstimate();
		else return this.defaultTTFB_;
	}
	get defaultEstimate() {
		return this.defaultEstimate_;
	}
	destroy() {}
};
function _defineProperty(e, r, t) {
	return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: true,
		configurable: true,
		writable: true
	}) : e[r] = t, e;
}
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread2(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys(Object(t), true).forEach(function(r) {
			_defineProperty(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r);
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
var Logger = class {
	constructor(label, logger) {
		this.trace = void 0;
		this.debug = void 0;
		this.log = void 0;
		this.warn = void 0;
		this.info = void 0;
		this.error = void 0;
		const lb = `[${label}]:`;
		this.trace = noop$2;
		this.debug = logger.debug.bind(null, lb);
		this.log = logger.log.bind(null, lb);
		this.warn = logger.warn.bind(null, lb);
		this.info = logger.info.bind(null, lb);
		this.error = logger.error.bind(null, lb);
	}
};
var noop$2 = function noop() {};
var fakeLogger = {
	trace: noop$2,
	debug: noop$2,
	log: noop$2,
	warn: noop$2,
	info: noop$2,
	error: noop$2
};
function createLogger() {
	return _extends({}, fakeLogger);
}
function consolePrintFn(type, id) {
	const func = self.console[type];
	return func ? func.bind(self.console, `${id ? "[" + id + "] " : ""}[${type}] >`) : noop$2;
}
function getLoggerFn(key, debugConfig, id) {
	return debugConfig[key] ? debugConfig[key].bind(debugConfig) : consolePrintFn(key, id);
}
var exportedLogger = createLogger();
function enableLogs(debugConfig, context, id) {
	const newLogger = createLogger();
	if (typeof console === "object" && debugConfig === true || typeof debugConfig === "object") {
		const keys = [
			"debug",
			"log",
			"info",
			"warn",
			"error"
		];
		keys.forEach((key) => {
			newLogger[key] = getLoggerFn(key, debugConfig, id);
		});
		try {
			newLogger.log(`Debug logs enabled for "${context}" in hls.js version 1.6.16`);
		} catch (e) {
			return createLogger();
		}
		keys.forEach((key) => {
			exportedLogger[key] = getLoggerFn(key, debugConfig);
		});
	} else _extends(exportedLogger, newLogger);
	return newLogger;
}
var logger = exportedLogger;
function getMediaSource(preferManagedMediaSource = true) {
	if (typeof self === "undefined") return void 0;
	return (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function isManagedMediaSource(source) {
	return typeof self !== "undefined" && source === self.ManagedMediaSource;
}
function isCompatibleTrackChange(currentTracks, requiredTracks) {
	const trackNames = Object.keys(currentTracks);
	const requiredTrackNames = Object.keys(requiredTracks);
	const trackCount = trackNames.length;
	const requiredTrackCount = requiredTrackNames.length;
	return !trackCount || !requiredTrackCount || trackCount === requiredTrackCount && !trackNames.some((name) => requiredTrackNames.indexOf(name) === -1);
}
/**
* Converts a UTF-8 array to a string.
*
* @param array - The UTF-8 array to convert
*
* @returns The string
*
* @group Utils
*
* @beta
*/
function utf8ArrayToStr(array, exitOnNull = false) {
	if (typeof TextDecoder !== "undefined") {
		const decoded = new TextDecoder("utf-8").decode(array);
		if (exitOnNull) {
			const idx = decoded.indexOf("\0");
			return idx !== -1 ? decoded.substring(0, idx) : decoded;
		}
		return decoded.replace(/\0/g, "");
	}
	const len = array.length;
	let c;
	let char2;
	let char3;
	let out = "";
	let i = 0;
	while (i < len) {
		c = array[i++];
		if (c === 0 && exitOnNull) return out;
		else if (c === 0 || c === 3) continue;
		switch (c >> 4) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
				out += String.fromCharCode(c);
				break;
			case 12:
			case 13:
				char2 = array[i++];
				out += String.fromCharCode((c & 31) << 6 | char2 & 63);
				break;
			case 14:
				char2 = array[i++];
				char3 = array[i++];
				out += String.fromCharCode((c & 15) << 12 | (char2 & 63) << 6 | (char3 & 63) << 0);
				break;
		}
	}
	return out;
}
/**
*  hex dump helper class
*/
function arrayToHex(array) {
	let str = "";
	for (let i = 0; i < array.length; i++) {
		let h = array[i].toString(16);
		if (h.length < 2) h = "0" + h;
		str += h;
	}
	return str;
}
function hexToArrayBuffer(str) {
	return Uint8Array.from(str.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
function getDefaultExportFromCjs$2(x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var urlToolkit = { exports: {} };
var hasRequiredUrlToolkit;
function requireUrlToolkit() {
	if (hasRequiredUrlToolkit) return urlToolkit.exports;
	hasRequiredUrlToolkit = 1;
	(function(module, exports) {
		(function(root) {
			var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
			var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
			var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
			var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
			var URLToolkit = {
				buildAbsoluteURL: function(baseURL, relativeURL, opts) {
					opts = opts || {};
					baseURL = baseURL.trim();
					relativeURL = relativeURL.trim();
					if (!relativeURL) {
						if (!opts.alwaysNormalize) return baseURL;
						var basePartsForNormalise = URLToolkit.parseURL(baseURL);
						if (!basePartsForNormalise) throw new Error("Error trying to parse base URL.");
						basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
						return URLToolkit.buildURLFromParts(basePartsForNormalise);
					}
					var relativeParts = URLToolkit.parseURL(relativeURL);
					if (!relativeParts) throw new Error("Error trying to parse relative URL.");
					if (relativeParts.scheme) {
						if (!opts.alwaysNormalize) return relativeURL;
						relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
						return URLToolkit.buildURLFromParts(relativeParts);
					}
					var baseParts = URLToolkit.parseURL(baseURL);
					if (!baseParts) throw new Error("Error trying to parse base URL.");
					if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== "/") {
						var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
						baseParts.netLoc = pathParts[1];
						baseParts.path = pathParts[2];
					}
					if (baseParts.netLoc && !baseParts.path) baseParts.path = "/";
					var builtParts = {
						scheme: baseParts.scheme,
						netLoc: relativeParts.netLoc,
						path: null,
						params: relativeParts.params,
						query: relativeParts.query,
						fragment: relativeParts.fragment
					};
					if (!relativeParts.netLoc) {
						builtParts.netLoc = baseParts.netLoc;
						if (relativeParts.path[0] !== "/") if (!relativeParts.path) {
							builtParts.path = baseParts.path;
							if (!relativeParts.params) {
								builtParts.params = baseParts.params;
								if (!relativeParts.query) builtParts.query = baseParts.query;
							}
						} else {
							var baseURLPath = baseParts.path;
							var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf("/") + 1) + relativeParts.path;
							builtParts.path = URLToolkit.normalizePath(newPath);
						}
					}
					if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
					return URLToolkit.buildURLFromParts(builtParts);
				},
				parseURL: function(url) {
					var parts = URL_REGEX.exec(url);
					if (!parts) return null;
					return {
						scheme: parts[1] || "",
						netLoc: parts[2] || "",
						path: parts[3] || "",
						params: parts[4] || "",
						query: parts[5] || "",
						fragment: parts[6] || ""
					};
				},
				normalizePath: function(path) {
					path = path.split("").reverse().join("").replace(SLASH_DOT_REGEX, "");
					while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, "")).length);
					return path.split("").reverse().join("");
				},
				buildURLFromParts: function(parts) {
					return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
				}
			};
			module.exports = URLToolkit;
		})();
	})(urlToolkit);
	return urlToolkit.exports;
}
var urlToolkitExports = requireUrlToolkit();
var LoadStats = class {
	constructor() {
		this.aborted = false;
		this.loaded = 0;
		this.retry = 0;
		this.total = 0;
		this.chunkCount = 0;
		this.bwEstimate = 0;
		this.loading = {
			start: 0,
			first: 0,
			end: 0
		};
		this.parsing = {
			start: 0,
			end: 0
		};
		this.buffering = {
			start: 0,
			first: 0,
			end: 0
		};
	}
};
var ElementaryStreamTypes = {
	AUDIO: "audio",
	VIDEO: "video",
	AUDIOVIDEO: "audiovideo"
};
var BaseSegment = class {
	constructor(base) {
		this._byteRange = null;
		this._url = null;
		this._stats = null;
		this._streams = null;
		this.base = void 0;
		this.relurl = void 0;
		if (typeof base === "string") base = { url: base };
		this.base = base;
		makeEnumerable(this, "stats");
	}
	setByteRange(value, previous) {
		const params = value.split("@", 2);
		let start;
		if (params.length === 1) start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
		else start = parseInt(params[1]);
		this._byteRange = [start, parseInt(params[0]) + start];
	}
	get baseurl() {
		return this.base.url;
	}
	get byteRange() {
		if (this._byteRange === null) return [];
		return this._byteRange;
	}
	get byteRangeStartOffset() {
		return this.byteRange[0];
	}
	get byteRangeEndOffset() {
		return this.byteRange[1];
	}
	get elementaryStreams() {
		if (this._streams === null) this._streams = {
			[ElementaryStreamTypes.AUDIO]: null,
			[ElementaryStreamTypes.VIDEO]: null,
			[ElementaryStreamTypes.AUDIOVIDEO]: null
		};
		return this._streams;
	}
	set elementaryStreams(value) {
		this._streams = value;
	}
	get hasStats() {
		return this._stats !== null;
	}
	get hasStreams() {
		return this._streams !== null;
	}
	get stats() {
		if (this._stats === null) this._stats = new LoadStats();
		return this._stats;
	}
	set stats(value) {
		this._stats = value;
	}
	get url() {
		if (!this._url && this.baseurl && this.relurl) this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
		return this._url || "";
	}
	set url(value) {
		this._url = value;
	}
	clearElementaryStreamInfo() {
		const { elementaryStreams } = this;
		elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
		elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
		elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
	}
};
function isMediaFragment(frag) {
	return frag.sn !== "initSegment";
}
/**
* Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
*/
var Fragment = class extends BaseSegment {
	constructor(type, base) {
		super(base);
		this._decryptdata = null;
		this._programDateTime = null;
		this._ref = null;
		this._bitrate = void 0;
		this.rawProgramDateTime = null;
		this.tagList = [];
		this.duration = 0;
		this.sn = 0;
		this.levelkeys = void 0;
		this.type = void 0;
		this.loader = null;
		this.keyLoader = null;
		this.level = -1;
		this.cc = 0;
		this.startPTS = void 0;
		this.endPTS = void 0;
		this.startDTS = void 0;
		this.endDTS = void 0;
		this.start = 0;
		this.playlistOffset = 0;
		this.deltaPTS = void 0;
		this.maxStartPTS = void 0;
		this.minEndPTS = void 0;
		this.data = void 0;
		this.bitrateTest = false;
		this.title = null;
		this.initSegment = null;
		this.endList = void 0;
		this.gap = void 0;
		this.urlId = 0;
		this.type = type;
	}
	get byteLength() {
		if (this.hasStats) {
			const total = this.stats.total;
			if (total) return total;
		}
		if (this.byteRange.length) {
			const start = this.byteRange[0];
			const end = this.byteRange[1];
			if (isFiniteNumber(start) && isFiniteNumber(end)) return end - start;
		}
		return null;
	}
	get bitrate() {
		if (this.byteLength) return this.byteLength * 8 / this.duration;
		if (this._bitrate) return this._bitrate;
		return null;
	}
	set bitrate(value) {
		this._bitrate = value;
	}
	get decryptdata() {
		var _this$_decryptdata;
		const { levelkeys } = this;
		if (!levelkeys || levelkeys.NONE) return null;
		if (levelkeys.identity) {
			if (!this._decryptdata) this._decryptdata = levelkeys.identity.getDecryptData(this.sn);
		} else if (!((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.keyId)) {
			const keyFormats = Object.keys(levelkeys);
			if (keyFormats.length === 1) {
				const levelKey = this._decryptdata = levelkeys[keyFormats[0]] || null;
				if (levelKey) this._decryptdata = levelKey.getDecryptData(this.sn, levelkeys);
			}
		}
		return this._decryptdata;
	}
	get end() {
		return this.start + this.duration;
	}
	get endProgramDateTime() {
		if (this.programDateTime === null) return null;
		const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
		return this.programDateTime + duration * 1e3;
	}
	get encrypted() {
		var _this$_decryptdata2;
		if ((_this$_decryptdata2 = this._decryptdata) != null && _this$_decryptdata2.encrypted) return true;
		else if (this.levelkeys) {
			var _this$levelkeys$keyFo;
			const keyFormats = Object.keys(this.levelkeys);
			const len = keyFormats.length;
			if (len > 1 || len === 1 && (_this$levelkeys$keyFo = this.levelkeys[keyFormats[0]]) != null && _this$levelkeys$keyFo.encrypted) return true;
		}
		return false;
	}
	get programDateTime() {
		if (this._programDateTime === null && this.rawProgramDateTime) this.programDateTime = Date.parse(this.rawProgramDateTime);
		return this._programDateTime;
	}
	set programDateTime(value) {
		if (!isFiniteNumber(value)) {
			this._programDateTime = this.rawProgramDateTime = null;
			return;
		}
		this._programDateTime = value;
	}
	get ref() {
		if (!isMediaFragment(this)) return null;
		if (!this._ref) this._ref = {
			base: this.base,
			start: this.start,
			duration: this.duration,
			sn: this.sn,
			programDateTime: this.programDateTime
		};
		return this._ref;
	}
	addStart(value) {
		this.setStart(this.start + value);
	}
	setStart(value) {
		this.start = value;
		if (this._ref) this._ref.start = value;
	}
	setDuration(value) {
		this.duration = value;
		if (this._ref) this._ref.duration = value;
	}
	setKeyFormat(keyFormat) {
		const levelkeys = this.levelkeys;
		if (levelkeys) {
			var _this$_decryptdata3;
			const key = levelkeys[keyFormat];
			if (key && !((_this$_decryptdata3 = this._decryptdata) != null && _this$_decryptdata3.keyId)) this._decryptdata = key.getDecryptData(this.sn, levelkeys);
		}
	}
	abortRequests() {
		var _this$loader, _this$keyLoader;
		(_this$loader = this.loader) == null || _this$loader.abort();
		(_this$keyLoader = this.keyLoader) == null || _this$keyLoader.abort();
	}
	setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
		const { elementaryStreams } = this;
		const info = elementaryStreams[type];
		if (!info) {
			elementaryStreams[type] = {
				startPTS,
				endPTS,
				startDTS,
				endDTS,
				partial
			};
			return;
		}
		info.startPTS = Math.min(info.startPTS, startPTS);
		info.endPTS = Math.max(info.endPTS, endPTS);
		info.startDTS = Math.min(info.startDTS, startDTS);
		info.endDTS = Math.max(info.endDTS, endDTS);
	}
};
/**
* Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
*/
var Part = class extends BaseSegment {
	constructor(partAttrs, frag, base, index, previous) {
		super(base);
		this.fragOffset = 0;
		this.duration = 0;
		this.gap = false;
		this.independent = false;
		this.relurl = void 0;
		this.fragment = void 0;
		this.index = void 0;
		this.duration = partAttrs.decimalFloatingPoint("DURATION");
		this.gap = partAttrs.bool("GAP");
		this.independent = partAttrs.bool("INDEPENDENT");
		this.relurl = partAttrs.enumeratedString("URI");
		this.fragment = frag;
		this.index = index;
		const byteRange = partAttrs.enumeratedString("BYTERANGE");
		if (byteRange) this.setByteRange(byteRange, previous);
		if (previous) this.fragOffset = previous.fragOffset + previous.duration;
	}
	get start() {
		return this.fragment.start + this.fragOffset;
	}
	get end() {
		return this.start + this.duration;
	}
	get loaded() {
		const { elementaryStreams } = this;
		return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
	}
};
function getOwnPropertyDescriptorFromPrototypeChain(object, property) {
	const prototype = Object.getPrototypeOf(object);
	if (prototype) {
		const propertyDescriptor = Object.getOwnPropertyDescriptor(prototype, property);
		if (propertyDescriptor) return propertyDescriptor;
		return getOwnPropertyDescriptorFromPrototypeChain(prototype, property);
	}
}
function makeEnumerable(object, property) {
	const d = getOwnPropertyDescriptorFromPrototypeChain(object, property);
	if (d) {
		d.enumerable = true;
		Object.defineProperty(object, property, d);
	}
}
var UINT32_MAX$1 = Math.pow(2, 32) - 1;
var push = [].push;
var RemuxerTrackIdConfig = {
	video: 1,
	audio: 2,
	id3: 3,
	text: 4
};
function bin2str(data) {
	return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
	const val = buffer[offset] << 8 | buffer[offset + 1];
	return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
	const val = readSint32(buffer, offset);
	return val < 0 ? 4294967296 + val : val;
}
function readUint64(buffer, offset) {
	let result = readUint32(buffer, offset);
	result *= Math.pow(2, 32);
	result += readUint32(buffer, offset + 4);
	return result;
}
function readSint32(buffer, offset) {
	return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function hasMoofData(data) {
	const end = data.byteLength;
	for (let i = 0; i < end;) {
		const size = readUint32(data, i);
		if (size > 8 && data[i + 4] === 109 && data[i + 5] === 111 && data[i + 6] === 111 && data[i + 7] === 102) return true;
		i = size > 1 ? i + size : end;
	}
	return false;
}
function findBox(data, path) {
	const results = [];
	if (!path.length) return results;
	const end = data.byteLength;
	for (let i = 0; i < end;) {
		const size = readUint32(data, i);
		const type = bin2str(data.subarray(i + 4, i + 8));
		const endbox = size > 1 ? i + size : end;
		if (type === path[0]) if (path.length === 1) results.push(data.subarray(i + 8, endbox));
		else {
			const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
			if (subresults.length) push.apply(results, subresults);
		}
		i = endbox;
	}
	return results;
}
function parseSegmentIndex(sidx) {
	const references = [];
	const version = sidx[0];
	let index = 8;
	const timescale = readUint32(sidx, index);
	index += 4;
	let earliestPresentationTime = 0;
	let firstOffset = 0;
	if (version === 0) {
		earliestPresentationTime = readUint32(sidx, index);
		firstOffset = readUint32(sidx, index + 4);
		index += 8;
	} else {
		earliestPresentationTime = readUint64(sidx, index);
		firstOffset = readUint64(sidx, index + 8);
		index += 16;
	}
	index += 2;
	let startByte = sidx.length + firstOffset;
	const referencesCount = readUint16(sidx, index);
	index += 2;
	for (let i = 0; i < referencesCount; i++) {
		let referenceIndex = index;
		const referenceInfo = readUint32(sidx, referenceIndex);
		referenceIndex += 4;
		const referenceSize = referenceInfo & 2147483647;
		if ((referenceInfo & 2147483648) >>> 31 === 1) {
			logger.warn("SIDX has hierarchical references (not supported)");
			return null;
		}
		const subsegmentDuration = readUint32(sidx, referenceIndex);
		referenceIndex += 4;
		references.push({
			referenceSize,
			subsegmentDuration,
			info: {
				duration: subsegmentDuration / timescale,
				start: startByte,
				end: startByte + referenceSize - 1
			}
		});
		startByte += referenceSize;
		referenceIndex += 4;
		index = referenceIndex;
	}
	return {
		earliestPresentationTime,
		timescale,
		version,
		referencesCount,
		references
	};
}
/**
* Parses an MP4 initialization segment and extracts stream type and
* timescale values for any declared tracks. Timescale values indicate the
* number of clock ticks per second to assume for time-based values
* elsewhere in the MP4.
*
* To determine the start time of an MP4, you need two pieces of
* information: the timescale unit and the earliest base media decode
* time. Multiple timescales can be specified within an MP4 but the
* base media decode time is always expressed in the timescale from
* the media header box for the track:
* ```
* moov > trak > mdia > mdhd.timescale
* moov > trak > mdia > hdlr
* ```
* @param initSegment the bytes of the init segment
* @returns a hash of track type to timescale values or null if
* the init segment is malformed.
*/
function parseInitSegment(initSegment) {
	const result = [];
	const traks = findBox(initSegment, ["moov", "trak"]);
	for (let i = 0; i < traks.length; i++) {
		const trak = traks[i];
		const tkhd = findBox(trak, ["tkhd"])[0];
		if (tkhd) {
			let version = tkhd[0];
			const trackId = readUint32(tkhd, version === 0 ? 12 : 20);
			const mdhd = findBox(trak, ["mdia", "mdhd"])[0];
			if (mdhd) {
				version = mdhd[0];
				const timescale = readUint32(mdhd, version === 0 ? 12 : 20);
				const hdlr = findBox(trak, ["mdia", "hdlr"])[0];
				if (hdlr) {
					const hdlrType = bin2str(hdlr.subarray(8, 12));
					const type = {
						soun: ElementaryStreamTypes.AUDIO,
						vide: ElementaryStreamTypes.VIDEO
					}[hdlrType];
					const stsdBox = findBox(trak, [
						"mdia",
						"minf",
						"stbl",
						"stsd"
					])[0];
					const stsd = parseStsd(stsdBox);
					if (type) {
						result[trackId] = {
							timescale,
							type,
							stsd
						};
						result[type] = _objectSpread2({
							timescale,
							id: trackId
						}, stsd);
					} else result[trackId] = {
						timescale,
						type: hdlrType,
						stsd
					};
				}
			}
		}
	}
	findBox(initSegment, [
		"moov",
		"mvex",
		"trex"
	]).forEach((trex) => {
		const track = result[readUint32(trex, 4)];
		if (track) track.default = {
			duration: readUint32(trex, 12),
			flags: readUint32(trex, 20)
		};
	});
	return result;
}
function parseStsd(stsd) {
	const sampleEntries = stsd.subarray(8);
	const sampleEntriesEnd = sampleEntries.subarray(86);
	const fourCC = bin2str(sampleEntries.subarray(4, 8));
	let codec = fourCC;
	let supplemental;
	const encrypted = fourCC === "enca" || fourCC === "encv";
	if (encrypted) findBox(findBox(sampleEntries, [fourCC])[0].subarray(fourCC === "enca" ? 28 : 78), ["sinf"]).forEach((sinf) => {
		const schm = findBox(sinf, ["schm"])[0];
		if (schm) {
			const scheme = bin2str(schm.subarray(4, 8));
			if (scheme === "cbcs" || scheme === "cenc") {
				const frma = findBox(sinf, ["frma"])[0];
				if (frma) codec = bin2str(frma);
			}
		}
	});
	const codecFourCC = codec;
	switch (codec) {
		case "avc1":
		case "avc2":
		case "avc3":
		case "avc4": {
			const avcCBox = findBox(sampleEntriesEnd, ["avcC"])[0];
			if (avcCBox && avcCBox.length > 3) {
				codec += "." + toHex(avcCBox[1]) + toHex(avcCBox[2]) + toHex(avcCBox[3]);
				supplemental = parseSupplementalDoViCodec(codecFourCC === "avc1" ? "dva1" : "dvav", sampleEntriesEnd);
			}
			break;
		}
		case "mp4a": {
			const codecBox = findBox(sampleEntries, [fourCC])[0];
			const esdsBox = findBox(codecBox.subarray(28), ["esds"])[0];
			if (esdsBox && esdsBox.length > 7) {
				let i = 4;
				if (esdsBox[i++] !== 3) break;
				i = skipBERInteger(esdsBox, i);
				i += 2;
				const flags = esdsBox[i++];
				if (flags & 128) i += 2;
				if (flags & 64) i += esdsBox[i++];
				if (esdsBox[i++] !== 4) break;
				i = skipBERInteger(esdsBox, i);
				const objectType = esdsBox[i++];
				if (objectType === 64) codec += "." + toHex(objectType);
				else break;
				i += 12;
				if (esdsBox[i++] !== 5) break;
				i = skipBERInteger(esdsBox, i);
				const firstByte = esdsBox[i++];
				let audioObjectType = (firstByte & 248) >> 3;
				if (audioObjectType === 31) audioObjectType += 1 + ((firstByte & 7) << 3) + ((esdsBox[i] & 224) >> 5);
				codec += "." + audioObjectType;
			}
			break;
		}
		case "hvc1":
		case "hev1": {
			const hvcCBox = findBox(sampleEntriesEnd, ["hvcC"])[0];
			if (hvcCBox && hvcCBox.length > 12) {
				const profileByte = hvcCBox[1];
				const profileSpace = [
					"",
					"A",
					"B",
					"C"
				][profileByte >> 6];
				const generalProfileIdc = profileByte & 31;
				const profileCompat = readUint32(hvcCBox, 2);
				const tierFlag = (profileByte & 32) >> 5 ? "H" : "L";
				const levelIDC = hvcCBox[12];
				const constraintIndicator = hvcCBox.subarray(6, 12);
				codec += "." + profileSpace + generalProfileIdc;
				codec += "." + reverse32BitInt(profileCompat).toString(16).toUpperCase();
				codec += "." + tierFlag + levelIDC;
				let constraintString = "";
				for (let i = constraintIndicator.length; i--;) {
					const byte = constraintIndicator[i];
					if (byte || constraintString) constraintString = "." + byte.toString(16).toUpperCase() + constraintString;
				}
				codec += constraintString;
			}
			supplemental = parseSupplementalDoViCodec(codecFourCC == "hev1" ? "dvhe" : "dvh1", sampleEntriesEnd);
			break;
		}
		case "dvh1":
		case "dvhe":
		case "dvav":
		case "dva1":
		case "dav1":
			codec = parseSupplementalDoViCodec(codec, sampleEntriesEnd) || codec;
			break;
		case "vp09": {
			const vpcCBox = findBox(sampleEntriesEnd, ["vpcC"])[0];
			if (vpcCBox && vpcCBox.length > 6) {
				const profile = vpcCBox[4];
				const level = vpcCBox[5];
				const bitDepth = vpcCBox[6] >> 4 & 15;
				codec += "." + addLeadingZero(profile) + "." + addLeadingZero(level) + "." + addLeadingZero(bitDepth);
			}
			break;
		}
		case "av01": {
			const av1CBox = findBox(sampleEntriesEnd, ["av1C"])[0];
			if (av1CBox && av1CBox.length > 2) {
				const profile = av1CBox[1] >>> 5;
				const level = av1CBox[1] & 31;
				const tierFlag = av1CBox[2] >>> 7 ? "H" : "M";
				const highBitDepth = (av1CBox[2] & 64) >> 6;
				const twelveBit = (av1CBox[2] & 32) >> 5;
				const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
				const monochrome = (av1CBox[2] & 16) >> 4;
				const chromaSubsamplingX = (av1CBox[2] & 8) >> 3;
				const chromaSubsamplingY = (av1CBox[2] & 4) >> 2;
				const chromaSamplePosition = av1CBox[2] & 3;
				codec += "." + profile + "." + addLeadingZero(level) + tierFlag + "." + addLeadingZero(bitDepth) + "." + monochrome + "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + "." + addLeadingZero(1) + "." + addLeadingZero(1) + "." + addLeadingZero(1) + ".0";
				supplemental = parseSupplementalDoViCodec("dav1", sampleEntriesEnd);
			}
			break;
		}
	}
	return {
		codec,
		encrypted,
		supplemental
	};
}
function parseSupplementalDoViCodec(fourCC, sampleEntriesEnd) {
	const dvvCResult = findBox(sampleEntriesEnd, ["dvvC"]);
	const dvXCBox = dvvCResult.length ? dvvCResult[0] : findBox(sampleEntriesEnd, ["dvcC"])[0];
	if (dvXCBox) {
		const doViProfile = dvXCBox[2] >> 1 & 127;
		const doViLevel = dvXCBox[2] << 5 & 32 | dvXCBox[3] >> 3 & 31;
		return fourCC + "." + addLeadingZero(doViProfile) + "." + addLeadingZero(doViLevel);
	}
}
function reverse32BitInt(val) {
	let result = 0;
	for (let i = 0; i < 32; i++) result |= (val >> i & 1) << 31 - i;
	return result >>> 0;
}
function skipBERInteger(bytes, i) {
	const limit = i + 5;
	while (bytes[i++] & 128 && i < limit);
	return i;
}
function toHex(x) {
	return ("0" + x.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(num) {
	return (num < 10 ? "0" : "") + num;
}
function patchEncyptionData(initSegment, decryptdata) {
	if (!initSegment || !decryptdata) return;
	const keyId = decryptdata.keyId;
	if (keyId && decryptdata.isCommonEncryption) applyToTencBoxes(initSegment, (tenc, isAudio) => {
		const tencKeyId = tenc.subarray(8, 24);
		if (!tencKeyId.some((b) => b !== 0)) {
			logger.log(`[eme] Patching keyId in 'enc${isAudio ? "a" : "v"}>sinf>>tenc' box: ${arrayToHex(tencKeyId)} -> ${arrayToHex(keyId)}`);
			tenc.set(keyId, 8);
		}
	});
}
function parseKeyIdsFromTenc(initSegment) {
	const keyIds = [];
	applyToTencBoxes(initSegment, (tenc) => keyIds.push(tenc.subarray(8, 24)));
	return keyIds;
}
function applyToTencBoxes(initSegment, predicate) {
	findBox(initSegment, ["moov", "trak"]).forEach((trak) => {
		const stsd = findBox(trak, [
			"mdia",
			"minf",
			"stbl",
			"stsd"
		])[0];
		if (!stsd) return;
		const sampleEntries = stsd.subarray(8);
		let encBoxes = findBox(sampleEntries, ["enca"]);
		const isAudio = encBoxes.length > 0;
		if (!isAudio) encBoxes = findBox(sampleEntries, ["encv"]);
		encBoxes.forEach((enc) => {
			findBox(isAudio ? enc.subarray(28) : enc.subarray(78), ["sinf"]).forEach((sinf) => {
				const tenc = parseSinf(sinf);
				if (tenc) predicate(tenc, isAudio);
			});
		});
	});
}
function parseSinf(sinf) {
	const schm = findBox(sinf, ["schm"])[0];
	if (schm) {
		const scheme = bin2str(schm.subarray(4, 8));
		if (scheme === "cbcs" || scheme === "cenc") {
			const tenc = findBox(sinf, ["schi", "tenc"])[0];
			if (tenc) return tenc;
		}
	}
}
function getSampleData(data, initData, logger) {
	const tracks = {};
	const trafs = findBox(data, ["moof", "traf"]);
	for (let i = 0; i < trafs.length; i++) {
		const traf = trafs[i];
		const tfhd = findBox(traf, ["tfhd"])[0];
		const id = readUint32(tfhd, 4);
		const track = initData[id];
		if (!track) continue;
		tracks[id] || (tracks[id] = {
			start: NaN,
			duration: 0,
			sampleCount: 0,
			timescale: track.timescale,
			type: track.type
		});
		const trackTimes = tracks[id];
		const tfdt = findBox(traf, ["tfdt"])[0];
		if (tfdt) {
			const version = tfdt[0];
			let baseTime = readUint32(tfdt, 4);
			if (version === 1) if (baseTime === UINT32_MAX$1) logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
			else {
				baseTime *= UINT32_MAX$1 + 1;
				baseTime += readUint32(tfdt, 8);
			}
			if (isFiniteNumber(baseTime) && (!isFiniteNumber(trackTimes.start) || baseTime < trackTimes.start)) trackTimes.start = baseTime;
		}
		const trackDefault = track.default;
		const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
		let defaultSampleDuration = (trackDefault == null ? void 0 : trackDefault.duration) || 0;
		if (tfhdFlags & 8) if (tfhdFlags & 2) defaultSampleDuration = readUint32(tfhd, 12);
		else defaultSampleDuration = readUint32(tfhd, 8);
		const truns = findBox(traf, ["trun"]);
		let sampleDTS = trackTimes.start || 0;
		let rawDuration = 0;
		let sampleDuration = defaultSampleDuration;
		for (let j = 0; j < truns.length; j++) {
			const trun = truns[j];
			const sampleCount = readUint32(trun, 4);
			const sampleIndex = trackTimes.sampleCount;
			trackTimes.sampleCount += sampleCount;
			const dataOffsetPresent = trun[3] & 1;
			const firstSampleFlagsPresent = trun[3] & 4;
			const sampleDurationPresent = trun[2] & 1;
			const sampleSizePresent = trun[2] & 2;
			const sampleFlagsPresent = trun[2] & 4;
			const sampleCompositionTimeOffsetPresent = trun[2] & 8;
			let offset = 8;
			let remaining = sampleCount;
			if (dataOffsetPresent) offset += 4;
			if (firstSampleFlagsPresent && sampleCount) {
				if (!(trun[offset + 1] & 1) && trackTimes.keyFrameIndex === void 0) trackTimes.keyFrameIndex = sampleIndex;
				offset += 4;
				if (sampleDurationPresent) {
					sampleDuration = readUint32(trun, offset);
					offset += 4;
				} else sampleDuration = defaultSampleDuration;
				if (sampleSizePresent) offset += 4;
				if (sampleCompositionTimeOffsetPresent) offset += 4;
				sampleDTS += sampleDuration;
				rawDuration += sampleDuration;
				remaining--;
			}
			while (remaining--) {
				if (sampleDurationPresent) {
					sampleDuration = readUint32(trun, offset);
					offset += 4;
				} else sampleDuration = defaultSampleDuration;
				if (sampleSizePresent) offset += 4;
				if (sampleFlagsPresent) {
					if (!(trun[offset + 1] & 1)) {
						if (trackTimes.keyFrameIndex === void 0) {
							trackTimes.keyFrameIndex = trackTimes.sampleCount - (remaining + 1);
							trackTimes.keyFrameStart = sampleDTS;
						}
					}
					offset += 4;
				}
				if (sampleCompositionTimeOffsetPresent) offset += 4;
				sampleDTS += sampleDuration;
				rawDuration += sampleDuration;
			}
			if (!rawDuration && defaultSampleDuration) rawDuration += defaultSampleDuration * sampleCount;
		}
		trackTimes.duration += rawDuration;
	}
	if (!Object.keys(tracks).some((trackId) => tracks[trackId].duration)) {
		let sidxMinStart = Infinity;
		let sidxMaxEnd = 0;
		const sidxs = findBox(data, ["sidx"]);
		for (let i = 0; i < sidxs.length; i++) {
			const sidx = parseSegmentIndex(sidxs[i]);
			if (sidx != null && sidx.references) {
				sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
				const subSegmentDuration = sidx.references.reduce((dur, ref) => dur + ref.info.duration || 0, 0);
				sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
			}
		}
		if (sidxMaxEnd && isFiniteNumber(sidxMaxEnd)) Object.keys(tracks).forEach((trackId) => {
			if (!tracks[trackId].duration) tracks[trackId].duration = sidxMaxEnd * tracks[trackId].timescale - tracks[trackId].start;
		});
	}
	return tracks;
}
function segmentValidRange(data) {
	const segmentedRange = {
		valid: null,
		remainder: null
	};
	const moofs = findBox(data, ["moof"]);
	if (moofs.length < 2) {
		segmentedRange.remainder = data;
		return segmentedRange;
	}
	const last = moofs[moofs.length - 1];
	segmentedRange.valid = data.slice(0, last.byteOffset - 8);
	segmentedRange.remainder = data.slice(last.byteOffset - 8);
	return segmentedRange;
}
function appendUint8Array(data1, data2) {
	const temp = new Uint8Array(data1.length + data2.length);
	temp.set(data1);
	temp.set(data2, data1.length);
	return temp;
}
function parseSamples(timeOffset, track) {
	const seiSamples = [];
	const videoData = track.samples;
	const timescale = track.timescale;
	const trackId = track.id;
	let isHEVCFlavor = false;
	findBox(videoData, ["moof"]).map((moof) => {
		const moofOffset = moof.byteOffset - 8;
		findBox(moof, ["traf"]).map((traf) => {
			const baseTime = findBox(traf, ["tfdt"]).map((tfdt) => {
				const version = tfdt[0];
				let result = readUint32(tfdt, 4);
				if (version === 1) {
					result *= Math.pow(2, 32);
					result += readUint32(tfdt, 8);
				}
				return result / timescale;
			})[0];
			if (baseTime !== void 0) timeOffset = baseTime;
			return findBox(traf, ["tfhd"]).map((tfhd) => {
				const id = readUint32(tfhd, 4);
				const tfhdFlags = readUint32(tfhd, 0) & 16777215;
				const baseDataOffsetPresent = (tfhdFlags & 1) !== 0;
				const sampleDescriptionIndexPresent = (tfhdFlags & 2) !== 0;
				const defaultSampleDurationPresent = (tfhdFlags & 8) !== 0;
				let defaultSampleDuration = 0;
				const defaultSampleSizePresent = (tfhdFlags & 16) !== 0;
				let defaultSampleSize = 0;
				const defaultSampleFlagsPresent = (tfhdFlags & 32) !== 0;
				let tfhdOffset = 8;
				if (id === trackId) {
					if (baseDataOffsetPresent) tfhdOffset += 8;
					if (sampleDescriptionIndexPresent) tfhdOffset += 4;
					if (defaultSampleDurationPresent) {
						defaultSampleDuration = readUint32(tfhd, tfhdOffset);
						tfhdOffset += 4;
					}
					if (defaultSampleSizePresent) {
						defaultSampleSize = readUint32(tfhd, tfhdOffset);
						tfhdOffset += 4;
					}
					if (defaultSampleFlagsPresent) tfhdOffset += 4;
					if (track.type === "video") isHEVCFlavor = isHEVC(track.codec);
					findBox(traf, ["trun"]).map((trun) => {
						const version = trun[0];
						const flags = readUint32(trun, 0) & 16777215;
						const dataOffsetPresent = (flags & 1) !== 0;
						let dataOffset = 0;
						const firstSampleFlagsPresent = (flags & 4) !== 0;
						const sampleDurationPresent = (flags & 256) !== 0;
						let sampleDuration = 0;
						const sampleSizePresent = (flags & 512) !== 0;
						let sampleSize = 0;
						const sampleFlagsPresent = (flags & 1024) !== 0;
						const sampleCompositionOffsetsPresent = (flags & 2048) !== 0;
						let compositionOffset = 0;
						const sampleCount = readUint32(trun, 4);
						let trunOffset = 8;
						if (dataOffsetPresent) {
							dataOffset = readUint32(trun, trunOffset);
							trunOffset += 4;
						}
						if (firstSampleFlagsPresent) trunOffset += 4;
						let sampleOffset = dataOffset + moofOffset;
						for (let ix = 0; ix < sampleCount; ix++) {
							if (sampleDurationPresent) {
								sampleDuration = readUint32(trun, trunOffset);
								trunOffset += 4;
							} else sampleDuration = defaultSampleDuration;
							if (sampleSizePresent) {
								sampleSize = readUint32(trun, trunOffset);
								trunOffset += 4;
							} else sampleSize = defaultSampleSize;
							if (sampleFlagsPresent) trunOffset += 4;
							if (sampleCompositionOffsetsPresent) {
								if (version === 0) compositionOffset = readUint32(trun, trunOffset);
								else compositionOffset = readSint32(trun, trunOffset);
								trunOffset += 4;
							}
							if (track.type === ElementaryStreamTypes.VIDEO) {
								let naluTotalSize = 0;
								while (naluTotalSize < sampleSize) {
									const naluSize = readUint32(videoData, sampleOffset);
									sampleOffset += 4;
									if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) parseSEIMessageFromNALu(videoData.subarray(sampleOffset, sampleOffset + naluSize), isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
									sampleOffset += naluSize;
									naluTotalSize += naluSize + 4;
								}
							}
							timeOffset += sampleDuration / timescale;
						}
					});
				}
			});
		});
	});
	return seiSamples;
}
function isHEVC(codec) {
	if (!codec) return false;
	const baseCodec = codec.substring(0, 4);
	return baseCodec === "hvc1" || baseCodec === "hev1" || baseCodec === "dvh1" || baseCodec === "dvhe";
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
	if (isHEVCFlavor) {
		const naluType = naluHeader >> 1 & 63;
		return naluType === 39 || naluType === 40;
	} else return (naluHeader & 31) === 6;
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
	const data = discardEPB(unescapedData);
	let seiPtr = 0;
	seiPtr += headerSize;
	let payloadType = 0;
	let payloadSize = 0;
	let b = 0;
	while (seiPtr < data.length) {
		payloadType = 0;
		do {
			if (seiPtr >= data.length) break;
			b = data[seiPtr++];
			payloadType += b;
		} while (b === 255);
		payloadSize = 0;
		do {
			if (seiPtr >= data.length) break;
			b = data[seiPtr++];
			payloadSize += b;
		} while (b === 255);
		const leftOver = data.length - seiPtr;
		let payPtr = seiPtr;
		if (payloadSize < leftOver) seiPtr += payloadSize;
		else if (payloadSize > leftOver) {
			logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
			break;
		}
		if (payloadType === 4) {
			if (data[payPtr++] === 181) {
				const providerCode = readUint16(data, payPtr);
				payPtr += 2;
				if (providerCode === 49) {
					const userStructure = readUint32(data, payPtr);
					payPtr += 4;
					if (userStructure === 1195456820) {
						const userDataType = data[payPtr++];
						if (userDataType === 3) {
							const firstByte = data[payPtr++];
							const totalCCs = 31 & firstByte;
							const enabled = 64 & firstByte;
							const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
							const byteArray = new Uint8Array(totalBytes);
							if (enabled) {
								byteArray[0] = firstByte;
								for (let i = 1; i < totalBytes; i++) byteArray[i] = data[payPtr++];
							}
							samples.push({
								type: userDataType,
								payloadType,
								pts,
								bytes: byteArray
							});
						}
					}
				}
			}
		} else if (payloadType === 5) {
			if (payloadSize > 16) {
				const uuidStrArray = [];
				for (let i = 0; i < 16; i++) {
					const _b = data[payPtr++].toString(16);
					uuidStrArray.push(_b.length == 1 ? "0" + _b : _b);
					if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push("-");
				}
				const length = payloadSize - 16;
				const userDataBytes = new Uint8Array(length);
				for (let i = 0; i < length; i++) userDataBytes[i] = data[payPtr++];
				samples.push({
					payloadType,
					pts,
					uuid: uuidStrArray.join(""),
					userData: utf8ArrayToStr(userDataBytes),
					userDataBytes
				});
			}
		}
	}
}
/**
* remove Emulation Prevention bytes from a RBSP
*/
function discardEPB(data) {
	const length = data.byteLength;
	const EPBPositions = [];
	let i = 1;
	while (i < length - 2) if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 3) {
		EPBPositions.push(i + 2);
		i += 2;
	} else i++;
	if (EPBPositions.length === 0) return data;
	const newLength = length - EPBPositions.length;
	const newData = new Uint8Array(newLength);
	let sourceIndex = 0;
	for (i = 0; i < newLength; sourceIndex++, i++) {
		if (sourceIndex === EPBPositions[0]) {
			sourceIndex++;
			EPBPositions.shift();
		}
		newData[i] = data[sourceIndex];
	}
	return newData;
}
function parseEmsg(data) {
	const version = data[0];
	let schemeIdUri = "";
	let value = "";
	let timeScale = 0;
	let presentationTimeDelta = 0;
	let presentationTime = 0;
	let eventDuration = 0;
	let id = 0;
	let offset = 0;
	if (version === 0) {
		while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
			schemeIdUri += bin2str(data.subarray(offset, offset + 1));
			offset += 1;
		}
		schemeIdUri += bin2str(data.subarray(offset, offset + 1));
		offset += 1;
		while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
			value += bin2str(data.subarray(offset, offset + 1));
			offset += 1;
		}
		value += bin2str(data.subarray(offset, offset + 1));
		offset += 1;
		timeScale = readUint32(data, 12);
		presentationTimeDelta = readUint32(data, 16);
		eventDuration = readUint32(data, 20);
		id = readUint32(data, 24);
		offset = 28;
	} else if (version === 1) {
		offset += 4;
		timeScale = readUint32(data, offset);
		offset += 4;
		const leftPresentationTime = readUint32(data, offset);
		offset += 4;
		const rightPresentationTime = readUint32(data, offset);
		offset += 4;
		presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
		if (!isSafeInteger(presentationTime)) {
			presentationTime = Number.MAX_SAFE_INTEGER;
			logger.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box");
		}
		eventDuration = readUint32(data, offset);
		offset += 4;
		id = readUint32(data, offset);
		offset += 4;
		while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
			schemeIdUri += bin2str(data.subarray(offset, offset + 1));
			offset += 1;
		}
		schemeIdUri += bin2str(data.subarray(offset, offset + 1));
		offset += 1;
		while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
			value += bin2str(data.subarray(offset, offset + 1));
			offset += 1;
		}
		value += bin2str(data.subarray(offset, offset + 1));
		offset += 1;
	}
	const payload = data.subarray(offset, data.byteLength);
	return {
		schemeIdUri,
		value,
		timeScale,
		presentationTime,
		presentationTimeDelta,
		eventDuration,
		id,
		payload
	};
}
function mp4Box(type, ...payload) {
	const len = payload.length;
	let size = 8;
	let i = len;
	while (i--) size += payload[i].byteLength;
	const result = new Uint8Array(size);
	result[0] = size >> 24 & 255;
	result[1] = size >> 16 & 255;
	result[2] = size >> 8 & 255;
	result[3] = size & 255;
	result.set(type, 4);
	for (i = 0, size = 8; i < len; i++) {
		result.set(payload[i], size);
		size += payload[i].byteLength;
	}
	return result;
}
function mp4pssh(systemId, keyids, data) {
	if (systemId.byteLength !== 16) throw new RangeError("Invalid system id");
	let version;
	let kids;
	version = 0;
	kids = new Uint8Array();
	let kidCount;
	if (version > 0) {
		kidCount = new Uint8Array(4);
		if (keyids.length > 0) new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
	} else kidCount = new Uint8Array();
	const dataSize = new Uint8Array(4);
	if (data.byteLength > 0) new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
	return mp4Box([
		112,
		115,
		115,
		104
	], new Uint8Array([
		version,
		0,
		0,
		0
	]), systemId, kidCount, kids, dataSize, data);
}
function parseMultiPssh(initData) {
	const results = [];
	if (initData instanceof ArrayBuffer) {
		const length = initData.byteLength;
		let offset = 0;
		while (offset + 32 < length) {
			const pssh = parsePssh(new DataView(initData, offset));
			results.push(pssh);
			offset += pssh.size;
		}
	}
	return results;
}
function parsePssh(view) {
	const size = view.getUint32(0);
	const offset = view.byteOffset;
	const length = view.byteLength;
	if (length < size) return {
		offset,
		size: length
	};
	if (view.getUint32(4) !== 1886614376) return {
		offset,
		size
	};
	const version = view.getUint32(8) >>> 24;
	if (version !== 0 && version !== 1) return {
		offset,
		size
	};
	const buffer = view.buffer;
	const systemId = arrayToHex(new Uint8Array(buffer, offset + 12, 16));
	let kids = null;
	let data = null;
	let dataSizeOffset = 0;
	if (version === 0) dataSizeOffset = 28;
	else {
		const kidCounts = view.getUint32(28);
		if (!kidCounts || length < 32 + kidCounts * 16) return {
			offset,
			size
		};
		kids = [];
		for (let i = 0; i < kidCounts; i++) kids.push(new Uint8Array(buffer, offset + 32 + i * 16, 16));
		dataSizeOffset = 32 + kidCounts * 16;
	}
	if (!dataSizeOffset) return {
		offset,
		size
	};
	const dataSizeOrKidCount = view.getUint32(dataSizeOffset);
	if (size - 32 < dataSizeOrKidCount) return {
		offset,
		size
	};
	data = new Uint8Array(buffer, offset + dataSizeOffset + 4, dataSizeOrKidCount);
	return {
		version,
		systemId,
		kids,
		data,
		offset,
		size
	};
}
var userAgentHevcSupportIsInaccurate = () => {
	return /\(Windows.+Firefox\//i.test(navigator.userAgent);
};
var sampleEntryCodesISO = {
	audio: {
		a3ds: 1,
		"ac-3": .95,
		"ac-4": 1,
		alac: .9,
		alaw: 1,
		dra1: 1,
		"dts+": 1,
		"dts-": 1,
		dtsc: 1,
		dtse: 1,
		dtsh: 1,
		"ec-3": .9,
		enca: 1,
		fLaC: .9,
		flac: .9,
		FLAC: .9,
		g719: 1,
		g726: 1,
		m4ae: 1,
		mha1: 1,
		mha2: 1,
		mhm1: 1,
		mhm2: 1,
		mlpa: 1,
		mp4a: 1,
		"raw ": 1,
		Opus: 1,
		opus: 1,
		samr: 1,
		sawb: 1,
		sawp: 1,
		sevc: 1,
		sqcp: 1,
		ssmv: 1,
		twos: 1,
		ulaw: 1
	},
	video: {
		avc1: 1,
		avc2: 1,
		avc3: 1,
		avc4: 1,
		avcp: 1,
		av01: .8,
		dav1: .8,
		drac: 1,
		dva1: 1,
		dvav: 1,
		dvh1: .7,
		dvhe: .7,
		encv: 1,
		hev1: .75,
		hvc1: .75,
		mjp2: 1,
		mp4v: 1,
		mvc1: 1,
		mvc2: 1,
		mvc3: 1,
		mvc4: 1,
		resv: 1,
		rv60: 1,
		s263: 1,
		svc1: 1,
		svc2: 1,
		"vc-1": 1,
		vp08: 1,
		vp09: .9
	},
	text: {
		stpp: 1,
		wvtt: 1
	}
};
function isCodecType(codec, type) {
	const typeCodes = sampleEntryCodesISO[type];
	return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
	return !codecs.split(",").some((codec) => !isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
	var _MediaSource$isTypeSu;
	const MediaSource = getMediaSource(preferManagedMediaSource);
	return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported(mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function mimeTypeForCodec(codec, type) {
	return `${type}/mp4;codecs=${codec}`;
}
function videoCodecPreferenceValue(videoCodec) {
	if (videoCodec) {
		const fourCC = videoCodec.substring(0, 4);
		return sampleEntryCodesISO.video[fourCC];
	}
	return 2;
}
function codecsSetSelectionPreferenceValue(codecSet) {
	const limitedHevcSupport = userAgentHevcSupportIsInaccurate();
	return codecSet.split(",").reduce((num, fourCC) => {
		const preferenceValue = limitedHevcSupport && isHEVC(fourCC) ? 9 : sampleEntryCodesISO.video[fourCC];
		if (preferenceValue) return (preferenceValue * 2 + num) / (num ? 3 : 2);
		return (sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
	}, 0);
}
var CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
	if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
	const codecsToCheck = {
		flac: [
			"flac",
			"fLaC",
			"FLAC"
		],
		opus: ["opus", "Opus"],
		"mp4a.40.34": ["mp3"]
	}[lowerCaseCodec];
	for (let i = 0; i < codecsToCheck.length; i++) {
		var _getMediaSource;
		if (isCodecMediaSourceSupported(codecsToCheck[i], "audio", preferManagedMediaSource)) {
			CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
			return codecsToCheck[i];
		} else if (codecsToCheck[i] === "mp3" && (_getMediaSource = getMediaSource(preferManagedMediaSource)) != null && _getMediaSource.isTypeSupported("audio/mpeg")) return "";
	}
	return lowerCaseCodec;
}
var AUDIO_CODEC_REGEXP = /flac|opus|mp4a\.40\.34/i;
function getCodecCompatibleName(codec, preferManagedMediaSource = true) {
	return codec.replace(AUDIO_CODEC_REGEXP, (m) => getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function replaceVideoCodec(originalCodecs, newVideoCodec) {
	const codecs = [];
	if (originalCodecs) {
		const allCodecs = originalCodecs.split(",");
		for (let i = 0; i < allCodecs.length; i++) if (!isCodecType(allCodecs[i], "video")) codecs.push(allCodecs[i]);
	}
	if (newVideoCodec) codecs.push(newVideoCodec);
	return codecs.join(",");
}
function pickMostCompleteCodecName(parsedCodec, levelCodec) {
	if (parsedCodec && (parsedCodec.length > 4 || [
		"ac-3",
		"ec-3",
		"alac",
		"fLaC",
		"Opus"
	].indexOf(parsedCodec) !== -1)) {
		if (isCodecSupportedAsType(parsedCodec, "audio") || isCodecSupportedAsType(parsedCodec, "video")) return parsedCodec;
	}
	if (levelCodec) {
		const levelCodecs = levelCodec.split(",");
		if (levelCodecs.length > 1) {
			if (parsedCodec) {
				for (let i = levelCodecs.length; i--;) if (levelCodecs[i].substring(0, 4) === parsedCodec.substring(0, 4)) return levelCodecs[i];
			}
			return levelCodecs[0];
		}
	}
	return levelCodec || parsedCodec;
}
function isCodecSupportedAsType(codec, type) {
	return isCodecType(codec, type) && isCodecMediaSourceSupported(codec, type);
}
function convertAVC1ToAVCOTI(videoCodecs) {
	const codecs = videoCodecs.split(",");
	for (let i = 0; i < codecs.length; i++) {
		const avcdata = codecs[i].split(".");
		if (avcdata.length > 2 && avcdata[0] === "avc1") codecs[i] = `avc1.${parseInt(avcdata[1]).toString(16)}${("000" + parseInt(avcdata[2]).toString(16)).slice(-4)}`;
	}
	return codecs.join(",");
}
function fillInMissingAV01Params(videoCodec) {
	if (videoCodec.startsWith("av01.")) {
		const av1params = videoCodec.split(".");
		const placeholders = [
			"0",
			"111",
			"01",
			"01",
			"01",
			"0"
		];
		for (let i = av1params.length; i > 4 && i < 10; i++) av1params[i] = placeholders[i - 4];
		return av1params.join(".");
	}
	return videoCodec;
}
function getM2TSSupportedAudioTypes(preferManagedMediaSource) {
	const MediaSource = getMediaSource(preferManagedMediaSource) || { isTypeSupported: () => false };
	return {
		mpeg: MediaSource.isTypeSupported("audio/mpeg"),
		mp3: MediaSource.isTypeSupported("audio/mp4; codecs=\"mp3\""),
		ac3: MediaSource.isTypeSupported("audio/mp4; codecs=\"ac-3\"")
	};
}
function getCodecsForMimeType(mimeType) {
	return mimeType.replace(/^.+codecs=["']?([^"']+).*$/, "$1");
}
var supportedResult = {
	supported: true,
	powerEfficient: true,
	smooth: true
};
var unsupportedResult = {
	supported: false,
	smooth: false,
	powerEfficient: false
};
var SUPPORTED_INFO_DEFAULT = {
	supported: true,
	configurations: [],
	decodingInfoResults: [supportedResult]
};
function getUnsupportedResult(error, configurations) {
	return {
		supported: false,
		configurations,
		decodingInfoResults: [unsupportedResult],
		error
	};
}
function requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
	const videoCodecs = level.videoCodec;
	const audioGroups = level.audioCodec ? level.audioGroups : null;
	const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
	const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
	const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
	let audioChannels = null;
	if (audioGroups != null && audioGroups.length) try {
		if (audioGroups.length === 1 && audioGroups[0]) audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
		else audioChannels = audioGroups.reduce((acc, groupId) => {
			if (groupId) {
				const audioTrackGroup = audioTracksByGroup.groups[groupId];
				if (!audioTrackGroup) throw new Error(`Audio track group ${groupId} not found`);
				Object.keys(audioTrackGroup.channels).forEach((key) => {
					acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
				});
			}
			return acc;
		}, { 2: 0 });
	} catch (error) {
		return true;
	}
	return videoCodecs !== void 0 && (videoCodecs.split(",").some((videoCodec) => isHEVC(videoCodec)) || level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== "SDR" && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && isFiniteNumber(maxChannels) && Object.keys(audioChannels).some((channels) => parseInt(channels) > maxChannels);
}
function getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities, cache = {}) {
	const videoCodecs = level.videoCodec;
	if (!videoCodecs && !level.audioCodec || !mediaCapabilities) return Promise.resolve(SUPPORTED_INFO_DEFAULT);
	const configurations = [];
	const videoDecodeList = makeVideoConfigurations(level);
	const videoCount = videoDecodeList.length;
	const audioDecodeList = makeAudioConfigurations(level, audioTracksByGroup, videoCount > 0);
	const audioCount = audioDecodeList.length;
	for (let i = videoCount || 1 * audioCount || 1; i--;) {
		const configuration = { type: "media-source" };
		if (videoCount) configuration.video = videoDecodeList[i % videoCount];
		if (audioCount) {
			configuration.audio = audioDecodeList[i % audioCount];
			const audioBitrate = configuration.audio.bitrate;
			if (configuration.video && audioBitrate) configuration.video.bitrate -= audioBitrate;
		}
		configurations.push(configuration);
	}
	if (videoCodecs) {
		const ua = navigator.userAgent;
		if (videoCodecs.split(",").some((videoCodec) => isHEVC(videoCodec)) && userAgentHevcSupportIsInaccurate()) return Promise.resolve(getUnsupportedResult(/* @__PURE__ */ new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent string: (${ua})`), configurations));
	}
	return Promise.all(configurations.map((configuration) => {
		const decodingInfoKey = getMediaDecodingInfoKey(configuration);
		return cache[decodingInfoKey] || (cache[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
	})).then((decodingInfoResults) => ({
		supported: !decodingInfoResults.some((info) => !info.supported),
		configurations,
		decodingInfoResults
	})).catch((error) => ({
		supported: false,
		configurations,
		decodingInfoResults: [],
		error
	}));
}
function makeVideoConfigurations(level) {
	var _level$videoCodec;
	const videoCodecs = (_level$videoCodec = level.videoCodec) == null ? void 0 : _level$videoCodec.split(",");
	const bitrate = getVariantDecodingBitrate(level);
	const width = level.width || 640;
	const height = level.height || 480;
	const framerate = level.frameRate || 30;
	const videoRange = level.videoRange.toLowerCase();
	return videoCodecs ? videoCodecs.map((videoCodec) => {
		const videoConfiguration = {
			contentType: mimeTypeForCodec(fillInMissingAV01Params(videoCodec), "video"),
			width,
			height,
			bitrate,
			framerate
		};
		if (videoRange !== "sdr") videoConfiguration.transferFunction = videoRange;
		return videoConfiguration;
	}) : [];
}
function makeAudioConfigurations(level, audioTracksByGroup, hasVideo) {
	var _level$audioCodec;
	const audioCodecs = (_level$audioCodec = level.audioCodec) == null ? void 0 : _level$audioCodec.split(",");
	const combinedBitrate = getVariantDecodingBitrate(level);
	if (audioCodecs && level.audioGroups) return level.audioGroups.reduce((configurations, audioGroupId) => {
		var _audioTracksByGroup$g;
		const tracks = audioGroupId ? (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null ? void 0 : _audioTracksByGroup$g.tracks : null;
		if (tracks) return tracks.reduce((configs, audioTrack) => {
			if (audioTrack.groupId === audioGroupId) {
				const channelsNumber = parseFloat(audioTrack.channels || "");
				audioCodecs.forEach((audioCodec) => {
					const audioConfiguration = {
						contentType: mimeTypeForCodec(audioCodec, "audio"),
						bitrate: hasVideo ? estimatedAudioBitrate(audioCodec, combinedBitrate) : combinedBitrate
					};
					if (channelsNumber) audioConfiguration.channels = "" + channelsNumber;
					configs.push(audioConfiguration);
				});
			}
			return configs;
		}, configurations);
		return configurations;
	}, []);
	return [];
}
function estimatedAudioBitrate(audioCodec, levelBitrate) {
	if (levelBitrate <= 1) return 1;
	let audioBitrate = 128e3;
	if (audioCodec === "ec-3") audioBitrate = 768e3;
	else if (audioCodec === "ac-3") audioBitrate = 64e4;
	return Math.min(levelBitrate / 2, audioBitrate);
}
function getVariantDecodingBitrate(level) {
	return Math.ceil(Math.max(level.bitrate * .9, level.averageBitrate) / 1e3) * 1e3 || 1;
}
function getMediaDecodingInfoKey(config) {
	let key = "";
	const { audio, video } = config;
	if (video) {
		const codec = getCodecsForMimeType(video.contentType);
		key += `${codec}_r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || "sd"}_${Math.ceil(video.bitrate / 1e5)}`;
	}
	if (audio) {
		const codec = getCodecsForMimeType(audio.contentType);
		key += `${video ? "_" : ""}${codec}_c${audio.channels}`;
	}
	return key;
}
var HdcpLevels = [
	"NONE",
	"TYPE-0",
	"TYPE-1",
	null
];
function isHdcpLevel(value) {
	return HdcpLevels.indexOf(value) > -1;
}
var VideoRangeValues = [
	"SDR",
	"PQ",
	"HLG"
];
function isVideoRange(value) {
	return !!value && VideoRangeValues.indexOf(value) > -1;
}
var HlsSkip = {
	No: "",
	Yes: "YES",
	v2: "v2"
};
function getSkipValue(details) {
	const { canSkipUntil, canSkipDateRanges, age } = details;
	const playlistRecentEnough = age < canSkipUntil / 2;
	if (canSkipUntil && playlistRecentEnough) {
		if (canSkipDateRanges) return HlsSkip.v2;
		return HlsSkip.Yes;
	}
	return HlsSkip.No;
}
var HlsUrlParameters = class {
	constructor(msn, part, skip) {
		this.msn = void 0;
		this.part = void 0;
		this.skip = void 0;
		this.msn = msn;
		this.part = part;
		this.skip = skip;
	}
	addDirectives(uri) {
		const url = new self.URL(uri);
		if (this.msn !== void 0) url.searchParams.set("_HLS_msn", this.msn.toString());
		if (this.part !== void 0) url.searchParams.set("_HLS_part", this.part.toString());
		if (this.skip) url.searchParams.set("_HLS_skip", this.skip);
		return url.href;
	}
};
var Level = class {
	constructor(data) {
		this._attrs = void 0;
		this.audioCodec = void 0;
		this.bitrate = void 0;
		this.codecSet = void 0;
		this.url = void 0;
		this.frameRate = void 0;
		this.height = void 0;
		this.id = void 0;
		this.name = void 0;
		this.supplemental = void 0;
		this.videoCodec = void 0;
		this.width = void 0;
		this.details = void 0;
		this.fragmentError = 0;
		this.loadError = 0;
		this.loaded = void 0;
		this.realBitrate = 0;
		this.supportedPromise = void 0;
		this.supportedResult = void 0;
		this._avgBitrate = 0;
		this._audioGroups = void 0;
		this._subtitleGroups = void 0;
		this._urlId = 0;
		this.url = [data.url];
		this._attrs = [data.attrs];
		this.bitrate = data.bitrate;
		if (data.details) this.details = data.details;
		this.id = data.id || 0;
		this.name = data.name;
		this.width = data.width || 0;
		this.height = data.height || 0;
		this.frameRate = data.attrs.optionalFloat("FRAME-RATE", 0);
		this._avgBitrate = data.attrs.decimalInteger("AVERAGE-BANDWIDTH");
		this.audioCodec = data.audioCodec;
		this.videoCodec = data.videoCodec;
		this.codecSet = [data.videoCodec, data.audioCodec].filter((c) => !!c).map((s) => s.substring(0, 4)).join(",");
		if ("supplemental" in data) {
			var _data$supplemental;
			this.supplemental = data.supplemental;
			const supplementalVideo = (_data$supplemental = data.supplemental) == null ? void 0 : _data$supplemental.videoCodec;
			if (supplementalVideo && supplementalVideo !== data.videoCodec) this.codecSet += `,${supplementalVideo.substring(0, 4)}`;
		}
		this.addGroupId("audio", data.attrs.AUDIO);
		this.addGroupId("text", data.attrs.SUBTITLES);
	}
	get maxBitrate() {
		return Math.max(this.realBitrate, this.bitrate);
	}
	get averageBitrate() {
		return this._avgBitrate || this.realBitrate || this.bitrate;
	}
	get attrs() {
		return this._attrs[0];
	}
	get codecs() {
		return this.attrs.CODECS || "";
	}
	get pathwayId() {
		return this.attrs["PATHWAY-ID"] || ".";
	}
	get videoRange() {
		return this.attrs["VIDEO-RANGE"] || "SDR";
	}
	get score() {
		return this.attrs.optionalFloat("SCORE", 0);
	}
	get uri() {
		return this.url[0] || "";
	}
	hasAudioGroup(groupId) {
		return hasGroup(this._audioGroups, groupId);
	}
	hasSubtitleGroup(groupId) {
		return hasGroup(this._subtitleGroups, groupId);
	}
	get audioGroups() {
		return this._audioGroups;
	}
	get subtitleGroups() {
		return this._subtitleGroups;
	}
	addGroupId(type, groupId) {
		if (!groupId) return;
		if (type === "audio") {
			let audioGroups = this._audioGroups;
			if (!audioGroups) audioGroups = this._audioGroups = [];
			if (audioGroups.indexOf(groupId) === -1) audioGroups.push(groupId);
		} else if (type === "text") {
			let subtitleGroups = this._subtitleGroups;
			if (!subtitleGroups) subtitleGroups = this._subtitleGroups = [];
			if (subtitleGroups.indexOf(groupId) === -1) subtitleGroups.push(groupId);
		}
	}
	get urlId() {
		return 0;
	}
	set urlId(value) {}
	get audioGroupIds() {
		return this.audioGroups ? [this.audioGroupId] : void 0;
	}
	get textGroupIds() {
		return this.subtitleGroups ? [this.textGroupId] : void 0;
	}
	get audioGroupId() {
		var _this$audioGroups;
		return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
	}
	get textGroupId() {
		var _this$subtitleGroups;
		return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
	}
	addFallback() {}
};
function hasGroup(groups, groupId) {
	if (!groupId || !groups) return false;
	return groups.indexOf(groupId) !== -1;
}
/**
* @returns Whether we can detect and validate HDR capability within the window context
*/
function isHdrSupported() {
	if (typeof matchMedia === "function") {
		const mediaQueryList = matchMedia("(dynamic-range: high)");
		const badQuery = matchMedia("bad query");
		if (mediaQueryList.media !== badQuery.media) return mediaQueryList.matches === true;
	}
	return false;
}
/**
* Sanitizes inputs to return the active video selection options for HDR/SDR.
* When both inputs are null:
*
*    `{ preferHDR: false, allowedVideoRanges: [] }`
*
* When `currentVideoRange` non-null, maintain the active range:
*
*    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
*
* When VideoSelectionOption non-null:
*
*  - Allow all video ranges if `allowedVideoRanges` unspecified.
*  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
*  - Else check window for HDR support and set `preferHDR` to the result.
*
* @param currentVideoRange
* @param videoPreference
*/
function getVideoSelectionOptions(currentVideoRange, videoPreference) {
	let preferHDR = false;
	let allowedVideoRanges = [];
	if (currentVideoRange) {
		preferHDR = currentVideoRange !== "SDR";
		allowedVideoRanges = [currentVideoRange];
	}
	if (videoPreference) {
		allowedVideoRanges = videoPreference.allowedVideoRanges || VideoRangeValues.slice(0);
		const allowAutoPreferHDR = allowedVideoRanges.join("") !== "SDR" && !videoPreference.videoCodec;
		preferHDR = videoPreference.preferHDR !== void 0 ? videoPreference.preferHDR : allowAutoPreferHDR && isHdrSupported();
		if (!preferHDR) allowedVideoRanges = ["SDR"];
	}
	return {
		preferHDR,
		allowedVideoRanges
	};
}
var omitCircularRefsReplacer = (replacer) => {
	const known = /* @__PURE__ */ new WeakSet();
	return (_, value) => {
		if (replacer) value = replacer(_, value);
		if (typeof value === "object" && value !== null) {
			if (known.has(value)) return;
			known.add(value);
		}
		return value;
	};
};
var stringify = (object, replacer) => JSON.stringify(object, omitCircularRefsReplacer(replacer));
function getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
	const codecSets = Object.keys(codecTiers);
	const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
	const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
	const videoCodecPreference = videoPreference == null ? void 0 : videoPreference.videoCodec;
	const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
	let hasStereo = false;
	let hasCurrentVideoRange = false;
	let minHeight = Infinity;
	let minFramerate = Infinity;
	let minBitrate = Infinity;
	let minIndex = Infinity;
	let selectedScore = 0;
	let videoRanges = [];
	const { preferHDR, allowedVideoRanges } = getVideoSelectionOptions(currentVideoRange, videoPreference);
	for (let i = codecSets.length; i--;) {
		const tier = codecTiers[codecSets[i]];
		hasStereo || (hasStereo = tier.channels[2] > 0);
		minHeight = Math.min(minHeight, tier.minHeight);
		minFramerate = Math.min(minFramerate, tier.minFramerate);
		minBitrate = Math.min(minBitrate, tier.minBitrate);
		if (allowedVideoRanges.filter((range) => tier.videoRanges[range] > 0).length > 0) hasCurrentVideoRange = true;
	}
	minHeight = isFiniteNumber(minHeight) ? minHeight : 0;
	minFramerate = isFiniteNumber(minFramerate) ? minFramerate : 0;
	const maxHeight = Math.max(1080, minHeight);
	const maxFramerate = Math.max(30, minFramerate);
	minBitrate = isFiniteNumber(minBitrate) ? minBitrate : currentBw;
	currentBw = Math.max(minBitrate, currentBw);
	if (!hasCurrentVideoRange) currentVideoRange = void 0;
	const hasMultipleSets = codecSets.length > 1;
	return {
		codecSet: codecSets.reduce((selected, candidate) => {
			const candidateTier = codecTiers[candidate];
			if (candidate === selected) return selected;
			videoRanges = hasCurrentVideoRange ? allowedVideoRanges.filter((range) => candidateTier.videoRanges[range] > 0) : [];
			if (hasMultipleSets) {
				if (candidateTier.minBitrate > currentBw) {
					logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
					return selected;
				}
				if (!candidateTier.hasDefaultAudio) {
					logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
					return selected;
				}
				if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
					logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
					return selected;
				}
				if (channelsPreference && !preferStereo) {
					if (!candidateTier.channels[channelsPreference]) {
						logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
						return selected;
					}
				} else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels["2"] === 0) {
					logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
					return selected;
				}
				if (candidateTier.minHeight > maxHeight) {
					logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
					return selected;
				}
				if (candidateTier.minFramerate > maxFramerate) {
					logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
					return selected;
				}
				if (!videoRanges.some((range) => candidateTier.videoRanges[range] > 0)) {
					logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${stringify(videoRanges)} found`);
					return selected;
				}
				if (videoCodecPreference && candidate.indexOf(videoCodecPreference.substring(0, 4)) % 5 !== 0) {
					logStartCodecCandidateIgnored(candidate, `video codec preference "${videoCodecPreference}" not found`);
					return selected;
				}
				if (candidateTier.maxScore < selectedScore) {
					logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
					return selected;
				}
			}
			if (selected && (codecsSetSelectionPreferenceValue(candidate) >= codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) return selected;
			minIndex = candidateTier.minIndex;
			selectedScore = candidateTier.maxScore;
			return candidate;
		}, void 0),
		videoRanges,
		preferHDR,
		minFramerate,
		minBitrate,
		minIndex
	};
}
function logStartCodecCandidateIgnored(codeSet, reason) {
	logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function getAudioTracksByGroup(allAudioTracks) {
	return allAudioTracks.reduce((audioTracksByGroup, track) => {
		let trackGroup = audioTracksByGroup.groups[track.groupId];
		if (!trackGroup) trackGroup = audioTracksByGroup.groups[track.groupId] = {
			tracks: [],
			channels: { 2: 0 },
			hasDefault: false,
			hasAutoSelect: false
		};
		trackGroup.tracks.push(track);
		const channelsKey = track.channels || "2";
		trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
		trackGroup.hasDefault = trackGroup.hasDefault || track.default;
		trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
		if (trackGroup.hasDefault) audioTracksByGroup.hasDefaultAudio = true;
		if (trackGroup.hasAutoSelect) audioTracksByGroup.hasAutoSelectAudio = true;
		return audioTracksByGroup;
	}, {
		hasDefaultAudio: false,
		hasAutoSelectAudio: false,
		groups: {}
	});
}
function getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
	return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level, index) => {
		if (!level.codecSet) return tiers;
		const audioGroups = level.audioGroups;
		let tier = tiers[level.codecSet];
		if (!tier) tiers[level.codecSet] = tier = {
			minBitrate: Infinity,
			minHeight: Infinity,
			minFramerate: Infinity,
			minIndex: index,
			maxScore: 0,
			videoRanges: { SDR: 0 },
			channels: { "2": 0 },
			hasDefaultAudio: !audioGroups,
			fragmentError: 0
		};
		tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
		const lesserWidthOrHeight = Math.min(level.height, level.width);
		tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
		tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
		tier.minIndex = Math.min(tier.minIndex, index);
		tier.maxScore = Math.max(tier.maxScore, level.score);
		tier.fragmentError += level.fragmentError;
		tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
		if (audioGroups) audioGroups.forEach((audioGroupId) => {
			if (!audioGroupId) return;
			const audioGroup = audioTracksByGroup.groups[audioGroupId];
			if (!audioGroup) return;
			tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
			Object.keys(audioGroup.channels).forEach((channels) => {
				tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
			});
		});
		return tiers;
	}, {});
}
function getBasicSelectionOption(option) {
	if (!option) return option;
	const { lang, assocLang, characteristics, channels, audioCodec } = option;
	return {
		lang,
		assocLang,
		characteristics,
		channels,
		audioCodec
	};
}
function findMatchingOption(option, tracks, matchPredicate) {
	if ("attrs" in option) {
		const index = tracks.indexOf(option);
		if (index !== -1) return index;
	}
	for (let i = 0; i < tracks.length; i++) {
		const track = tracks[i];
		if (matchesOption(option, track, matchPredicate)) return i;
	}
	return -1;
}
function matchesOption(option, track, matchPredicate) {
	const { groupId, name, lang, assocLang, default: isDefault } = option;
	const forced = option.forced;
	return (groupId === void 0 || track.groupId === groupId) && (name === void 0 || track.name === name) && (lang === void 0 || languagesMatch(lang, track.lang)) && (lang === void 0 || track.assocLang === assocLang) && (isDefault === void 0 || track.default === isDefault) && (forced === void 0 || track.forced === forced) && (!("characteristics" in option) || characteristicsMatch(option.characteristics || "", track.characteristics)) && (matchPredicate === void 0 || matchPredicate(option, track));
}
function languagesMatch(languageA, languageB = "--") {
	if (languageA.length === languageB.length) return languageA === languageB;
	return languageA.startsWith(languageB) || languageB.startsWith(languageA);
}
function characteristicsMatch(characteristicsA, characteristicsB = "") {
	const arrA = characteristicsA.split(",");
	const arrB = characteristicsB.split(",");
	return arrA.length === arrB.length && !arrA.some((el) => arrB.indexOf(el) === -1);
}
function audioMatchPredicate(option, track) {
	const { audioCodec, channels } = option;
	return (audioCodec === void 0 || (track.audioCodec || "").substring(0, 4) === audioCodec.substring(0, 4)) && (channels === void 0 || channels === (track.channels || "2"));
}
function findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
	const currentLevel = levels[searchIndex];
	const renditions = levels.reduce((variantMap, level, index) => {
		const uri = level.uri;
		(variantMap[uri] || (variantMap[uri] = [])).push(index);
		return variantMap;
	}, {})[currentLevel.uri];
	if (renditions.length > 1) searchIndex = Math.max.apply(Math, renditions);
	const currentVideoRange = currentLevel.videoRange;
	const currentFrameRate = currentLevel.frameRate;
	const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
	const matchingVideo = searchDownAndUpList(levels, searchIndex, (level) => {
		if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) return false;
		const audioGroups = level.audioGroups;
		return findMatchingOption(option, allAudioTracks.filter((track) => !audioGroups || audioGroups.indexOf(track.groupId) !== -1), matchPredicate) > -1;
	});
	if (matchingVideo > -1) return matchingVideo;
	return searchDownAndUpList(levels, searchIndex, (level) => {
		const audioGroups = level.audioGroups;
		return findMatchingOption(option, allAudioTracks.filter((track) => !audioGroups || audioGroups.indexOf(track.groupId) !== -1), matchPredicate) > -1;
	});
}
function searchDownAndUpList(arr, searchIndex, predicate) {
	for (let i = searchIndex; i > -1; i--) if (predicate(arr[i])) return i;
	for (let i = searchIndex + 1; i < arr.length; i++) if (predicate(arr[i])) return i;
	return -1;
}
function useAlternateAudio(audioTrackUrl, hls) {
	var _hls$loadLevelObj;
	return !!audioTrackUrl && audioTrackUrl !== ((_hls$loadLevelObj = hls.loadLevelObj) == null ? void 0 : _hls$loadLevelObj.uri);
}
var AbrController = class extends Logger {
	constructor(_hls) {
		super("abr", _hls.logger);
		this.hls = void 0;
		this.lastLevelLoadSec = 0;
		this.lastLoadedFragLevel = -1;
		this.firstSelection = -1;
		this._nextAutoLevel = -1;
		this.nextAutoLevelKey = "";
		this.audioTracksByGroup = null;
		this.codecTiers = null;
		this.timer = -1;
		this.fragCurrent = null;
		this.partCurrent = null;
		this.bitrateTestDelay = 0;
		this.rebufferNotice = -1;
		this.supportedCache = {};
		this.bwEstimator = void 0;
		this._abandonRulesCheck = (levelLoaded) => {
			var _ref;
			const { fragCurrent: frag, partCurrent: part, hls } = this;
			const { autoLevelEnabled, media } = hls;
			if (!frag || !media) return;
			const now = performance.now();
			const stats = part ? part.stats : frag.stats;
			const duration = part ? part.duration : frag.duration;
			const timeLoading = now - stats.loading.start;
			const minAutoLevel = hls.minAutoLevel;
			const loadingFragForLevel = frag.level;
			const currentAutoLevel = this._nextAutoLevel;
			if (stats.aborted || stats.loaded && stats.loaded === stats.total || loadingFragForLevel <= minAutoLevel) {
				this.clearTimer();
				this._nextAutoLevel = -1;
				return;
			}
			if (!autoLevelEnabled) return;
			const fragBlockingSwitch = currentAutoLevel > -1 && currentAutoLevel !== loadingFragForLevel;
			const levelChange = !!levelLoaded || fragBlockingSwitch;
			if (!levelChange && (media.paused || !media.playbackRate || !media.readyState)) return;
			const bufferInfo = hls.mainForwardBufferInfo;
			if (!levelChange && bufferInfo === null) return;
			const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
			const playbackRate = Math.abs(media.playbackRate);
			if (timeLoading <= Math.max(ttfbEstimate, 1e3 * (duration / (playbackRate * 2)))) return;
			const bufferStarvationDelay = bufferInfo ? bufferInfo.len / playbackRate : 0;
			const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
			const loadedFirstByte = stats.loaded && ttfb > -1;
			const bwEstimate = this.getBwEstimate();
			const levels = hls.levels;
			const level = levels[loadingFragForLevel];
			const expectedLen = Math.max(stats.loaded, Math.round(duration * (frag.bitrate || level.averageBitrate) / 8));
			let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
			if (timeStreaming < 1 && loadedFirstByte) timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
			const loadRate = loadedFirstByte ? stats.loaded * 1e3 / timeStreaming : 0;
			const ttfbSeconds = ttfbEstimate / 1e3;
			const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbSeconds;
			if (fragLoadedDelay <= bufferStarvationDelay) return;
			const bwe = loadRate ? loadRate * 8 : bwEstimate;
			const live = ((_ref = (levelLoaded == null ? void 0 : levelLoaded.details) || this.hls.latestLevelDetails) == null ? void 0 : _ref.live) === true;
			const abrBandWidthUpFactor = this.hls.config.abrBandWidthUpFactor;
			let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
			let nextLoadLevel;
			for (nextLoadLevel = loadingFragForLevel - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
				const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
				const requiresLevelLoad = !levels[nextLoadLevel].details || live;
				fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbSeconds, bwe, duration * levelNextBitrate, requiresLevelLoad);
				if (fragLevelNextLoadedDelay < Math.min(bufferStarvationDelay, duration + ttfbSeconds)) break;
			}
			if (fragLevelNextLoadedDelay >= fragLoadedDelay) return;
			if (fragLevelNextLoadedDelay > duration * 10) return;
			if (loadedFirstByte) this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
			else this.bwEstimator.sampleTTFB(timeLoading);
			const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
			if (this.getBwEstimate() * abrBandWidthUpFactor > nextLoadLevelBitrate) this.resetEstimator(nextLoadLevelBitrate);
			const bestSwitchLevel = this.findBestLevel(nextLoadLevelBitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
			if (bestSwitchLevel > -1) nextLoadLevel = bestSwitchLevel;
			this.warn(`Fragment ${frag.sn}${part ? " part " + part.index : ""} of level ${loadingFragForLevel} is loading too slowly;
      Fragment duration: ${frag.duration.toFixed(3)}
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? bwEstimate | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
			hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
			this.clearTimer();
			const abortAndSwitch = () => {
				this.clearTimer();
				if (this.fragCurrent === frag && this.hls.loadLevel === nextLoadLevel && nextLoadLevel > 0) {
					const bufferStarvationDelay = this.getStarvationDelay();
					this.warn(`Aborting inflight request ${nextLoadLevel > 0 ? "and switching down" : ""}
      Fragment duration: ${frag.duration.toFixed(3)} s
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s`);
					frag.abortRequests();
					this.fragCurrent = this.partCurrent = null;
					if (nextLoadLevel > minAutoLevel) {
						let lowestSwitchLevel = this.findBestLevel(this.hls.levels[minAutoLevel].bitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
						if (lowestSwitchLevel === -1) lowestSwitchLevel = minAutoLevel;
						this.hls.nextLoadLevel = this.hls.nextAutoLevel = lowestSwitchLevel;
						this.resetEstimator(this.hls.levels[lowestSwitchLevel].bitrate);
					}
				}
			};
			if (fragBlockingSwitch || fragLoadedDelay > fragLevelNextLoadedDelay * 2) abortAndSwitch();
			else this.timer = self.setInterval(abortAndSwitch, fragLevelNextLoadedDelay * 1e3);
			hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
				frag,
				part,
				stats
			});
		};
		this.hls = _hls;
		this.bwEstimator = this.initEstimator();
		this.registerListeners();
	}
	resetEstimator(abrEwmaDefaultEstimate) {
		if (abrEwmaDefaultEstimate) {
			this.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
			this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
		}
		this.firstSelection = -1;
		this.bwEstimator = this.initEstimator();
	}
	initEstimator() {
		const config = this.hls.config;
		return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
		hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
		hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		if (!hls) return;
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
		hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
		hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	destroy() {
		this.unregisterListeners();
		this.clearTimer();
		this.hls = this._abandonRulesCheck = this.supportedCache = null;
		this.fragCurrent = this.partCurrent = null;
	}
	onManifestLoading(event, data) {
		this.lastLoadedFragLevel = -1;
		this.firstSelection = -1;
		this.lastLevelLoadSec = 0;
		this.supportedCache = {};
		this.fragCurrent = this.partCurrent = null;
		this.onLevelsUpdated();
		this.clearTimer();
	}
	onLevelsUpdated() {
		if (this.lastLoadedFragLevel > -1 && this.fragCurrent) this.lastLoadedFragLevel = this.fragCurrent.level;
		this._nextAutoLevel = -1;
		this.onMaxAutoLevelUpdated();
		this.codecTiers = null;
		this.audioTracksByGroup = null;
	}
	onMaxAutoLevelUpdated() {
		this.firstSelection = -1;
		this.nextAutoLevelKey = "";
	}
	onFragLoading(event, data) {
		const frag = data.frag;
		if (this.ignoreFragment(frag)) return;
		if (!frag.bitrateTest) {
			var _data$part;
			this.fragCurrent = frag;
			this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
		}
		this.clearTimer();
		this.timer = self.setInterval(this._abandonRulesCheck, 100);
	}
	onLevelSwitching(event, data) {
		this.clearTimer();
	}
	onError(event, data) {
		if (data.fatal) return;
		switch (data.details) {
			case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
			case ErrorDetails.BUFFER_APPEND_ERROR:
				this.lastLoadedFragLevel = -1;
				this.firstSelection = -1;
				break;
			case ErrorDetails.FRAG_LOAD_TIMEOUT: {
				const frag = data.frag;
				const { fragCurrent, partCurrent: part } = this;
				if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
					const now = performance.now();
					const stats = part ? part.stats : frag.stats;
					const timeLoading = now - stats.loading.start;
					const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
					if (stats.loaded && ttfb > -1) {
						const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
						this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
					} else this.bwEstimator.sampleTTFB(timeLoading);
				}
				break;
			}
		}
	}
	getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
		return timeToFirstByteSec + fragSizeBits / bandwidth + (isSwitch ? timeToFirstByteSec + this.lastLevelLoadSec : 0);
	}
	onLevelLoaded(event, data) {
		const config = this.hls.config;
		const { loading } = data.stats;
		const timeLoadingMs = loading.end - loading.first;
		if (isFiniteNumber(timeLoadingMs)) this.lastLevelLoadSec = timeLoadingMs / 1e3;
		if (data.details.live) this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
		else this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
		if (this.timer > -1) this._abandonRulesCheck(data.levelInfo);
	}
	onFragLoaded(event, { frag, part }) {
		const stats = part ? part.stats : frag.stats;
		if (frag.type === PlaylistLevelType.MAIN) this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
		if (this.ignoreFragment(frag)) return;
		this.clearTimer();
		if (frag.level === this._nextAutoLevel) this._nextAutoLevel = -1;
		this.firstSelection = -1;
		if (this.hls.config.abrMaxWithRealBitrate) {
			const duration = part ? part.duration : frag.duration;
			const level = this.hls.levels[frag.level];
			const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
			const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
			level.loaded = {
				bytes: loadedBytes,
				duration: loadedDuration
			};
			level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
		}
		if (frag.bitrateTest) {
			const fragBufferedData = {
				stats,
				frag,
				part,
				id: frag.type
			};
			this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
			frag.bitrateTest = false;
		} else this.lastLoadedFragLevel = frag.level;
	}
	onFragBuffered(event, data) {
		const { frag, part } = data;
		const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
		if (stats.aborted) return;
		if (this.ignoreFragment(frag)) return;
		const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
		this.bwEstimator.sample(processingMs, stats.loaded);
		stats.bwEstimate = this.getBwEstimate();
		if (frag.bitrateTest) this.bitrateTestDelay = processingMs / 1e3;
		else this.bitrateTestDelay = 0;
	}
	ignoreFragment(frag) {
		return frag.type !== PlaylistLevelType.MAIN || frag.sn === "initSegment";
	}
	clearTimer() {
		if (this.timer > -1) {
			self.clearInterval(this.timer);
			this.timer = -1;
		}
	}
	get firstAutoLevel() {
		const { maxAutoLevel, minAutoLevel } = this.hls;
		const bwEstimate = this.getBwEstimate();
		const maxStartDelay = this.hls.config.maxStarvationDelay;
		const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
		if (abrAutoLevel > -1) return abrAutoLevel;
		const firstLevel = this.hls.firstLevel;
		const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
		this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
		return clamped;
	}
	get forcedAutoLevel() {
		if (this.nextAutoLevelKey) return -1;
		return this._nextAutoLevel;
	}
	get nextAutoLevel() {
		const forcedAutoLevel = this.forcedAutoLevel;
		const useEstimate = this.bwEstimator.canEstimate();
		const loadedFirstFrag = this.lastLoadedFragLevel > -1;
		if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) return forcedAutoLevel;
		const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;
		if (forcedAutoLevel !== -1) {
			const levels = this.hls.levels;
			if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) return forcedAutoLevel;
		}
		this._nextAutoLevel = nextABRAutoLevel;
		this.nextAutoLevelKey = this.getAutoLevelKey();
		return nextABRAutoLevel;
	}
	getAutoLevelKey() {
		return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
	}
	getNextABRAutoLevel() {
		const { fragCurrent, partCurrent, hls } = this;
		if (hls.levels.length <= 1) return hls.loadLevel;
		const { maxAutoLevel, config, minAutoLevel } = hls;
		const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
		const avgbw = this.getBwEstimate();
		const bufferStarvationDelay = this.getStarvationDelay();
		let bwFactor = config.abrBandWidthFactor;
		let bwUpFactor = config.abrBandWidthUpFactor;
		if (bufferStarvationDelay) {
			const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
			if (_bestLevel >= 0) {
				this.rebufferNotice = -1;
				return _bestLevel;
			}
		}
		let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
		if (!bufferStarvationDelay) {
			const bitrateTestDelay = this.bitrateTestDelay;
			if (bitrateTestDelay) {
				maxStarvationDelay = (currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay) - bitrateTestDelay;
				this.info(`bitrate test took ${Math.round(1e3 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * maxStarvationDelay)} ms`);
				bwFactor = bwUpFactor = 1;
			}
		}
		const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
		if (this.rebufferNotice !== bestLevel) {
			this.rebufferNotice = bestLevel;
			this.info(`${bufferStarvationDelay ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${bestLevel}`);
		}
		if (bestLevel > -1) return bestLevel;
		const minLevel = hls.levels[minAutoLevel];
		const autoLevel = hls.loadLevelObj;
		if (autoLevel && (minLevel == null ? void 0 : minLevel.bitrate) < autoLevel.bitrate) return minAutoLevel;
		return hls.loadLevel;
	}
	getStarvationDelay() {
		const hls = this.hls;
		const media = hls.media;
		if (!media) return Infinity;
		const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1;
		const bufferInfo = hls.mainForwardBufferInfo;
		return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
	}
	getBwEstimate() {
		return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
	}
	findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
		var _this$hls$latestLevel;
		const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
		const lastLoadedFragLevel = this.lastLoadedFragLevel;
		const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
		const { fragCurrent, partCurrent } = this;
		const { levels, allAudioTracks, loadLevel, config } = this.hls;
		if (levels.length === 1) return 0;
		const level = levels[selectionBaseLevel];
		const live = !!((_this$hls$latestLevel = this.hls.latestLevelDetails) != null && _this$hls$latestLevel.live);
		const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
		let currentCodecSet;
		let currentVideoRange = "SDR";
		let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
		const { audioPreference, videoPreference } = config;
		const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(allAudioTracks));
		let minStartIndex = -1;
		if (firstSelection) {
			if (this.firstSelection !== -1) return this.firstSelection;
			const startTier = getStartCodecTier(this.codecTiers || (this.codecTiers = getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel)), currentVideoRange, currentBw, audioPreference, videoPreference);
			const { codecSet, videoRanges, minFramerate, minBitrate, minIndex, preferHDR } = startTier;
			minStartIndex = minIndex;
			currentCodecSet = codecSet;
			currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
			currentFrameRate = minFramerate;
			currentBw = Math.max(currentBw, minBitrate);
			this.log(`picked start tier ${stringify(startTier)}`);
		} else {
			currentCodecSet = level == null ? void 0 : level.codecSet;
			currentVideoRange = level == null ? void 0 : level.videoRange;
		}
		const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
		const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1e3;
		const levelsSkipped = [];
		for (let i = maxAutoLevel; i >= minAutoLevel; i--) {
			var _levelInfo$supportedR;
			const levelInfo = levels[i];
			const upSwitch = i > selectionBaseLevel;
			if (!levelInfo) continue;
			if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
				const mediaCapabilities = navigator.mediaCapabilities;
				if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === "function" && requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference)) {
					levelInfo.supportedPromise = getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities, this.supportedCache);
					levelInfo.supportedPromise.then((decodingInfo) => {
						if (!this.hls) return;
						levelInfo.supportedResult = decodingInfo;
						const levels = this.hls.levels;
						const index = levels.indexOf(levelInfo);
						if (decodingInfo.error) this.warn(`MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${stringify(decodingInfo)}`);
						else if (!decodingInfo.supported) {
							this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${index} ${stringify(decodingInfo)}`);
							if (index > -1 && levels.length > 1) {
								this.log(`Removing unsupported level ${index}`);
								this.hls.removeLevel(index);
								if (this.hls.loadLevel === -1) this.hls.nextLoadLevel = 0;
							}
						} else if (decodingInfo.decodingInfoResults.some((info) => info.smooth === false || info.powerEfficient === false)) this.log(`MediaCapabilities decodingInfo for level ${index} not smooth or powerEfficient: ${stringify(decodingInfo)}`);
					}).catch((error) => {
						this.warn(`Error handling MediaCapabilities decodingInfo: ${error}`);
					});
				} else levelInfo.supportedResult = SUPPORTED_INFO_DEFAULT;
			}
			if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || (_levelInfo$supportedR = levelInfo.supportedResult) != null && (_levelInfo$supportedR = _levelInfo$supportedR.decodingInfoResults) != null && _levelInfo$supportedR.some((info) => info.smooth === false)) {
				if (!firstSelection || i !== minStartIndex) {
					levelsSkipped.push(i);
					continue;
				}
			}
			const levelDetails = levelInfo.details;
			const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
			let adjustedbw;
			if (!upSwitch) adjustedbw = bwFactor * currentBw;
			else adjustedbw = bwUpFactor * currentBw;
			const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levelInfo.averageBitrate : levelInfo.maxBitrate;
			const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === void 0);
			if (adjustedbw >= bitrate && (i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && (fetchDuration <= ttfbEstimateSec || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) {
				const forcedAutoLevel = this.forcedAutoLevel;
				if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
					if (levelsSkipped.length) this.trace(`Skipped level(s) ${levelsSkipped.join(",")} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${currentCodecSet}" ${currentVideoRange}`);
					this.info(`switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${levelInfo.codecSet} videoRange:${levelInfo.videoRange} hls.loadLevel:${loadLevel}`);
				}
				if (firstSelection) this.firstSelection = i;
				return i;
			}
		}
		return -1;
	}
	set nextAutoLevel(nextLevel) {
		const value = this.deriveNextAutoLevel(nextLevel);
		if (this._nextAutoLevel !== value) {
			this.nextAutoLevelKey = "";
			this._nextAutoLevel = value;
		}
	}
	deriveNextAutoLevel(nextLevel) {
		const { maxAutoLevel, minAutoLevel } = this.hls;
		return Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
	}
};
var BinarySearch = { 
/**
* Searches for an item in an array which matches a certain condition.
* This requires the condition to only match one item in the array,
* and for the array to be ordered.
*
* @param list The array to search.
* @param comparisonFn
*      Called and provided a candidate item as the first argument.
*      Should return:
*          > -1 if the item should be located at a lower index than the provided item.
*          > 1 if the item should be located at a higher index than the provided item.
*          > 0 if the item is the item you're looking for.
*
* @returns the object if found, otherwise returns null
*/
search: function(list, comparisonFn) {
	let minIndex = 0;
	let maxIndex = list.length - 1;
	let currentIndex = null;
	let currentElement = null;
	while (minIndex <= maxIndex) {
		currentIndex = (minIndex + maxIndex) / 2 | 0;
		currentElement = list[currentIndex];
		const comparisonResult = comparisonFn(currentElement);
		if (comparisonResult > 0) minIndex = currentIndex + 1;
		else if (comparisonResult < 0) maxIndex = currentIndex - 1;
		else return currentElement;
	}
	return null;
} };
/**
* Returns first fragment whose endPdt value exceeds the given PDT, or null.
* @param fragments - The array of candidate fragments
* @param PDTValue - The PDT value which must be exceeded
* @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
*/
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
	if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) return null;
	if (PDTValue < (fragments[0].programDateTime || 0)) return null;
	if (PDTValue >= (fragments[fragments.length - 1].endProgramDateTime || 0)) return null;
	for (let seg = 0; seg < fragments.length; ++seg) {
		const frag = fragments[seg];
		if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
	}
	return null;
}
/**
* Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
* This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
* breaking any traps which would cause the same fragment to be continuously selected within a small range.
* @param fragPrevious - The last frag successfully appended
* @param fragments - The array of candidate fragments
* @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
* @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
* @returns a matching fragment or null
*/
function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = .005) {
	let fragNext = null;
	if (fragPrevious) {
		fragNext = fragments[1 + fragPrevious.sn - fragments[0].sn] || null;
		const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
		if (bufferEdgeError > 0 && bufferEdgeError < 15e-7) bufferEnd += 15e-7;
		if (fragNext && fragPrevious.level !== fragNext.level && fragNext.end <= fragPrevious.end) fragNext = fragments[2 + fragPrevious.sn - fragments[0].sn] || null;
	} else if (bufferEnd === 0 && fragments[0].start === 0) fragNext = fragments[0];
	if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) return fragNext;
	const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
	if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) return foundFragment;
	return fragNext;
}
function fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
	if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
		const firstDuration = fragPrevious.tagList.reduce((duration, tag) => {
			if (tag[0] === "INF") duration += parseFloat(tag[1]);
			return duration;
		}, nextFragLookupTolerance);
		return fragNext.start <= firstDuration;
	}
	return false;
}
/**
* The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
* @param candidate - The fragment to test
* @param bufferEnd - The end of the current buffered range the playhead is currently within
* @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
* @returns 0 if it matches, 1 if too low, -1 if too high
*/
function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
	if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) return 0;
	const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
	if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
	else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) return -1;
	return 0;
}
/**
* The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
* This function tests the candidate's program date time values, as represented in Unix time
* @param candidate - The fragment to test
* @param pdtBufferEnd - The Unix time representing the end of the current buffered range
* @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
* @returns true if contiguous, false otherwise
*/
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
	const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1e3;
	return (candidate.endProgramDateTime || 0) - candidateLookupTolerance > pdtBufferEnd;
}
function findNearestWithCC(details, cc, pos) {
	if (details) {
		if (details.startCC <= cc && details.endCC >= cc) {
			let fragments = details.fragments;
			const { fragmentHint } = details;
			if (fragmentHint) fragments = fragments.concat(fragmentHint);
			let closest;
			BinarySearch.search(fragments, (candidate) => {
				if (candidate.cc < cc) return 1;
				if (candidate.cc > cc) return -1;
				closest = candidate;
				if (candidate.end <= pos) return 1;
				if (candidate.start > pos) return -1;
				return 0;
			});
			return closest || null;
		}
	}
	return null;
}
function isTimeoutError(error) {
	switch (error.details) {
		case ErrorDetails.FRAG_LOAD_TIMEOUT:
		case ErrorDetails.KEY_LOAD_TIMEOUT:
		case ErrorDetails.LEVEL_LOAD_TIMEOUT:
		case ErrorDetails.MANIFEST_LOAD_TIMEOUT: return true;
	}
	return false;
}
function isKeyError(error) {
	return error.details.startsWith("key");
}
function isUnusableKeyError(error) {
	return isKeyError(error) && !!error.frag && !error.frag.decryptdata;
}
function getRetryConfig(loadPolicy, error) {
	const isTimeout = isTimeoutError(error);
	return loadPolicy.default[`${isTimeout ? "timeout" : "error"}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
	const backoffFactor = retryConfig.backoff === "linear" ? 1 : Math.pow(2, retryCount);
	return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
	return _objectSpread2(_objectSpread2({}, loderConfig), {
		errorRetry: null,
		timeoutRetry: null
	});
}
function shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
	if (!retryConfig) return false;
	const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
	const retry = retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
	return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function retryForHttpStatus(httpStatus) {
	return offlineHttpStatus(httpStatus) || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}
function offlineHttpStatus(httpStatus) {
	return httpStatus === 0 && navigator.onLine === false;
}
var NetworkErrorAction = {
	DoNothing: 0,
	SendEndCallback: 1,
	SendAlternateToPenaltyBox: 2,
	RemoveAlternatePermanently: 3,
	InsertDiscontinuity: 4,
	RetryRequest: 5
};
var ErrorActionFlags = {
	None: 0,
	MoveAllAlternatesMatchingHost: 1,
	MoveAllAlternatesMatchingHDCP: 2,
	MoveAllAlternatesMatchingKey: 4,
	SwitchToSDR: 8
};
var ErrorController = class extends Logger {
	constructor(hls) {
		super("error-controller", hls.logger);
		this.hls = void 0;
		this.playlistError = 0;
		this.hls = hls;
		this.registerListeners();
	}
	registerListeners() {
		const hls = this.hls;
		hls.on(Events.ERROR, this.onError, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
	}
	unregisterListeners() {
		const hls = this.hls;
		if (!hls) return;
		hls.off(Events.ERROR, this.onError, this);
		hls.off(Events.ERROR, this.onErrorOut, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
	}
	destroy() {
		this.unregisterListeners();
		this.hls = null;
	}
	startLoad(startPosition) {}
	stopLoad() {
		this.playlistError = 0;
	}
	getVariantLevelIndex(frag) {
		if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN) return frag.level;
		return this.getVariantIndex();
	}
	getVariantIndex() {
		var _hls$loadLevelObj;
		const hls = this.hls;
		const currentLevel = hls.currentLevel;
		if ((_hls$loadLevelObj = hls.loadLevelObj) != null && _hls$loadLevelObj.details || currentLevel === -1) return hls.loadLevel;
		return currentLevel;
	}
	variantHasKey(level, keyInError) {
		if (level) {
			var _level$details;
			if ((_level$details = level.details) != null && _level$details.hasKey(keyInError)) return true;
			const audioGroupsIds = level.audioGroups;
			if (audioGroupsIds) return this.hls.allAudioTracks.filter((track) => audioGroupsIds.indexOf(track.groupId) >= 0).some((track) => {
				var _track$details;
				return (_track$details = track.details) == null ? void 0 : _track$details.hasKey(keyInError);
			});
		}
		return false;
	}
	onManifestLoading() {
		this.playlistError = 0;
	}
	onLevelUpdated() {
		this.playlistError = 0;
	}
	onError(event, data) {
		var _data$frag;
		if (data.fatal) return;
		const hls = this.hls;
		const context = data.context;
		switch (data.details) {
			case ErrorDetails.FRAG_LOAD_ERROR:
			case ErrorDetails.FRAG_LOAD_TIMEOUT:
			case ErrorDetails.KEY_LOAD_ERROR:
			case ErrorDetails.KEY_LOAD_TIMEOUT:
				data.errorAction = this.getFragRetryOrSwitchAction(data);
				return;
			case ErrorDetails.FRAG_PARSING_ERROR: if ((_data$frag = data.frag) != null && _data$frag.gap) {
				data.errorAction = createDoNothingErrorAction();
				return;
			}
			case ErrorDetails.FRAG_GAP:
			case ErrorDetails.FRAG_DECRYPT_ERROR:
				data.errorAction = this.getFragRetryOrSwitchAction(data);
				data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
				return;
			case ErrorDetails.LEVEL_EMPTY_ERROR:
			case ErrorDetails.LEVEL_PARSING_ERROR:
				{
					var _data$context;
					const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
					if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context = _data$context.levelDetails) != null && _data$context.live)) data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
					else {
						data.levelRetry = false;
						data.errorAction = this.getLevelSwitchAction(data, levelIndex);
					}
				}
				return;
			case ErrorDetails.LEVEL_LOAD_ERROR:
			case ErrorDetails.LEVEL_LOAD_TIMEOUT:
				if (typeof (context == null ? void 0 : context.level) === "number") data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
				return;
			case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
			case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
			case ErrorDetails.SUBTITLE_LOAD_ERROR:
			case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
				if (context) {
					const level = hls.loadLevelObj;
					if (level && (context.type === PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
						data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
						data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
						data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
						return;
					}
				}
				return;
			case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
				data.errorAction = {
					action: NetworkErrorAction.SendAlternateToPenaltyBox,
					flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP
				};
				return;
			case ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED:
			case ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR:
			case ErrorDetails.KEY_SYSTEM_NO_SESSION:
				data.errorAction = {
					action: NetworkErrorAction.SendAlternateToPenaltyBox,
					flags: ErrorActionFlags.MoveAllAlternatesMatchingKey
				};
				return;
			case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
			case ErrorDetails.REMUX_ALLOC_ERROR:
			case ErrorDetails.BUFFER_APPEND_ERROR:
				if (!data.errorAction) {
					var _data$level;
					data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
				}
				return;
			case ErrorDetails.INTERNAL_EXCEPTION:
			case ErrorDetails.BUFFER_APPENDING_ERROR:
			case ErrorDetails.BUFFER_FULL_ERROR:
			case ErrorDetails.LEVEL_SWITCH_ERROR:
			case ErrorDetails.BUFFER_STALLED_ERROR:
			case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
			case ErrorDetails.BUFFER_NUDGE_ON_STALL:
				data.errorAction = createDoNothingErrorAction();
				return;
		}
		if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
			data.levelRetry = false;
			data.errorAction = createDoNothingErrorAction();
		}
	}
	getPlaylistRetryOrSwitchAction(data, levelIndex) {
		const hls = this.hls;
		const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
		const retryCount = this.playlistError++;
		if (shouldRetry(retryConfig, retryCount, isTimeoutError(data), data.response)) return {
			action: NetworkErrorAction.RetryRequest,
			flags: ErrorActionFlags.None,
			retryConfig,
			retryCount
		};
		const errorAction = this.getLevelSwitchAction(data, levelIndex);
		if (retryConfig) {
			errorAction.retryConfig = retryConfig;
			errorAction.retryCount = retryCount;
		}
		return errorAction;
	}
	getFragRetryOrSwitchAction(data) {
		const hls = this.hls;
		const variantLevelIndex = this.getVariantLevelIndex(data.frag);
		const level = hls.levels[variantLevelIndex];
		const { fragLoadPolicy, keyLoadPolicy } = hls.config;
		const retryConfig = getRetryConfig(isKeyError(data) ? keyLoadPolicy : fragLoadPolicy, data);
		const fragmentErrors = hls.levels.reduce((acc, level) => acc + level.fragmentError, 0);
		if (level) {
			if (data.details !== ErrorDetails.FRAG_GAP) level.fragmentError++;
			if (!isUnusableKeyError(data)) {
				if (shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), data.response)) return {
					action: NetworkErrorAction.RetryRequest,
					flags: ErrorActionFlags.None,
					retryConfig,
					retryCount: fragmentErrors
				};
			}
		}
		const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
		if (retryConfig) {
			errorAction.retryConfig = retryConfig;
			errorAction.retryCount = fragmentErrors;
		}
		return errorAction;
	}
	getLevelSwitchAction(data, levelIndex) {
		const hls = this.hls;
		if (levelIndex === null || levelIndex === void 0) levelIndex = hls.loadLevel;
		const level = this.hls.levels[levelIndex];
		if (level) {
			var _data$frag2, _data$context2;
			const errorDetails = data.details;
			level.loadError++;
			if (errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) level.fragmentError++;
			let nextLevel = -1;
			const { levels, loadLevel, minAutoLevel, maxAutoLevel } = hls;
			if (!hls.autoLevelEnabled && !hls.config.preserveManualLevelOnError) hls.loadLevel = -1;
			const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
			const findAudioCodecAlternate = (fragErrorType === PlaylistLevelType.AUDIO && errorDetails === ErrorDetails.FRAG_PARSING_ERROR || data.sourceBufferName === "audio" && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR)) && levels.some(({ audioCodec }) => level.audioCodec !== audioCodec);
			const findVideoCodecAlternate = data.sourceBufferName === "video" && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) && levels.some(({ codecSet, audioCodec }) => level.codecSet !== codecSet && level.audioCodec === audioCodec);
			const { type: playlistErrorType, groupId: playlistErrorGroupId } = (_data$context2 = data.context) != null ? _data$context2 : {};
			for (let i = levels.length; i--;) {
				const candidate = (i + loadLevel) % levels.length;
				if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
					var _level$audioGroups, _level$subtitleGroups;
					const levelCandidate = levels[candidate];
					if (errorDetails === ErrorDetails.FRAG_GAP && fragErrorType === PlaylistLevelType.MAIN && data.frag) {
						const levelDetails = levels[candidate].details;
						if (levelDetails) {
							const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
							if (fragCandidate != null && fragCandidate.gap) continue;
						}
					} else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) continue;
					else if (fragErrorType === PlaylistLevelType.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some((groupId) => levelCandidate.hasAudioGroup(groupId)) || fragErrorType === PlaylistLevelType.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some((groupId) => levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet || !findAudioCodecAlternate && level.codecSet !== levelCandidate.codecSet) continue;
					nextLevel = candidate;
					break;
				}
			}
			if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
				data.levelRetry = true;
				this.playlistError = 0;
				return {
					action: NetworkErrorAction.SendAlternateToPenaltyBox,
					flags: ErrorActionFlags.None,
					nextAutoLevel: nextLevel
				};
			}
		}
		return {
			action: NetworkErrorAction.SendAlternateToPenaltyBox,
			flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
		};
	}
	onErrorOut(event, data) {
		var _data$errorAction;
		switch ((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action) {
			case NetworkErrorAction.DoNothing: break;
			case NetworkErrorAction.SendAlternateToPenaltyBox:
				this.sendAlternateToPenaltyBox(data);
				if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) data.fatal = true;
				else if (/MediaSource readyState: ended/.test(data.error.message)) {
					this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
					this.hls.recoverMediaError();
				}
				break;
			case NetworkErrorAction.RetryRequest: break;
		}
		if (data.fatal) {
			this.hls.stopLoad();
			return;
		}
	}
	sendAlternateToPenaltyBox(data) {
		const hls = this.hls;
		const errorAction = data.errorAction;
		if (!errorAction) return;
		const { flags } = errorAction;
		const nextAutoLevel = errorAction.nextAutoLevel;
		switch (flags) {
			case ErrorActionFlags.None:
				this.switchLevel(data, nextAutoLevel);
				break;
			case ErrorActionFlags.MoveAllAlternatesMatchingHDCP: {
				const levelIndex = this.getVariantLevelIndex(data.frag);
				const level = hls.levels[levelIndex];
				const restrictedHdcpLevel = level == null ? void 0 : level.attrs["HDCP-LEVEL"];
				errorAction.hdcpLevel = restrictedHdcpLevel;
				if (restrictedHdcpLevel === "NONE") this.warn(`HDCP policy resticted output with HDCP-LEVEL=NONE`);
				else if (restrictedHdcpLevel) {
					hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(restrictedHdcpLevel) - 1];
					errorAction.resolved = true;
					this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
					break;
				}
			}
			case ErrorActionFlags.MoveAllAlternatesMatchingKey: {
				const levelKey = data.decryptdata;
				if (levelKey) {
					const levels = this.hls.levels;
					const levelCountWithError = levels.length;
					for (let i = levelCountWithError; i--;) if (this.variantHasKey(levels[i], levelKey)) {
						var _levels$i$audioGroups, _data$frag3;
						this.log(`Banned key found in level ${i} (${levels[i].bitrate}bps) or audio group "${(_levels$i$audioGroups = levels[i].audioGroups) == null ? void 0 : _levels$i$audioGroups.join(",")}" (${(_data$frag3 = data.frag) == null ? void 0 : _data$frag3.type} fragment) ${arrayToHex(levelKey.keyId || [])}`);
						levels[i].fragmentError++;
						levels[i].loadError++;
						this.log(`Removing level ${i} with key error (${data.error})`);
						this.hls.removeLevel(i);
					}
					const frag = data.frag;
					if (this.hls.levels.length < levelCountWithError) errorAction.resolved = true;
					else if (frag && frag.type !== PlaylistLevelType.MAIN) {
						const fragLevelKey = frag.decryptdata;
						if (fragLevelKey && !levelKey.matches(fragLevelKey)) errorAction.resolved = true;
					}
				}
				break;
			}
		}
		if (!errorAction.resolved) this.switchLevel(data, nextAutoLevel);
	}
	switchLevel(data, levelIndex) {
		if (levelIndex !== void 0 && data.errorAction) {
			this.warn(`switching to level ${levelIndex} after ${data.details}`);
			this.hls.nextAutoLevel = levelIndex;
			data.errorAction.resolved = true;
			this.hls.nextLoadLevel = this.hls.nextAutoLevel;
			if (data.details === ErrorDetails.BUFFER_ADD_CODEC_ERROR && data.mimeType && data.sourceBufferName !== "audiovideo") {
				const codec = getCodecsForMimeType(data.mimeType);
				const levels = this.hls.levels;
				for (let i = levels.length; i--;) if (levels[i][`${data.sourceBufferName}Codec`] === codec) {
					this.log(`Removing level ${i} for ${data.details} ("${codec}" not supported)`);
					this.hls.removeLevel(i);
				}
			}
		}
	}
};
function createDoNothingErrorAction(resolved) {
	const errorAction = {
		action: NetworkErrorAction.DoNothing,
		flags: ErrorActionFlags.None
	};
	if (resolved) errorAction.resolved = true;
	return errorAction;
}
var FragmentState = {
	NOT_LOADED: "NOT_LOADED",
	APPENDING: "APPENDING",
	PARTIAL: "PARTIAL",
	OK: "OK"
};
var FragmentTracker = class {
	constructor(hls) {
		this.activePartLists = Object.create(null);
		this.endListFragments = Object.create(null);
		this.fragments = Object.create(null);
		this.timeRanges = Object.create(null);
		this.bufferPadding = .2;
		this.hls = void 0;
		this.hasGaps = false;
		this.hls = hls;
		this._registerListeners();
	}
	_registerListeners() {
		const { hls } = this;
		if (hls) {
			hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
			hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
			hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
		}
	}
	_unregisterListeners() {
		const { hls } = this;
		if (hls) {
			hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
			hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
			hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
		}
	}
	destroy() {
		this._unregisterListeners();
		this.hls = this.fragments = this.activePartLists = this.endListFragments = this.timeRanges = null;
	}
	/**
	* Return a Fragment or Part with an appended range that matches the position and levelType
	* Otherwise, return null
	*/
	getAppendedFrag(position, levelType) {
		const activeParts = this.activePartLists[levelType];
		if (activeParts) for (let i = activeParts.length; i--;) {
			const activePart = activeParts[i];
			if (!activePart) break;
			if (activePart.start <= position && position <= activePart.end && activePart.loaded) return activePart;
		}
		return this.getBufferedFrag(position, levelType);
	}
	/**
	* Return a buffered Fragment that matches the position and levelType.
	* A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
	* If not found any Fragment, return null
	*/
	getBufferedFrag(position, levelType) {
		return this.getFragAtPos(position, levelType, true);
	}
	getFragAtPos(position, levelType, buffered) {
		const { fragments } = this;
		const keys = Object.keys(fragments);
		for (let i = keys.length; i--;) {
			const fragmentEntity = fragments[keys[i]];
			if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && (!buffered || fragmentEntity.buffered)) {
				const frag = fragmentEntity.body;
				if (frag.start <= position && position <= frag.end) return frag;
			}
		}
		return null;
	}
	/**
	* Partial fragments effected by coded frame eviction will be removed
	* The browser will unload parts of the buffer to free up memory for new buffer data
	* Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
	*/
	detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart, removeAppending) {
		if (this.timeRanges) this.timeRanges[elementaryStream] = timeRange;
		const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
		Object.keys(this.fragments).forEach((key) => {
			const fragmentEntity = this.fragments[key];
			if (!fragmentEntity) return;
			if (appendedPartSn >= fragmentEntity.body.sn) return;
			if (!fragmentEntity.buffered && (!fragmentEntity.loaded || removeAppending)) {
				if (fragmentEntity.body.type === playlistType) this.removeFragment(fragmentEntity.body);
				return;
			}
			const esData = fragmentEntity.range[elementaryStream];
			if (!esData) return;
			if (esData.time.length === 0) {
				this.removeFragment(fragmentEntity.body);
				return;
			}
			esData.time.some((time) => {
				const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
				if (isNotBuffered) this.removeFragment(fragmentEntity.body);
				return isNotBuffered;
			});
		});
	}
	/**
	* Checks if the fragment passed in is loaded in the buffer properly
	* Partially loaded fragments will be registered as a partial fragment
	*/
	detectPartialFragments(data) {
		const timeRanges = this.timeRanges;
		if (!timeRanges || data.frag.sn === "initSegment") return;
		const frag = data.frag;
		const fragKey = getFragmentKey(frag);
		const fragmentEntity = this.fragments[fragKey];
		if (!fragmentEntity || fragmentEntity.buffered && frag.gap) return;
		const isFragHint = !frag.relurl;
		Object.keys(timeRanges).forEach((elementaryStream) => {
			const streamInfo = frag.elementaryStreams[elementaryStream];
			if (!streamInfo) return;
			const timeRange = timeRanges[elementaryStream];
			const partial = isFragHint || streamInfo.partial === true;
			fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, data.part, partial, timeRange);
		});
		fragmentEntity.loaded = null;
		if (Object.keys(fragmentEntity.range).length) {
			this.bufferedEnd(fragmentEntity, frag);
			if (!isPartial(fragmentEntity)) this.removeParts(frag.sn - 1, frag.type);
		} else this.removeFragment(fragmentEntity.body);
	}
	bufferedEnd(fragmentEntity, frag) {
		fragmentEntity.buffered = true;
		if (fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList) this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
	}
	removeParts(snToKeep, levelType) {
		const activeParts = this.activePartLists[levelType];
		if (!activeParts) return;
		this.activePartLists[levelType] = filterParts(activeParts, (part) => part.fragment.sn >= snToKeep);
	}
	fragBuffered(frag, force) {
		const fragKey = getFragmentKey(frag);
		let fragmentEntity = this.fragments[fragKey];
		if (!fragmentEntity && force) {
			fragmentEntity = this.fragments[fragKey] = {
				body: frag,
				appendedPTS: null,
				loaded: null,
				buffered: false,
				range: Object.create(null)
			};
			if (frag.gap) this.hasGaps = true;
		}
		if (fragmentEntity) {
			fragmentEntity.loaded = null;
			this.bufferedEnd(fragmentEntity, frag);
		}
	}
	getBufferedTimes(fragment, part, partial, timeRange) {
		const buffered = {
			time: [],
			partial
		};
		const startPTS = fragment.start;
		const endPTS = fragment.end;
		const minEndPTS = fragment.minEndPTS || endPTS;
		const maxStartPTS = fragment.maxStartPTS || startPTS;
		for (let i = 0; i < timeRange.length; i++) {
			const startTime = timeRange.start(i) - this.bufferPadding;
			const endTime = timeRange.end(i) + this.bufferPadding;
			if (maxStartPTS >= startTime && minEndPTS <= endTime) {
				buffered.time.push({
					startPTS: Math.max(startPTS, timeRange.start(i)),
					endPTS: Math.min(endPTS, timeRange.end(i))
				});
				break;
			} else if (startPTS < endTime && endPTS > startTime) {
				const start = Math.max(startPTS, timeRange.start(i));
				const end = Math.min(endPTS, timeRange.end(i));
				if (end > start) {
					buffered.partial = true;
					buffered.time.push({
						startPTS: start,
						endPTS: end
					});
				}
			} else if (endPTS <= startTime) break;
		}
		return buffered;
	}
	/**
	* Gets the partial fragment for a certain time
	*/
	getPartialFragment(time) {
		let bestFragment = null;
		let timePadding;
		let startTime;
		let endTime;
		let bestOverlap = 0;
		const { bufferPadding, fragments } = this;
		Object.keys(fragments).forEach((key) => {
			const fragmentEntity = fragments[key];
			if (!fragmentEntity) return;
			if (isPartial(fragmentEntity)) {
				startTime = fragmentEntity.body.start - bufferPadding;
				endTime = fragmentEntity.body.end + bufferPadding;
				if (time >= startTime && time <= endTime) {
					timePadding = Math.min(time - startTime, endTime - time);
					if (bestOverlap <= timePadding) {
						bestFragment = fragmentEntity.body;
						bestOverlap = timePadding;
					}
				}
			}
		});
		return bestFragment;
	}
	isEndListAppended(type) {
		const lastFragmentEntity = this.endListFragments[type];
		return lastFragmentEntity !== void 0 && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
	}
	getState(fragment) {
		const fragKey = getFragmentKey(fragment);
		const fragmentEntity = this.fragments[fragKey];
		if (fragmentEntity) if (!fragmentEntity.buffered) return FragmentState.APPENDING;
		else if (isPartial(fragmentEntity)) return FragmentState.PARTIAL;
		else return FragmentState.OK;
		return FragmentState.NOT_LOADED;
	}
	isTimeBuffered(startPTS, endPTS, timeRange) {
		let startTime;
		let endTime;
		for (let i = 0; i < timeRange.length; i++) {
			startTime = timeRange.start(i) - this.bufferPadding;
			endTime = timeRange.end(i) + this.bufferPadding;
			if (startPTS >= startTime && endPTS <= endTime) return true;
			if (endPTS <= startTime) return false;
		}
		return false;
	}
	onManifestLoading() {
		this.removeAllFragments();
	}
	onFragLoaded(event, data) {
		if (data.frag.sn === "initSegment" || data.frag.bitrateTest) return;
		const frag = data.frag;
		const loaded = data.part ? null : data;
		const fragKey = getFragmentKey(frag);
		this.fragments[fragKey] = {
			body: frag,
			appendedPTS: null,
			loaded,
			buffered: false,
			range: Object.create(null)
		};
	}
	onBufferAppended(event, data) {
		const { frag, part, timeRanges, type } = data;
		if (frag.sn === "initSegment") return;
		const playlistType = frag.type;
		if (part) {
			let activeParts = this.activePartLists[playlistType];
			if (!activeParts) this.activePartLists[playlistType] = activeParts = [];
			activeParts.push(part);
		}
		this.timeRanges = timeRanges;
		const timeRange = timeRanges[type];
		this.detectEvictedFragments(type, timeRange, playlistType, part);
	}
	onFragBuffered(event, data) {
		this.detectPartialFragments(data);
	}
	hasFragment(fragment) {
		const fragKey = getFragmentKey(fragment);
		return !!this.fragments[fragKey];
	}
	hasFragments(type) {
		const { fragments } = this;
		const keys = Object.keys(fragments);
		if (!type) return keys.length > 0;
		for (let i = keys.length; i--;) {
			const fragmentEntity = fragments[keys[i]];
			if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === type) return true;
		}
		return false;
	}
	hasParts(type) {
		var _this$activePartLists;
		return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
	}
	removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
		if (withGapOnly && !this.hasGaps) return;
		Object.keys(this.fragments).forEach((key) => {
			const fragmentEntity = this.fragments[key];
			if (!fragmentEntity) return;
			const frag = fragmentEntity.body;
			if (frag.type !== playlistType || withGapOnly && !frag.gap) return;
			if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) this.removeFragment(frag);
		});
	}
	removeFragment(fragment) {
		const fragKey = getFragmentKey(fragment);
		fragment.clearElementaryStreamInfo();
		const activeParts = this.activePartLists[fragment.type];
		if (activeParts) {
			const snToRemove = fragment.sn;
			this.activePartLists[fragment.type] = filterParts(activeParts, (part) => part.fragment.sn !== snToRemove);
		}
		delete this.fragments[fragKey];
		if (fragment.endList) delete this.endListFragments[fragment.type];
	}
	removeAllFragments() {
		var _this$hls;
		this.fragments = Object.create(null);
		this.endListFragments = Object.create(null);
		this.activePartLists = Object.create(null);
		this.hasGaps = false;
		const partlist = (_this$hls = this.hls) == null || (_this$hls = _this$hls.latestLevelDetails) == null ? void 0 : _this$hls.partList;
		if (partlist) partlist.forEach((part) => part.clearElementaryStreamInfo());
	}
};
function isPartial(fragmentEntity) {
	var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
	return fragmentEntity.buffered && !!(fragmentEntity.body.gap || (_fragmentEntity$range = fragmentEntity.range.video) != null && _fragmentEntity$range.partial || (_fragmentEntity$range2 = fragmentEntity.range.audio) != null && _fragmentEntity$range2.partial || (_fragmentEntity$range3 = fragmentEntity.range.audiovideo) != null && _fragmentEntity$range3.partial);
}
function getFragmentKey(fragment) {
	return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}
function filterParts(partList, predicate) {
	return partList.filter((part) => {
		const keep = predicate(part);
		if (!keep) part.clearElementaryStreamInfo();
		return keep;
	});
}
var DecrypterAesMode = {
	cbc: 0,
	ctr: 1
};
var AESCrypto = class {
	constructor(subtle, iv, aesMode) {
		this.subtle = void 0;
		this.aesIV = void 0;
		this.aesMode = void 0;
		this.subtle = subtle;
		this.aesIV = iv;
		this.aesMode = aesMode;
	}
	decrypt(data, key) {
		switch (this.aesMode) {
			case DecrypterAesMode.cbc: return this.subtle.decrypt({
				name: "AES-CBC",
				iv: this.aesIV
			}, key, data);
			case DecrypterAesMode.ctr: return this.subtle.decrypt({
				name: "AES-CTR",
				counter: this.aesIV,
				length: 64
			}, key, data);
			default: throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
		}
	}
};
function removePadding(array) {
	const outputBytes = array.byteLength;
	const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
	if (paddingBytes) return array.slice(0, outputBytes - paddingBytes);
	return array;
}
var AESDecryptor = class {
	constructor() {
		this.rcon = [
			0,
			1,
			2,
			4,
			8,
			16,
			32,
			64,
			128,
			27,
			54
		];
		this.subMix = [
			new Uint32Array(256),
			new Uint32Array(256),
			new Uint32Array(256),
			new Uint32Array(256)
		];
		this.invSubMix = [
			new Uint32Array(256),
			new Uint32Array(256),
			new Uint32Array(256),
			new Uint32Array(256)
		];
		this.sBox = new Uint32Array(256);
		this.invSBox = new Uint32Array(256);
		this.key = new Uint32Array(0);
		this.ksRows = 0;
		this.keySize = 0;
		this.keySchedule = void 0;
		this.invKeySchedule = void 0;
		this.initTable();
	}
	uint8ArrayToUint32Array_(arrayBuffer) {
		const view = new DataView(arrayBuffer);
		const newArray = new Uint32Array(4);
		for (let i = 0; i < 4; i++) newArray[i] = view.getUint32(i * 4);
		return newArray;
	}
	initTable() {
		const sBox = this.sBox;
		const invSBox = this.invSBox;
		const subMix = this.subMix;
		const subMix0 = subMix[0];
		const subMix1 = subMix[1];
		const subMix2 = subMix[2];
		const subMix3 = subMix[3];
		const invSubMix = this.invSubMix;
		const invSubMix0 = invSubMix[0];
		const invSubMix1 = invSubMix[1];
		const invSubMix2 = invSubMix[2];
		const invSubMix3 = invSubMix[3];
		const d = new Uint32Array(256);
		let x = 0;
		let xi = 0;
		let i = 0;
		for (i = 0; i < 256; i++) if (i < 128) d[i] = i << 1;
		else d[i] = i << 1 ^ 283;
		for (i = 0; i < 256; i++) {
			let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
			sx = sx >>> 8 ^ sx & 255 ^ 99;
			sBox[x] = sx;
			invSBox[sx] = x;
			const x2 = d[x];
			const x4 = d[x2];
			const x8 = d[x4];
			let t = d[sx] * 257 ^ sx * 16843008;
			subMix0[x] = t << 24 | t >>> 8;
			subMix1[x] = t << 16 | t >>> 16;
			subMix2[x] = t << 8 | t >>> 24;
			subMix3[x] = t;
			t = x8 * 16843009 ^ x4 * 65537 ^ x2 * 257 ^ x * 16843008;
			invSubMix0[sx] = t << 24 | t >>> 8;
			invSubMix1[sx] = t << 16 | t >>> 16;
			invSubMix2[sx] = t << 8 | t >>> 24;
			invSubMix3[sx] = t;
			if (!x) x = xi = 1;
			else {
				x = x2 ^ d[d[d[x8 ^ x2]]];
				xi ^= d[d[xi]];
			}
		}
	}
	expandKey(keyBuffer) {
		const key = this.uint8ArrayToUint32Array_(keyBuffer);
		let sameKey = true;
		let offset = 0;
		while (offset < key.length && sameKey) {
			sameKey = key[offset] === this.key[offset];
			offset++;
		}
		if (sameKey) return;
		this.key = key;
		const keySize = this.keySize = key.length;
		if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error("Invalid aes key size=" + keySize);
		const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
		let ksRow;
		let invKsRow;
		const keySchedule = this.keySchedule = new Uint32Array(ksRows);
		const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
		const sbox = this.sBox;
		const rcon = this.rcon;
		const invSubMix = this.invSubMix;
		const invSubMix0 = invSubMix[0];
		const invSubMix1 = invSubMix[1];
		const invSubMix2 = invSubMix[2];
		const invSubMix3 = invSubMix[3];
		let prev;
		let t;
		for (ksRow = 0; ksRow < ksRows; ksRow++) {
			if (ksRow < keySize) {
				prev = keySchedule[ksRow] = key[ksRow];
				continue;
			}
			t = prev;
			if (ksRow % keySize === 0) {
				t = t << 8 | t >>> 24;
				t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 255] << 16 | sbox[t >>> 8 & 255] << 8 | sbox[t & 255];
				t ^= rcon[ksRow / keySize | 0] << 24;
			} else if (keySize > 6 && ksRow % keySize === 4) t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 255] << 16 | sbox[t >>> 8 & 255] << 8 | sbox[t & 255];
			keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
		}
		for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
			ksRow = ksRows - invKsRow;
			if (invKsRow & 3) t = keySchedule[ksRow];
			else t = keySchedule[ksRow - 4];
			if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
			else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 255]] ^ invSubMix2[sbox[t >>> 8 & 255]] ^ invSubMix3[sbox[t & 255]];
			invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
		}
	}
	networkToHostOrderSwap(word) {
		return word << 24 | (word & 65280) << 8 | (word & 16711680) >> 8 | word >>> 24;
	}
	decrypt(inputArrayBuffer, offset, aesIV) {
		const nRounds = this.keySize + 6;
		const invKeySchedule = this.invKeySchedule;
		const invSBOX = this.invSBox;
		const invSubMix = this.invSubMix;
		const invSubMix0 = invSubMix[0];
		const invSubMix1 = invSubMix[1];
		const invSubMix2 = invSubMix[2];
		const invSubMix3 = invSubMix[3];
		const initVector = this.uint8ArrayToUint32Array_(aesIV);
		let initVector0 = initVector[0];
		let initVector1 = initVector[1];
		let initVector2 = initVector[2];
		let initVector3 = initVector[3];
		const inputInt32 = new Int32Array(inputArrayBuffer);
		const outputInt32 = new Int32Array(inputInt32.length);
		let t0, t1, t2, t3;
		let s0, s1, s2, s3;
		let inputWords0, inputWords1, inputWords2, inputWords3;
		let ksRow, i;
		const swapWord = this.networkToHostOrderSwap;
		while (offset < inputInt32.length) {
			inputWords0 = swapWord(inputInt32[offset]);
			inputWords1 = swapWord(inputInt32[offset + 1]);
			inputWords2 = swapWord(inputInt32[offset + 2]);
			inputWords3 = swapWord(inputInt32[offset + 3]);
			s0 = inputWords0 ^ invKeySchedule[0];
			s1 = inputWords3 ^ invKeySchedule[1];
			s2 = inputWords2 ^ invKeySchedule[2];
			s3 = inputWords1 ^ invKeySchedule[3];
			ksRow = 4;
			for (i = 1; i < nRounds; i++) {
				t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 255] ^ invSubMix2[s2 >> 8 & 255] ^ invSubMix3[s3 & 255] ^ invKeySchedule[ksRow];
				t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 255] ^ invSubMix2[s3 >> 8 & 255] ^ invSubMix3[s0 & 255] ^ invKeySchedule[ksRow + 1];
				t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 255] ^ invSubMix2[s0 >> 8 & 255] ^ invSubMix3[s1 & 255] ^ invKeySchedule[ksRow + 2];
				t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 255] ^ invSubMix2[s1 >> 8 & 255] ^ invSubMix3[s2 & 255] ^ invKeySchedule[ksRow + 3];
				s0 = t0;
				s1 = t1;
				s2 = t2;
				s3 = t3;
				ksRow = ksRow + 4;
			}
			t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 255] << 16 ^ invSBOX[s2 >> 8 & 255] << 8 ^ invSBOX[s3 & 255] ^ invKeySchedule[ksRow];
			t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 255] << 16 ^ invSBOX[s3 >> 8 & 255] << 8 ^ invSBOX[s0 & 255] ^ invKeySchedule[ksRow + 1];
			t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 255] << 16 ^ invSBOX[s0 >> 8 & 255] << 8 ^ invSBOX[s1 & 255] ^ invKeySchedule[ksRow + 2];
			t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 255] << 16 ^ invSBOX[s1 >> 8 & 255] << 8 ^ invSBOX[s2 & 255] ^ invKeySchedule[ksRow + 3];
			outputInt32[offset] = swapWord(t0 ^ initVector0);
			outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
			outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
			outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
			initVector0 = inputWords0;
			initVector1 = inputWords1;
			initVector2 = inputWords2;
			initVector3 = inputWords3;
			offset = offset + 4;
		}
		return outputInt32.buffer;
	}
};
var FastAESKey = class {
	constructor(subtle, key, aesMode) {
		this.subtle = void 0;
		this.key = void 0;
		this.aesMode = void 0;
		this.subtle = subtle;
		this.key = key;
		this.aesMode = aesMode;
	}
	expandKey() {
		const subtleAlgoName = getSubtleAlgoName(this.aesMode);
		return this.subtle.importKey("raw", this.key, { name: subtleAlgoName }, false, ["encrypt", "decrypt"]);
	}
};
function getSubtleAlgoName(aesMode) {
	switch (aesMode) {
		case DecrypterAesMode.cbc: return "AES-CBC";
		case DecrypterAesMode.ctr: return "AES-CTR";
		default: throw new Error(`[FastAESKey] invalid aes mode ${aesMode}`);
	}
}
var CHUNK_SIZE = 16;
var Decrypter = class {
	constructor(config, { removePKCS7Padding = true } = {}) {
		this.logEnabled = true;
		this.removePKCS7Padding = void 0;
		this.subtle = null;
		this.softwareDecrypter = null;
		this.key = null;
		this.fastAesKey = null;
		this.remainderData = null;
		this.currentIV = null;
		this.currentResult = null;
		this.useSoftware = void 0;
		this.enableSoftwareAES = void 0;
		this.enableSoftwareAES = config.enableSoftwareAES;
		this.removePKCS7Padding = removePKCS7Padding;
		if (removePKCS7Padding) try {
			const browserCrypto = self.crypto;
			if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
		} catch (e) {}
		this.useSoftware = !this.subtle;
	}
	destroy() {
		this.subtle = null;
		this.softwareDecrypter = null;
		this.key = null;
		this.fastAesKey = null;
		this.remainderData = null;
		this.currentIV = null;
		this.currentResult = null;
	}
	isSync() {
		return this.useSoftware;
	}
	flush() {
		const { currentResult, remainderData } = this;
		if (!currentResult || remainderData) {
			this.reset();
			return null;
		}
		const data = new Uint8Array(currentResult);
		this.reset();
		if (this.removePKCS7Padding) return removePadding(data);
		return data;
	}
	reset() {
		this.currentResult = null;
		this.currentIV = null;
		this.remainderData = null;
		if (this.softwareDecrypter) this.softwareDecrypter = null;
	}
	decrypt(data, key, iv, aesMode) {
		if (this.useSoftware) return new Promise((resolve, reject) => {
			const dataView = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
			this.softwareDecrypt(dataView, key, iv, aesMode);
			const decryptResult = this.flush();
			if (decryptResult) resolve(decryptResult.buffer);
			else reject(/* @__PURE__ */ new Error("[softwareDecrypt] Failed to decrypt data"));
		});
		return this.webCryptoDecrypt(new Uint8Array(data), key, iv, aesMode);
	}
	softwareDecrypt(data, key, iv, aesMode) {
		const { currentIV, currentResult, remainderData } = this;
		if (aesMode !== DecrypterAesMode.cbc || key.byteLength !== 16) {
			logger.warn("SoftwareDecrypt: can only handle AES-128-CBC");
			return null;
		}
		this.logOnce("JS AES decrypt");
		if (remainderData) {
			data = appendUint8Array(remainderData, data);
			this.remainderData = null;
		}
		const currentChunk = this.getValidChunk(data);
		if (!currentChunk.length) return null;
		if (currentIV) iv = currentIV;
		let softwareDecrypter = this.softwareDecrypter;
		if (!softwareDecrypter) softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
		softwareDecrypter.expandKey(key);
		const result = currentResult;
		this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
		this.currentIV = currentChunk.slice(-16).buffer;
		if (!result) return null;
		return result;
	}
	webCryptoDecrypt(data, key, iv, aesMode) {
		if (this.key !== key || !this.fastAesKey) {
			if (!this.subtle) return Promise.resolve(this.onWebCryptoError(data, key, iv, aesMode));
			this.key = key;
			this.fastAesKey = new FastAESKey(this.subtle, key, aesMode);
		}
		return this.fastAesKey.expandKey().then((aesKey) => {
			if (!this.subtle) return Promise.reject(/* @__PURE__ */ new Error("web crypto not initialized"));
			this.logOnce("WebCrypto AES decrypt");
			return new AESCrypto(this.subtle, new Uint8Array(iv), aesMode).decrypt(data.buffer, aesKey);
		}).catch((err) => {
			logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
			return this.onWebCryptoError(data, key, iv, aesMode);
		});
	}
	onWebCryptoError(data, key, iv, aesMode) {
		const enableSoftwareAES = this.enableSoftwareAES;
		if (enableSoftwareAES) {
			this.useSoftware = true;
			this.logEnabled = true;
			this.softwareDecrypt(data, key, iv, aesMode);
			const decryptResult = this.flush();
			if (decryptResult) return decryptResult.buffer;
		}
		throw new Error("WebCrypto" + (enableSoftwareAES ? " and softwareDecrypt" : "") + ": failed to decrypt data");
	}
	getValidChunk(data) {
		let currentChunk = data;
		const splitPoint = data.length - data.length % CHUNK_SIZE;
		if (splitPoint !== data.length) {
			currentChunk = data.slice(0, splitPoint);
			this.remainderData = data.slice(splitPoint);
		}
		return currentChunk;
	}
	logOnce(msg) {
		if (!this.logEnabled) return;
		logger.log(`[decrypter]: ${msg}`);
		this.logEnabled = false;
	}
};
var MIN_CHUNK_SIZE = Math.pow(2, 17);
var FragmentLoader = class {
	constructor(config) {
		this.config = void 0;
		this.loader = null;
		this.partLoadTimeout = -1;
		this.config = config;
	}
	destroy() {
		if (this.loader) {
			this.loader.destroy();
			this.loader = null;
		}
	}
	abort() {
		if (this.loader) this.loader.abort();
	}
	load(frag, onProgress) {
		const url = frag.url;
		if (!url) return Promise.reject(new LoadError({
			type: ErrorTypes.NETWORK_ERROR,
			details: ErrorDetails.FRAG_LOAD_ERROR,
			fatal: false,
			frag,
			error: /* @__PURE__ */ new Error(`Fragment does not have a ${url ? "part list" : "url"}`),
			networkDetails: null
		}));
		this.abort();
		const config = this.config;
		const FragmentILoader = config.fLoader;
		const DefaultILoader = config.loader;
		return new Promise((resolve, reject) => {
			if (this.loader) this.loader.destroy();
			if (frag.gap) if (frag.tagList.some((tags) => tags[0] === "GAP")) {
				reject(createGapLoadError(frag));
				return;
			} else frag.gap = false;
			const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
			const loaderContext = createLoaderContext(frag);
			frag.loader = loader;
			const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
			const loaderConfig = {
				loadPolicy,
				timeout: loadPolicy.maxLoadTimeMs,
				maxRetry: 0,
				retryDelay: 0,
				maxRetryDelay: 0,
				highWaterMark: frag.sn === "initSegment" ? Infinity : MIN_CHUNK_SIZE
			};
			frag.stats = loader.stats;
			const callbacks = {
				onSuccess: (response, stats, context, networkDetails) => {
					this.resetLoader(frag, loader);
					let payload = response.data;
					if (context.resetIV && frag.decryptdata) {
						frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
						payload = payload.slice(16);
					}
					resolve({
						frag,
						part: null,
						payload,
						networkDetails
					});
				},
				onError: (response, context, networkDetails, stats) => {
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.FRAG_LOAD_ERROR,
						fatal: false,
						frag,
						response: _objectSpread2({
							url,
							data: void 0
						}, response),
						error: /* @__PURE__ */ new Error(`HTTP Error ${response.code} ${response.text}`),
						networkDetails,
						stats
					}));
				},
				onAbort: (stats, context, networkDetails) => {
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.INTERNAL_ABORTED,
						fatal: false,
						frag,
						error: /* @__PURE__ */ new Error("Aborted"),
						networkDetails,
						stats
					}));
				},
				onTimeout: (stats, context, networkDetails) => {
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.FRAG_LOAD_TIMEOUT,
						fatal: false,
						frag,
						error: /* @__PURE__ */ new Error(`Timeout after ${loaderConfig.timeout}ms`),
						networkDetails,
						stats
					}));
				}
			};
			if (onProgress) callbacks.onProgress = (stats, context, data, networkDetails) => onProgress({
				frag,
				part: null,
				payload: data,
				networkDetails
			});
			loader.load(loaderContext, loaderConfig, callbacks);
		});
	}
	loadPart(frag, part, onProgress) {
		this.abort();
		const config = this.config;
		const FragmentILoader = config.fLoader;
		const DefaultILoader = config.loader;
		return new Promise((resolve, reject) => {
			if (this.loader) this.loader.destroy();
			if (frag.gap || part.gap) {
				reject(createGapLoadError(frag, part));
				return;
			}
			const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
			const loaderContext = createLoaderContext(frag, part);
			frag.loader = loader;
			const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
			const loaderConfig = {
				loadPolicy,
				timeout: loadPolicy.maxLoadTimeMs,
				maxRetry: 0,
				retryDelay: 0,
				maxRetryDelay: 0,
				highWaterMark: MIN_CHUNK_SIZE
			};
			part.stats = loader.stats;
			loader.load(loaderContext, loaderConfig, {
				onSuccess: (response, stats, context, networkDetails) => {
					this.resetLoader(frag, loader);
					this.updateStatsFromPart(frag, part);
					const partLoadedData = {
						frag,
						part,
						payload: response.data,
						networkDetails
					};
					onProgress(partLoadedData);
					resolve(partLoadedData);
				},
				onError: (response, context, networkDetails, stats) => {
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.FRAG_LOAD_ERROR,
						fatal: false,
						frag,
						part,
						response: _objectSpread2({
							url: loaderContext.url,
							data: void 0
						}, response),
						error: /* @__PURE__ */ new Error(`HTTP Error ${response.code} ${response.text}`),
						networkDetails,
						stats
					}));
				},
				onAbort: (stats, context, networkDetails) => {
					frag.stats.aborted = part.stats.aborted;
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.INTERNAL_ABORTED,
						fatal: false,
						frag,
						part,
						error: /* @__PURE__ */ new Error("Aborted"),
						networkDetails,
						stats
					}));
				},
				onTimeout: (stats, context, networkDetails) => {
					this.resetLoader(frag, loader);
					reject(new LoadError({
						type: ErrorTypes.NETWORK_ERROR,
						details: ErrorDetails.FRAG_LOAD_TIMEOUT,
						fatal: false,
						frag,
						part,
						error: /* @__PURE__ */ new Error(`Timeout after ${loaderConfig.timeout}ms`),
						networkDetails,
						stats
					}));
				}
			});
		});
	}
	updateStatsFromPart(frag, part) {
		const fragStats = frag.stats;
		const partStats = part.stats;
		const partTotal = partStats.total;
		fragStats.loaded += partStats.loaded;
		if (partTotal) {
			const estTotalParts = Math.round(frag.duration / part.duration);
			const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
			const estRemainingBytes = (estTotalParts - estLoadedParts) * Math.round(fragStats.loaded / estLoadedParts);
			fragStats.total = fragStats.loaded + estRemainingBytes;
		} else fragStats.total = Math.max(fragStats.loaded, fragStats.total);
		const fragLoading = fragStats.loading;
		const partLoading = partStats.loading;
		if (fragLoading.start) fragLoading.first += partLoading.first - partLoading.start;
		else {
			fragLoading.start = partLoading.start;
			fragLoading.first = partLoading.first;
		}
		fragLoading.end = partLoading.end;
	}
	resetLoader(frag, loader) {
		frag.loader = null;
		if (this.loader === loader) {
			self.clearTimeout(this.partLoadTimeout);
			this.loader = null;
		}
		loader.destroy();
	}
};
function createLoaderContext(frag, part = null) {
	const segment = part || frag;
	const loaderContext = {
		frag,
		part,
		responseType: "arraybuffer",
		url: segment.url,
		headers: {},
		rangeStart: 0,
		rangeEnd: 0
	};
	const start = segment.byteRangeStartOffset;
	const end = segment.byteRangeEndOffset;
	if (isFiniteNumber(start) && isFiniteNumber(end)) {
		var _frag$decryptdata;
		let byteRangeStart = start;
		let byteRangeEnd = end;
		if (frag.sn === "initSegment" && isMethodFullSegmentAesCbc((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method)) {
			const fragmentLen = end - start;
			if (fragmentLen % 16) byteRangeEnd = end + (16 - fragmentLen % 16);
			if (start !== 0) {
				loaderContext.resetIV = true;
				byteRangeStart = start - 16;
			}
		}
		loaderContext.rangeStart = byteRangeStart;
		loaderContext.rangeEnd = byteRangeEnd;
	}
	return loaderContext;
}
function createGapLoadError(frag, part) {
	const error = /* @__PURE__ */ new Error(`GAP ${frag.gap ? "tag" : "attribute"} found`);
	const errorData = {
		type: ErrorTypes.MEDIA_ERROR,
		details: ErrorDetails.FRAG_GAP,
		fatal: false,
		frag,
		error,
		networkDetails: null
	};
	if (part) errorData.part = part;
	(part ? part : frag).stats.aborted = true;
	return new LoadError(errorData);
}
function isMethodFullSegmentAesCbc(method) {
	return method === "AES-128" || method === "AES-256";
}
var LoadError = class extends Error {
	constructor(data) {
		super(data.error.message);
		this.data = void 0;
		this.data = data;
	}
};
/**
* @ignore
* Sub-class specialization of EventHandler base class.
*
* TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
* scheduled asynchroneously, avoiding recursive calls in the same tick.
*
* The task itself is implemented in `doTick`. It can be requested and called for single execution
* using the `tick` method.
*
* It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
* no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
*
* If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
* and cancelled with `clearNextTick`.
*
* The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
*
* Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
*
* Further explanations:
*
* The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
* only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
*
* When the task execution (`tick` method) is called in re-entrant way this is detected and
* we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
* task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
*/
var TaskLoop = class extends Logger {
	constructor(label, logger) {
		super(label, logger);
		this._boundTick = void 0;
		this._tickTimer = null;
		this._tickInterval = null;
		this._tickCallCount = 0;
		this._boundTick = this.tick.bind(this);
	}
	destroy() {
		this.onHandlerDestroying();
		this.onHandlerDestroyed();
	}
	onHandlerDestroying() {
		this.clearNextTick();
		this.clearInterval();
	}
	onHandlerDestroyed() {}
	hasInterval() {
		return !!this._tickInterval;
	}
	hasNextTick() {
		return !!this._tickTimer;
	}
	/**
	* @param millis - Interval time (ms)
	* @eturns True when interval has been scheduled, false when already scheduled (no effect)
	*/
	setInterval(millis) {
		if (!this._tickInterval) {
			this._tickCallCount = 0;
			this._tickInterval = self.setInterval(this._boundTick, millis);
			return true;
		}
		return false;
	}
	/**
	* @returns True when interval was cleared, false when none was set (no effect)
	*/
	clearInterval() {
		if (this._tickInterval) {
			self.clearInterval(this._tickInterval);
			this._tickInterval = null;
			return true;
		}
		return false;
	}
	/**
	* @returns True when timeout was cleared, false when none was set (no effect)
	*/
	clearNextTick() {
		if (this._tickTimer) {
			self.clearTimeout(this._tickTimer);
			this._tickTimer = null;
			return true;
		}
		return false;
	}
	/**
	* Will call the subclass doTick implementation in this main loop tick
	* or in the next one (via setTimeout(,0)) in case it has already been called
	* in this tick (in case this is a re-entrant call).
	*/
	tick() {
		this._tickCallCount++;
		if (this._tickCallCount === 1) {
			this.doTick();
			if (this._tickCallCount > 1) this.tickImmediate();
			this._tickCallCount = 0;
		}
	}
	tickImmediate() {
		this.clearNextTick();
		this._tickTimer = self.setTimeout(this._boundTick, 0);
	}
	/**
	* For subclass to implement task logic
	* @abstract
	*/
	doTick() {}
};
var ChunkMetadata = class {
	constructor(level, sn, id, size = 0, part = -1, partial = false) {
		this.level = void 0;
		this.sn = void 0;
		this.part = void 0;
		this.id = void 0;
		this.size = void 0;
		this.partial = void 0;
		this.transmuxing = getNewPerformanceTiming();
		this.buffering = {
			audio: getNewPerformanceTiming(),
			video: getNewPerformanceTiming(),
			audiovideo: getNewPerformanceTiming()
		};
		this.level = level;
		this.sn = sn;
		this.id = id;
		this.size = size;
		this.part = part;
		this.partial = partial;
	}
};
function getNewPerformanceTiming() {
	return {
		start: 0,
		executeStart: 0,
		executeEnd: 0,
		end: 0
	};
}
/**
* Provides methods dealing with buffer length retrieval for example.
*
* In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
*
* Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
*/
var noopBuffered = {
	length: 0,
	start: () => 0,
	end: () => 0
};
var BufferHelper = class BufferHelper {
	/**
	* Return true if `media`'s buffered include `position`
	*/
	static isBuffered(media, position) {
		if (media) {
			const buffered = BufferHelper.getBuffered(media);
			for (let i = buffered.length; i--;) if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
		}
		return false;
	}
	static bufferedRanges(media) {
		if (media) {
			const timeRanges = BufferHelper.getBuffered(media);
			return BufferHelper.timeRangesToArray(timeRanges);
		}
		return [];
	}
	static timeRangesToArray(timeRanges) {
		const buffered = [];
		for (let i = 0; i < timeRanges.length; i++) buffered.push({
			start: timeRanges.start(i),
			end: timeRanges.end(i)
		});
		return buffered;
	}
	static bufferInfo(media, pos, maxHoleDuration) {
		if (media) {
			const buffered = BufferHelper.bufferedRanges(media);
			if (buffered.length) return BufferHelper.bufferedInfo(buffered, pos, maxHoleDuration);
		}
		return {
			len: 0,
			start: pos,
			end: pos,
			bufferedIndex: -1
		};
	}
	static bufferedInfo(buffered, pos, maxHoleDuration) {
		pos = Math.max(0, pos);
		if (buffered.length > 1) buffered.sort((a, b) => a.start - b.start || b.end - a.end);
		let bufferedIndex = -1;
		let buffered2 = [];
		if (maxHoleDuration) for (let i = 0; i < buffered.length; i++) {
			if (pos >= buffered[i].start && pos <= buffered[i].end) bufferedIndex = i;
			const buf2len = buffered2.length;
			if (buf2len) {
				const buf2end = buffered2[buf2len - 1].end;
				if (buffered[i].start - buf2end < maxHoleDuration) {
					if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
				} else buffered2.push(buffered[i]);
			} else buffered2.push(buffered[i]);
		}
		else buffered2 = buffered;
		let bufferLen = 0;
		let nextStart;
		let bufferStart = pos;
		let bufferEnd = pos;
		for (let i = 0; i < buffered2.length; i++) {
			const start = buffered2[i].start;
			const end = buffered2[i].end;
			if (bufferedIndex === -1 && pos >= start && pos <= end) bufferedIndex = i;
			if (pos + maxHoleDuration >= start && pos < end) {
				bufferStart = start;
				bufferEnd = end;
				bufferLen = bufferEnd - pos;
			} else if (pos + maxHoleDuration < start) {
				nextStart = start;
				break;
			}
		}
		return {
			len: bufferLen,
			start: bufferStart || 0,
			end: bufferEnd || 0,
			nextStart,
			buffered,
			bufferedIndex
		};
	}
	/**
	* Safe method to get buffered property.
	* SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
	*/
	static getBuffered(media) {
		try {
			return media.buffered || noopBuffered;
		} catch (e) {
			logger.log("failed to get media.buffered", e);
			return noopBuffered;
		}
	}
};
var VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
	return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariables(parsed, value) {
	if (parsed.variableList !== null || parsed.hasVariableRefs) {
		const variableList = parsed.variableList;
		return value.replace(VARIABLE_REPLACEMENT_REGEX, (variableReference) => {
			const variableName = variableReference.substring(2, variableReference.length - 1);
			const variableValue = variableList == null ? void 0 : variableList[variableName];
			if (variableValue === void 0) {
				parsed.playlistParsingError || (parsed.playlistParsingError = /* @__PURE__ */ new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
				return variableReference;
			}
			return variableValue;
		});
	}
	return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
	let variableList = parsed.variableList;
	if (!variableList) parsed.variableList = variableList = {};
	let NAME;
	let VALUE;
	if ("QUERYPARAM" in attr) {
		NAME = attr.QUERYPARAM;
		try {
			const searchParams = new self.URL(parentUrl).searchParams;
			if (searchParams.has(NAME)) VALUE = searchParams.get(NAME);
			else throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
		} catch (error) {
			parsed.playlistParsingError || (parsed.playlistParsingError = /* @__PURE__ */ new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
		}
	} else {
		NAME = attr.NAME;
		VALUE = attr.VALUE;
	}
	if (NAME in variableList) parsed.playlistParsingError || (parsed.playlistParsingError = /* @__PURE__ */ new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
	else variableList[NAME] = VALUE || "";
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
	const IMPORT = attr.IMPORT;
	if (sourceVariableList && IMPORT in sourceVariableList) {
		let variableList = parsed.variableList;
		if (!variableList) parsed.variableList = variableList = {};
		variableList[IMPORT] = sourceVariableList[IMPORT];
	} else parsed.playlistParsingError || (parsed.playlistParsingError = /* @__PURE__ */ new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
}
var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
var ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
var AttrList = class AttrList {
	constructor(attrs, parsed) {
		if (typeof attrs === "string") attrs = AttrList.parseAttrList(attrs, parsed);
		_extends(this, attrs);
	}
	get clientAttrs() {
		return Object.keys(this).filter((attr) => attr.substring(0, 2) === "X-");
	}
	decimalInteger(attrName) {
		const intValue = parseInt(this[attrName], 10);
		if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
		return intValue;
	}
	hexadecimalInteger(attrName) {
		if (this[attrName]) {
			let stringValue = (this[attrName] || "0x").slice(2);
			stringValue = (stringValue.length & 1 ? "0" : "") + stringValue;
			const value = new Uint8Array(stringValue.length / 2);
			for (let i = 0; i < stringValue.length / 2; i++) value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
			return value;
		}
		return null;
	}
	hexadecimalIntegerAsNumber(attrName) {
		const intValue = parseInt(this[attrName], 16);
		if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
		return intValue;
	}
	decimalFloatingPoint(attrName) {
		return parseFloat(this[attrName]);
	}
	optionalFloat(attrName, defaultValue) {
		const value = this[attrName];
		return value ? parseFloat(value) : defaultValue;
	}
	enumeratedString(attrName) {
		return this[attrName];
	}
	enumeratedStringList(attrName, dict) {
		const attrValue = this[attrName];
		return (attrValue ? attrValue.split(/[ ,]+/) : []).reduce((result, identifier) => {
			result[identifier.toLowerCase()] = true;
			return result;
		}, dict);
	}
	bool(attrName) {
		return this[attrName] === "YES";
	}
	decimalResolution(attrName) {
		const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
		if (res === null) return;
		return {
			width: parseInt(res[1], 10),
			height: parseInt(res[2], 10)
		};
	}
	static parseAttrList(input, parsed) {
		let match;
		const attrs = {};
		const quote = "\"";
		ATTR_LIST_REGEX.lastIndex = 0;
		while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
			const name = match[1].trim();
			let value = match[2];
			const quotedString = value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1;
			let hexadecimalSequence = false;
			if (quotedString) value = value.slice(1, -1);
			else switch (name) {
				case "IV":
				case "SCTE35-CMD":
				case "SCTE35-IN":
				case "SCTE35-OUT": hexadecimalSequence = true;
			}
			if (parsed && (quotedString || hexadecimalSequence)) value = substituteVariables(parsed, value);
			else if (!hexadecimalSequence && !quotedString) switch (name) {
				case "CLOSED-CAPTIONS": if (value === "NONE") break;
				case "ALLOWED-CPC":
				case "CLASS":
				case "ASSOC-LANGUAGE":
				case "AUDIO":
				case "BYTERANGE":
				case "CHANNELS":
				case "CHARACTERISTICS":
				case "CODECS":
				case "DATA-ID":
				case "END-DATE":
				case "GROUP-ID":
				case "ID":
				case "IMPORT":
				case "INSTREAM-ID":
				case "KEYFORMAT":
				case "KEYFORMATVERSIONS":
				case "LANGUAGE":
				case "NAME":
				case "PATHWAY-ID":
				case "QUERYPARAM":
				case "RECENTLY-REMOVED-DATERANGES":
				case "SERVER-URI":
				case "STABLE-RENDITION-ID":
				case "STABLE-VARIANT-ID":
				case "START-DATE":
				case "SUBTITLES":
				case "SUPPLEMENTAL-CODECS":
				case "URI":
				case "VALUE":
				case "VIDEO":
				case "X-ASSET-LIST":
				case "X-ASSET-URI": logger.warn(`${input}: attribute ${name} is missing quotes`);
			}
			attrs[name] = value;
		}
		return attrs;
	}
};
var CLASS_INTERSTITIAL = "com.apple.hls.interstitial";
function isDateRangeCueAttribute(attrName) {
	return attrName !== "ID" && attrName !== "CLASS" && attrName !== "CUE" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
	return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN" || attrName === "SCTE35-CMD";
}
var DateRange = class {
	constructor(dateRangeAttr, dateRangeWithSameId, tagCount = 0) {
		var _dateRangeWithSameId$;
		this.attr = void 0;
		this.tagAnchor = void 0;
		this.tagOrder = void 0;
		this._startDate = void 0;
		this._endDate = void 0;
		this._dateAtEnd = void 0;
		this._cue = void 0;
		this._badValueForSameId = void 0;
		this.tagAnchor = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagAnchor) || null;
		this.tagOrder = (_dateRangeWithSameId$ = dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagOrder) != null ? _dateRangeWithSameId$ : tagCount;
		if (dateRangeWithSameId) {
			const previousAttr = dateRangeWithSameId.attr;
			for (const key in previousAttr) if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
				logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
				this._badValueForSameId = key;
				break;
			}
			dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
		}
		this.attr = dateRangeAttr;
		if (dateRangeWithSameId) {
			this._startDate = dateRangeWithSameId._startDate;
			this._cue = dateRangeWithSameId._cue;
			this._endDate = dateRangeWithSameId._endDate;
			this._dateAtEnd = dateRangeWithSameId._dateAtEnd;
		} else this._startDate = new Date(dateRangeAttr["START-DATE"]);
		if ("END-DATE" in this.attr) {
			const endDate = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.endDate) || new Date(this.attr["END-DATE"]);
			if (isFiniteNumber(endDate.getTime())) this._endDate = endDate;
		}
	}
	get id() {
		return this.attr.ID;
	}
	get class() {
		return this.attr.CLASS;
	}
	get cue() {
		const _cue = this._cue;
		if (_cue === void 0) return this._cue = this.attr.enumeratedStringList(this.attr.CUE ? "CUE" : "X-CUE", {
			pre: false,
			post: false,
			once: false
		});
		return _cue;
	}
	get startTime() {
		const { tagAnchor } = this;
		if (tagAnchor === null || tagAnchor.programDateTime === null) {
			logger.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${tagAnchor}`);
			return NaN;
		}
		return tagAnchor.start + (this.startDate.getTime() - tagAnchor.programDateTime) / 1e3;
	}
	get startDate() {
		return this._startDate;
	}
	get endDate() {
		const dateAtEnd = this._endDate || this._dateAtEnd;
		if (dateAtEnd) return dateAtEnd;
		const duration = this.duration;
		if (duration !== null) return this._dateAtEnd = new Date(this._startDate.getTime() + duration * 1e3);
		return null;
	}
	get duration() {
		if ("DURATION" in this.attr) {
			const duration = this.attr.decimalFloatingPoint("DURATION");
			if (isFiniteNumber(duration)) return duration;
		} else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
		return null;
	}
	get plannedDuration() {
		if ("PLANNED-DURATION" in this.attr) return this.attr.decimalFloatingPoint("PLANNED-DURATION");
		return null;
	}
	get endOnNext() {
		return this.attr.bool("END-ON-NEXT");
	}
	get isInterstitial() {
		return this.class === CLASS_INTERSTITIAL;
	}
	get isValid() {
		return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || "X-ASSET-URI" in this.attr || "X-ASSET-LIST" in this.attr);
	}
};
var DEFAULT_TARGET_DURATION = 10;
/**
* Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
*/
var LevelDetails = class {
	constructor(baseUrl) {
		this.PTSKnown = false;
		this.alignedSliding = false;
		this.averagetargetduration = void 0;
		this.endCC = 0;
		this.endSN = 0;
		this.fragments = void 0;
		this.fragmentHint = void 0;
		this.partList = null;
		this.dateRanges = void 0;
		this.dateRangeTagCount = 0;
		this.live = true;
		this.requestScheduled = -1;
		this.ageHeader = 0;
		this.advancedDateTime = void 0;
		this.updated = true;
		this.advanced = true;
		this.misses = 0;
		this.startCC = 0;
		this.startSN = 0;
		this.startTimeOffset = null;
		this.targetduration = 0;
		this.totalduration = 0;
		this.type = null;
		this.url = void 0;
		this.m3u8 = "";
		this.version = null;
		this.canBlockReload = false;
		this.canSkipUntil = 0;
		this.canSkipDateRanges = false;
		this.skippedSegments = 0;
		this.recentlyRemovedDateranges = void 0;
		this.partHoldBack = 0;
		this.holdBack = 0;
		this.partTarget = 0;
		this.preloadHint = void 0;
		this.renditionReports = void 0;
		this.tuneInGoal = 0;
		this.deltaUpdateFailed = void 0;
		this.driftStartTime = 0;
		this.driftEndTime = 0;
		this.driftStart = 0;
		this.driftEnd = 0;
		this.encryptedFragments = void 0;
		this.playlistParsingError = null;
		this.variableList = null;
		this.hasVariableRefs = false;
		this.appliedTimelineOffset = void 0;
		this.fragments = [];
		this.encryptedFragments = [];
		this.dateRanges = {};
		this.url = baseUrl;
	}
	reloaded(previous) {
		if (!previous) {
			this.advanced = true;
			this.updated = true;
			return;
		}
		const partSnDiff = this.lastPartSn - previous.lastPartSn;
		const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
		this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
		this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
		if (this.updated || this.advanced) this.misses = Math.floor(previous.misses * .6);
		else this.misses = previous.misses + 1;
	}
	hasKey(levelKey) {
		return this.encryptedFragments.some((frag) => {
			let decryptdata = frag.decryptdata;
			if (!decryptdata) {
				frag.setKeyFormat(levelKey.keyFormat);
				decryptdata = frag.decryptdata;
			}
			return !!decryptdata && levelKey.matches(decryptdata);
		});
	}
	get hasProgramDateTime() {
		if (this.fragments.length) return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
		return false;
	}
	get levelTargetDuration() {
		return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
	}
	get drift() {
		const runTime = this.driftEndTime - this.driftStartTime;
		if (runTime > 0) return (this.driftEnd - this.driftStart) * 1e3 / runTime;
		return 1;
	}
	get edge() {
		return this.partEnd || this.fragmentEnd;
	}
	get partEnd() {
		var _this$partList;
		if ((_this$partList = this.partList) != null && _this$partList.length) return this.partList[this.partList.length - 1].end;
		return this.fragmentEnd;
	}
	get fragmentEnd() {
		if (this.fragments.length) return this.fragments[this.fragments.length - 1].end;
		return 0;
	}
	get fragmentStart() {
		if (this.fragments.length) return this.fragments[0].start;
		return 0;
	}
	get age() {
		if (this.advancedDateTime) return Math.max(Date.now() - this.advancedDateTime, 0) / 1e3;
		return 0;
	}
	get lastPartIndex() {
		var _this$partList2;
		if ((_this$partList2 = this.partList) != null && _this$partList2.length) return this.partList[this.partList.length - 1].index;
		return -1;
	}
	get maxPartIndex() {
		const partList = this.partList;
		if (partList) {
			const lastIndex = this.lastPartIndex;
			if (lastIndex !== -1) {
				for (let i = partList.length; i--;) if (partList[i].index > lastIndex) return partList[i].index;
				return lastIndex;
			}
		}
		return 0;
	}
	get lastPartSn() {
		var _this$partList3;
		if ((_this$partList3 = this.partList) != null && _this$partList3.length) return this.partList[this.partList.length - 1].fragment.sn;
		return this.endSN;
	}
	get expired() {
		if (this.live && this.age && this.misses < 3) {
			const playlistWindowDuration = this.partEnd - this.fragmentStart;
			return this.age > Math.max(playlistWindowDuration, this.totalduration) + this.levelTargetDuration;
		}
		return false;
	}
};
function arrayValuesMatch(a, b) {
	if (a.length === b.length) return !a.some((value, i) => value !== b[i]);
	return false;
}
function optionalArrayValuesMatch(a, b) {
	if (!a && !b) return true;
	if (!a || !b) return false;
	return arrayValuesMatch(a, b);
}
function isFullSegmentEncryption(method) {
	return method === "AES-128" || method === "AES-256" || method === "AES-256-CTR";
}
function getAesModeFromFullSegmentMethod(method) {
	switch (method) {
		case "AES-128":
		case "AES-256": return DecrypterAesMode.cbc;
		case "AES-256-CTR": return DecrypterAesMode.ctr;
		default: throw new Error(`invalid full segment method ${method}`);
	}
}
function base64Decode(base64encodedStr) {
	return Uint8Array.from(atob(base64encodedStr), (c) => c.charCodeAt(0));
}
function strToUtf8array(str) {
	return Uint8Array.from(unescape(encodeURIComponent(str)), (c) => c.charCodeAt(0));
}
function getKeyIdBytes(str) {
	const keyIdbytes = strToUtf8array(str).subarray(0, 16);
	const paddedkeyIdbytes = new Uint8Array(16);
	paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
	return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
	const swap = function swap(array, from, to) {
		const cur = array[from];
		array[from] = array[to];
		array[to] = cur;
	};
	swap(keyId, 0, 3);
	swap(keyId, 1, 2);
	swap(keyId, 4, 5);
	swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
	const colonsplit = uri.split(":");
	let keydata = null;
	if (colonsplit[0] === "data" && colonsplit.length === 2) {
		const semicolonsplit = colonsplit[1].split(";");
		const commasplit = semicolonsplit[semicolonsplit.length - 1].split(",");
		if (commasplit.length === 2) {
			const isbase64 = commasplit[0] === "base64";
			const data = commasplit[1];
			if (isbase64) {
				semicolonsplit.splice(-1, 1);
				keydata = base64Decode(data);
			} else keydata = getKeyIdBytes(data);
		}
	}
	return keydata;
}
/** returns `undefined` is `self` is missing, e.g. in node */
var optionalSelf = typeof self !== "undefined" ? self : void 0;
/**
* @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
*/
var KeySystems = {
	CLEARKEY: "org.w3.clearkey",
	FAIRPLAY: "com.apple.fps",
	PLAYREADY: "com.microsoft.playready",
	WIDEVINE: "com.widevine.alpha"
};
var KeySystemFormats = {
	CLEARKEY: "org.w3.clearkey",
	FAIRPLAY: "com.apple.streamingkeydelivery",
	PLAYREADY: "com.microsoft.playready",
	WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
	switch (format) {
		case KeySystemFormats.FAIRPLAY: return KeySystems.FAIRPLAY;
		case KeySystemFormats.PLAYREADY: return KeySystems.PLAYREADY;
		case KeySystemFormats.WIDEVINE: return KeySystems.WIDEVINE;
		case KeySystemFormats.CLEARKEY: return KeySystems.CLEARKEY;
	}
}
function keySystemDomainToKeySystemFormat(keySystem) {
	switch (keySystem) {
		case KeySystems.FAIRPLAY: return KeySystemFormats.FAIRPLAY;
		case KeySystems.PLAYREADY: return KeySystemFormats.PLAYREADY;
		case KeySystems.WIDEVINE: return KeySystemFormats.WIDEVINE;
		case KeySystems.CLEARKEY: return KeySystemFormats.CLEARKEY;
	}
}
function getKeySystemsForConfig(config) {
	const { drmSystems, widevineLicenseUrl } = config;
	const keySystemsToAttempt = drmSystems ? [
		KeySystems.FAIRPLAY,
		KeySystems.WIDEVINE,
		KeySystems.PLAYREADY,
		KeySystems.CLEARKEY
	].filter((keySystem) => !!drmSystems[keySystem]) : [];
	if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) keySystemsToAttempt.push(KeySystems.WIDEVINE);
	return keySystemsToAttempt;
}
var requestMediaKeySystemAccess = function(_optionalSelf$navigat) {
	if (optionalSelf != null && (_optionalSelf$navigat = optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
	else return null;
}();
/**
* @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
*/
function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
	let initDataTypes;
	switch (keySystem) {
		case KeySystems.FAIRPLAY:
			initDataTypes = ["cenc", "sinf"];
			break;
		case KeySystems.WIDEVINE:
		case KeySystems.PLAYREADY:
			initDataTypes = ["cenc"];
			break;
		case KeySystems.CLEARKEY:
			initDataTypes = ["cenc", "keyids"];
			break;
		default: throw new Error(`Unknown key-system: ${keySystem}`);
	}
	return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
	return [{
		initDataTypes,
		persistentState: drmSystemOptions.persistentState || "optional",
		distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || "optional",
		sessionTypes: drmSystemOptions.sessionTypes || [drmSystemOptions.sessionType || "temporary"],
		audioCapabilities: audioCodecs.map((codec) => ({
			contentType: `audio/mp4; codecs=${codec}`,
			robustness: drmSystemOptions.audioRobustness || "",
			encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
		})),
		videoCapabilities: videoCodecs.map((codec) => ({
			contentType: `video/mp4; codecs=${codec}`,
			robustness: drmSystemOptions.videoRobustness || "",
			encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
		}))
	}];
}
function isPersistentSessionType(drmSystemOptions) {
	var _drmSystemOptions$ses;
	return !!drmSystemOptions && (drmSystemOptions.sessionType === "persistent-license" || !!((_drmSystemOptions$ses = drmSystemOptions.sessionTypes) != null && _drmSystemOptions$ses.some((type) => type === "persistent-license")));
}
function parsePlayReadyWRM(keyBytes) {
	const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
	const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));
	const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf("<"), keyByteStr.length);
	const keyData = new DOMParser().parseFromString(xmlKeyBytes, "text/xml").getElementsByTagName("KID")[0];
	if (keyData) {
		const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute("VALUE");
		if (keyId) {
			const keyIdArray = base64Decode(keyId).subarray(0, 16);
			changeEndianness(keyIdArray);
			return keyIdArray;
		}
	}
	return null;
}
var keyUriToKeyIdMap = {};
var LevelKey = class LevelKey {
	static clearKeyUriToKeyIdMap() {
		keyUriToKeyIdMap = {};
	}
	static setKeyIdForUri(uri, keyId) {
		keyUriToKeyIdMap[uri] = keyId;
	}
	static addKeyIdForUri(uri) {
		const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
		const keyId = new Uint8Array(16);
		new DataView(keyId.buffer, 12, 4).setUint32(0, val);
		keyUriToKeyIdMap[uri] = keyId;
		return keyId;
	}
	constructor(method, uri, format, formatversions = [1], iv = null, keyId) {
		this.uri = void 0;
		this.method = void 0;
		this.keyFormat = void 0;
		this.keyFormatVersions = void 0;
		this.encrypted = void 0;
		this.isCommonEncryption = void 0;
		this.iv = null;
		this.key = null;
		this.keyId = null;
		this.pssh = null;
		this.method = method;
		this.uri = uri;
		this.keyFormat = format;
		this.keyFormatVersions = formatversions;
		this.iv = iv;
		this.encrypted = method ? method !== "NONE" : false;
		this.isCommonEncryption = this.encrypted && !isFullSegmentEncryption(method);
		if (keyId != null && keyId.startsWith("0x")) this.keyId = new Uint8Array(hexToArrayBuffer(keyId));
	}
	matches(key) {
		return key.uri === this.uri && key.method === this.method && key.encrypted === this.encrypted && key.keyFormat === this.keyFormat && arrayValuesMatch(key.keyFormatVersions, this.keyFormatVersions) && optionalArrayValuesMatch(key.iv, this.iv) && optionalArrayValuesMatch(key.keyId, this.keyId);
	}
	isSupported() {
		if (this.method) {
			if (isFullSegmentEncryption(this.method) || this.method === "NONE") return true;
			if (this.keyFormat === "identity") return this.method === "SAMPLE-AES";
			else switch (this.keyFormat) {
				case KeySystemFormats.FAIRPLAY:
				case KeySystemFormats.WIDEVINE:
				case KeySystemFormats.PLAYREADY:
				case KeySystemFormats.CLEARKEY: return [
					"SAMPLE-AES",
					"SAMPLE-AES-CENC",
					"SAMPLE-AES-CTR"
				].indexOf(this.method) !== -1;
			}
		}
		return false;
	}
	getDecryptData(sn, levelKeys) {
		if (!this.encrypted || !this.uri) return null;
		if (isFullSegmentEncryption(this.method)) {
			let iv = this.iv;
			if (!iv) {
				if (typeof sn !== "number") {
					logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
					sn = 0;
				}
				iv = createInitializationVector(sn);
			}
			return new LevelKey(this.method, this.uri, "identity", this.keyFormatVersions, iv);
		}
		if (this.keyId) {
			const assignedKeyId = keyUriToKeyIdMap[this.uri];
			if (assignedKeyId && !arrayValuesMatch(this.keyId, assignedKeyId)) LevelKey.setKeyIdForUri(this.uri, this.keyId);
			if (this.pssh) return this;
		}
		const keyBytes = convertDataUriToArrayBytes(this.uri);
		if (keyBytes) switch (this.keyFormat) {
			case KeySystemFormats.WIDEVINE:
				this.pssh = keyBytes;
				if (!this.keyId) {
					const results = parseMultiPssh(keyBytes.buffer);
					if (results.length) {
						var _psshData$kids;
						const psshData = results[0];
						this.keyId = (_psshData$kids = psshData.kids) != null && _psshData$kids.length ? psshData.kids[0] : null;
					}
				}
				if (!this.keyId) this.keyId = getKeyIdFromPlayReadyKey(levelKeys);
				break;
			case KeySystemFormats.PLAYREADY: {
				const PlayReadyKeySystemUUID = new Uint8Array([
					154,
					4,
					240,
					121,
					152,
					64,
					66,
					134,
					171,
					146,
					230,
					91,
					224,
					136,
					95,
					149
				]);
				this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
				this.keyId = parsePlayReadyWRM(keyBytes);
				break;
			}
			default: {
				let keydata = keyBytes.subarray(0, 16);
				if (keydata.length !== 16) {
					const padded = new Uint8Array(16);
					padded.set(keydata, 16 - keydata.length);
					keydata = padded;
				}
				this.keyId = keydata;
				break;
			}
		}
		if (!this.keyId || this.keyId.byteLength !== 16) {
			let keyId;
			keyId = getKeyIdFromWidevineKey(levelKeys);
			if (!keyId) {
				keyId = getKeyIdFromPlayReadyKey(levelKeys);
				if (!keyId) keyId = keyUriToKeyIdMap[this.uri];
			}
			if (keyId) {
				this.keyId = keyId;
				LevelKey.setKeyIdForUri(this.uri, keyId);
			}
		}
		return this;
	}
};
function getKeyIdFromWidevineKey(levelKeys) {
	const widevineKey = levelKeys == null ? void 0 : levelKeys[KeySystemFormats.WIDEVINE];
	if (widevineKey) return widevineKey.keyId;
	return null;
}
function getKeyIdFromPlayReadyKey(levelKeys) {
	const playReadyKey = levelKeys == null ? void 0 : levelKeys[KeySystemFormats.PLAYREADY];
	if (playReadyKey) {
		const playReadyKeyBytes = convertDataUriToArrayBytes(playReadyKey.uri);
		if (playReadyKeyBytes) return parsePlayReadyWRM(playReadyKeyBytes);
	}
	return null;
}
function createInitializationVector(segmentNumber) {
	const uint8View = new Uint8Array(16);
	for (let i = 12; i < 16; i++) uint8View[i] = segmentNumber >> 8 * (15 - i) & 255;
	return uint8View;
}
var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
var IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m;
var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
	/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
	/(?!#) *(\S[^\r\n]*)/.source,
	/#.*/.source
].join("|"), "g");
var LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([
	/#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
	/#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
	/#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,
	/(#)([^:]*):(.*)/.source,
	/(#)(.*)(?:.*)\r?\n?/.source
].join("|"));
var M3U8Parser = class M3U8Parser {
	static findGroup(groups, mediaGroupId) {
		for (let i = 0; i < groups.length; i++) {
			const group = groups[i];
			if (group.id === mediaGroupId) return group;
		}
	}
	static resolve(url, baseUrl) {
		return urlToolkitExports.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
	}
	static isMediaPlaylist(str) {
		return IS_MEDIA_PLAYLIST.test(str);
	}
	static parseMasterPlaylist(string, baseurl) {
		const parsed = {
			contentSteering: null,
			levels: [],
			playlistParsingError: null,
			sessionData: null,
			sessionKeys: null,
			startTimeOffset: null,
			variableList: null,
			hasVariableRefs: hasVariableReferences(string)
		};
		const levelsWithKnownCodecs = [];
		MASTER_PLAYLIST_REGEX.lastIndex = 0;
		if (!string.startsWith("#EXTM3U")) {
			parsed.playlistParsingError = /* @__PURE__ */ new Error("no EXTM3U delimiter");
			return parsed;
		}
		let result;
		while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) if (result[1]) {
			var _level$unknownCodecs;
			const attrs = new AttrList(result[1], parsed);
			const uri = substituteVariables(parsed, result[2]);
			const level = {
				attrs,
				bitrate: attrs.decimalInteger("BANDWIDTH") || attrs.decimalInteger("AVERAGE-BANDWIDTH"),
				name: attrs.NAME,
				url: M3U8Parser.resolve(uri, baseurl)
			};
			const resolution = attrs.decimalResolution("RESOLUTION");
			if (resolution) {
				level.width = resolution.width;
				level.height = resolution.height;
			}
			setCodecs(attrs.CODECS, level);
			const supplementalCodecs = attrs["SUPPLEMENTAL-CODECS"];
			if (supplementalCodecs) {
				level.supplemental = {};
				setCodecs(supplementalCodecs, level.supplemental);
			}
			if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) levelsWithKnownCodecs.push(level);
			parsed.levels.push(level);
		} else if (result[3]) {
			const tag = result[3];
			const attributes = result[4];
			switch (tag) {
				case "SESSION-DATA": {
					const sessionAttrs = new AttrList(attributes, parsed);
					const dataId = sessionAttrs["DATA-ID"];
					if (dataId) {
						if (parsed.sessionData === null) parsed.sessionData = {};
						parsed.sessionData[dataId] = sessionAttrs;
					}
					break;
				}
				case "SESSION-KEY": {
					const sessionKey = parseKey(attributes, baseurl, parsed);
					if (sessionKey.encrypted && sessionKey.isSupported()) {
						if (parsed.sessionKeys === null) parsed.sessionKeys = [];
						parsed.sessionKeys.push(sessionKey);
					} else logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
					break;
				}
				case "DEFINE":
					addVariableDefinition(parsed, new AttrList(attributes, parsed), baseurl);
					break;
				case "CONTENT-STEERING": {
					const contentSteeringAttributes = new AttrList(attributes, parsed);
					parsed.contentSteering = {
						uri: M3U8Parser.resolve(contentSteeringAttributes["SERVER-URI"], baseurl),
						pathwayId: contentSteeringAttributes["PATHWAY-ID"] || "."
					};
					break;
				}
				case "START":
					parsed.startTimeOffset = parseStartTimeOffset(attributes);
					break;
			}
		}
		parsed.levels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length ? levelsWithKnownCodecs : parsed.levels;
		if (parsed.levels.length === 0) parsed.playlistParsingError = /* @__PURE__ */ new Error("no levels found in manifest");
		return parsed;
	}
	static parseMasterPlaylistMedia(string, baseurl, parsed) {
		let result;
		const results = {};
		const levels = parsed.levels;
		const groupsByType = {
			AUDIO: levels.map((level) => ({
				id: level.attrs.AUDIO,
				audioCodec: level.audioCodec
			})),
			SUBTITLES: levels.map((level) => ({
				id: level.attrs.SUBTITLES,
				textCodec: level.textCodec
			})),
			"CLOSED-CAPTIONS": []
		};
		let id = 0;
		MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
		while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
			const attrs = new AttrList(result[1], parsed);
			const type = attrs.TYPE;
			if (type) {
				const groups = groupsByType[type];
				const medias = results[type] || [];
				results[type] = medias;
				const lang = attrs.LANGUAGE;
				const assocLang = attrs["ASSOC-LANGUAGE"];
				const channels = attrs.CHANNELS;
				const characteristics = attrs.CHARACTERISTICS;
				const instreamId = attrs["INSTREAM-ID"];
				const media = {
					attrs,
					bitrate: 0,
					id: id++,
					groupId: attrs["GROUP-ID"] || "",
					name: attrs.NAME || lang || "",
					type,
					default: attrs.bool("DEFAULT"),
					autoselect: attrs.bool("AUTOSELECT"),
					forced: attrs.bool("FORCED"),
					lang,
					url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ""
				};
				if (assocLang) media.assocLang = assocLang;
				if (channels) media.channels = channels;
				if (characteristics) media.characteristics = characteristics;
				if (instreamId) media.instreamId = instreamId;
				if (groups != null && groups.length) {
					const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
					assignCodec(media, groupCodec, "audioCodec");
					assignCodec(media, groupCodec, "textCodec");
				}
				medias.push(media);
			}
		}
		return results;
	}
	static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
		var _LEVEL_PLAYLIST_REGEX;
		const base = { url: baseurl };
		const level = new LevelDetails(baseurl);
		const fragments = level.fragments;
		const programDateTimes = [];
		let currentInitSegment = null;
		let currentSN = 0;
		let currentPart = 0;
		let totalduration = 0;
		let discontinuityCounter = 0;
		let currentBitrate = 0;
		let prevFrag = null;
		let frag = new Fragment(type, base);
		let result;
		let i;
		let levelkeys;
		let firstPdtIndex = -1;
		let createNextFrag = false;
		let nextByteRange = null;
		let serverControlAttrs;
		LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
		level.m3u8 = string;
		level.hasVariableRefs = hasVariableReferences(string);
		if (((_LEVEL_PLAYLIST_REGEX = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) == null ? void 0 : _LEVEL_PLAYLIST_REGEX[0]) !== "#EXTM3U") {
			level.playlistParsingError = /* @__PURE__ */ new Error("Missing format identifier #EXTM3U");
			return level;
		}
		while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
			if (createNextFrag) {
				createNextFrag = false;
				frag = new Fragment(type, base);
				frag.playlistOffset = totalduration;
				frag.setStart(totalduration);
				frag.sn = currentSN;
				frag.cc = discontinuityCounter;
				if (currentBitrate) frag.bitrate = currentBitrate;
				frag.level = id;
				if (currentInitSegment) {
					frag.initSegment = currentInitSegment;
					if (currentInitSegment.rawProgramDateTime) {
						frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
						currentInitSegment.rawProgramDateTime = null;
					}
					if (nextByteRange) {
						frag.setByteRange(nextByteRange);
						nextByteRange = null;
					}
				}
			}
			const duration = result[1];
			if (duration) {
				frag.duration = parseFloat(duration);
				const title = (" " + result[2]).slice(1);
				frag.title = title || null;
				frag.tagList.push(title ? [
					"INF",
					duration,
					title
				] : ["INF", duration]);
			} else if (result[3]) {
				if (isFiniteNumber(frag.duration)) {
					frag.playlistOffset = totalduration;
					frag.setStart(totalduration);
					if (levelkeys) setFragLevelKeys(frag, levelkeys, level);
					frag.sn = currentSN;
					frag.level = id;
					frag.cc = discontinuityCounter;
					fragments.push(frag);
					const uri = (" " + result[3]).slice(1);
					frag.relurl = substituteVariables(level, uri);
					assignProgramDateTime(frag, prevFrag, programDateTimes);
					prevFrag = frag;
					totalduration += frag.duration;
					currentSN++;
					currentPart = 0;
					createNextFrag = true;
				}
			} else {
				result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
				if (!result) {
					logger.warn("No matches on slow regex match for level playlist!");
					continue;
				}
				for (i = 1; i < result.length; i++) if (result[i] !== void 0) break;
				const tag = (" " + result[i]).slice(1);
				const value1 = (" " + result[i + 1]).slice(1);
				const value2 = result[i + 2] ? (" " + result[i + 2]).slice(1) : null;
				switch (tag) {
					case "BYTERANGE":
						if (prevFrag) frag.setByteRange(value1, prevFrag);
						else frag.setByteRange(value1);
						break;
					case "PROGRAM-DATE-TIME":
						frag.rawProgramDateTime = value1;
						frag.tagList.push(["PROGRAM-DATE-TIME", value1]);
						if (firstPdtIndex === -1) firstPdtIndex = fragments.length;
						break;
					case "PLAYLIST-TYPE":
						if (level.type) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						level.type = value1.toUpperCase();
						break;
					case "MEDIA-SEQUENCE":
						if (level.startSN !== 0) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						else if (fragments.length > 0) assignMustAppearBeforeSegmentsError(level, tag, result);
						currentSN = level.startSN = parseInt(value1);
						break;
					case "SKIP": {
						if (level.skippedSegments) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						const skipAttrs = new AttrList(value1, level);
						const skippedSegments = skipAttrs.decimalInteger("SKIPPED-SEGMENTS");
						if (isFiniteNumber(skippedSegments)) {
							level.skippedSegments += skippedSegments;
							for (let _i = skippedSegments; _i--;) fragments.push(null);
							currentSN += skippedSegments;
						}
						const recentlyRemovedDateranges = skipAttrs.enumeratedString("RECENTLY-REMOVED-DATERANGES");
						if (recentlyRemovedDateranges) level.recentlyRemovedDateranges = (level.recentlyRemovedDateranges || []).concat(recentlyRemovedDateranges.split("	"));
						break;
					}
					case "TARGETDURATION":
						if (level.targetduration !== 0) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						level.targetduration = Math.max(parseInt(value1), 1);
						break;
					case "VERSION":
						if (level.version !== null) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						level.version = parseInt(value1);
						break;
					case "INDEPENDENT-SEGMENTS": break;
					case "ENDLIST":
						if (!level.live) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						level.live = false;
						break;
					case "#":
						if (value1 || value2) frag.tagList.push(value2 ? [value1, value2] : [value1]);
						break;
					case "DISCONTINUITY":
						discontinuityCounter++;
						frag.tagList.push(["DIS"]);
						break;
					case "GAP":
						frag.gap = true;
						frag.tagList.push([tag]);
						break;
					case "BITRATE":
						frag.tagList.push([tag, value1]);
						currentBitrate = parseInt(value1) * 1e3;
						if (isFiniteNumber(currentBitrate)) frag.bitrate = currentBitrate;
						else currentBitrate = 0;
						break;
					case "DATERANGE": {
						const dateRangeAttr = new AttrList(value1, level);
						const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID], level.dateRangeTagCount);
						level.dateRangeTagCount++;
						if (dateRange.isValid || level.skippedSegments) level.dateRanges[dateRange.id] = dateRange;
						else logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
						frag.tagList.push(["EXT-X-DATERANGE", value1]);
						break;
					}
					case "DEFINE":
						{
							const variableAttributes = new AttrList(value1, level);
							if ("IMPORT" in variableAttributes) importVariableDefinition(level, variableAttributes, multivariantVariableList);
							else addVariableDefinition(level, variableAttributes, baseurl);
						}
						break;
					case "DISCONTINUITY-SEQUENCE":
						if (level.startCC !== 0) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						else if (fragments.length > 0) assignMustAppearBeforeSegmentsError(level, tag, result);
						level.startCC = discontinuityCounter = parseInt(value1);
						break;
					case "KEY": {
						const levelKey = parseKey(value1, baseurl, level);
						if (levelKey.isSupported()) {
							if (levelKey.method === "NONE") {
								levelkeys = void 0;
								break;
							}
							if (!levelkeys) levelkeys = {};
							const currentKey = levelkeys[levelKey.keyFormat];
							if (!(currentKey != null && currentKey.matches(levelKey))) {
								if (currentKey) levelkeys = _extends({}, levelkeys);
								levelkeys[levelKey.keyFormat] = levelKey;
							}
						} else logger.warn(`[Keys] Ignoring unsupported EXT-X-KEY tag: "${value1}"`);
						break;
					}
					case "START":
						level.startTimeOffset = parseStartTimeOffset(value1);
						break;
					case "MAP": {
						const mapAttrs = new AttrList(value1, level);
						if (frag.duration) {
							const init = new Fragment(type, base);
							setInitSegment(init, mapAttrs, id, levelkeys);
							currentInitSegment = init;
							frag.initSegment = currentInitSegment;
							if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
						} else {
							const end = frag.byteRangeEndOffset;
							if (end) {
								const start = frag.byteRangeStartOffset;
								nextByteRange = `${end - start}@${start}`;
							} else nextByteRange = null;
							setInitSegment(frag, mapAttrs, id, levelkeys);
							currentInitSegment = frag;
							createNextFrag = true;
						}
						currentInitSegment.cc = discontinuityCounter;
						break;
					}
					case "SERVER-CONTROL":
						if (serverControlAttrs) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						serverControlAttrs = new AttrList(value1);
						level.canBlockReload = serverControlAttrs.bool("CAN-BLOCK-RELOAD");
						level.canSkipUntil = serverControlAttrs.optionalFloat("CAN-SKIP-UNTIL", 0);
						level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool("CAN-SKIP-DATERANGES");
						level.partHoldBack = serverControlAttrs.optionalFloat("PART-HOLD-BACK", 0);
						level.holdBack = serverControlAttrs.optionalFloat("HOLD-BACK", 0);
						break;
					case "PART-INF":
						if (level.partTarget) assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
						level.partTarget = new AttrList(value1).decimalFloatingPoint("PART-TARGET");
						break;
					case "PART": {
						let partList = level.partList;
						if (!partList) partList = level.partList = [];
						const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : void 0;
						const index = currentPart++;
						const part = new Part(new AttrList(value1, level), frag, base, index, previousFragmentPart);
						partList.push(part);
						frag.duration += part.duration;
						break;
					}
					case "PRELOAD-HINT":
						level.preloadHint = new AttrList(value1, level);
						break;
					case "RENDITION-REPORT": {
						const renditionReportAttrs = new AttrList(value1, level);
						level.renditionReports = level.renditionReports || [];
						level.renditionReports.push(renditionReportAttrs);
						break;
					}
					default:
						logger.warn(`line parsed but not handled: ${result}`);
						break;
				}
			}
		}
		if (prevFrag && !prevFrag.relurl) {
			fragments.pop();
			totalduration -= prevFrag.duration;
			if (level.partList) level.fragmentHint = prevFrag;
		} else if (level.partList) {
			assignProgramDateTime(frag, prevFrag, programDateTimes);
			frag.cc = discontinuityCounter;
			level.fragmentHint = frag;
			if (levelkeys) setFragLevelKeys(frag, levelkeys, level);
		}
		if (!level.targetduration) level.playlistParsingError = /* @__PURE__ */ new Error(`Missing Target Duration`);
		const fragmentLength = fragments.length;
		const firstFragment = fragments[0];
		const lastFragment = fragments[fragmentLength - 1];
		totalduration += level.skippedSegments * level.targetduration;
		if (totalduration > 0 && fragmentLength && lastFragment) {
			level.averagetargetduration = totalduration / fragmentLength;
			const lastSn = lastFragment.sn;
			level.endSN = lastSn !== "initSegment" ? lastSn : 0;
			if (!level.live) lastFragment.endList = true;
			/**
			* Backfill any missing PDT values
			* "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
			* one or more Media Segment URIs, the client SHOULD extrapolate
			* backward from that tag (using EXTINF durations and/or media
			* timestamps) to associate dates with those segments."
			* We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
			* computed.
			*/
			if (firstPdtIndex > 0) {
				backfillProgramDateTimes(fragments, firstPdtIndex);
				if (firstFragment) programDateTimes.unshift(firstFragment);
			}
		}
		if (level.fragmentHint) totalduration += level.fragmentHint.duration;
		level.totalduration = totalduration;
		if (programDateTimes.length && level.dateRangeTagCount && firstFragment) mapDateRanges(programDateTimes, level);
		level.endCC = discontinuityCounter;
		return level;
	}
};
function mapDateRanges(programDateTimes, details) {
	let programDateTimeCount = programDateTimes.length;
	if (!programDateTimeCount) if (details.hasProgramDateTime) {
		const lastFragment = details.fragments[details.fragments.length - 1];
		programDateTimes.push(lastFragment);
		programDateTimeCount++;
	} else return;
	const lastProgramDateTime = programDateTimes[programDateTimeCount - 1];
	const playlistEnd = details.live ? Infinity : details.totalduration;
	const dateRangeIds = Object.keys(details.dateRanges);
	for (let i = dateRangeIds.length; i--;) {
		const dateRange = details.dateRanges[dateRangeIds[i]];
		const startDateTime = dateRange.startDate.getTime();
		dateRange.tagAnchor = lastProgramDateTime.ref;
		for (let j = programDateTimeCount; j--;) {
			var _programDateTimes$j;
			if (((_programDateTimes$j = programDateTimes[j]) == null ? void 0 : _programDateTimes$j.sn) < details.startSN) break;
			const fragIndex = findFragmentWithStartDate(details, startDateTime, programDateTimes, j, playlistEnd);
			if (fragIndex !== -1) {
				dateRange.tagAnchor = details.fragments[fragIndex].ref;
				break;
			}
		}
	}
}
function findFragmentWithStartDate(details, startDateTime, programDateTimes, index, endTime) {
	const pdtFragment = programDateTimes[index];
	if (pdtFragment) {
		const pdtStart = pdtFragment.programDateTime;
		if (startDateTime >= pdtStart || index === 0) {
			var _programDateTimes;
			if (startDateTime <= pdtStart + ((((_programDateTimes = programDateTimes[index + 1]) == null ? void 0 : _programDateTimes.start) || endTime) - pdtFragment.start) * 1e3) {
				const startIndex = programDateTimes[index].sn - details.startSN;
				if (startIndex < 0) return -1;
				const fragments = details.fragments;
				if (fragments.length > programDateTimes.length) {
					const endIndex = (programDateTimes[index + 1] || fragments[fragments.length - 1]).sn - details.startSN;
					for (let i = endIndex; i > startIndex; i--) {
						const fragStartDateTime = fragments[i].programDateTime;
						if (startDateTime >= fragStartDateTime && startDateTime < fragStartDateTime + fragments[i].duration * 1e3) return i;
					}
				}
				return startIndex;
			}
		}
	}
	return -1;
}
function parseKey(keyTagAttributes, baseurl, parsed) {
	var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
	const keyAttrs = new AttrList(keyTagAttributes, parsed);
	const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : "";
	const decrypturi = keyAttrs.URI;
	const decryptiv = keyAttrs.hexadecimalInteger("IV");
	const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
	const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : "identity";
	if (decrypturi && keyAttrs.IV && !decryptiv) logger.error(`Invalid IV: ${keyAttrs.IV}`);
	return new LevelKey(decryptmethod, decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : "", decryptkeyformat, (decryptkeyformatversions ? decryptkeyformatversions : "1").split("/").map(Number).filter(Number.isFinite), decryptiv, keyAttrs.KEYID);
}
function parseStartTimeOffset(startAttributes) {
	const startTimeOffset = new AttrList(startAttributes).decimalFloatingPoint("TIME-OFFSET");
	if (isFiniteNumber(startTimeOffset)) return startTimeOffset;
	return null;
}
function setCodecs(codecsAttributeValue, level) {
	let codecs = (codecsAttributeValue || "").split(/[ ,]+/).filter((c) => c);
	[
		"video",
		"audio",
		"text"
	].forEach((type) => {
		const filtered = codecs.filter((codec) => isCodecType(codec, type));
		if (filtered.length) {
			level[`${type}Codec`] = filtered.map((c) => c.split("/")[0]).join(",");
			codecs = codecs.filter((codec) => filtered.indexOf(codec) === -1);
		}
	});
	level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
	const codecValue = groupItem[codecProperty];
	if (codecValue) media[codecProperty] = codecValue;
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
	let fragPrev = fragments[firstPdtIndex];
	for (let i = firstPdtIndex; i--;) {
		const frag = fragments[i];
		if (!frag) return;
		frag.programDateTime = fragPrev.programDateTime - frag.duration * 1e3;
		fragPrev = frag;
	}
}
function assignProgramDateTime(frag, prevFrag, programDateTimes) {
	if (frag.rawProgramDateTime) programDateTimes.push(frag);
	else if (prevFrag != null && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
	frag.relurl = mapAttrs.URI;
	if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
	frag.level = id;
	frag.sn = "initSegment";
	if (levelkeys) frag.levelkeys = levelkeys;
	frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
	frag.levelkeys = levelkeys;
	const { encryptedFragments } = level;
	if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some((format) => levelkeys[format].isCommonEncryption)) encryptedFragments.push(frag);
}
function assignMultipleMediaPlaylistTagOccuranceError(level, tag, result) {
	level.playlistParsingError = /* @__PURE__ */ new Error(`#EXT-X-${tag} must not appear more than once (${result[0]})`);
}
function assignMustAppearBeforeSegmentsError(level, tag, result) {
	level.playlistParsingError = /* @__PURE__ */ new Error(`#EXT-X-${tag} must appear before the first Media Segment (${result[0]})`);
}
function updateFromToPTS(fragFrom, fragTo) {
	const fragToPTS = fragTo.startPTS;
	if (isFiniteNumber(fragToPTS)) {
		let duration = 0;
		let frag;
		if (fragTo.sn > fragFrom.sn) {
			duration = fragToPTS - fragFrom.start;
			frag = fragFrom;
		} else {
			duration = fragFrom.start - fragToPTS;
			frag = fragTo;
		}
		if (frag.duration !== duration) frag.setDuration(duration);
	} else if (fragTo.sn > fragFrom.sn) if (fragFrom.cc === fragTo.cc && fragFrom.minEndPTS) fragTo.setStart(fragFrom.start + (fragFrom.minEndPTS - fragFrom.start));
	else fragTo.setStart(fragFrom.start + fragFrom.duration);
	else fragTo.setStart(Math.max(fragFrom.start - fragTo.duration, 0));
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS, logger) {
	if (endPTS - startPTS <= 0) {
		logger.warn("Fragment should have a positive duration", frag);
		endPTS = startPTS + frag.duration;
		endDTS = startDTS + frag.duration;
	}
	let maxStartPTS = startPTS;
	let minEndPTS = endPTS;
	const fragStartPts = frag.startPTS;
	const fragEndPts = frag.endPTS;
	if (isFiniteNumber(fragStartPts)) {
		const deltaPTS = Math.abs(fragStartPts - startPTS);
		if (details && deltaPTS > details.totalduration) logger.warn(`media timestamps and playlist times differ by ${deltaPTS}s for level ${frag.level} ${details.url}`);
		else if (!isFiniteNumber(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
		else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
		maxStartPTS = Math.max(startPTS, fragStartPts);
		startPTS = Math.min(startPTS, fragStartPts);
		startDTS = frag.startDTS !== void 0 ? Math.min(startDTS, frag.startDTS) : startDTS;
		minEndPTS = Math.min(endPTS, fragEndPts);
		endPTS = Math.max(endPTS, fragEndPts);
		endDTS = frag.endDTS !== void 0 ? Math.max(endDTS, frag.endDTS) : endDTS;
	}
	const drift = startPTS - frag.start;
	if (frag.start !== 0) frag.setStart(startPTS);
	frag.setDuration(endPTS - frag.start);
	frag.startPTS = startPTS;
	frag.maxStartPTS = maxStartPTS;
	frag.startDTS = startDTS;
	frag.endPTS = endPTS;
	frag.minEndPTS = minEndPTS;
	frag.endDTS = endDTS;
	const sn = frag.sn;
	if (!details || sn < details.startSN || sn > details.endSN) return 0;
	let i;
	const fragIdx = sn - details.startSN;
	const fragments = details.fragments;
	fragments[fragIdx] = frag;
	for (i = fragIdx; i > 0; i--) updateFromToPTS(fragments[i], fragments[i - 1]);
	for (i = fragIdx; i < fragments.length - 1; i++) updateFromToPTS(fragments[i], fragments[i + 1]);
	if (details.fragmentHint) updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
	details.PTSKnown = details.alignedSliding = true;
	return drift;
}
function mergeDetails(oldDetails, newDetails, logger) {
	if (oldDetails === newDetails) return;
	let currentInitSegment = null;
	const oldFragments = oldDetails.fragments;
	for (let i = oldFragments.length - 1; i >= 0; i--) {
		const oldInit = oldFragments[i].initSegment;
		if (oldInit) {
			currentInitSegment = oldInit;
			break;
		}
	}
	if (oldDetails.fragmentHint) delete oldDetails.fragmentHint.endPTS;
	let PTSFrag;
	mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag, newFragIndex, newFragments) => {
		if ((!newDetails.startCC || newDetails.skippedSegments) && newFrag.cc !== oldFrag.cc) {
			const ccOffset = oldFrag.cc - newFrag.cc;
			for (let i = newFragIndex; i < newFragments.length; i++) newFragments[i].cc += ccOffset;
			newDetails.endCC = newFragments[newFragments.length - 1].cc;
		}
		if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
			newFrag.setStart(newFrag.startPTS = oldFrag.startPTS);
			newFrag.startDTS = oldFrag.startDTS;
			newFrag.maxStartPTS = oldFrag.maxStartPTS;
			newFrag.endPTS = oldFrag.endPTS;
			newFrag.endDTS = oldFrag.endDTS;
			newFrag.minEndPTS = oldFrag.minEndPTS;
			newFrag.setDuration(oldFrag.endPTS - oldFrag.startPTS);
			if (newFrag.duration) PTSFrag = newFrag;
			newDetails.PTSKnown = newDetails.alignedSliding = true;
		}
		if (oldFrag.hasStreams) newFrag.elementaryStreams = oldFrag.elementaryStreams;
		newFrag.loader = oldFrag.loader;
		if (oldFrag.hasStats) newFrag.stats = oldFrag.stats;
		if (oldFrag.initSegment) {
			newFrag.initSegment = oldFrag.initSegment;
			currentInitSegment = oldFrag.initSegment;
		}
	});
	const newFragments = newDetails.fragments;
	const fragmentsToCheck = newDetails.fragmentHint ? newFragments.concat(newDetails.fragmentHint) : newFragments;
	if (currentInitSegment) fragmentsToCheck.forEach((frag) => {
		var _currentInitSegment;
		if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) frag.initSegment = currentInitSegment;
	});
	if (newDetails.skippedSegments) {
		newDetails.deltaUpdateFailed = newFragments.some((frag) => !frag);
		if (newDetails.deltaUpdateFailed) {
			logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
			for (let i = newDetails.skippedSegments; i--;) newFragments.shift();
			newDetails.startSN = newFragments[0].sn;
		} else {
			if (newDetails.canSkipDateRanges) newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails, logger);
			const programDateTimes = oldDetails.fragments.filter((frag) => frag.rawProgramDateTime);
			if (oldDetails.hasProgramDateTime && !newDetails.hasProgramDateTime) {
				for (let i = 1; i < fragmentsToCheck.length; i++) if (fragmentsToCheck[i].programDateTime === null) assignProgramDateTime(fragmentsToCheck[i], fragmentsToCheck[i - 1], programDateTimes);
			}
			mapDateRanges(programDateTimes, newDetails);
		}
		newDetails.endCC = newFragments[newFragments.length - 1].cc;
	}
	if (!newDetails.startCC) {
		var _fragPriorToNewStart$;
		const fragPriorToNewStart = getFragmentWithSN(oldDetails, newDetails.startSN - 1);
		newDetails.startCC = (_fragPriorToNewStart$ = fragPriorToNewStart == null ? void 0 : fragPriorToNewStart.cc) != null ? _fragPriorToNewStart$ : newFragments[0].cc;
	}
	mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart) => {
		newPart.elementaryStreams = oldPart.elementaryStreams;
		newPart.stats = oldPart.stats;
	});
	if (PTSFrag) updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS, logger);
	else adjustSliding(oldDetails, newDetails);
	if (newFragments.length) newDetails.totalduration = newDetails.edge - newFragments[0].start;
	newDetails.driftStartTime = oldDetails.driftStartTime;
	newDetails.driftStart = oldDetails.driftStart;
	const advancedDateTime = newDetails.advancedDateTime;
	if (newDetails.advanced && advancedDateTime) {
		const edge = newDetails.edge;
		if (!newDetails.driftStart) {
			newDetails.driftStartTime = advancedDateTime;
			newDetails.driftStart = edge;
		}
		newDetails.driftEndTime = advancedDateTime;
		newDetails.driftEnd = edge;
	} else {
		newDetails.driftEndTime = oldDetails.driftEndTime;
		newDetails.driftEnd = oldDetails.driftEnd;
		newDetails.advancedDateTime = oldDetails.advancedDateTime;
	}
	if (newDetails.requestScheduled === -1) newDetails.requestScheduled = oldDetails.requestScheduled;
}
function mergeDateRanges(oldDateRanges, newDetails, logger) {
	const { dateRanges: deltaDateRanges, recentlyRemovedDateranges } = newDetails;
	const dateRanges = _extends({}, oldDateRanges);
	if (recentlyRemovedDateranges) recentlyRemovedDateranges.forEach((id) => {
		delete dateRanges[id];
	});
	const mergeCount = Object.keys(dateRanges).length;
	if (!mergeCount) return deltaDateRanges;
	Object.keys(deltaDateRanges).forEach((id) => {
		const mergedDateRange = dateRanges[id];
		const dateRange = new DateRange(deltaDateRanges[id].attr, mergedDateRange);
		if (dateRange.isValid) {
			dateRanges[id] = dateRange;
			if (!mergedDateRange) dateRange.tagOrder += mergeCount;
		} else logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${stringify(deltaDateRanges[id].attr)}"`);
	});
	return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
	if (oldParts && newParts) {
		let delta = 0;
		for (let i = 0, len = oldParts.length; i <= len; i++) {
			const oldPart = oldParts[i];
			const newPart = newParts[i + delta];
			if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) intersectionFn(oldPart, newPart);
			else delta--;
		}
	}
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
	const skippedSegments = newDetails.skippedSegments;
	const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
	const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
	const delta = newDetails.startSN - oldDetails.startSN;
	const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
	const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
	for (let i = start; i <= end; i++) {
		const oldFrag = oldFrags[delta + i];
		let newFrag = newFrags[i];
		if (skippedSegments && !newFrag && oldFrag) newFrag = newDetails.fragments[i] = oldFrag;
		if (oldFrag && newFrag) {
			intersectionFn(oldFrag, newFrag, i, newFrags);
			const uriBefore = oldFrag.relurl;
			const uriAfter = newFrag.relurl;
			if (uriBefore && notEqualAfterStrippingQueries(uriBefore, uriAfter)) {
				newDetails.playlistParsingError = getSequenceError(`media sequence mismatch ${newFrag.sn}:`, oldDetails, newDetails, oldFrag, newFrag);
				return;
			} else if (oldFrag.cc !== newFrag.cc) {
				newDetails.playlistParsingError = getSequenceError(`discontinuity sequence mismatch (${oldFrag.cc}!=${newFrag.cc})`, oldDetails, newDetails, oldFrag, newFrag);
				return;
			}
		}
	}
}
function getSequenceError(message, oldDetails, newDetails, oldFrag, newFrag) {
	return /* @__PURE__ */ new Error(`${message} ${newFrag.url}
Playlist starting @${oldDetails.startSN}
${oldDetails.m3u8}

Playlist starting @${newDetails.startSN}
${newDetails.m3u8}`);
}
function adjustSliding(oldDetails, newDetails, matchingStableVariantOrRendition = true) {
	const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
	const oldFragments = oldDetails.fragments;
	const advancedOrStable = delta >= 0;
	let sliding = 0;
	if (advancedOrStable && delta < oldFragments.length) sliding = oldFragments[delta].start;
	else if (advancedOrStable && newDetails.startSN === oldDetails.endSN + 1) sliding = oldDetails.fragmentEnd;
	else if (advancedOrStable && matchingStableVariantOrRendition) sliding = oldDetails.fragmentStart + delta * newDetails.levelTargetDuration;
	else if (!newDetails.skippedSegments && newDetails.fragmentStart === 0) sliding = oldDetails.fragmentStart;
	else return;
	addSliding(newDetails, sliding);
}
function addSliding(details, sliding) {
	if (sliding) {
		const fragments = details.fragments;
		for (let i = details.skippedSegments; i < fragments.length; i++) fragments[i].addStart(sliding);
		if (details.fragmentHint) details.fragmentHint.addStart(sliding);
	}
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
	let reloadInterval = 1e3 * newDetails.targetduration;
	if (newDetails.updated) {
		const fragments = newDetails.fragments;
		if (fragments.length && reloadInterval * 4 > distanceToLiveEdgeMs) {
			const lastSegmentDuration = fragments[fragments.length - 1].duration * 1e3;
			if (lastSegmentDuration < reloadInterval) reloadInterval = lastSegmentDuration;
		}
	} else reloadInterval /= 2;
	return Math.round(reloadInterval);
}
function getFragmentWithSN(details, sn, fragCurrent) {
	if (!details) return null;
	let fragment = details.fragments[sn - details.startSN];
	if (fragment) return fragment;
	fragment = details.fragmentHint;
	if (fragment && fragment.sn === sn) return fragment;
	if (sn < details.startSN && fragCurrent && fragCurrent.sn === sn) return fragCurrent;
	return null;
}
function getPartWith(details, sn, partIndex) {
	if (!details) return null;
	return findPart(details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
	if (partList) for (let i = partList.length; i--;) {
		const part = partList[i];
		if (part.index === partIndex && part.fragment.sn === sn) return part;
	}
	return null;
}
function reassignFragmentLevelIndexes(levels) {
	levels.forEach((level, index) => {
		var _level$details;
		(_level$details = level.details) == null || _level$details.fragments.forEach((fragment) => {
			fragment.level = index;
			if (fragment.initSegment) fragment.initSegment.level = index;
		});
	});
}
function notEqualAfterStrippingQueries(uriBefore, uriAfter) {
	if (uriBefore !== uriAfter && uriAfter) return stripQuery(uriBefore) !== stripQuery(uriAfter);
	return false;
}
function stripQuery(uri) {
	return uri.replace(/\?[^?]*$/, "");
}
function findFirstFragWithCC(fragments, cc) {
	for (let i = 0, len = fragments.length; i < len; i++) {
		var _fragments$i;
		if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) return fragments[i];
	}
	return null;
}
function shouldAlignOnDiscontinuities(refDetails, details) {
	if (refDetails) {
		if (details.startCC < refDetails.endCC && details.endCC > refDetails.startCC) return true;
	}
	return false;
}
function adjustFragmentStart(frag, sliding) {
	const start = frag.start + sliding;
	frag.startPTS = start;
	frag.setStart(start);
	frag.endPTS = start + frag.duration;
}
function adjustSlidingStart(sliding, details) {
	const fragments = details.fragments;
	for (let i = 0, len = fragments.length; i < len; i++) adjustFragmentStart(fragments[i], sliding);
	if (details.fragmentHint) adjustFragmentStart(details.fragmentHint, sliding);
	details.alignedSliding = true;
}
/**
* Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
* contiguous stream with the last fragments.
* The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
* download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
* and an extra download.
* @param lastLevel
* @param details
*/
function alignStream(switchDetails, details) {
	if (!switchDetails) return;
	alignDiscontinuities(details, switchDetails);
	if (!details.alignedSliding) alignMediaPlaylistByPDT(details, switchDetails);
	if (!details.alignedSliding && !details.skippedSegments) adjustSliding(switchDetails, details, false);
}
/**
* Ajust the start of fragments in `details` by the difference in time between fragments of the latest
* shared discontinuity sequence change.
* @param lastLevel - The details of the last loaded level
* @param details - The details of the new level
*/
function alignDiscontinuities(details, refDetails) {
	if (!shouldAlignOnDiscontinuities(refDetails, details)) return;
	const targetCC = Math.min(refDetails.endCC, details.endCC);
	const refFrag = findFirstFragWithCC(refDetails.fragments, targetCC);
	const frag = findFirstFragWithCC(details.fragments, targetCC);
	if (!refFrag || !frag) return;
	logger.log(`Aligning playlist at start of dicontinuity sequence ${targetCC}`);
	adjustSlidingStart(refFrag.start - frag.start, details);
}
/**
* Ensures appropriate time-alignment between renditions based on PDT.
* This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
* for the last discontinuity sequence number shared by both playlists when present,
* and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
* times/timelines of `details` accordingly.
* Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
* the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
* are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
* be consistent across playlists, per the HLS spec.
* @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
* @param refDetails - The details of the reference rendition with start and PDT times for alignment.
*/
function alignMediaPlaylistByPDT(details, refDetails) {
	if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) return;
	const fragments = details.fragments;
	const refFragments = refDetails.fragments;
	if (!fragments.length || !refFragments.length) return;
	let refFrag;
	let frag;
	const targetCC = Math.min(refDetails.endCC, details.endCC);
	if (refDetails.startCC < targetCC && details.startCC < targetCC) {
		refFrag = findFirstFragWithCC(refFragments, targetCC);
		frag = findFirstFragWithCC(fragments, targetCC);
	}
	if (!refFrag || !frag) {
		refFrag = refFragments[Math.floor(refFragments.length / 2)];
		frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
	}
	const refPDT = refFrag.programDateTime;
	const targetPDT = frag.programDateTime;
	if (!refPDT || !targetPDT) return;
	adjustSlidingStart((targetPDT - refPDT) / 1e3 - (frag.start - refFrag.start), details);
}
function addEventListener(el, type, listener) {
	removeEventListener(el, type, listener);
	el.addEventListener(type, listener);
}
function removeEventListener(el, type, listener) {
	el.removeEventListener(type, listener);
}
/**
*  TimeRanges to string helper
*/
var TimeRanges = { toString: function(r) {
	let log = "";
	const len = r.length;
	for (let i = 0; i < len; i++) log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
	return log;
} };
var State = {
	STOPPED: "STOPPED",
	IDLE: "IDLE",
	KEY_LOADING: "KEY_LOADING",
	FRAG_LOADING: "FRAG_LOADING",
	FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
	WAITING_TRACK: "WAITING_TRACK",
	PARSING: "PARSING",
	PARSED: "PARSED",
	ENDED: "ENDED",
	ERROR: "ERROR",
	WAITING_INIT_PTS: "WAITING_INIT_PTS",
	WAITING_LEVEL: "WAITING_LEVEL"
};
var BaseStreamController = class extends TaskLoop {
	constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType) {
		super(logPrefix, hls.logger);
		this.hls = void 0;
		this.fragPrevious = null;
		this.fragCurrent = null;
		this.fragmentTracker = void 0;
		this.transmuxer = null;
		this._state = State.STOPPED;
		this.playlistType = void 0;
		this.media = null;
		this.mediaBuffer = null;
		this.config = void 0;
		this.bitrateTest = false;
		this.lastCurrentTime = 0;
		this.nextLoadPosition = 0;
		this.startPosition = 0;
		this.startTimeOffset = null;
		this.retryDate = 0;
		this.levels = null;
		this.fragmentLoader = void 0;
		this.keyLoader = void 0;
		this.levelLastLoaded = null;
		this.startFragRequested = false;
		this.decrypter = void 0;
		this.initPTS = [];
		this.buffering = true;
		this.loadingParts = false;
		this.loopSn = void 0;
		this.onMediaSeeking = () => {
			const { config, fragCurrent, media, mediaBuffer, state } = this;
			const currentTime = media ? media.currentTime : 0;
			const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
			const noFowardBuffer = !bufferInfo.len;
			this.log(`Media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}, ${noFowardBuffer ? "out of" : "in"} buffer`);
			if (this.state === State.ENDED) this.resetLoadingState();
			else if (fragCurrent) {
				const tolerance = config.maxFragLookUpTolerance;
				const fragStartOffset = fragCurrent.start - tolerance;
				const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
				if (noFowardBuffer || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
					const pastFragment = currentTime > fragEndOffset;
					if (currentTime < fragStartOffset || pastFragment) {
						if (pastFragment && fragCurrent.loader) {
							this.log(`Cancelling fragment load for seek (sn: ${fragCurrent.sn})`);
							fragCurrent.abortRequests();
							this.resetLoadingState();
						}
						this.fragPrevious = null;
					}
				}
			}
			if (media) {
				this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
				if (currentTime > this.lastCurrentTime) this.lastCurrentTime = currentTime;
				if (!this.loadingParts) {
					const bufferEnd = Math.max(bufferInfo.end, currentTime);
					const shouldLoadParts = this.shouldLoadParts(this.getLevelDetails(), bufferEnd);
					if (shouldLoadParts) {
						this.log(`LL-Part loading ON after seeking to ${currentTime.toFixed(2)} with buffer @${bufferEnd.toFixed(2)}`);
						this.loadingParts = shouldLoadParts;
					}
				}
			}
			if (!this.hls.hasEnoughToStart) {
				this.log(`Setting ${noFowardBuffer ? "startPosition" : "nextLoadPosition"} to ${currentTime} for seek without enough to start`);
				this.nextLoadPosition = currentTime;
				if (noFowardBuffer) this.startPosition = currentTime;
			}
			if (noFowardBuffer && this.state === State.IDLE) this.tickImmediate();
		};
		this.onMediaEnded = () => {
			this.log(`setting startPosition to 0 because media ended`);
			this.startPosition = this.lastCurrentTime = 0;
		};
		this.playlistType = playlistType;
		this.hls = hls;
		this.fragmentLoader = new FragmentLoader(hls.config);
		this.keyLoader = keyLoader;
		this.fragmentTracker = fragmentTracker;
		this.config = hls.config;
		this.decrypter = new Decrypter(hls.config);
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	doTick() {
		this.onTickEnd();
	}
	onTickEnd() {}
	startLoad(startPosition) {}
	stopLoad() {
		if (this.state === State.STOPPED) return;
		this.fragmentLoader.abort();
		this.keyLoader.abort(this.playlistType);
		const frag = this.fragCurrent;
		if (frag != null && frag.loader) {
			frag.abortRequests();
			this.fragmentTracker.removeFragment(frag);
		}
		this.resetTransmuxer();
		this.fragCurrent = null;
		this.fragPrevious = null;
		this.clearInterval();
		this.clearNextTick();
		this.state = State.STOPPED;
	}
	get startPositionValue() {
		const { nextLoadPosition, startPosition } = this;
		if (startPosition === -1 && nextLoadPosition) return nextLoadPosition;
		return startPosition;
	}
	get bufferingEnabled() {
		return this.buffering;
	}
	pauseBuffering() {
		this.buffering = false;
	}
	resumeBuffering() {
		this.buffering = true;
	}
	get inFlightFrag() {
		return {
			frag: this.fragCurrent,
			state: this.state
		};
	}
	_streamEnded(bufferInfo, levelDetails) {
		if (levelDetails.live || !this.media) return false;
		const bufferEnd = bufferInfo.end || 0;
		const timelineStart = this.config.timelineOffset || 0;
		if (bufferEnd <= timelineStart) return false;
		const bufferedRanges = bufferInfo.buffered;
		if (this.config.maxBufferHole && bufferedRanges && bufferedRanges.length > 1) bufferInfo = BufferHelper.bufferedInfo(bufferedRanges, bufferInfo.start, 0);
		const nextStart = bufferInfo.nextStart;
		if (nextStart && nextStart > timelineStart && nextStart < levelDetails.edge) return false;
		if (this.media.currentTime < bufferInfo.start) return false;
		const partList = levelDetails.partList;
		if (partList != null && partList.length) {
			const lastPart = partList[partList.length - 1];
			return BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
		}
		const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
		return this.fragmentTracker.isEndListAppended(playlistType);
	}
	getLevelDetails() {
		if (this.levels && this.levelLastLoaded !== null) return this.levelLastLoaded.details;
	}
	get timelineOffset() {
		const configuredTimelineOffset = this.config.timelineOffset;
		if (configuredTimelineOffset) {
			var _this$getLevelDetails;
			return ((_this$getLevelDetails = this.getLevelDetails()) == null ? void 0 : _this$getLevelDetails.appliedTimelineOffset) || configuredTimelineOffset;
		}
		return 0;
	}
	onMediaAttached(event, data) {
		const media = this.media = this.mediaBuffer = data.media;
		addEventListener(media, "seeking", this.onMediaSeeking);
		addEventListener(media, "ended", this.onMediaEnded);
		const config = this.config;
		if (this.levels && config.autoStartLoad && this.state === State.STOPPED) this.startLoad(config.startPosition);
	}
	onMediaDetaching(event, data) {
		const transferringMedia = !!data.transferMedia;
		const media = this.media;
		if (media === null) return;
		if (media.ended) {
			this.log("MSE detaching and video ended, reset startPosition");
			this.startPosition = this.lastCurrentTime = 0;
		}
		removeEventListener(media, "seeking", this.onMediaSeeking);
		removeEventListener(media, "ended", this.onMediaEnded);
		if (this.keyLoader && !transferringMedia) this.keyLoader.detach();
		this.media = this.mediaBuffer = null;
		this.loopSn = void 0;
		if (transferringMedia) {
			this.resetLoadingState();
			this.resetTransmuxer();
			return;
		}
		this.loadingParts = false;
		this.fragmentTracker.removeAllFragments();
		this.stopLoad();
	}
	onManifestLoading() {
		this.initPTS = [];
		this.levels = this.levelLastLoaded = this.fragCurrent = null;
		this.lastCurrentTime = this.startPosition = 0;
		this.startFragRequested = false;
	}
	onError(event, data) {}
	onManifestLoaded(event, data) {
		this.startTimeOffset = data.startTimeOffset;
	}
	onHandlerDestroying() {
		this.stopLoad();
		if (this.transmuxer) {
			this.transmuxer.destroy();
			this.transmuxer = null;
		}
		super.onHandlerDestroying();
		this.hls = this.onMediaSeeking = this.onMediaEnded = null;
	}
	onHandlerDestroyed() {
		this.state = State.STOPPED;
		if (this.fragmentLoader) this.fragmentLoader.destroy();
		if (this.keyLoader) this.keyLoader.destroy();
		if (this.decrypter) this.decrypter.destroy();
		this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
		super.onHandlerDestroyed();
	}
	loadFragment(frag, level, targetBufferTime) {
		this.startFragRequested = true;
		this._loadFragForPlayback(frag, level, targetBufferTime);
	}
	_loadFragForPlayback(fragment, level, targetBufferTime) {
		const progressCallback = (data) => {
			const frag = data.frag;
			if (this.fragContextChanged(frag)) {
				this.warn(`${frag.type} sn: ${frag.sn}${data.part ? " part: " + data.part.index : ""} of ${this.fragInfo(frag, false, data.part)}) was dropped during download.`);
				this.fragmentTracker.removeFragment(frag);
				return;
			}
			frag.stats.chunkCount++;
			this._handleFragmentLoadProgress(data);
		};
		this._doFragLoad(fragment, level, targetBufferTime, progressCallback).then((data) => {
			if (!data) return;
			const state = this.state;
			const frag = data.frag;
			if (this.fragContextChanged(frag)) {
				if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
					this.fragmentTracker.removeFragment(frag);
					this.state = State.IDLE;
				}
				return;
			}
			if ("payload" in data) {
				this.log(`Loaded ${frag.type} sn: ${frag.sn} of ${this.playlistLabel()} ${frag.level}`);
				this.hls.trigger(Events.FRAG_LOADED, data);
			}
			this._handleFragmentLoadComplete(data);
		}).catch((reason) => {
			if (this.state === State.STOPPED || this.state === State.ERROR) return;
			this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
			this.resetFragmentLoading(fragment);
		});
	}
	clearTrackerIfNeeded(frag) {
		var _this$mediaBuffer;
		const { fragmentTracker } = this;
		if (fragmentTracker.getState(frag) === FragmentState.APPENDING) {
			const playlistType = frag.type;
			const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
			const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
			const backtrackFragment = this.backtrackFragment;
			if ((backtrackFragment ? frag.sn - backtrackFragment.sn : 0) === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) fragmentTracker.removeFragment(frag);
		} else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) fragmentTracker.removeAllFragments();
		else if (fragmentTracker.hasParts(frag.type)) {
			fragmentTracker.detectPartialFragments({
				frag,
				part: null,
				stats: frag.stats,
				id: frag.type
			});
			if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) fragmentTracker.removeFragment(frag);
		}
	}
	checkLiveUpdate(details) {
		if (details.updated && !details.live) {
			const lastFragment = details.fragments[details.fragments.length - 1];
			this.fragmentTracker.detectPartialFragments({
				frag: lastFragment,
				part: null,
				stats: lastFragment.stats,
				id: lastFragment.type
			});
		}
		if (!details.fragments[0]) details.deltaUpdateFailed = true;
	}
	waitForLive(levelInfo) {
		const details = levelInfo.details;
		return (details == null ? void 0 : details.live) && details.type !== "EVENT" && (this.levelLastLoaded !== levelInfo || details.expired);
	}
	flushMainBuffer(startOffset, endOffset, type = null) {
		if (!(startOffset - endOffset)) return;
		const flushScope = {
			startOffset,
			endOffset,
			type
		};
		this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
	}
	_loadInitSegment(fragment, level) {
		this._doFragLoad(fragment, level).then((data) => {
			const frag = data == null ? void 0 : data.frag;
			if (!frag || this.fragContextChanged(frag) || !this.levels) throw new Error("init load aborted");
			return data;
		}).then((data) => {
			const { hls } = this;
			const { frag, payload } = data;
			const decryptData = frag.decryptdata;
			if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && isFullSegmentEncryption(decryptData.method)) {
				const startTime = self.performance.now();
				return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, getAesModeFromFullSegmentMethod(decryptData.method)).catch((err) => {
					hls.trigger(Events.ERROR, {
						type: ErrorTypes.MEDIA_ERROR,
						details: ErrorDetails.FRAG_DECRYPT_ERROR,
						fatal: false,
						error: err,
						reason: err.message,
						frag
					});
					throw err;
				}).then((decryptedData) => {
					const endTime = self.performance.now();
					hls.trigger(Events.FRAG_DECRYPTED, {
						frag,
						payload: decryptedData,
						stats: {
							tstart: startTime,
							tdecrypt: endTime
						}
					});
					data.payload = decryptedData;
					return this.completeInitSegmentLoad(data);
				});
			}
			return this.completeInitSegmentLoad(data);
		}).catch((reason) => {
			if (this.state === State.STOPPED || this.state === State.ERROR) return;
			this.warn(reason);
			this.resetFragmentLoading(fragment);
		});
	}
	completeInitSegmentLoad(data) {
		const { levels } = this;
		if (!levels) throw new Error("init load aborted, missing levels");
		const stats = data.frag.stats;
		if (this.state !== State.STOPPED) this.state = State.IDLE;
		data.frag.data = new Uint8Array(data.payload);
		stats.parsing.start = stats.buffering.start = self.performance.now();
		stats.parsing.end = stats.buffering.end = self.performance.now();
		this.tick();
	}
	unhandledEncryptionError(initSegment, frag) {
		var _tracks$audio, _tracks$video;
		const tracks = initSegment.tracks;
		if (tracks && !frag.encrypted && ((_tracks$audio = tracks.audio) != null && _tracks$audio.encrypted || (_tracks$video = tracks.video) != null && _tracks$video.encrypted) && (!this.config.emeEnabled || !this.keyLoader.emeController)) {
			const media = this.media;
			const error = /* @__PURE__ */ new Error(`Encrypted track with no key in ${this.fragInfo(frag)} (media ${media ? "attached mediaKeys: " + media.mediaKeys : "detached"})`);
			this.warn(error.message);
			if (!media || media.mediaKeys) return false;
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.KEY_SYSTEM_ERROR,
				details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
				fatal: false,
				error,
				frag
			});
			this.resetTransmuxer();
			return true;
		}
		return false;
	}
	fragContextChanged(frag) {
		const { fragCurrent } = this;
		return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
	}
	fragBufferedComplete(frag, part) {
		const media = this.mediaBuffer ? this.mediaBuffer : this.media;
		this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? " part: " + part.index : ""} of ${this.fragInfo(frag, false, part)} > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : "(detached)"})`);
		if (isMediaFragment(frag)) {
			var _this$levels;
			if (frag.type !== PlaylistLevelType.SUBTITLE) {
				const el = frag.elementaryStreams;
				if (!Object.keys(el).some((type) => !!el[type])) {
					this.state = State.IDLE;
					return;
				}
			}
			const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
			if (level != null && level.fragmentError) {
				this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
				level.fragmentError = 0;
			}
		}
		this.state = State.IDLE;
	}
	_handleFragmentLoadComplete(fragLoadedEndData) {
		const { transmuxer } = this;
		if (!transmuxer) return;
		const { frag, part, partsLoaded } = fragLoadedEndData;
		const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some((fragLoaded) => !fragLoaded);
		const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
		transmuxer.flush(chunkMeta);
	}
	_handleFragmentLoadProgress(frag) {}
	_doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
		var _frag$decryptdata;
		this.fragCurrent = frag;
		const details = level.details;
		if (!this.levels || !details) throw new Error(`frag load aborted, missing level${details ? "" : " detail"}s`);
		let keyLoadingPromise = null;
		if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
			this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.playlistLabel()} ${frag.level}`);
			this.state = State.KEY_LOADING;
			this.fragCurrent = frag;
			keyLoadingPromise = this.keyLoader.load(frag).then((keyLoadedData) => {
				if (!this.fragContextChanged(keyLoadedData.frag)) {
					this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
					if (this.state === State.KEY_LOADING) this.state = State.IDLE;
					return keyLoadedData;
				}
			});
			this.hls.trigger(Events.KEY_LOADING, { frag });
			if (this.fragCurrent === null) {
				this.log(`context changed in KEY_LOADING`);
				return Promise.resolve(null);
			}
		} else if (!frag.encrypted) {
			keyLoadingPromise = this.keyLoader.loadClear(frag, details.encryptedFragments, this.startFragRequested);
			if (keyLoadingPromise) this.log(`[eme] blocking frag load until media-keys acquired`);
		}
		const fragPrevious = this.fragPrevious;
		if (isMediaFragment(frag) && (!fragPrevious || frag.sn !== fragPrevious.sn)) {
			const shouldLoadParts = this.shouldLoadParts(level.details, frag.end);
			if (shouldLoadParts !== this.loadingParts) {
				this.log(`LL-Part loading ${shouldLoadParts ? "ON" : "OFF"} loading sn ${fragPrevious == null ? void 0 : fragPrevious.sn}->${frag.sn}`);
				this.loadingParts = shouldLoadParts;
			}
		}
		targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
		if (this.loadingParts && isMediaFragment(frag)) {
			const partList = details.partList;
			if (partList && progressCallback) {
				if (targetBufferTime > details.fragmentEnd && details.fragmentHint) frag = details.fragmentHint;
				const partIndex = this.getNextPart(partList, frag, targetBufferTime);
				if (partIndex > -1) {
					const part = partList[partIndex];
					frag = this.fragCurrent = part.fragment;
					this.log(`Loading ${frag.type} sn: ${frag.sn} part: ${part.index} (${partIndex}/${partList.length - 1}) of ${this.fragInfo(frag, false, part)}) cc: ${frag.cc} [${details.startSN}-${details.endSN}], target: ${parseFloat(targetBufferTime.toFixed(3))}`);
					this.nextLoadPosition = part.start + part.duration;
					this.state = State.FRAG_LOADING;
					let _result;
					if (keyLoadingPromise) _result = keyLoadingPromise.then((keyLoadedData) => {
						if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
						return this.doFragPartsLoad(frag, part, level, progressCallback);
					}).catch((error) => this.handleFragLoadError(error));
					else _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch((error) => this.handleFragLoadError(error));
					this.hls.trigger(Events.FRAG_LOADING, {
						frag,
						part,
						targetBufferTime
					});
					if (this.fragCurrent === null) return Promise.reject(/* @__PURE__ */ new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
					return _result;
				} else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) return Promise.resolve(null);
			}
		}
		if (isMediaFragment(frag) && this.loadingParts) {
			var _details$partList;
			this.log(`LL-Part loading OFF after next part miss @${targetBufferTime.toFixed(2)} Check buffer at sn: ${frag.sn} loaded parts: ${(_details$partList = details.partList) == null ? void 0 : _details$partList.filter((p) => p.loaded).map((p) => `[${p.start}-${p.end}]`)}`);
			this.loadingParts = false;
		} else if (!frag.url) return Promise.resolve(null);
		this.log(`Loading ${frag.type} sn: ${frag.sn} of ${this.fragInfo(frag, false)}) cc: ${frag.cc} ${"[" + details.startSN + "-" + details.endSN + "]"}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
		if (isFiniteNumber(frag.sn) && !this.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
		this.state = State.FRAG_LOADING;
		const dataOnProgress = this.config.progressive && frag.type !== PlaylistLevelType.SUBTITLE;
		let result;
		if (dataOnProgress && keyLoadingPromise) result = keyLoadingPromise.then((keyLoadedData) => {
			if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
			return this.fragmentLoader.load(frag, progressCallback);
		}).catch((error) => this.handleFragLoadError(error));
		else result = Promise.all([this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : void 0), keyLoadingPromise]).then(([fragLoadedData]) => {
			if (!dataOnProgress && progressCallback) progressCallback(fragLoadedData);
			return fragLoadedData;
		}).catch((error) => this.handleFragLoadError(error));
		this.hls.trigger(Events.FRAG_LOADING, {
			frag,
			targetBufferTime
		});
		if (this.fragCurrent === null) return Promise.reject(/* @__PURE__ */ new Error(`frag load aborted, context changed in FRAG_LOADING`));
		return result;
	}
	doFragPartsLoad(frag, fromPart, level, progressCallback) {
		return new Promise((resolve, reject) => {
			var _level$details;
			const partsLoaded = [];
			const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
			const loadPart = (part) => {
				this.fragmentLoader.loadPart(frag, part, progressCallback).then((partLoadedData) => {
					partsLoaded[part.index] = partLoadedData;
					const loadedPart = partLoadedData.part;
					this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
					const nextPart = getPartWith(level.details, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
					if (nextPart) loadPart(nextPart);
					else return resolve({
						frag,
						part: loadedPart,
						partsLoaded
					});
				}).catch(reject);
			};
			loadPart(fromPart);
		});
	}
	handleFragLoadError(error) {
		if ("data" in error) {
			const data = error.data;
			if (data.frag && data.details === ErrorDetails.INTERNAL_ABORTED) this.handleFragLoadAborted(data.frag, data.part);
			else if (data.frag && data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
				data.frag.abortRequests();
				this.resetStartWhenNotLoaded();
				this.resetFragmentLoading(data.frag);
			} else this.hls.trigger(Events.ERROR, data);
		} else this.hls.trigger(Events.ERROR, {
			type: ErrorTypes.OTHER_ERROR,
			details: ErrorDetails.INTERNAL_EXCEPTION,
			err: error,
			error,
			fatal: true
		});
		return null;
	}
	_handleTransmuxerFlush(chunkMeta) {
		const context = this.getCurrentContext(chunkMeta);
		if (!context || this.state !== State.PARSING) {
			if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) this.state = State.IDLE;
			return;
		}
		const { frag, part, level } = context;
		const now = self.performance.now();
		frag.stats.parsing.end = now;
		if (part) part.stats.parsing.end = now;
		const levelDetails = this.getLevelDetails();
		const shouldLoadParts = levelDetails && frag.sn > levelDetails.endSN || this.shouldLoadParts(levelDetails, frag.end);
		if (shouldLoadParts !== this.loadingParts) {
			this.log(`LL-Part loading ${shouldLoadParts ? "ON" : "OFF"} after parsing segment ending @${frag.end.toFixed(2)}`);
			this.loadingParts = shouldLoadParts;
		}
		this.updateLevelTiming(frag, part, level, chunkMeta.partial);
	}
	shouldLoadParts(details, bufferEnd) {
		if (this.config.lowLatencyMode) {
			if (!details) return this.loadingParts;
			if (details.partList) {
				var _details$fragmentHint;
				const firstPart = details.partList[0];
				if (firstPart.fragment.type === PlaylistLevelType.SUBTITLE) return false;
				if (bufferEnd >= firstPart.end + (((_details$fragmentHint = details.fragmentHint) == null ? void 0 : _details$fragmentHint.duration) || 0)) {
					var _this$media;
					if ((this.hls.hasEnoughToStart ? ((_this$media = this.media) == null ? void 0 : _this$media.currentTime) || this.lastCurrentTime : this.getLoadPosition()) > firstPart.start - firstPart.fragment.duration) return true;
				}
			}
		}
		return false;
	}
	getCurrentContext(chunkMeta) {
		const { levels, fragCurrent } = this;
		const { level: levelIndex, sn, part: partIndex } = chunkMeta;
		if (!(levels != null && levels[levelIndex])) {
			this.warn(`Levels object was unset while buffering fragment ${sn} of ${this.playlistLabel()} ${levelIndex}. The current chunk will not be buffered.`);
			return null;
		}
		const level = levels[levelIndex];
		const levelDetails = level.details;
		const part = partIndex > -1 ? getPartWith(levelDetails, sn, partIndex) : null;
		const frag = part ? part.fragment : getFragmentWithSN(levelDetails, sn, fragCurrent);
		if (!frag) return null;
		if (fragCurrent && fragCurrent !== frag) frag.stats = fragCurrent.stats;
		return {
			frag,
			part,
			level
		};
	}
	bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
		if (this.state !== State.PARSING) return;
		const { data1, data2 } = data;
		let buffer = data1;
		if (data2) buffer = appendUint8Array(data1, data2);
		if (!buffer.length) return;
		const offsetTimestamp = this.initPTS[frag.cc];
		const offset = offsetTimestamp ? -offsetTimestamp.baseTime / offsetTimestamp.timescale : void 0;
		const segment = {
			type: data.type,
			frag,
			part,
			chunkMeta,
			offset,
			parent: frag.type,
			data: buffer
		};
		this.hls.trigger(Events.BUFFER_APPENDING, segment);
		if (data.dropped && data.independent && !part) {
			if (noBacktracking) return;
			this.flushBufferGap(frag);
		}
	}
	flushBufferGap(frag) {
		const media = this.media;
		if (!media) return;
		if (!BufferHelper.isBuffered(media, media.currentTime)) {
			this.flushMainBuffer(0, frag.start);
			return;
		}
		const currentTime = media.currentTime;
		const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
		const fragDuration = frag.duration;
		const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * .25);
		const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
		if (frag.start - start > segmentFraction) this.flushMainBuffer(start, frag.start);
	}
	getFwdBufferInfo(bufferable, type) {
		var _this$media2;
		const pos = this.getLoadPosition();
		if (!isFiniteNumber(pos)) return null;
		const maxBufferHole = this.lastCurrentTime > pos || (_this$media2 = this.media) != null && _this$media2.paused ? 0 : this.config.maxBufferHole;
		return this.getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole);
	}
	getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole) {
		const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
		if (bufferInfo.len === 0 && bufferInfo.nextStart !== void 0) {
			const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
			if (bufferedFragAtPos && (bufferInfo.nextStart <= bufferedFragAtPos.end || bufferedFragAtPos.gap)) {
				const gapDuration = Math.max(Math.min(bufferInfo.nextStart, bufferedFragAtPos.end) - pos, maxBufferHole);
				return BufferHelper.bufferInfo(bufferable, pos, gapDuration);
			}
		}
		return bufferInfo;
	}
	getMaxBufferLength(levelBitrate) {
		const { config } = this;
		let maxBufLen;
		if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
		else maxBufLen = config.maxBufferLength;
		return Math.min(maxBufLen, config.maxMaxBufferLength);
	}
	exceedsMaxBuffer(bufferInfo, maxBufLen, selected) {
		const nextStart = bufferInfo.nextStart;
		if (nextStart && selected.start > nextStart) {
			const bufferedRanges = bufferInfo.buffered;
			if (bufferedRanges) {
				let fullBufferLength = bufferInfo.len;
				const bufferedIndex = bufferInfo.bufferedIndex;
				for (let i = bufferedRanges.length - 1; i > bufferedIndex; i--) if (bufferedRanges[i].start < selected.start) fullBufferLength += bufferedRanges[i].end - bufferedRanges[i].start;
				return fullBufferLength >= maxBufLen;
			}
		}
		return false;
	}
	reduceMaxBufferLength(threshold, fragDuration) {
		const config = this.config;
		const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
		const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
		if (reducedLength >= minLength) {
			config.maxMaxBufferLength = reducedLength;
			this.warn(`Reduce max buffer length to ${reducedLength}s`);
			return true;
		}
		return false;
	}
	getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
		const fragOrPart = this.fragmentTracker ? this.fragmentTracker.getAppendedFrag(position, playlistType) : null;
		if (fragOrPart && "fragment" in fragOrPart) return fragOrPart.fragment;
		return fragOrPart;
	}
	getNextFragment(pos, levelDetails) {
		const fragments = levelDetails.fragments;
		const fragLen = fragments.length;
		if (!fragLen) return null;
		const { config } = this;
		const playlistStart = levelDetails.fragmentStart;
		const canLoadParts = config.lowLatencyMode && !!levelDetails.partList;
		let frag = null;
		if (levelDetails.live) {
			const initialLiveManifestSize = config.initialLiveManifestSize;
			if (fragLen < initialLiveManifestSize) {
				this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
				return null;
			}
			if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < playlistStart) {
				var _frag;
				if (canLoadParts && !this.loadingParts) {
					this.log(`LL-Part loading ON for initial live fragment`);
					this.loadingParts = true;
				}
				frag = this.getInitialLiveFragment(levelDetails);
				const configValue = this.config.startPosition;
				const mainStart = this.hls.startPosition;
				const liveSyncPosition = this.hls.liveSyncPosition;
				const fragStart = ((_frag = frag) == null ? void 0 : _frag.start) || 0;
				let startPosition;
				let reason;
				if (mainStart !== -1 && mainStart >= playlistStart) {
					startPosition = mainStart;
					reason = mainStart === configValue ? "config" : "next load start";
				} else if (liveSyncPosition !== null) {
					startPosition = liveSyncPosition;
					reason = "live edge";
				} else {
					startPosition = pos;
					reason = "buffer pos";
				}
				if (startPosition < fragStart) {
					startPosition = fragStart;
					reason = "live frag start";
				}
				if (startPosition < playlistStart) {
					startPosition = playlistStart;
					reason = "playlist start";
				}
				if (this.startPosition != startPosition || this.nextLoadPosition != startPosition) {
					this.log(`Setting startPosition to ${startPosition.toFixed(3)} ${mainStart === -1 ? "" : `(from ${configValue}) `}based on ${reason}. live edge: ${liveSyncPosition} live frag start: ${fragStart.toFixed(3)} playlist start: ${playlistStart.toFixed(3)} buffer pos: ${pos}`);
					this.startPosition = this.nextLoadPosition = startPosition;
				}
			}
		} else if (pos <= playlistStart) frag = fragments[0];
		if (!frag) {
			const end = this.loadingParts ? levelDetails.partEnd : levelDetails.fragmentEnd;
			frag = this.getFragmentAtPosition(pos, end, levelDetails);
		}
		let programFrag = this.filterReplacedPrimary(frag, levelDetails);
		if (!programFrag && frag) {
			const curSNIdx = frag.sn - levelDetails.startSN;
			programFrag = this.filterReplacedPrimary(fragments[curSNIdx + 1] || null, levelDetails);
		}
		return this.mapToInitFragWhenRequired(programFrag);
	}
	isLoopLoading(frag, targetBufferTime) {
		if (this.nextLoadPosition <= targetBufferTime) return false;
		const trackerState = this.fragmentTracker.getState(frag);
		return trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap;
	}
	getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
		let nextFragment = null;
		if (frag.gap) {
			nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
			if (nextFragment && !nextFragment.gap && bufferInfo.nextStart) {
				const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType, 0);
				if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
					const sn = nextFragment.sn;
					if (this.loopSn !== sn) {
						this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${sn}`);
						this.loopSn = sn;
					}
					return null;
				}
			}
		}
		this.loopSn = void 0;
		return nextFragment;
	}
	get primaryPrefetch() {
		if (interstitialsEnabled(this.config)) {
			var _this$hls$interstitia;
			if ((_this$hls$interstitia = this.hls.interstitialsManager) == null || (_this$hls$interstitia = _this$hls$interstitia.playingItem) == null ? void 0 : _this$hls$interstitia.event) return true;
		}
		return false;
	}
	filterReplacedPrimary(frag, details) {
		if (!frag) return frag;
		if (interstitialsEnabled(this.config) && frag.type !== PlaylistLevelType.SUBTITLE) {
			const interstitials = this.hls.interstitialsManager;
			const bufferingItem = interstitials == null ? void 0 : interstitials.bufferingItem;
			if (bufferingItem) {
				const bufferingInterstitial = bufferingItem.event;
				if (bufferingInterstitial) {
					if (bufferingInterstitial.appendInPlace || Math.abs(frag.start - bufferingItem.start) > 1 || bufferingItem.start === 0) return null;
				} else {
					if (frag.end <= bufferingItem.start && (details == null ? void 0 : details.live) === false) return null;
					if (frag.start > bufferingItem.end && bufferingItem.nextEvent) {
						if (bufferingItem.nextEvent.appendInPlace || frag.start - bufferingItem.end > 1) return null;
					}
				}
			}
			const playerQueue = interstitials == null ? void 0 : interstitials.playerQueue;
			if (playerQueue) for (let i = playerQueue.length; i--;) {
				const interstitial = playerQueue[i].interstitial;
				if (interstitial.appendInPlace && frag.start >= interstitial.startTime && frag.end <= interstitial.resumeTime) return null;
			}
		}
		return frag;
	}
	mapToInitFragWhenRequired(frag) {
		if (frag != null && frag.initSegment && !frag.initSegment.data && !this.bitrateTest) return frag.initSegment;
		return frag;
	}
	getNextPart(partList, frag, targetBufferTime) {
		let nextPart = -1;
		let contiguous = false;
		let independentAttrOmitted = true;
		for (let i = 0, len = partList.length; i < len; i++) {
			const part = partList[i];
			independentAttrOmitted = independentAttrOmitted && !part.independent;
			if (nextPart > -1 && targetBufferTime < part.start) break;
			const loaded = part.loaded;
			if (loaded) nextPart = -1;
			else if (contiguous || (part.independent || independentAttrOmitted) && part.fragment === frag) {
				if (part.fragment !== frag) this.warn(`Need buffer at ${targetBufferTime} but next unloaded part starts at ${part.start}`);
				nextPart = i;
			}
			contiguous = loaded;
		}
		return nextPart;
	}
	loadedEndOfParts(partList, targetBufferTime) {
		let part;
		for (let i = partList.length; i--;) {
			part = partList[i];
			if (!part.loaded) return false;
			if (targetBufferTime > part.start) return true;
		}
		return false;
	}
	getInitialLiveFragment(levelDetails) {
		const fragments = levelDetails.fragments;
		const fragPrevious = this.fragPrevious;
		let frag = null;
		if (fragPrevious) {
			if (levelDetails.hasProgramDateTime) {
				frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
				if (frag) this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
			}
			if (!frag) {
				const targetSN = fragPrevious.sn + 1;
				if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
					const fragNext = fragments[targetSN - levelDetails.startSN];
					if (fragPrevious.cc === fragNext.cc) {
						frag = fragNext;
						this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
					}
				}
				if (!frag) {
					frag = findNearestWithCC(levelDetails, fragPrevious.cc, fragPrevious.end);
					if (frag) this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
				}
			}
		} else {
			const liveStart = this.hls.liveSyncPosition;
			if (liveStart !== null) frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
		}
		return frag;
	}
	getFragmentAtPosition(bufferEnd, end, levelDetails) {
		const { config } = this;
		let { fragPrevious } = this;
		let { fragments, endSN } = levelDetails;
		const { fragmentHint } = levelDetails;
		const { maxFragLookUpTolerance } = config;
		const partList = levelDetails.partList;
		const loadingParts = !!(this.loadingParts && partList != null && partList.length && fragmentHint);
		if (loadingParts && !this.bitrateTest && partList[partList.length - 1].fragment.sn === fragmentHint.sn) {
			fragments = fragments.concat(fragmentHint);
			endSN = fragmentHint.sn;
		}
		let frag;
		if (bufferEnd < end) {
			var _this$media3;
			const lookupTolerance = bufferEnd < this.lastCurrentTime || bufferEnd > end - maxFragLookUpTolerance || (_this$media3 = this.media) != null && _this$media3.paused || !this.startFragRequested ? 0 : maxFragLookUpTolerance;
			frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
		} else frag = fragments[fragments.length - 1];
		if (frag) {
			const curSNIdx = frag.sn - levelDetails.startSN;
			const fragState = this.fragmentTracker.getState(frag);
			if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) fragPrevious = frag;
			if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn || !levelDetails.live)) {
				if (frag.level === fragPrevious.level) {
					const nextFrag = fragments[curSNIdx + 1];
					if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) frag = nextFrag;
					else frag = null;
				}
			}
		}
		return frag;
	}
	alignPlaylists(details, previousDetails, switchDetails) {
		const length = details.fragments.length;
		if (!length) {
			this.warn(`No fragments in live playlist`);
			return 0;
		}
		const slidingStart = details.fragmentStart;
		const firstLevelLoad = !previousDetails;
		const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
		if (firstLevelLoad || !aligned && !slidingStart) {
			alignStream(switchDetails, details);
			const alignedSlidingStart = details.fragmentStart;
			this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : "na"}->${details.startSN} fragments: ${length}`);
			return alignedSlidingStart;
		}
		return slidingStart;
	}
	waitForCdnTuneIn(details) {
		return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * 3);
	}
	setStartPosition(details, sliding) {
		let startPosition = this.startPosition;
		if (startPosition < sliding) startPosition = -1;
		const timelineOffset = this.timelineOffset;
		if (startPosition === -1) {
			const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
			const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
			if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
				startPosition = sliding + startTimeOffset;
				if (startTimeOffset < 0) startPosition += details.edge;
				startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
				this.log(`Setting startPosition to ${startPosition} for start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? "multivariant" : "media"} playlist`);
				this.startPosition = startPosition;
			} else if (details.live) {
				startPosition = this.hls.liveSyncPosition || sliding;
				this.log(`Setting startPosition to -1 to start at live edge ${startPosition}`);
				this.startPosition = -1;
			} else {
				this.log(`setting startPosition to 0 by default`);
				this.startPosition = startPosition = 0;
			}
			this.lastCurrentTime = startPosition + timelineOffset;
		}
		this.nextLoadPosition = startPosition + timelineOffset;
	}
	getLoadPosition() {
		var _this$hls;
		const { media } = this;
		let pos = 0;
		if ((_this$hls = this.hls) != null && _this$hls.hasEnoughToStart && media) pos = media.currentTime;
		else if (this.nextLoadPosition >= 0) pos = this.nextLoadPosition;
		return pos;
	}
	handleFragLoadAborted(frag, part) {
		if (this.transmuxer && frag.type === this.playlistType && isMediaFragment(frag) && frag.stats.aborted) {
			this.log(`Fragment ${frag.sn}${part ? " part " + part.index : ""} of ${this.playlistLabel()} ${frag.level} was aborted`);
			this.resetFragmentLoading(frag);
		}
	}
	resetFragmentLoading(frag) {
		if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) this.state = State.IDLE;
	}
	onFragmentOrKeyLoadError(filterType, data) {
		var _this$hls$latestLevel;
		if (data.chunkMeta && !data.frag) {
			const context = this.getCurrentContext(data.chunkMeta);
			if (context) data.frag = context.frag;
		}
		const frag = data.frag;
		if (!frag || frag.type !== filterType || !this.levels) return;
		if (this.fragContextChanged(frag)) {
			var _this$fragCurrent;
			this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.url}`);
			return;
		}
		const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
		if (gapTagEncountered) this.fragmentTracker.fragBuffered(frag, true);
		const errorAction = data.errorAction;
		if (!errorAction) {
			this.state = State.ERROR;
			return;
		}
		const { action, flags, retryCount = 0, retryConfig } = errorAction;
		const couldRetry = !!retryConfig;
		const retry = couldRetry && action === NetworkErrorAction.RetryRequest;
		const noAlternate = couldRetry && !errorAction.resolved && flags === ErrorActionFlags.MoveAllAlternatesMatchingHost;
		const live = (_this$hls$latestLevel = this.hls.latestLevelDetails) == null ? void 0 : _this$hls$latestLevel.live;
		if (!retry && noAlternate && isMediaFragment(frag) && !frag.endList && live && !isUnusableKeyError(data)) {
			this.resetFragmentErrors(filterType);
			this.treatAsGap(frag);
			errorAction.resolved = true;
		} else if ((retry || noAlternate) && retryCount < retryConfig.maxNumRetry) {
			var _data$response;
			const offlineStatus = offlineHttpStatus((_data$response = data.response) == null ? void 0 : _data$response.code);
			const delay = getRetryDelay(retryConfig, retryCount);
			this.resetStartWhenNotLoaded();
			this.retryDate = self.performance.now() + delay;
			this.state = State.FRAG_LOADING_WAITING_RETRY;
			errorAction.resolved = true;
			if (offlineStatus) {
				this.log(`Waiting for connection (offline)`);
				this.retryDate = Infinity;
				data.reason = "offline";
				return;
			}
			this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
		} else if (retryConfig) {
			this.resetFragmentErrors(filterType);
			if (retryCount < retryConfig.maxNumRetry) {
				if (!gapTagEncountered && action !== NetworkErrorAction.RemoveAlternatePermanently) errorAction.resolved = true;
			} else {
				this.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
				return;
			}
		} else if (action === NetworkErrorAction.SendAlternateToPenaltyBox) this.state = State.WAITING_LEVEL;
		else this.state = State.ERROR;
		this.tickImmediate();
	}
	checkRetryDate() {
		const now = self.performance.now();
		const retryDate = this.retryDate;
		const waitingForConnection = retryDate === Infinity;
		if (!retryDate || now >= retryDate || waitingForConnection && !offlineHttpStatus(0)) {
			if (waitingForConnection) this.log(`Connection restored (online)`);
			this.resetStartWhenNotLoaded();
			this.state = State.IDLE;
		}
	}
	reduceLengthAndFlushBuffer(data) {
		if (this.state === State.PARSING || this.state === State.PARSED) {
			const frag = data.frag;
			const playlistType = data.parent;
			const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
			const buffered = bufferedInfo && bufferedInfo.len > .5;
			if (buffered) this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
			const flushBuffer = !buffered;
			if (flushBuffer) this.warn(`Buffer full error while media.currentTime (${this.getLoadPosition()}) is not buffered, flush ${playlistType} buffer`);
			if (frag) {
				this.fragmentTracker.removeFragment(frag);
				this.nextLoadPosition = frag.start;
			}
			this.resetLoadingState();
			return flushBuffer;
		}
		return false;
	}
	resetFragmentErrors(filterType) {
		if (filterType === PlaylistLevelType.AUDIO) this.fragCurrent = null;
		if (!this.hls.hasEnoughToStart) this.startFragRequested = false;
		if (this.state !== State.STOPPED) this.state = State.IDLE;
	}
	afterBufferFlushed(media, bufferType, playlistType) {
		if (!media) return;
		const bufferedTimeRanges = BufferHelper.getBuffered(media);
		this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
		if (this.state === State.ENDED) this.resetLoadingState();
	}
	resetLoadingState() {
		this.log("Reset loading state");
		this.fragCurrent = null;
		this.fragPrevious = null;
		if (this.state !== State.STOPPED) this.state = State.IDLE;
	}
	resetStartWhenNotLoaded() {
		if (!this.hls.hasEnoughToStart) {
			this.startFragRequested = false;
			const level = this.levelLastLoaded;
			const details = level ? level.details : null;
			if (details != null && details.live) {
				this.log(`resetting startPosition for live start`);
				this.startPosition = -1;
				this.setStartPosition(details, details.fragmentStart);
				this.resetLoadingState();
			} else this.nextLoadPosition = this.startPosition;
		}
	}
	resetWhenMissingContext(chunkMeta) {
		this.log(`Loading context changed while buffering sn ${chunkMeta.sn} of ${this.playlistLabel()} ${chunkMeta.level === -1 ? "<removed>" : chunkMeta.level}. This chunk will not be buffered.`);
		this.removeUnbufferedFrags();
		this.resetStartWhenNotLoaded();
		this.resetLoadingState();
	}
	removeUnbufferedFrags(start = 0) {
		this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
	}
	updateLevelTiming(frag, part, level, partial) {
		const details = level.details;
		if (!details) {
			this.warn("level.details undefined");
			return;
		}
		if (!Object.keys(frag.elementaryStreams).reduce((result, type) => {
			const info = frag.elementaryStreams[type];
			if (info) {
				const parsedDuration = info.endPTS - info.startPTS;
				if (parsedDuration <= 0) {
					this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
					return result || false;
				}
				const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS, this);
				this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
					details,
					level,
					drift,
					type,
					frag,
					start: info.startPTS,
					end: info.endPTS
				});
				return true;
			}
			return result;
		}, false)) {
			var _this$transmuxer;
			const mediaNotFound = ((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null;
			if (level.fragmentError === 0 || mediaNotFound && (level.fragmentError < 2 || frag.endList)) this.treatAsGap(frag, level);
			if (mediaNotFound) {
				const error = /* @__PURE__ */ new Error(`Found no media in fragment ${frag.sn} of ${this.playlistLabel()} ${frag.level} resetting transmuxer to fallback to playlist timing`);
				this.warn(error.message);
				this.hls.trigger(Events.ERROR, {
					type: ErrorTypes.MEDIA_ERROR,
					details: ErrorDetails.FRAG_PARSING_ERROR,
					fatal: false,
					error,
					frag,
					reason: `Found no media in msn ${frag.sn} of ${this.playlistLabel()} "${level.url}"`
				});
				if (!this.hls) return;
				this.resetTransmuxer();
			}
		}
		this.state = State.PARSED;
		this.log(`Parsed ${frag.type} sn: ${frag.sn}${part ? " part: " + part.index : ""} of ${this.fragInfo(frag, false, part)})`);
		this.hls.trigger(Events.FRAG_PARSED, {
			frag,
			part
		});
	}
	playlistLabel() {
		return this.playlistType === PlaylistLevelType.MAIN ? "level" : "track";
	}
	fragInfo(frag, pts = true, part) {
		var _ref, _ref2;
		return `${this.playlistLabel()} ${frag.level} (${part ? "part" : "frag"}:[${((_ref = pts && !part ? frag.startPTS : (part || frag).start) != null ? _ref : NaN).toFixed(3)}-${((_ref2 = pts && !part ? frag.endPTS : (part || frag).end) != null ? _ref2 : NaN).toFixed(3)}]${part && frag.type === "main" ? "INDEPENDENT=" + (part.independent ? "YES" : "NO") : ""}`;
	}
	treatAsGap(frag, level) {
		if (level) level.fragmentError++;
		frag.gap = true;
		this.fragmentTracker.removeFragment(frag);
		this.fragmentTracker.fragBuffered(frag, true);
	}
	resetTransmuxer() {
		var _this$transmuxer2;
		(_this$transmuxer2 = this.transmuxer) == null || _this$transmuxer2.reset();
	}
	recoverWorkerError(data) {
		if (data.event === "demuxerWorker") {
			this.fragmentTracker.removeAllFragments();
			if (this.transmuxer) {
				this.transmuxer.destroy();
				this.transmuxer = null;
			}
			this.resetStartWhenNotLoaded();
			this.resetLoadingState();
		}
	}
	set state(nextState) {
		const previousState = this._state;
		if (previousState !== nextState) {
			this._state = nextState;
			this.log(`${previousState}->${nextState}`);
		}
	}
	get state() {
		return this._state;
	}
};
function interstitialsEnabled(config) {
	return !!config.interstitialsController && config.enableInterstitialPlayback !== false;
}
var ChunkCache = class {
	constructor() {
		this.chunks = [];
		this.dataLength = 0;
	}
	push(chunk) {
		this.chunks.push(chunk);
		this.dataLength += chunk.length;
	}
	flush() {
		const { chunks, dataLength } = this;
		let result;
		if (!chunks.length) return new Uint8Array(0);
		else if (chunks.length === 1) result = chunks[0];
		else result = concatUint8Arrays(chunks, dataLength);
		this.reset();
		return result;
	}
	reset() {
		this.chunks.length = 0;
		this.dataLength = 0;
	}
};
function concatUint8Arrays(chunks, dataLength) {
	const result = new Uint8Array(dataLength);
	let offset = 0;
	for (let i = 0; i < chunks.length; i++) {
		const chunk = chunks[i];
		result.set(chunk, offset);
		offset += chunk.length;
	}
	return result;
}
var eventemitter3 = { exports: {} };
var hasRequiredEventemitter3;
function requireEventemitter3() {
	if (hasRequiredEventemitter3) return eventemitter3.exports;
	hasRequiredEventemitter3 = 1;
	(function(module) {
		var has = Object.prototype.hasOwnProperty, prefix = "~";
		/**
		* Constructor to create a storage for our `EE` objects.
		* An `Events` instance is a plain object whose properties are event names.
		*
		* @constructor
		* @private
		*/
		function Events() {}
		if (Object.create) {
			Events.prototype = Object.create(null);
			if (!new Events().__proto__) prefix = false;
		}
		/**
		* Representation of a single event listener.
		*
		* @param {Function} fn The listener function.
		* @param {*} context The context to invoke the listener with.
		* @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		* @constructor
		* @private
		*/
		function EE(fn, context, once) {
			this.fn = fn;
			this.context = context;
			this.once = once || false;
		}
		/**
		* Add a listener for a given event.
		*
		* @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		* @param {(String|Symbol)} event The event name.
		* @param {Function} fn The listener function.
		* @param {*} context The context to invoke the listener with.
		* @param {Boolean} once Specify if the listener is a one-time listener.
		* @returns {EventEmitter}
		* @private
		*/
		function addListener(emitter, event, fn, context, once) {
			if (typeof fn !== "function") throw new TypeError("The listener must be a function");
			var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
			if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
			else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
			else emitter._events[evt] = [emitter._events[evt], listener];
			return emitter;
		}
		/**
		* Clear event by name.
		*
		* @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		* @param {(String|Symbol)} evt The Event name.
		* @private
		*/
		function clearEvent(emitter, evt) {
			if (--emitter._eventsCount === 0) emitter._events = new Events();
			else delete emitter._events[evt];
		}
		/**
		* Minimal `EventEmitter` interface that is molded against the Node.js
		* `EventEmitter` interface.
		*
		* @constructor
		* @public
		*/
		function EventEmitter() {
			this._events = new Events();
			this._eventsCount = 0;
		}
		/**
		* Return an array listing the events for which the emitter has registered
		* listeners.
		*
		* @returns {Array}
		* @public
		*/
		EventEmitter.prototype.eventNames = function eventNames() {
			var names = [], events, name;
			if (this._eventsCount === 0) return names;
			for (name in events = this._events) if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
			if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
			return names;
		};
		/**
		* Return the listeners registered for a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @returns {Array} The registered listeners.
		* @public
		*/
		EventEmitter.prototype.listeners = function listeners(event) {
			var evt = prefix ? prefix + event : event, handlers = this._events[evt];
			if (!handlers) return [];
			if (handlers.fn) return [handlers.fn];
			for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) ee[i] = handlers[i].fn;
			return ee;
		};
		/**
		* Return the number of listeners listening to a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @returns {Number} The number of listeners.
		* @public
		*/
		EventEmitter.prototype.listenerCount = function listenerCount(event) {
			var evt = prefix ? prefix + event : event, listeners = this._events[evt];
			if (!listeners) return 0;
			if (listeners.fn) return 1;
			return listeners.length;
		};
		/**
		* Calls each of the listeners registered for a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @returns {Boolean} `true` if the event had listeners, else `false`.
		* @public
		*/
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
			var evt = prefix ? prefix + event : event;
			if (!this._events[evt]) return false;
			var listeners = this._events[evt], len = arguments.length, args, i;
			if (listeners.fn) {
				if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
				switch (len) {
					case 1: return listeners.fn.call(listeners.context), true;
					case 2: return listeners.fn.call(listeners.context, a1), true;
					case 3: return listeners.fn.call(listeners.context, a1, a2), true;
					case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
					case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
					case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
				}
				for (i = 1, args = new Array(len - 1); i < len; i++) args[i - 1] = arguments[i];
				listeners.fn.apply(listeners.context, args);
			} else {
				var length = listeners.length, j;
				for (i = 0; i < length; i++) {
					if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
					switch (len) {
						case 1:
							listeners[i].fn.call(listeners[i].context);
							break;
						case 2:
							listeners[i].fn.call(listeners[i].context, a1);
							break;
						case 3:
							listeners[i].fn.call(listeners[i].context, a1, a2);
							break;
						case 4:
							listeners[i].fn.call(listeners[i].context, a1, a2, a3);
							break;
						default:
							if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) args[j - 1] = arguments[j];
							listeners[i].fn.apply(listeners[i].context, args);
					}
				}
			}
			return true;
		};
		/**
		* Add a listener for a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @param {Function} fn The listener function.
		* @param {*} [context=this] The context to invoke the listener with.
		* @returns {EventEmitter} `this`.
		* @public
		*/
		EventEmitter.prototype.on = function on(event, fn, context) {
			return addListener(this, event, fn, context, false);
		};
		/**
		* Add a one-time listener for a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @param {Function} fn The listener function.
		* @param {*} [context=this] The context to invoke the listener with.
		* @returns {EventEmitter} `this`.
		* @public
		*/
		EventEmitter.prototype.once = function once(event, fn, context) {
			return addListener(this, event, fn, context, true);
		};
		/**
		* Remove the listeners of a given event.
		*
		* @param {(String|Symbol)} event The event name.
		* @param {Function} fn Only remove the listeners that match this function.
		* @param {*} context Only remove the listeners that have this context.
		* @param {Boolean} once Only remove one-time listeners.
		* @returns {EventEmitter} `this`.
		* @public
		*/
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
			var evt = prefix ? prefix + event : event;
			if (!this._events[evt]) return this;
			if (!fn) {
				clearEvent(this, evt);
				return this;
			}
			var listeners = this._events[evt];
			if (listeners.fn) {
				if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
			} else {
				for (var i = 0, events = [], length = listeners.length; i < length; i++) if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
				if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
				else clearEvent(this, evt);
			}
			return this;
		};
		/**
		* Remove all listeners, or those of the specified event.
		*
		* @param {(String|Symbol)} [event] The event name.
		* @returns {EventEmitter} `this`.
		* @public
		*/
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
			var evt;
			if (event) {
				evt = prefix ? prefix + event : event;
				if (this._events[evt]) clearEvent(this, evt);
			} else {
				this._events = new Events();
				this._eventsCount = 0;
			}
			return this;
		};
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;
		EventEmitter.prefixed = prefix;
		EventEmitter.EventEmitter = EventEmitter;
		module.exports = EventEmitter;
	})(eventemitter3);
	return eventemitter3.exports;
}
var EventEmitter$1 = /* @__PURE__ */ getDefaultExportFromCjs$2(requireEventemitter3());
var version = "1.6.16";
var workerStore = {};
function hasUMDWorker() {
	return typeof __HLS_WORKER_BUNDLE__ === "function";
}
function injectWorker() {
	const workerContext = workerStore[version];
	if (workerContext) {
		workerContext.clientCount++;
		return workerContext;
	}
	const blob = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], { type: "text/javascript" });
	const objectURL = self.URL.createObjectURL(blob);
	const result = {
		worker: new self.Worker(objectURL),
		objectURL,
		clientCount: 1
	};
	workerStore[version] = result;
	return result;
}
function loadWorker(path) {
	const workerContext = workerStore[path];
	if (workerContext) {
		workerContext.clientCount++;
		return workerContext;
	}
	const scriptURL = new self.URL(path, self.location.href).href;
	const result = {
		worker: new self.Worker(scriptURL),
		scriptURL,
		clientCount: 1
	};
	workerStore[path] = result;
	return result;
}
function removeWorkerFromStore(path) {
	const workerContext = workerStore[path || version];
	if (workerContext) {
		if (workerContext.clientCount-- === 1) {
			const { worker, objectURL } = workerContext;
			delete workerStore[path || version];
			if (objectURL) self.URL.revokeObjectURL(objectURL);
			worker.terminate();
		}
	}
}
/**
* Returns true if an ID3 footer can be found at offset in data
*
* @param data - The data to search in
* @param offset - The offset at which to start searching
*
* @returns `true` if an ID3 footer is found
*
* @internal
*
* @group ID3
*/
function isId3Footer(data, offset) {
	if (offset + 10 <= data.length) {
		if (data[offset] === 51 && data[offset + 1] === 68 && data[offset + 2] === 73) {
			if (data[offset + 3] < 255 && data[offset + 4] < 255) {
				if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) return true;
			}
		}
	}
	return false;
}
/**
* Returns true if an ID3 header can be found at offset in data
*
* @param data - The data to search in
* @param offset - The offset at which to start searching
*
* @returns `true` if an ID3 header is found
*
* @internal
*
* @group ID3
*/
function isId3Header(data, offset) {
	if (offset + 10 <= data.length) {
		if (data[offset] === 73 && data[offset + 1] === 68 && data[offset + 2] === 51) {
			if (data[offset + 3] < 255 && data[offset + 4] < 255) {
				if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) return true;
			}
		}
	}
	return false;
}
/**
* Read ID3 size
*
* @param data - The data to read from
* @param offset - The offset at which to start reading
*
* @returns The size
*
* @internal
*
* @group ID3
*/
function readId3Size(data, offset) {
	let size = 0;
	size = (data[offset] & 127) << 21;
	size |= (data[offset + 1] & 127) << 14;
	size |= (data[offset + 2] & 127) << 7;
	size |= data[offset + 3] & 127;
	return size;
}
/**
* Returns any adjacent ID3 tags found in data starting at offset, as one block of data
*
* @param data - The data to search in
* @param offset - The offset at which to start searching
*
* @returns The block of data containing any ID3 tags found
* or `undefined` if no header is found at the starting offset
*
* @internal
*
* @group ID3
*/
function getId3Data(data, offset) {
	const front = offset;
	let length = 0;
	while (isId3Header(data, offset)) {
		length += 10;
		const size = readId3Size(data, offset + 6);
		length += size;
		if (isId3Footer(data, offset + 10)) length += 10;
		offset += length;
	}
	if (length > 0) return data.subarray(front, front + length);
}
function getAudioConfig(observer, data, offset, manifestCodec) {
	const adtsSamplingRates = [
		96e3,
		88200,
		64e3,
		48e3,
		44100,
		32e3,
		24e3,
		22050,
		16e3,
		12e3,
		11025,
		8e3,
		7350
	];
	const byte2 = data[offset + 2];
	const adtsSamplingIndex = byte2 >> 2 & 15;
	if (adtsSamplingIndex > 12) {
		const error = /* @__PURE__ */ new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
		observer.emit(Events.ERROR, Events.ERROR, {
			type: ErrorTypes.MEDIA_ERROR,
			details: ErrorDetails.FRAG_PARSING_ERROR,
			fatal: true,
			error,
			reason: error.message
		});
		return;
	}
	const adtsObjectType = (byte2 >> 6 & 3) + 1;
	const channelCount = data[offset + 3] >> 6 & 3 | (byte2 & 1) << 2;
	const codec = "mp4a.40." + adtsObjectType;
	const samplerate = adtsSamplingRates[adtsSamplingIndex];
	let aacSampleIndex = adtsSamplingIndex;
	if (adtsObjectType === 5 || adtsObjectType === 29) aacSampleIndex -= 3;
	const config = [adtsObjectType << 3 | (aacSampleIndex & 14) >> 1, (aacSampleIndex & 1) << 7 | channelCount << 3];
	logger.log(`manifest codec:${manifestCodec}, parsed codec:${codec}, channels:${channelCount}, rate:${samplerate} (ADTS object type:${adtsObjectType} sampling index:${adtsSamplingIndex})`);
	return {
		config,
		samplerate,
		channelCount,
		codec,
		parsedCodec: codec,
		manifestCodec
	};
}
function isHeaderPattern$1(data, offset) {
	return data[offset] === 255 && (data[offset + 1] & 246) === 240;
}
function getHeaderLength(data, offset) {
	return data[offset + 1] & 1 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
	return (data[offset + 3] & 3) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 224) >>> 5;
}
function canGetFrameLength(data, offset) {
	return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
	return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
	return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
	if (isHeader$1(data, offset)) {
		const headerLength = getHeaderLength(data, offset);
		if (offset + headerLength >= data.length) return false;
		const frameLength = getFullFrameLength(data, offset);
		if (frameLength <= headerLength) return false;
		const newOffset = offset + frameLength;
		return newOffset === data.length || isHeader$1(data, newOffset);
	}
	return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
	if (!track.samplerate) {
		const config = getAudioConfig(observer, data, offset, audioCodec);
		if (!config) return;
		_extends(track, config);
	}
}
function getFrameDuration(samplerate) {
	return 1024 * 9e4 / samplerate;
}
function parseFrameHeader(data, offset) {
	const headerLength = getHeaderLength(data, offset);
	if (offset + headerLength <= data.length) {
		const frameLength = getFullFrameLength(data, offset) - headerLength;
		if (frameLength > 0) return {
			headerLength,
			frameLength
		};
	}
}
function appendFrame$2(track, data, offset, pts, frameIndex) {
	const stamp = pts + frameIndex * getFrameDuration(track.samplerate);
	const header = parseFrameHeader(data, offset);
	let unit;
	if (header) {
		const { frameLength, headerLength } = header;
		const _length = headerLength + frameLength;
		const missing = Math.max(0, offset + _length - data.length);
		if (missing) {
			unit = new Uint8Array(_length - headerLength);
			unit.set(data.subarray(offset + headerLength, data.length), 0);
		} else unit = data.subarray(offset + headerLength, offset + _length);
		const _sample = {
			unit,
			pts: stamp
		};
		if (!missing) track.samples.push(_sample);
		return {
			sample: _sample,
			length: _length,
			missing
		};
	}
	const length = data.length - offset;
	unit = new Uint8Array(length);
	unit.set(data.subarray(offset, data.length), 0);
	return {
		sample: {
			unit,
			pts: stamp
		},
		length,
		missing: -1
	};
}
/**
* Checks if the given data contains an ID3 tag.
*
* @param data - The data to check
* @param offset - The offset at which to start checking
*
* @returns `true` if an ID3 tag is found
*
* @group ID3
*
* @beta
*/
function canParseId3(data, offset) {
	return isId3Header(data, offset) && readId3Size(data, offset + 6) + 10 <= data.length - offset;
}
function toArrayBuffer(view) {
	if (view instanceof ArrayBuffer) return view;
	else {
		if (view.byteOffset == 0 && view.byteLength == view.buffer.byteLength) return view.buffer;
		return new Uint8Array(view).buffer;
	}
}
function toUint8(data, offset = 0, length = Infinity) {
	return view(data, offset, length, Uint8Array);
}
function view(data, offset, length, Type) {
	const buffer = unsafeGetArrayBuffer(data);
	let bytesPerElement = 1;
	if ("BYTES_PER_ELEMENT" in Type) bytesPerElement = Type.BYTES_PER_ELEMENT;
	const dataOffset = isArrayBufferView(data) ? data.byteOffset : 0;
	const dataEnd = (dataOffset + data.byteLength) / bytesPerElement;
	const rawStart = (dataOffset + offset) / bytesPerElement;
	const start = Math.floor(Math.max(0, Math.min(rawStart, dataEnd)));
	return new Type(buffer, start, Math.floor(Math.min(start + Math.max(length, 0), dataEnd)) - start);
}
function unsafeGetArrayBuffer(view) {
	if (view instanceof ArrayBuffer) return view;
	else return view.buffer;
}
function isArrayBufferView(obj) {
	return obj && obj.buffer instanceof ArrayBuffer && obj.byteLength !== void 0 && obj.byteOffset !== void 0;
}
function decodeId3ImageFrame(frame) {
	const metadataFrame = {
		key: frame.type,
		description: "",
		data: "",
		mimeType: null,
		pictureType: null
	};
	const utf8Encoding = 3;
	if (frame.size < 2) return;
	if (frame.data[0] !== utf8Encoding) {
		console.log("Ignore frame with unrecognized character encoding");
		return;
	}
	const mimeTypeEndIndex = frame.data.subarray(1).indexOf(0);
	if (mimeTypeEndIndex === -1) return;
	const mimeType = utf8ArrayToStr(toUint8(frame.data, 1, mimeTypeEndIndex));
	const pictureType = frame.data[2 + mimeTypeEndIndex];
	const descriptionEndIndex = frame.data.subarray(3 + mimeTypeEndIndex).indexOf(0);
	if (descriptionEndIndex === -1) return;
	const description = utf8ArrayToStr(toUint8(frame.data, 3 + mimeTypeEndIndex, descriptionEndIndex));
	let data;
	if (mimeType === "-->") data = utf8ArrayToStr(toUint8(frame.data, 4 + mimeTypeEndIndex + descriptionEndIndex));
	else data = toArrayBuffer(frame.data.subarray(4 + mimeTypeEndIndex + descriptionEndIndex));
	metadataFrame.mimeType = mimeType;
	metadataFrame.pictureType = pictureType;
	metadataFrame.description = description;
	metadataFrame.data = data;
	return metadataFrame;
}
/**
* Decode an ID3 PRIV frame.
*
* @param frame - the ID3 PRIV frame
*
* @returns The decoded ID3 PRIV frame
*
* @internal
*
* @group ID3
*/
function decodeId3PrivFrame(frame) {
	if (frame.size < 2) return;
	const owner = utf8ArrayToStr(frame.data, true);
	const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
	return {
		key: frame.type,
		info: owner,
		data: privateData.buffer
	};
}
/**
* Decodes an ID3 text frame
*
* @param frame - the ID3 text frame
*
* @returns The decoded ID3 text frame
*
* @internal
*
* @group ID3
*/
function decodeId3TextFrame(frame) {
	if (frame.size < 2) return;
	if (frame.type === "TXXX") {
		let index = 1;
		const description = utf8ArrayToStr(frame.data.subarray(index), true);
		index += description.length + 1;
		const value = utf8ArrayToStr(frame.data.subarray(index));
		return {
			key: frame.type,
			info: description,
			data: value
		};
	}
	const text = utf8ArrayToStr(frame.data.subarray(1));
	return {
		key: frame.type,
		info: "",
		data: text
	};
}
/**
* Decode a URL frame
*
* @param frame - the ID3 URL frame
*
* @returns The decoded ID3 URL frame
*
* @internal
*
* @group ID3
*/
function decodeId3UrlFrame(frame) {
	if (frame.type === "WXXX") {
		if (frame.size < 2) return;
		let index = 1;
		const description = utf8ArrayToStr(frame.data.subarray(index), true);
		index += description.length + 1;
		const value = utf8ArrayToStr(frame.data.subarray(index));
		return {
			key: frame.type,
			info: description,
			data: value
		};
	}
	const url = utf8ArrayToStr(frame.data);
	return {
		key: frame.type,
		info: "",
		data: url
	};
}
/**
* Decode an ID3 frame.
*
* @param frame - the ID3 frame
*
* @returns The decoded ID3 frame
*
* @internal
*
* @group ID3
*/
function decodeId3Frame(frame) {
	if (frame.type === "PRIV") return decodeId3PrivFrame(frame);
	else if (frame.type[0] === "W") return decodeId3UrlFrame(frame);
	else if (frame.type === "APIC") return decodeId3ImageFrame(frame);
	return decodeId3TextFrame(frame);
}
/**
* Returns the data of an ID3 frame.
*
* @param data - The data to read from
*
* @returns The data of the ID3 frame
*
* @internal
*
* @group ID3
*/
function getId3FrameData(data) {
	const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
	const size = readId3Size(data, 4);
	const offset = 10;
	return {
		type,
		size,
		data: data.subarray(offset, offset + size)
	};
}
var HEADER_FOOTER_SIZE = 10;
var FRAME_SIZE = 10;
/**
* Returns an array of ID3 frames found in all the ID3 tags in the id3Data
*
* @param id3Data - The ID3 data containing one or more ID3 tags
*
* @returns Array of ID3 frame objects
*
* @group ID3
*
* @beta
*/
function getId3Frames(id3Data) {
	let offset = 0;
	const frames = [];
	while (isId3Header(id3Data, offset)) {
		const size = readId3Size(id3Data, offset + 6);
		if (id3Data[offset + 5] >> 6 & 1) offset += HEADER_FOOTER_SIZE;
		offset += HEADER_FOOTER_SIZE;
		const end = offset + size;
		while (offset + FRAME_SIZE < end) {
			const frameData = getId3FrameData(id3Data.subarray(offset));
			const frame = decodeId3Frame(frameData);
			if (frame) frames.push(frame);
			offset += frameData.size + HEADER_FOOTER_SIZE;
		}
		if (isId3Footer(id3Data, offset)) offset += HEADER_FOOTER_SIZE;
	}
	return frames;
}
/**
* Returns true if the ID3 frame is an Elementary Stream timestamp frame
*
* @param frame - the ID3 frame
*
* @returns `true` if the ID3 frame is an Elementary Stream timestamp frame
*
* @internal
*
* @group ID3
*/
function isId3TimestampFrame(frame) {
	return frame && frame.key === "PRIV" && frame.info === "com.apple.streaming.transportStreamTimestamp";
}
/**
* Read a 33 bit timestamp from an ID3 frame.
*
* @param timeStampFrame - the ID3 frame
*
* @returns The timestamp
*
* @internal
*
* @group ID3
*/
function readId3Timestamp(timeStampFrame) {
	if (timeStampFrame.data.byteLength === 8) {
		const data = new Uint8Array(timeStampFrame.data);
		const pts33Bit = data[3] & 1;
		let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
		timestamp /= 45;
		if (pts33Bit) timestamp += 47721858.84;
		return Math.round(timestamp);
	}
}
/**
* Searches for the Elementary Stream timestamp found in the ID3 data chunk
*
* @param data - Block of data containing one or more ID3 tags
*
* @returns The timestamp
*
* @group ID3
*
* @beta
*/
function getId3Timestamp(data) {
	const frames = getId3Frames(data);
	for (let i = 0; i < frames.length; i++) {
		const frame = frames[i];
		if (isId3TimestampFrame(frame)) return readId3Timestamp(frame);
	}
}
var MetadataSchema = /* @__PURE__ */ function(MetadataSchema) {
	MetadataSchema["audioId3"] = "org.id3";
	MetadataSchema["dateRange"] = "com.apple.quicktime.HLS";
	MetadataSchema["emsg"] = "https://aomedia.org/emsg/ID3";
	MetadataSchema["misbklv"] = "urn:misb:KLV:bin:1910.1";
	return MetadataSchema;
}({});
function dummyTrack(type = "", inputTimeScale = 9e4) {
	return {
		type,
		id: -1,
		pid: -1,
		inputTimeScale,
		sequenceNumber: -1,
		samples: [],
		dropped: 0
	};
}
var BaseAudioDemuxer = class {
	constructor() {
		this._audioTrack = void 0;
		this._id3Track = void 0;
		this.frameIndex = 0;
		this.cachedData = null;
		this.basePTS = null;
		this.initPTS = null;
		this.lastPTS = null;
	}
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		this._id3Track = {
			type: "id3",
			id: 3,
			pid: -1,
			inputTimeScale: 9e4,
			sequenceNumber: 0,
			samples: [],
			dropped: 0
		};
	}
	resetTimeStamp(deaultTimestamp) {
		this.initPTS = deaultTimestamp;
		this.resetContiguity();
	}
	resetContiguity() {
		this.basePTS = null;
		this.lastPTS = null;
		this.frameIndex = 0;
	}
	canParse(data, offset) {
		return false;
	}
	appendFrame(track, data, offset) {}
	demux(data, timeOffset) {
		if (this.cachedData) {
			data = appendUint8Array(this.cachedData, data);
			this.cachedData = null;
		}
		let id3Data = getId3Data(data, 0);
		let offset = id3Data ? id3Data.length : 0;
		let lastDataIndex;
		const track = this._audioTrack;
		const id3Track = this._id3Track;
		const timestamp = id3Data ? getId3Timestamp(id3Data) : void 0;
		const length = data.length;
		if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
			this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
			this.lastPTS = this.basePTS;
		}
		if (this.lastPTS === null) this.lastPTS = this.basePTS;
		if (id3Data && id3Data.length > 0) id3Track.samples.push({
			pts: this.lastPTS,
			dts: this.lastPTS,
			data: id3Data,
			type: MetadataSchema.audioId3,
			duration: Number.POSITIVE_INFINITY
		});
		while (offset < length) {
			if (this.canParse(data, offset)) {
				const frame = this.appendFrame(track, data, offset);
				if (frame) {
					this.frameIndex++;
					this.lastPTS = frame.sample.pts;
					offset += frame.length;
					lastDataIndex = offset;
				} else offset = length;
			} else if (canParseId3(data, offset)) {
				id3Data = getId3Data(data, offset);
				id3Track.samples.push({
					pts: this.lastPTS,
					dts: this.lastPTS,
					data: id3Data,
					type: MetadataSchema.audioId3,
					duration: Number.POSITIVE_INFINITY
				});
				offset += id3Data.length;
				lastDataIndex = offset;
			} else offset++;
			if (offset === length && lastDataIndex !== length) {
				const partialData = data.slice(lastDataIndex);
				if (this.cachedData) this.cachedData = appendUint8Array(this.cachedData, partialData);
				else this.cachedData = partialData;
			}
		}
		return {
			audioTrack: track,
			videoTrack: dummyTrack(),
			id3Track,
			textTrack: dummyTrack()
		};
	}
	demuxSampleAes(data, keyData, timeOffset) {
		return Promise.reject(/* @__PURE__ */ new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
	}
	flush(timeOffset) {
		const cachedData = this.cachedData;
		if (cachedData) {
			this.cachedData = null;
			this.demux(cachedData, 0);
		}
		return {
			audioTrack: this._audioTrack,
			videoTrack: dummyTrack(),
			id3Track: this._id3Track,
			textTrack: dummyTrack()
		};
	}
	destroy() {
		this.cachedData = null;
		this._audioTrack = this._id3Track = void 0;
	}
};
/**
* Initialize PTS
* <p>
*    use timestamp unless it is undefined, NaN or Infinity
* </p>
*/
var initPTSFn = (timestamp, timeOffset, initPTS) => {
	if (isFiniteNumber(timestamp)) return timestamp * 90;
	const init90kHz = initPTS ? initPTS.baseTime * 9e4 / initPTS.timescale : 0;
	return timeOffset * 9e4 + init90kHz;
};
/**
*  MPEG parser helper
*/
var chromeVersion$1 = null;
var BitratesMap = [
	32,
	64,
	96,
	128,
	160,
	192,
	224,
	256,
	288,
	320,
	352,
	384,
	416,
	448,
	32,
	48,
	56,
	64,
	80,
	96,
	112,
	128,
	160,
	192,
	224,
	256,
	320,
	384,
	32,
	40,
	48,
	56,
	64,
	80,
	96,
	112,
	128,
	160,
	192,
	224,
	256,
	320,
	32,
	48,
	56,
	64,
	80,
	96,
	112,
	128,
	144,
	160,
	176,
	192,
	224,
	256,
	8,
	16,
	24,
	32,
	40,
	48,
	56,
	64,
	80,
	96,
	112,
	128,
	144,
	160
];
var SamplingRateMap = [
	44100,
	48e3,
	32e3,
	22050,
	24e3,
	16e3,
	11025,
	12e3,
	8e3
];
var SamplesCoefficients = [
	[
		0,
		72,
		144,
		12
	],
	[
		0,
		0,
		0,
		0
	],
	[
		0,
		72,
		144,
		12
	],
	[
		0,
		144,
		144,
		12
	]
];
var BytesInSlot = [
	0,
	1,
	1,
	4
];
function appendFrame$1(track, data, offset, pts, frameIndex) {
	if (offset + 24 > data.length) return;
	const header = parseHeader(data, offset);
	if (header && offset + header.frameLength <= data.length) {
		const stamp = pts + frameIndex * (header.samplesPerFrame * 9e4 / header.sampleRate);
		const sample = {
			unit: data.subarray(offset, offset + header.frameLength),
			pts: stamp,
			dts: stamp
		};
		track.config = [];
		track.channelCount = header.channelCount;
		track.samplerate = header.sampleRate;
		track.samples.push(sample);
		return {
			sample,
			length: header.frameLength,
			missing: 0
		};
	}
}
function parseHeader(data, offset) {
	const mpegVersion = data[offset + 1] >> 3 & 3;
	const mpegLayer = data[offset + 1] >> 1 & 3;
	const bitRateIndex = data[offset + 2] >> 4 & 15;
	const sampleRateIndex = data[offset + 2] >> 2 & 3;
	if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
		const paddingBit = data[offset + 2] >> 1 & 1;
		const channelMode = data[offset + 3] >> 6;
		const bitRate = BitratesMap[(mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4) * 14 + bitRateIndex - 1] * 1e3;
		const sampleRate = SamplingRateMap[(mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2) * 3 + sampleRateIndex];
		const channelCount = channelMode === 3 ? 1 : 2;
		const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
		const bytesInSlot = BytesInSlot[mpegLayer];
		const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
		const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
		if (chromeVersion$1 === null) {
			const result = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
			chromeVersion$1 = result ? parseInt(result[1]) : 0;
		}
		if (!!chromeVersion$1 && chromeVersion$1 <= 87 && mpegLayer === 2 && bitRate >= 224e3 && channelMode === 0) data[offset + 3] = data[offset + 3] | 128;
		return {
			sampleRate,
			channelCount,
			frameLength,
			samplesPerFrame
		};
	}
}
function isHeaderPattern(data, offset) {
	return data[offset] === 255 && (data[offset + 1] & 224) === 224 && (data[offset + 1] & 6) !== 0;
}
function isHeader(data, offset) {
	return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
	return isHeaderPattern(data, offset) && 4 <= data.length - offset;
}
function probe(data, offset) {
	if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
		const headerLength = 4;
		const header = parseHeader(data, offset);
		let frameLength = headerLength;
		if (header != null && header.frameLength) frameLength = header.frameLength;
		const newOffset = offset + frameLength;
		return newOffset === data.length || isHeader(data, newOffset);
	}
	return false;
}
/**
* AAC demuxer
*/
var AACDemuxer = class extends BaseAudioDemuxer {
	constructor(observer, config) {
		super();
		this.observer = void 0;
		this.config = void 0;
		this.observer = observer;
		this.config = config;
	}
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
		this._audioTrack = {
			container: "audio/adts",
			type: "audio",
			id: 2,
			pid: -1,
			sequenceNumber: 0,
			segmentCodec: "aac",
			samples: [],
			manifestCodec: audioCodec,
			duration: trackDuration,
			inputTimeScale: 9e4,
			dropped: 0
		};
	}
	static probe(data, logger) {
		if (!data) return false;
		const id3Data = getId3Data(data, 0);
		let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
		if (probe(data, offset)) return false;
		for (let length = data.length; offset < length; offset++) if (probe$1(data, offset)) {
			logger.log("ADTS sync word found !");
			return true;
		}
		return false;
	}
	canParse(data, offset) {
		return canParse$1(data, offset);
	}
	appendFrame(track, data, offset) {
		initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
		const frame = appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
		if (frame && frame.missing === 0) return frame;
	}
};
var getAudioBSID = (data, offset) => {
	let bsid = 0;
	let numBits = 5;
	offset += numBits;
	const temp = new Uint32Array(1);
	const mask = new Uint32Array(1);
	const byte = new Uint8Array(1);
	while (numBits > 0) {
		byte[0] = data[offset];
		const bits = Math.min(numBits, 8);
		const shift = 8 - bits;
		mask[0] = 4278190080 >>> 24 + shift << shift;
		temp[0] = (byte[0] & mask[0]) >> shift;
		bsid = !bsid ? temp[0] : bsid << bits | temp[0];
		offset += 1;
		numBits -= bits;
	}
	return bsid;
};
var AC3Demuxer = class extends BaseAudioDemuxer {
	constructor(observer) {
		super();
		this.observer = void 0;
		this.observer = observer;
	}
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
		this._audioTrack = {
			container: "audio/ac-3",
			type: "audio",
			id: 2,
			pid: -1,
			sequenceNumber: 0,
			segmentCodec: "ac3",
			samples: [],
			manifestCodec: audioCodec,
			duration: trackDuration,
			inputTimeScale: 9e4,
			dropped: 0
		};
	}
	canParse(data, offset) {
		return offset + 64 < data.length;
	}
	appendFrame(track, data, offset) {
		const frameLength = appendFrame(track, data, offset, this.basePTS, this.frameIndex);
		if (frameLength !== -1) return {
			sample: track.samples[track.samples.length - 1],
			length: frameLength,
			missing: 0
		};
	}
	static probe(data) {
		if (!data) return false;
		const id3Data = getId3Data(data, 0);
		if (!id3Data) return false;
		const offset = id3Data.length;
		if (data[offset] === 11 && data[offset + 1] === 119 && getId3Timestamp(id3Data) !== void 0 && getAudioBSID(data, offset) < 16) return true;
		return false;
	}
};
function appendFrame(track, data, start, pts, frameIndex) {
	if (start + 8 > data.length) return -1;
	if (data[start] !== 11 || data[start + 1] !== 119) return -1;
	const samplingRateCode = data[start + 4] >> 6;
	if (samplingRateCode >= 3) return -1;
	const sampleRate = [
		48e3,
		44100,
		32e3
	][samplingRateCode];
	const frameSizeCode = data[start + 4] & 63;
	const frameLength = [
		64,
		69,
		96,
		64,
		70,
		96,
		80,
		87,
		120,
		80,
		88,
		120,
		96,
		104,
		144,
		96,
		105,
		144,
		112,
		121,
		168,
		112,
		122,
		168,
		128,
		139,
		192,
		128,
		140,
		192,
		160,
		174,
		240,
		160,
		175,
		240,
		192,
		208,
		288,
		192,
		209,
		288,
		224,
		243,
		336,
		224,
		244,
		336,
		256,
		278,
		384,
		256,
		279,
		384,
		320,
		348,
		480,
		320,
		349,
		480,
		384,
		417,
		576,
		384,
		418,
		576,
		448,
		487,
		672,
		448,
		488,
		672,
		512,
		557,
		768,
		512,
		558,
		768,
		640,
		696,
		960,
		640,
		697,
		960,
		768,
		835,
		1152,
		768,
		836,
		1152,
		896,
		975,
		1344,
		896,
		976,
		1344,
		1024,
		1114,
		1536,
		1024,
		1115,
		1536,
		1152,
		1253,
		1728,
		1152,
		1254,
		1728,
		1280,
		1393,
		1920,
		1280,
		1394,
		1920
	][frameSizeCode * 3 + samplingRateCode] * 2;
	if (start + frameLength > data.length) return -1;
	const channelMode = data[start + 6] >> 5;
	let skipCount = 0;
	if (channelMode === 2) skipCount += 2;
	else {
		if (channelMode & 1 && channelMode !== 1) skipCount += 2;
		if (channelMode & 4) skipCount += 2;
	}
	const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
	const channelCount = [
		2,
		1,
		2,
		3,
		3,
		4,
		4,
		5
	][channelMode] + lfeon;
	const bsid = data[start + 5] >> 3;
	const bsmod = data[start + 5] & 7;
	const config = new Uint8Array([
		samplingRateCode << 6 | bsid << 1 | bsmod >> 2,
		(bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4,
		frameSizeCode << 4 & 224
	]);
	const stamp = pts + frameIndex * (1536 / sampleRate * 9e4);
	const unit = data.subarray(start, start + frameLength);
	track.config = config;
	track.channelCount = channelCount;
	track.samplerate = sampleRate;
	track.samples.push({
		unit,
		pts: stamp
	});
	return frameLength;
}
/**
* MP3 demuxer
*/
var MP3Demuxer = class extends BaseAudioDemuxer {
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
		this._audioTrack = {
			container: "audio/mpeg",
			type: "audio",
			id: 2,
			pid: -1,
			sequenceNumber: 0,
			segmentCodec: "mp3",
			samples: [],
			manifestCodec: audioCodec,
			duration: trackDuration,
			inputTimeScale: 9e4,
			dropped: 0
		};
	}
	static probe(data) {
		if (!data) return false;
		const id3Data = getId3Data(data, 0);
		let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
		if (id3Data && data[offset] === 11 && data[offset + 1] === 119 && getId3Timestamp(id3Data) !== void 0 && getAudioBSID(data, offset) <= 16) return false;
		for (let length = data.length; offset < length; offset++) if (probe(data, offset)) {
			logger.log("MPEG Audio sync word found !");
			return true;
		}
		return false;
	}
	canParse(data, offset) {
		return canParse(data, offset);
	}
	appendFrame(track, data, offset) {
		if (this.basePTS === null) return;
		return appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
	}
};
var emsgSchemePattern = /\/emsg[-/]ID3/i;
var MP4Demuxer = class {
	constructor(observer, config) {
		this.remainderData = null;
		this.timeOffset = 0;
		this.config = void 0;
		this.videoTrack = void 0;
		this.audioTrack = void 0;
		this.id3Track = void 0;
		this.txtTrack = void 0;
		this.config = config;
	}
	resetTimeStamp() {}
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		const videoTrack = this.videoTrack = dummyTrack("video", 1);
		const audioTrack = this.audioTrack = dummyTrack("audio", 1);
		const captionTrack = this.txtTrack = dummyTrack("text", 1);
		this.id3Track = dummyTrack("id3", 1);
		this.timeOffset = 0;
		if (!(initSegment != null && initSegment.byteLength)) return;
		const initData = parseInitSegment(initSegment);
		if (initData.video) {
			const { id, timescale, codec, supplemental } = initData.video;
			videoTrack.id = id;
			videoTrack.timescale = captionTrack.timescale = timescale;
			videoTrack.codec = codec;
			videoTrack.supplemental = supplemental;
		}
		if (initData.audio) {
			const { id, timescale, codec } = initData.audio;
			audioTrack.id = id;
			audioTrack.timescale = timescale;
			audioTrack.codec = codec;
		}
		captionTrack.id = RemuxerTrackIdConfig.text;
		videoTrack.sampleDuration = 0;
		videoTrack.duration = audioTrack.duration = trackDuration;
	}
	resetContiguity() {
		this.remainderData = null;
	}
	static probe(data) {
		return hasMoofData(data);
	}
	demux(data, timeOffset) {
		this.timeOffset = timeOffset;
		let videoSamples = data;
		const videoTrack = this.videoTrack;
		const textTrack = this.txtTrack;
		if (this.config.progressive) {
			if (this.remainderData) videoSamples = appendUint8Array(this.remainderData, data);
			const segmentedData = segmentValidRange(videoSamples);
			this.remainderData = segmentedData.remainder;
			videoTrack.samples = segmentedData.valid || new Uint8Array();
		} else videoTrack.samples = videoSamples;
		const id3Track = this.extractID3Track(videoTrack, timeOffset);
		textTrack.samples = parseSamples(timeOffset, videoTrack);
		return {
			videoTrack,
			audioTrack: this.audioTrack,
			id3Track,
			textTrack: this.txtTrack
		};
	}
	flush() {
		const timeOffset = this.timeOffset;
		const videoTrack = this.videoTrack;
		const textTrack = this.txtTrack;
		videoTrack.samples = this.remainderData || new Uint8Array();
		this.remainderData = null;
		const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
		textTrack.samples = parseSamples(timeOffset, videoTrack);
		return {
			videoTrack,
			audioTrack: dummyTrack(),
			id3Track,
			textTrack: dummyTrack()
		};
	}
	extractID3Track(videoTrack, timeOffset) {
		const id3Track = this.id3Track;
		if (videoTrack.samples.length) {
			const emsgs = findBox(videoTrack.samples, ["emsg"]);
			if (emsgs) emsgs.forEach((data) => {
				const emsgInfo = parseEmsg(data);
				if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
					const pts = getEmsgStartTime(emsgInfo, timeOffset);
					let duration = emsgInfo.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
					if (duration <= .001) duration = Number.POSITIVE_INFINITY;
					const payload = emsgInfo.payload;
					id3Track.samples.push({
						data: payload,
						len: payload.byteLength,
						dts: pts,
						pts,
						type: MetadataSchema.emsg,
						duration
					});
				} else if (this.config.enableEmsgKLVMetadata && emsgInfo.schemeIdUri.startsWith("urn:misb:KLV:bin:1910.1")) {
					const pts = getEmsgStartTime(emsgInfo, timeOffset);
					id3Track.samples.push({
						data: emsgInfo.payload,
						len: emsgInfo.payload.byteLength,
						dts: pts,
						pts,
						type: MetadataSchema.misbklv,
						duration: Number.POSITIVE_INFINITY
					});
				}
			});
		}
		return id3Track;
	}
	demuxSampleAes(data, keyData, timeOffset) {
		return Promise.reject(/* @__PURE__ */ new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
	}
	destroy() {
		this.config = null;
		this.remainderData = null;
		this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = void 0;
	}
};
function getEmsgStartTime(emsgInfo, timeOffset) {
	return isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
}
/**
* SAMPLE-AES decrypter
*/
var SampleAesDecrypter = class {
	constructor(observer, config, keyData) {
		this.keyData = void 0;
		this.decrypter = void 0;
		this.keyData = keyData;
		this.decrypter = new Decrypter(config, { removePKCS7Padding: false });
	}
	decryptBuffer(encryptedData) {
		return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer, DecrypterAesMode.cbc);
	}
	decryptAacSample(samples, sampleIndex, callback) {
		const curUnit = samples[sampleIndex].unit;
		if (curUnit.length <= 16) return;
		const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
		const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
		this.decryptBuffer(encryptedBuffer).then((decryptedBuffer) => {
			const decryptedData = new Uint8Array(decryptedBuffer);
			curUnit.set(decryptedData, 16);
			if (!this.decrypter.isSync()) this.decryptAacSamples(samples, sampleIndex + 1, callback);
		}).catch(callback);
	}
	decryptAacSamples(samples, sampleIndex, callback) {
		for (;; sampleIndex++) {
			if (sampleIndex >= samples.length) {
				callback();
				return;
			}
			if (samples[sampleIndex].unit.length < 32) continue;
			this.decryptAacSample(samples, sampleIndex, callback);
			if (!this.decrypter.isSync()) return;
		}
	}
	getAvcEncryptedData(decodedData) {
		const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
		const encryptedData = new Int8Array(encryptedDataLen);
		let outputPos = 0;
		for (let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
		return encryptedData;
	}
	getAvcDecryptedUnit(decodedData, decryptedData) {
		const uint8DecryptedData = new Uint8Array(decryptedData);
		let inputPos = 0;
		for (let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
		return decodedData;
	}
	decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
		const decodedData = discardEPB(curUnit.data);
		const encryptedData = this.getAvcEncryptedData(decodedData);
		this.decryptBuffer(encryptedData.buffer).then((decryptedBuffer) => {
			curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
			if (!this.decrypter.isSync()) this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
		}).catch(callback);
	}
	decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
		if (samples instanceof Uint8Array) throw new Error("Cannot decrypt samples of type Uint8Array");
		for (;; sampleIndex++, unitIndex = 0) {
			if (sampleIndex >= samples.length) {
				callback();
				return;
			}
			const curUnits = samples[sampleIndex].units;
			for (;; unitIndex++) {
				if (unitIndex >= curUnits.length) break;
				const curUnit = curUnits[unitIndex];
				if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
				this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
				if (!this.decrypter.isSync()) return;
			}
		}
	}
};
var BaseVideoParser = class {
	constructor() {
		this.VideoSample = null;
	}
	createVideoSample(key, pts, dts) {
		return {
			key,
			frame: false,
			pts,
			dts,
			units: [],
			length: 0
		};
	}
	getLastNalUnit(samples) {
		var _VideoSample;
		let VideoSample = this.VideoSample;
		let lastUnit;
		if (!VideoSample || VideoSample.units.length === 0) VideoSample = samples[samples.length - 1];
		if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
			const units = VideoSample.units;
			lastUnit = units[units.length - 1];
		}
		return lastUnit;
	}
	pushAccessUnit(VideoSample, videoTrack) {
		if (VideoSample.units.length && VideoSample.frame) {
			if (VideoSample.pts === void 0) {
				const samples = videoTrack.samples;
				const nbSamples = samples.length;
				if (nbSamples) {
					const lastSample = samples[nbSamples - 1];
					VideoSample.pts = lastSample.pts;
					VideoSample.dts = lastSample.dts;
				} else {
					videoTrack.dropped++;
					return;
				}
			}
			videoTrack.samples.push(VideoSample);
		}
	}
	parseNALu(track, array, endOfSegment) {
		const len = array.byteLength;
		let state = track.naluState || 0;
		const lastState = state;
		const units = [];
		let i = 0;
		let value;
		let overflow;
		let unitType;
		let lastUnitStart = -1;
		let lastUnitType = 0;
		if (state === -1) {
			lastUnitStart = 0;
			lastUnitType = this.getNALuType(array, 0);
			state = 0;
			i = 1;
		}
		while (i < len) {
			value = array[i++];
			if (!state) {
				state = value ? 0 : 1;
				continue;
			}
			if (state === 1) {
				state = value ? 0 : 2;
				continue;
			}
			if (!value) state = 3;
			else if (value === 1) {
				overflow = i - state - 1;
				if (lastUnitStart >= 0) {
					const unit = {
						data: array.subarray(lastUnitStart, overflow),
						type: lastUnitType
					};
					units.push(unit);
				} else {
					const lastUnit = this.getLastNalUnit(track.samples);
					if (lastUnit) {
						if (lastState && i <= 4 - lastState) {
							if (lastUnit.state) lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
						}
						if (overflow > 0) {
							lastUnit.data = appendUint8Array(lastUnit.data, array.subarray(0, overflow));
							lastUnit.state = 0;
						}
					}
				}
				if (i < len) {
					unitType = this.getNALuType(array, i);
					lastUnitStart = i;
					lastUnitType = unitType;
					state = 0;
				} else state = -1;
			} else state = 0;
		}
		if (lastUnitStart >= 0 && state >= 0) {
			const unit = {
				data: array.subarray(lastUnitStart, len),
				type: lastUnitType,
				state
			};
			units.push(unit);
		}
		if (units.length === 0) {
			const lastUnit = this.getLastNalUnit(track.samples);
			if (lastUnit) lastUnit.data = appendUint8Array(lastUnit.data, array);
		}
		track.naluState = state;
		return units;
	}
};
/**
* Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
*/
var ExpGolomb = class {
	constructor(data) {
		this.data = void 0;
		this.bytesAvailable = void 0;
		this.word = void 0;
		this.bitsAvailable = void 0;
		this.data = data;
		this.bytesAvailable = data.byteLength;
		this.word = 0;
		this.bitsAvailable = 0;
	}
	loadWord() {
		const data = this.data;
		const bytesAvailable = this.bytesAvailable;
		const position = data.byteLength - bytesAvailable;
		const workingBytes = new Uint8Array(4);
		const availableBytes = Math.min(4, bytesAvailable);
		if (availableBytes === 0) throw new Error("no bytes available");
		workingBytes.set(data.subarray(position, position + availableBytes));
		this.word = new DataView(workingBytes.buffer).getUint32(0);
		this.bitsAvailable = availableBytes * 8;
		this.bytesAvailable -= availableBytes;
	}
	skipBits(count) {
		let skipBytes;
		count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
		if (this.bitsAvailable > count) {
			this.word <<= count;
			this.bitsAvailable -= count;
		} else {
			count -= this.bitsAvailable;
			skipBytes = count >> 3;
			count -= skipBytes << 3;
			this.bytesAvailable -= skipBytes;
			this.loadWord();
			this.word <<= count;
			this.bitsAvailable -= count;
		}
	}
	readBits(size) {
		let bits = Math.min(this.bitsAvailable, size);
		const valu = this.word >>> 32 - bits;
		if (size > 32) logger.error("Cannot read more than 32 bits at a time");
		this.bitsAvailable -= bits;
		if (this.bitsAvailable > 0) this.word <<= bits;
		else if (this.bytesAvailable > 0) this.loadWord();
		else throw new Error("no bits available");
		bits = size - bits;
		if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
		else return valu;
	}
	skipLZ() {
		let leadingZeroCount;
		for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) if ((this.word & 2147483648 >>> leadingZeroCount) !== 0) {
			this.word <<= leadingZeroCount;
			this.bitsAvailable -= leadingZeroCount;
			return leadingZeroCount;
		}
		this.loadWord();
		return leadingZeroCount + this.skipLZ();
	}
	skipUEG() {
		this.skipBits(1 + this.skipLZ());
	}
	skipEG() {
		this.skipBits(1 + this.skipLZ());
	}
	readUEG() {
		const clz = this.skipLZ();
		return this.readBits(clz + 1) - 1;
	}
	readEG() {
		const valu = this.readUEG();
		if (1 & valu) return 1 + valu >>> 1;
		else return -1 * (valu >>> 1);
	}
	readBoolean() {
		return this.readBits(1) === 1;
	}
	readUByte() {
		return this.readBits(8);
	}
	readUShort() {
		return this.readBits(16);
	}
	readUInt() {
		return this.readBits(32);
	}
};
var AvcVideoParser = class extends BaseVideoParser {
	parsePES(track, textTrack, pes, endOfSegment) {
		const units = this.parseNALu(track, pes.data, endOfSegment);
		let VideoSample = this.VideoSample;
		let push;
		let spsfound = false;
		pes.data = null;
		if (VideoSample && units.length && !track.audFound) {
			this.pushAccessUnit(VideoSample, track);
			VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
		}
		units.forEach((unit) => {
			var _VideoSample2, _VideoSample3;
			switch (unit.type) {
				case 1: {
					let iskey = false;
					push = true;
					const data = unit.data;
					if (spsfound && data.length > 4) {
						const sliceType = this.readSliceType(data);
						if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) iskey = true;
					}
					if (iskey) {
						var _VideoSample;
						if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
							this.pushAccessUnit(VideoSample, track);
							VideoSample = this.VideoSample = null;
						}
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
					VideoSample.frame = true;
					VideoSample.key = iskey;
					break;
				}
				case 5:
					push = true;
					if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
						this.pushAccessUnit(VideoSample, track);
						VideoSample = this.VideoSample = null;
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
					VideoSample.key = true;
					VideoSample.frame = true;
					break;
				case 6:
					push = true;
					parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
					break;
				case 7: {
					var _track$pixelRatio, _track$pixelRatio2;
					push = true;
					spsfound = true;
					const sps = unit.data;
					const config = this.readSPS(sps);
					if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
						track.width = config.width;
						track.height = config.height;
						track.pixelRatio = config.pixelRatio;
						track.sps = [sps];
						const codecarray = sps.subarray(1, 4);
						let codecstring = "avc1.";
						for (let i = 0; i < 3; i++) {
							let h = codecarray[i].toString(16);
							if (h.length < 2) h = "0" + h;
							codecstring += h;
						}
						track.codec = codecstring;
					}
					break;
				}
				case 8:
					push = true;
					track.pps = [unit.data];
					break;
				case 9:
					push = true;
					track.audFound = true;
					if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
						this.pushAccessUnit(VideoSample, track);
						VideoSample = null;
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
					break;
				case 12:
					push = true;
					break;
				default:
					push = false;
					break;
			}
			if (VideoSample && push) VideoSample.units.push(unit);
		});
		if (endOfSegment && VideoSample) {
			this.pushAccessUnit(VideoSample, track);
			this.VideoSample = null;
		}
	}
	getNALuType(data, offset) {
		return data[offset] & 31;
	}
	readSliceType(data) {
		const eg = new ExpGolomb(data);
		eg.readUByte();
		eg.readUEG();
		return eg.readUEG();
	}
	/**
	* The scaling list is optionally transmitted as part of a sequence parameter
	* set and is not relevant to transmuxing.
	* @param count the number of entries in this scaling list
	* @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	*/
	skipScalingList(count, reader) {
		let lastScale = 8;
		let nextScale = 8;
		let deltaScale;
		for (let j = 0; j < count; j++) {
			if (nextScale !== 0) {
				deltaScale = reader.readEG();
				nextScale = (lastScale + deltaScale + 256) % 256;
			}
			lastScale = nextScale === 0 ? lastScale : nextScale;
		}
	}
	/**
	* Read a sequence parameter set and return some interesting video
	* properties. A sequence parameter set is the H264 metadata that
	* describes the properties of upcoming video frames.
	* @returns an object with configuration parsed from the
	* sequence parameter set, including the dimensions of the
	* associated video frames.
	*/
	readSPS(sps) {
		const eg = new ExpGolomb(sps);
		let frameCropLeftOffset = 0;
		let frameCropRightOffset = 0;
		let frameCropTopOffset = 0;
		let frameCropBottomOffset = 0;
		let numRefFramesInPicOrderCntCycle;
		let scalingListCount;
		let i;
		const readUByte = eg.readUByte.bind(eg);
		const readBits = eg.readBits.bind(eg);
		const readUEG = eg.readUEG.bind(eg);
		const readBoolean = eg.readBoolean.bind(eg);
		const skipBits = eg.skipBits.bind(eg);
		const skipEG = eg.skipEG.bind(eg);
		const skipUEG = eg.skipUEG.bind(eg);
		const skipScalingList = this.skipScalingList.bind(this);
		readUByte();
		const profileIdc = readUByte();
		readBits(5);
		skipBits(3);
		readUByte();
		skipUEG();
		if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
			const chromaFormatIdc = readUEG();
			if (chromaFormatIdc === 3) skipBits(1);
			skipUEG();
			skipUEG();
			skipBits(1);
			if (readBoolean()) {
				scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
				for (i = 0; i < scalingListCount; i++) if (readBoolean()) if (i < 6) skipScalingList(16, eg);
				else skipScalingList(64, eg);
			}
		}
		skipUEG();
		const picOrderCntType = readUEG();
		if (picOrderCntType === 0) readUEG();
		else if (picOrderCntType === 1) {
			skipBits(1);
			skipEG();
			skipEG();
			numRefFramesInPicOrderCntCycle = readUEG();
			for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) skipEG();
		}
		skipUEG();
		skipBits(1);
		const picWidthInMbsMinus1 = readUEG();
		const picHeightInMapUnitsMinus1 = readUEG();
		const frameMbsOnlyFlag = readBits(1);
		if (frameMbsOnlyFlag === 0) skipBits(1);
		skipBits(1);
		if (readBoolean()) {
			frameCropLeftOffset = readUEG();
			frameCropRightOffset = readUEG();
			frameCropTopOffset = readUEG();
			frameCropBottomOffset = readUEG();
		}
		let pixelRatio = [1, 1];
		if (readBoolean()) {
			if (readBoolean()) switch (readUByte()) {
				case 1:
					pixelRatio = [1, 1];
					break;
				case 2:
					pixelRatio = [12, 11];
					break;
				case 3:
					pixelRatio = [10, 11];
					break;
				case 4:
					pixelRatio = [16, 11];
					break;
				case 5:
					pixelRatio = [40, 33];
					break;
				case 6:
					pixelRatio = [24, 11];
					break;
				case 7:
					pixelRatio = [20, 11];
					break;
				case 8:
					pixelRatio = [32, 11];
					break;
				case 9:
					pixelRatio = [80, 33];
					break;
				case 10:
					pixelRatio = [18, 11];
					break;
				case 11:
					pixelRatio = [15, 11];
					break;
				case 12:
					pixelRatio = [64, 33];
					break;
				case 13:
					pixelRatio = [160, 99];
					break;
				case 14:
					pixelRatio = [4, 3];
					break;
				case 15:
					pixelRatio = [3, 2];
					break;
				case 16:
					pixelRatio = [2, 1];
					break;
				case 255:
					pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
					break;
			}
		}
		return {
			width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
			height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
			pixelRatio
		};
	}
};
var HevcVideoParser = class extends BaseVideoParser {
	constructor(...args) {
		super(...args);
		this.initVPS = null;
	}
	parsePES(track, textTrack, pes, endOfSegment) {
		const units = this.parseNALu(track, pes.data, endOfSegment);
		let VideoSample = this.VideoSample;
		let push;
		let spsfound = false;
		pes.data = null;
		if (VideoSample && units.length && !track.audFound) {
			this.pushAccessUnit(VideoSample, track);
			VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
		}
		units.forEach((unit) => {
			var _VideoSample2, _VideoSample3;
			switch (unit.type) {
				case 0:
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
				case 6:
				case 7:
				case 8:
				case 9:
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
					VideoSample.frame = true;
					push = true;
					break;
				case 16:
				case 17:
				case 18:
				case 21:
					push = true;
					if (spsfound) {
						var _VideoSample;
						if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
							this.pushAccessUnit(VideoSample, track);
							VideoSample = this.VideoSample = null;
						}
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
					VideoSample.key = true;
					VideoSample.frame = true;
					break;
				case 19:
				case 20:
					push = true;
					if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
						this.pushAccessUnit(VideoSample, track);
						VideoSample = this.VideoSample = null;
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
					VideoSample.key = true;
					VideoSample.frame = true;
					break;
				case 39:
					push = true;
					parseSEIMessageFromNALu(unit.data, 2, pes.pts, textTrack.samples);
					break;
				case 32:
					push = true;
					if (!track.vps) {
						if (typeof track.params !== "object") track.params = {};
						track.params = _extends(track.params, this.readVPS(unit.data));
						this.initVPS = unit.data;
					}
					track.vps = [unit.data];
					break;
				case 33:
					push = true;
					spsfound = true;
					if (track.vps !== void 0 && track.vps[0] !== this.initVPS && track.sps !== void 0 && !this.matchSPS(track.sps[0], unit.data)) {
						this.initVPS = track.vps[0];
						track.sps = track.pps = void 0;
					}
					if (!track.sps) {
						const config = this.readSPS(unit.data);
						track.width = config.width;
						track.height = config.height;
						track.pixelRatio = config.pixelRatio;
						track.codec = config.codecString;
						track.sps = [];
						if (typeof track.params !== "object") track.params = {};
						for (const prop in config.params) track.params[prop] = config.params[prop];
					}
					this.pushParameterSet(track.sps, unit.data, track.vps);
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
					VideoSample.key = true;
					break;
				case 34:
					push = true;
					if (typeof track.params === "object") {
						if (!track.pps) {
							track.pps = [];
							const config = this.readPPS(unit.data);
							for (const prop in config) track.params[prop] = config[prop];
						}
						this.pushParameterSet(track.pps, unit.data, track.vps);
					}
					break;
				case 35:
					push = true;
					track.audFound = true;
					if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
						this.pushAccessUnit(VideoSample, track);
						VideoSample = null;
					}
					if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
					break;
				default:
					push = false;
					break;
			}
			if (VideoSample && push) VideoSample.units.push(unit);
		});
		if (endOfSegment && VideoSample) {
			this.pushAccessUnit(VideoSample, track);
			this.VideoSample = null;
		}
	}
	pushParameterSet(parameterSets, data, vps) {
		if (vps && vps[0] === this.initVPS || !vps && !parameterSets.length) parameterSets.push(data);
	}
	getNALuType(data, offset) {
		return (data[offset] & 126) >>> 1;
	}
	ebsp2rbsp(arr) {
		const dst = new Uint8Array(arr.byteLength);
		let dstIdx = 0;
		for (let i = 0; i < arr.byteLength; i++) {
			if (i >= 2) {
				if (arr[i] === 3 && arr[i - 1] === 0 && arr[i - 2] === 0) continue;
			}
			dst[dstIdx] = arr[i];
			dstIdx++;
		}
		return new Uint8Array(dst.buffer, 0, dstIdx);
	}
	pushAccessUnit(VideoSample, videoTrack) {
		super.pushAccessUnit(VideoSample, videoTrack);
		if (this.initVPS) this.initVPS = null;
	}
	readVPS(vps) {
		const eg = new ExpGolomb(vps);
		eg.readUByte();
		eg.readUByte();
		eg.readBits(4);
		eg.skipBits(2);
		eg.readBits(6);
		const max_sub_layers_minus1 = eg.readBits(3);
		const temporal_id_nesting_flag = eg.readBoolean();
		return {
			numTemporalLayers: max_sub_layers_minus1 + 1,
			temporalIdNested: temporal_id_nesting_flag
		};
	}
	readSPS(sps) {
		const eg = new ExpGolomb(this.ebsp2rbsp(sps));
		eg.readUByte();
		eg.readUByte();
		eg.readBits(4);
		const max_sub_layers_minus1 = eg.readBits(3);
		eg.readBoolean();
		const general_profile_space = eg.readBits(2);
		const general_tier_flag = eg.readBoolean();
		const general_profile_idc = eg.readBits(5);
		const general_profile_compatibility_flags_1 = eg.readUByte();
		const general_profile_compatibility_flags_2 = eg.readUByte();
		const general_profile_compatibility_flags_3 = eg.readUByte();
		const general_profile_compatibility_flags_4 = eg.readUByte();
		const general_constraint_indicator_flags_1 = eg.readUByte();
		const general_constraint_indicator_flags_2 = eg.readUByte();
		const general_constraint_indicator_flags_3 = eg.readUByte();
		const general_constraint_indicator_flags_4 = eg.readUByte();
		const general_constraint_indicator_flags_5 = eg.readUByte();
		const general_constraint_indicator_flags_6 = eg.readUByte();
		const general_level_idc = eg.readUByte();
		const sub_layer_profile_present_flags = [];
		const sub_layer_level_present_flags = [];
		for (let i = 0; i < max_sub_layers_minus1; i++) {
			sub_layer_profile_present_flags.push(eg.readBoolean());
			sub_layer_level_present_flags.push(eg.readBoolean());
		}
		if (max_sub_layers_minus1 > 0) for (let i = max_sub_layers_minus1; i < 8; i++) eg.readBits(2);
		for (let i = 0; i < max_sub_layers_minus1; i++) {
			if (sub_layer_profile_present_flags[i]) {
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
				eg.readUByte();
			}
			if (sub_layer_level_present_flags[i]) eg.readUByte();
		}
		eg.readUEG();
		const chroma_format_idc = eg.readUEG();
		if (chroma_format_idc == 3) eg.skipBits(1);
		const pic_width_in_luma_samples = eg.readUEG();
		const pic_height_in_luma_samples = eg.readUEG();
		const conformance_window_flag = eg.readBoolean();
		let pic_left_offset = 0, pic_right_offset = 0, pic_top_offset = 0, pic_bottom_offset = 0;
		if (conformance_window_flag) {
			pic_left_offset += eg.readUEG();
			pic_right_offset += eg.readUEG();
			pic_top_offset += eg.readUEG();
			pic_bottom_offset += eg.readUEG();
		}
		const bit_depth_luma_minus8 = eg.readUEG();
		const bit_depth_chroma_minus8 = eg.readUEG();
		const log2_max_pic_order_cnt_lsb_minus4 = eg.readUEG();
		const sub_layer_ordering_info_present_flag = eg.readBoolean();
		for (let i = sub_layer_ordering_info_present_flag ? 0 : max_sub_layers_minus1; i <= max_sub_layers_minus1; i++) {
			eg.skipUEG();
			eg.skipUEG();
			eg.skipUEG();
		}
		eg.skipUEG();
		eg.skipUEG();
		eg.skipUEG();
		eg.skipUEG();
		eg.skipUEG();
		eg.skipUEG();
		if (eg.readBoolean()) {
			if (eg.readBoolean()) for (let sizeId = 0; sizeId < 4; sizeId++) for (let matrixId = 0; matrixId < (sizeId === 3 ? 2 : 6); matrixId++) if (!eg.readBoolean()) eg.readUEG();
			else {
				const coefNum = Math.min(64, 1 << 4 + (sizeId << 1));
				if (sizeId > 1) eg.readEG();
				for (let i = 0; i < coefNum; i++) eg.readEG();
			}
		}
		eg.readBoolean();
		eg.readBoolean();
		if (eg.readBoolean()) {
			eg.readUByte();
			eg.skipUEG();
			eg.skipUEG();
			eg.readBoolean();
		}
		const num_short_term_ref_pic_sets = eg.readUEG();
		let num_delta_pocs = 0;
		for (let i = 0; i < num_short_term_ref_pic_sets; i++) {
			let inter_ref_pic_set_prediction_flag = false;
			if (i !== 0) inter_ref_pic_set_prediction_flag = eg.readBoolean();
			if (inter_ref_pic_set_prediction_flag) {
				if (i === num_short_term_ref_pic_sets) eg.readUEG();
				eg.readBoolean();
				eg.readUEG();
				let next_num_delta_pocs = 0;
				for (let j = 0; j <= num_delta_pocs; j++) {
					const used_by_curr_pic_flag = eg.readBoolean();
					let use_delta_flag = false;
					if (!used_by_curr_pic_flag) use_delta_flag = eg.readBoolean();
					if (used_by_curr_pic_flag || use_delta_flag) next_num_delta_pocs++;
				}
				num_delta_pocs = next_num_delta_pocs;
			} else {
				const num_negative_pics = eg.readUEG();
				const num_positive_pics = eg.readUEG();
				num_delta_pocs = num_negative_pics + num_positive_pics;
				for (let j = 0; j < num_negative_pics; j++) {
					eg.readUEG();
					eg.readBoolean();
				}
				for (let j = 0; j < num_positive_pics; j++) {
					eg.readUEG();
					eg.readBoolean();
				}
			}
		}
		if (eg.readBoolean()) {
			const num_long_term_ref_pics_sps = eg.readUEG();
			for (let i = 0; i < num_long_term_ref_pics_sps; i++) {
				for (let j = 0; j < log2_max_pic_order_cnt_lsb_minus4 + 4; j++) eg.readBits(1);
				eg.readBits(1);
			}
		}
		let min_spatial_segmentation_idc = 0;
		let sar_width = 1, sar_height = 1;
		let fps_fixed = true, fps_den = 1, fps_num = 0;
		eg.readBoolean();
		eg.readBoolean();
		let default_display_window_flag = false;
		if (eg.readBoolean()) {
			if (eg.readBoolean()) {
				const aspect_ratio_idc = eg.readUByte();
				const sar_width_table = [
					1,
					12,
					10,
					16,
					40,
					24,
					20,
					32,
					80,
					18,
					15,
					64,
					160,
					4,
					3,
					2
				];
				const sar_height_table = [
					1,
					11,
					11,
					11,
					33,
					11,
					11,
					11,
					33,
					11,
					11,
					33,
					99,
					3,
					2,
					1
				];
				if (aspect_ratio_idc > 0 && aspect_ratio_idc < 16) {
					sar_width = sar_width_table[aspect_ratio_idc - 1];
					sar_height = sar_height_table[aspect_ratio_idc - 1];
				} else if (aspect_ratio_idc === 255) {
					sar_width = eg.readBits(16);
					sar_height = eg.readBits(16);
				}
			}
			if (eg.readBoolean()) eg.readBoolean();
			if (eg.readBoolean()) {
				eg.readBits(3);
				eg.readBoolean();
				if (eg.readBoolean()) {
					eg.readUByte();
					eg.readUByte();
					eg.readUByte();
				}
			}
			if (eg.readBoolean()) {
				eg.readUEG();
				eg.readUEG();
			}
			eg.readBoolean();
			eg.readBoolean();
			eg.readBoolean();
			default_display_window_flag = eg.readBoolean();
			if (default_display_window_flag) {
				eg.skipUEG();
				eg.skipUEG();
				eg.skipUEG();
				eg.skipUEG();
			}
			if (eg.readBoolean()) {
				fps_den = eg.readBits(32);
				fps_num = eg.readBits(32);
				if (eg.readBoolean()) eg.readUEG();
				if (eg.readBoolean()) {
					const nal_hrd_parameters_present_flag = eg.readBoolean();
					const vcl_hrd_parameters_present_flag = eg.readBoolean();
					let sub_pic_hrd_params_present_flag = false;
					if (nal_hrd_parameters_present_flag || vcl_hrd_parameters_present_flag) {
						sub_pic_hrd_params_present_flag = eg.readBoolean();
						if (sub_pic_hrd_params_present_flag) {
							eg.readUByte();
							eg.readBits(5);
							eg.readBoolean();
							eg.readBits(5);
						}
						eg.readBits(4);
						eg.readBits(4);
						if (sub_pic_hrd_params_present_flag) eg.readBits(4);
						eg.readBits(5);
						eg.readBits(5);
						eg.readBits(5);
					}
					for (let i = 0; i <= max_sub_layers_minus1; i++) {
						fps_fixed = eg.readBoolean();
						const fixed_pic_rate_within_cvs_flag = fps_fixed || eg.readBoolean();
						let low_delay_hrd_flag = false;
						if (fixed_pic_rate_within_cvs_flag) eg.readEG();
						else low_delay_hrd_flag = eg.readBoolean();
						const cpb_cnt = low_delay_hrd_flag ? 1 : eg.readUEG() + 1;
						if (nal_hrd_parameters_present_flag) for (let j = 0; j < cpb_cnt; j++) {
							eg.readUEG();
							eg.readUEG();
							if (sub_pic_hrd_params_present_flag) {
								eg.readUEG();
								eg.readUEG();
							}
							eg.skipBits(1);
						}
						if (vcl_hrd_parameters_present_flag) for (let j = 0; j < cpb_cnt; j++) {
							eg.readUEG();
							eg.readUEG();
							if (sub_pic_hrd_params_present_flag) {
								eg.readUEG();
								eg.readUEG();
							}
							eg.skipBits(1);
						}
					}
				}
			}
			if (eg.readBoolean()) {
				eg.readBoolean();
				eg.readBoolean();
				eg.readBoolean();
				min_spatial_segmentation_idc = eg.readUEG();
			}
		}
		let width = pic_width_in_luma_samples, height = pic_height_in_luma_samples;
		if (conformance_window_flag) {
			let chroma_scale_w = 1, chroma_scale_h = 1;
			if (chroma_format_idc === 1) chroma_scale_w = chroma_scale_h = 2;
			else if (chroma_format_idc == 2) chroma_scale_w = 2;
			width = pic_width_in_luma_samples - chroma_scale_w * pic_right_offset - chroma_scale_w * pic_left_offset;
			height = pic_height_in_luma_samples - chroma_scale_h * pic_bottom_offset - chroma_scale_h * pic_top_offset;
		}
		const profile_space_string = general_profile_space ? [
			"A",
			"B",
			"C"
		][general_profile_space] : "";
		const profile_compatibility_buf = general_profile_compatibility_flags_1 << 24 | general_profile_compatibility_flags_2 << 16 | general_profile_compatibility_flags_3 << 8 | general_profile_compatibility_flags_4;
		let profile_compatibility_rev = 0;
		for (let i = 0; i < 32; i++) profile_compatibility_rev = (profile_compatibility_rev | (profile_compatibility_buf >> i & 1) << 31 - i) >>> 0;
		let profile_compatibility_flags_string = profile_compatibility_rev.toString(16);
		if (general_profile_idc === 1 && profile_compatibility_flags_string === "2") profile_compatibility_flags_string = "6";
		return {
			codecString: `hvc1.${profile_space_string}${general_profile_idc}.${profile_compatibility_flags_string}.${general_tier_flag ? "H" : "L"}${general_level_idc}.B0`,
			params: {
				general_tier_flag,
				general_profile_idc,
				general_profile_space,
				general_profile_compatibility_flags: [
					general_profile_compatibility_flags_1,
					general_profile_compatibility_flags_2,
					general_profile_compatibility_flags_3,
					general_profile_compatibility_flags_4
				],
				general_constraint_indicator_flags: [
					general_constraint_indicator_flags_1,
					general_constraint_indicator_flags_2,
					general_constraint_indicator_flags_3,
					general_constraint_indicator_flags_4,
					general_constraint_indicator_flags_5,
					general_constraint_indicator_flags_6
				],
				general_level_idc,
				bit_depth: bit_depth_luma_minus8 + 8,
				bit_depth_luma_minus8,
				bit_depth_chroma_minus8,
				min_spatial_segmentation_idc,
				chroma_format_idc,
				frame_rate: {
					fixed: fps_fixed,
					fps: fps_num / fps_den
				}
			},
			width,
			height,
			pixelRatio: [sar_width, sar_height]
		};
	}
	readPPS(pps) {
		const eg = new ExpGolomb(this.ebsp2rbsp(pps));
		eg.readUByte();
		eg.readUByte();
		eg.skipUEG();
		eg.skipUEG();
		eg.skipBits(2);
		eg.skipBits(3);
		eg.skipBits(2);
		eg.skipUEG();
		eg.skipUEG();
		eg.skipEG();
		eg.skipBits(2);
		if (eg.readBoolean()) eg.skipUEG();
		eg.skipEG();
		eg.skipEG();
		eg.skipBits(4);
		const tiles_enabled_flag = eg.readBoolean();
		const entropy_coding_sync_enabled_flag = eg.readBoolean();
		let parallelismType = 1;
		if (entropy_coding_sync_enabled_flag && tiles_enabled_flag) parallelismType = 0;
		else if (entropy_coding_sync_enabled_flag) parallelismType = 3;
		else if (tiles_enabled_flag) parallelismType = 2;
		return { parallelismType };
	}
	matchSPS(sps1, sps2) {
		return String.fromCharCode.apply(null, sps1).substr(3) === String.fromCharCode.apply(null, sps2).substr(3);
	}
};
var PACKET_LENGTH = 188;
var TSDemuxer = class TSDemuxer {
	constructor(observer, config, typeSupported, logger) {
		this.logger = void 0;
		this.observer = void 0;
		this.config = void 0;
		this.typeSupported = void 0;
		this.sampleAes = null;
		this.pmtParsed = false;
		this.audioCodec = void 0;
		this.videoCodec = void 0;
		this._pmtId = -1;
		this._videoTrack = void 0;
		this._audioTrack = void 0;
		this._id3Track = void 0;
		this._txtTrack = void 0;
		this.aacOverFlow = null;
		this.remainderData = null;
		this.videoParser = void 0;
		this.observer = observer;
		this.config = config;
		this.typeSupported = typeSupported;
		this.logger = logger;
		this.videoParser = null;
	}
	static probe(data, logger) {
		const syncOffset = TSDemuxer.syncOffset(data);
		if (syncOffset > 0) logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
		return syncOffset !== -1;
	}
	static syncOffset(data) {
		const length = data.length;
		let scanwindow = Math.min(PACKET_LENGTH * 5, length - PACKET_LENGTH) + 1;
		let i = 0;
		while (i < scanwindow) {
			let foundPat = false;
			let packetStart = -1;
			let tsPackets = 0;
			for (let j = i; j < length; j += PACKET_LENGTH) if (data[j] === 71 && (length - j === PACKET_LENGTH || data[j + PACKET_LENGTH] === 71)) {
				tsPackets++;
				if (packetStart === -1) {
					packetStart = j;
					if (packetStart !== 0) scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
				}
				if (!foundPat) foundPat = parsePID(data, j) === 0;
				if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) return packetStart;
			} else if (tsPackets) return -1;
			else break;
			i++;
		}
		return -1;
	}
	/**
	* Creates a track model internal to demuxer used to drive remuxing input
	*/
	static createTrack(type, duration) {
		return {
			container: type === "video" || type === "audio" ? "video/mp2t" : void 0,
			type,
			id: RemuxerTrackIdConfig[type],
			pid: -1,
			inputTimeScale: 9e4,
			sequenceNumber: 0,
			samples: [],
			dropped: 0,
			duration: type === "audio" ? duration : void 0
		};
	}
	/**
	* Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
	* Resets all internal track instances of the demuxer.
	*/
	resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
		this.pmtParsed = false;
		this._pmtId = -1;
		this._videoTrack = TSDemuxer.createTrack("video");
		this._videoTrack.duration = trackDuration;
		this._audioTrack = TSDemuxer.createTrack("audio", trackDuration);
		this._id3Track = TSDemuxer.createTrack("id3");
		this._txtTrack = TSDemuxer.createTrack("text");
		this._audioTrack.segmentCodec = "aac";
		this.videoParser = null;
		this.aacOverFlow = null;
		this.remainderData = null;
		this.audioCodec = audioCodec;
		this.videoCodec = videoCodec;
	}
	resetTimeStamp() {}
	resetContiguity() {
		const { _audioTrack, _videoTrack, _id3Track } = this;
		if (_audioTrack) _audioTrack.pesData = null;
		if (_videoTrack) _videoTrack.pesData = null;
		if (_id3Track) _id3Track.pesData = null;
		this.aacOverFlow = null;
		this.remainderData = null;
	}
	demux(data, timeOffset, isSampleAes = false, flush = false) {
		if (!isSampleAes) this.sampleAes = null;
		let pes;
		const videoTrack = this._videoTrack;
		const audioTrack = this._audioTrack;
		const id3Track = this._id3Track;
		const textTrack = this._txtTrack;
		let videoPid = videoTrack.pid;
		let videoData = videoTrack.pesData;
		let audioPid = audioTrack.pid;
		let id3Pid = id3Track.pid;
		let audioData = audioTrack.pesData;
		let id3Data = id3Track.pesData;
		let unknownPID = null;
		let pmtParsed = this.pmtParsed;
		let pmtId = this._pmtId;
		let len = data.length;
		if (this.remainderData) {
			data = appendUint8Array(this.remainderData, data);
			len = data.length;
			this.remainderData = null;
		}
		if (len < PACKET_LENGTH && !flush) {
			this.remainderData = data;
			return {
				audioTrack,
				videoTrack,
				id3Track,
				textTrack
			};
		}
		const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
		len -= (len - syncOffset) % PACKET_LENGTH;
		if (len < data.byteLength && !flush) this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
		let tsPacketErrors = 0;
		for (let start = syncOffset; start < len; start += PACKET_LENGTH) if (data[start] === 71) {
			const stt = !!(data[start + 1] & 64);
			const pid = parsePID(data, start);
			const atf = (data[start + 3] & 48) >> 4;
			let offset;
			if (atf > 1) {
				offset = start + 5 + data[start + 4];
				if (offset === start + PACKET_LENGTH) continue;
			} else offset = start + 4;
			switch (pid) {
				case videoPid:
					if (stt) {
						if (videoData && (pes = parsePES(videoData, this.logger))) {
							this.readyVideoParser(videoTrack.segmentCodec);
							if (this.videoParser !== null) this.videoParser.parsePES(videoTrack, textTrack, pes, false);
						}
						videoData = {
							data: [],
							size: 0
						};
					}
					if (videoData) {
						videoData.data.push(data.subarray(offset, start + PACKET_LENGTH));
						videoData.size += start + PACKET_LENGTH - offset;
					}
					break;
				case audioPid:
					if (stt) {
						if (audioData && (pes = parsePES(audioData, this.logger))) switch (audioTrack.segmentCodec) {
							case "aac":
								this.parseAACPES(audioTrack, pes);
								break;
							case "mp3":
								this.parseMPEGPES(audioTrack, pes);
								break;
							case "ac3":
								this.parseAC3PES(audioTrack, pes);
								break;
						}
						audioData = {
							data: [],
							size: 0
						};
					}
					if (audioData) {
						audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
						audioData.size += start + PACKET_LENGTH - offset;
					}
					break;
				case id3Pid:
					if (stt) {
						if (id3Data && (pes = parsePES(id3Data, this.logger))) this.parseID3PES(id3Track, pes);
						id3Data = {
							data: [],
							size: 0
						};
					}
					if (id3Data) {
						id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
						id3Data.size += start + PACKET_LENGTH - offset;
					}
					break;
				case 0:
					if (stt) offset += data[offset] + 1;
					pmtId = this._pmtId = parsePAT(data, offset);
					break;
				case pmtId: {
					if (stt) offset += data[offset] + 1;
					const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer, this.logger);
					videoPid = parsedPIDs.videoPid;
					if (videoPid > 0) {
						videoTrack.pid = videoPid;
						videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
					}
					audioPid = parsedPIDs.audioPid;
					if (audioPid > 0) {
						audioTrack.pid = audioPid;
						audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
					}
					id3Pid = parsedPIDs.id3Pid;
					if (id3Pid > 0) id3Track.pid = id3Pid;
					if (unknownPID !== null && !pmtParsed) {
						this.logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
						unknownPID = null;
						start = syncOffset - 188;
					}
					pmtParsed = this.pmtParsed = true;
					break;
				}
				case 17:
				case 8191: break;
				default:
					unknownPID = pid;
					break;
			}
		} else tsPacketErrors++;
		if (tsPacketErrors > 0) emitParsingError(this.observer, /* @__PURE__ */ new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`), void 0, this.logger);
		videoTrack.pesData = videoData;
		audioTrack.pesData = audioData;
		id3Track.pesData = id3Data;
		const demuxResult = {
			audioTrack,
			videoTrack,
			id3Track,
			textTrack
		};
		if (flush) this.extractRemainingSamples(demuxResult);
		return demuxResult;
	}
	flush() {
		const { remainderData } = this;
		this.remainderData = null;
		let result;
		if (remainderData) result = this.demux(remainderData, -1, false, true);
		else result = {
			videoTrack: this._videoTrack,
			audioTrack: this._audioTrack,
			id3Track: this._id3Track,
			textTrack: this._txtTrack
		};
		this.extractRemainingSamples(result);
		if (this.sampleAes) return this.decrypt(result, this.sampleAes);
		return result;
	}
	extractRemainingSamples(demuxResult) {
		const { audioTrack, videoTrack, id3Track, textTrack } = demuxResult;
		const videoData = videoTrack.pesData;
		const audioData = audioTrack.pesData;
		const id3Data = id3Track.pesData;
		let pes;
		if (videoData && (pes = parsePES(videoData, this.logger))) {
			this.readyVideoParser(videoTrack.segmentCodec);
			if (this.videoParser !== null) {
				this.videoParser.parsePES(videoTrack, textTrack, pes, true);
				videoTrack.pesData = null;
			}
		} else videoTrack.pesData = videoData;
		if (audioData && (pes = parsePES(audioData, this.logger))) {
			switch (audioTrack.segmentCodec) {
				case "aac":
					this.parseAACPES(audioTrack, pes);
					break;
				case "mp3":
					this.parseMPEGPES(audioTrack, pes);
					break;
				case "ac3":
					this.parseAC3PES(audioTrack, pes);
					break;
			}
			audioTrack.pesData = null;
		} else {
			if (audioData != null && audioData.size) this.logger.log("last AAC PES packet truncated,might overlap between fragments");
			audioTrack.pesData = audioData;
		}
		if (id3Data && (pes = parsePES(id3Data, this.logger))) {
			this.parseID3PES(id3Track, pes);
			id3Track.pesData = null;
		} else id3Track.pesData = id3Data;
	}
	demuxSampleAes(data, keyData, timeOffset) {
		const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
		const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
		return this.decrypt(demuxResult, sampleAes);
	}
	readyVideoParser(codec) {
		if (this.videoParser === null) {
			if (codec === "avc") this.videoParser = new AvcVideoParser();
			else if (codec === "hevc") this.videoParser = new HevcVideoParser();
		}
	}
	decrypt(demuxResult, sampleAes) {
		return new Promise((resolve) => {
			const { audioTrack, videoTrack } = demuxResult;
			if (audioTrack.samples && audioTrack.segmentCodec === "aac") sampleAes.decryptAacSamples(audioTrack.samples, 0, () => {
				if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
					resolve(demuxResult);
				});
				else resolve(demuxResult);
			});
			else if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
				resolve(demuxResult);
			});
		});
	}
	destroy() {
		if (this.observer) this.observer.removeAllListeners();
		this.config = this.logger = this.observer = null;
		this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null;
		this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = void 0;
	}
	parseAACPES(track, pes) {
		let startOffset = 0;
		const aacOverFlow = this.aacOverFlow;
		let data = pes.data;
		if (aacOverFlow) {
			this.aacOverFlow = null;
			const frameMissingBytes = aacOverFlow.missing;
			const sampleLength = aacOverFlow.sample.unit.byteLength;
			if (frameMissingBytes === -1) data = appendUint8Array(aacOverFlow.sample.unit, data);
			else {
				const frameOverflowBytes = sampleLength - frameMissingBytes;
				aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
				track.samples.push(aacOverFlow.sample);
				startOffset = aacOverFlow.missing;
			}
		}
		let offset;
		let len;
		for (offset = startOffset, len = data.length; offset < len - 1; offset++) if (isHeader$1(data, offset)) break;
		if (offset !== startOffset) {
			let reason;
			const recoverable = offset < len - 1;
			if (recoverable) reason = `AAC PES did not start with ADTS header,offset:${offset}`;
			else reason = "No ADTS header found in AAC PES";
			emitParsingError(this.observer, new Error(reason), recoverable, this.logger);
			if (!recoverable) return;
		}
		initTrackConfig(track, this.observer, data, offset, this.audioCodec);
		let pts;
		if (pes.pts !== void 0) pts = pes.pts;
		else if (aacOverFlow) {
			const frameDuration = getFrameDuration(track.samplerate);
			pts = aacOverFlow.sample.pts + frameDuration;
		} else {
			this.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
			return;
		}
		let frameIndex = 0;
		let frame;
		while (offset < len) {
			frame = appendFrame$2(track, data, offset, pts, frameIndex);
			offset += frame.length;
			if (!frame.missing) {
				frameIndex++;
				for (; offset < len - 1; offset++) if (isHeader$1(data, offset)) break;
			} else {
				this.aacOverFlow = frame;
				break;
			}
		}
	}
	parseMPEGPES(track, pes) {
		const data = pes.data;
		const length = data.length;
		let frameIndex = 0;
		let offset = 0;
		const pts = pes.pts;
		if (pts === void 0) {
			this.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
			return;
		}
		while (offset < length) if (isHeader(data, offset)) {
			const frame = appendFrame$1(track, data, offset, pts, frameIndex);
			if (frame) {
				offset += frame.length;
				frameIndex++;
			} else break;
		} else offset++;
	}
	parseAC3PES(track, pes) {
		{
			const data = pes.data;
			const pts = pes.pts;
			if (pts === void 0) {
				this.logger.warn("[tsdemuxer]: AC3 PES unknown PTS");
				return;
			}
			const length = data.length;
			let frameIndex = 0;
			let offset = 0;
			let parsed;
			while (offset < length && (parsed = appendFrame(track, data, offset, pts, frameIndex++)) > 0) offset += parsed;
		}
	}
	parseID3PES(id3Track, pes) {
		if (pes.pts === void 0) {
			this.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
			return;
		}
		const id3Sample = _extends({}, pes, {
			type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
			duration: Number.POSITIVE_INFINITY
		});
		id3Track.samples.push(id3Sample);
	}
};
function parsePID(data, offset) {
	return ((data[offset + 1] & 31) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
	return (data[offset + 10] & 31) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes, observer, logger) {
	const result = {
		audioPid: -1,
		videoPid: -1,
		id3Pid: -1,
		segmentVideoCodec: "avc",
		segmentAudioCodec: "aac"
	};
	const sectionLength = (data[offset + 1] & 15) << 8 | data[offset + 2];
	const tableEnd = offset + 3 + sectionLength - 4;
	const programInfoLength = (data[offset + 10] & 15) << 8 | data[offset + 11];
	offset += 12 + programInfoLength;
	while (offset < tableEnd) {
		const pid = parsePID(data, offset);
		const esInfoLength = (data[offset + 3] & 15) << 8 | data[offset + 4];
		switch (data[offset]) {
			case 207: if (!isSampleAes) {
				logEncryptedSamplesFoundInUnencryptedStream("ADTS AAC", logger);
				break;
			}
			case 15:
				if (result.audioPid === -1) result.audioPid = pid;
				break;
			case 21:
				if (result.id3Pid === -1) result.id3Pid = pid;
				break;
			case 219: if (!isSampleAes) {
				logEncryptedSamplesFoundInUnencryptedStream("H.264", logger);
				break;
			}
			case 27:
				if (result.videoPid === -1) result.videoPid = pid;
				break;
			case 3:
			case 4:
				if (!typeSupported.mpeg && !typeSupported.mp3) logger.log("MPEG audio found, not supported in this browser");
				else if (result.audioPid === -1) {
					result.audioPid = pid;
					result.segmentAudioCodec = "mp3";
				}
				break;
			case 193: if (!isSampleAes) {
				logEncryptedSamplesFoundInUnencryptedStream("AC-3", logger);
				break;
			}
			case 129:
				if (!typeSupported.ac3) logger.log("AC-3 audio found, not supported in this browser");
				else if (result.audioPid === -1) {
					result.audioPid = pid;
					result.segmentAudioCodec = "ac3";
				}
				break;
			case 6:
				if (result.audioPid === -1 && esInfoLength > 0) {
					let parsePos = offset + 5;
					let remaining = esInfoLength;
					while (remaining > 2) {
						switch (data[parsePos]) {
							case 106:
								if (typeSupported.ac3 !== true) logger.log("AC-3 audio found, not supported in this browser for now");
								else {
									result.audioPid = pid;
									result.segmentAudioCodec = "ac3";
								}
								break;
						}
						const descriptorLen = data[parsePos + 1] + 2;
						parsePos += descriptorLen;
						remaining -= descriptorLen;
					}
				}
				break;
			case 194:
			case 135:
				emitParsingError(observer, /* @__PURE__ */ new Error("Unsupported EC-3 in M2TS found"), void 0, logger);
				return result;
			case 36:
				if (result.videoPid === -1) {
					result.videoPid = pid;
					result.segmentVideoCodec = "hevc";
					logger.log("HEVC in M2TS found");
				}
				break;
		}
		offset += esInfoLength + 5;
	}
	return result;
}
function emitParsingError(observer, error, levelRetry, logger) {
	logger.warn(`parsing error: ${error.message}`);
	observer.emit(Events.ERROR, Events.ERROR, {
		type: ErrorTypes.MEDIA_ERROR,
		details: ErrorDetails.FRAG_PARSING_ERROR,
		fatal: false,
		levelRetry,
		error,
		reason: error.message
	});
}
function logEncryptedSamplesFoundInUnencryptedStream(type, logger) {
	logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(stream, logger) {
	let i = 0;
	let frag;
	let pesLen;
	let pesHdrLen;
	let pesPts;
	let pesDts;
	const data = stream.data;
	if (!stream || stream.size === 0) return null;
	while (data[0].length < 19 && data.length > 1) {
		data[0] = appendUint8Array(data[0], data[1]);
		data.splice(1, 1);
	}
	frag = data[0];
	if ((frag[0] << 16) + (frag[1] << 8) + frag[2] === 1) {
		pesLen = (frag[4] << 8) + frag[5];
		if (pesLen && pesLen > stream.size - 6) return null;
		const pesFlags = frag[7];
		if (pesFlags & 192) {
			pesPts = (frag[9] & 14) * 536870912 + (frag[10] & 255) * 4194304 + (frag[11] & 254) * 16384 + (frag[12] & 255) * 128 + (frag[13] & 254) / 2;
			if (pesFlags & 64) {
				pesDts = (frag[14] & 14) * 536870912 + (frag[15] & 255) * 4194304 + (frag[16] & 254) * 16384 + (frag[17] & 255) * 128 + (frag[18] & 254) / 2;
				if (pesPts - pesDts > 60 * 9e4) {
					logger.warn(`${Math.round((pesPts - pesDts) / 9e4)}s delta between PTS and DTS, align them`);
					pesPts = pesDts;
				}
			} else pesDts = pesPts;
		}
		pesHdrLen = frag[8];
		let payloadStartOffset = pesHdrLen + 9;
		if (stream.size <= payloadStartOffset) return null;
		stream.size -= payloadStartOffset;
		const pesData = new Uint8Array(stream.size);
		for (let j = 0, dataLen = data.length; j < dataLen; j++) {
			frag = data[j];
			let len = frag.byteLength;
			if (payloadStartOffset) if (payloadStartOffset > len) {
				payloadStartOffset -= len;
				continue;
			} else {
				frag = frag.subarray(payloadStartOffset);
				len -= payloadStartOffset;
				payloadStartOffset = 0;
			}
			pesData.set(frag, i);
			i += len;
		}
		if (pesLen) pesLen -= pesHdrLen + 3;
		return {
			data: pesData,
			pts: pesPts,
			dts: pesDts,
			len: pesLen
		};
	}
	return null;
}
/**
*  AAC helper
*/
var AAC = class {
	static getSilentFrame(codec, channelCount) {
		switch (codec) {
			case "mp4a.40.2":
				if (channelCount === 1) return new Uint8Array([
					0,
					200,
					0,
					128,
					35,
					128
				]);
				else if (channelCount === 2) return new Uint8Array([
					33,
					0,
					73,
					144,
					2,
					25,
					0,
					35,
					128
				]);
				else if (channelCount === 3) return new Uint8Array([
					0,
					200,
					0,
					128,
					32,
					132,
					1,
					38,
					64,
					8,
					100,
					0,
					142
				]);
				else if (channelCount === 4) return new Uint8Array([
					0,
					200,
					0,
					128,
					32,
					132,
					1,
					38,
					64,
					8,
					100,
					0,
					128,
					44,
					128,
					8,
					2,
					56
				]);
				else if (channelCount === 5) return new Uint8Array([
					0,
					200,
					0,
					128,
					32,
					132,
					1,
					38,
					64,
					8,
					100,
					0,
					130,
					48,
					4,
					153,
					0,
					33,
					144,
					2,
					56
				]);
				else if (channelCount === 6) return new Uint8Array([
					0,
					200,
					0,
					128,
					32,
					132,
					1,
					38,
					64,
					8,
					100,
					0,
					130,
					48,
					4,
					153,
					0,
					33,
					144,
					2,
					0,
					178,
					0,
					32,
					8,
					224
				]);
				break;
			default:
				if (channelCount === 1) return new Uint8Array([
					1,
					64,
					34,
					128,
					163,
					78,
					230,
					128,
					186,
					8,
					0,
					0,
					0,
					28,
					6,
					241,
					193,
					10,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					94
				]);
				else if (channelCount === 2) return new Uint8Array([
					1,
					64,
					34,
					128,
					163,
					94,
					230,
					128,
					186,
					8,
					0,
					0,
					0,
					0,
					149,
					0,
					6,
					241,
					161,
					10,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					94
				]);
				else if (channelCount === 3) return new Uint8Array([
					1,
					64,
					34,
					128,
					163,
					94,
					230,
					128,
					186,
					8,
					0,
					0,
					0,
					0,
					149,
					0,
					6,
					241,
					161,
					10,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					90,
					94
				]);
				break;
		}
	}
};
/**
* Generate MP4 Box
*/
var UINT32_MAX = Math.pow(2, 32) - 1;
var MP4 = class MP4 {
	static init() {
		MP4.types = {
			avc1: [],
			avcC: [],
			hvc1: [],
			hvcC: [],
			btrt: [],
			dinf: [],
			dref: [],
			esds: [],
			ftyp: [],
			hdlr: [],
			mdat: [],
			mdhd: [],
			mdia: [],
			mfhd: [],
			minf: [],
			moof: [],
			moov: [],
			mp4a: [],
			".mp3": [],
			dac3: [],
			"ac-3": [],
			mvex: [],
			mvhd: [],
			pasp: [],
			sdtp: [],
			stbl: [],
			stco: [],
			stsc: [],
			stsd: [],
			stsz: [],
			stts: [],
			tfdt: [],
			tfhd: [],
			traf: [],
			trak: [],
			trun: [],
			trex: [],
			tkhd: [],
			vmhd: [],
			smhd: []
		};
		let i;
		for (i in MP4.types) if (MP4.types.hasOwnProperty(i)) MP4.types[i] = [
			i.charCodeAt(0),
			i.charCodeAt(1),
			i.charCodeAt(2),
			i.charCodeAt(3)
		];
		MP4.HDLR_TYPES = {
			video: new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				118,
				105,
				100,
				101,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				86,
				105,
				100,
				101,
				111,
				72,
				97,
				110,
				100,
				108,
				101,
				114,
				0
			]),
			audio: new Uint8Array([
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				115,
				111,
				117,
				110,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				83,
				111,
				117,
				110,
				100,
				72,
				97,
				110,
				100,
				108,
				101,
				114,
				0
			])
		};
		const dref = new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			12,
			117,
			114,
			108,
			32,
			0,
			0,
			0,
			1
		]);
		MP4.STTS = MP4.STSC = MP4.STCO = new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		]);
		MP4.STSZ = new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		]);
		MP4.VMHD = new Uint8Array([
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		]);
		MP4.SMHD = new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		]);
		MP4.STSD = new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1
		]);
		const majorBrand = new Uint8Array([
			105,
			115,
			111,
			109
		]);
		const avc1Brand = new Uint8Array([
			97,
			118,
			99,
			49
		]);
		const minorVersion = new Uint8Array([
			0,
			0,
			0,
			1
		]);
		MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
		MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
	}
	static box(type, ...payload) {
		let size = 8;
		let i = payload.length;
		const len = i;
		while (i--) size += payload[i].byteLength;
		const result = new Uint8Array(size);
		result[0] = size >> 24 & 255;
		result[1] = size >> 16 & 255;
		result[2] = size >> 8 & 255;
		result[3] = size & 255;
		result.set(type, 4);
		for (i = 0, size = 8; i < len; i++) {
			result.set(payload[i], size);
			size += payload[i].byteLength;
		}
		return result;
	}
	static hdlr(type) {
		return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
	}
	static mdat(data) {
		return MP4.box(MP4.types.mdat, data);
	}
	static mdhd(timescale, duration) {
		duration *= timescale;
		const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
		const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
		return MP4.box(MP4.types.mdhd, new Uint8Array([
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3,
			timescale >> 24 & 255,
			timescale >> 16 & 255,
			timescale >> 8 & 255,
			timescale & 255,
			upperWordDuration >> 24,
			upperWordDuration >> 16 & 255,
			upperWordDuration >> 8 & 255,
			upperWordDuration & 255,
			lowerWordDuration >> 24,
			lowerWordDuration >> 16 & 255,
			lowerWordDuration >> 8 & 255,
			lowerWordDuration & 255,
			85,
			196,
			0,
			0
		]));
	}
	static mdia(track) {
		return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale || 0, track.duration || 0), MP4.hdlr(track.type), MP4.minf(track));
	}
	static mfhd(sequenceNumber) {
		return MP4.box(MP4.types.mfhd, new Uint8Array([
			0,
			0,
			0,
			0,
			sequenceNumber >> 24,
			sequenceNumber >> 16 & 255,
			sequenceNumber >> 8 & 255,
			sequenceNumber & 255
		]));
	}
	static minf(track) {
		if (track.type === "audio") return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
		else return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
	}
	static moof(sn, baseMediaDecodeTime, track) {
		return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
	}
	static moov(tracks) {
		let i = tracks.length;
		const boxes = [];
		while (i--) boxes[i] = MP4.trak(tracks[i]);
		return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale || 0, tracks[0].duration || 0)].concat(boxes).concat(MP4.mvex(tracks)));
	}
	static mvex(tracks) {
		let i = tracks.length;
		const boxes = [];
		while (i--) boxes[i] = MP4.trex(tracks[i]);
		return MP4.box.apply(null, [MP4.types.mvex, ...boxes]);
	}
	static mvhd(timescale, duration) {
		duration *= timescale;
		const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
		const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
		const bytes = new Uint8Array([
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3,
			timescale >> 24 & 255,
			timescale >> 16 & 255,
			timescale >> 8 & 255,
			timescale & 255,
			upperWordDuration >> 24,
			upperWordDuration >> 16 & 255,
			upperWordDuration >> 8 & 255,
			upperWordDuration & 255,
			lowerWordDuration >> 24,
			lowerWordDuration >> 16 & 255,
			lowerWordDuration >> 8 & 255,
			lowerWordDuration & 255,
			0,
			1,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			64,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			255,
			255,
			255,
			255
		]);
		return MP4.box(MP4.types.mvhd, bytes);
	}
	static sdtp(track) {
		const samples = track.samples || [];
		const bytes = new Uint8Array(4 + samples.length);
		let i;
		let flags;
		for (i = 0; i < samples.length; i++) {
			flags = samples[i].flags;
			bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
		}
		return MP4.box(MP4.types.sdtp, bytes);
	}
	static stbl(track) {
		return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
	}
	static avc1(track) {
		let sps = [];
		let pps = [];
		let i;
		let data;
		let len;
		for (i = 0; i < track.sps.length; i++) {
			data = track.sps[i];
			len = data.byteLength;
			sps.push(len >>> 8 & 255);
			sps.push(len & 255);
			sps = sps.concat(Array.prototype.slice.call(data));
		}
		for (i = 0; i < track.pps.length; i++) {
			data = track.pps[i];
			len = data.byteLength;
			pps.push(len >>> 8 & 255);
			pps.push(len & 255);
			pps = pps.concat(Array.prototype.slice.call(data));
		}
		const avcc = MP4.box(MP4.types.avcC, new Uint8Array([
			1,
			sps[3],
			sps[4],
			sps[5],
			255,
			224 | track.sps.length
		].concat(sps).concat([track.pps.length]).concat(pps)));
		const width = track.width;
		const height = track.height;
		const hSpacing = track.pixelRatio[0];
		const vSpacing = track.pixelRatio[1];
		return MP4.box(MP4.types.avc1, new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			width >> 8 & 255,
			width & 255,
			height >> 8 & 255,
			height & 255,
			0,
			72,
			0,
			0,
			0,
			72,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			18,
			100,
			97,
			105,
			108,
			121,
			109,
			111,
			116,
			105,
			111,
			110,
			47,
			104,
			108,
			115,
			46,
			106,
			115,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			24,
			17,
			17
		]), avcc, MP4.box(MP4.types.btrt, new Uint8Array([
			0,
			28,
			156,
			128,
			0,
			45,
			198,
			192,
			0,
			45,
			198,
			192
		])), MP4.box(MP4.types.pasp, new Uint8Array([
			hSpacing >> 24,
			hSpacing >> 16 & 255,
			hSpacing >> 8 & 255,
			hSpacing & 255,
			vSpacing >> 24,
			vSpacing >> 16 & 255,
			vSpacing >> 8 & 255,
			vSpacing & 255
		])));
	}
	static esds(track) {
		const config = track.config;
		return new Uint8Array([
			0,
			0,
			0,
			0,
			3,
			25,
			0,
			1,
			0,
			4,
			17,
			64,
			21,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5,
			2,
			...config,
			6,
			1,
			2
		]);
	}
	static audioStsd(track) {
		const samplerate = track.samplerate || 0;
		return new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			track.channelCount || 0,
			0,
			16,
			0,
			0,
			0,
			0,
			samplerate >> 8 & 255,
			samplerate & 255,
			0,
			0
		]);
	}
	static mp4a(track) {
		return MP4.box(MP4.types.mp4a, MP4.audioStsd(track), MP4.box(MP4.types.esds, MP4.esds(track)));
	}
	static mp3(track) {
		return MP4.box(MP4.types[".mp3"], MP4.audioStsd(track));
	}
	static ac3(track) {
		return MP4.box(MP4.types["ac-3"], MP4.audioStsd(track), MP4.box(MP4.types.dac3, track.config));
	}
	static stsd(track) {
		const { segmentCodec } = track;
		if (track.type === "audio") {
			if (segmentCodec === "aac") return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
			if (segmentCodec === "ac3" && track.config) return MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(track));
			if (segmentCodec === "mp3" && track.codec === "mp3") return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
		} else if (track.pps && track.sps) {
			if (segmentCodec === "avc") return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
			if (segmentCodec === "hevc" && track.vps) return MP4.box(MP4.types.stsd, MP4.STSD, MP4.hvc1(track));
		} else throw new Error(`video track missing pps or sps`);
		throw new Error(`unsupported ${track.type} segment codec (${segmentCodec}/${track.codec})`);
	}
	static tkhd(track) {
		const id = track.id;
		const duration = (track.duration || 0) * (track.timescale || 0);
		const width = track.width || 0;
		const height = track.height || 0;
		const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
		const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
		return MP4.box(MP4.types.tkhd, new Uint8Array([
			1,
			0,
			0,
			7,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3,
			id >> 24 & 255,
			id >> 16 & 255,
			id >> 8 & 255,
			id & 255,
			0,
			0,
			0,
			0,
			upperWordDuration >> 24,
			upperWordDuration >> 16 & 255,
			upperWordDuration >> 8 & 255,
			upperWordDuration & 255,
			lowerWordDuration >> 24,
			lowerWordDuration >> 16 & 255,
			lowerWordDuration >> 8 & 255,
			lowerWordDuration & 255,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			64,
			0,
			0,
			0,
			width >> 8 & 255,
			width & 255,
			0,
			0,
			height >> 8 & 255,
			height & 255,
			0,
			0
		]));
	}
	static traf(track, baseMediaDecodeTime) {
		const sampleDependencyTable = MP4.sdtp(track);
		const id = track.id;
		const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
		const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
		return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([
			0,
			0,
			0,
			0,
			id >> 24,
			id >> 16 & 255,
			id >> 8 & 255,
			id & 255
		])), MP4.box(MP4.types.tfdt, new Uint8Array([
			1,
			0,
			0,
			0,
			upperWordBaseMediaDecodeTime >> 24,
			upperWordBaseMediaDecodeTime >> 16 & 255,
			upperWordBaseMediaDecodeTime >> 8 & 255,
			upperWordBaseMediaDecodeTime & 255,
			lowerWordBaseMediaDecodeTime >> 24,
			lowerWordBaseMediaDecodeTime >> 16 & 255,
			lowerWordBaseMediaDecodeTime >> 8 & 255,
			lowerWordBaseMediaDecodeTime & 255
		])), MP4.trun(track, sampleDependencyTable.length + 16 + 20 + 8 + 16 + 8 + 8), sampleDependencyTable);
	}
	/**
	* Generate a track box.
	* @param track a track definition
	*/
	static trak(track) {
		track.duration = track.duration || 4294967295;
		return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
	}
	static trex(track) {
		const id = track.id;
		return MP4.box(MP4.types.trex, new Uint8Array([
			0,
			0,
			0,
			0,
			id >> 24,
			id >> 16 & 255,
			id >> 8 & 255,
			id & 255,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			1
		]));
	}
	static trun(track, offset) {
		const samples = track.samples || [];
		const len = samples.length;
		const arraylen = 12 + 16 * len;
		const array = new Uint8Array(arraylen);
		let i;
		let sample;
		let duration;
		let size;
		let flags;
		let cts;
		offset += 8 + arraylen;
		array.set([
			track.type === "video" ? 1 : 0,
			0,
			15,
			1,
			len >>> 24 & 255,
			len >>> 16 & 255,
			len >>> 8 & 255,
			len & 255,
			offset >>> 24 & 255,
			offset >>> 16 & 255,
			offset >>> 8 & 255,
			offset & 255
		], 0);
		for (i = 0; i < len; i++) {
			sample = samples[i];
			duration = sample.duration;
			size = sample.size;
			flags = sample.flags;
			cts = sample.cts;
			array.set([
				duration >>> 24 & 255,
				duration >>> 16 & 255,
				duration >>> 8 & 255,
				duration & 255,
				size >>> 24 & 255,
				size >>> 16 & 255,
				size >>> 8 & 255,
				size & 255,
				flags.isLeading << 2 | flags.dependsOn,
				flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
				flags.degradPrio & 61440,
				flags.degradPrio & 15,
				cts >>> 24 & 255,
				cts >>> 16 & 255,
				cts >>> 8 & 255,
				cts & 255
			], 12 + 16 * i);
		}
		return MP4.box(MP4.types.trun, array);
	}
	static initSegment(tracks) {
		if (!MP4.types) MP4.init();
		const movie = MP4.moov(tracks);
		return appendUint8Array(MP4.FTYP, movie);
	}
	static hvc1(track) {
		const ps = track.params;
		const units = [
			track.vps,
			track.sps,
			track.pps
		];
		const config = new Uint8Array([
			1,
			ps.general_profile_space << 6 | (ps.general_tier_flag ? 32 : 0) | ps.general_profile_idc,
			ps.general_profile_compatibility_flags[0],
			ps.general_profile_compatibility_flags[1],
			ps.general_profile_compatibility_flags[2],
			ps.general_profile_compatibility_flags[3],
			ps.general_constraint_indicator_flags[0],
			ps.general_constraint_indicator_flags[1],
			ps.general_constraint_indicator_flags[2],
			ps.general_constraint_indicator_flags[3],
			ps.general_constraint_indicator_flags[4],
			ps.general_constraint_indicator_flags[5],
			ps.general_level_idc,
			240 | ps.min_spatial_segmentation_idc >> 8,
			255 & ps.min_spatial_segmentation_idc,
			252 | ps.parallelismType,
			252 | ps.chroma_format_idc,
			248 | ps.bit_depth_luma_minus8,
			248 | ps.bit_depth_chroma_minus8,
			0,
			parseInt(ps.frame_rate.fps),
			3 | ps.temporal_id_nested << 2 | ps.num_temporal_layers << 3 | (ps.frame_rate.fixed ? 64 : 0),
			units.length
		]);
		let length = config.length;
		for (let i = 0; i < units.length; i += 1) {
			length += 3;
			for (let j = 0; j < units[i].length; j += 1) length += 2 + units[i][j].length;
		}
		const hvcC = new Uint8Array(length);
		hvcC.set(config, 0);
		length = config.length;
		const iMax = units.length - 1;
		for (let i = 0; i < units.length; i += 1) {
			hvcC.set(new Uint8Array([
				32 + i | (i === iMax ? 128 : 0),
				0,
				units[i].length
			]), length);
			length += 3;
			for (let j = 0; j < units[i].length; j += 1) {
				hvcC.set(new Uint8Array([units[i][j].length >> 8, units[i][j].length & 255]), length);
				length += 2;
				hvcC.set(units[i][j], length);
				length += units[i][j].length;
			}
		}
		const hvcc = MP4.box(MP4.types.hvcC, hvcC);
		const width = track.width;
		const height = track.height;
		const hSpacing = track.pixelRatio[0];
		const vSpacing = track.pixelRatio[1];
		return MP4.box(MP4.types.hvc1, new Uint8Array([
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			width >> 8 & 255,
			width & 255,
			height >> 8 & 255,
			height & 255,
			0,
			72,
			0,
			0,
			0,
			72,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1,
			18,
			100,
			97,
			105,
			108,
			121,
			109,
			111,
			116,
			105,
			111,
			110,
			47,
			104,
			108,
			115,
			46,
			106,
			115,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			24,
			17,
			17
		]), hvcc, MP4.box(MP4.types.btrt, new Uint8Array([
			0,
			28,
			156,
			128,
			0,
			45,
			198,
			192,
			0,
			45,
			198,
			192
		])), MP4.box(MP4.types.pasp, new Uint8Array([
			hSpacing >> 24,
			hSpacing >> 16 & 255,
			hSpacing >> 8 & 255,
			hSpacing & 255,
			vSpacing >> 24,
			vSpacing >> 16 & 255,
			vSpacing >> 8 & 255,
			vSpacing & 255
		])));
	}
};
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;
var MPEG_TS_CLOCK_FREQ_HZ = 9e4;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
	const result = baseTime * destScale * srcBase;
	return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
	return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
	return toTimescaleFromBase(baseTime, 1e3, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
	return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}
function timestampToString(timestamp) {
	const { baseTime, timescale, trackId } = timestamp;
	return `${baseTime / timescale} (${baseTime}/${timescale}) trackId: ${trackId}`;
}
var MAX_SILENT_FRAME_DURATION = 10 * 1e3;
var AAC_SAMPLES_PER_FRAME = 1024;
var MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
var AC3_SAMPLES_PER_FRAME = 1536;
var chromeVersion = null;
var safariWebkitVersion = null;
function createMp4Sample(isKeyframe, duration, size, cts) {
	return {
		duration,
		size,
		cts,
		flags: {
			isLeading: 0,
			isDependedOn: 0,
			hasRedundancy: 0,
			degradPrio: 0,
			dependsOn: isKeyframe ? 2 : 1,
			isNonSync: isKeyframe ? 0 : 1
		}
	};
}
var MP4Remuxer = class extends Logger {
	constructor(observer, config, typeSupported, logger) {
		super("mp4-remuxer", logger);
		this.observer = void 0;
		this.config = void 0;
		this.typeSupported = void 0;
		this.ISGenerated = false;
		this._initPTS = null;
		this._initDTS = null;
		this.nextVideoTs = null;
		this.nextAudioTs = null;
		this.videoSampleDuration = null;
		this.isAudioContiguous = false;
		this.isVideoContiguous = false;
		this.videoTrackConfig = void 0;
		this.observer = observer;
		this.config = config;
		this.typeSupported = typeSupported;
		this.ISGenerated = false;
		if (chromeVersion === null) {
			const result = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
			chromeVersion = result ? parseInt(result[1]) : 0;
		}
		if (safariWebkitVersion === null) {
			const result = navigator.userAgent.match(/Safari\/(\d+)/i);
			safariWebkitVersion = result ? parseInt(result[1]) : 0;
		}
	}
	destroy() {
		this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
	}
	resetTimeStamp(defaultTimeStamp) {
		const initPTS = this._initPTS;
		if (!initPTS || !defaultTimeStamp || defaultTimeStamp.trackId !== initPTS.trackId || defaultTimeStamp.baseTime !== initPTS.baseTime || defaultTimeStamp.timescale !== initPTS.timescale) this.log(`Reset initPTS: ${initPTS ? timestampToString(initPTS) : initPTS} > ${defaultTimeStamp ? timestampToString(defaultTimeStamp) : defaultTimeStamp}`);
		this._initPTS = this._initDTS = defaultTimeStamp;
	}
	resetNextTimestamp() {
		this.log("reset next timestamp");
		this.isVideoContiguous = false;
		this.isAudioContiguous = false;
	}
	resetInitSegment() {
		this.log("ISGenerated flag reset");
		this.ISGenerated = false;
		this.videoTrackConfig = void 0;
	}
	getVideoStartPts(videoSamples) {
		let rolloverDetected = false;
		const firstPts = videoSamples[0].pts;
		const startPTS = videoSamples.reduce((minPTS, sample) => {
			let pts = sample.pts;
			let delta = pts - minPTS;
			if (delta < -4294967296) {
				rolloverDetected = true;
				pts = normalizePts(pts, firstPts);
				delta = pts - minPTS;
			}
			if (delta > 0) return minPTS;
			return pts;
		}, firstPts);
		if (rolloverDetected) this.debug("PTS rollover detected");
		return startPTS;
	}
	remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
		let video;
		let audio;
		let initSegment;
		let text;
		let id3;
		let independent;
		let audioTimeOffset = timeOffset;
		let videoTimeOffset = timeOffset;
		const hasAudio = audioTrack.pid > -1;
		const hasVideo = videoTrack.pid > -1;
		const length = videoTrack.samples.length;
		const enoughAudioSamples = audioTrack.samples.length > 0;
		const enoughVideoSamples = flush && length > 0 || length > 1;
		if ((!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush) {
			if (this.ISGenerated) {
				var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
				const config = this.videoTrackConfig;
				if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1])) || !config && enoughVideoSamples || this.nextAudioTs === null && enoughAudioSamples) this.resetInitSegment();
			}
			if (!this.ISGenerated) initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
			const isVideoContiguous = this.isVideoContiguous;
			let firstKeyFrameIndex = -1;
			let firstKeyFramePTS;
			if (enoughVideoSamples) {
				firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
				if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
					independent = true;
					if (firstKeyFrameIndex > 0) {
						this.warn(`Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
						const startPTS = this.getVideoStartPts(videoTrack.samples);
						videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
						videoTrack.dropped += firstKeyFrameIndex;
						videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
						firstKeyFramePTS = videoTimeOffset;
					} else if (firstKeyFrameIndex === -1) {
						this.warn(`No keyframe found out of ${length} video samples`);
						independent = false;
					}
				}
			}
			if (this.ISGenerated) {
				if (enoughAudioSamples && enoughVideoSamples) {
					const startPTS = this.getVideoStartPts(videoTrack.samples);
					const audiovideoTimestampDelta = (normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS) / videoTrack.inputTimeScale;
					audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
					videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
				}
				if (enoughAudioSamples) {
					if (!audioTrack.samplerate) {
						this.warn("regenerate InitSegment as audio detected");
						initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
					}
					audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : void 0);
					if (enoughVideoSamples) {
						const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
						if (!videoTrack.inputTimeScale) {
							this.warn("regenerate InitSegment as video detected");
							initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
						}
						video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
					}
				} else if (enoughVideoSamples) video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
				if (video) {
					video.firstKeyFrame = firstKeyFrameIndex;
					video.independent = firstKeyFrameIndex !== -1;
					video.firstKeyFramePTS = firstKeyFramePTS;
				}
			}
		}
		if (this.ISGenerated && this._initPTS && this._initDTS) {
			if (id3Track.samples.length) id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
			if (textTrack.samples.length) text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
		}
		return {
			audio,
			video,
			initSegment,
			independent,
			text,
			id3
		};
	}
	computeInitPts(basetime, timescale, presentationTime, type) {
		const offset = Math.round(presentationTime * timescale);
		let timestamp = normalizePts(basetime, offset);
		if (timestamp < offset + timescale) {
			this.log(`Adjusting PTS for rollover in timeline near ${(offset - timestamp) / timescale} ${type}`);
			while (timestamp < offset + timescale) timestamp += 8589934592;
		}
		return timestamp - offset;
	}
	generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
		const audioSamples = audioTrack.samples;
		const videoSamples = videoTrack.samples;
		const typeSupported = this.typeSupported;
		const tracks = {};
		const _initPTS = this._initPTS;
		let computePTSDTS = !_initPTS || accurateTimeOffset;
		let container = "audio/mp4";
		let initPTS;
		let initDTS;
		let timescale;
		let trackId = -1;
		if (computePTSDTS) initPTS = initDTS = Infinity;
		if (audioTrack.config && audioSamples.length) {
			audioTrack.timescale = audioTrack.samplerate;
			switch (audioTrack.segmentCodec) {
				case "mp3":
					if (typeSupported.mpeg) {
						container = "audio/mpeg";
						audioTrack.codec = "";
					} else if (typeSupported.mp3) audioTrack.codec = "mp3";
					break;
				case "ac3":
					audioTrack.codec = "ac-3";
					break;
			}
			tracks.audio = {
				id: "audio",
				container,
				codec: audioTrack.codec,
				initSegment: audioTrack.segmentCodec === "mp3" && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([audioTrack]),
				metadata: { channelCount: audioTrack.channelCount }
			};
			if (computePTSDTS) {
				trackId = audioTrack.id;
				timescale = audioTrack.inputTimeScale;
				if (!_initPTS || timescale !== _initPTS.timescale) initPTS = initDTS = this.computeInitPts(audioSamples[0].pts, timescale, timeOffset, "audio");
				else computePTSDTS = false;
			}
		}
		if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
			videoTrack.timescale = videoTrack.inputTimeScale;
			tracks.video = {
				id: "main",
				container: "video/mp4",
				codec: videoTrack.codec,
				initSegment: MP4.initSegment([videoTrack]),
				metadata: {
					width: videoTrack.width,
					height: videoTrack.height
				}
			};
			if (computePTSDTS) {
				trackId = videoTrack.id;
				timescale = videoTrack.inputTimeScale;
				if (!_initPTS || timescale !== _initPTS.timescale) {
					const basePTS = this.getVideoStartPts(videoSamples);
					const baseDTS = normalizePts(videoSamples[0].dts, basePTS);
					const videoInitDTS = this.computeInitPts(baseDTS, timescale, timeOffset, "video");
					const videoInitPTS = this.computeInitPts(basePTS, timescale, timeOffset, "video");
					initDTS = Math.min(initDTS, videoInitDTS);
					initPTS = Math.min(initPTS, videoInitPTS);
				} else computePTSDTS = false;
			}
			this.videoTrackConfig = {
				width: videoTrack.width,
				height: videoTrack.height,
				pixelRatio: videoTrack.pixelRatio
			};
		}
		if (Object.keys(tracks).length) {
			this.ISGenerated = true;
			if (computePTSDTS) {
				if (_initPTS) this.warn(`Timestamps at playlist time: ${accurateTimeOffset ? "" : "~"}${timeOffset} ${initPTS / timescale} != initPTS: ${_initPTS.baseTime / _initPTS.timescale} (${_initPTS.baseTime}/${_initPTS.timescale}) trackId: ${_initPTS.trackId}`);
				this.log(`Found initPTS at playlist time: ${timeOffset} offset: ${initPTS / timescale} (${initPTS}/${timescale}) trackId: ${trackId}`);
				this._initPTS = {
					baseTime: initPTS,
					timescale,
					trackId
				};
				this._initDTS = {
					baseTime: initDTS,
					timescale,
					trackId
				};
			} else initPTS = timescale = void 0;
			return {
				tracks,
				initPTS,
				timescale,
				trackId
			};
		}
	}
	remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
		const timeScale = track.inputTimeScale;
		const inputSamples = track.samples;
		const outputSamples = [];
		const nbSamples = inputSamples.length;
		const initPTS = this._initPTS;
		const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
		let nextVideoTs = this.nextVideoTs;
		let offset = 8;
		let mp4SampleDuration = this.videoSampleDuration;
		let firstDTS;
		let lastDTS;
		let minPTS = Number.POSITIVE_INFINITY;
		let maxPTS = Number.NEGATIVE_INFINITY;
		let sortSamples = false;
		if (!contiguous || nextVideoTs === null) {
			const pts = initTime + timeOffset * timeScale;
			const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
			if (chromeVersion && nextVideoTs !== null && Math.abs(pts - cts - (nextVideoTs + initTime)) < 15e3) contiguous = true;
			else nextVideoTs = pts - cts - initTime;
		}
		const nextVideoPts = nextVideoTs + initTime;
		for (let i = 0; i < nbSamples; i++) {
			const sample = inputSamples[i];
			sample.pts = normalizePts(sample.pts, nextVideoPts);
			sample.dts = normalizePts(sample.dts, nextVideoPts);
			if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) sortSamples = true;
		}
		if (sortSamples) inputSamples.sort(function(a, b) {
			const deltadts = a.dts - b.dts;
			const deltapts = a.pts - b.pts;
			return deltadts || deltapts;
		});
		firstDTS = inputSamples[0].dts;
		lastDTS = inputSamples[inputSamples.length - 1].dts;
		const inputDuration = lastDTS - firstDTS;
		const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;
		if (contiguous) {
			const delta = firstDTS - nextVideoPts;
			const foundHole = delta > averageSampleDuration;
			const foundOverlap = delta < -1;
			if (foundHole || foundOverlap) {
				if (foundHole) this.warn(`${(track.segmentCodec || "").toUpperCase()}: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
				else this.warn(`${(track.segmentCodec || "").toUpperCase()}: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
				if (!foundOverlap || nextVideoPts >= inputSamples[0].pts || chromeVersion) {
					firstDTS = nextVideoPts;
					const firstPTS = inputSamples[0].pts - delta;
					if (foundHole) {
						inputSamples[0].dts = firstDTS;
						inputSamples[0].pts = firstPTS;
					} else {
						let isPTSOrderRetained = true;
						for (let i = 0; i < inputSamples.length; i++) {
							if (inputSamples[i].dts > firstPTS && isPTSOrderRetained) break;
							const prevPTS = inputSamples[i].pts;
							inputSamples[i].dts -= delta;
							inputSamples[i].pts -= delta;
							if (i < inputSamples.length - 1) {
								const nextSamplePTS = inputSamples[i + 1].pts;
								isPTSOrderRetained = nextSamplePTS <= inputSamples[i].pts == nextSamplePTS <= prevPTS;
							}
						}
					}
					this.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
				}
			}
		}
		firstDTS = Math.max(0, firstDTS);
		let nbNalu = 0;
		let naluLen = 0;
		let dtsStep = firstDTS;
		for (let i = 0; i < nbSamples; i++) {
			const sample = inputSamples[i];
			const units = sample.units;
			const nbUnits = units.length;
			let sampleLen = 0;
			for (let j = 0; j < nbUnits; j++) sampleLen += units[j].data.length;
			naluLen += sampleLen;
			nbNalu += nbUnits;
			sample.length = sampleLen;
			if (sample.dts < dtsStep) {
				sample.dts = dtsStep;
				dtsStep += averageSampleDuration / 4 | 0 || 1;
			} else dtsStep = sample.dts;
			minPTS = Math.min(sample.pts, minPTS);
			maxPTS = Math.max(sample.pts, maxPTS);
		}
		lastDTS = inputSamples[nbSamples - 1].dts;
		const mdatSize = naluLen + 4 * nbNalu + 8;
		let mdat;
		try {
			mdat = new Uint8Array(mdatSize);
		} catch (err) {
			this.observer.emit(Events.ERROR, Events.ERROR, {
				type: ErrorTypes.MUX_ERROR,
				details: ErrorDetails.REMUX_ALLOC_ERROR,
				fatal: false,
				error: err,
				bytes: mdatSize,
				reason: `fail allocating video mdat ${mdatSize}`
			});
			return;
		}
		const view = new DataView(mdat.buffer);
		view.setUint32(0, mdatSize);
		mdat.set(MP4.types.mdat, 4);
		let stretchedLastFrame = false;
		let minDtsDelta = Number.POSITIVE_INFINITY;
		let minPtsDelta = Number.POSITIVE_INFINITY;
		let maxDtsDelta = Number.NEGATIVE_INFINITY;
		let maxPtsDelta = Number.NEGATIVE_INFINITY;
		for (let i = 0; i < nbSamples; i++) {
			const VideoSample = inputSamples[i];
			const VideoSampleUnits = VideoSample.units;
			let mp4SampleLength = 0;
			for (let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++) {
				const unit = VideoSampleUnits[j];
				const unitData = unit.data;
				const unitDataLen = unit.data.byteLength;
				view.setUint32(offset, unitDataLen);
				offset += 4;
				mdat.set(unitData, offset);
				offset += unitDataLen;
				mp4SampleLength += 4 + unitDataLen;
			}
			let ptsDelta;
			if (i < nbSamples - 1) {
				mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
				ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
			} else {
				const config = this.config;
				const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
				ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
				if (config.stretchShortVideoTrack && this.nextAudioTs !== null) {
					const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
					const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioTs + initTime) - VideoSample.pts;
					if (deltaToFrameEnd > gapTolerance) {
						mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
						if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
						else stretchedLastFrame = true;
						this.log(`It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
					} else mp4SampleDuration = lastFrameDuration;
				} else mp4SampleDuration = lastFrameDuration;
			}
			const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
			minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
			maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
			minPtsDelta = Math.min(minPtsDelta, ptsDelta);
			maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
			outputSamples.push(createMp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
		}
		if (outputSamples.length) {
			if (chromeVersion) {
				if (chromeVersion < 70) {
					const flags = outputSamples[0].flags;
					flags.dependsOn = 2;
					flags.isNonSync = 0;
				}
			} else if (safariWebkitVersion) {
				if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < .025 && outputSamples[0].cts === 0) {
					this.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
					let dts = firstDTS;
					for (let i = 0, len = outputSamples.length; i < len; i++) {
						const nextDts = dts + outputSamples[i].duration;
						const pts = dts + outputSamples[i].cts;
						if (i < len - 1) {
							const nextPts = nextDts + outputSamples[i + 1].cts;
							outputSamples[i].duration = nextPts - pts;
						} else outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
						outputSamples[i].cts = 0;
						dts = nextDts;
					}
				}
			}
		}
		mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
		const endDTS = lastDTS + mp4SampleDuration;
		this.nextVideoTs = nextVideoTs = endDTS - initTime;
		this.videoSampleDuration = mp4SampleDuration;
		this.isVideoContiguous = true;
		const data = {
			data1: MP4.moof(track.sequenceNumber++, firstDTS, _extends(track, { samples: outputSamples })),
			data2: mdat,
			startPTS: (minPTS - initTime) / timeScale,
			endPTS: (maxPTS + mp4SampleDuration - initTime) / timeScale,
			startDTS: (firstDTS - initTime) / timeScale,
			endDTS: nextVideoTs / timeScale,
			type: "video",
			hasAudio: false,
			hasVideo: true,
			nb: outputSamples.length,
			dropped: track.dropped
		};
		track.samples = [];
		track.dropped = 0;
		return data;
	}
	getSamplesPerFrame(track) {
		switch (track.segmentCodec) {
			case "mp3": return MPEG_AUDIO_SAMPLE_PER_FRAME;
			case "ac3": return AC3_SAMPLES_PER_FRAME;
			default: return AAC_SAMPLES_PER_FRAME;
		}
	}
	remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
		const inputTimeScale = track.inputTimeScale;
		const scaleFactor = inputTimeScale / (track.samplerate ? track.samplerate : inputTimeScale);
		const mp4SampleDuration = this.getSamplesPerFrame(track);
		const inputSampleDuration = mp4SampleDuration * scaleFactor;
		const initPTS = this._initPTS;
		const rawMPEG = track.segmentCodec === "mp3" && this.typeSupported.mpeg;
		const outputSamples = [];
		const alignedWithVideo = videoTimeOffset !== void 0;
		let inputSamples = track.samples;
		let offset = rawMPEG ? 0 : 8;
		let nextAudioTs = this.nextAudioTs || -1;
		const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
		const timeOffsetMpegTS = initTime + timeOffset * inputTimeScale;
		this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioTs > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - (nextAudioTs + initTime)) < 9e3 || Math.abs(normalizePts(inputSamples[0].pts, timeOffsetMpegTS) - (nextAudioTs + initTime)) < 20 * inputSampleDuration);
		inputSamples.forEach(function(sample) {
			sample.pts = normalizePts(sample.pts, timeOffsetMpegTS);
		});
		if (!contiguous || nextAudioTs < 0) {
			const sampleCount = inputSamples.length;
			inputSamples = inputSamples.filter((sample) => sample.pts >= 0);
			if (sampleCount !== inputSamples.length) this.warn(`Removed ${inputSamples.length - sampleCount} of ${sampleCount} samples (initPTS ${initTime} / ${inputTimeScale})`);
			if (!inputSamples.length) return;
			if (videoTimeOffset === 0) nextAudioTs = 0;
			else if (accurateTimeOffset && !alignedWithVideo) nextAudioTs = Math.max(0, timeOffsetMpegTS - initTime);
			else nextAudioTs = inputSamples[0].pts - initTime;
		}
		if (track.segmentCodec === "aac") {
			const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
			for (let i = 0, nextPts = nextAudioTs + initTime; i < inputSamples.length; i++) {
				const sample = inputSamples[i];
				const pts = sample.pts;
				const delta = pts - nextPts;
				const duration = Math.abs(1e3 * delta / inputTimeScale);
				if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
					if (i === 0) {
						this.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps marker by ${Math.round(1e3 * delta / inputTimeScale)} ms.`);
						this.nextAudioTs = nextAudioTs = pts - initTime;
						nextPts = pts;
					}
				} else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
					let missing = Math.round(delta / inputSampleDuration);
					nextPts = pts - missing * inputSampleDuration;
					while (nextPts < 0 && missing && inputSampleDuration) {
						missing--;
						nextPts += inputSampleDuration;
					}
					if (i === 0) this.nextAudioTs = nextAudioTs = nextPts - initTime;
					this.warn(`Injecting ${missing} audio frames @ ${((nextPts - initTime) / inputTimeScale).toFixed(3)}s due to ${Math.round(1e3 * delta / inputTimeScale)} ms gap.`);
					for (let j = 0; j < missing; j++) {
						let fillFrame = AAC.getSilentFrame(track.parsedCodec || track.manifestCodec || track.codec, track.channelCount);
						if (!fillFrame) {
							this.log("Unable to get silent frame for given audio codec; duplicating last frame instead.");
							fillFrame = sample.unit.subarray();
						}
						inputSamples.splice(i, 0, {
							unit: fillFrame,
							pts: nextPts
						});
						nextPts += inputSampleDuration;
						i++;
					}
				}
				sample.pts = nextPts;
				nextPts += inputSampleDuration;
			}
		}
		let firstPTS = null;
		let lastPTS = null;
		let mdat;
		let mdatSize = 0;
		let sampleLength = inputSamples.length;
		while (sampleLength--) mdatSize += inputSamples[sampleLength].unit.byteLength;
		for (let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++) {
			const audioSample = inputSamples[j];
			const unit = audioSample.unit;
			let pts = audioSample.pts;
			if (lastPTS !== null) {
				const prevSample = outputSamples[j - 1];
				prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
			} else {
				if (contiguous && track.segmentCodec === "aac") pts = nextAudioTs + initTime;
				firstPTS = pts;
				if (mdatSize > 0) {
					mdatSize += offset;
					try {
						mdat = new Uint8Array(mdatSize);
					} catch (err) {
						this.observer.emit(Events.ERROR, Events.ERROR, {
							type: ErrorTypes.MUX_ERROR,
							details: ErrorDetails.REMUX_ALLOC_ERROR,
							fatal: false,
							error: err,
							bytes: mdatSize,
							reason: `fail allocating audio mdat ${mdatSize}`
						});
						return;
					}
					if (!rawMPEG) {
						new DataView(mdat.buffer).setUint32(0, mdatSize);
						mdat.set(MP4.types.mdat, 4);
					}
				} else return;
			}
			mdat.set(unit, offset);
			const unitLen = unit.byteLength;
			offset += unitLen;
			outputSamples.push(createMp4Sample(true, mp4SampleDuration, unitLen, 0));
			lastPTS = pts;
		}
		const nbSamples = outputSamples.length;
		if (!nbSamples) return;
		const lastSample = outputSamples[outputSamples.length - 1];
		nextAudioTs = lastPTS - initTime;
		this.nextAudioTs = nextAudioTs + scaleFactor * lastSample.duration;
		const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, { samples: outputSamples }));
		track.samples = [];
		const start = (firstPTS - initTime) / inputTimeScale;
		const end = this.nextAudioTs / inputTimeScale;
		const audioData = {
			data1: moof,
			data2: mdat,
			startPTS: start,
			endPTS: end,
			startDTS: start,
			endDTS: end,
			type: "audio",
			hasAudio: true,
			hasVideo: false,
			nb: nbSamples
		};
		this.isAudioContiguous = true;
		return audioData;
	}
};
function normalizePts(value, reference) {
	let offset;
	if (reference === null) return value;
	if (reference < value) offset = -8589934592;
	else offset = 8589934592;
	while (Math.abs(value - reference) > 4294967296) value += offset;
	return value;
}
function findKeyframeIndex(samples) {
	for (let i = 0; i < samples.length; i++) if (samples[i].key) return i;
	return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
	const length = track.samples.length;
	if (!length) return;
	const inputTimeScale = track.inputTimeScale;
	for (let index = 0; index < length; index++) {
		const sample = track.samples[index];
		sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
		sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
	}
	const samples = track.samples;
	track.samples = [];
	return { samples };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
	const length = track.samples.length;
	if (!length) return;
	const inputTimeScale = track.inputTimeScale;
	for (let index = 0; index < length; index++) {
		const sample = track.samples[index];
		sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
	}
	track.samples.sort((a, b) => a.pts - b.pts);
	const samples = track.samples;
	track.samples = [];
	return { samples };
}
var PassThroughRemuxer = class extends Logger {
	constructor(observer, config, typeSupported, logger) {
		super("passthrough-remuxer", logger);
		this.emitInitSegment = false;
		this.audioCodec = void 0;
		this.videoCodec = void 0;
		this.initData = void 0;
		this.initPTS = null;
		this.initTracks = void 0;
		this.lastEndTime = null;
		this.isVideoContiguous = false;
	}
	destroy() {}
	resetTimeStamp(defaultInitPTS) {
		this.lastEndTime = null;
		const initPTS = this.initPTS;
		if (initPTS && defaultInitPTS) {
			if (initPTS.baseTime === defaultInitPTS.baseTime && initPTS.timescale === defaultInitPTS.timescale) return;
		}
		this.initPTS = defaultInitPTS;
	}
	resetNextTimestamp() {
		this.isVideoContiguous = false;
		this.lastEndTime = null;
	}
	resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
		this.audioCodec = audioCodec;
		this.videoCodec = videoCodec;
		this.generateInitSegment(initSegment, decryptdata);
		this.emitInitSegment = true;
	}
	generateInitSegment(initSegment, decryptdata) {
		let { audioCodec, videoCodec } = this;
		if (!(initSegment != null && initSegment.byteLength)) {
			this.initTracks = void 0;
			this.initData = void 0;
			return;
		}
		const { audio, video } = this.initData = parseInitSegment(initSegment);
		if (decryptdata) patchEncyptionData(initSegment, decryptdata);
		else {
			const eitherTrack = audio || video;
			if (eitherTrack != null && eitherTrack.encrypted) this.warn(`Init segment with encrypted track with has no key ("${eitherTrack.codec}")!`);
		}
		if (audio) audioCodec = getParsedTrackCodec(audio, ElementaryStreamTypes.AUDIO, this);
		if (video) videoCodec = getParsedTrackCodec(video, ElementaryStreamTypes.VIDEO, this);
		const tracks = {};
		if (audio && video) tracks.audiovideo = {
			container: "video/mp4",
			codec: audioCodec + "," + videoCodec,
			supplemental: video.supplemental,
			encrypted: video.encrypted,
			initSegment,
			id: "main"
		};
		else if (audio) tracks.audio = {
			container: "audio/mp4",
			codec: audioCodec,
			encrypted: audio.encrypted,
			initSegment,
			id: "audio"
		};
		else if (video) tracks.video = {
			container: "video/mp4",
			codec: videoCodec,
			supplemental: video.supplemental,
			encrypted: video.encrypted,
			initSegment,
			id: "main"
		};
		else this.warn("initSegment does not contain moov or trak boxes.");
		this.initTracks = tracks;
	}
	remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
		var _initData, _initData2;
		let { initPTS, lastEndTime } = this;
		const result = {
			audio: void 0,
			video: void 0,
			text: textTrack,
			id3: id3Track,
			initSegment: void 0
		};
		if (!isFiniteNumber(lastEndTime)) lastEndTime = this.lastEndTime = timeOffset || 0;
		const data = videoTrack.samples;
		if (!data.length) return result;
		const initSegment = {
			initPTS: void 0,
			timescale: void 0,
			trackId: void 0
		};
		let initData = this.initData;
		if (!((_initData = initData) != null && _initData.length)) {
			this.generateInitSegment(data);
			initData = this.initData;
		}
		if (!((_initData2 = initData) != null && _initData2.length)) {
			this.warn("Failed to generate initSegment.");
			return result;
		}
		if (this.emitInitSegment) {
			initSegment.tracks = this.initTracks;
			this.emitInitSegment = false;
		}
		const trackSampleData = getSampleData(data, initData, this);
		const audioSampleTimestamps = initData.audio ? trackSampleData[initData.audio.id] : null;
		const videoSampleTimestamps = initData.video ? trackSampleData[initData.video.id] : null;
		const videoStartTime = toStartEndOrDefault(videoSampleTimestamps, Infinity);
		const audioStartTime = toStartEndOrDefault(audioSampleTimestamps, Infinity);
		const videoEndTime = toStartEndOrDefault(videoSampleTimestamps, 0, true);
		const audioEndTime = toStartEndOrDefault(audioSampleTimestamps, 0, true);
		let decodeTime = timeOffset;
		let duration = 0;
		const syncOnAudio = audioSampleTimestamps && (!videoSampleTimestamps || !initPTS && audioStartTime < videoStartTime || initPTS && initPTS.trackId === initData.audio.id);
		const baseOffsetSamples = syncOnAudio ? audioSampleTimestamps : videoSampleTimestamps;
		if (baseOffsetSamples) {
			const timescale = baseOffsetSamples.timescale;
			const baseTime = baseOffsetSamples.start - timeOffset * timescale;
			const trackId = syncOnAudio ? initData.audio.id : initData.video.id;
			decodeTime = baseOffsetSamples.start / timescale;
			duration = syncOnAudio ? audioEndTime - audioStartTime : videoEndTime - videoStartTime;
			if ((accurateTimeOffset || !initPTS) && (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || timescale !== initPTS.timescale)) {
				if (initPTS) this.warn(`Timestamps at playlist time: ${accurateTimeOffset ? "" : "~"}${timeOffset} ${baseTime / timescale} != initPTS: ${initPTS.baseTime / initPTS.timescale} (${initPTS.baseTime}/${initPTS.timescale}) trackId: ${initPTS.trackId}`);
				this.log(`Found initPTS at playlist time: ${timeOffset} offset: ${decodeTime - timeOffset} (${baseTime}/${timescale}) trackId: ${trackId}`);
				initPTS = null;
				initSegment.initPTS = baseTime;
				initSegment.timescale = timescale;
				initSegment.trackId = trackId;
			}
		} else this.warn(`No audio or video samples found for initPTS at playlist time: ${timeOffset}`);
		if (!initPTS) {
			if (!initSegment.timescale || initSegment.trackId === void 0 || initSegment.initPTS === void 0) {
				this.warn("Could not set initPTS");
				initSegment.initPTS = decodeTime;
				initSegment.timescale = 1;
				initSegment.trackId = -1;
			}
			this.initPTS = initPTS = {
				baseTime: initSegment.initPTS,
				timescale: initSegment.timescale,
				trackId: initSegment.trackId
			};
		} else {
			initSegment.initPTS = initPTS.baseTime;
			initSegment.timescale = initPTS.timescale;
			initSegment.trackId = initPTS.trackId;
		}
		const startTime = decodeTime - initPTS.baseTime / initPTS.timescale;
		const endTime = startTime + duration;
		if (duration > 0) this.lastEndTime = endTime;
		else {
			this.warn("Duration parsed from mp4 should be greater than zero");
			this.resetNextTimestamp();
		}
		const hasAudio = !!initData.audio;
		const hasVideo = !!initData.video;
		let type = "";
		if (hasAudio) type += "audio";
		if (hasVideo) type += "video";
		const encrypted = (initData.audio ? initData.audio.encrypted : false) || (initData.video ? initData.video.encrypted : false);
		const track = {
			data1: data,
			startPTS: startTime,
			startDTS: startTime,
			endPTS: endTime,
			endDTS: endTime,
			type,
			hasAudio,
			hasVideo,
			nb: 1,
			dropped: 0,
			encrypted
		};
		result.audio = hasAudio && !hasVideo ? track : void 0;
		result.video = hasVideo ? track : void 0;
		const videoSampleCount = videoSampleTimestamps == null ? void 0 : videoSampleTimestamps.sampleCount;
		if (videoSampleCount) {
			const firstKeyFrame = videoSampleTimestamps.keyFrameIndex;
			const independent = firstKeyFrame !== -1;
			track.nb = videoSampleCount;
			track.dropped = firstKeyFrame === 0 || this.isVideoContiguous ? 0 : independent ? firstKeyFrame : videoSampleCount;
			track.independent = independent;
			track.firstKeyFrame = firstKeyFrame;
			if (independent && videoSampleTimestamps.keyFrameStart) track.firstKeyFramePTS = (videoSampleTimestamps.keyFrameStart - initPTS.baseTime) / initPTS.timescale;
			if (!this.isVideoContiguous) result.independent = independent;
			this.isVideoContiguous || (this.isVideoContiguous = independent);
			if (track.dropped) this.warn(`fmp4 does not start with IDR: firstIDR ${firstKeyFrame}/${videoSampleCount} dropped: ${track.dropped} start: ${track.firstKeyFramePTS || "NA"}`);
		}
		result.initSegment = initSegment;
		result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
		if (textTrack.samples.length) result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
		return result;
	}
};
function toStartEndOrDefault(trackTimes, defaultValue, end = false) {
	return (trackTimes == null ? void 0 : trackTimes.start) !== void 0 ? (trackTimes.start + (end ? trackTimes.duration : 0)) / trackTimes.timescale : defaultValue;
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
	if (initPTS === null) return true;
	const minDuration = Math.max(duration, 1);
	const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
	return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type, logger) {
	const parsedCodec = track.codec;
	if (parsedCodec && parsedCodec.length > 4) return parsedCodec;
	if (type === ElementaryStreamTypes.AUDIO) {
		if (parsedCodec === "ec-3" || parsedCodec === "ac-3" || parsedCodec === "alac") return parsedCodec;
		if (parsedCodec === "fLaC" || parsedCodec === "Opus") return getCodecCompatibleName(parsedCodec, false);
		logger.warn(`Unhandled audio codec "${parsedCodec}" in mp4 MAP`);
		return parsedCodec || "mp4a";
	}
	logger.warn(`Unhandled video codec "${parsedCodec}" in mp4 MAP`);
	return parsedCodec || "avc1";
}
var now;
try {
	now = self.performance.now.bind(self.performance);
} catch (err) {
	now = Date.now;
}
var muxConfig = [
	{
		demux: MP4Demuxer,
		remux: PassThroughRemuxer
	},
	{
		demux: TSDemuxer,
		remux: MP4Remuxer
	},
	{
		demux: AACDemuxer,
		remux: MP4Remuxer
	},
	{
		demux: MP3Demuxer,
		remux: MP4Remuxer
	}
];
muxConfig.splice(2, 0, {
	demux: AC3Demuxer,
	remux: MP4Remuxer
});
var Transmuxer = class {
	constructor(observer, typeSupported, config, vendor, id, logger) {
		this.asyncResult = false;
		this.logger = void 0;
		this.observer = void 0;
		this.typeSupported = void 0;
		this.config = void 0;
		this.id = void 0;
		this.demuxer = void 0;
		this.remuxer = void 0;
		this.decrypter = void 0;
		this.probe = void 0;
		this.decryptionPromise = null;
		this.transmuxConfig = void 0;
		this.currentTransmuxState = void 0;
		this.observer = observer;
		this.typeSupported = typeSupported;
		this.config = config;
		this.id = id;
		this.logger = logger;
	}
	configure(transmuxConfig) {
		this.transmuxConfig = transmuxConfig;
		if (this.decrypter) this.decrypter.reset();
	}
	push(data, decryptdata, chunkMeta, state) {
		const stats = chunkMeta.transmuxing;
		stats.executeStart = now();
		let uintData = new Uint8Array(data);
		const { currentTransmuxState, transmuxConfig } = this;
		if (state) this.currentTransmuxState = state;
		const { contiguous, discontinuity, trackSwitch, accurateTimeOffset, timeOffset, initSegmentChange } = state || currentTransmuxState;
		const { audioCodec, videoCodec, defaultInitPts, duration, initSegmentData } = transmuxConfig;
		const keyData = getEncryptionType(uintData, decryptdata);
		if (keyData && isFullSegmentEncryption(keyData.method)) {
			const decrypter = this.getDecrypter();
			const aesMode = getAesModeFromFullSegmentMethod(keyData.method);
			if (decrypter.isSync()) {
				let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode);
				if (chunkMeta.part > -1) {
					const _data = decrypter.flush();
					decryptedData = _data ? _data.buffer : _data;
				}
				if (!decryptedData) {
					stats.executeEnd = now();
					return emptyResult(chunkMeta);
				}
				uintData = new Uint8Array(decryptedData);
			} else {
				this.asyncResult = true;
				this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode).then((decryptedData) => {
					const result = this.push(decryptedData, null, chunkMeta);
					this.decryptionPromise = null;
					return result;
				});
				return this.decryptionPromise;
			}
		}
		const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
		if (resetMuxers) {
			const error = this.configureTransmuxer(uintData);
			if (error) {
				this.logger.warn(`[transmuxer] ${error.message}`);
				this.observer.emit(Events.ERROR, Events.ERROR, {
					type: ErrorTypes.MEDIA_ERROR,
					details: ErrorDetails.FRAG_PARSING_ERROR,
					fatal: false,
					error,
					reason: error.message
				});
				stats.executeEnd = now();
				return emptyResult(chunkMeta);
			}
		}
		if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
		if (discontinuity || initSegmentChange || resetMuxers) this.resetInitialTimestamp(defaultInitPts);
		if (!contiguous) this.resetContiguity();
		const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
		this.asyncResult = isPromise(result);
		const currentState = this.currentTransmuxState;
		currentState.contiguous = true;
		currentState.discontinuity = false;
		currentState.trackSwitch = false;
		stats.executeEnd = now();
		return result;
	}
	flush(chunkMeta) {
		const stats = chunkMeta.transmuxing;
		stats.executeStart = now();
		const { decrypter, currentTransmuxState, decryptionPromise } = this;
		if (decryptionPromise) {
			this.asyncResult = true;
			return decryptionPromise.then(() => {
				return this.flush(chunkMeta);
			});
		}
		const transmuxResults = [];
		const { timeOffset } = currentTransmuxState;
		if (decrypter) {
			const decryptedData = decrypter.flush();
			if (decryptedData) transmuxResults.push(this.push(decryptedData.buffer, null, chunkMeta));
		}
		const { demuxer, remuxer } = this;
		if (!demuxer || !remuxer) {
			stats.executeEnd = now();
			const emptyResults = [emptyResult(chunkMeta)];
			if (this.asyncResult) return Promise.resolve(emptyResults);
			return emptyResults;
		}
		const demuxResultOrPromise = demuxer.flush(timeOffset);
		if (isPromise(demuxResultOrPromise)) {
			this.asyncResult = true;
			return demuxResultOrPromise.then((demuxResult) => {
				this.flushRemux(transmuxResults, demuxResult, chunkMeta);
				return transmuxResults;
			});
		}
		this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
		if (this.asyncResult) return Promise.resolve(transmuxResults);
		return transmuxResults;
	}
	flushRemux(transmuxResults, demuxResult, chunkMeta) {
		const { audioTrack, videoTrack, id3Track, textTrack } = demuxResult;
		const { accurateTimeOffset, timeOffset } = this.currentTransmuxState;
		this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? " part: " + chunkMeta.part : ""} of ${this.id === PlaylistLevelType.MAIN ? "level" : "track"} ${chunkMeta.level}`);
		const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
		transmuxResults.push({
			remuxResult,
			chunkMeta
		});
		chunkMeta.transmuxing.executeEnd = now();
	}
	resetInitialTimestamp(defaultInitPts) {
		const { demuxer, remuxer } = this;
		if (!demuxer || !remuxer) return;
		demuxer.resetTimeStamp(defaultInitPts);
		remuxer.resetTimeStamp(defaultInitPts);
	}
	resetContiguity() {
		const { demuxer, remuxer } = this;
		if (!demuxer || !remuxer) return;
		demuxer.resetContiguity();
		remuxer.resetNextTimestamp();
	}
	resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
		const { demuxer, remuxer } = this;
		if (!demuxer || !remuxer) return;
		demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
		remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
	}
	destroy() {
		if (this.demuxer) {
			this.demuxer.destroy();
			this.demuxer = void 0;
		}
		if (this.remuxer) {
			this.remuxer.destroy();
			this.remuxer = void 0;
		}
	}
	transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
		let result;
		if (keyData && keyData.method === "SAMPLE-AES") result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
		else result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
		return result;
	}
	transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
		const { audioTrack, videoTrack, id3Track, textTrack } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
		return {
			remuxResult: this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id),
			chunkMeta
		};
	}
	transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
		return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then((demuxResult) => {
			return {
				remuxResult: this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id),
				chunkMeta
			};
		});
	}
	configureTransmuxer(data) {
		const { config, observer, typeSupported } = this;
		let mux;
		for (let i = 0, len = muxConfig.length; i < len; i++) {
			var _muxConfig$i$demux;
			if ((_muxConfig$i$demux = muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data, this.logger)) {
				mux = muxConfig[i];
				break;
			}
		}
		if (!mux) return /* @__PURE__ */ new Error("Failed to find demuxer by probing fragment data");
		const demuxer = this.demuxer;
		const remuxer = this.remuxer;
		const Remuxer = mux.remux;
		const Demuxer = mux.demux;
		if (!remuxer || !(remuxer instanceof Remuxer)) this.remuxer = new Remuxer(observer, config, typeSupported, this.logger);
		if (!demuxer || !(demuxer instanceof Demuxer)) {
			this.demuxer = new Demuxer(observer, config, typeSupported, this.logger);
			this.probe = Demuxer.probe;
		}
	}
	needsProbing(discontinuity, trackSwitch) {
		return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
	}
	getDecrypter() {
		let decrypter = this.decrypter;
		if (!decrypter) decrypter = this.decrypter = new Decrypter(this.config);
		return decrypter;
	}
};
function getEncryptionType(data, decryptData) {
	let encryptionType = null;
	if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) encryptionType = decryptData;
	return encryptionType;
}
var emptyResult = (chunkMeta) => ({
	remuxResult: {},
	chunkMeta
});
function isPromise(p) {
	return "then" in p && p.then instanceof Function;
}
var TransmuxConfig = class {
	constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
		this.audioCodec = void 0;
		this.videoCodec = void 0;
		this.initSegmentData = void 0;
		this.duration = void 0;
		this.defaultInitPts = void 0;
		this.audioCodec = audioCodec;
		this.videoCodec = videoCodec;
		this.initSegmentData = initSegmentData;
		this.duration = duration;
		this.defaultInitPts = defaultInitPts || null;
	}
};
var TransmuxState = class {
	constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
		this.discontinuity = void 0;
		this.contiguous = void 0;
		this.accurateTimeOffset = void 0;
		this.trackSwitch = void 0;
		this.timeOffset = void 0;
		this.initSegmentChange = void 0;
		this.discontinuity = discontinuity;
		this.contiguous = contiguous;
		this.accurateTimeOffset = accurateTimeOffset;
		this.trackSwitch = trackSwitch;
		this.timeOffset = timeOffset;
		this.initSegmentChange = initSegmentChange;
	}
};
var transmuxerInstanceCount = 0;
var TransmuxerInterface = class {
	constructor(_hls, id, onTransmuxComplete, onFlush) {
		this.error = null;
		this.hls = void 0;
		this.id = void 0;
		this.instanceNo = transmuxerInstanceCount++;
		this.observer = void 0;
		this.frag = null;
		this.part = null;
		this.useWorker = void 0;
		this.workerContext = null;
		this.transmuxer = null;
		this.onTransmuxComplete = void 0;
		this.onFlush = void 0;
		this.onWorkerMessage = (event) => {
			const data = event.data;
			const hls = this.hls;
			if (!hls || !(data != null && data.event) || data.instanceNo !== this.instanceNo) return;
			switch (data.event) {
				case "init": {
					var _this$workerContext;
					const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
					if (objectURL) self.URL.revokeObjectURL(objectURL);
					break;
				}
				case "transmuxComplete":
					this.handleTransmuxComplete(data.data);
					break;
				case "flush":
					this.onFlush(data.data);
					break;
				case "workerLog":
					if (hls.logger[data.data.logType]) hls.logger[data.data.logType](data.data.message);
					break;
				default:
					data.data = data.data || {};
					data.data.frag = this.frag;
					data.data.part = this.part;
					data.data.id = this.id;
					hls.trigger(data.event, data.data);
					break;
			}
		};
		this.onWorkerError = (event) => {
			if (!this.hls) return;
			const error = /* @__PURE__ */ new Error(`${event.message}  (${event.filename}:${event.lineno})`);
			this.hls.config.enableWorker = false;
			this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`);
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.INTERNAL_EXCEPTION,
				fatal: false,
				event: "demuxerWorker",
				error
			});
		};
		const config = _hls.config;
		this.hls = _hls;
		this.id = id;
		this.useWorker = !!config.enableWorker;
		this.onTransmuxComplete = onTransmuxComplete;
		this.onFlush = onFlush;
		const forwardMessage = (ev, data) => {
			data = data || {};
			data.frag = this.frag || void 0;
			if (ev === Events.ERROR) {
				data = data;
				data.parent = this.id;
				data.part = this.part;
				this.error = data.error;
			}
			this.hls.trigger(ev, data);
		};
		this.observer = new EventEmitter$1();
		this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
		this.observer.on(Events.ERROR, forwardMessage);
		const m2tsTypeSupported = getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
		if (this.useWorker && typeof Worker !== "undefined") {
			const logger = this.hls.logger;
			if (config.workerPath || hasUMDWorker()) {
				try {
					if (config.workerPath) {
						logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
						this.workerContext = loadWorker(config.workerPath);
					} else {
						logger.log(`injecting Web Worker for "${id}"`);
						this.workerContext = injectWorker();
					}
					const { worker } = this.workerContext;
					worker.addEventListener("message", this.onWorkerMessage);
					worker.addEventListener("error", this.onWorkerError);
					worker.postMessage({
						instanceNo: this.instanceNo,
						cmd: "init",
						typeSupported: m2tsTypeSupported,
						id,
						config: stringify(config)
					});
				} catch (err) {
					logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
					this.terminateWorker();
					this.error = null;
					this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, "", id, _hls.logger);
				}
				return;
			}
		}
		this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, "", id, _hls.logger);
	}
	reset() {
		this.frag = null;
		this.part = null;
		if (this.workerContext) {
			const instanceNo = this.instanceNo;
			this.instanceNo = transmuxerInstanceCount++;
			const config = this.hls.config;
			const m2tsTypeSupported = getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
			this.workerContext.worker.postMessage({
				instanceNo: this.instanceNo,
				cmd: "reset",
				resetNo: instanceNo,
				typeSupported: m2tsTypeSupported,
				id: this.id,
				config: stringify(config)
			});
		}
	}
	terminateWorker() {
		if (this.workerContext) {
			const { worker } = this.workerContext;
			this.workerContext = null;
			worker.removeEventListener("message", this.onWorkerMessage);
			worker.removeEventListener("error", this.onWorkerError);
			removeWorkerFromStore(this.hls.config.workerPath);
		}
	}
	destroy() {
		if (this.workerContext) {
			this.terminateWorker();
			this.onWorkerMessage = this.onWorkerError = null;
		} else {
			const transmuxer = this.transmuxer;
			if (transmuxer) {
				transmuxer.destroy();
				this.transmuxer = null;
			}
		}
		const observer = this.observer;
		if (observer) observer.removeAllListeners();
		this.frag = null;
		this.part = null;
		this.observer = null;
		this.hls = null;
	}
	push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
		var _frag$initSegment, _lastFrag$initSegment;
		chunkMeta.transmuxing.start = self.performance.now();
		const { instanceNo, transmuxer } = this;
		const timeOffset = part ? part.start : frag.start;
		const decryptdata = frag.decryptdata;
		const lastFrag = this.frag;
		const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
		const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
		const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
		const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
		const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
		const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
		const now = self.performance.now();
		if (trackSwitch || snDiff || frag.stats.parsing.start === 0) frag.stats.parsing.start = now;
		if (part && (partDiff || !contiguous)) part.stats.parsing.start = now;
		const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
		const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
		if (!contiguous || discontinuity || initSegmentChange) {
			this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${frag.type} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? " part: " + chunkMeta.part : ""} ${this.id === PlaylistLevelType.MAIN ? "level" : "track"}: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
			const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
			this.configureTransmuxer(config);
		}
		this.frag = frag;
		this.part = part;
		if (this.workerContext) this.workerContext.worker.postMessage({
			instanceNo,
			cmd: "demux",
			data,
			decryptdata,
			chunkMeta,
			state
		}, data instanceof ArrayBuffer ? [data] : []);
		else if (transmuxer) {
			const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
			if (isPromise(transmuxResult)) transmuxResult.then((data) => {
				this.handleTransmuxComplete(data);
			}).catch((error) => {
				this.transmuxerError(error, chunkMeta, "transmuxer-interface push error");
			});
			else this.handleTransmuxComplete(transmuxResult);
		}
	}
	flush(chunkMeta) {
		chunkMeta.transmuxing.start = self.performance.now();
		const { instanceNo, transmuxer } = this;
		if (this.workerContext) this.workerContext.worker.postMessage({
			instanceNo,
			cmd: "flush",
			chunkMeta
		});
		else if (transmuxer) {
			const transmuxResult = transmuxer.flush(chunkMeta);
			if (isPromise(transmuxResult)) transmuxResult.then((data) => {
				this.handleFlushResult(data, chunkMeta);
			}).catch((error) => {
				this.transmuxerError(error, chunkMeta, "transmuxer-interface flush error");
			});
			else this.handleFlushResult(transmuxResult, chunkMeta);
		}
	}
	transmuxerError(error, chunkMeta, reason) {
		if (!this.hls) return;
		this.error = error;
		this.hls.trigger(Events.ERROR, {
			type: ErrorTypes.MEDIA_ERROR,
			details: ErrorDetails.FRAG_PARSING_ERROR,
			chunkMeta,
			frag: this.frag || void 0,
			part: this.part || void 0,
			fatal: false,
			error,
			err: error,
			reason
		});
	}
	handleFlushResult(results, chunkMeta) {
		results.forEach((result) => {
			this.handleTransmuxComplete(result);
		});
		this.onFlush(chunkMeta);
	}
	configureTransmuxer(config) {
		const { instanceNo, transmuxer } = this;
		if (this.workerContext) this.workerContext.worker.postMessage({
			instanceNo,
			cmd: "configure",
			config
		});
		else if (transmuxer) transmuxer.configure(config);
	}
	handleTransmuxComplete(result) {
		result.chunkMeta.transmuxing.end = self.performance.now();
		this.onTransmuxComplete(result);
	}
};
var TICK_INTERVAL$3 = 100;
var AudioStreamController = class extends BaseStreamController {
	constructor(hls, fragmentTracker, keyLoader) {
		super(hls, fragmentTracker, keyLoader, "audio-stream-controller", PlaylistLevelType.AUDIO);
		this.mainAnchor = null;
		this.mainFragLoading = null;
		this.audioOnly = false;
		this.bufferedTrack = null;
		this.switchingTrack = null;
		this.trackId = -1;
		this.waitingData = null;
		this.mainDetails = null;
		this.flushing = false;
		this.bufferFlushed = false;
		this.cachedTrackLoadedData = null;
		this.registerListeners();
	}
	onHandlerDestroying() {
		this.unregisterListeners();
		super.onHandlerDestroying();
		this.resetItem();
	}
	resetItem() {
		this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
	}
	registerListeners() {
		super.registerListeners();
		const { hls } = this;
		hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
		hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
		hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
		hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
		hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
		hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
		hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
		hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
		hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
	}
	unregisterListeners() {
		const { hls } = this;
		if (!hls) return;
		super.unregisterListeners();
		hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
		hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
		hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
		hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
		hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
		hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
		hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
		hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
		hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
	}
	onInitPtsFound(event, { frag, id, initPTS, timescale, trackId }) {
		if (id === PlaylistLevelType.MAIN) {
			const cc = frag.cc;
			const inFlightFrag = this.fragCurrent;
			this.initPTS[cc] = {
				baseTime: initPTS,
				timescale,
				trackId
			};
			this.log(`InitPTS for cc: ${cc} found from main: ${initPTS / timescale} (${initPTS}/${timescale}) trackId: ${trackId}`);
			this.mainAnchor = frag;
			if (this.state === State.WAITING_INIT_PTS) {
				const waitingData = this.waitingData;
				if (!waitingData && !this.loadingParts || waitingData && waitingData.frag.cc !== cc) this.syncWithAnchor(frag, waitingData == null ? void 0 : waitingData.frag);
			} else if (!this.hls.hasEnoughToStart && inFlightFrag && inFlightFrag.cc !== cc) {
				inFlightFrag.abortRequests();
				this.syncWithAnchor(frag, inFlightFrag);
			} else if (this.state === State.IDLE) this.tick();
		}
	}
	getLoadPosition() {
		if (!this.startFragRequested && this.nextLoadPosition >= 0) return this.nextLoadPosition;
		return super.getLoadPosition();
	}
	syncWithAnchor(mainAnchor, waitingToAppend) {
		var _this$mainFragLoading;
		const mainFragLoading = ((_this$mainFragLoading = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading.frag) || null;
		if (waitingToAppend) {
			if ((mainFragLoading == null ? void 0 : mainFragLoading.cc) === waitingToAppend.cc) return;
		}
		const targetDiscontinuity = (mainFragLoading || mainAnchor).cc;
		const syncFrag = findNearestWithCC(this.getLevelDetails(), targetDiscontinuity, this.getLoadPosition());
		if (syncFrag) {
			this.log(`Syncing with main frag at ${syncFrag.start} cc ${syncFrag.cc}`);
			this.startFragRequested = false;
			this.nextLoadPosition = syncFrag.start;
			this.resetLoadingState();
			if (this.state === State.IDLE) this.doTickIdle();
		}
	}
	startLoad(startPosition, skipSeekToStartPosition) {
		if (!this.levels) {
			this.startPosition = startPosition;
			this.state = State.STOPPED;
			return;
		}
		const lastCurrentTime = this.lastCurrentTime;
		this.stopLoad();
		this.setInterval(TICK_INTERVAL$3);
		if (lastCurrentTime > 0 && startPosition === -1) {
			this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
			startPosition = lastCurrentTime;
			this.state = State.IDLE;
		} else this.state = State.WAITING_TRACK;
		this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
		this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
		this.tick();
	}
	doTick() {
		switch (this.state) {
			case State.IDLE:
				this.doTickIdle();
				break;
			case State.WAITING_TRACK: {
				const { levels, trackId } = this;
				const currenTrack = levels == null ? void 0 : levels[trackId];
				const details = currenTrack == null ? void 0 : currenTrack.details;
				if (details && !this.waitForLive(currenTrack)) {
					if (this.waitForCdnTuneIn(details)) break;
					this.state = State.WAITING_INIT_PTS;
				}
				break;
			}
			case State.FRAG_LOADING_WAITING_RETRY:
				this.checkRetryDate();
				break;
			case State.WAITING_INIT_PTS: {
				const waitingData = this.waitingData;
				if (waitingData) {
					const { frag, part, cache, complete } = waitingData;
					const mainAnchor = this.mainAnchor;
					if (this.initPTS[frag.cc] !== void 0) {
						this.waitingData = null;
						this.state = State.FRAG_LOADING;
						const data = {
							frag,
							part,
							payload: cache.flush().buffer,
							networkDetails: null
						};
						this._handleFragmentLoadProgress(data);
						if (complete) super._handleFragmentLoadComplete(data);
					} else if (mainAnchor && mainAnchor.cc !== waitingData.frag.cc) this.syncWithAnchor(mainAnchor, waitingData.frag);
				} else this.state = State.IDLE;
			}
		}
		this.onTickEnd();
	}
	resetLoadingState() {
		const waitingData = this.waitingData;
		if (waitingData) {
			this.fragmentTracker.removeFragment(waitingData.frag);
			this.waitingData = null;
		}
		super.resetLoadingState();
	}
	onTickEnd() {
		const { media } = this;
		if (!(media != null && media.readyState)) return;
		this.lastCurrentTime = media.currentTime;
	}
	doTickIdle() {
		var _this$mainFragLoading2;
		const { hls, levels, media, trackId } = this;
		const config = hls.config;
		if (!this.buffering || !media && !this.primaryPrefetch && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) return;
		const levelInfo = levels[trackId];
		const trackDetails = levelInfo.details;
		if (!trackDetails || this.waitForLive(levelInfo) || this.waitForCdnTuneIn(trackDetails)) {
			this.state = State.WAITING_TRACK;
			this.startFragRequested = false;
			return;
		}
		const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
		if (this.bufferFlushed && bufferable) {
			this.bufferFlushed = false;
			this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
		}
		const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
		if (bufferInfo === null) return;
		if (!this.switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
			hls.trigger(Events.BUFFER_EOS, { type: "audio" });
			this.state = State.ENDED;
			return;
		}
		const bufferLen = bufferInfo.len;
		const maxBufLen = hls.maxBufferLength;
		const fragments = trackDetails.fragments;
		const start = fragments[0].start;
		const loadPosition = this.getLoadPosition();
		const targetBufferTime = this.flushing ? loadPosition : bufferInfo.end;
		if (this.switchingTrack && media) {
			const pos = loadPosition;
			if (trackDetails.PTSKnown && pos < start) {
				if (bufferInfo.end > start || bufferInfo.nextStart) {
					this.log("Alt audio track ahead of main track, seek to start of alt audio track");
					media.currentTime = start + .05;
				}
			}
		}
		if (bufferLen >= maxBufLen && !this.switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) return;
		let frag = this.getNextFragment(targetBufferTime, trackDetails);
		if (frag && this.isLoopLoading(frag, targetBufferTime)) frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
		if (!frag) {
			this.bufferFlushed = true;
			return;
		}
		if (this.exceedsMaxBuffer(bufferInfo, maxBufLen, frag)) return;
		let mainFragLoading = ((_this$mainFragLoading2 = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading2.frag) || null;
		if (!this.audioOnly && this.startFragRequested && mainFragLoading && isMediaFragment(frag) && !frag.endList && (!trackDetails.live || !this.loadingParts && targetBufferTime < this.hls.liveSyncPosition)) {
			if (this.fragmentTracker.getState(mainFragLoading) === FragmentState.OK) this.mainFragLoading = mainFragLoading = null;
			if (mainFragLoading && isMediaFragment(mainFragLoading)) {
				if (frag.start > mainFragLoading.end) {
					const mainFragAtPos = this.fragmentTracker.getFragAtPos(targetBufferTime, PlaylistLevelType.MAIN);
					if (mainFragAtPos && mainFragAtPos.end > mainFragLoading.end) {
						mainFragLoading = mainFragAtPos;
						this.mainFragLoading = {
							frag: mainFragAtPos,
							targetBufferTime: null
						};
					}
				}
				if (frag.start > mainFragLoading.end) return;
			}
		}
		this.loadFragment(frag, levelInfo, targetBufferTime);
	}
	onMediaDetaching(event, data) {
		this.bufferFlushed = this.flushing = false;
		super.onMediaDetaching(event, data);
	}
	onAudioTracksUpdated(event, { audioTracks }) {
		this.resetTransmuxer();
		this.levels = audioTracks.map((mediaPlaylist) => new Level(mediaPlaylist));
	}
	onAudioTrackSwitching(event, data) {
		const altAudio = !!data.url;
		this.trackId = data.id;
		const { fragCurrent } = this;
		if (fragCurrent) {
			fragCurrent.abortRequests();
			this.removeUnbufferedFrags(fragCurrent.start);
		}
		this.resetLoadingState();
		if (altAudio) {
			this.switchingTrack = data;
			this.flushAudioIfNeeded(data);
			if (this.state !== State.STOPPED) {
				this.setInterval(TICK_INTERVAL$3);
				this.state = State.IDLE;
				this.tick();
			}
		} else {
			this.resetTransmuxer();
			this.switchingTrack = null;
			this.bufferedTrack = data;
			this.clearInterval();
		}
	}
	onManifestLoading() {
		super.onManifestLoading();
		this.bufferFlushed = this.flushing = this.audioOnly = false;
		this.resetItem();
		this.trackId = -1;
	}
	onLevelLoaded(event, data) {
		this.mainDetails = data.details;
		const cachedTrackLoadedData = this.cachedTrackLoadedData;
		if (cachedTrackLoadedData) {
			this.cachedTrackLoadedData = null;
			this.onAudioTrackLoaded(Events.AUDIO_TRACK_LOADED, cachedTrackLoadedData);
		}
	}
	onAudioTrackLoaded(event, data) {
		var _trackLevel$details;
		const { levels } = this;
		const { details: newDetails, id: trackId, groupId, track } = data;
		if (!levels) {
			this.warn(`Audio tracks reset while loading track ${trackId} "${track.name}" of "${groupId}"`);
			return;
		}
		const mainDetails = this.mainDetails;
		if (!mainDetails || newDetails.endCC > mainDetails.endCC || mainDetails.expired) {
			this.cachedTrackLoadedData = data;
			if (this.state !== State.STOPPED) this.state = State.WAITING_TRACK;
			return;
		}
		this.cachedTrackLoadedData = null;
		this.log(`Audio track ${trackId} "${track.name}" of "${groupId}" loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ""},duration:${newDetails.totalduration}`);
		const trackLevel = levels[trackId];
		let sliding = 0;
		if (newDetails.live || (_trackLevel$details = trackLevel.details) != null && _trackLevel$details.live) {
			this.checkLiveUpdate(newDetails);
			if (newDetails.deltaUpdateFailed) return;
			if (trackLevel.details) {
				var _this$levelLastLoaded;
				sliding = this.alignPlaylists(newDetails, trackLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
			}
			if (!newDetails.alignedSliding) {
				alignDiscontinuities(newDetails, mainDetails);
				if (!newDetails.alignedSliding) alignMediaPlaylistByPDT(newDetails, mainDetails);
				sliding = newDetails.fragmentStart;
			}
		}
		trackLevel.details = newDetails;
		this.levelLastLoaded = trackLevel;
		if (!this.startFragRequested) this.setStartPosition(mainDetails, sliding);
		this.hls.trigger(Events.AUDIO_TRACK_UPDATED, {
			details: newDetails,
			id: trackId,
			groupId: data.groupId
		});
		if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) this.state = State.IDLE;
		this.tick();
	}
	_handleFragmentLoadProgress(data) {
		var _frag$initSegment;
		const frag = data.frag;
		const { part, payload } = data;
		const { config, trackId, levels } = this;
		if (!levels) {
			this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
			return;
		}
		const track = levels[trackId];
		if (!track) {
			this.warn("Audio track is undefined on fragment load progress");
			return;
		}
		const details = track.details;
		if (!details) {
			this.warn("Audio track details undefined on fragment load progress");
			this.removeUnbufferedFrags(frag.start);
			return;
		}
		const audioCodec = config.defaultAudioCodec || track.audioCodec || "mp4a.40.2";
		let transmuxer = this.transmuxer;
		if (!transmuxer) transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
		const initPTS = this.initPTS[frag.cc];
		const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
		if (initPTS !== void 0) {
			const accurateTimeOffset = false;
			const partIndex = part ? part.index : -1;
			const partial = partIndex !== -1;
			const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
			transmuxer.push(payload, initSegmentData, audioCodec, "", frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
		} else {
			this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
			const { cache } = this.waitingData = this.waitingData || {
				frag,
				part,
				cache: new ChunkCache(),
				complete: false
			};
			cache.push(new Uint8Array(payload));
			if (this.state !== State.STOPPED) this.state = State.WAITING_INIT_PTS;
		}
	}
	_handleFragmentLoadComplete(fragLoadedData) {
		if (this.waitingData) {
			this.waitingData.complete = true;
			return;
		}
		super._handleFragmentLoadComplete(fragLoadedData);
	}
	onBufferReset() {
		this.mediaBuffer = null;
	}
	onBufferCreated(event, data) {
		this.bufferFlushed = this.flushing = false;
		const audioTrack = data.tracks.audio;
		if (audioTrack) this.mediaBuffer = audioTrack.buffer || null;
	}
	onFragLoading(event, data) {
		if (!this.audioOnly && data.frag.type === PlaylistLevelType.MAIN && isMediaFragment(data.frag)) {
			this.mainFragLoading = data;
			if (this.state === State.IDLE) this.tick();
		}
	}
	onFragBuffered(event, data) {
		const { frag, part } = data;
		if (frag.type !== PlaylistLevelType.AUDIO) {
			if (!this.audioOnly && frag.type === PlaylistLevelType.MAIN && !frag.elementaryStreams.video && !frag.elementaryStreams.audiovideo) {
				this.audioOnly = true;
				this.mainFragLoading = null;
			}
			return;
		}
		if (this.fragContextChanged(frag)) {
			this.warn(`Fragment ${frag.sn}${part ? " p: " + part.index : ""} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
			return;
		}
		if (isMediaFragment(frag)) {
			this.fragPrevious = frag;
			const track = this.switchingTrack;
			if (track) {
				this.bufferedTrack = track;
				this.switchingTrack = null;
				this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
			}
		}
		this.fragBufferedComplete(frag, part);
		if (this.media) this.tick();
	}
	onError(event, data) {
		var _data$context;
		if (data.fatal) {
			this.state = State.ERROR;
			return;
		}
		switch (data.details) {
			case ErrorDetails.FRAG_GAP:
			case ErrorDetails.FRAG_PARSING_ERROR:
			case ErrorDetails.FRAG_DECRYPT_ERROR:
			case ErrorDetails.FRAG_LOAD_ERROR:
			case ErrorDetails.FRAG_LOAD_TIMEOUT:
			case ErrorDetails.KEY_LOAD_ERROR:
			case ErrorDetails.KEY_LOAD_TIMEOUT:
				this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
				break;
			case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
			case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
			case ErrorDetails.LEVEL_PARSING_ERROR:
				if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) this.state = State.IDLE;
				break;
			case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
			case ErrorDetails.BUFFER_APPEND_ERROR:
				if (data.parent !== "audio") return;
				if (!this.reduceLengthAndFlushBuffer(data)) this.resetLoadingState();
				break;
			case ErrorDetails.BUFFER_FULL_ERROR:
				if (data.parent !== "audio") return;
				if (this.reduceLengthAndFlushBuffer(data)) {
					this.bufferedTrack = null;
					super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio");
				}
				break;
			case ErrorDetails.INTERNAL_EXCEPTION:
				this.recoverWorkerError(data);
				break;
		}
	}
	onBufferFlushing(event, { type }) {
		if (type !== ElementaryStreamTypes.VIDEO) this.flushing = true;
	}
	onBufferFlushed(event, { type }) {
		if (type !== ElementaryStreamTypes.VIDEO) {
			this.flushing = false;
			this.bufferFlushed = true;
			if (this.state === State.ENDED) this.state = State.IDLE;
			const mediaBuffer = this.mediaBuffer || this.media;
			if (mediaBuffer) {
				this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.AUDIO);
				this.tick();
			}
		}
	}
	_handleTransmuxComplete(transmuxResult) {
		var _id3$samples;
		const id = "audio";
		const { hls } = this;
		const { remuxResult, chunkMeta } = transmuxResult;
		const context = this.getCurrentContext(chunkMeta);
		if (!context) {
			this.resetWhenMissingContext(chunkMeta);
			return;
		}
		const { frag, part, level } = context;
		const { details } = level;
		const { audio, text, id3, initSegment } = remuxResult;
		if (this.fragContextChanged(frag) || !details) {
			this.fragmentTracker.removeFragment(frag);
			return;
		}
		this.state = State.PARSING;
		if (this.switchingTrack && audio) this.completeAudioSwitch(this.switchingTrack);
		if (initSegment != null && initSegment.tracks) {
			const mapFragment = frag.initSegment || frag;
			if (this.unhandledEncryptionError(initSegment, frag)) return;
			this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
			hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
				frag: mapFragment,
				id,
				tracks: initSegment.tracks
			});
		}
		if (audio) {
			const { startPTS, endPTS, startDTS, endDTS } = audio;
			if (part) part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
				startPTS,
				endPTS,
				startDTS,
				endDTS
			};
			frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
			this.bufferFragmentData(audio, frag, part, chunkMeta);
		}
		if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
			const emittedID3 = _extends({
				id,
				frag,
				details
			}, id3);
			hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
		}
		if (text) {
			const emittedText = _extends({
				id,
				frag,
				details
			}, text);
			hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
		}
	}
	_bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
		if (this.state !== State.PARSING) return;
		if (tracks.video) delete tracks.video;
		if (tracks.audiovideo) delete tracks.audiovideo;
		if (!tracks.audio) return;
		const track = tracks.audio;
		track.id = PlaylistLevelType.AUDIO;
		const variantAudioCodecs = currentLevel.audioCodec;
		this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
		if (variantAudioCodecs && variantAudioCodecs.split(",").length === 1) track.levelCodec = variantAudioCodecs;
		this.hls.trigger(Events.BUFFER_CODECS, tracks);
		const initSegment = track.initSegment;
		if (initSegment != null && initSegment.byteLength) {
			const segment = {
				type: "audio",
				frag,
				part: null,
				chunkMeta,
				parent: frag.type,
				data: initSegment
			};
			this.hls.trigger(Events.BUFFER_APPENDING, segment);
		}
		this.tickImmediate();
	}
	loadFragment(frag, track, targetBufferTime) {
		const fragState = this.fragmentTracker.getState(frag);
		if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
			var _track$details;
			if (!isMediaFragment(frag)) this._loadInitSegment(frag, track);
			else if ((_track$details = track.details) != null && _track$details.live && !this.initPTS[frag.cc]) {
				this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
				this.state = State.WAITING_INIT_PTS;
				const mainDetails = this.mainDetails;
				if (mainDetails && mainDetails.fragmentStart !== track.details.fragmentStart) alignMediaPlaylistByPDT(track.details, mainDetails);
			} else super.loadFragment(frag, track, targetBufferTime);
		} else this.clearTrackerIfNeeded(frag);
	}
	flushAudioIfNeeded(switchingTrack) {
		if (this.media && this.bufferedTrack) {
			const { name, lang, assocLang, characteristics, audioCodec, channels } = this.bufferedTrack;
			if (!matchesOption({
				name,
				lang,
				assocLang,
				characteristics,
				audioCodec,
				channels
			}, switchingTrack, audioMatchPredicate)) if (useAlternateAudio(switchingTrack.url, this.hls)) {
				this.log("Switching audio track : flushing all audio");
				super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio");
				this.bufferedTrack = null;
			} else this.bufferedTrack = switchingTrack;
		}
	}
	completeAudioSwitch(switchingTrack) {
		const { hls } = this;
		this.flushAudioIfNeeded(switchingTrack);
		this.bufferedTrack = switchingTrack;
		this.switchingTrack = null;
		hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
	}
};
var BasePlaylistController = class extends Logger {
	constructor(hls, logPrefix) {
		super(logPrefix, hls.logger);
		this.hls = void 0;
		this.canLoad = false;
		this.timer = -1;
		this.hls = hls;
	}
	destroy() {
		this.clearTimer();
		this.hls = this.log = this.warn = null;
	}
	clearTimer() {
		if (this.timer !== -1) {
			self.clearTimeout(this.timer);
			this.timer = -1;
		}
	}
	startLoad() {
		this.canLoad = true;
		this.loadPlaylist();
	}
	stopLoad() {
		this.canLoad = false;
		this.clearTimer();
	}
	switchParams(playlistUri, previous, current) {
		const renditionReports = previous == null ? void 0 : previous.renditionReports;
		if (renditionReports) {
			let foundIndex = -1;
			for (let i = 0; i < renditionReports.length; i++) {
				const attr = renditionReports[i];
				let uri;
				try {
					uri = new self.URL(attr.URI, previous.url).href;
				} catch (error) {
					this.warn(`Could not construct new URL for Rendition Report: ${error}`);
					uri = attr.URI || "";
				}
				if (uri === playlistUri) {
					foundIndex = i;
					break;
				} else if (uri === playlistUri.substring(0, uri.length)) foundIndex = i;
			}
			if (foundIndex !== -1) {
				const attr = renditionReports[foundIndex];
				const msn = parseInt(attr["LAST-MSN"]) || previous.lastPartSn;
				let part = parseInt(attr["LAST-PART"]) || previous.lastPartIndex;
				if (this.hls.config.lowLatencyMode) {
					const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
					if (part >= 0 && currentGoal > previous.partTarget) part += 1;
				}
				const skip = current && getSkipValue(current);
				return new HlsUrlParameters(msn, part >= 0 ? part : void 0, skip);
			}
		}
	}
	loadPlaylist(hlsUrlParameters) {
		this.clearTimer();
	}
	loadingPlaylist(playlist, hlsUrlParameters) {
		this.clearTimer();
	}
	shouldLoadPlaylist(playlist) {
		return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
	}
	getUrlWithDirectives(uri, hlsUrlParameters) {
		if (hlsUrlParameters) try {
			return hlsUrlParameters.addDirectives(uri);
		} catch (error) {
			this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
		}
		return uri;
	}
	playlistLoaded(index, data, previousDetails) {
		const { details, stats } = data;
		const now = self.performance.now();
		const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
		details.advancedDateTime = Date.now() - elapsed;
		const timelineOffset = this.hls.config.timelineOffset;
		if (timelineOffset !== details.appliedTimelineOffset) {
			const offset = Math.max(timelineOffset || 0, 0);
			details.appliedTimelineOffset = offset;
			details.fragments.forEach((frag) => {
				frag.setStart(frag.playlistOffset + offset);
			});
		}
		if (details.live || previousDetails != null && previousDetails.live) {
			const levelOrTrack = "levelInfo" in data ? data.levelInfo : data.track;
			details.reloaded(previousDetails);
			if (previousDetails && details.fragments.length > 0) {
				mergeDetails(previousDetails, details, this);
				const error = details.playlistParsingError;
				if (error) {
					this.warn(error);
					const hls = this.hls;
					if (!hls.config.ignorePlaylistParsingErrors) {
						var _details$fragments$;
						const { networkDetails } = data;
						hls.trigger(Events.ERROR, {
							type: ErrorTypes.NETWORK_ERROR,
							details: ErrorDetails.LEVEL_PARSING_ERROR,
							fatal: false,
							url: details.url,
							error,
							reason: error.message,
							level: data.level || void 0,
							parent: (_details$fragments$ = details.fragments[0]) == null ? void 0 : _details$fragments$.type,
							networkDetails,
							stats
						});
						return;
					}
					details.playlistParsingError = null;
				}
			}
			if (details.requestScheduled === -1) details.requestScheduled = stats.loading.start;
			const bufferInfo = this.hls.mainForwardBufferInfo;
			const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
			const reloadInterval = computeReloadInterval(details, (details.edge - position) * 1e3);
			if (details.requestScheduled + reloadInterval < now) details.requestScheduled = now;
			else details.requestScheduled += reloadInterval;
			this.log(`live playlist ${index} ${details.advanced ? "REFRESHED " + details.lastPartSn + "-" + details.lastPartIndex : details.updated ? "UPDATED" : "MISSED"}`);
			if (!this.canLoad || !details.live) return;
			let deliveryDirectives;
			let msn = void 0;
			let part = void 0;
			if (details.canBlockReload && details.endSN && details.advanced) {
				const lowLatencyMode = this.hls.config.lowLatencyMode;
				const lastPartSn = details.lastPartSn;
				const endSn = details.endSN;
				const lastPartIndex = details.lastPartIndex;
				const hasParts = lastPartIndex !== -1;
				const atLastPartOfSegment = lastPartSn === endSn;
				if (hasParts) if (atLastPartOfSegment) {
					msn = endSn + 1;
					part = lowLatencyMode ? 0 : lastPartIndex;
				} else {
					msn = lastPartSn;
					part = lowLatencyMode ? lastPartIndex + 1 : details.maxPartIndex;
				}
				else msn = endSn + 1;
				const lastAdvanced = details.age;
				const cdnAge = lastAdvanced + details.ageHeader;
				let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
				if (currentGoal > 0) {
					if (cdnAge > details.targetduration * 3) {
						this.log(`Playlist last advanced ${lastAdvanced.toFixed(2)}s ago. Omitting segment and part directives.`);
						msn = void 0;
						part = void 0;
					} else if (previousDetails != null && previousDetails.tuneInGoal && cdnAge - details.partTarget > previousDetails.tuneInGoal) {
						this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
						currentGoal = 0;
					} else {
						const segments = Math.floor(currentGoal / details.targetduration);
						msn += segments;
						if (part !== void 0) {
							const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
							part += parts;
						}
						this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
					}
					details.tuneInGoal = currentGoal;
				}
				deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
				if (lowLatencyMode || !atLastPartOfSegment) {
					details.requestScheduled = now;
					this.loadingPlaylist(levelOrTrack, deliveryDirectives);
					return;
				}
			} else if (details.canBlockReload || details.canSkipUntil) deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
			if (deliveryDirectives && msn !== void 0 && details.canBlockReload) details.requestScheduled = stats.loading.first + Math.max(reloadInterval - elapsed * 2, reloadInterval / 2);
			this.scheduleLoading(levelOrTrack, deliveryDirectives, details);
		} else this.clearTimer();
	}
	scheduleLoading(levelOrTrack, deliveryDirectives, updatedDetails) {
		const details = updatedDetails || levelOrTrack.details;
		if (!details) {
			this.loadingPlaylist(levelOrTrack, deliveryDirectives);
			return;
		}
		const now = self.performance.now();
		const requestScheduled = details.requestScheduled;
		if (now >= requestScheduled) {
			this.loadingPlaylist(levelOrTrack, deliveryDirectives);
			return;
		}
		const estimatedTimeUntilUpdate = requestScheduled - now;
		this.log(`reload live playlist ${levelOrTrack.name || levelOrTrack.bitrate + "bps"} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
		this.clearTimer();
		this.timer = self.setTimeout(() => this.loadingPlaylist(levelOrTrack, deliveryDirectives), estimatedTimeUntilUpdate);
	}
	getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
		let skip = getSkipValue(details);
		if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
			msn = previousDeliveryDirectives.msn;
			part = previousDeliveryDirectives.part;
			skip = HlsSkip.No;
		}
		return new HlsUrlParameters(msn, part, skip);
	}
	checkRetry(errorEvent) {
		const errorDetails = errorEvent.details;
		const isTimeout = isTimeoutError(errorEvent);
		const errorAction = errorEvent.errorAction;
		const { action, retryCount = 0, retryConfig } = errorAction || {};
		const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
		if (retry) {
			var _errorEvent$context;
			if (retryCount >= retryConfig.maxNumRetry) return false;
			if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
				this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
				this.loadPlaylist();
			} else {
				const delay = getRetryDelay(retryConfig, retryCount);
				this.clearTimer();
				this.timer = self.setTimeout(() => this.loadPlaylist(), delay);
				this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
			}
			errorEvent.levelRetry = true;
			errorAction.resolved = true;
		}
		return retry;
	}
};
function subtitleOptionsIdentical(trackList1, trackList2) {
	if (trackList1.length !== trackList2.length) return false;
	for (let i = 0; i < trackList1.length; i++) if (!mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) return false;
	return true;
}
function mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
	const stableRenditionId = attrs1["STABLE-RENDITION-ID"];
	if (stableRenditionId && !customAttributes) return stableRenditionId === attrs2["STABLE-RENDITION-ID"];
	return !(customAttributes || [
		"LANGUAGE",
		"NAME",
		"CHARACTERISTICS",
		"AUTOSELECT",
		"DEFAULT",
		"FORCED",
		"ASSOC-LANGUAGE"
	]).some((subtitleAttribute) => attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
	return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || "").toLowerCase());
}
var AudioTrackController = class extends BasePlaylistController {
	constructor(hls) {
		super(hls, "audio-track-controller");
		this.tracks = [];
		this.groupIds = null;
		this.tracksInGroup = [];
		this.trackId = -1;
		this.currentTrack = null;
		this.selectDefaultTrack = true;
		this.registerListeners();
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	destroy() {
		this.unregisterListeners();
		this.tracks.length = 0;
		this.tracksInGroup.length = 0;
		this.currentTrack = null;
		super.destroy();
	}
	onManifestLoading() {
		this.tracks = [];
		this.tracksInGroup = [];
		this.groupIds = null;
		this.currentTrack = null;
		this.trackId = -1;
		this.selectDefaultTrack = true;
	}
	onManifestParsed(event, data) {
		this.tracks = data.audioTracks || [];
	}
	onAudioTrackLoaded(event, data) {
		const { id, groupId, details } = data;
		const trackInActiveGroup = this.tracksInGroup[id];
		if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
			this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
			return;
		}
		const curDetails = trackInActiveGroup.details;
		trackInActiveGroup.details = data.details;
		this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
		if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
	}
	onLevelLoading(event, data) {
		this.switchLevel(data.level);
	}
	onLevelSwitching(event, data) {
		this.switchLevel(data.level);
	}
	switchLevel(levelIndex) {
		const levelInfo = this.hls.levels[levelIndex];
		if (!levelInfo) return;
		const audioGroups = levelInfo.audioGroups || null;
		const currentGroups = this.groupIds;
		let currentTrack = this.currentTrack;
		if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some((groupId) => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
			this.groupIds = audioGroups;
			this.trackId = -1;
			this.currentTrack = null;
			const audioTracks = this.tracks.filter((track) => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
			if (audioTracks.length) {
				if (this.selectDefaultTrack && !audioTracks.some((track) => track.default)) this.selectDefaultTrack = false;
				audioTracks.forEach((track, i) => {
					track.id = i;
				});
			} else if (!currentTrack && !this.tracksInGroup.length) return;
			this.tracksInGroup = audioTracks;
			const audioPreference = this.hls.config.audioPreference;
			if (!currentTrack && audioPreference) {
				const groupIndex = findMatchingOption(audioPreference, audioTracks, audioMatchPredicate);
				if (groupIndex > -1) currentTrack = audioTracks[groupIndex];
				else {
					const allIndex = findMatchingOption(audioPreference, this.tracks);
					currentTrack = this.tracks[allIndex];
				}
			}
			let trackId = this.findTrackId(currentTrack);
			if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
			const audioTracksUpdated = { audioTracks };
			this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(",")}`);
			this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
			const selectedTrackId = this.trackId;
			if (trackId !== -1 && selectedTrackId === -1) this.setAudioTrack(trackId);
			else if (audioTracks.length && selectedTrackId === -1) {
				var _this$groupIds;
				const error = /* @__PURE__ */ new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(",")} track count: ${audioTracks.length}`);
				this.warn(error.message);
				this.hls.trigger(Events.ERROR, {
					type: ErrorTypes.MEDIA_ERROR,
					details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
					fatal: true,
					error
				});
			}
		}
	}
	onError(event, data) {
		if (data.fatal || !data.context) return;
		if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
	}
	get allAudioTracks() {
		return this.tracks;
	}
	get audioTracks() {
		return this.tracksInGroup;
	}
	get audioTrack() {
		return this.trackId;
	}
	set audioTrack(newId) {
		this.selectDefaultTrack = false;
		this.setAudioTrack(newId);
	}
	setAudioOption(audioOption) {
		const hls = this.hls;
		hls.config.audioPreference = audioOption;
		if (audioOption) {
			const allAudioTracks = this.allAudioTracks;
			this.selectDefaultTrack = false;
			if (allAudioTracks.length) {
				const currentTrack = this.currentTrack;
				if (currentTrack && matchesOption(audioOption, currentTrack, audioMatchPredicate)) return currentTrack;
				const groupIndex = findMatchingOption(audioOption, this.tracksInGroup, audioMatchPredicate);
				if (groupIndex > -1) {
					const track = this.tracksInGroup[groupIndex];
					this.setAudioTrack(groupIndex);
					return track;
				} else if (currentTrack) {
					let searchIndex = hls.loadLevel;
					if (searchIndex === -1) searchIndex = hls.firstAutoLevel;
					const switchIndex = findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, audioMatchPredicate);
					if (switchIndex === -1) return null;
					hls.nextLoadLevel = switchIndex;
				}
				if (audioOption.channels || audioOption.audioCodec) {
					const withoutCodecAndChannelsMatch = findMatchingOption(audioOption, allAudioTracks);
					if (withoutCodecAndChannelsMatch > -1) return allAudioTracks[withoutCodecAndChannelsMatch];
				}
			}
		}
		return null;
	}
	setAudioTrack(newId) {
		const tracks = this.tracksInGroup;
		if (newId < 0 || newId >= tracks.length) {
			this.warn(`Invalid audio track id: ${newId}`);
			return;
		}
		this.selectDefaultTrack = false;
		const lastTrack = this.currentTrack;
		const track = tracks[newId];
		const trackLoaded = track.details && !track.details.live;
		if (newId === this.trackId && track === lastTrack && trackLoaded) return;
		this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
		this.trackId = newId;
		this.currentTrack = track;
		this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
		if (trackLoaded) return;
		const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
		this.loadPlaylist(hlsUrlParameters);
	}
	findTrackId(currentTrack) {
		const audioTracks = this.tracksInGroup;
		for (let i = 0; i < audioTracks.length; i++) {
			const track = audioTracks[i];
			if (this.selectDefaultTrack && !track.default) continue;
			if (!currentTrack || matchesOption(currentTrack, track, audioMatchPredicate)) return i;
		}
		if (currentTrack) {
			const { name, lang, assocLang, characteristics, audioCodec, channels } = currentTrack;
			for (let i = 0; i < audioTracks.length; i++) {
				const track = audioTracks[i];
				if (matchesOption({
					name,
					lang,
					assocLang,
					characteristics,
					audioCodec,
					channels
				}, track, audioMatchPredicate)) return i;
			}
			for (let i = 0; i < audioTracks.length; i++) {
				const track = audioTracks[i];
				if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
					"LANGUAGE",
					"ASSOC-LANGUAGE",
					"CHARACTERISTICS"
				])) return i;
			}
			for (let i = 0; i < audioTracks.length; i++) {
				const track = audioTracks[i];
				if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ["LANGUAGE"])) return i;
			}
		}
		return -1;
	}
	loadPlaylist(hlsUrlParameters) {
		super.loadPlaylist();
		const audioTrack = this.currentTrack;
		if (!this.shouldLoadPlaylist(audioTrack)) return;
		if (useAlternateAudio(audioTrack.url, this.hls)) this.scheduleLoading(audioTrack, hlsUrlParameters);
	}
	loadingPlaylist(audioTrack, hlsUrlParameters) {
		super.loadingPlaylist(audioTrack, hlsUrlParameters);
		const id = audioTrack.id;
		const groupId = audioTrack.groupId;
		const url = this.getUrlWithDirectives(audioTrack.url, hlsUrlParameters);
		const details = audioTrack.details;
		const age = details == null ? void 0 : details.age;
		this.log(`Loading audio-track ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== void 0 ? " at sn " + hlsUrlParameters.msn + " part " + hlsUrlParameters.part : ""}${age && details.live ? " age " + age.toFixed(1) + (details.type ? " " + details.type || "" : "") : ""} ${url}`);
		this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
			url,
			id,
			groupId,
			deliveryDirectives: hlsUrlParameters || null,
			track: audioTrack
		});
	}
};
var BufferOperationQueue = class {
	constructor(sourceBufferReference) {
		this.tracks = void 0;
		this.queues = {
			video: [],
			audio: [],
			audiovideo: []
		};
		this.tracks = sourceBufferReference;
	}
	destroy() {
		this.tracks = this.queues = null;
	}
	append(operation, type, pending) {
		if (this.queues === null || this.tracks === null) return;
		const queue = this.queues[type];
		queue.push(operation);
		if (queue.length === 1 && !pending) this.executeNext(type);
	}
	appendBlocker(type) {
		return new Promise((resolve) => {
			const operation = {
				label: "async-blocker",
				execute: resolve,
				onStart: () => {},
				onComplete: () => {},
				onError: () => {}
			};
			this.append(operation, type);
		});
	}
	prependBlocker(type) {
		return new Promise((resolve) => {
			if (this.queues) {
				const operation = {
					label: "async-blocker-prepend",
					execute: resolve,
					onStart: () => {},
					onComplete: () => {},
					onError: () => {}
				};
				this.queues[type].unshift(operation);
			}
		});
	}
	removeBlockers() {
		if (this.queues === null) return;
		[
			this.queues.video,
			this.queues.audio,
			this.queues.audiovideo
		].forEach((queue) => {
			var _queue$;
			const label = (_queue$ = queue[0]) == null ? void 0 : _queue$.label;
			if (label === "async-blocker" || label === "async-blocker-prepend") {
				queue[0].execute();
				queue.splice(0, 1);
			}
		});
	}
	unblockAudio(op) {
		if (this.queues === null) return;
		if (this.queues.audio[0] === op) this.shiftAndExecuteNext("audio");
	}
	executeNext(type) {
		if (this.queues === null || this.tracks === null) return;
		const queue = this.queues[type];
		if (queue.length) {
			const operation = queue[0];
			try {
				operation.execute();
			} catch (error) {
				var _this$tracks$type;
				operation.onError(error);
				if (this.queues === null || this.tracks === null) return;
				const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
				if (!(sb != null && sb.updating)) this.shiftAndExecuteNext(type);
			}
		}
	}
	shiftAndExecuteNext(type) {
		if (this.queues === null) return;
		this.queues[type].shift();
		this.executeNext(type);
	}
	current(type) {
		var _this$queues;
		return ((_this$queues = this.queues) == null ? void 0 : _this$queues[type][0]) || null;
	}
	toString() {
		const { queues, tracks } = this;
		if (queues === null || tracks === null) return `<destroyed>`;
		return `
${this.list("video")}
${this.list("audio")}
${this.list("audiovideo")}}`;
	}
	list(type) {
		var _this$queues2, _this$tracks;
		return (_this$queues2 = this.queues) != null && _this$queues2[type] || (_this$tracks = this.tracks) != null && _this$tracks[type] ? `${type}: (${this.listSbInfo(type)}) ${this.listOps(type)}` : "";
	}
	listSbInfo(type) {
		var _this$tracks2;
		const track = (_this$tracks2 = this.tracks) == null ? void 0 : _this$tracks2[type];
		const sb = track == null ? void 0 : track.buffer;
		if (!sb) return "none";
		return `SourceBuffer${sb.updating ? " updating" : ""}${track.ended ? " ended" : ""}${track.ending ? " ending" : ""}`;
	}
	listOps(type) {
		var _this$queues3;
		return ((_this$queues3 = this.queues) == null ? void 0 : _this$queues3[type].map((op) => op.label).join(", ")) || "";
	}
};
var VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
var TRACK_REMOVED_ERROR_NAME = "HlsJsTrackRemovedError";
var HlsJsTrackRemovedError = class extends Error {
	constructor(message) {
		super(message);
		this.name = TRACK_REMOVED_ERROR_NAME;
	}
};
var BufferController = class extends Logger {
	constructor(hls, fragmentTracker) {
		super("buffer-controller", hls.logger);
		this.hls = void 0;
		this.fragmentTracker = void 0;
		this.details = null;
		this._objectUrl = null;
		this.operationQueue = null;
		this.bufferCodecEventsTotal = 0;
		this.media = null;
		this.mediaSource = null;
		this.lastMpegAudioChunk = null;
		this.blockedAudioAppend = null;
		this.lastVideoAppendEnd = 0;
		this.appendSource = void 0;
		this.transferData = void 0;
		this.overrides = void 0;
		this.appendErrors = {
			audio: 0,
			video: 0,
			audiovideo: 0
		};
		this.tracks = {};
		this.sourceBuffers = [[null, null], [null, null]];
		this._onEndStreaming = (event) => {
			var _this$mediaSource;
			if (!this.hls) return;
			if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) !== "open") return;
			this.hls.pauseBuffering();
		};
		this._onStartStreaming = (event) => {
			if (!this.hls) return;
			this.hls.resumeBuffering();
		};
		this._onMediaSourceOpen = (e) => {
			const { media, mediaSource } = this;
			if (e) this.log("Media source opened");
			if (!media || !mediaSource) return;
			mediaSource.removeEventListener("sourceopen", this._onMediaSourceOpen);
			media.removeEventListener("emptied", this._onMediaEmptied);
			this.updateDuration();
			this.hls.trigger(Events.MEDIA_ATTACHED, {
				media,
				mediaSource
			});
			if (this.mediaSource !== null) this.checkPendingTracks();
		};
		this._onMediaSourceClose = () => {
			this.log("Media source closed");
		};
		this._onMediaSourceEnded = () => {
			this.log("Media source ended");
		};
		this._onMediaEmptied = () => {
			const { mediaSrc, _objectUrl } = this;
			if (mediaSrc !== _objectUrl) this.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
		};
		this.hls = hls;
		this.fragmentTracker = fragmentTracker;
		this.appendSource = isManagedMediaSource(getMediaSource(hls.config.preferManagedMediaSource));
		this.initTracks();
		this.registerListeners();
	}
	hasSourceTypes() {
		return Object.keys(this.tracks).length > 0;
	}
	destroy() {
		this.unregisterListeners();
		this.details = null;
		this.lastMpegAudioChunk = this.blockedAudioAppend = null;
		this.transferData = this.overrides = void 0;
		if (this.operationQueue) {
			this.operationQueue.destroy();
			this.operationQueue = null;
		}
		this.hls = this.fragmentTracker = null;
		this._onMediaSourceOpen = this._onMediaSourceClose = null;
		this._onMediaSourceEnded = null;
		this._onStartStreaming = this._onEndStreaming = null;
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
		hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
		hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
		hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
		hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
		hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
		hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
		hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
		hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
		hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
		hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
		hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
		hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
		hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
		hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	transferMedia() {
		const { media, mediaSource } = this;
		if (!media) return null;
		const tracks = {};
		if (this.operationQueue) {
			const updating = this.isUpdating();
			if (!updating) this.operationQueue.removeBlockers();
			const queued = this.isQueued();
			if (updating || queued) this.warn(`Transfering MediaSource with${queued ? " operations in queue" : ""}${updating ? " updating SourceBuffer(s)" : ""} ${this.operationQueue}`);
			this.operationQueue.destroy();
		}
		const transferData = this.transferData;
		if (!this.sourceBufferCount && transferData && transferData.mediaSource === mediaSource) _extends(tracks, transferData.tracks);
		else this.sourceBuffers.forEach((tuple) => {
			const [type] = tuple;
			if (type) {
				tracks[type] = _extends({}, this.tracks[type]);
				this.removeBuffer(type);
			}
			tuple[0] = tuple[1] = null;
		});
		return {
			media,
			mediaSource,
			tracks
		};
	}
	initTracks() {
		const tracks = {};
		this.sourceBuffers = [[null, null], [null, null]];
		this.tracks = tracks;
		this.resetQueue();
		this.resetAppendErrors();
		this.lastMpegAudioChunk = this.blockedAudioAppend = null;
		this.lastVideoAppendEnd = 0;
	}
	onManifestLoading() {
		this.bufferCodecEventsTotal = 0;
		this.details = null;
	}
	onManifestParsed(event, data) {
		var _this$transferData;
		let codecEvents = 2;
		if (data.audio && !data.video || !data.altAudio) codecEvents = 1;
		this.bufferCodecEventsTotal = codecEvents;
		this.log(`${codecEvents} bufferCodec event(s) expected.`);
		if ((_this$transferData = this.transferData) != null && _this$transferData.mediaSource && this.sourceBufferCount && codecEvents) this.bufferCreated();
	}
	onMediaAttaching(event, data) {
		const media = this.media = data.media;
		this.transferData = this.overrides = void 0;
		const MediaSource = getMediaSource(this.appendSource);
		if (MediaSource) {
			const transferringMedia = !!data.mediaSource;
			if (transferringMedia || data.overrides) {
				this.transferData = data;
				this.overrides = data.overrides;
			}
			const ms = this.mediaSource = data.mediaSource || new MediaSource();
			this.assignMediaSource(ms);
			if (transferringMedia) {
				this._objectUrl = media.src;
				this.attachTransferred();
			} else {
				const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
				if (this.appendSource) try {
					media.removeAttribute("src");
					const MMS = self.ManagedMediaSource;
					media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
					removeSourceChildren(media);
					addSource(media, objectUrl);
					media.load();
				} catch (error) {
					media.src = objectUrl;
				}
				else media.src = objectUrl;
			}
			media.addEventListener("emptied", this._onMediaEmptied);
		}
	}
	assignMediaSource(ms) {
		var _this$transferData2, _ms$constructor;
		this.log(`${((_this$transferData2 = this.transferData) == null ? void 0 : _this$transferData2.mediaSource) === ms ? "transferred" : "created"} media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
		ms.addEventListener("sourceopen", this._onMediaSourceOpen);
		ms.addEventListener("sourceended", this._onMediaSourceEnded);
		ms.addEventListener("sourceclose", this._onMediaSourceClose);
		if (this.appendSource) {
			ms.addEventListener("startstreaming", this._onStartStreaming);
			ms.addEventListener("endstreaming", this._onEndStreaming);
		}
	}
	attachTransferred() {
		const media = this.media;
		const data = this.transferData;
		if (!data || !media) return;
		const requiredTracks = this.tracks;
		const transferredTracks = data.tracks;
		const trackNames = transferredTracks ? Object.keys(transferredTracks) : null;
		const trackCount = trackNames ? trackNames.length : 0;
		const mediaSourceOpenCallback = () => {
			Promise.resolve().then(() => {
				if (this.media && this.mediaSourceOpenOrEnded) this._onMediaSourceOpen();
			});
		};
		if (transferredTracks && trackNames && trackCount) {
			if (!this.tracksReady) {
				this.hls.config.startFragPrefetch = true;
				this.log(`attachTransferred: waiting for SourceBuffer track info`);
				return;
			}
			this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${stringify(requiredTracks, (key, value) => key === "initSegment" ? void 0 : value)};
transfer tracks: ${stringify(transferredTracks, (key, value) => key === "initSegment" ? void 0 : value)}}`);
			if (!isCompatibleTrackChange(transferredTracks, requiredTracks)) {
				data.mediaSource = null;
				data.tracks = void 0;
				const currentTime = media.currentTime;
				const details = this.details;
				const startTime = Math.max(currentTime, (details == null ? void 0 : details.fragments[0].start) || 0);
				if (startTime - currentTime > 1) {
					this.log(`attachTransferred: waiting for playback to reach new tracks start time ${currentTime} -> ${startTime}`);
					return;
				}
				this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(transferredTracks)}"->"${Object.keys(requiredTracks)}") start time: ${startTime} currentTime: ${currentTime}`);
				this.onMediaDetaching(Events.MEDIA_DETACHING, {});
				this.onMediaAttaching(Events.MEDIA_ATTACHING, data);
				media.currentTime = startTime;
				return;
			}
			this.transferData = void 0;
			trackNames.forEach((trackName) => {
				const type = trackName;
				const track = transferredTracks[type];
				if (track) {
					const sb = track.buffer;
					if (sb) {
						const fragmentTracker = this.fragmentTracker;
						const playlistType = track.id;
						if (fragmentTracker.hasFragments(playlistType) || fragmentTracker.hasParts(playlistType)) {
							const bufferedTimeRanges = BufferHelper.getBuffered(sb);
							fragmentTracker.detectEvictedFragments(type, bufferedTimeRanges, playlistType, null, true);
						}
						const sbIndex = sourceBufferNameToIndex(type);
						const sbTuple = [type, sb];
						this.sourceBuffers[sbIndex] = sbTuple;
						if (sb.updating && this.operationQueue) this.operationQueue.prependBlocker(type);
						this.trackSourceBuffer(type, track);
					}
				}
			});
			mediaSourceOpenCallback();
			this.bufferCreated();
		} else {
			this.log(`attachTransferred: MediaSource w/o SourceBuffers`);
			mediaSourceOpenCallback();
		}
	}
	get mediaSourceOpenOrEnded() {
		var _this$mediaSource2;
		const readyState = (_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState;
		return readyState === "open" || readyState === "ended";
	}
	onMediaDetaching(event, data) {
		const transferringMedia = !!data.transferMedia;
		this.transferData = this.overrides = void 0;
		const { media, mediaSource, _objectUrl } = this;
		if (mediaSource) {
			this.log(`media source ${transferringMedia ? "transferring" : "detaching"}`);
			if (transferringMedia) {
				this.sourceBuffers.forEach(([type]) => {
					if (type) this.removeBuffer(type);
				});
				this.resetQueue();
			} else {
				if (this.mediaSourceOpenOrEnded) {
					const open = mediaSource.readyState === "open";
					try {
						const sourceBuffers = mediaSource.sourceBuffers;
						for (let i = sourceBuffers.length; i--;) {
							if (open) sourceBuffers[i].abort();
							mediaSource.removeSourceBuffer(sourceBuffers[i]);
						}
						if (open) mediaSource.endOfStream();
					} catch (err) {
						this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
					}
				}
				if (this.sourceBufferCount) this.onBufferReset();
			}
			mediaSource.removeEventListener("sourceopen", this._onMediaSourceOpen);
			mediaSource.removeEventListener("sourceended", this._onMediaSourceEnded);
			mediaSource.removeEventListener("sourceclose", this._onMediaSourceClose);
			if (this.appendSource) {
				mediaSource.removeEventListener("startstreaming", this._onStartStreaming);
				mediaSource.removeEventListener("endstreaming", this._onEndStreaming);
			}
			this.mediaSource = null;
			this._objectUrl = null;
		}
		if (media) {
			media.removeEventListener("emptied", this._onMediaEmptied);
			if (!transferringMedia) {
				if (_objectUrl) self.URL.revokeObjectURL(_objectUrl);
				if (this.mediaSrc === _objectUrl) {
					media.removeAttribute("src");
					if (this.appendSource) removeSourceChildren(media);
					media.load();
				} else this.warn("media|source.src was changed by a third party - skip cleanup");
			}
			this.media = null;
		}
		this.hls.trigger(Events.MEDIA_DETACHED, data);
	}
	onBufferReset() {
		this.sourceBuffers.forEach(([type]) => {
			if (type) this.resetBuffer(type);
		});
		this.initTracks();
	}
	resetBuffer(type) {
		var _this$tracks$type;
		const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
		this.removeBuffer(type);
		if (sb) try {
			var _this$mediaSource3;
			if ((_this$mediaSource3 = this.mediaSource) != null && _this$mediaSource3.sourceBuffers.length) this.mediaSource.removeSourceBuffer(sb);
		} catch (err) {
			this.warn(`onBufferReset ${type}`, err);
		}
		delete this.tracks[type];
	}
	removeBuffer(type) {
		this.removeBufferListeners(type);
		this.sourceBuffers[sourceBufferNameToIndex(type)] = [null, null];
		const track = this.tracks[type];
		if (track) track.buffer = void 0;
	}
	resetQueue() {
		if (this.operationQueue) this.operationQueue.destroy();
		this.operationQueue = new BufferOperationQueue(this.tracks);
	}
	onBufferCodecs(event, data) {
		var _data$audio;
		const tracks = this.tracks;
		const trackNames = Object.keys(data);
		this.log(`BUFFER_CODECS: "${trackNames}" (current SB count ${this.sourceBufferCount})`);
		const unmuxedToMuxed = "audiovideo" in data && (tracks.audio || tracks.video) || tracks.audiovideo && ("audio" in data || "video" in data);
		const muxedToUnmuxed = !unmuxedToMuxed && this.sourceBufferCount && this.media && trackNames.some((sbName) => !tracks[sbName]);
		if (unmuxedToMuxed || muxedToUnmuxed) {
			this.warn(`Unsupported transition between "${Object.keys(tracks)}" and "${trackNames}" SourceBuffers`);
			return;
		}
		trackNames.forEach((trackName) => {
			var _this$transferData3, _trackCodec;
			const { id, codec, levelCodec, container, metadata, supplemental } = data[trackName];
			let track = tracks[trackName];
			const transferredTrack = (_this$transferData3 = this.transferData) == null || (_this$transferData3 = _this$transferData3.tracks) == null ? void 0 : _this$transferData3[trackName];
			const sbTrack = transferredTrack != null && transferredTrack.buffer ? transferredTrack : track;
			const sbCodec = (sbTrack == null ? void 0 : sbTrack.pendingCodec) || (sbTrack == null ? void 0 : sbTrack.codec);
			const trackLevelCodec = sbTrack == null ? void 0 : sbTrack.levelCodec;
			if (!track) track = tracks[trackName] = {
				buffer: void 0,
				listeners: [],
				codec,
				supplemental,
				container,
				levelCodec,
				metadata,
				id
			};
			const currentCodecFull = pickMostCompleteCodecName(sbCodec, trackLevelCodec);
			const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE, "$1");
			let trackCodec = pickMostCompleteCodecName(codec, levelCodec);
			const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE, "$1");
			if (trackCodec && currentCodecFull && currentCodec !== nextCodec) {
				if (trackName.slice(0, 5) === "audio") trackCodec = getCodecCompatibleName(trackCodec, this.appendSource);
				this.log(`switching codec ${sbCodec} to ${trackCodec}`);
				if (trackCodec !== (track.pendingCodec || track.codec)) track.pendingCodec = trackCodec;
				track.container = container;
				this.appendChangeType(trackName, container, trackCodec);
			}
		});
		if (this.tracksReady || this.sourceBufferCount) data.tracks = this.sourceBufferTracks;
		if (this.sourceBufferCount) return;
		if (this.bufferCodecEventsTotal > 1 && !this.tracks.video && !data.video && ((_data$audio = data.audio) == null ? void 0 : _data$audio.id) === "main") {
			this.log(`Main audio-only`);
			this.bufferCodecEventsTotal = 1;
		}
		if (this.mediaSourceOpenOrEnded) this.checkPendingTracks();
	}
	get sourceBufferTracks() {
		return Object.keys(this.tracks).reduce((baseTracks, type) => {
			const track = this.tracks[type];
			baseTracks[type] = {
				id: track.id,
				container: track.container,
				codec: track.codec,
				levelCodec: track.levelCodec
			};
			return baseTracks;
		}, {});
	}
	appendChangeType(type, container, codec) {
		const mimeType = `${container};codecs=${codec}`;
		const operation = {
			label: `change-type=${mimeType}`,
			execute: () => {
				const track = this.tracks[type];
				if (track) {
					const sb = track.buffer;
					if (sb != null && sb.changeType) {
						this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
						sb.changeType(mimeType);
						track.codec = codec;
						track.container = container;
					}
				}
				this.shiftAndExecuteNext(type);
			},
			onStart: () => {},
			onComplete: () => {},
			onError: (error) => {
				this.warn(`Failed to change ${type} SourceBuffer type`, error);
			}
		};
		this.append(operation, type, this.isPending(this.tracks[type]));
	}
	blockAudio(partOrFrag) {
		var _this$fragmentTracker;
		const pStart = partOrFrag.start;
		const pTime = pStart + partOrFrag.duration * .05;
		if (((_this$fragmentTracker = this.fragmentTracker.getAppendedFrag(pStart, PlaylistLevelType.MAIN)) == null ? void 0 : _this$fragmentTracker.gap) === true) return;
		const op = {
			label: "block-audio",
			execute: () => {
				var _this$fragmentTracker2;
				const videoTrack = this.tracks.video;
				if (this.lastVideoAppendEnd > pTime || videoTrack != null && videoTrack.buffer && BufferHelper.isBuffered(videoTrack.buffer, pTime) || ((_this$fragmentTracker2 = this.fragmentTracker.getAppendedFrag(pTime, PlaylistLevelType.MAIN)) == null ? void 0 : _this$fragmentTracker2.gap) === true) {
					this.blockedAudioAppend = null;
					this.shiftAndExecuteNext("audio");
				}
			},
			onStart: () => {},
			onComplete: () => {},
			onError: (error) => {
				this.warn("Error executing block-audio operation", error);
			}
		};
		this.blockedAudioAppend = {
			op,
			frag: partOrFrag
		};
		this.append(op, "audio", true);
	}
	unblockAudio() {
		const { blockedAudioAppend, operationQueue } = this;
		if (blockedAudioAppend && operationQueue) {
			this.blockedAudioAppend = null;
			operationQueue.unblockAudio(blockedAudioAppend.op);
		}
	}
	onBufferAppending(event, eventData) {
		const { tracks } = this;
		const { data, type, parent, frag, part, chunkMeta, offset } = eventData;
		const chunkStats = chunkMeta.buffering[type];
		const { sn, cc } = frag;
		const bufferAppendingStart = self.performance.now();
		chunkStats.start = bufferAppendingStart;
		const fragBuffering = frag.stats.buffering;
		const partBuffering = part ? part.stats.buffering : null;
		if (fragBuffering.start === 0) fragBuffering.start = bufferAppendingStart;
		if (partBuffering && partBuffering.start === 0) partBuffering.start = bufferAppendingStart;
		const audioTrack = tracks.audio;
		let checkTimestampOffset = false;
		if (type === "audio" && (audioTrack == null ? void 0 : audioTrack.container) === "audio/mpeg") {
			checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
			this.lastMpegAudioChunk = chunkMeta;
		}
		const videoTrack = tracks.video;
		const videoSb = videoTrack == null ? void 0 : videoTrack.buffer;
		if (videoSb && sn !== "initSegment") {
			const partOrFrag = part || frag;
			const blockedAudioAppend = this.blockedAudioAppend;
			if (type === "audio" && parent !== "main" && !this.blockedAudioAppend && !(videoTrack.ending || videoTrack.ended)) {
				const pTime = partOrFrag.start + partOrFrag.duration * .05;
				const vbuffered = videoSb.buffered;
				const vappending = this.currentOp("video");
				if (!vbuffered.length && !vappending) this.blockAudio(partOrFrag);
				else if (!vappending && !BufferHelper.isBuffered(videoSb, pTime) && this.lastVideoAppendEnd < pTime) this.blockAudio(partOrFrag);
			} else if (type === "video") {
				const videoAppendEnd = partOrFrag.end;
				if (blockedAudioAppend) {
					const audioStart = blockedAudioAppend.frag.start;
					if (videoAppendEnd > audioStart || videoAppendEnd < this.lastVideoAppendEnd || BufferHelper.isBuffered(videoSb, audioStart)) this.unblockAudio();
				}
				this.lastVideoAppendEnd = videoAppendEnd;
			}
		}
		const fragStart = (part || frag).start;
		const operation = {
			label: `append-${type}`,
			execute: () => {
				var _this$tracks$type2;
				chunkStats.executeStart = self.performance.now();
				const sb = (_this$tracks$type2 = this.tracks[type]) == null ? void 0 : _this$tracks$type2.buffer;
				if (sb) {
					if (checkTimestampOffset) this.updateTimestampOffset(sb, fragStart, .1, type, sn, cc);
					else if (offset !== void 0 && isFiniteNumber(offset)) this.updateTimestampOffset(sb, offset, 1e-6, type, sn, cc);
				}
				this.appendExecutor(data, type);
			},
			onStart: () => {},
			onComplete: () => {
				const end = self.performance.now();
				chunkStats.executeEnd = chunkStats.end = end;
				if (fragBuffering.first === 0) fragBuffering.first = end;
				if (partBuffering && partBuffering.first === 0) partBuffering.first = end;
				const timeRanges = {};
				this.sourceBuffers.forEach(([type, sb]) => {
					if (type) timeRanges[type] = BufferHelper.getBuffered(sb);
				});
				this.appendErrors[type] = 0;
				if (type === "audio" || type === "video") this.appendErrors.audiovideo = 0;
				else {
					this.appendErrors.audio = 0;
					this.appendErrors.video = 0;
				}
				this.hls.trigger(Events.BUFFER_APPENDED, {
					type,
					frag,
					part,
					chunkMeta,
					parent: frag.type,
					timeRanges
				});
			},
			onError: (error) => {
				var _this$media;
				const event = {
					type: ErrorTypes.MEDIA_ERROR,
					parent: frag.type,
					details: ErrorDetails.BUFFER_APPEND_ERROR,
					sourceBufferName: type,
					frag,
					part,
					chunkMeta,
					error,
					err: error,
					fatal: false
				};
				const mediaError = (_this$media = this.media) == null ? void 0 : _this$media.error;
				if (error.code === DOMException.QUOTA_EXCEEDED_ERR || error.name == "QuotaExceededError" || `quota` in error) event.details = ErrorDetails.BUFFER_FULL_ERROR;
				else if (error.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !mediaError) event.errorAction = createDoNothingErrorAction(true);
				else if (error.name === TRACK_REMOVED_ERROR_NAME && this.sourceBufferCount === 0) event.errorAction = createDoNothingErrorAction(true);
				else {
					const appendErrorCount = ++this.appendErrors[type];
					this.warn(`Failed ${appendErrorCount}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer (${mediaError ? mediaError : "no media error"})`);
					if (appendErrorCount >= this.hls.config.appendErrorMaxRetry || !!mediaError) event.fatal = true;
				}
				this.hls.trigger(Events.ERROR, event);
			}
		};
		this.log(`queuing "${type}" append sn: ${sn}${part ? " p: " + part.index : ""} of ${frag.type === PlaylistLevelType.MAIN ? "level" : "track"} ${frag.level} cc: ${cc}`);
		this.append(operation, type, this.isPending(this.tracks[type]));
	}
	getFlushOp(type, start, end) {
		this.log(`queuing "${type}" remove ${start}-${end}`);
		return {
			label: "remove",
			execute: () => {
				this.removeExecutor(type, start, end);
			},
			onStart: () => {},
			onComplete: () => {
				this.hls.trigger(Events.BUFFER_FLUSHED, { type });
			},
			onError: (error) => {
				this.warn(`Failed to remove ${start}-${end} from "${type}" SourceBuffer`, error);
			}
		};
	}
	onBufferFlushing(event, data) {
		const { type, startOffset, endOffset } = data;
		if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
		else this.sourceBuffers.forEach(([type]) => {
			if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
		});
	}
	onFragParsed(event, data) {
		const { frag, part } = data;
		const buffersAppendedTo = [];
		const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
		if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) buffersAppendedTo.push("audiovideo");
		else {
			if (elementaryStreams[ElementaryStreamTypes.AUDIO]) buffersAppendedTo.push("audio");
			if (elementaryStreams[ElementaryStreamTypes.VIDEO]) buffersAppendedTo.push("video");
		}
		const onUnblocked = () => {
			const now = self.performance.now();
			frag.stats.buffering.end = now;
			if (part) part.stats.buffering.end = now;
			const stats = part ? part.stats : frag.stats;
			this.hls.trigger(Events.FRAG_BUFFERED, {
				frag,
				part,
				stats,
				id: frag.type
			});
		};
		if (buffersAppendedTo.length === 0) this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
		this.blockBuffers(onUnblocked, buffersAppendedTo).catch((error) => {
			this.warn(`Fragment buffered callback ${error}`);
			this.stepOperationQueue(this.sourceBufferTypes);
		});
	}
	onFragChanged(event, data) {
		this.trimBuffers();
	}
	get bufferedToEnd() {
		return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type]) => {
			if (type) {
				const track = this.tracks[type];
				if (track) return !track.ended || track.ending;
			}
			return false;
		});
	}
	onBufferEos(event, data) {
		var _this$overrides;
		this.sourceBuffers.forEach(([type]) => {
			if (type) {
				const track = this.tracks[type];
				if (!data.type || data.type === type) {
					track.ending = true;
					if (!track.ended) {
						track.ended = true;
						this.log(`${type} buffer reached EOS`);
					}
				}
			}
		});
		const allowEndOfStream = ((_this$overrides = this.overrides) == null ? void 0 : _this$overrides.endOfStream) !== false;
		if (this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type]) => {
			var _this$tracks$type3;
			return type && !((_this$tracks$type3 = this.tracks[type]) != null && _this$tracks$type3.ended);
		})) if (allowEndOfStream) {
			this.log(`Queueing EOS`);
			this.blockUntilOpen(() => {
				this.tracksEnded();
				const { mediaSource } = this;
				if (!mediaSource || mediaSource.readyState !== "open") {
					if (mediaSource) this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
					return;
				}
				this.log(`Calling mediaSource.endOfStream()`);
				mediaSource.endOfStream();
				this.hls.trigger(Events.BUFFERED_TO_END, void 0);
			});
		} else {
			this.tracksEnded();
			this.hls.trigger(Events.BUFFERED_TO_END, void 0);
		}
		else if (data.type === "video") this.unblockAudio();
	}
	tracksEnded() {
		this.sourceBuffers.forEach(([type]) => {
			if (type !== null) {
				const track = this.tracks[type];
				if (track) track.ending = false;
			}
		});
	}
	onLevelUpdated(event, { details }) {
		if (!details.fragments.length) return;
		this.details = details;
		this.updateDuration();
	}
	updateDuration() {
		this.blockUntilOpen(() => {
			const durationAndRange = this.getDurationAndRange();
			if (!durationAndRange) return;
			this.updateMediaSource(durationAndRange);
		});
	}
	onError(event, data) {
		if (data.details === ErrorDetails.BUFFER_APPEND_ERROR && data.frag) {
			var _data$errorAction;
			const nextAutoLevel = (_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.nextAutoLevel;
			if (isFiniteNumber(nextAutoLevel) && nextAutoLevel !== data.frag.level) this.resetAppendErrors();
		}
	}
	resetAppendErrors() {
		this.appendErrors = {
			audio: 0,
			video: 0,
			audiovideo: 0
		};
	}
	trimBuffers() {
		const { hls, details, media } = this;
		if (!media || details === null) return;
		if (!this.sourceBufferCount) return;
		const config = hls.config;
		const currentTime = media.currentTime;
		const targetDuration = details.levelTargetDuration;
		const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
		if (isFiniteNumber(backBufferLength) && backBufferLength >= 0) {
			const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
			const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
			this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
		}
		const frontBufferFlushThreshold = config.frontBufferFlushThreshold;
		if (isFiniteNumber(frontBufferFlushThreshold) && frontBufferFlushThreshold > 0) {
			const frontBufferLength = Math.max(config.maxBufferLength, frontBufferFlushThreshold);
			const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
			const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
			this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
		}
	}
	flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
		this.sourceBuffers.forEach(([type, sb]) => {
			if (sb) {
				const buffered = BufferHelper.getBuffered(sb);
				if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
					var _this$details;
					this.hls.trigger(Events.BACK_BUFFER_REACHED, { bufferEnd: targetBackBufferPosition });
					const track = this.tracks[type];
					if ((_this$details = this.details) != null && _this$details.live) this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, { bufferEnd: targetBackBufferPosition });
					else if (track != null && track.ended) {
						this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
						return;
					}
					this.hls.trigger(Events.BUFFER_FLUSHING, {
						startOffset: 0,
						endOffset: targetBackBufferPosition,
						type
					});
				}
			}
		});
	}
	flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
		this.sourceBuffers.forEach(([type, sb]) => {
			if (sb) {
				const buffered = BufferHelper.getBuffered(sb);
				const numBufferedRanges = buffered.length;
				if (numBufferedRanges < 2) return;
				const bufferStart = buffered.start(numBufferedRanges - 1);
				const bufferEnd = buffered.end(numBufferedRanges - 1);
				if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) return;
				this.hls.trigger(Events.BUFFER_FLUSHING, {
					startOffset: bufferStart,
					endOffset: Infinity,
					type
				});
			}
		});
	}
	/**
	* Update Media Source duration to current level duration or override to Infinity if configuration parameter
	* 'liveDurationInfinity` is set to `true`
	* More details: https://github.com/video-dev/hls.js/issues/355
	*/
	getDurationAndRange() {
		var _this$overrides2;
		const { details, mediaSource } = this;
		if (!details || !this.media || (mediaSource == null ? void 0 : mediaSource.readyState) !== "open") return null;
		const playlistEnd = details.edge;
		if (details.live && this.hls.config.liveDurationInfinity) {
			if (details.fragments.length && !!mediaSource.setLiveSeekableRange) {
				const start = Math.max(0, details.fragmentStart);
				return {
					duration: Infinity,
					start,
					end: Math.max(start, playlistEnd)
				};
			}
			return { duration: Infinity };
		}
		const overrideDuration = (_this$overrides2 = this.overrides) == null ? void 0 : _this$overrides2.duration;
		if (overrideDuration) {
			if (!isFiniteNumber(overrideDuration)) return null;
			return { duration: overrideDuration };
		}
		const mediaDuration = this.media.duration;
		if (playlistEnd > (isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0) && playlistEnd > mediaDuration || !isFiniteNumber(mediaDuration)) return { duration: playlistEnd };
		return null;
	}
	updateMediaSource({ duration, start, end }) {
		const mediaSource = this.mediaSource;
		if (!this.media || !mediaSource || mediaSource.readyState !== "open") return;
		if (mediaSource.duration !== duration) {
			if (isFiniteNumber(duration)) this.log(`Updating MediaSource duration to ${duration.toFixed(3)}`);
			mediaSource.duration = duration;
		}
		if (start !== void 0 && end !== void 0) {
			this.log(`MediaSource duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
			mediaSource.setLiveSeekableRange(start, end);
		}
	}
	get tracksReady() {
		const pendingTrackCount = this.pendingTrackCount;
		return pendingTrackCount > 0 && (pendingTrackCount >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
	}
	checkPendingTracks() {
		const { bufferCodecEventsTotal, pendingTrackCount, tracks } = this;
		this.log(`checkPendingTracks (pending: ${pendingTrackCount} codec events expected: ${bufferCodecEventsTotal}) ${stringify(tracks)}`);
		if (this.tracksReady) {
			var _this$transferData4;
			const transferredTracks = (_this$transferData4 = this.transferData) == null ? void 0 : _this$transferData4.tracks;
			if (transferredTracks && Object.keys(transferredTracks).length) this.attachTransferred();
			else this.createSourceBuffers();
		}
	}
	bufferCreated() {
		if (this.sourceBufferCount) {
			const tracks = {};
			this.sourceBuffers.forEach(([type, buffer]) => {
				if (type) {
					const track = this.tracks[type];
					tracks[type] = {
						buffer,
						container: track.container,
						codec: track.codec,
						supplemental: track.supplemental,
						levelCodec: track.levelCodec,
						id: track.id,
						metadata: track.metadata
					};
				}
			});
			this.hls.trigger(Events.BUFFER_CREATED, { tracks });
			this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`);
			this.sourceBuffers.forEach(([type]) => {
				this.executeNext(type);
			});
		} else {
			const error = /* @__PURE__ */ new Error("could not create source buffer for media codec(s)");
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
				fatal: true,
				error,
				reason: error.message
			});
		}
	}
	createSourceBuffers() {
		const { tracks, sourceBuffers, mediaSource } = this;
		if (!mediaSource) throw new Error("createSourceBuffers called when mediaSource was null");
		for (const trackName in tracks) {
			const type = trackName;
			const track = tracks[type];
			if (this.isPending(track)) {
				const codec = this.getTrackCodec(track, type);
				const mimeType = `${track.container};codecs=${codec}`;
				track.codec = codec;
				this.log(`creating sourceBuffer(${mimeType})${this.currentOp(type) ? " Queued" : ""} ${stringify(track)}`);
				try {
					const sb = mediaSource.addSourceBuffer(mimeType);
					const sbIndex = sourceBufferNameToIndex(type);
					sourceBuffers[sbIndex] = [type, sb];
					track.buffer = sb;
				} catch (error) {
					var _this$operationQueue;
					this.error(`error while trying to add sourceBuffer: ${error.message}`);
					this.shiftAndExecuteNext(type);
					(_this$operationQueue = this.operationQueue) == null || _this$operationQueue.removeBlockers();
					delete this.tracks[type];
					this.hls.trigger(Events.ERROR, {
						type: ErrorTypes.MEDIA_ERROR,
						details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
						fatal: false,
						error,
						sourceBufferName: type,
						mimeType,
						parent: track.id
					});
					return;
				}
				this.trackSourceBuffer(type, track);
			}
		}
		this.bufferCreated();
	}
	getTrackCodec(track, trackName) {
		const supplementalCodec = track.supplemental;
		let trackCodec = track.codec;
		if (supplementalCodec && (trackName === "video" || trackName === "audiovideo") && areCodecsMediaSourceSupported(supplementalCodec, "video")) trackCodec = replaceVideoCodec(trackCodec, supplementalCodec);
		const codec = pickMostCompleteCodecName(trackCodec, track.levelCodec);
		if (codec) {
			if (trackName.slice(0, 5) === "audio") return getCodecCompatibleName(codec, this.appendSource);
			return codec;
		}
		return "";
	}
	trackSourceBuffer(type, track) {
		const buffer = track.buffer;
		if (!buffer) return;
		const codec = this.getTrackCodec(track, type);
		this.tracks[type] = {
			buffer,
			codec,
			container: track.container,
			levelCodec: track.levelCodec,
			supplemental: track.supplemental,
			metadata: track.metadata,
			id: track.id,
			listeners: []
		};
		this.removeBufferListeners(type);
		this.addBufferListener(type, "updatestart", this.onSBUpdateStart);
		this.addBufferListener(type, "updateend", this.onSBUpdateEnd);
		this.addBufferListener(type, "error", this.onSBUpdateError);
		if (this.appendSource) this.addBufferListener(type, "bufferedchange", (type, event) => {
			const removedRanges = event.removedRanges;
			if (removedRanges != null && removedRanges.length) this.hls.trigger(Events.BUFFER_FLUSHED, { type });
		});
	}
	get mediaSrc() {
		var _this$media2, _this$media2$querySel;
		const media = ((_this$media2 = this.media) == null || (_this$media2$querySel = _this$media2.querySelector) == null ? void 0 : _this$media2$querySel.call(_this$media2, "source")) || this.media;
		return media == null ? void 0 : media.src;
	}
	onSBUpdateStart(type) {
		const operation = this.currentOp(type);
		if (!operation) return;
		operation.onStart();
	}
	onSBUpdateEnd(type) {
		var _this$mediaSource4;
		if (((_this$mediaSource4 = this.mediaSource) == null ? void 0 : _this$mediaSource4.readyState) === "closed") {
			this.resetBuffer(type);
			return;
		}
		const operation = this.currentOp(type);
		if (!operation) return;
		operation.onComplete();
		this.shiftAndExecuteNext(type);
	}
	onSBUpdateError(type, event) {
		var _this$mediaSource5;
		const error = /* @__PURE__ */ new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource5 = this.mediaSource) == null ? void 0 : _this$mediaSource5.readyState}`);
		this.error(`${error}`, event);
		this.hls.trigger(Events.ERROR, {
			type: ErrorTypes.MEDIA_ERROR,
			details: ErrorDetails.BUFFER_APPENDING_ERROR,
			sourceBufferName: type,
			error,
			fatal: false
		});
		const operation = this.currentOp(type);
		if (operation) operation.onError(error);
	}
	updateTimestampOffset(sb, timestampOffset, tolerance, type, sn, cc) {
		const delta = timestampOffset - sb.timestampOffset;
		if (Math.abs(delta) >= tolerance) {
			this.log(`Updating ${type} SourceBuffer timestampOffset to ${timestampOffset} (sn: ${sn} cc: ${cc})`);
			sb.timestampOffset = timestampOffset;
		}
	}
	removeExecutor(type, startOffset, endOffset) {
		const { media, mediaSource } = this;
		const track = this.tracks[type];
		const sb = track == null ? void 0 : track.buffer;
		if (!media || !mediaSource || !sb) {
			this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
			this.shiftAndExecuteNext(type);
			return;
		}
		const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
		const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
		const removeStart = Math.max(0, startOffset);
		const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
		if (removeEnd > removeStart && (!track.ending || track.ended)) {
			track.ended = false;
			this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
			sb.remove(removeStart, removeEnd);
		} else this.shiftAndExecuteNext(type);
	}
	appendExecutor(data, type) {
		const track = this.tracks[type];
		const sb = track == null ? void 0 : track.buffer;
		if (!sb) throw new HlsJsTrackRemovedError(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
		track.ending = false;
		track.ended = false;
		sb.appendBuffer(data);
	}
	blockUntilOpen(callback) {
		if (this.isUpdating() || this.isQueued()) this.blockBuffers(callback).catch((error) => {
			this.warn(`SourceBuffer blocked callback ${error}`);
			this.stepOperationQueue(this.sourceBufferTypes);
		});
		else try {
			callback();
		} catch (error) {
			this.warn(`Callback run without blocking ${this.operationQueue} ${error}`);
		}
	}
	isUpdating() {
		return this.sourceBuffers.some(([type, sb]) => type && sb.updating);
	}
	isQueued() {
		return this.sourceBuffers.some(([type]) => type && !!this.currentOp(type));
	}
	isPending(track) {
		return !!track && !track.buffer;
	}
	blockBuffers(onUnblocked, bufferNames = this.sourceBufferTypes) {
		if (!bufferNames.length) {
			this.log("Blocking operation requested, but no SourceBuffers exist");
			return Promise.resolve().then(onUnblocked);
		}
		const { operationQueue } = this;
		const blockingOperations = bufferNames.map((type) => this.appendBlocker(type));
		if (bufferNames.length > 1 && !!this.blockedAudioAppend) this.unblockAudio();
		return Promise.all(blockingOperations).then((result) => {
			if (operationQueue !== this.operationQueue) return;
			onUnblocked();
			this.stepOperationQueue(this.sourceBufferTypes);
		});
	}
	stepOperationQueue(bufferNames) {
		bufferNames.forEach((type) => {
			var _this$tracks$type4;
			const sb = (_this$tracks$type4 = this.tracks[type]) == null ? void 0 : _this$tracks$type4.buffer;
			if (!sb || sb.updating) return;
			this.shiftAndExecuteNext(type);
		});
	}
	append(operation, type, pending) {
		if (this.operationQueue) this.operationQueue.append(operation, type, pending);
	}
	appendBlocker(type) {
		if (this.operationQueue) return this.operationQueue.appendBlocker(type);
	}
	currentOp(type) {
		if (this.operationQueue) return this.operationQueue.current(type);
		return null;
	}
	executeNext(type) {
		if (type && this.operationQueue) this.operationQueue.executeNext(type);
	}
	shiftAndExecuteNext(type) {
		if (this.operationQueue) this.operationQueue.shiftAndExecuteNext(type);
	}
	get pendingTrackCount() {
		return Object.keys(this.tracks).reduce((acc, type) => acc + (this.isPending(this.tracks[type]) ? 1 : 0), 0);
	}
	get sourceBufferCount() {
		return this.sourceBuffers.reduce((acc, [type]) => acc + (type ? 1 : 0), 0);
	}
	get sourceBufferTypes() {
		return this.sourceBuffers.map(([type]) => type).filter((type) => !!type);
	}
	addBufferListener(type, event, fn) {
		const track = this.tracks[type];
		if (!track) return;
		const buffer = track.buffer;
		if (!buffer) return;
		const listener = fn.bind(this, type);
		track.listeners.push({
			event,
			listener
		});
		buffer.addEventListener(event, listener);
	}
	removeBufferListeners(type) {
		const track = this.tracks[type];
		if (!track) return;
		const buffer = track.buffer;
		if (!buffer) return;
		track.listeners.forEach((l) => {
			buffer.removeEventListener(l.event, l.listener);
		});
		track.listeners.length = 0;
	}
};
function removeSourceChildren(node) {
	const sourceChildren = node.querySelectorAll("source");
	[].slice.call(sourceChildren).forEach((source) => {
		node.removeChild(source);
	});
}
function addSource(media, url) {
	const source = self.document.createElement("source");
	source.type = "video/mp4";
	source.src = url;
	media.appendChild(source);
}
function sourceBufferNameToIndex(type) {
	return type === "audio" ? 1 : 0;
}
var CapLevelController = class CapLevelController {
	constructor(hls) {
		this.hls = void 0;
		this.autoLevelCapping = void 0;
		this.firstLevel = void 0;
		this.media = void 0;
		this.restrictedLevels = void 0;
		this.timer = void 0;
		this.clientRect = void 0;
		this.streamController = void 0;
		this.hls = hls;
		this.autoLevelCapping = Number.POSITIVE_INFINITY;
		this.firstLevel = -1;
		this.media = null;
		this.restrictedLevels = [];
		this.timer = void 0;
		this.clientRect = null;
		this.registerListeners();
	}
	setStreamController(streamController) {
		this.streamController = streamController;
	}
	destroy() {
		if (this.hls) this.unregisterListener();
		if (this.timer) this.stopCapping();
		this.media = null;
		this.clientRect = null;
		this.hls = this.streamController = null;
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
		hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
	}
	unregisterListener() {
		const { hls } = this;
		hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
		hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
	}
	onFpsDropLevelCapping(event, data) {
		const level = this.hls.levels[data.droppedLevel];
		if (this.isLevelAllowed(level)) this.restrictedLevels.push({
			bitrate: level.bitrate,
			height: level.height,
			width: level.width
		});
	}
	onMediaAttaching(event, data) {
		this.media = data.media instanceof HTMLVideoElement ? data.media : null;
		this.clientRect = null;
		if (this.timer && this.hls.levels.length) this.detectPlayerSize();
	}
	onManifestParsed(event, data) {
		const hls = this.hls;
		this.restrictedLevels = [];
		this.firstLevel = data.firstLevel;
		if (hls.config.capLevelToPlayerSize && data.video) this.startCapping();
	}
	onLevelsUpdated(event, data) {
		if (this.timer && isFiniteNumber(this.autoLevelCapping)) this.detectPlayerSize();
	}
	onBufferCodecs(event, data) {
		if (this.hls.config.capLevelToPlayerSize && data.video) this.startCapping();
	}
	onMediaDetaching() {
		this.stopCapping();
		this.media = null;
	}
	detectPlayerSize() {
		if (this.media) {
			if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
				this.clientRect = null;
				return;
			}
			const levels = this.hls.levels;
			if (levels.length) {
				const hls = this.hls;
				const maxLevel = this.getMaxLevel(levels.length - 1);
				if (maxLevel !== this.autoLevelCapping) hls.logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
				hls.autoLevelCapping = maxLevel;
				if (hls.autoLevelEnabled && hls.autoLevelCapping > this.autoLevelCapping && this.streamController) this.streamController.nextLevelSwitch();
				this.autoLevelCapping = hls.autoLevelCapping;
			}
		}
	}
	getMaxLevel(capLevelIndex) {
		const levels = this.hls.levels;
		if (!levels.length) return -1;
		const validLevels = levels.filter((level, index) => this.isLevelAllowed(level) && index <= capLevelIndex);
		this.clientRect = null;
		return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
	}
	startCapping() {
		if (this.timer) return;
		this.autoLevelCapping = Number.POSITIVE_INFINITY;
		self.clearInterval(this.timer);
		this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3);
		this.detectPlayerSize();
	}
	stopCapping() {
		this.restrictedLevels = [];
		this.firstLevel = -1;
		this.autoLevelCapping = Number.POSITIVE_INFINITY;
		if (this.timer) {
			self.clearInterval(this.timer);
			this.timer = void 0;
		}
	}
	getDimensions() {
		if (this.clientRect) return this.clientRect;
		const media = this.media;
		const boundsRect = {
			width: 0,
			height: 0
		};
		if (media) {
			const clientRect = media.getBoundingClientRect();
			boundsRect.width = clientRect.width;
			boundsRect.height = clientRect.height;
			if (!boundsRect.width && !boundsRect.height) {
				boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
				boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
			}
		}
		this.clientRect = boundsRect;
		return boundsRect;
	}
	get mediaWidth() {
		return this.getDimensions().width * this.contentScaleFactor;
	}
	get mediaHeight() {
		return this.getDimensions().height * this.contentScaleFactor;
	}
	get contentScaleFactor() {
		let pixelRatio = 1;
		if (!this.hls.config.ignoreDevicePixelRatio) try {
			pixelRatio = self.devicePixelRatio;
		} catch (e) {}
		return Math.min(pixelRatio, this.hls.config.maxDevicePixelRatio);
	}
	isLevelAllowed(level) {
		return !this.restrictedLevels.some((restrictedLevel) => {
			return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
		});
	}
	static getMaxLevelByMediaSize(levels, width, height) {
		if (!(levels != null && levels.length)) return -1;
		const atGreatestBandwidth = (curLevel, nextLevel) => {
			if (!nextLevel) return true;
			return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
		};
		let maxLevelIndex = levels.length - 1;
		const squareSize = Math.max(width, height);
		for (let i = 0; i < levels.length; i += 1) {
			const level = levels[i];
			if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
				maxLevelIndex = i;
				break;
			}
		}
		return maxLevelIndex;
	}
};
/**
* Common Media Client Data Object Type
*
* @group CMCD
*
* @beta
*
* @enum
*/
var CmcdObjectType = {
	/**
	* text file, such as a manifest or playlist
	*/
	MANIFEST: "m",
	/**
	* audio only
	*/
	AUDIO: "a",
	/**
	* video only
	*/
	VIDEO: "v",
	/**
	* muxed audio and video
	*/
	MUXED: "av",
	/**
	* init segment
	*/
	INIT: "i",
	/**
	* caption or subtitle
	*/
	CAPTION: "c",
	/**
	* ISOBMFF timed text track
	*/
	TIMED_TEXT: "tt",
	/**
	* cryptographic key, license or certificate.
	*/
	KEY: "k",
	/**
	* other
	*/
	OTHER: "o"
};
/**
* Common Media Client Data Streaming Format
*
* @group CMCD
*
* @enum
*
* @beta
*/
var CmcdStreamingFormat = { 
/**
* HTTP Live Streaming (HLS)
*/
HLS: "h" };
/**
* Structured Field Item
*
* @group Structured Field
*
* @beta
*/
var SfItem = class SfItem {
	constructor(value, params) {
		if (Array.isArray(value)) value = value.map((v) => v instanceof SfItem ? v : new SfItem(v));
		this.value = value;
		this.params = params;
	}
};
var DICT = "Dict";
function format(value) {
	if (Array.isArray(value)) return JSON.stringify(value);
	if (value instanceof Map) return "Map{}";
	if (value instanceof Set) return "Set{}";
	if (typeof value === "object") return JSON.stringify(value);
	return String(value);
}
function throwError(action, src, type, cause) {
	return new Error(`failed to ${action} "${format(src)}" as ${type}`, { cause });
}
function serializeError(src, type, cause) {
	return throwError("serialize", src, type, cause);
}
/**
* A class to represent structured field tokens when `Symbol` is not available.
*
* @group Structured Field
*
* @beta
*/
var SfToken = class {
	constructor(description) {
		this.description = description;
	}
};
var BARE_ITEM = "Bare Item";
var BOOLEAN = "Boolean";
function serializeBoolean(value) {
	if (typeof value !== "boolean") throw serializeError(value, BOOLEAN);
	return value ? "?1" : "?0";
}
/**
* Encodes binary data to base64
*
* @param binary - The binary data to encode
* @returns The base64 encoded string
*
* @group Utils
*
* @beta
*/
function encodeBase64(binary) {
	return btoa(String.fromCharCode(...binary));
}
var BYTES = "Byte Sequence";
function serializeByteSequence(value) {
	if (ArrayBuffer.isView(value) === false) throw serializeError(value, BYTES);
	return `:${encodeBase64(value)}:`;
}
var INTEGER = "Integer";
function isInvalidInt(value) {
	return value < -999999999999999 || 999999999999999 < value;
}
function serializeInteger(value) {
	if (isInvalidInt(value)) throw serializeError(value, INTEGER);
	return value.toString();
}
function serializeDate(value) {
	return `@${serializeInteger(value.getTime() / 1e3)}`;
}
/**
* This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
* This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
*
* @param value - The value to round
* @param precision - The number of decimal places to round to
* @returns The rounded value
*
* @group Utils
*
* @beta
*/
function roundToEven(value, precision) {
	if (value < 0) return -roundToEven(-value, precision);
	const decimalShift = Math.pow(10, precision);
	if (Math.abs(value * decimalShift % 1 - .5) < Number.EPSILON) {
		const flooredValue = Math.floor(value * decimalShift);
		return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
	} else return Math.round(value * decimalShift) / decimalShift;
}
var DECIMAL = "Decimal";
function serializeDecimal(value) {
	const roundedValue = roundToEven(value, 3);
	if (Math.floor(Math.abs(roundedValue)).toString().length > 12) throw serializeError(value, DECIMAL);
	const stringValue = roundedValue.toString();
	return stringValue.includes(".") ? stringValue : `${stringValue}.0`;
}
var STRING = "String";
var STRING_REGEX = /[\x00-\x1f\x7f]+/;
function serializeString$1(value) {
	if (STRING_REGEX.test(value)) throw serializeError(value, STRING);
	return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}
/**
* Converts a symbol to a string.
*
* @param symbol - The symbol to convert.
*
* @returns The string representation of the symbol.
*
* @internal
*/
function symbolToStr(symbol) {
	return symbol.description || symbol.toString().slice(7, -1);
}
var TOKEN = "Token";
function serializeToken(token) {
	const value = symbolToStr(token);
	if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) throw serializeError(value, TOKEN);
	return value;
}
function serializeBareItem(value) {
	switch (typeof value) {
		case "number":
			if (!isFiniteNumber(value)) throw serializeError(value, BARE_ITEM);
			if (Number.isInteger(value)) return serializeInteger(value);
			return serializeDecimal(value);
		case "string": return serializeString$1(value);
		case "symbol": return serializeToken(value);
		case "boolean": return serializeBoolean(value);
		case "object":
			if (value instanceof Date) return serializeDate(value);
			if (value instanceof Uint8Array) return serializeByteSequence(value);
			if (value instanceof SfToken) return serializeToken(value);
		default: throw serializeError(value, BARE_ITEM);
	}
}
var KEY = "Key";
function serializeKey(value) {
	if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) throw serializeError(value, KEY);
	return value;
}
function serializeParams(params) {
	if (params == null) return "";
	return Object.entries(params).map(([key, value]) => {
		if (value === true) return `;${serializeKey(key)}`;
		return `;${serializeKey(key)}=${serializeBareItem(value)}`;
	}).join("");
}
function serializeItem(value) {
	if (value instanceof SfItem) return `${serializeBareItem(value.value)}${serializeParams(value.params)}`;
	else return serializeBareItem(value);
}
function serializeInnerList(value) {
	return `(${value.value.map(serializeItem).join(" ")})${serializeParams(value.params)}`;
}
function serializeDict(dict, options = { whitespace: true }) {
	if (typeof dict !== "object" || dict == null) throw serializeError(dict, DICT);
	const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
	const optionalWhiteSpace = (options === null || options === void 0 ? void 0 : options.whitespace) ? " " : "";
	return Array.from(entries).map(([key, item]) => {
		if (item instanceof SfItem === false) item = new SfItem(item);
		let output = serializeKey(key);
		if (item.value === true) output += serializeParams(item.params);
		else {
			output += "=";
			if (Array.isArray(item.value)) output += serializeInnerList(item);
			else output += serializeItem(item);
		}
		return output;
	}).join(`,${optionalWhiteSpace}`);
}
/**
* Encode an object into a structured field dictionary
*
* @param value - The structured field dictionary to encode
* @param options - Encoding options
*
* @returns The structured field string
*
* @group Structured Field
*
* @beta
*/
function encodeSfDict(value, options) {
	return serializeDict(value, options);
}
/**
* CMCD object header name.
*
* @group CMCD
*
* @beta
*/
var CMCD_OBJECT = "CMCD-Object";
/**
* CMCD request header name.
*
* @group CMCD
*
* @beta
*/
var CMCD_REQUEST = "CMCD-Request";
/**
* CMCD session header name.
*
* @group CMCD
*
* @beta
*/
var CMCD_SESSION = "CMCD-Session";
/**
* CMCD status header name.
*
* @group CMCD
*
* @beta
*/
var CMCD_STATUS = "CMCD-Status";
/**
* The map of CMCD keys to their appropriate header shard.
*
* @group CMCD
*
* @internal
*/
var CMCD_HEADER_MAP = {
	br: CMCD_OBJECT,
	ab: CMCD_OBJECT,
	d: CMCD_OBJECT,
	ot: CMCD_OBJECT,
	tb: CMCD_OBJECT,
	tpb: CMCD_OBJECT,
	lb: CMCD_OBJECT,
	tab: CMCD_OBJECT,
	lab: CMCD_OBJECT,
	url: CMCD_OBJECT,
	pb: CMCD_REQUEST,
	bl: CMCD_REQUEST,
	tbl: CMCD_REQUEST,
	dl: CMCD_REQUEST,
	ltc: CMCD_REQUEST,
	mtp: CMCD_REQUEST,
	nor: CMCD_REQUEST,
	nrr: CMCD_REQUEST,
	rc: CMCD_REQUEST,
	sn: CMCD_REQUEST,
	sta: CMCD_REQUEST,
	su: CMCD_REQUEST,
	ttfb: CMCD_REQUEST,
	ttfbb: CMCD_REQUEST,
	ttlb: CMCD_REQUEST,
	cmsdd: CMCD_REQUEST,
	cmsds: CMCD_REQUEST,
	smrt: CMCD_REQUEST,
	df: CMCD_REQUEST,
	cs: CMCD_REQUEST,
	ts: CMCD_REQUEST,
	cid: CMCD_SESSION,
	pr: CMCD_SESSION,
	sf: CMCD_SESSION,
	sid: CMCD_SESSION,
	st: CMCD_SESSION,
	v: CMCD_SESSION,
	msd: CMCD_SESSION,
	bs: CMCD_STATUS,
	bsd: CMCD_STATUS,
	cdn: CMCD_STATUS,
	rtp: CMCD_STATUS,
	bg: CMCD_STATUS,
	pt: CMCD_STATUS,
	ec: CMCD_STATUS,
	e: CMCD_STATUS
};
/**
* CMCD header fields.
*
* @group CMCD
*
* @enum
*
* @beta
*/
var CmcdHeaderField = { 
/**
* keys whose values vary with each request.
*/
REQUEST: CMCD_REQUEST };
function createHeaderMap(headerMap) {
	return Object.keys(headerMap).reduce((acc, field) => {
		var _a;
		(_a = headerMap[field]) === null || _a === void 0 || _a.forEach((key) => acc[key] = field);
		return acc;
	}, {});
}
/**
* Group a CMCD data object into header shards
*
* @param cmcd - The CMCD data object to convert.
* @param customHeaderMap - A map of CMCD header fields to custom CMCD keys.
*
* @returns The CMCD header shards.
*
* @group CMCD
*
* @beta
*/
function groupCmcdHeaders(cmcd, customHeaderMap) {
	const result = {};
	if (!cmcd) return result;
	const keys = Object.keys(cmcd);
	const custom = customHeaderMap ? createHeaderMap(customHeaderMap) : {};
	return keys.reduce((acc, key) => {
		var _a;
		const field = CMCD_HEADER_MAP[key] || custom[key] || CmcdHeaderField.REQUEST;
		const data = (_a = acc[field]) !== null && _a !== void 0 ? _a : acc[field] = {};
		data[key] = cmcd[key];
		return acc;
	}, result);
}
/**
* Checks if the given key is a token field.
*
* @param key - The key to check.
*
* @returns `true` if the key is a token field.
*
* @internal
*/
function isTokenField(key) {
	return [
		"ot",
		"sf",
		"st",
		"e",
		"sta"
	].includes(key);
}
/**
* Checks if the given value is valid
*
* @param value - The value to check.
*
* @returns `true` if the key is a value is valid.
*
* @internal
*/
function isValid(value) {
	if (typeof value === "number") return isFiniteNumber(value);
	return value != null && value !== "" && value !== false;
}
/**
* CMCD event mode variable name.
*
* @group CMCD
*
* @beta
*/
var CMCD_EVENT_MODE = "event";
/**
* Constructs a relative path from a URL.
*
* @param url - The destination URL
* @param base - The base URL
* @returns The relative path
*
* @group Utils
*
* @beta
*/
function urlToRelativePath(url, base) {
	const to = new URL(url);
	const from = new URL(base);
	if (to.origin !== from.origin) return url;
	const toPath = to.pathname.split("/").slice(1);
	const fromPath = from.pathname.split("/").slice(1, -1);
	while (toPath[0] === fromPath[0]) {
		toPath.shift();
		fromPath.shift();
	}
	while (fromPath.length) {
		fromPath.shift();
		toPath.unshift("..");
	}
	return toPath.join("/") + to.search + to.hash;
}
var toRounded = (value) => Math.round(value);
var toUrlSafe = (value, options) => {
	if (Array.isArray(value)) return value.map((item) => toUrlSafe(item, options));
	if (value instanceof SfItem && typeof value.value === "string") return new SfItem(toUrlSafe(value.value, options), value.params);
	else {
		if (options.baseUrl) value = urlToRelativePath(value, options.baseUrl);
		return options.version === 1 ? encodeURIComponent(value) : value;
	}
};
var toHundred = (value) => toRounded(value / 100) * 100;
var nor = (value, options) => {
	let norValue = value;
	if (options.version >= 2) {
		if (value instanceof SfItem && typeof value.value === "string") norValue = new SfItem([value]);
		else if (typeof value === "string") norValue = [value];
	}
	return toUrlSafe(norValue, options);
};
/**
* The default formatters for CMCD values.
*
* @group CMCD
*
* @beta
*/
var CMCD_FORMATTER_MAP = {
	/**
	* Bitrate (kbps) rounded integer
	*/
	br: toRounded,
	/**
	* Duration (milliseconds) rounded integer
	*/
	d: toRounded,
	/**
	* Buffer Length (milliseconds) rounded nearest 100ms
	*/
	bl: toHundred,
	/**
	* Deadline (milliseconds) rounded nearest 100ms
	*/
	dl: toHundred,
	/**
	* Measured Throughput (kbps) rounded nearest 100kbps
	*/
	mtp: toHundred,
	/**
	* Next Object Request URL encoded
	*/
	nor,
	/**
	* Requested maximum throughput (kbps) rounded nearest 100kbps
	*/
	rtp: toHundred,
	/**
	* Top Bitrate (kbps) rounded integer
	*/
	tb: toRounded
};
/**
* CMCD request mode variable name.
*
* @group CMCD
*
* @beta
*/
var CMCD_REQUEST_MODE = "request";
/**
* CMCD response mode variable name.
*
* @group CMCD
*
* @beta
*/
var CMCD_RESPONSE_MODE = "response";
/**
* Defines the common keys for CMCD (Common Media Client Data) version 2.
*
* @group CMCD
*
* @beta
*/
var CMCD_COMMON_KEYS = [
	"ab",
	"bg",
	"bl",
	"br",
	"bs",
	"bsd",
	"cdn",
	"cid",
	"cs",
	"df",
	"ec",
	"lab",
	"lb",
	"ltc",
	"msd",
	"mtp",
	"pb",
	"pr",
	"pt",
	"sf",
	"sid",
	"sn",
	"st",
	"sta",
	"tab",
	"tb",
	"tbl",
	"tpb",
	"ts",
	"v"
];
/**
* Defines the event-specific keys for CMCD (Common Media Client Data) version 2.
*
* @group CMCD
*
* @beta
*/
var CMCD_EVENT_KEYS = ["e"];
var CUSTOM_KEY_REGEX = /^[a-zA-Z0-9-.]+-[a-zA-Z0-9-.]+$/;
/**
* Check if a key is a custom key.
*
* @param key - The key to check.
*
* @returns `true` if the key is a custom key, `false` otherwise.
*
* @group CMCD
*
* @beta
*/
function isCmcdCustomKey(key) {
	return CUSTOM_KEY_REGEX.test(key);
}
/**
* Check if a key is a valid CMCD event key.
*
* @param key - The key to check.
*
* @returns `true` if the key is a valid CMCD event key, `false` otherwise.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/isCmcdEventKey.test.ts#example}
*/
function isCmcdEventKey(key) {
	return CMCD_COMMON_KEYS.includes(key) || CMCD_EVENT_KEYS.includes(key) || isCmcdCustomKey(key);
}
/**
* Defines the request-specific keys for CMCD (Common Media Client Data) version 2.
*
* @group CMCD
*
* @beta
*/
var CMCD_REQUEST_KEYS = [
	"d",
	"dl",
	"nor",
	"ot",
	"rtp",
	"su"
];
/**
* Check if a key is a valid CMCD request key.
*
* @param key - The key to check.
*
* @returns `true` if the key is a valid CMCD request key, `false` otherwise.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/isCmcdRequestKey.test.ts#example}
*/
function isCmcdRequestKey(key) {
	return CMCD_COMMON_KEYS.includes(key) || CMCD_REQUEST_KEYS.includes(key) || isCmcdCustomKey(key);
}
/**
* CMCD v2 - Response-only and timing keys.
*
* @group CMCD
*
* @beta
*/
var CMCD_RESPONSE_KEYS = [
	"cmsdd",
	"cmsds",
	"rc",
	"smrt",
	"ttfb",
	"ttfbb",
	"ttlb",
	"url"
];
/**
* Check if a key is a valid CMCD response key.
*
* @param key - The key to check.
*
* @returns `true` if the key is a valid CMCD request key, `false` otherwise.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/isCmcdResponseKey.test.ts#example}
*/
function isCmcdResponseKey(key) {
	return CMCD_COMMON_KEYS.includes(key) || CMCD_REQUEST_KEYS.includes(key) || CMCD_RESPONSE_KEYS.includes(key) || isCmcdCustomKey(key);
}
/**
* Defines the keys for CMCD (Common Media Client Data) version 1.
*
* @group CMCD
*
* @beta
*/
var CMCD_V1_KEYS = [
	"bl",
	"br",
	"bs",
	"cid",
	"d",
	"dl",
	"mtp",
	"nor",
	"nrr",
	"ot",
	"pr",
	"rtp",
	"sf",
	"sid",
	"st",
	"su",
	"tb",
	"v"
];
/**
* Filter function for CMCD v1 keys.
*
* @param key - The CMCD key to filter.
*
* @returns `true` if the key should be included, `false` otherwise.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/isCmcdV1Key.test.ts#example}
*/
function isCmcdV1Key(key) {
	return CMCD_V1_KEYS.includes(key) || isCmcdCustomKey(key);
}
var filterMap = {
	[CMCD_RESPONSE_MODE]: isCmcdResponseKey,
	[CMCD_EVENT_MODE]: isCmcdEventKey,
	[CMCD_REQUEST_MODE]: isCmcdRequestKey
};
/**
* Convert a generic object to CMCD data.
*
* @param obj - The CMCD object to process.
* @param options - Options for encoding.
*
* @group CMCD
*
* @beta
*/
function prepareCmcdData(obj, options = {}) {
	const results = {};
	if (obj == null || typeof obj !== "object") return results;
	const version = options.version || obj["v"] || 1;
	const reportingMode = options.reportingMode || CMCD_REQUEST_MODE;
	const keyFilter = version === 1 ? isCmcdV1Key : filterMap[reportingMode];
	let keys = Object.keys(obj).filter(keyFilter);
	const filter = options.filter;
	if (typeof filter === "function") keys = keys.filter(filter);
	const needsTimestamp = reportingMode === CMCD_RESPONSE_MODE || reportingMode === CMCD_EVENT_MODE;
	if (needsTimestamp && !keys.includes("ts")) keys.push("ts");
	if (version > 1 && !keys.includes("v")) keys.push("v");
	const formatters = _extends({}, CMCD_FORMATTER_MAP, options.formatters);
	const formatterOptions = {
		version,
		reportingMode,
		baseUrl: options.baseUrl
	};
	keys.sort().forEach((key) => {
		let value = obj[key];
		const formatter = formatters[key];
		if (typeof formatter === "function") value = formatter(value, formatterOptions);
		if (key === "v") if (version === 1) return;
		else value = version;
		if (key == "pr" && value === 1) return;
		if (needsTimestamp && key === "ts" && !isFiniteNumber(value)) value = Date.now();
		if (!isValid(value)) return;
		if (isTokenField(key) && typeof value === "string") value = new SfToken(value);
		results[key] = value;
	});
	return results;
}
/**
* Convert a CMCD data object to request headers
*
* @param cmcd - The CMCD data object to convert.
* @param options - Options for encoding the CMCD object.
*
* @returns The CMCD header shards.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/toCmcdHeaders.test.ts#example}
*/
function toCmcdHeaders(cmcd, options = {}) {
	const result = {};
	if (!cmcd) return result;
	const shards = groupCmcdHeaders(prepareCmcdData(cmcd, options), options === null || options === void 0 ? void 0 : options.customHeaderMap);
	return Object.entries(shards).reduce((acc, [field, value]) => {
		const shard = encodeSfDict(value, { whitespace: false });
		if (shard) acc[field] = shard;
		return acc;
	}, result);
}
/**
* Append CMCD query args to a header object.
*
* @param headers - The headers to append to.
* @param cmcd - The CMCD object to append.
* @param options - Encode options.
*
* @returns The headers with the CMCD header shards appended.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/appendCmcdHeaders.test.ts#example}
*/
function appendCmcdHeaders(headers, cmcd, options) {
	return _extends(headers, toCmcdHeaders(cmcd, options));
}
/**
* CMCD parameter name.
*
* @group CMCD
*
* @beta
*/
var CMCD_PARAM = "CMCD";
/**
* Encode a CMCD object to a string.
*
* @param cmcd - The CMCD object to encode.
* @param options - Options for encoding.
*
* @returns The encoded CMCD string.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/encodeCmcd.test.ts#example}
*/
function encodeCmcd(cmcd, options = {}) {
	if (!cmcd) return "";
	return encodeSfDict(prepareCmcdData(cmcd, options), { whitespace: false });
}
/**
* Convert a CMCD data object to a URL encoded string.
*
* @param cmcd - The CMCD object to convert.
* @param options - Options for encoding the CMCD object.
*
* @returns The URL encoded CMCD data.
*
* @group CMCD
*
* @beta
*/
function toCmcdUrl(cmcd, options = {}) {
	if (!cmcd) return "";
	const params = encodeCmcd(cmcd, options);
	return encodeURIComponent(params);
}
/**
* Convert a CMCD data object to a query arg.
*
* @param cmcd - The CMCD object to convert.
* @param options - Options for encoding the CMCD object.
*
* @returns The CMCD query arg.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/toCmcdQuery.test.ts#example}
*/
function toCmcdQuery(cmcd, options = {}) {
	if (!cmcd) return "";
	return `${CMCD_PARAM}=${toCmcdUrl(cmcd, options)}`;
}
var REGEX = /CMCD=[^&#]+/;
/**
* Append CMCD query args to a URL.
*
* @param url - The URL to append to.
* @param cmcd - The CMCD object to append.
* @param options - Options for encoding the CMCD object.
*
* @returns The URL with the CMCD query args appended.
*
* @group CMCD
*
* @beta
*
* @example
* {@includeCode ../../test/cmcd/appendCmcdQuery.test.ts#example}
*/
function appendCmcdQuery(url, cmcd, options) {
	const query = toCmcdQuery(cmcd, options);
	if (!query) return url;
	if (REGEX.test(url)) return url.replace(REGEX, query);
	return `${url}${url.includes("?") ? "&" : "?"}${query}`;
}
/**
* Controller to deal with Common Media Client Data (CMCD)
* @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
*/
var CMCDController = class {
	constructor(hls) {
		this.hls = void 0;
		this.config = void 0;
		this.media = void 0;
		this.sid = void 0;
		this.cid = void 0;
		this.useHeaders = false;
		this.includeKeys = void 0;
		this.initialized = false;
		this.starved = false;
		this.buffering = true;
		this.audioBuffer = void 0;
		this.videoBuffer = void 0;
		this.onWaiting = () => {
			if (this.initialized) this.starved = true;
			this.buffering = true;
		};
		this.onPlaying = () => {
			if (!this.initialized) this.initialized = true;
			this.buffering = false;
		};
		/**
		* Apply CMCD data to a manifest request.
		*/
		this.applyPlaylistData = (context) => {
			try {
				this.apply(context, {
					ot: CmcdObjectType.MANIFEST,
					su: !this.initialized
				});
			} catch (error) {
				this.hls.logger.warn("Could not generate manifest CMCD data.", error);
			}
		};
		/**
		* Apply CMCD data to a segment request
		*/
		this.applyFragmentData = (context) => {
			try {
				const { frag, part } = context;
				const level = this.hls.levels[frag.level];
				const ot = this.getObjectType(frag);
				const data = {
					d: (part || frag).duration * 1e3,
					ot
				};
				if (ot === CmcdObjectType.VIDEO || ot === CmcdObjectType.AUDIO || ot == CmcdObjectType.MUXED) {
					data.br = level.bitrate / 1e3;
					data.tb = this.getTopBandwidth(ot) / 1e3;
					data.bl = this.getBufferLength(ot);
				}
				const next = part ? this.getNextPart(part) : this.getNextFrag(frag);
				if (next != null && next.url && next.url !== frag.url) data.nor = next.url;
				this.apply(context, data);
			} catch (error) {
				this.hls.logger.warn("Could not generate segment CMCD data.", error);
			}
		};
		this.hls = hls;
		const config = this.config = hls.config;
		const { cmcd } = config;
		if (cmcd != null) {
			config.pLoader = this.createPlaylistLoader();
			config.fLoader = this.createFragmentLoader();
			this.sid = cmcd.sessionId || hls.sessionId;
			this.cid = cmcd.contentId;
			this.useHeaders = cmcd.useHeaders === true;
			this.includeKeys = cmcd.includeKeys;
			this.registerListeners();
		}
	}
	registerListeners() {
		const hls = this.hls;
		hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
		hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
	}
	unregisterListeners() {
		const hls = this.hls;
		hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
		hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
	}
	destroy() {
		this.unregisterListeners();
		this.onMediaDetached();
		this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
		this.onWaiting = this.onPlaying = this.media = null;
	}
	onMediaAttached(event, data) {
		this.media = data.media;
		this.media.addEventListener("waiting", this.onWaiting);
		this.media.addEventListener("playing", this.onPlaying);
	}
	onMediaDetached() {
		if (!this.media) return;
		this.media.removeEventListener("waiting", this.onWaiting);
		this.media.removeEventListener("playing", this.onPlaying);
		this.media = null;
	}
	onBufferCreated(event, data) {
		var _data$tracks$audio, _data$tracks$video;
		this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
		this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
	}
	/**
	* Create baseline CMCD data
	*/
	createData() {
		var _this$media;
		return {
			v: 1,
			sf: CmcdStreamingFormat.HLS,
			sid: this.sid,
			cid: this.cid,
			pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
			mtp: this.hls.bandwidthEstimate / 1e3
		};
	}
	/**
	* Apply CMCD data to a request.
	*/
	apply(context, data = {}) {
		_extends(data, this.createData());
		const isVideo = data.ot === CmcdObjectType.INIT || data.ot === CmcdObjectType.VIDEO || data.ot === CmcdObjectType.MUXED;
		if (this.starved && isVideo) {
			data.bs = true;
			data.su = true;
			this.starved = false;
		}
		if (data.su == null) data.su = this.buffering;
		const { includeKeys } = this;
		if (includeKeys) data = Object.keys(data).reduce((acc, key) => {
			includeKeys.includes(key) && (acc[key] = data[key]);
			return acc;
		}, {});
		const options = { baseUrl: context.url };
		if (this.useHeaders) {
			if (!context.headers) context.headers = {};
			appendCmcdHeaders(context.headers, data, options);
		} else context.url = appendCmcdQuery(context.url, data, options);
	}
	getNextFrag(fragment) {
		var _this$hls$levels$frag;
		const levelDetails = (_this$hls$levels$frag = this.hls.levels[fragment.level]) == null ? void 0 : _this$hls$levels$frag.details;
		if (levelDetails) {
			const index = fragment.sn - levelDetails.startSN;
			return levelDetails.fragments[index + 1];
		}
	}
	getNextPart(part) {
		var _this$hls$levels$frag2;
		const { index, fragment } = part;
		const partList = (_this$hls$levels$frag2 = this.hls.levels[fragment.level]) == null || (_this$hls$levels$frag2 = _this$hls$levels$frag2.details) == null ? void 0 : _this$hls$levels$frag2.partList;
		if (partList) {
			const { sn } = fragment;
			for (let i = partList.length - 1; i >= 0; i--) {
				const p = partList[i];
				if (p.index === index && p.fragment.sn === sn) return partList[i + 1];
			}
		}
	}
	/**
	* The CMCD object type.
	*/
	getObjectType(fragment) {
		const { type } = fragment;
		if (type === "subtitle") return CmcdObjectType.TIMED_TEXT;
		if (fragment.sn === "initSegment") return CmcdObjectType.INIT;
		if (type === "audio") return CmcdObjectType.AUDIO;
		if (type === "main") {
			if (!this.hls.audioTracks.length) return CmcdObjectType.MUXED;
			return CmcdObjectType.VIDEO;
		}
	}
	/**
	* Get the highest bitrate.
	*/
	getTopBandwidth(type) {
		let bitrate = 0;
		let levels;
		const hls = this.hls;
		if (type === CmcdObjectType.AUDIO) levels = hls.audioTracks;
		else {
			const max = hls.maxAutoLevel;
			const len = max > -1 ? max + 1 : hls.levels.length;
			levels = hls.levels.slice(0, len);
		}
		levels.forEach((level) => {
			if (level.bitrate > bitrate) bitrate = level.bitrate;
		});
		return bitrate > 0 ? bitrate : NaN;
	}
	/**
	* Get the buffer length for a media type in milliseconds
	*/
	getBufferLength(type) {
		const media = this.media;
		const buffer = type === CmcdObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
		if (!buffer || !media) return NaN;
		return BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole).len * 1e3;
	}
	/**
	* Create a playlist loader
	*/
	createPlaylistLoader() {
		const { pLoader } = this.config;
		const apply = this.applyPlaylistData;
		const Ctor = pLoader || this.config.loader;
		return class CmcdPlaylistLoader {
			constructor(config) {
				this.loader = void 0;
				this.loader = new Ctor(config);
			}
			get stats() {
				return this.loader.stats;
			}
			get context() {
				return this.loader.context;
			}
			destroy() {
				this.loader.destroy();
			}
			abort() {
				this.loader.abort();
			}
			load(context, config, callbacks) {
				apply(context);
				this.loader.load(context, config, callbacks);
			}
		};
	}
	/**
	* Create a playlist loader
	*/
	createFragmentLoader() {
		const { fLoader } = this.config;
		const apply = this.applyFragmentData;
		const Ctor = fLoader || this.config.loader;
		return class CmcdFragmentLoader {
			constructor(config) {
				this.loader = void 0;
				this.loader = new Ctor(config);
			}
			get stats() {
				return this.loader.stats;
			}
			get context() {
				return this.loader.context;
			}
			destroy() {
				this.loader.destroy();
			}
			abort() {
				this.loader.abort();
			}
			load(context, config, callbacks) {
				apply(context);
				this.loader.load(context, config, callbacks);
			}
		};
	}
};
var PATHWAY_PENALTY_DURATION_MS = 3e5;
var ContentSteeringController = class extends Logger {
	constructor(hls) {
		super("content-steering", hls.logger);
		this.hls = void 0;
		this.loader = null;
		this.uri = null;
		this.pathwayId = ".";
		this._pathwayPriority = null;
		this.timeToLoad = 300;
		this.reloadTimer = -1;
		this.updated = 0;
		this.started = false;
		this.enabled = true;
		this.levels = null;
		this.audioTracks = null;
		this.subtitleTracks = null;
		this.penalizedPathways = {};
		this.hls = hls;
		this.registerListeners();
	}
	registerListeners() {
		const hls = this.hls;
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const hls = this.hls;
		if (!hls) return;
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	pathways() {
		return (this.levels || []).reduce((pathways, level) => {
			if (pathways.indexOf(level.pathwayId) === -1) pathways.push(level.pathwayId);
			return pathways;
		}, []);
	}
	get pathwayPriority() {
		return this._pathwayPriority;
	}
	set pathwayPriority(pathwayPriority) {
		this.updatePathwayPriority(pathwayPriority);
	}
	startLoad() {
		this.started = true;
		this.clearTimeout();
		if (this.enabled && this.uri) {
			if (this.updated) {
				const ttl = this.timeToLoad * 1e3 - (performance.now() - this.updated);
				if (ttl > 0) {
					this.scheduleRefresh(this.uri, ttl);
					return;
				}
			}
			this.loadSteeringManifest(this.uri);
		}
	}
	stopLoad() {
		this.started = false;
		if (this.loader) {
			this.loader.destroy();
			this.loader = null;
		}
		this.clearTimeout();
	}
	clearTimeout() {
		if (this.reloadTimer !== -1) {
			self.clearTimeout(this.reloadTimer);
			this.reloadTimer = -1;
		}
	}
	destroy() {
		this.unregisterListeners();
		this.stopLoad();
		this.hls = null;
		this.levels = this.audioTracks = this.subtitleTracks = null;
	}
	removeLevel(levelToRemove) {
		const levels = this.levels;
		if (levels) this.levels = levels.filter((level) => level !== levelToRemove);
	}
	onManifestLoading() {
		this.stopLoad();
		this.enabled = true;
		this.timeToLoad = 300;
		this.updated = 0;
		this.uri = null;
		this.pathwayId = ".";
		this.levels = this.audioTracks = this.subtitleTracks = null;
	}
	onManifestLoaded(event, data) {
		const { contentSteering } = data;
		if (contentSteering === null) return;
		this.pathwayId = contentSteering.pathwayId;
		this.uri = contentSteering.uri;
		if (this.started) this.startLoad();
	}
	onManifestParsed(event, data) {
		this.audioTracks = data.audioTracks;
		this.subtitleTracks = data.subtitleTracks;
	}
	onError(event, data) {
		const { errorAction } = data;
		if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
			const levels = this.levels;
			let pathwayPriority = this._pathwayPriority;
			let errorPathway = this.pathwayId;
			if (data.context) {
				const { groupId, pathwayId, type } = data.context;
				if (groupId && levels) errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
				else if (pathwayId) errorPathway = pathwayId;
			}
			if (!(errorPathway in this.penalizedPathways)) this.penalizedPathways[errorPathway] = performance.now();
			if (!pathwayPriority && levels) pathwayPriority = this.pathways();
			if (pathwayPriority && pathwayPriority.length > 1) {
				this.updatePathwayPriority(pathwayPriority);
				errorAction.resolved = this.pathwayId !== errorPathway;
			}
			if (data.details === ErrorDetails.BUFFER_APPEND_ERROR && !data.fatal) errorAction.resolved = true;
			else if (!errorAction.resolved) this.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${stringify(pathwayPriority)} penalized: ${stringify(this.penalizedPathways)}`);
		}
	}
	filterParsedLevels(levels) {
		this.levels = levels;
		let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
		if (pathwayLevels.length === 0) {
			const pathwayId = levels[0].pathwayId;
			this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
			pathwayLevels = this.getLevelsForPathway(pathwayId);
			this.pathwayId = pathwayId;
		}
		if (pathwayLevels.length !== levels.length) this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
		return pathwayLevels;
	}
	getLevelsForPathway(pathwayId) {
		if (this.levels === null) return [];
		return this.levels.filter((level) => pathwayId === level.pathwayId);
	}
	updatePathwayPriority(pathwayPriority) {
		this._pathwayPriority = pathwayPriority;
		let levels;
		const penalizedPathways = this.penalizedPathways;
		const now = performance.now();
		Object.keys(penalizedPathways).forEach((pathwayId) => {
			if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) delete penalizedPathways[pathwayId];
		});
		for (let i = 0; i < pathwayPriority.length; i++) {
			const pathwayId = pathwayPriority[i];
			if (pathwayId in penalizedPathways) continue;
			if (pathwayId === this.pathwayId) return;
			const selectedIndex = this.hls.nextLoadLevel;
			const selectedLevel = this.hls.levels[selectedIndex];
			levels = this.getLevelsForPathway(pathwayId);
			if (levels.length > 0) {
				this.log(`Setting Pathway to "${pathwayId}"`);
				this.pathwayId = pathwayId;
				reassignFragmentLevelIndexes(levels);
				this.hls.trigger(Events.LEVELS_UPDATED, { levels });
				const levelAfterChange = this.hls.levels[selectedIndex];
				if (selectedLevel && levelAfterChange && this.levels) {
					if (levelAfterChange.attrs["STABLE-VARIANT-ID"] !== selectedLevel.attrs["STABLE-VARIANT-ID"] && levelAfterChange.bitrate !== selectedLevel.bitrate) this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
					this.hls.nextLoadLevel = selectedIndex;
				}
				break;
			}
		}
	}
	getPathwayForGroupId(groupId, type, defaultPathway) {
		const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
		for (let i = 0; i < levels.length; i++) if (type === PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) return levels[i].pathwayId;
		return defaultPathway;
	}
	clonePathways(pathwayClones) {
		const levels = this.levels;
		if (!levels) return;
		const audioGroupCloneMap = {};
		const subtitleGroupCloneMap = {};
		pathwayClones.forEach((pathwayClone) => {
			const { ID: cloneId, "BASE-ID": baseId, "URI-REPLACEMENT": uriReplacement } = pathwayClone;
			if (levels.some((level) => level.pathwayId === cloneId)) return;
			const clonedVariants = this.getLevelsForPathway(baseId).map((baseLevel) => {
				const attributes = new AttrList(baseLevel.attrs);
				attributes["PATHWAY-ID"] = cloneId;
				const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
				const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
				if (clonedAudioGroupId) {
					audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
					attributes.AUDIO = clonedAudioGroupId;
				}
				if (clonedSubtitleGroupId) {
					subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
					attributes.SUBTITLES = clonedSubtitleGroupId;
				}
				const url = performUriReplacement(baseLevel.uri, attributes["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", uriReplacement);
				const clonedLevel = new Level({
					attrs: attributes,
					audioCodec: baseLevel.audioCodec,
					bitrate: baseLevel.bitrate,
					height: baseLevel.height,
					name: baseLevel.name,
					url,
					videoCodec: baseLevel.videoCodec,
					width: baseLevel.width
				});
				if (baseLevel.audioGroups) for (let i = 1; i < baseLevel.audioGroups.length; i++) clonedLevel.addGroupId("audio", `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
				if (baseLevel.subtitleGroups) for (let i = 1; i < baseLevel.subtitleGroups.length; i++) clonedLevel.addGroupId("text", `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
				return clonedLevel;
			});
			levels.push(...clonedVariants);
			cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
			cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
		});
	}
	loadSteeringManifest(uri) {
		const config = this.hls.config;
		const Loader = config.loader;
		if (this.loader) this.loader.destroy();
		this.loader = new Loader(config);
		let url;
		try {
			url = new self.URL(uri);
		} catch (error) {
			this.enabled = false;
			this.log(`Failed to parse Steering Manifest URI: ${uri}`);
			return;
		}
		if (url.protocol !== "data:") {
			const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
			url.searchParams.set("_HLS_pathway", this.pathwayId);
			url.searchParams.set("_HLS_throughput", "" + throughput);
		}
		const context = {
			responseType: "json",
			url: url.href
		};
		const loadPolicy = config.steeringManifestLoadPolicy.default;
		const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
		const loaderConfig = {
			loadPolicy,
			timeout: loadPolicy.maxLoadTimeMs,
			maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
			retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
			maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
		};
		const callbacks = {
			onSuccess: (response, stats, context, networkDetails) => {
				this.log(`Loaded steering manifest: "${url}"`);
				const steeringData = response.data;
				if ((steeringData == null ? void 0 : steeringData.VERSION) !== 1) {
					this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
					return;
				}
				this.updated = performance.now();
				this.timeToLoad = steeringData.TTL;
				const { "RELOAD-URI": reloadUri, "PATHWAY-CLONES": pathwayClones, "PATHWAY-PRIORITY": pathwayPriority } = steeringData;
				if (reloadUri) try {
					this.uri = new self.URL(reloadUri, url).href;
				} catch (error) {
					this.enabled = false;
					this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
					return;
				}
				this.scheduleRefresh(this.uri || context.url);
				if (pathwayClones) this.clonePathways(pathwayClones);
				const loadedSteeringData = {
					steeringManifest: steeringData,
					url: url.toString()
				};
				this.hls.trigger(Events.STEERING_MANIFEST_LOADED, loadedSteeringData);
				if (pathwayPriority) this.updatePathwayPriority(pathwayPriority);
			},
			onError: (error, context, networkDetails, stats) => {
				this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
				this.stopLoad();
				if (error.code === 410) {
					this.enabled = false;
					this.log(`Steering manifest ${context.url} no longer available`);
					return;
				}
				let ttl = this.timeToLoad * 1e3;
				if (error.code === 429) {
					const loader = this.loader;
					if (typeof (loader == null ? void 0 : loader.getResponseHeader) === "function") {
						const retryAfter = loader.getResponseHeader("Retry-After");
						if (retryAfter) ttl = parseFloat(retryAfter) * 1e3;
					}
					this.log(`Steering manifest ${context.url} rate limited`);
					return;
				}
				this.scheduleRefresh(this.uri || context.url, ttl);
			},
			onTimeout: (stats, context, networkDetails) => {
				this.log(`Timeout loading steering manifest (${context.url})`);
				this.scheduleRefresh(this.uri || context.url);
			}
		};
		this.log(`Requesting steering manifest: ${url}`);
		this.loader.load(context, loaderConfig, callbacks);
	}
	scheduleRefresh(uri, ttlMs = this.timeToLoad * 1e3) {
		this.clearTimeout();
		this.reloadTimer = self.setTimeout(() => {
			var _this$hls;
			const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
			if (media && !media.ended) {
				this.loadSteeringManifest(uri);
				return;
			}
			this.scheduleRefresh(uri, this.timeToLoad * 1e3);
		}, ttlMs);
	}
};
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
	if (!tracks) return;
	Object.keys(groupCloneMap).forEach((audioGroupId) => {
		const clonedTracks = tracks.filter((track) => track.groupId === audioGroupId).map((track) => {
			const clonedTrack = _extends({}, track);
			clonedTrack.details = void 0;
			clonedTrack.attrs = new AttrList(clonedTrack.attrs);
			clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", uriReplacement);
			clonedTrack.groupId = clonedTrack.attrs["GROUP-ID"] = groupCloneMap[audioGroupId];
			clonedTrack.attrs["PATHWAY-ID"] = cloneId;
			return clonedTrack;
		});
		tracks.push(...clonedTracks);
	});
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
	const { HOST: host, PARAMS: params, [perOptionKey]: perOptionUris } = uriReplacement;
	let perVariantUri;
	if (stableId) {
		perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
		if (perVariantUri) uri = perVariantUri;
	}
	const url = new self.URL(uri);
	if (host && !perVariantUri) url.host = host;
	if (params) Object.keys(params).sort().forEach((key) => {
		if (key) url.searchParams.set(key, params[key]);
	});
	return url.href;
}
/**
* Controller to deal with encrypted media extensions (EME)
* @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
*
* @class
* @constructor
*/
var EMEController = class EMEController extends Logger {
	constructor(hls) {
		super("eme", hls.logger);
		this.hls = void 0;
		this.config = void 0;
		this.media = null;
		this.mediaResolved = void 0;
		this.keyFormatPromise = null;
		this.keySystemAccessPromises = {};
		this._requestLicenseFailureCount = 0;
		this.mediaKeySessions = [];
		this.keyIdToKeySessionPromise = {};
		this.mediaKeys = null;
		this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [];
		this.bannedKeyIds = {};
		this.onMediaEncrypted = (event) => {
			const { initDataType, initData } = event;
			const logMessage = `"${event.type}" event: init data type: "${initDataType}"`;
			this.debug(logMessage);
			if (initData === null) return;
			if (!this.keyFormatPromise) {
				let keySystems = Object.keys(this.keySystemAccessPromises);
				if (!keySystems.length) keySystems = getKeySystemsForConfig(this.config);
				const keyFormats = keySystems.map(keySystemDomainToKeySystemFormat).filter((k) => !!k);
				this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
			}
			this.keyFormatPromise.then((keySystemFormat) => {
				const keySystem = keySystemFormatToKeySystemDomain(keySystemFormat);
				if (initDataType !== "sinf" || keySystem !== KeySystems.FAIRPLAY) {
					this.log(`Ignoring "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
					return;
				}
				let keyId;
				try {
					const json = bin2str(new Uint8Array(initData));
					const tenc = parseSinf(base64Decode(JSON.parse(json).sinf));
					if (!tenc) throw new Error(`'schm' box missing or not cbcs/cenc with schi > tenc`);
					keyId = new Uint8Array(tenc.subarray(8, 24));
				} catch (error) {
					this.warn(`${logMessage} Failed to parse sinf: ${error}`);
					return;
				}
				const keyIdHex = arrayToHex(keyId);
				const { keyIdToKeySessionPromise, mediaKeySessions } = this;
				let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
				for (let i = 0; i < mediaKeySessions.length; i++) {
					const keyContext = mediaKeySessions[i];
					const decryptdata = keyContext.decryptdata;
					if (!decryptdata.keyId) continue;
					const oldKeyIdHex = arrayToHex(decryptdata.keyId);
					if (arrayValuesMatch(keyId, decryptdata.keyId) || decryptdata.uri.replace(/-/g, "").indexOf(keyIdHex) !== -1) {
						keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
						if (!keySessionContextPromise) continue;
						if (decryptdata.pssh) break;
						delete keyIdToKeySessionPromise[oldKeyIdHex];
						decryptdata.pssh = new Uint8Array(initData);
						decryptdata.keyId = keyId;
						keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(() => {
							return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, "encrypted-event-key-match");
						});
						keySessionContextPromise.catch((error) => this.handleError(error));
						break;
					}
				}
				if (!keySessionContextPromise) this.handleError(/* @__PURE__ */ new Error(`Key ID ${keyIdHex} not encountered in playlist. Key-system sessions ${mediaKeySessions.length}.`));
			}).catch((error) => this.handleError(error));
		};
		this.onWaitingForKey = (event) => {
			this.log(`"${event.type}" event`);
		};
		this.hls = hls;
		this.config = hls.config;
		this.registerListeners();
	}
	destroy() {
		this.onDestroying();
		this.onMediaDetached();
		const config = this.config;
		config.requestMediaKeySystemAccessFunc = null;
		config.licenseXhrSetup = config.licenseResponseCallback = void 0;
		config.drmSystems = config.drmSystemOptions = {};
		this.hls = this.config = this.keyIdToKeySessionPromise = null;
		this.onMediaEncrypted = this.onWaitingForKey = null;
	}
	registerListeners() {
		this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
		this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		this.hls.on(Events.DESTROYING, this.onDestroying, this);
	}
	unregisterListeners() {
		this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
		this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		this.hls.off(Events.DESTROYING, this.onDestroying, this);
	}
	getLicenseServerUrl(keySystem) {
		const { drmSystems, widevineLicenseUrl } = this.config;
		const keySystemConfiguration = drmSystems == null ? void 0 : drmSystems[keySystem];
		if (keySystemConfiguration) return keySystemConfiguration.licenseUrl;
		if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) return widevineLicenseUrl;
	}
	getLicenseServerUrlOrThrow(keySystem) {
		const url = this.getLicenseServerUrl(keySystem);
		if (url === void 0) throw new Error(`no license server URL configured for key-system "${keySystem}"`);
		return url;
	}
	getServerCertificateUrl(keySystem) {
		const { drmSystems } = this.config;
		const keySystemConfiguration = drmSystems == null ? void 0 : drmSystems[keySystem];
		if (keySystemConfiguration) return keySystemConfiguration.serverCertificateUrl;
		else this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
	}
	attemptKeySystemAccess(keySystemsToAttempt) {
		const levels = this.hls.levels;
		const uniqueCodec = (value, i, a) => !!value && a.indexOf(value) === i;
		const audioCodecs = levels.map((level) => level.audioCodec).filter(uniqueCodec);
		const videoCodecs = levels.map((level) => level.videoCodec).filter(uniqueCodec);
		if (audioCodecs.length + videoCodecs.length === 0) videoCodecs.push("avc1.42e01e");
		return new Promise((resolve, reject) => {
			const attempt = (keySystems) => {
				const keySystem = keySystems.shift();
				this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then((mediaKeys) => resolve({
					keySystem,
					mediaKeys
				})).catch((error) => {
					if (keySystems.length) attempt(keySystems);
					else if (error instanceof EMEKeyError) reject(error);
					else reject(new EMEKeyError({
						type: ErrorTypes.KEY_SYSTEM_ERROR,
						details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
						error,
						fatal: true
					}, error.message));
				});
			};
			attempt(keySystemsToAttempt);
		});
	}
	requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
		const { requestMediaKeySystemAccessFunc } = this.config;
		if (!(typeof requestMediaKeySystemAccessFunc === "function")) {
			let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
			if (requestMediaKeySystemAccess === null && self.location.protocol === "http:") errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
			return Promise.reject(new Error(errMessage));
		}
		return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
	}
	getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
		var _keySystemAccessPromi;
		const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions || {});
		let keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
		let keySystemAccess = (_keySystemAccessPromi = keySystemAccessPromises) == null ? void 0 : _keySystemAccessPromi.keySystemAccess;
		if (!keySystemAccess) {
			this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${stringify(mediaKeySystemConfigs)}`);
			keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
			const keySystemAccessPromisesNew = keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = { keySystemAccess };
			keySystemAccess.catch((error) => {
				this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
			});
			return keySystemAccess.then((mediaKeySystemAccess) => {
				this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
				const certificateRequest = this.fetchServerCertificate(keySystem);
				this.log(`Create media-keys for "${keySystem}"`);
				const mediaKeys = keySystemAccessPromisesNew.mediaKeys = mediaKeySystemAccess.createMediaKeys().then((mediaKeys) => {
					this.log(`Media-keys created for "${keySystem}"`);
					keySystemAccessPromisesNew.hasMediaKeys = true;
					return certificateRequest.then((certificate) => {
						if (certificate) return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
						return mediaKeys;
					});
				});
				mediaKeys.catch((error) => {
					this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
				});
				return mediaKeys;
			});
		}
		return keySystemAccess.then(() => keySystemAccessPromises.mediaKeys);
	}
	createMediaKeySessionContext({ decryptdata, keySystem, mediaKeys }) {
		this.log(`Creating key-system session "${keySystem}" keyId: ${arrayToHex(decryptdata.keyId || [])} keyUri: ${decryptdata.uri}`);
		const mediaKeySessionContext = {
			decryptdata,
			keySystem,
			mediaKeys,
			mediaKeysSession: mediaKeys.createSession(),
			keyStatus: "status-pending"
		};
		this.mediaKeySessions.push(mediaKeySessionContext);
		return mediaKeySessionContext;
	}
	renewKeySession(mediaKeySessionContext) {
		const decryptdata = mediaKeySessionContext.decryptdata;
		if (decryptdata.pssh) {
			const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
			const keyId = getKeyIdString(decryptdata);
			const scheme = "cenc";
			this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh.buffer, "expired");
		} else this.warn(`Could not renew expired session. Missing pssh initData.`);
		this.removeSession(mediaKeySessionContext);
	}
	updateKeySession(mediaKeySessionContext, data) {
		const keySession = mediaKeySessionContext.mediaKeysSession;
		this.log(`Updating key-session "${keySession.sessionId}" for keyId ${arrayToHex(mediaKeySessionContext.decryptdata.keyId || [])}
      } (data length: ${data.byteLength})`);
		return keySession.update(data);
	}
	getSelectedKeySystemFormats() {
		return Object.keys(this.keySystemAccessPromises).map((keySystem) => ({
			keySystem,
			hasMediaKeys: this.keySystemAccessPromises[keySystem].hasMediaKeys
		})).filter(({ hasMediaKeys }) => !!hasMediaKeys).map(({ keySystem }) => keySystemDomainToKeySystemFormat(keySystem)).filter((keySystem) => !!keySystem);
	}
	getKeySystemAccess(keySystemsToAttempt) {
		return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem, mediaKeys }) => {
			return this.attemptSetMediaKeys(keySystem, mediaKeys);
		});
	}
	selectKeySystem(keySystemsToAttempt) {
		return new Promise((resolve, reject) => {
			this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem }) => {
				const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
				if (keySystemFormat) resolve(keySystemFormat);
				else reject(/* @__PURE__ */ new Error(`Unable to find format for key-system "${keySystem}"`));
			}).catch(reject);
		});
	}
	selectKeySystemFormat(frag) {
		const keyFormats = Object.keys(frag.levelkeys || {});
		if (!this.keyFormatPromise) {
			this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(", ")}`);
			this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
		}
		return this.keyFormatPromise;
	}
	getKeyFormatPromise(keyFormats) {
		const keySystemsInConfig = getKeySystemsForConfig(this.config);
		const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter((value) => !!value && keySystemsInConfig.indexOf(value) !== -1);
		return this.selectKeySystem(keySystemsToAttempt);
	}
	getKeyStatus(decryptdata) {
		const { mediaKeySessions } = this;
		for (let i = 0; i < mediaKeySessions.length; i++) {
			const status = getKeyStatus(decryptdata, mediaKeySessions[i]);
			if (status) return status;
		}
	}
	loadKey(data) {
		const decryptdata = data.keyInfo.decryptdata;
		const keyId = getKeyIdString(decryptdata);
		const badStatus = this.bannedKeyIds[keyId];
		if (badStatus || this.getKeyStatus(decryptdata) === "internal-error") {
			const error = getKeyStatusError(badStatus || "internal-error", decryptdata);
			this.handleError(error, data.frag);
			return Promise.reject(error);
		}
		const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
		this.log(`Starting session for key ${keyDetails}`);
		const keyContextPromise = this.keyIdToKeySessionPromise[keyId];
		if (!keyContextPromise) {
			const keySessionContextPromise = this.getKeySystemForKeyPromise(decryptdata).then(({ keySystem, mediaKeys }) => {
				this.throwIfDestroyed();
				this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
				return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
					this.throwIfDestroyed();
					return this.createMediaKeySessionContext({
						keySystem,
						mediaKeys,
						decryptdata
					});
				});
			}).then((keySessionContext) => {
				const scheme = "cenc";
				const initData = decryptdata.pssh ? decryptdata.pssh.buffer : null;
				return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, initData, "playlist-key");
			});
			keySessionContextPromise.catch((error) => this.handleError(error, data.frag));
			this.keyIdToKeySessionPromise[keyId] = keySessionContextPromise;
			return keySessionContextPromise;
		}
		keyContextPromise.catch((error) => {
			if (error instanceof EMEKeyError) {
				const errorData = _objectSpread2({}, error.data);
				if (this.getKeyStatus(decryptdata) === "internal-error") errorData.decryptdata = decryptdata;
				const clonedError = new EMEKeyError(errorData, error.message);
				this.handleError(clonedError, data.frag);
			}
		});
		return keyContextPromise;
	}
	throwIfDestroyed(message = "Invalid state") {
		if (!this.hls) throw new Error("invalid state");
	}
	handleError(error, frag) {
		if (!this.hls) return;
		if (error instanceof EMEKeyError) {
			if (frag) error.data.frag = frag;
			const levelKey = error.data.decryptdata;
			this.error(`${error.message}${levelKey ? ` (${arrayToHex(levelKey.keyId || [])})` : ""}`);
			this.hls.trigger(Events.ERROR, error.data);
		} else {
			this.error(error.message);
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.KEY_SYSTEM_ERROR,
				details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
				error,
				fatal: true
			});
		}
	}
	getKeySystemForKeyPromise(decryptdata) {
		const keyId = getKeyIdString(decryptdata);
		const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
		if (!mediaKeySessionContext) {
			const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
			const keySystemsToAttempt = keySystem ? [keySystem] : getKeySystemsForConfig(this.config);
			return this.attemptKeySystemAccess(keySystemsToAttempt);
		}
		return mediaKeySessionContext;
	}
	getKeySystemSelectionPromise(keySystemsToAttempt) {
		if (!keySystemsToAttempt.length) keySystemsToAttempt = getKeySystemsForConfig(this.config);
		if (keySystemsToAttempt.length === 0) throw new EMEKeyError({
			type: ErrorTypes.KEY_SYSTEM_ERROR,
			details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
			fatal: true
		}, `Missing key-system license configuration options ${stringify({ drmSystems: this.config.drmSystems })}`);
		return this.attemptKeySystemAccess(keySystemsToAttempt);
	}
	attemptSetMediaKeys(keySystem, mediaKeys) {
		this.mediaResolved = void 0;
		if (this.mediaKeys === mediaKeys) return Promise.resolve();
		const queue = this.setMediaKeysQueue.slice();
		this.log(`Setting media-keys for "${keySystem}"`);
		const setMediaKeysPromise = Promise.all(queue).then(() => {
			if (!this.media) return new Promise((resolve, reject) => {
				this.mediaResolved = () => {
					this.mediaResolved = void 0;
					if (!this.media) return reject(/* @__PURE__ */ new Error("Attempted to set mediaKeys without media element attached"));
					this.mediaKeys = mediaKeys;
					this.media.setMediaKeys(mediaKeys).then(resolve).catch(reject);
				};
			});
			return this.media.setMediaKeys(mediaKeys);
		});
		this.mediaKeys = mediaKeys;
		this.setMediaKeysQueue.push(setMediaKeysPromise);
		return setMediaKeysPromise.then(() => {
			this.log(`Media-keys set for "${keySystem}"`);
			queue.push(setMediaKeysPromise);
			this.setMediaKeysQueue = this.setMediaKeysQueue.filter((p) => queue.indexOf(p) === -1);
		});
	}
	generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
		var _this$config$drmSyste;
		const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null || (_this$config$drmSyste = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste.generateRequest;
		if (generateRequestFilter) try {
			const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
			if (!mappedInitData) throw new Error("Invalid response from configured generateRequest filter");
			initDataType = mappedInitData.initDataType;
			initData = mappedInitData.initData ? mappedInitData.initData : null;
			context.decryptdata.pssh = initData ? new Uint8Array(initData) : null;
		} catch (error) {
			this.warn(error.message);
			if (this.hls && this.hls.config.debug) throw error;
		}
		if (initData === null) {
			this.log(`Skipping key-session request for "${reason}" (no initData)`);
			return Promise.resolve(context);
		}
		const keyId = getKeyIdString(context.decryptdata);
		const keyUri = context.decryptdata.uri;
		this.log(`Generating key-session request for "${reason}" keyId: ${keyId} URI: ${keyUri} (init data type: ${initDataType} length: ${initData.byteLength})`);
		const licenseStatus = new EventEmitter$1();
		const onmessage = context._onmessage = (event) => {
			const keySession = context.mediaKeysSession;
			if (!keySession) {
				licenseStatus.emit("error", /* @__PURE__ */ new Error("invalid state"));
				return;
			}
			const { messageType, message } = event;
			this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
			if (messageType === "license-request" || messageType === "license-renewal") this.renewLicense(context, message).catch((error) => {
				if (licenseStatus.eventNames().length) licenseStatus.emit("error", error);
				else this.handleError(error);
			});
			else if (messageType === "license-release") {
				if (context.keySystem === KeySystems.FAIRPLAY) this.updateKeySession(context, strToUtf8array("acknowledged")).then(() => this.removeSession(context)).catch((error) => this.handleError(error));
			} else this.warn(`unhandled media key message type "${messageType}"`);
		};
		const handleKeyStatus = (keyStatus, context) => {
			context.keyStatus = keyStatus;
			let keyError;
			if (keyStatus.startsWith("usable")) licenseStatus.emit("resolved");
			else if (keyStatus === "internal-error" || keyStatus === "output-restricted" || keyStatus === "output-downscaled") keyError = getKeyStatusError(keyStatus, context.decryptdata);
			else if (keyStatus === "expired") keyError = /* @__PURE__ */ new Error(`key expired (keyId: ${keyId})`);
			else if (keyStatus === "released") keyError = /* @__PURE__ */ new Error(`key released`);
			else if (keyStatus === "status-pending");
			else this.warn(`unhandled key status change "${keyStatus}" (keyId: ${keyId})`);
			if (keyError) if (licenseStatus.eventNames().length) licenseStatus.emit("error", keyError);
			else this.handleError(keyError);
		};
		const onkeystatuseschange = context._onkeystatuseschange = (event) => {
			if (!context.mediaKeysSession) {
				licenseStatus.emit("error", /* @__PURE__ */ new Error("invalid state"));
				return;
			}
			const keyStatuses = this.getKeyStatuses(context);
			if (!Object.keys(keyStatuses).some((id) => keyStatuses[id] !== "status-pending")) return;
			if (keyStatuses[keyId] === "expired") {
				this.log(`Expired key ${stringify(keyStatuses)} in key-session "${context.mediaKeysSession.sessionId}"`);
				this.renewKeySession(context);
				return;
			}
			let keyStatus = keyStatuses[keyId];
			if (keyStatus) handleKeyStatus(keyStatus, context);
			else {
				var _context$keyStatusTim;
				const timeout = 1e3;
				context.keyStatusTimeouts || (context.keyStatusTimeouts = {});
				(_context$keyStatusTim = context.keyStatusTimeouts)[keyId] || (_context$keyStatusTim[keyId] = self.setTimeout(() => {
					if (!context.mediaKeysSession || !this.mediaKeys) return;
					const sessionKeyStatus = this.getKeyStatus(context.decryptdata);
					if (sessionKeyStatus && sessionKeyStatus !== "status-pending") {
						this.log(`No status for keyId ${keyId} in key-session "${context.mediaKeysSession.sessionId}". Using session key-status ${sessionKeyStatus} from other session.`);
						return handleKeyStatus(sessionKeyStatus, context);
					}
					this.log(`key status for ${keyId} in key-session "${context.mediaKeysSession.sessionId}" timed out after ${timeout}ms`);
					keyStatus = "internal-error";
					handleKeyStatus(keyStatus, context);
				}, timeout));
				this.log(`No status for keyId ${keyId} (${stringify(keyStatuses)}).`);
			}
		};
		addEventListener(context.mediaKeysSession, "message", onmessage);
		addEventListener(context.mediaKeysSession, "keystatuseschange", onkeystatuseschange);
		const keyUsablePromise = new Promise((resolve, reject) => {
			licenseStatus.on("error", reject);
			licenseStatus.on("resolved", resolve);
		});
		return context.mediaKeysSession.generateRequest(initDataType, initData).then(() => {
			this.log(`Request generated for key-session "${context.mediaKeysSession.sessionId}" keyId: ${keyId} URI: ${keyUri}`);
		}).catch((error) => {
			throw new EMEKeyError({
				type: ErrorTypes.KEY_SYSTEM_ERROR,
				details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
				error,
				decryptdata: context.decryptdata,
				fatal: false
			}, `Error generating key-session request: ${error}`);
		}).then(() => keyUsablePromise).catch((error) => {
			licenseStatus.removeAllListeners();
			return this.removeSession(context).then(() => {
				throw error;
			});
		}).then(() => {
			licenseStatus.removeAllListeners();
			return context;
		});
	}
	getKeyStatuses(mediaKeySessionContext) {
		const keyStatuses = {};
		mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status, keyId) => {
			if (typeof keyId === "string" && typeof status === "object") {
				const temp = keyId;
				keyId = status;
				status = temp;
			}
			const keyIdArray = "buffer" in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId);
			if (mediaKeySessionContext.keySystem === KeySystems.PLAYREADY && keyIdArray.length === 16) {
				const originKeyIdWithStatusChange = arrayToHex(keyIdArray);
				keyStatuses[originKeyIdWithStatusChange] = status;
				changeEndianness(keyIdArray);
			}
			const keyIdWithStatusChange = arrayToHex(keyIdArray);
			if (status === "internal-error") this.bannedKeyIds[keyIdWithStatusChange] = status;
			this.log(`key status change "${status}" for keyStatuses keyId: ${keyIdWithStatusChange} key-session "${mediaKeySessionContext.mediaKeysSession.sessionId}"`);
			keyStatuses[keyIdWithStatusChange] = status;
		});
		return keyStatuses;
	}
	fetchServerCertificate(keySystem) {
		const config = this.config;
		const Loader = config.loader;
		const certLoader = new Loader(config);
		const url = this.getServerCertificateUrl(keySystem);
		if (!url) return Promise.resolve();
		this.log(`Fetching server certificate for "${keySystem}"`);
		return new Promise((resolve, reject) => {
			const loaderContext = {
				responseType: "arraybuffer",
				url
			};
			const loadPolicy = config.certLoadPolicy.default;
			const loaderConfig = {
				loadPolicy,
				timeout: loadPolicy.maxLoadTimeMs,
				maxRetry: 0,
				retryDelay: 0,
				maxRetryDelay: 0
			};
			certLoader.load(loaderContext, loaderConfig, {
				onSuccess: (response, stats, context, networkDetails) => {
					resolve(response.data);
				},
				onError: (response, contex, networkDetails, stats) => {
					reject(new EMEKeyError({
						type: ErrorTypes.KEY_SYSTEM_ERROR,
						details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
						fatal: true,
						networkDetails,
						response: _objectSpread2({
							url: loaderContext.url,
							data: void 0
						}, response)
					}, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
				},
				onTimeout: (stats, context, networkDetails) => {
					reject(new EMEKeyError({
						type: ErrorTypes.KEY_SYSTEM_ERROR,
						details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
						fatal: true,
						networkDetails,
						response: {
							url: loaderContext.url,
							data: void 0
						}
					}, `"${keySystem}" certificate request timed out (${url})`));
				},
				onAbort: (stats, context, networkDetails) => {
					reject(/* @__PURE__ */ new Error("aborted"));
				}
			});
		});
	}
	setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
		return new Promise((resolve, reject) => {
			mediaKeys.setServerCertificate(cert).then((success) => {
				this.log(`setServerCertificate ${success ? "success" : "not supported by CDM"} (${cert.byteLength}) on "${keySystem}"`);
				resolve(mediaKeys);
			}).catch((error) => {
				reject(new EMEKeyError({
					type: ErrorTypes.KEY_SYSTEM_ERROR,
					details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
					error,
					fatal: true
				}, error.message));
			});
		});
	}
	renewLicense(context, keyMessage) {
		return this.requestLicense(context, new Uint8Array(keyMessage)).then((data) => {
			return this.updateKeySession(context, new Uint8Array(data)).catch((error) => {
				throw new EMEKeyError({
					type: ErrorTypes.KEY_SYSTEM_ERROR,
					details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
					decryptdata: context.decryptdata,
					error,
					fatal: false
				}, error.message);
			});
		});
	}
	unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
		const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
		if (!xmlString.includes("PlayReadyKeyMessage")) {
			xhr.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
			return licenseChallenge;
		}
		const keyMessageXml = new DOMParser().parseFromString(xmlString, "application/xml");
		const headers = keyMessageXml.querySelectorAll("HttpHeader");
		if (headers.length > 0) {
			let header;
			for (let i = 0, len = headers.length; i < len; i++) {
				var _header$querySelector, _header$querySelector2;
				header = headers[i];
				const name = (_header$querySelector = header.querySelector("name")) == null ? void 0 : _header$querySelector.textContent;
				const value = (_header$querySelector2 = header.querySelector("value")) == null ? void 0 : _header$querySelector2.textContent;
				if (name && value) xhr.setRequestHeader(name, value);
			}
		}
		const challengeElement = keyMessageXml.querySelector("Challenge");
		const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
		if (!challengeText) throw new Error(`Cannot find <Challenge> in key message`);
		return strToUtf8array(atob(challengeText));
	}
	setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
		const licenseXhrSetup = this.config.licenseXhrSetup;
		if (!licenseXhrSetup) {
			xhr.open("POST", url, true);
			return Promise.resolve({
				xhr,
				licenseChallenge
			});
		}
		return Promise.resolve().then(() => {
			if (!keysListItem.decryptdata) throw new Error("Key removed");
			return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
		}).catch((error) => {
			if (!keysListItem.decryptdata) throw error;
			xhr.open("POST", url, true);
			return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
		}).then((licenseXhrSetupResult) => {
			if (!xhr.readyState) xhr.open("POST", url, true);
			return {
				xhr,
				licenseChallenge: licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge
			};
		});
	}
	requestLicense(keySessionContext, licenseChallenge) {
		const keyLoadPolicy = this.config.keyLoadPolicy.default;
		return new Promise((resolve, reject) => {
			const url = this.getLicenseServerUrlOrThrow(keySessionContext.keySystem);
			this.log(`Sending license request to URL: ${url}`);
			const xhr = new XMLHttpRequest();
			xhr.responseType = "arraybuffer";
			xhr.onreadystatechange = () => {
				if (!this.hls || !keySessionContext.mediaKeysSession) return reject(/* @__PURE__ */ new Error("invalid state"));
				if (xhr.readyState === 4) if (xhr.status === 200) {
					this._requestLicenseFailureCount = 0;
					let data = xhr.response;
					this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
					const licenseResponseCallback = this.config.licenseResponseCallback;
					if (licenseResponseCallback) try {
						data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
					} catch (error) {
						this.error(error);
					}
					resolve(data);
				} else {
					const retryConfig = keyLoadPolicy.errorRetry;
					const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
					this._requestLicenseFailureCount++;
					if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) reject(new EMEKeyError({
						type: ErrorTypes.KEY_SYSTEM_ERROR,
						details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
						decryptdata: keySessionContext.decryptdata,
						fatal: true,
						networkDetails: xhr,
						response: {
							url,
							data: void 0,
							code: xhr.status,
							text: xhr.statusText
						}
					}, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
					else {
						const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
						this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
						this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
					}
				}
			};
			if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) keySessionContext.licenseXhr.abort();
			keySessionContext.licenseXhr = xhr;
			this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({ xhr, licenseChallenge }) => {
				if (keySessionContext.keySystem == KeySystems.PLAYREADY) licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
				xhr.send(licenseChallenge);
			}).catch(reject);
		});
	}
	onDestroying() {
		this.unregisterListeners();
		this._clear();
	}
	onMediaAttached(event, data) {
		if (!this.config.emeEnabled) return;
		const media = data.media;
		this.media = media;
		addEventListener(media, "encrypted", this.onMediaEncrypted);
		addEventListener(media, "waitingforkey", this.onWaitingForKey);
		const mediaResolved = this.mediaResolved;
		if (mediaResolved) mediaResolved();
		else this.mediaKeys = media.mediaKeys;
	}
	onMediaDetached() {
		const media = this.media;
		if (media) {
			removeEventListener(media, "encrypted", this.onMediaEncrypted);
			removeEventListener(media, "waitingforkey", this.onWaitingForKey);
			this.media = null;
			this.mediaKeys = null;
		}
	}
	_clear() {
		var _media$setMediaKeys;
		this._requestLicenseFailureCount = 0;
		this.keyIdToKeySessionPromise = {};
		this.bannedKeyIds = {};
		const mediaResolved = this.mediaResolved;
		if (mediaResolved) mediaResolved();
		if (!this.mediaKeys && !this.mediaKeySessions.length) return;
		const media = this.media;
		const mediaKeysList = this.mediaKeySessions.slice();
		this.mediaKeySessions = [];
		this.mediaKeys = null;
		LevelKey.clearKeyUriToKeyIdMap();
		const keySessionCount = mediaKeysList.length;
		EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map((mediaKeySessionContext) => this.removeSession(mediaKeySessionContext)).concat((media == null || (_media$setMediaKeys = media.setMediaKeys(null)) == null ? void 0 : _media$setMediaKeys.catch((error) => {
			this.log(`Could not clear media keys: ${error}`);
			if (!this.hls) return;
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
				fatal: false,
				error: /* @__PURE__ */ new Error(`Could not clear media keys: ${error}`)
			});
		})) || Promise.resolve())).catch((error) => {
			this.log(`Could not close sessions and clear media keys: ${error}`);
			if (!this.hls) return;
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
				fatal: false,
				error: /* @__PURE__ */ new Error(`Could not close sessions and clear media keys: ${error}`)
			});
		}).then(() => {
			if (keySessionCount) this.log("finished closing key sessions and clearing media keys");
		});
	}
	onManifestLoading() {
		this._clear();
	}
	onManifestLoaded(event, { sessionKeys }) {
		if (!sessionKeys || !this.config.emeEnabled) return;
		if (!this.keyFormatPromise) {
			const keyFormats = sessionKeys.reduce((formats, sessionKey) => {
				if (formats.indexOf(sessionKey.keyFormat) === -1) formats.push(sessionKey.keyFormat);
				return formats;
			}, []);
			this.log(`Selecting key-system from session-keys ${keyFormats.join(", ")}`);
			this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
		}
	}
	removeSession(mediaKeySessionContext) {
		const { mediaKeysSession, licenseXhr, decryptdata } = mediaKeySessionContext;
		if (mediaKeysSession) {
			this.log(`Remove licenses and keys and close session "${mediaKeysSession.sessionId}" keyId: ${arrayToHex((decryptdata == null ? void 0 : decryptdata.keyId) || [])}`);
			if (mediaKeySessionContext._onmessage) {
				mediaKeysSession.removeEventListener("message", mediaKeySessionContext._onmessage);
				mediaKeySessionContext._onmessage = void 0;
			}
			if (mediaKeySessionContext._onkeystatuseschange) {
				mediaKeysSession.removeEventListener("keystatuseschange", mediaKeySessionContext._onkeystatuseschange);
				mediaKeySessionContext._onkeystatuseschange = void 0;
			}
			if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) licenseXhr.abort();
			mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = void 0;
			const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
			if (index > -1) this.mediaKeySessions.splice(index, 1);
			const { keyStatusTimeouts } = mediaKeySessionContext;
			if (keyStatusTimeouts) Object.keys(keyStatusTimeouts).forEach((keyId) => self.clearTimeout(keyStatusTimeouts[keyId]));
			const { drmSystemOptions } = this.config;
			return (isPersistentSessionType(drmSystemOptions) ? new Promise((resolve, reject) => {
				self.setTimeout(() => reject(/* @__PURE__ */ new Error(`MediaKeySession.remove() timeout`)), 8e3);
				mediaKeysSession.remove().then(resolve).catch(reject);
			}) : Promise.resolve()).catch((error) => {
				this.log(`Could not remove session: ${error}`);
				if (!this.hls) return;
				this.hls.trigger(Events.ERROR, {
					type: ErrorTypes.OTHER_ERROR,
					details: ErrorDetails.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
					fatal: false,
					error: /* @__PURE__ */ new Error(`Could not remove session: ${error}`)
				});
			}).then(() => {
				return mediaKeysSession.close();
			}).catch((error) => {
				this.log(`Could not close session: ${error}`);
				if (!this.hls) return;
				this.hls.trigger(Events.ERROR, {
					type: ErrorTypes.OTHER_ERROR,
					details: ErrorDetails.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
					fatal: false,
					error: /* @__PURE__ */ new Error(`Could not close session: ${error}`)
				});
			});
		}
		return Promise.resolve();
	}
};
EMEController.CDMCleanupPromise = void 0;
function getKeyIdString(decryptdata) {
	if (!decryptdata) throw new Error("Could not read keyId of undefined decryptdata");
	if (decryptdata.keyId === null) throw new Error("keyId is null");
	return arrayToHex(decryptdata.keyId);
}
function getKeyStatus(decryptdata, keyContext) {
	if (decryptdata.keyId && keyContext.mediaKeysSession.keyStatuses.has(decryptdata.keyId)) return keyContext.mediaKeysSession.keyStatuses.get(decryptdata.keyId);
	if (decryptdata.matches(keyContext.decryptdata)) return keyContext.keyStatus;
}
var EMEKeyError = class extends Error {
	constructor(data, message) {
		super(message);
		this.data = void 0;
		data.error || (data.error = new Error(message));
		this.data = data;
		data.err = data.error;
	}
};
function getKeyStatusError(keyStatus, decryptdata) {
	const outputRestricted = keyStatus === "output-restricted";
	const details = outputRestricted ? ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED : ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR;
	return new EMEKeyError({
		type: ErrorTypes.KEY_SYSTEM_ERROR,
		details,
		fatal: false,
		decryptdata
	}, outputRestricted ? "HDCP level output restricted" : `key status changed to "${keyStatus}"`);
}
var FPSController = class {
	constructor(hls) {
		this.hls = void 0;
		this.isVideoPlaybackQualityAvailable = false;
		this.timer = void 0;
		this.media = null;
		this.lastTime = void 0;
		this.lastDroppedFrames = 0;
		this.lastDecodedFrames = 0;
		this.streamController = void 0;
		this.hls = hls;
		this.registerListeners();
	}
	setStreamController(streamController) {
		this.streamController = streamController;
	}
	registerListeners() {
		this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
	}
	unregisterListeners() {
		this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
	}
	destroy() {
		if (this.timer) clearInterval(this.timer);
		this.unregisterListeners();
		this.isVideoPlaybackQualityAvailable = false;
		this.media = null;
	}
	onMediaAttaching(event, data) {
		const config = this.hls.config;
		if (config.capLevelOnFPSDrop) {
			const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
			this.media = media;
			if (media && typeof media.getVideoPlaybackQuality === "function") this.isVideoPlaybackQualityAvailable = true;
			self.clearInterval(this.timer);
			this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
		}
	}
	onMediaDetaching() {
		this.media = null;
	}
	checkFPS(video, decodedFrames, droppedFrames) {
		const currentTime = performance.now();
		if (decodedFrames) {
			if (this.lastTime) {
				const currentPeriod = currentTime - this.lastTime;
				const currentDropped = droppedFrames - this.lastDroppedFrames;
				const currentDecoded = decodedFrames - this.lastDecodedFrames;
				const droppedFPS = 1e3 * currentDropped / currentPeriod;
				const hls = this.hls;
				hls.trigger(Events.FPS_DROP, {
					currentDropped,
					currentDecoded,
					totalDroppedFrames: droppedFrames
				});
				if (droppedFPS > 0) {
					if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
						let currentLevel = hls.currentLevel;
						hls.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + currentLevel);
						if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
							currentLevel = currentLevel - 1;
							hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
								level: currentLevel,
								droppedLevel: hls.currentLevel
							});
							hls.autoLevelCapping = currentLevel;
							this.streamController.nextLevelSwitch();
						}
					}
				}
			}
			this.lastTime = currentTime;
			this.lastDroppedFrames = droppedFrames;
			this.lastDecodedFrames = decodedFrames;
		}
	}
	checkFPSInterval() {
		const video = this.media;
		if (video) if (this.isVideoPlaybackQualityAvailable) {
			const videoPlaybackQuality = video.getVideoPlaybackQuality();
			this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
		} else this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
	}
};
function sendAddTrackEvent(track, videoEl) {
	let event;
	try {
		event = new Event("addtrack");
	} catch (err) {
		event = document.createEvent("Event");
		event.initEvent("addtrack", false, false);
	}
	event.track = track;
	videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
	const mode = track.mode;
	if (mode === "disabled") track.mode = "hidden";
	if (track.cues && !track.cues.getCueById(cue.id)) try {
		track.addCue(cue);
		if (!track.cues.getCueById(cue.id)) throw new Error(`addCue is failed for: ${cue}`);
	} catch (err) {
		logger.debug(`[texttrack-utils]: ${err}`);
		try {
			const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
			textTrackCue.id = cue.id;
			track.addCue(textTrackCue);
		} catch (err2) {
			logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
		}
	}
	if (mode === "disabled") track.mode = mode;
}
function clearCurrentCues(track, enterHandler) {
	const mode = track.mode;
	if (mode === "disabled") track.mode = "hidden";
	if (track.cues) for (let i = track.cues.length; i--;) {
		if (enterHandler) track.cues[i].removeEventListener("enter", enterHandler);
		track.removeCue(track.cues[i]);
	}
	if (mode === "disabled") track.mode = mode;
}
function removeCuesInRange(track, start, end, predicate) {
	const mode = track.mode;
	if (mode === "disabled") track.mode = "hidden";
	if (track.cues && track.cues.length > 0) {
		const cues = getCuesInRange(track.cues, start, end);
		for (let i = 0; i < cues.length; i++) if (!predicate || predicate(cues[i])) track.removeCue(cues[i]);
	}
	if (mode === "disabled") track.mode = mode;
}
function getFirstCueIndexFromTime(cues, time) {
	if (time <= cues[0].startTime) return 0;
	const len = cues.length - 1;
	if (time > cues[len].endTime) return -1;
	let left = 0;
	let right = len;
	let mid;
	while (left <= right) {
		mid = Math.floor((right + left) / 2);
		if (time < cues[mid].startTime) right = mid - 1;
		else if (time > cues[mid].startTime && left < len) left = mid + 1;
		else return mid;
	}
	return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
	const cuesFound = [];
	const firstCueInRange = getFirstCueIndexFromTime(cues, start);
	if (firstCueInRange > -1) for (let i = firstCueInRange, len = cues.length; i < len; i++) {
		const cue = cues[i];
		if (cue.startTime >= start && cue.endTime <= end) cuesFound.push(cue);
		else if (cue.startTime > end) return cuesFound;
	}
	return cuesFound;
}
function filterSubtitleTracks(textTrackList) {
	const tracks = [];
	for (let i = 0; i < textTrackList.length; i++) {
		const track = textTrackList[i];
		if ((track.kind === "subtitles" || track.kind === "captions") && track.label) tracks.push(textTrackList[i]);
	}
	return tracks;
}
var SubtitleTrackController = class extends BasePlaylistController {
	constructor(hls) {
		super(hls, "subtitle-track-controller");
		this.media = null;
		this.tracks = [];
		this.groupIds = null;
		this.tracksInGroup = [];
		this.trackId = -1;
		this.currentTrack = null;
		this.selectDefaultTrack = true;
		this.queuedDefaultTrack = -1;
		this.useTextTrackPolling = false;
		this.subtitlePollingInterval = -1;
		this._subtitleDisplay = true;
		this.asyncPollTrackChange = () => this.pollTrackChange(0);
		this.onTextTracksChanged = () => {
			if (!this.useTextTrackPolling) self.clearInterval(this.subtitlePollingInterval);
			if (!this.media || !this.hls.config.renderTextTracksNatively) return;
			let textTrack = null;
			const tracks = filterSubtitleTracks(this.media.textTracks);
			for (let i = 0; i < tracks.length; i++) if (tracks[i].mode === "hidden") textTrack = tracks[i];
			else if (tracks[i].mode === "showing") {
				textTrack = tracks[i];
				break;
			}
			const trackId = this.findTrackForTextTrack(textTrack);
			if (this.subtitleTrack !== trackId) this.setSubtitleTrack(trackId);
		};
		this.registerListeners();
	}
	destroy() {
		this.unregisterListeners();
		this.tracks.length = 0;
		this.tracksInGroup.length = 0;
		this.currentTrack = null;
		this.onTextTracksChanged = this.asyncPollTrackChange = null;
		super.destroy();
	}
	get subtitleDisplay() {
		return this._subtitleDisplay;
	}
	set subtitleDisplay(value) {
		this._subtitleDisplay = value;
		if (this.trackId > -1) this.toggleTrackModes();
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
		hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	onMediaAttached(event, data) {
		this.media = data.media;
		if (!this.media) return;
		if (this.queuedDefaultTrack > -1) {
			this.subtitleTrack = this.queuedDefaultTrack;
			this.queuedDefaultTrack = -1;
		}
		this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks);
		if (this.useTextTrackPolling) this.pollTrackChange(500);
		else this.media.textTracks.addEventListener("change", this.asyncPollTrackChange);
	}
	pollTrackChange(timeout) {
		self.clearInterval(this.subtitlePollingInterval);
		this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
	}
	onMediaDetaching(event, data) {
		const media = this.media;
		if (!media) return;
		const transferringMedia = !!data.transferMedia;
		self.clearInterval(this.subtitlePollingInterval);
		if (!this.useTextTrackPolling) media.textTracks.removeEventListener("change", this.asyncPollTrackChange);
		if (this.trackId > -1) this.queuedDefaultTrack = this.trackId;
		this.subtitleTrack = -1;
		this.media = null;
		if (transferringMedia) return;
		filterSubtitleTracks(media.textTracks).forEach((track) => {
			clearCurrentCues(track);
		});
	}
	onManifestLoading() {
		this.tracks = [];
		this.groupIds = null;
		this.tracksInGroup = [];
		this.trackId = -1;
		this.currentTrack = null;
		this.selectDefaultTrack = true;
	}
	onManifestParsed(event, data) {
		this.tracks = data.subtitleTracks;
	}
	onSubtitleTrackLoaded(event, data) {
		const { id, groupId, details } = data;
		const trackInActiveGroup = this.tracksInGroup[id];
		if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
			this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
			return;
		}
		const curDetails = trackInActiveGroup.details;
		trackInActiveGroup.details = data.details;
		this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
		if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
	}
	onLevelLoading(event, data) {
		this.switchLevel(data.level);
	}
	onLevelSwitching(event, data) {
		this.switchLevel(data.level);
	}
	switchLevel(levelIndex) {
		const levelInfo = this.hls.levels[levelIndex];
		if (!levelInfo) return;
		const subtitleGroups = levelInfo.subtitleGroups || null;
		const currentGroups = this.groupIds;
		let currentTrack = this.currentTrack;
		if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some((groupId) => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
			this.groupIds = subtitleGroups;
			this.trackId = -1;
			this.currentTrack = null;
			const subtitleTracks = this.tracks.filter((track) => !subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
			if (subtitleTracks.length) {
				if (this.selectDefaultTrack && !subtitleTracks.some((track) => track.default)) this.selectDefaultTrack = false;
				subtitleTracks.forEach((track, i) => {
					track.id = i;
				});
			} else if (!currentTrack && !this.tracksInGroup.length) return;
			this.tracksInGroup = subtitleTracks;
			const subtitlePreference = this.hls.config.subtitlePreference;
			if (!currentTrack && subtitlePreference) {
				this.selectDefaultTrack = false;
				const groupIndex = findMatchingOption(subtitlePreference, subtitleTracks);
				if (groupIndex > -1) currentTrack = subtitleTracks[groupIndex];
				else {
					const allIndex = findMatchingOption(subtitlePreference, this.tracks);
					currentTrack = this.tracks[allIndex];
				}
			}
			let trackId = this.findTrackId(currentTrack);
			if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
			const subtitleTracksUpdated = { subtitleTracks };
			this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(",")}" group-id`);
			this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
			if (trackId !== -1 && this.trackId === -1) this.setSubtitleTrack(trackId);
		}
	}
	findTrackId(currentTrack) {
		const tracks = this.tracksInGroup;
		const selectDefault = this.selectDefaultTrack;
		for (let i = 0; i < tracks.length; i++) {
			const track = tracks[i];
			if (selectDefault && !track.default || !selectDefault && !currentTrack) continue;
			if (!currentTrack || matchesOption(track, currentTrack)) return i;
		}
		if (currentTrack) {
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
					"LANGUAGE",
					"ASSOC-LANGUAGE",
					"CHARACTERISTICS"
				])) return i;
			}
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ["LANGUAGE"])) return i;
			}
		}
		return -1;
	}
	findTrackForTextTrack(textTrack) {
		if (textTrack) {
			const tracks = this.tracksInGroup;
			for (let i = 0; i < tracks.length; i++) {
				const track = tracks[i];
				if (subtitleTrackMatchesTextTrack(track, textTrack)) return i;
			}
		}
		return -1;
	}
	onError(event, data) {
		if (data.fatal || !data.context) return;
		if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
	}
	get allSubtitleTracks() {
		return this.tracks;
	}
	/** get alternate subtitle tracks list from playlist **/
	get subtitleTracks() {
		return this.tracksInGroup;
	}
	/** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
	get subtitleTrack() {
		return this.trackId;
	}
	set subtitleTrack(newId) {
		this.selectDefaultTrack = false;
		this.setSubtitleTrack(newId);
	}
	setSubtitleOption(subtitleOption) {
		this.hls.config.subtitlePreference = subtitleOption;
		if (subtitleOption) {
			if (subtitleOption.id === -1) {
				this.setSubtitleTrack(-1);
				return null;
			}
			const allSubtitleTracks = this.allSubtitleTracks;
			this.selectDefaultTrack = false;
			if (allSubtitleTracks.length) {
				const currentTrack = this.currentTrack;
				if (currentTrack && matchesOption(subtitleOption, currentTrack)) return currentTrack;
				const groupIndex = findMatchingOption(subtitleOption, this.tracksInGroup);
				if (groupIndex > -1) {
					const track = this.tracksInGroup[groupIndex];
					this.setSubtitleTrack(groupIndex);
					return track;
				} else if (currentTrack) return null;
				else {
					const allIndex = findMatchingOption(subtitleOption, allSubtitleTracks);
					if (allIndex > -1) return allSubtitleTracks[allIndex];
				}
			}
		}
		return null;
	}
	loadPlaylist(hlsUrlParameters) {
		super.loadPlaylist();
		if (this.shouldLoadPlaylist(this.currentTrack)) this.scheduleLoading(this.currentTrack, hlsUrlParameters);
	}
	loadingPlaylist(currentTrack, hlsUrlParameters) {
		super.loadingPlaylist(currentTrack, hlsUrlParameters);
		const id = currentTrack.id;
		const groupId = currentTrack.groupId;
		const url = this.getUrlWithDirectives(currentTrack.url, hlsUrlParameters);
		const details = currentTrack.details;
		const age = details == null ? void 0 : details.age;
		this.log(`Loading subtitle ${id} "${currentTrack.name}" lang:${currentTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== void 0 ? " at sn " + hlsUrlParameters.msn + " part " + hlsUrlParameters.part : ""}${age && details.live ? " age " + age.toFixed(1) + (details.type ? " " + details.type || "" : "") : ""} ${url}`);
		this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
			url,
			id,
			groupId,
			deliveryDirectives: hlsUrlParameters || null,
			track: currentTrack
		});
	}
	/**
	* Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
	* This operates on the DOM textTracks.
	* A value of -1 will disable all subtitle tracks.
	*/
	toggleTrackModes() {
		const { media } = this;
		if (!media) return;
		const textTracks = filterSubtitleTracks(media.textTracks);
		const currentTrack = this.currentTrack;
		let nextTrack;
		if (currentTrack) {
			nextTrack = textTracks.filter((textTrack) => subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
			if (!nextTrack) this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
		}
		[].slice.call(textTracks).forEach((track) => {
			if (track.mode !== "disabled" && track !== nextTrack) track.mode = "disabled";
		});
		if (nextTrack) {
			const mode = this.subtitleDisplay ? "showing" : "hidden";
			if (nextTrack.mode !== mode) nextTrack.mode = mode;
		}
	}
	/**
	* This method is responsible for validating the subtitle index and periodically reloading if live.
	* Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
	*/
	setSubtitleTrack(newId) {
		const tracks = this.tracksInGroup;
		if (!this.media) {
			this.queuedDefaultTrack = newId;
			return;
		}
		if (newId < -1 || newId >= tracks.length || !isFiniteNumber(newId)) {
			this.warn(`Invalid subtitle track id: ${newId}`);
			return;
		}
		this.selectDefaultTrack = false;
		const lastTrack = this.currentTrack;
		const track = tracks[newId] || null;
		this.trackId = newId;
		this.currentTrack = track;
		this.toggleTrackModes();
		if (!track) {
			this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, { id: newId });
			return;
		}
		const trackLoaded = !!track.details && !track.details.live;
		if (newId === this.trackId && track === lastTrack && trackLoaded) return;
		this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ""));
		const { id, groupId = "", name, type, url } = track;
		this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
			id,
			groupId,
			name,
			type,
			url
		});
		const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
		this.loadPlaylist(hlsUrlParameters);
	}
};
/**
* Generate a random v4 UUID
*
* @returns A random v4 UUID
*
* @group Utils
*
* @beta
*/
function uuid() {
	try {
		return crypto.randomUUID();
	} catch (error) {
		try {
			const url = URL.createObjectURL(new Blob());
			const uuid = url.toString();
			URL.revokeObjectURL(url);
			return uuid.slice(uuid.lastIndexOf("/") + 1);
		} catch (error) {
			let dt = (/* @__PURE__ */ new Date()).getTime();
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
				const r = (dt + Math.random() * 16) % 16 | 0;
				dt = Math.floor(dt / 16);
				return (c == "x" ? r : r & 3 | 8).toString(16);
			});
		}
	}
}
function hash(text) {
	let hash = 5381;
	let i = text.length;
	while (i) hash = hash * 33 ^ text.charCodeAt(--i);
	return (hash >>> 0).toString();
}
var ALIGNED_END_THRESHOLD_SECONDS = .025;
var TimelineOccupancy = /* @__PURE__ */ function(TimelineOccupancy) {
	TimelineOccupancy[TimelineOccupancy["Point"] = 0] = "Point";
	TimelineOccupancy[TimelineOccupancy["Range"] = 1] = "Range";
	return TimelineOccupancy;
}({});
function generateAssetIdentifier(interstitial, uri, assetListIndex) {
	return `${interstitial.identifier}-${assetListIndex + 1}-${hash(uri)}`;
}
var InterstitialEvent = class {
	constructor(dateRange, base) {
		this.base = void 0;
		this._duration = null;
		this._timelineStart = null;
		this.appendInPlaceDisabled = void 0;
		this.appendInPlaceStarted = void 0;
		this.dateRange = void 0;
		this.hasPlayed = false;
		this.cumulativeDuration = 0;
		this.resumeOffset = NaN;
		this.playoutLimit = NaN;
		this.restrictions = {
			skip: false,
			jump: false
		};
		this.snapOptions = {
			out: false,
			in: false
		};
		this.assetList = [];
		this.assetListLoader = void 0;
		this.assetListResponse = null;
		this.resumeAnchor = void 0;
		this.error = void 0;
		this.resetOnResume = void 0;
		this.base = base;
		this.dateRange = dateRange;
		this.setDateRange(dateRange);
	}
	setDateRange(dateRange) {
		this.dateRange = dateRange;
		this.resumeOffset = dateRange.attr.optionalFloat("X-RESUME-OFFSET", this.resumeOffset);
		this.playoutLimit = dateRange.attr.optionalFloat("X-PLAYOUT-LIMIT", this.playoutLimit);
		this.restrictions = dateRange.attr.enumeratedStringList("X-RESTRICT", this.restrictions);
		this.snapOptions = dateRange.attr.enumeratedStringList("X-SNAP", this.snapOptions);
	}
	reset() {
		var _this$assetListLoader;
		this.appendInPlaceStarted = false;
		(_this$assetListLoader = this.assetListLoader) == null || _this$assetListLoader.destroy();
		this.assetListLoader = void 0;
		if (!this.supplementsPrimary) {
			this.assetListResponse = null;
			this.assetList = [];
			this._duration = null;
		}
	}
	isAssetPastPlayoutLimit(assetIndex) {
		var _this$assetList$asset;
		if (assetIndex > 0 && assetIndex >= this.assetList.length) return true;
		const playoutLimit = this.playoutLimit;
		if (assetIndex <= 0 || isNaN(playoutLimit)) return false;
		if (playoutLimit === 0) return true;
		return (((_this$assetList$asset = this.assetList[assetIndex]) == null ? void 0 : _this$assetList$asset.startOffset) || 0) > playoutLimit;
	}
	findAssetIndex(asset) {
		return this.assetList.indexOf(asset);
	}
	get identifier() {
		return this.dateRange.id;
	}
	get startDate() {
		return this.dateRange.startDate;
	}
	get startTime() {
		const startTime = this.dateRange.startTime;
		if (this.snapOptions.out) {
			const frag = this.dateRange.tagAnchor;
			if (frag) return getSnapToFragmentTime(startTime, frag);
		}
		return startTime;
	}
	get startOffset() {
		return this.cue.pre ? 0 : this.startTime;
	}
	get startIsAligned() {
		if (this.startTime === 0 || this.snapOptions.out) return true;
		const frag = this.dateRange.tagAnchor;
		if (frag) {
			const startTime = this.dateRange.startTime;
			return startTime - getSnapToFragmentTime(startTime, frag) < .1;
		}
		return false;
	}
	get resumptionOffset() {
		const resumeOffset = this.resumeOffset;
		const offset = isFiniteNumber(resumeOffset) ? resumeOffset : this.duration;
		return this.cumulativeDuration + offset;
	}
	get resumeTime() {
		const resumeTime = this.startOffset + this.resumptionOffset;
		if (this.snapOptions.in) {
			const frag = this.resumeAnchor;
			if (frag) return getSnapToFragmentTime(resumeTime, frag);
		}
		return resumeTime;
	}
	get appendInPlace() {
		if (this.appendInPlaceStarted) return true;
		if (this.appendInPlaceDisabled) return false;
		if (!this.cue.once && !this.cue.pre && this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < ALIGNED_END_THRESHOLD_SECONDS)) return true;
		return false;
	}
	set appendInPlace(value) {
		if (this.appendInPlaceStarted) {
			this.resetOnResume = !value;
			return;
		}
		this.appendInPlaceDisabled = !value;
	}
	get timelineStart() {
		if (this._timelineStart !== null) return this._timelineStart;
		return this.startTime;
	}
	set timelineStart(value) {
		this._timelineStart = value;
	}
	get duration() {
		const playoutLimit = this.playoutLimit;
		let duration;
		if (this._duration !== null) duration = this._duration;
		else if (this.dateRange.duration) duration = this.dateRange.duration;
		else duration = this.dateRange.plannedDuration || 0;
		if (!isNaN(playoutLimit) && playoutLimit < duration) duration = playoutLimit;
		return duration;
	}
	set duration(value) {
		this._duration = value;
	}
	get cue() {
		return this.dateRange.cue;
	}
	get timelineOccupancy() {
		if (this.dateRange.attr["X-TIMELINE-OCCUPIES"] === "RANGE") return TimelineOccupancy.Range;
		return TimelineOccupancy.Point;
	}
	get supplementsPrimary() {
		return this.dateRange.attr["X-TIMELINE-STYLE"] === "PRIMARY";
	}
	get contentMayVary() {
		return this.dateRange.attr["X-CONTENT-MAY-VARY"] !== "NO";
	}
	get assetUrl() {
		return this.dateRange.attr["X-ASSET-URI"];
	}
	get assetListUrl() {
		return this.dateRange.attr["X-ASSET-LIST"];
	}
	get baseUrl() {
		return this.base.url;
	}
	get assetListLoaded() {
		return this.assetList.length > 0 || this.assetListResponse !== null;
	}
	toString() {
		return eventToString(this);
	}
};
function getSnapToFragmentTime(time, frag) {
	return time - frag.start < frag.duration / 2 && !(Math.abs(time - (frag.start + frag.duration)) < ALIGNED_END_THRESHOLD_SECONDS) ? frag.start : frag.start + frag.duration;
}
function getInterstitialUrl(uri, sessionId, baseUrl) {
	const url = new self.URL(uri, baseUrl);
	if (url.protocol !== "data:") url.searchParams.set("_HLS_primary_id", sessionId);
	return url;
}
function getNextAssetIndex(interstitial, assetListIndex) {
	while ((_interstitial$assetLi = interstitial.assetList[++assetListIndex]) != null && _interstitial$assetLi.error) var _interstitial$assetLi;
	return assetListIndex;
}
function eventToString(interstitial) {
	return `["${interstitial.identifier}" ${interstitial.cue.pre ? "<pre>" : interstitial.cue.post ? "<post>" : ""}${interstitial.timelineStart.toFixed(2)}-${interstitial.resumeTime.toFixed(2)}]`;
}
function eventAssetToString(asset) {
	const start = asset.timelineStart;
	const duration = asset.duration || 0;
	return `["${asset.identifier}" ${start.toFixed(2)}-${(start + duration).toFixed(2)}]`;
}
var HlsAssetPlayer = class {
	constructor(HlsPlayerClass, userConfig, interstitial, assetItem) {
		this.hls = void 0;
		this.interstitial = void 0;
		this.assetItem = void 0;
		this.tracks = null;
		this.hasDetails = false;
		this.mediaAttached = null;
		this._currentTime = void 0;
		this._bufferedEosTime = void 0;
		this.checkPlayout = () => {
			if (this.reachedPlayout(this.currentTime) && this.hls) this.hls.trigger(Events.PLAYOUT_LIMIT_REACHED, {});
		};
		const hls = this.hls = new HlsPlayerClass(userConfig);
		this.interstitial = interstitial;
		this.assetItem = assetItem;
		const detailsLoaded = () => {
			this.hasDetails = true;
		};
		hls.once(Events.LEVEL_LOADED, detailsLoaded);
		hls.once(Events.AUDIO_TRACK_LOADED, detailsLoaded);
		hls.once(Events.SUBTITLE_TRACK_LOADED, detailsLoaded);
		hls.on(Events.MEDIA_ATTACHING, (name, { media }) => {
			this.removeMediaListeners();
			this.mediaAttached = media;
			if (this.interstitial.playoutLimit) {
				media.addEventListener("timeupdate", this.checkPlayout);
				if (this.appendInPlace) hls.on(Events.BUFFER_APPENDED, () => {
					const bufferedEnd = this.bufferedEnd;
					if (this.reachedPlayout(bufferedEnd)) {
						this._bufferedEosTime = bufferedEnd;
						hls.trigger(Events.BUFFERED_TO_END, void 0);
					}
				});
			}
		});
	}
	get appendInPlace() {
		return this.interstitial.appendInPlace;
	}
	loadSource() {
		const hls = this.hls;
		if (!hls) return;
		if (!hls.url) {
			let uri = this.assetItem.uri;
			try {
				uri = getInterstitialUrl(uri, hls.config.primarySessionId || "").href;
			} catch (error) {}
			hls.loadSource(uri);
		} else if (hls.levels.length && !hls.started) hls.startLoad(-1, true);
	}
	bufferedInPlaceToEnd(media) {
		var _this$hls;
		if (!this.appendInPlace) return false;
		if ((_this$hls = this.hls) != null && _this$hls.bufferedToEnd) return true;
		if (!media) return false;
		const duration = Math.min(this._bufferedEosTime || Infinity, this.duration);
		const start = this.timelineOffset;
		const bufferInfo = BufferHelper.bufferInfo(media, start, 0);
		return this.getAssetTime(bufferInfo.end) >= duration - .02;
	}
	reachedPlayout(time) {
		const playoutLimit = this.interstitial.playoutLimit;
		return this.startOffset + time >= playoutLimit;
	}
	get destroyed() {
		var _this$hls2;
		return !((_this$hls2 = this.hls) != null && _this$hls2.userConfig);
	}
	get assetId() {
		return this.assetItem.identifier;
	}
	get interstitialId() {
		return this.assetItem.parentIdentifier;
	}
	get media() {
		var _this$hls3;
		return ((_this$hls3 = this.hls) == null ? void 0 : _this$hls3.media) || null;
	}
	get bufferedEnd() {
		const media = this.media || this.mediaAttached;
		if (!media) {
			if (this._bufferedEosTime) return this._bufferedEosTime;
			return this.currentTime;
		}
		const bufferInfo = BufferHelper.bufferInfo(media, media.currentTime, .001);
		return this.getAssetTime(bufferInfo.end);
	}
	get currentTime() {
		const media = this.media || this.mediaAttached;
		if (!media) return this._currentTime || 0;
		return this.getAssetTime(media.currentTime);
	}
	get duration() {
		const duration = this.assetItem.duration;
		if (!duration) return 0;
		const playoutLimit = this.interstitial.playoutLimit;
		if (playoutLimit) {
			const assetPlayout = playoutLimit - this.startOffset;
			if (assetPlayout > 0 && assetPlayout < duration) return assetPlayout;
		}
		return duration;
	}
	get remaining() {
		const duration = this.duration;
		if (!duration) return 0;
		return Math.max(0, duration - this.currentTime);
	}
	get startOffset() {
		return this.assetItem.startOffset;
	}
	get timelineOffset() {
		var _this$hls4;
		return ((_this$hls4 = this.hls) == null ? void 0 : _this$hls4.config.timelineOffset) || 0;
	}
	set timelineOffset(value) {
		const timelineOffset = this.timelineOffset;
		if (value !== timelineOffset) {
			const diff = value - timelineOffset;
			if (Math.abs(diff) > 1 / 9e4 && this.hls) {
				if (this.hasDetails) throw new Error(`Cannot set timelineOffset after playlists are loaded`);
				this.hls.config.timelineOffset = value;
			}
		}
	}
	getAssetTime(time) {
		const timelineOffset = this.timelineOffset;
		const duration = this.duration;
		return Math.min(Math.max(0, time - timelineOffset), duration);
	}
	removeMediaListeners() {
		const media = this.mediaAttached;
		if (media) {
			this._currentTime = media.currentTime;
			this.bufferSnapShot();
			media.removeEventListener("timeupdate", this.checkPlayout);
		}
	}
	bufferSnapShot() {
		if (this.mediaAttached) {
			var _this$hls5;
			if ((_this$hls5 = this.hls) != null && _this$hls5.bufferedToEnd) this._bufferedEosTime = this.bufferedEnd;
		}
	}
	destroy() {
		this.removeMediaListeners();
		if (this.hls) this.hls.destroy();
		this.hls = null;
		this.tracks = this.mediaAttached = this.checkPlayout = null;
	}
	attachMedia(data) {
		var _this$hls6;
		this.loadSource();
		(_this$hls6 = this.hls) == null || _this$hls6.attachMedia(data);
	}
	detachMedia() {
		var _this$hls7;
		this.removeMediaListeners();
		this.mediaAttached = null;
		(_this$hls7 = this.hls) == null || _this$hls7.detachMedia();
	}
	resumeBuffering() {
		var _this$hls8;
		(_this$hls8 = this.hls) == null || _this$hls8.resumeBuffering();
	}
	pauseBuffering() {
		var _this$hls9;
		(_this$hls9 = this.hls) == null || _this$hls9.pauseBuffering();
	}
	transferMedia() {
		var _this$hls0;
		this.bufferSnapShot();
		return ((_this$hls0 = this.hls) == null ? void 0 : _this$hls0.transferMedia()) || null;
	}
	resetDetails() {
		const hls = this.hls;
		if (hls && this.hasDetails) {
			hls.stopLoad();
			const deleteDetails = (obj) => delete obj.details;
			hls.levels.forEach(deleteDetails);
			hls.allAudioTracks.forEach(deleteDetails);
			hls.allSubtitleTracks.forEach(deleteDetails);
			this.hasDetails = false;
		}
	}
	on(event, listener, context) {
		var _this$hls1;
		(_this$hls1 = this.hls) == null || _this$hls1.on(event, listener);
	}
	once(event, listener, context) {
		var _this$hls10;
		(_this$hls10 = this.hls) == null || _this$hls10.once(event, listener);
	}
	off(event, listener, context) {
		var _this$hls11;
		(_this$hls11 = this.hls) == null || _this$hls11.off(event, listener);
	}
	toString() {
		var _this$hls12;
		return `HlsAssetPlayer: ${eventAssetToString(this.assetItem)} ${(_this$hls12 = this.hls) == null ? void 0 : _this$hls12.sessionId} ${this.appendInPlace ? "append-in-place" : ""}`;
	}
};
var ABUTTING_THRESHOLD_SECONDS = .033;
var InterstitialsSchedule = class extends Logger {
	constructor(onScheduleUpdate, logger) {
		super("interstitials-sched", logger);
		this.onScheduleUpdate = void 0;
		this.eventMap = {};
		this.events = null;
		this.items = null;
		this.durations = {
			primary: 0,
			playout: 0,
			integrated: 0
		};
		this.onScheduleUpdate = onScheduleUpdate;
	}
	destroy() {
		this.reset();
		this.onScheduleUpdate = null;
	}
	reset() {
		this.eventMap = {};
		this.setDurations(0, 0, 0);
		if (this.events) this.events.forEach((interstitial) => interstitial.reset());
		this.events = this.items = null;
	}
	resetErrorsInRange(start, end) {
		if (this.events) return this.events.reduce((count, interstitial) => {
			if (start <= interstitial.startOffset && end > interstitial.startOffset) {
				delete interstitial.error;
				return count + 1;
			}
			return count;
		}, 0);
		return 0;
	}
	get duration() {
		const items = this.items;
		return items ? items[items.length - 1].end : 0;
	}
	get length() {
		return this.items ? this.items.length : 0;
	}
	getEvent(identifier) {
		return identifier ? this.eventMap[identifier] || null : null;
	}
	hasEvent(identifier) {
		return identifier in this.eventMap;
	}
	findItemIndex(item, time) {
		if (item.event) return this.findEventIndex(item.event.identifier);
		let index = -1;
		if (item.nextEvent) index = this.findEventIndex(item.nextEvent.identifier) - 1;
		else if (item.previousEvent) index = this.findEventIndex(item.previousEvent.identifier) + 1;
		const items = this.items;
		if (items) {
			if (!items[index]) {
				if (time === void 0) time = item.start;
				index = this.findItemIndexAtTime(time);
			}
			while (index >= 0 && (_items$index = items[index]) != null && _items$index.event) {
				var _items$index;
				index--;
			}
		}
		return index;
	}
	findItemIndexAtTime(timelinePos, timelineType) {
		const items = this.items;
		if (items) for (let i = 0; i < items.length; i++) {
			let timeRange = items[i];
			if (timelineType && timelineType !== "primary") timeRange = timeRange[timelineType];
			if (timelinePos === timeRange.start || timelinePos > timeRange.start && timelinePos < timeRange.end) return i;
		}
		return -1;
	}
	findJumpRestrictedIndex(startIndex, endIndex) {
		const items = this.items;
		if (items) for (let i = startIndex; i <= endIndex; i++) {
			if (!items[i]) break;
			const event = items[i].event;
			if (event != null && event.restrictions.jump && !event.appendInPlace) return i;
		}
		return -1;
	}
	findEventIndex(identifier) {
		const items = this.items;
		if (items) for (let i = items.length; i--;) {
			var _items$i$event;
			if (((_items$i$event = items[i].event) == null ? void 0 : _items$i$event.identifier) === identifier) return i;
		}
		return -1;
	}
	findAssetIndex(event, timelinePos) {
		const assetList = event.assetList;
		const length = assetList.length;
		if (length > 1) for (let i = 0; i < length; i++) {
			const asset = assetList[i];
			if (!asset.error) {
				const timelineStart = asset.timelineStart;
				if (timelinePos === timelineStart || timelinePos > timelineStart && (timelinePos < timelineStart + (asset.duration || 0) || i === length - 1)) return i;
			}
		}
		return 0;
	}
	get assetIdAtEnd() {
		var _this$items;
		const interstitialAtEnd = (_this$items = this.items) == null || (_this$items = _this$items[this.length - 1]) == null ? void 0 : _this$items.event;
		if (interstitialAtEnd) {
			const assetList = interstitialAtEnd.assetList;
			const assetAtEnd = assetList[assetList.length - 1];
			if (assetAtEnd) return assetAtEnd.identifier;
		}
		return null;
	}
	parseInterstitialDateRanges(mediaSelection, enableAppendInPlace) {
		const details = mediaSelection.main.details;
		const { dateRanges } = details;
		const previousInterstitialEvents = this.events;
		const interstitialEvents = this.parseDateRanges(dateRanges, { url: details.url }, enableAppendInPlace);
		const ids = Object.keys(dateRanges);
		const removedInterstitials = previousInterstitialEvents ? previousInterstitialEvents.filter((event) => !ids.includes(event.identifier)) : [];
		if (interstitialEvents.length) interstitialEvents.sort((a, b) => {
			const aPre = a.cue.pre;
			const aPost = a.cue.post;
			const bPre = b.cue.pre;
			const bPost = b.cue.post;
			if (aPre && !bPre) return -1;
			if (bPre && !aPre) return 1;
			if (aPost && !bPost) return 1;
			if (bPost && !aPost) return -1;
			if (!aPre && !bPre && !aPost && !bPost) {
				const startA = a.startTime;
				const startB = b.startTime;
				if (startA !== startB) return startA - startB;
			}
			return a.dateRange.tagOrder - b.dateRange.tagOrder;
		});
		this.events = interstitialEvents;
		removedInterstitials.forEach((interstitial) => {
			this.removeEvent(interstitial);
		});
		this.updateSchedule(mediaSelection, removedInterstitials);
	}
	updateSchedule(mediaSelection, removedInterstitials = [], forceUpdate = false) {
		const events = this.events || [];
		if (events.length || removedInterstitials.length || this.length < 2) {
			const currentItems = this.items;
			const updatedItems = this.parseSchedule(events, mediaSelection);
			if (forceUpdate || removedInterstitials.length || (currentItems == null ? void 0 : currentItems.length) !== updatedItems.length || updatedItems.some((item, i) => {
				return Math.abs(item.playout.start - currentItems[i].playout.start) > .005 || Math.abs(item.playout.end - currentItems[i].playout.end) > .005;
			})) {
				this.items = updatedItems;
				this.onScheduleUpdate(removedInterstitials, currentItems);
			}
		}
	}
	parseDateRanges(dateRanges, baseData, enableAppendInPlace) {
		const interstitialEvents = [];
		const ids = Object.keys(dateRanges);
		for (let i = 0; i < ids.length; i++) {
			const id = ids[i];
			const dateRange = dateRanges[id];
			if (dateRange.isInterstitial) {
				let interstitial = this.eventMap[id];
				if (interstitial) interstitial.setDateRange(dateRange);
				else {
					interstitial = new InterstitialEvent(dateRange, baseData);
					this.eventMap[id] = interstitial;
					if (enableAppendInPlace === false) interstitial.appendInPlace = enableAppendInPlace;
				}
				interstitialEvents.push(interstitial);
			}
		}
		return interstitialEvents;
	}
	parseSchedule(interstitialEvents, mediaSelection) {
		const schedule = [];
		const details = mediaSelection.main.details;
		const primaryDuration = details.live ? Infinity : details.edge;
		let playoutDuration = 0;
		interstitialEvents = interstitialEvents.filter((event) => !event.error && !(event.cue.once && event.hasPlayed));
		if (interstitialEvents.length) {
			this.resolveOffsets(interstitialEvents, mediaSelection);
			let primaryPosition = 0;
			let integratedTime = 0;
			interstitialEvents.forEach((interstitial, i) => {
				const preroll = interstitial.cue.pre;
				const postroll = interstitial.cue.post;
				const previousEvent = interstitialEvents[i - 1] || null;
				const appendInPlace = interstitial.appendInPlace;
				const eventStart = postroll ? primaryDuration : interstitial.startOffset;
				const interstitialDuration = interstitial.duration;
				const timelineDuration = interstitial.timelineOccupancy === TimelineOccupancy.Range ? interstitialDuration : 0;
				const resumptionOffset = interstitial.resumptionOffset;
				const inSameStartTimeSequence = (previousEvent == null ? void 0 : previousEvent.startTime) === eventStart;
				const start = eventStart + interstitial.cumulativeDuration;
				let end = appendInPlace ? start + interstitialDuration : eventStart + resumptionOffset;
				if (preroll || !postroll && eventStart <= 0) {
					const integratedStart = integratedTime;
					integratedTime += timelineDuration;
					interstitial.timelineStart = start;
					const playoutStart = playoutDuration;
					playoutDuration += interstitialDuration;
					schedule.push({
						event: interstitial,
						start,
						end,
						playout: {
							start: playoutStart,
							end: playoutDuration
						},
						integrated: {
							start: integratedStart,
							end: integratedTime
						}
					});
				} else if (eventStart <= primaryDuration) {
					if (!inSameStartTimeSequence) {
						const segmentDuration = eventStart - primaryPosition;
						if (segmentDuration > ABUTTING_THRESHOLD_SECONDS) {
							const timelineStart = primaryPosition;
							const _integratedStart = integratedTime;
							integratedTime += segmentDuration;
							const _playoutStart = playoutDuration;
							playoutDuration += segmentDuration;
							const primarySegment = {
								previousEvent: interstitialEvents[i - 1] || null,
								nextEvent: interstitial,
								start: timelineStart,
								end: timelineStart + segmentDuration,
								playout: {
									start: _playoutStart,
									end: playoutDuration
								},
								integrated: {
									start: _integratedStart,
									end: integratedTime
								}
							};
							schedule.push(primarySegment);
						} else if (segmentDuration > 0 && previousEvent) {
							previousEvent.cumulativeDuration += segmentDuration;
							schedule[schedule.length - 1].end = eventStart;
						}
					}
					if (postroll) end = start;
					interstitial.timelineStart = start;
					const integratedStart = integratedTime;
					integratedTime += timelineDuration;
					const playoutStart = playoutDuration;
					playoutDuration += interstitialDuration;
					schedule.push({
						event: interstitial,
						start,
						end,
						playout: {
							start: playoutStart,
							end: playoutDuration
						},
						integrated: {
							start: integratedStart,
							end: integratedTime
						}
					});
				} else return;
				const resumeTime = interstitial.resumeTime;
				if (postroll || resumeTime > primaryDuration) primaryPosition = primaryDuration;
				else primaryPosition = resumeTime;
			});
			if (primaryPosition < primaryDuration) {
				var _schedule;
				const timelineStart = primaryPosition;
				const integratedStart = integratedTime;
				const segmentDuration = primaryDuration - primaryPosition;
				integratedTime += segmentDuration;
				const playoutStart = playoutDuration;
				playoutDuration += segmentDuration;
				schedule.push({
					previousEvent: ((_schedule = schedule[schedule.length - 1]) == null ? void 0 : _schedule.event) || null,
					nextEvent: null,
					start: primaryPosition,
					end: timelineStart + segmentDuration,
					playout: {
						start: playoutStart,
						end: playoutDuration
					},
					integrated: {
						start: integratedStart,
						end: integratedTime
					}
				});
			}
			this.setDurations(primaryDuration, playoutDuration, integratedTime);
		} else {
			const start = 0;
			schedule.push({
				previousEvent: null,
				nextEvent: null,
				start,
				end: primaryDuration,
				playout: {
					start,
					end: primaryDuration
				},
				integrated: {
					start,
					end: primaryDuration
				}
			});
			this.setDurations(primaryDuration, primaryDuration, primaryDuration);
		}
		return schedule;
	}
	setDurations(primary, playout, integrated) {
		this.durations = {
			primary,
			playout,
			integrated
		};
	}
	resolveOffsets(interstitialEvents, mediaSelection) {
		const details = mediaSelection.main.details;
		const primaryDuration = details.live ? Infinity : details.edge;
		let cumulativeDuration = 0;
		let lastScheduledStart = -1;
		interstitialEvents.forEach((interstitial, i) => {
			const preroll = interstitial.cue.pre;
			const postroll = interstitial.cue.post;
			const eventStart = preroll ? 0 : postroll ? primaryDuration : interstitial.startTime;
			this.updateAssetDurations(interstitial);
			if (lastScheduledStart === eventStart) interstitial.cumulativeDuration = cumulativeDuration;
			else {
				cumulativeDuration = 0;
				lastScheduledStart = eventStart;
			}
			if (!postroll && interstitial.snapOptions.in) interstitial.resumeAnchor = findFragmentByPTS(null, details.fragments, interstitial.startOffset + interstitial.resumptionOffset, 0, 0) || void 0;
			if (interstitial.appendInPlace && !interstitial.appendInPlaceStarted) {
				if (!this.primaryCanResumeInPlaceAt(interstitial, mediaSelection)) interstitial.appendInPlace = false;
			}
			if (!interstitial.appendInPlace && i + 1 < interstitialEvents.length) {
				if (interstitialEvents[i + 1].startTime - interstitialEvents[i].resumeTime < ABUTTING_THRESHOLD_SECONDS) {
					interstitialEvents[i + 1].appendInPlace = false;
					if (interstitialEvents[i + 1].appendInPlace) this.warn(`Could not change append strategy for abutting event ${interstitial}`);
				}
			}
			const resumeOffset = isFiniteNumber(interstitial.resumeOffset) ? interstitial.resumeOffset : interstitial.duration;
			cumulativeDuration += resumeOffset;
		});
	}
	primaryCanResumeInPlaceAt(interstitial, mediaSelection) {
		const resumeTime = interstitial.resumeTime;
		const resumesInPlaceAt = interstitial.startTime + interstitial.resumptionOffset;
		if (Math.abs(resumeTime - resumesInPlaceAt) > ALIGNED_END_THRESHOLD_SECONDS) {
			this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with estimated timeline end ${resumesInPlaceAt}`);
			return false;
		}
		return !Object.keys(mediaSelection).some((playlistType) => {
			const details = mediaSelection[playlistType].details;
			const playlistEnd = details.edge;
			if (resumeTime >= playlistEnd) {
				this.log(`"${interstitial.identifier}" resumption ${resumeTime} past ${playlistType} playlist end ${playlistEnd}`);
				return false;
			}
			const startFragment = findFragmentByPTS(null, details.fragments, resumeTime);
			if (!startFragment) {
				this.log(`"${interstitial.identifier}" resumption ${resumeTime} does not align with any fragments in ${playlistType} playlist (${details.fragStart}-${details.fragmentEnd})`);
				return true;
			}
			const allowance = playlistType === "audio" ? .175 : 0;
			if (!(Math.abs(startFragment.start - resumeTime) < ALIGNED_END_THRESHOLD_SECONDS + allowance || Math.abs(startFragment.end - resumeTime) < ALIGNED_END_THRESHOLD_SECONDS + allowance)) {
				this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with ${playlistType} fragment bounds (${startFragment.start}-${startFragment.end} sn: ${startFragment.sn} cc: ${startFragment.cc})`);
				return true;
			}
			return false;
		});
	}
	updateAssetDurations(interstitial) {
		if (!interstitial.assetListLoaded) return;
		const eventStart = interstitial.timelineStart;
		let sumDuration = 0;
		let hasUnknownDuration = false;
		let hasErrors = false;
		for (let i = 0; i < interstitial.assetList.length; i++) {
			const asset = interstitial.assetList[i];
			const timelineStart = eventStart + sumDuration;
			asset.startOffset = sumDuration;
			asset.timelineStart = timelineStart;
			hasUnknownDuration || (hasUnknownDuration = asset.duration === null);
			hasErrors || (hasErrors = !!asset.error);
			const duration = asset.error ? 0 : asset.duration || 0;
			sumDuration += duration;
		}
		if (hasUnknownDuration && !hasErrors) interstitial.duration = Math.max(sumDuration, interstitial.duration);
		else interstitial.duration = sumDuration;
	}
	removeEvent(interstitial) {
		interstitial.reset();
		delete this.eventMap[interstitial.identifier];
	}
};
function segmentToString(segment) {
	return `[${segment.event ? "\"" + segment.event.identifier + "\"" : "primary"}: ${segment.start.toFixed(2)}-${segment.end.toFixed(2)}]`;
}
var AssetListLoader = class {
	constructor(hls) {
		this.hls = void 0;
		this.hls = hls;
	}
	destroy() {
		this.hls = null;
	}
	loadAssetList(interstitial, hlsStartOffset) {
		const assetListUrl = interstitial.assetListUrl;
		let url;
		try {
			url = getInterstitialUrl(assetListUrl, this.hls.sessionId, interstitial.baseUrl);
		} catch (error) {
			const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_ERROR, error, assetListUrl);
			this.hls.trigger(Events.ERROR, errorData);
			return;
		}
		if (hlsStartOffset && url.protocol !== "data:") url.searchParams.set("_HLS_start_offset", "" + hlsStartOffset);
		const config = this.hls.config;
		const Loader = config.loader;
		const loader = new Loader(config);
		const context = {
			responseType: "json",
			url: url.href
		};
		const loadPolicy = config.interstitialAssetListLoadPolicy.default;
		const loaderConfig = {
			loadPolicy,
			timeout: loadPolicy.maxLoadTimeMs,
			maxRetry: 0,
			retryDelay: 0,
			maxRetryDelay: 0
		};
		loader.load(context, loaderConfig, {
			onSuccess: (response, stats, context, networkDetails) => {
				const assetListResponse = response.data;
				const assets = assetListResponse == null ? void 0 : assetListResponse.ASSETS;
				if (!Array.isArray(assets)) {
					const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_PARSING_ERROR, /* @__PURE__ */ new Error(`Invalid interstitial asset list`), context.url, stats, networkDetails);
					this.hls.trigger(Events.ERROR, errorData);
					return;
				}
				interstitial.assetListResponse = assetListResponse;
				this.hls.trigger(Events.ASSET_LIST_LOADED, {
					event: interstitial,
					assetListResponse,
					networkDetails
				});
			},
			onError: (error, context, networkDetails, stats) => {
				const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_ERROR, /* @__PURE__ */ new Error(`Error loading X-ASSET-LIST: HTTP status ${error.code} ${error.text} (${context.url})`), context.url, stats, networkDetails);
				this.hls.trigger(Events.ERROR, errorData);
			},
			onTimeout: (stats, context, networkDetails) => {
				const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_TIMEOUT, /* @__PURE__ */ new Error(`Timeout loading X-ASSET-LIST (${context.url})`), context.url, stats, networkDetails);
				this.hls.trigger(Events.ERROR, errorData);
			}
		});
		this.hls.trigger(Events.ASSET_LIST_LOADING, { event: interstitial });
		return loader;
	}
	assignAssetListError(interstitial, details, error, url, stats, networkDetails) {
		interstitial.error = error;
		return {
			type: ErrorTypes.NETWORK_ERROR,
			details,
			fatal: false,
			interstitial,
			url,
			error,
			networkDetails,
			stats
		};
	}
};
function playWithCatch(media) {
	var _media$play;
	media == null || (_media$play = media.play()) == null || _media$play.catch(() => {});
}
function timelineMessage(label, time) {
	return `[${label}] Advancing timeline position to ${time}`;
}
var InterstitialsController = class extends Logger {
	constructor(hls, HlsPlayerClass) {
		super("interstitials", hls.logger);
		this.HlsPlayerClass = void 0;
		this.hls = void 0;
		this.assetListLoader = void 0;
		this.mediaSelection = null;
		this.altSelection = null;
		this.media = null;
		this.detachedData = null;
		this.requiredTracks = null;
		this.manager = null;
		this.playerQueue = [];
		this.bufferedPos = -1;
		this.timelinePos = -1;
		this.schedule = void 0;
		this.playingItem = null;
		this.bufferingItem = null;
		this.waitingItem = null;
		this.endedItem = null;
		this.playingAsset = null;
		this.endedAsset = null;
		this.bufferingAsset = null;
		this.shouldPlay = false;
		this.onPlay = () => {
			this.shouldPlay = true;
		};
		this.onPause = () => {
			this.shouldPlay = false;
		};
		this.onSeeking = () => {
			const currentTime = this.currentTime;
			if (currentTime === void 0 || this.playbackDisabled || !this.schedule) return;
			const diff = currentTime - this.timelinePos;
			if (Math.abs(diff) < 1 / 7056e5) return;
			const backwardSeek = diff <= -.01;
			if (this.timelinePos === -1 && !this.effectivePlayingItem) this.checkStart();
			this.timelinePos = currentTime;
			this.bufferedPos = currentTime;
			const playingItem = this.playingItem;
			if (!playingItem) {
				this.checkBuffer();
				return;
			}
			if (backwardSeek) {
				if (this.schedule.resetErrorsInRange(currentTime, currentTime - diff)) this.updateSchedule(true);
			}
			this.checkBuffer();
			if (backwardSeek && currentTime < playingItem.start || currentTime >= playingItem.end) {
				var _this$media;
				const playingIndex = this.findItemIndex(playingItem);
				let scheduleIndex = this.schedule.findItemIndexAtTime(currentTime);
				if (scheduleIndex === -1) {
					scheduleIndex = playingIndex + (backwardSeek ? -1 : 1);
					this.log(`seeked ${backwardSeek ? "back " : ""}to position not covered by schedule ${currentTime} (resolving from ${playingIndex} to ${scheduleIndex})`);
				}
				if (!this.isInterstitial(playingItem) && (_this$media = this.media) != null && _this$media.paused) this.shouldPlay = false;
				if (!backwardSeek) {
					if (scheduleIndex > playingIndex) {
						const jumpIndex = this.schedule.findJumpRestrictedIndex(playingIndex + 1, scheduleIndex);
						if (jumpIndex > playingIndex) {
							this.setSchedulePosition(jumpIndex);
							return;
						}
					}
				}
				this.setSchedulePosition(scheduleIndex);
				return;
			}
			const playingAsset = this.playingAsset;
			if (!playingAsset) {
				if (this.playingLastItem && this.isInterstitial(playingItem)) {
					const restartAsset = playingItem.event.assetList[0];
					if (restartAsset) {
						this.endedItem = this.playingItem;
						this.playingItem = null;
						this.setScheduleToAssetAtTime(currentTime, restartAsset);
					}
				}
				return;
			}
			const start = playingAsset.timelineStart;
			const duration = playingAsset.duration || 0;
			if (backwardSeek && currentTime < start || currentTime >= start + duration) {
				var _playingItem$event;
				if ((_playingItem$event = playingItem.event) != null && _playingItem$event.appendInPlace) {
					this.clearAssetPlayers(playingItem.event, playingItem);
					this.flushFrontBuffer(currentTime);
				}
				this.setScheduleToAssetAtTime(currentTime, playingAsset);
			}
		};
		this.onTimeupdate = () => {
			const currentTime = this.currentTime;
			if (currentTime === void 0 || this.playbackDisabled) return;
			if (this.timelinePos === -1 && !this.effectivePlayingItem) this.checkStart();
			if (currentTime > this.timelinePos) {
				this.timelinePos = currentTime;
				if (currentTime > this.bufferedPos) this.checkBuffer();
			} else return;
			const playingItem = this.playingItem;
			if (!playingItem || this.playingLastItem) return;
			if (currentTime >= playingItem.end) {
				this.timelinePos = playingItem.end;
				const playingIndex = this.findItemIndex(playingItem);
				this.setSchedulePosition(playingIndex + 1);
			}
			const playingAsset = this.playingAsset;
			if (!playingAsset) return;
			if (currentTime >= playingAsset.timelineStart + (playingAsset.duration || 0)) this.setScheduleToAssetAtTime(currentTime, playingAsset);
		};
		this.onScheduleUpdate = (removedInterstitials, previousItems) => {
			const schedule = this.schedule;
			if (!schedule) return;
			const playingItem = this.playingItem;
			const interstitialEvents = schedule.events || [];
			const scheduleItems = schedule.items || [];
			const durations = schedule.durations;
			const removedIds = removedInterstitials.map((interstitial) => interstitial.identifier);
			const interstitialsUpdated = !!(interstitialEvents.length || removedIds.length);
			if (interstitialsUpdated || previousItems) this.log(`INTERSTITIALS_UPDATED (${interstitialEvents.length}): ${interstitialEvents}
Schedule: ${scheduleItems.map((seg) => segmentToString(seg))} pos: ${this.timelinePos}`);
			if (removedIds.length) this.log(`Removed events ${removedIds}`);
			let updatedPlayingItem = null;
			let updatedBufferingItem = null;
			if (playingItem) {
				updatedPlayingItem = this.updateItem(playingItem, this.timelinePos);
				if (this.itemsMatch(playingItem, updatedPlayingItem)) this.playingItem = updatedPlayingItem;
				else this.waitingItem = this.endedItem = null;
			}
			this.waitingItem = this.updateItem(this.waitingItem);
			this.endedItem = this.updateItem(this.endedItem);
			const bufferingItem = this.bufferingItem;
			if (bufferingItem) {
				updatedBufferingItem = this.updateItem(bufferingItem, this.bufferedPos);
				if (this.itemsMatch(bufferingItem, updatedBufferingItem)) this.bufferingItem = updatedBufferingItem;
				else if (bufferingItem.event) {
					this.bufferingItem = this.playingItem;
					this.clearInterstitial(bufferingItem.event, null);
				}
			}
			removedInterstitials.forEach((interstitial) => {
				interstitial.assetList.forEach((asset) => {
					this.clearAssetPlayer(asset.identifier, null);
				});
			});
			this.playerQueue.forEach((player) => {
				if (player.interstitial.appendInPlace) {
					const timelineStart = player.assetItem.timelineStart;
					const diff = player.timelineOffset - timelineStart;
					if (diff) try {
						player.timelineOffset = timelineStart;
					} catch (e) {
						if (Math.abs(diff) > ALIGNED_END_THRESHOLD_SECONDS) this.warn(`${e} ("${player.assetId}" ${player.timelineOffset}->${timelineStart})`);
					}
				}
			});
			if (interstitialsUpdated || previousItems) {
				this.hls.trigger(Events.INTERSTITIALS_UPDATED, {
					events: interstitialEvents.slice(0),
					schedule: scheduleItems.slice(0),
					durations,
					removedIds
				});
				if (this.isInterstitial(playingItem) && removedIds.includes(playingItem.event.identifier)) {
					this.warn(`Interstitial "${playingItem.event.identifier}" removed while playing`);
					this.primaryFallback(playingItem.event);
					return;
				}
				if (playingItem) this.trimInPlace(updatedPlayingItem, playingItem);
				if (bufferingItem && updatedBufferingItem !== updatedPlayingItem) this.trimInPlace(updatedBufferingItem, bufferingItem);
				this.checkBuffer();
			}
		};
		this.hls = hls;
		this.HlsPlayerClass = HlsPlayerClass;
		this.assetListLoader = new AssetListLoader(hls);
		this.schedule = new InterstitialsSchedule(this.onScheduleUpdate, hls.logger);
		this.registerListeners();
	}
	registerListeners() {
		const hls = this.hls;
		if (hls) {
			hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
			hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
			hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
			hls.on(Events.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
			hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
			hls.on(Events.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
			hls.on(Events.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
			hls.on(Events.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
			hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
			hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
			hls.on(Events.BUFFERED_TO_END, this.onBufferedToEnd, this);
			hls.on(Events.MEDIA_ENDED, this.onMediaEnded, this);
			hls.on(Events.ERROR, this.onError, this);
			hls.on(Events.DESTROYING, this.onDestroying, this);
		}
	}
	unregisterListeners() {
		const hls = this.hls;
		if (hls) {
			hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
			hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
			hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
			hls.off(Events.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
			hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
			hls.off(Events.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
			hls.off(Events.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
			hls.off(Events.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
			hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
			hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
			hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
			hls.off(Events.BUFFERED_TO_END, this.onBufferedToEnd, this);
			hls.off(Events.MEDIA_ENDED, this.onMediaEnded, this);
			hls.off(Events.ERROR, this.onError, this);
			hls.off(Events.DESTROYING, this.onDestroying, this);
		}
	}
	startLoad() {
		this.resumeBuffering();
	}
	stopLoad() {
		this.pauseBuffering();
	}
	resumeBuffering() {
		var _this$getBufferingPla;
		(_this$getBufferingPla = this.getBufferingPlayer()) == null || _this$getBufferingPla.resumeBuffering();
	}
	pauseBuffering() {
		var _this$getBufferingPla2;
		(_this$getBufferingPla2 = this.getBufferingPlayer()) == null || _this$getBufferingPla2.pauseBuffering();
	}
	destroy() {
		this.unregisterListeners();
		this.stopLoad();
		if (this.assetListLoader) this.assetListLoader.destroy();
		this.emptyPlayerQueue();
		this.clearScheduleState();
		if (this.schedule) this.schedule.destroy();
		this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.schedule = this.manager = null;
		this.hls = this.HlsPlayerClass = this.log = null;
		this.assetListLoader = null;
		this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null;
		this.onScheduleUpdate = null;
	}
	onDestroying() {
		const media = this.primaryMedia || this.media;
		if (media) this.removeMediaListeners(media);
	}
	removeMediaListeners(media) {
		removeEventListener(media, "play", this.onPlay);
		removeEventListener(media, "pause", this.onPause);
		removeEventListener(media, "seeking", this.onSeeking);
		removeEventListener(media, "timeupdate", this.onTimeupdate);
	}
	onMediaAttaching(event, data) {
		const media = this.media = data.media;
		addEventListener(media, "seeking", this.onSeeking);
		addEventListener(media, "timeupdate", this.onTimeupdate);
		addEventListener(media, "play", this.onPlay);
		addEventListener(media, "pause", this.onPause);
	}
	onMediaAttached(event, data) {
		const playingItem = this.effectivePlayingItem;
		const detachedMedia = this.detachedData;
		this.detachedData = null;
		if (playingItem === null) this.checkStart();
		else if (!detachedMedia) {
			this.clearScheduleState();
			const playingIndex = this.findItemIndex(playingItem);
			this.setSchedulePosition(playingIndex);
		}
	}
	clearScheduleState() {
		this.log(`clear schedule state`);
		this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
	}
	onMediaDetaching(event, data) {
		const transferringMedia = !!data.transferMedia;
		const media = this.media;
		this.media = null;
		if (transferringMedia) return;
		if (media) this.removeMediaListeners(media);
		if (this.detachedData) {
			const player = this.getBufferingPlayer();
			if (player) {
				this.log(`Removing schedule state for detachedData and ${player}`);
				this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null;
				player.detachMedia();
			}
			this.shouldPlay = false;
		}
	}
	get interstitialsManager() {
		if (!this.hls) return null;
		if (this.manager) return this.manager;
		const c = this;
		const effectiveBufferingItem = () => c.bufferingItem || c.waitingItem;
		const getAssetPlayer = (asset) => asset ? c.getAssetPlayer(asset.identifier) : asset;
		const getMappedTime = (item, timelineType, asset, controllerField, assetPlayerField) => {
			if (item) {
				let time = item[timelineType].start;
				const interstitial = item.event;
				if (interstitial) {
					if (timelineType === "playout" || interstitial.timelineOccupancy !== TimelineOccupancy.Point) {
						const assetPlayer = getAssetPlayer(asset);
						if ((assetPlayer == null ? void 0 : assetPlayer.interstitial) === interstitial) time += assetPlayer.assetItem.startOffset + assetPlayer[assetPlayerField];
					}
				} else {
					const value = controllerField === "bufferedPos" ? getBufferedEnd() : c[controllerField];
					time += value - item.start;
				}
				return time;
			}
			return 0;
		};
		const findMappedTime = (primaryTime, timelineType) => {
			var _c$schedule;
			if (primaryTime !== 0 && timelineType !== "primary" && (_c$schedule = c.schedule) != null && _c$schedule.length) {
				var _c$schedule$items;
				const index = c.schedule.findItemIndexAtTime(primaryTime);
				const item = (_c$schedule$items = c.schedule.items) == null ? void 0 : _c$schedule$items[index];
				if (item) return primaryTime + (item[timelineType].start - item.start);
			}
			return primaryTime;
		};
		const getBufferedEnd = () => {
			const value = c.bufferedPos;
			if (value === Number.MAX_VALUE) return getMappedDuration("primary");
			return Math.max(value, 0);
		};
		const getMappedDuration = (timelineType) => {
			var _c$primaryDetails, _c$schedule2;
			if ((_c$primaryDetails = c.primaryDetails) != null && _c$primaryDetails.live) return c.primaryDetails.edge;
			return ((_c$schedule2 = c.schedule) == null ? void 0 : _c$schedule2.durations[timelineType]) || 0;
		};
		const seekTo = (time, timelineType) => {
			var _item$event, _c$schedule$items2;
			const item = c.effectivePlayingItem;
			if (item != null && (_item$event = item.event) != null && _item$event.restrictions.skip || !c.schedule) return;
			c.log(`seek to ${time} "${timelineType}"`);
			const playingItem = c.effectivePlayingItem;
			const targetIndex = c.schedule.findItemIndexAtTime(time, timelineType);
			const targetItem = (_c$schedule$items2 = c.schedule.items) == null ? void 0 : _c$schedule$items2[targetIndex];
			const bufferingPlayer = c.getBufferingPlayer();
			const bufferingInterstitial = bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial;
			const appendInPlace = bufferingInterstitial == null ? void 0 : bufferingInterstitial.appendInPlace;
			const seekInItem = playingItem && c.itemsMatch(playingItem, targetItem);
			if (playingItem && (appendInPlace || seekInItem)) {
				const assetPlayer = getAssetPlayer(c.playingAsset);
				const media = (assetPlayer == null ? void 0 : assetPlayer.media) || c.primaryMedia;
				if (media) {
					const currentTime = timelineType === "primary" ? media.currentTime : getMappedTime(playingItem, timelineType, c.playingAsset, "timelinePos", "currentTime");
					const diff = time - currentTime;
					const seekToTime = (appendInPlace ? currentTime : media.currentTime) + diff;
					if (seekToTime >= 0 && (!assetPlayer || appendInPlace || seekToTime <= assetPlayer.duration)) {
						media.currentTime = seekToTime;
						return;
					}
				}
			}
			if (targetItem) {
				let seekToTime = time;
				if (timelineType !== "primary") {
					const diff = time - targetItem[timelineType].start;
					seekToTime = targetItem.start + diff;
				}
				const targetIsPrimary = !c.isInterstitial(targetItem);
				if ((!c.isInterstitial(playingItem) || playingItem.event.appendInPlace) && (targetIsPrimary || targetItem.event.appendInPlace)) {
					const media = c.media || (appendInPlace ? bufferingPlayer == null ? void 0 : bufferingPlayer.media : null);
					if (media) media.currentTime = seekToTime;
				} else if (playingItem) {
					const playingIndex = c.findItemIndex(playingItem);
					if (targetIndex > playingIndex) {
						const jumpIndex = c.schedule.findJumpRestrictedIndex(playingIndex + 1, targetIndex);
						if (jumpIndex > playingIndex) {
							c.setSchedulePosition(jumpIndex);
							return;
						}
					}
					let assetIndex = 0;
					if (targetIsPrimary) {
						c.timelinePos = seekToTime;
						c.checkBuffer();
					} else {
						const assetList = targetItem.event.assetList;
						const eventTime = time - (targetItem[timelineType] || targetItem).start;
						for (let i = assetList.length; i--;) {
							const asset = assetList[i];
							if (asset.duration && eventTime >= asset.startOffset && eventTime < asset.startOffset + asset.duration) {
								assetIndex = i;
								break;
							}
						}
					}
					c.setSchedulePosition(targetIndex, assetIndex);
				}
			}
		};
		const getActiveInterstitial = () => {
			const playingItem = c.effectivePlayingItem;
			if (c.isInterstitial(playingItem)) return playingItem;
			const bufferingItem = effectiveBufferingItem();
			if (c.isInterstitial(bufferingItem)) return bufferingItem;
			return null;
		};
		const interstitialPlayer = {
			get bufferedEnd() {
				const interstitialItem = effectiveBufferingItem();
				const bufferingItem = c.bufferingItem;
				if (bufferingItem && bufferingItem === interstitialItem) {
					var _c$bufferingAsset;
					return getMappedTime(bufferingItem, "playout", c.bufferingAsset, "bufferedPos", "bufferedEnd") - bufferingItem.playout.start || ((_c$bufferingAsset = c.bufferingAsset) == null ? void 0 : _c$bufferingAsset.startOffset) || 0;
				}
				return 0;
			},
			get currentTime() {
				const interstitialItem = getActiveInterstitial();
				const playingItem = c.effectivePlayingItem;
				if (playingItem && playingItem === interstitialItem) return getMappedTime(playingItem, "playout", c.effectivePlayingAsset, "timelinePos", "currentTime") - playingItem.playout.start;
				return 0;
			},
			set currentTime(time) {
				const interstitialItem = getActiveInterstitial();
				const playingItem = c.effectivePlayingItem;
				if (playingItem && playingItem === interstitialItem) seekTo(time + playingItem.playout.start, "playout");
			},
			get duration() {
				const interstitialItem = getActiveInterstitial();
				if (interstitialItem) return interstitialItem.playout.end - interstitialItem.playout.start;
				return 0;
			},
			get assetPlayers() {
				var _getActiveInterstitia;
				const assetList = (_getActiveInterstitia = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia.event.assetList;
				if (assetList) return assetList.map((asset) => c.getAssetPlayer(asset.identifier));
				return [];
			},
			get playingIndex() {
				var _getActiveInterstitia2;
				const interstitial = (_getActiveInterstitia2 = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia2.event;
				if (interstitial && c.effectivePlayingAsset) return interstitial.findAssetIndex(c.effectivePlayingAsset);
				return -1;
			},
			get scheduleItem() {
				return getActiveInterstitial();
			}
		};
		return this.manager = {
			get events() {
				var _c$schedule3;
				return ((_c$schedule3 = c.schedule) == null || (_c$schedule3 = _c$schedule3.events) == null ? void 0 : _c$schedule3.slice(0)) || [];
			},
			get schedule() {
				var _c$schedule4;
				return ((_c$schedule4 = c.schedule) == null || (_c$schedule4 = _c$schedule4.items) == null ? void 0 : _c$schedule4.slice(0)) || [];
			},
			get interstitialPlayer() {
				if (getActiveInterstitial()) return interstitialPlayer;
				return null;
			},
			get playerQueue() {
				return c.playerQueue.slice(0);
			},
			get bufferingAsset() {
				return c.bufferingAsset;
			},
			get bufferingItem() {
				return effectiveBufferingItem();
			},
			get bufferingIndex() {
				const item = effectiveBufferingItem();
				return c.findItemIndex(item);
			},
			get playingAsset() {
				return c.effectivePlayingAsset;
			},
			get playingItem() {
				return c.effectivePlayingItem;
			},
			get playingIndex() {
				const item = c.effectivePlayingItem;
				return c.findItemIndex(item);
			},
			primary: {
				get bufferedEnd() {
					return getBufferedEnd();
				},
				get currentTime() {
					const timelinePos = c.timelinePos;
					return timelinePos > 0 ? timelinePos : 0;
				},
				set currentTime(time) {
					seekTo(time, "primary");
				},
				get duration() {
					return getMappedDuration("primary");
				},
				get seekableStart() {
					var _c$primaryDetails2;
					return ((_c$primaryDetails2 = c.primaryDetails) == null ? void 0 : _c$primaryDetails2.fragmentStart) || 0;
				}
			},
			integrated: {
				get bufferedEnd() {
					return getMappedTime(effectiveBufferingItem(), "integrated", c.bufferingAsset, "bufferedPos", "bufferedEnd");
				},
				get currentTime() {
					return getMappedTime(c.effectivePlayingItem, "integrated", c.effectivePlayingAsset, "timelinePos", "currentTime");
				},
				set currentTime(time) {
					seekTo(time, "integrated");
				},
				get duration() {
					return getMappedDuration("integrated");
				},
				get seekableStart() {
					var _c$primaryDetails3;
					return findMappedTime(((_c$primaryDetails3 = c.primaryDetails) == null ? void 0 : _c$primaryDetails3.fragmentStart) || 0, "integrated");
				}
			},
			skip: () => {
				const item = c.effectivePlayingItem;
				const event = item == null ? void 0 : item.event;
				if (event && !event.restrictions.skip) {
					const index = c.findItemIndex(item);
					if (event.appendInPlace) seekTo(item.playout.start + item.event.duration + .001, "playout");
					else c.advanceAfterAssetEnded(event, index, Infinity);
				}
			}
		};
	}
	get effectivePlayingItem() {
		return this.waitingItem || this.playingItem || this.endedItem;
	}
	get effectivePlayingAsset() {
		return this.playingAsset || this.endedAsset;
	}
	get playingLastItem() {
		var _this$schedule;
		const playingItem = this.playingItem;
		const items = (_this$schedule = this.schedule) == null ? void 0 : _this$schedule.items;
		if (!this.playbackStarted || !playingItem || !items) return false;
		return this.findItemIndex(playingItem) === items.length - 1;
	}
	get playbackStarted() {
		return this.effectivePlayingItem !== null;
	}
	get currentTime() {
		var _this$bufferingItem, _media;
		if (this.mediaSelection === null) return;
		const queuedForPlayback = this.waitingItem || this.playingItem;
		if (this.isInterstitial(queuedForPlayback) && !queuedForPlayback.event.appendInPlace) return;
		let media = this.media;
		if (!media && (_this$bufferingItem = this.bufferingItem) != null && (_this$bufferingItem = _this$bufferingItem.event) != null && _this$bufferingItem.appendInPlace) media = this.primaryMedia;
		const currentTime = (_media = media) == null ? void 0 : _media.currentTime;
		if (currentTime === void 0 || !isFiniteNumber(currentTime)) return;
		return currentTime;
	}
	get primaryMedia() {
		var _this$detachedData;
		return this.media || ((_this$detachedData = this.detachedData) == null ? void 0 : _this$detachedData.media) || null;
	}
	isInterstitial(item) {
		return !!(item != null && item.event);
	}
	retreiveMediaSource(assetId, toSegment) {
		const player = this.getAssetPlayer(assetId);
		if (player) this.transferMediaFromPlayer(player, toSegment);
	}
	transferMediaFromPlayer(player, toSegment) {
		const appendInPlace = player.interstitial.appendInPlace;
		const playerMedia = player.media;
		if (appendInPlace && playerMedia === this.primaryMedia) {
			this.bufferingAsset = null;
			if (!toSegment || this.isInterstitial(toSegment) && !toSegment.event.appendInPlace) {
				if (toSegment && playerMedia) {
					this.detachedData = { media: playerMedia };
					return;
				}
			}
			const attachMediaSourceData = player.transferMedia();
			this.log(`transfer MediaSource from ${player} ${stringify(attachMediaSourceData)}`);
			this.detachedData = attachMediaSourceData;
		} else if (toSegment && playerMedia) this.shouldPlay || (this.shouldPlay = !playerMedia.paused);
	}
	transferMediaTo(player, media) {
		var _this$detachedData2, _attachMediaSourceDat;
		if (player.media === media) return;
		let attachMediaSourceData = null;
		const primaryPlayer = this.hls;
		const isAssetPlayer = player !== primaryPlayer;
		const appendInPlace = isAssetPlayer && player.interstitial.appendInPlace;
		const detachedMediaSource = (_this$detachedData2 = this.detachedData) == null ? void 0 : _this$detachedData2.mediaSource;
		let logFromSource;
		if (primaryPlayer.media) {
			if (appendInPlace) {
				attachMediaSourceData = primaryPlayer.transferMedia();
				this.detachedData = attachMediaSourceData;
			}
			logFromSource = `Primary`;
		} else if (detachedMediaSource) {
			const bufferingPlayer = this.getBufferingPlayer();
			if (bufferingPlayer) {
				attachMediaSourceData = bufferingPlayer.transferMedia();
				logFromSource = `${bufferingPlayer}`;
			} else logFromSource = `detached MediaSource`;
		} else logFromSource = `detached media`;
		if (!attachMediaSourceData) {
			if (detachedMediaSource) {
				attachMediaSourceData = this.detachedData;
				this.log(`using detachedData: MediaSource ${stringify(attachMediaSourceData)}`);
			} else if (!this.detachedData || primaryPlayer.media === media) {
				const playerQueue = this.playerQueue;
				if (playerQueue.length > 1) playerQueue.forEach((queuedPlayer) => {
					if (isAssetPlayer && queuedPlayer.interstitial.appendInPlace !== appendInPlace) {
						const interstitial = queuedPlayer.interstitial;
						this.clearInterstitial(queuedPlayer.interstitial, null);
						interstitial.appendInPlace = false;
						if (interstitial.appendInPlace) this.warn(`Could not change append strategy for queued assets ${interstitial}`);
					}
				});
				this.hls.detachMedia();
				this.detachedData = { media };
			}
		}
		const transferring = attachMediaSourceData && "mediaSource" in attachMediaSourceData && ((_attachMediaSourceDat = attachMediaSourceData.mediaSource) == null ? void 0 : _attachMediaSourceDat.readyState) !== "closed";
		const dataToAttach = transferring && attachMediaSourceData ? attachMediaSourceData : media;
		this.log(`${transferring ? "transfering MediaSource" : "attaching media"} to ${isAssetPlayer ? player : "Primary"} from ${logFromSource} (media.currentTime: ${media.currentTime})`);
		const schedule = this.schedule;
		if (dataToAttach === attachMediaSourceData && schedule) {
			const isAssetAtEndOfSchedule = isAssetPlayer && player.assetId === schedule.assetIdAtEnd;
			dataToAttach.overrides = {
				duration: schedule.duration,
				endOfStream: !isAssetPlayer || isAssetAtEndOfSchedule,
				cueRemoval: !isAssetPlayer
			};
		}
		player.attachMedia(dataToAttach);
	}
	onInterstitialCueEnter() {
		this.onTimeupdate();
	}
	checkStart() {
		const schedule = this.schedule;
		const interstitialEvents = schedule == null ? void 0 : schedule.events;
		if (!interstitialEvents || this.playbackDisabled || !this.media) return;
		if (this.bufferedPos === -1) this.bufferedPos = 0;
		const timelinePos = this.timelinePos;
		const effectivePlayingItem = this.effectivePlayingItem;
		if (timelinePos === -1) {
			const startPosition = this.hls.startPosition;
			this.timelinePos = startPosition;
			if (interstitialEvents.length === 0) this.setSchedulePosition(0);
			else if (interstitialEvents[0].cue.pre) {
				this.log(timelineMessage("checkStart (preroll)", startPosition));
				const index = schedule.findEventIndex(interstitialEvents[0].identifier);
				this.setSchedulePosition(index);
			} else if (startPosition >= 0 || !this.primaryLive) {
				this.log(timelineMessage("checkStart", startPosition));
				const start = this.timelinePos = startPosition > 0 ? startPosition : 0;
				const index = schedule.findItemIndexAtTime(start);
				this.setSchedulePosition(index);
			} else if (this.hls.liveSyncPosition === 0) this.setSchedulePosition(0);
			else this.log("[checkStart] waiting for live start");
		} else if (effectivePlayingItem && !this.playingItem) {
			this.log(timelineMessage("checkStart (playing item)", effectivePlayingItem.start));
			const index = schedule.findItemIndex(effectivePlayingItem);
			this.setSchedulePosition(index);
		}
	}
	advanceAssetBuffering(item, assetItem) {
		const interstitial = item.event;
		const nextAssetIndex = getNextAssetIndex(interstitial, interstitial.findAssetIndex(assetItem));
		if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) this.bufferedToEvent(item, nextAssetIndex);
		else if (this.schedule) {
			var _this$schedule$items;
			const nextItem = (_this$schedule$items = this.schedule.items) == null ? void 0 : _this$schedule$items[this.findItemIndex(item) + 1];
			if (nextItem) this.bufferedToItem(nextItem);
		}
	}
	advanceAfterAssetEnded(interstitial, index, assetListIndex) {
		const nextAssetIndex = getNextAssetIndex(interstitial, assetListIndex);
		if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) {
			if (interstitial.appendInPlace) {
				const assetItem = interstitial.assetList[nextAssetIndex];
				if (assetItem) this.advanceInPlace(assetItem.timelineStart);
			}
			this.setSchedulePosition(index, nextAssetIndex);
		} else if (this.schedule) {
			const scheduleItems = this.schedule.items;
			if (scheduleItems) {
				const nextIndex = index + 1;
				if (nextIndex >= scheduleItems.length) {
					this.setSchedulePosition(-1);
					return;
				}
				const resumptionTime = interstitial.resumeTime;
				if (this.timelinePos < resumptionTime) {
					this.log(timelineMessage("advanceAfterAssetEnded", resumptionTime));
					this.timelinePos = resumptionTime;
					if (interstitial.appendInPlace) this.advanceInPlace(resumptionTime);
					this.checkBuffer(this.bufferedPos < resumptionTime);
				}
				this.setSchedulePosition(nextIndex);
			}
		}
	}
	setScheduleToAssetAtTime(time, playingAsset) {
		const schedule = this.schedule;
		if (!schedule) return;
		const parentIdentifier = playingAsset.parentIdentifier;
		const interstitial = schedule.getEvent(parentIdentifier);
		if (interstitial) {
			const itemIndex = schedule.findEventIndex(parentIdentifier);
			const assetListIndex = schedule.findAssetIndex(interstitial, time);
			this.advanceAfterAssetEnded(interstitial, itemIndex, assetListIndex - 1);
		}
	}
	setSchedulePosition(index, assetListIndex) {
		var _this$schedule2;
		const scheduleItems = (_this$schedule2 = this.schedule) == null ? void 0 : _this$schedule2.items;
		if (!scheduleItems || this.playbackDisabled) return;
		const scheduledItem = index >= 0 ? scheduleItems[index] : null;
		this.log(`setSchedulePosition ${index}, ${assetListIndex} (${scheduledItem ? segmentToString(scheduledItem) : scheduledItem}) pos: ${this.timelinePos}`);
		const currentItem = this.waitingItem || this.playingItem;
		const playingLastItem = this.playingLastItem;
		if (this.isInterstitial(currentItem)) {
			const interstitial = currentItem.event;
			const playingAsset = this.playingAsset;
			const assetId = playingAsset == null ? void 0 : playingAsset.identifier;
			const player = assetId ? this.getAssetPlayer(assetId) : null;
			if (player && assetId && (!this.eventItemsMatch(currentItem, scheduledItem) || assetListIndex !== void 0 && assetId !== interstitial.assetList[assetListIndex].identifier)) {
				var _this$detachedData3;
				const playingAssetListIndex = interstitial.findAssetIndex(playingAsset);
				this.log(`INTERSTITIAL_ASSET_ENDED ${playingAssetListIndex + 1}/${interstitial.assetList.length} ${eventAssetToString(playingAsset)}`);
				this.endedAsset = playingAsset;
				this.playingAsset = null;
				this.hls.trigger(Events.INTERSTITIAL_ASSET_ENDED, {
					asset: playingAsset,
					assetListIndex: playingAssetListIndex,
					event: interstitial,
					schedule: scheduleItems.slice(0),
					scheduleIndex: index,
					player
				});
				if (currentItem !== this.playingItem) {
					if (this.itemsMatch(currentItem, this.playingItem) && !this.playingAsset) this.advanceAfterAssetEnded(interstitial, this.findItemIndex(this.playingItem), playingAssetListIndex);
					return;
				}
				this.retreiveMediaSource(assetId, scheduledItem);
				if (player.media && !((_this$detachedData3 = this.detachedData) != null && _this$detachedData3.mediaSource)) player.detachMedia();
			}
			if (!this.eventItemsMatch(currentItem, scheduledItem)) {
				this.endedItem = currentItem;
				this.playingItem = null;
				this.log(`INTERSTITIAL_ENDED ${interstitial} ${segmentToString(currentItem)}`);
				interstitial.hasPlayed = true;
				this.hls.trigger(Events.INTERSTITIAL_ENDED, {
					event: interstitial,
					schedule: scheduleItems.slice(0),
					scheduleIndex: index
				});
				if (interstitial.cue.once) {
					var _this$schedule3;
					this.updateSchedule();
					const updatedScheduleItems = (_this$schedule3 = this.schedule) == null ? void 0 : _this$schedule3.items;
					if (scheduledItem && updatedScheduleItems) {
						const updatedIndex = this.findItemIndex(scheduledItem);
						this.advanceSchedule(updatedIndex, updatedScheduleItems, assetListIndex, currentItem, playingLastItem);
					}
					return;
				}
			}
		}
		this.advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playingLastItem);
	}
	advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playedLastItem) {
		const schedule = this.schedule;
		if (!schedule) return;
		const scheduledItem = scheduleItems[index] || null;
		const media = this.primaryMedia;
		const playerQueue = this.playerQueue;
		if (playerQueue.length) playerQueue.forEach((player) => {
			const interstitial = player.interstitial;
			const queuedIndex = schedule.findEventIndex(interstitial.identifier);
			if (queuedIndex < index || queuedIndex > index + 1) this.clearInterstitial(interstitial, scheduledItem);
		});
		if (this.isInterstitial(scheduledItem)) {
			this.timelinePos = Math.min(Math.max(this.timelinePos, scheduledItem.start), scheduledItem.end);
			const interstitial = scheduledItem.event;
			if (assetListIndex === void 0) {
				assetListIndex = schedule.findAssetIndex(interstitial, this.timelinePos);
				const assetIndexCandidate = getNextAssetIndex(interstitial, assetListIndex - 1);
				if (interstitial.isAssetPastPlayoutLimit(assetIndexCandidate) || interstitial.appendInPlace && this.timelinePos === scheduledItem.end) {
					this.advanceAfterAssetEnded(interstitial, index, assetListIndex);
					return;
				}
				assetListIndex = assetIndexCandidate;
			}
			const waitingItem = this.waitingItem;
			if (!this.assetsBuffered(scheduledItem, media)) this.setBufferingItem(scheduledItem);
			let player = this.preloadAssets(interstitial, assetListIndex);
			if (!this.eventItemsMatch(scheduledItem, waitingItem || currentItem)) {
				this.waitingItem = scheduledItem;
				this.log(`INTERSTITIAL_STARTED ${segmentToString(scheduledItem)} ${interstitial.appendInPlace ? "append in place" : ""}`);
				this.hls.trigger(Events.INTERSTITIAL_STARTED, {
					event: interstitial,
					schedule: scheduleItems.slice(0),
					scheduleIndex: index
				});
			}
			if (!interstitial.assetListLoaded) {
				this.log(`Waiting for ASSET-LIST to complete loading ${interstitial}`);
				return;
			}
			if (interstitial.assetListLoader) {
				interstitial.assetListLoader.destroy();
				interstitial.assetListLoader = void 0;
			}
			if (!media) {
				this.log(`Waiting for attachMedia to start Interstitial ${interstitial}`);
				return;
			}
			this.waitingItem = this.endedItem = null;
			this.playingItem = scheduledItem;
			const assetItem = interstitial.assetList[assetListIndex];
			if (!assetItem) {
				this.advanceAfterAssetEnded(interstitial, index, assetListIndex || 0);
				return;
			}
			if (!player) player = this.getAssetPlayer(assetItem.identifier);
			if (player === null || player.destroyed) {
				const assetListLength = interstitial.assetList.length;
				this.warn(`asset ${assetListIndex + 1}/${assetListLength} player destroyed ${interstitial}`);
				player = this.createAssetPlayer(interstitial, assetItem, assetListIndex);
				player.loadSource();
			}
			if (!this.eventItemsMatch(scheduledItem, this.bufferingItem)) {
				if (interstitial.appendInPlace && this.isAssetBuffered(assetItem)) return;
			}
			this.startAssetPlayer(player, assetListIndex, scheduleItems, index, media);
			if (this.shouldPlay) playWithCatch(player.media);
		} else if (scheduledItem) {
			this.resumePrimary(scheduledItem, index, currentItem);
			if (this.shouldPlay) playWithCatch(this.hls.media);
		} else if (playedLastItem && this.isInterstitial(currentItem)) {
			this.endedItem = null;
			this.playingItem = currentItem;
			if (!currentItem.event.appendInPlace) this.attachPrimary(schedule.durations.primary, null);
		}
	}
	get playbackDisabled() {
		return this.hls.config.enableInterstitialPlayback === false;
	}
	get primaryDetails() {
		var _this$mediaSelection;
		return (_this$mediaSelection = this.mediaSelection) == null ? void 0 : _this$mediaSelection.main.details;
	}
	get primaryLive() {
		var _this$primaryDetails;
		return !!((_this$primaryDetails = this.primaryDetails) != null && _this$primaryDetails.live);
	}
	resumePrimary(scheduledItem, index, fromItem) {
		var _this$detachedData4, _this$schedule4;
		this.playingItem = scheduledItem;
		this.playingAsset = this.endedAsset = null;
		this.waitingItem = this.endedItem = null;
		this.bufferedToItem(scheduledItem);
		this.log(`resuming ${segmentToString(scheduledItem)}`);
		if (!((_this$detachedData4 = this.detachedData) != null && _this$detachedData4.mediaSource)) {
			let timelinePos = this.timelinePos;
			if (timelinePos < scheduledItem.start || timelinePos >= scheduledItem.end) {
				timelinePos = this.getPrimaryResumption(scheduledItem, index);
				this.log(timelineMessage("resumePrimary", timelinePos));
				this.timelinePos = timelinePos;
			}
			this.attachPrimary(timelinePos, scheduledItem);
		}
		if (!fromItem) return;
		const scheduleItems = (_this$schedule4 = this.schedule) == null ? void 0 : _this$schedule4.items;
		if (!scheduleItems) return;
		this.log(`INTERSTITIALS_PRIMARY_RESUMED ${segmentToString(scheduledItem)}`);
		this.hls.trigger(Events.INTERSTITIALS_PRIMARY_RESUMED, {
			schedule: scheduleItems.slice(0),
			scheduleIndex: index
		});
		this.checkBuffer();
	}
	getPrimaryResumption(scheduledItem, index) {
		const itemStart = scheduledItem.start;
		if (this.primaryLive) {
			const details = this.primaryDetails;
			if (index === 0) return this.hls.startPosition;
			else if (details && (itemStart < details.fragmentStart || itemStart > details.edge)) return this.hls.liveSyncPosition || -1;
		}
		return itemStart;
	}
	isAssetBuffered(asset) {
		const player = this.getAssetPlayer(asset.identifier);
		if (player != null && player.hls) return player.hls.bufferedToEnd;
		return BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0).end + 1 >= asset.timelineStart + (asset.duration || 0);
	}
	attachPrimary(timelinePos, item, skipSeekToStartPosition) {
		if (item) this.setBufferingItem(item);
		else this.bufferingItem = this.playingItem;
		this.bufferingAsset = null;
		const media = this.primaryMedia;
		if (!media) return;
		const hls = this.hls;
		if (hls.media) this.checkBuffer();
		else {
			this.transferMediaTo(hls, media);
			if (skipSeekToStartPosition) this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
		}
		if (!skipSeekToStartPosition) {
			this.log(timelineMessage("attachPrimary", timelinePos));
			this.timelinePos = timelinePos;
			this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
		}
	}
	startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition) {
		var _hls$mainForwardBuffe;
		const hls = this.hls;
		if (!hls.loadingEnabled || !hls.media || Math.abs((((_hls$mainForwardBuffe = hls.mainForwardBufferInfo) == null ? void 0 : _hls$mainForwardBuffe.start) || hls.media.currentTime) - timelinePos) > .5) hls.startLoad(timelinePos, skipSeekToStartPosition);
		else if (!hls.bufferingEnabled) hls.resumeBuffering();
	}
	onManifestLoading() {
		var _this$schedule5;
		this.stopLoad();
		(_this$schedule5 = this.schedule) == null || _this$schedule5.reset();
		this.emptyPlayerQueue();
		this.clearScheduleState();
		this.shouldPlay = false;
		this.bufferedPos = this.timelinePos = -1;
		this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null;
		this.hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
		this.hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
	}
	onLevelUpdated(event, data) {
		if (data.level === -1 || !this.schedule) return;
		const main = this.hls.levels[data.level];
		if (!main.details) return;
		const currentSelection = _objectSpread2(_objectSpread2({}, this.mediaSelection || this.altSelection), {}, { main });
		this.mediaSelection = currentSelection;
		this.schedule.parseInterstitialDateRanges(currentSelection, this.hls.config.interstitialAppendInPlace);
		if (!this.effectivePlayingItem && this.schedule.items) this.checkStart();
	}
	onAudioTrackUpdated(event, data) {
		const audio = this.hls.audioTracks[data.id];
		const previousSelection = this.mediaSelection;
		if (!previousSelection) {
			this.altSelection = _objectSpread2(_objectSpread2({}, this.altSelection), {}, { audio });
			return;
		}
		const currentSelection = _objectSpread2(_objectSpread2({}, previousSelection), {}, { audio });
		this.mediaSelection = currentSelection;
	}
	onSubtitleTrackUpdated(event, data) {
		const subtitles = this.hls.subtitleTracks[data.id];
		const previousSelection = this.mediaSelection;
		if (!previousSelection) {
			this.altSelection = _objectSpread2(_objectSpread2({}, this.altSelection), {}, { subtitles });
			return;
		}
		const currentSelection = _objectSpread2(_objectSpread2({}, previousSelection), {}, { subtitles });
		this.mediaSelection = currentSelection;
	}
	onAudioTrackSwitching(event, data) {
		const audioOption = getBasicSelectionOption(data);
		this.playerQueue.forEach(({ hls }) => hls && (hls.setAudioOption(data) || hls.setAudioOption(audioOption)));
	}
	onSubtitleTrackSwitch(event, data) {
		const subtitleOption = getBasicSelectionOption(data);
		this.playerQueue.forEach(({ hls }) => hls && (hls.setSubtitleOption(data) || data.id !== -1 && hls.setSubtitleOption(subtitleOption)));
	}
	onBufferCodecs(event, data) {
		const requiredTracks = data.tracks;
		if (requiredTracks) this.requiredTracks = requiredTracks;
	}
	onBufferAppended(event, data) {
		this.checkBuffer();
	}
	onBufferFlushed(event, data) {
		const playingItem = this.playingItem;
		if (playingItem && !this.itemsMatch(playingItem, this.bufferingItem) && !this.isInterstitial(playingItem)) {
			const timelinePos = this.timelinePos;
			this.bufferedPos = timelinePos;
			this.checkBuffer();
		}
	}
	onBufferedToEnd(event) {
		if (!this.schedule) return;
		const interstitialEvents = this.schedule.events;
		if (this.bufferedPos < Number.MAX_VALUE && interstitialEvents) {
			for (let i = 0; i < interstitialEvents.length; i++) {
				const interstitial = interstitialEvents[i];
				if (interstitial.cue.post) {
					var _this$schedule$items2;
					const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
					const item = (_this$schedule$items2 = this.schedule.items) == null ? void 0 : _this$schedule$items2[scheduleIndex];
					if (this.isInterstitial(item) && this.eventItemsMatch(item, this.bufferingItem)) this.bufferedToItem(item, 0);
					break;
				}
			}
			this.bufferedPos = Number.MAX_VALUE;
		}
	}
	onMediaEnded(event) {
		const playingItem = this.playingItem;
		if (!this.playingLastItem && playingItem) {
			const playingIndex = this.findItemIndex(playingItem);
			this.setSchedulePosition(playingIndex + 1);
		} else this.shouldPlay = false;
	}
	updateItem(previousItem, time) {
		var _this$schedule6;
		const items = (_this$schedule6 = this.schedule) == null ? void 0 : _this$schedule6.items;
		if (previousItem && items) return items[this.findItemIndex(previousItem, time)] || null;
		return null;
	}
	trimInPlace(updatedItem, itemBeforeUpdate) {
		if (this.isInterstitial(updatedItem) && updatedItem.event.appendInPlace && itemBeforeUpdate.end - updatedItem.end > .25) {
			updatedItem.event.assetList.forEach((asset, index) => {
				if (updatedItem.event.isAssetPastPlayoutLimit(index)) this.clearAssetPlayer(asset.identifier, null);
			});
			const flushStart = updatedItem.end + .25;
			const bufferInfo = BufferHelper.bufferInfo(this.primaryMedia, flushStart, 0);
			if (bufferInfo.end > flushStart || (bufferInfo.nextStart || 0) > flushStart) {
				this.log(`trim buffered interstitial ${segmentToString(updatedItem)} (was ${segmentToString(itemBeforeUpdate)})`);
				this.attachPrimary(flushStart, null, true);
				this.flushFrontBuffer(flushStart);
			}
		}
	}
	itemsMatch(a, b) {
		return !!b && (a === b || a.event && b.event && this.eventItemsMatch(a, b) || !a.event && !b.event && this.findItemIndex(a) === this.findItemIndex(b));
	}
	eventItemsMatch(a, b) {
		var _b$event;
		return !!b && (a === b || a.event.identifier === ((_b$event = b.event) == null ? void 0 : _b$event.identifier));
	}
	findItemIndex(item, time) {
		return item && this.schedule ? this.schedule.findItemIndex(item, time) : -1;
	}
	updateSchedule(forceUpdate = false) {
		var _this$schedule7;
		const mediaSelection = this.mediaSelection;
		if (!mediaSelection) return;
		(_this$schedule7 = this.schedule) == null || _this$schedule7.updateSchedule(mediaSelection, [], forceUpdate);
	}
	checkBuffer(starved) {
		var _this$schedule8;
		const items = (_this$schedule8 = this.schedule) == null ? void 0 : _this$schedule8.items;
		if (!items) return;
		const bufferInfo = BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
		if (starved) this.bufferedPos = this.timelinePos;
		starved || (starved = bufferInfo.len < 1);
		this.updateBufferedPos(bufferInfo.end, items, starved);
	}
	updateBufferedPos(bufferEnd, items, bufferIsEmpty) {
		const schedule = this.schedule;
		const bufferingItem = this.bufferingItem;
		if (this.bufferedPos > bufferEnd || !schedule) return;
		if (items.length === 1 && this.itemsMatch(items[0], bufferingItem)) {
			this.bufferedPos = bufferEnd;
			return;
		}
		const playingItem = this.playingItem;
		const playingIndex = this.findItemIndex(playingItem);
		let bufferEndIndex = schedule.findItemIndexAtTime(bufferEnd);
		if (this.bufferedPos < bufferEnd) {
			var _nextItemToBuffer$eve;
			const bufferingIndex = this.findItemIndex(bufferingItem);
			const nextToBufferIndex = Math.min(bufferingIndex + 1, items.length - 1);
			const nextItemToBuffer = items[nextToBufferIndex];
			if (bufferEndIndex === -1 && bufferingItem && bufferEnd >= bufferingItem.end || (_nextItemToBuffer$eve = nextItemToBuffer.event) != null && _nextItemToBuffer$eve.appendInPlace && bufferEnd + .01 >= nextItemToBuffer.start) bufferEndIndex = nextToBufferIndex;
			if (this.isInterstitial(bufferingItem)) {
				const interstitial = bufferingItem.event;
				if (nextToBufferIndex - playingIndex > 1 && interstitial.appendInPlace === false) return;
				if (interstitial.assetList.length === 0 && interstitial.assetListLoader) return;
			}
			this.bufferedPos = bufferEnd;
			if (bufferEndIndex > bufferingIndex && bufferEndIndex > playingIndex) this.bufferedToItem(nextItemToBuffer);
			else {
				const details = this.primaryDetails;
				if (this.primaryLive && details && bufferEnd > details.edge - details.targetduration && nextItemToBuffer.start < details.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(nextItemToBuffer)) this.preloadAssets(nextItemToBuffer.event, 0);
			}
		} else if (bufferIsEmpty && playingItem && !this.itemsMatch(playingItem, bufferingItem)) {
			if (bufferEndIndex === playingIndex) this.bufferedToItem(playingItem);
			else if (bufferEndIndex === playingIndex + 1) this.bufferedToItem(items[bufferEndIndex]);
		}
	}
	assetsBuffered(item, media) {
		if (item.event.assetList.length === 0) return false;
		return !item.event.assetList.some((asset) => {
			const player = this.getAssetPlayer(asset.identifier);
			return !(player != null && player.bufferedInPlaceToEnd(media));
		});
	}
	setBufferingItem(item) {
		const bufferingLast = this.bufferingItem;
		const schedule = this.schedule;
		if (!this.itemsMatch(item, bufferingLast) && schedule) {
			const { items, events } = schedule;
			if (!items || !events) return bufferingLast;
			const isInterstitial = this.isInterstitial(item);
			const bufferingPlayer = this.getBufferingPlayer();
			this.bufferingItem = item;
			this.bufferedPos = Math.max(item.start, Math.min(item.end, this.timelinePos));
			const timeRemaining = bufferingPlayer ? bufferingPlayer.remaining : bufferingLast ? bufferingLast.end - this.timelinePos : 0;
			this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${segmentToString(item)}` + (bufferingLast ? ` (${timeRemaining.toFixed(2)} remaining)` : ""));
			if (!this.playbackDisabled) if (isInterstitial) {
				const bufferIndex = schedule.findAssetIndex(item.event, this.bufferedPos);
				item.event.assetList.forEach((asset, i) => {
					const player = this.getAssetPlayer(asset.identifier);
					if (player) {
						if (i === bufferIndex) player.loadSource();
						player.resumeBuffering();
					}
				});
			} else {
				this.hls.resumeBuffering();
				this.playerQueue.forEach((player) => player.pauseBuffering());
			}
			this.hls.trigger(Events.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
				events: events.slice(0),
				schedule: items.slice(0),
				bufferingIndex: this.findItemIndex(item),
				playingIndex: this.findItemIndex(this.playingItem)
			});
		} else if (this.bufferingItem !== item) this.bufferingItem = item;
		return bufferingLast;
	}
	bufferedToItem(item, assetListIndex = 0) {
		const bufferingLast = this.setBufferingItem(item);
		if (this.playbackDisabled) return;
		if (this.isInterstitial(item)) this.bufferedToEvent(item, assetListIndex);
		else if (bufferingLast !== null) {
			this.bufferingAsset = null;
			const detachedData = this.detachedData;
			if (detachedData) if (detachedData.mediaSource) this.attachPrimary(item.start, item, true);
			else this.preloadPrimary(item);
			else this.preloadPrimary(item);
		}
	}
	preloadPrimary(item) {
		const index = this.findItemIndex(item);
		const timelinePos = this.getPrimaryResumption(item, index);
		this.startLoadingPrimaryAt(timelinePos);
	}
	bufferedToEvent(item, assetListIndex) {
		const interstitial = item.event;
		const neverLoaded = interstitial.assetList.length === 0 && !interstitial.assetListLoader;
		const playOnce = interstitial.cue.once;
		if (neverLoaded || !playOnce) {
			const player = this.preloadAssets(interstitial, assetListIndex);
			if (player != null && player.interstitial.appendInPlace) {
				const media = this.primaryMedia;
				if (media) this.bufferAssetPlayer(player, media);
			}
		}
	}
	preloadAssets(interstitial, assetListIndex) {
		const uri = interstitial.assetUrl;
		const assetListLength = interstitial.assetList.length;
		const neverLoaded = assetListLength === 0 && !interstitial.assetListLoader;
		const playOnce = interstitial.cue.once;
		if (neverLoaded) {
			const timelineStart = interstitial.timelineStart;
			if (interstitial.appendInPlace) {
				var _playingItem$nextEven;
				const playingItem = this.playingItem;
				if (!this.isInterstitial(playingItem) && (playingItem == null || (_playingItem$nextEven = playingItem.nextEvent) == null ? void 0 : _playingItem$nextEven.identifier) === interstitial.identifier) this.flushFrontBuffer(timelineStart + .25);
			}
			let hlsStartOffset;
			let liveStartPosition = 0;
			if (!this.playingItem && this.primaryLive) {
				liveStartPosition = this.hls.startPosition;
				if (liveStartPosition === -1) liveStartPosition = this.hls.liveSyncPosition || 0;
			}
			if (liveStartPosition && !(interstitial.cue.pre || interstitial.cue.post)) {
				const startOffset = liveStartPosition - timelineStart;
				if (startOffset > 0) hlsStartOffset = Math.round(startOffset * 1e3) / 1e3;
			}
			this.log(`Load interstitial asset ${assetListIndex + 1}/${uri ? 1 : assetListLength} ${interstitial}${hlsStartOffset ? ` live-start: ${liveStartPosition} start-offset: ${hlsStartOffset}` : ""}`);
			if (uri) return this.createAsset(interstitial, 0, 0, timelineStart, interstitial.duration, uri);
			const assetListLoader = this.assetListLoader.loadAssetList(interstitial, hlsStartOffset);
			if (assetListLoader) interstitial.assetListLoader = assetListLoader;
		} else if (!playOnce && assetListLength) {
			for (let i = assetListIndex; i < assetListLength; i++) {
				const _asset = interstitial.assetList[i];
				const playerIndex = this.getAssetPlayerQueueIndex(_asset.identifier);
				if ((playerIndex === -1 || this.playerQueue[playerIndex].destroyed) && !_asset.error) this.createAssetPlayer(interstitial, _asset, i);
			}
			const asset = interstitial.assetList[assetListIndex];
			if (asset) {
				const player = this.getAssetPlayer(asset.identifier);
				if (player) player.loadSource();
				return player;
			}
		}
		return null;
	}
	flushFrontBuffer(startOffset) {
		const requiredTracks = this.requiredTracks;
		if (!requiredTracks) return;
		this.log(`Removing front buffer starting at ${startOffset}`);
		Object.keys(requiredTracks).forEach((type) => {
			this.hls.trigger(Events.BUFFER_FLUSHING, {
				startOffset,
				endOffset: Infinity,
				type
			});
		});
	}
	getAssetPlayerQueueIndex(assetId) {
		const playerQueue = this.playerQueue;
		for (let i = 0; i < playerQueue.length; i++) if (assetId === playerQueue[i].assetId) return i;
		return -1;
	}
	getAssetPlayer(assetId) {
		const index = this.getAssetPlayerQueueIndex(assetId);
		return this.playerQueue[index] || null;
	}
	getBufferingPlayer() {
		const { playerQueue, primaryMedia } = this;
		if (primaryMedia) {
			for (let i = 0; i < playerQueue.length; i++) if (playerQueue[i].media === primaryMedia) return playerQueue[i];
		}
		return null;
	}
	createAsset(interstitial, assetListIndex, startOffset, timelineStart, duration, uri) {
		const assetItem = {
			parentIdentifier: interstitial.identifier,
			identifier: generateAssetIdentifier(interstitial, uri, assetListIndex),
			duration,
			startOffset,
			timelineStart,
			uri
		};
		return this.createAssetPlayer(interstitial, assetItem, assetListIndex);
	}
	createAssetPlayer(interstitial, assetItem, assetListIndex) {
		const primary = this.hls;
		const userConfig = primary.userConfig;
		let videoPreference = userConfig.videoPreference;
		const currentLevel = primary.loadLevelObj || primary.levels[primary.currentLevel];
		if (videoPreference || currentLevel) {
			videoPreference = _extends({}, videoPreference);
			if (currentLevel.videoCodec) videoPreference.videoCodec = currentLevel.videoCodec;
			if (currentLevel.videoRange) videoPreference.allowedVideoRanges = [currentLevel.videoRange];
		}
		const selectedAudio = primary.audioTracks[primary.audioTrack];
		const selectedSubtitle = primary.subtitleTracks[primary.subtitleTrack];
		let startPosition = 0;
		if (this.primaryLive || interstitial.appendInPlace) {
			const timePastStart = this.timelinePos - assetItem.timelineStart;
			if (timePastStart > 1) {
				const duration = assetItem.duration;
				if (duration && timePastStart < duration) startPosition = timePastStart;
			}
		}
		const assetId = assetItem.identifier;
		const playerConfig = _objectSpread2(_objectSpread2({}, userConfig), {}, {
			maxMaxBufferLength: Math.min(180, primary.config.maxMaxBufferLength),
			autoStartLoad: true,
			startFragPrefetch: true,
			primarySessionId: primary.sessionId,
			assetPlayerId: assetId,
			abrEwmaDefaultEstimate: primary.bandwidthEstimate,
			interstitialsController: void 0,
			startPosition,
			liveDurationInfinity: false,
			testBandwidth: false,
			videoPreference,
			audioPreference: selectedAudio || userConfig.audioPreference,
			subtitlePreference: selectedSubtitle || userConfig.subtitlePreference
		});
		if (interstitial.appendInPlace) {
			interstitial.appendInPlaceStarted = true;
			if (assetItem.timelineStart) playerConfig.timelineOffset = assetItem.timelineStart;
		}
		const cmcd = playerConfig.cmcd;
		if (cmcd != null && cmcd.sessionId && cmcd.contentId) playerConfig.cmcd = _extends({}, cmcd, { contentId: hash(assetItem.uri) });
		if (this.getAssetPlayer(assetId)) this.warn(`Duplicate date range identifier ${interstitial} and asset ${assetId}`);
		const player = new HlsAssetPlayer(this.HlsPlayerClass, playerConfig, interstitial, assetItem);
		this.playerQueue.push(player);
		interstitial.assetList[assetListIndex] = assetItem;
		let initialDuration = true;
		const updateAssetPlayerDetails = (details) => {
			if (details.live) {
				var _this$schedule9;
				const error = /* @__PURE__ */ new Error(`Interstitials MUST be VOD assets ${interstitial}`);
				const errorData = {
					fatal: true,
					type: ErrorTypes.OTHER_ERROR,
					details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
					error
				};
				const scheduleIndex = ((_this$schedule9 = this.schedule) == null ? void 0 : _this$schedule9.findEventIndex(interstitial.identifier)) || -1;
				this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
				return;
			}
			const duration = details.edge - details.fragmentStart;
			const currentAssetDuration = assetItem.duration;
			if (initialDuration || currentAssetDuration === null || duration > currentAssetDuration) {
				initialDuration = false;
				this.log(`Interstitial asset "${assetId}" duration change ${currentAssetDuration} > ${duration}`);
				assetItem.duration = duration;
				this.updateSchedule();
			}
		};
		player.on(Events.LEVEL_UPDATED, (event, { details }) => updateAssetPlayerDetails(details));
		player.on(Events.LEVEL_PTS_UPDATED, (event, { details }) => updateAssetPlayerDetails(details));
		player.on(Events.EVENT_CUE_ENTER, () => this.onInterstitialCueEnter());
		const onBufferCodecs = (event, data) => {
			const inQueuPlayer = this.getAssetPlayer(assetId);
			if (inQueuPlayer && data.tracks) {
				inQueuPlayer.off(Events.BUFFER_CODECS, onBufferCodecs);
				inQueuPlayer.tracks = data.tracks;
				const media = this.primaryMedia;
				if (this.bufferingAsset === inQueuPlayer.assetItem && media && !inQueuPlayer.media) this.bufferAssetPlayer(inQueuPlayer, media);
			}
		};
		player.on(Events.BUFFER_CODECS, onBufferCodecs);
		const bufferedToEnd = () => {
			var _this$schedule$items3;
			const inQueuPlayer = this.getAssetPlayer(assetId);
			this.log(`buffered to end of asset ${inQueuPlayer}`);
			if (!inQueuPlayer || !this.schedule) return;
			const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
			const item = (_this$schedule$items3 = this.schedule.items) == null ? void 0 : _this$schedule$items3[scheduleIndex];
			if (this.isInterstitial(item)) this.advanceAssetBuffering(item, assetItem);
		};
		player.on(Events.BUFFERED_TO_END, bufferedToEnd);
		const endedWithAssetIndex = (assetIndex) => {
			return () => {
				if (!this.getAssetPlayer(assetId) || !this.schedule) return;
				this.shouldPlay = true;
				const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
				this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetIndex);
			};
		};
		player.once(Events.MEDIA_ENDED, endedWithAssetIndex(assetListIndex));
		player.once(Events.PLAYOUT_LIMIT_REACHED, endedWithAssetIndex(Infinity));
		player.on(Events.ERROR, (event, data) => {
			if (!this.schedule) return;
			const inQueuPlayer = this.getAssetPlayer(assetId);
			if (data.details === ErrorDetails.BUFFER_STALLED_ERROR) {
				if (inQueuPlayer != null && inQueuPlayer.appendInPlace) {
					this.handleInPlaceStall(interstitial);
					return;
				}
				this.onTimeupdate();
				this.checkBuffer(true);
				return;
			}
			this.handleAssetItemError(data, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, `Asset player error ${data.error} ${interstitial}`);
		});
		player.on(Events.DESTROYING, () => {
			if (!this.getAssetPlayer(assetId) || !this.schedule) return;
			const error = /* @__PURE__ */ new Error(`Asset player destroyed unexpectedly ${assetId}`);
			const errorData = {
				fatal: true,
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
				error
			};
			this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
		});
		this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${eventAssetToString(assetItem)}`);
		this.hls.trigger(Events.INTERSTITIAL_ASSET_PLAYER_CREATED, {
			asset: assetItem,
			assetListIndex,
			event: interstitial,
			player
		});
		return player;
	}
	clearInterstitial(interstitial, toSegment) {
		this.clearAssetPlayers(interstitial, toSegment);
		interstitial.reset();
	}
	clearAssetPlayers(interstitial, toSegment) {
		interstitial.assetList.forEach((asset) => {
			this.clearAssetPlayer(asset.identifier, toSegment);
		});
	}
	resetAssetPlayer(assetId) {
		const playerIndex = this.getAssetPlayerQueueIndex(assetId);
		if (playerIndex !== -1) {
			this.log(`reset asset player "${assetId}" after error`);
			const player = this.playerQueue[playerIndex];
			this.transferMediaFromPlayer(player, null);
			player.resetDetails();
		}
	}
	clearAssetPlayer(assetId, toSegment) {
		const playerIndex = this.getAssetPlayerQueueIndex(assetId);
		if (playerIndex !== -1) {
			const player = this.playerQueue[playerIndex];
			this.log(`clear ${player} toSegment: ${toSegment ? segmentToString(toSegment) : toSegment}`);
			this.transferMediaFromPlayer(player, toSegment);
			this.playerQueue.splice(playerIndex, 1);
			player.destroy();
		}
	}
	emptyPlayerQueue() {
		let player;
		while (player = this.playerQueue.pop()) player.destroy();
		this.playerQueue = [];
	}
	startAssetPlayer(player, assetListIndex, scheduleItems, scheduleIndex, media) {
		const { interstitial, assetItem, assetId } = player;
		const assetListLength = interstitial.assetList.length;
		const playingAsset = this.playingAsset;
		this.endedAsset = null;
		this.playingAsset = assetItem;
		if (!playingAsset || playingAsset.identifier !== assetId) {
			if (playingAsset) {
				this.clearAssetPlayer(playingAsset.identifier, scheduleItems[scheduleIndex]);
				delete playingAsset.error;
			}
			this.log(`INTERSTITIAL_ASSET_STARTED ${assetListIndex + 1}/${assetListLength} ${eventAssetToString(assetItem)}`);
			this.hls.trigger(Events.INTERSTITIAL_ASSET_STARTED, {
				asset: assetItem,
				assetListIndex,
				event: interstitial,
				schedule: scheduleItems.slice(0),
				scheduleIndex,
				player
			});
		}
		this.bufferAssetPlayer(player, media);
	}
	bufferAssetPlayer(player, media) {
		var _this$schedule$items4, _this$detachedData5;
		if (!this.schedule) return;
		const { interstitial, assetItem } = player;
		const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
		const item = (_this$schedule$items4 = this.schedule.items) == null ? void 0 : _this$schedule$items4[scheduleIndex];
		if (!item) return;
		player.loadSource();
		this.setBufferingItem(item);
		this.bufferingAsset = assetItem;
		const bufferingPlayer = this.getBufferingPlayer();
		if (bufferingPlayer === player) return;
		const appendInPlaceNext = interstitial.appendInPlace;
		if (appendInPlaceNext && (bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial.appendInPlace) === false) return;
		const activeTracks = (bufferingPlayer == null ? void 0 : bufferingPlayer.tracks) || ((_this$detachedData5 = this.detachedData) == null ? void 0 : _this$detachedData5.tracks) || this.requiredTracks;
		if (appendInPlaceNext && assetItem !== this.playingAsset) {
			if (!player.tracks) {
				this.log(`Waiting for track info before buffering ${player}`);
				return;
			}
			if (activeTracks && !isCompatibleTrackChange(activeTracks, player.tracks)) {
				const error = /* @__PURE__ */ new Error(`Asset ${eventAssetToString(assetItem)} SourceBuffer tracks ('${Object.keys(player.tracks)}') are not compatible with primary content tracks ('${Object.keys(activeTracks)}')`);
				const errorData = {
					fatal: true,
					type: ErrorTypes.OTHER_ERROR,
					details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
					error
				};
				const assetListIndex = interstitial.findAssetIndex(assetItem);
				this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
				return;
			}
		}
		this.transferMediaTo(player, media);
	}
	handleInPlaceStall(interstitial) {
		const schedule = this.schedule;
		const media = this.primaryMedia;
		if (!schedule || !media) return;
		const currentTime = media.currentTime;
		const foundAssetIndex = schedule.findAssetIndex(interstitial, currentTime);
		const stallingAsset = interstitial.assetList[foundAssetIndex];
		if (stallingAsset) {
			const player = this.getAssetPlayer(stallingAsset.identifier);
			if (player) {
				const assetCurrentTime = player.currentTime || currentTime - stallingAsset.timelineStart;
				const distanceFromEnd = player.duration - assetCurrentTime;
				this.warn(`Stalled at ${assetCurrentTime} of ${assetCurrentTime + distanceFromEnd} in ${player} ${interstitial} (media.currentTime: ${currentTime})`);
				if (assetCurrentTime && (distanceFromEnd / media.playbackRate < .5 || player.bufferedInPlaceToEnd(media)) && player.hls) {
					const scheduleIndex = schedule.findEventIndex(interstitial.identifier);
					this.advanceAfterAssetEnded(interstitial, scheduleIndex, foundAssetIndex);
				}
			}
		}
	}
	advanceInPlace(time) {
		const media = this.primaryMedia;
		if (media && media.currentTime < time) media.currentTime = time;
	}
	handleAssetItemError(data, interstitial, scheduleIndex, assetListIndex, errorMessage) {
		if (data.details === ErrorDetails.BUFFER_STALLED_ERROR) return;
		const assetItem = interstitial.assetList[assetListIndex] || null;
		this.warn(`INTERSTITIAL_ASSET_ERROR ${assetItem ? eventAssetToString(assetItem) : assetItem} ${data.error}`);
		if (!this.schedule) return;
		const assetId = (assetItem == null ? void 0 : assetItem.identifier) || "";
		const playerIndex = this.getAssetPlayerQueueIndex(assetId);
		const player = this.playerQueue[playerIndex] || null;
		const items = this.schedule.items;
		const interstitialAssetError = _extends({}, data, {
			fatal: false,
			errorAction: createDoNothingErrorAction(true),
			asset: assetItem,
			assetListIndex,
			event: interstitial,
			schedule: items,
			scheduleIndex,
			player
		});
		this.hls.trigger(Events.INTERSTITIAL_ASSET_ERROR, interstitialAssetError);
		if (!data.fatal) return;
		const playingAsset = this.playingAsset;
		const bufferingAsset = this.bufferingAsset;
		const error = new Error(errorMessage);
		if (assetItem) {
			this.clearAssetPlayer(assetId, null);
			assetItem.error = error;
		}
		if (!interstitial.assetList.some((asset) => !asset.error)) interstitial.error = error;
		else for (let i = assetListIndex; i < interstitial.assetList.length; i++) this.resetAssetPlayer(interstitial.assetList[i].identifier);
		this.updateSchedule(true);
		if (interstitial.error) this.primaryFallback(interstitial);
		else if (playingAsset && playingAsset.identifier === assetId) this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetListIndex);
		else if (bufferingAsset && bufferingAsset.identifier === assetId && this.isInterstitial(this.bufferingItem)) this.advanceAssetBuffering(this.bufferingItem, bufferingAsset);
	}
	primaryFallback(interstitial) {
		const flushStart = interstitial.timelineStart;
		const playingItem = this.effectivePlayingItem;
		let timelinePos = this.timelinePos;
		if (playingItem) {
			this.log(`Fallback to primary from event "${interstitial.identifier}" start: ${flushStart} pos: ${timelinePos} playing: ${segmentToString(playingItem)} error: ${interstitial.error}`);
			if (timelinePos === -1) timelinePos = this.hls.startPosition;
			const newPlayingItem = this.updateItem(playingItem, timelinePos);
			if (this.itemsMatch(playingItem, newPlayingItem)) this.clearInterstitial(interstitial, null);
			if (interstitial.appendInPlace) {
				this.attachPrimary(flushStart, null);
				this.flushFrontBuffer(flushStart);
			}
		} else if (timelinePos === -1) {
			this.checkStart();
			return;
		}
		if (!this.schedule) return;
		const scheduleIndex = this.schedule.findItemIndexAtTime(timelinePos);
		this.setSchedulePosition(scheduleIndex);
	}
	onAssetListLoaded(event, data) {
		var _this$schedule0, _this$bufferingItem2;
		const interstitial = data.event;
		const interstitialId = interstitial.identifier;
		const assets = data.assetListResponse.ASSETS;
		if (!((_this$schedule0 = this.schedule) != null && _this$schedule0.hasEvent(interstitialId))) return;
		const eventStart = interstitial.timelineStart;
		const previousDuration = interstitial.duration;
		let sumDuration = 0;
		assets.forEach((asset, assetListIndex) => {
			const duration = parseFloat(asset.DURATION);
			this.createAsset(interstitial, assetListIndex, sumDuration, eventStart + sumDuration, duration, asset.URI);
			sumDuration += duration;
		});
		interstitial.duration = sumDuration;
		this.log(`Loaded asset-list with duration: ${sumDuration} (was: ${previousDuration}) ${interstitial}`);
		const waitingItem = this.waitingItem;
		const waitingForItem = (waitingItem == null ? void 0 : waitingItem.event.identifier) === interstitialId;
		this.updateSchedule();
		const bufferingEvent = (_this$bufferingItem2 = this.bufferingItem) == null ? void 0 : _this$bufferingItem2.event;
		if (waitingForItem) {
			var _this$schedule$items5;
			const scheduleIndex = this.schedule.findEventIndex(interstitialId);
			const item = (_this$schedule$items5 = this.schedule.items) == null ? void 0 : _this$schedule$items5[scheduleIndex];
			if (item) {
				if (!this.playingItem && this.timelinePos > item.end) {
					if (this.schedule.findItemIndexAtTime(this.timelinePos) !== scheduleIndex) {
						interstitial.error = /* @__PURE__ */ new Error(`Interstitial ${assets.length ? "no longer within playback range" : "asset-list is empty"} ${this.timelinePos} ${interstitial}`);
						this.log(interstitial.error.message);
						this.updateSchedule(true);
						this.primaryFallback(interstitial);
						return;
					}
				}
				this.setBufferingItem(item);
			}
			this.setSchedulePosition(scheduleIndex);
		} else if ((bufferingEvent == null ? void 0 : bufferingEvent.identifier) === interstitialId) {
			const assetItem = interstitial.assetList[0];
			if (assetItem) {
				const player = this.getAssetPlayer(assetItem.identifier);
				if (bufferingEvent.appendInPlace) {
					const media = this.primaryMedia;
					if (player && media) this.bufferAssetPlayer(player, media);
				} else if (player) player.loadSource();
			}
		}
	}
	onError(event, data) {
		if (!this.schedule) return;
		switch (data.details) {
			case ErrorDetails.ASSET_LIST_PARSING_ERROR:
			case ErrorDetails.ASSET_LIST_LOAD_ERROR:
			case ErrorDetails.ASSET_LIST_LOAD_TIMEOUT: {
				const interstitial = data.interstitial;
				if (interstitial) {
					this.updateSchedule(true);
					this.primaryFallback(interstitial);
				}
				break;
			}
			case ErrorDetails.BUFFER_STALLED_ERROR: {
				const stallingItem = this.endedItem || this.waitingItem || this.playingItem;
				if (this.isInterstitial(stallingItem) && stallingItem.event.appendInPlace) {
					this.handleInPlaceStall(stallingItem.event);
					return;
				}
				this.log(`Primary player stall @${this.timelinePos} bufferedPos: ${this.bufferedPos}`);
				this.onTimeupdate();
				this.checkBuffer(true);
				break;
			}
		}
	}
};
var TICK_INTERVAL$2 = 500;
var SubtitleStreamController = class extends BaseStreamController {
	constructor(hls, fragmentTracker, keyLoader) {
		super(hls, fragmentTracker, keyLoader, "subtitle-stream-controller", PlaylistLevelType.SUBTITLE);
		this.currentTrackId = -1;
		this.tracksBuffered = [];
		this.mainDetails = null;
		this.registerListeners();
	}
	onHandlerDestroying() {
		this.unregisterListeners();
		super.onHandlerDestroying();
		this.mainDetails = null;
	}
	registerListeners() {
		super.registerListeners();
		const { hls } = this;
		hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
		hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
		hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
		hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
		hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
	}
	unregisterListeners() {
		super.unregisterListeners();
		const { hls } = this;
		hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
		hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
		hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
		hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
		hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
	}
	startLoad(startPosition, skipSeekToStartPosition) {
		this.stopLoad();
		this.state = State.IDLE;
		this.setInterval(TICK_INTERVAL$2);
		this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
		this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
		this.tick();
	}
	onManifestLoading() {
		super.onManifestLoading();
		this.mainDetails = null;
	}
	onMediaDetaching(event, data) {
		this.tracksBuffered = [];
		super.onMediaDetaching(event, data);
	}
	onLevelLoaded(event, data) {
		this.mainDetails = data.details;
	}
	onSubtitleFragProcessed(event, data) {
		const { frag, success } = data;
		if (!this.fragContextChanged(frag)) {
			if (isMediaFragment(frag)) this.fragPrevious = frag;
			this.state = State.IDLE;
		}
		if (!success) return;
		const buffered = this.tracksBuffered[this.currentTrackId];
		if (!buffered) return;
		let timeRange;
		const fragStart = frag.start;
		for (let i = 0; i < buffered.length; i++) if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
			timeRange = buffered[i];
			break;
		}
		const fragEnd = frag.start + frag.duration;
		if (timeRange) timeRange.end = fragEnd;
		else {
			timeRange = {
				start: fragStart,
				end: fragEnd
			};
			buffered.push(timeRange);
		}
		this.fragmentTracker.fragBuffered(frag);
		this.fragBufferedComplete(frag, null);
		if (this.media) this.tick();
	}
	onBufferFlushing(event, data) {
		const { startOffset, endOffset } = data;
		if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
			const endOffsetSubtitles = endOffset - 1;
			if (endOffsetSubtitles <= 0) return;
			data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
			this.tracksBuffered.forEach((buffered) => {
				for (let i = 0; i < buffered.length;) {
					if (buffered[i].end <= endOffsetSubtitles) {
						buffered.shift();
						continue;
					} else if (buffered[i].start < endOffsetSubtitles) buffered[i].start = endOffsetSubtitles;
					else break;
					i++;
				}
			});
			this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
		}
	}
	onError(event, data) {
		const frag = data.frag;
		if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
			if (data.details === ErrorDetails.FRAG_GAP) this.fragmentTracker.fragBuffered(frag, true);
			if (this.fragCurrent) this.fragCurrent.abortRequests();
			if (this.state !== State.STOPPED) this.state = State.IDLE;
		}
	}
	onSubtitleTracksUpdated(event, { subtitleTracks }) {
		if (this.levels && subtitleOptionsIdentical(this.levels, subtitleTracks)) {
			this.levels = subtitleTracks.map((mediaPlaylist) => new Level(mediaPlaylist));
			return;
		}
		this.tracksBuffered = [];
		this.levels = subtitleTracks.map((mediaPlaylist) => {
			const level = new Level(mediaPlaylist);
			this.tracksBuffered[level.id] = [];
			return level;
		});
		this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
		this.fragPrevious = null;
		this.mediaBuffer = null;
	}
	onSubtitleTrackSwitch(event, data) {
		var _this$levels;
		this.currentTrackId = data.id;
		if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
			this.clearInterval();
			return;
		}
		const currentTrack = this.levels[this.currentTrackId];
		if (currentTrack != null && currentTrack.details) this.mediaBuffer = this.mediaBufferTimeRanges;
		else this.mediaBuffer = null;
		if (currentTrack && this.state !== State.STOPPED) this.setInterval(TICK_INTERVAL$2);
	}
	onSubtitleTrackLoaded(event, data) {
		var _track$details;
		const { currentTrackId, levels } = this;
		const { details: newDetails, id: trackId } = data;
		if (!levels) {
			this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
			return;
		}
		const track = levels[trackId];
		if (trackId >= levels.length || !track) return;
		this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ""},duration:${newDetails.totalduration}`);
		this.mediaBuffer = this.mediaBufferTimeRanges;
		let sliding = 0;
		if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
			if (newDetails.deltaUpdateFailed) return;
			const mainDetails = this.mainDetails;
			if (!mainDetails) {
				this.startFragRequested = false;
				return;
			}
			const mainSlidingStartFragment = mainDetails.fragments[0];
			if (!track.details) {
				if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
					alignMediaPlaylistByPDT(newDetails, mainDetails);
					sliding = newDetails.fragmentStart;
				} else if (mainSlidingStartFragment) {
					sliding = mainSlidingStartFragment.start;
					addSliding(newDetails, sliding);
				}
			} else {
				var _this$levelLastLoaded;
				sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
				if (sliding === 0 && mainSlidingStartFragment) {
					sliding = mainSlidingStartFragment.start;
					addSliding(newDetails, sliding);
				}
			}
			if (mainDetails && !this.startFragRequested) this.setStartPosition(mainDetails, sliding);
		}
		track.details = newDetails;
		this.levelLastLoaded = track;
		if (trackId !== currentTrackId) return;
		this.hls.trigger(Events.SUBTITLE_TRACK_UPDATED, {
			details: newDetails,
			id: trackId,
			groupId: data.groupId
		});
		this.tick();
		if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
			if (!findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0)) {
				this.warn("Subtitle playlist not aligned with playback");
				track.details = void 0;
			}
		}
	}
	_handleFragmentLoadComplete(fragLoadedData) {
		const { frag, payload } = fragLoadedData;
		const decryptData = frag.decryptdata;
		const hls = this.hls;
		if (this.fragContextChanged(frag)) return;
		if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && isFullSegmentEncryption(decryptData.method)) {
			const startTime = performance.now();
			this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, getAesModeFromFullSegmentMethod(decryptData.method)).catch((err) => {
				hls.trigger(Events.ERROR, {
					type: ErrorTypes.MEDIA_ERROR,
					details: ErrorDetails.FRAG_DECRYPT_ERROR,
					fatal: false,
					error: err,
					reason: err.message,
					frag
				});
				throw err;
			}).then((decryptedData) => {
				const endTime = performance.now();
				hls.trigger(Events.FRAG_DECRYPTED, {
					frag,
					payload: decryptedData,
					stats: {
						tstart: startTime,
						tdecrypt: endTime
					}
				});
			}).catch((err) => {
				this.warn(`${err.name}: ${err.message}`);
				this.state = State.IDLE;
			});
		}
	}
	doTick() {
		if (!this.media) {
			this.state = State.IDLE;
			return;
		}
		if (this.state === State.IDLE) {
			const { currentTrackId, levels } = this;
			const track = levels == null ? void 0 : levels[currentTrackId];
			if (!track || !levels.length || !track.details) return;
			if (this.waitForLive(track)) return;
			const { config } = this;
			const currentTime = this.getLoadPosition();
			const { end: targetBufferTime, len: bufferLen } = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
			const trackDetails = track.details;
			if (bufferLen > this.hls.maxBufferLength + trackDetails.levelTargetDuration) return;
			const fragments = trackDetails.fragments;
			const fragLen = fragments.length;
			const end = trackDetails.edge;
			let foundFrag = null;
			const fragPrevious = this.fragPrevious;
			if (targetBufferTime < end) {
				const tolerance = config.maxFragLookUpTolerance;
				const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
				foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
				if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) foundFrag = fragments[0];
			} else foundFrag = fragments[fragLen - 1];
			foundFrag = this.filterReplacedPrimary(foundFrag, track.details);
			if (!foundFrag) return;
			const prevFrag = fragments[foundFrag.sn - trackDetails.startSN - 1];
			if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) foundFrag = prevFrag;
			if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
				const fragToLoad = this.mapToInitFragWhenRequired(foundFrag);
				if (fragToLoad) this.loadFragment(fragToLoad, track, targetBufferTime);
			}
		}
	}
	loadFragment(frag, level, targetBufferTime) {
		if (!isMediaFragment(frag)) this._loadInitSegment(frag, level);
		else super.loadFragment(frag, level, targetBufferTime);
	}
	get mediaBufferTimeRanges() {
		return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
	}
};
var BufferableInstance = class {
	constructor(timeranges) {
		this.buffered = void 0;
		const getRange = (name, index, length) => {
			index = index >>> 0;
			if (index > length - 1) throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
			return timeranges[index][name];
		};
		this.buffered = {
			get length() {
				return timeranges.length;
			},
			end(index) {
				return getRange("end", index, timeranges.length);
			},
			start(index) {
				return getRange("start", index, timeranges.length);
			}
		};
	}
};
/**
*
* This code was ported from the dash.js project at:
*   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
*   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
*
* The original copyright appears below:
*
* The copyright in this software is being made available under the BSD License,
* included below. This software may be subject to other third party and contributor
* rights, including patent rights, and no such rights are granted under this license.
*
* Copyright (c) 2015-2016, DASH Industry Forum.
* All rights reserved.
*
* Redistribution and use in source and binary forms, with or without modification,
* are permitted provided that the following conditions are met:
*  1. Redistributions of source code must retain the above copyright notice, this
*  list of conditions and the following disclaimer.
*  * Redistributions in binary form must reproduce the above copyright notice,
*  this list of conditions and the following disclaimer in the documentation and/or
*  other materials provided with the distribution.
*  2. Neither the name of Dash Industry Forum nor the names of its
*  contributors may be used to endorse or promote products derived from this software
*  without specific prior written permission.
*
*  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
*  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
*  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
*  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
*  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
*  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
*  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
*  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
*  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
*  POSSIBILITY OF SUCH DAMAGE.
*/
/**
*  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
*/
var specialCea608CharsCodes = {
	42: 225,
	92: 233,
	94: 237,
	95: 243,
	96: 250,
	123: 231,
	124: 247,
	125: 209,
	126: 241,
	127: 9608,
	128: 174,
	129: 176,
	130: 189,
	131: 191,
	132: 8482,
	133: 162,
	134: 163,
	135: 9834,
	136: 224,
	137: 32,
	138: 232,
	139: 226,
	140: 234,
	141: 238,
	142: 244,
	143: 251,
	144: 193,
	145: 201,
	146: 211,
	147: 218,
	148: 220,
	149: 252,
	150: 8216,
	151: 161,
	152: 42,
	153: 8217,
	154: 9473,
	155: 169,
	156: 8480,
	157: 8226,
	158: 8220,
	159: 8221,
	160: 192,
	161: 194,
	162: 199,
	163: 200,
	164: 202,
	165: 203,
	166: 235,
	167: 206,
	168: 207,
	169: 239,
	170: 212,
	171: 217,
	172: 249,
	173: 219,
	174: 171,
	175: 187,
	176: 195,
	177: 227,
	178: 205,
	179: 204,
	180: 236,
	181: 210,
	182: 242,
	183: 213,
	184: 245,
	185: 123,
	186: 125,
	187: 92,
	188: 94,
	189: 95,
	190: 124,
	191: 8764,
	192: 196,
	193: 228,
	194: 214,
	195: 246,
	196: 223,
	197: 165,
	198: 164,
	199: 9475,
	200: 197,
	201: 229,
	202: 216,
	203: 248,
	204: 9487,
	205: 9491,
	206: 9495,
	207: 9499
};
/**
* Utils
*/
var getCharForByte = (byte) => String.fromCharCode(specialCea608CharsCodes[byte] || byte);
var NR_ROWS = 15;
var NR_COLS = 100;
var rowsLowCh1 = {
	17: 1,
	18: 3,
	21: 5,
	22: 7,
	23: 9,
	16: 11,
	19: 12,
	20: 14
};
var rowsHighCh1 = {
	17: 2,
	18: 4,
	21: 6,
	22: 8,
	23: 10,
	19: 13,
	20: 15
};
var rowsLowCh2 = {
	25: 1,
	26: 3,
	29: 5,
	30: 7,
	31: 9,
	24: 11,
	27: 12,
	28: 14
};
var rowsHighCh2 = {
	25: 2,
	26: 4,
	29: 6,
	30: 8,
	31: 10,
	27: 13,
	28: 15
};
var backgroundColors = [
	"white",
	"green",
	"blue",
	"cyan",
	"red",
	"yellow",
	"magenta",
	"black",
	"transparent"
];
var CaptionsLogger = class {
	constructor() {
		this.time = null;
		this.verboseLevel = 0;
	}
	log(severity, msg) {
		if (this.verboseLevel >= severity) {
			const m = typeof msg === "function" ? msg() : msg;
			logger.log(`${this.time} [${severity}] ${m}`);
		}
	}
};
var numArrayToHexArray = function numArrayToHexArray(numArray) {
	const hexArray = [];
	for (let j = 0; j < numArray.length; j++) hexArray.push(numArray[j].toString(16));
	return hexArray;
};
var PenState = class {
	constructor() {
		this.foreground = "white";
		this.underline = false;
		this.italics = false;
		this.background = "black";
		this.flash = false;
	}
	reset() {
		this.foreground = "white";
		this.underline = false;
		this.italics = false;
		this.background = "black";
		this.flash = false;
	}
	setStyles(styles) {
		const attribs = [
			"foreground",
			"underline",
			"italics",
			"background",
			"flash"
		];
		for (let i = 0; i < attribs.length; i++) {
			const style = attribs[i];
			if (styles.hasOwnProperty(style)) this[style] = styles[style];
		}
	}
	isDefault() {
		return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
	}
	equals(other) {
		return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
	}
	copy(newPenState) {
		this.foreground = newPenState.foreground;
		this.underline = newPenState.underline;
		this.italics = newPenState.italics;
		this.background = newPenState.background;
		this.flash = newPenState.flash;
	}
	toString() {
		return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
	}
};
/**
* Unicode character with styling and background.
* @constructor
*/
var StyledUnicodeChar = class {
	constructor() {
		this.uchar = " ";
		this.penState = new PenState();
	}
	reset() {
		this.uchar = " ";
		this.penState.reset();
	}
	setChar(uchar, newPenState) {
		this.uchar = uchar;
		this.penState.copy(newPenState);
	}
	setPenState(newPenState) {
		this.penState.copy(newPenState);
	}
	equals(other) {
		return this.uchar === other.uchar && this.penState.equals(other.penState);
	}
	copy(newChar) {
		this.uchar = newChar.uchar;
		this.penState.copy(newChar.penState);
	}
	isEmpty() {
		return this.uchar === " " && this.penState.isDefault();
	}
};
/**
* CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
* @constructor
*/
var Row = class {
	constructor(logger) {
		this.chars = [];
		this.pos = 0;
		this.currPenState = new PenState();
		this.cueStartTime = null;
		this.logger = void 0;
		for (let i = 0; i < NR_COLS; i++) this.chars.push(new StyledUnicodeChar());
		this.logger = logger;
	}
	equals(other) {
		for (let i = 0; i < NR_COLS; i++) if (!this.chars[i].equals(other.chars[i])) return false;
		return true;
	}
	copy(other) {
		for (let i = 0; i < NR_COLS; i++) this.chars[i].copy(other.chars[i]);
	}
	isEmpty() {
		let empty = true;
		for (let i = 0; i < NR_COLS; i++) if (!this.chars[i].isEmpty()) {
			empty = false;
			break;
		}
		return empty;
	}
	/**
	*  Set the cursor to a valid column.
	*/
	setCursor(absPos) {
		if (this.pos !== absPos) this.pos = absPos;
		if (this.pos < 0) {
			this.logger.log(3, "Negative cursor position " + this.pos);
			this.pos = 0;
		} else if (this.pos > NR_COLS) {
			this.logger.log(3, "Too large cursor position " + this.pos);
			this.pos = NR_COLS;
		}
	}
	/**
	* Move the cursor relative to current position.
	*/
	moveCursor(relPos) {
		const newPos = this.pos + relPos;
		if (relPos > 1) for (let i = this.pos + 1; i < newPos + 1; i++) this.chars[i].setPenState(this.currPenState);
		this.setCursor(newPos);
	}
	/**
	* Backspace, move one step back and clear character.
	*/
	backSpace() {
		this.moveCursor(-1);
		this.chars[this.pos].setChar(" ", this.currPenState);
	}
	insertChar(byte) {
		if (byte >= 144) this.backSpace();
		const char = getCharForByte(byte);
		if (this.pos >= NR_COLS) {
			this.logger.log(0, () => "Cannot insert " + byte.toString(16) + " (" + char + ") at position " + this.pos + ". Skipping it!");
			return;
		}
		this.chars[this.pos].setChar(char, this.currPenState);
		this.moveCursor(1);
	}
	clearFromPos(startPos) {
		let i;
		for (i = startPos; i < NR_COLS; i++) this.chars[i].reset();
	}
	clear() {
		this.clearFromPos(0);
		this.pos = 0;
		this.currPenState.reset();
	}
	clearToEndOfRow() {
		this.clearFromPos(this.pos);
	}
	getTextString() {
		const chars = [];
		let empty = true;
		for (let i = 0; i < NR_COLS; i++) {
			const char = this.chars[i].uchar;
			if (char !== " ") empty = false;
			chars.push(char);
		}
		if (empty) return "";
		else return chars.join("");
	}
	setPenStyles(styles) {
		this.currPenState.setStyles(styles);
		this.chars[this.pos].setPenState(this.currPenState);
	}
};
/**
* Keep a CEA-608 screen of 32x15 styled characters
* @constructor
*/
var CaptionScreen = class {
	constructor(logger) {
		this.rows = [];
		this.currRow = NR_ROWS - 1;
		this.nrRollUpRows = null;
		this.lastOutputScreen = null;
		this.logger = void 0;
		for (let i = 0; i < NR_ROWS; i++) this.rows.push(new Row(logger));
		this.logger = logger;
	}
	reset() {
		for (let i = 0; i < NR_ROWS; i++) this.rows[i].clear();
		this.currRow = NR_ROWS - 1;
	}
	equals(other) {
		let equal = true;
		for (let i = 0; i < NR_ROWS; i++) if (!this.rows[i].equals(other.rows[i])) {
			equal = false;
			break;
		}
		return equal;
	}
	copy(other) {
		for (let i = 0; i < NR_ROWS; i++) this.rows[i].copy(other.rows[i]);
	}
	isEmpty() {
		let empty = true;
		for (let i = 0; i < NR_ROWS; i++) if (!this.rows[i].isEmpty()) {
			empty = false;
			break;
		}
		return empty;
	}
	backSpace() {
		this.rows[this.currRow].backSpace();
	}
	clearToEndOfRow() {
		this.rows[this.currRow].clearToEndOfRow();
	}
	/**
	* Insert a character (without styling) in the current row.
	*/
	insertChar(char) {
		this.rows[this.currRow].insertChar(char);
	}
	setPen(styles) {
		this.rows[this.currRow].setPenStyles(styles);
	}
	moveCursor(relPos) {
		this.rows[this.currRow].moveCursor(relPos);
	}
	setCursor(absPos) {
		this.logger.log(2, "setCursor: " + absPos);
		this.rows[this.currRow].setCursor(absPos);
	}
	setPAC(pacData) {
		this.logger.log(2, () => "pacData = " + stringify(pacData));
		let newRow = pacData.row - 1;
		if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
		if (this.nrRollUpRows && this.currRow !== newRow) {
			for (let i = 0; i < NR_ROWS; i++) this.rows[i].clear();
			const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
			const lastOutputScreen = this.lastOutputScreen;
			if (lastOutputScreen) {
				const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
				const time = this.logger.time;
				if (prevLineTime !== null && time !== null && prevLineTime < time) for (let i = 0; i < this.nrRollUpRows; i++) this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
			}
		}
		this.currRow = newRow;
		const row = this.rows[this.currRow];
		if (pacData.indent !== null) {
			const indent = pacData.indent;
			const prevPos = Math.max(indent - 1, 0);
			row.setCursor(pacData.indent);
			pacData.color = row.chars[prevPos].penState.foreground;
		}
		const styles = {
			foreground: pacData.color,
			underline: pacData.underline,
			italics: pacData.italics,
			background: "black",
			flash: false
		};
		this.setPen(styles);
	}
	/**
	* Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
	*/
	setBkgData(bkgData) {
		this.logger.log(2, () => "bkgData = " + stringify(bkgData));
		this.backSpace();
		this.setPen(bkgData);
		this.insertChar(32);
	}
	setRollUpRows(nrRows) {
		this.nrRollUpRows = nrRows;
	}
	rollUp() {
		if (this.nrRollUpRows === null) {
			this.logger.log(3, "roll_up but nrRollUpRows not set yet");
			return;
		}
		this.logger.log(1, () => this.getDisplayText());
		const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
		const topRow = this.rows.splice(topRowIndex, 1)[0];
		topRow.clear();
		this.rows.splice(this.currRow, 0, topRow);
		this.logger.log(2, "Rolling up");
	}
	/**
	* Get all non-empty rows with as unicode text.
	*/
	getDisplayText(asOneRow) {
		asOneRow = asOneRow || false;
		const displayText = [];
		let text = "";
		let rowNr = -1;
		for (let i = 0; i < NR_ROWS; i++) {
			const rowText = this.rows[i].getTextString();
			if (rowText) {
				rowNr = i + 1;
				if (asOneRow) displayText.push("Row " + rowNr + ": '" + rowText + "'");
				else displayText.push(rowText.trim());
			}
		}
		if (displayText.length > 0) if (asOneRow) text = "[" + displayText.join(" | ") + "]";
		else text = displayText.join("\n");
		return text;
	}
	getTextAndFormat() {
		return this.rows;
	}
};
var Cea608Channel = class {
	constructor(channelNumber, outputFilter, logger) {
		this.chNr = void 0;
		this.outputFilter = void 0;
		this.mode = void 0;
		this.verbose = void 0;
		this.displayedMemory = void 0;
		this.nonDisplayedMemory = void 0;
		this.lastOutputScreen = void 0;
		this.currRollUpRow = void 0;
		this.writeScreen = void 0;
		this.cueStartTime = void 0;
		this.logger = void 0;
		this.chNr = channelNumber;
		this.outputFilter = outputFilter;
		this.mode = null;
		this.verbose = 0;
		this.displayedMemory = new CaptionScreen(logger);
		this.nonDisplayedMemory = new CaptionScreen(logger);
		this.lastOutputScreen = new CaptionScreen(logger);
		this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
		this.writeScreen = this.displayedMemory;
		this.mode = null;
		this.cueStartTime = null;
		this.logger = logger;
	}
	reset() {
		this.mode = null;
		this.displayedMemory.reset();
		this.nonDisplayedMemory.reset();
		this.lastOutputScreen.reset();
		this.outputFilter.reset();
		this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
		this.writeScreen = this.displayedMemory;
		this.mode = null;
		this.cueStartTime = null;
	}
	getHandler() {
		return this.outputFilter;
	}
	setHandler(newHandler) {
		this.outputFilter = newHandler;
	}
	setPAC(pacData) {
		this.writeScreen.setPAC(pacData);
	}
	setBkgData(bkgData) {
		this.writeScreen.setBkgData(bkgData);
	}
	setMode(newMode) {
		if (newMode === this.mode) return;
		this.mode = newMode;
		this.logger.log(2, () => "MODE=" + newMode);
		if (this.mode === "MODE_POP-ON") this.writeScreen = this.nonDisplayedMemory;
		else {
			this.writeScreen = this.displayedMemory;
			this.writeScreen.reset();
		}
		if (this.mode !== "MODE_ROLL-UP") {
			this.displayedMemory.nrRollUpRows = null;
			this.nonDisplayedMemory.nrRollUpRows = null;
		}
		this.mode = newMode;
	}
	insertChars(chars) {
		for (let i = 0; i < chars.length; i++) this.writeScreen.insertChar(chars[i]);
		const screen = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
		this.logger.log(2, () => screen + ": " + this.writeScreen.getDisplayText(true));
		if (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") {
			this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(true));
			this.outputDataUpdate();
		}
	}
	ccRCL() {
		this.logger.log(2, "RCL - Resume Caption Loading");
		this.setMode("MODE_POP-ON");
	}
	ccBS() {
		this.logger.log(2, "BS - BackSpace");
		if (this.mode === "MODE_TEXT") return;
		this.writeScreen.backSpace();
		if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
	}
	ccAOF() {}
	ccAON() {}
	ccDER() {
		this.logger.log(2, "DER- Delete to End of Row");
		this.writeScreen.clearToEndOfRow();
		this.outputDataUpdate();
	}
	ccRU(nrRows) {
		this.logger.log(2, "RU(" + nrRows + ") - Roll Up");
		this.writeScreen = this.displayedMemory;
		this.setMode("MODE_ROLL-UP");
		this.writeScreen.setRollUpRows(nrRows);
	}
	ccFON() {
		this.logger.log(2, "FON - Flash On");
		this.writeScreen.setPen({ flash: true });
	}
	ccRDC() {
		this.logger.log(2, "RDC - Resume Direct Captioning");
		this.setMode("MODE_PAINT-ON");
	}
	ccTR() {
		this.logger.log(2, "TR");
		this.setMode("MODE_TEXT");
	}
	ccRTD() {
		this.logger.log(2, "RTD");
		this.setMode("MODE_TEXT");
	}
	ccEDM() {
		this.logger.log(2, "EDM - Erase Displayed Memory");
		this.displayedMemory.reset();
		this.outputDataUpdate(true);
	}
	ccCR() {
		this.logger.log(2, "CR - Carriage Return");
		this.writeScreen.rollUp();
		this.outputDataUpdate(true);
	}
	ccENM() {
		this.logger.log(2, "ENM - Erase Non-displayed Memory");
		this.nonDisplayedMemory.reset();
	}
	ccEOC() {
		this.logger.log(2, "EOC - End Of Caption");
		if (this.mode === "MODE_POP-ON") {
			const tmp = this.displayedMemory;
			this.displayedMemory = this.nonDisplayedMemory;
			this.nonDisplayedMemory = tmp;
			this.writeScreen = this.nonDisplayedMemory;
			this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
		}
		this.outputDataUpdate(true);
	}
	ccTO(nrCols) {
		this.logger.log(2, "TO(" + nrCols + ") - Tab Offset");
		this.writeScreen.moveCursor(nrCols);
	}
	ccMIDROW(secondByte) {
		const styles = { flash: false };
		styles.underline = secondByte % 2 === 1;
		styles.italics = secondByte >= 46;
		if (!styles.italics) styles.foreground = [
			"white",
			"green",
			"blue",
			"cyan",
			"red",
			"yellow",
			"magenta"
		][Math.floor(secondByte / 2) - 16];
		else styles.foreground = "white";
		this.logger.log(2, "MIDROW: " + stringify(styles));
		this.writeScreen.setPen(styles);
	}
	outputDataUpdate(dispatch = false) {
		const time = this.logger.time;
		if (time === null) return;
		if (this.outputFilter) {
			if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) this.cueStartTime = time;
			else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
				this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
				if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
				this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
			}
			this.lastOutputScreen.copy(this.displayedMemory);
		}
	}
	cueSplitAtTime(t) {
		if (this.outputFilter) {
			if (!this.displayedMemory.isEmpty()) {
				if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
				this.cueStartTime = t;
			}
		}
	}
};
var Cea608Parser = class {
	constructor(field, out1, out2) {
		this.channels = void 0;
		this.currentChannel = 0;
		this.cmdHistory = createCmdHistory();
		this.logger = void 0;
		const logger = this.logger = new CaptionsLogger();
		this.channels = [
			null,
			new Cea608Channel(field, out1, logger),
			new Cea608Channel(field + 1, out2, logger)
		];
	}
	getHandler(channel) {
		return this.channels[channel].getHandler();
	}
	setHandler(channel, newHandler) {
		this.channels[channel].setHandler(newHandler);
	}
	/**
	* Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
	*/
	addData(time, byteList) {
		this.logger.time = time;
		for (let i = 0; i < byteList.length; i += 2) {
			const a = byteList[i] & 127;
			const b = byteList[i + 1] & 127;
			let cmdFound = false;
			let charsFound = null;
			if (a === 0 && b === 0) continue;
			else this.logger.log(3, () => "[" + numArrayToHexArray([byteList[i], byteList[i + 1]]) + "] -> (" + numArrayToHexArray([a, b]) + ")");
			const cmdHistory = this.cmdHistory;
			if (a >= 16 && a <= 31) {
				if (hasCmdRepeated(a, b, cmdHistory)) {
					setLastCmd(null, null, cmdHistory);
					this.logger.log(3, () => "Repeated command (" + numArrayToHexArray([a, b]) + ") is dropped");
					continue;
				}
				setLastCmd(a, b, this.cmdHistory);
				cmdFound = this.parseCmd(a, b);
				if (!cmdFound) cmdFound = this.parseMidrow(a, b);
				if (!cmdFound) cmdFound = this.parsePAC(a, b);
				if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
			} else setLastCmd(null, null, cmdHistory);
			if (!cmdFound) {
				charsFound = this.parseChars(a, b);
				if (charsFound) {
					const currChNr = this.currentChannel;
					if (currChNr && currChNr > 0) this.channels[currChNr].insertChars(charsFound);
					else this.logger.log(2, "No channel found yet. TEXT-MODE?");
				}
			}
			if (!cmdFound && !charsFound) this.logger.log(2, () => "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + " orig: " + numArrayToHexArray([byteList[i], byteList[i + 1]]));
		}
	}
	/**
	* Parse Command.
	* @returns True if a command was found
	*/
	parseCmd(a, b) {
		if (!((a === 20 || a === 28 || a === 21 || a === 29) && b >= 32 && b <= 47 || (a === 23 || a === 31) && b >= 33 && b <= 35)) return false;
		const chNr = a === 20 || a === 21 || a === 23 ? 1 : 2;
		const channel = this.channels[chNr];
		if (a === 20 || a === 21 || a === 28 || a === 29) {
			if (b === 32) channel.ccRCL();
			else if (b === 33) channel.ccBS();
			else if (b === 34) channel.ccAOF();
			else if (b === 35) channel.ccAON();
			else if (b === 36) channel.ccDER();
			else if (b === 37) channel.ccRU(2);
			else if (b === 38) channel.ccRU(3);
			else if (b === 39) channel.ccRU(4);
			else if (b === 40) channel.ccFON();
			else if (b === 41) channel.ccRDC();
			else if (b === 42) channel.ccTR();
			else if (b === 43) channel.ccRTD();
			else if (b === 44) channel.ccEDM();
			else if (b === 45) channel.ccCR();
			else if (b === 46) channel.ccENM();
			else if (b === 47) channel.ccEOC();
		} else channel.ccTO(b - 32);
		this.currentChannel = chNr;
		return true;
	}
	/**
	* Parse midrow styling command
	*/
	parseMidrow(a, b) {
		let chNr = 0;
		if ((a === 17 || a === 25) && b >= 32 && b <= 47) {
			if (a === 17) chNr = 1;
			else chNr = 2;
			if (chNr !== this.currentChannel) {
				this.logger.log(0, "Mismatch channel in midrow parsing");
				return false;
			}
			const channel = this.channels[chNr];
			if (!channel) return false;
			channel.ccMIDROW(b);
			this.logger.log(3, () => "MIDROW (" + numArrayToHexArray([a, b]) + ")");
			return true;
		}
		return false;
	}
	/**
	* Parse Preable Access Codes (Table 53).
	* @returns {Boolean} Tells if PAC found
	*/
	parsePAC(a, b) {
		let row;
		if (!((a >= 17 && a <= 23 || a >= 25 && a <= 31) && b >= 64 && b <= 127 || (a === 16 || a === 24) && b >= 64 && b <= 95)) return false;
		const chNr = a <= 23 ? 1 : 2;
		if (b >= 64 && b <= 95) row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
		else row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
		const channel = this.channels[chNr];
		if (!channel) return false;
		channel.setPAC(this.interpretPAC(row, b));
		this.currentChannel = chNr;
		return true;
	}
	/**
	* Interpret the second byte of the pac, and return the information.
	* @returns pacData with style parameters
	*/
	interpretPAC(row, byte) {
		let pacIndex;
		const pacData = {
			color: null,
			italics: false,
			indent: null,
			underline: false,
			row
		};
		if (byte > 95) pacIndex = byte - 96;
		else pacIndex = byte - 64;
		pacData.underline = (pacIndex & 1) === 1;
		if (pacIndex <= 13) pacData.color = [
			"white",
			"green",
			"blue",
			"cyan",
			"red",
			"yellow",
			"magenta",
			"white"
		][Math.floor(pacIndex / 2)];
		else if (pacIndex <= 15) {
			pacData.italics = true;
			pacData.color = "white";
		} else pacData.indent = Math.floor((pacIndex - 16) / 2) * 4;
		return pacData;
	}
	/**
	* Parse characters.
	* @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
	*/
	parseChars(a, b) {
		let channelNr;
		let charCodes = null;
		let charCode1 = null;
		if (a >= 25) {
			channelNr = 2;
			charCode1 = a - 8;
		} else {
			channelNr = 1;
			charCode1 = a;
		}
		if (charCode1 >= 17 && charCode1 <= 19) {
			let oneCode;
			if (charCode1 === 17) oneCode = b + 80;
			else if (charCode1 === 18) oneCode = b + 112;
			else oneCode = b + 144;
			this.logger.log(2, () => "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
			charCodes = [oneCode];
		} else if (a >= 32 && a <= 127) charCodes = b === 0 ? [a] : [a, b];
		if (charCodes) this.logger.log(3, () => "Char codes =  " + numArrayToHexArray(charCodes).join(","));
		return charCodes;
	}
	/**
	* Parse extended background attributes as well as new foreground color black.
	* @returns True if background attributes are found
	*/
	parseBackgroundAttributes(a, b) {
		if (!((a === 16 || a === 24) && b >= 32 && b <= 47 || (a === 23 || a === 31) && b >= 45 && b <= 47)) return false;
		let index;
		const bkgData = {};
		if (a === 16 || a === 24) {
			index = Math.floor((b - 32) / 2);
			bkgData.background = backgroundColors[index];
			if (b % 2 === 1) bkgData.background = bkgData.background + "_semi";
		} else if (b === 45) bkgData.background = "transparent";
		else {
			bkgData.foreground = "black";
			if (b === 47) bkgData.underline = true;
		}
		const chNr = a <= 23 ? 1 : 2;
		this.channels[chNr].setBkgData(bkgData);
		return true;
	}
	/**
	* Reset state of parser and its channels.
	*/
	reset() {
		for (let i = 0; i < Object.keys(this.channels).length; i++) {
			const channel = this.channels[i];
			if (channel) channel.reset();
		}
		setLastCmd(null, null, this.cmdHistory);
	}
	/**
	* Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
	*/
	cueSplitAtTime(t) {
		for (let i = 0; i < this.channels.length; i++) {
			const channel = this.channels[i];
			if (channel) channel.cueSplitAtTime(t);
		}
	}
};
function setLastCmd(a, b, cmdHistory) {
	cmdHistory.a = a;
	cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
	return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
	return {
		a: null,
		b: null
	};
}
/**
* Copyright 2013 vtt.js Contributors
*
* Licensed under the Apache License, Version 2.0 (the 'License');
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an 'AS IS' BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
var VTTCue = (function() {
	if (optionalSelf != null && optionalSelf.VTTCue) return self.VTTCue;
	const AllowedDirections = [
		"",
		"lr",
		"rl"
	];
	const AllowedAlignments = [
		"start",
		"middle",
		"end",
		"left",
		"right"
	];
	function isAllowedValue(allowed, value) {
		if (typeof value !== "string") return false;
		if (!Array.isArray(allowed)) return false;
		const lcValue = value.toLowerCase();
		if (~allowed.indexOf(lcValue)) return lcValue;
		return false;
	}
	function findDirectionSetting(value) {
		return isAllowedValue(AllowedDirections, value);
	}
	function findAlignSetting(value) {
		return isAllowedValue(AllowedAlignments, value);
	}
	function extend(obj, ...rest) {
		let i = 1;
		for (; i < arguments.length; i++) {
			const cobj = arguments[i];
			for (const p in cobj) obj[p] = cobj[p];
		}
		return obj;
	}
	function VTTCue(startTime, endTime, text) {
		const cue = this;
		const baseObj = { enumerable: true };
		/**
		* Shim implementation specific properties. These properties are not in
		* the spec.
		*/
		cue.hasBeenReset = false;
		/**
		* VTTCue and TextTrackCue properties
		* http://dev.w3.org/html5/webvtt/#vttcue-interface
		*/
		let _id = "";
		let _pauseOnExit = false;
		let _startTime = startTime;
		let _endTime = endTime;
		let _text = text;
		let _region = null;
		let _vertical = "";
		let _snapToLines = true;
		let _line = "auto";
		let _lineAlign = "start";
		let _position = 50;
		let _positionAlign = "middle";
		let _size = 50;
		let _align = "middle";
		Object.defineProperty(cue, "id", extend({}, baseObj, {
			get: function() {
				return _id;
			},
			set: function(value) {
				_id = "" + value;
			}
		}));
		Object.defineProperty(cue, "pauseOnExit", extend({}, baseObj, {
			get: function() {
				return _pauseOnExit;
			},
			set: function(value) {
				_pauseOnExit = !!value;
			}
		}));
		Object.defineProperty(cue, "startTime", extend({}, baseObj, {
			get: function() {
				return _startTime;
			},
			set: function(value) {
				if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
				_startTime = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "endTime", extend({}, baseObj, {
			get: function() {
				return _endTime;
			},
			set: function(value) {
				if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
				_endTime = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "text", extend({}, baseObj, {
			get: function() {
				return _text;
			},
			set: function(value) {
				_text = "" + value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "region", extend({}, baseObj, {
			get: function() {
				return _region;
			},
			set: function(value) {
				_region = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "vertical", extend({}, baseObj, {
			get: function() {
				return _vertical;
			},
			set: function(value) {
				const setting = findDirectionSetting(value);
				if (setting === false) throw new SyntaxError("An invalid or illegal string was specified.");
				_vertical = setting;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "snapToLines", extend({}, baseObj, {
			get: function() {
				return _snapToLines;
			},
			set: function(value) {
				_snapToLines = !!value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "line", extend({}, baseObj, {
			get: function() {
				return _line;
			},
			set: function(value) {
				if (typeof value !== "number" && value !== "auto") throw new SyntaxError("An invalid number or illegal string was specified.");
				_line = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "lineAlign", extend({}, baseObj, {
			get: function() {
				return _lineAlign;
			},
			set: function(value) {
				const setting = findAlignSetting(value);
				if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
				_lineAlign = setting;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "position", extend({}, baseObj, {
			get: function() {
				return _position;
			},
			set: function(value) {
				if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
				_position = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "positionAlign", extend({}, baseObj, {
			get: function() {
				return _positionAlign;
			},
			set: function(value) {
				const setting = findAlignSetting(value);
				if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
				_positionAlign = setting;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "size", extend({}, baseObj, {
			get: function() {
				return _size;
			},
			set: function(value) {
				if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
				_size = value;
				this.hasBeenReset = true;
			}
		}));
		Object.defineProperty(cue, "align", extend({}, baseObj, {
			get: function() {
				return _align;
			},
			set: function(value) {
				const setting = findAlignSetting(value);
				if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
				_align = setting;
				this.hasBeenReset = true;
			}
		}));
		/**
		* Other <track> spec defined properties
		*/
		cue.displayState = void 0;
	}
	/**
	* VTTCue methods
	*/
	VTTCue.prototype.getCueAsHTML = function() {
		return self.WebVTT.convertCueToDOMTree(self, this.text);
	};
	return VTTCue;
})();
var StringDecoder = class {
	decode(data, options) {
		if (!data) return "";
		if (typeof data !== "string") throw new Error("Error - expected string data.");
		return decodeURIComponent(encodeURIComponent(data));
	}
};
function parseTimeStamp(input) {
	function computeSeconds(h, m, s, f) {
		return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
	}
	const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
	if (!m) return null;
	if (parseFloat(m[2]) > 59) return computeSeconds(m[2], m[3], 0, m[4]);
	return computeSeconds(m[1], m[2], m[3], m[4]);
}
var Settings = class {
	constructor() {
		this.values = Object.create(null);
	}
	set(k, v) {
		if (!this.get(k) && v !== "") this.values[k] = v;
	}
	get(k, dflt, defaultKey) {
		if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
		return this.has(k) ? this.values[k] : dflt;
	}
	has(k) {
		return k in this.values;
	}
	alt(k, v, a) {
		for (let n = 0; n < a.length; ++n) if (v === a[n]) {
			this.set(k, v);
			break;
		}
	}
	integer(k, v) {
		if (/^-?\d+$/.test(v)) this.set(k, parseInt(v, 10));
	}
	percent(k, v) {
		if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
			const percent = parseFloat(v);
			if (percent >= 0 && percent <= 100) {
				this.set(k, percent);
				return true;
			}
		}
		return false;
	}
};
function parseOptions(input, callback, keyValueDelim, groupDelim) {
	const groups = groupDelim ? input.split(groupDelim) : [input];
	for (const i in groups) {
		if (typeof groups[i] !== "string") continue;
		const kv = groups[i].split(keyValueDelim);
		if (kv.length !== 2) continue;
		const k = kv[0];
		const v = kv[1];
		callback(k, v);
	}
}
var defaults = new VTTCue(0, 0, "");
var center = defaults.align === "middle" ? "middle" : "center";
function parseCue(input, cue, regionList) {
	const oInput = input;
	function consumeTimeStamp() {
		const ts = parseTimeStamp(input);
		if (ts === null) throw new Error("Malformed timestamp: " + oInput);
		input = input.replace(/^[^\sa-zA-Z-]+/, "");
		return ts;
	}
	function consumeCueSettings(input, cue) {
		const settings = new Settings();
		parseOptions(input, function(k, v) {
			let vals;
			switch (k) {
				case "region":
					for (let i = regionList.length - 1; i >= 0; i--) if (regionList[i].id === v) {
						settings.set(k, regionList[i].region);
						break;
					}
					break;
				case "vertical":
					settings.alt(k, v, ["rl", "lr"]);
					break;
				case "line":
					vals = v.split(",");
					settings.integer(k, vals[0]);
					if (settings.percent(k, vals[0])) settings.set("snapToLines", false);
					settings.alt(k, vals[0], ["auto"]);
					if (vals.length === 2) settings.alt("lineAlign", vals[1], [
						"start",
						center,
						"end"
					]);
					break;
				case "position":
					vals = v.split(",");
					settings.percent(k, vals[0]);
					if (vals.length === 2) settings.alt("positionAlign", vals[1], [
						"start",
						center,
						"end",
						"line-left",
						"line-right",
						"auto"
					]);
					break;
				case "size":
					settings.percent(k, v);
					break;
				case "align":
					settings.alt(k, v, [
						"start",
						center,
						"end",
						"left",
						"right"
					]);
					break;
			}
		}, /:/, /\s/);
		cue.region = settings.get("region", null);
		cue.vertical = settings.get("vertical", "");
		let line = settings.get("line", "auto");
		if (line === "auto" && defaults.line === -1) line = -1;
		cue.line = line;
		cue.lineAlign = settings.get("lineAlign", "start");
		cue.snapToLines = settings.get("snapToLines", true);
		cue.size = settings.get("size", 100);
		cue.align = settings.get("align", center);
		let position = settings.get("position", "auto");
		if (position === "auto" && defaults.position === 50) position = cue.align === "start" || cue.align === "left" ? 0 : cue.align === "end" || cue.align === "right" ? 100 : 50;
		cue.position = position;
	}
	function skipWhitespace() {
		input = input.replace(/^\s+/, "");
	}
	skipWhitespace();
	cue.startTime = consumeTimeStamp();
	skipWhitespace();
	if (input.slice(0, 3) !== "-->") throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
	input = input.slice(3);
	skipWhitespace();
	cue.endTime = consumeTimeStamp();
	skipWhitespace();
	consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
	return input.replace(/<br(?: \/)?>/gi, "\n");
}
var VTTParser = class {
	constructor() {
		this.state = "INITIAL";
		this.buffer = "";
		this.decoder = new StringDecoder();
		this.regionList = [];
		this.cue = null;
		this.oncue = void 0;
		this.onparsingerror = void 0;
		this.onflush = void 0;
	}
	parse(data) {
		const _this = this;
		if (data) _this.buffer += _this.decoder.decode(data, { stream: true });
		function collectNextLine() {
			let buffer = _this.buffer;
			let pos = 0;
			buffer = fixLineBreaks(buffer);
			while (pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n") ++pos;
			const line = buffer.slice(0, pos);
			if (buffer[pos] === "\r") ++pos;
			if (buffer[pos] === "\n") ++pos;
			_this.buffer = buffer.slice(pos);
			return line;
		}
		function parseHeader(input) {
			parseOptions(input, function(k, v) {}, /:/);
		}
		try {
			let line = "";
			if (_this.state === "INITIAL") {
				if (!/\r\n|\n/.test(_this.buffer)) return this;
				line = collectNextLine();
				const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
				if (!(m != null && m[0])) throw new Error("Malformed WebVTT signature.");
				_this.state = "HEADER";
			}
			let alreadyCollectedLine = false;
			while (_this.buffer) {
				if (!/\r\n|\n/.test(_this.buffer)) return this;
				if (!alreadyCollectedLine) line = collectNextLine();
				else alreadyCollectedLine = false;
				switch (_this.state) {
					case "HEADER":
						if (/:/.test(line)) parseHeader(line);
						else if (!line) _this.state = "ID";
						continue;
					case "NOTE":
						if (!line) _this.state = "ID";
						continue;
					case "ID":
						if (/^NOTE($|[ \t])/.test(line)) {
							_this.state = "NOTE";
							break;
						}
						if (!line) continue;
						_this.cue = new VTTCue(0, 0, "");
						_this.state = "CUE";
						if (line.indexOf("-->") === -1) {
							_this.cue.id = line;
							continue;
						}
					case "CUE":
						if (!_this.cue) {
							_this.state = "BADCUE";
							continue;
						}
						try {
							parseCue(line, _this.cue, _this.regionList);
						} catch (e) {
							_this.cue = null;
							_this.state = "BADCUE";
							continue;
						}
						_this.state = "CUETEXT";
						continue;
					case "CUETEXT":
						{
							const hasSubstring = line.indexOf("-->") !== -1;
							if (!line || hasSubstring && (alreadyCollectedLine = true)) {
								if (_this.oncue && _this.cue) _this.oncue(_this.cue);
								_this.cue = null;
								_this.state = "ID";
								continue;
							}
							if (_this.cue === null) continue;
							if (_this.cue.text) _this.cue.text += "\n";
							_this.cue.text += line;
						}
						continue;
					case "BADCUE": if (!line) _this.state = "ID";
				}
			}
		} catch (e) {
			if (_this.state === "CUETEXT" && _this.cue && _this.oncue) _this.oncue(_this.cue);
			_this.cue = null;
			_this.state = _this.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
		}
		return this;
	}
	flush() {
		const _this = this;
		try {
			if (_this.cue || _this.state === "HEADER") {
				_this.buffer += "\n\n";
				_this.parse();
			}
			if (_this.state === "INITIAL" || _this.state === "BADWEBVTT") throw new Error("Malformed WebVTT signature.");
		} catch (e) {
			if (_this.onparsingerror) _this.onparsingerror(e);
		}
		if (_this.onflush) _this.onflush();
		return this;
	}
};
var LINEBREAKS = /\r\n|\n\r|\n|\r/g;
var startsWith = function startsWith(inputString, searchString, position = 0) {
	return inputString.slice(position, position + searchString.length) === searchString;
};
var cueString2millis = function cueString2millis(timeString) {
	let ts = parseInt(timeString.slice(-3));
	const secs = parseInt(timeString.slice(-6, -4));
	const mins = parseInt(timeString.slice(-9, -7));
	const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(":"))) : 0;
	if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
	ts += 1e3 * secs;
	ts += 60 * 1e3 * mins;
	ts += 3600 * 1e3 * hours;
	return ts;
};
function generateCueId(startTime, endTime, text) {
	return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
	let currCC = vttCCs[cc];
	let prevCC = vttCCs[currCC.prevCC];
	if (!prevCC || !prevCC.new && currCC.new) {
		vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
		currCC.new = false;
		return;
	}
	while ((_prevCC = prevCC) != null && _prevCC.new) {
		var _prevCC;
		vttCCs.ccOffset += currCC.start - prevCC.start;
		currCC.new = false;
		currCC = prevCC;
		prevCC = vttCCs[currCC.prevCC];
	}
	vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
	const parser = new VTTParser();
	const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, "\n").split("\n");
	const cues = [];
	const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
	let cueTime = "00:00.000";
	let timestampMapMPEGTS = 0;
	let timestampMapLOCAL = 0;
	let parsingError;
	let inHeader = true;
	parser.oncue = function(cue) {
		const currCC = vttCCs[cc];
		let cueOffset = vttCCs.ccOffset;
		const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 9e4;
		if (currCC != null && currCC.new) if (timestampMapLOCAL !== void 0) cueOffset = vttCCs.ccOffset = currCC.start;
		else calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
		if (webVttMpegTsMapOffset) {
			if (!initPTS) {
				parsingError = /* @__PURE__ */ new Error("Missing initPTS for VTT MPEGTS");
				return;
			}
			cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
		}
		const duration = cue.endTime - cue.startTime;
		const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 9e4, timeOffset * 9e4) / 9e4;
		cue.startTime = Math.max(startTime, 0);
		cue.endTime = Math.max(startTime + duration, 0);
		const text = cue.text.trim();
		cue.text = decodeURIComponent(encodeURIComponent(text));
		if (!cue.id) cue.id = generateCueId(cue.startTime, cue.endTime, text);
		if (cue.endTime > 0) cues.push(cue);
	};
	parser.onparsingerror = function(error) {
		parsingError = error;
	};
	parser.onflush = function() {
		if (parsingError) {
			errorCallBack(parsingError);
			return;
		}
		callBack(cues);
	};
	vttLines.forEach((line) => {
		if (inHeader) {
			if (startsWith(line, "X-TIMESTAMP-MAP=")) {
				inHeader = false;
				line.slice(16).split(",").forEach((timestamp) => {
					if (startsWith(timestamp, "LOCAL:")) cueTime = timestamp.slice(6);
					else if (startsWith(timestamp, "MPEGTS:")) timestampMapMPEGTS = parseInt(timestamp.slice(7));
				});
				try {
					timestampMapLOCAL = cueString2millis(cueTime) / 1e3;
				} catch (error) {
					parsingError = error;
				}
				return;
			} else if (line === "") inHeader = false;
		}
		parser.parse(line + "\n");
	});
	parser.flush();
}
var IMSC1_CODEC = "stpp.ttml.im1t";
var HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
var TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
var textAlignToLineAlign = {
	left: "start",
	center: "center",
	right: "end",
	start: "start",
	end: "end"
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
	const results = findBox(new Uint8Array(payload), ["mdat"]);
	if (results.length === 0) {
		errorCallBack(/* @__PURE__ */ new Error("Could not parse IMSC1 mdat"));
		return;
	}
	const ttmlList = results.map((mdat) => utf8ArrayToStr(mdat));
	const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
	try {
		ttmlList.forEach((ttml) => callBack(parseTTML(ttml, syncTime)));
	} catch (error) {
		errorCallBack(error);
	}
}
function parseTTML(ttml, syncTime) {
	const tt = new DOMParser().parseFromString(ttml, "text/xml").getElementsByTagName("tt")[0];
	if (!tt) throw new Error("Invalid ttml");
	const defaultRateInfo = {
		frameRate: 30,
		subFrameRate: 1,
		frameRateMultiplier: 0,
		tickRate: 0
	};
	const rateInfo = Object.keys(defaultRateInfo).reduce((result, key) => {
		result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
		return result;
	}, {});
	const trim = tt.getAttribute("xml:space") !== "preserve";
	const styleElements = collectionToDictionary(getElementCollection(tt, "styling", "style"));
	const regionElements = collectionToDictionary(getElementCollection(tt, "layout", "region"));
	const cueElements = getElementCollection(tt, "body", "[begin]");
	return [].map.call(cueElements, (cueElement) => {
		const cueText = getTextContent(cueElement, trim);
		if (!cueText || !cueElement.hasAttribute("begin")) return null;
		const startTime = parseTtmlTime(cueElement.getAttribute("begin"), rateInfo);
		const duration = parseTtmlTime(cueElement.getAttribute("dur"), rateInfo);
		let endTime = parseTtmlTime(cueElement.getAttribute("end"), rateInfo);
		if (startTime === null) throw timestampParsingError(cueElement);
		if (endTime === null) {
			if (duration === null) throw timestampParsingError(cueElement);
			endTime = startTime + duration;
		}
		const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
		cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
		const region = regionElements[cueElement.getAttribute("region")];
		const style = styleElements[cueElement.getAttribute("style")];
		const styles = getTtmlStyles(region, style, styleElements);
		const { textAlign } = styles;
		if (textAlign) {
			const lineAlign = textAlignToLineAlign[textAlign];
			if (lineAlign) cue.lineAlign = lineAlign;
			cue.align = textAlign;
		}
		_extends(cue, styles);
		return cue;
	}).filter((cue) => cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
	const parent = fromElement.getElementsByTagName(parentName)[0];
	if (parent) return [].slice.call(parent.querySelectorAll(childName));
	return [];
}
function collectionToDictionary(elementsWithId) {
	return elementsWithId.reduce((dict, element) => {
		const id = element.getAttribute("xml:id");
		if (id) dict[id] = element;
		return dict;
	}, {});
}
function getTextContent(element, trim) {
	return [].slice.call(element.childNodes).reduce((str, node, i) => {
		var _node$childNodes;
		if (node.nodeName === "br" && i) return str + "\n";
		if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) return getTextContent(node, trim);
		else if (trim) return str + node.textContent.trim().replace(/\s+/g, " ");
		return str + node.textContent;
	}, "");
}
function getTtmlStyles(region, style, styleElements) {
	const ttsNs = "http://www.w3.org/ns/ttml#styling";
	let regionStyle = null;
	const styleAttributes = [
		"displayAlign",
		"textAlign",
		"color",
		"backgroundColor",
		"fontSize",
		"fontFamily"
	];
	const regionStyleName = region != null && region.hasAttribute("style") ? region.getAttribute("style") : null;
	if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) regionStyle = styleElements[regionStyleName];
	return styleAttributes.reduce((styles, name) => {
		const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
		if (value) styles[name] = value;
		return styles;
	}, {});
}
function getAttributeNS(element, ns, name) {
	if (!element) return null;
	return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
	return /* @__PURE__ */ new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
	if (!timeAttributeValue) return null;
	let seconds = parseTimeStamp(timeAttributeValue);
	if (seconds === null) {
		if (HMSF_REGEX.test(timeAttributeValue)) seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
		else if (TIME_UNIT_REGEX.test(timeAttributeValue)) seconds = parseTimeUnits(timeAttributeValue, rateInfo);
	}
	return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
	const m = HMSF_REGEX.exec(timeAttributeValue);
	const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
	return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
	const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
	const value = Number(m[1]);
	switch (m[2]) {
		case "h": return value * 3600;
		case "m": return value * 60;
		case "ms": return value * 1e3;
		case "f": return value / rateInfo.frameRate;
		case "t": return value / rateInfo.tickRate;
	}
	return value;
}
var OutputFilter = class {
	constructor(timelineController, trackName) {
		this.timelineController = void 0;
		this.cueRanges = [];
		this.trackName = void 0;
		this.startTime = null;
		this.endTime = null;
		this.screen = null;
		this.timelineController = timelineController;
		this.trackName = trackName;
	}
	dispatchCue() {
		if (this.startTime === null) return;
		this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
		this.startTime = null;
	}
	newCue(startTime, endTime, screen) {
		if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
		this.endTime = endTime;
		this.screen = screen;
		this.timelineController.createCaptionsTrack(this.trackName);
	}
	reset() {
		this.cueRanges = [];
		this.startTime = null;
	}
};
var TimelineController = class {
	constructor(hls) {
		this.hls = void 0;
		this.media = null;
		this.config = void 0;
		this.enabled = true;
		this.Cues = void 0;
		this.textTracks = [];
		this.tracks = [];
		this.initPTS = [];
		this.unparsedVttFrags = [];
		this.captionsTracks = {};
		this.nonNativeCaptionsTracks = {};
		this.cea608Parser1 = void 0;
		this.cea608Parser2 = void 0;
		this.lastCc = -1;
		this.lastSn = -1;
		this.lastPartIndex = -1;
		this.prevCC = -1;
		this.vttCCs = newVTTCCs();
		this.captionsProperties = void 0;
		this.hls = hls;
		this.config = hls.config;
		this.Cues = hls.config.cueHandler;
		this.captionsProperties = {
			textTrack1: {
				label: this.config.captionsTextTrack1Label,
				languageCode: this.config.captionsTextTrack1LanguageCode
			},
			textTrack2: {
				label: this.config.captionsTextTrack2Label,
				languageCode: this.config.captionsTextTrack2LanguageCode
			},
			textTrack3: {
				label: this.config.captionsTextTrack3Label,
				languageCode: this.config.captionsTextTrack3LanguageCode
			},
			textTrack4: {
				label: this.config.captionsTextTrack4Label,
				languageCode: this.config.captionsTextTrack4LanguageCode
			}
		};
		hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
		hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
		hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
		hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
		hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
		hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
		hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
	}
	destroy() {
		const { hls } = this;
		hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
		hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
		hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
		hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
		hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
		hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
		hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
		hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
		this.hls = this.config = this.media = null;
		this.cea608Parser1 = this.cea608Parser2 = void 0;
	}
	initCea608Parsers() {
		const channel1 = new OutputFilter(this, "textTrack1");
		const channel2 = new OutputFilter(this, "textTrack2");
		const channel3 = new OutputFilter(this, "textTrack3");
		const channel4 = new OutputFilter(this, "textTrack4");
		this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
		this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
	}
	addCues(trackName, startTime, endTime, screen, cueRanges) {
		let merged = false;
		for (let i = cueRanges.length; i--;) {
			const cueRange = cueRanges[i];
			const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
			if (overlap >= 0) {
				cueRange[0] = Math.min(cueRange[0], startTime);
				cueRange[1] = Math.max(cueRange[1], endTime);
				merged = true;
				if (overlap / (endTime - startTime) > .5) return;
			}
		}
		if (!merged) cueRanges.push([startTime, endTime]);
		if (this.config.renderTextTracksNatively) {
			const track = this.captionsTracks[trackName];
			this.Cues.newCue(track, startTime, endTime, screen);
		} else {
			const cues = this.Cues.newCue(null, startTime, endTime, screen);
			this.hls.trigger(Events.CUES_PARSED, {
				type: "captions",
				cues,
				track: trackName
			});
		}
	}
	onInitPtsFound(event, { frag, id, initPTS, timescale, trackId }) {
		const { unparsedVttFrags } = this;
		if (id === PlaylistLevelType.MAIN) this.initPTS[frag.cc] = {
			baseTime: initPTS,
			timescale,
			trackId
		};
		if (unparsedVttFrags.length) {
			this.unparsedVttFrags = [];
			unparsedVttFrags.forEach((data) => {
				if (this.initPTS[data.frag.cc]) this.onFragLoaded(Events.FRAG_LOADED, data);
				else this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
					success: false,
					frag: data.frag,
					error: /* @__PURE__ */ new Error("Subtitle discontinuity domain does not match main")
				});
			});
		}
	}
	getExistingTrack(label, language) {
		const { media } = this;
		if (media) for (let i = 0; i < media.textTracks.length; i++) {
			const textTrack = media.textTracks[i];
			if (canReuseVttTextTrack(textTrack, {
				name: label,
				lang: language,
				characteristics: "transcribes-spoken-dialog,describes-music-and-sound"
			})) return textTrack;
		}
		return null;
	}
	createCaptionsTrack(trackName) {
		if (this.config.renderTextTracksNatively) this.createNativeTrack(trackName);
		else this.createNonNativeTrack(trackName);
	}
	createNativeTrack(trackName) {
		if (this.captionsTracks[trackName]) return;
		const { captionsProperties, captionsTracks, media } = this;
		const { label, languageCode } = captionsProperties[trackName];
		const existingTrack = this.getExistingTrack(label, languageCode);
		if (!existingTrack) {
			const textTrack = this.createTextTrack("captions", label, languageCode);
			if (textTrack) {
				textTrack[trackName] = true;
				captionsTracks[trackName] = textTrack;
			}
		} else {
			captionsTracks[trackName] = existingTrack;
			clearCurrentCues(captionsTracks[trackName]);
			sendAddTrackEvent(captionsTracks[trackName], media);
		}
	}
	createNonNativeTrack(trackName) {
		if (this.nonNativeCaptionsTracks[trackName]) return;
		const trackProperties = this.captionsProperties[trackName];
		if (!trackProperties) return;
		const track = {
			_id: trackName,
			label: trackProperties.label,
			kind: "captions",
			default: trackProperties.media ? !!trackProperties.media.default : false,
			closedCaptions: trackProperties.media
		};
		this.nonNativeCaptionsTracks[trackName] = track;
		this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: [track] });
	}
	createTextTrack(kind, label, lang) {
		const media = this.media;
		if (!media) return;
		return media.addTextTrack(kind, label, lang);
	}
	onMediaAttaching(event, data) {
		this.media = data.media;
		if (!data.mediaSource) this._cleanTracks();
	}
	onMediaDetaching(event, data) {
		const transferringMedia = !!data.transferMedia;
		this.media = null;
		if (transferringMedia) return;
		const { captionsTracks } = this;
		Object.keys(captionsTracks).forEach((trackName) => {
			clearCurrentCues(captionsTracks[trackName]);
			delete captionsTracks[trackName];
		});
		this.nonNativeCaptionsTracks = {};
	}
	onManifestLoading() {
		this.lastCc = -1;
		this.lastSn = -1;
		this.lastPartIndex = -1;
		this.prevCC = -1;
		this.vttCCs = newVTTCCs();
		this._cleanTracks();
		this.tracks = [];
		this.captionsTracks = {};
		this.nonNativeCaptionsTracks = {};
		this.textTracks = [];
		this.unparsedVttFrags = [];
		this.initPTS = [];
		if (this.cea608Parser1 && this.cea608Parser2) {
			this.cea608Parser1.reset();
			this.cea608Parser2.reset();
		}
	}
	_cleanTracks() {
		const { media } = this;
		if (!media) return;
		const textTracks = media.textTracks;
		if (textTracks) for (let i = 0; i < textTracks.length; i++) clearCurrentCues(textTracks[i]);
	}
	onSubtitleTracksUpdated(event, data) {
		const tracks = data.subtitleTracks || [];
		const hasIMSC1 = tracks.some((track) => track.textCodec === IMSC1_CODEC);
		if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
			if (subtitleOptionsIdentical(this.tracks, tracks)) {
				this.tracks = tracks;
				return;
			}
			this.textTracks = [];
			this.tracks = tracks;
			if (this.config.renderTextTracksNatively) {
				const media = this.media;
				const inUseTracks = media ? filterSubtitleTracks(media.textTracks) : null;
				this.tracks.forEach((track, index) => {
					let textTrack;
					if (inUseTracks) {
						let inUseTrack = null;
						for (let i = 0; i < inUseTracks.length; i++) if (inUseTracks[i] && canReuseVttTextTrack(inUseTracks[i], track)) {
							inUseTrack = inUseTracks[i];
							inUseTracks[i] = null;
							break;
						}
						if (inUseTrack) textTrack = inUseTrack;
					}
					if (textTrack) clearCurrentCues(textTrack);
					else {
						const textTrackKind = captionsOrSubtitlesFromCharacteristics(track);
						textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
						if (textTrack) textTrack.mode = "disabled";
					}
					if (textTrack) this.textTracks.push(textTrack);
				});
				if (inUseTracks != null && inUseTracks.length) {
					const unusedTextTracks = inUseTracks.filter((t) => t !== null).map((t) => t.label);
					if (unusedTextTracks.length) this.hls.logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
				}
			} else if (this.tracks.length) {
				const tracksList = this.tracks.map((track) => {
					return {
						label: track.name,
						kind: track.type.toLowerCase(),
						default: track.default,
						subtitleTrack: track
					};
				});
				this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, { tracks: tracksList });
			}
		}
	}
	onManifestLoaded(event, data) {
		if (this.config.enableCEA708Captions && data.captions) data.captions.forEach((captionsTrack) => {
			const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
			if (!instreamIdMatch) return;
			const trackName = `textTrack${instreamIdMatch[1]}`;
			const trackProperties = this.captionsProperties[trackName];
			if (!trackProperties) return;
			trackProperties.label = captionsTrack.name;
			if (captionsTrack.lang) trackProperties.languageCode = captionsTrack.lang;
			trackProperties.media = captionsTrack;
		});
	}
	closedCaptionsForLevel(frag) {
		const level = this.hls.levels[frag.level];
		return level == null ? void 0 : level.attrs["CLOSED-CAPTIONS"];
	}
	onFragLoading(event, data) {
		if (this.enabled && data.frag.type === PlaylistLevelType.MAIN) {
			var _data$part$index, _data$part;
			const { cea608Parser1, cea608Parser2, lastSn } = this;
			const { cc, sn } = data.frag;
			const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
			if (cea608Parser1 && cea608Parser2) {
				if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
					cea608Parser1.reset();
					cea608Parser2.reset();
				}
			}
			this.lastCc = cc;
			this.lastSn = sn;
			this.lastPartIndex = partIndex;
		}
	}
	onFragLoaded(event, data) {
		const { frag, payload } = data;
		if (frag.type === PlaylistLevelType.SUBTITLE) if (payload.byteLength) {
			const decryptData = frag.decryptdata;
			const decrypted = "stats" in data;
			if (decryptData == null || !decryptData.encrypted || decrypted) {
				const trackPlaylistMedia = this.tracks[frag.level];
				const vttCCs = this.vttCCs;
				if (!vttCCs[frag.cc]) {
					vttCCs[frag.cc] = {
						start: frag.start,
						prevCC: this.prevCC,
						new: true
					};
					this.prevCC = frag.cc;
				}
				if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) this._parseIMSC1(frag, payload);
				else this._parseVTTs(data);
			}
		} else this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
			success: false,
			frag,
			error: /* @__PURE__ */ new Error("Empty subtitle payload")
		});
	}
	_parseIMSC1(frag, payload) {
		const hls = this.hls;
		parseIMSC1(payload, this.initPTS[frag.cc], (cues) => {
			this._appendCues(cues, frag.level);
			hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
				success: true,
				frag
			});
		}, (error) => {
			hls.logger.log(`Failed to parse IMSC1: ${error}`);
			hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
				success: false,
				frag,
				error
			});
		});
	}
	_parseVTTs(data) {
		var _frag$initSegment;
		const { frag, payload } = data;
		const { initPTS, unparsedVttFrags } = this;
		const maxAvCC = initPTS.length - 1;
		if (!initPTS[frag.cc] && maxAvCC === -1) {
			unparsedVttFrags.push(data);
			return;
		}
		const hls = this.hls;
		parseWebVTT((_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)).buffer : payload, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, (cues) => {
			this._appendCues(cues, frag.level);
			hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
				success: true,
				frag
			});
		}, (error) => {
			const missingInitPTS = error.message === "Missing initPTS for VTT MPEGTS";
			if (missingInitPTS) unparsedVttFrags.push(data);
			else this._fallbackToIMSC1(frag, payload);
			hls.logger.log(`Failed to parse VTT cue: ${error}`);
			if (missingInitPTS && maxAvCC > frag.cc) return;
			hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
				success: false,
				frag,
				error
			});
		});
	}
	_fallbackToIMSC1(frag, payload) {
		const trackPlaylistMedia = this.tracks[frag.level];
		if (!trackPlaylistMedia.textCodec) parseIMSC1(payload, this.initPTS[frag.cc], () => {
			trackPlaylistMedia.textCodec = IMSC1_CODEC;
			this._parseIMSC1(frag, payload);
		}, () => {
			trackPlaylistMedia.textCodec = "wvtt";
		});
	}
	_appendCues(cues, fragLevel) {
		const hls = this.hls;
		if (this.config.renderTextTracksNatively) {
			const textTrack = this.textTracks[fragLevel];
			if (!textTrack || textTrack.mode === "disabled") return;
			cues.forEach((cue) => addCueToTrack(textTrack, cue));
		} else {
			const currentTrack = this.tracks[fragLevel];
			if (!currentTrack) return;
			const track = currentTrack.default ? "default" : "subtitles" + fragLevel;
			hls.trigger(Events.CUES_PARSED, {
				type: "subtitles",
				cues,
				track
			});
		}
	}
	onFragDecrypted(event, data) {
		const { frag } = data;
		if (frag.type === PlaylistLevelType.SUBTITLE) this.onFragLoaded(Events.FRAG_LOADED, data);
	}
	onSubtitleTracksCleared() {
		this.tracks = [];
		this.captionsTracks = {};
	}
	onFragParsingUserdata(event, data) {
		if (!this.enabled || !this.config.enableCEA708Captions) return;
		const { frag, samples } = data;
		if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === "NONE") return;
		for (let i = 0; i < samples.length; i++) {
			const ccBytes = samples[i].bytes;
			if (ccBytes) {
				if (!this.cea608Parser1) this.initCea608Parsers();
				const ccdatas = this.extractCea608Data(ccBytes);
				this.cea608Parser1.addData(samples[i].pts, ccdatas[0]);
				this.cea608Parser2.addData(samples[i].pts, ccdatas[1]);
			}
		}
	}
	onBufferFlushing(event, { startOffset, endOffset, endOffsetSubtitles, type }) {
		const { media } = this;
		if (!media || media.currentTime < endOffset) return;
		if (!type || type === "video") {
			const { captionsTracks } = this;
			Object.keys(captionsTracks).forEach((trackName) => removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
		}
		if (this.config.renderTextTracksNatively) {
			if (startOffset === 0 && endOffsetSubtitles !== void 0) {
				const { textTracks } = this;
				Object.keys(textTracks).forEach((trackName) => removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
			}
		}
	}
	extractCea608Data(byteArray) {
		const actualCCBytes = [[], []];
		const count = byteArray[0] & 31;
		let position = 2;
		for (let j = 0; j < count; j++) {
			const tmpByte = byteArray[position++];
			const ccbyte1 = 127 & byteArray[position++];
			const ccbyte2 = 127 & byteArray[position++];
			if (ccbyte1 === 0 && ccbyte2 === 0) continue;
			if ((4 & tmpByte) !== 0) {
				const ccType = 3 & tmpByte;
				if (0 === ccType || 1 === ccType) {
					actualCCBytes[ccType].push(ccbyte1);
					actualCCBytes[ccType].push(ccbyte2);
				}
			}
		}
		return actualCCBytes;
	}
};
function captionsOrSubtitlesFromCharacteristics(track) {
	if (track.characteristics) {
		if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) return "captions";
	}
	return "subtitles";
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
	return !!inUseTrack && inUseTrack.kind === captionsOrSubtitlesFromCharacteristics(manifestTrack) && subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function intersection(x1, x2, y1, y2) {
	return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
	return {
		ccOffset: 0,
		presentationOffset: 0,
		0: {
			start: 0,
			prevCC: -1,
			new: true
		}
	};
}
var WHITESPACE_CHAR = /\s/;
var Cues = { newCue(track, startTime, endTime, captionScreen) {
	const result = [];
	let row;
	let cue;
	let indenting;
	let indent;
	let text;
	const Cue = self.VTTCue || self.TextTrackCue;
	for (let r = 0; r < captionScreen.rows.length; r++) {
		row = captionScreen.rows[r];
		indenting = true;
		indent = 0;
		text = "";
		if (!row.isEmpty()) {
			var _track$cues;
			for (let c = 0; c < row.chars.length; c++) if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) indent++;
			else {
				text += row.chars[c].uchar;
				indenting = false;
			}
			row.cueStartTime = startTime;
			if (startTime === endTime) endTime += 1e-4;
			if (indent >= 16) indent--;
			else indent++;
			const cueText = fixLineBreaks(text.trim());
			const id = generateCueId(startTime, endTime, cueText);
			if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
				cue = new Cue(startTime, endTime, cueText);
				cue.id = id;
				cue.line = r + 1;
				cue.align = "left";
				cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
				result.push(cue);
			}
		}
	}
	if (track && result.length) {
		result.sort((cueA, cueB) => {
			if (cueA.line === "auto" || cueB.line === "auto") return 0;
			if (cueA.line > 8 && cueB.line > 8) return cueB.line - cueA.line;
			return cueA.line - cueB.line;
		});
		result.forEach((cue) => addCueToTrack(track, cue));
	}
	return result;
} };
function fetchSupported() {
	if (self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
		new self.ReadableStream({});
		return true;
	} catch (e) {}
	return false;
}
var BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
var FetchLoader = class {
	constructor(config) {
		this.fetchSetup = void 0;
		this.requestTimeout = void 0;
		this.request = null;
		this.response = null;
		this.controller = void 0;
		this.context = null;
		this.config = null;
		this.callbacks = null;
		this.stats = void 0;
		this.loader = null;
		this.fetchSetup = config.fetchSetup || getRequest;
		this.controller = new self.AbortController();
		this.stats = new LoadStats();
	}
	destroy() {
		this.loader = this.callbacks = this.context = this.config = this.request = null;
		this.abortInternal();
		this.response = null;
		this.fetchSetup = this.controller = this.stats = null;
	}
	abortInternal() {
		if (this.controller && !this.stats.loading.end) {
			this.stats.aborted = true;
			this.controller.abort();
		}
	}
	abort() {
		var _this$callbacks;
		this.abortInternal();
		if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.response);
	}
	load(context, config, callbacks) {
		const stats = this.stats;
		if (stats.loading.start) throw new Error("Loader can only be used once.");
		stats.loading.start = self.performance.now();
		const initParams = getRequestParameters(context, this.controller.signal);
		const isArrayBuffer = context.responseType === "arraybuffer";
		const LENGTH = isArrayBuffer ? "byteLength" : "length";
		const { maxTimeToFirstByteMs, maxLoadTimeMs } = config.loadPolicy;
		this.context = context;
		this.config = config;
		this.callbacks = callbacks;
		this.request = this.fetchSetup(context, initParams);
		self.clearTimeout(this.requestTimeout);
		config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
		this.requestTimeout = self.setTimeout(() => {
			if (this.callbacks) {
				this.abortInternal();
				this.callbacks.onTimeout(stats, context, this.response);
			}
		}, config.timeout);
		(isPromise(this.request) ? this.request.then(self.fetch) : self.fetch(this.request)).then((response) => {
			var _this$callbacks2;
			this.response = this.loader = response;
			const first = Math.max(self.performance.now(), stats.loading.start);
			self.clearTimeout(this.requestTimeout);
			config.timeout = maxLoadTimeMs;
			this.requestTimeout = self.setTimeout(() => {
				if (this.callbacks) {
					this.abortInternal();
					this.callbacks.onTimeout(stats, context, this.response);
				}
			}, maxLoadTimeMs - (first - stats.loading.start));
			if (!response.ok) {
				const { status, statusText } = response;
				throw new FetchError(statusText || "fetch, bad network response", status, response);
			}
			stats.loading.first = first;
			stats.total = getContentLength(response.headers) || stats.total;
			const onProgress = (_this$callbacks2 = this.callbacks) == null ? void 0 : _this$callbacks2.onProgress;
			if (onProgress && isFiniteNumber(config.highWaterMark)) return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
			if (isArrayBuffer) return response.arrayBuffer();
			if (context.responseType === "json") return response.json();
			return response.text();
		}).then((responseData) => {
			var _this$callbacks3, _this$callbacks4;
			const response = this.response;
			if (!response) throw new Error("loader destroyed");
			self.clearTimeout(this.requestTimeout);
			stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
			const total = responseData[LENGTH];
			if (total) stats.loaded = stats.total = total;
			const loaderResponse = {
				url: response.url,
				data: responseData,
				code: response.status
			};
			const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
			if (onProgress && !isFiniteNumber(config.highWaterMark)) onProgress(stats, context, responseData, response);
			(_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(loaderResponse, stats, context, response);
		}).catch((error) => {
			var _this$callbacks5;
			self.clearTimeout(this.requestTimeout);
			if (stats.aborted) return;
			const code = !error ? 0 : error.code || 0;
			const text = !error ? null : error.message;
			(_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
				code,
				text
			}, context, error ? error.details : null, stats);
		});
	}
	getCacheAge() {
		let result = null;
		if (this.response) {
			const ageHeader = this.response.headers.get("age");
			result = ageHeader ? parseFloat(ageHeader) : null;
		}
		return result;
	}
	getResponseHeader(name) {
		return this.response ? this.response.headers.get(name) : null;
	}
	loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
		const chunkCache = new ChunkCache();
		const reader = response.body.getReader();
		const pump = () => {
			return reader.read().then((data) => {
				if (data.done) {
					if (chunkCache.dataLength) onProgress(stats, context, chunkCache.flush().buffer, response);
					return Promise.resolve(/* @__PURE__ */ new ArrayBuffer(0));
				}
				const chunk = data.value;
				const len = chunk.length;
				stats.loaded += len;
				if (len < highWaterMark || chunkCache.dataLength) {
					chunkCache.push(chunk);
					if (chunkCache.dataLength >= highWaterMark) onProgress(stats, context, chunkCache.flush().buffer, response);
				} else onProgress(stats, context, chunk.buffer, response);
				return pump();
			}).catch(() => {
				return Promise.reject();
			});
		};
		return pump();
	}
};
function getRequestParameters(context, signal) {
	const initParams = {
		method: "GET",
		mode: "cors",
		credentials: "same-origin",
		signal,
		headers: new self.Headers(_extends({}, context.headers))
	};
	if (context.rangeEnd) initParams.headers.set("Range", "bytes=" + context.rangeStart + "-" + String(context.rangeEnd - 1));
	return initParams;
}
function getByteRangeLength(byteRangeHeader) {
	const result = BYTERANGE.exec(byteRangeHeader);
	if (result) return parseInt(result[2]) - parseInt(result[1]) + 1;
}
function getContentLength(headers) {
	const contentRange = headers.get("Content-Range");
	if (contentRange) {
		const byteRangeLength = getByteRangeLength(contentRange);
		if (isFiniteNumber(byteRangeLength)) return byteRangeLength;
	}
	const contentLength = headers.get("Content-Length");
	if (contentLength) return parseInt(contentLength);
}
function getRequest(context, initParams) {
	return new self.Request(context.url, initParams);
}
var FetchError = class extends Error {
	constructor(message, code, details) {
		super(message);
		this.code = void 0;
		this.details = void 0;
		this.code = code;
		this.details = details;
	}
};
var AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
var XhrLoader = class {
	constructor(config) {
		this.xhrSetup = void 0;
		this.requestTimeout = void 0;
		this.retryTimeout = void 0;
		this.retryDelay = void 0;
		this.config = null;
		this.callbacks = null;
		this.context = null;
		this.loader = null;
		this.stats = void 0;
		this.xhrSetup = config ? config.xhrSetup || null : null;
		this.stats = new LoadStats();
		this.retryDelay = 0;
	}
	destroy() {
		this.callbacks = null;
		this.abortInternal();
		this.loader = null;
		this.config = null;
		this.context = null;
		this.xhrSetup = null;
	}
	abortInternal() {
		const loader = this.loader;
		self.clearTimeout(this.requestTimeout);
		self.clearTimeout(this.retryTimeout);
		if (loader) {
			loader.onreadystatechange = null;
			loader.onprogress = null;
			if (loader.readyState !== 4) {
				this.stats.aborted = true;
				loader.abort();
			}
		}
	}
	abort() {
		var _this$callbacks;
		this.abortInternal();
		if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.loader);
	}
	load(context, config, callbacks) {
		if (this.stats.loading.start) throw new Error("Loader can only be used once.");
		this.stats.loading.start = self.performance.now();
		this.context = context;
		this.config = config;
		this.callbacks = callbacks;
		this.loadInternal();
	}
	loadInternal() {
		const { config, context } = this;
		if (!config || !context) return;
		const xhr = this.loader = new self.XMLHttpRequest();
		const stats = this.stats;
		stats.loading.first = 0;
		stats.loaded = 0;
		stats.aborted = false;
		const xhrSetup = this.xhrSetup;
		if (xhrSetup) Promise.resolve().then(() => {
			if (this.loader !== xhr || this.stats.aborted) return;
			return xhrSetup(xhr, context.url);
		}).catch((error) => {
			if (this.loader !== xhr || this.stats.aborted) return;
			xhr.open("GET", context.url, true);
			return xhrSetup(xhr, context.url);
		}).then(() => {
			if (this.loader !== xhr || this.stats.aborted) return;
			this.openAndSendXhr(xhr, context, config);
		}).catch((error) => {
			var _this$callbacks2;
			(_this$callbacks2 = this.callbacks) == null || _this$callbacks2.onError({
				code: xhr.status,
				text: error.message
			}, context, xhr, stats);
		});
		else this.openAndSendXhr(xhr, context, config);
	}
	openAndSendXhr(xhr, context, config) {
		if (!xhr.readyState) xhr.open("GET", context.url, true);
		const headers = context.headers;
		const { maxTimeToFirstByteMs, maxLoadTimeMs } = config.loadPolicy;
		if (headers) for (const header in headers) xhr.setRequestHeader(header, headers[header]);
		if (context.rangeEnd) xhr.setRequestHeader("Range", "bytes=" + context.rangeStart + "-" + (context.rangeEnd - 1));
		xhr.onreadystatechange = this.readystatechange.bind(this);
		xhr.onprogress = this.loadprogress.bind(this);
		xhr.responseType = context.responseType;
		self.clearTimeout(this.requestTimeout);
		config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
		this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
		xhr.send();
	}
	readystatechange() {
		const { context, loader: xhr, stats } = this;
		if (!context || !xhr) return;
		const readyState = xhr.readyState;
		const config = this.config;
		if (stats.aborted) return;
		if (readyState >= 2) {
			if (stats.loading.first === 0) {
				stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
				if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
					self.clearTimeout(this.requestTimeout);
					config.timeout = config.loadPolicy.maxLoadTimeMs;
					this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
				}
			}
			if (readyState === 4) {
				self.clearTimeout(this.requestTimeout);
				xhr.onreadystatechange = null;
				xhr.onprogress = null;
				const status = xhr.status;
				const useResponseText = xhr.responseType === "text" ? xhr.responseText : null;
				if (status >= 200 && status < 300) {
					const data = useResponseText != null ? useResponseText : xhr.response;
					if (data != null) {
						var _this$callbacks3, _this$callbacks4;
						stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
						stats.loaded = stats.total = xhr.responseType === "arraybuffer" ? data.byteLength : data.length;
						stats.bwEstimate = stats.total * 8e3 / (stats.loading.end - stats.loading.first);
						const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
						if (onProgress) onProgress(stats, context, data, xhr);
						const _response = {
							url: xhr.responseURL,
							data,
							code: status
						};
						(_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(_response, stats, context, xhr);
						return;
					}
				}
				const retryConfig = config.loadPolicy.errorRetry;
				const retryCount = stats.retry;
				if (shouldRetry(retryConfig, retryCount, false, {
					url: context.url,
					data: void 0,
					code: status
				})) this.retry(retryConfig);
				else {
					var _this$callbacks5;
					logger.error(`${status} while loading ${context.url}`);
					(_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
						code: status,
						text: xhr.statusText
					}, context, xhr, stats);
				}
			}
		}
	}
	loadtimeout() {
		if (!this.config) return;
		const retryConfig = this.config.loadPolicy.timeoutRetry;
		const retryCount = this.stats.retry;
		if (shouldRetry(retryConfig, retryCount, true)) this.retry(retryConfig);
		else {
			var _this$context;
			logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
			const callbacks = this.callbacks;
			if (callbacks) {
				this.abortInternal();
				callbacks.onTimeout(this.stats, this.context, this.loader);
			}
		}
	}
	retry(retryConfig) {
		const { context, stats } = this;
		this.retryDelay = getRetryDelay(retryConfig, stats.retry);
		stats.retry++;
		logger.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
		this.abortInternal();
		this.loader = null;
		self.clearTimeout(this.retryTimeout);
		this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
	}
	loadprogress(event) {
		const stats = this.stats;
		stats.loaded = event.loaded;
		if (event.lengthComputable) stats.total = event.total;
	}
	getCacheAge() {
		let result = null;
		if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
			const ageHeader = this.loader.getResponseHeader("age");
			result = ageHeader ? parseFloat(ageHeader) : null;
		}
		return result;
	}
	getResponseHeader(name) {
		if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders())) return this.loader.getResponseHeader(name);
		return null;
	}
};
/**
* @ignore
* If possible, keep hlsDefaultConfig shallow
* It is cloned whenever a new Hls instance is created, by keeping the config
* shallow the properties are cloned, and we don't end up manipulating the default
*/
var hlsDefaultConfig = _objectSpread2(_objectSpread2({
	autoStartLoad: true,
	startPosition: -1,
	defaultAudioCodec: void 0,
	debug: false,
	capLevelOnFPSDrop: false,
	capLevelToPlayerSize: false,
	ignoreDevicePixelRatio: false,
	maxDevicePixelRatio: Number.POSITIVE_INFINITY,
	preferManagedMediaSource: true,
	initialLiveManifestSize: 1,
	maxBufferLength: 30,
	backBufferLength: Infinity,
	frontBufferFlushThreshold: Infinity,
	startOnSegmentBoundary: false,
	maxBufferSize: 60 * 1e3 * 1e3,
	maxFragLookUpTolerance: .25,
	maxBufferHole: .1,
	detectStallWithCurrentTimeMs: 1250,
	highBufferWatchdogPeriod: 2,
	nudgeOffset: .1,
	nudgeMaxRetry: 3,
	nudgeOnVideoHole: true,
	liveSyncMode: "edge",
	liveSyncDurationCount: 3,
	liveSyncOnStallIncrease: 1,
	liveMaxLatencyDurationCount: Infinity,
	liveSyncDuration: void 0,
	liveMaxLatencyDuration: void 0,
	maxLiveSyncPlaybackRate: 1,
	liveDurationInfinity: false,
	/**
	* @deprecated use backBufferLength
	*/
	liveBackBufferLength: null,
	maxMaxBufferLength: 600,
	enableWorker: true,
	workerPath: null,
	enableSoftwareAES: true,
	startLevel: void 0,
	startFragPrefetch: false,
	fpsDroppedMonitoringPeriod: 5e3,
	fpsDroppedMonitoringThreshold: .2,
	appendErrorMaxRetry: 3,
	ignorePlaylistParsingErrors: false,
	loader: XhrLoader,
	fLoader: void 0,
	pLoader: void 0,
	xhrSetup: void 0,
	licenseXhrSetup: void 0,
	licenseResponseCallback: void 0,
	abrController: AbrController,
	bufferController: BufferController,
	capLevelController: CapLevelController,
	errorController: ErrorController,
	fpsController: FPSController,
	stretchShortVideoTrack: false,
	maxAudioFramesDrift: 1,
	forceKeyFrameOnDiscontinuity: true,
	abrEwmaFastLive: 3,
	abrEwmaSlowLive: 9,
	abrEwmaFastVoD: 3,
	abrEwmaSlowVoD: 9,
	abrEwmaDefaultEstimate: 5e5,
	abrEwmaDefaultEstimateMax: 5e6,
	abrBandWidthFactor: .95,
	abrBandWidthUpFactor: .7,
	abrMaxWithRealBitrate: false,
	maxStarvationDelay: 4,
	maxLoadingDelay: 4,
	minAutoBitrate: 0,
	emeEnabled: false,
	widevineLicenseUrl: void 0,
	drmSystems: {},
	drmSystemOptions: {},
	requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess,
	requireKeySystemAccessOnStart: false,
	testBandwidth: true,
	progressive: false,
	lowLatencyMode: true,
	cmcd: void 0,
	enableDateRangeMetadataCues: true,
	enableEmsgMetadataCues: true,
	enableEmsgKLVMetadata: false,
	enableID3MetadataCues: true,
	enableInterstitialPlayback: true,
	interstitialAppendInPlace: true,
	interstitialLiveLookAhead: 10,
	useMediaCapabilities: true,
	preserveManualLevelOnError: false,
	certLoadPolicy: { default: {
		maxTimeToFirstByteMs: 8e3,
		maxLoadTimeMs: 2e4,
		timeoutRetry: null,
		errorRetry: null
	} },
	keyLoadPolicy: { default: {
		maxTimeToFirstByteMs: 8e3,
		maxLoadTimeMs: 2e4,
		timeoutRetry: {
			maxNumRetry: 1,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 2e4,
			backoff: "linear"
		},
		errorRetry: {
			maxNumRetry: 8,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 2e4,
			backoff: "linear"
		}
	} },
	manifestLoadPolicy: { default: {
		maxTimeToFirstByteMs: Infinity,
		maxLoadTimeMs: 2e4,
		timeoutRetry: {
			maxNumRetry: 2,
			retryDelayMs: 0,
			maxRetryDelayMs: 0
		},
		errorRetry: {
			maxNumRetry: 1,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 8e3
		}
	} },
	playlistLoadPolicy: { default: {
		maxTimeToFirstByteMs: 1e4,
		maxLoadTimeMs: 2e4,
		timeoutRetry: {
			maxNumRetry: 2,
			retryDelayMs: 0,
			maxRetryDelayMs: 0
		},
		errorRetry: {
			maxNumRetry: 2,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 8e3
		}
	} },
	fragLoadPolicy: { default: {
		maxTimeToFirstByteMs: 1e4,
		maxLoadTimeMs: 12e4,
		timeoutRetry: {
			maxNumRetry: 4,
			retryDelayMs: 0,
			maxRetryDelayMs: 0
		},
		errorRetry: {
			maxNumRetry: 6,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 8e3
		}
	} },
	steeringManifestLoadPolicy: { default: {
		maxTimeToFirstByteMs: 1e4,
		maxLoadTimeMs: 2e4,
		timeoutRetry: {
			maxNumRetry: 2,
			retryDelayMs: 0,
			maxRetryDelayMs: 0
		},
		errorRetry: {
			maxNumRetry: 1,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 8e3
		}
	} },
	interstitialAssetListLoadPolicy: { default: {
		maxTimeToFirstByteMs: 1e4,
		maxLoadTimeMs: 3e4,
		timeoutRetry: {
			maxNumRetry: 0,
			retryDelayMs: 0,
			maxRetryDelayMs: 0
		},
		errorRetry: {
			maxNumRetry: 0,
			retryDelayMs: 1e3,
			maxRetryDelayMs: 8e3
		}
	} },
	manifestLoadingTimeOut: 1e4,
	manifestLoadingMaxRetry: 1,
	manifestLoadingRetryDelay: 1e3,
	manifestLoadingMaxRetryTimeout: 64e3,
	levelLoadingTimeOut: 1e4,
	levelLoadingMaxRetry: 4,
	levelLoadingRetryDelay: 1e3,
	levelLoadingMaxRetryTimeout: 64e3,
	fragLoadingTimeOut: 2e4,
	fragLoadingMaxRetry: 6,
	fragLoadingRetryDelay: 1e3,
	fragLoadingMaxRetryTimeout: 64e3
}, timelineConfig()), {}, {
	subtitleStreamController: SubtitleStreamController,
	subtitleTrackController: SubtitleTrackController,
	timelineController: TimelineController,
	audioStreamController: AudioStreamController,
	audioTrackController: AudioTrackController,
	emeController: EMEController,
	cmcdController: CMCDController,
	contentSteeringController: ContentSteeringController,
	interstitialsController: InterstitialsController
});
function timelineConfig() {
	return {
		cueHandler: Cues,
		enableWebVTT: true,
		enableIMSC1: true,
		enableCEA708Captions: true,
		captionsTextTrack1Label: "English",
		captionsTextTrack1LanguageCode: "en",
		captionsTextTrack2Label: "Spanish",
		captionsTextTrack2LanguageCode: "es",
		captionsTextTrack3Label: "Unknown CC",
		captionsTextTrack3LanguageCode: "",
		captionsTextTrack4Label: "Unknown CC",
		captionsTextTrack4LanguageCode: "",
		renderTextTracksNatively: true
	};
}
/**
* @ignore
*/
function mergeConfig(defaultConfig, userConfig, logger) {
	if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
	if (userConfig.liveMaxLatencyDurationCount !== void 0 && (userConfig.liveSyncDurationCount === void 0 || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) throw new Error("Illegal hls.js config: \"liveMaxLatencyDurationCount\" must be greater than \"liveSyncDurationCount\"");
	if (userConfig.liveMaxLatencyDuration !== void 0 && (userConfig.liveSyncDuration === void 0 || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) throw new Error("Illegal hls.js config: \"liveMaxLatencyDuration\" must be greater than \"liveSyncDuration\"");
	const defaultsCopy = deepCpy(defaultConfig);
	const deprecatedSettingTypes = [
		"manifest",
		"level",
		"frag"
	];
	const deprecatedSettings = [
		"TimeOut",
		"MaxRetry",
		"RetryDelay",
		"MaxRetryTimeout"
	];
	deprecatedSettingTypes.forEach((type) => {
		const policyName = `${type === "level" ? "playlist" : type}LoadPolicy`;
		const policyNotSet = userConfig[policyName] === void 0;
		const report = [];
		deprecatedSettings.forEach((setting) => {
			const deprecatedSetting = `${type}Loading${setting}`;
			const value = userConfig[deprecatedSetting];
			if (value !== void 0 && policyNotSet) {
				report.push(deprecatedSetting);
				const settings = defaultsCopy[policyName].default;
				userConfig[policyName] = { default: settings };
				switch (setting) {
					case "TimeOut":
						settings.maxLoadTimeMs = value;
						settings.maxTimeToFirstByteMs = value;
						break;
					case "MaxRetry":
						settings.errorRetry.maxNumRetry = value;
						settings.timeoutRetry.maxNumRetry = value;
						break;
					case "RetryDelay":
						settings.errorRetry.retryDelayMs = value;
						settings.timeoutRetry.retryDelayMs = value;
						break;
					case "MaxRetryTimeout":
						settings.errorRetry.maxRetryDelayMs = value;
						settings.timeoutRetry.maxRetryDelayMs = value;
						break;
				}
			}
		});
		if (report.length) logger.warn(`hls.js config: "${report.join("\", \"")}" setting(s) are deprecated, use "${policyName}": ${stringify(userConfig[policyName])}`);
	});
	return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
	if (obj && typeof obj === "object") {
		if (Array.isArray(obj)) return obj.map(deepCpy);
		return Object.keys(obj).reduce((result, key) => {
			result[key] = deepCpy(obj[key]);
			return result;
		}, {});
	}
	return obj;
}
/**
* @ignore
*/
function enableStreamingMode(config, logger) {
	const currentLoader = config.loader;
	if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
		logger.log("[config]: Custom loader detected, cannot enable progressive streaming");
		config.progressive = false;
	} else if (fetchSupported()) {
		config.loader = FetchLoader;
		config.progressive = true;
		config.enableSoftwareAES = true;
		logger.log("[config]: Progressive streaming enabled, using FetchLoader");
	}
}
var MAX_START_GAP_JUMP = 2;
var SKIP_BUFFER_HOLE_STEP_SECONDS = .1;
var SKIP_BUFFER_RANGE_START = .05;
var TICK_INTERVAL$1 = 100;
var GapController = class extends TaskLoop {
	constructor(hls, fragmentTracker) {
		super("gap-controller", hls.logger);
		this.hls = void 0;
		this.fragmentTracker = void 0;
		this.media = null;
		this.mediaSource = void 0;
		this.nudgeRetry = 0;
		this.stallReported = false;
		this.stalled = null;
		this.moved = false;
		this.seeking = false;
		this.buffered = {};
		this.lastCurrentTime = 0;
		this.ended = 0;
		this.waiting = 0;
		this.onMediaPlaying = () => {
			this.ended = 0;
			this.waiting = 0;
		};
		this.onMediaWaiting = () => {
			var _this$media;
			if ((_this$media = this.media) != null && _this$media.seeking) return;
			this.waiting = self.performance.now();
			this.tick();
		};
		this.onMediaEnded = () => {
			if (this.hls) {
				var _this$media2;
				this.ended = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || 1;
				this.hls.trigger(Events.MEDIA_ENDED, { stalled: false });
			}
		};
		this.hls = hls;
		this.fragmentTracker = fragmentTracker;
		this.registerListeners();
	}
	registerListeners() {
		const { hls } = this;
		if (hls) {
			hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
		}
	}
	unregisterListeners() {
		const { hls } = this;
		if (hls) {
			hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
		}
	}
	destroy() {
		super.destroy();
		this.unregisterListeners();
		this.media = this.hls = this.fragmentTracker = null;
		this.mediaSource = void 0;
	}
	onMediaAttached(event, data) {
		this.setInterval(TICK_INTERVAL$1);
		this.mediaSource = data.mediaSource;
		const media = this.media = data.media;
		addEventListener(media, "playing", this.onMediaPlaying);
		addEventListener(media, "waiting", this.onMediaWaiting);
		addEventListener(media, "ended", this.onMediaEnded);
	}
	onMediaDetaching(event, data) {
		this.clearInterval();
		const { media } = this;
		if (media) {
			removeEventListener(media, "playing", this.onMediaPlaying);
			removeEventListener(media, "waiting", this.onMediaWaiting);
			removeEventListener(media, "ended", this.onMediaEnded);
			this.media = null;
		}
		this.mediaSource = void 0;
	}
	onBufferAppended(event, data) {
		this.buffered = data.timeRanges;
	}
	get hasBuffered() {
		return Object.keys(this.buffered).length > 0;
	}
	tick() {
		var _this$media3;
		if (!((_this$media3 = this.media) != null && _this$media3.readyState) || !this.hasBuffered) return;
		const currentTime = this.media.currentTime;
		this.poll(currentTime, this.lastCurrentTime);
		this.lastCurrentTime = currentTime;
	}
	/**
	* Checks if the playhead is stuck within a gap, and if so, attempts to free it.
	* A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
	*
	* @param lastCurrentTime - Previously read playhead position
	*/
	poll(currentTime, lastCurrentTime) {
		var _this$hls, _this$hls2;
		const config = (_this$hls = this.hls) == null ? void 0 : _this$hls.config;
		if (!config) return;
		const media = this.media;
		if (!media) return;
		const { seeking } = media;
		const seeked = this.seeking && !seeking;
		const beginSeek = !this.seeking && seeking;
		const pausedEndedOrHalted = media.paused && !seeking || media.ended || media.playbackRate === 0;
		this.seeking = seeking;
		if (currentTime !== lastCurrentTime) {
			if (lastCurrentTime) this.ended = 0;
			this.moved = true;
			if (!seeking) {
				this.nudgeRetry = 0;
				if (config.nudgeOnVideoHole && !pausedEndedOrHalted && currentTime > lastCurrentTime) this.nudgeOnVideoHole(currentTime, lastCurrentTime);
			}
			if (this.waiting === 0) this.stallResolved(currentTime);
			return;
		}
		if (beginSeek || seeked) {
			if (seeked) this.stallResolved(currentTime);
			return;
		}
		if (pausedEndedOrHalted) {
			this.nudgeRetry = 0;
			this.stallResolved(currentTime);
			if (!this.ended && media.ended && this.hls) {
				this.ended = currentTime || 1;
				this.hls.trigger(Events.MEDIA_ENDED, { stalled: false });
			}
			return;
		}
		if (!BufferHelper.getBuffered(media).length) {
			this.nudgeRetry = 0;
			return;
		}
		const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
		const nextStart = bufferInfo.nextStart || 0;
		const fragmentTracker = this.fragmentTracker;
		if (seeking && fragmentTracker && this.hls) {
			const inFlightDependency = getInFlightDependency(this.hls.inFlightFragments, currentTime);
			const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
			const noBufferHole = !nextStart || inFlightDependency || nextStart - currentTime > MAX_START_GAP_JUMP && !fragmentTracker.getPartialFragment(currentTime);
			if (hasEnoughBuffer || noBufferHole) return;
			this.moved = false;
		}
		const levelDetails = (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.latestLevelDetails;
		if (!this.moved && this.stalled !== null && fragmentTracker) {
			if (!(bufferInfo.len > 0) && !nextStart) return;
			const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
			const maxStartGapJump = !!(levelDetails != null && levelDetails.live) ? levelDetails.targetduration * 2 : MAX_START_GAP_JUMP;
			const appended = appendedFragAtPosition(currentTime, fragmentTracker);
			if (startJump > 0 && (startJump <= maxStartGapJump || appended)) {
				if (!media.paused) this._trySkipBufferHole(appended);
				return;
			}
		}
		const detectStallWithCurrentTimeMs = config.detectStallWithCurrentTimeMs;
		const tnow = self.performance.now();
		const tWaiting = this.waiting;
		let stalled = this.stalled;
		if (stalled === null) if (tWaiting > 0 && tnow - tWaiting < detectStallWithCurrentTimeMs) stalled = this.stalled = tWaiting;
		else {
			this.stalled = tnow;
			return;
		}
		const stalledDuration = tnow - stalled;
		if (!seeking && (stalledDuration >= detectStallWithCurrentTimeMs || tWaiting) && this.hls) {
			var _this$mediaSource;
			if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) === "ended" && !(levelDetails != null && levelDetails.live) && Math.abs(currentTime - ((levelDetails == null ? void 0 : levelDetails.edge) || 0)) < 1) {
				if (this.ended) return;
				this.ended = currentTime || 1;
				this.hls.trigger(Events.MEDIA_ENDED, { stalled: true });
				return;
			}
			this._reportStall(bufferInfo);
			if (!this.media || !this.hls) return;
		}
		const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
		this._tryFixBufferStall(bufferedWithHoles, stalledDuration, currentTime);
	}
	stallResolved(currentTime) {
		const stalled = this.stalled;
		if (stalled && this.hls) {
			this.stalled = null;
			if (this.stallReported) {
				const stalledDuration = self.performance.now() - stalled;
				this.log(`playback not stuck anymore @${currentTime}, after ${Math.round(stalledDuration)}ms`);
				this.stallReported = false;
				this.waiting = 0;
				this.hls.trigger(Events.STALL_RESOLVED, {});
			}
		}
	}
	nudgeOnVideoHole(currentTime, lastCurrentTime) {
		var _this$buffered$audio;
		const videoSourceBuffered = this.buffered.video;
		if (this.hls && this.media && this.fragmentTracker && (_this$buffered$audio = this.buffered.audio) != null && _this$buffered$audio.length && videoSourceBuffered && videoSourceBuffered.length > 1 && currentTime > videoSourceBuffered.end(0)) {
			const audioBufferInfo = BufferHelper.bufferedInfo(BufferHelper.timeRangesToArray(this.buffered.audio), currentTime, 0);
			if (audioBufferInfo.len > 1 && lastCurrentTime >= audioBufferInfo.start) {
				const videoTimes = BufferHelper.timeRangesToArray(videoSourceBuffered);
				const lastBufferedIndex = BufferHelper.bufferedInfo(videoTimes, lastCurrentTime, 0).bufferedIndex;
				if (lastBufferedIndex > -1 && lastBufferedIndex < videoTimes.length - 1) {
					const bufferedIndex = BufferHelper.bufferedInfo(videoTimes, currentTime, 0).bufferedIndex;
					const holeStart = videoTimes[lastBufferedIndex].end;
					const holeEnd = videoTimes[lastBufferedIndex + 1].start;
					if ((bufferedIndex === -1 || bufferedIndex > lastBufferedIndex) && holeEnd - holeStart < 1 && currentTime - holeStart < 2) {
						const error = /* @__PURE__ */ new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${currentTime} hole: ${holeStart} -> ${holeEnd} buffered index: ${bufferedIndex}`);
						this.warn(error.message);
						this.media.currentTime += 1e-6;
						let frag = appendedFragAtPosition(currentTime, this.fragmentTracker);
						if (frag && "fragment" in frag) frag = frag.fragment;
						else if (!frag) frag = void 0;
						const bufferInfo = BufferHelper.bufferInfo(this.media, currentTime, 0);
						this.hls.trigger(Events.ERROR, {
							type: ErrorTypes.MEDIA_ERROR,
							details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
							fatal: false,
							error,
							reason: error.message,
							frag,
							buffer: bufferInfo.len,
							bufferInfo
						});
					}
				}
			}
		}
	}
	/**
	* Detects and attempts to fix known buffer stalling issues.
	* @param bufferInfo - The properties of the current buffer.
	* @param stalledDurationMs - The amount of time Hls.js has been stalling for.
	* @private
	*/
	_tryFixBufferStall(bufferInfo, stalledDurationMs, currentTime) {
		var _this$hls3, _this$hls4;
		const { fragmentTracker, media } = this;
		const config = (_this$hls3 = this.hls) == null ? void 0 : _this$hls3.config;
		if (!media || !fragmentTracker || !config) return;
		const levelDetails = (_this$hls4 = this.hls) == null ? void 0 : _this$hls4.latestLevelDetails;
		const appended = appendedFragAtPosition(currentTime, fragmentTracker);
		if (appended || levelDetails != null && levelDetails.live && currentTime < levelDetails.fragmentStart) {
			if (this._trySkipBufferHole(appended) || !this.media) return;
		}
		const bufferedRanges = bufferInfo.buffered;
		const adjacentTraversal = this.adjacentTraversal(bufferInfo, currentTime);
		if ((bufferedRanges && bufferedRanges.length > 1 && bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && (bufferInfo.nextStart - currentTime < config.maxBufferHole || adjacentTraversal)) && (stalledDurationMs > config.highBufferWatchdogPeriod * 1e3 || this.waiting)) {
			this.warn("Trying to nudge playhead over buffer-hole");
			this._tryNudgeBuffer(bufferInfo);
		}
	}
	adjacentTraversal(bufferInfo, currentTime) {
		const fragmentTracker = this.fragmentTracker;
		const nextStart = bufferInfo.nextStart;
		if (fragmentTracker && nextStart) {
			const current = fragmentTracker.getFragAtPos(currentTime, PlaylistLevelType.MAIN);
			const next = fragmentTracker.getFragAtPos(nextStart, PlaylistLevelType.MAIN);
			if (current && next) return next.sn - current.sn < 2;
		}
		return false;
	}
	/**
	* Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
	* @param bufferLen - The playhead distance from the end of the current buffer segment.
	* @private
	*/
	_reportStall(bufferInfo) {
		const { hls, media, stallReported, stalled } = this;
		if (!stallReported && stalled !== null && media && hls) {
			this.stallReported = true;
			const error = /* @__PURE__ */ new Error(`Playback stalling at @${media.currentTime} due to low buffer (${stringify(bufferInfo)})`);
			this.warn(error.message);
			hls.trigger(Events.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.BUFFER_STALLED_ERROR,
				fatal: false,
				error,
				buffer: bufferInfo.len,
				bufferInfo,
				stalled: { start: stalled }
			});
		}
	}
	/**
	* Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
	* @param appended - The fragment or part found at the current time (where playback is stalling).
	* @private
	*/
	_trySkipBufferHole(appended) {
		var _this$hls5;
		const { fragmentTracker, media } = this;
		const config = (_this$hls5 = this.hls) == null ? void 0 : _this$hls5.config;
		if (!media || !fragmentTracker || !config) return 0;
		const currentTime = media.currentTime;
		const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
		const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
		if (startTime && this.hls) {
			const bufferStarved = bufferInfo.len <= config.maxBufferHole;
			const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
			const gapLength = startTime - currentTime;
			if (gapLength > 0 && (bufferStarved || waiting)) {
				if (gapLength > config.maxBufferHole) {
					let startGap = false;
					if (currentTime === 0) {
						const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
						if (startFrag && startTime < startFrag.end) startGap = true;
					}
					if (!startGap && appended) {
						var _this$hls$loadLevelOb;
						if (!((_this$hls$loadLevelOb = this.hls.loadLevelObj) != null && _this$hls$loadLevelOb.details)) return 0;
						if (getInFlightDependency(this.hls.inFlightFragments, startTime)) return 0;
						let moreToLoad = false;
						let pos = appended.end;
						while (pos < startTime) {
							const provisioned = appendedFragAtPosition(pos, fragmentTracker);
							if (provisioned) pos += provisioned.duration;
							else {
								moreToLoad = true;
								break;
							}
						}
						if (moreToLoad) return 0;
					}
				}
				const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
				this.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
				this.moved = true;
				media.currentTime = targetTime;
				if (!(appended != null && appended.gap)) {
					const error = /* @__PURE__ */ new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
					const errorData = {
						type: ErrorTypes.MEDIA_ERROR,
						details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
						fatal: false,
						error,
						reason: error.message,
						buffer: bufferInfo.len,
						bufferInfo
					};
					if (appended) if ("fragment" in appended) errorData.part = appended;
					else errorData.frag = appended;
					this.hls.trigger(Events.ERROR, errorData);
				}
				return targetTime;
			}
		}
		return 0;
	}
	/**
	* Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
	* @private
	*/
	_tryNudgeBuffer(bufferInfo) {
		const { hls, media, nudgeRetry } = this;
		const config = hls == null ? void 0 : hls.config;
		if (!media || !config) return 0;
		const currentTime = media.currentTime;
		this.nudgeRetry++;
		if (nudgeRetry < config.nudgeMaxRetry) {
			const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
			const error = /* @__PURE__ */ new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
			this.warn(error.message);
			media.currentTime = targetTime;
			hls.trigger(Events.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
				error,
				fatal: false,
				buffer: bufferInfo.len,
				bufferInfo
			});
		} else {
			const error = /* @__PURE__ */ new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
			this.error(error.message);
			hls.trigger(Events.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.BUFFER_STALLED_ERROR,
				error,
				fatal: true,
				buffer: bufferInfo.len,
				bufferInfo
			});
		}
	}
};
function getInFlightDependency(inFlightFragments, currentTime) {
	const main = inFlight(inFlightFragments.main);
	if (main && main.start <= currentTime) return main;
	const audio = inFlight(inFlightFragments.audio);
	if (audio && audio.start <= currentTime) return audio;
	return null;
}
function inFlight(inFlightData) {
	if (!inFlightData) return null;
	switch (inFlightData.state) {
		case State.IDLE:
		case State.STOPPED:
		case State.ENDED:
		case State.ERROR: return null;
	}
	return inFlightData.frag;
}
function appendedFragAtPosition(pos, fragmentTracker) {
	return fragmentTracker.getAppendedFrag(pos, PlaylistLevelType.MAIN) || fragmentTracker.getPartialFragment(pos);
}
var MIN_CUE_DURATION = .25;
function getCueClass() {
	if (typeof self === "undefined") return void 0;
	return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(Cue, startTime, endTime, data, type) {
	let cue = new Cue(startTime, endTime, "");
	try {
		cue.value = data;
		if (type) cue.type = type;
	} catch (e) {
		cue = new Cue(startTime, endTime, stringify(type ? _objectSpread2({ type }, data) : data));
	}
	return cue;
}
var MAX_CUE_ENDTIME = (() => {
	const Cue = getCueClass();
	try {
		Cue && new Cue(0, Number.POSITIVE_INFINITY, "");
	} catch (e) {
		return Number.MAX_VALUE;
	}
	return Number.POSITIVE_INFINITY;
})();
var ID3TrackController = class {
	constructor(hls) {
		this.hls = void 0;
		this.id3Track = null;
		this.media = null;
		this.dateRangeCuesAppended = {};
		this.removeCues = true;
		this.assetCue = void 0;
		this.onEventCueEnter = () => {
			if (!this.hls) return;
			this.hls.trigger(Events.EVENT_CUE_ENTER, {});
		};
		this.hls = hls;
		this._registerListeners();
	}
	destroy() {
		this._unregisterListeners();
		this.id3Track = null;
		this.media = null;
		this.dateRangeCuesAppended = {};
		this.hls = this.onEventCueEnter = null;
	}
	_registerListeners() {
		const { hls } = this;
		if (hls) {
			hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
			hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
			hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
			hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
			hls.on(Events.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
		}
	}
	_unregisterListeners() {
		const { hls } = this;
		if (hls) {
			hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
			hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
			hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
			hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
			hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
			hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
			hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
			hls.off(Events.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
		}
	}
	onMediaAttaching(event, data) {
		var _data$overrides;
		this.media = data.media;
		if (((_data$overrides = data.overrides) == null ? void 0 : _data$overrides.cueRemoval) === false) this.removeCues = false;
	}
	onMediaAttached() {
		var _this$hls;
		const details = (_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails;
		if (details) this.updateDateRangeCues(details);
	}
	onMediaDetaching(event, data) {
		this.media = null;
		if (!!data.transferMedia) return;
		if (this.id3Track) {
			if (this.removeCues) clearCurrentCues(this.id3Track, this.onEventCueEnter);
			this.id3Track = null;
		}
		this.dateRangeCuesAppended = {};
	}
	onManifestLoading() {
		this.dateRangeCuesAppended = {};
	}
	createTrack(media) {
		const track = this.getID3Track(media.textTracks);
		track.mode = "hidden";
		return track;
	}
	getID3Track(textTracks) {
		if (!this.media) return;
		for (let i = 0; i < textTracks.length; i++) {
			const textTrack = textTracks[i];
			if (textTrack.kind === "metadata" && textTrack.label === "id3") {
				sendAddTrackEvent(textTrack, this.media);
				return textTrack;
			}
		}
		return this.media.addTextTrack("metadata", "id3");
	}
	onFragParsingMetadata(event, data) {
		if (!this.media || !this.hls) return;
		const { enableEmsgMetadataCues, enableID3MetadataCues } = this.hls.config;
		if (!enableEmsgMetadataCues && !enableID3MetadataCues) return;
		const { samples } = data;
		if (!this.id3Track) this.id3Track = this.createTrack(this.media);
		const Cue = getCueClass();
		if (!Cue) return;
		for (let i = 0; i < samples.length; i++) {
			const type = samples[i].type;
			if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) continue;
			const frames = getId3Frames(samples[i].data);
			const startTime = samples[i].pts;
			let endTime = startTime + samples[i].duration;
			if (endTime > MAX_CUE_ENDTIME) endTime = MAX_CUE_ENDTIME;
			if (endTime - startTime <= 0) endTime = startTime + MIN_CUE_DURATION;
			for (let j = 0; j < frames.length; j++) {
				const frame = frames[j];
				if (!isId3TimestampFrame(frame)) {
					this.updateId3CueEnds(startTime, type);
					const cue = createCueWithDataFields(Cue, startTime, endTime, frame, type);
					if (cue) this.id3Track.addCue(cue);
				}
			}
		}
	}
	updateId3CueEnds(startTime, type) {
		var _this$id3Track;
		const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
		if (cues) for (let i = cues.length; i--;) {
			const cue = cues[i];
			if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) cue.endTime = startTime;
		}
	}
	onBufferFlushing(event, { startOffset, endOffset, type }) {
		const { id3Track, hls } = this;
		if (!hls) return;
		const { config: { enableEmsgMetadataCues, enableID3MetadataCues } } = hls;
		if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
			let predicate;
			if (type === "audio") predicate = (cue) => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
			else if (type === "video") predicate = (cue) => cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
			else predicate = (cue) => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
			removeCuesInRange(id3Track, startOffset, endOffset, predicate);
		}
	}
	onLevelUpdated(event, { details }) {
		this.updateDateRangeCues(details, true);
	}
	onLevelPtsUpdated(event, data) {
		if (Math.abs(data.drift) > .01) this.updateDateRangeCues(data.details);
	}
	updateDateRangeCues(details, removeOldCues) {
		if (!this.hls || !this.media) return;
		const { assetPlayerId, timelineOffset, enableDateRangeMetadataCues, interstitialsController } = this.hls.config;
		if (!enableDateRangeMetadataCues) return;
		const Cue = getCueClass();
		if (assetPlayerId && timelineOffset && !interstitialsController) {
			const { fragmentStart, fragmentEnd } = details;
			let cue = this.assetCue;
			if (cue) {
				cue.startTime = fragmentStart;
				cue.endTime = fragmentEnd;
			} else if (Cue) {
				cue = this.assetCue = createCueWithDataFields(Cue, fragmentStart, fragmentEnd, { assetPlayerId: this.hls.config.assetPlayerId }, "hlsjs.interstitial.asset");
				if (cue) {
					cue.id = assetPlayerId;
					this.id3Track || (this.id3Track = this.createTrack(this.media));
					this.id3Track.addCue(cue);
					cue.addEventListener("enter", this.onEventCueEnter);
				}
			}
		}
		if (!details.hasProgramDateTime) return;
		const { id3Track } = this;
		const { dateRanges } = details;
		const ids = Object.keys(dateRanges);
		let dateRangeCuesAppended = this.dateRangeCuesAppended;
		if (id3Track && removeOldCues) {
			var _id3Track$cues;
			if ((_id3Track$cues = id3Track.cues) != null && _id3Track$cues.length) {
				const idsToRemove = Object.keys(dateRangeCuesAppended).filter((id) => !ids.includes(id));
				for (let i = idsToRemove.length; i--;) {
					var _dateRangeCuesAppende;
					const id = idsToRemove[i];
					const cues = (_dateRangeCuesAppende = dateRangeCuesAppended[id]) == null ? void 0 : _dateRangeCuesAppende.cues;
					delete dateRangeCuesAppended[id];
					if (cues) Object.keys(cues).forEach((key) => {
						const cue = cues[key];
						if (cue) {
							cue.removeEventListener("enter", this.onEventCueEnter);
							try {
								id3Track.removeCue(cue);
							} catch (e) {}
						}
					});
				}
			} else dateRangeCuesAppended = this.dateRangeCuesAppended = {};
		}
		const lastFragment = details.fragments[details.fragments.length - 1];
		if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) return;
		this.id3Track || (this.id3Track = this.createTrack(this.media));
		for (let i = 0; i < ids.length; i++) {
			const id = ids[i];
			const dateRange = dateRanges[id];
			const startTime = dateRange.startTime;
			const appendedDateRangeCues = dateRangeCuesAppended[id];
			const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
			let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
			let endTime = MAX_CUE_ENDTIME;
			const { duration, endDate } = dateRange;
			if (endDate && duration !== null) {
				endTime = startTime + duration;
				durationKnown = true;
			} else if (dateRange.endOnNext && !durationKnown) {
				const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id) => {
					if (id !== dateRange.id) {
						const otherDateRange = dateRanges[id];
						if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) return otherDateRange;
					}
					return candidateDateRange;
				}, null);
				if (nextDateRangeWithSameClass) {
					endTime = nextDateRangeWithSameClass.startTime;
					durationKnown = true;
				}
			}
			const attributes = Object.keys(dateRange.attr);
			for (let j = 0; j < attributes.length; j++) {
				const key = attributes[j];
				if (!isDateRangeCueAttribute(key)) continue;
				const cue = cues[key];
				if (cue) {
					if (durationKnown && !(appendedDateRangeCues != null && appendedDateRangeCues.durationKnown)) cue.endTime = endTime;
					else if (Math.abs(cue.startTime - startTime) > .01) {
						cue.startTime = startTime;
						cue.endTime = endTime;
					}
				} else if (Cue) {
					let data = dateRange.attr[key];
					if (isSCTE35Attribute(key)) data = hexToArrayBuffer(data);
					const _cue = createCueWithDataFields(Cue, startTime, endTime, {
						key,
						data
					}, MetadataSchema.dateRange);
					if (_cue) {
						_cue.id = id;
						this.id3Track.addCue(_cue);
						cues[key] = _cue;
						if (interstitialsController) {
							if (key === "X-ASSET-LIST" || key === "X-ASSET-URL") _cue.addEventListener("enter", this.onEventCueEnter);
						}
					}
				}
			}
			dateRangeCuesAppended[id] = {
				cues,
				dateRange,
				durationKnown
			};
		}
	}
};
var LatencyController = class {
	constructor(hls) {
		this.hls = void 0;
		this.config = void 0;
		this.media = null;
		this.currentTime = 0;
		this.stallCount = 0;
		this._latency = null;
		this._targetLatencyUpdated = false;
		this.onTimeupdate = () => {
			const { media } = this;
			const levelDetails = this.levelDetails;
			if (!media || !levelDetails) return;
			this.currentTime = media.currentTime;
			const latency = this.computeLatency();
			if (latency === null) return;
			this._latency = latency;
			const { lowLatencyMode, maxLiveSyncPlaybackRate } = this.config;
			if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) return;
			const targetLatency = this.targetLatency;
			if (targetLatency === null) return;
			const distanceFromTarget = latency - targetLatency;
			if (distanceFromTarget < Math.min(this.maxLatency, targetLatency + levelDetails.targetduration) && distanceFromTarget > .05 && this.forwardBufferLength > 1) {
				const max = Math.min(2, Math.max(1, maxLiveSyncPlaybackRate));
				const rate = Math.round(2 / (1 + Math.exp(-.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
				const playbackRate = Math.min(max, Math.max(1, rate));
				this.changeMediaPlaybackRate(media, playbackRate);
			} else if (media.playbackRate !== 1 && media.playbackRate !== 0) this.changeMediaPlaybackRate(media, 1);
		};
		this.hls = hls;
		this.config = hls.config;
		this.registerListeners();
	}
	get levelDetails() {
		var _this$hls;
		return ((_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails) || null;
	}
	get latency() {
		return this._latency || 0;
	}
	get maxLatency() {
		const { config } = this;
		if (config.liveMaxLatencyDuration !== void 0) return config.liveMaxLatencyDuration;
		const levelDetails = this.levelDetails;
		return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
	}
	get targetLatency() {
		const levelDetails = this.levelDetails;
		if (levelDetails === null || this.hls === null) return null;
		const { holdBack, partHoldBack, targetduration } = levelDetails;
		const { liveSyncDuration, liveSyncDurationCount, lowLatencyMode } = this.config;
		const userConfig = this.hls.userConfig;
		let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
		if (this._targetLatencyUpdated || userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) targetLatency = liveSyncDuration !== void 0 ? liveSyncDuration : liveSyncDurationCount * targetduration;
		const maxLiveSyncOnStallIncrease = targetduration;
		return targetLatency + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
	}
	set targetLatency(latency) {
		this.stallCount = 0;
		this.config.liveSyncDuration = latency;
		this._targetLatencyUpdated = true;
	}
	get liveSyncPosition() {
		const liveEdge = this.estimateLiveEdge();
		const targetLatency = this.targetLatency;
		if (liveEdge === null || targetLatency === null) return null;
		const levelDetails = this.levelDetails;
		if (levelDetails === null) return null;
		const edge = levelDetails.edge;
		const syncPosition = liveEdge - targetLatency - this.edgeStalled;
		const min = edge - levelDetails.totalduration;
		const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
		return Math.min(Math.max(min, syncPosition), max);
	}
	get drift() {
		const levelDetails = this.levelDetails;
		if (levelDetails === null) return 1;
		return levelDetails.drift;
	}
	get edgeStalled() {
		const levelDetails = this.levelDetails;
		if (levelDetails === null) return 0;
		const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
		return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
	}
	get forwardBufferLength() {
		const { media } = this;
		const levelDetails = this.levelDetails;
		if (!media || !levelDetails) return 0;
		const bufferedRanges = media.buffered.length;
		return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
	}
	destroy() {
		this.unregisterListeners();
		this.onMediaDetaching();
		this.hls = null;
	}
	registerListeners() {
		const { hls } = this;
		if (!hls) return;
		hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	unregisterListeners() {
		const { hls } = this;
		if (!hls) return;
		hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
		hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	onMediaAttached(event, data) {
		this.media = data.media;
		this.media.addEventListener("timeupdate", this.onTimeupdate);
	}
	onMediaDetaching() {
		if (this.media) {
			this.media.removeEventListener("timeupdate", this.onTimeupdate);
			this.media = null;
		}
	}
	onManifestLoading() {
		this._latency = null;
		this.stallCount = 0;
	}
	onLevelUpdated(event, { details }) {
		if (details.advanced) this.onTimeupdate();
		if (!details.live && this.media) this.media.removeEventListener("timeupdate", this.onTimeupdate);
	}
	onError(event, data) {
		var _this$levelDetails;
		if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) return;
		this.stallCount++;
		if (this.hls && (_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) this.hls.logger.warn("[latency-controller]: Stall detected, adjusting target latency");
	}
	changeMediaPlaybackRate(media, playbackRate) {
		var _this$hls2, _this$targetLatency;
		if (media.playbackRate === playbackRate) return;
		(_this$hls2 = this.hls) == null || _this$hls2.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(_this$targetLatency = this.targetLatency) == null ? void 0 : _this$targetLatency.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${media.playbackRate} to ${playbackRate}`);
		media.playbackRate = playbackRate;
	}
	estimateLiveEdge() {
		const levelDetails = this.levelDetails;
		if (levelDetails === null) return null;
		return levelDetails.edge + levelDetails.age;
	}
	computeLatency() {
		const liveEdge = this.estimateLiveEdge();
		if (liveEdge === null) return null;
		return liveEdge - this.currentTime;
	}
};
var LevelController = class extends BasePlaylistController {
	constructor(hls, contentSteeringController) {
		super(hls, "level-controller");
		this._levels = [];
		this._firstLevel = -1;
		this._maxAutoLevel = -1;
		this._startLevel = void 0;
		this.currentLevel = null;
		this.currentLevelIndex = -1;
		this.manualLevelIndex = -1;
		this.steering = void 0;
		this.onParsedComplete = void 0;
		this.steering = contentSteeringController;
		this._registerListeners();
	}
	_registerListeners() {
		const { hls } = this;
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
		hls.on(Events.ERROR, this.onError, this);
	}
	_unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
		hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
		hls.off(Events.ERROR, this.onError, this);
	}
	destroy() {
		this._unregisterListeners();
		this.steering = null;
		this.resetLevels();
		super.destroy();
	}
	stopLoad() {
		this._levels.forEach((level) => {
			level.loadError = 0;
			level.fragmentError = 0;
		});
		super.stopLoad();
	}
	resetLevels() {
		this._startLevel = void 0;
		this.manualLevelIndex = -1;
		this.currentLevelIndex = -1;
		this.currentLevel = null;
		this._levels = [];
		this._maxAutoLevel = -1;
	}
	onManifestLoading(event, data) {
		this.resetLevels();
	}
	onManifestLoaded(event, data) {
		const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
		const levels = [];
		const redundantSet = {};
		const generatePathwaySet = {};
		let resolutionFound = false;
		let videoCodecFound = false;
		let audioCodecFound = false;
		data.levels.forEach((levelParsed) => {
			const attributes = levelParsed.attrs;
			let { audioCodec, videoCodec } = levelParsed;
			if (audioCodec) levelParsed.audioCodec = audioCodec = getCodecCompatibleName(audioCodec, preferManagedMediaSource) || void 0;
			if (videoCodec) videoCodec = levelParsed.videoCodec = convertAVC1ToAVCOTI(videoCodec);
			const { width, height, unknownCodecs } = levelParsed;
			const unknownUnsupportedCodecCount = (unknownCodecs == null ? void 0 : unknownCodecs.length) || 0;
			resolutionFound || (resolutionFound = !!(width && height));
			videoCodecFound || (videoCodecFound = !!videoCodec);
			audioCodecFound || (audioCodecFound = !!audioCodec);
			if (unknownUnsupportedCodecCount || audioCodec && !this.isAudioSupported(audioCodec) || videoCodec && !this.isVideoSupported(videoCodec)) {
				this.log(`Some or all CODECS not supported "${attributes.CODECS}"`);
				return;
			}
			const { CODECS, "FRAME-RATE": FRAMERATE, "HDCP-LEVEL": HDCP, "PATHWAY-ID": PATHWAY, RESOLUTION, "VIDEO-RANGE": VIDEO_RANGE } = attributes;
			const levelKey = `${`${PATHWAY || "."}-`}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
			if (!redundantSet[levelKey]) {
				const level = this.createLevel(levelParsed);
				redundantSet[levelKey] = level;
				generatePathwaySet[levelKey] = 1;
				levels.push(level);
			} else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs["PATHWAY-ID"]) {
				const pathwayCount = generatePathwaySet[levelKey] += 1;
				levelParsed.attrs["PATHWAY-ID"] = new Array(pathwayCount + 1).join(".");
				const level = this.createLevel(levelParsed);
				redundantSet[levelKey] = level;
				levels.push(level);
			} else {
				redundantSet[levelKey].addGroupId("audio", attributes.AUDIO);
				redundantSet[levelKey].addGroupId("text", attributes.SUBTITLES);
			}
		});
		this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
	}
	createLevel(levelParsed) {
		const level = new Level(levelParsed);
		const supplemental = levelParsed.supplemental;
		if (supplemental != null && supplemental.videoCodec && !this.isVideoSupported(supplemental.videoCodec)) {
			const error = /* @__PURE__ */ new Error(`SUPPLEMENTAL-CODECS not supported "${supplemental.videoCodec}"`);
			this.log(error.message);
			level.supportedResult = getUnsupportedResult(error, []);
		}
		return level;
	}
	isAudioSupported(codec) {
		return areCodecsMediaSourceSupported(codec, "audio", this.hls.config.preferManagedMediaSource);
	}
	isVideoSupported(codec) {
		return areCodecsMediaSourceSupported(codec, "video", this.hls.config.preferManagedMediaSource);
	}
	filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
		var _data$stats;
		let audioTracks = [];
		let subtitleTracks = [];
		let levels = filteredLevels;
		const statsParsing = ((_data$stats = data.stats) == null ? void 0 : _data$stats.parsing) || {};
		if ((resolutionFound || videoCodecFound) && audioCodecFound) levels = levels.filter(({ videoCodec, videoRange, width, height }) => (!!videoCodec || !!(width && height)) && isVideoRange(videoRange));
		if (levels.length === 0) {
			Promise.resolve().then(() => {
				if (this.hls) {
					let message = "no level with compatible codecs found in manifest";
					let reason = message;
					if (data.levels.length) {
						reason = `one or more CODECS in variant not supported: ${stringify(data.levels.map((level) => level.attrs.CODECS).filter((value, index, array) => array.indexOf(value) === index))}`;
						this.warn(reason);
						message += ` (${reason})`;
					}
					const error = new Error(message);
					this.hls.trigger(Events.ERROR, {
						type: ErrorTypes.MEDIA_ERROR,
						details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
						fatal: true,
						url: data.url,
						error,
						reason
					});
				}
			});
			statsParsing.end = performance.now();
			return;
		}
		if (data.audioTracks) {
			audioTracks = data.audioTracks.filter((track) => !track.audioCodec || this.isAudioSupported(track.audioCodec));
			assignTrackIdsByGroup(audioTracks);
		}
		if (data.subtitles) {
			subtitleTracks = data.subtitles;
			assignTrackIdsByGroup(subtitleTracks);
		}
		const unsortedLevels = levels.slice(0);
		levels.sort((a, b) => {
			if (a.attrs["HDCP-LEVEL"] !== b.attrs["HDCP-LEVEL"]) return (a.attrs["HDCP-LEVEL"] || "") > (b.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
			if (resolutionFound && a.height !== b.height) return a.height - b.height;
			if (a.frameRate !== b.frameRate) return a.frameRate - b.frameRate;
			if (a.videoRange !== b.videoRange) return VideoRangeValues.indexOf(a.videoRange) - VideoRangeValues.indexOf(b.videoRange);
			if (a.videoCodec !== b.videoCodec) {
				const valueA = videoCodecPreferenceValue(a.videoCodec);
				const valueB = videoCodecPreferenceValue(b.videoCodec);
				if (valueA !== valueB) return valueB - valueA;
			}
			if (a.uri === b.uri && a.codecSet !== b.codecSet) {
				const valueA = codecsSetSelectionPreferenceValue(a.codecSet);
				const valueB = codecsSetSelectionPreferenceValue(b.codecSet);
				if (valueA !== valueB) return valueB - valueA;
			}
			if (a.averageBitrate !== b.averageBitrate) return a.averageBitrate - b.averageBitrate;
			return 0;
		});
		let firstLevelInPlaylist = unsortedLevels[0];
		if (this.steering) {
			levels = this.steering.filterParsedLevels(levels);
			if (levels.length !== unsortedLevels.length) {
				for (let i = 0; i < unsortedLevels.length; i++) if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
					firstLevelInPlaylist = unsortedLevels[i];
					break;
				}
			}
		}
		this._levels = levels;
		for (let i = 0; i < levels.length; i++) if (levels[i] === firstLevelInPlaylist) {
			var _this$hls$userConfig;
			this._firstLevel = i;
			const firstLevelBitrate = firstLevelInPlaylist.bitrate;
			const bandwidthEstimate = this.hls.bandwidthEstimate;
			this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
			if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === void 0) {
				const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
				if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === this.hls.abrEwmaDefaultEstimate) this.hls.bandwidthEstimate = startingBwEstimate;
			}
			break;
		}
		const audioOnly = audioCodecFound && !videoCodecFound;
		const config = this.hls.config;
		const altAudioEnabled = !!(config.audioStreamController && config.audioTrackController);
		const edata = {
			levels,
			audioTracks,
			subtitleTracks,
			sessionData: data.sessionData,
			sessionKeys: data.sessionKeys,
			firstLevel: this._firstLevel,
			stats: data.stats,
			audio: audioCodecFound,
			video: videoCodecFound,
			altAudio: altAudioEnabled && !audioOnly && audioTracks.some((t) => !!t.url)
		};
		statsParsing.end = performance.now();
		this.hls.trigger(Events.MANIFEST_PARSED, edata);
	}
	get levels() {
		if (this._levels.length === 0) return null;
		return this._levels;
	}
	get loadLevelObj() {
		return this.currentLevel;
	}
	get level() {
		return this.currentLevelIndex;
	}
	set level(newLevel) {
		const levels = this._levels;
		if (levels.length === 0) return;
		if (newLevel < 0 || newLevel >= levels.length) {
			const error = /* @__PURE__ */ new Error("invalid level idx");
			const fatal = newLevel < 0;
			this.hls.trigger(Events.ERROR, {
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.LEVEL_SWITCH_ERROR,
				level: newLevel,
				fatal,
				error,
				reason: error.message
			});
			if (fatal) return;
			newLevel = Math.min(newLevel, levels.length - 1);
		}
		const lastLevelIndex = this.currentLevelIndex;
		const lastLevel = this.currentLevel;
		const lastPathwayId = lastLevel ? lastLevel.attrs["PATHWAY-ID"] : void 0;
		const level = levels[newLevel];
		const pathwayId = level.attrs["PATHWAY-ID"];
		this.currentLevelIndex = newLevel;
		this.currentLevel = level;
		if (lastLevelIndex === newLevel && lastLevel && lastPathwayId === pathwayId) return;
		this.log(`Switching to level ${newLevel} (${level.height ? level.height + "p " : ""}${level.videoRange ? level.videoRange + " " : ""}${level.codecSet ? level.codecSet + " " : ""}@${level.bitrate})${pathwayId ? " with Pathway " + pathwayId : ""} from level ${lastLevelIndex}${lastPathwayId ? " with Pathway " + lastPathwayId : ""}`);
		const levelSwitchingData = {
			level: newLevel,
			attrs: level.attrs,
			details: level.details,
			bitrate: level.bitrate,
			averageBitrate: level.averageBitrate,
			maxBitrate: level.maxBitrate,
			realBitrate: level.realBitrate,
			width: level.width,
			height: level.height,
			codecSet: level.codecSet,
			audioCodec: level.audioCodec,
			videoCodec: level.videoCodec,
			audioGroups: level.audioGroups,
			subtitleGroups: level.subtitleGroups,
			loaded: level.loaded,
			loadError: level.loadError,
			fragmentError: level.fragmentError,
			name: level.name,
			id: level.id,
			uri: level.uri,
			url: level.url,
			urlId: 0,
			audioGroupIds: level.audioGroupIds,
			textGroupIds: level.textGroupIds
		};
		this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
		const levelDetails = level.details;
		if (!levelDetails || levelDetails.live) {
			const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
			this.loadPlaylist(hlsUrlParameters);
		}
	}
	get manualLevel() {
		return this.manualLevelIndex;
	}
	set manualLevel(newLevel) {
		this.manualLevelIndex = newLevel;
		if (this._startLevel === void 0) this._startLevel = newLevel;
		if (newLevel !== -1) this.level = newLevel;
	}
	get firstLevel() {
		return this._firstLevel;
	}
	set firstLevel(newLevel) {
		this._firstLevel = newLevel;
	}
	get startLevel() {
		if (this._startLevel === void 0) {
			const configStartLevel = this.hls.config.startLevel;
			if (configStartLevel !== void 0) return configStartLevel;
			return this.hls.firstAutoLevel;
		}
		return this._startLevel;
	}
	set startLevel(newLevel) {
		this._startLevel = newLevel;
	}
	get pathways() {
		if (this.steering) return this.steering.pathways();
		return [];
	}
	get pathwayPriority() {
		if (this.steering) return this.steering.pathwayPriority;
		return null;
	}
	set pathwayPriority(pathwayPriority) {
		if (this.steering) {
			const pathwaysList = this.steering.pathways();
			const filteredPathwayPriority = pathwayPriority.filter((pathwayId) => {
				return pathwaysList.indexOf(pathwayId) !== -1;
			});
			if (pathwayPriority.length < 1) {
				this.warn(`pathwayPriority ${pathwayPriority} should contain at least one pathway from list: ${pathwaysList}`);
				return;
			}
			this.steering.pathwayPriority = filteredPathwayPriority;
		}
	}
	onError(event, data) {
		if (data.fatal || !data.context) return;
		if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) this.checkRetry(data);
	}
	onFragBuffered(event, { frag }) {
		if (frag !== void 0 && frag.type === PlaylistLevelType.MAIN) {
			const el = frag.elementaryStreams;
			if (!Object.keys(el).some((type) => !!el[type])) return;
			const level = this._levels[frag.level];
			if (level != null && level.loadError) {
				this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
				level.loadError = 0;
			}
		}
	}
	onLevelLoaded(event, data) {
		var _data$deliveryDirecti2;
		const { level, details } = data;
		const curLevel = data.levelInfo;
		if (!curLevel) {
			var _data$deliveryDirecti;
			this.warn(`Invalid level index ${level}`);
			if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) details.deltaUpdateFailed = true;
			return;
		}
		if (curLevel === this.currentLevel || data.withoutMultiVariant) {
			if (curLevel.fragmentError === 0) curLevel.loadError = 0;
			let previousDetails = curLevel.details;
			if (previousDetails === data.details && previousDetails.advanced) previousDetails = void 0;
			this.playlistLoaded(level, data, previousDetails);
		} else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) details.deltaUpdateFailed = true;
	}
	loadPlaylist(hlsUrlParameters) {
		super.loadPlaylist();
		if (this.shouldLoadPlaylist(this.currentLevel)) this.scheduleLoading(this.currentLevel, hlsUrlParameters);
	}
	loadingPlaylist(currentLevel, hlsUrlParameters) {
		super.loadingPlaylist(currentLevel, hlsUrlParameters);
		const url = this.getUrlWithDirectives(currentLevel.uri, hlsUrlParameters);
		const currentLevelIndex = this.currentLevelIndex;
		const pathwayId = currentLevel.attrs["PATHWAY-ID"];
		const details = currentLevel.details;
		const age = details == null ? void 0 : details.age;
		this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== void 0 ? " at sn " + hlsUrlParameters.msn + " part " + hlsUrlParameters.part : ""}${pathwayId ? " Pathway " + pathwayId : ""}${age && details.live ? " age " + age.toFixed(1) + (details.type ? " " + details.type || "" : "") : ""} ${url}`);
		this.hls.trigger(Events.LEVEL_LOADING, {
			url,
			level: currentLevelIndex,
			levelInfo: currentLevel,
			pathwayId: currentLevel.attrs["PATHWAY-ID"],
			id: 0,
			deliveryDirectives: hlsUrlParameters || null
		});
	}
	get nextLoadLevel() {
		if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
		else return this.hls.nextAutoLevel;
	}
	set nextLoadLevel(nextLevel) {
		this.level = nextLevel;
		if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
	}
	removeLevel(levelIndex) {
		var _this$currentLevel;
		if (this._levels.length === 1) return;
		const levels = this._levels.filter((level, index) => {
			if (index !== levelIndex) return true;
			if (this.steering) this.steering.removeLevel(level);
			if (level === this.currentLevel) {
				this.currentLevel = null;
				this.currentLevelIndex = -1;
				if (level.details) level.details.fragments.forEach((f) => f.level = -1);
			}
			return false;
		});
		reassignFragmentLevelIndexes(levels);
		this._levels = levels;
		if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
		if (this.manualLevelIndex > -1) this.manualLevelIndex = this.currentLevelIndex;
		const maxLevel = levels.length - 1;
		this._firstLevel = Math.min(this._firstLevel, maxLevel);
		if (this._startLevel) this._startLevel = Math.min(this._startLevel, maxLevel);
		this.hls.trigger(Events.LEVELS_UPDATED, { levels });
	}
	onLevelsUpdated(event, { levels }) {
		this._levels = levels;
	}
	checkMaxAutoUpdated() {
		const { autoLevelCapping, maxAutoLevel, maxHdcpLevel } = this.hls;
		if (this._maxAutoLevel !== maxAutoLevel) {
			this._maxAutoLevel = maxAutoLevel;
			this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
				autoLevelCapping,
				levels: this.levels,
				maxAutoLevel,
				minAutoLevel: this.hls.minAutoLevel,
				maxHdcpLevel
			});
		}
	}
};
function assignTrackIdsByGroup(tracks) {
	const groups = {};
	tracks.forEach((track) => {
		const groupId = track.groupId || "";
		track.id = groups[groupId] = groups[groupId] || 0;
		groups[groupId]++;
	});
}
function getSourceBuffer() {
	return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
	if (!getMediaSource()) return false;
	const sourceBuffer = getSourceBuffer();
	return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
}
function isSupported() {
	if (!isMSESupported()) return false;
	const mediaSource = getMediaSource();
	return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === "function" && ([
		"avc1.42E01E,mp4a.40.2",
		"av01.0.01M.08",
		"vp09.00.50.08"
	].some((codecsForVideoContainer) => mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer, "video"))) || ["mp4a.40.2", "fLaC"].some((codecForAudioContainer) => mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer, "audio"))));
}
function changeTypeSupported() {
	var _sourceBuffer$prototy;
	const sourceBuffer = getSourceBuffer();
	return typeof (sourceBuffer == null || (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === "function";
}
var TICK_INTERVAL = 100;
var StreamController = class extends BaseStreamController {
	constructor(hls, fragmentTracker, keyLoader) {
		super(hls, fragmentTracker, keyLoader, "stream-controller", PlaylistLevelType.MAIN);
		this.audioCodecSwap = false;
		this.level = -1;
		this._forceStartLoad = false;
		this._hasEnoughToStart = false;
		this.altAudio = 0;
		this.audioOnly = false;
		this.fragPlaying = null;
		this.fragLastKbps = 0;
		this.couldBacktrack = false;
		this.backtrackFragment = null;
		this.audioCodecSwitch = false;
		this.videoBuffer = null;
		this.onMediaPlaying = () => {
			this.tick();
		};
		this.onMediaSeeked = () => {
			const media = this.media;
			const currentTime = media ? media.currentTime : null;
			if (currentTime === null || !isFiniteNumber(currentTime)) return;
			this.log(`Media seeked to ${currentTime.toFixed(3)}`);
			if (!this.getBufferedFrag(currentTime)) return;
			const bufferInfo = this.getFwdBufferInfoAtPos(media, currentTime, PlaylistLevelType.MAIN, 0);
			if (bufferInfo === null || bufferInfo.len === 0) {
				this.warn(`Main forward buffer length at ${currentTime} on "seeked" event ${bufferInfo ? bufferInfo.len : "empty"})`);
				return;
			}
			this.tick();
		};
		this.registerListeners();
	}
	registerListeners() {
		super.registerListeners();
		const { hls } = this;
		hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
		hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
		hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
		hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
		hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
		hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
	}
	unregisterListeners() {
		super.unregisterListeners();
		const { hls } = this;
		hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
		hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
		hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
		hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
		hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
		hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
		hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
		hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
		hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
	}
	onHandlerDestroying() {
		this.onMediaPlaying = this.onMediaSeeked = null;
		this.unregisterListeners();
		super.onHandlerDestroying();
	}
	startLoad(startPosition, skipSeekToStartPosition) {
		if (this.levels) {
			const { lastCurrentTime, hls } = this;
			this.stopLoad();
			this.setInterval(TICK_INTERVAL);
			this.level = -1;
			if (!this.startFragRequested) {
				let startLevel = hls.startLevel;
				if (startLevel === -1) if (hls.config.testBandwidth && this.levels.length > 1) {
					startLevel = 0;
					this.bitrateTest = true;
				} else startLevel = hls.firstAutoLevel;
				hls.nextLoadLevel = startLevel;
				this.level = hls.loadLevel;
				this._hasEnoughToStart = !!skipSeekToStartPosition;
			}
			if (lastCurrentTime > 0 && startPosition === -1 && !skipSeekToStartPosition) {
				this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
				startPosition = lastCurrentTime;
			}
			this.state = State.IDLE;
			this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
			this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
			this.tick();
		} else {
			this._forceStartLoad = true;
			this.state = State.STOPPED;
		}
	}
	stopLoad() {
		this._forceStartLoad = false;
		super.stopLoad();
	}
	doTick() {
		switch (this.state) {
			case State.WAITING_LEVEL: {
				const { levels, level } = this;
				const currentLevel = levels == null ? void 0 : levels[level];
				const details = currentLevel == null ? void 0 : currentLevel.details;
				if (details && (!details.live || this.levelLastLoaded === currentLevel && !this.waitForLive(currentLevel))) {
					if (this.waitForCdnTuneIn(details)) break;
					this.state = State.IDLE;
					break;
				} else if (this.hls.nextLoadLevel !== this.level) {
					this.state = State.IDLE;
					break;
				}
				break;
			}
			case State.FRAG_LOADING_WAITING_RETRY:
				this.checkRetryDate();
				break;
		}
		if (this.state === State.IDLE) this.doTickIdle();
		this.onTickEnd();
	}
	onTickEnd() {
		var _this$media;
		super.onTickEnd();
		if ((_this$media = this.media) != null && _this$media.readyState && this.media.seeking === false) this.lastCurrentTime = this.media.currentTime;
		this.checkFragmentChanged();
	}
	doTickIdle() {
		const { hls, levelLastLoaded, levels, media } = this;
		if (levelLastLoaded === null || !media && !this.primaryPrefetch && (this.startFragRequested || !hls.config.startFragPrefetch)) return;
		if (this.altAudio && this.audioOnly) return;
		const level = this.buffering ? hls.nextLoadLevel : hls.loadLevel;
		if (!(levels != null && levels[level])) return;
		const levelInfo = levels[level];
		const bufferInfo = this.getMainFwdBufferInfo();
		if (bufferInfo === null) return;
		const lastDetails = this.getLevelDetails();
		if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
			const data = {};
			if (this.altAudio === 2) data.type = "video";
			this.hls.trigger(Events.BUFFER_EOS, data);
			this.state = State.ENDED;
			return;
		}
		if (!this.buffering) return;
		if (hls.loadLevel !== level && hls.manualLevel === -1) this.log(`Adapting to level ${level} from level ${this.level}`);
		this.level = hls.nextLoadLevel = level;
		const levelDetails = levelInfo.details;
		if (!levelDetails || this.state === State.WAITING_LEVEL || this.waitForLive(levelInfo)) {
			this.level = level;
			this.state = State.WAITING_LEVEL;
			this.startFragRequested = false;
			return;
		}
		const bufferLen = bufferInfo.len;
		const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);
		if (bufferLen >= maxBufLen) return;
		if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) this.backtrackFragment = null;
		const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
		let frag = this.getNextFragment(targetBufferTime, levelDetails);
		if (this.couldBacktrack && !this.fragPrevious && frag && isMediaFragment(frag) && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
			var _this$backtrackFragme;
			const fragIdx = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn - levelDetails.startSN;
			const backtrackFrag = levelDetails.fragments[fragIdx - 1];
			if (backtrackFrag && frag.cc === backtrackFrag.cc) {
				frag = backtrackFrag;
				this.fragmentTracker.removeFragment(backtrackFrag);
			}
		} else if (this.backtrackFragment && bufferInfo.len) this.backtrackFragment = null;
		if (frag && this.isLoopLoading(frag, targetBufferTime)) {
			if (!frag.gap) {
				const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
				const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
				if (mediaBuffer) this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
			}
			frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
		}
		if (!frag) return;
		if (this.exceedsMaxBuffer(bufferInfo, maxBufLen, frag)) return;
		if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) frag = frag.initSegment;
		this.loadFragment(frag, levelInfo, targetBufferTime);
	}
	loadFragment(frag, level, targetBufferTime) {
		const fragState = this.fragmentTracker.getState(frag);
		if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) if (!isMediaFragment(frag)) this._loadInitSegment(frag, level);
		else if (this.bitrateTest) {
			this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
			this._loadBitrateTestFrag(frag, level);
		} else super.loadFragment(frag, level, targetBufferTime);
		else this.clearTrackerIfNeeded(frag);
	}
	getBufferedFrag(position) {
		return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
	}
	followingBufferedFrag(frag) {
		if (frag) return this.getBufferedFrag(frag.end + .5);
		return null;
	}
	immediateLevelSwitch() {
		this.abortCurrentFrag();
		this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
		if (this.altAudio !== 0) {
			var _this$getLevelDetails;
			if ((((_this$getLevelDetails = this.getLevelDetails()) == null ? void 0 : _this$getLevelDetails.fragmentStart) || 0) > this.lastCurrentTime) super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio");
		}
	}
	/**
	* try to switch ASAP without breaking video playback:
	* in order to ensure smooth but quick level switching,
	* we need to find the next flushable buffer range
	* we should take into account new segment fetch time
	*/
	nextLevelSwitch() {
		const { levels, media } = this;
		if (media != null && media.readyState) {
			let fetchdelay;
			const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
			if (fragPlayingCurrent && fragPlayingCurrent.start > 1) this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
			const levelDetails = this.getLevelDetails();
			if (levelDetails != null && levelDetails.live) {
				const bufferInfo = this.getMainFwdBufferInfo();
				if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) return;
			}
			if (!media.paused && levels) {
				const nextLevel = levels[this.hls.nextLoadLevel];
				const fragLastKbps = this.fragLastKbps;
				if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1e3 * fragLastKbps) + 1;
				else fetchdelay = 0;
			} else fetchdelay = 0;
			const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
			if (bufferedFrag) {
				const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
				if (nextBufferedFrag) {
					this.abortCurrentFrag();
					const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
					const fragDuration = nextBufferedFrag.duration;
					const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? .5 : .125)), fragDuration * (this.couldBacktrack ? .75 : .25)));
					this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
				}
			}
		}
	}
	abortCurrentFrag() {
		const fragCurrent = this.fragCurrent;
		this.fragCurrent = null;
		this.backtrackFragment = null;
		if (fragCurrent) {
			fragCurrent.abortRequests();
			this.fragmentTracker.removeFragment(fragCurrent);
		}
		switch (this.state) {
			case State.KEY_LOADING:
			case State.FRAG_LOADING:
			case State.FRAG_LOADING_WAITING_RETRY:
			case State.PARSING:
			case State.PARSED:
				this.state = State.IDLE;
				break;
		}
		this.nextLoadPosition = this.getLoadPosition();
	}
	flushMainBuffer(startOffset, endOffset) {
		super.flushMainBuffer(startOffset, endOffset, this.altAudio === 2 ? "video" : null);
	}
	onMediaAttached(event, data) {
		super.onMediaAttached(event, data);
		const media = data.media;
		addEventListener(media, "playing", this.onMediaPlaying);
		addEventListener(media, "seeked", this.onMediaSeeked);
	}
	onMediaDetaching(event, data) {
		const { media } = this;
		if (media) {
			removeEventListener(media, "playing", this.onMediaPlaying);
			removeEventListener(media, "seeked", this.onMediaSeeked);
		}
		this.videoBuffer = null;
		this.fragPlaying = null;
		super.onMediaDetaching(event, data);
		if (!!data.transferMedia) return;
		this._hasEnoughToStart = false;
	}
	onManifestLoading() {
		super.onManifestLoading();
		this.log("Trigger BUFFER_RESET");
		this.hls.trigger(Events.BUFFER_RESET, void 0);
		this.couldBacktrack = false;
		this.fragLastKbps = 0;
		this.fragPlaying = this.backtrackFragment = null;
		this.altAudio = 0;
		this.audioOnly = false;
	}
	onManifestParsed(event, data) {
		let aac = false;
		let heaac = false;
		for (let i = 0; i < data.levels.length; i++) {
			const codec = data.levels[i].audioCodec;
			if (codec) {
				aac = aac || codec.indexOf("mp4a.40.2") !== -1;
				heaac = heaac || codec.indexOf("mp4a.40.5") !== -1;
			}
		}
		this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
		if (this.audioCodecSwitch) this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC");
		this.levels = data.levels;
		this.startFragRequested = false;
	}
	onLevelLoading(event, data) {
		const { levels } = this;
		if (!levels || this.state !== State.IDLE) return;
		const level = data.levelInfo;
		if (!level.details || level.details.live && (this.levelLastLoaded !== level || level.details.expired) || this.waitForCdnTuneIn(level.details)) this.state = State.WAITING_LEVEL;
	}
	onLevelLoaded(event, data) {
		var _curLevel$details;
		const { levels, startFragRequested } = this;
		const newLevelId = data.level;
		const newDetails = data.details;
		const duration = newDetails.totalduration;
		if (!levels) {
			this.warn(`Levels were reset while loading level ${newLevelId}`);
			return;
		}
		this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ""}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
		const curLevel = data.levelInfo;
		const fragCurrent = this.fragCurrent;
		if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
			if (fragCurrent.level !== data.level && fragCurrent.loader) this.abortCurrentFrag();
		}
		let sliding = 0;
		if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
			var _this$levelLastLoaded;
			this.checkLiveUpdate(newDetails);
			if (newDetails.deltaUpdateFailed) return;
			sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
		}
		curLevel.details = newDetails;
		this.levelLastLoaded = curLevel;
		if (!startFragRequested) this.setStartPosition(newDetails, sliding);
		this.hls.trigger(Events.LEVEL_UPDATED, {
			details: newDetails,
			level: newLevelId
		});
		if (this.state === State.WAITING_LEVEL) {
			if (this.waitForCdnTuneIn(newDetails)) return;
			this.state = State.IDLE;
		}
		if (startFragRequested && newDetails.live) this.synchronizeToLiveEdge(newDetails);
		this.tick();
	}
	synchronizeToLiveEdge(levelDetails) {
		const { config, media } = this;
		if (!media) return;
		const liveSyncPosition = this.hls.liveSyncPosition;
		const currentTime = this.getLoadPosition();
		const start = levelDetails.fragmentStart;
		const end = levelDetails.edge;
		const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
		if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
			const maxLatency = config.liveMaxLatencyDuration !== void 0 ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
			if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
				if (!this._hasEnoughToStart) this.nextLoadPosition = liveSyncPosition;
				if (media.readyState) {
					this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
					if (this.config.liveSyncMode === "buffered") {
						var _bufferInfo$buffered;
						const bufferInfo = BufferHelper.bufferInfo(media, liveSyncPosition, 0);
						if (!((_bufferInfo$buffered = bufferInfo.buffered) != null && _bufferInfo$buffered.length)) {
							media.currentTime = liveSyncPosition;
							return;
						}
						if (bufferInfo.start <= currentTime) {
							media.currentTime = liveSyncPosition;
							return;
						}
						const { nextStart } = BufferHelper.bufferedInfo(bufferInfo.buffered, currentTime, 0);
						if (nextStart) media.currentTime = nextStart;
					} else media.currentTime = liveSyncPosition;
				}
			}
		}
	}
	_handleFragmentLoadProgress(data) {
		var _frag$initSegment;
		const frag = data.frag;
		const { part, payload } = data;
		const { levels } = this;
		if (!levels) {
			this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
			return;
		}
		const currentLevel = levels[frag.level];
		if (!currentLevel) {
			this.warn(`Level ${frag.level} not found on progress`);
			return;
		}
		const details = currentLevel.details;
		if (!details) {
			this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
			this.fragmentTracker.removeFragment(frag);
			return;
		}
		const videoCodec = currentLevel.videoCodec;
		const accurateTimeOffset = details.PTSKnown || !details.live;
		const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
		const audioCodec = this._getAudioCodec(currentLevel);
		const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
		const partIndex = part ? part.index : -1;
		const partial = partIndex !== -1;
		const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
		const initPTS = this.initPTS[frag.cc];
		transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
	}
	onAudioTrackSwitching(event, data) {
		const hls = this.hls;
		const fromAltAudio = this.altAudio !== 0;
		if (!useAlternateAudio(data.url, hls)) {
			if (this.mediaBuffer !== this.media) {
				this.log("Switching on main audio, use media.buffered to schedule main fragment loading");
				this.mediaBuffer = this.media;
				const fragCurrent = this.fragCurrent;
				if (fragCurrent) {
					this.log("Switching to main audio track, cancel main fragment load");
					fragCurrent.abortRequests();
					this.fragmentTracker.removeFragment(fragCurrent);
				}
				this.resetTransmuxer();
				this.resetLoadingState();
			} else if (this.audioOnly) this.resetTransmuxer();
			if (fromAltAudio) {
				this.altAudio = 0;
				this.fragmentTracker.removeAllFragments();
				hls.once(Events.BUFFER_FLUSHED, () => {
					if (!this.hls) return;
					this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
				});
				hls.trigger(Events.BUFFER_FLUSHING, {
					startOffset: 0,
					endOffset: Number.POSITIVE_INFINITY,
					type: null
				});
				return;
			}
			hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
		} else this.altAudio = 1;
	}
	onAudioTrackSwitched(event, data) {
		const altAudio = useAlternateAudio(data.url, this.hls);
		if (altAudio) {
			const videoBuffer = this.videoBuffer;
			if (videoBuffer && this.mediaBuffer !== videoBuffer) {
				this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading");
				this.mediaBuffer = videoBuffer;
			}
		}
		this.altAudio = altAudio ? 2 : 0;
		this.tick();
	}
	onBufferCreated(event, data) {
		const tracks = data.tracks;
		let mediaTrack;
		let name;
		let alternate = false;
		for (const type in tracks) {
			const track = tracks[type];
			if (track.id === "main") {
				name = type;
				mediaTrack = track;
				if (type === "video") {
					const videoTrack = tracks[type];
					if (videoTrack) this.videoBuffer = videoTrack.buffer;
				}
			} else alternate = true;
		}
		if (alternate && mediaTrack) {
			this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
			this.mediaBuffer = mediaTrack.buffer;
		} else this.mediaBuffer = this.media;
	}
	onFragBuffered(event, data) {
		const { frag, part } = data;
		const bufferedMainFragment = frag.type === PlaylistLevelType.MAIN;
		if (bufferedMainFragment) {
			if (this.fragContextChanged(frag)) {
				this.warn(`Fragment ${frag.sn}${part ? " p: " + part.index : ""} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
				if (this.state === State.PARSED) this.state = State.IDLE;
				return;
			}
			const stats = part ? part.stats : frag.stats;
			this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
			if (isMediaFragment(frag)) this.fragPrevious = frag;
			this.fragBufferedComplete(frag, part);
		}
		const media = this.media;
		if (!media) return;
		if (!this._hasEnoughToStart && BufferHelper.getBuffered(media).length) {
			this._hasEnoughToStart = true;
			this.seekToStartPos();
		}
		if (bufferedMainFragment) this.tick();
	}
	get hasEnoughToStart() {
		return this._hasEnoughToStart;
	}
	onError(event, data) {
		var _data$context;
		if (data.fatal) {
			this.state = State.ERROR;
			return;
		}
		switch (data.details) {
			case ErrorDetails.FRAG_GAP:
			case ErrorDetails.FRAG_PARSING_ERROR:
			case ErrorDetails.FRAG_DECRYPT_ERROR:
			case ErrorDetails.FRAG_LOAD_ERROR:
			case ErrorDetails.FRAG_LOAD_TIMEOUT:
			case ErrorDetails.KEY_LOAD_ERROR:
			case ErrorDetails.KEY_LOAD_TIMEOUT:
				this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
				break;
			case ErrorDetails.LEVEL_LOAD_ERROR:
			case ErrorDetails.LEVEL_LOAD_TIMEOUT:
			case ErrorDetails.LEVEL_PARSING_ERROR:
				if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) this.state = State.IDLE;
				break;
			case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
			case ErrorDetails.BUFFER_APPEND_ERROR:
				if (data.parent !== "main") return;
				if (this.reduceLengthAndFlushBuffer(data)) this.resetLoadingState();
				break;
			case ErrorDetails.BUFFER_FULL_ERROR:
				if (data.parent !== "main") return;
				if (this.reduceLengthAndFlushBuffer(data)) if (!this.config.interstitialsController && this.config.assetPlayerId) this._hasEnoughToStart = true;
				else this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
				break;
			case ErrorDetails.INTERNAL_EXCEPTION:
				this.recoverWorkerError(data);
				break;
		}
	}
	onFragLoadEmergencyAborted() {
		this.state = State.IDLE;
		if (!this._hasEnoughToStart) {
			this.startFragRequested = false;
			this.nextLoadPosition = this.lastCurrentTime;
		}
		this.tickImmediate();
	}
	onBufferFlushed(event, { type }) {
		if (type !== ElementaryStreamTypes.AUDIO || !this.altAudio) {
			const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
			if (mediaBuffer) {
				this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
				this.tick();
			}
		}
	}
	onLevelsUpdated(event, data) {
		if (this.level > -1 && this.fragCurrent) {
			this.level = this.fragCurrent.level;
			if (this.level === -1) this.resetWhenMissingContext(this.fragCurrent);
		}
		this.levels = data.levels;
	}
	swapAudioCodec() {
		this.audioCodecSwap = !this.audioCodecSwap;
	}
	/**
	* Seeks to the set startPosition if not equal to the mediaElement's current time.
	*/
	seekToStartPos() {
		const { media } = this;
		if (!media) return;
		const currentTime = media.currentTime;
		let startPosition = this.startPosition;
		if (startPosition >= 0 && currentTime < startPosition) {
			if (media.seeking) {
				this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
				return;
			}
			const timelineOffset = this.timelineOffset;
			if (timelineOffset && startPosition) startPosition += timelineOffset;
			const details = this.getLevelDetails();
			const buffered = BufferHelper.getBuffered(media);
			const bufferStart = buffered.length ? buffered.start(0) : 0;
			const delta = bufferStart - startPosition;
			const skipTolerance = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
			if (this.config.startOnSegmentBoundary || delta > 0 && (delta < skipTolerance || this.loadingParts && delta < 2 * ((details == null ? void 0 : details.partTarget) || 0))) {
				this.log(`adjusting start position by ${delta} to match buffer start`);
				startPosition += delta;
				this.startPosition = startPosition;
			}
			if (currentTime < startPosition) {
				this.log(`seek to target start position ${startPosition} from current time ${currentTime} buffer start ${bufferStart}`);
				media.currentTime = startPosition;
			}
		}
	}
	_getAudioCodec(currentLevel) {
		let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
		if (this.audioCodecSwap && audioCodec) {
			this.log("Swapping audio codec");
			if (audioCodec.indexOf("mp4a.40.5") !== -1) audioCodec = "mp4a.40.2";
			else audioCodec = "mp4a.40.5";
		}
		return audioCodec;
	}
	_loadBitrateTestFrag(fragment, level) {
		fragment.bitrateTest = true;
		this._doFragLoad(fragment, level).then((data) => {
			const { hls } = this;
			const frag = data == null ? void 0 : data.frag;
			if (!frag || this.fragContextChanged(frag)) return;
			level.fragmentError = 0;
			this.state = State.IDLE;
			this.startFragRequested = false;
			this.bitrateTest = false;
			const stats = frag.stats;
			stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
			hls.trigger(Events.FRAG_LOADED, data);
			frag.bitrateTest = false;
		}).catch((reason) => {
			if (this.state === State.STOPPED || this.state === State.ERROR) return;
			this.warn(reason);
			this.resetFragmentLoading(fragment);
		});
	}
	_handleTransmuxComplete(transmuxResult) {
		const id = this.playlistType;
		const { hls } = this;
		const { remuxResult, chunkMeta } = transmuxResult;
		const context = this.getCurrentContext(chunkMeta);
		if (!context) {
			this.resetWhenMissingContext(chunkMeta);
			return;
		}
		const { frag, part, level } = context;
		const { video, text, id3, initSegment } = remuxResult;
		const { details } = level;
		const audio = this.altAudio ? void 0 : remuxResult.audio;
		if (this.fragContextChanged(frag)) {
			this.fragmentTracker.removeFragment(frag);
			return;
		}
		this.state = State.PARSING;
		if (initSegment) {
			const tracks = initSegment.tracks;
			if (tracks) {
				const mapFragment = frag.initSegment || frag;
				if (this.unhandledEncryptionError(initSegment, frag)) return;
				this._bufferInitSegment(level, tracks, mapFragment, chunkMeta);
				hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
					frag: mapFragment,
					id,
					tracks
				});
			}
			const baseTime = initSegment.initPTS;
			const timescale = initSegment.timescale;
			const initPTS = this.initPTS[frag.cc];
			if (isFiniteNumber(baseTime) && (!initPTS || initPTS.baseTime !== baseTime || initPTS.timescale !== timescale)) {
				const trackId = initSegment.trackId;
				this.initPTS[frag.cc] = {
					baseTime,
					timescale,
					trackId
				};
				hls.trigger(Events.INIT_PTS_FOUND, {
					frag,
					id,
					initPTS: baseTime,
					timescale,
					trackId
				});
			}
		}
		if (video && details) {
			if (audio && video.type === "audiovideo") this.logMuxedErr(frag);
			const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
			const isFirstFragment = frag.sn === details.startSN;
			const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
			if (remuxResult.independent !== false) {
				const { startPTS, endPTS, startDTS, endDTS } = video;
				if (part) part.elementaryStreams[video.type] = {
					startPTS,
					endPTS,
					startDTS,
					endDTS
				};
				else {
					if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) this.couldBacktrack = true;
					if (video.dropped && video.independent) {
						const bufferInfo = this.getMainFwdBufferInfo();
						const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
						const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
						if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
							this.backtrack(frag);
							return;
						} else if (isFirstInDiscontinuity) frag.gap = true;
						frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
					} else if (isFirstFragment && startPTS - (details.appliedTimelineOffset || 0) > MAX_START_GAP_JUMP) frag.gap = true;
				}
				frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
				if (this.backtrackFragment) this.backtrackFragment = frag;
				this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
			} else if (isFirstFragment || isFirstInDiscontinuity) frag.gap = true;
			else {
				this.backtrack(frag);
				return;
			}
		}
		if (audio) {
			const { startPTS, endPTS, startDTS, endDTS } = audio;
			if (part) part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
				startPTS,
				endPTS,
				startDTS,
				endDTS
			};
			frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
			this.bufferFragmentData(audio, frag, part, chunkMeta);
		}
		if (details && id3 != null && id3.samples.length) {
			const emittedID3 = {
				id,
				frag,
				details,
				samples: id3.samples
			};
			hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
		}
		if (details && text) {
			const emittedText = {
				id,
				frag,
				details,
				samples: text.samples
			};
			hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
		}
	}
	logMuxedErr(frag) {
		this.warn(`${isMediaFragment(frag) ? "Media" : "Init"} segment with muxed audiovideo where only video expected: ${frag.url}`);
	}
	_bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
		if (this.state !== State.PARSING) return;
		this.audioOnly = !!tracks.audio && !tracks.video;
		if (this.altAudio && !this.audioOnly) {
			delete tracks.audio;
			if (tracks.audiovideo) this.logMuxedErr(frag);
		}
		const { audio, video, audiovideo } = tracks;
		if (audio) {
			const levelCodec = currentLevel.audioCodec;
			let audioCodec = pickMostCompleteCodecName(audio.codec, levelCodec);
			if (audioCodec === "mp4a") audioCodec = "mp4a.40.5";
			const ua = navigator.userAgent.toLowerCase();
			if (this.audioCodecSwitch) {
				if (audioCodec) if (audioCodec.indexOf("mp4a.40.5") !== -1) audioCodec = "mp4a.40.2";
				else audioCodec = "mp4a.40.5";
				const audioMetadata = audio.metadata;
				if (audioMetadata && "channelCount" in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf("firefox") === -1) audioCodec = "mp4a.40.5";
			}
			if (audioCodec && audioCodec.indexOf("mp4a.40.5") !== -1 && ua.indexOf("android") !== -1 && audio.container !== "audio/mpeg") {
				audioCodec = "mp4a.40.2";
				this.log(`Android: force audio codec to ${audioCodec}`);
			}
			if (levelCodec && levelCodec !== audioCodec) this.log(`Swapping manifest audio codec "${levelCodec}" for "${audioCodec}"`);
			audio.levelCodec = audioCodec;
			audio.id = PlaylistLevelType.MAIN;
			this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ""}/${levelCodec || ""}/${audio.codec}]`);
			delete tracks.audiovideo;
		}
		if (video) {
			video.levelCodec = currentLevel.videoCodec;
			video.id = PlaylistLevelType.MAIN;
			const parsedVideoCodec = video.codec;
			if ((parsedVideoCodec == null ? void 0 : parsedVideoCodec.length) === 4) switch (parsedVideoCodec) {
				case "hvc1":
				case "hev1":
					video.codec = "hvc1.1.6.L120.90";
					break;
				case "av01":
					video.codec = "av01.0.04M.08";
					break;
				case "avc1":
					video.codec = "avc1.42e01e";
					break;
			}
			this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ""}/${parsedVideoCodec}]${video.codec !== parsedVideoCodec ? " parsed-corrected=" + video.codec : ""}${video.supplemental ? " supplemental=" + video.supplemental : ""}`);
			delete tracks.audiovideo;
		}
		if (audiovideo) {
			this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
			delete tracks.video;
			delete tracks.audio;
		}
		const trackTypes = Object.keys(tracks);
		if (trackTypes.length) {
			this.hls.trigger(Events.BUFFER_CODECS, tracks);
			if (!this.hls) return;
			trackTypes.forEach((trackName) => {
				const initSegment = tracks[trackName].initSegment;
				if (initSegment != null && initSegment.byteLength) this.hls.trigger(Events.BUFFER_APPENDING, {
					type: trackName,
					data: initSegment,
					frag,
					part: null,
					chunkMeta,
					parent: frag.type
				});
			});
		}
		this.tickImmediate();
	}
	getMainFwdBufferInfo() {
		const bufferOutput = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
		return this.getFwdBufferInfo(bufferOutput, PlaylistLevelType.MAIN);
	}
	get maxBufferLength() {
		const { levels, level } = this;
		const levelInfo = levels == null ? void 0 : levels[level];
		if (!levelInfo) return this.config.maxBufferLength;
		return this.getMaxBufferLength(levelInfo.maxBitrate);
	}
	backtrack(frag) {
		this.couldBacktrack = true;
		this.backtrackFragment = frag;
		this.resetTransmuxer();
		this.flushBufferGap(frag);
		this.fragmentTracker.removeFragment(frag);
		this.fragPrevious = null;
		this.nextLoadPosition = frag.start;
		this.state = State.IDLE;
	}
	checkFragmentChanged() {
		const video = this.media;
		let fragPlayingCurrent = null;
		if (video && video.readyState > 1 && video.seeking === false) {
			const currentTime = video.currentTime;
			if (BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getAppendedFrag(currentTime);
			else if (BufferHelper.isBuffered(video, currentTime + .1)) fragPlayingCurrent = this.getAppendedFrag(currentTime + .1);
			if (fragPlayingCurrent) {
				this.backtrackFragment = null;
				const fragPlaying = this.fragPlaying;
				const fragCurrentLevel = fragPlayingCurrent.level;
				if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
					this.fragPlaying = fragPlayingCurrent;
					this.hls.trigger(Events.FRAG_CHANGED, { frag: fragPlayingCurrent });
					if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) this.hls.trigger(Events.LEVEL_SWITCHED, { level: fragCurrentLevel });
				}
			}
		}
	}
	get nextLevel() {
		const frag = this.nextBufferedFrag;
		if (frag) return frag.level;
		return -1;
	}
	get currentFrag() {
		var _this$media2;
		if (this.fragPlaying) return this.fragPlaying;
		const currentTime = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || this.lastCurrentTime;
		if (isFiniteNumber(currentTime)) return this.getAppendedFrag(currentTime);
		return null;
	}
	get currentProgramDateTime() {
		var _this$media3;
		const currentTime = ((_this$media3 = this.media) == null ? void 0 : _this$media3.currentTime) || this.lastCurrentTime;
		if (isFiniteNumber(currentTime)) {
			const details = this.getLevelDetails();
			const frag = this.currentFrag || (details ? findFragmentByPTS(null, details.fragments, currentTime) : null);
			if (frag) {
				const programDateTime = frag.programDateTime;
				if (programDateTime !== null) {
					const epocMs = programDateTime + (currentTime - frag.start) * 1e3;
					return new Date(epocMs);
				}
			}
		}
		return null;
	}
	get currentLevel() {
		const frag = this.currentFrag;
		if (frag) return frag.level;
		return -1;
	}
	get nextBufferedFrag() {
		const frag = this.currentFrag;
		if (frag) return this.followingBufferedFrag(frag);
		return null;
	}
	get forceStartLoad() {
		return this._forceStartLoad;
	}
};
var KeyLoader = class extends Logger {
	constructor(config, logger) {
		super("key-loader", logger);
		this.config = void 0;
		this.keyIdToKeyInfo = {};
		this.emeController = null;
		this.config = config;
	}
	abort(type) {
		for (const id in this.keyIdToKeyInfo) {
			const loader = this.keyIdToKeyInfo[id].loader;
			if (loader) {
				var _loader$context;
				if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) return;
				loader.abort();
			}
		}
	}
	detach() {
		for (const id in this.keyIdToKeyInfo) {
			const keyInfo = this.keyIdToKeyInfo[id];
			if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) delete this.keyIdToKeyInfo[id];
		}
	}
	destroy() {
		this.detach();
		for (const id in this.keyIdToKeyInfo) {
			const loader = this.keyIdToKeyInfo[id].loader;
			if (loader) loader.destroy();
		}
		this.keyIdToKeyInfo = {};
	}
	createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
		return new LoadError({
			type: ErrorTypes.NETWORK_ERROR,
			details,
			fatal: false,
			frag,
			response,
			error,
			networkDetails
		});
	}
	loadClear(loadingFrag, encryptedFragments, startFragRequested) {
		if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
			if (encryptedFragments.length) for (let i = 0, l = encryptedFragments.length; i < l; i++) {
				const frag = encryptedFragments[i];
				if (loadingFrag.cc <= frag.cc && (!isMediaFragment(loadingFrag) || !isMediaFragment(frag) || loadingFrag.sn < frag.sn) || !startFragRequested && i == l - 1) return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat) => {
					if (!this.emeController) return;
					frag.setKeyFormat(keySystemFormat);
					const keySystem = keySystemFormatToKeySystemDomain(keySystemFormat);
					if (keySystem) return this.emeController.getKeySystemAccess([keySystem]);
				});
			}
			if (this.config.requireKeySystemAccessOnStart) {
				const keySystemsInConfig = getKeySystemsForConfig(this.config);
				if (keySystemsInConfig.length) return this.emeController.getKeySystemAccess(keySystemsInConfig);
			}
		}
		return null;
	}
	load(frag) {
		if (!frag.decryptdata && frag.encrypted && this.emeController && this.config.emeEnabled) return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat) => {
			return this.loadInternal(frag, keySystemFormat);
		});
		return this.loadInternal(frag);
	}
	loadInternal(frag, keySystemFormat) {
		var _keyInfo, _keyInfo2;
		if (keySystemFormat) frag.setKeyFormat(keySystemFormat);
		const decryptdata = frag.decryptdata;
		if (!decryptdata) {
			const error = /* @__PURE__ */ new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : `Missing decryption data on fragment in onKeyLoading (emeEnabled with controller: ${this.emeController && this.config.emeEnabled})`);
			return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
		}
		const uri = decryptdata.uri;
		if (!uri) return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, /* @__PURE__ */ new Error(`Invalid key URI: "${uri}"`)));
		const id = getKeyId(decryptdata);
		let keyInfo = this.keyIdToKeyInfo[id];
		if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
			decryptdata.key = keyInfo.decryptdata.key;
			return Promise.resolve({
				frag,
				keyInfo
			});
		}
		if (this.emeController && (_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) switch (this.emeController.getKeyStatus(keyInfo.decryptdata)) {
			case "usable":
			case "usable-in-future": return keyInfo.keyLoadPromise.then((keyLoadedData) => {
				const { keyInfo } = keyLoadedData;
				decryptdata.key = keyInfo.decryptdata.key;
				return {
					frag,
					keyInfo
				};
			});
		}
		this.log(`${this.keyIdToKeyInfo[id] ? "Rel" : "L"}oading${decryptdata.keyId ? " keyId: " + arrayToHex(decryptdata.keyId) : ""} URI: ${decryptdata.uri} from ${frag.type} ${frag.level}`);
		keyInfo = this.keyIdToKeyInfo[id] = {
			decryptdata,
			keyLoadPromise: null,
			loader: null,
			mediaKeySessionContext: null
		};
		switch (decryptdata.method) {
			case "SAMPLE-AES":
			case "SAMPLE-AES-CENC":
			case "SAMPLE-AES-CTR":
				if (decryptdata.keyFormat === "identity") return this.loadKeyHTTP(keyInfo, frag);
				return this.loadKeyEME(keyInfo, frag);
			case "AES-128":
			case "AES-256":
			case "AES-256-CTR": return this.loadKeyHTTP(keyInfo, frag);
			default: return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, /* @__PURE__ */ new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
		}
	}
	loadKeyEME(keyInfo, frag) {
		const keyLoadedData = {
			frag,
			keyInfo
		};
		if (this.emeController && this.config.emeEnabled) {
			var _frag$initSegment;
			if (!keyInfo.decryptdata.keyId && (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data) {
				const keyIds = parseKeyIdsFromTenc(frag.initSegment.data);
				if (keyIds.length) {
					let keyId = keyIds[0];
					if (keyId.some((b) => b !== 0)) {
						this.log(`Using keyId found in init segment ${arrayToHex(keyId)}`);
						LevelKey.setKeyIdForUri(keyInfo.decryptdata.uri, keyId);
					} else {
						keyId = LevelKey.addKeyIdForUri(keyInfo.decryptdata.uri);
						this.log(`Generating keyId to patch media ${arrayToHex(keyId)}`);
					}
					keyInfo.decryptdata.keyId = keyId;
				}
			}
			if (!keyInfo.decryptdata.keyId && !isMediaFragment(frag)) return Promise.resolve(keyLoadedData);
			return (keyInfo.keyLoadPromise = this.emeController.loadKey(keyLoadedData).then((keySessionContext) => {
				keyInfo.mediaKeySessionContext = keySessionContext;
				return keyLoadedData;
			})).catch((error) => {
				keyInfo.keyLoadPromise = null;
				if ("data" in error) error.data.frag = frag;
				throw error;
			});
		}
		return Promise.resolve(keyLoadedData);
	}
	loadKeyHTTP(keyInfo, frag) {
		const config = this.config;
		const Loader = config.loader;
		const keyLoader = new Loader(config);
		frag.keyLoader = keyInfo.loader = keyLoader;
		return keyInfo.keyLoadPromise = new Promise((resolve, reject) => {
			const loaderContext = {
				keyInfo,
				frag,
				responseType: "arraybuffer",
				url: keyInfo.decryptdata.uri
			};
			const loadPolicy = config.keyLoadPolicy.default;
			const loaderConfig = {
				loadPolicy,
				timeout: loadPolicy.maxLoadTimeMs,
				maxRetry: 0,
				retryDelay: 0,
				maxRetryDelay: 0
			};
			keyLoader.load(loaderContext, loaderConfig, {
				onSuccess: (response, stats, context, networkDetails) => {
					const { frag, keyInfo } = context;
					const id = getKeyId(keyInfo.decryptdata);
					if (!frag.decryptdata || keyInfo !== this.keyIdToKeyInfo[id]) return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, /* @__PURE__ */ new Error("after key load, decryptdata unset or changed"), networkDetails));
					keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);
					frag.keyLoader = null;
					keyInfo.loader = null;
					resolve({
						frag,
						keyInfo
					});
				},
				onError: (response, context, networkDetails, stats) => {
					this.resetLoader(context);
					reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, /* @__PURE__ */ new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
						url: loaderContext.url,
						data: void 0
					}, response)));
				},
				onTimeout: (stats, context, networkDetails) => {
					this.resetLoader(context);
					reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, /* @__PURE__ */ new Error("key loading timed out"), networkDetails));
				},
				onAbort: (stats, context, networkDetails) => {
					this.resetLoader(context);
					reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, /* @__PURE__ */ new Error("key loading aborted"), networkDetails));
				}
			});
		});
	}
	resetLoader(context) {
		const { frag, keyInfo, url: uri } = context;
		const loader = keyInfo.loader;
		if (frag.keyLoader === loader) {
			frag.keyLoader = null;
			keyInfo.loader = null;
		}
		const id = getKeyId(keyInfo.decryptdata) || uri;
		delete this.keyIdToKeyInfo[id];
		if (loader) loader.destroy();
	}
};
function getKeyId(decryptdata) {
	if (decryptdata.keyFormat !== KeySystemFormats.FAIRPLAY) {
		const keyId = decryptdata.keyId;
		if (keyId) return arrayToHex(keyId);
	}
	return decryptdata.uri;
}
function mapContextToLevelType(context) {
	const { type } = context;
	switch (type) {
		case PlaylistContextType.AUDIO_TRACK: return PlaylistLevelType.AUDIO;
		case PlaylistContextType.SUBTITLE_TRACK: return PlaylistLevelType.SUBTITLE;
		default: return PlaylistLevelType.MAIN;
	}
}
function getResponseUrl(response, context) {
	let url = response.url;
	if (url === void 0 || url.indexOf("data:") === 0) url = context.url;
	return url;
}
var PlaylistLoader = class {
	constructor(hls) {
		this.hls = void 0;
		this.loaders = Object.create(null);
		this.variableList = null;
		this.onManifestLoaded = this.checkAutostartLoad;
		this.hls = hls;
		this.registerListeners();
	}
	startLoad(startPosition) {}
	stopLoad() {
		this.destroyInternalLoaders();
	}
	registerListeners() {
		const { hls } = this;
		hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
		hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
		hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
	}
	unregisterListeners() {
		const { hls } = this;
		hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
		hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
		hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
		hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
		hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
	}
	/**
	* Returns defaults or configured loader-type overloads (pLoader and loader config params)
	*/
	createInternalLoader(context) {
		const config = this.hls.config;
		const PLoader = config.pLoader;
		const Loader = config.loader;
		const loader = new (PLoader || Loader)(config);
		this.loaders[context.type] = loader;
		return loader;
	}
	getInternalLoader(context) {
		return this.loaders[context.type];
	}
	resetInternalLoader(contextType) {
		if (this.loaders[contextType]) delete this.loaders[contextType];
	}
	/**
	* Call `destroy` on all internal loader instances mapped (one per context type)
	*/
	destroyInternalLoaders() {
		for (const contextType in this.loaders) {
			const loader = this.loaders[contextType];
			if (loader) loader.destroy();
			this.resetInternalLoader(contextType);
		}
	}
	destroy() {
		this.variableList = null;
		this.unregisterListeners();
		this.destroyInternalLoaders();
	}
	onManifestLoading(event, data) {
		const { url } = data;
		this.variableList = null;
		this.load({
			id: null,
			level: 0,
			responseType: "text",
			type: PlaylistContextType.MANIFEST,
			url,
			deliveryDirectives: null,
			levelOrTrack: null
		});
	}
	onLevelLoading(event, data) {
		const { id, level, pathwayId, url, deliveryDirectives, levelInfo } = data;
		this.load({
			id,
			level,
			pathwayId,
			responseType: "text",
			type: PlaylistContextType.LEVEL,
			url,
			deliveryDirectives,
			levelOrTrack: levelInfo
		});
	}
	onAudioTrackLoading(event, data) {
		const { id, groupId, url, deliveryDirectives, track } = data;
		this.load({
			id,
			groupId,
			level: null,
			responseType: "text",
			type: PlaylistContextType.AUDIO_TRACK,
			url,
			deliveryDirectives,
			levelOrTrack: track
		});
	}
	onSubtitleTrackLoading(event, data) {
		const { id, groupId, url, deliveryDirectives, track } = data;
		this.load({
			id,
			groupId,
			level: null,
			responseType: "text",
			type: PlaylistContextType.SUBTITLE_TRACK,
			url,
			deliveryDirectives,
			levelOrTrack: track
		});
	}
	onLevelsUpdated(event, data) {
		const loader = this.loaders[PlaylistContextType.LEVEL];
		if (loader) {
			const context = loader.context;
			if (context && !data.levels.some((lvl) => lvl === context.levelOrTrack)) {
				loader.abort();
				delete this.loaders[PlaylistContextType.LEVEL];
			}
		}
	}
	load(context) {
		var _context$deliveryDire;
		const config = this.hls.config;
		let loader = this.getInternalLoader(context);
		if (loader) {
			const logger = this.hls.logger;
			const loaderContext = loader.context;
			if (loaderContext && loaderContext.levelOrTrack === context.levelOrTrack && (loaderContext.url === context.url || loaderContext.deliveryDirectives && !context.deliveryDirectives)) {
				if (loaderContext.url === context.url) logger.log(`[playlist-loader]: ignore ${context.url} ongoing request`);
				else logger.log(`[playlist-loader]: ignore ${context.url} in favor of ${loaderContext.url}`);
				return;
			}
			logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
			loader.abort();
		}
		let loadPolicy;
		if (context.type === PlaylistContextType.MANIFEST) loadPolicy = config.manifestLoadPolicy.default;
		else loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
			timeoutRetry: null,
			errorRetry: null
		});
		loader = this.createInternalLoader(context);
		if (isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
			let levelDetails;
			if (context.type === PlaylistContextType.LEVEL && context.level !== null) levelDetails = this.hls.levels[context.level].details;
			else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) levelDetails = this.hls.audioTracks[context.id].details;
			else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) levelDetails = this.hls.subtitleTracks[context.id].details;
			if (levelDetails) {
				const partTarget = levelDetails.partTarget;
				const targetDuration = levelDetails.targetduration;
				if (partTarget && targetDuration) {
					const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * .8) * 1e3;
					loadPolicy = _extends({}, loadPolicy, {
						maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
						maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
					});
				}
			}
		}
		const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
		const loaderConfig = {
			loadPolicy,
			timeout: loadPolicy.maxLoadTimeMs,
			maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
			retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
			maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
		};
		loader.load(context, loaderConfig, {
			onSuccess: (response, stats, context, networkDetails) => {
				const loader = this.getInternalLoader(context);
				this.resetInternalLoader(context.type);
				const string = response.data;
				stats.parsing.start = performance.now();
				if (M3U8Parser.isMediaPlaylist(string) || context.type !== PlaylistContextType.MANIFEST) this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
				else this.handleMasterPlaylist(response, stats, context, networkDetails);
			},
			onError: (response, context, networkDetails, stats) => {
				this.handleNetworkError(context, networkDetails, false, response, stats);
			},
			onTimeout: (stats, context, networkDetails) => {
				this.handleNetworkError(context, networkDetails, true, void 0, stats);
			}
		});
	}
	checkAutostartLoad() {
		if (!this.hls) return;
		const { config: { autoStartLoad, startPosition }, forceStartLoad } = this.hls;
		if (autoStartLoad || forceStartLoad) {
			this.hls.logger.log(`${autoStartLoad ? "auto" : "force"} startLoad with configured startPosition ${startPosition}`);
			this.hls.startLoad(startPosition);
		}
	}
	handleMasterPlaylist(response, stats, context, networkDetails) {
		const hls = this.hls;
		const string = response.data;
		const url = getResponseUrl(response, context);
		const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
		if (parsedResult.playlistParsingError) {
			stats.parsing.end = performance.now();
			this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
			return;
		}
		const { contentSteering, levels, sessionData, sessionKeys, startTimeOffset, variableList } = parsedResult;
		this.variableList = variableList;
		levels.forEach((levelParsed) => {
			const { unknownCodecs } = levelParsed;
			if (unknownCodecs) {
				const { preferManagedMediaSource } = this.hls.config;
				let { audioCodec, videoCodec } = levelParsed;
				for (let i = unknownCodecs.length; i--;) {
					const unknownCodec = unknownCodecs[i];
					if (areCodecsMediaSourceSupported(unknownCodec, "audio", preferManagedMediaSource)) {
						levelParsed.audioCodec = audioCodec = audioCodec ? `${audioCodec},${unknownCodec}` : unknownCodec;
						sampleEntryCodesISO.audio[audioCodec.substring(0, 4)] = 2;
						unknownCodecs.splice(i, 1);
					} else if (areCodecsMediaSourceSupported(unknownCodec, "video", preferManagedMediaSource)) {
						levelParsed.videoCodec = videoCodec = videoCodec ? `${videoCodec},${unknownCodec}` : unknownCodec;
						sampleEntryCodesISO.video[videoCodec.substring(0, 4)] = 2;
						unknownCodecs.splice(i, 1);
					}
				}
			}
		});
		const { AUDIO: audioTracks = [], SUBTITLES: subtitles, "CLOSED-CAPTIONS": captions } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
		if (audioTracks.length) {
			if (!audioTracks.some((audioTrack) => !audioTrack.url) && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
				this.hls.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one");
				audioTracks.unshift({
					type: "main",
					name: "main",
					groupId: "main",
					default: false,
					autoselect: false,
					forced: false,
					id: -1,
					attrs: new AttrList({}),
					bitrate: 0,
					url: ""
				});
			}
		}
		hls.trigger(Events.MANIFEST_LOADED, {
			levels,
			audioTracks,
			subtitles,
			captions,
			contentSteering,
			url,
			stats,
			networkDetails,
			sessionData,
			sessionKeys,
			startTimeOffset,
			variableList
		});
	}
	handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
		const hls = this.hls;
		const { id, level, type } = context;
		const url = getResponseUrl(response, context);
		const levelId = isFiniteNumber(level) ? level : isFiniteNumber(id) ? id : 0;
		const levelType = mapContextToLevelType(context);
		const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, 0, this.variableList);
		if (type === PlaylistContextType.MANIFEST) {
			const singleLevel = {
				attrs: new AttrList({}),
				bitrate: 0,
				details: levelDetails,
				name: "",
				url
			};
			levelDetails.requestScheduled = stats.loading.start + computeReloadInterval(levelDetails, 0);
			hls.trigger(Events.MANIFEST_LOADED, {
				levels: [singleLevel],
				audioTracks: [],
				url,
				stats,
				networkDetails,
				sessionData: null,
				sessionKeys: null,
				contentSteering: null,
				startTimeOffset: null,
				variableList: null
			});
		}
		stats.parsing.end = performance.now();
		context.levelDetails = levelDetails;
		this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
	}
	handleManifestParsingError(response, context, error, networkDetails, stats) {
		this.hls.trigger(Events.ERROR, {
			type: ErrorTypes.NETWORK_ERROR,
			details: ErrorDetails.MANIFEST_PARSING_ERROR,
			fatal: context.type === PlaylistContextType.MANIFEST,
			url: response.url,
			err: error,
			error,
			reason: error.message,
			response,
			context,
			networkDetails,
			stats
		});
	}
	handleNetworkError(context, networkDetails, timeout = false, response, stats) {
		let message = `A network ${timeout ? "timeout" : "error" + (response ? " (status " + response.code + ")" : "")} occurred while loading ${context.type}`;
		if (context.type === PlaylistContextType.LEVEL) message += `: ${context.level} id: ${context.id}`;
		else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) message += ` id: ${context.id} group-id: "${context.groupId}"`;
		const error = new Error(message);
		this.hls.logger.warn(`[playlist-loader]: ${message}`);
		let details = ErrorDetails.UNKNOWN;
		let fatal = false;
		const loader = this.getInternalLoader(context);
		switch (context.type) {
			case PlaylistContextType.MANIFEST:
				details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
				fatal = true;
				break;
			case PlaylistContextType.LEVEL:
				details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
				fatal = false;
				break;
			case PlaylistContextType.AUDIO_TRACK:
				details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
				fatal = false;
				break;
			case PlaylistContextType.SUBTITLE_TRACK:
				details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
				fatal = false;
				break;
		}
		if (loader) this.resetInternalLoader(context.type);
		const errorData = {
			type: ErrorTypes.NETWORK_ERROR,
			details,
			fatal,
			url: context.url,
			loader,
			context,
			error,
			networkDetails,
			stats
		};
		if (response) errorData.response = _objectSpread2({
			url: (networkDetails == null ? void 0 : networkDetails.url) || context.url,
			data: void 0
		}, response);
		this.hls.trigger(Events.ERROR, errorData);
	}
	handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
		const hls = this.hls;
		const { type, level, levelOrTrack, id, groupId, deliveryDirectives } = context;
		const url = getResponseUrl(response, context);
		const parent = mapContextToLevelType(context);
		let levelIndex = typeof context.level === "number" && parent === PlaylistLevelType.MAIN ? level : void 0;
		const error = levelDetails.playlistParsingError;
		if (error) {
			this.hls.logger.warn(`${error} ${levelDetails.url}`);
			if (!hls.config.ignorePlaylistParsingErrors) {
				hls.trigger(Events.ERROR, {
					type: ErrorTypes.NETWORK_ERROR,
					details: ErrorDetails.LEVEL_PARSING_ERROR,
					fatal: false,
					url,
					error,
					reason: error.message,
					response,
					context,
					level: levelIndex,
					parent,
					networkDetails,
					stats
				});
				return;
			}
			levelDetails.playlistParsingError = null;
		}
		if (!levelDetails.fragments.length) {
			const _error = levelDetails.playlistParsingError = /* @__PURE__ */ new Error("No Segments found in Playlist");
			hls.trigger(Events.ERROR, {
				type: ErrorTypes.NETWORK_ERROR,
				details: ErrorDetails.LEVEL_EMPTY_ERROR,
				fatal: false,
				url,
				error: _error,
				reason: _error.message,
				response,
				context,
				level: levelIndex,
				parent,
				networkDetails,
				stats
			});
			return;
		}
		if (levelDetails.live && loader) {
			if (loader.getCacheAge) levelDetails.ageHeader = loader.getCacheAge() || 0;
			if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) levelDetails.ageHeader = 0;
		}
		switch (type) {
			case PlaylistContextType.MANIFEST:
			case PlaylistContextType.LEVEL:
				if (levelIndex) {
					if (!levelOrTrack) levelIndex = 0;
					else if (levelOrTrack !== hls.levels[levelIndex]) {
						const updatedIndex = hls.levels.indexOf(levelOrTrack);
						if (updatedIndex > -1) levelIndex = updatedIndex;
					}
				}
				hls.trigger(Events.LEVEL_LOADED, {
					details: levelDetails,
					levelInfo: levelOrTrack || hls.levels[0],
					level: levelIndex || 0,
					id: id || 0,
					stats,
					networkDetails,
					deliveryDirectives,
					withoutMultiVariant: type === PlaylistContextType.MANIFEST
				});
				break;
			case PlaylistContextType.AUDIO_TRACK:
				hls.trigger(Events.AUDIO_TRACK_LOADED, {
					details: levelDetails,
					track: levelOrTrack,
					id: id || 0,
					groupId: groupId || "",
					stats,
					networkDetails,
					deliveryDirectives
				});
				break;
			case PlaylistContextType.SUBTITLE_TRACK:
				hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
					details: levelDetails,
					track: levelOrTrack,
					id: id || 0,
					groupId: groupId || "",
					stats,
					networkDetails,
					deliveryDirectives
				});
				break;
		}
	}
};
/**
* The `Hls` class is the core of the HLS.js library used to instantiate player instances.
* @public
*/
var Hls = class Hls {
	/**
	* Get the video-dev/hls.js package version.
	*/
	static get version() {
		return version;
	}
	/**
	* Check if the required MediaSource Extensions are available.
	*/
	static isMSESupported() {
		return isMSESupported();
	}
	/**
	* Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
	*/
	static isSupported() {
		return isSupported();
	}
	/**
	* Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
	*/
	static getMediaSource() {
		return getMediaSource();
	}
	static get Events() {
		return Events;
	}
	static get MetadataSchema() {
		return MetadataSchema;
	}
	static get ErrorTypes() {
		return ErrorTypes;
	}
	static get ErrorDetails() {
		return ErrorDetails;
	}
	/**
	* Get the default configuration applied to new instances.
	*/
	static get DefaultConfig() {
		if (!Hls.defaultConfig) return hlsDefaultConfig;
		return Hls.defaultConfig;
	}
	/**
	* Replace the default configuration applied to new instances.
	*/
	static set DefaultConfig(defaultConfig) {
		Hls.defaultConfig = defaultConfig;
	}
	/**
	* Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
	* @param userConfig - Configuration options applied over `Hls.DefaultConfig`
	*/
	constructor(userConfig = {}) {
		/**
		* The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
		*/
		this.config = void 0;
		/**
		* The configuration object provided on player instantiation.
		*/
		this.userConfig = void 0;
		/**
		* The logger functions used by this player instance, configured on player instantiation.
		*/
		this.logger = void 0;
		this.coreComponents = void 0;
		this.networkControllers = void 0;
		this._emitter = new EventEmitter$1();
		this._autoLevelCapping = -1;
		this._maxHdcpLevel = null;
		this.abrController = void 0;
		this.bufferController = void 0;
		this.capLevelController = void 0;
		this.latencyController = void 0;
		this.levelController = void 0;
		this.streamController = void 0;
		this.audioStreamController = void 0;
		this.subtititleStreamController = void 0;
		this.audioTrackController = void 0;
		this.subtitleTrackController = void 0;
		this.interstitialsController = void 0;
		this.gapController = void 0;
		this.emeController = void 0;
		this.cmcdController = void 0;
		this._media = null;
		this._url = null;
		this._sessionId = void 0;
		this.triggeringException = void 0;
		this.started = false;
		const logger = this.logger = enableLogs(userConfig.debug || false, "Hls instance", userConfig.assetPlayerId);
		const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig, logger);
		this.userConfig = userConfig;
		if (config.progressive) enableStreamingMode(config, logger);
		const { abrController: _AbrController, bufferController: _BufferController, capLevelController: _CapLevelController, errorController: _ErrorController, fpsController: _FpsController } = config;
		const errorController = new _ErrorController(this);
		const abrController = this.abrController = new _AbrController(this);
		const fragmentTracker = new FragmentTracker(this);
		const _InterstitialsController = config.interstitialsController;
		const interstitialsController = _InterstitialsController ? this.interstitialsController = new _InterstitialsController(this, Hls) : null;
		const bufferController = this.bufferController = new _BufferController(this, fragmentTracker);
		const capLevelController = this.capLevelController = new _CapLevelController(this);
		const fpsController = new _FpsController(this);
		const playListLoader = new PlaylistLoader(this);
		const _ContentSteeringController = config.contentSteeringController;
		const contentSteering = _ContentSteeringController ? new _ContentSteeringController(this) : null;
		const levelController = this.levelController = new LevelController(this, contentSteering);
		const id3TrackController = new ID3TrackController(this);
		const keyLoader = new KeyLoader(this.config, this.logger);
		const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);
		const gapController = this.gapController = new GapController(this, fragmentTracker);
		capLevelController.setStreamController(streamController);
		fpsController.setStreamController(streamController);
		const networkControllers = [
			playListLoader,
			levelController,
			streamController
		];
		if (interstitialsController) networkControllers.splice(1, 0, interstitialsController);
		if (contentSteering) networkControllers.splice(1, 0, contentSteering);
		this.networkControllers = networkControllers;
		const coreComponents = [
			abrController,
			bufferController,
			gapController,
			capLevelController,
			fpsController,
			id3TrackController,
			fragmentTracker
		];
		this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
		const AudioStreamControllerClass = config.audioStreamController;
		if (AudioStreamControllerClass) networkControllers.push(this.audioStreamController = new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
		this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
		const SubtitleStreamControllerClass = config.subtitleStreamController;
		if (SubtitleStreamControllerClass) networkControllers.push(this.subtititleStreamController = new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
		this.createController(config.timelineController, coreComponents);
		keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
		this.cmcdController = this.createController(config.cmcdController, coreComponents);
		this.latencyController = this.createController(LatencyController, coreComponents);
		this.coreComponents = coreComponents;
		networkControllers.push(errorController);
		const onErrorOut = errorController.onErrorOut;
		if (typeof onErrorOut === "function") this.on(Events.ERROR, onErrorOut, errorController);
		this.on(Events.MANIFEST_LOADED, playListLoader.onManifestLoaded, playListLoader);
	}
	createController(ControllerClass, components) {
		if (ControllerClass) {
			const controllerInstance = new ControllerClass(this);
			if (components) components.push(controllerInstance);
			return controllerInstance;
		}
		return null;
	}
	on(event, listener, context = this) {
		this._emitter.on(event, listener, context);
	}
	once(event, listener, context = this) {
		this._emitter.once(event, listener, context);
	}
	removeAllListeners(event) {
		this._emitter.removeAllListeners(event);
	}
	off(event, listener, context = this, once) {
		this._emitter.off(event, listener, context, once);
	}
	listeners(event) {
		return this._emitter.listeners(event);
	}
	emit(event, name, eventObject) {
		return this._emitter.emit(event, name, eventObject);
	}
	trigger(event, eventObject) {
		if (this.config.debug) return this.emit(event, event, eventObject);
		else try {
			return this.emit(event, event, eventObject);
		} catch (error) {
			this.logger.error("An internal error happened while handling event " + event + ". Error message: \"" + error.message + "\". Here is a stacktrace:", error);
			if (!this.triggeringException) {
				this.triggeringException = true;
				const fatal = event === Events.ERROR;
				this.trigger(Events.ERROR, {
					type: ErrorTypes.OTHER_ERROR,
					details: ErrorDetails.INTERNAL_EXCEPTION,
					fatal,
					event,
					error
				});
				this.triggeringException = false;
			}
		}
		return false;
	}
	listenerCount(event) {
		return this._emitter.listenerCount(event);
	}
	/**
	* Dispose of the instance
	*/
	destroy() {
		this.logger.log("destroy");
		this.trigger(Events.DESTROYING, void 0);
		this.detachMedia();
		this.removeAllListeners();
		this._autoLevelCapping = -1;
		this._url = null;
		this.networkControllers.forEach((component) => component.destroy());
		this.networkControllers.length = 0;
		this.coreComponents.forEach((component) => component.destroy());
		this.coreComponents.length = 0;
		const config = this.config;
		config.xhrSetup = config.fetchSetup = void 0;
		this.userConfig = null;
	}
	/**
	* Attaches Hls.js to a media element
	*/
	attachMedia(data) {
		if (!data || "media" in data && !data.media) {
			const error = /* @__PURE__ */ new Error(`attachMedia failed: invalid argument (${data})`);
			this.trigger(Events.ERROR, {
				type: ErrorTypes.OTHER_ERROR,
				details: ErrorDetails.ATTACH_MEDIA_ERROR,
				fatal: true,
				error
			});
			return;
		}
		this.logger.log(`attachMedia`);
		if (this._media) {
			this.logger.warn(`media must be detached before attaching`);
			this.detachMedia();
		}
		const attachMediaSource = "media" in data;
		const media = attachMediaSource ? data.media : data;
		const attachingData = attachMediaSource ? data : { media };
		this._media = media;
		this.trigger(Events.MEDIA_ATTACHING, attachingData);
	}
	/**
	* Detach Hls.js from the media
	*/
	detachMedia() {
		this.logger.log("detachMedia");
		this.trigger(Events.MEDIA_DETACHING, {});
		this._media = null;
	}
	/**
	* Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
	*/
	transferMedia() {
		this._media = null;
		const transferMedia = this.bufferController.transferMedia();
		this.trigger(Events.MEDIA_DETACHING, { transferMedia });
		return transferMedia;
	}
	/**
	* Set the source URL. Can be relative or absolute.
	*/
	loadSource(url) {
		this.stopLoad();
		const media = this.media;
		const loadedSource = this._url;
		const loadingSource = this._url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, { alwaysNormalize: true });
		this._autoLevelCapping = -1;
		this._maxHdcpLevel = null;
		this.logger.log(`loadSource:${loadingSource}`);
		if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
			this.detachMedia();
			this.attachMedia(media);
		}
		this.trigger(Events.MANIFEST_LOADING, { url });
	}
	/**
	* Gets the currently loaded URL
	*/
	get url() {
		return this._url;
	}
	/**
	* Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
	*/
	get hasEnoughToStart() {
		return this.streamController.hasEnoughToStart;
	}
	/**
	* Get the startPosition set on startLoad(position) or on autostart with config.startPosition
	*/
	get startPosition() {
		return this.streamController.startPositionValue;
	}
	/**
	* Start loading data from the stream source.
	* Depending on default config, client starts loading automatically when a source is set.
	*
	* @param startPosition - Set the start position to stream from.
	* Defaults to -1 (None: starts from earliest point)
	*/
	startLoad(startPosition = -1, skipSeekToStartPosition) {
		this.logger.log(`startLoad(${startPosition + (skipSeekToStartPosition ? ", <skip seek to start>" : "")})`);
		this.started = true;
		this.resumeBuffering();
		for (let i = 0; i < this.networkControllers.length; i++) {
			this.networkControllers[i].startLoad(startPosition, skipSeekToStartPosition);
			if (!this.started || !this.networkControllers) break;
		}
	}
	/**
	* Stop loading of any stream data.
	*/
	stopLoad() {
		this.logger.log("stopLoad");
		this.started = false;
		for (let i = 0; i < this.networkControllers.length; i++) {
			this.networkControllers[i].stopLoad();
			if (this.started || !this.networkControllers) break;
		}
	}
	/**
	* Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
	*/
	get loadingEnabled() {
		return this.started;
	}
	/**
	* Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
	*/
	get bufferingEnabled() {
		return this.streamController.bufferingEnabled;
	}
	/**
	* Resumes stream controller segment loading after `pauseBuffering` has been called.
	*/
	resumeBuffering() {
		if (!this.bufferingEnabled) {
			this.logger.log(`resume buffering`);
			this.networkControllers.forEach((controller) => {
				if (controller.resumeBuffering) controller.resumeBuffering();
			});
		}
	}
	/**
	* Prevents stream controller from loading new segments until `resumeBuffering` is called.
	* This allows for media buffering to be paused without interupting playlist loading.
	*/
	pauseBuffering() {
		if (this.bufferingEnabled) {
			this.logger.log(`pause buffering`);
			this.networkControllers.forEach((controller) => {
				if (controller.pauseBuffering) controller.pauseBuffering();
			});
		}
	}
	get inFlightFragments() {
		const inFlightData = { [PlaylistLevelType.MAIN]: this.streamController.inFlightFrag };
		if (this.audioStreamController) inFlightData[PlaylistLevelType.AUDIO] = this.audioStreamController.inFlightFrag;
		if (this.subtititleStreamController) inFlightData[PlaylistLevelType.SUBTITLE] = this.subtititleStreamController.inFlightFrag;
		return inFlightData;
	}
	/**
	* Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
	*/
	swapAudioCodec() {
		this.logger.log("swapAudioCodec");
		this.streamController.swapAudioCodec();
	}
	/**
	* When the media-element fails, this allows to detach and then re-attach it
	* as one call (convenience method).
	*
	* Automatic recovery of media-errors by this process is configurable.
	*/
	recoverMediaError() {
		this.logger.log("recoverMediaError");
		const media = this._media;
		const time = media == null ? void 0 : media.currentTime;
		this.detachMedia();
		if (media) {
			this.attachMedia(media);
			if (time) this.startLoad(time);
		}
	}
	removeLevel(levelIndex) {
		this.levelController.removeLevel(levelIndex);
	}
	/**
	* @returns a UUID for this player instance
	*/
	get sessionId() {
		let _sessionId = this._sessionId;
		if (!_sessionId) _sessionId = this._sessionId = uuid();
		return _sessionId;
	}
	/**
	* @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
	*/
	get levels() {
		const levels = this.levelController.levels;
		return levels ? levels : [];
	}
	/**
	* @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
	*/
	get latestLevelDetails() {
		return this.streamController.getLevelDetails() || null;
	}
	/**
	* @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
	*/
	get loadLevelObj() {
		return this.levelController.loadLevelObj;
	}
	/**
	* Index of quality level (variant) currently played
	*/
	get currentLevel() {
		return this.streamController.currentLevel;
	}
	/**
	* Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
	*/
	set currentLevel(newLevel) {
		this.logger.log(`set currentLevel:${newLevel}`);
		this.levelController.manualLevel = newLevel;
		this.streamController.immediateLevelSwitch();
	}
	/**
	* Index of next quality level loaded as scheduled by stream controller.
	*/
	get nextLevel() {
		return this.streamController.nextLevel;
	}
	/**
	* Set quality level index for next loaded data.
	* This will switch the video quality asap, without interrupting playback.
	* May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
	* @param newLevel - Pass -1 for automatic level selection
	*/
	set nextLevel(newLevel) {
		this.logger.log(`set nextLevel:${newLevel}`);
		this.levelController.manualLevel = newLevel;
		this.streamController.nextLevelSwitch();
	}
	/**
	* Return the quality level of the currently or last (of none is loaded currently) segment
	*/
	get loadLevel() {
		return this.levelController.level;
	}
	/**
	* Set quality level index for next loaded data in a conservative way.
	* This will switch the quality without flushing, but interrupt current loading.
	* Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
	* @param newLevel - Pass -1 for automatic level selection
	*/
	set loadLevel(newLevel) {
		this.logger.log(`set loadLevel:${newLevel}`);
		this.levelController.manualLevel = newLevel;
	}
	/**
	* get next quality level loaded
	*/
	get nextLoadLevel() {
		return this.levelController.nextLoadLevel;
	}
	/**
	* Set quality level of next loaded segment in a fully "non-destructive" way.
	* Same as `loadLevel` but will wait for next switch (until current loading is done).
	*/
	set nextLoadLevel(level) {
		this.levelController.nextLoadLevel = level;
	}
	/**
	* Return "first level": like a default level, if not set,
	* falls back to index of first level referenced in manifest
	*/
	get firstLevel() {
		return Math.max(this.levelController.firstLevel, this.minAutoLevel);
	}
	/**
	* Sets "first-level", see getter.
	*/
	set firstLevel(newLevel) {
		this.logger.log(`set firstLevel:${newLevel}`);
		this.levelController.firstLevel = newLevel;
	}
	/**
	* Return the desired start level for the first fragment that will be loaded.
	* The default value of -1 indicates automatic start level selection.
	* Setting hls.nextAutoLevel without setting a startLevel will result in
	* the nextAutoLevel value being used for one fragment load.
	*/
	get startLevel() {
		const startLevel = this.levelController.startLevel;
		if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) return this.abrController.forcedAutoLevel;
		return startLevel;
	}
	/**
	* set  start level (level of first fragment that will be played back)
	* if not overrided by user, first level appearing in manifest will be used as start level
	* if -1 : automatic start level selection, playback will start from level matching download bandwidth
	* (determined from download of first segment)
	*/
	set startLevel(newLevel) {
		this.logger.log(`set startLevel:${newLevel}`);
		if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
		this.levelController.startLevel = newLevel;
	}
	/**
	* Whether level capping is enabled.
	* Default value is set via `config.capLevelToPlayerSize`.
	*/
	get capLevelToPlayerSize() {
		return this.config.capLevelToPlayerSize;
	}
	/**
	* Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
	*/
	set capLevelToPlayerSize(shouldStartCapping) {
		const newCapLevelToPlayerSize = !!shouldStartCapping;
		if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
			if (newCapLevelToPlayerSize) this.capLevelController.startCapping();
			else {
				this.capLevelController.stopCapping();
				this.autoLevelCapping = -1;
				this.streamController.nextLevelSwitch();
			}
			this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
		}
	}
	/**
	* Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
	*/
	get autoLevelCapping() {
		return this._autoLevelCapping;
	}
	/**
	* Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
	*/
	get bandwidthEstimate() {
		const { bwEstimator } = this.abrController;
		if (!bwEstimator) return NaN;
		return bwEstimator.getEstimate();
	}
	set bandwidthEstimate(abrEwmaDefaultEstimate) {
		this.abrController.resetEstimator(abrEwmaDefaultEstimate);
	}
	get abrEwmaDefaultEstimate() {
		const { bwEstimator } = this.abrController;
		if (!bwEstimator) return NaN;
		return bwEstimator.defaultEstimate;
	}
	/**
	* get time to first byte estimate
	* @type {number}
	*/
	get ttfbEstimate() {
		const { bwEstimator } = this.abrController;
		if (!bwEstimator) return NaN;
		return bwEstimator.getEstimateTTFB();
	}
	/**
	* Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
	*/
	set autoLevelCapping(newLevel) {
		if (this._autoLevelCapping !== newLevel) {
			this.logger.log(`set autoLevelCapping:${newLevel}`);
			this._autoLevelCapping = newLevel;
			this.levelController.checkMaxAutoUpdated();
		}
	}
	get maxHdcpLevel() {
		return this._maxHdcpLevel;
	}
	set maxHdcpLevel(value) {
		if (isHdcpLevel(value) && this._maxHdcpLevel !== value) {
			this._maxHdcpLevel = value;
			this.levelController.checkMaxAutoUpdated();
		}
	}
	/**
	* True when automatic level selection enabled
	*/
	get autoLevelEnabled() {
		return this.levelController.manualLevel === -1;
	}
	/**
	* Level set manually (if any)
	*/
	get manualLevel() {
		return this.levelController.manualLevel;
	}
	/**
	* min level selectable in auto mode according to config.minAutoBitrate
	*/
	get minAutoLevel() {
		const { levels, config: { minAutoBitrate } } = this;
		if (!levels) return 0;
		const len = levels.length;
		for (let i = 0; i < len; i++) if (levels[i].maxBitrate >= minAutoBitrate) return i;
		return 0;
	}
	/**
	* max level selectable in auto mode according to autoLevelCapping
	*/
	get maxAutoLevel() {
		const { levels, autoLevelCapping, maxHdcpLevel } = this;
		let maxAutoLevel;
		if (autoLevelCapping === -1 && levels != null && levels.length) maxAutoLevel = levels.length - 1;
		else maxAutoLevel = autoLevelCapping;
		if (maxHdcpLevel) for (let i = maxAutoLevel; i--;) {
			const hdcpLevel = levels[i].attrs["HDCP-LEVEL"];
			if (hdcpLevel && hdcpLevel <= maxHdcpLevel) return i;
		}
		return maxAutoLevel;
	}
	get firstAutoLevel() {
		return this.abrController.firstAutoLevel;
	}
	/**
	* next automatically selected quality level
	*/
	get nextAutoLevel() {
		return this.abrController.nextAutoLevel;
	}
	/**
	* this setter is used to force next auto level.
	* this is useful to force a switch down in auto mode:
	* in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
	* forced value is valid for one fragment. upon successful frag loading at forced level,
	* this value will be resetted to -1 by ABR controller.
	*/
	set nextAutoLevel(nextLevel) {
		this.abrController.nextAutoLevel = nextLevel;
	}
	/**
	* get the datetime value relative to media.currentTime for the active level Program Date Time if present
	*/
	get playingDate() {
		return this.streamController.currentProgramDateTime;
	}
	get mainForwardBufferInfo() {
		return this.streamController.getMainFwdBufferInfo();
	}
	get maxBufferLength() {
		return this.streamController.maxBufferLength;
	}
	/**
	* Find and select the best matching audio track, making a level switch when a Group change is necessary.
	* Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
	*/
	setAudioOption(audioOption) {
		var _this$audioTrackContr;
		return ((_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption)) || null;
	}
	/**
	* Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
	* Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
	*/
	setSubtitleOption(subtitleOption) {
		var _this$subtitleTrackCo;
		return ((_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption)) || null;
	}
	/**
	* Get the complete list of audio tracks across all media groups
	*/
	get allAudioTracks() {
		const audioTrackController = this.audioTrackController;
		return audioTrackController ? audioTrackController.allAudioTracks : [];
	}
	/**
	* Get the list of selectable audio tracks
	*/
	get audioTracks() {
		const audioTrackController = this.audioTrackController;
		return audioTrackController ? audioTrackController.audioTracks : [];
	}
	/**
	* index of the selected audio track (index in audio track lists)
	*/
	get audioTrack() {
		const audioTrackController = this.audioTrackController;
		return audioTrackController ? audioTrackController.audioTrack : -1;
	}
	/**
	* selects an audio track, based on its index in audio track lists
	*/
	set audioTrack(audioTrackId) {
		const audioTrackController = this.audioTrackController;
		if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
	}
	/**
	* get the complete list of subtitle tracks across all media groups
	*/
	get allSubtitleTracks() {
		const subtitleTrackController = this.subtitleTrackController;
		return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
	}
	/**
	* get alternate subtitle tracks list from playlist
	*/
	get subtitleTracks() {
		const subtitleTrackController = this.subtitleTrackController;
		return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
	}
	/**
	* index of the selected subtitle track (index in subtitle track lists)
	*/
	get subtitleTrack() {
		const subtitleTrackController = this.subtitleTrackController;
		return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
	}
	get media() {
		return this._media;
	}
	/**
	* select an subtitle track, based on its index in subtitle track lists
	*/
	set subtitleTrack(subtitleTrackId) {
		const subtitleTrackController = this.subtitleTrackController;
		if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
	}
	/**
	* Whether subtitle display is enabled or not
	*/
	get subtitleDisplay() {
		const subtitleTrackController = this.subtitleTrackController;
		return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
	}
	/**
	* Enable/disable subtitle display rendering
	*/
	set subtitleDisplay(value) {
		const subtitleTrackController = this.subtitleTrackController;
		if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
	}
	/**
	* get mode for Low-Latency HLS loading
	*/
	get lowLatencyMode() {
		return this.config.lowLatencyMode;
	}
	/**
	* Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
	*/
	set lowLatencyMode(mode) {
		this.config.lowLatencyMode = mode;
	}
	/**
	* Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
	* @returns null prior to loading live Playlist
	*/
	get liveSyncPosition() {
		return this.latencyController.liveSyncPosition;
	}
	/**
	* Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
	* @returns 0 before first playlist is loaded
	*/
	get latency() {
		return this.latencyController.latency;
	}
	/**
	* maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
	* configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
	* @returns 0 before first playlist is loaded
	*/
	get maxLatency() {
		return this.latencyController.maxLatency;
	}
	/**
	* target distance from the edge as calculated by the latency controller
	*/
	get targetLatency() {
		return this.latencyController.targetLatency;
	}
	set targetLatency(latency) {
		this.latencyController.targetLatency = latency;
	}
	/**
	* the rate at which the edge of the current live playlist is advancing or 1 if there is none
	*/
	get drift() {
		return this.latencyController.drift;
	}
	/**
	* set to true when startLoad is called before MANIFEST_PARSED event
	*/
	get forceStartLoad() {
		return this.streamController.forceStartLoad;
	}
	/**
	* ContentSteering pathways getter
	*/
	get pathways() {
		return this.levelController.pathways;
	}
	/**
	* ContentSteering pathwayPriority getter/setter
	*/
	get pathwayPriority() {
		return this.levelController.pathwayPriority;
	}
	set pathwayPriority(pathwayPriority) {
		this.levelController.pathwayPriority = pathwayPriority;
	}
	/**
	* returns true when all SourceBuffers are buffered to the end
	*/
	get bufferedToEnd() {
		var _this$bufferControlle;
		return !!((_this$bufferControlle = this.bufferController) != null && _this$bufferControlle.bufferedToEnd);
	}
	/**
	* returns Interstitials Program Manager
	*/
	get interstitialsManager() {
		var _this$interstitialsCo;
		return ((_this$interstitialsCo = this.interstitialsController) == null ? void 0 : _this$interstitialsCo.interstitialsManager) || null;
	}
	/**
	* returns mediaCapabilities.decodingInfo for a variant/rendition
	*/
	getMediaDecodingInfo(level, audioTracks = this.allAudioTracks) {
		return getMediaDecodingInfoPromise(level, getAudioTracksByGroup(audioTracks), navigator.mediaCapabilities);
	}
};
Hls.defaultConfig = void 0;
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/utils.js
function getSegmentRuntimeId(segmentRequestUrl, byteRange) {
	if (!byteRange) return segmentRequestUrl;
	return `${segmentRequestUrl}|${byteRange.start}-${byteRange.end}`;
}
function getByteRange(rangeStart, rangeEnd) {
	if (rangeStart !== void 0 && rangeEnd !== void 0 && rangeStart <= rangeEnd) return {
		start: rangeStart,
		end: rangeEnd
	};
}
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-core@2.2.2/node_modules/p2p-media-loader-core/dist/p2p-media-loader-core.es.js
init_dist$1();
var RequestError = class extends Error {
	/**
	* Constructs a new RequestError.
	* @param type - The specific error type.
	* @param message - Optional message describing the error.
	*/
	constructor(type, message) {
		super(message);
		this.type = type;
		this.timestamp = performance.now();
	}
	/** Error timestamp. */
	timestamp;
};
var CoreRequestError = class extends Error {
	/**
	* Constructs a new CoreRequestError.
	* @param type - The type of the error, either 'failed' or 'aborted'.
	*/
	constructor(type) {
		super();
		this.type = type;
	}
};
var HttpRequestExecutor = class {
	constructor(request, httpConfig, eventTarget) {
		this.request = request;
		this.httpConfig = httpConfig;
		this.onChunkDownloaded = eventTarget.getEventDispatcher("onChunkDownloaded");
		const { byteRange } = this.request.segment;
		if (byteRange) this.requestByteRange = { ...byteRange };
		if (request.loadedBytes !== 0) {
			this.requestByteRange = this.requestByteRange ?? { start: 0 };
			this.requestByteRange.start = this.requestByteRange.start + request.loadedBytes;
		}
		if (this.request.totalBytes) this.expectedBytesLength = this.request.totalBytes - this.request.loadedBytes;
		this.requestControls = this.request.start({ downloadSource: "http" }, {
			abort: () => this.abortController.abort("abort"),
			notReceivingBytesTimeoutMs: this.httpConfig.httpNotReceivingBytesTimeoutMs
		});
		this.fetch();
	}
	requestControls;
	abortController = new AbortController();
	expectedBytesLength;
	requestByteRange;
	onChunkDownloaded;
	async fetch() {
		const { segment } = this.request;
		try {
			let request = await this.httpConfig.httpRequestSetup?.(segment.url, segment.byteRange, this.abortController.signal, this.requestByteRange);
			if (!request) {
				const headers = new Headers(this.requestByteRange ? { Range: `bytes=${this.requestByteRange.start}-${this.requestByteRange.end ?? ""}` } : void 0);
				request = new Request(segment.url, {
					headers,
					signal: this.abortController.signal
				});
			}
			if (this.abortController.signal.aborted) throw new DOMException("Request aborted before request fetch", "AbortError");
			const response = await window.fetch(request);
			this.handleResponseHeaders(response);
			if (!response.body) return;
			const { requestControls } = this;
			requestControls.firstBytesReceived();
			const reader = response.body.getReader();
			for await (const chunk of readStream(reader)) {
				this.requestControls.addLoadedChunk(chunk);
				this.onChunkDownloaded(chunk.byteLength, "http");
			}
			if (!(await this.httpConfig.validateHTTPSegment?.(segment.url, segment.byteRange, this.request.data) ?? true)) {
				this.request.clearLoadedBytes();
				throw new RequestError("http-segment-validation-failed");
			}
			requestControls.completeOnSuccess();
		} catch (error) {
			this.handleError(error);
		}
	}
	handleResponseHeaders(response) {
		if (!response.ok) if (response.status === 406) {
			this.request.clearLoadedBytes();
			throw new RequestError("http-bytes-mismatch", response.statusText);
		} else throw new RequestError("http-error", response.statusText);
		const { requestByteRange } = this;
		if (requestByteRange) if (response.status === 200) if (this.request.segment.byteRange) throw new RequestError("http-unexpected-status-code");
		else this.request.clearLoadedBytes();
		else {
			if (response.status !== 206) throw new RequestError("http-unexpected-status-code", response.statusText);
			const contentLengthHeader = response.headers.get("Content-Length");
			if (contentLengthHeader && this.expectedBytesLength !== void 0 && this.expectedBytesLength !== +contentLengthHeader) {
				this.request.clearLoadedBytes();
				throw new RequestError("http-bytes-mismatch", response.statusText);
			}
			const contentRangeHeader = response.headers.get("Content-Range");
			const contentRange = contentRangeHeader ? parseContentRangeHeader(contentRangeHeader) : void 0;
			if (contentRange) {
				const { from, to } = contentRange;
				const responseExpectedBytesLength = to !== void 0 && from !== void 0 ? to - from + 1 : void 0;
				if (responseExpectedBytesLength !== void 0 && this.expectedBytesLength !== responseExpectedBytesLength || from !== void 0 && requestByteRange.start !== from || to !== void 0 && requestByteRange.end !== void 0 && requestByteRange.end !== to) {
					this.request.clearLoadedBytes();
					throw new RequestError("http-bytes-mismatch", response.statusText);
				}
			}
		}
		if (response.status === 200 && this.request.totalBytes === void 0) {
			const contentLengthHeader = response.headers.get("Content-Length");
			if (contentLengthHeader) this.request.setTotalBytes(+contentLengthHeader);
		}
	}
	handleError(error) {
		if (error instanceof Error) {
			if (error.name !== "abort") return;
			const httpLoaderError = error instanceof RequestError ? error : new RequestError("http-error", error.message);
			this.requestControls.abortOnError(httpLoaderError);
		}
	}
};
async function* readStream(reader) {
	while (true) {
		const { done, value } = await reader.read();
		if (done) break;
		yield value;
	}
}
var rangeHeaderRegex = /^bytes (?:(?:(\d+)|)-(?:(\d+)|)|\*)\/(?:(\d+)|\*)$/;
function parseContentRangeHeader(headerValue) {
	const match = rangeHeaderRegex.exec(headerValue.trim());
	if (!match) return;
	const [, from, to, total] = match;
	return {
		from: from ? parseInt(from) : void 0,
		to: to ? parseInt(to) : void 0,
		total: total ? parseInt(total) : void 0
	};
}
function getDefaultExportFromCjs$1(x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser$1 = { exports: {} };
var process = browser$1.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
	throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
	throw new Error("clearTimeout has not been defined");
}
(function() {
	try {
		if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
		else cachedSetTimeout = defaultSetTimout;
	} catch (e) {
		cachedSetTimeout = defaultSetTimout;
	}
	try {
		if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
		else cachedClearTimeout = defaultClearTimeout;
	} catch (e) {
		cachedClearTimeout = defaultClearTimeout;
	}
})();
function runTimeout(fun) {
	if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
	if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		cachedSetTimeout = setTimeout;
		return setTimeout(fun, 0);
	}
	try {
		return cachedSetTimeout(fun, 0);
	} catch (e) {
		try {
			return cachedSetTimeout.call(null, fun, 0);
		} catch (e2) {
			return cachedSetTimeout.call(this, fun, 0);
		}
	}
}
function runClearTimeout(marker) {
	if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
	if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		cachedClearTimeout = clearTimeout;
		return clearTimeout(marker);
	}
	try {
		return cachedClearTimeout(marker);
	} catch (e) {
		try {
			return cachedClearTimeout.call(null, marker);
		} catch (e2) {
			return cachedClearTimeout.call(this, marker);
		}
	}
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
	if (!draining || !currentQueue) return;
	draining = false;
	if (currentQueue.length) queue = currentQueue.concat(queue);
	else queueIndex = -1;
	if (queue.length) drainQueue();
}
function drainQueue() {
	if (draining) return;
	var timeout = runTimeout(cleanUpNextTick);
	draining = true;
	var len = queue.length;
	while (len) {
		currentQueue = queue;
		queue = [];
		while (++queueIndex < len) if (currentQueue) currentQueue[queueIndex].run();
		queueIndex = -1;
		len = queue.length;
	}
	currentQueue = null;
	draining = false;
	runClearTimeout(timeout);
}
process.nextTick = function(fun) {
	var args = new Array(arguments.length - 1);
	if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) args[i - 1] = arguments[i];
	queue.push(new Item(fun, args));
	if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
function Item(fun, array) {
	this.fun = fun;
	this.array = array;
}
Item.prototype.run = function() {
	this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$1() {}
process.on = noop$1;
process.addListener = noop$1;
process.once = noop$1;
process.off = noop$1;
process.removeListener = noop$1;
process.removeAllListeners = noop$1;
process.emit = noop$1;
process.prependListener = noop$1;
process.prependOnceListener = noop$1;
process.listeners = function(name) {
	return [];
};
process.binding = function(name) {
	throw new Error("process.binding is not supported");
};
process.cwd = function() {
	return "/";
};
process.chdir = function(dir) {
	throw new Error("process.chdir is not supported");
};
process.umask = function() {
	return 0;
};
var browserExports$1 = browser$1.exports;
var process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports$1);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = { exports: {} };
var ms;
var hasRequiredMs;
function requireMs() {
	if (hasRequiredMs) return ms;
	hasRequiredMs = 1;
	var s = 1e3;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	ms = function(val, options) {
		options = options || {};
		var type = typeof val;
		if (type === "string" && val.length > 0) return parse(val);
		else if (type === "number" && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
		throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
	};
	function parse(str) {
		str = String(str);
		if (str.length > 100) return;
		var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
		if (!match) return;
		var n = parseFloat(match[1]);
		switch ((match[2] || "ms").toLowerCase()) {
			case "years":
			case "year":
			case "yrs":
			case "yr":
			case "y": return n * y;
			case "weeks":
			case "week":
			case "w": return n * w;
			case "days":
			case "day":
			case "d": return n * d;
			case "hours":
			case "hour":
			case "hrs":
			case "hr":
			case "h": return n * h;
			case "minutes":
			case "minute":
			case "mins":
			case "min":
			case "m": return n * m;
			case "seconds":
			case "second":
			case "secs":
			case "sec":
			case "s": return n * s;
			case "milliseconds":
			case "millisecond":
			case "msecs":
			case "msec":
			case "ms": return n;
			default: return;
		}
	}
	function fmtShort(ms2) {
		var msAbs = Math.abs(ms2);
		if (msAbs >= d) return Math.round(ms2 / d) + "d";
		if (msAbs >= h) return Math.round(ms2 / h) + "h";
		if (msAbs >= m) return Math.round(ms2 / m) + "m";
		if (msAbs >= s) return Math.round(ms2 / s) + "s";
		return ms2 + "ms";
	}
	function fmtLong(ms2) {
		var msAbs = Math.abs(ms2);
		if (msAbs >= d) return plural(ms2, msAbs, d, "day");
		if (msAbs >= h) return plural(ms2, msAbs, h, "hour");
		if (msAbs >= m) return plural(ms2, msAbs, m, "minute");
		if (msAbs >= s) return plural(ms2, msAbs, s, "second");
		return ms2 + " ms";
	}
	function plural(ms2, msAbs, n, name) {
		var isPlural = msAbs >= n * 1.5;
		return Math.round(ms2 / n) + " " + name + (isPlural ? "s" : "");
	}
	return ms;
}
var common$2;
var hasRequiredCommon;
function requireCommon() {
	if (hasRequiredCommon) return common$2;
	hasRequiredCommon = 1;
	function setup(env) {
		createDebug.debug = createDebug;
		createDebug.default = createDebug;
		createDebug.coerce = coerce;
		createDebug.disable = disable;
		createDebug.enable = enable;
		createDebug.enabled = enabled;
		createDebug.humanize = requireMs();
		createDebug.destroy = destroy;
		Object.keys(env).forEach((key) => {
			createDebug[key] = env[key];
		});
		createDebug.names = [];
		createDebug.skips = [];
		createDebug.formatters = {};
		function selectColor(namespace) {
			let hash = 0;
			for (let i = 0; i < namespace.length; i++) {
				hash = (hash << 5) - hash + namespace.charCodeAt(i);
				hash |= 0;
			}
			return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
		}
		createDebug.selectColor = selectColor;
		function createDebug(namespace) {
			let prevTime;
			let enableOverride = null;
			let namespacesCache;
			let enabledCache;
			function debug2(...args) {
				if (!debug2.enabled) return;
				const self2 = debug2;
				const curr = Number(/* @__PURE__ */ new Date());
				self2.diff = curr - (prevTime || curr);
				self2.prev = prevTime;
				self2.curr = curr;
				prevTime = curr;
				args[0] = createDebug.coerce(args[0]);
				if (typeof args[0] !== "string") args.unshift("%O");
				let index = 0;
				args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
					if (match === "%%") return "%";
					index++;
					const formatter = createDebug.formatters[format];
					if (typeof formatter === "function") {
						const val = args[index];
						match = formatter.call(self2, val);
						args.splice(index, 1);
						index--;
					}
					return match;
				});
				createDebug.formatArgs.call(self2, args);
				(self2.log || createDebug.log).apply(self2, args);
			}
			debug2.namespace = namespace;
			debug2.useColors = createDebug.useColors();
			debug2.color = createDebug.selectColor(namespace);
			debug2.extend = extend;
			debug2.destroy = createDebug.destroy;
			Object.defineProperty(debug2, "enabled", {
				enumerable: true,
				configurable: false,
				get: () => {
					if (enableOverride !== null) return enableOverride;
					if (namespacesCache !== createDebug.namespaces) {
						namespacesCache = createDebug.namespaces;
						enabledCache = createDebug.enabled(namespace);
					}
					return enabledCache;
				},
				set: (v) => {
					enableOverride = v;
				}
			});
			if (typeof createDebug.init === "function") createDebug.init(debug2);
			return debug2;
		}
		function extend(namespace, delimiter) {
			const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
			newDebug.log = this.log;
			return newDebug;
		}
		function enable(namespaces) {
			createDebug.save(namespaces);
			createDebug.namespaces = namespaces;
			createDebug.names = [];
			createDebug.skips = [];
			const split = (typeof namespaces === "string" ? namespaces : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
			for (const ns of split) if (ns[0] === "-") createDebug.skips.push(ns.slice(1));
			else createDebug.names.push(ns);
		}
		function matchesTemplate(search, template) {
			let searchIndex = 0;
			let templateIndex = 0;
			let starIndex = -1;
			let matchIndex = 0;
			while (searchIndex < search.length) if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === "*")) if (template[templateIndex] === "*") {
				starIndex = templateIndex;
				matchIndex = searchIndex;
				templateIndex++;
			} else {
				searchIndex++;
				templateIndex++;
			}
			else if (starIndex !== -1) {
				templateIndex = starIndex + 1;
				matchIndex++;
				searchIndex = matchIndex;
			} else return false;
			while (templateIndex < template.length && template[templateIndex] === "*") templateIndex++;
			return templateIndex === template.length;
		}
		function disable() {
			const namespaces = [...createDebug.names, ...createDebug.skips.map((namespace) => "-" + namespace)].join(",");
			createDebug.enable("");
			return namespaces;
		}
		function enabled(name) {
			for (const skip of createDebug.skips) if (matchesTemplate(name, skip)) return false;
			for (const ns of createDebug.names) if (matchesTemplate(name, ns)) return true;
			return false;
		}
		function coerce(val) {
			if (val instanceof Error) return val.stack || val.message;
			return val;
		}
		function destroy() {
			console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
		}
		createDebug.enable(createDebug.load());
		return createDebug;
	}
	common$2 = setup;
	return common$2;
}
var hasRequiredBrowser;
function requireBrowser() {
	if (hasRequiredBrowser) return browser.exports;
	hasRequiredBrowser = 1;
	(function(module, exports$1) {
		exports$1.formatArgs = formatArgs;
		exports$1.save = save;
		exports$1.load = load;
		exports$1.useColors = useColors;
		exports$1.storage = localstorage();
		exports$1.destroy = /* @__PURE__ */ (() => {
			let warned = false;
			return () => {
				if (!warned) {
					warned = true;
					console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
				}
			};
		})();
		exports$1.colors = [
			"#0000CC",
			"#0000FF",
			"#0033CC",
			"#0033FF",
			"#0066CC",
			"#0066FF",
			"#0099CC",
			"#0099FF",
			"#00CC00",
			"#00CC33",
			"#00CC66",
			"#00CC99",
			"#00CCCC",
			"#00CCFF",
			"#3300CC",
			"#3300FF",
			"#3333CC",
			"#3333FF",
			"#3366CC",
			"#3366FF",
			"#3399CC",
			"#3399FF",
			"#33CC00",
			"#33CC33",
			"#33CC66",
			"#33CC99",
			"#33CCCC",
			"#33CCFF",
			"#6600CC",
			"#6600FF",
			"#6633CC",
			"#6633FF",
			"#66CC00",
			"#66CC33",
			"#9900CC",
			"#9900FF",
			"#9933CC",
			"#9933FF",
			"#99CC00",
			"#99CC33",
			"#CC0000",
			"#CC0033",
			"#CC0066",
			"#CC0099",
			"#CC00CC",
			"#CC00FF",
			"#CC3300",
			"#CC3333",
			"#CC3366",
			"#CC3399",
			"#CC33CC",
			"#CC33FF",
			"#CC6600",
			"#CC6633",
			"#CC9900",
			"#CC9933",
			"#CCCC00",
			"#CCCC33",
			"#FF0000",
			"#FF0033",
			"#FF0066",
			"#FF0099",
			"#FF00CC",
			"#FF00FF",
			"#FF3300",
			"#FF3333",
			"#FF3366",
			"#FF3399",
			"#FF33CC",
			"#FF33FF",
			"#FF6600",
			"#FF6633",
			"#FF9900",
			"#FF9933",
			"#FFCC00",
			"#FFCC33"
		];
		function useColors() {
			if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
			if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
			let m;
			return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
		}
		function formatArgs(args) {
			args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
			if (!this.useColors) return;
			const c = "color: " + this.color;
			args.splice(1, 0, c, "color: inherit");
			let index = 0;
			let lastC = 0;
			args[0].replace(/%[a-zA-Z%]/g, (match) => {
				if (match === "%%") return;
				index++;
				if (match === "%c") lastC = index;
			});
			args.splice(lastC, 0, c);
		}
		exports$1.log = console.debug || console.log || (() => {});
		function save(namespaces) {
			try {
				if (namespaces) exports$1.storage.setItem("debug", namespaces);
				else exports$1.storage.removeItem("debug");
			} catch (error) {}
		}
		function load() {
			let r;
			try {
				r = exports$1.storage.getItem("debug") || exports$1.storage.getItem("DEBUG");
			} catch (error) {}
			if (!r && typeof process$1 !== "undefined" && "env" in process$1) r = process$1.env.DEBUG;
			return r;
		}
		function localstorage() {
			try {
				return localStorage;
			} catch (error) {}
		}
		module.exports = requireCommon()(exports$1);
		const { formatters } = module.exports;
		formatters.j = function(v) {
			try {
				return JSON.stringify(v);
			} catch (error) {
				return "[UnexpectedJSONParseError]: " + error.message;
			}
		};
	})(browser, browser.exports);
	return browser.exports;
}
var browserExports = requireBrowser();
var debug$3$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var events = { exports: {} };
var hasRequiredEvents;
function requireEvents() {
	if (hasRequiredEvents) return events.exports;
	hasRequiredEvents = 1;
	var R = typeof Reflect === "object" ? Reflect : null;
	var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
		return Function.prototype.apply.call(target, receiver, args);
	};
	var ReflectOwnKeys;
	if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
	else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys2(target) {
		return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
	};
	else ReflectOwnKeys = function ReflectOwnKeys2(target) {
		return Object.getOwnPropertyNames(target);
	};
	function ProcessEmitWarning(warning) {
		if (console && console.warn) console.warn(warning);
	}
	var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
		return value !== value;
	};
	function EventEmitter2() {
		EventEmitter2.init.call(this);
	}
	events.exports = EventEmitter2;
	events.exports.once = once2;
	EventEmitter2.EventEmitter = EventEmitter2;
	EventEmitter2.prototype._events = void 0;
	EventEmitter2.prototype._eventsCount = 0;
	EventEmitter2.prototype._maxListeners = void 0;
	var defaultMaxListeners = 10;
	function checkListener(listener) {
		if (typeof listener !== "function") throw new TypeError("The \"listener\" argument must be of type Function. Received type " + typeof listener);
	}
	Object.defineProperty(EventEmitter2, "defaultMaxListeners", {
		enumerable: true,
		get: function() {
			return defaultMaxListeners;
		},
		set: function(arg) {
			if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + arg + ".");
			defaultMaxListeners = arg;
		}
	});
	EventEmitter2.init = function() {
		if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
			this._events = /* @__PURE__ */ Object.create(null);
			this._eventsCount = 0;
		}
		this._maxListeners = this._maxListeners || void 0;
	};
	EventEmitter2.prototype.setMaxListeners = function setMaxListeners(n) {
		if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + n + ".");
		this._maxListeners = n;
		return this;
	};
	function _getMaxListeners(that) {
		if (that._maxListeners === void 0) return EventEmitter2.defaultMaxListeners;
		return that._maxListeners;
	}
	EventEmitter2.prototype.getMaxListeners = function getMaxListeners() {
		return _getMaxListeners(this);
	};
	EventEmitter2.prototype.emit = function emit(type) {
		var args = [];
		for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
		var doError = type === "error";
		var events2 = this._events;
		if (events2 !== void 0) doError = doError && events2.error === void 0;
		else if (!doError) return false;
		if (doError) {
			var er;
			if (args.length > 0) er = args[0];
			if (er instanceof Error) throw er;
			var err = /* @__PURE__ */ new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
			err.context = er;
			throw err;
		}
		var handler = events2[type];
		if (handler === void 0) return false;
		if (typeof handler === "function") ReflectApply(handler, this, args);
		else {
			var len = handler.length;
			var listeners = arrayClone(handler, len);
			for (var i = 0; i < len; ++i) ReflectApply(listeners[i], this, args);
		}
		return true;
	};
	function _addListener(target, type, listener, prepend) {
		var m;
		var events2;
		var existing;
		checkListener(listener);
		events2 = target._events;
		if (events2 === void 0) {
			events2 = target._events = /* @__PURE__ */ Object.create(null);
			target._eventsCount = 0;
		} else {
			if (events2.newListener !== void 0) {
				target.emit("newListener", type, listener.listener ? listener.listener : listener);
				events2 = target._events;
			}
			existing = events2[type];
		}
		if (existing === void 0) {
			existing = events2[type] = listener;
			++target._eventsCount;
		} else {
			if (typeof existing === "function") existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
			else if (prepend) existing.unshift(listener);
			else existing.push(listener);
			m = _getMaxListeners(target);
			if (m > 0 && existing.length > m && !existing.warned) {
				existing.warned = true;
				var w = /* @__PURE__ */ new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
				w.name = "MaxListenersExceededWarning";
				w.emitter = target;
				w.type = type;
				w.count = existing.length;
				ProcessEmitWarning(w);
			}
		}
		return target;
	}
	EventEmitter2.prototype.addListener = function addListener(type, listener) {
		return _addListener(this, type, listener, false);
	};
	EventEmitter2.prototype.on = EventEmitter2.prototype.addListener;
	EventEmitter2.prototype.prependListener = function prependListener(type, listener) {
		return _addListener(this, type, listener, true);
	};
	function onceWrapper() {
		if (!this.fired) {
			this.target.removeListener(this.type, this.wrapFn);
			this.fired = true;
			if (arguments.length === 0) return this.listener.call(this.target);
			return this.listener.apply(this.target, arguments);
		}
	}
	function _onceWrap(target, type, listener) {
		var state = {
			fired: false,
			wrapFn: void 0,
			target,
			type,
			listener
		};
		var wrapped = onceWrapper.bind(state);
		wrapped.listener = listener;
		state.wrapFn = wrapped;
		return wrapped;
	}
	EventEmitter2.prototype.once = function once3(type, listener) {
		checkListener(listener);
		this.on(type, _onceWrap(this, type, listener));
		return this;
	};
	EventEmitter2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
		checkListener(listener);
		this.prependListener(type, _onceWrap(this, type, listener));
		return this;
	};
	EventEmitter2.prototype.removeListener = function removeListener(type, listener) {
		var list, events2, position, i, originalListener;
		checkListener(listener);
		events2 = this._events;
		if (events2 === void 0) return this;
		list = events2[type];
		if (list === void 0) return this;
		if (list === listener || list.listener === listener) if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
		else {
			delete events2[type];
			if (events2.removeListener) this.emit("removeListener", type, list.listener || listener);
		}
		else if (typeof list !== "function") {
			position = -1;
			for (i = list.length - 1; i >= 0; i--) if (list[i] === listener || list[i].listener === listener) {
				originalListener = list[i].listener;
				position = i;
				break;
			}
			if (position < 0) return this;
			if (position === 0) list.shift();
			else spliceOne(list, position);
			if (list.length === 1) events2[type] = list[0];
			if (events2.removeListener !== void 0) this.emit("removeListener", type, originalListener || listener);
		}
		return this;
	};
	EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
	EventEmitter2.prototype.removeAllListeners = function removeAllListeners(type) {
		var listeners, events2 = this._events, i;
		if (events2 === void 0) return this;
		if (events2.removeListener === void 0) {
			if (arguments.length === 0) {
				this._events = /* @__PURE__ */ Object.create(null);
				this._eventsCount = 0;
			} else if (events2[type] !== void 0) if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
			else delete events2[type];
			return this;
		}
		if (arguments.length === 0) {
			var keys = Object.keys(events2);
			var key;
			for (i = 0; i < keys.length; ++i) {
				key = keys[i];
				if (key === "removeListener") continue;
				this.removeAllListeners(key);
			}
			this.removeAllListeners("removeListener");
			this._events = /* @__PURE__ */ Object.create(null);
			this._eventsCount = 0;
			return this;
		}
		listeners = events2[type];
		if (typeof listeners === "function") this.removeListener(type, listeners);
		else if (listeners !== void 0) for (i = listeners.length - 1; i >= 0; i--) this.removeListener(type, listeners[i]);
		return this;
	};
	function _listeners(target, type, unwrap) {
		var events2 = target._events;
		if (events2 === void 0) return [];
		var evlistener = events2[type];
		if (evlistener === void 0) return [];
		if (typeof evlistener === "function") return unwrap ? [evlistener.listener || evlistener] : [evlistener];
		return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	EventEmitter2.prototype.listeners = function listeners(type) {
		return _listeners(this, type, true);
	};
	EventEmitter2.prototype.rawListeners = function rawListeners(type) {
		return _listeners(this, type, false);
	};
	EventEmitter2.listenerCount = function(emitter, type) {
		if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
		else return listenerCount.call(emitter, type);
	};
	EventEmitter2.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
		var events2 = this._events;
		if (events2 !== void 0) {
			var evlistener = events2[type];
			if (typeof evlistener === "function") return 1;
			else if (evlistener !== void 0) return evlistener.length;
		}
		return 0;
	}
	EventEmitter2.prototype.eventNames = function eventNames() {
		return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	function arrayClone(arr, n) {
		var copy = new Array(n);
		for (var i = 0; i < n; ++i) copy[i] = arr[i];
		return copy;
	}
	function spliceOne(list, index) {
		for (; index + 1 < list.length; index++) list[index] = list[index + 1];
		list.pop();
	}
	function unwrapListeners(arr) {
		var ret = new Array(arr.length);
		for (var i = 0; i < ret.length; ++i) ret[i] = arr[i].listener || arr[i];
		return ret;
	}
	function once2(emitter, name) {
		return new Promise(function(resolve, reject) {
			function errorListener(err) {
				emitter.removeListener(name, resolver);
				reject(err);
			}
			function resolver() {
				if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
				resolve([].slice.call(arguments));
			}
			eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
			if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
		});
	}
	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
		if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
	}
	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
		if (typeof emitter.on === "function") if (flags.once) emitter.once(name, listener);
		else emitter.on(name, listener);
		else if (typeof emitter.addEventListener === "function") emitter.addEventListener(name, function wrapListener(arg) {
			if (flags.once) emitter.removeEventListener(name, wrapListener);
			listener(arg);
		});
		else throw new TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof emitter);
	}
	return events.exports;
}
var EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(requireEvents());
var once$1 = { exports: {} };
var wrappy_1;
var hasRequiredWrappy;
function requireWrappy() {
	if (hasRequiredWrappy) return wrappy_1;
	hasRequiredWrappy = 1;
	wrappy_1 = wrappy;
	function wrappy(fn, cb) {
		if (fn && cb) return wrappy(fn)(cb);
		if (typeof fn !== "function") throw new TypeError("need wrapper function");
		Object.keys(fn).forEach(function(k) {
			wrapper[k] = fn[k];
		});
		return wrapper;
		function wrapper() {
			var args = new Array(arguments.length);
			for (var i = 0; i < args.length; i++) args[i] = arguments[i];
			var ret = fn.apply(this, args);
			var cb2 = args[args.length - 1];
			if (typeof ret === "function" && ret !== cb2) Object.keys(cb2).forEach(function(k) {
				ret[k] = cb2[k];
			});
			return ret;
		}
	}
	return wrappy_1;
}
var hasRequiredOnce;
function requireOnce() {
	if (hasRequiredOnce) return once$1.exports;
	hasRequiredOnce = 1;
	var wrappy = requireWrappy();
	once$1.exports = wrappy(once2);
	once$1.exports.strict = wrappy(onceStrict);
	once2.proto = once2(function() {
		Object.defineProperty(Function.prototype, "once", {
			value: function() {
				return once2(this);
			},
			configurable: true
		});
		Object.defineProperty(Function.prototype, "onceStrict", {
			value: function() {
				return onceStrict(this);
			},
			configurable: true
		});
	});
	function once2(fn) {
		var f = function() {
			if (f.called) return f.value;
			f.called = true;
			return f.value = fn.apply(this, arguments);
		};
		f.called = false;
		return f;
	}
	function onceStrict(fn) {
		var f = function() {
			if (f.called) throw new Error(f.onceError);
			f.called = true;
			return f.value = fn.apply(this, arguments);
		};
		f.onceError = (fn.name || "Function wrapped with `once`") + " shouldn't be called more than once";
		f.called = false;
		return f;
	}
	return once$1.exports;
}
var once = /* @__PURE__ */ getDefaultExportFromCjs(requireOnce());
var queueMicrotask_1;
var hasRequiredQueueMicrotask;
function requireQueueMicrotask() {
	if (hasRequiredQueueMicrotask) return queueMicrotask_1;
	hasRequiredQueueMicrotask = 1;
	let promise;
	queueMicrotask_1 = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : commonjsGlobal) : (cb) => (promise || (promise = Promise.resolve())).then(cb).catch((err) => setTimeout(() => {
		throw err;
	}, 0));
	return queueMicrotask_1;
}
var runParallel_1;
var hasRequiredRunParallel;
function requireRunParallel() {
	if (hasRequiredRunParallel) return runParallel_1;
	hasRequiredRunParallel = 1;
	runParallel_1 = runParallel;
	const queueMicrotask2 = requireQueueMicrotask();
	function runParallel(tasks, cb) {
		let results, pending, keys;
		let isSync = true;
		if (Array.isArray(tasks)) {
			results = [];
			pending = tasks.length;
		} else {
			keys = Object.keys(tasks);
			results = {};
			pending = keys.length;
		}
		function done(err) {
			function end() {
				if (cb) cb(err, results);
				cb = null;
			}
			if (isSync) queueMicrotask2(end);
			else end();
		}
		function each(i, err, result) {
			results[i] = result;
			if (--pending === 0 || err) done(err);
		}
		if (!pending) done(null);
		else if (keys) keys.forEach(function(key) {
			tasks[key](function(err, result) {
				each(key, err, result);
			});
		});
		else tasks.forEach(function(task, i) {
			task(function(err, result) {
				each(i, err, result);
			});
		});
		isSync = false;
	}
	return runParallel_1;
}
var parallel = /* @__PURE__ */ getDefaultExportFromCjs(requireRunParallel());
var scope$1 = typeof window !== "undefined" ? window : self;
var RTCPeerConnection = scope$1.RTCPeerConnection || scope$1.mozRTCPeerConnection || scope$1.webkitRTCPeerConnection;
var RTCSessionDescription = scope$1.RTCSessionDescription || scope$1.mozRTCSessionDescription || scope$1.webkitRTCSessionDescription;
var RTCIceCandidate = scope$1.RTCIceCandidate || scope$1.mozRTCIceCandidate || scope$1.webkitRTCIceCandidate;
var _default;
var hasRequired_default;
function require_default() {
	if (hasRequired_default) return _default;
	hasRequired_default = 1;
	_default = requireEvents();
	return _default;
}
var fixedSize;
var hasRequiredFixedSize;
function requireFixedSize() {
	if (hasRequiredFixedSize) return fixedSize;
	hasRequiredFixedSize = 1;
	fixedSize = class FixedFIFO {
		constructor(hwm) {
			if (!(hwm > 0) || (hwm - 1 & hwm) !== 0) throw new Error("Max size for a FixedFIFO should be a power of two");
			this.buffer = new Array(hwm);
			this.mask = hwm - 1;
			this.top = 0;
			this.btm = 0;
			this.next = null;
		}
		clear() {
			this.top = this.btm = 0;
			this.next = null;
			this.buffer.fill(void 0);
		}
		push(data) {
			if (this.buffer[this.top] !== void 0) return false;
			this.buffer[this.top] = data;
			this.top = this.top + 1 & this.mask;
			return true;
		}
		shift() {
			const last = this.buffer[this.btm];
			if (last === void 0) return void 0;
			this.buffer[this.btm] = void 0;
			this.btm = this.btm + 1 & this.mask;
			return last;
		}
		peek() {
			return this.buffer[this.btm];
		}
		isEmpty() {
			return this.buffer[this.btm] === void 0;
		}
	};
	return fixedSize;
}
var fastFifo;
var hasRequiredFastFifo;
function requireFastFifo() {
	if (hasRequiredFastFifo) return fastFifo;
	hasRequiredFastFifo = 1;
	const FixedFIFO = requireFixedSize();
	fastFifo = class FastFIFO {
		constructor(hwm) {
			this.hwm = hwm || 16;
			this.head = new FixedFIFO(this.hwm);
			this.tail = this.head;
			this.length = 0;
		}
		clear() {
			this.head = this.tail;
			this.head.clear();
			this.length = 0;
		}
		push(val) {
			this.length++;
			if (!this.head.push(val)) {
				const prev = this.head;
				this.head = prev.next = new FixedFIFO(2 * this.head.buffer.length);
				this.head.push(val);
			}
		}
		shift() {
			if (this.length !== 0) this.length--;
			const val = this.tail.shift();
			if (val === void 0 && this.tail.next) {
				const next = this.tail.next;
				this.tail.next = null;
				this.tail = next;
				return this.tail.shift();
			}
			return val;
		}
		peek() {
			const val = this.tail.peek();
			if (val === void 0 && this.tail.next) return this.tail.next.peek();
			return val;
		}
		isEmpty() {
			return this.length === 0;
		}
	};
	return fastFifo;
}
var browserDecoder;
var hasRequiredBrowserDecoder;
function requireBrowserDecoder() {
	if (hasRequiredBrowserDecoder) return browserDecoder;
	hasRequiredBrowserDecoder = 1;
	browserDecoder = class BrowserDecoder {
		constructor(encoding) {
			this.decoder = new TextDecoder(encoding === "utf16le" ? "utf16-le" : encoding);
		}
		get remaining() {
			return -1;
		}
		decode(data) {
			return this.decoder.decode(data, { stream: true });
		}
		flush() {
			return this.decoder.decode(new Uint8Array(0));
		}
	};
	return browserDecoder;
}
var textDecoder;
var hasRequiredTextDecoder;
function requireTextDecoder() {
	if (hasRequiredTextDecoder) return textDecoder;
	hasRequiredTextDecoder = 1;
	const PassThroughDecoder = requireBrowserDecoder();
	const UTF8Decoder = requireBrowserDecoder();
	textDecoder = class TextDecoder {
		constructor(encoding = "utf8") {
			this.encoding = normalizeEncoding(encoding);
			switch (this.encoding) {
				case "utf8":
					this.decoder = new UTF8Decoder();
					break;
				case "utf16le":
				case "base64": throw new Error("Unsupported encoding: " + this.encoding);
				default: this.decoder = new PassThroughDecoder(this.encoding);
			}
		}
		get remaining() {
			return this.decoder.remaining;
		}
		push(data) {
			if (typeof data === "string") return data;
			return this.decoder.decode(data);
		}
		write(data) {
			return this.push(data);
		}
		end(data) {
			let result = "";
			if (data) result = this.push(data);
			result += this.decoder.flush();
			return result;
		}
	};
	function normalizeEncoding(encoding) {
		encoding = encoding.toLowerCase();
		switch (encoding) {
			case "utf8":
			case "utf-8": return "utf8";
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return "utf16le";
			case "latin1":
			case "binary": return "latin1";
			case "base64":
			case "ascii":
			case "hex": return encoding;
			default: throw new Error("Unknown encoding: " + encoding);
		}
	}
	return textDecoder;
}
var streamx;
var hasRequiredStreamx;
function requireStreamx() {
	if (hasRequiredStreamx) return streamx;
	hasRequiredStreamx = 1;
	const { EventEmitter: EventEmitter2 } = require_default();
	const STREAM_DESTROYED = /* @__PURE__ */ new Error("Stream was destroyed");
	const PREMATURE_CLOSE = /* @__PURE__ */ new Error("Premature close");
	const FIFO = requireFastFifo();
	const TextDecoder2 = requireTextDecoder();
	const qmt = typeof queueMicrotask === "undefined" ? (fn) => commonjsGlobal.process.nextTick(fn) : queueMicrotask;
	const MAX = (1 << 29) - 1;
	const OPENING = 1;
	const PREDESTROYING = 2;
	const DESTROYING = 4;
	const DESTROYED = 8;
	const NOT_OPENING = MAX ^ OPENING;
	const NOT_PREDESTROYING = MAX ^ PREDESTROYING;
	const READ_ACTIVE = 16;
	const READ_UPDATING = 32;
	const READ_PRIMARY = 64;
	const READ_QUEUED = 128;
	const READ_RESUMED = 256;
	const READ_PIPE_DRAINED = 512;
	const READ_ENDING = 1024;
	const READ_EMIT_DATA = 2048;
	const READ_EMIT_READABLE = 4096;
	const READ_EMITTED_READABLE = 8192;
	const READ_DONE = 16384;
	const READ_NEXT_TICK = 32768;
	const READ_NEEDS_PUSH = 65536;
	const READ_READ_AHEAD = 131072;
	const READ_FLOWING = READ_RESUMED | READ_PIPE_DRAINED;
	const READ_ACTIVE_AND_NEEDS_PUSH = READ_ACTIVE | READ_NEEDS_PUSH;
	const READ_PRIMARY_AND_ACTIVE = READ_PRIMARY | READ_ACTIVE;
	const READ_EMIT_READABLE_AND_QUEUED = READ_EMIT_READABLE | READ_QUEUED;
	const READ_RESUMED_READ_AHEAD = READ_RESUMED | READ_READ_AHEAD;
	const READ_NOT_ACTIVE = MAX ^ READ_ACTIVE;
	const READ_NON_PRIMARY = MAX ^ READ_PRIMARY;
	const READ_NON_PRIMARY_AND_PUSHED = MAX ^ (READ_PRIMARY | READ_NEEDS_PUSH);
	const READ_PUSHED = MAX ^ READ_NEEDS_PUSH;
	const READ_PAUSED = MAX ^ READ_RESUMED;
	const READ_NOT_QUEUED = MAX ^ (READ_QUEUED | READ_EMITTED_READABLE);
	const READ_NOT_ENDING = MAX ^ READ_ENDING;
	const READ_PIPE_NOT_DRAINED = MAX ^ READ_FLOWING;
	const READ_NOT_NEXT_TICK = MAX ^ READ_NEXT_TICK;
	const READ_NOT_UPDATING = MAX ^ READ_UPDATING;
	const READ_NO_READ_AHEAD = MAX ^ READ_READ_AHEAD;
	const READ_PAUSED_NO_READ_AHEAD = MAX ^ READ_RESUMED_READ_AHEAD;
	const WRITE_ACTIVE = 1 << 18;
	const WRITE_UPDATING = 2 << 18;
	const WRITE_PRIMARY = 4 << 18;
	const WRITE_QUEUED = 8 << 18;
	const WRITE_UNDRAINED = 16 << 18;
	const WRITE_DONE = 32 << 18;
	const WRITE_EMIT_DRAIN = 64 << 18;
	const WRITE_NEXT_TICK = 128 << 18;
	const WRITE_WRITING = 256 << 18;
	const WRITE_FINISHING = 512 << 18;
	const WRITE_CORKED = 1024 << 18;
	const WRITE_NOT_ACTIVE = MAX ^ (WRITE_ACTIVE | WRITE_WRITING);
	const WRITE_NON_PRIMARY = MAX ^ WRITE_PRIMARY;
	const WRITE_NOT_FINISHING = MAX ^ (WRITE_ACTIVE | WRITE_FINISHING);
	const WRITE_DRAINED = MAX ^ WRITE_UNDRAINED;
	const WRITE_NOT_QUEUED = MAX ^ WRITE_QUEUED;
	const WRITE_NOT_NEXT_TICK = MAX ^ WRITE_NEXT_TICK;
	const WRITE_NOT_UPDATING = MAX ^ WRITE_UPDATING;
	const WRITE_NOT_CORKED = MAX ^ WRITE_CORKED;
	const ACTIVE = READ_ACTIVE | WRITE_ACTIVE;
	const NOT_ACTIVE = MAX ^ ACTIVE;
	const DONE = READ_DONE | WRITE_DONE;
	const DESTROY_STATUS = DESTROYED | 6;
	const OPEN_STATUS = DESTROY_STATUS | OPENING;
	const AUTO_DESTROY = DESTROY_STATUS | DONE;
	const NON_PRIMARY = WRITE_NON_PRIMARY & READ_NON_PRIMARY;
	const ACTIVE_OR_TICKING = WRITE_NEXT_TICK | READ_NEXT_TICK;
	const IS_OPENING = OPEN_STATUS | ACTIVE_OR_TICKING & NOT_ACTIVE;
	const READ_PRIMARY_STATUS = READ_ENDING | 16399;
	const READ_STATUS = READ_DONE | 143;
	const READ_ENDING_STATUS = READ_ENDING | 143;
	const READ_READABLE_STATUS = 12431;
	const SHOULD_NOT_READ = 214047;
	const READ_BACKPRESSURE_STATUS = READ_ENDING | 16398;
	const READ_UPDATE_SYNC_STATUS = 32879;
	const READ_NEXT_TICK_OR_OPENING = READ_NEXT_TICK | OPENING;
	const WRITE_PRIMARY_STATUS = WRITE_FINISHING | 8388623;
	const WRITE_QUEUED_AND_UNDRAINED = WRITE_QUEUED | WRITE_UNDRAINED;
	const WRITE_QUEUED_AND_ACTIVE = WRITE_QUEUED | WRITE_ACTIVE;
	const WRITE_DRAIN_STATUS = 6553615;
	const WRITE_STATUS = 270794767;
	const WRITE_PRIMARY_AND_ACTIVE = WRITE_PRIMARY | WRITE_ACTIVE;
	const WRITE_ACTIVE_AND_WRITING = WRITE_ACTIVE | WRITE_WRITING;
	const WRITE_FINISHING_STATUS = 144965647;
	const WRITE_BACKPRESSURE_STATUS = 146800654;
	const WRITE_UPDATE_SYNC_STATUS = 35127311;
	const WRITE_DROP_DATA = WRITE_DONE | 134217742;
	const asyncIterator = Symbol.asyncIterator || Symbol("asyncIterator");
	class WritableState {
		constructor(stream, { highWaterMark = 16384, map = null, mapWritable, byteLength, byteLengthWritable } = {}) {
			this.stream = stream;
			this.queue = new FIFO();
			this.highWaterMark = highWaterMark;
			this.buffered = 0;
			this.error = null;
			this.pipeline = null;
			this.drains = null;
			this.byteLength = byteLengthWritable || byteLength || defaultByteLength;
			this.map = mapWritable || map;
			this.afterWrite = afterWrite.bind(this);
			this.afterUpdateNextTick = updateWriteNT.bind(this);
		}
		get ended() {
			return (this.stream._duplexState & WRITE_DONE) !== 0;
		}
		push(data) {
			if ((this.stream._duplexState & WRITE_DROP_DATA) !== 0) return false;
			if (this.map !== null) data = this.map(data);
			this.buffered += this.byteLength(data);
			this.queue.push(data);
			if (this.buffered < this.highWaterMark) {
				this.stream._duplexState |= WRITE_QUEUED;
				return true;
			}
			this.stream._duplexState |= WRITE_QUEUED_AND_UNDRAINED;
			return false;
		}
		shift() {
			const data = this.queue.shift();
			this.buffered -= this.byteLength(data);
			if (this.buffered === 0) this.stream._duplexState &= WRITE_NOT_QUEUED;
			return data;
		}
		end(data) {
			if (typeof data === "function") this.stream.once("finish", data);
			else if (data !== void 0 && data !== null) this.push(data);
			this.stream._duplexState = (this.stream._duplexState | WRITE_FINISHING) & WRITE_NON_PRIMARY;
		}
		autoBatch(data, cb) {
			const buffer = [];
			const stream = this.stream;
			buffer.push(data);
			while ((stream._duplexState & WRITE_STATUS) === WRITE_QUEUED_AND_ACTIVE) buffer.push(stream._writableState.shift());
			if ((stream._duplexState & OPEN_STATUS) !== 0) return cb(null);
			stream._writev(buffer, cb);
		}
		update() {
			const stream = this.stream;
			stream._duplexState |= WRITE_UPDATING;
			do {
				while ((stream._duplexState & WRITE_STATUS) === WRITE_QUEUED) {
					const data = this.shift();
					stream._duplexState |= WRITE_ACTIVE_AND_WRITING;
					stream._write(data, this.afterWrite);
				}
				if ((stream._duplexState & WRITE_PRIMARY_AND_ACTIVE) === 0) this.updateNonPrimary();
			} while (this.continueUpdate() === true);
			stream._duplexState &= WRITE_NOT_UPDATING;
		}
		updateNonPrimary() {
			const stream = this.stream;
			if ((stream._duplexState & WRITE_FINISHING_STATUS) === WRITE_FINISHING) {
				stream._duplexState = stream._duplexState | WRITE_ACTIVE;
				stream._final(afterFinal.bind(this));
				return;
			}
			if ((stream._duplexState & DESTROY_STATUS) === DESTROYING) {
				if ((stream._duplexState & ACTIVE_OR_TICKING) === 0) {
					stream._duplexState |= ACTIVE;
					stream._destroy(afterDestroy.bind(this));
				}
				return;
			}
			if ((stream._duplexState & IS_OPENING) === OPENING) {
				stream._duplexState = (stream._duplexState | ACTIVE) & NOT_OPENING;
				stream._open(afterOpen.bind(this));
			}
		}
		continueUpdate() {
			if ((this.stream._duplexState & WRITE_NEXT_TICK) === 0) return false;
			this.stream._duplexState &= WRITE_NOT_NEXT_TICK;
			return true;
		}
		updateCallback() {
			if ((this.stream._duplexState & WRITE_UPDATE_SYNC_STATUS) === WRITE_PRIMARY) this.update();
			else this.updateNextTick();
		}
		updateNextTick() {
			if ((this.stream._duplexState & WRITE_NEXT_TICK) !== 0) return;
			this.stream._duplexState |= WRITE_NEXT_TICK;
			if ((this.stream._duplexState & WRITE_UPDATING) === 0) qmt(this.afterUpdateNextTick);
		}
	}
	class ReadableState {
		constructor(stream, { highWaterMark = 16384, map = null, mapReadable, byteLength, byteLengthReadable } = {}) {
			this.stream = stream;
			this.queue = new FIFO();
			this.highWaterMark = highWaterMark === 0 ? 1 : highWaterMark;
			this.buffered = 0;
			this.readAhead = highWaterMark > 0;
			this.error = null;
			this.pipeline = null;
			this.byteLength = byteLengthReadable || byteLength || defaultByteLength;
			this.map = mapReadable || map;
			this.pipeTo = null;
			this.afterRead = afterRead.bind(this);
			this.afterUpdateNextTick = updateReadNT.bind(this);
		}
		get ended() {
			return (this.stream._duplexState & READ_DONE) !== 0;
		}
		pipe(pipeTo, cb) {
			if (this.pipeTo !== null) throw new Error("Can only pipe to one destination");
			if (typeof cb !== "function") cb = null;
			this.stream._duplexState |= READ_PIPE_DRAINED;
			this.pipeTo = pipeTo;
			this.pipeline = new Pipeline(this.stream, pipeTo, cb);
			if (cb) this.stream.on("error", noop2);
			if (isStreamx(pipeTo)) {
				pipeTo._writableState.pipeline = this.pipeline;
				if (cb) pipeTo.on("error", noop2);
				pipeTo.on("finish", this.pipeline.finished.bind(this.pipeline));
			} else {
				const onerror = this.pipeline.done.bind(this.pipeline, pipeTo);
				const onclose = this.pipeline.done.bind(this.pipeline, pipeTo, null);
				pipeTo.on("error", onerror);
				pipeTo.on("close", onclose);
				pipeTo.on("finish", this.pipeline.finished.bind(this.pipeline));
			}
			pipeTo.on("drain", afterDrain.bind(this));
			this.stream.emit("piping", pipeTo);
			pipeTo.emit("pipe", this.stream);
		}
		push(data) {
			const stream = this.stream;
			if (data === null) {
				this.highWaterMark = 0;
				stream._duplexState = (stream._duplexState | READ_ENDING) & READ_NON_PRIMARY_AND_PUSHED;
				return false;
			}
			if (this.map !== null) {
				data = this.map(data);
				if (data === null) {
					stream._duplexState &= READ_PUSHED;
					return this.buffered < this.highWaterMark;
				}
			}
			this.buffered += this.byteLength(data);
			this.queue.push(data);
			stream._duplexState = (stream._duplexState | READ_QUEUED) & READ_PUSHED;
			return this.buffered < this.highWaterMark;
		}
		shift() {
			const data = this.queue.shift();
			this.buffered -= this.byteLength(data);
			if (this.buffered === 0) this.stream._duplexState &= READ_NOT_QUEUED;
			return data;
		}
		unshift(data) {
			const pending = [this.map !== null ? this.map(data) : data];
			while (this.buffered > 0) pending.push(this.shift());
			for (let i = 0; i < pending.length - 1; i++) {
				const data2 = pending[i];
				this.buffered += this.byteLength(data2);
				this.queue.push(data2);
			}
			this.push(pending[pending.length - 1]);
		}
		read() {
			const stream = this.stream;
			if ((stream._duplexState & READ_STATUS) === READ_QUEUED) {
				const data = this.shift();
				if (this.pipeTo !== null && this.pipeTo.write(data) === false) stream._duplexState &= READ_PIPE_NOT_DRAINED;
				if ((stream._duplexState & READ_EMIT_DATA) !== 0) stream.emit("data", data);
				return data;
			}
			if (this.readAhead === false) {
				stream._duplexState |= READ_READ_AHEAD;
				this.updateNextTick();
			}
			return null;
		}
		drain() {
			const stream = this.stream;
			while ((stream._duplexState & READ_STATUS) === READ_QUEUED && (stream._duplexState & READ_FLOWING) !== 0) {
				const data = this.shift();
				if (this.pipeTo !== null && this.pipeTo.write(data) === false) stream._duplexState &= READ_PIPE_NOT_DRAINED;
				if ((stream._duplexState & READ_EMIT_DATA) !== 0) stream.emit("data", data);
			}
		}
		update() {
			const stream = this.stream;
			stream._duplexState |= READ_UPDATING;
			do {
				this.drain();
				while (this.buffered < this.highWaterMark && (stream._duplexState & SHOULD_NOT_READ) === READ_READ_AHEAD) {
					stream._duplexState |= READ_ACTIVE_AND_NEEDS_PUSH;
					stream._read(this.afterRead);
					this.drain();
				}
				if ((stream._duplexState & READ_READABLE_STATUS) === READ_EMIT_READABLE_AND_QUEUED) {
					stream._duplexState |= READ_EMITTED_READABLE;
					stream.emit("readable");
				}
				if ((stream._duplexState & READ_PRIMARY_AND_ACTIVE) === 0) this.updateNonPrimary();
			} while (this.continueUpdate() === true);
			stream._duplexState &= READ_NOT_UPDATING;
		}
		updateNonPrimary() {
			const stream = this.stream;
			if ((stream._duplexState & READ_ENDING_STATUS) === READ_ENDING) {
				stream._duplexState = (stream._duplexState | READ_DONE) & READ_NOT_ENDING;
				stream.emit("end");
				if ((stream._duplexState & AUTO_DESTROY) === DONE) stream._duplexState |= DESTROYING;
				if (this.pipeTo !== null) this.pipeTo.end();
			}
			if ((stream._duplexState & DESTROY_STATUS) === DESTROYING) {
				if ((stream._duplexState & ACTIVE_OR_TICKING) === 0) {
					stream._duplexState |= ACTIVE;
					stream._destroy(afterDestroy.bind(this));
				}
				return;
			}
			if ((stream._duplexState & IS_OPENING) === OPENING) {
				stream._duplexState = (stream._duplexState | ACTIVE) & NOT_OPENING;
				stream._open(afterOpen.bind(this));
			}
		}
		continueUpdate() {
			if ((this.stream._duplexState & READ_NEXT_TICK) === 0) return false;
			this.stream._duplexState &= READ_NOT_NEXT_TICK;
			return true;
		}
		updateCallback() {
			if ((this.stream._duplexState & READ_UPDATE_SYNC_STATUS) === READ_PRIMARY) this.update();
			else this.updateNextTick();
		}
		updateNextTickIfOpen() {
			if ((this.stream._duplexState & READ_NEXT_TICK_OR_OPENING) !== 0) return;
			this.stream._duplexState |= READ_NEXT_TICK;
			if ((this.stream._duplexState & READ_UPDATING) === 0) qmt(this.afterUpdateNextTick);
		}
		updateNextTick() {
			if ((this.stream._duplexState & READ_NEXT_TICK) !== 0) return;
			this.stream._duplexState |= READ_NEXT_TICK;
			if ((this.stream._duplexState & READ_UPDATING) === 0) qmt(this.afterUpdateNextTick);
		}
	}
	class TransformState {
		constructor(stream) {
			this.data = null;
			this.afterTransform = afterTransform.bind(stream);
			this.afterFinal = null;
		}
	}
	class Pipeline {
		constructor(src, dst, cb) {
			this.from = src;
			this.to = dst;
			this.afterPipe = cb;
			this.error = null;
			this.pipeToFinished = false;
		}
		finished() {
			this.pipeToFinished = true;
		}
		done(stream, err) {
			if (err) this.error = err;
			if (stream === this.to) {
				this.to = null;
				if (this.from !== null) {
					if ((this.from._duplexState & READ_DONE) === 0 || !this.pipeToFinished) this.from.destroy(this.error || /* @__PURE__ */ new Error("Writable stream closed prematurely"));
					return;
				}
			}
			if (stream === this.from) {
				this.from = null;
				if (this.to !== null) {
					if ((stream._duplexState & READ_DONE) === 0) this.to.destroy(this.error || /* @__PURE__ */ new Error("Readable stream closed before ending"));
					return;
				}
			}
			if (this.afterPipe !== null) this.afterPipe(this.error);
			this.to = this.from = this.afterPipe = null;
		}
	}
	function afterDrain() {
		this.stream._duplexState |= READ_PIPE_DRAINED;
		this.updateCallback();
	}
	function afterFinal(err) {
		const stream = this.stream;
		if (err) stream.destroy(err);
		if ((stream._duplexState & DESTROY_STATUS) === 0) {
			stream._duplexState |= WRITE_DONE;
			stream.emit("finish");
		}
		if ((stream._duplexState & AUTO_DESTROY) === DONE) stream._duplexState |= DESTROYING;
		stream._duplexState &= WRITE_NOT_FINISHING;
		if ((stream._duplexState & WRITE_UPDATING) === 0) this.update();
		else this.updateNextTick();
	}
	function afterDestroy(err) {
		const stream = this.stream;
		if (!err && this.error !== STREAM_DESTROYED) err = this.error;
		if (err) stream.emit("error", err);
		stream._duplexState |= DESTROYED;
		stream.emit("close");
		const rs = stream._readableState;
		const ws = stream._writableState;
		if (rs !== null && rs.pipeline !== null) rs.pipeline.done(stream, err);
		if (ws !== null) {
			while (ws.drains !== null && ws.drains.length > 0) ws.drains.shift().resolve(false);
			if (ws.pipeline !== null) ws.pipeline.done(stream, err);
		}
	}
	function afterWrite(err) {
		const stream = this.stream;
		if (err) stream.destroy(err);
		stream._duplexState &= WRITE_NOT_ACTIVE;
		if (this.drains !== null) tickDrains(this.drains);
		if ((stream._duplexState & WRITE_DRAIN_STATUS) === WRITE_UNDRAINED) {
			stream._duplexState &= WRITE_DRAINED;
			if ((stream._duplexState & WRITE_EMIT_DRAIN) === WRITE_EMIT_DRAIN) stream.emit("drain");
		}
		this.updateCallback();
	}
	function afterRead(err) {
		if (err) this.stream.destroy(err);
		this.stream._duplexState &= READ_NOT_ACTIVE;
		if (this.readAhead === false && (this.stream._duplexState & READ_RESUMED) === 0) this.stream._duplexState &= READ_NO_READ_AHEAD;
		this.updateCallback();
	}
	function updateReadNT() {
		if ((this.stream._duplexState & READ_UPDATING) === 0) {
			this.stream._duplexState &= READ_NOT_NEXT_TICK;
			this.update();
		}
	}
	function updateWriteNT() {
		if ((this.stream._duplexState & WRITE_UPDATING) === 0) {
			this.stream._duplexState &= WRITE_NOT_NEXT_TICK;
			this.update();
		}
	}
	function tickDrains(drains) {
		for (let i = 0; i < drains.length; i++) if (--drains[i].writes === 0) {
			drains.shift().resolve(true);
			i--;
		}
	}
	function afterOpen(err) {
		const stream = this.stream;
		if (err) stream.destroy(err);
		if ((stream._duplexState & DESTROYING) === 0) {
			if ((stream._duplexState & READ_PRIMARY_STATUS) === 0) stream._duplexState |= READ_PRIMARY;
			if ((stream._duplexState & WRITE_PRIMARY_STATUS) === 0) stream._duplexState |= WRITE_PRIMARY;
			stream.emit("open");
		}
		stream._duplexState &= NOT_ACTIVE;
		if (stream._writableState !== null) stream._writableState.updateCallback();
		if (stream._readableState !== null) stream._readableState.updateCallback();
	}
	function afterTransform(err, data) {
		if (data !== void 0 && data !== null) this.push(data);
		this._writableState.afterWrite(err);
	}
	function newListener(name) {
		if (this._readableState !== null) {
			if (name === "data") {
				this._duplexState |= READ_EMIT_DATA | READ_RESUMED_READ_AHEAD;
				this._readableState.updateNextTick();
			}
			if (name === "readable") {
				this._duplexState |= READ_EMIT_READABLE;
				this._readableState.updateNextTick();
			}
		}
		if (this._writableState !== null) {
			if (name === "drain") {
				this._duplexState |= WRITE_EMIT_DRAIN;
				this._writableState.updateNextTick();
			}
		}
	}
	class Stream extends EventEmitter2 {
		constructor(opts) {
			super();
			this._duplexState = 0;
			this._readableState = null;
			this._writableState = null;
			if (opts) {
				if (opts.open) this._open = opts.open;
				if (opts.destroy) this._destroy = opts.destroy;
				if (opts.predestroy) this._predestroy = opts.predestroy;
				if (opts.signal) opts.signal.addEventListener("abort", abort.bind(this));
			}
			this.on("newListener", newListener);
		}
		_open(cb) {
			cb(null);
		}
		_destroy(cb) {
			cb(null);
		}
		_predestroy() {}
		get readable() {
			return this._readableState !== null ? true : void 0;
		}
		get writable() {
			return this._writableState !== null ? true : void 0;
		}
		get destroyed() {
			return (this._duplexState & DESTROYED) !== 0;
		}
		get destroying() {
			return (this._duplexState & DESTROY_STATUS) !== 0;
		}
		destroy(err) {
			if ((this._duplexState & DESTROY_STATUS) === 0) {
				if (!err) err = STREAM_DESTROYED;
				this._duplexState = (this._duplexState | DESTROYING) & NON_PRIMARY;
				if (this._readableState !== null) {
					this._readableState.highWaterMark = 0;
					this._readableState.error = err;
				}
				if (this._writableState !== null) {
					this._writableState.highWaterMark = 0;
					this._writableState.error = err;
				}
				this._duplexState |= PREDESTROYING;
				this._predestroy();
				this._duplexState &= NOT_PREDESTROYING;
				if (this._readableState !== null) this._readableState.updateNextTick();
				if (this._writableState !== null) this._writableState.updateNextTick();
			}
		}
	}
	class Readable extends Stream {
		constructor(opts) {
			super(opts);
			this._duplexState |= WRITE_DONE | 131073;
			this._readableState = new ReadableState(this, opts);
			if (opts) {
				if (this._readableState.readAhead === false) this._duplexState &= READ_NO_READ_AHEAD;
				if (opts.read) this._read = opts.read;
				if (opts.eagerOpen) this._readableState.updateNextTick();
				if (opts.encoding) this.setEncoding(opts.encoding);
			}
		}
		setEncoding(encoding) {
			const dec = new TextDecoder2(encoding);
			const map = this._readableState.map || echo;
			this._readableState.map = mapOrSkip;
			return this;
			function mapOrSkip(data) {
				const next = dec.push(data);
				return next === "" && (data.byteLength !== 0 || dec.remaining > 0) ? null : map(next);
			}
		}
		_read(cb) {
			cb(null);
		}
		pipe(dest, cb) {
			this._readableState.updateNextTick();
			this._readableState.pipe(dest, cb);
			return dest;
		}
		read() {
			this._readableState.updateNextTick();
			return this._readableState.read();
		}
		push(data) {
			this._readableState.updateNextTickIfOpen();
			return this._readableState.push(data);
		}
		unshift(data) {
			this._readableState.updateNextTickIfOpen();
			return this._readableState.unshift(data);
		}
		resume() {
			this._duplexState |= READ_RESUMED_READ_AHEAD;
			this._readableState.updateNextTick();
			return this;
		}
		pause() {
			this._duplexState &= this._readableState.readAhead === false ? READ_PAUSED_NO_READ_AHEAD : READ_PAUSED;
			return this;
		}
		static _fromAsyncIterator(ite, opts) {
			let destroy;
			const rs = new Readable({
				...opts,
				read(cb) {
					ite.next().then(push).then(cb.bind(null, null)).catch(cb);
				},
				predestroy() {
					destroy = ite.return();
				},
				destroy(cb) {
					if (!destroy) return cb(null);
					destroy.then(cb.bind(null, null)).catch(cb);
				}
			});
			return rs;
			function push(data) {
				if (data.done) rs.push(null);
				else rs.push(data.value);
			}
		}
		static from(data, opts) {
			if (isReadStreamx(data)) return data;
			if (data[asyncIterator]) return this._fromAsyncIterator(data[asyncIterator](), opts);
			if (!Array.isArray(data)) data = data === void 0 ? [] : [data];
			let i = 0;
			return new Readable({
				...opts,
				read(cb) {
					this.push(i === data.length ? null : data[i++]);
					cb(null);
				}
			});
		}
		static isBackpressured(rs) {
			return (rs._duplexState & READ_BACKPRESSURE_STATUS) !== 0 || rs._readableState.buffered >= rs._readableState.highWaterMark;
		}
		static isPaused(rs) {
			return (rs._duplexState & READ_RESUMED) === 0;
		}
		[asyncIterator]() {
			const stream = this;
			let error = null;
			let promiseResolve = null;
			let promiseReject = null;
			this.on("error", (err) => {
				error = err;
			});
			this.on("readable", onreadable);
			this.on("close", onclose);
			return {
				[asyncIterator]() {
					return this;
				},
				next() {
					return new Promise(function(resolve, reject) {
						promiseResolve = resolve;
						promiseReject = reject;
						const data = stream.read();
						if (data !== null) ondata(data);
						else if ((stream._duplexState & DESTROYED) !== 0) ondata(null);
					});
				},
				return() {
					return destroy(null);
				},
				throw(err) {
					return destroy(err);
				}
			};
			function onreadable() {
				if (promiseResolve !== null) ondata(stream.read());
			}
			function onclose() {
				if (promiseResolve !== null) ondata(null);
			}
			function ondata(data) {
				if (promiseReject === null) return;
				if (error) promiseReject(error);
				else if (data === null && (stream._duplexState & READ_DONE) === 0) promiseReject(STREAM_DESTROYED);
				else promiseResolve({
					value: data,
					done: data === null
				});
				promiseReject = promiseResolve = null;
			}
			function destroy(err) {
				stream.destroy(err);
				return new Promise((resolve, reject) => {
					if (stream._duplexState & DESTROYED) return resolve({
						value: void 0,
						done: true
					});
					stream.once("close", function() {
						if (err) reject(err);
						else resolve({
							value: void 0,
							done: true
						});
					});
				});
			}
		}
	}
	class Writable extends Stream {
		constructor(opts) {
			super(opts);
			this._duplexState |= OPENING | READ_DONE;
			this._writableState = new WritableState(this, opts);
			if (opts) {
				if (opts.writev) this._writev = opts.writev;
				if (opts.write) this._write = opts.write;
				if (opts.final) this._final = opts.final;
				if (opts.eagerOpen) this._writableState.updateNextTick();
			}
		}
		cork() {
			this._duplexState |= WRITE_CORKED;
		}
		uncork() {
			this._duplexState &= WRITE_NOT_CORKED;
			this._writableState.updateNextTick();
		}
		_writev(batch, cb) {
			cb(null);
		}
		_write(data, cb) {
			this._writableState.autoBatch(data, cb);
		}
		_final(cb) {
			cb(null);
		}
		static isBackpressured(ws) {
			return (ws._duplexState & WRITE_BACKPRESSURE_STATUS) !== 0;
		}
		static drained(ws) {
			if (ws.destroyed) return Promise.resolve(false);
			const state = ws._writableState;
			const writes = (isWritev(ws) ? Math.min(1, state.queue.length) : state.queue.length) + (ws._duplexState & WRITE_WRITING ? 1 : 0);
			if (writes === 0) return Promise.resolve(true);
			if (state.drains === null) state.drains = [];
			return new Promise((resolve) => {
				state.drains.push({
					writes,
					resolve
				});
			});
		}
		write(data) {
			this._writableState.updateNextTick();
			return this._writableState.push(data);
		}
		end(data) {
			this._writableState.updateNextTick();
			this._writableState.end(data);
			return this;
		}
	}
	class Duplex extends Readable {
		constructor(opts) {
			super(opts);
			this._duplexState = OPENING | this._duplexState & READ_READ_AHEAD;
			this._writableState = new WritableState(this, opts);
			if (opts) {
				if (opts.writev) this._writev = opts.writev;
				if (opts.write) this._write = opts.write;
				if (opts.final) this._final = opts.final;
			}
		}
		cork() {
			this._duplexState |= WRITE_CORKED;
		}
		uncork() {
			this._duplexState &= WRITE_NOT_CORKED;
			this._writableState.updateNextTick();
		}
		_writev(batch, cb) {
			cb(null);
		}
		_write(data, cb) {
			this._writableState.autoBatch(data, cb);
		}
		_final(cb) {
			cb(null);
		}
		write(data) {
			this._writableState.updateNextTick();
			return this._writableState.push(data);
		}
		end(data) {
			this._writableState.updateNextTick();
			this._writableState.end(data);
			return this;
		}
	}
	class Transform extends Duplex {
		constructor(opts) {
			super(opts);
			this._transformState = new TransformState(this);
			if (opts) {
				if (opts.transform) this._transform = opts.transform;
				if (opts.flush) this._flush = opts.flush;
			}
		}
		_write(data, cb) {
			if (this._readableState.buffered >= this._readableState.highWaterMark) this._transformState.data = data;
			else this._transform(data, this._transformState.afterTransform);
		}
		_read(cb) {
			if (this._transformState.data !== null) {
				const data = this._transformState.data;
				this._transformState.data = null;
				cb(null);
				this._transform(data, this._transformState.afterTransform);
			} else cb(null);
		}
		destroy(err) {
			super.destroy(err);
			if (this._transformState.data !== null) {
				this._transformState.data = null;
				this._transformState.afterTransform();
			}
		}
		_transform(data, cb) {
			cb(null, data);
		}
		_flush(cb) {
			cb(null);
		}
		_final(cb) {
			this._transformState.afterFinal = cb;
			this._flush(transformAfterFlush.bind(this));
		}
	}
	class PassThrough extends Transform {}
	function transformAfterFlush(err, data) {
		const cb = this._transformState.afterFinal;
		if (err) return cb(err);
		if (data !== null && data !== void 0) this.push(data);
		this.push(null);
		cb(null);
	}
	function pipelinePromise(...streams) {
		return new Promise((resolve, reject) => {
			return pipeline(...streams, (err) => {
				if (err) return reject(err);
				resolve();
			});
		});
	}
	function pipeline(stream, ...streams) {
		const all = Array.isArray(stream) ? [...stream, ...streams] : [stream, ...streams];
		const done = all.length && typeof all[all.length - 1] === "function" ? all.pop() : null;
		if (all.length < 2) throw new Error("Pipeline requires at least 2 streams");
		let src = all[0];
		let dest = null;
		let error = null;
		for (let i = 1; i < all.length; i++) {
			dest = all[i];
			if (isStreamx(src)) src.pipe(dest, onerror);
			else {
				errorHandle(src, true, i > 1, onerror);
				src.pipe(dest);
			}
			src = dest;
		}
		if (done) {
			let fin = false;
			const autoDestroy = isStreamx(dest) || !!(dest._writableState && dest._writableState.autoDestroy);
			dest.on("error", (err) => {
				if (error === null) error = err;
			});
			dest.on("finish", () => {
				fin = true;
				if (!autoDestroy) done(error);
			});
			if (autoDestroy) dest.on("close", () => done(error || (fin ? null : PREMATURE_CLOSE)));
		}
		return dest;
		function errorHandle(s, rd, wr, onerror2) {
			s.on("error", onerror2);
			s.on("close", onclose);
			function onclose() {
				if (s._readableState && !s._readableState.ended) return onerror2(PREMATURE_CLOSE);
				if (wr && s._writableState && !s._writableState.ended) return onerror2(PREMATURE_CLOSE);
			}
		}
		function onerror(err) {
			if (!err || error) return;
			error = err;
			for (const s of all) s.destroy(err);
		}
	}
	function echo(s) {
		return s;
	}
	function isStream(stream) {
		return !!stream._readableState || !!stream._writableState;
	}
	function isStreamx(stream) {
		return typeof stream._duplexState === "number" && isStream(stream);
	}
	function isEnded(stream) {
		return !!stream._readableState && stream._readableState.ended;
	}
	function isFinished(stream) {
		return !!stream._writableState && stream._writableState.ended;
	}
	function getStreamError(stream, opts = {}) {
		const err = stream._readableState && stream._readableState.error || stream._writableState && stream._writableState.error;
		return !opts.all && err === STREAM_DESTROYED ? null : err;
	}
	function isReadStreamx(stream) {
		return isStreamx(stream) && stream.readable;
	}
	function isDisturbed(stream) {
		return (stream._duplexState & OPENING) !== OPENING || (stream._duplexState & ACTIVE_OR_TICKING) !== 0;
	}
	function isTypedArray(data) {
		return typeof data === "object" && data !== null && typeof data.byteLength === "number";
	}
	function defaultByteLength(data) {
		return isTypedArray(data) ? data.byteLength : 1024;
	}
	function noop2() {}
	function abort() {
		this.destroy(/* @__PURE__ */ new Error("Stream aborted."));
	}
	function isWritev(s) {
		return s._writev !== Writable.prototype._writev && s._writev !== Duplex.prototype._writev;
	}
	streamx = {
		pipeline,
		pipelinePromise,
		isStream,
		isStreamx,
		isEnded,
		isFinished,
		isDisturbed,
		getStreamError,
		Stream,
		Writable,
		Readable,
		Duplex,
		Transform,
		PassThrough
	};
	return streamx;
}
var streamxExports = requireStreamx();
var errCode$1;
var hasRequiredErrCode;
function requireErrCode() {
	if (hasRequiredErrCode) return errCode$1;
	hasRequiredErrCode = 1;
	function assign(obj, props) {
		for (const key in props) Object.defineProperty(obj, key, {
			value: props[key],
			enumerable: true,
			configurable: true
		});
		return obj;
	}
	function createError(err, code, props) {
		if (!err || typeof err === "string") throw new TypeError("Please pass an Error to err-code");
		if (!props) props = {};
		if (typeof code === "object") {
			props = code;
			code = "";
		}
		if (code) props.code = code;
		try {
			return assign(err, props);
		} catch (_) {
			props.message = err.message;
			props.stack = err.stack;
			const ErrClass = function() {};
			ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
			return assign(new ErrClass(), props);
		}
	}
	errCode$1 = createError;
	return errCode$1;
}
var errCode = /* @__PURE__ */ getDefaultExportFromCjs(requireErrCode());
var alphabet = "0123456789abcdef";
var encodeLookup = [];
var decodeLookup = [];
for (let i = 0; i < 256; i++) {
	encodeLookup[i] = alphabet[i >> 4 & 15] + alphabet[i & 15];
	if (i < 16) if (i < 10) decodeLookup[48 + i] = i;
	else decodeLookup[87 + i] = i;
}
var arr2hex = (data) => {
	const length = data.length;
	let string = "";
	let i = 0;
	while (i < length) string += encodeLookup[data[i++]];
	return string;
};
var hex2arr = (str) => {
	const sizeof = str.length >> 1;
	const length = sizeof << 1;
	const array = new Uint8Array(sizeof);
	let n = 0;
	let i = 0;
	while (i < length) array[n++] = decodeLookup[str.charCodeAt(i++)] << 4 | decodeLookup[str.charCodeAt(i++)];
	return array;
};
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i$1 = 0; i$1 < chars.length; i$1++) lookup$1[chars.charCodeAt(i$1)] = i$1;
var decoder = new TextDecoder();
var arr2text = (data, enc) => {
	return decoder.decode(data);
};
var encoder = new TextEncoder();
var text2arr = (str) => encoder.encode(str);
var bin2hex = (str) => {
	let res = "";
	let c;
	let i = 0;
	const len = str.length;
	while (i < len) {
		c = str.charCodeAt(i++);
		res += alphabet[c >> 4] + alphabet[c & 15];
	}
	return res;
};
var MAX_ARGUMENTS_LENGTH = 65536;
var hex2bin = (hex) => {
	const points = hex2arr(hex);
	if (points.length <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode(...points);
	let res = "";
	let i = 0;
	while (i < points.length) res += String.fromCharCode(...points.subarray(i, i += MAX_ARGUMENTS_LENGTH));
	return res;
};
var scope = typeof window !== "undefined" ? window : self;
var crypto$1 = scope.crypto || scope.msCrypto || {};
crypto$1.subtle || crypto$1.webkitSubtle;
var randomBytes = (size) => {
	const view = new Uint8Array(size);
	return crypto$1.getRandomValues(view);
};
var Debug = debug$3$1("simple-peer");
var MAX_BUFFERED_AMOUNT$1 = 64 * 1024;
var ICECOMPLETE_TIMEOUT = 5 * 1e3;
var CHANNEL_CLOSING_TIMEOUT = 5 * 1e3;
function filterTrickle(sdp) {
	return sdp.replace(/a=ice-options:trickle\s\n/g, "");
}
function warn(message) {
	console.warn(message);
}
var Peer$1 = class Peer extends streamxExports.Duplex {
	/** @type {RTCPeerConnection} */
	_pc;
	constructor(opts) {
		opts = Object.assign({ allowHalfOpen: false }, opts);
		super(opts);
		this.__objectMode = !!opts.objectMode;
		this._id = arr2hex(randomBytes(4)).slice(0, 7);
		this._debug("new peer %o", opts);
		this.channelName = opts.initiator ? opts.channelName || arr2hex(randomBytes(20)) : null;
		this.initiator = opts.initiator || false;
		this.channelConfig = opts.channelConfig || Peer.channelConfig;
		this.channelNegotiated = this.channelConfig.negotiated;
		this.config = Object.assign({}, Peer.config, opts.config);
		this.offerOptions = opts.offerOptions || {};
		this.answerOptions = opts.answerOptions || {};
		this.sdpTransform = opts.sdpTransform || ((sdp) => sdp);
		this.trickle = opts.trickle !== void 0 ? opts.trickle : true;
		this.allowHalfTrickle = opts.allowHalfTrickle !== void 0 ? opts.allowHalfTrickle : false;
		this.iceCompleteTimeout = opts.iceCompleteTimeout || ICECOMPLETE_TIMEOUT;
		this._destroying = false;
		this._connected = false;
		this.remoteAddress = void 0;
		this.remoteFamily = void 0;
		this.remotePort = void 0;
		this.localAddress = void 0;
		this.localFamily = void 0;
		this.localPort = void 0;
		if (!RTCPeerConnection) if (typeof window === "undefined") throw errCode(/* @__PURE__ */ new Error("No WebRTC support: Specify `opts.wrtc` option in this environment"), "ERR_WEBRTC_SUPPORT");
		else throw errCode(/* @__PURE__ */ new Error("No WebRTC support: Not a supported browser"), "ERR_WEBRTC_SUPPORT");
		this._pcReady = false;
		this._channelReady = false;
		this._iceComplete = false;
		this._iceCompleteTimer = null;
		this._channel = null;
		this._pendingCandidates = [];
		this._isNegotiating = false;
		this._firstNegotiation = true;
		this._batchedNegotiation = false;
		this._queuedNegotiation = false;
		this._sendersAwaitingStable = [];
		this._closingInterval = null;
		this._remoteTracks = [];
		this._remoteStreams = [];
		this._chunk = null;
		this._cb = null;
		this._interval = null;
		try {
			this._pc = new RTCPeerConnection(this.config);
		} catch (err) {
			this.__destroy(errCode(err, "ERR_PC_CONSTRUCTOR"));
			return;
		}
		this._isReactNativeWebrtc = typeof this._pc._peerConnectionId === "number";
		this._pc.oniceconnectionstatechange = () => {
			this._onIceStateChange();
		};
		this._pc.onicegatheringstatechange = () => {
			this._onIceStateChange();
		};
		this._pc.onconnectionstatechange = () => {
			this._onConnectionStateChange();
		};
		this._pc.onsignalingstatechange = () => {
			this._onSignalingStateChange();
		};
		this._pc.onicecandidate = (event) => {
			this._onIceCandidate(event);
		};
		if (typeof this._pc.peerIdentity === "object") this._pc.peerIdentity.catch((err) => {
			this.__destroy(errCode(err, "ERR_PC_PEER_IDENTITY"));
		});
		if (this.initiator || this.channelNegotiated) this._setupData({ channel: this._pc.createDataChannel(this.channelName, this.channelConfig) });
		else this._pc.ondatachannel = (event) => {
			this._setupData(event);
		};
		this._debug("initial negotiation");
		this._needsNegotiation();
		this._onFinishBound = () => {
			this._onFinish();
		};
		this.once("finish", this._onFinishBound);
	}
	get bufferSize() {
		return this._channel && this._channel.bufferedAmount || 0;
	}
	get connected() {
		return this._connected && this._channel.readyState === "open";
	}
	address() {
		return {
			port: this.localPort,
			family: this.localFamily,
			address: this.localAddress
		};
	}
	signal(data) {
		if (this._destroying) return;
		if (this.destroyed) throw errCode(/* @__PURE__ */ new Error("cannot signal after peer is destroyed"), "ERR_DESTROYED");
		if (typeof data === "string") try {
			data = JSON.parse(data);
		} catch (err) {
			data = {};
		}
		this._debug("signal()");
		if (data.renegotiate && this.initiator) {
			this._debug("got request to renegotiate");
			this._needsNegotiation();
		}
		if (data.transceiverRequest && this.initiator) {
			this._debug("got request for transceiver");
			this.addTransceiver(data.transceiverRequest.kind, data.transceiverRequest.init);
		}
		if (data.candidate) if (this._pc.remoteDescription && this._pc.remoteDescription.type) this._addIceCandidate(data.candidate);
		else this._pendingCandidates.push(data.candidate);
		if (data.sdp) this._pc.setRemoteDescription(new RTCSessionDescription(data)).then(() => {
			if (this.destroyed) return;
			this._pendingCandidates.forEach((candidate) => {
				this._addIceCandidate(candidate);
			});
			this._pendingCandidates = [];
			if (this._pc.remoteDescription.type === "offer") this._createAnswer();
		}).catch((err) => {
			this.__destroy(errCode(err, "ERR_SET_REMOTE_DESCRIPTION"));
		});
		if (!data.sdp && !data.candidate && !data.renegotiate && !data.transceiverRequest) this.__destroy(errCode(/* @__PURE__ */ new Error("signal() called with invalid signal data"), "ERR_SIGNALING"));
	}
	_addIceCandidate(candidate) {
		const iceCandidateObj = new RTCIceCandidate(candidate);
		this._pc.addIceCandidate(iceCandidateObj).catch((err) => {
			if (!iceCandidateObj.address || iceCandidateObj.address.endsWith(".local")) warn("Ignoring unsupported ICE candidate.");
			else this.__destroy(errCode(err, "ERR_ADD_ICE_CANDIDATE"));
		});
	}
	/**
	* Send text/binary data to the remote peer.
	* @param {ArrayBufferView|ArrayBuffer|Uint8Array|string|Blob} chunk
	*/
	send(chunk) {
		if (this._destroying) return;
		if (this.destroyed) throw errCode(/* @__PURE__ */ new Error("cannot send after peer is destroyed"), "ERR_DESTROYED");
		this._channel.send(chunk);
	}
	_needsNegotiation() {
		this._debug("_needsNegotiation");
		if (this._batchedNegotiation) return;
		this._batchedNegotiation = true;
		queueMicrotask(() => {
			this._batchedNegotiation = false;
			if (this.initiator || !this._firstNegotiation) {
				this._debug("starting batched negotiation");
				this.negotiate();
			} else this._debug("non-initiator initial negotiation request discarded");
			this._firstNegotiation = false;
		});
	}
	negotiate() {
		if (this._destroying) return;
		if (this.destroyed) throw errCode(/* @__PURE__ */ new Error("cannot negotiate after peer is destroyed"), "ERR_DESTROYED");
		if (this.initiator) if (this._isNegotiating) {
			this._queuedNegotiation = true;
			this._debug("already negotiating, queueing");
		} else {
			this._debug("start negotiation");
			setTimeout(() => {
				this._createOffer();
			}, 0);
		}
		else if (this._isNegotiating) {
			this._queuedNegotiation = true;
			this._debug("already negotiating, queueing");
		} else {
			this._debug("requesting negotiation from initiator");
			this.emit("signal", {
				type: "renegotiate",
				renegotiate: true
			});
		}
		this._isNegotiating = true;
	}
	_final(cb) {
		if (!this._readableState.ended) this.push(null);
		cb(null);
	}
	__destroy(err) {
		this.end();
		this._destroy(() => {}, err);
	}
	_destroy(cb, err) {
		if (this.destroyed || this._destroying) return;
		this._destroying = true;
		this._debug("destroying (error: %s)", err && (err.message || err));
		setTimeout(() => {
			if (this._connected) this.emit("disconnect");
			this._connected = false;
			this._pcReady = false;
			this._channelReady = false;
			this._remoteTracks = null;
			this._remoteStreams = null;
			this._senderMap = null;
			clearInterval(this._closingInterval);
			this._closingInterval = null;
			clearInterval(this._interval);
			this._interval = null;
			this._chunk = null;
			this._cb = null;
			if (this._onFinishBound) this.removeListener("finish", this._onFinishBound);
			this._onFinishBound = null;
			if (this._channel) {
				try {
					this._channel.close();
				} catch (err2) {}
				this._channel.onmessage = null;
				this._channel.onopen = null;
				this._channel.onclose = null;
				this._channel.onerror = null;
			}
			if (this._pc) {
				try {
					this._pc.close();
				} catch (err2) {}
				this._pc.oniceconnectionstatechange = null;
				this._pc.onicegatheringstatechange = null;
				this._pc.onsignalingstatechange = null;
				this._pc.onicecandidate = null;
				this._pc.ontrack = null;
				this._pc.ondatachannel = null;
			}
			this._pc = null;
			this._channel = null;
			if (err) this.emit("error", err);
			cb();
		}, 0);
	}
	_setupData(event) {
		if (!event.channel) return this.__destroy(errCode(/* @__PURE__ */ new Error("Data channel event is missing `channel` property"), "ERR_DATA_CHANNEL"));
		this._channel = event.channel;
		this._channel.binaryType = "arraybuffer";
		if (typeof this._channel.bufferedAmountLowThreshold === "number") this._channel.bufferedAmountLowThreshold = MAX_BUFFERED_AMOUNT$1;
		this.channelName = this._channel.label;
		this._channel.onmessage = (event2) => {
			this._onChannelMessage(event2);
		};
		this._channel.onbufferedamountlow = () => {
			this._onChannelBufferedAmountLow();
		};
		this._channel.onopen = () => {
			this._onChannelOpen();
		};
		this._channel.onclose = () => {
			this._onChannelClose();
		};
		this._channel.onerror = (event2) => {
			const err = event2.error instanceof Error ? event2.error : /* @__PURE__ */ new Error(`Datachannel error: ${event2.message} ${event2.filename}:${event2.lineno}:${event2.colno}`);
			this.__destroy(errCode(err, "ERR_DATA_CHANNEL"));
		};
		let isClosing = false;
		this._closingInterval = setInterval(() => {
			if (this._channel && this._channel.readyState === "closing") {
				if (isClosing) this._onChannelClose();
				isClosing = true;
			} else isClosing = false;
		}, CHANNEL_CLOSING_TIMEOUT);
	}
	_write(chunk, cb) {
		if (this.destroyed) return cb(errCode(/* @__PURE__ */ new Error("cannot write after peer is destroyed"), "ERR_DATA_CHANNEL"));
		if (this._connected) {
			try {
				this.send(chunk);
			} catch (err) {
				return this.__destroy(errCode(err, "ERR_DATA_CHANNEL"));
			}
			if (this._channel.bufferedAmount > MAX_BUFFERED_AMOUNT$1) {
				this._debug("start backpressure: bufferedAmount %d", this._channel.bufferedAmount);
				this._cb = cb;
			} else cb(null);
		} else {
			this._debug("write before connect");
			this._chunk = chunk;
			this._cb = cb;
		}
	}
	_onFinish() {
		if (this.destroyed) return;
		const destroySoon = () => {
			setTimeout(() => this.__destroy(), 1e3);
		};
		if (this._connected) destroySoon();
		else this.once("connect", destroySoon);
	}
	_startIceCompleteTimeout() {
		if (this.destroyed) return;
		if (this._iceCompleteTimer) return;
		this._debug("started iceComplete timeout");
		this._iceCompleteTimer = setTimeout(() => {
			if (!this._iceComplete) {
				this._iceComplete = true;
				this._debug("iceComplete timeout completed");
				this.emit("iceTimeout");
				this.emit("_iceComplete");
			}
		}, this.iceCompleteTimeout);
	}
	_createOffer() {
		if (this.destroyed) return;
		this._pc.createOffer(this.offerOptions).then((offer) => {
			if (this.destroyed) return;
			if (!this.trickle && !this.allowHalfTrickle) offer.sdp = filterTrickle(offer.sdp);
			offer.sdp = this.sdpTransform(offer.sdp);
			const sendOffer = () => {
				if (this.destroyed) return;
				const signal = this._pc.localDescription || offer;
				this._debug("signal");
				this.emit("signal", {
					type: signal.type,
					sdp: signal.sdp
				});
			};
			const onSuccess = () => {
				this._debug("createOffer success");
				if (this.destroyed) return;
				if (this.trickle || this._iceComplete) sendOffer();
				else this.once("_iceComplete", sendOffer);
			};
			const onError = (err) => {
				this.__destroy(errCode(err, "ERR_SET_LOCAL_DESCRIPTION"));
			};
			this._pc.setLocalDescription(offer).then(onSuccess).catch(onError);
		}).catch((err) => {
			this.__destroy(errCode(err, "ERR_CREATE_OFFER"));
		});
	}
	_createAnswer() {
		if (this.destroyed) return;
		this._pc.createAnswer(this.answerOptions).then((answer) => {
			if (this.destroyed) return;
			if (!this.trickle && !this.allowHalfTrickle) answer.sdp = filterTrickle(answer.sdp);
			answer.sdp = this.sdpTransform(answer.sdp);
			const sendAnswer = () => {
				if (this.destroyed) return;
				const signal = this._pc.localDescription || answer;
				this._debug("signal");
				this.emit("signal", {
					type: signal.type,
					sdp: signal.sdp
				});
				if (!this.initiator) this._requestMissingTransceivers?.();
			};
			const onSuccess = () => {
				if (this.destroyed) return;
				if (this.trickle || this._iceComplete) sendAnswer();
				else this.once("_iceComplete", sendAnswer);
			};
			const onError = (err) => {
				this.__destroy(errCode(err, "ERR_SET_LOCAL_DESCRIPTION"));
			};
			this._pc.setLocalDescription(answer).then(onSuccess).catch(onError);
		}).catch((err) => {
			this.__destroy(errCode(err, "ERR_CREATE_ANSWER"));
		});
	}
	_onConnectionStateChange() {
		if (this.destroyed || this._destroying) return;
		if (this._pc.connectionState === "failed") this.__destroy(errCode(/* @__PURE__ */ new Error("Connection failed."), "ERR_CONNECTION_FAILURE"));
	}
	_onIceStateChange() {
		if (this.destroyed) return;
		const iceConnectionState = this._pc.iceConnectionState;
		const iceGatheringState = this._pc.iceGatheringState;
		this._debug("iceStateChange (connection: %s) (gathering: %s)", iceConnectionState, iceGatheringState);
		this.emit("iceStateChange", iceConnectionState, iceGatheringState);
		if (iceConnectionState === "connected" || iceConnectionState === "completed") {
			this._pcReady = true;
			this._maybeReady();
		}
		if (iceConnectionState === "failed") this.__destroy(errCode(/* @__PURE__ */ new Error("Ice connection failed."), "ERR_ICE_CONNECTION_FAILURE"));
		if (iceConnectionState === "closed") this.__destroy(errCode(/* @__PURE__ */ new Error("Ice connection closed."), "ERR_ICE_CONNECTION_CLOSED"));
	}
	getStats(cb) {
		const flattenValues = (report) => {
			if (Object.prototype.toString.call(report.values) === "[object Array]") report.values.forEach((value) => {
				Object.assign(report, value);
			});
			return report;
		};
		if (this._pc.getStats.length === 0 || this._isReactNativeWebrtc) this._pc.getStats().then((res) => {
			const reports = [];
			res.forEach((report) => {
				reports.push(flattenValues(report));
			});
			cb(null, reports);
		}, (err) => cb(err));
		else if (this._pc.getStats.length > 0) this._pc.getStats((res) => {
			if (this.destroyed) return;
			const reports = [];
			res.result().forEach((result) => {
				const report = {};
				result.names().forEach((name) => {
					report[name] = result.stat(name);
				});
				report.id = result.id;
				report.type = result.type;
				report.timestamp = result.timestamp;
				reports.push(flattenValues(report));
			});
			cb(null, reports);
		}, (err) => cb(err));
		else cb(null, []);
	}
	_maybeReady() {
		this._debug("maybeReady pc %s channel %s", this._pcReady, this._channelReady);
		if (this._connected || this._connecting || !this._pcReady || !this._channelReady) return;
		this._connecting = true;
		const findCandidatePair = () => {
			if (this.destroyed || this._destroying) return;
			this.getStats((err, items) => {
				if (this.destroyed || this._destroying) return;
				if (err) items = [];
				const remoteCandidates = {};
				const localCandidates = {};
				const candidatePairs = {};
				let foundSelectedCandidatePair = false;
				items.forEach((item) => {
					if (item.type === "remotecandidate" || item.type === "remote-candidate") remoteCandidates[item.id] = item;
					if (item.type === "localcandidate" || item.type === "local-candidate") localCandidates[item.id] = item;
					if (item.type === "candidatepair" || item.type === "candidate-pair") candidatePairs[item.id] = item;
				});
				const setSelectedCandidatePair = (selectedCandidatePair) => {
					foundSelectedCandidatePair = true;
					let local = localCandidates[selectedCandidatePair.localCandidateId];
					if (local && (local.ip || local.address)) {
						this.localAddress = local.ip || local.address;
						this.localPort = Number(local.port);
					} else if (local && local.ipAddress) {
						this.localAddress = local.ipAddress;
						this.localPort = Number(local.portNumber);
					} else if (typeof selectedCandidatePair.googLocalAddress === "string") {
						local = selectedCandidatePair.googLocalAddress.split(":");
						this.localAddress = local[0];
						this.localPort = Number(local[1]);
					}
					if (this.localAddress) this.localFamily = this.localAddress.includes(":") ? "IPv6" : "IPv4";
					let remote = remoteCandidates[selectedCandidatePair.remoteCandidateId];
					if (remote && (remote.ip || remote.address)) {
						this.remoteAddress = remote.ip || remote.address;
						this.remotePort = Number(remote.port);
					} else if (remote && remote.ipAddress) {
						this.remoteAddress = remote.ipAddress;
						this.remotePort = Number(remote.portNumber);
					} else if (typeof selectedCandidatePair.googRemoteAddress === "string") {
						remote = selectedCandidatePair.googRemoteAddress.split(":");
						this.remoteAddress = remote[0];
						this.remotePort = Number(remote[1]);
					}
					if (this.remoteAddress) this.remoteFamily = this.remoteAddress.includes(":") ? "IPv6" : "IPv4";
					this._debug("connect local: %s:%s remote: %s:%s", this.localAddress, this.localPort, this.remoteAddress, this.remotePort);
				};
				items.forEach((item) => {
					if (item.type === "transport" && item.selectedCandidatePairId) setSelectedCandidatePair(candidatePairs[item.selectedCandidatePairId]);
					if (item.type === "googCandidatePair" && item.googActiveConnection === "true" || (item.type === "candidatepair" || item.type === "candidate-pair") && item.selected) setSelectedCandidatePair(item);
				});
				if (!foundSelectedCandidatePair && (!Object.keys(candidatePairs).length || Object.keys(localCandidates).length)) {
					setTimeout(findCandidatePair, 100);
					return;
				} else {
					this._connecting = false;
					this._connected = true;
					this.emit("connect");
				}
				if (this._chunk) {
					try {
						this.send(this._chunk);
					} catch (err2) {
						return this.__destroy(errCode(err2, "ERR_DATA_CHANNEL"));
					}
					this._chunk = null;
					this._debug("sent chunk from \"write before connect\"");
					const cb = this._cb;
					this._cb = null;
					cb(null);
				}
				if (typeof this._channel.bufferedAmountLowThreshold !== "number") {
					this._interval = setInterval(() => this._onInterval(), 150);
					if (this._interval.unref) this._interval.unref();
				}
				this._debug("connect");
				this.emit("connect");
			});
		};
		findCandidatePair();
	}
	_onInterval() {
		if (!this._cb || !this._channel || this._channel.bufferedAmount > MAX_BUFFERED_AMOUNT$1) return;
		this._onChannelBufferedAmountLow();
	}
	_onSignalingStateChange() {
		if (this.destroyed) return;
		if (this._pc.signalingState === "stable") {
			this._isNegotiating = false;
			this._debug("flushing sender queue", this._sendersAwaitingStable);
			this._sendersAwaitingStable.forEach((sender) => {
				this._pc.removeTrack(sender);
				this._queuedNegotiation = true;
			});
			this._sendersAwaitingStable = [];
			if (this._queuedNegotiation) {
				this._debug("flushing negotiation queue");
				this._queuedNegotiation = false;
				this._needsNegotiation();
			} else {
				this._debug("negotiated");
				this.emit("negotiated");
			}
		}
		this._debug("signalingStateChange %s", this._pc.signalingState);
		this.emit("signalingStateChange", this._pc.signalingState);
	}
	_onIceCandidate(event) {
		if (this.destroyed) return;
		if (event.candidate && this.trickle) this.emit("signal", {
			type: "candidate",
			candidate: {
				candidate: event.candidate.candidate,
				sdpMLineIndex: event.candidate.sdpMLineIndex,
				sdpMid: event.candidate.sdpMid
			}
		});
		else if (!event.candidate && !this._iceComplete) {
			this._iceComplete = true;
			this.emit("_iceComplete");
		}
		if (event.candidate) this._startIceCompleteTimeout();
	}
	_onChannelMessage(event) {
		if (this.destroyed) return;
		let data = event.data;
		if (data instanceof ArrayBuffer) data = new Uint8Array(data);
		else if (this.__objectMode === false) data = text2arr(data);
		this.push(data);
	}
	_onChannelBufferedAmountLow() {
		if (this.destroyed || !this._cb) return;
		this._debug("ending backpressure: bufferedAmount %d", this._channel.bufferedAmount);
		const cb = this._cb;
		this._cb = null;
		cb(null);
	}
	_onChannelOpen() {
		if (this._connected || this.destroyed) return;
		this._debug("on channel open");
		this._channelReady = true;
		this._maybeReady();
	}
	_onChannelClose() {
		if (this.destroyed) return;
		this._debug("on channel close");
		this.__destroy();
	}
	_debug() {
		const args = [].slice.call(arguments);
		args[0] = "[" + this._id + "] " + args[0];
		Debug.apply(null, args);
	}
};
Peer$1.WEBRTC_SUPPORT = !!RTCPeerConnection;
Peer$1.config = {
	iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:global.stun.twilio.com:3478"] }],
	sdpSemantics: "unified-plan"
};
Peer$1.channelConfig = {};
var queueMicrotask$1 = /* @__PURE__ */ getDefaultExportFromCjs(requireQueueMicrotask());
var UDPTracker = {};
var common$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
	__proto__: null,
	default: UDPTracker
}, Symbol.toStringTag, { value: "Module" }));
var DEFAULT_ANNOUNCE_PEERS = 50;
var MAX_ANNOUNCE_PEERS = 82;
var parseUrl = (str) => {
	const url = new URL(str.replace(/^udp:/, "http:"));
	if (str.match(/^udp:/)) Object.defineProperties(url, {
		href: { value: url.href.replace(/^http/, "udp") },
		protocol: { value: url.protocol.replace(/^http/, "udp") },
		origin: { value: url.origin.replace(/^http/, "udp") }
	});
	return url;
};
var common = {
	DEFAULT_ANNOUNCE_PEERS,
	MAX_ANNOUNCE_PEERS,
	parseUrl,
	...common$1
};
var debug$2$1 = debug$3$1("simple-websocket");
var _WebSocket = typeof UDPTracker !== "function" ? WebSocket : UDPTracker;
var MAX_BUFFERED_AMOUNT = 64 * 1024;
var Socket = class extends streamxExports.Duplex {
	constructor(opts = {}) {
		if (typeof opts === "string") opts = { url: opts };
		opts = Object.assign({ allowHalfOpen: false }, opts);
		super(opts);
		this.__objectMode = !!opts.objectMode;
		if (opts.objectMode != null) delete opts.objectMode;
		if (opts.url == null && opts.socket == null) throw new Error("Missing required `url` or `socket` option");
		if (opts.url != null && opts.socket != null) throw new Error("Must specify either `url` or `socket` option, not both");
		this._id = arr2hex(randomBytes(4)).slice(0, 7);
		this._debug("new websocket: %o", opts);
		this.connected = false;
		this._chunk = null;
		this._cb = null;
		this._interval = null;
		if (opts.socket) {
			this.url = opts.socket.url;
			this._ws = opts.socket;
			this.connected = opts.socket.readyState === _WebSocket.OPEN;
		} else {
			this.url = opts.url;
			try {
				if (typeof UDPTracker === "function") this._ws = new _WebSocket(opts.url, {
					...opts,
					encoding: void 0
				});
				else this._ws = new _WebSocket(opts.url);
			} catch (err) {
				queueMicrotask$1(() => this.destroy(err));
				return;
			}
		}
		this._ws.binaryType = "arraybuffer";
		if (opts.socket && this.connected) queueMicrotask$1(() => this._handleOpen());
		else this._ws.onopen = () => this._handleOpen();
		this._ws.onmessage = (event) => this._handleMessage(event);
		this._ws.onclose = () => this._handleClose();
		this._ws.onerror = (err) => this._handleError(err);
		this._handleFinishBound = () => this._handleFinish();
		this.once("finish", this._handleFinishBound);
	}
	/**
	* Send text/binary data to the WebSocket server.
	* @param {TypedArrayView|ArrayBuffer|Uint8Array|string|Blob|Object} chunk
	*/
	send(chunk) {
		this._ws.send(chunk);
	}
	_final(cb) {
		if (!this._readableState.ended) this.push(null);
		cb(null);
	}
	_destroy(cb) {
		if (this.destroyed) return;
		if (!this._writableState.ended) this.end();
		this.connected = false;
		clearInterval(this._interval);
		this._interval = null;
		this._chunk = null;
		this._cb = null;
		if (this._handleFinishBound) this.removeListener("finish", this._handleFinishBound);
		this._handleFinishBound = null;
		if (this._ws) {
			const ws = this._ws;
			const onClose = () => {
				ws.onclose = null;
			};
			if (ws.readyState === _WebSocket.CLOSED) onClose();
			else try {
				ws.onclose = onClose;
				ws.close();
			} catch (err) {
				onClose();
			}
			ws.onopen = null;
			ws.onmessage = null;
			ws.onerror = () => {};
		}
		this._ws = null;
		cb();
	}
	_write(chunk, cb) {
		if (this.destroyed) return cb(/* @__PURE__ */ new Error("cannot write after socket is destroyed"));
		if (this.connected) {
			try {
				this.send(chunk);
			} catch (err) {
				return this.destroy(err);
			}
			if (typeof UDPTracker !== "function" && this._ws.bufferedAmount > MAX_BUFFERED_AMOUNT) {
				this._debug("start backpressure: bufferedAmount %d", this._ws.bufferedAmount);
				this._cb = cb;
			} else cb(null);
		} else {
			this._debug("write before connect");
			this._chunk = chunk;
			this._cb = cb;
		}
	}
	_handleOpen() {
		if (this.connected || this.destroyed) return;
		this.connected = true;
		if (this._chunk) {
			try {
				this.send(this._chunk);
			} catch (err) {
				return this.destroy(err);
			}
			this._chunk = null;
			this._debug("sent chunk from \"write before connect\"");
			const cb = this._cb;
			this._cb = null;
			cb(null);
		}
		if (typeof UDPTracker !== "function") {
			this._interval = setInterval(() => this._onInterval(), 150);
			if (this._interval.unref) this._interval.unref();
		}
		this._debug("connect");
		this.emit("connect");
	}
	_handleMessage(event) {
		if (this.destroyed) return;
		let data = event.data;
		if (data instanceof ArrayBuffer) data = new Uint8Array(data);
		if (this.__objectMode === false) data = text2arr(data);
		this.push(data);
	}
	_handleClose() {
		if (this.destroyed) return;
		this._debug("on close");
		this.destroy();
	}
	_handleError(_) {
		this.destroy(/* @__PURE__ */ new Error(`Error connecting to ${this.url}`));
	}
	_handleFinish() {
		if (this.destroyed) return;
		const destroySoon = () => {
			setTimeout(() => this.destroy(), 1e3);
		};
		if (this.connected) destroySoon();
		else this.once("connect", destroySoon);
	}
	_onInterval() {
		if (!this._cb || !this._ws || this._ws.bufferedAmount > MAX_BUFFERED_AMOUNT) return;
		this._debug("ending backpressure: bufferedAmount %d", this._ws.bufferedAmount);
		const cb = this._cb;
		this._cb = null;
		cb(null);
	}
	_debug() {
		const args = [].slice.call(arguments);
		args[0] = "[" + this._id + "] " + args[0];
		debug$2$1.apply(null, args);
	}
};
Socket.WEBSOCKET_SUPPORT = !!_WebSocket;
var Tracker = class extends EventEmitter {
	constructor(client, announceUrl) {
		super();
		this.client = client;
		this.announceUrl = announceUrl;
		this.interval = null;
		this.destroyed = false;
	}
	setInterval(intervalMs) {
		if (intervalMs == null) intervalMs = this.DEFAULT_ANNOUNCE_INTERVAL;
		clearInterval(this.interval);
		if (intervalMs) {
			this.interval = setInterval(() => {
				this.announce(this.client._defaultAnnounceOpts());
			}, intervalMs);
			if (this.interval.unref) this.interval.unref();
		}
	}
};
var debug$1$1 = debug$3$1("bittorrent-tracker:websocket-tracker");
var socketPool = {};
var RECONNECT_MINIMUM = 10 * 1e3;
var RECONNECT_MAXIMUM = 3600 * 1e3;
var RECONNECT_VARIANCE = 300 * 1e3;
var OFFER_TIMEOUT = 50 * 1e3;
var WebSocketTracker = class extends Tracker {
	constructor(client, announceUrl) {
		super(client, announceUrl);
		debug$1$1("new websocket tracker %s", announceUrl);
		this.peers = {};
		this.socket = null;
		this.reconnecting = false;
		this.retries = 0;
		this.reconnectTimer = null;
		this.expectingResponse = false;
		this._openSocket();
	}
	announce(opts) {
		if (this.destroyed || this.reconnecting) return;
		if (!this.socket.connected) {
			this.socket.once("connect", () => {
				this.announce(opts);
			});
			return;
		}
		const params = Object.assign({}, opts, {
			action: "announce",
			info_hash: this.client._infoHashBinary,
			peer_id: this.client._peerIdBinary
		});
		if (this._trackerId) params.trackerid = this._trackerId;
		if (opts.event === "stopped" || opts.event === "completed") this._send(params);
		else {
			const numwant = Math.min(opts.numwant, 5);
			this._generateOffers(numwant, (offers) => {
				params.numwant = numwant;
				params.offers = offers;
				this._send(params);
			});
		}
	}
	scrape(opts) {
		if (this.destroyed || this.reconnecting) return;
		if (!this.socket.connected) {
			this.socket.once("connect", () => {
				this.scrape(opts);
			});
			return;
		}
		const params = {
			action: "scrape",
			info_hash: Array.isArray(opts.infoHash) && opts.infoHash.length > 0 ? opts.infoHash.map((infoHash) => hex2bin(infoHash)) : opts.infoHash && hex2bin(opts.infoHash) || this.client._infoHashBinary
		};
		this._send(params);
	}
	destroy(cb = noop) {
		if (this.destroyed) return cb(null);
		this.destroyed = true;
		clearInterval(this.interval);
		clearTimeout(this.reconnectTimer);
		for (const peerId in this.peers) {
			const peer = this.peers[peerId];
			clearTimeout(peer.trackerTimeout);
			peer.destroy();
		}
		this.peers = null;
		if (this.socket) {
			this.socket.removeListener("connect", this._onSocketConnectBound);
			this.socket.removeListener("data", this._onSocketDataBound);
			this.socket.removeListener("close", this._onSocketCloseBound);
			this.socket.removeListener("error", this._onSocketErrorBound);
			this.socket = null;
		}
		this._onSocketConnectBound = null;
		this._onSocketErrorBound = null;
		this._onSocketDataBound = null;
		this._onSocketCloseBound = null;
		if (socketPool[this.announceUrl]) socketPool[this.announceUrl].consumers -= 1;
		if (socketPool[this.announceUrl].consumers > 0) return cb();
		let socket = socketPool[this.announceUrl];
		delete socketPool[this.announceUrl];
		socket.on("error", noop);
		socket.once("close", cb);
		let timeout;
		if (!this.expectingResponse) return destroyCleanup();
		timeout = setTimeout(destroyCleanup, common.DESTROY_TIMEOUT);
		socket.once("data", destroyCleanup);
		function destroyCleanup() {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			socket.removeListener("data", destroyCleanup);
			socket.destroy();
			socket = null;
		}
	}
	_openSocket() {
		this.destroyed = false;
		if (!this.peers) this.peers = {};
		this._onSocketConnectBound = () => {
			this._onSocketConnect();
		};
		this._onSocketErrorBound = (err) => {
			this._onSocketError(err);
		};
		this._onSocketDataBound = (data) => {
			this._onSocketData(data);
		};
		this._onSocketCloseBound = () => {
			this._onSocketClose();
		};
		this.socket = socketPool[this.announceUrl];
		if (this.socket) {
			socketPool[this.announceUrl].consumers += 1;
			if (this.socket.connected) this._onSocketConnectBound();
		} else {
			const parsedUrl = new URL(this.announceUrl);
			let agent;
			if (this.client._proxyOpts) {
				agent = parsedUrl.protocol === "wss:" ? this.client._proxyOpts.httpsAgent : this.client._proxyOpts.httpAgent;
				if (!agent && this.client._proxyOpts.socksProxy) agent = this.client._proxyOpts.socksProxy;
			}
			this.socket = socketPool[this.announceUrl] = new Socket({
				url: this.announceUrl,
				agent
			});
			this.socket.consumers = 1;
			this.socket.once("connect", this._onSocketConnectBound);
		}
		this.socket.on("data", this._onSocketDataBound);
		this.socket.once("close", this._onSocketCloseBound);
		this.socket.once("error", this._onSocketErrorBound);
	}
	_onSocketConnect() {
		if (this.destroyed) return;
		if (this.reconnecting) {
			this.reconnecting = false;
			this.retries = 0;
			this.announce(this.client._defaultAnnounceOpts());
		}
	}
	_onSocketData(data) {
		if (this.destroyed) return;
		this.expectingResponse = false;
		try {
			data = JSON.parse(arr2text(data));
		} catch (err) {
			this.client.emit("warning", /* @__PURE__ */ new Error("Invalid tracker response"));
			return;
		}
		if (data.action === "announce") this._onAnnounceResponse(data);
		else if (data.action === "scrape") this._onScrapeResponse(data);
		else this._onSocketError(/* @__PURE__ */ new Error(`invalid action in WS response: ${data.action}`));
	}
	_onAnnounceResponse(data) {
		if (data.info_hash !== this.client._infoHashBinary) {
			debug$1$1("ignoring websocket data from %s for %s (looking for %s: reused socket)", this.announceUrl, bin2hex(data.info_hash), this.client.infoHash);
			return;
		}
		if (data.peer_id && data.peer_id === this.client._peerIdBinary) return;
		debug$1$1("received %s from %s for %s", JSON.stringify(data), this.announceUrl, this.client.infoHash);
		const failure = data["failure reason"];
		if (failure) return this.client.emit("warning", new Error(failure));
		const warning = data["warning message"];
		if (warning) this.client.emit("warning", new Error(warning));
		const interval = data.interval || data["min interval"];
		if (interval) this.setInterval(interval * 1e3);
		const trackerId = data["tracker id"];
		if (trackerId) this._trackerId = trackerId;
		if (data.complete != null) {
			const response = Object.assign({}, data, {
				announce: this.announceUrl,
				infoHash: bin2hex(data.info_hash)
			});
			this.client.emit("update", response);
		}
		let peer;
		if (data.offer && data.peer_id) {
			debug$1$1("creating peer (from remote offer)");
			peer = this._createPeer();
			peer.id = bin2hex(data.peer_id);
			peer.once("signal", (answer) => {
				const params = {
					action: "announce",
					info_hash: this.client._infoHashBinary,
					peer_id: this.client._peerIdBinary,
					to_peer_id: data.peer_id,
					answer,
					offer_id: data.offer_id
				};
				if (this._trackerId) params.trackerid = this._trackerId;
				this._send(params);
			});
			this.client.emit("peer", peer);
			peer.signal(data.offer);
		}
		if (data.answer && data.peer_id) {
			const offerId = bin2hex(data.offer_id);
			peer = this.peers[offerId];
			if (peer) {
				peer.id = bin2hex(data.peer_id);
				this.client.emit("peer", peer);
				peer.signal(data.answer);
				clearTimeout(peer.trackerTimeout);
				peer.trackerTimeout = null;
				delete this.peers[offerId];
			} else debug$1$1(`got unexpected answer: ${JSON.stringify(data.answer)}`);
		}
	}
	_onScrapeResponse(data) {
		data = data.files || {};
		const keys = Object.keys(data);
		if (keys.length === 0) {
			this.client.emit("warning", /* @__PURE__ */ new Error("invalid scrape response"));
			return;
		}
		keys.forEach((infoHash) => {
			const response = Object.assign(data[infoHash], {
				announce: this.announceUrl,
				infoHash: bin2hex(infoHash)
			});
			this.client.emit("scrape", response);
		});
	}
	_onSocketClose() {
		if (this.destroyed) return;
		this.destroy();
		this._startReconnectTimer();
	}
	_onSocketError(err) {
		if (this.destroyed) return;
		this.destroy();
		this.client.emit("warning", err);
		this._startReconnectTimer();
	}
	_startReconnectTimer() {
		const ms2 = Math.floor(Math.random() * RECONNECT_VARIANCE) + Math.min(Math.pow(2, this.retries) * RECONNECT_MINIMUM, RECONNECT_MAXIMUM);
		this.reconnecting = true;
		clearTimeout(this.reconnectTimer);
		this.reconnectTimer = setTimeout(() => {
			this.retries++;
			this._openSocket();
		}, ms2);
		if (this.reconnectTimer.unref) this.reconnectTimer.unref();
		debug$1$1("reconnecting socket in %s ms", ms2);
	}
	_send(params) {
		if (this.destroyed) return;
		this.expectingResponse = true;
		const message = JSON.stringify(params);
		debug$1$1("send %s", message);
		this.socket.send(message);
	}
	_generateOffers(numwant, cb) {
		const self2 = this;
		const offers = [];
		debug$1$1("generating %s offers", numwant);
		for (let i = 0; i < numwant; ++i) generateOffer();
		checkDone();
		function generateOffer() {
			const offerId = arr2hex(randomBytes(20));
			debug$1$1("creating peer (from _generateOffers)");
			const peer = self2.peers[offerId] = self2._createPeer({ initiator: true });
			peer.once("signal", (offer) => {
				offers.push({
					offer,
					offer_id: hex2bin(offerId)
				});
				checkDone();
			});
			peer.trackerTimeout = setTimeout(() => {
				debug$1$1("tracker timeout: destroying peer");
				peer.trackerTimeout = null;
				delete self2.peers[offerId];
				peer.destroy();
			}, OFFER_TIMEOUT);
			if (peer.trackerTimeout.unref) peer.trackerTimeout.unref();
		}
		function checkDone() {
			if (offers.length === numwant) {
				debug$1$1("generated %s offers", numwant);
				cb(offers);
			}
		}
	}
	_createPeer(opts) {
		const self2 = this;
		opts = Object.assign({
			trickle: false,
			config: self2.client._rtcConfig,
			wrtc: self2.client._wrtc
		}, opts);
		const peer = new Peer$1(opts);
		peer.once("error", onError);
		peer.once("connect", onConnect);
		return peer;
		function onError(err) {
			self2.client.emit("warning", /* @__PURE__ */ new Error(`Connection error: ${err.message}`));
			peer.destroy();
		}
		function onConnect() {
			peer.removeListener("error", onError);
			peer.removeListener("connect", onConnect);
		}
	}
};
WebSocketTracker.prototype.DEFAULT_ANNOUNCE_INTERVAL = 30 * 1e3;
WebSocketTracker._socketPool = socketPool;
function noop() {}
var debug$7 = debug$3$1("bittorrent-tracker:client");
var Client = class extends EventEmitter {
	constructor(opts = {}) {
		super();
		if (!opts.peerId) throw new Error("Option `peerId` is required");
		if (!opts.infoHash) throw new Error("Option `infoHash` is required");
		if (!opts.announce) throw new Error("Option `announce` is required");
		if (!process$1.browser && !opts.port) throw new Error("Option `port` is required");
		this.peerId = typeof opts.peerId === "string" ? opts.peerId : arr2hex(opts.peerId);
		this._peerIdBuffer = hex2arr(this.peerId);
		this._peerIdBinary = hex2bin(this.peerId);
		this.infoHash = typeof opts.infoHash === "string" ? opts.infoHash.toLowerCase() : arr2hex(opts.infoHash);
		this._infoHashBuffer = hex2arr(this.infoHash);
		this._infoHashBinary = hex2bin(this.infoHash);
		debug$7("new client %s", this.infoHash);
		this.destroyed = false;
		this._port = opts.port;
		this._getAnnounceOpts = opts.getAnnounceOpts;
		this._rtcConfig = opts.rtcConfig;
		this._userAgent = opts.userAgent;
		this._proxyOpts = opts.proxyOpts;
		this._wrtc = typeof opts.wrtc === "function" ? opts.wrtc() : opts.wrtc;
		let announce = typeof opts.announce === "string" ? [opts.announce] : opts.announce == null ? [] : opts.announce;
		announce = announce.map((announceUrl) => {
			if (ArrayBuffer.isView(announceUrl)) announceUrl = arr2text(announceUrl);
			if (announceUrl[announceUrl.length - 1] === "/") announceUrl = announceUrl.substring(0, announceUrl.length - 1);
			return announceUrl;
		});
		announce = Array.from(new Set(announce));
		const webrtcSupport = this._wrtc !== false && (!!this._wrtc || Peer$1.WEBRTC_SUPPORT);
		const nextTickWarn = (err) => {
			queueMicrotask$1(() => {
				this.emit("warning", err);
			});
		};
		this._trackers = announce.map((announceUrl) => {
			let parsedUrl;
			try {
				parsedUrl = common.parseUrl(announceUrl);
			} catch (err) {
				nextTickWarn(/* @__PURE__ */ new Error(`Invalid tracker URL: ${announceUrl}`));
				return null;
			}
			const port = parsedUrl.port;
			if (port < 0 || port > 65535) {
				nextTickWarn(/* @__PURE__ */ new Error(`Invalid tracker port: ${announceUrl}`));
				return null;
			}
			const protocol = parsedUrl.protocol;
			if ((protocol === "http:" || protocol === "https:") && typeof UDPTracker === "function") return new UDPTracker(this, announceUrl);
			else if (protocol === "udp:" && typeof UDPTracker === "function") return new UDPTracker(this, announceUrl);
			else if ((protocol === "ws:" || protocol === "wss:") && webrtcSupport) {
				if (protocol === "ws:" && typeof window !== "undefined" && window.location.protocol === "https:") {
					nextTickWarn(/* @__PURE__ */ new Error(`Unsupported tracker protocol: ${announceUrl}`));
					return null;
				}
				return new WebSocketTracker(this, announceUrl);
			} else {
				nextTickWarn(/* @__PURE__ */ new Error(`Unsupported tracker protocol: ${announceUrl}`));
				return null;
			}
		}).filter(Boolean);
	}
	/**
	* Send a `start` announce to the trackers.
	* @param {Object} opts
	* @param {number=} opts.uploaded
	* @param {number=} opts.downloaded
	* @param {number=} opts.left (if not set, calculated automatically)
	*/
	start(opts) {
		opts = this._defaultAnnounceOpts(opts);
		opts.event = "started";
		debug$7("send `start` %o", opts);
		this._announce(opts);
		this._trackers.forEach((tracker) => {
			tracker.setInterval();
		});
	}
	/**
	* Send a `stop` announce to the trackers.
	* @param {Object} opts
	* @param {number=} opts.uploaded
	* @param {number=} opts.downloaded
	* @param {number=} opts.numwant
	* @param {number=} opts.left (if not set, calculated automatically)
	*/
	stop(opts) {
		opts = this._defaultAnnounceOpts(opts);
		opts.event = "stopped";
		debug$7("send `stop` %o", opts);
		this._announce(opts);
	}
	/**
	* Send a `complete` announce to the trackers.
	* @param {Object} opts
	* @param {number=} opts.uploaded
	* @param {number=} opts.downloaded
	* @param {number=} opts.numwant
	* @param {number=} opts.left (if not set, calculated automatically)
	*/
	complete(opts) {
		if (!opts) opts = {};
		opts = this._defaultAnnounceOpts(opts);
		opts.event = "completed";
		debug$7("send `complete` %o", opts);
		this._announce(opts);
	}
	/**
	* Send a `update` announce to the trackers.
	* @param {Object} opts
	* @param {number=} opts.uploaded
	* @param {number=} opts.downloaded
	* @param {number=} opts.numwant
	* @param {number=} opts.left (if not set, calculated automatically)
	*/
	update(opts) {
		opts = this._defaultAnnounceOpts(opts);
		if (opts.event) delete opts.event;
		debug$7("send `update` %o", opts);
		this._announce(opts);
	}
	_announce(opts) {
		this._trackers.forEach((tracker) => {
			tracker.announce(opts);
		});
	}
	/**
	* Send a scrape request to the trackers.
	* @param {Object} opts
	*/
	scrape(opts) {
		debug$7("send `scrape`");
		if (!opts) opts = {};
		this._trackers.forEach((tracker) => {
			tracker.scrape(opts);
		});
	}
	setInterval(intervalMs) {
		debug$7("setInterval %d", intervalMs);
		this._trackers.forEach((tracker) => {
			tracker.setInterval(intervalMs);
		});
	}
	destroy(cb) {
		if (this.destroyed) return;
		this.destroyed = true;
		debug$7("destroy");
		parallel(this._trackers.map((tracker) => (cb2) => {
			tracker.destroy(cb2);
		}), cb);
		this._trackers = [];
		this._getAnnounceOpts = null;
	}
	_defaultAnnounceOpts(opts = {}) {
		if (opts.numwant == null) opts.numwant = common.DEFAULT_ANNOUNCE_PEERS;
		if (opts.uploaded == null) opts.uploaded = 0;
		if (opts.downloaded == null) opts.downloaded = 0;
		if (this._getAnnounceOpts) opts = Object.assign({}, opts, this._getAnnounceOpts());
		return opts;
	}
};
Client.scrape = (opts, cb) => {
	cb = once(cb);
	if (!opts.infoHash) throw new Error("Option `infoHash` is required");
	if (!opts.announce) throw new Error("Option `announce` is required");
	const client = new Client(Object.assign({}, opts, {
		infoHash: Array.isArray(opts.infoHash) ? opts.infoHash[0] : opts.infoHash,
		peerId: text2arr("01234567890123456789"),
		port: 6881
	}));
	client.once("error", cb);
	client.once("warning", cb);
	let len = Array.isArray(opts.infoHash) ? opts.infoHash.length : 1;
	const results = {};
	client.on("scrape", (data) => {
		len -= 1;
		results[data.infoHash] = data;
		if (len === 0) {
			client.destroy();
			const keys = Object.keys(results);
			if (keys.length === 1) cb(null, results[keys[0]]);
			else cb(null, results);
		}
	});
	client.scrape({ infoHash: opts.infoHash });
	return client;
};
var md5$1 = { exports: {} };
var hasRequiredMd5;
function requireMd5() {
	if (hasRequiredMd5) return md5$1.exports;
	hasRequiredMd5 = 1;
	function FF(a, b, c, d, m, s, k) {
		var n = a + (b & c | ~b & d) + (m >>> 0) + k;
		return (n << s | n >>> 32 - s) + b;
	}
	function GG(a, b, c, d, m, s, k) {
		var n = a + (b & d | c & ~d) + (m >>> 0) + k;
		return (n << s | n >>> 32 - s) + b;
	}
	function HH(a, b, c, d, m, s, k) {
		var n = a + (b ^ c ^ d) + (m >>> 0) + k;
		return (n << s | n >>> 32 - s) + b;
	}
	function II(a, b, c, d, m, s, k) {
		var n = a + (c ^ (b | ~d)) + (m >>> 0) + k;
		return (n << s | n >>> 32 - s) + b;
	}
	function byteToHex(byte) {
		return (256 + (byte & 255)).toString(16).substr(-2);
	}
	function bs(byte) {
		return String.fromCharCode(byte & 255);
	}
	function wordToBytes(word) {
		return bs(word) + bs(word >>> 8) + bs(word >>> 16) + bs(word >>> 24);
	}
	var utf8toBytes = function(utf8) {
		return unescape(encodeURIComponent(utf8));
	};
	function bytesToWords(bytes) {
		var bytes_count = bytes.length, bits_count = bytes_count << 3, words = new Uint32Array(bytes_count + 72 >>> 6 << 4);
		for (var i = 0, n = bytes.length; i < n; ++i) words[i >>> 2] |= bytes.charCodeAt(i) << ((i & 3) << 3);
		words[bytes_count >> 2] |= 128 << (bits_count & 31);
		words[words.length - 2] = bits_count;
		return words;
	}
	var exports$1 = md5$1.exports = function md52(utf8) {
		return utf8toMD5(utf8).toHex();
	};
	var bytesToMD5 = exports$1.fromBytes = function(bytes) {
		var words = bytesToWords(bytes), a = 1732584193, b = 4023233417, c = 2562383102, d = 271733878, S11 = 7, S12 = 12, S13 = 17, S14 = 22, S21 = 5, S22 = 9, S23 = 14, S24 = 20, S31 = 4, S32 = 11, S33 = 16, S34 = 23, S41 = 6, S42 = 10, S43 = 15, S44 = 21;
		for (var i = 0, ws = words.length; i < ws; i += 16) {
			var AA = a, BB = b, CC = c, DD = d;
			a = FF(a, b, c, d, words[i + 0], S11, 3614090360);
			d = FF(d, a, b, c, words[i + 1], S12, 3905402710);
			c = FF(c, d, a, b, words[i + 2], S13, 606105819);
			b = FF(b, c, d, a, words[i + 3], S14, 3250441966);
			a = FF(a, b, c, d, words[i + 4], S11, 4118548399);
			d = FF(d, a, b, c, words[i + 5], S12, 1200080426);
			c = FF(c, d, a, b, words[i + 6], S13, 2821735955);
			b = FF(b, c, d, a, words[i + 7], S14, 4249261313);
			a = FF(a, b, c, d, words[i + 8], S11, 1770035416);
			d = FF(d, a, b, c, words[i + 9], S12, 2336552879);
			c = FF(c, d, a, b, words[i + 10], S13, 4294925233);
			b = FF(b, c, d, a, words[i + 11], S14, 2304563134);
			a = FF(a, b, c, d, words[i + 12], S11, 1804603682);
			d = FF(d, a, b, c, words[i + 13], S12, 4254626195);
			c = FF(c, d, a, b, words[i + 14], S13, 2792965006);
			b = FF(b, c, d, a, words[i + 15], S14, 1236535329);
			a = GG(a, b, c, d, words[i + 1], S21, 4129170786);
			d = GG(d, a, b, c, words[i + 6], S22, 3225465664);
			c = GG(c, d, a, b, words[i + 11], S23, 643717713);
			b = GG(b, c, d, a, words[i + 0], S24, 3921069994);
			a = GG(a, b, c, d, words[i + 5], S21, 3593408605);
			d = GG(d, a, b, c, words[i + 10], S22, 38016083);
			c = GG(c, d, a, b, words[i + 15], S23, 3634488961);
			b = GG(b, c, d, a, words[i + 4], S24, 3889429448);
			a = GG(a, b, c, d, words[i + 9], S21, 568446438);
			d = GG(d, a, b, c, words[i + 14], S22, 3275163606);
			c = GG(c, d, a, b, words[i + 3], S23, 4107603335);
			b = GG(b, c, d, a, words[i + 8], S24, 1163531501);
			a = GG(a, b, c, d, words[i + 13], S21, 2850285829);
			d = GG(d, a, b, c, words[i + 2], S22, 4243563512);
			c = GG(c, d, a, b, words[i + 7], S23, 1735328473);
			b = GG(b, c, d, a, words[i + 12], S24, 2368359562);
			a = HH(a, b, c, d, words[i + 5], S31, 4294588738);
			d = HH(d, a, b, c, words[i + 8], S32, 2272392833);
			c = HH(c, d, a, b, words[i + 11], S33, 1839030562);
			b = HH(b, c, d, a, words[i + 14], S34, 4259657740);
			a = HH(a, b, c, d, words[i + 1], S31, 2763975236);
			d = HH(d, a, b, c, words[i + 4], S32, 1272893353);
			c = HH(c, d, a, b, words[i + 7], S33, 4139469664);
			b = HH(b, c, d, a, words[i + 10], S34, 3200236656);
			a = HH(a, b, c, d, words[i + 13], S31, 681279174);
			d = HH(d, a, b, c, words[i + 0], S32, 3936430074);
			c = HH(c, d, a, b, words[i + 3], S33, 3572445317);
			b = HH(b, c, d, a, words[i + 6], S34, 76029189);
			a = HH(a, b, c, d, words[i + 9], S31, 3654602809);
			d = HH(d, a, b, c, words[i + 12], S32, 3873151461);
			c = HH(c, d, a, b, words[i + 15], S33, 530742520);
			b = HH(b, c, d, a, words[i + 2], S34, 3299628645);
			a = II(a, b, c, d, words[i + 0], S41, 4096336452);
			d = II(d, a, b, c, words[i + 7], S42, 1126891415);
			c = II(c, d, a, b, words[i + 14], S43, 2878612391);
			b = II(b, c, d, a, words[i + 5], S44, 4237533241);
			a = II(a, b, c, d, words[i + 12], S41, 1700485571);
			d = II(d, a, b, c, words[i + 3], S42, 2399980690);
			c = II(c, d, a, b, words[i + 10], S43, 4293915773);
			b = II(b, c, d, a, words[i + 1], S44, 2240044497);
			a = II(a, b, c, d, words[i + 8], S41, 1873313359);
			d = II(d, a, b, c, words[i + 15], S42, 4264355552);
			c = II(c, d, a, b, words[i + 6], S43, 2734768916);
			b = II(b, c, d, a, words[i + 13], S44, 1309151649);
			a = II(a, b, c, d, words[i + 4], S41, 4149444226);
			d = II(d, a, b, c, words[i + 11], S42, 3174756917);
			c = II(c, d, a, b, words[i + 2], S43, 718787259);
			b = II(b, c, d, a, words[i + 9], S44, 3951481745);
			a = a + AA >>> 0;
			b = b + BB >>> 0;
			c = c + CC >>> 0;
			d = d + DD >>> 0;
		}
		var hash_bytes = new String(wordToBytes(a) + wordToBytes(b) + wordToBytes(c) + wordToBytes(d));
		hash_bytes.toHex = function() {
			var hex = "";
			for (var i2 = 0, n = hash_bytes.length; i2 < n; ++i2) hex += byteToHex(hash_bytes.charCodeAt(i2));
			return hex;
		};
		return hash_bytes;
	};
	var utf8toMD5 = exports$1.fromUtf8 = function(utf8) {
		return bytesToMD5(utf8toBytes(utf8));
	};
	var b64 = "./0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	function to64(u, n) {
		for (var s = ""; --n >= 0; u >>>= 6) s += b64.charAt(u & 63);
		return s;
	}
	var MAX_KEY_LENGTH = 64, b64_map = [
		0,
		6,
		12,
		1,
		7,
		13,
		2,
		8,
		14,
		3,
		9,
		15,
		4,
		10,
		5,
		11
	];
	var gen_salt = exports$1.salt = function(n) {
		var s = "";
		if (!n) n = 8;
		do
			s += b64.charAt(64 * Math.random() >>> 0);
		while (--n);
		return s;
	};
	exports$1.crypt = function(key, setting) {
		if (key.length > MAX_KEY_LENGTH) throw Error("too long key");
		if (!setting) setting = "$1$" + gen_salt();
		key = utf8toBytes(key);
		var salt = utf8toBytes(setting.replace(/^\$1\$([^$]+)(?:\$.*)?$/, "$1")), md = bytesToMD5(key + salt + key), s = key + "$1$" + salt;
		for (var kl = key.length; kl > 16; kl -= 16) s += md;
		s += md.slice(0, kl);
		for (var kl = key.length; kl; kl >>= 1) s += kl & 1 ? "\0" : key.charAt(0);
		md = bytesToMD5(s);
		for (var i = 0; i < 1e3; ++i) md = bytesToMD5((i & 1 ? key : md) + (i % 3 ? salt : "") + (i % 7 ? key : "") + (i & 1 ? md : key));
		var h = "$1$" + salt + "$";
		for (var i = 0; i < 15; i += 3) h += to64(md.charCodeAt(b64_map[i + 0]) << 16 | md.charCodeAt(b64_map[i + 1]) << 8 | md.charCodeAt(b64_map[i + 2]), 4);
		return h + to64(md.charCodeAt(b64_map[15]), 2);
	};
	return md5$1.exports;
}
var md5 = /* @__PURE__ */ getDefaultExportFromCjs(requireMd5());
var TRACKER_CLIENT_VERSION_PREFIX = `-PM${formatVersion("2.2.2")}-`;
var HASH_SYMBOLS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
var PEER_ID_LENGTH = 20;
function getStreamHash(streamId) {
	const binary15BytesHashString = md5.fromUtf8(streamId).slice(1);
	return btoa(binary15BytesHashString);
}
function generatePeerId(trackerClientVersionPrefix) {
	const trackerClientId = [trackerClientVersionPrefix];
	const randomCharsCount = PEER_ID_LENGTH - trackerClientVersionPrefix.length;
	for (let i = 0; i < randomCharsCount; i++) trackerClientId.push(HASH_SYMBOLS[Math.floor(Math.random() * 62)]);
	return trackerClientId.join("");
}
function formatVersion(versionString) {
	const splittedVersion = versionString.split(".");
	return `${splittedVersion[0].padStart(2, "0")}${splittedVersion[1].padStart(2, "0")}`;
}
function getStreamString(stream) {
	return `${stream.type}-${stream.index}`;
}
function getSegmentString(segment) {
	const { externalId } = segment;
	return `(${getStreamString(segment.stream)} | ${externalId})`;
}
function getControlledPromise() {
	let resolve;
	let reject;
	return {
		promise: new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		}),
		resolve,
		reject
	};
}
function joinChunks(chunks, totalBytes) {
	totalBytes ??= chunks.reduce((sum, chunk) => sum + chunk.byteLength, 0);
	const buffer = new Uint8Array(totalBytes);
	let offset = 0;
	for (const chunk of chunks) {
		buffer.set(chunk, offset);
		offset += chunk.byteLength;
	}
	return buffer;
}
function getRandomItem(items) {
	return items[Math.floor(Math.random() * items.length)];
}
function utf8ToUintArray(utf8String) {
	const encoder2 = new TextEncoder();
	const bytes = new Uint8Array(utf8String.length);
	encoder2.encodeInto(utf8String, bytes);
	return bytes;
}
function hexToUtf8(hexString) {
	const bytes = new Uint8Array(hexString.length / 2);
	for (let i = 0; i < hexString.length; i += 2) bytes[i / 2] = parseInt(hexString.slice(i, i + 2), 16);
	return new TextDecoder().decode(bytes);
}
function* arrayBackwards(arr) {
	for (let i = arr.length - 1; i >= 0; i--) yield arr[i];
}
function isObject(item) {
	return !!item && typeof item === "object" && !Array.isArray(item);
}
function isArray(item) {
	return Array.isArray(item);
}
function filterUndefinedProps(obj) {
	function filter(obj2) {
		if (isObject(obj2)) {
			const result = {};
			Object.keys(obj2).forEach((key) => {
				if (obj2[key] !== void 0) {
					const value = filter(obj2[key]);
					if (value !== void 0) result[key] = value;
				}
			});
			return result;
		} else return obj2;
	}
	return filter(obj);
}
function deepCopy(item) {
	if (isArray(item)) return item.map((element) => deepCopy(element));
	else if (isObject(item)) {
		const copy = {};
		for (const key of Object.keys(item)) copy[key] = deepCopy(item[key]);
		return copy;
	} else return item;
}
function shuffleArray(array) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
}
function overrideConfig(target, updates, defaults = {}) {
	if (typeof target !== "object" || target === null || typeof updates !== "object" || updates === null) return target;
	Object.keys(updates).forEach((key) => {
		const keyStr = typeof key === "symbol" ? key.toString() : String(key);
		if (key === "__proto__" || key === "constructor" || key === "prototype") throw new Error(`Attempt to modify restricted property '${keyStr}'`);
		const updateValue = updates[key];
		const defaultValue = defaults[key];
		if (key in target) if (updateValue === void 0) target[key] = defaultValue === void 0 ? void 0 : defaultValue;
		else target[key] = updateValue;
	});
	return target;
}
function mergeAndFilterConfig(options) {
	const { defaultConfig, baseConfig = {}, specificStreamConfig = {} } = options;
	const mergedConfig = deepCopy({
		...defaultConfig,
		...baseConfig,
		...specificStreamConfig
	});
	const keysOfT = Object.keys(defaultConfig);
	const filteredConfig = {};
	keysOfT.forEach((key) => {
		if (key in mergedConfig) filteredConfig[key] = mergedConfig[key];
	});
	return filteredConfig;
}
var PeerCommandType$1 = /* @__PURE__ */ ((PeerCommandType2) => {
	PeerCommandType2[PeerCommandType2["SegmentsAnnouncement"] = 0] = "SegmentsAnnouncement";
	PeerCommandType2[PeerCommandType2["SegmentRequest"] = 1] = "SegmentRequest";
	PeerCommandType2[PeerCommandType2["SegmentData"] = 2] = "SegmentData";
	PeerCommandType2[PeerCommandType2["SegmentDataSendingCompleted"] = 3] = "SegmentDataSendingCompleted";
	PeerCommandType2[PeerCommandType2["SegmentAbsent"] = 4] = "SegmentAbsent";
	PeerCommandType2[PeerCommandType2["CancelSegmentRequest"] = 5] = "CancelSegmentRequest";
	return PeerCommandType2;
})(PeerCommandType$1 || {});
var SerializedItem = /* @__PURE__ */ ((SerializedItem2) => {
	SerializedItem2[SerializedItem2["Min"] = -1] = "Min";
	SerializedItem2[SerializedItem2["Int"] = 0] = "Int";
	SerializedItem2[SerializedItem2["SimilarIntArray"] = 1] = "SimilarIntArray";
	SerializedItem2[SerializedItem2["String"] = 2] = "String";
	SerializedItem2[SerializedItem2["Max"] = 3] = "Max";
	return SerializedItem2;
})(SerializedItem || {});
function abs(num) {
	return num < 0 ? -num : num;
}
function getRequiredBytesForInt(num) {
	const binaryString = num.toString(2);
	const necessaryBits = num < 0 ? binaryString.length : binaryString.length + 1;
	return Math.ceil(necessaryBits / 8);
}
function intToBytes(num) {
	const isNegative = num < 0;
	const bytesAmountNumber = getRequiredBytesForInt(num);
	const bytes = new Uint8Array(bytesAmountNumber);
	const bytesAmount = BigInt(bytesAmountNumber);
	num = abs(num);
	for (let i = 0; i < bytesAmountNumber; i++) {
		const shift = 8n * (bytesAmount - 1n - BigInt(i));
		const byte = num >> shift & 255n;
		bytes[i] = Number(byte);
	}
	if (isNegative) bytes[0] = bytes[0] | 128;
	return bytes;
}
function bytesToInt(bytes) {
	const byteLength = BigInt(bytes.length);
	const getNumberPart = (byte, i) => {
		const shift = 8n * (byteLength - 1n - BigInt(i));
		return BigInt(byte) << shift;
	};
	let number = getNumberPart(bytes[0] & 127, 0);
	for (let i = 1; i < byteLength; i++) number = getNumberPart(bytes[i], i) | number;
	if ((bytes[0] & 128) >> 7 !== 0) number = -number;
	return number;
}
function serializeInt(num) {
	const numBytes = intToBytes(num);
	const numberMetadata = 0 | numBytes.length;
	return new Uint8Array([numberMetadata, ...numBytes]);
}
function deserializeInt(bytes) {
	const metadata = bytes[0];
	if (metadata >> 4 !== 0) throw new Error("Trying to deserialize integer with invalid serialized item code");
	const numberBytesLength = metadata & 15;
	const start = 1;
	const end = start + numberBytesLength;
	return {
		number: bytesToInt(bytes.slice(start, end)),
		byteLength: numberBytesLength + 1
	};
}
function serializeSimilarIntArray(numbers) {
	const commonPartNumbersMap = /* @__PURE__ */ new Map();
	for (const number of numbers) {
		const common2 = number & -256n;
		const diffByte = number & 255n;
		const bytes = commonPartNumbersMap.get(common2) ?? new ResizableUint8Array();
		if (!bytes.length) commonPartNumbersMap.set(common2, bytes);
		bytes.push(Number(diffByte));
	}
	const result = new ResizableUint8Array();
	result.push([16, commonPartNumbersMap.size]);
	for (const [commonPart, binaryArray] of commonPartNumbersMap) {
		const { length } = binaryArray.getBytesChunks();
		const commonPartWithLength = commonPart | BigInt(length) & 255n;
		binaryArray.unshift(serializeInt(commonPartWithLength));
		result.push(binaryArray.getBuffer());
	}
	return result.getBuffer();
}
function deserializeSimilarIntArray(bytes) {
	const [codeByte, commonPartArraysAmount] = bytes;
	if (codeByte >> 4 !== 1) throw new Error("Trying to deserialize similar int array with invalid serialized item code");
	let offset = 2;
	const originalIntArr = [];
	for (let i = 0; i < commonPartArraysAmount; i++) {
		const { number: commonPartWithLength, byteLength } = deserializeInt(bytes.slice(offset));
		offset += byteLength;
		const arrayLength = commonPartWithLength & 255n;
		const commonPart = commonPartWithLength & -256n;
		for (let j = 0; j < arrayLength; j++) {
			const diffPart = BigInt(bytes[offset]);
			originalIntArr.push(commonPart | diffPart);
			offset++;
		}
	}
	return {
		numbers: originalIntArr,
		byteLength: offset
	};
}
function serializeString(string) {
	const { length } = string;
	const bytes = new ResizableUint8Array();
	bytes.push([32 | length >> 8 & 15, length & 255]);
	bytes.push(new TextEncoder().encode(string));
	return bytes.getBuffer();
}
function deserializeString(bytes) {
	const [codeByte, lengthByte] = bytes;
	if (codeByte >> 4 !== 2) throw new Error("Trying to deserialize bytes (sting) with invalid serialized item code.");
	const length = (codeByte & 15) << 8 | lengthByte;
	const stringBytes = bytes.slice(2, length + 2);
	return {
		string: new TextDecoder("utf8").decode(stringBytes),
		byteLength: length + 2
	};
}
var ResizableUint8Array = class {
	bytes = [];
	_length = 0;
	push(bytes) {
		this.addBytes(bytes, "end");
	}
	unshift(bytes) {
		this.addBytes(bytes, "start");
	}
	addBytes(bytes, position) {
		let bytesToAdd;
		if (bytes instanceof Uint8Array) bytesToAdd = bytes;
		else if (Array.isArray(bytes)) bytesToAdd = new Uint8Array(bytes);
		else bytesToAdd = new Uint8Array([bytes]);
		this._length += bytesToAdd.length;
		this.bytes[position === "start" ? "unshift" : "push"](bytesToAdd);
	}
	getBytesChunks() {
		return this.bytes;
	}
	getBuffer() {
		return joinChunks(this.bytes, this._length);
	}
	get length() {
		return this._length;
	}
};
var FRAME_PART_LENGTH = 4;
var commandFrameStart = stringToUtf8CodesBuffer("cstr", FRAME_PART_LENGTH);
var commandFrameEnd = stringToUtf8CodesBuffer("cend", FRAME_PART_LENGTH);
var commandDivFrameStart = stringToUtf8CodesBuffer("dstr", FRAME_PART_LENGTH);
var commandDivFrameEnd = stringToUtf8CodesBuffer("dend", FRAME_PART_LENGTH);
var startFrames = [commandFrameStart, commandDivFrameStart];
var endFrames = [commandFrameEnd, commandDivFrameEnd];
var commandFramesLength = commandFrameStart.length + commandFrameEnd.length;
function isCommandChunk(buffer) {
	const { length } = commandFrameStart;
	const bufferEndingToCompare = buffer.slice(-length);
	return startFrames.some((frame) => areBuffersEqual(buffer, frame, FRAME_PART_LENGTH)) && endFrames.some((frame) => areBuffersEqual(bufferEndingToCompare, frame, FRAME_PART_LENGTH));
}
function isFirstCommandChunk(buffer) {
	return areBuffersEqual(buffer, commandFrameStart, FRAME_PART_LENGTH);
}
function isLastCommandChunk(buffer) {
	return areBuffersEqual(buffer.slice(-FRAME_PART_LENGTH), commandFrameEnd, FRAME_PART_LENGTH);
}
var BinaryCommandJoiningError = class extends Error {
	constructor(type) {
		super();
		this.type = type;
	}
};
var BinaryCommandChunksJoiner = class {
	constructor(onComplete) {
		this.onComplete = onComplete;
	}
	chunks = new ResizableUint8Array();
	status = "joining";
	addCommandChunk(chunk) {
		if (this.status === "completed") return;
		const isFirstChunk = isFirstCommandChunk(chunk);
		if (!this.chunks.length && !isFirstChunk) throw new BinaryCommandJoiningError("no-first-chunk");
		if (this.chunks.length && isFirstChunk) throw new BinaryCommandJoiningError("incomplete-joining");
		this.chunks.push(this.unframeCommandChunk(chunk));
		if (!isLastCommandChunk(chunk)) return;
		this.status = "completed";
		this.onComplete(this.chunks.getBuffer());
	}
	unframeCommandChunk(chunk) {
		return chunk.slice(FRAME_PART_LENGTH, chunk.length - FRAME_PART_LENGTH);
	}
};
var BinaryCommandCreator = class {
	constructor(commandType, maxChunkLength) {
		this.maxChunkLength = maxChunkLength;
		this.bytes.push(commandType);
	}
	bytes = new ResizableUint8Array();
	resultBuffers = [];
	status = "creating";
	addInteger(name, value) {
		this.bytes.push(name.charCodeAt(0));
		const bytes = serializeInt(BigInt(value));
		this.bytes.push(bytes);
	}
	addSimilarIntArr(name, arr) {
		this.bytes.push(name.charCodeAt(0));
		const bytes = serializeSimilarIntArray(arr.map((num) => BigInt(num)));
		this.bytes.push(bytes);
	}
	addString(name, string) {
		this.bytes.push(name.charCodeAt(0));
		const bytes = serializeString(string);
		this.bytes.push(bytes);
	}
	complete() {
		if (!this.bytes.length) throw new Error("Buffer is empty");
		if (this.status === "completed") return;
		this.status = "completed";
		const unframedBuffer = this.bytes.getBuffer();
		if (unframedBuffer.length + commandFramesLength <= this.maxChunkLength) {
			this.resultBuffers.push(frameBuffer(unframedBuffer, commandFrameStart, commandFrameEnd));
			return;
		}
		let chunksCount = Math.ceil(unframedBuffer.length / this.maxChunkLength);
		if (Math.ceil(unframedBuffer.length / chunksCount) + commandFramesLength > this.maxChunkLength) chunksCount++;
		for (const [i, chunk] of splitBufferToEqualChunks(unframedBuffer, chunksCount)) if (i === 0) this.resultBuffers.push(frameBuffer(chunk, commandFrameStart, commandDivFrameEnd));
		else if (i === chunksCount - 1) this.resultBuffers.push(frameBuffer(chunk, commandDivFrameStart, commandFrameEnd));
		else this.resultBuffers.push(frameBuffer(chunk, commandDivFrameStart, commandDivFrameEnd));
	}
	getResultBuffers() {
		if (this.status === "creating" || !this.resultBuffers.length) throw new Error("Command is not complete.");
		return this.resultBuffers;
	}
};
function deserializeCommand(bytes) {
	const [commandCode] = bytes;
	const deserializedCommand = { c: commandCode };
	let offset = 1;
	while (offset < bytes.length) {
		const name = String.fromCharCode(bytes[offset]);
		offset++;
		switch (getDataTypeFromByte(bytes[offset])) {
			case SerializedItem.Int:
				{
					const { number, byteLength } = deserializeInt(bytes.slice(offset));
					deserializedCommand[name] = Number(number);
					offset += byteLength;
				}
				break;
			case SerializedItem.SimilarIntArray:
				{
					const { numbers, byteLength } = deserializeSimilarIntArray(bytes.slice(offset));
					deserializedCommand[name] = numbers.map((n) => Number(n));
					offset += byteLength;
				}
				break;
			case SerializedItem.String:
				{
					const { string, byteLength } = deserializeString(bytes.slice(offset));
					deserializedCommand[name] = string;
					offset += byteLength;
				}
				break;
		}
	}
	return deserializedCommand;
}
function getDataTypeFromByte(byte) {
	const typeCode = byte >> 4;
	if (typeCode <= SerializedItem.Min || typeCode >= SerializedItem.Max) throw new Error("Not existing type");
	return typeCode;
}
function stringToUtf8CodesBuffer(string, length) {
	if (string.length !== length) throw new Error("Wrong string length");
	const buffer = new Uint8Array(length);
	for (let i = 0; i < string.length; i++) buffer[i] = string.charCodeAt(i);
	return buffer;
}
function* splitBufferToEqualChunks(buffer, chunksCount) {
	const chunkLength = Math.ceil(buffer.length / chunksCount);
	for (let i = 0; i < chunksCount; i++) yield [i, buffer.slice(i * chunkLength, (i + 1) * chunkLength)];
}
function frameBuffer(buffer, frameStart, frameEnd) {
	const result = new Uint8Array(buffer.length + frameStart.length + frameEnd.length);
	result.set(frameStart);
	result.set(buffer, frameStart.length);
	result.set(frameEnd, frameStart.length + buffer.length);
	return result;
}
function areBuffersEqual(buffer1, buffer2, length) {
	for (let i = 0; i < length; i++) if (buffer1[i] !== buffer2[i]) return false;
	return true;
}
function serializeSegmentAnnouncementCommand(command, maxChunkSize) {
	const { c: commandCode, p: loadingByHttp, l: loaded } = command;
	const creator = new BinaryCommandCreator(commandCode, maxChunkSize);
	if (loaded?.length) creator.addSimilarIntArr("l", loaded);
	if (loadingByHttp?.length) creator.addSimilarIntArr("p", loadingByHttp);
	creator.complete();
	return creator.getResultBuffers();
}
function serializePeerSegmentCommand(command, maxChunkSize) {
	const creator = new BinaryCommandCreator(command.c, maxChunkSize);
	creator.addInteger("i", command.i);
	creator.addInteger("r", command.r);
	creator.complete();
	return creator.getResultBuffers();
}
function serializePeerSendSegmentCommand(command, maxChunkSize) {
	const creator = new BinaryCommandCreator(command.c, maxChunkSize);
	creator.addInteger("i", command.i);
	creator.addInteger("s", command.s);
	creator.addInteger("r", command.r);
	creator.complete();
	return creator.getResultBuffers();
}
function serializePeerSegmentRequestCommand(command, maxChunkSize) {
	const creator = new BinaryCommandCreator(command.c, maxChunkSize);
	creator.addInteger("i", command.i);
	creator.addInteger("r", command.r);
	if (command.b) creator.addInteger("b", command.b);
	creator.complete();
	return creator.getResultBuffers();
}
function serializePeerCommand(command, maxChunkSize) {
	switch (command.c) {
		case PeerCommandType$1.CancelSegmentRequest:
		case PeerCommandType$1.SegmentAbsent:
		case PeerCommandType$1.SegmentDataSendingCompleted: return serializePeerSegmentCommand(command, maxChunkSize);
		case PeerCommandType$1.SegmentRequest: return serializePeerSegmentRequestCommand(command, maxChunkSize);
		case PeerCommandType$1.SegmentsAnnouncement: return serializeSegmentAnnouncementCommand(command, maxChunkSize);
		case PeerCommandType$1.SegmentData: return serializePeerSendSegmentCommand(command, maxChunkSize);
	}
}
var Command = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
	__proto__: null,
	BinaryCommandChunksJoiner,
	BinaryCommandJoiningError,
	PeerCommandType: PeerCommandType$1,
	deserializeCommand,
	isCommandChunk,
	serializePeerCommand
}, Symbol.toStringTag, { value: "Module" }));
var PeerProtocol = class {
	constructor(connection, peerConfig, eventHandlers, eventTarget) {
		this.connection = connection;
		this.peerConfig = peerConfig;
		this.eventHandlers = eventHandlers;
		this.onChunkDownloaded = eventTarget.getEventDispatcher("onChunkDownloaded");
		this.onChunkUploaded = eventTarget.getEventDispatcher("onChunkUploaded");
		connection.on("data", this.onDataReceived);
	}
	commandChunks;
	uploadingContext;
	onChunkDownloaded;
	onChunkUploaded;
	onDataReceived = (data) => {
		if (isCommandChunk(data)) this.receivingCommandBytes(data);
		else {
			this.eventHandlers.onSegmentChunkReceived(data);
			this.onChunkDownloaded(data.byteLength, "p2p", this.connection.idUtf8);
		}
	};
	sendCommand(command) {
		const binaryCommandBuffers = serializePeerCommand(command, this.peerConfig.webRtcMaxMessageSize);
		for (const buffer of binaryCommandBuffers) this.connection.write(buffer);
	}
	stopUploadingSegmentData() {
		this.uploadingContext?.stopUploading();
		this.uploadingContext = void 0;
	}
	getUploadingRequestId() {
		return this.uploadingContext?.requestId;
	}
	async splitSegmentDataToChunksAndUploadAsync(data, requestId) {
		if (this.uploadingContext) throw new Error(`Some segment data is already uploading.`);
		const chunks = getBufferChunks(data, this.peerConfig.webRtcMaxMessageSize);
		const { promise, resolve, reject } = getControlledPromise();
		let isUploadingSegmentData = false;
		const uploadingContext = {
			stopUploading: () => {
				isUploadingSegmentData = false;
			},
			requestId
		};
		this.uploadingContext = uploadingContext;
		const sendChunk = () => {
			if (!isUploadingSegmentData) {
				reject();
				return;
			}
			while (true) {
				const chunk = chunks.next().value;
				if (!chunk) {
					resolve();
					break;
				}
				const drained = this.connection.write(chunk);
				this.onChunkUploaded(chunk.byteLength, this.connection.idUtf8);
				if (!drained) break;
			}
		};
		try {
			this.connection.on("drain", sendChunk);
			isUploadingSegmentData = true;
			sendChunk();
			await promise;
		} finally {
			this.connection.off("drain", sendChunk);
			if (this.uploadingContext === uploadingContext) this.uploadingContext = void 0;
		}
	}
	receivingCommandBytes(buffer) {
		this.commandChunks ??= new BinaryCommandChunksJoiner((commandBuffer) => {
			this.commandChunks = void 0;
			const command = deserializeCommand(commandBuffer);
			this.eventHandlers.onCommandReceived(command);
		});
		try {
			this.commandChunks.addCommandChunk(buffer);
		} catch (err) {
			if (!(err instanceof BinaryCommandJoiningError)) return;
			this.commandChunks = void 0;
		}
	}
};
function* getBufferChunks(data, maxChunkSize) {
	let bytesLeft = data.byteLength;
	while (bytesLeft > 0) {
		const bytesToSend = bytesLeft >= maxChunkSize ? maxChunkSize : bytesLeft;
		const from = data.byteLength - bytesLeft;
		const buffer = data.slice(from, from + bytesToSend);
		bytesLeft -= bytesToSend;
		yield buffer;
	}
}
var { PeerCommandType } = Command;
var Peer2 = class Peer2 {
	constructor(connection, eventHandlers, peerConfig, streamType, eventTarget) {
		this.connection = connection;
		this.eventHandlers = eventHandlers;
		this.peerConfig = peerConfig;
		this.streamType = streamType;
		this.eventTarget = eventTarget;
		this.onPeerClosed = eventTarget.getEventDispatcher("onPeerClose");
		this.id = Peer2.getPeerIdFromConnection(connection);
		this.peerProtocol = new PeerProtocol(connection, peerConfig, {
			onSegmentChunkReceived: this.onSegmentChunkReceived,
			onCommandReceived: this.onCommandReceived
		}, eventTarget);
		eventTarget.getEventDispatcher("onPeerConnect")({
			peerId: this.id,
			streamType
		});
		connection.on("error", this.onConnectionError);
		connection.on("close", this.onPeerConnectionClosed);
		connection.on("end", this.onPeerConnectionClosed);
		connection.on("finish", this.onPeerConnectionClosed);
	}
	id;
	peerProtocol;
	downloadingContext;
	loadedSegments = /* @__PURE__ */ new Set();
	httpLoadingSegments = /* @__PURE__ */ new Set();
	downloadingErrors = [];
	logger = debug$3$1("p2pml-core:peer");
	onPeerClosed;
	get downloadingSegment() {
		return this.downloadingContext?.request.segment;
	}
	getSegmentStatus(segment) {
		const { externalId } = segment;
		if (this.loadedSegments.has(externalId)) return "loaded";
		if (this.httpLoadingSegments.has(externalId)) return "http-loading";
	}
	onCommandReceived = async (command) => {
		switch (command.c) {
			case PeerCommandType.SegmentsAnnouncement:
				this.loadedSegments = new Set(command.l);
				this.httpLoadingSegments = new Set(command.p);
				this.eventHandlers.onSegmentsAnnouncement();
				break;
			case PeerCommandType.SegmentRequest:
				this.peerProtocol.stopUploadingSegmentData();
				this.eventHandlers.onSegmentRequested(this, command.i, command.r, command.b);
				break;
			case PeerCommandType.SegmentData:
				{
					if (!this.downloadingContext) break;
					if (this.downloadingContext.isSegmentDataCommandReceived) break;
					const { request, controls, requestId } = this.downloadingContext;
					if (request.segment.externalId !== command.i || requestId !== command.r) break;
					this.downloadingContext.isSegmentDataCommandReceived = true;
					controls.firstBytesReceived();
					if (request.totalBytes === void 0) request.setTotalBytes(command.s);
					else if (request.totalBytes - request.loadedBytes !== command.s) {
						request.clearLoadedBytes();
						this.sendCancelSegmentRequestCommand(request.segment, requestId);
						this.cancelSegmentDownloading("peer-response-bytes-length-mismatch");
						this.destroy();
					}
				}
				break;
			case PeerCommandType.SegmentDataSendingCompleted: {
				const { downloadingContext } = this;
				if (!downloadingContext?.isSegmentDataCommandReceived) return;
				const { request, controls } = downloadingContext;
				if (downloadingContext.request.segment.externalId !== command.i || downloadingContext.requestId !== command.r) {
					request.clearLoadedBytes();
					this.cancelSegmentDownloading("peer-protocol-violation");
					this.destroy();
					return;
				}
				if (request.loadedBytes !== request.totalBytes) {
					request.clearLoadedBytes();
					this.cancelSegmentDownloading("peer-response-bytes-length-mismatch");
					this.destroy();
					return;
				}
				const isValid = await this.peerConfig.validateP2PSegment?.(request.segment.url, request.segment.byteRange, request.data) ?? true;
				if (this.downloadingContext !== downloadingContext) return;
				if (!isValid) {
					request.clearLoadedBytes();
					this.cancelSegmentDownloading("p2p-segment-validation-failed");
					this.destroy();
					return;
				}
				this.downloadingErrors = [];
				controls.completeOnSuccess();
				this.downloadingContext = void 0;
				break;
			}
			case PeerCommandType.SegmentAbsent:
				if (this.downloadingContext?.request.segment.externalId === command.i && this.downloadingContext.requestId === command.r) {
					this.cancelSegmentDownloading("peer-segment-absent");
					this.loadedSegments.delete(command.i);
				}
				break;
			case PeerCommandType.CancelSegmentRequest:
				if (this.peerProtocol.getUploadingRequestId() !== command.r) break;
				this.peerProtocol.stopUploadingSegmentData();
				break;
		}
	};
	onSegmentChunkReceived = (chunk) => {
		if (!this.downloadingContext?.isSegmentDataCommandReceived) return;
		const { request, controls } = this.downloadingContext;
		if (request.totalBytes !== void 0 && request.loadedBytes + chunk.byteLength > request.totalBytes) {
			request.clearLoadedBytes();
			this.cancelSegmentDownloading("peer-response-bytes-length-mismatch");
			this.destroy();
			return;
		}
		controls.addLoadedChunk(chunk);
	};
	downloadSegment(segmentRequest) {
		if (this.downloadingContext) throw new Error("Some segment already is downloading");
		this.downloadingContext = {
			request: segmentRequest,
			requestId: Math.floor(Math.random() * 1e3),
			isSegmentDataCommandReceived: false,
			controls: segmentRequest.start({
				downloadSource: "p2p",
				peerId: this.id
			}, {
				notReceivingBytesTimeoutMs: this.peerConfig.p2pNotReceivingBytesTimeoutMs,
				abort: (error) => {
					if (!this.downloadingContext) return;
					const { request, requestId } = this.downloadingContext;
					this.sendCancelSegmentRequestCommand(request.segment, requestId);
					this.downloadingErrors.push(error);
					this.downloadingContext = void 0;
					if (this.downloadingErrors.filter((error2) => error2.type === "bytes-receiving-timeout").length >= this.peerConfig.p2pErrorRetries) this.destroy();
				}
			})
		};
		const command = {
			c: PeerCommandType.SegmentRequest,
			r: this.downloadingContext.requestId,
			i: segmentRequest.segment.externalId
		};
		if (segmentRequest.loadedBytes) command.b = segmentRequest.loadedBytes;
		this.peerProtocol.sendCommand(command);
	}
	async uploadSegmentData(segment, requestId, data) {
		const { externalId } = segment;
		this.logger(`send segment ${segment.externalId} to ${this.id}`);
		const command = {
			c: PeerCommandType.SegmentData,
			i: externalId,
			r: requestId,
			s: data.byteLength
		};
		this.peerProtocol.sendCommand(command);
		try {
			await this.peerProtocol.splitSegmentDataToChunksAndUploadAsync(data, requestId);
			this.sendSegmentDataSendingCompletedCommand(segment, requestId);
			this.logger(`segment ${externalId} has been sent to ${this.id}`);
		} catch {
			this.logger(`cancel segment uploading ${externalId}`);
		}
	}
	cancelSegmentDownloading(type) {
		if (!this.downloadingContext) return;
		const { request, controls } = this.downloadingContext;
		const { segment } = request;
		this.logger(`cancel segment request ${segment.externalId} (${type})`);
		const error = new RequestError(type);
		controls.abortOnError(error);
		this.downloadingContext = void 0;
		this.downloadingErrors.push(error);
	}
	sendSegmentsAnnouncementCommand(loadedSegmentsIds, httpLoadingSegmentsIds) {
		const command = {
			c: PeerCommandType.SegmentsAnnouncement,
			p: httpLoadingSegmentsIds,
			l: loadedSegmentsIds
		};
		this.peerProtocol.sendCommand(command);
	}
	sendSegmentAbsentCommand(segmentExternalId, requestId) {
		this.peerProtocol.sendCommand({
			c: PeerCommandType.SegmentAbsent,
			i: segmentExternalId,
			r: requestId
		});
	}
	sendCancelSegmentRequestCommand(segment, requestId) {
		this.peerProtocol.sendCommand({
			c: PeerCommandType.CancelSegmentRequest,
			i: segment.externalId,
			r: requestId
		});
	}
	sendSegmentDataSendingCompletedCommand(segment, requestId) {
		this.peerProtocol.sendCommand({
			c: PeerCommandType.SegmentDataSendingCompleted,
			r: requestId,
			i: segment.externalId
		});
	}
	onPeerConnectionClosed = () => {
		this.destroy();
	};
	onConnectionError = (error) => {
		this.logger(`peer connection error ${this.id} %O`, error);
		this.eventTarget.getEventDispatcher("onPeerError")({
			peerId: this.id,
			streamType: this.streamType,
			error
		});
		const { code } = error;
		if (code === "ERR_DATA_CHANNEL") this.destroy();
		else if (code === "ERR_CONNECTION_FAILURE") this.destroy();
	};
	destroy = () => {
		this.cancelSegmentDownloading("peer-closed");
		this.connection.destroy();
		this.eventHandlers.onPeerClosed(this);
		this.onPeerClosed({
			peerId: this.id,
			streamType: this.streamType
		});
		this.logger(`peer closed ${this.id}`);
	};
	static getPeerIdFromConnection(connection) {
		return hexToUtf8(connection.id);
	}
};
function isSafariOrWkWebview() {
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	const isWkWebview = /\b(iPad|iPhone|Macintosh).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
	return isSafari || isWkWebview;
}
var P2PTrackerClient = class P2PTrackerClient {
	constructor(streamSwarmId, stream, eventHandlers, config, eventTarget) {
		this.stream = stream;
		this.eventHandlers = eventHandlers;
		this.config = config;
		this.eventTarget = eventTarget;
		const streamHash = getStreamHash(streamSwarmId);
		this.streamShortId = getStreamString(stream);
		let peerId = P2PTrackerClient.PEER_ID_BY_INFO_HASH.get(streamHash);
		if (!peerId) {
			peerId = generatePeerId(config.trackerClientVersionPrefix);
			P2PTrackerClient.PEER_ID_BY_INFO_HASH.set(streamHash, peerId);
		}
		this.client = new Client({
			infoHash: utf8ToUintArray(streamHash),
			peerId: utf8ToUintArray(peerId),
			announce: isSafariOrWkWebview() ? config.announceTrackers.slice(0, 1) : config.announceTrackers,
			rtcConfig: this.config.rtcConfig
		});
		this.client.on("peer", this.onReceivePeerConnection);
		this.client.on("warning", this.onTrackerClientWarning);
		this.client.on("error", this.onTrackerClientError);
		this.logger(`create new client; 
stream: ${this.streamShortId}; hash: ${streamHash}
peerId: ${peerId}`);
	}
	static PEER_ID_BY_INFO_HASH = /* @__PURE__ */ new Map();
	streamShortId;
	client;
	_peers = /* @__PURE__ */ new Map();
	logger = debug$3$1("p2pml-core:p2p-tracker-client");
	start() {
		this.client.start();
	}
	destroy() {
		this.client.destroy();
		for (const { peer, potentialConnections } of this._peers.values()) {
			peer?.destroy();
			for (const connection of potentialConnections) connection.destroy();
		}
		this._peers.clear();
		this.logger("destroy client; stream:", this.streamShortId);
	}
	onReceivePeerConnection = (peerConnection) => {
		const itemId = Peer2.getPeerIdFromConnection(peerConnection);
		let peerItem = this._peers.get(itemId);
		if (peerItem?.peer) {
			peerConnection.destroy();
			return;
		}
		if (!peerItem) {
			peerItem = { potentialConnections: /* @__PURE__ */ new Set() };
			peerConnection.idUtf8 = itemId;
			this._peers.set(itemId, peerItem);
		}
		peerItem.potentialConnections.add(peerConnection);
		peerConnection.on("connect", () => {
			if (peerItem.peer) return;
			for (const connection of peerItem.potentialConnections) if (connection !== peerConnection) connection.destroy();
			peerItem.potentialConnections.clear();
			peerItem.peer = new Peer2(peerConnection, {
				onPeerClosed: this.onPeerClosed,
				onSegmentRequested: this.eventHandlers.onSegmentRequested,
				onSegmentsAnnouncement: this.eventHandlers.onSegmentsAnnouncement
			}, this.config, this.stream.type, this.eventTarget);
			this.logger(`connected with peer: ${peerItem.peer.id} ${this.streamShortId}`);
			this.eventHandlers.onPeerConnected(peerItem.peer);
		});
	};
	onTrackerClientWarning = (warning) => {
		this.logger("tracker warning %s:", this.streamShortId, warning);
		this.eventTarget.getEventDispatcher("onTrackerWarning")({
			streamType: this.stream.type,
			warning
		});
	};
	onTrackerClientError = (error) => {
		this.logger("tracker error in stream %s:", this.streamShortId, error);
		this.eventTarget.getEventDispatcher("onTrackerError")({
			streamType: this.stream.type,
			error
		});
	};
	*peers() {
		for (const peerItem of this._peers.values()) if (peerItem.peer) yield peerItem.peer;
	}
	onPeerClosed = (peer) => {
		this.logger(`peer closed: ${peer.id}`);
		this._peers.delete(peer.id);
	};
	static clearPeerIdCache() {
		P2PTrackerClient.PEER_ID_BY_INFO_HASH.clear();
	}
};
var PEER_PROTOCOL_VERSION = "v2";
function getStreamSwarmId(swarmId, stream) {
	return `${PEER_PROTOCOL_VERSION}-${swarmId}-${getStreamId(stream)}`;
}
function getSegmentFromStreamsMap(streams, segmentRuntimeId) {
	for (const stream of streams.values()) {
		const segment = stream.segments.get(segmentRuntimeId);
		if (segment) return segment;
	}
}
function getSegmentFromStreamByExternalId(stream, segmentExternalId) {
	for (const segment of stream.segments.values()) if (segment.externalId === segmentExternalId) return segment;
}
function getStreamId(stream) {
	return `${stream.type}-${stream.index}`;
}
function getSegmentAvgDuration(stream) {
	const { segments } = stream;
	let sumDuration = 0;
	const { size } = segments;
	for (const segment of segments.values()) {
		const duration = segment.endTime - segment.startTime;
		sumDuration += duration;
	}
	return sumDuration / size;
}
function calculateTimeWindows(timeWindowsConfig, availableMemoryInPercent) {
	const { highDemandTimeWindow, httpDownloadTimeWindow, p2pDownloadTimeWindow } = timeWindowsConfig;
	const result = {
		highDemandTimeWindow,
		httpDownloadTimeWindow,
		p2pDownloadTimeWindow
	};
	if (availableMemoryInPercent <= 5) {
		result.httpDownloadTimeWindow = 0;
		result.p2pDownloadTimeWindow = 0;
	} else if (availableMemoryInPercent <= 10) result.p2pDownloadTimeWindow = result.httpDownloadTimeWindow;
	return result;
}
function getSegmentPlaybackStatuses(segment, playback, timeWindowsConfig, currentP2PLoader, availableMemoryPercent) {
	const { highDemandTimeWindow, httpDownloadTimeWindow, p2pDownloadTimeWindow } = calculateTimeWindows(timeWindowsConfig, availableMemoryPercent);
	return {
		isHighDemand: isSegmentInTimeWindow(segment, playback, highDemandTimeWindow),
		isHttpDownloadable: isSegmentInTimeWindow(segment, playback, httpDownloadTimeWindow),
		isP2PDownloadable: isSegmentInTimeWindow(segment, playback, p2pDownloadTimeWindow) && currentP2PLoader.isSegmentLoadingOrLoadedBySomeone(segment)
	};
}
function isSegmentInTimeWindow(segment, playback, timeWindowLength) {
	const { startTime, endTime } = segment;
	const { position, rate } = playback;
	return !(position + timeWindowLength * rate < startTime || position > endTime);
}
var P2PLoader = class {
	constructor(streamManifestUrl, stream, requests, segmentStorage, config, eventTarget, onSegmentAnnouncement) {
		this.streamManifestUrl = streamManifestUrl;
		this.stream = stream;
		this.requests = requests;
		this.segmentStorage = segmentStorage;
		this.config = config;
		this.eventTarget = eventTarget;
		this.onSegmentAnnouncement = onSegmentAnnouncement;
		const streamSwarmId = getStreamSwarmId(this.config.swarmId ?? this.streamManifestUrl, this.stream);
		this.trackerClient = new P2PTrackerClient(streamSwarmId, this.stream, {
			onPeerConnected: this.onPeerConnected,
			onSegmentRequested: this.onSegmentRequested,
			onSegmentsAnnouncement: this.onSegmentAnnouncement
		}, this.config, this.eventTarget);
		this.eventTarget.addEventListener(`onStorageUpdated-${streamSwarmId}`, this.broadcastAnnouncement);
		this.segmentStorage.setSegmentChangeCallback((streamId) => {
			this.eventTarget.dispatchEvent(`onStorageUpdated-${streamId}`);
		});
		this.trackerClient.start();
	}
	trackerClient;
	isAnnounceMicrotaskCreated = false;
	downloadSegment(segment) {
		const peersWithSegment = [];
		for (const peer2 of this.trackerClient.peers()) if (!peer2.downloadingSegment && peer2.getSegmentStatus(segment) === "loaded") peersWithSegment.push(peer2);
		if (peersWithSegment.length === 0) return;
		const peer = getRandomItem(peersWithSegment);
		const request = this.requests.getOrCreateRequest(segment);
		peer.downloadSegment(request);
	}
	isSegmentLoadingOrLoadedBySomeone(segment) {
		for (const peer of this.trackerClient.peers()) if (peer.getSegmentStatus(segment)) return true;
		return false;
	}
	isSegmentLoadedBySomeone(segment) {
		for (const peer of this.trackerClient.peers()) if (peer.getSegmentStatus(segment) === "loaded") return true;
		return false;
	}
	get connectedPeerCount() {
		let count = 0;
		const iterator = this.trackerClient.peers();
		while (!iterator.next().done) count++;
		return count;
	}
	getSegmentsAnnouncement() {
		const swarmId = this.config.swarmId ?? this.streamManifestUrl;
		const streamSwarmId = getStreamSwarmId(swarmId, this.stream);
		const loaded = this.segmentStorage.getStoredSegmentIds(swarmId, streamSwarmId);
		const httpLoading = [];
		for (const request of this.requests.httpRequests()) {
			const segment = this.stream.segments.get(request.segment.runtimeId);
			if (!segment) continue;
			httpLoading.push(segment.externalId);
		}
		return {
			loaded,
			httpLoading
		};
	}
	onPeerConnected = (peer) => {
		if (this.config.isP2PUploadDisabled) return;
		const { httpLoading, loaded } = this.getSegmentsAnnouncement();
		peer.sendSegmentsAnnouncementCommand(loaded, httpLoading);
	};
	broadcastAnnouncement = (sendEmptyAnnouncement = false) => {
		if (sendEmptyAnnouncement) {
			this.sendSegmentsAnnouncement([], []);
			return;
		}
		if (this.isAnnounceMicrotaskCreated || this.config.isP2PUploadDisabled) return;
		const { loaded, httpLoading } = this.getSegmentsAnnouncement();
		this.sendSegmentsAnnouncement(loaded, httpLoading);
	};
	sendSegmentsAnnouncement = (loaded, httpLoading) => {
		this.isAnnounceMicrotaskCreated = true;
		queueMicrotask(() => {
			for (const peer of this.trackerClient.peers()) peer.sendSegmentsAnnouncementCommand(loaded, httpLoading);
			this.isAnnounceMicrotaskCreated = false;
		});
	};
	onSegmentRequested = async (peer, segmentExternalId, requestId, byteFrom) => {
		const segment = getSegmentFromStreamByExternalId(this.stream, segmentExternalId);
		if (!segment) return;
		if (this.config.isP2PUploadDisabled) {
			peer.sendSegmentAbsentCommand(segmentExternalId, requestId);
			return;
		}
		const swarmId = this.config.swarmId ?? this.streamManifestUrl;
		const streamSwarmId = getStreamSwarmId(swarmId, this.stream);
		const segmentData = await this.segmentStorage.getSegmentData(swarmId, streamSwarmId, segment.externalId);
		if (!segmentData) {
			peer.sendSegmentAbsentCommand(segmentExternalId, requestId);
			return;
		}
		await peer.uploadSegmentData(segment, requestId, byteFrom !== void 0 ? segmentData.slice(byteFrom) : segmentData);
	};
	destroy() {
		const streamSwarmId = getStreamSwarmId(this.config.swarmId ?? this.streamManifestUrl, this.stream);
		this.eventTarget.removeEventListener(`onStorageUpdated-${streamSwarmId}`, this.broadcastAnnouncement);
		this.trackerClient.destroy();
	}
};
var P2PLoadersContainer = class {
	constructor(streamManifestUrl, stream, requests, segmentStorage, config, eventTarget, onSegmentAnnouncement) {
		this.streamManifestUrl = streamManifestUrl;
		this.requests = requests;
		this.segmentStorage = segmentStorage;
		this.config = config;
		this.eventTarget = eventTarget;
		this.onSegmentAnnouncement = onSegmentAnnouncement;
		this._currentLoaderItem = this.findOrCreateLoaderForStream(stream);
		this.logger(`set current p2p loader: ${getStreamString(stream)}`);
	}
	loaders = /* @__PURE__ */ new Map();
	_currentLoaderItem;
	logger = debug$3$1("p2pml-core:p2p-loaders-container");
	createLoader(stream) {
		if (this.loaders.has(stream.runtimeId)) throw new Error("Loader for this stream already exists");
		const loader = new P2PLoader(this.streamManifestUrl, stream, this.requests, this.segmentStorage, this.config, this.eventTarget, () => {
			if (this._currentLoaderItem.loader === loader) this.onSegmentAnnouncement();
		});
		const loggerInfo = getStreamString(stream);
		this.logger(`created new loader: ${loggerInfo}`);
		return {
			loader,
			stream,
			loggerInfo: getStreamString(stream)
		};
	}
	findOrCreateLoaderForStream(stream) {
		const loaderItem = this.loaders.get(stream.runtimeId);
		if (loaderItem) {
			clearTimeout(loaderItem.destroyTimeoutId);
			loaderItem.destroyTimeoutId = void 0;
			return loaderItem;
		} else {
			const loader = this.createLoader(stream);
			this.loaders.set(stream.runtimeId, loader);
			return loader;
		}
	}
	changeCurrentLoader(stream) {
		const swarmId = this.config.swarmId ?? this.streamManifestUrl;
		const streamSwarmId = getStreamSwarmId(swarmId, this._currentLoaderItem.stream);
		if (!this.segmentStorage.getStoredSegmentIds(swarmId, streamSwarmId).length) this.destroyAndRemoveLoader(this._currentLoaderItem);
		else this.setLoaderDestroyTimeout(this._currentLoaderItem);
		this._currentLoaderItem = this.findOrCreateLoaderForStream(stream);
		this.logger(`change current p2p loader: ${getStreamString(stream)}`);
	}
	setLoaderDestroyTimeout(item) {
		item.destroyTimeoutId = window.setTimeout(() => this.destroyAndRemoveLoader(item), this.config.p2pInactiveLoaderDestroyTimeoutMs);
	}
	destroyAndRemoveLoader(item) {
		item.loader.destroy();
		this.loaders.delete(item.stream.runtimeId);
		this.logger(`destroy p2p loader: `, item.loggerInfo);
	}
	get currentLoader() {
		return this._currentLoaderItem.loader;
	}
	destroy() {
		for (const { loader, destroyTimeoutId } of this.loaders.values()) {
			loader.destroy();
			clearTimeout(destroyTimeoutId);
		}
		this.loaders.clear();
	}
};
function mapSegmentWithStreamToSegment(segment) {
	return {
		runtimeId: segment.runtimeId,
		externalId: segment.externalId,
		url: segment.url,
		byteRange: segment.byteRange,
		startTime: segment.startTime,
		endTime: segment.endTime
	};
}
var Request$1 = class Request2 {
	constructor(segment, requestProcessQueueCallback, bandwidthCalculators, playback, playbackConfig, eventTarget) {
		this.segment = segment;
		this.requestProcessQueueCallback = requestProcessQueueCallback;
		this.bandwidthCalculators = bandwidthCalculators;
		this.playback = playback;
		this.playbackConfig = playbackConfig;
		this.onSegmentError = eventTarget.getEventDispatcher("onSegmentError");
		this.onSegmentAbort = eventTarget.getEventDispatcher("onSegmentAbort");
		this.onSegmentStart = eventTarget.getEventDispatcher("onSegmentStart");
		this.onSegmentLoaded = eventTarget.getEventDispatcher("onSegmentLoaded");
		const { byteRange } = this.segment;
		if (byteRange) {
			const { end, start } = byteRange;
			this._totalBytes = end - start + 1;
		}
		this.notReceivingBytesTimeout = new Timeout(this.abortOnTimeout);
		const { type } = this.segment.stream;
		this._logger = debug$3$1(`p2pml-core:request-${type}`);
	}
	currentAttempt;
	_failedAttempts = new FailedRequestAttempts();
	finalData;
	bytes = [];
	_loadedBytes = 0;
	_totalBytes;
	_status = "not-started";
	progress;
	notReceivingBytesTimeout;
	_abortRequestCallback;
	_logger;
	_isHandledByProcessQueue = false;
	onSegmentError;
	onSegmentAbort;
	onSegmentStart;
	onSegmentLoaded;
	clearLoadedBytes() {
		this._loadedBytes = 0;
		this.bytes = [];
		this._totalBytes = void 0;
		this.finalData = void 0;
	}
	get status() {
		return this._status;
	}
	setStatus(status) {
		this._status = status;
		this._isHandledByProcessQueue = false;
	}
	get downloadSource() {
		return this.currentAttempt?.downloadSource;
	}
	get loadedBytes() {
		return this._loadedBytes;
	}
	get totalBytes() {
		return this._totalBytes;
	}
	get data() {
		this.finalData ??= joinChunks(this.bytes).buffer;
		return this.finalData;
	}
	get failedAttempts() {
		return this._failedAttempts;
	}
	get isHandledByProcessQueue() {
		return this._isHandledByProcessQueue;
	}
	markHandledByProcessQueue() {
		this._isHandledByProcessQueue = true;
	}
	setTotalBytes(value) {
		if (this._totalBytes !== void 0) throw new Error("Request total bytes value is already set");
		this._totalBytes = value;
	}
	start(requestData, controls) {
		if (this._status === "succeed") throw new Error(`Request ${this.segment.externalId} has been already succeed.`);
		if (this._status === "loading") throw new Error(`Request ${this.segment.externalId} has been already started.`);
		this.setStatus("loading");
		this.currentAttempt = { ...requestData };
		this.progress = {
			startFromByte: this._loadedBytes,
			loadedBytes: 0,
			startTimestamp: performance.now()
		};
		this.manageBandwidthCalculatorsState("start");
		const { notReceivingBytesTimeoutMs, abort } = controls;
		this._abortRequestCallback = abort;
		if (notReceivingBytesTimeoutMs !== void 0) this.notReceivingBytesTimeout.start(notReceivingBytesTimeoutMs);
		this.logger(`${requestData.downloadSource} ${this.segment.externalId} started`);
		this.onSegmentStart({
			segment: mapSegmentWithStreamToSegment(this.segment),
			downloadSource: requestData.downloadSource,
			peerId: requestData.downloadSource === "p2p" ? requestData.peerId : void 0
		});
		return {
			firstBytesReceived: this.firstBytesReceived,
			addLoadedChunk: this.addLoadedChunk,
			completeOnSuccess: this.completeOnSuccess,
			abortOnError: this.abortOnError
		};
	}
	abortFromProcessQueue() {
		this.throwErrorIfNotLoadingStatus();
		this.setStatus("aborted");
		this.logger(`${this.currentAttempt?.downloadSource} ${this.segment.externalId} aborted`);
		this._abortRequestCallback?.(new RequestError("abort"));
		this.onSegmentAbort({
			segment: mapSegmentWithStreamToSegment(this.segment),
			downloadSource: this.currentAttempt?.downloadSource,
			peerId: this.currentAttempt?.downloadSource === "p2p" ? this.currentAttempt.peerId : void 0,
			streamType: this.segment.stream.type
		});
		this._abortRequestCallback = void 0;
		this.manageBandwidthCalculatorsState("stop");
		this.notReceivingBytesTimeout.clear();
	}
	abortOnTimeout = () => {
		this.throwErrorIfNotLoadingStatus();
		if (!this.currentAttempt) return;
		this.setStatus("failed");
		const error = new RequestError("bytes-receiving-timeout");
		this._abortRequestCallback?.(error);
		this.logger(`${this.downloadSource} ${this.segment.externalId} failed ${error.type}`);
		this._failedAttempts.add({
			...this.currentAttempt,
			error
		});
		this.onSegmentError({
			segment: mapSegmentWithStreamToSegment(this.segment),
			error,
			downloadSource: this.currentAttempt.downloadSource,
			peerId: this.currentAttempt.downloadSource === "p2p" ? this.currentAttempt.peerId : void 0,
			streamType: this.segment.stream.type
		});
		this.notReceivingBytesTimeout.clear();
		this.manageBandwidthCalculatorsState("stop");
		this.requestProcessQueueCallback();
	};
	abortOnError = (error) => {
		this.throwErrorIfNotLoadingStatus();
		if (!this.currentAttempt) return;
		this.setStatus("failed");
		this.logger(`${this.downloadSource} ${this.segment.externalId} failed ${error.type}`);
		this._failedAttempts.add({
			...this.currentAttempt,
			error
		});
		this.onSegmentError({
			segment: mapSegmentWithStreamToSegment(this.segment),
			error,
			downloadSource: this.currentAttempt.downloadSource,
			peerId: this.currentAttempt.downloadSource === "p2p" ? this.currentAttempt.peerId : void 0,
			streamType: this.segment.stream.type
		});
		this.notReceivingBytesTimeout.clear();
		this.manageBandwidthCalculatorsState("stop");
		this.requestProcessQueueCallback();
	};
	completeOnSuccess = () => {
		this.throwErrorIfNotLoadingStatus();
		if (!this.currentAttempt) return;
		this.manageBandwidthCalculatorsState("stop");
		this.notReceivingBytesTimeout.clear();
		this.setStatus("succeed");
		this._totalBytes = this._loadedBytes;
		this.onSegmentLoaded({
			segmentUrl: this.segment.url,
			bytesLength: this.data.byteLength,
			downloadSource: this.currentAttempt.downloadSource,
			peerId: this.currentAttempt.downloadSource === "p2p" ? this.currentAttempt.peerId : void 0,
			streamType: this.segment.stream.type
		});
		this.logger(`${this.currentAttempt.downloadSource} ${this.segment.externalId} succeed`);
		this.requestProcessQueueCallback();
	};
	addLoadedChunk = (chunk) => {
		this.throwErrorIfNotLoadingStatus();
		if (!this.currentAttempt || !this.progress) return;
		this.notReceivingBytesTimeout.restart();
		const { byteLength } = chunk;
		const { all: allBC, http: httpBC } = this.bandwidthCalculators;
		allBC.addBytes(byteLength);
		if (this.currentAttempt.downloadSource === "http") httpBC.addBytes(byteLength);
		this.bytes.push(chunk);
		this.progress.lastLoadedChunkTimestamp = performance.now();
		this.progress.loadedBytes += byteLength;
		this._loadedBytes += byteLength;
	};
	firstBytesReceived = () => {
		this.throwErrorIfNotLoadingStatus();
		this.notReceivingBytesTimeout.restart();
	};
	throwErrorIfNotLoadingStatus() {
		if (this._status !== "loading") throw new Error(`Request has been already ${this.status}.`);
	}
	logger(message) {
		this._logger.color = this.currentAttempt?.downloadSource === "http" ? "green" : "red";
		this._logger(message);
		this._logger.color = "";
	}
	manageBandwidthCalculatorsState(state) {
		const { all, http } = this.bandwidthCalculators;
		const method = state === "start" ? "startLoading" : "stopLoading";
		if (this.currentAttempt?.downloadSource === "http") http[method]();
		all[method]();
	}
};
var FailedRequestAttempts = class {
	attempts = [];
	add(attempt) {
		this.attempts.push(attempt);
	}
	get httpAttemptsCount() {
		return this.attempts.reduce((sum, attempt) => attempt.downloadSource === "http" ? sum + 1 : sum, 0);
	}
	get lastAttempt() {
		return this.attempts[this.attempts.length - 1];
	}
	clear() {
		this.attempts = [];
	}
};
var Timeout = class {
	constructor(action) {
		this.action = action;
	}
	timeoutId;
	ms;
	start(ms2) {
		if (this.timeoutId) throw new Error("Timeout is already started.");
		this.ms = ms2;
		this.timeoutId = window.setTimeout(this.action, this.ms);
	}
	restart(ms2) {
		if (this.timeoutId) clearTimeout(this.timeoutId);
		if (ms2) this.ms = ms2;
		if (!this.ms) return;
		this.timeoutId = window.setTimeout(this.action, this.ms);
	}
	clear() {
		clearTimeout(this.timeoutId);
		this.timeoutId = void 0;
	}
};
var RequestsContainer = class {
	constructor(requestProcessQueueCallback, bandwidthCalculators, playback, config, eventTarget) {
		this.requestProcessQueueCallback = requestProcessQueueCallback;
		this.bandwidthCalculators = bandwidthCalculators;
		this.playback = playback;
		this.config = config;
		this.eventTarget = eventTarget;
	}
	requests = /* @__PURE__ */ new Map();
	get executingHttpCount() {
		let count = 0;
		for (const request of this.httpRequests()) if (request.status === "loading") count++;
		return count;
	}
	get executingP2PCount() {
		let count = 0;
		for (const request of this.p2pRequests()) if (request.status === "loading") count++;
		return count;
	}
	get(segment) {
		return this.requests.get(segment);
	}
	getOrCreateRequest(segment) {
		let request = this.requests.get(segment);
		if (!request) {
			request = new Request$1(segment, this.requestProcessQueueCallback, this.bandwidthCalculators, this.playback, this.config, this.eventTarget);
			this.requests.set(segment, request);
		}
		return request;
	}
	remove(request) {
		this.requests.delete(request.segment);
	}
	items() {
		return this.requests.values();
	}
	*httpRequests() {
		for (const request of this.requests.values()) if (request.downloadSource === "http") yield request;
	}
	*p2pRequests() {
		for (const request of this.requests.values()) if (request.downloadSource === "p2p") yield request;
	}
	destroy() {
		for (const request of this.requests.values()) {
			if (request.status !== "loading") continue;
			request.abortFromProcessQueue();
		}
		this.requests.clear();
	}
};
var EngineRequest = class {
	constructor(segment, engineCallbacks) {
		this.segment = segment;
		this.engineCallbacks = engineCallbacks;
	}
	_status = "pending";
	_shouldBeStartedImmediately = false;
	get status() {
		return this._status;
	}
	get shouldBeStartedImmediately() {
		return this._shouldBeStartedImmediately;
	}
	resolve(data, bandwidth) {
		if (this._status !== "pending") return;
		this._status = "succeed";
		this.engineCallbacks.onSuccess({
			data,
			bandwidth
		});
	}
	reject() {
		if (this._status !== "pending") return;
		this._status = "failed";
		this.engineCallbacks.onError(new CoreRequestError("failed"));
	}
	abort() {
		if (this._status !== "pending") return;
		this._status = "aborted";
		this.engineCallbacks.onError(new CoreRequestError("aborted"));
	}
	markAsShouldBeStartedImmediately() {
		this._shouldBeStartedImmediately = true;
	}
};
function* generateQueue(lastRequestedSegment, playback, playbackConfig, currentP2PLoader, availablePercentMemory) {
	const { runtimeId, stream } = lastRequestedSegment;
	const requestedSegment = stream.segments.get(runtimeId);
	if (!requestedSegment) return;
	const queueSegments = stream.segments.values();
	let first;
	do {
		const next = queueSegments.next();
		if (next.done) return;
		first = next.value;
	} while (first !== requestedSegment);
	const firstStatuses = getSegmentPlaybackStatuses(first, playback, playbackConfig, currentP2PLoader, availablePercentMemory);
	if (isNotActualStatuses(firstStatuses)) {
		const next = queueSegments.next();
		if (next.done) return;
		const second = next.value;
		const secondStatuses = getSegmentPlaybackStatuses(second, playback, playbackConfig, currentP2PLoader, availablePercentMemory);
		if (isNotActualStatuses(secondStatuses)) return;
		firstStatuses.isHighDemand = true;
		yield {
			segment: first,
			statuses: firstStatuses
		};
		yield {
			segment: second,
			statuses: secondStatuses
		};
	} else yield {
		segment: first,
		statuses: firstStatuses
	};
	for (const segment of queueSegments) {
		const statuses = getSegmentPlaybackStatuses(segment, playback, playbackConfig, currentP2PLoader, availablePercentMemory);
		if (isNotActualStatuses(statuses)) break;
		yield {
			segment,
			statuses
		};
	}
}
function isNotActualStatuses(statuses) {
	const { isHighDemand = false, isHttpDownloadable = false, isP2PDownloadable = false } = statuses;
	return !isHighDemand && !isHttpDownloadable && !isP2PDownloadable;
}
var FAILED_ATTEMPTS_CLEAR_INTERVAL = 6e4;
var PEER_UPDATE_LATENCY = 1e3;
var HybridLoader = class {
	constructor(streamManifestUrl, lastRequestedSegment, streamDetails, config, bandwidthCalculators, segmentStorage, eventTarget) {
		this.streamManifestUrl = streamManifestUrl;
		this.lastRequestedSegment = lastRequestedSegment;
		this.streamDetails = streamDetails;
		this.config = config;
		this.bandwidthCalculators = bandwidthCalculators;
		this.segmentStorage = segmentStorage;
		this.eventTarget = eventTarget;
		const activeStream = this.lastRequestedSegment.stream;
		this.playback = {
			position: this.lastRequestedSegment.startTime,
			rate: 1
		};
		this.segmentAvgDuration = getSegmentAvgDuration(activeStream);
		this.requests = new RequestsContainer(this.requestProcessQueueMicrotask, this.bandwidthCalculators, this.playback, this.config, this.eventTarget);
		this.p2pLoaders = new P2PLoadersContainer(this.streamManifestUrl, this.lastRequestedSegment.stream, this.requests, this.segmentStorage, this.config, this.eventTarget, this.requestProcessQueueMicrotask);
		this.logger = debug$3$1(`p2pml-core:hybrid-loader-${activeStream.type}`);
		this.logger.color = "coral";
		this.setIntervalLoading();
	}
	requests;
	engineRequest;
	p2pLoaders;
	playback;
	segmentAvgDuration;
	logger;
	storageCleanUpIntervalId;
	levelChangedTimestamp;
	lastQueueProcessingTimeStamp;
	randomHttpDownloadInterval;
	isProcessQueueMicrotaskCreated = false;
	setIntervalLoading() {
		const peersCount = this.p2pLoaders.currentLoader.connectedPeerCount;
		const randomTimeout = Math.random() * PEER_UPDATE_LATENCY * peersCount + PEER_UPDATE_LATENCY;
		this.randomHttpDownloadInterval = window.setTimeout(() => {
			this.loadRandomThroughHttp();
			this.setIntervalLoading();
		}, randomTimeout);
	}
	async loadSegment(segment, callbacks) {
		this.logger(`requests: ${getSegmentString(segment)}`);
		const { stream } = segment;
		if (stream !== this.lastRequestedSegment.stream) {
			this.logger(`stream changed to ${getStreamString(stream)}`);
			this.p2pLoaders.changeCurrentLoader(stream);
		}
		this.lastRequestedSegment = segment;
		const swarmId = this.config.swarmId ?? this.streamManifestUrl;
		const streamSwarmId = getStreamSwarmId(swarmId, stream);
		this.segmentStorage.onSegmentRequested(swarmId, streamSwarmId, segment.externalId, segment.startTime, segment.endTime, stream.type, this.streamDetails.isLive);
		const engineRequest = new EngineRequest(segment, callbacks);
		try {
			if (this.segmentStorage.hasSegment(swarmId, streamSwarmId, segment.externalId)) {
				const data = await this.segmentStorage.getSegmentData(swarmId, streamSwarmId, segment.externalId);
				if (data) {
					const { queueDownloadRatio } = this.generateQueue();
					engineRequest.resolve(data, this.getBandwidth(queueDownloadRatio));
					return;
				}
			}
			this.engineRequest?.abort();
			this.engineRequest = engineRequest;
		} catch {
			engineRequest.reject();
		} finally {
			this.requestProcessQueueMicrotask();
		}
	}
	requestProcessQueueMicrotask = (force = true) => {
		const now = performance.now();
		if (!force && this.lastQueueProcessingTimeStamp !== void 0 && now - this.lastQueueProcessingTimeStamp <= 1e3 || this.isProcessQueueMicrotaskCreated) return;
		this.isProcessQueueMicrotaskCreated = true;
		queueMicrotask(() => {
			try {
				this.processQueue();
				this.lastQueueProcessingTimeStamp = now;
			} finally {
				this.isProcessQueueMicrotaskCreated = false;
			}
		});
	};
	processRequests(queueSegmentIds, queueDownloadRatio) {
		const { stream } = this.lastRequestedSegment;
		const { httpErrorRetries } = this.config;
		const now = performance.now();
		for (const request of this.requests.items()) {
			const { downloadSource: type, status, segment, isHandledByProcessQueue } = request;
			const engineRequest = this.engineRequest?.segment === segment ? this.engineRequest : void 0;
			switch (status) {
				case "loading":
					if (!queueSegmentIds.has(segment.runtimeId) && !engineRequest) {
						request.abortFromProcessQueue();
						this.requests.remove(request);
					}
					break;
				case "succeed": {
					if (!type) break;
					if (type === "http") this.p2pLoaders.currentLoader.broadcastAnnouncement();
					if (engineRequest) {
						engineRequest.resolve(request.data, this.getBandwidth(queueDownloadRatio));
						this.engineRequest = void 0;
					}
					this.requests.remove(request);
					const swarmId = this.config.swarmId ?? this.streamManifestUrl;
					const streamSwarmId = getStreamSwarmId(swarmId, stream);
					this.segmentStorage.storeSegment(swarmId, streamSwarmId, segment.externalId, request.data, segment.startTime, segment.endTime, segment.stream.type, this.streamDetails.isLive);
					break;
				}
				case "failed":
					if (type === "http" && !isHandledByProcessQueue) this.p2pLoaders.currentLoader.broadcastAnnouncement();
					if (!engineRequest && !stream.segments.has(request.segment.runtimeId)) this.requests.remove(request);
					if (request.failedAttempts.httpAttemptsCount >= httpErrorRetries && engineRequest) {
						this.engineRequest = void 0;
						engineRequest.reject();
					}
					break;
				case "not-started":
					this.requests.remove(request);
					break;
				case "aborted":
					this.requests.remove(request);
					break;
			}
			request.markHandledByProcessQueue();
			const { lastAttempt } = request.failedAttempts;
			if (lastAttempt && now - lastAttempt.error.timestamp > FAILED_ATTEMPTS_CLEAR_INTERVAL) request.failedAttempts.clear();
		}
	}
	processQueue() {
		const { queue: queue2, queueSegmentIds, queueDownloadRatio } = this.generateQueue();
		this.processRequests(queueSegmentIds, queueDownloadRatio);
		const { simultaneousHttpDownloads, simultaneousP2PDownloads, httpErrorRetries } = this.config;
		if (this.engineRequest?.shouldBeStartedImmediately && this.engineRequest.status === "pending" && this.requests.executingHttpCount < simultaneousHttpDownloads) {
			const { segment } = this.engineRequest;
			const request = this.requests.get(segment);
			if (!request || request.status === "not-started" || request.status === "failed" && request.failedAttempts.httpAttemptsCount < this.config.httpErrorRetries) this.loadThroughHttp(segment);
		}
		for (const item of queue2) {
			const { statuses, segment } = item;
			const request = this.requests.get(segment);
			if (statuses.isHighDemand) {
				if (request?.downloadSource === "http" && request.status === "loading") continue;
				if (request?.downloadSource === "http" && request.status === "failed" && request.failedAttempts.httpAttemptsCount >= httpErrorRetries) continue;
				const isP2PLoadingRequest = request?.status === "loading" && request.downloadSource === "p2p";
				if (this.requests.executingHttpCount < simultaneousHttpDownloads) {
					if (isP2PLoadingRequest) request.abortFromProcessQueue();
					this.loadThroughHttp(segment);
					continue;
				}
				if (this.abortLastHttpLoadingInQueueAfterItem(queue2, segment) && this.requests.executingHttpCount < simultaneousHttpDownloads) {
					if (isP2PLoadingRequest) request.abortFromProcessQueue();
					this.loadThroughHttp(segment);
					continue;
				}
				if (isP2PLoadingRequest) continue;
				if (this.requests.executingP2PCount < simultaneousP2PDownloads) {
					this.loadThroughP2P(segment);
					continue;
				}
				if (this.abortLastP2PLoadingInQueueAfterItem(queue2, segment) && this.requests.executingP2PCount < simultaneousP2PDownloads) {
					this.loadThroughP2P(segment);
					continue;
				}
			} else if (statuses.isP2PDownloadable) {
				if (request?.status === "loading") continue;
				if (this.requests.executingP2PCount < simultaneousP2PDownloads) this.loadThroughP2P(segment);
				else if (this.p2pLoaders.currentLoader.isSegmentLoadedBySomeone(segment)) {
					if (this.abortLastP2PLoadingInQueueAfterItem(queue2, segment) && this.requests.executingP2PCount < simultaneousP2PDownloads) this.loadThroughP2P(segment);
				}
			}
		}
	}
	abortSegmentRequest(segmentRuntimeId) {
		if (this.engineRequest?.segment.runtimeId !== segmentRuntimeId) return;
		this.engineRequest.abort();
		this.logger("abort: ", getSegmentString(this.engineRequest.segment));
		this.engineRequest = void 0;
		this.requestProcessQueueMicrotask();
	}
	loadThroughHttp(segment) {
		new HttpRequestExecutor(this.requests.getOrCreateRequest(segment), this.config, this.eventTarget);
		this.p2pLoaders.currentLoader.broadcastAnnouncement();
	}
	loadThroughP2P(segment) {
		this.p2pLoaders.currentLoader.downloadSegment(segment);
	}
	loadRandomThroughHttp() {
		const availableStorageCapacityPercent = this.getAvailableStorageCapacityPercent();
		if (availableStorageCapacityPercent <= 10) return;
		const { simultaneousHttpDownloads, httpErrorRetries } = this.config;
		const p2pLoader = this.p2pLoaders.currentLoader;
		if (this.requests.executingHttpCount >= simultaneousHttpDownloads || !p2pLoader.connectedPeerCount) return;
		const segmentsToLoad = [];
		for (const { segment, statuses } of generateQueue(this.lastRequestedSegment, this.playback, this.config, this.p2pLoaders.currentLoader, availableStorageCapacityPercent)) {
			const swarmId = this.config.swarmId ?? this.streamManifestUrl;
			const streamSwarmId = getStreamSwarmId(swarmId, segment.stream);
			if (!statuses.isHttpDownloadable || statuses.isP2PDownloadable || this.segmentStorage.hasSegment(swarmId, streamSwarmId, segment.externalId)) continue;
			const request = this.requests.get(segment);
			if (request && (request.status === "loading" || request.status === "succeed" || request.failedAttempts.httpAttemptsCount >= httpErrorRetries)) continue;
			segmentsToLoad.push(segment);
		}
		if (!segmentsToLoad.length) return;
		if (simultaneousHttpDownloads - this.requests.executingHttpCount === 0) return;
		const peersCount = p2pLoader.connectedPeerCount + 1;
		const safeRandomSegmentsCount = Math.min(segmentsToLoad.length, simultaneousHttpDownloads * peersCount);
		const randomIndices = shuffleArray(Array.from({ length: safeRandomSegmentsCount }, (_, i) => i));
		let probability = safeRandomSegmentsCount / peersCount;
		for (const randomIndex of randomIndices) {
			if (this.requests.executingHttpCount >= simultaneousHttpDownloads) break;
			if (probability >= 1 || Math.random() <= probability) {
				const segment = segmentsToLoad[randomIndex];
				this.loadThroughHttp(segment);
			}
			probability--;
			if (probability <= 0) break;
		}
	}
	abortLastHttpLoadingInQueueAfterItem(queue2, segment) {
		for (const { segment: itemSegment } of arrayBackwards(queue2)) {
			if (itemSegment === segment) break;
			const request = this.requests.get(itemSegment);
			if (request?.downloadSource === "http" && request.status === "loading") {
				request.abortFromProcessQueue();
				return true;
			}
		}
		return false;
	}
	abortLastP2PLoadingInQueueAfterItem(queue2, segment) {
		for (const { segment: itemSegment } of arrayBackwards(queue2)) {
			if (itemSegment === segment) break;
			const request = this.requests.get(itemSegment);
			if (request?.downloadSource === "p2p" && request.status === "loading") {
				request.abortFromProcessQueue();
				return true;
			}
		}
		return false;
	}
	getAvailableStorageCapacityPercent() {
		const { totalCapacity, usedCapacity } = this.segmentStorage.getUsage();
		return 100 - usedCapacity / totalCapacity * 100;
	}
	generateQueue() {
		const queue2 = [];
		const queueSegmentIds = /* @__PURE__ */ new Set();
		let maxPossibleLength = 0;
		let alreadyLoadedCount = 0;
		const availableStorageCapacityPercent = this.getAvailableStorageCapacityPercent();
		for (const item of generateQueue(this.lastRequestedSegment, this.playback, this.config, this.p2pLoaders.currentLoader, availableStorageCapacityPercent)) {
			maxPossibleLength++;
			const { segment } = item;
			const swarmId = this.config.swarmId ?? this.streamManifestUrl;
			const streamSwarmId = getStreamSwarmId(swarmId, segment.stream);
			if (this.segmentStorage.hasSegment(swarmId, streamSwarmId, segment.externalId) || this.requests.get(segment)?.status === "succeed") {
				alreadyLoadedCount++;
				continue;
			}
			queue2.push(item);
			queueSegmentIds.add(segment.runtimeId);
		}
		return {
			queue: queue2,
			queueSegmentIds,
			maxPossibleLength,
			alreadyLoadedCount,
			queueDownloadRatio: maxPossibleLength !== 0 ? alreadyLoadedCount / maxPossibleLength : 0
		};
	}
	getBandwidth(queueDownloadRatio) {
		const { http, all } = this.bandwidthCalculators;
		const { activeLevelBitrate } = this.streamDetails;
		if (this.streamDetails.activeLevelBitrate === 0) return all.getBandwidthLoadingOnly(3);
		const bandwidth = Math.max(all.getBandwidth(30, this.levelChangedTimestamp), all.getBandwidth(60, this.levelChangedTimestamp), all.getBandwidth(90, this.levelChangedTimestamp));
		if (queueDownloadRatio >= .8 || bandwidth >= activeLevelBitrate * .9) return Math.max(all.getBandwidthLoadingOnly(1), all.getBandwidthLoadingOnly(3), all.getBandwidthLoadingOnly(5));
		const httpRealBandwidth = Math.max(http.getBandwidthLoadingOnly(1), http.getBandwidthLoadingOnly(3), http.getBandwidthLoadingOnly(5));
		return Math.max(bandwidth, httpRealBandwidth);
	}
	notifyLevelChanged() {
		this.levelChangedTimestamp = performance.now();
	}
	sendBroadcastAnnouncement(sendEmptySegmentsAnnouncement = false) {
		this.p2pLoaders.currentLoader.broadcastAnnouncement(sendEmptySegmentsAnnouncement);
	}
	updatePlayback(position, rate) {
		const isRateChanged = this.playback.rate !== rate;
		const isPositionChanged = this.playback.position !== position;
		if (!isRateChanged && !isPositionChanged) return;
		const isPositionSignificantlyChanged = Math.abs(position - this.playback.position) / this.segmentAvgDuration > .5;
		if (isPositionChanged) this.playback.position = position;
		if (isRateChanged && rate !== 0) this.playback.rate = rate;
		if (isPositionSignificantlyChanged) {
			this.logger("position significantly changed");
			this.engineRequest?.markAsShouldBeStartedImmediately();
		}
		this.segmentStorage.onPlaybackUpdated(position, rate);
		this.requestProcessQueueMicrotask(isPositionSignificantlyChanged);
	}
	updateStream(stream) {
		if (stream !== this.lastRequestedSegment.stream) return;
		this.logger(`update stream: ${getStreamString(stream)}`);
		this.requestProcessQueueMicrotask();
	}
	destroy() {
		clearInterval(this.storageCleanUpIntervalId);
		clearInterval(this.randomHttpDownloadInterval);
		this.storageCleanUpIntervalId = void 0;
		this.engineRequest?.abort();
		this.requests.destroy();
		this.p2pLoaders.destroy();
	}
};
var BandwidthCalculator = class {
	constructor(clearThresholdMs = 2e4) {
		this.clearThresholdMs = clearThresholdMs;
	}
	loadingsCount = 0;
	bytes = [];
	loadingOnlyTimestamps = [];
	timestamps = [];
	noLoadingsTime = 0;
	loadingsStoppedAt = 0;
	addBytes(bytesLength, now = performance.now()) {
		this.bytes.push(bytesLength);
		this.loadingOnlyTimestamps.push(now - this.noLoadingsTime);
		this.timestamps.push(now);
	}
	startLoading(now = performance.now()) {
		this.clearStale();
		if (this.loadingsCount === 0 && this.loadingsStoppedAt !== 0) this.noLoadingsTime += now - this.loadingsStoppedAt;
		this.loadingsCount++;
	}
	stopLoading(now = performance.now()) {
		if (this.loadingsCount > 0) {
			this.loadingsCount--;
			if (this.loadingsCount === 0) this.loadingsStoppedAt = now;
		}
	}
	getBandwidthLoadingOnly(seconds, ignoreThresholdTimestamp = Number.NEGATIVE_INFINITY) {
		if (!this.loadingOnlyTimestamps.length) return 0;
		const milliseconds = seconds * 1e3;
		const lastItemTimestamp = this.loadingOnlyTimestamps[this.loadingOnlyTimestamps.length - 1];
		let lastCountedTimestamp = lastItemTimestamp;
		const threshold = lastItemTimestamp - milliseconds;
		let totalBytes = 0;
		for (let i = this.bytes.length - 1; i >= 0; i--) {
			const timestamp = this.loadingOnlyTimestamps[i];
			if (timestamp < threshold || this.timestamps[i] < ignoreThresholdTimestamp) break;
			lastCountedTimestamp = timestamp;
			totalBytes += this.bytes[i];
		}
		return totalBytes * 8e3 / (lastItemTimestamp - lastCountedTimestamp);
	}
	getBandwidth(seconds, ignoreThresholdTimestamp = Number.NEGATIVE_INFINITY, now = performance.now()) {
		if (!this.timestamps.length) return 0;
		const threshold = now - seconds * 1e3;
		let lastCountedTimestamp = now;
		let totalBytes = 0;
		for (let i = this.bytes.length - 1; i >= 0; i--) {
			const timestamp = this.timestamps[i];
			if (timestamp < threshold || timestamp < ignoreThresholdTimestamp) break;
			lastCountedTimestamp = timestamp;
			totalBytes += this.bytes[i];
		}
		return totalBytes * 8e3 / (now - lastCountedTimestamp);
	}
	clearStale() {
		if (!this.loadingOnlyTimestamps.length) return;
		const threshold = this.loadingOnlyTimestamps[this.loadingOnlyTimestamps.length - 1] - this.clearThresholdMs;
		let samplesToRemove = 0;
		for (const timestamp of this.loadingOnlyTimestamps) {
			if (timestamp > threshold) break;
			samplesToRemove++;
		}
		this.bytes.splice(0, samplesToRemove);
		this.loadingOnlyTimestamps.splice(0, samplesToRemove);
		this.timestamps.splice(0, samplesToRemove);
	}
};
var getStorageItemId = (streamId, segmentId) => `${streamId}|${segmentId}`;
var isAndroid = (userAgent) => /Android/i.test(userAgent);
var isIPadOrIPhone = (userAgent) => /iPad|iPhone/i.test(userAgent);
var isAndroidWebview = (userAgent) => /Android/i.test(userAgent) && !/Chrome|Firefox/i.test(userAgent);
var BYTES_PER_MiB = 1048576;
var SegmentMemoryStorage = class {
	userAgent = navigator.userAgent;
	segmentMemoryStorageLimit = 4 * 1024;
	currentStorageUsage = 0;
	cache = /* @__PURE__ */ new Map();
	logger;
	coreConfig;
	mainStreamConfig;
	secondaryStreamConfig;
	currentPlayback;
	lastRequestedSegment;
	segmentChangeCallback;
	constructor() {
		this.logger = debug$3$1("p2pml-core:segment-memory-storage");
		this.logger.color = "RebeccaPurple";
	}
	async initialize(coreConfig, mainStreamConfig, secondaryStreamConfig) {
		this.coreConfig = coreConfig;
		this.mainStreamConfig = mainStreamConfig;
		this.secondaryStreamConfig = secondaryStreamConfig;
		this.setMemoryStorageLimit();
		this.logger("initialized");
	}
	onPlaybackUpdated(position, rate) {
		this.currentPlayback = {
			position,
			rate
		};
	}
	onSegmentRequested(swarmId, streamId, segmentId, startTime, endTime, streamType, isLiveStream) {
		this.lastRequestedSegment = {
			streamId,
			segmentId,
			startTime,
			endTime,
			swarmId,
			streamType,
			isLiveStream
		};
	}
	async storeSegment(_swarmId, streamId, segmentId, data, startTime, endTime, streamType, isLiveStream) {
		this.clear(isLiveStream, data.byteLength);
		const storageId = getStorageItemId(streamId, segmentId);
		this.cache.set(storageId, {
			data,
			segmentId,
			streamId,
			startTime,
			endTime,
			streamType
		});
		this.increaseStorageUsage(data.byteLength);
		this.logger(`add segment: ${segmentId} to ${streamId}`);
		if (!this.segmentChangeCallback) throw new Error("dispatchStorageUpdatedEvent is not set");
		this.segmentChangeCallback(streamId);
	}
	async getSegmentData(_swarmId, streamId, segmentId) {
		const segmentStorageId = getStorageItemId(streamId, segmentId);
		const dataItem = this.cache.get(segmentStorageId);
		if (dataItem === void 0) return void 0;
		return dataItem.data;
	}
	getUsage() {
		if (!this.lastRequestedSegment || !this.currentPlayback) return {
			totalCapacity: this.segmentMemoryStorageLimit,
			usedCapacity: this.currentStorageUsage
		};
		const playbackPosition = this.currentPlayback.position;
		let calculatedUsedCapacity = 0;
		for (const { endTime, data } of this.cache.values()) {
			if (playbackPosition > endTime) continue;
			calculatedUsedCapacity += data.byteLength;
		}
		return {
			totalCapacity: this.segmentMemoryStorageLimit,
			usedCapacity: calculatedUsedCapacity / BYTES_PER_MiB
		};
	}
	hasSegment(_swarmId, streamId, externalId) {
		const segmentStorageId = getStorageItemId(streamId, externalId);
		return this.cache.get(segmentStorageId) !== void 0;
	}
	getStoredSegmentIds(_swarmId, streamId) {
		const externalIds = [];
		for (const { segmentId, streamId: streamCacheId } of this.cache.values()) {
			if (streamCacheId !== streamId) continue;
			externalIds.push(segmentId);
		}
		return externalIds;
	}
	clear(isLiveStream, newSegmentSize) {
		if (!this.currentPlayback || !this.mainStreamConfig || !this.secondaryStreamConfig || !this.coreConfig) return;
		if (!this.isMemoryLimitReached(newSegmentSize) && !isLiveStream) return;
		const affectedStreams = /* @__PURE__ */ new Set();
		const sortedCache = Array.from(this.cache.values()).sort((a, b) => a.startTime - b.startTime);
		for (const segmentData of sortedCache) {
			const { streamId, segmentId, data } = segmentData;
			const storageId = getStorageItemId(streamId, segmentId);
			if (!this.shouldRemoveSegment(segmentData, isLiveStream, this.currentPlayback.position)) continue;
			this.cache.delete(storageId);
			affectedStreams.add(streamId);
			this.decreaseStorageUsage(data.byteLength);
			this.logger(`Removed segment ${segmentId} from stream ${streamId}`);
			if (!this.isMemoryLimitReached(newSegmentSize) && !isLiveStream) break;
		}
		this.sendUpdatesToAffectedStreams(affectedStreams);
	}
	isMemoryLimitReached(segmentByteLength) {
		return this.currentStorageUsage + segmentByteLength / BYTES_PER_MiB > this.segmentMemoryStorageLimit;
	}
	setSegmentChangeCallback(callback) {
		this.segmentChangeCallback = callback;
	}
	sendUpdatesToAffectedStreams(affectedStreams) {
		if (affectedStreams.size === 0) return;
		affectedStreams.forEach((stream) => {
			if (!this.segmentChangeCallback) throw new Error("dispatchStorageUpdatedEvent is not set");
			this.segmentChangeCallback(stream);
		});
	}
	shouldRemoveSegment(segmentData, isLiveStream, currentPlaybackPosition) {
		const { endTime, streamType } = segmentData;
		const highDemandTimeWindow = this.getStreamTimeWindow(streamType, "highDemandTimeWindow");
		if (currentPlaybackPosition <= endTime) return false;
		if (isLiveStream) return currentPlaybackPosition > highDemandTimeWindow + endTime;
		return true;
	}
	increaseStorageUsage(segmentByteLength) {
		this.currentStorageUsage += segmentByteLength / BYTES_PER_MiB;
	}
	decreaseStorageUsage(segmentByteLength) {
		this.currentStorageUsage -= segmentByteLength / BYTES_PER_MiB;
	}
	setMemoryStorageLimit() {
		if (this.coreConfig?.segmentMemoryStorageLimit) {
			this.segmentMemoryStorageLimit = this.coreConfig.segmentMemoryStorageLimit;
			return;
		}
		if (isAndroidWebview(this.userAgent) || isIPadOrIPhone(this.userAgent)) this.segmentMemoryStorageLimit = 1024;
		else if (isAndroid(this.userAgent)) this.segmentMemoryStorageLimit = 2 * 1024;
	}
	getStreamTimeWindow(streamType, configKey) {
		return (streamType === "main" ? this.mainStreamConfig : this.secondaryStreamConfig)?.[configKey] ?? 0;
	}
	destroy() {
		this.cache.clear();
	}
};
var EventTarget = class {
	events = /* @__PURE__ */ new Map();
	dispatchEvent(eventName, ...args) {
		const listeners = this.events.get(eventName);
		if (!listeners) return;
		for (const listener of listeners) listener(...args);
	}
	getEventDispatcher(eventName) {
		let listeners = this.events.get(eventName);
		if (!listeners) {
			listeners = [];
			this.events.set(eventName, listeners);
		}
		const definedListeners = listeners;
		return (...args) => {
			for (const listener of definedListeners) listener(...args);
		};
	}
	addEventListener(eventName, listener) {
		const listeners = this.events.get(eventName);
		if (!listeners) this.events.set(eventName, [listener]);
		else listeners.push(listener);
	}
	removeEventListener(eventName, listener) {
		const listeners = this.events.get(eventName);
		if (listeners) {
			const index = listeners.indexOf(listener);
			if (index !== -1) listeners.splice(index, 1);
		}
	}
};
var Core = class Core {
	/** Default configuration for common core settings. */
	static DEFAULT_COMMON_CORE_CONFIG = {
		segmentMemoryStorageLimit: void 0,
		customSegmentStorageFactory: void 0
	};
	/** Default configuration for stream settings. */
	static DEFAULT_STREAM_CONFIG = {
		isP2PUploadDisabled: false,
		isP2PDisabled: false,
		simultaneousHttpDownloads: 2,
		simultaneousP2PDownloads: 3,
		highDemandTimeWindow: 15,
		httpDownloadTimeWindow: 3e3,
		p2pDownloadTimeWindow: 6e3,
		webRtcMaxMessageSize: 64 * 1024 - 1,
		p2pNotReceivingBytesTimeoutMs: 2e3,
		p2pInactiveLoaderDestroyTimeoutMs: 30 * 1e3,
		httpNotReceivingBytesTimeoutMs: 3e3,
		httpErrorRetries: 3,
		p2pErrorRetries: 3,
		trackerClientVersionPrefix: TRACKER_CLIENT_VERSION_PREFIX,
		announceTrackers: [
			"wss://tracker.novage.com.ua",
			"wss://tracker.webtorrent.dev",
			"wss://tracker.openwebtorrent.com"
		],
		rtcConfig: { iceServers: [{ urls: "stun:stun.l.google.com:19302" }, { urls: "stun:global.stun.twilio.com:3478" }] },
		validateP2PSegment: void 0,
		validateHTTPSegment: void 0,
		httpRequestSetup: void 0,
		swarmId: void 0
	};
	eventTarget = new EventTarget();
	manifestResponseUrl;
	streams = /* @__PURE__ */ new Map();
	mainStreamConfig;
	secondaryStreamConfig;
	commonCoreConfig;
	bandwidthCalculators = {
		all: new BandwidthCalculator(),
		http: new BandwidthCalculator()
	};
	segmentStorage;
	mainStreamLoader;
	secondaryStreamLoader;
	streamDetails = {
		isLive: false,
		activeLevelBitrate: 0
	};
	/**
	* Constructs a new Core instance with optional initial configuration.
	*
	* @param config - Optional partial configuration to override default settings.
	*
	* @example
	* // Create a Core instance with custom configuration for HTTP and P2P downloads.
	* const core = new Core({
	*   simultaneousHttpDownloads: 5,
	*   simultaneousP2PDownloads: 5,
	*   httpErrorRetries: 5,
	*   p2pErrorRetries: 5
	* });
	*
	* @example
	* // Create a Core instance using the default configuration.
	* const core = new Core();
	*/
	constructor(config) {
		const filteredConfig = filterUndefinedProps(config ?? {});
		this.commonCoreConfig = mergeAndFilterConfig({
			defaultConfig: Core.DEFAULT_COMMON_CORE_CONFIG,
			baseConfig: filteredConfig
		});
		this.mainStreamConfig = mergeAndFilterConfig({
			defaultConfig: Core.DEFAULT_STREAM_CONFIG,
			baseConfig: filteredConfig,
			specificStreamConfig: filteredConfig.mainStream
		});
		this.secondaryStreamConfig = mergeAndFilterConfig({
			defaultConfig: Core.DEFAULT_STREAM_CONFIG,
			baseConfig: filteredConfig,
			specificStreamConfig: filteredConfig.secondaryStream
		});
	}
	/**
	* Retrieves the current configuration for the core instance, ensuring immutability.
	*
	* @returns A deep readonly version of the core configuration.
	*/
	getConfig() {
		return {
			...deepCopy(this.commonCoreConfig),
			mainStream: deepCopy(this.mainStreamConfig),
			secondaryStream: deepCopy(this.secondaryStreamConfig)
		};
	}
	/**
	* Applies a set of dynamic configuration updates to the core, merging with the existing configuration.
	*
	* @param dynamicConfig - A set of configuration changes to apply.
	*
	* @example
	* // Example of dynamically updating the download time windows and timeout settings.
	* const dynamicConfig = {
	*   httpDownloadTimeWindow: 60,  // Set HTTP download time window to 60 seconds
	*   p2pDownloadTimeWindow: 60,   // Set P2P download time window to 60 seconds
	*   httpNotReceivingBytesTimeoutMs: 1500,  // Set HTTP timeout to 1500 milliseconds
	*   p2pNotReceivingBytesTimeoutMs: 1500    // Set P2P timeout to 1500 milliseconds
	* };
	* core.applyDynamicConfig(dynamicConfig);
	*/
	applyDynamicConfig(dynamicConfig) {
		const { mainStream, secondaryStream } = dynamicConfig;
		const mainStreamConfigCopy = deepCopy(this.mainStreamConfig);
		const secondaryStreamConfigCopy = deepCopy(this.secondaryStreamConfig);
		this.overrideAllConfigs(dynamicConfig, mainStream, secondaryStream);
		this.processSpecificDynamicConfigParams(mainStreamConfigCopy, dynamicConfig, "main");
		this.processSpecificDynamicConfigParams(secondaryStreamConfigCopy, dynamicConfig, "secondary");
	}
	processSpecificDynamicConfigParams(prevConfig, updatedConfig, streamType) {
		const isP2PDisabled = this.getUpdatedStreamProperty("isP2PDisabled", updatedConfig, streamType);
		if (isP2PDisabled && prevConfig.isP2PDisabled !== isP2PDisabled) this.destroyStreamLoader(streamType);
		const isP2PUploadDisabled = this.getUpdatedStreamProperty("isP2PUploadDisabled", updatedConfig, streamType);
		if (isP2PUploadDisabled !== void 0 && prevConfig.isP2PUploadDisabled !== isP2PUploadDisabled) (streamType === "main" ? this.mainStreamLoader : this.secondaryStreamLoader)?.sendBroadcastAnnouncement(isP2PUploadDisabled);
	}
	getUpdatedStreamProperty(propertyName, updatedConfig, streamType) {
		return (streamType === "main" ? updatedConfig.mainStream : updatedConfig.secondaryStream)?.[propertyName] ?? updatedConfig[propertyName];
	}
	/**
	* Adds an event listener for the specified event type on the core event target.
	*
	* @param eventName - The name of the event to listen for.
	* @param listener - The callback function to invoke when the event is fired.
	*/
	addEventListener(eventName, listener) {
		this.eventTarget.addEventListener(eventName, listener);
	}
	/**
	* Removes an event listener for the specified event type on the core event target.
	*
	* @param eventName - The name of the event to listen for.
	* @param listener - The callback function to be removed.
	*/
	removeEventListener(eventName, listener) {
		this.eventTarget.removeEventListener(eventName, listener);
	}
	/**
	* Sets the response URL for the manifest, stripping any query parameters.
	*
	* @param url - The full URL to the manifest response.
	*/
	setManifestResponseUrl(url) {
		this.manifestResponseUrl = url.split("?")[0];
	}
	/**
	* Checks if a segment is already stored within the core.
	*
	* @param segmentRuntimeId - The runtime identifier of the segment to check.
	* @returns `true` if the segment is present, otherwise `false`.
	*/
	hasSegment(segmentRuntimeId) {
		return !!getSegmentFromStreamsMap(this.streams, segmentRuntimeId);
	}
	/**
	* Retrieves a specific stream by its runtime identifier, if it exists.
	*
	* @param streamRuntimeId - The runtime identifier of the stream to retrieve.
	* @returns The stream with its segments, or `undefined` if not found.
	*/
	getStream(streamRuntimeId) {
		return this.streams.get(streamRuntimeId);
	}
	/**
	* Ensures a stream exists in the map; adds it if it does not.
	*
	* @param stream - The stream to potentially add to the map.
	*/
	addStreamIfNoneExists(stream) {
		if (this.streams.has(stream.runtimeId)) return;
		this.streams.set(stream.runtimeId, {
			...stream,
			segments: /* @__PURE__ */ new Map()
		});
	}
	/**
	* Updates the segments associated with a specific stream.
	*
	* @param streamRuntimeId - The runtime identifier of the stream to update.
	* @param addSegments - Optional segments to add to the stream.
	* @param removeSegmentIds - Optional segment IDs to remove from the stream.
	*/
	updateStream(streamRuntimeId, addSegments, removeSegmentIds) {
		const stream = this.streams.get(streamRuntimeId);
		if (!stream) return;
		if (addSegments) for (const segment of addSegments) {
			if (stream.segments.has(segment.runtimeId)) continue;
			stream.segments.set(segment.runtimeId, {
				...segment,
				stream
			});
		}
		if (removeSegmentIds) for (const id of removeSegmentIds) stream.segments.delete(id);
		this.mainStreamLoader?.updateStream(stream);
		this.secondaryStreamLoader?.updateStream(stream);
	}
	/**
	* Loads a segment given its runtime identifier and invokes the provided callbacks during the process.
	* Initializes segment storage if it has not been initialized yet.
	*
	* @param segmentRuntimeId - The runtime identifier of the segment to load.
	* @param callbacks - The callbacks to be invoked during segment loading.
	* @throws {Error} - Throws if the manifest response URL is not defined.
	*/
	async loadSegment(segmentRuntimeId, callbacks) {
		if (!this.manifestResponseUrl) throw new Error("Manifest response url is not defined");
		await this.initializeSegmentStorage();
		const segment = this.identifySegment(segmentRuntimeId);
		this.getStreamHybridLoader(segment).loadSegment(segment, callbacks);
	}
	/**
	* Aborts the loading of a segment specified by its runtime identifier.
	*
	* @param segmentRuntimeId - The runtime identifier of the segment whose loading is to be aborted.
	*/
	abortSegmentLoading(segmentRuntimeId) {
		this.mainStreamLoader?.abortSegmentRequest(segmentRuntimeId);
		this.secondaryStreamLoader?.abortSegmentRequest(segmentRuntimeId);
	}
	/**
	* Updates the playback parameters while play head moves, specifically position and playback rate, for stream loaders.
	*
	* @param position - The new position in the stream, in seconds.
	* @param rate - The new playback rate.
	*/
	updatePlayback(position, rate) {
		this.mainStreamLoader?.updatePlayback(position, rate);
		this.secondaryStreamLoader?.updatePlayback(position, rate);
	}
	/**
	* Sets the active level bitrate, used for adjusting quality levels in adaptive streaming.
	* Notifies the stream loaders if a change occurs.
	*
	* @param bitrate - The new bitrate to set as active.
	*/
	setActiveLevelBitrate(bitrate) {
		if (bitrate !== this.streamDetails.activeLevelBitrate) {
			this.streamDetails.activeLevelBitrate = bitrate;
			this.mainStreamLoader?.notifyLevelChanged();
			this.secondaryStreamLoader?.notifyLevelChanged();
		}
	}
	/**
	* Updates the 'isLive' status of the stream
	*
	* @param isLive - Boolean indicating whether the stream is live.
	*/
	setIsLive(isLive) {
		this.streamDetails.isLive = isLive;
	}
	/**
	* Identify if a segment is loadable by the P2P core based on the segment's stream type and configuration.
	* @param segmentRuntimeId Segment runtime identifier to check.
	* @returns `true` if the segment is loadable by the P2P core, otherwise `false`.
	*/
	isSegmentLoadable(segmentRuntimeId) {
		try {
			const segment = this.identifySegment(segmentRuntimeId);
			if (segment.stream.type === "main" && this.mainStreamConfig.isP2PDisabled) return false;
			if (segment.stream.type === "secondary" && this.secondaryStreamConfig.isP2PDisabled) return false;
			return true;
		} catch {
			return false;
		}
	}
	/**
	* Cleans up resources used by the Core instance, including destroying any active stream loaders
	* and clearing stored segments.
	*/
	destroy() {
		this.streams.clear();
		this.mainStreamLoader?.destroy();
		this.secondaryStreamLoader?.destroy();
		this.segmentStorage?.destroy();
		this.mainStreamLoader = void 0;
		this.secondaryStreamLoader = void 0;
		this.segmentStorage = void 0;
		this.manifestResponseUrl = void 0;
		this.streamDetails = {
			isLive: false,
			activeLevelBitrate: 0
		};
		P2PTrackerClient.clearPeerIdCache();
	}
	async initializeSegmentStorage() {
		if (this.segmentStorage) return;
		const { isLive } = this.streamDetails;
		const createCustomStorage = this.commonCoreConfig.customSegmentStorageFactory;
		if (createCustomStorage && typeof createCustomStorage !== "function") throw new Error("Storage configuration is invalid");
		const segmentStorage = createCustomStorage ? createCustomStorage(isLive) : new SegmentMemoryStorage();
		await segmentStorage.initialize(this.commonCoreConfig, this.mainStreamConfig, this.secondaryStreamConfig);
		this.segmentStorage = segmentStorage;
	}
	identifySegment(segmentRuntimeId) {
		if (!this.manifestResponseUrl) throw new Error("Manifest response url is undefined");
		const segment = getSegmentFromStreamsMap(this.streams, segmentRuntimeId);
		if (!segment) throw new Error(`Not found segment with id: ${segmentRuntimeId}`);
		return segment;
	}
	overrideAllConfigs(dynamicConfig, mainStream, secondaryStream) {
		overrideConfig(this.commonCoreConfig, dynamicConfig);
		overrideConfig(this.mainStreamConfig, dynamicConfig);
		overrideConfig(this.secondaryStreamConfig, dynamicConfig);
		if (mainStream) overrideConfig(this.mainStreamConfig, mainStream);
		if (secondaryStream) overrideConfig(this.secondaryStreamConfig, secondaryStream);
	}
	destroyStreamLoader(streamType) {
		if (streamType === "main") {
			this.mainStreamLoader?.destroy();
			this.mainStreamLoader = void 0;
		} else {
			this.secondaryStreamLoader?.destroy();
			this.secondaryStreamLoader = void 0;
		}
	}
	getStreamHybridLoader(segment) {
		if (segment.stream.type === "main") {
			this.mainStreamLoader ??= this.createNewHybridLoader(segment);
			return this.mainStreamLoader;
		} else {
			this.secondaryStreamLoader ??= this.createNewHybridLoader(segment);
			return this.secondaryStreamLoader;
		}
	}
	createNewHybridLoader(segment) {
		if (!this.manifestResponseUrl) throw new Error("Manifest response url is not defined");
		if (!this.segmentStorage) throw new Error("Segment storage is not initialized");
		const streamConfig = segment.stream.type === "main" ? this.mainStreamConfig : this.secondaryStreamConfig;
		return new HybridLoader(this.manifestResponseUrl, segment, this.streamDetails, streamConfig, this.bandwidthCalculators, this.segmentStorage, this.eventTarget);
	}
};
var debug$4$1 = browserExports.debug;
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/fragment-loader.js
var __classPrivateFieldSet$2 = function(receiver, state, value, kind, f) {
	if (kind === "m") throw new TypeError("Private method is not writable");
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet$2 = function(receiver, state, kind, f) {
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FragmentLoaderBase_instances, _FragmentLoaderBase_callbacks, _FragmentLoaderBase_createDefaultLoader, _FragmentLoaderBase_defaultLoader, _FragmentLoaderBase_core, _FragmentLoaderBase_response, _FragmentLoaderBase_segmentId, _FragmentLoaderBase_handleError, _FragmentLoaderBase_abortInternal;
var DEFAULT_DOWNLOAD_LATENCY = 10;
var FragmentLoaderBase = class {
	constructor(config, core) {
		_FragmentLoaderBase_instances.add(this);
		Object.defineProperty(this, "context", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "config", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "stats", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		_FragmentLoaderBase_callbacks.set(this, void 0);
		_FragmentLoaderBase_createDefaultLoader.set(this, void 0);
		_FragmentLoaderBase_defaultLoader.set(this, void 0);
		_FragmentLoaderBase_core.set(this, void 0);
		_FragmentLoaderBase_response.set(this, void 0);
		_FragmentLoaderBase_segmentId.set(this, void 0);
		__classPrivateFieldSet$2(this, _FragmentLoaderBase_core, core, "f");
		__classPrivateFieldSet$2(this, _FragmentLoaderBase_createDefaultLoader, () => new config.loader(config), "f");
		this.stats = {
			aborted: false,
			chunkCount: 0,
			loading: {
				start: 0,
				first: 0,
				end: 0
			},
			buffering: {
				start: 0,
				first: 0,
				end: 0
			},
			parsing: {
				start: 0,
				end: 0
			},
			total: 1,
			loaded: 1,
			bwEstimate: 0,
			retry: 0
		};
	}
	load(context, config, callbacks) {
		this.context = context;
		this.config = config;
		__classPrivateFieldSet$2(this, _FragmentLoaderBase_callbacks, callbacks, "f");
		const { stats } = this;
		const { rangeStart: start, rangeEnd: end } = context;
		const byteRange = getByteRange(start, end !== void 0 ? end - 1 : void 0);
		__classPrivateFieldSet$2(this, _FragmentLoaderBase_segmentId, getSegmentRuntimeId(context.url, byteRange), "f");
		const isSegmentDownloadableByP2PCore = __classPrivateFieldGet$2(this, _FragmentLoaderBase_core, "f").isSegmentLoadable(__classPrivateFieldGet$2(this, _FragmentLoaderBase_segmentId, "f"));
		if (!__classPrivateFieldGet$2(this, _FragmentLoaderBase_core, "f").hasSegment(__classPrivateFieldGet$2(this, _FragmentLoaderBase_segmentId, "f")) || !isSegmentDownloadableByP2PCore) {
			__classPrivateFieldSet$2(this, _FragmentLoaderBase_defaultLoader, __classPrivateFieldGet$2(this, _FragmentLoaderBase_createDefaultLoader, "f").call(this), "f");
			__classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f").stats = this.stats;
			__classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f").load(context, config, callbacks);
			return;
		}
		const onSuccess = (response) => {
			__classPrivateFieldSet$2(this, _FragmentLoaderBase_response, response, "f");
			const loadedBytes = __classPrivateFieldGet$2(this, _FragmentLoaderBase_response, "f").data.byteLength;
			stats.loading = getLoadingStat(__classPrivateFieldGet$2(this, _FragmentLoaderBase_response, "f").bandwidth, loadedBytes, performance.now());
			stats.total = loadedBytes;
			stats.loaded = loadedBytes;
			if (callbacks.onProgress) callbacks.onProgress(this.stats, context, __classPrivateFieldGet$2(this, _FragmentLoaderBase_response, "f").data, void 0);
			callbacks.onSuccess({
				data: __classPrivateFieldGet$2(this, _FragmentLoaderBase_response, "f").data,
				url: context.url
			}, this.stats, context, void 0);
		};
		const onError = (error) => {
			if (error instanceof CoreRequestError && error.type === "aborted" && this.stats.aborted) return;
			__classPrivateFieldGet$2(this, _FragmentLoaderBase_instances, "m", _FragmentLoaderBase_handleError).call(this, error);
		};
		__classPrivateFieldGet$2(this, _FragmentLoaderBase_core, "f").loadSegment(__classPrivateFieldGet$2(this, _FragmentLoaderBase_segmentId, "f"), {
			onSuccess,
			onError
		});
	}
	abort() {
		if (__classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f")) __classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f").abort();
		else {
			__classPrivateFieldGet$2(this, _FragmentLoaderBase_instances, "m", _FragmentLoaderBase_abortInternal).call(this);
			__classPrivateFieldGet$2(this, _FragmentLoaderBase_callbacks, "f")?.onAbort?.(this.stats, this.context, {});
		}
	}
	destroy() {
		if (__classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f")) __classPrivateFieldGet$2(this, _FragmentLoaderBase_defaultLoader, "f").destroy();
		else {
			if (!this.stats.aborted) __classPrivateFieldGet$2(this, _FragmentLoaderBase_instances, "m", _FragmentLoaderBase_abortInternal).call(this);
			__classPrivateFieldSet$2(this, _FragmentLoaderBase_callbacks, null, "f");
			this.config = null;
		}
	}
};
_FragmentLoaderBase_callbacks = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_createDefaultLoader = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_defaultLoader = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_core = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_response = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_segmentId = /* @__PURE__ */ new WeakMap(), _FragmentLoaderBase_instances = /* @__PURE__ */ new WeakSet(), _FragmentLoaderBase_handleError = function _FragmentLoaderBase_handleError(thrownError) {
	const error = {
		code: 0,
		text: ""
	};
	if (thrownError instanceof CoreRequestError && thrownError.type === "failed") error.text = thrownError.message;
	else if (thrownError instanceof Error) error.text = thrownError.message;
	__classPrivateFieldGet$2(this, _FragmentLoaderBase_callbacks, "f")?.onError(error, this.context, null, this.stats);
}, _FragmentLoaderBase_abortInternal = function _FragmentLoaderBase_abortInternal() {
	if (!__classPrivateFieldGet$2(this, _FragmentLoaderBase_response, "f") && __classPrivateFieldGet$2(this, _FragmentLoaderBase_segmentId, "f")) {
		this.stats.aborted = true;
		__classPrivateFieldGet$2(this, _FragmentLoaderBase_core, "f").abortSegmentLoading(__classPrivateFieldGet$2(this, _FragmentLoaderBase_segmentId, "f"));
	}
};
function getLoadingStat(targetBitrate, loadedBytes, loadingEndTime) {
	const first = loadingEndTime - loadedBytes * 8e3 / targetBitrate;
	return {
		start: first - DEFAULT_DOWNLOAD_LATENCY,
		first,
		end: loadingEndTime
	};
}
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/playlist-loader.js
var __classPrivateFieldSet$1 = function(receiver, state, value, kind, f) {
	if (kind === "m") throw new TypeError("Private method is not writable");
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet$1 = function(receiver, state, kind, f) {
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PlaylistLoaderBase_defaultLoader;
var PlaylistLoaderBase = class {
	constructor(config) {
		_PlaylistLoaderBase_defaultLoader.set(this, void 0);
		Object.defineProperty(this, "context", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "stats", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		__classPrivateFieldSet$1(this, _PlaylistLoaderBase_defaultLoader, new config.loader(config), "f");
		this.stats = __classPrivateFieldGet$1(this, _PlaylistLoaderBase_defaultLoader, "f").stats;
		this.context = __classPrivateFieldGet$1(this, _PlaylistLoaderBase_defaultLoader, "f").context;
	}
	load(context, config, callbacks) {
		__classPrivateFieldGet$1(this, _PlaylistLoaderBase_defaultLoader, "f").load(context, config, callbacks);
	}
	abort() {
		__classPrivateFieldGet$1(this, _PlaylistLoaderBase_defaultLoader, "f").abort();
	}
	destroy() {
		__classPrivateFieldGet$1(this, _PlaylistLoaderBase_defaultLoader, "f").destroy();
	}
};
_PlaylistLoaderBase_defaultLoader = /* @__PURE__ */ new WeakMap();
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/segment-mananger.js
var SegmentManager = class {
	constructor(core) {
		Object.defineProperty(this, "core", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		this.core = core;
	}
	processMainManifest(data) {
		const { levels, audioTracks } = data;
		for (const [index, level] of levels.entries()) {
			const { url } = level;
			this.core.addStreamIfNoneExists({
				runtimeId: Array.isArray(url) ? url[0] : url,
				type: "main",
				index
			});
		}
		for (const [index, track] of audioTracks.entries()) {
			const { url } = track;
			this.core.addStreamIfNoneExists({
				runtimeId: Array.isArray(url) ? url[0] : url,
				type: "secondary",
				index
			});
		}
	}
	updatePlaylist(data) {
		const { details: { url, fragments, live } } = data;
		const playlist = this.core.getStream(url);
		if (!playlist) return;
		const segmentToRemoveIds = new Set(playlist.segments.keys());
		const newSegments = [];
		fragments.forEach((fragment, index) => {
			const { url: responseUrl, byteRange: fragByteRange, sn, start: startTime, end: endTime } = fragment;
			const [start, end] = fragByteRange;
			const byteRange = getByteRange(start, end !== void 0 ? end - 1 : void 0);
			const runtimeId = getSegmentRuntimeId(responseUrl, byteRange);
			segmentToRemoveIds.delete(runtimeId);
			if (playlist.segments.has(runtimeId)) return;
			newSegments.push({
				runtimeId,
				url: responseUrl,
				externalId: live ? sn : index,
				byteRange,
				startTime,
				endTime
			});
		});
		if (!newSegments.length && !segmentToRemoveIds.size) return;
		this.core.updateStream(url, newSegments, segmentToRemoveIds.values());
	}
};
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/engine-static.js
var __classPrivateFieldGet = function(receiver, state, kind, f) {
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = function(receiver, state, value, kind, f) {
	if (kind === "m") throw new TypeError("Private method is not writable");
	if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function injectMixin(HlsJsClass) {
	var _HlsJsWithP2PClass_p2pEngine, _a;
	return _a = class HlsJsWithP2PClass extends HlsJsClass {
		get p2pEngine() {
			return __classPrivateFieldGet(this, _HlsJsWithP2PClass_p2pEngine, "f");
		}
		constructor(...args) {
			const { p2p, ...hlsJsConfig } = args[0] ?? {};
			const p2pEngine = new HlsJsP2PEngine(p2p);
			super({
				...hlsJsConfig,
				...p2pEngine.getConfigForHlsJs()
			});
			_HlsJsWithP2PClass_p2pEngine.set(this, void 0);
			p2pEngine.bindHls(this);
			__classPrivateFieldSet(this, _HlsJsWithP2PClass_p2pEngine, p2pEngine, "f");
			p2p?.onHlsJsCreated?.(this);
		}
	}, _HlsJsWithP2PClass_p2pEngine = /* @__PURE__ */ new WeakMap(), _a;
}
//#endregion
//#region ../../../../node_modules/.pnpm/p2p-media-loader-hlsjs@2.2.2/node_modules/p2p-media-loader-hlsjs/lib/engine.js
var MAX_LIVE_SYNC_DURATION = 120;
/**
* Represents a P2P (peer-to-peer) engine for HLS (HTTP Live Streaming) to enhance media streaming efficiency.
* This class integrates P2P technologies into HLS.js, enabling the distribution of media segments via a peer network
* alongside traditional HTTP fetching. It reduces server bandwidth costs and improves scalability by sharing the load
* across multiple clients.
*
* The engine manages core functionalities such as segment fetching, segment management, peer connection management,
* and event handling related to the P2P and HLS processes.
*
* @example
* // Creating an instance of HlsJsP2PEngine with custom configuration
* const hlsP2PEngine = new HlsJsP2PEngine({
*   core: {
*     highDemandTimeWindow: 30, // 30 seconds
*     simultaneousHttpDownloads: 3,
*     webRtcMaxMessageSize: 64 * 1024, // 64 KB
*     p2pNotReceivingBytesTimeoutMs: 10000, // 10 seconds
*     p2pInactiveLoaderDestroyTimeoutMs: 15000, // 15 seconds
*     httpNotReceivingBytesTimeoutMs: 8000, // 8 seconds
*     httpErrorRetries: 2,
*     p2pErrorRetries: 2,
*     announceTrackers: ["wss://personal.tracker.com"],
*     rtcConfig: {
*       iceServers: [{ urls: "stun:personal.stun.com" }]
*     },
*     swarmId: "example-swarm-id"
*   }
* });
*
*/
var HlsJsP2PEngine = class {
	/**
	* Enhances a given Hls.js class by injecting additional P2P (peer-to-peer) functionalities.
	*
	* @returns {HlsWithP2PInstance} - The enhanced Hls.js class with P2P functionalities.
	*
	* @example
	* const HlsWithP2P = HlsJsP2PEngine.injectMixin(Hls);
	*
	* const hls = new HlsWithP2P({
	*   // Hls.js configuration
	*   startLevel: 0, // Example of Hls.js config parameter
	*   p2p: {
	*     core: {
	*       // P2P core configuration
	*     },
	*     onHlsJsCreated(hls) {
	*       // Do something with the Hls.js instance
	*     },
	*   },
	* });
	*/
	static injectMixin(hls) {
		return injectMixin(hls);
	}
	/**
	* Constructs an instance of HlsJsP2PEngine.
	* @param config Optional configuration for P2P engine setup.
	*/
	constructor(config) {
		Object.defineProperty(this, "core", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "segmentManager", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "hlsInstanceGetter", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "currentHlsInstance", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0
		});
		Object.defineProperty(this, "debug", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: debug$4$1("p2pml-hlsjs:engine")
		});
		Object.defineProperty(this, "updateMediaElementEventHandlers", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: (type) => {
				const media = this.currentHlsInstance?.media;
				if (!media) return;
				const method = type === "register" ? "addEventListener" : "removeEventListener";
				media[method]("timeupdate", this.handlePlaybackUpdate);
				media[method]("seeking", this.handlePlaybackUpdate);
				media[method]("ratechange", this.handlePlaybackUpdate);
			}
		});
		Object.defineProperty(this, "handleManifestLoaded", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: (event, data) => {
				const networkDetails = data.networkDetails;
				if (networkDetails instanceof XMLHttpRequest) this.core.setManifestResponseUrl(networkDetails.responseURL);
				else if (networkDetails instanceof Response) this.core.setManifestResponseUrl(networkDetails.url);
				this.segmentManager.processMainManifest(data);
			}
		});
		Object.defineProperty(this, "handleLevelSwitching", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: (event, data) => {
				if (data.bitrate) this.core.setActiveLevelBitrate(data.bitrate);
			}
		});
		Object.defineProperty(this, "handleLevelUpdated", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: (event, data) => {
				if (this.currentHlsInstance && data.details.live && data.details.fragments[0].type === "main" && !this.currentHlsInstance.userConfig.liveSyncDuration && !this.currentHlsInstance.userConfig.liveSyncDurationCount && data.details.fragments.length > 4) this.updateLiveSyncDurationCount(data);
				this.core.setIsLive(data.details.live);
				this.segmentManager.updatePlaylist(data);
			}
		});
		Object.defineProperty(this, "handleMediaAttached", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: () => {
				this.updateMediaElementEventHandlers("register");
			}
		});
		Object.defineProperty(this, "handleMediaDetached", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: () => {
				this.updateMediaElementEventHandlers("unregister");
			}
		});
		Object.defineProperty(this, "handlePlaybackUpdate", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: (event) => {
				const media = event.target;
				this.core.updatePlayback(media.currentTime, media.playbackRate);
			}
		});
		Object.defineProperty(this, "destroyCore", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: () => this.core.destroy()
		});
		/** Clean up and release all resources. Unregister all event handlers. */
		Object.defineProperty(this, "destroy", {
			enumerable: true,
			configurable: true,
			writable: true,
			value: () => {
				this.destroyCore();
				this.updateHlsEventsHandlers("unregister");
				this.updateMediaElementEventHandlers("unregister");
				this.currentHlsInstance = void 0;
			}
		});
		this.core = new Core(config?.core);
		this.segmentManager = new SegmentManager(this.core);
	}
	/**
	* Adds an event listener for the specified event.
	* @param eventName The name of the event to listen for.
	* @param listener The callback function to be invoked when the event is triggered.
	*
	* @example
	* // Listening for a segment being successfully loaded
	* p2pEngine.addEventListener('onSegmentLoaded', (details) => {
	*   console.log('Segment Loaded:', details);
	* });
	*
	* @example
	* // Handling segment load errors
	* p2pEngine.addEventListener('onSegmentError', (errorDetails) => {
	*   console.error('Error loading segment:', errorDetails);
	* });
	*
	* @example
	* // Tracking data downloaded from peers
	* p2pEngine.addEventListener('onChunkDownloaded', (bytesLength, downloadSource, peerId) => {
	*   console.log(`Downloaded ${bytesLength} bytes from ${downloadSource} ${peerId ? 'from peer ' + peerId : 'from server'}`);
	* });
	*/
	addEventListener(eventName, listener) {
		this.core.addEventListener(eventName, listener);
	}
	/**
	* Removes an event listener for the specified event.
	* @param eventName The name of the event.
	* @param listener The callback function that was previously added.
	*/
	removeEventListener(eventName, listener) {
		this.core.removeEventListener(eventName, listener);
	}
	/**
	* provides the Hls.js P2P specific configuration for Hls.js loaders.
	* @returns An object with fragment loader (fLoader) and playlist loader (pLoader).
	*/
	getConfigForHlsJs() {
		return {
			fLoader: this.createFragmentLoaderClass(),
			pLoader: this.createPlaylistLoaderClass()
		};
	}
	/**
	* Returns the configuration of the HLS.js P2P engine.
	* @returns A readonly version of the HlsJsP2PEngineConfig.
	*/
	getConfig() {
		return { core: this.core.getConfig() };
	}
	/**
	* Applies dynamic configuration updates to the P2P engine.
	* @param dynamicConfig Configuration changes to apply.
	*
	* @example
	* // Assuming `hlsP2PEngine` is an instance of HlsJsP2PEngine
	*
	* const newDynamicConfig = {
	*   core: {
	*     // Increase the number of cached segments to 1000
	*     cachedSegmentsCount: 1000,
	*     // 50 minutes of segments will be downloaded further through HTTP connections if P2P fails
	*     httpDownloadTimeWindow: 3000,
	*     // 100 minutes of segments will be downloaded further through P2P connections
	*     p2pDownloadTimeWindow: 6000,
	* };
	*
	* hlsP2PEngine.applyDynamicConfig(newDynamicConfig);
	*/
	applyDynamicConfig(dynamicConfig) {
		if (dynamicConfig.core) this.core.applyDynamicConfig(dynamicConfig.core);
	}
	/**
	* Sets the HLS instance for handling media.
	* @param hls The HLS instance or a function that returns an HLS instance.
	*/
	bindHls(hls) {
		this.hlsInstanceGetter = typeof hls === "function" ? hls : () => hls;
	}
	initHlsEvents() {
		const hlsInstance = this.hlsInstanceGetter?.();
		if (this.currentHlsInstance === hlsInstance) return;
		if (this.currentHlsInstance) this.destroy();
		this.currentHlsInstance = hlsInstance;
		this.updateHlsEventsHandlers("register");
		this.updateMediaElementEventHandlers("register");
	}
	updateHlsEventsHandlers(type) {
		const hls = this.currentHlsInstance;
		if (!hls) return;
		const method = type === "register" ? "on" : "off";
		hls[method]("hlsManifestLoaded", this.handleManifestLoaded);
		hls[method]("hlsLevelSwitching", this.handleLevelSwitching);
		hls[method]("hlsLevelUpdated", this.handleLevelUpdated);
		hls[method]("hlsAudioTrackLoaded", this.handleLevelUpdated);
		hls[method]("hlsDestroying", this.destroy);
		hls[method]("hlsMediaAttaching", this.destroyCore);
		hls[method]("hlsManifestLoading", this.destroyCore);
		hls[method]("hlsMediaDetached", this.handleMediaDetached);
		hls[method]("hlsMediaAttached", this.handleMediaAttached);
	}
	updateLiveSyncDurationCount(data) {
		const fragmentDuration = data.details.targetduration;
		const maxLiveSyncCount = Math.floor(MAX_LIVE_SYNC_DURATION / fragmentDuration);
		const newLiveSyncDurationCount = Math.min(data.details.fragments.length - 1, maxLiveSyncCount);
		if (this.currentHlsInstance && this.currentHlsInstance.config.liveSyncDurationCount !== newLiveSyncDurationCount) {
			this.debug(`Setting liveSyncDurationCount to ${newLiveSyncDurationCount}`);
			this.currentHlsInstance.config.liveSyncDurationCount = newLiveSyncDurationCount;
		}
	}
	createFragmentLoaderClass() {
		const { core } = this;
		const engine = this;
		return class FragmentLoader extends FragmentLoaderBase {
			constructor(config) {
				super(config, core);
			}
			static getEngine() {
				return engine;
			}
		};
	}
	createPlaylistLoaderClass() {
		const engine = this;
		return class PlaylistLoader extends PlaylistLoaderBase {
			constructor(config) {
				super(config);
				engine.initHlsEvents();
			}
		};
	}
};
//#endregion
//#region src/shared/p2p-media-loader/hls-plugin.ts
var HlsWithP2P = HlsJsP2PEngine.injectMixin(Hls);
var alreadyRegistered = false;
var registerSourceHandler = function(vjs) {
	if (!Hls.isSupported()) {
		logger$1.info("Hls.js is not supported in this browser.");
		return;
	}
	const html5 = vjs.getTech("Html5");
	if (!html5) {
		logger$1.error("No \"Html5\" tech found in videojs");
		return;
	}
	if (alreadyRegistered) return;
	alreadyRegistered = true;
	html5.registerSourceHandler({
		canHandleSource: function(source) {
			const hlsTypeRE = /^application\/x-mpegURL|application\/vnd\.apple\.mpegurl$/i;
			const hlsExtRE = /\.m3u8/i;
			if (hlsTypeRE.test(source.type)) return "probably";
			if (hlsExtRE.test(source.src)) return "maybe";
			return "";
		},
		handleSource: function(source, tech) {
			if (tech.hlsProvider) tech.hlsProvider.dispose();
			tech.hlsProvider = new Html5Hlsjs(vjs, source, tech);
			return tech.hlsProvider;
		}
	}, 0);
	vjs.Html5Hlsjs = Html5Hlsjs;
};
var Plugin$8 = import_core.default.getPlugin("plugin");
var HLSJSConfigHandler = class extends Plugin$8 {
	constructor(player, options) {
		super(player);
		if (!options) return;
		if (!player.srOptions_) player.srOptions_ = {};
		if (!player.srOptions_.hlsjsConfig) player.srOptions_.hlsjsConfig = options.hlsjsConfig;
		if (options.levelLabelHandler && !player.srOptions_.levelLabelHandler) player.srOptions_.levelLabelHandler = options.levelLabelHandler;
		registerSourceHandler(import_core.default);
	}
	dispose() {
		this.player.srOptions_ = void 0;
		const tech = this.player.tech(true);
		if (tech.hlsProvider) {
			tech.hlsProvider.dispose();
			tech.hlsProvider = void 0;
		}
		super.dispose();
	}
};
import_core.default.registerPlugin("hlsjs", HLSJSConfigHandler);
var Html5Hlsjs = class {
	videoElement;
	errorCounts = {};
	player;
	tech;
	source;
	vjs;
	maxNetworkErrorRecovery = 5;
	hls;
	hlsjsConfig = null;
	_duration = null;
	metadata = null;
	isLive = null;
	dvrDuration = null;
	edgeMargin = null;
	liveEnded = false;
	handlers = {
		play: null,
		error: null
	};
	audioMode = false;
	constructor(vjs, source, tech) {
		this.vjs = vjs;
		this.source = source;
		this.tech = tech;
		this.tech.name_ = "Hlsjs";
		this.videoElement = tech.el();
		this.player = vjs(tech.options_.playerId);
		this.handlers.error = (event) => {
			let errorTxt;
			const mediaError = (event.currentTarget || event.target).error;
			if (!mediaError) return;
			logger$1.info(mediaError);
			switch (mediaError.code) {
				case mediaError.MEDIA_ERR_ABORTED:
					errorTxt = "You aborted the video playback";
					break;
				case mediaError.MEDIA_ERR_DECODE:
					errorTxt = "The video playback was aborted due to a corruption problem or because the video used features your browser did not support";
					this._handleMediaError(mediaError);
					break;
				case mediaError.MEDIA_ERR_NETWORK:
					errorTxt = "A network error caused the video download to fail part-way";
					break;
				case mediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
					errorTxt = "The video could not be loaded, either because the server or network failed or because the format is not supported";
					break;
				default: errorTxt = mediaError.message;
			}
			logger$1.error(`MEDIA_ERROR: ${errorTxt}`);
		};
		this.videoElement.addEventListener("error", this.handlers.error);
		this.initialize();
	}
	duration() {
		if (this._duration === Infinity) return Infinity;
		if (!isNaN(this.videoElement.duration)) return this.videoElement.duration;
		return this._duration || this.hlsjsConfig.durationPlaceholder || 0;
	}
	seekable() {
		if (this.hls.media) {
			if (!this.isLive) return this.vjs.time.createTimeRanges(0, this.hls.media.duration);
			const startTime = Math.round(this.hls.media.duration - this.dvrDuration);
			const endTime = Math.round(this.hls.media.duration - this.edgeMargin);
			return this.vjs.time.createTimeRanges(startTime, endTime);
		}
		return this.vjs.time.createTimeRanges(0, void 0);
	}
	dispose() {
		this.videoElement.removeEventListener("play", this.handlers.play);
		this.videoElement.removeEventListener("error", this.handlers.error);
		this.hls.destroy();
	}
	_getHumanErrorMsg(error) {
		switch (error.code) {
			default: return error.message;
		}
	}
	_handleUnrecoverableError(error) {
		if (this.hls.levels.filter((l) => l.id > -1).length > 1) {
			this._removeQuality(this.hls.loadLevel);
			return;
		}
		this.hls.destroy();
		logger$1.info("bubbling error up to VIDEOJS");
		this.tech.error = () => ({
			...error,
			message: this._getHumanErrorMsg(error)
		});
		this.tech.trigger("error");
	}
	_handleMediaError(error) {
		if (this.errorCounts[Hls.ErrorTypes.MEDIA_ERROR] === 1) {
			logger$1.info("trying to recover media error");
			this.hls.recoverMediaError();
			return;
		}
		if (this.errorCounts[Hls.ErrorTypes.MEDIA_ERROR] === 2) {
			logger$1.info("2nd try to recover media error (by swapping audio codec");
			this.hls.swapAudioCodec();
			this.hls.recoverMediaError();
			return;
		}
		if (this.errorCounts[Hls.ErrorTypes.MEDIA_ERROR] > 2) this._handleUnrecoverableError(error);
	}
	_handleNetworkError(error) {
		if (navigator.onLine === false) return;
		if (this.liveEnded) {
			logger$1.info("Forcing end of live stream after a network error");
			this.player?.handleTechEnded_();
			this.hls?.stopLoad();
			return;
		}
		if (this.errorCounts[Hls.ErrorTypes.NETWORK_ERROR] <= this.maxNetworkErrorRecovery) {
			logger$1.info("trying to recover network error");
			setTimeout(() => this.hls.startLoad(), 1e3);
			this.hls.once(Hls.Events.FRAG_LOADED, () => {
				this.errorCounts[Hls.ErrorTypes.NETWORK_ERROR] = 0;
			});
			return;
		}
		this._handleUnrecoverableError(error);
	}
	_onError(_event, data) {
		const error = { message: `HLS.js error: ${data.type} - fatal: ${data.fatal} - ${data.details}` };
		if (this.errorCounts[data.type]) this.errorCounts[data.type] += 1;
		else this.errorCounts[data.type] = 1;
		if (!/googlebot/i.test(navigator.userAgent)) if (data.fatal) logger$1.error(error.message, {
			currentTime: this.player.currentTime(),
			data
		});
		else logger$1.clientWarn(error.message);
		if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
			error.code = 2;
			this._handleNetworkError(error);
		} else if (data.fatal && data.type === Hls.ErrorTypes.MEDIA_ERROR && data.details !== Hls.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR) {
			error.code = 3;
			this._handleMediaError(error);
		} else if (data.fatal) this._handleUnrecoverableError(error);
	}
	buildLevelLabel(level) {
		return this.player.srOptions_.levelLabelHandler(level, this.player);
	}
	_removeQuality(index) {
		this.hls.removeLevel(index);
		this.player.peertubeResolutions().remove(index);
		this.hls.currentLevel = -1;
	}
	_notifyVideoQualities() {
		if (!this.metadata) return;
		const resolutions = [];
		this.metadata.levels.forEach((level, index) => {
			resolutions.push({
				id: index,
				height: level.height,
				width: level.width,
				bitrate: level.bitrate,
				label: this.buildLevelLabel(level),
				selected: level.id === this.hls.manualLevel,
				selectCallback: () => this.manuallySelectVideoLevel(index)
			});
		});
		if (resolutions.filter((r) => r.height !== 0).length !== 0 && this.getSeparateAudioTrack()) {
			const audioTrackUrl = this.getSeparateAudioTrack();
			resolutions.push({
				id: -2,
				height: 0,
				label: this.player.localize("Audio only"),
				selected: false,
				selectCallback: () => {
					if (this.audioMode) return;
					this.audioMode = true;
					this.updateToAudioOrVideo(audioTrackUrl);
				}
			});
		}
		resolutions.push({
			id: -1,
			label: this.player.localize("Auto"),
			selected: true,
			selectCallback: () => this.manuallySelectVideoLevel(-1)
		});
		this.player.peertubeResolutions().add(resolutions);
		const preferredResolution = this.pickPreferredResolution(resolutions);
		if (preferredResolution) this.player.peertubeResolutions().select({
			id: preferredResolution.id,
			fireCallback: true
		});
	}
	pickPreferredResolution(resolutions) {
		const preferredHeight = getStoredPreferredResolution();
		if (preferredHeight === void 0) return void 0;
		const selectableResolutions = resolutions.filter((r) => r.id !== -1 && r.height !== void 0).sort((a, b) => a.height - b.height);
		if (selectableResolutions.length === 0) return void 0;
		const exactMatch = selectableResolutions.find((r) => r.height === preferredHeight);
		if (exactMatch) return exactMatch;
		const nearestAbove = selectableResolutions.find((r) => r.height >= preferredHeight);
		if (nearestAbove) return nearestAbove;
		return selectableResolutions[selectableResolutions.length - 1];
	}
	manuallySelectVideoLevel(index) {
		if (this.audioMode) {
			this.audioMode = false;
			this.updateToAudioOrVideo(this.source.src, index);
			return;
		}
		this.hls.currentLevel = index;
	}
	_startLoad() {
		this.hls.startLoad(this.hlsjsConfig.startPosition || -1);
		this.videoElement.removeEventListener("play", this.handlers.play);
	}
	_onMetaData(_event, data) {
		this.metadata = data;
		this._notifyVideoQualities();
	}
	initialize() {
		this.liveEnded = false;
		this.buildBaseConfig();
		if (["", "auto"].includes(this.videoElement.preload) && !this.videoElement.autoplay && this.hlsjsConfig.autoStartLoad === void 0) this.hlsjsConfig.autoStartLoad = false;
		if (this.hlsjsConfig.autoStartLoad === false) {
			this.handlers.play = this._startLoad.bind(this);
			this.videoElement.addEventListener("play", this.handlers.play);
		}
		this.hls = new HlsWithP2P({
			...omit(this.hlsjsConfig, ["p2pMediaLoaderOptions"]),
			p2p: { core: this.hlsjsConfig.p2pMediaLoaderOptions }
		});
		this.player.trigger("hlsjs-initialized", { hlsjs: this.hls });
		this.hls.on(Hls.Events.ERROR, (event, data) => this._onError(event, data));
		this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => this._onMetaData(event, data));
		this.hls.on(Hls.Events.LEVEL_LOADED, (_event, data) => {
			if (this.hlsjsConfig.liveSyncDuration) this.edgeMargin = this.hlsjsConfig.liveSyncDuration;
			else if (this.hlsjsConfig.liveSyncDurationCount) this.edgeMargin = this.hlsjsConfig.liveSyncDurationCount * data.details.targetduration;
			if (this.isLive && !data.details.live) {
				this.liveEnded = true;
				this.player.trigger("hlsjs-live-ended");
			}
			this.isLive = data.details.live;
			this.dvrDuration = data.details.totalduration;
			this._duration = this.isLive ? Infinity : data.details.totalduration;
			if (this.isLive) this.maxNetworkErrorRecovery = 30;
		});
		this.registerLevelEventSwitch();
		this.hls.once(Hls.Events.FRAG_LOADED, () => {
			this.tech.trigger("loadedmetadata");
		});
		this.hls.attachMedia(this.videoElement);
		this.hls.loadSource(this.source.src);
	}
	updateToAudioOrVideo(newSource, startLevel) {
		this.player.addClass("vjs-updating-resolution");
		const currentTime = this.player.currentTime();
		this.dispose();
		this.buildBaseConfig();
		this.hlsjsConfig.autoStartLoad = true;
		this.player.autoplay("play");
		this.hls = new HlsWithP2P({
			...omit(this.hlsjsConfig, ["p2pMediaLoaderOptions"]),
			p2p: { core: this.hlsjsConfig.p2pMediaLoaderOptions },
			startPosition: this.duration() === Infinity ? void 0 : currentTime,
			startLevel
		});
		this.player.trigger("hlsjs-initialized", { hlsjs: this.hls });
		this.hls.on(Hls.Events.ERROR, (event, data) => this._onError(event, data));
		this.registerLevelEventSwitch();
		this.hls.attachMedia(this.videoElement);
		this.hls.loadSource(newSource);
		this.player.one("canplay", () => {
			this.player.removeClass("vjs-updating-resolution");
		});
	}
	registerLevelEventSwitch() {
		this.hls.on(Hls.Events.LEVEL_SWITCHING, (_e, data) => {
			let resolutionId = data.level;
			let autoResolutionChosenId = -1;
			if (this.audioMode) resolutionId = -2;
			else if (this.hls.autoLevelEnabled) {
				resolutionId = -1;
				autoResolutionChosenId = data.level;
			}
			this.player.peertubeResolutions().select({
				id: resolutionId,
				autoResolutionChosenId,
				fireCallback: false
			});
		});
	}
	buildBaseConfig() {
		const techOptions = this.tech.options_;
		const hlsjsConfigRef = this.player.srOptions_?.hlsjsConfig || techOptions.hlsjsConfig;
		this.hlsjsConfig = hlsjsConfigRef ? { ...hlsjsConfigRef } : {};
	}
	getSeparateAudioTrack() {
		if (this.metadata.audioTracks.length === 0) return void 0;
		return this.metadata.audioTracks[0].url;
	}
};
//#endregion
//#region src/shared/p2p-media-loader/p2p-media-loader-plugin.ts
var debugLogger$6 = (0, import_browser.default)("peertube:player:p2p-media-loader");
var Plugin$7 = import_core.default.getPlugin("plugin");
var P2pMediaLoaderPlugin = class extends Plugin$7 {
	constructor(player, options) {
		super(player);
		this.options = options;
		this.statsP2PBytes = {
			pendingDownload: [],
			pendingUpload: [],
			peersWithWebSeed: 0,
			peersP2POnly: 0,
			totalDownload: 0,
			totalUpload: 0
		};
		this.statsHTTPBytes = {
			pendingDownload: [],
			totalDownload: 0
		};
		this.liveEnded = false;
		if (!import_core.default.Html5Hlsjs) {
			if (player.canPlayType("application/vnd.apple.mpegurl")) {
				this.fallbackToBuiltInIOS();
				return;
			}
			const message = "HLS.js does not seem to be supported. Cannot fallback to built-in HLS";
			logger$1.warn(message);
			const error = {
				code: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
				message,
				MEDIA_ERR_ABORTED: MediaError.MEDIA_ERR_ABORTED,
				MEDIA_ERR_DECODE: MediaError.MEDIA_ERR_DECODE,
				MEDIA_ERR_NETWORK: MediaError.MEDIA_ERR_NETWORK,
				MEDIA_ERR_SRC_NOT_SUPPORTED: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
			};
			player.ready(() => player.error(error));
			return;
		}
		{
			const onHLSJSInitialized = (_, { hlsjs }) => {
				this.hlsjs?.p2pEngine?.destroy();
				clearInterval(this.networkInfoInterval);
				this.hlsjs = hlsjs;
				debugLogger$6("hls.js initialized, initializing p2p-media-loader plugin", { hlsjs });
				player.ready(() => this.initializePlugin());
			};
			player.on("hlsjs-initialized", onHLSJSInitialized);
			const onHLSJSLiveEnded = () => {
				debugLogger$6("hls.js says the live is ended");
				this.liveEnded = true;
			};
			player.on("hlsjs-live-ended", onHLSJSLiveEnded);
			this.on("dispose", () => {
				this.player.off("hlsjs-initialized", onHLSJSInitialized);
				this.player.off("hlsjs-live-ended", onHLSJSLiveEnded);
			});
		}
		player.src({
			type: options.type,
			src: options.src
		});
	}
	dispose() {
		this.hlsjs?.p2pEngine?.destroy();
		this.hlsjs?.destroy();
		this.options.segmentValidator?.destroy();
		clearInterval(this.networkInfoInterval);
		super.dispose();
	}
	getCurrentLevel() {
		if (!this.hlsjs) return void 0;
		return this.hlsjs.levels[this.hlsjs.currentLevel];
	}
	getLiveLatency() {
		return Math.round(this.hlsjs.latency);
	}
	getLiveLatencyFromEdge() {
		return Math.round(this.hlsjs.latency - this.hlsjs.targetLatency);
	}
	getHLSJS() {
		return this.hlsjs;
	}
	initializePlugin() {
		this.hlsjs.p2pEngine.addEventListener("onSegmentError", (details) => {
			if (navigator.onLine === false || this.liveEnded || details.downloadSource !== "http") return;
			const segment = details.segment;
			logger$1.clientError(`Segment ${segment.runtimeId} error.`, details);
			if (this.options.redundancyUrlManager) this.options.redundancyUrlManager.onSegmentError(segment.url);
		});
		this.hlsjs.p2pEngine.addEventListener("onSegmentLoaded", (details) => {
			if (details.downloadSource !== "http") return;
			if (this.options.redundancyUrlManager) this.options.redundancyUrlManager.onSegmentSuccess(details.segmentUrl);
		});
		const redundancyUrlsCount = this.options.redundancyUrlManager ? this.options.redundancyUrlManager.countBaseUrls() : 0;
		this.totalHTTPPeers = 1 + redundancyUrlsCount;
		this.statsP2PBytes.peersWithWebSeed = this.totalHTTPPeers;
		this.runStats();
		let initResolutionChange = true;
		this.hlsjs.on(Hls.Events.LEVEL_SWITCHED, () => {
			const level = this.getCurrentLevel();
			const resolution = Math.min(level?.height || 0, level?.width || 0);
			this.player.trigger("resolution-change", {
				resolution,
				initResolutionChange
			});
			initResolutionChange = false;
		});
		this.hlsjs.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
			if (Array.isArray(data.levels) && data.levels.length >= 1) {
				const level = data.levels[0];
				this.player.trigger("video-ratio-changed", { ratio: level.width / level.height });
			}
		});
		this.hlsjs.on(Hls.Events.ERROR, (_event, errorData) => {
			if (errorData.type !== Hls.ErrorTypes.MEDIA_ERROR) return;
			if (errorData.details === Hls.ErrorDetails.BUFFER_STALLED_ERROR) this.player.trigger("buffer-stalled");
		});
	}
	runStats() {
		this.connectedPeers = /* @__PURE__ */ new Set();
		if (this.hlsjs.p2pEngine.getConfig().core.mainStream.isP2PDisabled) this.hlsjs.on(Hls.Events.FRAG_LOADED, (e, data) => {
			const bytes = data.frag.stats.loaded;
			this.statsHTTPBytes.pendingDownload.push(bytes);
			this.statsHTTPBytes.totalDownload += bytes;
		});
		this.hlsjs.p2pEngine.addEventListener("onChunkDownloaded", (bytes, method) => {
			const elem = method === "p2p" ? this.statsP2PBytes : this.statsHTTPBytes;
			elem.pendingDownload.push(bytes);
			elem.totalDownload += bytes;
		});
		this.hlsjs.p2pEngine.addEventListener("onChunkUploaded", (bytes) => {
			this.statsP2PBytes.pendingUpload.push(bytes);
			this.statsP2PBytes.totalUpload += bytes;
		});
		this.hlsjs.p2pEngine.addEventListener("onPeerConnect", (peer) => {
			if (peer.streamType !== "main") return;
			this.connectedPeers.add(peer.peerId);
			this.statsP2PBytes.peersP2POnly = this.connectedPeers.size;
			this.statsP2PBytes.peersWithWebSeed = this.totalHTTPPeers + this.statsP2PBytes.peersP2POnly;
		});
		this.hlsjs.p2pEngine.addEventListener("onPeerClose", (peer) => {
			if (peer.streamType !== "main") return;
			this.connectedPeers.delete(peer.peerId);
			this.statsP2PBytes.peersP2POnly = this.connectedPeers.size;
			this.statsP2PBytes.peersWithWebSeed = this.totalHTTPPeers + this.statsP2PBytes.peersP2POnly;
		});
		this.networkInfoInterval = setInterval(() => {
			const player = this.player;
			const hlsjs = this.hlsjs;
			if (!player || !hlsjs) return;
			const p2pDownloadSpeed = this.arraySum(this.statsP2PBytes.pendingDownload);
			const p2pUploadSpeed = this.arraySum(this.statsP2PBytes.pendingUpload);
			const httpDownloadSpeed = this.arraySum(this.statsHTTPBytes.pendingDownload);
			this.statsP2PBytes.pendingDownload = [];
			this.statsP2PBytes.pendingUpload = [];
			this.statsHTTPBytes.pendingDownload = [];
			return player.trigger("network-info", {
				source: "p2p-media-loader",
				bandwidthEstimate: hlsjs.bandwidthEstimate / 8,
				http: {
					downloadSpeed: httpDownloadSpeed,
					downloaded: this.statsHTTPBytes.totalDownload
				},
				p2p: this.options.p2pEnabled ? {
					downloadSpeed: p2pDownloadSpeed,
					uploadSpeed: p2pUploadSpeed,
					peersWithWebSeed: this.statsP2PBytes.peersWithWebSeed,
					peersP2POnly: this.statsP2PBytes.peersP2POnly,
					downloaded: this.statsP2PBytes.totalDownload,
					uploaded: this.statsP2PBytes.totalUpload
				} : void 0
			});
		}, 1e3);
	}
	arraySum(data) {
		return data.reduce((a, b) => a + b, 0);
	}
	fallbackToBuiltInIOS() {
		logger$1.info("HLS.js does not seem to be supported. Fallback to built-in HLS.");
		this.player.src({
			type: this.options.type,
			src: addQueryParams(this.options.src, {
				videoFileToken: this.options.videoFileToken(),
				reinjectVideoFileToken: "true"
			})
		});
		this.getResolutionButton().hide();
	}
	getResolutionButton() {
		return this.player.controlBar.getDescendant(["settingsButton"]).menu.getChild("resolutionMenuButton");
	}
};
import_core.default.registerPlugin("p2pMediaLoader", P2pMediaLoaderPlugin);
//#endregion
//#region ../../../../node_modules/.pnpm/ua-parser-js@2.0.9/node_modules/ua-parser-js/src/main/ua-parser.mjs
var LIBVERSION = "2.0.9", UA_MAX_LENGTH = 500, USER_AGENT = "user-agent", EMPTY = "", UNKNOWN = "?", TYPEOF = {
	FUNCTION: "function",
	OBJECT: "object",
	STRING: "string",
	UNDEFINED: "undefined"
}, BROWSER = "browser", CPU = "cpu", DEVICE = "device", ENGINE = "engine", OS = "os", RESULT = "result", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", MAJOR = "major", MODEL = "model", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", XR = "xr", EMBEDDED = "embedded", FETCHER = "fetcher", INAPP = "inapp", BRANDS = "brands", FORMFACTORS = "formFactors", FULLVERLIST = "fullVersionList", PLATFORM = "platform", PLATFORMVER = "platformVersion", BITNESS = "bitness", CH = "sec-ch-ua", CH_FULL_VER_LIST = CH + "-full-version-list", CH_ARCH = CH + "-arch", CH_BITNESS = CH + "-" + BITNESS, CH_FORM_FACTORS = CH + "-form-factors", CH_MOBILE = CH + "-" + MOBILE, CH_MODEL = CH + "-" + MODEL, CH_PLATFORM = CH + "-" + PLATFORM, CH_PLATFORM_VER = CH_PLATFORM + "-version", CH_ALL_VALUES = [
	BRANDS,
	FULLVERLIST,
	MOBILE,
	MODEL,
	PLATFORM,
	PLATFORMVER,
	ARCHITECTURE,
	FORMFACTORS,
	BITNESS
], AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", GOOGLE = "Google", HUAWEI = "Huawei", LENOVO = "Lenovo", HONOR = "Honor", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", CHROME = "Chrome", CHROMIUM = "Chromium", CHROMECAST = "Chromecast", EDGE = "Edge", FIREFOX = "Firefox", OPERA = "Opera", FACEBOOK = "Facebook", SOGOU = "Sogou", PREFIX_MOBILE = "Mobile ", SUFFIX_BROWSER = " Browser", WINDOWS = "Windows";
var NAVIGATOR = typeof window !== TYPEOF.UNDEFINED && window.navigator ? window.navigator : void 0, NAVIGATOR_UADATA = NAVIGATOR && NAVIGATOR.userAgentData ? NAVIGATOR.userAgentData : void 0;
var extend = function(defaultRgx, extensions) {
	var mergedRgx = {};
	var extraRgx = extensions;
	if (!isExtensions(extensions)) {
		extraRgx = {};
		for (var i in extensions) for (var j in extensions[i]) extraRgx[j] = extensions[i][j].concat(extraRgx[j] ? extraRgx[j] : []);
	}
	for (var k in defaultRgx) mergedRgx[k] = extraRgx[k] && extraRgx[k].length % 2 === 0 ? extraRgx[k].concat(defaultRgx[k]) : defaultRgx[k];
	return mergedRgx;
}, enumerize = function(arr) {
	var enums = {};
	for (var i = 0; i < arr.length; i++) enums[arr[i].toUpperCase()] = arr[i];
	return enums;
}, has = function(str1, str2) {
	if (typeof str1 === TYPEOF.OBJECT && str1.length > 0) {
		for (var i in str1) if (lowerize(str2) == lowerize(str1[i])) return true;
		return false;
	}
	return isString(str1) ? lowerize(str2) == lowerize(str1) : false;
}, isExtensions = function(obj, deep) {
	for (var prop in obj) return /^(browser|cpu|device|engine|os)$/.test(prop) || (deep ? isExtensions(obj[prop]) : false);
}, isString = function(val) {
	return typeof val === TYPEOF.STRING;
}, itemListToArray = function(header) {
	if (!header) return void 0;
	var arr = [];
	var tokens = strip(/\\?\"/g, header).split(",");
	for (var i = 0; i < tokens.length; i++) if (tokens[i].indexOf(";") > -1) {
		var token = trim(tokens[i]).split(";v=");
		arr[i] = {
			brand: token[0],
			version: token[1]
		};
	} else arr[i] = trim(tokens[i]);
	return arr;
}, lowerize = function(str) {
	return isString(str) ? str.toLowerCase() : str;
}, majorize = function(version) {
	return isString(version) ? strip(/[^\d\.]/g, version).split(".")[0] : void 0;
}, setProps = function(arr) {
	for (var i in arr) {
		if (!arr.hasOwnProperty(i)) continue;
		var propName = arr[i];
		if (typeof propName == TYPEOF.OBJECT && propName.length == 2) this[propName[0]] = propName[1];
		else this[propName] = void 0;
	}
	return this;
}, strip = function(pattern, str) {
	return isString(str) ? str.replace(pattern, EMPTY) : str;
}, stripQuotes = function(str) {
	return strip(/\\?\"/g, str);
}, trim = function(str, len) {
	str = strip(/^\s\s*/, String(str));
	return typeof len === TYPEOF.UNDEFINED ? str : str.substring(0, len);
};
var rgxMapper = function(ua, arrays) {
	if (!ua || !arrays) return;
	var i = 0, j, k, p, q, matches, match;
	while (i < arrays.length && !matches) {
		var regex = arrays[i], props = arrays[i + 1];
		j = k = 0;
		while (j < regex.length && !matches) {
			if (!regex[j]) break;
			matches = regex[j++].exec(ua);
			if (!!matches) for (p = 0; p < props.length; p++) {
				match = matches[++k];
				q = props[p];
				if (typeof q === TYPEOF.OBJECT && q.length > 0) {
					if (q.length === 2) if (typeof q[1] == TYPEOF.FUNCTION) this[q[0]] = q[1].call(this, match);
					else this[q[0]] = q[1];
					else if (q.length >= 3) {
						if (typeof q[1] === TYPEOF.FUNCTION && !(q[1].exec && q[1].test)) if (q.length > 3) this[q[0]] = match ? q[1].apply(this, q.slice(2)) : void 0;
						else this[q[0]] = match ? q[1].call(this, match, q[2]) : void 0;
						else if (q.length == 3) this[q[0]] = match ? match.replace(q[1], q[2]) : void 0;
						else if (q.length == 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : void 0;
						else if (q.length > 4) this[q[0]] = match ? q[3].apply(this, [match.replace(q[1], q[2])].concat(q.slice(4))) : void 0;
					}
				} else this[q] = match ? match : void 0;
			}
		}
		i += 2;
	}
}, strMapper = function(str, map) {
	for (var i in map) if (typeof map[i] === TYPEOF.OBJECT && map[i].length > 0) {
		for (var j = 0; j < map[i].length; j++) if (has(map[i][j], str)) return i === UNKNOWN ? void 0 : i;
	} else if (has(map[i], str)) return i === UNKNOWN ? void 0 : i;
	return map.hasOwnProperty("*") ? map["*"] : str;
};
var windowsVersionMap = {
	"ME": "4.90",
	"NT 3.51": "3.51",
	"NT 4.0": "4.0",
	"2000": ["5.0", "5.01"],
	"XP": ["5.1", "5.2"],
	"Vista": "6.0",
	"7": "6.1",
	"8": "6.2",
	"8.1": "6.3",
	"10": ["6.4", "10.0"],
	"NT": ""
}, formFactorsMap = {
	"embedded": "Automotive",
	"mobile": "Mobile",
	"tablet": ["Tablet", "EInk"],
	"smarttv": "TV",
	"wearable": "Watch",
	"xr": ["VR", "XR"],
	"?": ["Desktop", "Unknown"],
	"*": void 0
}, browserHintsMap = {
	"Chrome": "Google Chrome",
	"Edge": "Microsoft Edge",
	"Edge WebView2": "Microsoft Edge WebView2",
	"Chrome WebView": "Android WebView",
	"Chrome Headless": "HeadlessChrome",
	"Huawei Browser": "HuaweiBrowser",
	"MIUI Browser": "Miui Browser",
	"Opera Mobi": "OperaMobile",
	"Yandex": "YaBrowser"
};
var defaultRegexes = {
	browser: [
		[/\b(?:crmo|crios)\/([\w\.]+)/i],
		[VERSION, [NAME, PREFIX_MOBILE + "Chrome"]],
		[/webview.+edge\/([\w\.]+)/i],
		[VERSION, [NAME, EDGE + " WebView"]],
		[/edg(?:e|ios|a)?\/([\w\.]+)/i],
		[VERSION, [NAME, "Edge"]],
		[
			/(opera mini)\/([-\w\.]+)/i,
			/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
			/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
		],
		[NAME, VERSION],
		[/opios[\/ ]+([\w\.]+)/i],
		[VERSION, [NAME, OPERA + " Mini"]],
		[/\bop(?:rg)?x\/([\w\.]+)/i],
		[VERSION, [NAME, OPERA + " GX"]],
		[/\bopr\/([\w\.]+)/i],
		[VERSION, [NAME, OPERA]],
		[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],
		[VERSION, [NAME, "Baidu"]],
		[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],
		[VERSION, [NAME, "Maxthon"]],
		[
			/(kindle)\/([\w\.]+)/i,
			/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
			/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
			/(?:ms|\()(ie) ([\w\.]+)/i,
			/(atlas|flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:hi|lg |ovi|qute)browser|palemoon)\/v?([-\w\.]+)/i,
			/(brave)(?: chrome)?\/([\d\.]+)/i,
			/(aloha|heytap|ovi|115|surf|qwant)browser\/([\d\.]+)/i,
			/(qwant)(?:ios|mobile)\/([\d\.]+)/i,
			/(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
		],
		[NAME, VERSION],
		[/quark(?:pc)?\/([-\w\.]+)/i],
		[VERSION, [NAME, "Quark"]],
		[/\bddg\/([\w\.]+)/i],
		[VERSION, [NAME, "DuckDuckGo"]],
		[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],
		[VERSION, [NAME, "UCBrowser"]],
		[
			/microm.+\bqbcore\/([\w\.]+)/i,
			/\bqbcore\/([\w\.]+).+microm/i,
			/micromessenger\/([\w\.]+)/i
		],
		[VERSION, [NAME, "WeChat"]],
		[/konqueror\/([\w\.]+)/i],
		[VERSION, [NAME, "Konqueror"]],
		[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],
		[VERSION, [NAME, "IE"]],
		[/ya(?:search)?browser\/([\w\.]+)/i],
		[VERSION, [NAME, "Yandex"]],
		[/slbrowser\/([\w\.]+)/i],
		[VERSION, [NAME, "Smart " + LENOVO + SUFFIX_BROWSER]],
		[/(av(?:ast|g|ira))\/([\w\.]+)/i],
		[[
			NAME,
			/(.+)/,
			"$1 Secure" + SUFFIX_BROWSER
		], VERSION],
		[/norton\/([\w\.]+)/i],
		[VERSION, [NAME, "Norton Private" + SUFFIX_BROWSER]],
		[/\bfocus\/([\w\.]+)/i],
		[VERSION, [NAME, FIREFOX + " Focus"]],
		[/ mms\/([\w\.]+)$/i],
		[VERSION, [NAME, OPERA + " Neon"]],
		[/ opt\/([\w\.]+)$/i],
		[VERSION, [NAME, OPERA + " Touch"]],
		[/coc_coc\w+\/([\w\.]+)/i],
		[VERSION, [NAME, "Coc Coc"]],
		[/dolfin\/([\w\.]+)/i],
		[VERSION, [NAME, "Dolphin"]],
		[/coast\/([\w\.]+)/i],
		[VERSION, [NAME, OPERA + " Coast"]],
		[/miuibrowser\/([\w\.]+)/i],
		[VERSION, [NAME, "MIUI" + SUFFIX_BROWSER]],
		[/fxios\/([\w\.-]+)/i],
		[VERSION, [NAME, PREFIX_MOBILE + FIREFOX]],
		[/\bqihoobrowser\/?([\w\.]*)/i],
		[VERSION, [NAME, "360"]],
		[/\b(qq)\/([\w\.]+)/i],
		[[
			NAME,
			/(.+)/,
			"$1Browser"
		], VERSION],
		[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],
		[[
			NAME,
			/(.+)/,
			"$1" + SUFFIX_BROWSER
		], VERSION],
		[/samsungbrowser\/([\w\.]+)/i],
		[VERSION, [NAME, SAMSUNG + " Internet"]],
		[/metasr[\/ ]?([\d\.]+)/i],
		[VERSION, [NAME, SOGOU + " Explorer"]],
		[/(sogou)mo\w+\/([\d\.]+)/i],
		[[NAME, SOGOU + " Mobile"], VERSION],
		[
			/(electron)\/([\w\.]+) safari/i,
			/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
			/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
		],
		[NAME, VERSION],
		[/(lbbrowser|luakit|rekonq|steam(?= (clie|tenf|gameo)))/i],
		[NAME],
		[/ome\/([\w\.]+).+(iron(?= saf)|360(?=[es]e$))/i],
		[VERSION, NAME],
		[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],
		[
			[NAME, FACEBOOK],
			VERSION,
			[TYPE, INAPP]
		],
		[
			/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
			/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
			/(daum)apps[\/ ]([\w\.]+)/i,
			/safari (line)\/([\w\.]+)/i,
			/\b(line)\/([\w\.]+)\/iab/i,
			/(alipay)client\/([\w\.]+)/i,
			/(twitter)(?:and| f.+e\/([\w\.]+))/i,
			/(bing)(?:web|sapphire)\/([\w\.]+)/i,
			/(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
		],
		[
			NAME,
			VERSION,
			[TYPE, INAPP]
		],
		[/\bgsa\/([\w\.]+) .*safari\//i],
		[
			VERSION,
			[NAME, "GSA"],
			[TYPE, INAPP]
		],
		[/(?:musical_ly|trill)(?:.+app_?version\/|_)([\w\.]+)/i],
		[
			VERSION,
			[NAME, "TikTok"],
			[TYPE, INAPP]
		],
		[/\[(linkedin)app\]/i],
		[NAME, [TYPE, INAPP]],
		[/(zalo(?:app)?)[\/\sa-z]*([\w\.-]+)/i],
		[
			[
				NAME,
				/(.+)/,
				"Zalo"
			],
			VERSION,
			[TYPE, INAPP]
		],
		[/(chromium)[\/ ]([-\w\.]+)/i],
		[NAME, VERSION],
		[/ome-(lighthouse)$/i],
		[NAME, [TYPE, FETCHER]],
		[/headlesschrome(?:\/([\w\.]+)| )/i],
		[VERSION, [NAME, CHROME + " Headless"]],
		[/wv\).+chrome\/([\w\.]+).+edgw\//i],
		[VERSION, [NAME, EDGE + " WebView2"]],
		[/ wv\).+(chrome)\/([\w\.]+)/i],
		[[NAME, CHROME + " WebView"], VERSION],
		[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],
		[VERSION, [NAME, "Android" + SUFFIX_BROWSER]],
		[/chrome\/([\w\.]+) mobile/i],
		[VERSION, [NAME, PREFIX_MOBILE + "Chrome"]],
		[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],
		[NAME, VERSION],
		[/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i],
		[VERSION, [NAME, PREFIX_MOBILE + "Safari"]],
		[/iphone .*mobile(?:\/\w+ | ?)safari/i],
		[[NAME, PREFIX_MOBILE + "Safari"]],
		[/version\/([\w\.\,]+) .*(safari)/i],
		[VERSION, NAME],
		[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],
		[NAME, [VERSION, "1"]],
		[/(webkit|khtml)\/([\w\.]+)/i],
		[NAME, VERSION],
		[/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i],
		[[NAME, PREFIX_MOBILE + FIREFOX], VERSION],
		[/(navigator|netscape\d?)\/([-\w\.]+)/i],
		[[NAME, "Netscape"], VERSION],
		[/(wolvic|librewolf)\/([\w\.]+)/i],
		[NAME, VERSION],
		[/mobile vr; rv:([\w\.]+)\).+firefox/i],
		[VERSION, [NAME, FIREFOX + " Reality"]],
		[
			/ekiohf.+(flow)\/([\w\.]+)/i,
			/(swiftfox)/i,
			/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
			/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|basilisk|waterfox)\/([-\w\.]+)$/i,
			/(firefox)\/([\w\.]+)/i,
			/(mozilla)\/([\w\.]+(?= .+rv\:.+gecko\/\d+)|[0-4][\w\.]+(?!.+compatible))/i,
			/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
			/\b(links) \(([\w\.]+)/i
		],
		[NAME, [
			VERSION,
			/_/g,
			"."
		]],
		[/(cobalt)\/([\w\.]+)/i],
		[NAME, [
			VERSION,
			/[^\d\.]+./,
			EMPTY
		]]
	],
	cpu: [
		[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],
		[[ARCHITECTURE, "amd64"]],
		[/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i],
		[[ARCHITECTURE, "ia32"]],
		[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],
		[[ARCHITECTURE, "arm64"]],
		[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],
		[[ARCHITECTURE, "armhf"]],
		[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],
		[[ARCHITECTURE, "arm"]],
		[/ sun4\w[;\)]/i],
		[[ARCHITECTURE, "sparc"]],
		[
			/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i,
			/((ppc|powerpc)(64)?)( mac|;|\))/i,
			/(?:osf1|[freopnt]{3,4}bsd) (alpha)/i
		],
		[[
			ARCHITECTURE,
			/ower/,
			EMPTY,
			lowerize
		]],
		[/mc680.0/i],
		[[ARCHITECTURE, "68k"]],
		[/winnt.+\[axp/i],
		[[ARCHITECTURE, "alpha"]]
	],
	device: [
		[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],
		[
			MODEL,
			[VENDOR, SAMSUNG],
			[TYPE, TABLET]
		],
		[
			/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
			/samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
			/sec-(sgh\w+)/i
		],
		[
			MODEL,
			[VENDOR, SAMSUNG],
			[TYPE, MOBILE]
		],
		[/(?:\/|\()(ip(?:hone|od)[\w, ]*)[\/\);]/i],
		[
			MODEL,
			[VENDOR, APPLE],
			[TYPE, MOBILE]
		],
		[/\b(?:ios|apple\w+)\/.+[\(\/](ipad)/i, /\b(ipad)[\d,]*[;\] ].+(mac |i(pad)?)os/i],
		[
			MODEL,
			[VENDOR, APPLE],
			[TYPE, TABLET]
		],
		[/(macintosh);/i],
		[MODEL, [VENDOR, APPLE]],
		[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],
		[
			MODEL,
			[VENDOR, SHARP],
			[TYPE, MOBILE]
		],
		[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],
		[
			MODEL,
			[VENDOR, HONOR],
			[TYPE, TABLET]
		],
		[/honor([-\w ]+)[;\)]/i],
		[
			MODEL,
			[VENDOR, HONOR],
			[TYPE, MOBILE]
		],
		[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],
		[
			MODEL,
			[VENDOR, HUAWEI],
			[TYPE, TABLET]
		],
		[/(?:huawei) ?([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][\dc][adnt]?)\b(?!.+d\/s)/i],
		[
			MODEL,
			[VENDOR, HUAWEI],
			[TYPE, MOBILE]
		],
		[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b(?:xiao)?((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],
		[
			[
				MODEL,
				/_/g,
				" "
			],
			[VENDOR, XIAOMI],
			[TYPE, TABLET]
		],
		[
			/\b; (\w+) build\/hm\1/i,
			/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
			/oid[^\)]+; (redmi[\-_ ]?(?:note|k)?[\w_ ]+|m?[12]\d[01]\d\w{3,6}|poco[\w ]+|(shark )?\w{3}-[ah]0|qin ?[1-3](s\+|ultra| pro)?)( bui|; wv|\))/i,
			/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note|max|cc)?[_ ]?(?:\d{0,2}\w?)[_ ]?(?:plus|se|lite|pro)?( 5g|lte)?)(?: bui|\))/i,
			/ ([\w ]+) miui\/v?\d/i
		],
		[
			[
				MODEL,
				/_/g,
				" "
			],
			[VENDOR, XIAOMI],
			[TYPE, MOBILE]
		],
		[/droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-l]\w[1m]10)\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],
		[
			MODEL,
			[VENDOR, ONEPLUS],
			[TYPE, MOBILE]
		],
		[/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],
		[
			MODEL,
			[VENDOR, OPPO],
			[TYPE, MOBILE]
		],
		[/\b(opd2(\d{3}a?))(?: bui|\))/i],
		[
			MODEL,
			[
				VENDOR,
				strMapper,
				{
					"OnePlus": [
						"203",
						"304",
						"403",
						"404",
						"413",
						"415"
					],
					"*": OPPO
				}
			],
			[TYPE, TABLET]
		],
		[/(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i],
		[
			MODEL,
			[VENDOR, "BLU"],
			[TYPE, MOBILE]
		],
		[/; vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i],
		[
			MODEL,
			[VENDOR, "Vivo"],
			[TYPE, MOBILE]
		],
		[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],
		[
			MODEL,
			[VENDOR, "Realme"],
			[TYPE, MOBILE]
		],
		[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],
		[
			MODEL,
			[VENDOR, LENOVO],
			[TYPE, TABLET]
		],
		[/lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i],
		[
			MODEL,
			[VENDOR, LENOVO],
			[TYPE, MOBILE]
		],
		[
			/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
			/\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
			/((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
		],
		[
			MODEL,
			[VENDOR, MOTOROLA],
			[TYPE, MOBILE]
		],
		[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
		[
			MODEL,
			[VENDOR, MOTOROLA],
			[TYPE, TABLET]
		],
		[/\b(?:lg)?([vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],
		[
			MODEL,
			[VENDOR, LG],
			[TYPE, TABLET]
		],
		[
			/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
			/\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
			/\blg-?([\d\w]+) bui/i
		],
		[
			MODEL,
			[VENDOR, LG],
			[TYPE, MOBILE]
		],
		[/(nokia) (t[12][01])/i],
		[
			VENDOR,
			MODEL,
			[TYPE, TABLET]
		],
		[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*?))( bui|\)|;|\/)/i],
		[
			[
				MODEL,
				/_/g,
				" "
			],
			[TYPE, MOBILE],
			[VENDOR, "Nokia"]
		],
		[/(pixel (c|tablet))\b/i],
		[
			MODEL,
			[VENDOR, GOOGLE],
			[TYPE, TABLET]
		],
		[/droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i],
		[
			MODEL,
			[VENDOR, GOOGLE],
			[TYPE, MOBILE]
		],
		[/(google) (pixelbook( go)?)/i],
		[VENDOR, MODEL],
		[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
		[
			MODEL,
			[VENDOR, SONY],
			[TYPE, MOBILE]
		],
		[/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
		[
			[MODEL, "Xperia Tablet"],
			[VENDOR, SONY],
			[TYPE, TABLET]
		],
		[
			/(alexa)webm/i,
			/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
			/(kf[a-z]+)( bui|\)).+silk\//i
		],
		[
			MODEL,
			[VENDOR, AMAZON],
			[TYPE, TABLET]
		],
		[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],
		[
			[
				MODEL,
				/(.+)/g,
				"Fire Phone $1"
			],
			[VENDOR, AMAZON],
			[TYPE, MOBILE]
		],
		[/(playbook);[-\w\),; ]+(rim)/i],
		[
			MODEL,
			VENDOR,
			[TYPE, TABLET]
		],
		[/\b((?:bb[a-f]|st[hv])100-\d)/i, /(?:blackberry|\(bb10;) (\w+)/i],
		[
			MODEL,
			[VENDOR, BLACKBERRY],
			[TYPE, MOBILE]
		],
		[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],
		[
			MODEL,
			[VENDOR, ASUS],
			[TYPE, TABLET]
		],
		[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
		[
			MODEL,
			[VENDOR, ASUS],
			[TYPE, MOBILE]
		],
		[/(nexus 9)/i],
		[
			MODEL,
			[VENDOR, "HTC"],
			[TYPE, TABLET]
		],
		[
			/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
			/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
			/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
		],
		[
			VENDOR,
			[
				MODEL,
				/_/g,
				" "
			],
			[TYPE, MOBILE]
		],
		[/tcl (xess p17aa)/i, /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i],
		[
			MODEL,
			[VENDOR, "TCL"],
			[TYPE, TABLET]
		],
		[/droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i],
		[
			MODEL,
			[VENDOR, "TCL"],
			[TYPE, MOBILE]
		],
		[/(itel) ((\w+))/i],
		[
			[VENDOR, lowerize],
			MODEL,
			[
				TYPE,
				strMapper,
				{
					"tablet": ["p10001l", "w7001"],
					"*": "mobile"
				}
			]
		],
		[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],
		[
			MODEL,
			[VENDOR, "Acer"],
			[TYPE, TABLET]
		],
		[/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i],
		[
			MODEL,
			[VENDOR, "Meizu"],
			[TYPE, MOBILE]
		],
		[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],
		[
			MODEL,
			[VENDOR, "Ulefone"],
			[TYPE, MOBILE]
		],
		[/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i],
		[
			MODEL,
			[VENDOR, "Energizer"],
			[TYPE, MOBILE]
		],
		[/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],
		[
			MODEL,
			[VENDOR, "Cat"],
			[TYPE, MOBILE]
		],
		[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],
		[
			MODEL,
			[VENDOR, "Smartfren"],
			[TYPE, MOBILE]
		],
		[/droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i],
		[
			MODEL,
			[VENDOR, "Nothing"],
			[TYPE, MOBILE]
		],
		[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i, /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],
		[
			MODEL,
			[VENDOR, "Archos"],
			[TYPE, TABLET]
		],
		[/archos ([\w ]+)( b|\))/i, /; (ac[3-6]\d\w{2,8})( b|\))/i],
		[
			MODEL,
			[VENDOR, "Archos"],
			[TYPE, MOBILE]
		],
		[/; (n159v)/i],
		[
			MODEL,
			[VENDOR, "HMD"],
			[TYPE, MOBILE]
		],
		[/(imo) (tab \w+)/i, /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i],
		[
			VENDOR,
			MODEL,
			[TYPE, TABLET]
		],
		[
			/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
			/; (blu|hmd|imo|infinix|lava|oneplus|tcl|wiko)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
			/(hp) ([\w ]+\w)/i,
			/(microsoft); (lumia[\w ]+)/i,
			/(oppo) ?([\w ]+) bui/i,
			/(hisense) ([ehv][\w ]+)\)/i,
			/droid[^;]+; (philips)[_ ]([sv-x][\d]{3,4}[xz]?)/i
		],
		[
			VENDOR,
			MODEL,
			[TYPE, MOBILE]
		],
		[
			/(kobo)\s(ereader|touch)/i,
			/(hp).+(touchpad(?!.+tablet)|tablet)/i,
			/(kindle)\/([\w\.]+)/i
		],
		[
			VENDOR,
			MODEL,
			[TYPE, TABLET]
		],
		[/(surface duo)/i],
		[
			MODEL,
			[VENDOR, MICROSOFT],
			[TYPE, TABLET]
		],
		[/droid [\d\.]+; (fp\du?)(?: b|\))/i],
		[
			MODEL,
			[VENDOR, "Fairphone"],
			[TYPE, MOBILE]
		],
		[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],
		[
			MODEL,
			[VENDOR, NVIDIA],
			[TYPE, TABLET]
		],
		[/(sprint) (\w+)/i],
		[
			VENDOR,
			MODEL,
			[TYPE, MOBILE]
		],
		[/(kin\.[onetw]{3})/i],
		[
			[
				MODEL,
				/\./g,
				" "
			],
			[VENDOR, MICROSOFT],
			[TYPE, MOBILE]
		],
		[/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],
		[
			MODEL,
			[VENDOR, ZEBRA],
			[TYPE, TABLET]
		],
		[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
		[
			MODEL,
			[VENDOR, ZEBRA],
			[TYPE, MOBILE]
		],
		[/(philips)[\w ]+tv/i, /smart-tv.+(samsung)/i],
		[VENDOR, [TYPE, SMARTTV]],
		[/hbbtv.+maple;(\d+)/i],
		[
			[
				MODEL,
				/^/,
				"SmartTV"
			],
			[VENDOR, SAMSUNG],
			[TYPE, SMARTTV]
		],
		[/(vizio)(?: |.+model\/)(\w+-\w+)/i, /tcast.+(lg)e?. ([-\w]+)/i],
		[
			VENDOR,
			MODEL,
			[TYPE, SMARTTV]
		],
		[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],
		[[VENDOR, LG], [TYPE, SMARTTV]],
		[/(apple) ?tv/i],
		[
			VENDOR,
			[MODEL, APPLE + " TV"],
			[TYPE, SMARTTV]
		],
		[/crkey.*devicetype\/chromecast/i],
		[
			[MODEL, CHROMECAST + " Third Generation"],
			[VENDOR, GOOGLE],
			[TYPE, SMARTTV]
		],
		[/crkey.*devicetype\/([^/]*)/i],
		[
			[
				MODEL,
				/^/,
				"Chromecast "
			],
			[VENDOR, GOOGLE],
			[TYPE, SMARTTV]
		],
		[/fuchsia.*crkey/i],
		[
			[MODEL, CHROMECAST + " Nest Hub"],
			[VENDOR, GOOGLE],
			[TYPE, SMARTTV]
		],
		[/crkey/i],
		[
			[MODEL, CHROMECAST],
			[VENDOR, GOOGLE],
			[TYPE, SMARTTV]
		],
		[/(portaltv)/i],
		[
			MODEL,
			[VENDOR, FACEBOOK],
			[TYPE, SMARTTV]
		],
		[/droid.+aft(\w+)( bui|\))/i],
		[
			MODEL,
			[VENDOR, AMAZON],
			[TYPE, SMARTTV]
		],
		[/(shield \w+ tv)/i],
		[
			MODEL,
			[VENDOR, NVIDIA],
			[TYPE, SMARTTV]
		],
		[/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i],
		[
			MODEL,
			[VENDOR, SHARP],
			[TYPE, SMARTTV]
		],
		[/(bravia[\w ]+)( bui|\))/i],
		[
			MODEL,
			[VENDOR, SONY],
			[TYPE, SMARTTV]
		],
		[/(mi(tv|box)-?\w+) bui/i],
		[
			MODEL,
			[VENDOR, XIAOMI],
			[TYPE, SMARTTV]
		],
		[/Hbbtv.*(technisat) (.*);/i],
		[
			VENDOR,
			MODEL,
			[TYPE, SMARTTV]
		],
		[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],
		[
			[
				VENDOR,
				/.+\/(\w+)/,
				"$1",
				strMapper,
				{ "LG": "lge" }
			],
			[MODEL, trim],
			[TYPE, SMARTTV]
		],
		[/(playstation \w+)/i],
		[
			MODEL,
			[VENDOR, SONY],
			[TYPE, CONSOLE]
		],
		[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],
		[
			MODEL,
			[VENDOR, MICROSOFT],
			[TYPE, CONSOLE]
		],
		[
			/(ouya)/i,
			/(nintendo) (\w+)/i,
			/(retroid) (pocket ([^\)]+))/i,
			/(valve).+(steam deck)/i,
			/droid.+; ((shield|rgcube|gr0006))( bui|\))/i
		],
		[
			[
				VENDOR,
				strMapper,
				{
					"Nvidia": "Shield",
					"Anbernic": "RGCUBE",
					"Logitech": "GR0006"
				}
			],
			MODEL,
			[TYPE, CONSOLE]
		],
		[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],
		[
			MODEL,
			[VENDOR, SAMSUNG],
			[TYPE, WEARABLE]
		],
		[/((pebble))app/i, /(asus|google|lg|oppo|xiaomi) ((pixel |zen)?watch[\w ]*)( bui|\))/i],
		[
			VENDOR,
			MODEL,
			[TYPE, WEARABLE]
		],
		[/(ow(?:19|20)?we?[1-3]{1,3})/i],
		[
			MODEL,
			[VENDOR, OPPO],
			[TYPE, WEARABLE]
		],
		[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],
		[
			MODEL,
			[VENDOR, APPLE],
			[TYPE, WEARABLE]
		],
		[/(opwwe\d{3})/i],
		[
			MODEL,
			[VENDOR, ONEPLUS],
			[TYPE, WEARABLE]
		],
		[/(moto 360)/i],
		[
			MODEL,
			[VENDOR, MOTOROLA],
			[TYPE, WEARABLE]
		],
		[/(smartwatch 3)/i],
		[
			MODEL,
			[VENDOR, SONY],
			[TYPE, WEARABLE]
		],
		[/(g watch r)/i],
		[
			MODEL,
			[VENDOR, LG],
			[TYPE, WEARABLE]
		],
		[/droid.+; (wt63?0{2,3})\)/i],
		[
			MODEL,
			[VENDOR, ZEBRA],
			[TYPE, WEARABLE]
		],
		[/droid.+; (glass) \d/i],
		[
			MODEL,
			[VENDOR, GOOGLE],
			[TYPE, XR]
		],
		[/(pico) ([\w ]+) os\d/i],
		[
			VENDOR,
			MODEL,
			[TYPE, XR]
		],
		[/(quest( \d| pro)?s?).+vr/i],
		[
			MODEL,
			[VENDOR, FACEBOOK],
			[TYPE, XR]
		],
		[/mobile vr; rv.+firefox/i],
		[[TYPE, XR]],
		[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],
		[VENDOR, [TYPE, EMBEDDED]],
		[/(aeobc)\b/i],
		[
			MODEL,
			[VENDOR, AMAZON],
			[TYPE, EMBEDDED]
		],
		[/(homepod).+mac os/i],
		[
			MODEL,
			[VENDOR, APPLE],
			[TYPE, EMBEDDED]
		],
		[/windows iot/i],
		[[TYPE, EMBEDDED]],
		[/droid.+; ([\w- ]+) (4k|android|smart|google)[- ]?tv/i],
		[MODEL, [TYPE, SMARTTV]],
		[/\b((4k|android|smart|opera)[- ]?tv|tv; rv:|large screen[\w ]+safari)\b/i],
		[[TYPE, SMARTTV]],
		[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew|; hmsc).+?(mobile|vr|\d) safari/i],
		[MODEL, [
			TYPE,
			strMapper,
			{
				"mobile": "Mobile",
				"xr": "VR",
				"*": TABLET
			}
		]],
		[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],
		[[TYPE, TABLET]],
		[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],
		[[TYPE, MOBILE]],
		[/droid .+?; ([\w\. -]+)( bui|\))/i],
		[MODEL, [VENDOR, "Generic"]]
	],
	engine: [
		[/windows.+ edge\/([\w\.]+)/i],
		[VERSION, [NAME, EDGE + "HTML"]],
		[/(arkweb)\/([\w\.]+)/i],
		[NAME, VERSION],
		[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],
		[VERSION, [NAME, "Blink"]],
		[
			/(presto)\/([\w\.]+)/i,
			/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
			/ekioh(flow)\/([\w\.]+)/i,
			/(khtml|tasman|links|dillo)[\/ ]\(?([\w\.]+)/i,
			/(icab)[\/ ]([23]\.[\d\.]+)/i,
			/\b(libweb)/i
		],
		[NAME, VERSION],
		[/ladybird\//i],
		[[NAME, "LibWeb"]],
		[/rv\:([\w\.]{1,9})\b.+(gecko)/i],
		[VERSION, NAME]
	],
	os: [
		[/(windows nt) (6\.[23]); arm/i],
		[[
			NAME,
			/N/,
			"R"
		], [
			VERSION,
			strMapper,
			windowsVersionMap
		]],
		[/(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i, /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i],
		[NAME, VERSION],
		[/windows nt ?([\d\.\)]*)(?!.+xbox)/i, /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i],
		[[
			VERSION,
			/(;|\))/g,
			"",
			strMapper,
			windowsVersionMap
		], [NAME, WINDOWS]],
		[/(windows ce)\/?([\d\.]*)/i],
		[NAME, VERSION],
		[
			/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
			/(?:ios;fbsv|ios(?=.+ip(?:ad|hone)|.+apple ?tv)|ip(?:ad|hone)(?: |.+i(?:pad)?)os|apple ?tv.+ios)[\/ ]([\w\.]+)/i,
			/\btvos ?([\w\.]+)/i,
			/cfnetwork\/.+darwin/i
		],
		[[
			VERSION,
			/_/g,
			"."
		], [NAME, "iOS"]],
		[/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i],
		[[NAME, "macOS"], [
			VERSION,
			/_/g,
			"."
		]],
		[/android ([\d\.]+).*crkey/i],
		[VERSION, [NAME, CHROMECAST + " Android"]],
		[/fuchsia.*crkey\/([\d\.]+)/i],
		[VERSION, [NAME, CHROMECAST + " Fuchsia"]],
		[/crkey\/([\d\.]+).*devicetype\/smartspeaker/i],
		[VERSION, [NAME, CHROMECAST + " SmartSpeaker"]],
		[/linux.*crkey\/([\d\.]+)/i],
		[VERSION, [NAME, CHROMECAST + " Linux"]],
		[/crkey\/([\d\.]+)/i],
		[VERSION, [NAME, CHROMECAST]],
		[/droid ([\w\.]+)\b.+(android[- ]x86)/i],
		[VERSION, NAME],
		[/(ubuntu) ([\w\.]+) like android/i],
		[[
			NAME,
			/(.+)/,
			"$1 Touch"
		], VERSION],
		[/(harmonyos)[\/ ]?([\d\.]*)/i, /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i],
		[NAME, VERSION],
		[/\(bb(10);/i],
		[VERSION, [NAME, BLACKBERRY]],
		[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],
		[VERSION, [NAME, "Symbian"]],
		[/mozilla\/[\d\.]+ \((?:mobile[;\w ]*|tablet|tv|[^\)]*(?:viera|lg(?:l25|-d300)|alcatel ?o.+|y300-f1)); rv:([\w\.]+)\).+gecko\//i],
		[VERSION, [NAME, FIREFOX + " OS"]],
		[/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i, /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i],
		[VERSION, [NAME, "webOS"]],
		[/web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i],
		[[
			VERSION,
			strMapper,
			{
				"25": "120",
				"24": "108",
				"23": "94",
				"22": "87",
				"6": "79",
				"5": "68",
				"4": "53",
				"3": "38",
				"2": "538",
				"1": "537",
				"*": "TV"
			}
		], [NAME, "webOS"]],
		[/watch(?: ?os[,\/ ]|\d,\d\/)([\d\.]+)/i],
		[VERSION, [NAME, "watchOS"]],
		[/cros [\w]+(?:\)| ([\w\.]+)\b)/i],
		[VERSION, [NAME, "Chrome OS"]],
		[/kepler ([\w\.]+); (aft|aeo)/i],
		[VERSION, [NAME, "Vega OS"]],
		[
			/(netrange)mmh/i,
			/(nettv)\/(\d+\.[\w\.]+)/i,
			/(nintendo|playstation) (\w+)/i,
			/(xbox); +xbox ([^\);]+)/i,
			/(pico) .+os([\w\.]+)/i,
			/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
			/linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
			/(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
			/([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
			/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
			/\b(aix)[; ]([1-9\.]{0,4})/i,
			/(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
			/(gnu) ?([\w\.]*)/i,
			/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
			/(haiku) ?(r\d)?/i
		],
		[NAME, VERSION],
		[/(sunos) ?([\d\.]*)/i],
		[[NAME, "Solaris"], VERSION],
		[/\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i],
		[NAME, VERSION]
	]
};
var defaultProps = (function() {
	var props = {
		init: {},
		isIgnore: {},
		isIgnoreRgx: {},
		toString: {}
	};
	setProps.call(props.init, [
		[BROWSER, [
			NAME,
			VERSION,
			MAJOR,
			TYPE
		]],
		[CPU, [ARCHITECTURE]],
		[DEVICE, [
			TYPE,
			MODEL,
			VENDOR
		]],
		[ENGINE, [NAME, VERSION]],
		[OS, [NAME, VERSION]]
	]);
	setProps.call(props.isIgnore, [
		[BROWSER, [VERSION, MAJOR]],
		[ENGINE, [VERSION]],
		[OS, [VERSION]]
	]);
	setProps.call(props.isIgnoreRgx, [[BROWSER, / ?browser$/i], [OS, / ?os$/i]]);
	setProps.call(props.toString, [
		[BROWSER, [NAME, VERSION]],
		[CPU, [ARCHITECTURE]],
		[DEVICE, [VENDOR, MODEL]],
		[ENGINE, [NAME, VERSION]],
		[OS, [NAME, VERSION]]
	]);
	return props;
})();
var createIData = function(item, itemType) {
	var init_props = defaultProps.init[itemType], is_ignoreProps = defaultProps.isIgnore[itemType] || 0, is_ignoreRgx = defaultProps.isIgnoreRgx[itemType] || 0, toString_props = defaultProps.toString[itemType] || 0;
	function IData() {
		setProps.call(this, init_props);
	}
	IData.prototype.getItem = function() {
		return item;
	};
	IData.prototype.withClientHints = function() {
		if (!NAVIGATOR_UADATA) return item.parseCH().get();
		return NAVIGATOR_UADATA.getHighEntropyValues(CH_ALL_VALUES).then(function(res) {
			return item.setCH(new UACHData(res, false)).parseCH().get();
		});
	};
	IData.prototype.withFeatureCheck = function() {
		return item.detectFeature().get();
	};
	if (itemType != RESULT) {
		IData.prototype.is = function(strToCheck) {
			var is = false;
			for (var i in this) if (this.hasOwnProperty(i) && !has(is_ignoreProps, i) && lowerize(is_ignoreRgx ? strip(is_ignoreRgx, this[i]) : this[i]) == lowerize(is_ignoreRgx ? strip(is_ignoreRgx, strToCheck) : strToCheck)) {
				is = true;
				if (strToCheck != TYPEOF.UNDEFINED) break;
			} else if (strToCheck == TYPEOF.UNDEFINED && is) {
				is = !is;
				break;
			}
			return is;
		};
		IData.prototype.toString = function() {
			var str = EMPTY;
			for (var i in toString_props) if (typeof this[toString_props[i]] !== TYPEOF.UNDEFINED) str += (str ? " " : EMPTY) + this[toString_props[i]];
			return str || TYPEOF.UNDEFINED;
		};
	}
	IData.prototype.then = function(cb) {
		var that = this;
		var IDataResolve = function() {
			for (var prop in that) if (that.hasOwnProperty(prop)) this[prop] = that[prop];
		};
		IDataResolve.prototype = {
			is: IData.prototype.is,
			toString: IData.prototype.toString,
			withClientHints: IData.prototype.withClientHints,
			withFeatureCheck: IData.prototype.withFeatureCheck
		};
		var resolveData = new IDataResolve();
		cb(resolveData);
		return resolveData;
	};
	return new IData();
};
function UACHData(uach, isHttpUACH) {
	uach = uach || {};
	setProps.call(this, CH_ALL_VALUES);
	if (isHttpUACH) setProps.call(this, [
		[BRANDS, itemListToArray(uach[CH])],
		[FULLVERLIST, itemListToArray(uach[CH_FULL_VER_LIST])],
		[MOBILE, /\?1/.test(uach[CH_MOBILE])],
		[MODEL, stripQuotes(uach[CH_MODEL])],
		[PLATFORM, stripQuotes(uach[CH_PLATFORM])],
		[PLATFORMVER, stripQuotes(uach[CH_PLATFORM_VER])],
		[ARCHITECTURE, stripQuotes(uach[CH_ARCH])],
		[FORMFACTORS, itemListToArray(uach[CH_FORM_FACTORS])],
		[BITNESS, stripQuotes(uach[CH_BITNESS])]
	]);
	else for (var prop in uach) if (this.hasOwnProperty(prop) && typeof uach[prop] !== TYPEOF.UNDEFINED) this[prop] = uach[prop];
}
function UAItem(itemType, ua, rgxMap, uaCH) {
	setProps.call(this, [
		["itemType", itemType],
		["ua", ua],
		["uaCH", uaCH],
		["rgxMap", rgxMap],
		["data", createIData(this, itemType)]
	]);
	return this;
}
UAItem.prototype.get = function(prop) {
	if (!prop) return this.data;
	return this.data.hasOwnProperty(prop) ? this.data[prop] : void 0;
};
UAItem.prototype.set = function(prop, val) {
	this.data[prop] = val;
	return this;
};
UAItem.prototype.setCH = function(ch) {
	this.uaCH = ch;
	return this;
};
UAItem.prototype.detectFeature = function() {
	if (NAVIGATOR && NAVIGATOR.userAgent == this.ua) switch (this.itemType) {
		case BROWSER:
			if (NAVIGATOR.brave && typeof NAVIGATOR.brave.isBrave == TYPEOF.FUNCTION) this.set(NAME, "Brave");
			break;
		case DEVICE:
			if (!this.get(TYPE) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[MOBILE]) this.set(TYPE, MOBILE);
			if (this.get(MODEL) == "Macintosh" && NAVIGATOR && typeof NAVIGATOR.standalone !== TYPEOF.UNDEFINED && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 2) this.set(MODEL, "iPad").set(TYPE, TABLET);
			break;
		case OS:
			if (!this.get(NAME) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[PLATFORM]) this.set(NAME, NAVIGATOR_UADATA[PLATFORM]);
			break;
		case RESULT:
			var data = this.data;
			var detect = function(itemType) {
				return data[itemType].getItem().detectFeature().get();
			};
			this.set(BROWSER, detect(BROWSER)).set(CPU, detect(CPU)).set(DEVICE, detect(DEVICE)).set(ENGINE, detect(ENGINE)).set(OS, detect(OS));
	}
	return this;
};
UAItem.prototype.parseUA = function() {
	if (this.itemType != RESULT) rgxMapper.call(this.data, this.ua, this.rgxMap);
	switch (this.itemType) {
		case BROWSER:
			this.set(MAJOR, majorize(this.get(VERSION)));
			break;
		case OS:
			if (this.get(NAME) == "iOS" && this.get(VERSION) == "18.6") {
				var realVersion = /\) Version\/([\d\.]+)/.exec(this.ua);
				if (realVersion && parseInt(realVersion[1].substring(0, 2), 10) >= 26) this.set(VERSION, realVersion[1]);
			}
			break;
	}
	return this;
};
UAItem.prototype.parseCH = function() {
	var uaCH = this.uaCH, rgxMap = this.rgxMap;
	switch (this.itemType) {
		case BROWSER:
		case ENGINE:
			var brands = uaCH[FULLVERLIST] || uaCH[BRANDS], prevName;
			if (brands) for (var i = 0; i < brands.length; i++) {
				var brandName = brands[i].brand || brands[i], brandVersion = brands[i].version;
				if (this.itemType == BROWSER && !/not.a.brand/i.test(brandName) && (!prevName || /Chrom/.test(prevName) && brandName != CHROMIUM || prevName == EDGE && /WebView2/.test(brandName))) {
					brandName = strMapper(brandName, browserHintsMap);
					prevName = this.get(NAME);
					if (!(prevName && !/Chrom/.test(prevName) && /Chrom/.test(brandName))) this.set(NAME, brandName).set(VERSION, brandVersion).set(MAJOR, majorize(brandVersion));
					prevName = brandName;
				}
				if (this.itemType == ENGINE && brandName == CHROMIUM) this.set(VERSION, brandVersion);
			}
			break;
		case CPU:
			var archName = uaCH[ARCHITECTURE];
			if (archName) {
				if (archName && uaCH[BITNESS] == "64") archName += "64";
				rgxMapper.call(this.data, archName + ";", rgxMap);
			}
			break;
		case DEVICE:
			if (uaCH[MOBILE]) this.set(TYPE, MOBILE);
			if (uaCH[MODEL]) {
				this.set(MODEL, uaCH[MODEL]);
				if (!this.get(TYPE) || !this.get(VENDOR)) {
					var reParse = {};
					rgxMapper.call(reParse, "droid 9; " + uaCH[MODEL] + ")", rgxMap);
					if (!this.get(TYPE) && !!reParse.type) this.set(TYPE, reParse.type);
					if (!this.get(VENDOR) && !!reParse.vendor) this.set(VENDOR, reParse.vendor);
				}
			}
			if (uaCH[FORMFACTORS]) {
				var ff;
				if (typeof uaCH[FORMFACTORS] !== "string") {
					var idx = 0;
					while (!ff && idx < uaCH[FORMFACTORS].length) ff = strMapper(uaCH[FORMFACTORS][idx++], formFactorsMap);
				} else ff = strMapper(uaCH[FORMFACTORS], formFactorsMap);
				this.set(TYPE, ff);
			}
			break;
		case OS:
			var osName = uaCH[PLATFORM];
			if (osName) {
				var osVersion = uaCH[PLATFORMVER];
				if (osName == WINDOWS) osVersion = parseInt(majorize(osVersion), 10) >= 13 ? "11" : "10";
				this.set(NAME, osName).set(VERSION, osVersion);
			}
			if (this.get(NAME) == WINDOWS && uaCH[MODEL] == "Xbox") this.set(NAME, "Xbox").set(VERSION, void 0);
			break;
		case RESULT:
			var data = this.data;
			var parse = function(itemType) {
				return data[itemType].getItem().setCH(uaCH).parseCH().get();
			};
			this.set(BROWSER, parse(BROWSER)).set(CPU, parse(CPU)).set(DEVICE, parse(DEVICE)).set(ENGINE, parse(ENGINE)).set(OS, parse(OS));
	}
	return this;
};
function UAParser(ua, extensions, headers) {
	if (typeof ua === TYPEOF.OBJECT) {
		if (isExtensions(ua, true)) {
			if (typeof extensions === TYPEOF.OBJECT) headers = extensions;
			extensions = ua;
		} else {
			headers = ua;
			extensions = void 0;
		}
		ua = void 0;
	} else if (typeof ua === TYPEOF.STRING && !isExtensions(extensions, true)) {
		headers = extensions;
		extensions = void 0;
	}
	if (headers) if (typeof headers.append === TYPEOF.FUNCTION) {
		var kv = {};
		headers.forEach(function(v, k) {
			kv[String(k).toLowerCase()] = v;
		});
		headers = kv;
	} else {
		var normalized = {};
		for (var header in headers) if (headers.hasOwnProperty(header)) normalized[String(header).toLowerCase()] = headers[header];
		headers = normalized;
	}
	if (!(this instanceof UAParser)) return new UAParser(ua, extensions, headers).getResult();
	var userAgent = typeof ua === TYPEOF.STRING ? ua : headers && headers[USER_AGENT] ? headers[USER_AGENT] : NAVIGATOR && NAVIGATOR.userAgent ? NAVIGATOR.userAgent : EMPTY, httpUACH = new UACHData(headers, true), regexMap = extensions ? extend(defaultRegexes, extensions) : defaultRegexes, createItemFunc = function(itemType) {
		if (itemType == RESULT) return function() {
			return new UAItem(itemType, userAgent, regexMap, httpUACH).set("ua", userAgent).set(BROWSER, this.getBrowser()).set(CPU, this.getCPU()).set(DEVICE, this.getDevice()).set(ENGINE, this.getEngine()).set(OS, this.getOS()).get();
		};
		else return function() {
			return new UAItem(itemType, userAgent, regexMap[itemType], httpUACH).parseUA().get();
		};
	};
	setProps.call(this, [
		["getBrowser", createItemFunc(BROWSER)],
		["getCPU", createItemFunc(CPU)],
		["getDevice", createItemFunc(DEVICE)],
		["getEngine", createItemFunc(ENGINE)],
		["getOS", createItemFunc(OS)],
		["getResult", createItemFunc(RESULT)],
		["getUA", function() {
			return userAgent;
		}],
		["setUA", function(ua) {
			if (isString(ua)) userAgent = trim(ua, UA_MAX_LENGTH);
			return this;
		}]
	]).setUA(userAgent);
	return this;
}
UAParser.VERSION = LIBVERSION;
UAParser.BROWSER = enumerize([
	NAME,
	VERSION,
	MAJOR,
	TYPE
]);
UAParser.CPU = enumerize([ARCHITECTURE]);
UAParser.DEVICE = enumerize([
	MODEL,
	VENDOR,
	TYPE,
	CONSOLE,
	MOBILE,
	SMARTTV,
	TABLET,
	WEARABLE,
	EMBEDDED
]);
UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
//#endregion
//#region src/shared/peertube/peertube-plugin.ts
var debugLogger$5 = (0, import_browser.default)("peertube:player:peertube");
var Plugin$6 = import_core.default.getPlugin("plugin");
var PeerTubePlugin = class extends Plugin$6 {
	constructor(player, options) {
		super(player);
		this.options = options;
		this.setUserAgentInfo();
		this.menuOpened = false;
		this.mouseInControlBar = false;
		this.mouseInSettings = false;
		this.hasInitialSeek = false;
		this.videoViewUrl = options.videoViewUrl;
		this.authorizationHeader = options.authorizationHeader;
		this.hasAutoplay = options.hasAutoplay;
		this.initialInactivityTimeout = this.player.options_.inactivityTimeout;
		this.currentSubtitle = this.options.subtitle() || getStoredLastSubtitle();
		this.initializePlayer();
		this.initOnVideoChange();
		this.player.removeClass("vjs-can-play");
		this.deleteLegacyIndexedDB();
		this.player.on("autoplay-failure", () => {
			debugLogger$5("Autoplay failed");
			this.player.removeClass("vjs-has-autoplay");
			this.player.poster(options.poster());
			if (isIOS() || isSafari()) this.player.hasStarted(false);
		});
		this.player.one("canplay", () => {
			const playerOptions = this.player.options_;
			const volume = getStoredVolume();
			if (volume !== void 0) this.player.volume(volume);
			const muted = playerOptions.muted !== void 0 ? playerOptions.muted : getStoredMute();
			if (muted !== void 0) this.player.muted(muted);
			const savedPlaybackRate = this.options.playbackRate ?? getStoredPlaybackRate();
			if (savedPlaybackRate !== void 0) {
				this.currentPlaybackRate = savedPlaybackRate;
				this.player.playbackRate(this.currentPlaybackRate);
				this.player.defaultPlaybackRate(this.currentPlaybackRate);
			}
			this.player.addClass("vjs-can-play");
		});
		this.player.ready(() => {
			this.player.on("volumechange", () => {
				saveVolumeInStore(this.player.volume());
				saveMuteInStore(this.player.muted());
			});
			this.player.on("ratechange", () => {
				this.currentPlaybackRate = this.player.playbackRate();
				this.player.defaultPlaybackRate(this.currentPlaybackRate);
				if (this.currentPlaybackRate !== this.options.playbackRate) savePlaybackRateInStore(this.currentPlaybackRate);
			});
			this.player.textTracks().addEventListener("change", () => {
				const showing = this.player.textTracks().tracks_.find((t) => {
					return t.kind === "captions" && t.mode === "showing";
				});
				if (!showing) {
					saveLastSubtitle("off");
					this.currentSubtitle = void 0;
					return;
				}
				if (this.currentSubtitle === showing.language) return;
				this.currentSubtitle = showing.language;
				saveLastSubtitle(showing.language);
				savePreferredSubtitle(showing.language);
			});
			this.player.on("video-change", () => {
				this.initOnVideoChange();
				this.hideFatalError();
			});
			this.updatePlayerSizeClasses();
			if (typeof ResizeObserver !== "undefined") {
				this.resizeObserver = new ResizeObserver(() => {
					this.updatePlayerSizeClasses();
				});
				this.resizeObserver.observe(this.player.el());
			}
		});
		this.player.on("resolution-change", (_, { resolution }) => {
			if (this.player.paused()) {
				this.player.on("play", () => this.adaptPosterForAudioOnly(resolution));
				return;
			}
			this.adaptPosterForAudioOnly(resolution);
		});
		this.initOnRatioChange();
	}
	dispose() {
		if (this.videoViewInterval) clearInterval(this.videoViewInterval);
		if (this.resizeObserver) this.resizeObserver.disconnect();
		super.dispose();
	}
	onMenuOpened() {
		this.menuOpened = true;
		this.alterInactivity();
	}
	onMenuClosed() {
		this.menuOpened = false;
		this.alterInactivity();
	}
	displayFatalError(options = {}) {
		const { log = true, error = this.player.error(), isTechnicalError = true } = options;
		if (this.errorModal) return;
		debugLogger$5("Display fatal error");
		this.player.loadingSpinner.hide();
		const buildModal = () => {
			const localize = this.player.localize.bind(this.player);
			const wrapper = document.createElement("div");
			const header = document.createElement("h1");
			header.innerText = localize("Failed to play video");
			wrapper.appendChild(header);
			if (isTechnicalError) {
				const desc = document.createElement("div");
				desc.innerText = localize("The video failed to play due to technical issues.");
				wrapper.appendChild(desc);
			}
			const details = document.createElement("p");
			details.classList.add("error-details");
			details.innerText = error.message;
			wrapper.appendChild(details);
			return wrapper;
		};
		this.errorModal = this.player.createModal(buildModal(), {
			temporary: true,
			uncloseable: true
		});
		this.errorModal.addClass("vjs-custom-error-display");
		this.player.addClass("vjs-error-display-enabled");
		if (log) if (/googlebot/i.test(navigator.userAgent)) console.error(error);
		else logger$1.error("Fatal error in player", error);
	}
	hideFatalError() {
		if (!this.errorModal) return;
		debugLogger$5("Hiding fatal error");
		this.player.removeClass("vjs-error-display-enabled");
		this.player.removeChild(this.errorModal);
		this.errorModal.close();
		this.errorModal = void 0;
		if (this.player.loadingSpinner) this.player.loadingSpinner.show();
	}
	setUserAgentInfo() {
		const userAgent = UAParser(window.navigator.userAgent);
		const defaultDevice = isMobile() ? "mobile" : "desktop";
		this.userAgentInfo = {
			client: userAgent.browser.name,
			os: userAgent.os.name,
			device: userAgent.device.type || defaultDevice
		};
	}
	initializePlayer() {
		if (isMobile()) this.player.addClass("vjs-is-mobile");
		this.patchMenuEscapeKey();
		this.player.ready(() => {
			this.listenControlBarMouse();
		});
		this.listenFullScreenChange();
	}
	initOnVideoChange() {
		if (this.hasAutoplay() !== false) this.player.addClass("vjs-has-autoplay");
		else this.player.removeClass("vjs-has-autoplay");
		if (this.currentPlaybackRate && this.currentPlaybackRate !== 1) {
			debugLogger$5("Setting playback rate to " + this.currentPlaybackRate);
			this.player.playbackRate(this.currentPlaybackRate);
		}
		this.player.ready(() => {
			this.initCaptions();
			this.updateControlBar();
		});
		this.handleStartStopTime();
		this.runUserViewing();
	}
	initOnRatioChange() {
		if (!this.options.autoPlayerRatio) return;
		const defaultRatio = getComputedStyle(this.player.el()).getPropertyValue(this.options.autoPlayerRatio.cssRatioVariable);
		const tryToUpdateRatioFromOptions = () => {
			if (!this.options.videoRatio()) return;
			this.adaptPlayerFromRatio({
				ratio: this.options.videoRatio(),
				defaultRatio
			});
			this.updatePlayerSizeClasses();
		};
		tryToUpdateRatioFromOptions();
		this.player.on("video-change", () => tryToUpdateRatioFromOptions());
		this.player.on("video-ratio-changed", (_event, data) => {
			if (this.options.videoRatio()) return;
			this.adaptPlayerFromRatio({
				ratio: data.ratio,
				defaultRatio
			});
			this.updatePlayerSizeClasses();
		});
	}
	adaptPlayerFromRatio(options) {
		const { ratio, defaultRatio } = options;
		const el = this.player.el();
		const portraitMode = getComputedStyle(el).getPropertyValue(this.options.autoPlayerRatio.cssPlayerPortraitModeVariable) === "1";
		const currentRatio = isNaN(ratio) || !portraitMode && ratio < 1 ? defaultRatio : ratio;
		el.style.setProperty(this.options.autoPlayerRatio.cssRatioVariable, currentRatio + "");
	}
	runUserViewing() {
		const startTime = timeToInt(this.options.startTime());
		let lastCurrentTime = startTime;
		let lastViewEvent;
		let ended = false;
		this.disableUserViewing();
		this.videoViewOnPlayHandler = () => {
			debugLogger$5("Notify user is watching on play: " + startTime);
			this.notifyUserIsWatching(startTime, lastViewEvent);
		};
		this.videoViewOnSeekedHandler = () => {
			if (this.hasInitialSeek) {
				this.hasInitialSeek = false;
				return;
			}
			const currentTime = Math.floor(this.player.currentTime());
			if (currentTime === 0 && this.player.loop()) {
				debugLogger$5("Disabling viewing notification after first video loop.");
				this.disableUserViewing();
				return;
			}
			const diff = currentTime - lastCurrentTime;
			if (diff > 0 && diff < 3) return;
			debugLogger$5("Detected seek event for user watching");
			lastViewEvent = "seek";
		};
		this.videoViewOnEndedHandler = () => {
			ended = true;
			if (this.options.isLive()) return;
			const currentTime = Math.floor(this.player.duration());
			lastCurrentTime = currentTime;
			debugLogger$5("Notify user is watching on end: " + currentTime);
			this.notifyUserIsWatching(currentTime, lastViewEvent);
			lastViewEvent = void 0;
		};
		this.player.one("play", this.videoViewOnPlayHandler);
		this.player.on("seeked", this.videoViewOnSeekedHandler);
		this.player.one("ended", this.videoViewOnEndedHandler);
		this.videoViewInterval = setInterval(() => {
			const player = this.player;
			if (!player || ended) return;
			const currentTime = Math.floor(player.currentTime());
			if (currentTime === lastCurrentTime) return;
			debugLogger$5("Notify user is watching: " + currentTime);
			lastCurrentTime = currentTime;
			this.notifyUserIsWatching(currentTime, lastViewEvent).catch((err) => logger$1.error("Cannot notify user is watching.", err));
			lastViewEvent = void 0;
		}, this.options.videoViewIntervalMs);
	}
	disableUserViewing() {
		if (this.videoViewInterval) {
			clearInterval(this.videoViewInterval);
			this.videoViewInterval = void 0;
		}
		if (this.videoViewOnPlayHandler) {
			this.player.off("play", this.videoViewOnPlayHandler);
			this.videoViewOnPlayHandler = void 0;
		}
		if (this.videoViewOnSeekedHandler) {
			this.player.off("seeked", this.videoViewOnSeekedHandler);
			this.videoViewOnSeekedHandler = void 0;
		}
		if (this.videoViewOnEndedHandler) {
			this.player.off("ended", this.videoViewOnEndedHandler);
			this.videoViewOnEndedHandler = void 0;
		}
	}
	notifyUserIsWatching(currentTime, viewEvent) {
		if (!this.authorizationHeader()) saveVideoWatchHistory(this.options.videoUUID(), currentTime);
		if (!this.videoViewUrl()) return Promise.resolve(true);
		const body = {
			currentTime,
			viewEvent,
			sessionId: getPlayerSessionId(),
			client: this.userAgentInfo.client || void 0,
			device: this.userAgentInfo.device || void 0,
			operatingSystem: this.userAgentInfo.os || void 0
		};
		const headers = new Headers({ "Content-type": "application/json; charset=UTF-8" });
		if (this.authorizationHeader()) headers.set("Authorization", this.authorizationHeader());
		return fetch(this.videoViewUrl(), {
			method: "POST",
			body: JSON.stringify(body),
			headers
		});
	}
	adaptPosterForAudioOnly(resolution) {
		debugLogger$5("Check if we need to adapt player for audio only", resolution);
		if (resolution === 0) {
			this.player.audioPosterMode(true);
			this.player.poster(this.options.poster());
			return;
		}
		this.player.audioPosterMode(false);
		this.player.poster("");
	}
	updatePlayerSizeClasses() {
		requestAnimationFrame(() => {
			if (!this.player) return;
			debugLogger$5("Updating player size classes");
			const width = this.player.currentWidth();
			for (const breakpoint of [
				350,
				570,
				750
			]) if (width <= breakpoint) this.player.addClass("vjs-size-" + breakpoint);
			else this.player.removeClass("vjs-size-" + breakpoint);
		});
	}
	listenFullScreenChange() {
		this.player.on("fullscreenchange", () => {
			if (this.player.isFullscreen()) this.player.focus();
		});
	}
	listenControlBarMouse() {
		const controlBar = this.player.controlBar;
		const settingsButton = controlBar.settingsButton;
		controlBar.on("mouseenter", () => {
			this.mouseInControlBar = true;
			this.alterInactivity();
		});
		controlBar.on("mouseleave", () => {
			this.mouseInControlBar = false;
			this.alterInactivity();
		});
		settingsButton.dialog.on("mouseenter", () => {
			this.mouseInSettings = true;
			this.alterInactivity();
		});
		settingsButton.dialog.on("mouseleave", () => {
			this.mouseInSettings = false;
			this.alterInactivity();
		});
	}
	alterInactivity() {
		if (this.menuOpened || this.mouseInSettings || this.mouseInControlBar) {
			this.setInactivityTimeout(0);
			return;
		}
		this.setInactivityTimeout(this.initialInactivityTimeout);
		this.player.reportUserActivity(true);
	}
	setInactivityTimeout(timeout) {
		this.player.cache_.inactivityTimeout = timeout;
		this.player.options_.inactivityTimeout = timeout;
	}
	initCaptions() {
		if (this.currentSubtitle) debugLogger$5("Init captions with current subtitle " + this.currentSubtitle);
		else debugLogger$5("Init captions without current subtitle");
		this.player.tech(true).clearTracks("text");
		this.player.removeClass("vjs-has-captions");
		for (const caption of this.options.videoCaptions()) {
			this.player.addRemoteTextTrack({
				kind: "captions",
				label: caption.automaticallyGenerated ? this.player.localize("{1} (auto-generated)", [caption.label]) : caption.label,
				language: caption.language,
				id: caption.language,
				src: caption.src,
				default: this.currentSubtitle === caption.language
			}, true);
			this.player.addClass("vjs-has-captions");
		}
		this.player.trigger("captions-changed");
	}
	updateControlBar() {
		debugLogger$5("Updating control bar");
		if (this.options.isLive() && this.options.liveDvrEnabled()) this.player.addClass("vjs-live-dvr");
		else this.player.removeClass("vjs-live-dvr");
		if (this.options.isLive()) {
			this.getPlaybackRateButton().hide();
			this.player.controlBar.getChild("peerTubeLiveDisplay").show();
			this.player.controlBar.getChild("currentTimeDisplay").hide();
			this.player.controlBar.getChild("timeDivider").hide();
			this.player.controlBar.getChild("durationDisplay").hide();
			if (!this.options.liveDvrEnabled()) this.player.controlBar.getChild("progressControl").hide();
		} else {
			this.getPlaybackRateButton().show();
			this.player.controlBar.getChild("progressControl").show();
			this.player.controlBar.getChild("currentTimeDisplay").show();
			this.player.controlBar.getChild("timeDivider").show();
			this.player.controlBar.getChild("durationDisplay").show();
			this.player.controlBar.getChild("peerTubeLiveDisplay").hide();
		}
		if (this.options.videoCaptions().length === 0) this.getCaptionsButton().hide();
		else this.getCaptionsButton().show();
	}
	handleStartStopTime() {
		this.player.duration(this.options.videoDuration());
		if (this.stopTimeHandler) {
			this.player.off("timeupdate", this.stopTimeHandler);
			this.stopTimeHandler = void 0;
		}
		this.player.one("canplaythrough", () => {
			const startTime = this.options.startTime();
			if (startTime !== null && startTime !== void 0) {
				debugLogger$5("Start the video at " + startTime);
				this.hasInitialSeek = true;
				this.player.currentTime(timeToInt(startTime));
			}
			if (this.options.stopTime()) {
				const stopTime = timeToInt(this.options.stopTime());
				this.stopTimeHandler = () => {
					if (this.player.currentTime() <= stopTime) return;
					debugLogger$5("Stopping the video at " + this.options.stopTime());
					this.player.pause();
					this.player.trigger("auto-stopped");
					this.player.off("timeupdate", this.stopTimeHandler);
					this.stopTimeHandler = void 0;
				};
				this.player.on("timeupdate", this.stopTimeHandler);
			}
		});
	}
	patchMenuEscapeKey() {
		const Menu = import_core.default.getComponent("Menu");
		const fn = Menu.prototype.handleKeyDown;
		Menu.prototype.handleKeyDown = function handleKeyDown(event) {
			if (event.key === "Escape") {
				event.preventDefault();
				event.stopPropagation();
				this.trigger("escaped-key");
				return;
			}
			if (event.key === "ArrowRight") {
				event.preventDefault();
				event.stopPropagation();
				this.trigger("arrow-right", event.target);
				return;
			}
			if (event.key === "ArrowLeft") {
				event.preventDefault();
				event.stopPropagation();
				this.trigger("arrow-left");
				return;
			}
			fn.call(this, event);
		};
	}
	getCaptionsButton() {
		return this.player.controlBar.getDescendant(["settingsButton"]).menu.getChild("captionsButton");
	}
	getPlaybackRateButton() {
		return this.player.controlBar.getDescendant(["settingsButton"]).menu.getChild("playbackRateMenuButton");
	}
	deleteLegacyIndexedDB() {
		try {
			if (typeof window.indexedDB === "undefined") return;
			if (!window.indexedDB) return;
			if (typeof window.indexedDB.databases !== "function") return;
			window.indexedDB.databases().then((databases) => {
				for (const db of databases) window.indexedDB.deleteDatabase(db.name);
			});
		} catch (err) {
			debugLogger$5("Cannot delete legacy indexed DB", err);
		}
	}
};
import_core.default.registerPlugin("peertube", PeerTubePlugin);
//#endregion
//#region src/shared/video-filter/video-flip-horizontally-plugin.ts
var Plugin$5 = import_core.default.getPlugin("plugin");
var VideoFlipHorizontallyPlugin = class extends Plugin$5 {
	constructor(player) {
		super(player);
		player.on("video-flip-horizontally-on", () => {
			this.player.addClass("vjs-video-flip-horizontally");
		});
		player.on("video-flip-horizontally-off", () => {
			this.player.removeClass("vjs-video-flip-horizontally");
		});
	}
	enableFlip() {
		this.player.trigger("video-flip-horizontally-on");
	}
	disableFlip() {
		this.player.trigger("video-flip-horizontally-off");
	}
	toggleFlip() {
		if (this.player.hasClass("vjs-video-flip-horizontally")) this.disableFlip();
		else this.enableFlip();
	}
	dispose() {
		this.player.removeClass("vjs-video-flip-horizontally");
		super.dispose();
	}
};
import_core.default.registerPlugin("videoFlipHorizontallyPlugin", VideoFlipHorizontallyPlugin);
//#endregion
//#region src/shared/player-options-builder/control-bar-options-builder.ts
var ControlBarOptionsBuilder = class {
	constructor(options) {
		this.options = options;
	}
	getChildrenOptions() {
		return {
			...this.getPreviousVideo(),
			playToggle: {},
			...this.getNextVideo(),
			...this.getTimeControls(),
			...this.getProgressControl(),
			p2PInfoButton: {},
			volumePanel: { inline: false },
			captionToggleButton: {},
			...this.getSettingsButton(),
			...this.getPeerTubeLinkButton(),
			...this.getTheaterButton(),
			fullscreenToggle: {}
		};
	}
	getSettingsButton() {
		const settingEntries = [];
		settingEntries.push("playbackRateMenuButton");
		settingEntries.push("captionsButton");
		settingEntries.push("resolutionMenuButton");
		settingEntries.push("videoFilterMenuButton");
		return { settingsButton: {
			setup: { maxHeightOffset: 60 },
			entries: settingEntries
		} };
	}
	getTimeControls() {
		return {
			peerTubeLiveDisplay: {},
			currentTimeDisplay: {},
			timeDivider: {},
			durationDisplay: {}
		};
	}
	getProgressControl() {
		return { progressControl: { children: { seekBar: { children: ["loadProgressBar", "playProgressBar"] } } } };
	}
	getPreviousVideo() {
		return { previousVideoButton: {
			type: "previous",
			handler: () => this.options.previousVideo().handler(),
			isDisabled: () => !this.options.previousVideo().enabled,
			isDisplayed: () => this.options.previousVideo().displayControlBarButton
		} };
	}
	getNextVideo() {
		return { nextVideoButton: {
			type: "next",
			handler: () => this.options.nextVideo().handler(),
			isDisabled: () => !this.options.nextVideo().enabled,
			isDisplayed: () => this.options.nextVideo().displayControlBarButton
		} };
	}
	getPeerTubeLinkButton() {
		return { peerTubeLinkButton: {
			isDisplayed: this.options.peertubeLink,
			shortUUID: this.options.videoShortUUID,
			instanceName: this.options.instanceName
		} };
	}
	getTheaterButton() {
		return { theaterButton: { isDisplayed: () => this.options.theaterButton } };
	}
};
//#endregion
//#region ../../root-helpers/url.ts
function isSameOrigin(current, target) {
	const currentUrl = new URL(current);
	const targetUrl = new URL(target);
	if (currentUrl.hostname === "localhost" && targetUrl.hostname === "localhost") return true;
	return currentUrl.origin === targetUrl.origin;
}
//#endregion
//#region src/shared/p2p-media-loader/redundancy-url-manager.ts
var RedundancyUrlManager = class {
	map = /* @__PURE__ */ new Map();
	constructor(baseUrls = []) {
		this.baseUrls = baseUrls;
	}
	onSegmentError(segmentUrl) {
		if (!this.map.has(segmentUrl)) return;
		const customSegmentUrl = this.map.get(segmentUrl);
		this.map.delete(segmentUrl);
		const baseUrl = getBaseUrl(customSegmentUrl);
		const oldLength = baseUrl.length;
		this.baseUrls = this.baseUrls.filter((u) => u !== baseUrl && u !== baseUrl + "/");
		if (oldLength !== this.baseUrls.length) logger$1.info(`Removed redundancy of segment URL ${customSegmentUrl}.`);
	}
	onSegmentSuccess(segmentUrl) {
		this.map.delete(segmentUrl);
	}
	buildUrl(url) {
		const max = this.baseUrls.length + 1;
		const i = this.getRandomInt(max);
		if (i === max - 1) return url;
		const newBaseUrl = this.baseUrls[i];
		const newUrl = newBaseUrl + (newBaseUrl.endsWith("/") ? "" : "/") + getFilename(url);
		this.map.set(url, newUrl);
		return newUrl;
	}
	countBaseUrls() {
		return this.baseUrls.length;
	}
	getRandomInt(max) {
		return Math.floor(Math.random() * Math.floor(max));
	}
};
function getFilename(url) {
	return url.split("/").pop();
}
function getBaseUrl(url) {
	const baseUrl = url.split("/");
	baseUrl.pop();
	return baseUrl.join("/");
}
//#endregion
//#region ../../../../node_modules/.pnpm/vite-plugin-node-polyfills@0.25.0_rollup@4.60.4_vite@8.0.10/node_modules/vite-plugin-node-polyfills/shims/buffer/dist/index.js
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i) {
	lookup[i] = code[i];
	revLookup[code.charCodeAt(i)] = i;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
	var len = b64.length;
	if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
	var validLen = b64.indexOf("=");
	if (validLen === -1) validLen = len;
	var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
	return [validLen, placeHoldersLen];
}
function byteLength(b64) {
	var lens = getLens(b64);
	var validLen = lens[0];
	var placeHoldersLen = lens[1];
	return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
	return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
	var tmp;
	var lens = getLens(b64);
	var validLen = lens[0];
	var placeHoldersLen = lens[1];
	var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
	var curByte = 0;
	var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
	var i;
	for (i = 0; i < len; i += 4) {
		tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
		arr[curByte++] = tmp >> 16 & 255;
		arr[curByte++] = tmp >> 8 & 255;
		arr[curByte++] = tmp & 255;
	}
	if (placeHoldersLen === 2) {
		tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
		arr[curByte++] = tmp & 255;
	}
	if (placeHoldersLen === 1) {
		tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
		arr[curByte++] = tmp >> 8 & 255;
		arr[curByte++] = tmp & 255;
	}
	return arr;
}
function tripletToBase64(num) {
	return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start, end) {
	var tmp;
	var output = [];
	for (var i = start; i < end; i += 3) {
		tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (uint8[i + 2] & 255);
		output.push(tripletToBase64(tmp));
	}
	return output.join("");
}
function fromByteArray(uint8) {
	var tmp;
	var len = uint8.length;
	var extraBytes = len % 3;
	var parts = [];
	var maxChunkLength = 16383;
	for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	if (extraBytes === 1) {
		tmp = uint8[len - 1];
		parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
	} else if (extraBytes === 2) {
		tmp = (uint8[len - 2] << 8) + uint8[len - 1];
		parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
	}
	return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
	var e, m;
	var eLen = nBytes * 8 - mLen - 1;
	var eMax = (1 << eLen) - 1;
	var eBias = eMax >> 1;
	var nBits = -7;
	var i = isLE ? nBytes - 1 : 0;
	var d = isLE ? -1 : 1;
	var s = buffer[offset + i];
	i += d;
	e = s & (1 << -nBits) - 1;
	s >>= -nBits;
	nBits += eLen;
	for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
	m = e & (1 << -nBits) - 1;
	e >>= -nBits;
	nBits += mLen;
	for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
	if (e === 0) e = 1 - eBias;
	else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
	else {
		m = m + Math.pow(2, mLen);
		e = e - eBias;
	}
	return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
	var e, m, c;
	var eLen = nBytes * 8 - mLen - 1;
	var eMax = (1 << eLen) - 1;
	var eBias = eMax >> 1;
	var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	var i = isLE ? 0 : nBytes - 1;
	var d = isLE ? 1 : -1;
	var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	value = Math.abs(value);
	if (isNaN(value) || value === Infinity) {
		m = isNaN(value) ? 1 : 0;
		e = eMax;
	} else {
		e = Math.floor(Math.log(value) / Math.LN2);
		if (value * (c = Math.pow(2, -e)) < 1) {
			e--;
			c *= 2;
		}
		if (e + eBias >= 1) value += rt / c;
		else value += rt * Math.pow(2, 1 - eBias);
		if (value * c >= 2) {
			e++;
			c /= 2;
		}
		if (e + eBias >= eMax) {
			m = 0;
			e = eMax;
		} else if (e + eBias >= 1) {
			m = (value * c - 1) * Math.pow(2, mLen);
			e = e + eBias;
		} else {
			m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
			e = 0;
		}
	}
	for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8);
	e = e << mLen | m;
	eLen += mLen;
	for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8);
	buffer[offset + i - d] |= s * 128;
};
/*!
* The buffer module from node.js, for the browser.
*
* @author   Feross Aboukhadijeh <https://feross.org>
* @license  MIT
*/
(function(exports) {
	const base64 = base64Js;
	const ieee754$1 = ieee754;
	const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	const K_MAX_LENGTH = 2147483647;
	exports.kMaxLength = K_MAX_LENGTH;
	const { Uint8Array: GlobalUint8Array, ArrayBuffer: GlobalArrayBuffer, SharedArrayBuffer: GlobalSharedArrayBuffer } = globalThis;
	/**
	* If `Buffer.TYPED_ARRAY_SUPPORT`:
	*   === true    Use Uint8Array implementation (fastest)
	*   === false   Print warning and recommend using `buffer` v4.x which has an Object
	*               implementation (most compatible, even IE6)
	*
	* Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	* Opera 11.6+, iOS 4.2+.
	*
	* We report that the browser does not support typed arrays if the are not subclassable
	* using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	* (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	* for __proto__ and has a buggy typed array implementation.
	*/
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
	function typedArraySupport() {
		try {
			const arr = new GlobalUint8Array(1);
			const proto = { foo: function() {
				return 42;
			} };
			Object.setPrototypeOf(proto, GlobalUint8Array.prototype);
			Object.setPrototypeOf(arr, proto);
			return arr.foo() === 42;
		} catch (e) {
			return false;
		}
	}
	Object.defineProperty(Buffer.prototype, "parent", {
		enumerable: true,
		get: function() {
			if (!Buffer.isBuffer(this)) return void 0;
			return this.buffer;
		}
	});
	Object.defineProperty(Buffer.prototype, "offset", {
		enumerable: true,
		get: function() {
			if (!Buffer.isBuffer(this)) return void 0;
			return this.byteOffset;
		}
	});
	function createBuffer(length) {
		if (length > K_MAX_LENGTH) throw new RangeError("The value \"" + length + "\" is invalid for option \"size\"");
		const buf = new GlobalUint8Array(length);
		Object.setPrototypeOf(buf, Buffer.prototype);
		return buf;
	}
	/**
	* The Buffer constructor returns instances of `Uint8Array` that have their
	* prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	* `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	* and the `Uint8Array` methods. Square bracket notation works as expected -- it
	* returns a single octet.
	*
	* The `Uint8Array` prototype remains unmodified.
	*/
	function Buffer(arg, encodingOrOffset, length) {
		if (typeof arg === "number") {
			if (typeof encodingOrOffset === "string") throw new TypeError("The \"string\" argument must be of type string. Received type number");
			return allocUnsafe(arg);
		}
		return from(arg, encodingOrOffset, length);
	}
	Buffer.poolSize = 8192;
	function from(value, encodingOrOffset, length) {
		if (typeof value === "string") return fromString(value, encodingOrOffset);
		if (GlobalArrayBuffer.isView(value)) return fromArrayView(value);
		if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
		if (isInstance(value, GlobalArrayBuffer) || value && isInstance(value.buffer, GlobalArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
		if (typeof GlobalSharedArrayBuffer !== "undefined" && (isInstance(value, GlobalSharedArrayBuffer) || value && isInstance(value.buffer, GlobalSharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
		if (typeof value === "number") throw new TypeError("The \"value\" argument must not be of type number. Received type number");
		const valueOf = value.valueOf && value.valueOf();
		if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
		const b = fromObject(value);
		if (b) return b;
		if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
		throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
	}
	/**
	* Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	* if value is a number.
	* Buffer.from(str[, encoding])
	* Buffer.from(array)
	* Buffer.from(buffer)
	* Buffer.from(arrayBuffer[, byteOffset[, length]])
	**/
	Buffer.from = function(value, encodingOrOffset, length) {
		return from(value, encodingOrOffset, length);
	};
	Object.setPrototypeOf(Buffer.prototype, GlobalUint8Array.prototype);
	Object.setPrototypeOf(Buffer, GlobalUint8Array);
	function assertSize(size) {
		if (typeof size !== "number") throw new TypeError("\"size\" argument must be of type number");
		else if (size < 0) throw new RangeError("The value \"" + size + "\" is invalid for option \"size\"");
	}
	function alloc(size, fill, encoding) {
		assertSize(size);
		if (size <= 0) return createBuffer(size);
		if (fill !== void 0) return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
		return createBuffer(size);
	}
	/**
	* Creates a new filled Buffer instance.
	* alloc(size[, fill[, encoding]])
	**/
	Buffer.alloc = function(size, fill, encoding) {
		return alloc(size, fill, encoding);
	};
	function allocUnsafe(size) {
		assertSize(size);
		return createBuffer(size < 0 ? 0 : checked(size) | 0);
	}
	/**
	* Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	* */
	Buffer.allocUnsafe = function(size) {
		return allocUnsafe(size);
	};
	/**
	* Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	*/
	Buffer.allocUnsafeSlow = function(size) {
		return allocUnsafe(size);
	};
	function fromString(string, encoding) {
		if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
		if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
		const length = byteLength(string, encoding) | 0;
		let buf = createBuffer(length);
		const actual = buf.write(string, encoding);
		if (actual !== length) buf = buf.slice(0, actual);
		return buf;
	}
	function fromArrayLike(array) {
		const length = array.length < 0 ? 0 : checked(array.length) | 0;
		const buf = createBuffer(length);
		for (let i = 0; i < length; i += 1) buf[i] = array[i] & 255;
		return buf;
	}
	function fromArrayView(arrayView) {
		if (isInstance(arrayView, GlobalUint8Array)) {
			const copy = new GlobalUint8Array(arrayView);
			return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
		}
		return fromArrayLike(arrayView);
	}
	function fromArrayBuffer(array, byteOffset, length) {
		if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("\"offset\" is outside of buffer bounds");
		if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("\"length\" is outside of buffer bounds");
		let buf;
		if (byteOffset === void 0 && length === void 0) buf = new GlobalUint8Array(array);
		else if (length === void 0) buf = new GlobalUint8Array(array, byteOffset);
		else buf = new GlobalUint8Array(array, byteOffset, length);
		Object.setPrototypeOf(buf, Buffer.prototype);
		return buf;
	}
	function fromObject(obj) {
		if (Buffer.isBuffer(obj)) {
			const len = checked(obj.length) | 0;
			const buf = createBuffer(len);
			if (buf.length === 0) return buf;
			obj.copy(buf, 0, 0, len);
			return buf;
		}
		if (obj.length !== void 0) {
			if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
			return fromArrayLike(obj);
		}
		if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
	}
	function checked(length) {
		if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
		return length | 0;
	}
	function SlowBuffer(length) {
		if (+length != length) length = 0;
		return Buffer.alloc(+length);
	}
	Buffer.isBuffer = function isBuffer(b) {
		return b != null && b._isBuffer === true && b !== Buffer.prototype;
	};
	Buffer.compare = function compare(a, b) {
		if (isInstance(a, GlobalUint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
		if (isInstance(b, GlobalUint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
		if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("The \"buf1\", \"buf2\" arguments must be one of type Buffer or Uint8Array");
		if (a === b) return 0;
		let x = a.length;
		let y = b.length;
		for (let i = 0, len = Math.min(x, y); i < len; ++i) if (a[i] !== b[i]) {
			x = a[i];
			y = b[i];
			break;
		}
		if (x < y) return -1;
		if (y < x) return 1;
		return 0;
	};
	Buffer.isEncoding = function isEncoding(encoding) {
		switch (String(encoding).toLowerCase()) {
			case "hex":
			case "utf8":
			case "utf-8":
			case "ascii":
			case "latin1":
			case "binary":
			case "base64":
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return true;
			default: return false;
		}
	};
	Buffer.concat = function concat(list, length) {
		if (!Array.isArray(list)) throw new TypeError("\"list\" argument must be an Array of Buffers");
		if (list.length === 0) return Buffer.alloc(0);
		let i;
		if (length === void 0) {
			length = 0;
			for (i = 0; i < list.length; ++i) length += list[i].length;
		}
		const buffer = Buffer.allocUnsafe(length);
		let pos = 0;
		for (i = 0; i < list.length; ++i) {
			let buf = list[i];
			if (isInstance(buf, GlobalUint8Array)) if (pos + buf.length > buffer.length) {
				if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
				buf.copy(buffer, pos);
			} else GlobalUint8Array.prototype.set.call(buffer, buf, pos);
			else if (!Buffer.isBuffer(buf)) throw new TypeError("\"list\" argument must be an Array of Buffers");
			else buf.copy(buffer, pos);
			pos += buf.length;
		}
		return buffer;
	};
	function byteLength(string, encoding) {
		if (Buffer.isBuffer(string)) return string.length;
		if (GlobalArrayBuffer.isView(string) || isInstance(string, GlobalArrayBuffer)) return string.byteLength;
		if (typeof string !== "string") throw new TypeError("The \"string\" argument must be one of type string, Buffer, or ArrayBuffer. Received type " + typeof string);
		const len = string.length;
		const mustMatch = arguments.length > 2 && arguments[2] === true;
		if (!mustMatch && len === 0) return 0;
		let loweredCase = false;
		for (;;) switch (encoding) {
			case "ascii":
			case "latin1":
			case "binary": return len;
			case "utf8":
			case "utf-8": return utf8ToBytes(string).length;
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return len * 2;
			case "hex": return len >>> 1;
			case "base64": return base64ToBytes(string).length;
			default:
				if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length;
				encoding = ("" + encoding).toLowerCase();
				loweredCase = true;
		}
	}
	Buffer.byteLength = byteLength;
	function slowToString(encoding, start, end) {
		let loweredCase = false;
		if (start === void 0 || start < 0) start = 0;
		if (start > this.length) return "";
		if (end === void 0 || end > this.length) end = this.length;
		if (end <= 0) return "";
		end >>>= 0;
		start >>>= 0;
		if (end <= start) return "";
		if (!encoding) encoding = "utf8";
		while (true) switch (encoding) {
			case "hex": return hexSlice(this, start, end);
			case "utf8":
			case "utf-8": return utf8Slice(this, start, end);
			case "ascii": return asciiSlice(this, start, end);
			case "latin1":
			case "binary": return latin1Slice(this, start, end);
			case "base64": return base64Slice(this, start, end);
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return utf16leSlice(this, start, end);
			default:
				if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
				encoding = (encoding + "").toLowerCase();
				loweredCase = true;
		}
	}
	Buffer.prototype._isBuffer = true;
	function swap(b, n, m) {
		const i = b[n];
		b[n] = b[m];
		b[m] = i;
	}
	Buffer.prototype.swap16 = function swap16() {
		const len = this.length;
		if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
		for (let i = 0; i < len; i += 2) swap(this, i, i + 1);
		return this;
	};
	Buffer.prototype.swap32 = function swap32() {
		const len = this.length;
		if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
		for (let i = 0; i < len; i += 4) {
			swap(this, i, i + 3);
			swap(this, i + 1, i + 2);
		}
		return this;
	};
	Buffer.prototype.swap64 = function swap64() {
		const len = this.length;
		if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
		for (let i = 0; i < len; i += 8) {
			swap(this, i, i + 7);
			swap(this, i + 1, i + 6);
			swap(this, i + 2, i + 5);
			swap(this, i + 3, i + 4);
		}
		return this;
	};
	Buffer.prototype.toString = function toString() {
		const length = this.length;
		if (length === 0) return "";
		if (arguments.length === 0) return utf8Slice(this, 0, length);
		return slowToString.apply(this, arguments);
	};
	Buffer.prototype.toLocaleString = Buffer.prototype.toString;
	Buffer.prototype.equals = function equals(b) {
		if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
		if (this === b) return true;
		return Buffer.compare(this, b) === 0;
	};
	Buffer.prototype.inspect = function inspect() {
		let str = "";
		const max = exports.INSPECT_MAX_BYTES;
		str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
		if (this.length > max) str += " ... ";
		return "<Buffer " + str + ">";
	};
	if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
		if (isInstance(target, GlobalUint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
		if (!Buffer.isBuffer(target)) throw new TypeError("The \"target\" argument must be one of type Buffer or Uint8Array. Received type " + typeof target);
		if (start === void 0) start = 0;
		if (end === void 0) end = target ? target.length : 0;
		if (thisStart === void 0) thisStart = 0;
		if (thisEnd === void 0) thisEnd = this.length;
		if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
		if (thisStart >= thisEnd && start >= end) return 0;
		if (thisStart >= thisEnd) return -1;
		if (start >= end) return 1;
		start >>>= 0;
		end >>>= 0;
		thisStart >>>= 0;
		thisEnd >>>= 0;
		if (this === target) return 0;
		let x = thisEnd - thisStart;
		let y = end - start;
		const len = Math.min(x, y);
		const thisCopy = this.slice(thisStart, thisEnd);
		const targetCopy = target.slice(start, end);
		for (let i = 0; i < len; ++i) if (thisCopy[i] !== targetCopy[i]) {
			x = thisCopy[i];
			y = targetCopy[i];
			break;
		}
		if (x < y) return -1;
		if (y < x) return 1;
		return 0;
	};
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
		if (buffer.length === 0) return -1;
		if (typeof byteOffset === "string") {
			encoding = byteOffset;
			byteOffset = 0;
		} else if (byteOffset > 2147483647) byteOffset = 2147483647;
		else if (byteOffset < -2147483648) byteOffset = -2147483648;
		byteOffset = +byteOffset;
		if (numberIsNaN(byteOffset)) byteOffset = dir ? 0 : buffer.length - 1;
		if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		if (byteOffset >= buffer.length) if (dir) return -1;
		else byteOffset = buffer.length - 1;
		else if (byteOffset < 0) if (dir) byteOffset = 0;
		else return -1;
		if (typeof val === "string") val = Buffer.from(val, encoding);
		if (Buffer.isBuffer(val)) {
			if (val.length === 0) return -1;
			return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
		} else if (typeof val === "number") {
			val = val & 255;
			if (typeof GlobalUint8Array.prototype.indexOf === "function") if (dir) return GlobalUint8Array.prototype.indexOf.call(buffer, val, byteOffset);
			else return GlobalUint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
			return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
		}
		throw new TypeError("val must be string, number or Buffer");
	}
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
		let indexSize = 1;
		let arrLength = arr.length;
		let valLength = val.length;
		if (encoding !== void 0) {
			encoding = String(encoding).toLowerCase();
			if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
				if (arr.length < 2 || val.length < 2) return -1;
				indexSize = 2;
				arrLength /= 2;
				valLength /= 2;
				byteOffset /= 2;
			}
		}
		function read(buf, i) {
			if (indexSize === 1) return buf[i];
			else return buf.readUInt16BE(i * indexSize);
		}
		let i;
		if (dir) {
			let foundIndex = -1;
			for (i = byteOffset; i < arrLength; i++) if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
				if (foundIndex === -1) foundIndex = i;
				if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
			} else {
				if (foundIndex !== -1) i -= i - foundIndex;
				foundIndex = -1;
			}
		} else {
			if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
			for (i = byteOffset; i >= 0; i--) {
				let found = true;
				for (let j = 0; j < valLength; j++) if (read(arr, i + j) !== read(val, j)) {
					found = false;
					break;
				}
				if (found) return i;
			}
		}
		return -1;
	}
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
		return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
		return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
		return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	function hexWrite(buf, string, offset, length) {
		offset = Number(offset) || 0;
		const remaining = buf.length - offset;
		if (!length) length = remaining;
		else {
			length = Number(length);
			if (length > remaining) length = remaining;
		}
		const strLen = string.length;
		if (length > strLen / 2) length = strLen / 2;
		let i;
		for (i = 0; i < length; ++i) {
			const parsed = parseInt(string.substr(i * 2, 2), 16);
			if (numberIsNaN(parsed)) return i;
			buf[offset + i] = parsed;
		}
		return i;
	}
	function utf8Write(buf, string, offset, length) {
		return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	function asciiWrite(buf, string, offset, length) {
		return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	function base64Write(buf, string, offset, length) {
		return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	function ucs2Write(buf, string, offset, length) {
		return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	Buffer.prototype.write = function write(string, offset, length, encoding) {
		if (offset === void 0) {
			encoding = "utf8";
			length = this.length;
			offset = 0;
		} else if (length === void 0 && typeof offset === "string") {
			encoding = offset;
			length = this.length;
			offset = 0;
		} else if (isFinite(offset)) {
			offset = offset >>> 0;
			if (isFinite(length)) {
				length = length >>> 0;
				if (encoding === void 0) encoding = "utf8";
			} else {
				encoding = length;
				length = void 0;
			}
		} else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
		const remaining = this.length - offset;
		if (length === void 0 || length > remaining) length = remaining;
		if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
		if (!encoding) encoding = "utf8";
		let loweredCase = false;
		for (;;) switch (encoding) {
			case "hex": return hexWrite(this, string, offset, length);
			case "utf8":
			case "utf-8": return utf8Write(this, string, offset, length);
			case "ascii":
			case "latin1":
			case "binary": return asciiWrite(this, string, offset, length);
			case "base64": return base64Write(this, string, offset, length);
			case "ucs2":
			case "ucs-2":
			case "utf16le":
			case "utf-16le": return ucs2Write(this, string, offset, length);
			default:
				if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
				encoding = ("" + encoding).toLowerCase();
				loweredCase = true;
		}
	};
	Buffer.prototype.toJSON = function toJSON() {
		return {
			type: "Buffer",
			data: Array.prototype.slice.call(this._arr || this, 0)
		};
	};
	function base64Slice(buf, start, end) {
		if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
		else return base64.fromByteArray(buf.slice(start, end));
	}
	function utf8Slice(buf, start, end) {
		end = Math.min(buf.length, end);
		const res = [];
		let i = start;
		while (i < end) {
			const firstByte = buf[i];
			let codePoint = null;
			let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
			if (i + bytesPerSequence <= end) {
				let secondByte, thirdByte, fourthByte, tempCodePoint;
				switch (bytesPerSequence) {
					case 1:
						if (firstByte < 128) codePoint = firstByte;
						break;
					case 2:
						secondByte = buf[i + 1];
						if ((secondByte & 192) === 128) {
							tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
							if (tempCodePoint > 127) codePoint = tempCodePoint;
						}
						break;
					case 3:
						secondByte = buf[i + 1];
						thirdByte = buf[i + 2];
						if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
							tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
							if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
						}
						break;
					case 4:
						secondByte = buf[i + 1];
						thirdByte = buf[i + 2];
						fourthByte = buf[i + 3];
						if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
							tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
							if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
						}
				}
			}
			if (codePoint === null) {
				codePoint = 65533;
				bytesPerSequence = 1;
			} else if (codePoint > 65535) {
				codePoint -= 65536;
				res.push(codePoint >>> 10 & 1023 | 55296);
				codePoint = 56320 | codePoint & 1023;
			}
			res.push(codePoint);
			i += bytesPerSequence;
		}
		return decodeCodePointsArray(res);
	}
	const MAX_ARGUMENTS_LENGTH = 4096;
	function decodeCodePointsArray(codePoints) {
		const len = codePoints.length;
		if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
		let res = "";
		let i = 0;
		while (i < len) res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
		return res;
	}
	function asciiSlice(buf, start, end) {
		let ret = "";
		end = Math.min(buf.length, end);
		for (let i = start; i < end; ++i) ret += String.fromCharCode(buf[i] & 127);
		return ret;
	}
	function latin1Slice(buf, start, end) {
		let ret = "";
		end = Math.min(buf.length, end);
		for (let i = start; i < end; ++i) ret += String.fromCharCode(buf[i]);
		return ret;
	}
	function hexSlice(buf, start, end) {
		const len = buf.length;
		if (!start || start < 0) start = 0;
		if (!end || end < 0 || end > len) end = len;
		let out = "";
		for (let i = start; i < end; ++i) out += hexSliceLookupTable[buf[i]];
		return out;
	}
	function utf16leSlice(buf, start, end) {
		const bytes = buf.slice(start, end);
		let res = "";
		for (let i = 0; i < bytes.length - 1; i += 2) res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
		return res;
	}
	Buffer.prototype.slice = function slice(start, end) {
		const len = this.length;
		start = ~~start;
		end = end === void 0 ? len : ~~end;
		if (start < 0) {
			start += len;
			if (start < 0) start = 0;
		} else if (start > len) start = len;
		if (end < 0) {
			end += len;
			if (end < 0) end = 0;
		} else if (end > len) end = len;
		if (end < start) end = start;
		const newBuf = this.subarray(start, end);
		Object.setPrototypeOf(newBuf, Buffer.prototype);
		return newBuf;
	};
	function checkOffset(offset, ext, length) {
		if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
		if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
	}
	Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset];
		let mul = 1;
		let i = 0;
		while (++i < byteLength && (mul *= 256)) val += this[offset + i] * mul;
		return val;
	};
	Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset + --byteLength];
		let mul = 1;
		while (byteLength > 0 && (mul *= 256)) val += this[offset + --byteLength] * mul;
		return val;
	};
	Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 1, this.length);
		return this[offset];
	};
	Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		return this[offset] | this[offset + 1] << 8;
	};
	Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		return this[offset] << 8 | this[offset + 1];
	};
	Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
	};
	Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
		const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
		return BigInt(lo) + (BigInt(hi) << BigInt(32));
	});
	Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
		const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
		return (BigInt(hi) << BigInt(32)) + BigInt(lo);
	});
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let val = this[offset];
		let mul = 1;
		let i = 0;
		while (++i < byteLength && (mul *= 256)) val += this[offset + i] * mul;
		mul *= 128;
		if (val >= mul) val -= Math.pow(2, 8 * byteLength);
		return val;
	};
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) checkOffset(offset, byteLength, this.length);
		let i = byteLength;
		let mul = 1;
		let val = this[offset + --i];
		while (i > 0 && (mul *= 256)) val += this[offset + --i] * mul;
		mul *= 128;
		if (val >= mul) val -= Math.pow(2, 8 * byteLength);
		return val;
	};
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 1, this.length);
		if (!(this[offset] & 128)) return this[offset];
		return (255 - this[offset] + 1) * -1;
	};
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		const val = this[offset] | this[offset + 1] << 8;
		return val & 32768 ? val | 4294901760 : val;
	};
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 2, this.length);
		const val = this[offset + 1] | this[offset] << 8;
		return val & 32768 ? val | 4294901760 : val;
	};
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
		return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
	});
	Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
		offset = offset >>> 0;
		validateNumber(offset, "offset");
		const first = this[offset];
		const last = this[offset + 7];
		if (first === void 0 || last === void 0) boundsError(offset, this.length - 8);
		const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
		return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
	});
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return ieee754$1.read(this, offset, true, 23, 4);
	};
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 4, this.length);
		return ieee754$1.read(this, offset, false, 23, 4);
	};
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 8, this.length);
		return ieee754$1.read(this, offset, true, 52, 8);
	};
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
		offset = offset >>> 0;
		if (!noAssert) checkOffset(offset, 8, this.length);
		return ieee754$1.read(this, offset, false, 52, 8);
	};
	function checkInt(buf, value, offset, ext, max, min) {
		if (!Buffer.isBuffer(buf)) throw new TypeError("\"buffer\" argument must be a Buffer instance");
		if (value > max || value < min) throw new RangeError("\"value\" argument is out of bounds");
		if (offset + ext > buf.length) throw new RangeError("Index out of range");
	}
	Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) {
			const maxBytes = Math.pow(2, 8 * byteLength) - 1;
			checkInt(this, value, offset, byteLength, maxBytes, 0);
		}
		let mul = 1;
		let i = 0;
		this[offset] = value & 255;
		while (++i < byteLength && (mul *= 256)) this[offset + i] = value / mul & 255;
		return offset + byteLength;
	};
	Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		byteLength = byteLength >>> 0;
		if (!noAssert) {
			const maxBytes = Math.pow(2, 8 * byteLength) - 1;
			checkInt(this, value, offset, byteLength, maxBytes, 0);
		}
		let i = byteLength - 1;
		let mul = 1;
		this[offset + i] = value & 255;
		while (--i >= 0 && (mul *= 256)) this[offset + i] = value / mul & 255;
		return offset + byteLength;
	};
	Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
		this[offset] = value & 255;
		return offset + 1;
	};
	Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		return offset + 2;
	};
	Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
		this[offset] = value >>> 8;
		this[offset + 1] = value & 255;
		return offset + 2;
	};
	Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
		this[offset + 3] = value >>> 24;
		this[offset + 2] = value >>> 16;
		this[offset + 1] = value >>> 8;
		this[offset] = value & 255;
		return offset + 4;
	};
	Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
		this[offset] = value >>> 24;
		this[offset + 1] = value >>> 16;
		this[offset + 2] = value >>> 8;
		this[offset + 3] = value & 255;
		return offset + 4;
	};
	function wrtBigUInt64LE(buf, value, offset, min, max) {
		checkIntBI(value, min, max, buf, offset, 7);
		let lo = Number(value & BigInt(4294967295));
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		lo = lo >> 8;
		buf[offset++] = lo;
		let hi = Number(value >> BigInt(32) & BigInt(4294967295));
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		hi = hi >> 8;
		buf[offset++] = hi;
		return offset;
	}
	function wrtBigUInt64BE(buf, value, offset, min, max) {
		checkIntBI(value, min, max, buf, offset, 7);
		let lo = Number(value & BigInt(4294967295));
		buf[offset + 7] = lo;
		lo = lo >> 8;
		buf[offset + 6] = lo;
		lo = lo >> 8;
		buf[offset + 5] = lo;
		lo = lo >> 8;
		buf[offset + 4] = lo;
		let hi = Number(value >> BigInt(32) & BigInt(4294967295));
		buf[offset + 3] = hi;
		hi = hi >> 8;
		buf[offset + 2] = hi;
		hi = hi >> 8;
		buf[offset + 1] = hi;
		hi = hi >> 8;
		buf[offset] = hi;
		return offset + 8;
	}
	Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
		return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	});
	Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
		return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	});
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) {
			const limit = Math.pow(2, 8 * byteLength - 1);
			checkInt(this, value, offset, byteLength, limit - 1, -limit);
		}
		let i = 0;
		let mul = 1;
		let sub = 0;
		this[offset] = value & 255;
		while (++i < byteLength && (mul *= 256)) {
			if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
			this[offset + i] = (value / mul >> 0) - sub & 255;
		}
		return offset + byteLength;
	};
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) {
			const limit = Math.pow(2, 8 * byteLength - 1);
			checkInt(this, value, offset, byteLength, limit - 1, -limit);
		}
		let i = byteLength - 1;
		let mul = 1;
		let sub = 0;
		this[offset + i] = value & 255;
		while (--i >= 0 && (mul *= 256)) {
			if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
			this[offset + i] = (value / mul >> 0) - sub & 255;
		}
		return offset + byteLength;
	};
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
		if (value < 0) value = 255 + value + 1;
		this[offset] = value & 255;
		return offset + 1;
	};
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		return offset + 2;
	};
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
		this[offset] = value >>> 8;
		this[offset + 1] = value & 255;
		return offset + 2;
	};
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
		this[offset] = value & 255;
		this[offset + 1] = value >>> 8;
		this[offset + 2] = value >>> 16;
		this[offset + 3] = value >>> 24;
		return offset + 4;
	};
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
		if (value < 0) value = 4294967295 + value + 1;
		this[offset] = value >>> 24;
		this[offset + 1] = value >>> 16;
		this[offset + 2] = value >>> 8;
		this[offset + 3] = value & 255;
		return offset + 4;
	};
	Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
		return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	});
	Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
		return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	});
	function checkIEEE754(buf, value, offset, ext, max, min) {
		if (offset + ext > buf.length) throw new RangeError("Index out of range");
		if (offset < 0) throw new RangeError("Index out of range");
	}
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkIEEE754(buf, value, offset, 4);
		ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
		return offset + 4;
	}
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
		return writeFloat(this, value, offset, true, noAssert);
	};
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
		return writeFloat(this, value, offset, false, noAssert);
	};
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
		value = +value;
		offset = offset >>> 0;
		if (!noAssert) checkIEEE754(buf, value, offset, 8);
		ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
		return offset + 8;
	}
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
		return writeDouble(this, value, offset, true, noAssert);
	};
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
		return writeDouble(this, value, offset, false, noAssert);
	};
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
		if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
		if (!start) start = 0;
		if (!end && end !== 0) end = this.length;
		if (targetStart >= target.length) targetStart = target.length;
		if (!targetStart) targetStart = 0;
		if (end > 0 && end < start) end = start;
		if (end === start) return 0;
		if (target.length === 0 || this.length === 0) return 0;
		if (targetStart < 0) throw new RangeError("targetStart out of bounds");
		if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
		if (end < 0) throw new RangeError("sourceEnd out of bounds");
		if (end > this.length) end = this.length;
		if (target.length - targetStart < end - start) end = target.length - targetStart + start;
		const len = end - start;
		if (this === target && typeof GlobalUint8Array.prototype.copyWithin === "function") this.copyWithin(targetStart, start, end);
		else GlobalUint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
		return len;
	};
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
		if (typeof val === "string") {
			if (typeof start === "string") {
				encoding = start;
				start = 0;
				end = this.length;
			} else if (typeof end === "string") {
				encoding = end;
				end = this.length;
			}
			if (encoding !== void 0 && typeof encoding !== "string") throw new TypeError("encoding must be a string");
			if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
			if (val.length === 1) {
				const code = val.charCodeAt(0);
				if (encoding === "utf8" && code < 128 || encoding === "latin1") val = code;
			}
		} else if (typeof val === "number") val = val & 255;
		else if (typeof val === "boolean") val = Number(val);
		if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
		if (end <= start) return this;
		start = start >>> 0;
		end = end === void 0 ? this.length : end >>> 0;
		if (!val) val = 0;
		let i;
		if (typeof val === "number") for (i = start; i < end; ++i) this[i] = val;
		else {
			const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
			const len = bytes.length;
			if (len === 0) throw new TypeError("The value \"" + val + "\" is invalid for argument \"value\"");
			for (i = 0; i < end - start; ++i) this[i + start] = bytes[i % len];
		}
		return this;
	};
	const errors = {};
	function E(sym, getMessage, Base) {
		errors[sym] = class NodeError extends Base {
			constructor() {
				super();
				Object.defineProperty(this, "message", {
					value: getMessage.apply(this, arguments),
					writable: true,
					configurable: true
				});
				this.name = `${this.name} [${sym}]`;
				this.stack;
				delete this.name;
			}
			get code() {
				return sym;
			}
			set code(value) {
				Object.defineProperty(this, "code", {
					configurable: true,
					enumerable: true,
					value,
					writable: true
				});
			}
			toString() {
				return `${this.name} [${sym}]: ${this.message}`;
			}
		};
	}
	E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
		if (name) return `${name} is outside of buffer bounds`;
		return "Attempt to access memory outside buffer bounds";
	}, RangeError);
	E("ERR_INVALID_ARG_TYPE", function(name, actual) {
		return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
	}, TypeError);
	E("ERR_OUT_OF_RANGE", function(str, range, input) {
		let msg = `The value of "${str}" is out of range.`;
		let received = input;
		if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
		else if (typeof input === "bigint") {
			received = String(input);
			if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
			received += "n";
		}
		msg += ` It must be ${range}. Received ${received}`;
		return msg;
	}, RangeError);
	function addNumericalSeparator(val) {
		let res = "";
		let i = val.length;
		const start = val[0] === "-" ? 1 : 0;
		for (; i >= start + 4; i -= 3) res = `_${val.slice(i - 3, i)}${res}`;
		return `${val.slice(0, i)}${res}`;
	}
	function checkBounds(buf, offset, byteLength) {
		validateNumber(offset, "offset");
		if (buf[offset] === void 0 || buf[offset + byteLength] === void 0) boundsError(offset, buf.length - (byteLength + 1));
	}
	function checkIntBI(value, min, max, buf, offset, byteLength) {
		if (value > max || value < min) {
			const n = typeof min === "bigint" ? "n" : "";
			let range;
			if (byteLength > 3) if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
			else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength + 1) * 8 - 1}${n}`;
			else range = `>= ${min}${n} and <= ${max}${n}`;
			throw new errors.ERR_OUT_OF_RANGE("value", range, value);
		}
		checkBounds(buf, offset, byteLength);
	}
	function validateNumber(value, name) {
		if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
	}
	function boundsError(value, length, type) {
		if (Math.floor(value) !== value) {
			validateNumber(value, type);
			throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
		}
		if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
		throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
	}
	const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
	function base64clean(str) {
		str = str.split("=")[0];
		str = str.trim().replace(INVALID_BASE64_RE, "");
		if (str.length < 2) return "";
		while (str.length % 4 !== 0) str = str + "=";
		return str;
	}
	function utf8ToBytes(string, units) {
		units = units || Infinity;
		let codePoint;
		const length = string.length;
		let leadSurrogate = null;
		const bytes = [];
		for (let i = 0; i < length; ++i) {
			codePoint = string.charCodeAt(i);
			if (codePoint > 55295 && codePoint < 57344) {
				if (!leadSurrogate) {
					if (codePoint > 56319) {
						if ((units -= 3) > -1) bytes.push(239, 191, 189);
						continue;
					} else if (i + 1 === length) {
						if ((units -= 3) > -1) bytes.push(239, 191, 189);
						continue;
					}
					leadSurrogate = codePoint;
					continue;
				}
				if (codePoint < 56320) {
					if ((units -= 3) > -1) bytes.push(239, 191, 189);
					leadSurrogate = codePoint;
					continue;
				}
				codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
			} else if (leadSurrogate) {
				if ((units -= 3) > -1) bytes.push(239, 191, 189);
			}
			leadSurrogate = null;
			if (codePoint < 128) {
				if ((units -= 1) < 0) break;
				bytes.push(codePoint);
			} else if (codePoint < 2048) {
				if ((units -= 2) < 0) break;
				bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
			} else if (codePoint < 65536) {
				if ((units -= 3) < 0) break;
				bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
			} else if (codePoint < 1114112) {
				if ((units -= 4) < 0) break;
				bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
			} else throw new Error("Invalid code point");
		}
		return bytes;
	}
	function asciiToBytes(str) {
		const byteArray = [];
		for (let i = 0; i < str.length; ++i) byteArray.push(str.charCodeAt(i) & 255);
		return byteArray;
	}
	function utf16leToBytes(str, units) {
		let c, hi, lo;
		const byteArray = [];
		for (let i = 0; i < str.length; ++i) {
			if ((units -= 2) < 0) break;
			c = str.charCodeAt(i);
			hi = c >> 8;
			lo = c % 256;
			byteArray.push(lo);
			byteArray.push(hi);
		}
		return byteArray;
	}
	function base64ToBytes(str) {
		return base64.toByteArray(base64clean(str));
	}
	function blitBuffer(src, dst, offset, length) {
		let i;
		for (i = 0; i < length; ++i) {
			if (i + offset >= dst.length || i >= src.length) break;
			dst[i + offset] = src[i];
		}
		return i;
	}
	function isInstance(obj, type) {
		return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
	}
	function numberIsNaN(obj) {
		return obj !== obj;
	}
	const hexSliceLookupTable = (function() {
		const alphabet = "0123456789abcdef";
		const table = new Array(256);
		for (let i = 0; i < 16; ++i) {
			const i16 = i * 16;
			for (let j = 0; j < 16; ++j) table[i16 + j] = alphabet[i] + alphabet[j];
		}
		return table;
	})();
	function defineBigIntMethod(fn) {
		return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
	}
	function BufferBigIntNotDefined() {
		throw new Error("BigInt not supported");
	}
})(buffer);
var Buffer = buffer.Buffer;
buffer.Blob;
buffer.BlobOptions;
buffer.Buffer;
buffer.File;
buffer.FileOptions;
buffer.INSPECT_MAX_BYTES;
buffer.SlowBuffer;
buffer.TranscodeEncoding;
buffer.atob;
buffer.btoa;
buffer.constants;
buffer.isAscii;
buffer.isUtf8;
buffer.kMaxLength;
buffer.kStringMaxLength;
buffer.resolveObjectURL;
buffer.transcode;
//#endregion
//#region src/shared/p2p-media-loader/segment-validator.ts
var debugLogger$4 = (0, import_browser.default)("peertube:player:segment-validator");
var maxRetries = 10;
var SegmentValidator = class {
	destroyed = false;
	segmentJSONPromise;
	constructor(options) {
		this.options = options;
	}
	async validate(url, byteRange, data, retry = 1) {
		if (this.destroyed) return false;
		this.loadSha256SegmentsPromiseIfNeeded();
		const filename = removeQueryParams(url).split("/").pop();
		const segmentValue = (await this.segmentJSONPromise)[filename];
		if (!segmentValue && retry > maxRetries) {
			logger$1.clientError(`Unknown segment name ${filename} in segment validator`);
			return false;
		}
		if (!segmentValue) {
			logger$1.info(`Refetching sha segments for ${filename}`);
			await wait(500);
			this.loadSha256SegmentsPromise();
			return this.validate(url, byteRange, data, retry + 1);
		}
		let hashShouldBe;
		let range = "";
		if (typeof segmentValue === "string") hashShouldBe = segmentValue;
		else {
			range = byteRange.start + "-" + byteRange.end;
			hashShouldBe = segmentValue[range];
		}
		if (hashShouldBe === void 0) {
			logger$1.clientError(`Unknown segment name ${filename}/${range} in segment validator`);
			return false;
		}
		debugLogger$4(`Validating ${filename}` + (range ? ` range ${range}` : ""));
		const calculatedSha = await this.sha256Hex(data);
		if (calculatedSha !== hashShouldBe) {
			logger$1.clientError(`Hashes does not correspond for segment ${filename}/${range} (expected: ${hashShouldBe} instead of ${calculatedSha})`);
			return true;
		}
	}
	destroy() {
		this.destroyed = true;
	}
	loadSha256SegmentsPromiseIfNeeded() {
		if (this.segmentJSONPromise) return;
		this.loadSha256SegmentsPromise();
	}
	loadSha256SegmentsPromise() {
		this.segmentJSONPromise = this.fetchSha256Segments();
	}
	fetchSha256Segments() {
		let headers = {};
		if (isSameOrigin(this.options.serverUrl, this.options.segmentsSha256Url)) {
			if (this.options.requiresPassword) headers = { "x-peertube-video-password": this.options.videoPassword() };
			else if (this.options.requiresUserAuth) headers = { Authorization: this.options.authorizationHeader() };
		}
		return fetch(this.options.segmentsSha256Url, { headers }).then((res) => res.json()).catch((err) => {
			logger$1.clientError("Cannot get sha256 segments", err);
			return {};
		});
	}
	async sha256Hex(data) {
		if (!data) return void 0;
		if (window.crypto.subtle) return window.crypto.subtle.digest("SHA-256", data).then((data) => this.bufferToHex(data));
		return new (await (import("./sha.js-C7oTT3Ch.js").then((m) => /* @__PURE__ */ __toESM(m.default, 1)))).default.sha256().update(Buffer.from(data)).digest("hex");
	}
	bufferToHex(buffer) {
		if (!buffer) return "";
		let s = "";
		const h = "0123456789abcdef";
		new Uint8Array(buffer).forEach((v) => {
			s += h[v >> 4] + h[v & 15];
		});
		return s;
	}
};
//#endregion
//#region src/shared/player-options-builder/hls-options-builder.ts
var debugLogger$3 = (0, import_browser.default)("peertube:player:hls");
var HLSOptionsBuilder = class {
	constructor(options) {
		this.options = options;
	}
	async getPluginOptions() {
		const segmentsSha256Url = this.options.hls.segmentsSha256Url;
		if (!segmentsSha256Url) logger$1.info("No segmentsSha256Url found. Disabling P2P & redundancy.");
		const redundancyUrlManager = segmentsSha256Url ? new RedundancyUrlManager(this.options.hls.redundancyBaseUrls) : null;
		const segmentValidator = segmentsSha256Url ? new SegmentValidator({
			segmentsSha256Url,
			authorizationHeader: this.options.authorizationHeader,
			requiresUserAuth: this.options.requiresUserAuth,
			serverUrl: this.options.serverUrl,
			requiresPassword: this.options.requiresPassword,
			videoPassword: this.options.videoPassword
		}) : null;
		const p2pMediaLoaderConfig = await this.options.pluginsManager.runHook("filter:internal.player.p2p-media-loader.options.result", this.getP2PMediaLoaderOptions({
			redundancyUrlManager,
			segmentValidator
		}));
		const p2pMediaLoader = {
			requiresUserAuth: this.options.requiresUserAuth,
			videoFileToken: this.options.videoFileToken,
			p2pEnabled: segmentsSha256Url && this.options.p2pEnabled,
			redundancyUrlManager,
			type: "application/x-mpegURL",
			src: this.options.hls.playlistUrl,
			segmentValidator
		};
		const hlsjs = {
			hlsjsConfig: this.getHLSJSOptions(p2pMediaLoaderConfig),
			levelLabelHandler: (level, player) => {
				const resolution = Math.min(level.height || 0, level.width || 0);
				const file = this.options.hls.videoFiles.find((f) => f.resolution.id === resolution);
				const resolutionLabel = getResolutionLabel({
					resolution,
					height: file?.height ?? level.height,
					width: file?.width ?? level.width
				});
				return player.localize(getResolutionAndFPSLabel(resolutionLabel, file?.fps ?? level.frameRate));
			}
		};
		debugLogger$3("Creating HLS player options", {
			hlsjs,
			p2pMediaLoader,
			loaderOptions: p2pMediaLoaderConfig
		});
		return {
			p2pMediaLoader,
			hlsjs
		};
	}
	getP2PMediaLoaderOptions(options) {
		const { redundancyUrlManager, segmentValidator } = options;
		let isP2PUploadDisabled = false;
		if (navigator?.connection?.type === "cellular" || peertubeLocalStorage.getItem("peertube-videojs-p2p-consume-only") === "true") {
			logger$1.info("We are on a cellular connection: disabling seeding.");
			isP2PUploadDisabled = true;
		}
		const announceTrackers = this.options.hls.trackerAnnounce.filter((t) => t.startsWith("ws"));
		const specificLiveOrVODOptions = this.options.isLive ? this.getP2PMediaLoaderLiveOptions() : this.getP2PMediaLoaderVODOptions();
		return { loader: {
			announceTrackers,
			rtcConfig: getRtcConfig(this.options.stunServers),
			httpRequestSetup: (segmentUrlArg, segmentByteRange, requestAbortSignal, requestByteRange) => {
				const { requiresUserAuth, requiresPassword } = this.options;
				const segmentUrl = redundancyUrlManager ? redundancyUrlManager.buildUrl(segmentUrlArg) : segmentUrlArg;
				const headers = new Headers();
				if (requestByteRange) headers.set("Range", `bytes=${requestByteRange.start}-${requestByteRange.end ?? ""}`);
				if (isSameOrigin(this.options.serverUrl, segmentUrl)) {
					if (requiresPassword) headers.set("x-peertube-video-password", this.options.videoPassword());
					else if (requiresUserAuth) headers.set("Authorization", this.options.authorizationHeader());
				}
				return Promise.resolve(new Request(segmentUrl, {
					headers,
					signal: requestAbortSignal
				}));
			},
			validateP2PSegment: segmentValidator ? segmentValidator.validate.bind(segmentValidator) : null,
			validateHTTPSegment: segmentValidator ? segmentValidator.validate.bind(segmentValidator) : null,
			isP2PDisabled: !this.options.p2pEnabled,
			isP2PUploadDisabled,
			swarmId: this.options.hls.playlistUrl,
			...specificLiveOrVODOptions
		} };
	}
	getP2PMediaLoaderLiveOptions() {
		const base = { highDemandTimeWindow: 4 };
		switch (this.options.liveOptions.latencyMode) {
			case LiveVideoLatencyMode.SMALL_LATENCY: return {
				...base,
				isP2PDisabled: true
			};
			case LiveVideoLatencyMode.HIGH_LATENCY: return base;
			default: return base;
		}
	}
	getP2PMediaLoaderVODOptions() {
		return {
			highDemandTimeWindow: 15,
			segmentMemoryStorageLimit: 1024
		};
	}
	getHLSJSOptions(p2pMediaLoaderConfig) {
		const specificLiveOrVODOptions = this.options.isLive ? this.getHLSLiveOptions() : this.getHLSVODOptions();
		const base = {
			capLevelToPlayerSize: true,
			autoStartLoad: false,
			startPosition: exists(this.options.startTime) ? timeToInt(this.options.startTime) : -1,
			durationPlaceholder: this.options.duration,
			p2pMediaLoaderOptions: p2pMediaLoaderConfig.loader,
			xhrSetup: (xhr, url) => {
				const { requiresUserAuth, requiresPassword } = this.options;
				if (isSameOrigin(this.options.serverUrl, url)) {
					if (requiresPassword) xhr.setRequestHeader("x-peertube-video-password", this.options.videoPassword());
					else if (requiresUserAuth) xhr.setRequestHeader("Authorization", this.options.authorizationHeader());
				}
			},
			...specificLiveOrVODOptions
		};
		const averageBandwidth = getAverageBandwidthInStore();
		if (!averageBandwidth) return base;
		return {
			...base,
			abrEwmaDefaultEstimate: averageBandwidth * 8,
			backBufferLength: 90,
			startLevel: -1,
			testBandwidth: false,
			debug: false,
			enableWorker: false
		};
	}
	getHLSLiveOptions() {
		const latencyMode = this.options.liveOptions.latencyMode;
		const liveSyncDurationCountMap = {
			[LiveVideoLatencyMode.SMALL_LATENCY]: 2,
			[LiveVideoLatencyMode.DEFAULT]: 5,
			[LiveVideoLatencyMode.HIGH_LATENCY]: 10
		};
		return {
			liveDvrEnabled: this.options.liveOptions.dvrEnabled,
			liveSyncDurationCount: liveSyncDurationCountMap[latencyMode] ?? liveSyncDurationCountMap[LiveVideoLatencyMode.DEFAULT]
		};
	}
	getHLSVODOptions() {
		return {};
	}
};
//#endregion
//#region src/shared/player-options-builder/web-video-options-builder.ts
var WebVideoOptionsBuilder = class {
	constructor(options) {
		this.options = options;
	}
	getPluginOptions() {
		const videoFileToken = this.options.videoFileToken;
		const hlsFiles = this.options.hls?.videoFiles || [];
		const webVideoFiles = this.options.webVideo.videoFiles || [];
		if (webVideoFiles.length !== 0 && webVideoFiles.some((f) => f.resolution.id !== VideoResolution.H_NOVIDEO)) return {
			videoFileToken,
			videoFiles: webVideoFiles
		};
		if (hlsFiles.length !== 0 && hlsFiles.some((f) => f.resolution.id !== VideoResolution.H_NOVIDEO)) return {
			videoFileToken,
			videoFiles: hlsFiles
		};
		return {
			videoFileToken,
			videoFiles: webVideoFiles
		};
	}
};
//#endregion
//#region src/shared/playlist/playlist-button.ts
var ClickableComponent = import_core.default.getComponent("ClickableComponent");
var PlaylistButton = class extends ClickableComponent {
	constructor(player, options) {
		super(player, options);
	}
	createEl() {
		this.wrapper = super.createEl("div", {
			className: "vjs-playlist-button",
			tabIndex: -1
		});
		const icon = super.createEl("div", {
			className: "vjs-playlist-icon",
			tabIndex: -1
		});
		this.playlistInfoElement = super.createEl("div", {
			className: "vjs-playlist-info",
			tabIndex: -1
		});
		this.wrapper.appendChild(icon);
		this.wrapper.appendChild(this.playlistInfoElement);
		this.update();
		return this.wrapper;
	}
	update() {
		this.playlistInfoElement.innerText = this.options_.getCurrentPosition() + "/" + this.options_.playlist.videosLength;
		this.wrapper.title = this.player().localize("Playlist: {1}", [this.options_.playlist.displayName]);
	}
	handleClick() {
		this.options_.playlistMenu.open();
	}
};
import_core.default.registerComponent("PlaylistButton", PlaylistButton);
//#endregion
//#region src/shared/playlist/playlist-menu-item.ts
var Component$8 = import_core.default.getComponent("Component");
var PlaylistMenuItem = class extends Component$8 {
	constructor(player, options) {
		super(player, options);
		this.emitTapEvents();
		this.element = options.element;
		this.clickHandler = () => this.switchPlaylistItem();
		this.keyDownHandler = (event) => this.handleKeyDown(event);
		this.on(["click", "tap"], this.clickHandler);
		this.on("keydown", this.keyDownHandler);
	}
	dispose() {
		this.off(["click", "tap"], this.clickHandler);
		this.off("keydown", this.keyDownHandler);
		super.dispose();
	}
	createEl() {
		const li = super.createEl("li", { className: "vjs-playlist-menu-item" });
		if (!this.options_.element.video) li.classList.add("vjs-disabled");
		const positionBlock = super.createEl("div", { className: "item-position-block" });
		const position = super.createEl("div", {
			className: "item-position",
			innerText: this.options_.element.position
		});
		positionBlock.appendChild(position);
		li.appendChild(positionBlock);
		if (this.options_.element.video) this.buildAvailableVideo(li, positionBlock, this.options_);
		else this.buildUnavailableVideo(li);
		return li;
	}
	setSelected(selected) {
		if (selected) this.addClass("vjs-selected");
		else this.removeClass("vjs-selected");
	}
	getElement() {
		return this.element;
	}
	buildAvailableVideo(li, positionBlock, options) {
		const videoElement = options.element;
		const player = super.createEl("div", { className: "item-player" });
		positionBlock.appendChild(player);
		const thumbnail = super.createEl("img", { src: videoElement.video.thumbnails.length !== 0 ? findAppropriateThumbnail(videoElement.video.thumbnails, 80, "16:9").fileUrl : "" });
		const infoBlock = super.createEl("div", { className: "info-block" });
		const title = super.createEl("div", {
			innerText: videoElement.video.name,
			className: "title"
		});
		const channel = super.createEl("div", {
			innerText: videoElement.video.channel.displayName,
			className: "channel"
		});
		infoBlock.appendChild(title);
		infoBlock.appendChild(channel);
		if (videoElement.startTimestamp || videoElement.stopTimestamp) {
			let html = "";
			if (videoElement.startTimestamp) html += secondsToTime(videoElement.startTimestamp);
			if (videoElement.stopTimestamp) html += " - " + secondsToTime(videoElement.stopTimestamp);
			const timestamps = super.createEl("div", {
				innerText: html,
				className: "timestamps"
			});
			infoBlock.append(timestamps);
		}
		li.append(thumbnail);
		li.append(infoBlock);
	}
	buildUnavailableVideo(li) {
		const block = super.createEl("div", {
			className: "item-unavailable",
			innerText: this.player().localize("Unavailable video")
		});
		li.appendChild(block);
	}
	handleKeyDown(event) {
		if (event.code === "Space" || event.code === "Enter") this.switchPlaylistItem();
	}
	switchPlaylistItem() {
		this.options_.onClicked();
	}
};
import_core.default.registerComponent("PlaylistMenuItem", PlaylistMenuItem);
//#endregion
//#region src/shared/playlist/playlist-menu.ts
var Component$7 = import_core.default.getComponent("Component");
var PlaylistMenu = class extends Component$7 {
	constructor(player, options) {
		super(player, options);
		this.menuItems = [];
		this.userInactiveHandler = () => {
			this.close();
		};
		this.onMouseEnter = () => {
			this.player().off("userinactive", this.userInactiveHandler);
		};
		this.onMouseLeave = () => {
			this.player().one("userinactive", this.userInactiveHandler);
		};
		this.onPlayerCick = (event) => {
			let current = event.target;
			do {
				if (current.classList.contains("vjs-playlist-menu") || current.classList.contains("vjs-playlist-button")) return;
				current = current.parentElement;
			} while (current);
			this.close();
		};
		this.el().addEventListener("mouseenter", this.onMouseEnter);
		this.el().addEventListener("mouseleave", this.onMouseLeave);
		this.player().on("click", this.onPlayerCick);
	}
	dispose() {
		this.el().removeEventListener("mouseenter", this.onMouseEnter);
		this.el().removeEventListener("mouseleave", this.onMouseLeave);
		this.player().off("userinactive", this.userInactiveHandler);
		this.player().off("click", this.onPlayerCick);
		for (const item of this.menuItems) item.dispose();
		super.dispose();
	}
	createEl() {
		this.menuItems = [];
		const menu = super.createEl("div", {
			className: "vjs-playlist-menu",
			tabIndex: -1
		});
		const header = super.createEl("div", { className: "header" });
		const headerLeft = super.createEl("div");
		const leftTitle = super.createEl("div", {
			innerText: this.options_.playlist.displayName,
			className: "title"
		});
		const playlistChannel = this.options_.playlist.videoChannel;
		const leftSubtitle = super.createEl("div", {
			innerText: playlistChannel ? this.player().localize("By {1}", [playlistChannel.displayName]) : "",
			className: "channel"
		});
		headerLeft.appendChild(leftTitle);
		headerLeft.appendChild(leftSubtitle);
		const tick = super.createEl("div", { className: "cross" });
		tick.addEventListener("click", () => this.close());
		header.appendChild(headerLeft);
		header.appendChild(tick);
		const list = super.createEl("ol");
		for (const playlistElement of this.options_.elements) {
			const item = new PlaylistMenuItem(this.player(), {
				element: playlistElement,
				onClicked: () => this.onItemClicked(playlistElement)
			});
			list.appendChild(item.el());
			this.menuItems.push(item);
		}
		menu.appendChild(header);
		menu.appendChild(list);
		this.update();
		return menu;
	}
	update() {
		this.updateSelected(this.options_.getCurrentPosition());
	}
	open() {
		this.player().addClass("playlist-menu-displayed");
	}
	close() {
		this.player().removeClass("playlist-menu-displayed");
	}
	updateSelected(newPosition) {
		for (const item of this.menuItems) item.setSelected(item.getElement().position === newPosition);
	}
	onItemClicked(element) {
		this.options_.onItemClicked(element);
	}
};
import_core.default.registerComponent("PlaylistMenu", PlaylistMenu);
//#endregion
//#region src/shared/playlist/playlist-plugin.ts
var Plugin$4 = import_core.default.getPlugin("plugin");
var PlaylistPlugin = class extends Plugin$4 {
	constructor(player, options) {
		super(player);
		this.player.addClass("vjs-playlist");
		this.playlistMenu = new PlaylistMenu(player, options);
		this.playlistButton = new PlaylistButton(player, {
			...options,
			playlistMenu: this.playlistMenu
		});
		player.addChild(this.playlistMenu, options);
		player.addChild(this.playlistButton, options);
	}
	dispose() {
		this.player.removeClass("vjs-playlist");
		this.playlistMenu.dispose();
		this.playlistButton.dispose();
		this.player.removeChild(this.playlistMenu);
		this.player.removeChild(this.playlistButton);
		super.dispose();
	}
};
import_core.default.registerPlugin("playlist", PlaylistPlugin);
//#endregion
//#region src/shared/resolutions/peertube-resolutions-plugin.ts
var Plugin$3 = import_core.default.getPlugin("plugin");
var PeerTubeResolutionsPlugin = class extends Plugin$3 {
	constructor(player) {
		super(player);
		this.resolutions = [];
		player.on("video-change", () => {
			this.resolutions = [];
			this.trigger("resolutions-removed");
		});
	}
	add(resolutions) {
		for (const r of resolutions) this.resolutions.push(r);
		this.currentSelection = this.getSelected();
		this.sort();
		this.trigger("resolutions-added");
	}
	remove(resolutionIndex) {
		this.resolutions = this.resolutions.filter((r) => r.id !== resolutionIndex);
		this.trigger("resolutions-removed");
	}
	getResolutions() {
		return this.resolutions;
	}
	getSelected() {
		return this.resolutions.find((r) => r.selected);
	}
	getAutoResolutionChosen() {
		return this.resolutions.find((r) => r.id === this.autoResolutionChosenId);
	}
	select(options) {
		const { id, autoResolutionChosenId, fireCallback } = options;
		if (this.currentSelection?.id === id && this.autoResolutionChosenId === autoResolutionChosenId) return;
		if (autoResolutionChosenId !== void 0) this.autoResolutionChosenId = autoResolutionChosenId;
		for (const r of this.resolutions) {
			r.selected = r.id === id;
			if (r.selected) {
				this.currentSelection = r;
				if (fireCallback) r.selectCallback();
			}
		}
		this.trigger("resolutions-changed");
	}
	sort() {
		this.resolutions.sort((a, b) => {
			if (a.id === -1) return 1;
			if (b.id === -1) return -1;
			if (a.height > b.height) return -1;
			if (a.height === b.height) return 0;
			return 1;
		});
	}
};
import_core.default.registerPlugin("peertubeResolutions", PeerTubeResolutionsPlugin);
//#endregion
//#region src/shared/settings/menu-focus-fixed.ts
var Menu$2 = import_core.default.getComponent("Menu");
var MenuFocusFixed = class extends Menu$2 {
	stepForward() {
		let stepChild = 0;
		if (this.focusedChild_ !== void 0) stepChild = this.focusedChild_ + 1;
		this.focus(stepChild);
	}
	stepBack() {
		let stepChild = 0;
		if (this.focusedChild_ !== void 0) stepChild = this.focusedChild_ - 1;
		this.focus(stepChild);
	}
	focus(item) {
		if (item === void 0) {
			this.focusedChild_ = -1;
			item = 0;
		}
		this._focus(item);
	}
	_focus(item) {
		const children = this.children().slice();
		if (children.length && children[0].hasClass("vjs-menu-title")) children.shift();
		if (children.length > 0) {
			if (item < 0) item = 0;
			else if (item >= children.length) item = children.length - 1;
			const el = children[item].el();
			if (el.classList.contains("vjs-hidden")) if (this.focusedChild_ < item) {
				if (item === children.length - 1) return;
				return this.focus(item + 1);
			} else {
				if (item === 0) return;
				return this.focus(item - 1);
			}
			this.focusedChild_ = item;
			el.focus();
		}
	}
};
import_core.default.registerComponent("MenuFocusFixed", MenuFocusFixed);
//#endregion
//#region src/shared/settings/resolution-menu-item.ts
var MenuItem$2 = import_core.default.getComponent("MenuItem");
var ResolutionMenuItem = class extends MenuItem$2 {
	constructor(player, options) {
		super(player, {
			...options,
			selectable: true
		});
		this.autoResolutionChosen = "";
		this.resolutionId = options.resolutionId;
		this.label = options.label;
		this.updateSelectionHandler = () => this.updateSelection();
		player.peertubeResolutions().on("resolutions-changed", this.updateSelectionHandler);
	}
	dispose() {
		this.player().peertubeResolutions().off("resolutions-changed", this.updateSelectionHandler);
		super.dispose();
	}
	handleClick(event) {
		super.handleClick(event);
		this.player().peertubeResolutions().select({
			id: this.resolutionId,
			fireCallback: true
		});
		if (this.resolutionId === -1) {
			clearStoredPreferredResolution();
			return;
		}
		const selectedResolution = this.player().peertubeResolutions().getResolutions().find((r) => r.id === this.resolutionId);
		if (selectedResolution?.height === void 0) return;
		savePreferredResolution(selectedResolution.height);
	}
	updateSelection() {
		const selectedResolution = this.player().peertubeResolutions().getSelected();
		if (this.resolutionId === -1) this.autoResolutionChosen = this.player().peertubeResolutions().getAutoResolutionChosen()?.label;
		this.selected(this.resolutionId === selectedResolution.id);
	}
	getLabel() {
		if (this.resolutionId === -1) return this.label + " <small>" + this.autoResolutionChosen + "</small>";
		return this.label;
	}
};
import_core.default.registerComponent("ResolutionMenuItem", ResolutionMenuItem);
//#endregion
//#region src/shared/settings/resolution-menu-button.ts
var Menu$1 = import_core.default.getComponent("Menu");
var MenuButton$1 = import_core.default.getComponent("MenuButton");
var ResolutionMenuButton = class extends MenuButton$1 {
	constructor(player, options) {
		super(player, options);
		this.controlText("Quality");
		player.peertubeResolutions().on("resolutions-added", () => this.update());
		player.peertubeResolutions().on("resolutions-removed", () => this.update());
		player.peertubeResolutions().on("resolutions-changed", () => {
			setTimeout(() => this.trigger("label-updated"));
		});
	}
	createEl() {
		const el = super.createEl();
		this.labelEl_ = import_core.default.dom.createEl("div", { className: "vjs-resolution-value" });
		el.appendChild(this.labelEl_);
		return el;
	}
	updateARIAAttributes() {
		this.el().setAttribute("aria-label", "Quality");
	}
	createMenu() {
		const menu = new Menu$1(this.player_, { menuButton: this });
		const resolutions = this.player().peertubeResolutions().getResolutions();
		for (const r of resolutions) {
			const label = r.label === "0p" ? this.player().localize("Audio only") : r.label;
			const component = new ResolutionMenuItem(this.player_, {
				id: r.id + "",
				resolutionId: r.id,
				label,
				selected: r.selected
			});
			menu.addItem(component);
		}
		return menu;
	}
	update() {
		super.update();
		this.trigger("resolution-menu-changed");
	}
	buildCSSClass() {
		return "vjs-resolution-button " + super.buildCSSClass();
	}
	buildWrapperCSSClass() {
		return "vjs-resolution-control " + super.buildWrapperCSSClass();
	}
};
import_core.default.registerComponent("ResolutionMenuButton", ResolutionMenuButton);
//#endregion
//#region src/shared/video-filter/video-filter-menu-item.ts
var MenuItem$1 = import_core.default.getComponent("MenuItem");
var VideoFilterMenuItem = class extends MenuItem$1 {
	menuLabel;
	videoFilter;
	constructor(player, options) {
		super(player, {
			...options,
			selectable: true
		});
		this.videoFilter = options.videoFilter || "";
		this.menuLabel = options.menuLabel || "";
		this.player().on(`${this.videoFilter}-on`, () => {
			this.selected(true);
			this.trigger("selected-updated");
		});
		this.player().on(`${this.videoFilter}-off`, () => {
			this.selected(false);
			this.trigger("selected-updated");
		});
	}
	handleClick() {
		if (this.isSelected_) this.player_.trigger(`${this.videoFilter}-off`);
		else this.player_.trigger(`${this.videoFilter}-on`);
	}
	getLabel() {
		return this.menuLabel;
	}
};
import_core.default.registerComponent("VideoFilterMenuItem", VideoFilterMenuItem);
//#endregion
//#region src/shared/video-filter/video-filter-menu-button.ts
var Menu = import_core.default.getComponent("Menu");
var MenuButton = import_core.default.getComponent("MenuButton");
var VideoFilterMenuButton = class extends MenuButton {
	constructor(player, options) {
		super(player, options);
		this.controlText(this.player().localize("Video Filter"));
	}
	createMenu() {
		const menu = new Menu(this.player_, { menuButton: this });
		const item = new VideoFilterMenuItem(this.player_, {
			label: this.player().localize("Mirror Video"),
			menuLabel: this.player().localize("Mirror"),
			videoFilter: "video-flip-horizontally"
		});
		item.on("selected-updated", () => {
			this.trigger("label-updated");
		});
		menu.addItem(item);
		return menu;
	}
	buildCSSClass() {
		return "vjs-video-filter-button " + super.buildCSSClass();
	}
	buildWrapperCSSClass() {
		return "vjs-video-filter-control " + super.buildWrapperCSSClass();
	}
};
import_core.default.registerComponent("VideoFilterMenuButton", VideoFilterMenuButton);
//#endregion
//#region src/shared/settings/settings-dialog.ts
var Component$6 = import_core.default.getComponent("Component");
var SettingsDialog = class extends Component$6 {
	constructor(player) {
		super(player);
		this.hide();
	}
	/**
	* Create the component's DOM element
	*/
	createEl() {
		const uniqueId = this.player().id();
		const dialogLabelId = "TTsettingsDialogLabel-" + uniqueId;
		const dialogDescriptionId = "TTsettingsDialogDescription-" + uniqueId;
		return super.createEl("div", {
			className: "vjs-settings-dialog vjs-modal-overlay",
			id: "vjs-settings-dialog-" + uniqueId,
			tabIndex: -1
		}, {
			"role": "dialog",
			"aria-labelledby": dialogLabelId,
			"aria-describedby": dialogDescriptionId
		});
	}
	show() {
		this.player().addClass("vjs-settings-dialog-opened");
		super.show();
	}
	hide() {
		this.player().removeClass("vjs-settings-dialog-opened");
		super.hide();
	}
};
import_core.default.registerComponent("SettingsDialog", SettingsDialog);
//#endregion
//#region src/shared/settings/settings-menu-item.ts
var debugLogger$2 = (0, import_browser.default)("peertube:player:settings");
var MenuItem = import_core.default.getComponent("MenuItem");
var Component$5 = import_core.default.getComponent("Component");
var SettingsMenuItem = class extends MenuItem {
	constructor(player, options) {
		super(player, options);
		this.settingsButton = options.menuButton;
		this.dialog = this.settingsButton.dialog;
		this.mainMenu = this.settingsButton.menu;
		this.panel = this.dialog.getChild("settingsPanel");
		this.panelChild = this.panel.getChild("settingsPanelChild");
		this.panelChildEl = this.panelChild.el();
		this.size = null;
		this.menuToLoad = "mainmenu";
		const subMenuName = toTitleCase(options.entry);
		const SubMenuComponent = import_core.default.getComponent(subMenuName);
		if (!SubMenuComponent) throw new Error(`Component ${subMenuName} does not exist`);
		this.subMenu = new SubMenuComponent(this.player(), { ...options });
		const subMenuClass = this.subMenu.buildCSSClass().split(" ")[0];
		this.settingsSubMenuEl_.className += " " + subMenuClass;
		this.eventHandlers();
		player.ready(() => {
			setTimeout(() => {
				if (!this.player_) return;
				this.build();
				if (subMenuName === "PlaybackRateMenuButton") {
					player.on("ratechange", this.submenuClickHandler);
					player.on("playbackrateschange", () => {
						setTimeout(() => this.rebuildAfterMenuChange());
					});
				}
				if (subMenuName === "CaptionsButton") {
					player.on("captions-changed", () => {
						setTimeout(() => this.rebuildAfterMenuChange());
					});
					player.on("texttrackchange", this.submenuClickHandler);
				}
				if (subMenuName === "ResolutionMenuButton") this.subMenu.on("resolution-menu-changed", () => {
					this.rebuildAfterMenuChange();
				});
				this.reset();
			}, 0);
		});
	}
	dispose() {
		this.settingsSubMenuEl_.removeEventListener("transitionend", this.transitionEndHandler);
		super.dispose();
	}
	eventHandlers() {
		this.submenuClickHandler = this.onSubmenuClick.bind(this);
		this.transitionEndHandler = this.onTransitionEnd.bind(this);
	}
	onSubmenuClick(event) {
		let target = null;
		if (event.type === "tap") target = event.target;
		else target = event.currentTarget || event.target;
		if (target?.classList.contains("vjs-back-button")) {
			this.loadMainMenu();
			return;
		}
		setTimeout(() => this.update(event), 0);
		this.subMenu.menu.removeClass("vjs-hidden");
	}
	/**
	* Create the component's DOM element
	*/
	createEl() {
		const el = import_core.default.dom.createEl("li", {
			className: "vjs-menu-item",
			tabIndex: 0
		});
		this.settingsSubMenuTitleEl_ = import_core.default.dom.createEl("div", { className: "vjs-settings-sub-menu-title" });
		el.appendChild(this.settingsSubMenuTitleEl_);
		this.settingsSubMenuValueEl_ = import_core.default.dom.createEl("div", { className: "vjs-settings-sub-menu-value" });
		el.appendChild(this.settingsSubMenuValueEl_);
		this.settingsSubMenuEl_ = import_core.default.dom.createEl("div", { className: "vjs-settings-sub-menu" });
		return el;
	}
	/**
	* Handle click on menu item
	*
	* @method handleClick
	*/
	handleClick(event) {
		this.menuToLoad = "submenu";
		import_core.default.dom.removeClass(this.el(), "open");
		super.handleClick(event);
		this.mainMenu.el().style.opacity = "0";
		if (import_core.default.dom.hasClass(this.settingsSubMenuEl_, "vjs-hidden")) {
			import_core.default.dom.removeClass(this.settingsSubMenuEl_, "vjs-hidden");
			setTimeout(() => {
				this.settingsSubMenuEl_.style.opacity = "1";
				this.settingsSubMenuEl_.style.marginRight = "0px";
			}, 0);
			this.settingsButton.setDialogSize(this.size);
			this.subMenu.menu.focus();
		} else import_core.default.dom.addClass(this.settingsSubMenuEl_, "vjs-hidden");
	}
	/**
	* Create back button
	*
	* @method createBackButton
	*/
	createBackButton() {
		const button = this.subMenu.menu.addChild("MenuItem", {}, 0);
		button.setAttribute("aria-label", this.player().localize("Go back"));
		button.addClass("vjs-back-button");
		button.el().innerHTML = this.player().localize(this.subMenu.controlText());
	}
	onTransitionEnd(event) {
		if (event.propertyName !== "margin-right") return;
		if (this.menuToLoad === "mainmenu") {
			import_core.default.dom.addClass(this.settingsSubMenuEl_, "vjs-hidden");
			this.settingsSubMenuEl_.style.opacity = "0";
		}
	}
	reset() {
		import_core.default.dom.addClass(this.settingsSubMenuEl_, "vjs-hidden");
		this.settingsSubMenuEl_.style.opacity = "0";
		this.setMargin();
	}
	loadMainMenu() {
		const mainMenuEl = this.mainMenu.el();
		this.menuToLoad = "mainmenu";
		this.mainMenu.show();
		mainMenuEl.style.opacity = "0";
		this.settingsButton.setDialogSize([this.mainMenu.width(), this.mainMenu.height()]);
		setTimeout(() => {
			this.setMargin();
			mainMenuEl.style.opacity = "1";
			this.mainMenu.focus();
		}, 0);
	}
	build() {
		this.subMenu.on("label-updated", () => {
			this.update();
		});
		this.settingsSubMenuTitleEl_.innerHTML = this.player().localize(this.subMenu.controlText());
		this.settingsSubMenuEl_.appendChild(this.subMenu.menu.el());
		this.panelChildEl.appendChild(this.settingsSubMenuEl_);
		this.update();
		this.createBackButton();
		this.setSize();
		this.bindClickEvents();
		this.bindKeyEvents();
		this.settingsSubMenuEl_.addEventListener("transitionend", this.transitionEndHandler, false);
	}
	update(event) {
		if (this.subMenu.name() === "PlaybackRateMenuButton") this.settingsSubMenuValueEl_.innerHTML = this.subMenu.labelEl_.textContent;
		else {
			let innerHTML = "";
			for (const subMenuItem of this.subMenu.menu.children_) {
				if (!(subMenuItem instanceof MenuItem)) continue;
				const subMenuItemExtended = subMenuItem;
				if (subMenuItemExtended.isSelected_) if (typeof subMenuItemExtended.getLabel === "function") innerHTML += subMenuItemExtended.getLabel();
				else innerHTML += this.player().localize(subMenuItemExtended.options_.label);
			}
			this.settingsSubMenuValueEl_.innerHTML = innerHTML;
		}
		let target = null;
		if (event?.type === "tap") target = event.target;
		else if (event) target = event.currentTarget;
		if (target && !target.classList.contains("vjs-back-button")) this.settingsButton.hideDialog();
	}
	bindClickEvents() {
		for (const item of this.subMenu.menu.children()) {
			if (!(item instanceof Component$5)) continue;
			item.on(["tap", "click"], this.submenuClickHandler);
		}
	}
	bindKeyEvents() {
		this.subMenu.menu.on("escaped-key", () => {
			this.trigger("escaped-key");
		});
		this.subMenu.menu.on("arrow-left", () => {
			debugLogger$2("Detected arrow left on sub menu " + this.subMenu.name());
			this.loadMainMenu();
		});
	}
	setSize() {
		this.dialog.removeClass("vjs-hidden");
		import_core.default.dom.removeClass(this.settingsSubMenuEl_, "vjs-hidden");
		this.size = this.settingsButton.getComponentSize(this.settingsSubMenuEl_);
		this.setMargin();
		this.dialog.addClass("vjs-hidden");
		import_core.default.dom.addClass(this.settingsSubMenuEl_, "vjs-hidden");
	}
	setMargin() {
		if (!this.size) return;
		const [width] = this.size;
		this.settingsSubMenuEl_.style.marginRight = `-${width}px`;
	}
	/**
	* Hide the sub menu
	*/
	hideSubMenu() {
		if (!this.el()) return;
		if (import_core.default.dom.hasClass(this.el(), "open")) {
			import_core.default.dom.addClass(this.settingsSubMenuEl_, "vjs-hidden");
			import_core.default.dom.removeClass(this.el(), "open");
		}
	}
	rebuildAfterMenuChange() {
		debugLogger$2("Rebuilding menu " + this.subMenu.name() + " after change");
		this.settingsSubMenuEl_.innerHTML = "";
		this.settingsSubMenuEl_.appendChild(this.subMenu.menu.el());
		this.update();
		this.createBackButton();
		this.setSize();
		this.bindClickEvents();
		this.bindKeyEvents();
	}
};
import_core.default.registerComponent("SettingsMenuItem", SettingsMenuItem);
//#endregion
//#region src/shared/settings/settings-menu-button.ts
var debugLogger$1 = (0, import_browser.default)("peertube:player:settings");
var Button = import_core.default.getComponent("Button");
var Component$4 = import_core.default.getComponent("Component");
var SettingsButton = class extends Button {
	constructor(player, options) {
		super(player, options);
		this.settingsButtonOptions = options;
		this.controlText("Settings");
		this.dialog = this.player().addChild("settingsDialog");
		this.dialogEl = this.dialog.el();
		this.menu = null;
		this.panel = this.dialog.addChild("settingsPanel");
		this.panelChild = this.panel.addChild("settingsPanelChild");
		this.addClass("vjs-settings");
		this.setAttribute("aria-controls", "vjs-settings-dialog-" + this.player().id());
		this.addSettingsItemHandler = this.onAddSettingsItem.bind(this);
		this.disposeSettingsItemHandler = this.onDisposeSettingsItem.bind(this);
		this.documentClickHandler = this.onDocumentClick.bind(this);
		this.userInactiveHandler = this.onUserInactive.bind(this);
		this.buildMenu();
		this.bindEvents();
		this.player().one("play", () => this.hideDialog());
	}
	onDocumentClick(event) {
		const element = event.target;
		if (element?.classList?.contains("vjs-settings") || element?.parentElement?.classList?.contains("vjs-settings")) return;
		if (!this.dialog.hasClass("vjs-hidden")) this.hideDialog();
	}
	onDisposeSettingsItem(_event, name) {
		if (name === void 0) {
			const children = this.menu.children();
			while (children.length > 0) {
				children[0].dispose();
				this.menu.removeChild(children[0]);
			}
			this.addClass("vjs-hidden");
		} else {
			const item = this.menu.getChild(name);
			if (item) {
				item.dispose();
				this.menu.removeChild(item);
			}
		}
		this.hideDialog();
		if (this.settingsButtonOptions.entries.length === 0) this.addClass("vjs-hidden");
	}
	dispose() {
		document.removeEventListener("click", this.documentClickHandler);
		if (this.isInIframe()) window.removeEventListener("blur", this.documentClickHandler);
		super.dispose();
	}
	onAddSettingsItem(event, data) {
		const [entry, options] = data;
		this.addMenuItem(entry, options);
		this.removeClass("vjs-hidden");
	}
	onUserInactive() {
		if (!this.dialog.hasClass("vjs-hidden")) this.hideDialog();
	}
	bindEvents() {
		document.addEventListener("click", this.documentClickHandler);
		if (this.isInIframe()) window.addEventListener("blur", this.documentClickHandler);
		this.player().on("addsettingsitem", this.addSettingsItemHandler);
		this.player().on("disposesettingsitem", this.disposeSettingsItemHandler);
		this.player().on("userinactive", this.userInactiveHandler);
	}
	buildCSSClass() {
		return `vjs-icon-settings ${super.buildCSSClass()}`;
	}
	handleClick() {
		if (this.dialog.hasClass("vjs-hidden")) this.showDialog();
		else this.hideDialog();
	}
	showDialog() {
		this.player().peertube().onMenuOpened();
		this.menu.el().style.opacity = "1";
		this.dialog.show();
		this.el().setAttribute("aria-expanded", "true");
		this.setDialogSize(this.getComponentSize(this.menu));
		this.menu.focus();
	}
	hideDialog() {
		this.player_.peertube().onMenuClosed();
		this.dialog.hide();
		this.el().setAttribute("aria-expanded", "false");
		this.setDialogSize(this.getComponentSize(this.menu));
		this.menu.el().style.opacity = "1";
		this.resetChildren();
	}
	getComponentSize(element) {
		let width = null;
		let height = null;
		if (element instanceof Component$4) {
			const el = element.el();
			width = el.offsetWidth;
			height = el.offsetHeight;
		} else {
			width = element.offsetWidth;
			height = element.offsetHeight;
		}
		return [width, height];
	}
	setDialogSize([width, height]) {
		if (typeof height !== "number") return;
		const offset = this.settingsButtonOptions.setup.maxHeightOffset;
		const maxHeight = this.player().el().offsetHeight - offset;
		const panelEl = this.panel.el();
		if (height > maxHeight) {
			height = maxHeight;
			width += 15;
			panelEl.style.maxHeight = `${height}px`;
		} else if (panelEl.style.maxHeight !== "") panelEl.style.maxHeight = "";
		this.dialogEl.style.width = `${width}px`;
		this.dialogEl.style.height = `${height}px`;
	}
	buildMenu() {
		this.menu = new MenuFocusFixed(this.player());
		this.menu.on("escaped-key", () => {
			this.hideDialog();
			this.focus();
		});
		this.menu.on("arrow-right", (_, el) => {
			debugLogger$1("Detected arrow right on menu item", el);
			el.click();
		});
		this.menu.addClass("vjs-main-menu");
		const entries = this.settingsButtonOptions.entries;
		if (entries.length === 0) {
			this.addClass("vjs-hidden");
			this.panelChild.addChild(this.menu);
			return;
		}
		for (const entry of entries) this.addMenuItem(entry, this.settingsButtonOptions);
		this.panelChild.addChild(this.menu);
	}
	addMenuItem(entry, options) {
		const openSubMenu = function() {
			if (import_core.default.dom.hasClass(this.el_, "open")) import_core.default.dom.removeClass(this.el_, "open");
			else import_core.default.dom.addClass(this.el_, "open");
		};
		options.name = toTitleCase(entry);
		const newOptions = Object.assign({}, options, {
			entry,
			menuButton: this
		});
		const settingsMenuItem = new SettingsMenuItem(this.player(), newOptions);
		this.menu.addChild(settingsMenuItem);
		settingsMenuItem.on("click", () => this.hideChildren());
		settingsMenuItem.on("click", openSubMenu);
		settingsMenuItem.on("escaped-key", () => {
			this.hideDialog();
			this.focus();
		});
	}
	resetChildren() {
		for (const menuChild of this.menu.children()) menuChild.reset();
	}
	/**
	* Hide all the sub menus
	*/
	hideChildren() {
		for (const menuChild of this.menu.children()) menuChild.hideSubMenu();
	}
	isInIframe() {
		return window.self !== window.top;
	}
};
import_core.default.registerComponent("SettingsButton", SettingsButton);
//#endregion
//#region src/shared/settings/settings-panel.ts
var Component$3 = import_core.default.getComponent("Component");
var SettingsPanel = class extends Component$3 {
	createEl() {
		return super.createEl("div", {
			className: "vjs-settings-panel",
			tabIndex: -1
		});
	}
};
import_core.default.registerComponent("SettingsPanel", SettingsPanel);
//#endregion
//#region src/shared/settings/settings-panel-child.ts
var Component$2 = import_core.default.getComponent("Component");
var SettingsPanelChild = class extends Component$2 {
	createEl() {
		return super.createEl("div", {
			className: "vjs-settings-panel-child",
			tabIndex: -1
		});
	}
};
import_core.default.registerComponent("SettingsPanelChild", SettingsPanelChild);
//#endregion
//#region src/shared/stats/stats-card.ts
var Component$1 = import_core.default.getComponent("Component");
var StatsCard = class extends Component$1 {
	constructor(player, options) {
		super(player, options);
		this.metadataStore = {};
		this.intervalMs = 300;
		this.playerNetworkInfo = {};
	}
	createEl() {
		this.containerEl = import_core.default.dom.createEl("div", { className: "vjs-stats-content" });
		this.containerEl.style.display = "none";
		this.infoListEl = import_core.default.dom.createEl("div", { className: "vjs-stats-list" });
		const closeButton = import_core.default.dom.createEl("button", {
			className: "vjs-stats-close",
			tabindex: "0",
			title: "Close stats",
			innerText: "[x]"
		}, { "aria-label": "Close stats" });
		closeButton.onclick = () => this.hide();
		this.containerEl.appendChild(closeButton);
		this.containerEl.appendChild(this.infoListEl);
		this.populateInfoBlocks();
		this.onNetworkInfoHandler = (_event, data) => {
			this.mode = data.source;
			const p2pStats = data.p2p;
			const httpStats = data.http;
			this.playerNetworkInfo.downloadSpeed = bytes((p2pStats?.downloadSpeed || 0) + (httpStats.downloadSpeed || 0)).join(" ");
			this.playerNetworkInfo.uploadSpeed = bytes(p2pStats?.uploadSpeed || 0).join(" ");
			this.playerNetworkInfo.totalDownloaded = bytes((p2pStats?.downloaded || 0) + httpStats.downloaded).join(" ");
			this.playerNetworkInfo.totalUploaded = bytes(p2pStats?.uploaded || 0).join(" ");
			this.playerNetworkInfo.numPeers = p2pStats?.peersWithWebSeed;
			if (data.source === "p2p-media-loader") {
				this.playerNetworkInfo.averageBandwidth = bytes(data.bandwidthEstimate).join(" ") + "/s";
				this.playerNetworkInfo.downloadedFromServer = bytes(httpStats.downloaded).join(" ");
				this.playerNetworkInfo.downloadedFromPeers = bytes(p2pStats?.downloaded || 0).join(" ");
			}
		};
		this.player().on("network-info", this.onNetworkInfoHandler);
		return this.containerEl;
	}
	dispose() {
		if (this.updateInterval) clearInterval(this.updateInterval);
		this.player().off("network-info", this.onNetworkInfoHandler);
		super.dispose();
	}
	toggle() {
		if (this.updateInterval) this.hide();
		else this.show();
	}
	show() {
		this.containerEl.style.display = "block";
		this.updateInterval = setInterval(async () => {
			if (!this.player() || !this.mode) return;
			try {
				const options = this.mode === "p2p-media-loader" ? this.buildHLSOptions() : await this.buildWebVideoOptions();
				if (!this.player()) return;
				this.populateInfoValues(options);
			} catch (err) {
				logger$1.error("Cannot update stats.", err);
				clearInterval(this.updateInterval);
			}
		}, this.intervalMs);
	}
	hide() {
		clearInterval(this.updateInterval);
		this.containerEl.style.display = "none";
	}
	buildHLSOptions() {
		const p2pMediaLoader = this.player_.p2pMediaLoader();
		const level = p2pMediaLoader.getCurrentLevel();
		const codecs = level?.videoCodec || level?.audioCodec ? `${level?.videoCodec || ""} / ${level?.audioCodec || ""}` : void 0;
		const resolution = level?.height ? `${level.height}p${level?.attrs["FRAME-RATE"] || ""}` : void 0;
		const buffer = this.timeRangesToString(this.player().buffered());
		let progress;
		let latency;
		let latencyFromEdge;
		if (this.options_.videoIsLive) {
			latency = secondsToTime(p2pMediaLoader.getLiveLatency());
			latencyFromEdge = secondsToTime(p2pMediaLoader.getLiveLatencyFromEdge());
		} else progress = this.player().bufferedPercent();
		return {
			playerNetworkInfo: this.playerNetworkInfo,
			resolution,
			codecs,
			buffer,
			latency,
			latencyFromEdge,
			progress
		};
	}
	async buildWebVideoOptions() {
		const videoFile = this.player_.webVideo().getCurrentVideoFile();
		if (!this.metadataStore[videoFile.fileUrl]) this.metadataStore[videoFile.fileUrl] = await fetch(videoFile.metadataUrl).then((res) => res.json());
		const metadata = this.metadataStore[videoFile.fileUrl];
		let colorSpace = "unknown";
		let codecs = "unknown";
		if (metadata?.streams?.[0]) {
			const stream = metadata.streams[0];
			colorSpace = stream["color_space"] !== "unknown" ? stream["color_space"] : "bt709";
			codecs = stream["codec_name"] || "avc1";
		}
		const resolution = videoFile?.resolution.label + videoFile?.fps;
		const buffer = this.timeRangesToString(this.player_.buffered());
		const progress = this.player_.bufferedPercent();
		return {
			playerNetworkInfo: this.playerNetworkInfo,
			progress,
			colorSpace,
			codecs,
			resolution,
			buffer
		};
	}
	populateInfoBlocks() {
		this.playerMode = this.buildInfoRow(this.player().localize("Player mode"));
		this.uuid = this.buildInfoRow(this.player().localize("Video UUID"));
		this.viewport = this.buildInfoRow(this.player().localize("Viewport / Frames"));
		this.resolution = this.buildInfoRow(this.player().localize("Resolution"));
		this.volume = this.buildInfoRow(this.player().localize("Volume"));
		this.codecs = this.buildInfoRow(this.player().localize("Codecs"));
		this.color = this.buildInfoRow(this.player().localize("Color"));
		this.bufferProgress = this.buildInfoRow(this.player().localize("Buffer Progress"));
		this.bufferState = this.buildInfoRow(this.player().localize("Buffer State"));
		this.p2p = this.buildInfoRow(this.player().localize("P2P"));
		this.peers = this.buildInfoRow(this.player().localize("Peers"));
		this.connection = this.buildInfoRow(this.player().localize("Connection Speed"));
		this.network = this.buildInfoRow(this.player().localize("Network Activity"));
		this.transferred = this.buildInfoRow(this.player().localize("Total Transfered"));
		this.download = this.buildInfoRow(this.player().localize("Download Breakdown"));
		this.liveLatency = this.buildInfoRow(this.player().localize("Live Latency"));
		this.infoListEl.appendChild(this.playerMode.root);
		this.infoListEl.appendChild(this.uuid.root);
		this.infoListEl.appendChild(this.viewport.root);
		this.infoListEl.appendChild(this.resolution.root);
		this.infoListEl.appendChild(this.volume.root);
		this.infoListEl.appendChild(this.codecs.root);
		this.infoListEl.appendChild(this.color.root);
		this.infoListEl.appendChild(this.bufferProgress.root);
		this.infoListEl.appendChild(this.bufferState.root);
		this.infoListEl.appendChild(this.connection.root);
		this.infoListEl.appendChild(this.p2p.root);
		this.infoListEl.appendChild(this.peers.root);
		this.infoListEl.appendChild(this.network.root);
		this.infoListEl.appendChild(this.transferred.root);
		this.infoListEl.appendChild(this.download.root);
		this.infoListEl.appendChild(this.liveLatency.root);
	}
	populateInfoValues(options) {
		const { playerNetworkInfo, progress, colorSpace, codecs, resolution, buffer, latency, latencyFromEdge } = options;
		const { downloadedFromServer, downloadedFromPeers } = playerNetworkInfo;
		const player = this.player();
		const videoQuality = player.getVideoPlaybackQuality();
		const vp = `${Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)}x${Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)}*${(window.devicePixelRatio || 1).toFixed(2)}`;
		const { droppedVideoFrames, totalVideoFrames } = videoQuality;
		const frames = player.localize("{1} / {2} dropped of {3}", [
			vp,
			droppedVideoFrames + "",
			totalVideoFrames + ""
		]);
		const duration = player.duration();
		let volume = `${Math.round(player.volume() * 100)}`;
		if (player.muted()) volume += player.localize(" (muted)");
		const networkActivity = playerNetworkInfo.downloadSpeed ? `${playerNetworkInfo.downloadSpeed} \u21D3 / ${playerNetworkInfo.uploadSpeed} \u21D1` : void 0;
		let totalTransferred = playerNetworkInfo.totalDownloaded ? `${playerNetworkInfo.totalDownloaded} \u21D3` : "";
		if (playerNetworkInfo.totalUploaded) totalTransferred += `/ ${playerNetworkInfo.totalUploaded} \u21D1`;
		const downloadBreakdown = playerNetworkInfo.downloadedFromServer ? player.localize("{1} from servers · {2} from peers", [downloadedFromServer, downloadedFromPeers]) : void 0;
		const bufferProgress = progress !== void 0 ? `${(progress * 100).toFixed(1)}% (${(progress * duration).toFixed(1)}s)` : void 0;
		const p2pEnabled = this.options_.p2pEnabled && this.mode === "p2p-media-loader";
		this.setInfoValue(this.playerMode, this.mode === "p2p-media-loader" ? "P2P Media Loader (v2)" : "Web Video");
		this.setInfoValue(this.uuid, this.options_.videoUUID);
		this.setInfoValue(this.viewport, frames);
		this.setInfoValue(this.resolution, resolution);
		this.setInfoValue(this.volume, volume);
		this.setInfoValue(this.codecs, codecs);
		this.setInfoValue(this.color, colorSpace);
		this.setInfoValue(this.bufferProgress, bufferProgress);
		this.setInfoValue(this.bufferState, buffer);
		this.setInfoValue(this.p2p, p2pEnabled ? player.localize("enabled") : player.localize("disabled"));
		this.setInfoValue(this.peers, playerNetworkInfo.numPeers ? playerNetworkInfo.numPeers + "" : player.localize("no peers"));
		this.setInfoValue(this.connection, playerNetworkInfo.averageBandwidth);
		this.setInfoValue(this.network, networkActivity);
		this.setInfoValue(this.download, downloadBreakdown);
		this.setInfoValue(this.transferred, totalTransferred);
		if (latency && latencyFromEdge) this.setInfoValue(this.liveLatency, player.localize("{1} (from edge: {2})", [latency, latencyFromEdge]));
	}
	setInfoValue(el, value) {
		if (!value) {
			el.root.style.display = "none";
			return;
		}
		el.root.style.display = "block";
		if (el.value.innerText === value) return;
		el.value.innerText = value;
	}
	buildInfoRow(labelText) {
		const root = import_core.default.dom.createEl("div");
		root.style.display = "none";
		const label = import_core.default.dom.createEl("div", { innerText: labelText });
		const value = import_core.default.dom.createEl("span");
		root.appendChild(label);
		root.appendChild(value);
		return {
			root,
			value
		};
	}
	timeRangesToString(r) {
		let result = "";
		let i = 0;
		if (r.length > 10) {
			const toSkip = r.length - 10;
			result += this.player().localize(`(skipped {1} buffers) `, [toSkip + ""]);
			i = toSkip;
		}
		while (i < r.length) {
			const start = Math.floor(r.start(i));
			const end = Math.floor(r.end(i));
			result += `[${secondsToTime(start)}, ${secondsToTime(end)}] `;
			i++;
		}
		return result;
	}
};
import_core.default.registerComponent("StatsCard", StatsCard);
//#endregion
//#region src/shared/stats/stats-plugin.ts
var Plugin$2 = import_core.default.getPlugin("plugin");
var StatsForNerdsPlugin = class extends Plugin$2 {
	constructor(player, options) {
		super(player);
		this.player.ready(() => {
			player.addClass("vjs-stats-for-nerds");
		});
		this.statsCard = new StatsCard(player, options);
		player.addChild(this.statsCard);
	}
	dispose() {
		if (this.statsCard) {
			this.statsCard.dispose();
			this.player.removeChild(this.statsCard);
		}
		super.dispose();
	}
	show() {
		this.statsCard.show();
	}
};
import_core.default.registerPlugin("stats", StatsForNerdsPlugin);
//#endregion
//#region src/shared/upnext/end-card.ts
function getMainTemplate(options) {
	return `
    <div class="vjs-upnext-top">
      <span class="vjs-upnext-headtext">${options.headText}</span>
      <div class="vjs-upnext-title"></div>
    </div>
    <div class="vjs-upnext-autoplay-icon">
      <svg height="100%" version="1.1" viewbox="0 0 98 98" width="100%">
        <circle class="vjs-upnext-svg-autoplay-circle" cx="49" cy="49" fill="#000" fill-opacity="0.8" r="48"></circle>
        <circle class="vjs-upnext-svg-autoplay-ring" cx="-49" cy="49" fill-opacity="0" r="46.5"
                stroke="#FFFFFF" stroke-width="4" transform="rotate(-90)"
        ></circle>
        <polygon class="vjs-upnext-svg-autoplay-triangle" fill="#fff" points="32,27 72,49 32,71"></polygon></svg>
    </div>
    <span class="vjs-upnext-bottom">
      <span class="vjs-upnext-cancel">
        <button class="vjs-upnext-cancel-button" tabindex="0" aria-label="Cancel autoplay">${options.cancelText}</button>
      </span>
      <span class="vjs-upnext-suspended">${options.suspendedText}</span>
    </span>
  `;
}
var Component = import_core.default.getComponent("Component");
var EndCard = class extends Component {
	constructor(player, options) {
		super(player, options);
		this.dashOffsetTotal = 586;
		this.dashOffsetStart = 293;
		this.interval = 50;
		this.upNextEvents = new import_core.default.EventTarget();
		this.ticks = 0;
		this.totalTicks = this.options_.timeout / this.interval;
		this.onEndedHandler = () => {
			if (!this.options_.isDisplayed()) return;
			player.addClass("vjs-upnext--showing");
			this.showCard((canceled) => {
				player.removeClass("vjs-upnext--showing");
				this.container.style.display = "none";
				if (!canceled) this.options_.next();
			});
		};
		this.onPlayingHandler = () => {
			this.upNextEvents.trigger("playing");
		};
		player.on(["auto-stopped", "ended"], this.onEndedHandler);
		player.on("playing", this.onPlayingHandler);
	}
	dispose() {
		if (this.onEndedHandler) this.player().off(["auto-stopped", "ended"], this.onEndedHandler);
		if (this.onPlayingHandler) this.player().off("playing", this.onPlayingHandler);
		if (this.timeout) clearTimeout(this.timeout);
		super.dispose();
	}
	createEl() {
		const container = super.createEl("div", {
			className: "vjs-upnext-content",
			innerHTML: getMainTemplate(this.options_)
		});
		this.container = container;
		container.style.display = "none";
		this.autoplayRing = container.getElementsByClassName("vjs-upnext-svg-autoplay-ring")[0];
		this.title = container.getElementsByClassName("vjs-upnext-title")[0];
		this.cancelButton = container.getElementsByClassName("vjs-upnext-cancel-button")[0];
		this.suspendedMessage = container.getElementsByClassName("vjs-upnext-suspended")[0];
		this.nextButton = container.getElementsByClassName("vjs-upnext-autoplay-icon")[0];
		this.cancelButton.onclick = () => {
			this.upNextEvents.trigger("cancel");
		};
		this.nextButton.onclick = () => {
			this.upNextEvents.trigger("next");
		};
		return container;
	}
	showCard(cb) {
		this.autoplayRing.setAttribute("stroke-dasharray", `${this.dashOffsetStart}`);
		this.autoplayRing.setAttribute("stroke-dashoffset", `${-this.dashOffsetStart}`);
		this.title.innerText = this.options_.getTitle();
		if (this.totalTicks === 0) return cb(false);
		this.upNextEvents.one("cancel", () => {
			clearTimeout(this.timeout);
			this.timeout = void 0;
			cb(true);
		});
		this.upNextEvents.one("playing", () => {
			clearTimeout(this.timeout);
			this.timeout = void 0;
			cb(true);
		});
		this.upNextEvents.one("next", () => {
			clearTimeout(this.timeout);
			this.timeout = void 0;
			cb(false);
		});
		const goToPercent = (percent) => {
			const newOffset = Math.max(-this.dashOffsetTotal, -this.dashOffsetStart - percent * this.dashOffsetTotal / 2 / 100);
			this.autoplayRing.setAttribute("stroke-dashoffset", "" + newOffset);
		};
		const tick = () => {
			goToPercent(this.ticks++ * 100 / this.totalTicks);
		};
		const update = () => {
			if (this.options_.isSuspended()) {
				this.suspendedMessage.innerText = this.options_.suspendedText;
				goToPercent(0);
				this.ticks = 0;
				this.timeout = setTimeout(update.bind(this), 300);
			} else if (this.ticks >= this.totalTicks) {
				clearTimeout(this.timeout);
				this.timeout = void 0;
				cb(false);
			} else {
				this.suspendedMessage.innerText = "";
				tick();
				this.timeout = setTimeout(update.bind(this), this.interval);
			}
		};
		this.container.style.display = "block";
		this.timeout = setTimeout(update.bind(this), this.interval);
	}
};
import_core.default.registerComponent("EndCard", EndCard);
//#endregion
//#region src/shared/upnext/upnext-plugin.ts
var Plugin$1 = import_core.default.getPlugin("plugin");
var UpNextPlugin = class extends Plugin$1 {
	constructor(player, options) {
		super(player);
		const settings = {
			next: options.next,
			getTitle: options.getTitle,
			timeout: options.timeout,
			cancelText: player.localize("Cancel"),
			headText: player.localize("Up Next"),
			suspendedText: player.localize("Autoplay is suspended"),
			isDisplayed: options.isDisplayed,
			isSuspended: options.isSuspended
		};
		this.player.ready(() => {
			player.addClass("vjs-upnext");
		});
		const component = new EndCard(player, settings);
		player.addChild(component);
		this.on("dispose", () => player.removeChild(component));
	}
};
import_core.default.registerPlugin("upnext", UpNextPlugin);
//#endregion
//#region src/shared/web-video/web-video-plugin.ts
var debugLogger = (0, import_browser.default)("peertube:player:web-video-plugin");
var Plugin = import_core.default.getPlugin("plugin");
var WebVideoPlugin = class extends Plugin {
	constructor(player, options) {
		super(player);
		this.videoFiles = options.videoFiles;
		this.videoFileToken = options.videoFileToken;
		const videoEl = this.player.tech(true)?.el();
		if (videoEl) videoEl.setAttribute("crossorigin", "anonymous");
		const videoFile = this.pickInitialVideoFile();
		if (videoFile) this.updateVideoFile({
			videoFile,
			isUserResolutionChange: false
		});
		this.onLoadedMetadata = () => {
			player.trigger("video-ratio-changed", { ratio: this.player.videoWidth() / this.player.videoHeight() });
		};
		player.on("loadedmetadata", this.onLoadedMetadata);
		player.ready(() => {
			if (this.videoFiles.length === 0) {
				this.player.addClass("disabled");
				return;
			}
			this.buildQualities();
			this.setupNetworkInfoInterval();
		});
	}
	dispose() {
		if (this.networkInfoInterval) clearInterval(this.networkInfoInterval);
		if (this.onLoadedMetadata) this.player.off("loadedmetadata", this.onLoadedMetadata);
		if (this.onErrorHandler) this.player.off("error", this.onErrorHandler);
		if (this.onPlayHandler) this.player.off("canplay", this.onPlayHandler);
		super.dispose();
	}
	getCurrentResolutionId() {
		return this.currentVideoFile?.resolution.id;
	}
	updateVideoFile(options) {
		this.currentVideoFile = options.videoFile;
		debugLogger("Updating web video file to " + this.currentVideoFile.fileUrl);
		const paused = this.player.paused();
		const currentTime = this.player.currentTime();
		if (!this.onErrorHandler) {
			this.onErrorHandler = () => this.player.peertube().displayFatalError();
			this.player.one("error", this.onErrorHandler);
		}
		let httpUrl = this.currentVideoFile.fileUrl;
		if (this.videoFileToken()) httpUrl = addQueryParams(httpUrl, { videoFileToken: this.videoFileToken() });
		const oldAutoplayValue = this.player.autoplay();
		if (options.isUserResolutionChange) {
			this.player.autoplay(false);
			this.player.addClass("vjs-updating-resolution");
		}
		if (this.onPlayHandler) this.player.off("canplay", this.onPlayHandler);
		this.onPlayHandler = () => {
			this.player.currentTime(currentTime);
			this.player.trigger("resolution-change", {
				resolution: this.currentVideoFile?.resolution.id,
				initResolutionChange: !options.isUserResolutionChange
			});
			if (options.isUserResolutionChange) {
				this.player.trigger("web-video-source-change");
				this.tryToPlay().then(() => {
					if (paused) this.player.pause();
					this.player.autoplay(oldAutoplayValue);
				});
			}
		};
		this.player.one("canplay", this.onPlayHandler);
		this.player.src(httpUrl);
		if (options.isUserResolutionChange) this.player.preload("auto");
	}
	getCurrentVideoFile() {
		return this.currentVideoFile;
	}
	tryToPlay() {
		debugLogger("Try to play manually the video");
		const playPromise = this.player.play();
		if (playPromise === void 0) return;
		return playPromise.catch((err) => {
			if (err.message.includes("The play() request was interrupted by a call to pause()")) return;
			logger$1.warn(err);
			this.player.pause();
			this.player.posterImage.show();
			this.player.removeClass("vjs-has-autoplay");
			this.player.removeClass("vjs-playing-audio-only-content");
		}).finally(() => {
			this.player.removeClass("vjs-updating-resolution");
		});
	}
	pickAverageVideoFile() {
		if (!this.videoFiles || this.videoFiles.length === 0) return void 0;
		if (this.videoFiles.length === 1) return this.videoFiles[0];
		const files = this.videoFiles.filter((f) => f.resolution.id !== 0);
		return files[Math.floor(files.length / 2)];
	}
	pickInitialVideoFile() {
		const preferredResolution = getStoredPreferredResolution();
		if (preferredResolution === void 0) return this.pickAverageVideoFile();
		const sortedVideoFiles = [...this.videoFiles].sort((a, b) => a.resolution.id - b.resolution.id);
		const exactMatch = sortedVideoFiles.find((videoFile) => videoFile.resolution.id === preferredResolution);
		if (exactMatch) return exactMatch;
		const nearestAbove = sortedVideoFiles.find((videoFile) => videoFile.resolution.id >= preferredResolution);
		if (nearestAbove) return nearestAbove;
		const nearestBelow = [...sortedVideoFiles].reverse().find((videoFile) => videoFile.resolution.id < preferredResolution);
		if (nearestBelow) return nearestBelow;
		return this.pickAverageVideoFile();
	}
	buildQualities() {
		const resolutions = this.videoFiles.map((videoFile) => ({
			id: videoFile.resolution.id,
			label: this.player.localize(getResolutionAndFPSLabel(videoFile.resolution.label, videoFile.fps)),
			height: videoFile.resolution.id,
			selected: videoFile.id === this.currentVideoFile?.id,
			selectCallback: () => this.updateVideoFile({
				videoFile,
				isUserResolutionChange: true
			})
		}));
		this.player.peertubeResolutions().add(resolutions);
	}
	setupNetworkInfoInterval() {
		this.networkInfoInterval = setInterval(() => {
			const player = this.player;
			if (!player) return;
			return player.trigger("network-info", {
				source: "web-video",
				http: { downloaded: player.bufferedPercent() * this.currentVideoFile?.size }
			});
		}, 1e3);
	}
};
import_core.default.registerPlugin("webVideo", WebVideoPlugin);
//#endregion
//#region src/peertube-player.ts
var CaptionsButton = import_core.default.getComponent("CaptionsButton");
CaptionsButton.prototype.controlText_ = "Subtitles/CC";
CaptionsButton.prototype.label_ = " ";
var PlaybackRateMenuButton = import_core.default.getComponent("PlaybackRateMenuButton");
PlaybackRateMenuButton.prototype.controlText_ = "Speed";
var PlayProgressBar = import_core.default.getComponent("PlayProgressBar");
if (PlayProgressBar.prototype.options_.children.includes("timeTooltip") !== true) PlayProgressBar.prototype.options_.children.push("timeTooltip");
var PeerTubePlayer = class {
	pluginsManager;
	videojsDecodeErrors = 0;
	player;
	currentLoadOptions;
	constructor(options) {
		this.options = options;
		this.pluginsManager = options.pluginsManager;
	}
	unload() {
		if (!this.player) return;
		this.disposeDynamicPluginsIfNeeded();
		this.player.reset();
	}
	async load(loadOptions) {
		this.currentLoadOptions = loadOptions;
		this.setPoster([]);
		this.disposeDynamicPluginsIfNeeded();
		await this.buildPlayerIfNeeded();
		for (const theme of ["galaxy", "lucide"]) this.player.removeClass("vjs-peertube-theme-" + theme);
		this.player.addClass("vjs-peertube-theme-" + loadOptions.theme);
		if (this.currentLoadOptions.mode === "p2p-media-loader") await this.loadP2PMediaLoader();
		else this.loadWebVideo();
		this.loadDynamicPlugins();
		if (this.options.controlBar === false) this.player.controlBar.hide();
		else this.player.controlBar.show();
		this.player.autoplay(this.getAutoPlayValue(this.currentLoadOptions.autoplay));
		if (!this.player.autoplay()) this.setPoster(loadOptions.thumbnails);
		this.player.trigger("video-change");
	}
	getPlayer() {
		return this.player;
	}
	destroy() {
		if (this.player) {
			this.disposeDynamicPluginsIfNeeded();
			this.player.dispose();
		}
		this.player = void 0;
		this.currentLoadOptions = void 0;
		this.pluginsManager = void 0;
	}
	setPoster(thumbnails) {
		if (!this.player) {
			const width = this.options.playerElement().clientWidth || window.innerWidth || screen.availWidth;
			this.options.playerElement().poster = findAppropriateThumbnail(thumbnails, width, "16:9")?.fileUrl || "";
			return;
		}
		if (this.player) {
			const width = this.player.el().clientWidth || window.innerWidth;
			this.player.poster(findAppropriateThumbnail(thumbnails, width, "16:9")?.fileUrl || "");
		}
		this.options.playerElement().poster = "";
	}
	enable() {
		if (!this.player) return;
		this.player.el().style.pointerEvents = "auto";
	}
	disable() {
		if (!this.player) return;
		if (this.player.isFullscreen()) this.player.exitFullscreen();
		this.player.hasStarted(false);
		this.player.removeClass("vjs-has-autoplay");
		this.player.bigPlayButton.hide();
		this.player.el().style.pointerEvents = "none";
	}
	setCurrentTime(currentTime) {
		if (!this.player.hasStarted_) {
			this.currentLoadOptions.startTime = currentTime;
			this.player.play();
			return;
		}
		this.player.currentTime(currentTime);
		this.player.userActive(true);
	}
	async loadP2PMediaLoader() {
		const { hlsjs, p2pMediaLoader } = await new HLSOptionsBuilder({
			...pick(this.options, [
				"pluginsManager",
				"serverUrl",
				"authorizationHeader",
				"stunServers"
			]),
			...pick(this.currentLoadOptions, [
				"videoPassword",
				"requiresUserAuth",
				"videoFileToken",
				"requiresPassword",
				"isLive",
				"p2pEnabled",
				"liveOptions",
				"hls",
				"duration"
			])
		}).getPluginOptions();
		this.player.hlsjs(hlsjs);
		this.player.p2pMediaLoader(p2pMediaLoader);
	}
	loadWebVideo() {
		const webVideoOptionsBuilder = new WebVideoOptionsBuilder(pick(this.currentLoadOptions, [
			"videoFileToken",
			"webVideo",
			"hls"
		]));
		this.player.webVideo(webVideoOptionsBuilder.getPluginOptions());
	}
	async buildPlayerIfNeeded() {
		if (this.player) return;
		await TranslationsManager.loadLocaleInVideoJS(this.options.serverUrl, this.options.language, import_core.default);
		const videojsOptions = await this.pluginsManager.runHook("filter:internal.player.videojs.options.result", this.getVideojsOptions());
		this.player = (0, import_core.default)(this.options.playerElement(), videojsOptions);
		this.player.ready(() => {
			let alreadyFallback = false;
			const handleError = () => {
				if (alreadyFallback) return;
				alreadyFallback = true;
				if (this.currentLoadOptions.mode === "p2p-media-loader") this.tryToRecoverHLSError(this.player.error());
				else this.maybeFallbackToWebVideo();
			};
			this.player.on("video-change", () => alreadyFallback = false);
			this.player.on("error", () => handleError());
			this.player.on("network-info", (_, data) => {
				if (data.source !== "p2p-media-loader" || isNaN(data.bandwidthEstimate)) return;
				saveAverageBandwidth(Math.floor(data.bandwidthEstimate));
			});
			this.player.contextMenu(this.getContextMenuOptions());
			this.displayNotificationWhenOffline();
		});
	}
	disposeDynamicPluginsIfNeeded() {
		if (!this.player) return;
		if (this.player.usingPlugin("peertubeMobile")) this.player.peertubeMobile().dispose();
		if (this.player.usingPlugin("videoFlipHorizontallyPlugin")) this.player.videoFlipHorizontallyPlugin().dispose();
		if (this.player.usingPlugin("peerTubeHotkeysPlugin")) this.player.peerTubeHotkeysPlugin().dispose();
		if (this.player.usingPlugin("playlist")) this.player.playlist().dispose();
		if (this.player.usingPlugin("bezels")) this.player.bezels().dispose();
		if (this.player.usingPlugin("upnext")) this.player.upnext().dispose();
		if (this.player.usingPlugin("stats")) this.player.stats().dispose();
		if (this.player.usingPlugin("storyboard")) this.player.storyboard().dispose();
		if (this.player.usingPlugin("chapters")) this.player.chapters().dispose();
		if (this.player.usingPlugin("peertubeNSFW")) this.player.peertubeNSFW().dispose();
		if (this.player.usingPlugin("peertubeDock")) this.player.peertubeDock().dispose();
		if (this.player.usingPlugin("p2pMediaLoader")) this.player.p2pMediaLoader().dispose();
		if (this.player.usingPlugin("hlsjs")) this.player.hlsjs().dispose();
		if (this.player.usingPlugin("webVideo")) this.player.webVideo().dispose();
	}
	loadDynamicPlugins() {
		if (isMobile()) this.player.peertubeMobile();
		this.player.bezels();
		this.player.stats({
			videoUUID: this.currentLoadOptions.videoUUID,
			videoIsLive: this.currentLoadOptions.isLive,
			mode: this.currentLoadOptions.mode,
			p2pEnabled: this.currentLoadOptions.p2pEnabled
		});
		this.player.videoFlipHorizontallyPlugin();
		if (this.options.enableHotkeys === true) this.player.peerTubeHotkeysPlugin({
			isLive: this.currentLoadOptions.isLive,
			liveDvrEnabled: this.currentLoadOptions.liveOptions?.dvrEnabled === true
		});
		if (this.currentLoadOptions.playlist) this.player.playlist(this.currentLoadOptions.playlist);
		if (this.currentLoadOptions.upnext) this.player.upnext({
			timeout: this.currentLoadOptions.upnext.timeout,
			getTitle: () => this.currentLoadOptions.nextVideo.getVideoTitle(),
			next: () => this.currentLoadOptions.nextVideo.handler(),
			isDisplayed: () => this.currentLoadOptions.nextVideo.enabled && this.currentLoadOptions.upnext.isEnabled(),
			isSuspended: () => this.currentLoadOptions.upnext.isSuspended(this.player)
		});
		if (this.currentLoadOptions.storyboard) this.player.storyboard(this.currentLoadOptions.storyboard);
		if (this.currentLoadOptions.videoChapters) this.player.chapters({ chapters: this.currentLoadOptions.videoChapters });
		if (this.currentLoadOptions.dock) this.player.peertubeDock(this.currentLoadOptions.dock);
		if (this.currentLoadOptions.nsfwWarning) this.player.peertubeNSFW(this.currentLoadOptions.nsfwWarning);
	}
	async tryToRecoverHLSError(err) {
		if (err.code === MediaError.MEDIA_ERR_DECODE) {
			if (this.videojsDecodeErrors === 0) this.options.errorNotifier(this.player.localize("The video failed to play, will try to fast forward."));
			if (this.videojsDecodeErrors === 20) {
				this.maybeFallbackToWebVideo();
				return;
			}
			logger$1.info("Fast forwarding HLS to recover from an error.", {
				err,
				videoShortUUID: this.currentLoadOptions.videoShortUUID,
				currentTime: this.player.currentTime(),
				resolution: this.player.videoHeight()
			});
			this.videojsDecodeErrors++;
			await this.load({
				...this.currentLoadOptions,
				mode: "p2p-media-loader",
				startTime: this.player.currentTime() + 2,
				autoplay: true
			});
		} else this.maybeFallbackToWebVideo();
	}
	async maybeFallbackToWebVideo() {
		if (this.currentLoadOptions.mode === "web-video") {
			this.player.peertube().displayFatalError();
			return;
		}
		logger$1.info("Fallback to web-video.");
		await this.load({
			...this.currentLoadOptions,
			mode: "web-video",
			startTime: this.player.currentTime(),
			autoplay: true
		});
	}
	getVideojsOptions() {
		const posterWidth = this.options.playerElement().clientWidth || window.innerWidth;
		const poster = findAppropriateThumbnail(this.currentLoadOptions.thumbnails, posterWidth, "16:9")?.fileUrl || "";
		const html5 = {
			preloadTextTracks: false,
			nativeTextTracks: false
		};
		const plugins = {
			peertube: {
				hasAutoplay: () => this.getAutoPlayValue(this.currentLoadOptions.autoplay),
				videoViewUrl: () => this.currentLoadOptions.videoViewUrl,
				videoViewIntervalMs: this.options.videoViewIntervalMs,
				authorizationHeader: this.options.authorizationHeader,
				videoDuration: () => this.currentLoadOptions.duration,
				startTime: () => this.currentLoadOptions.startTime,
				stopTime: () => this.currentLoadOptions.stopTime,
				videoCaptions: () => this.currentLoadOptions.videoCaptions,
				isLive: () => this.currentLoadOptions.isLive,
				liveDvrEnabled: () => this.currentLoadOptions.liveOptions?.dvrEnabled === true,
				videoUUID: () => this.currentLoadOptions.videoUUID,
				subtitle: () => this.currentLoadOptions.subtitle,
				videoRatio: () => this.currentLoadOptions.videoRatio,
				poster: () => poster,
				playbackRate: this.options.playbackRate,
				autoPlayerRatio: this.options.autoPlayerRatio
			},
			metrics: {
				mode: () => this.currentLoadOptions.mode,
				metricsUrl: () => this.options.metricsUrl,
				metricsInterval: () => this.options.metricsInterval,
				videoUUID: () => this.currentLoadOptions.videoUUID
			}
		};
		const controlBarOptionsBuilder = new ControlBarOptionsBuilder({
			...this.options,
			videoShortUUID: () => this.currentLoadOptions.videoShortUUID,
			p2pEnabled: () => this.currentLoadOptions.p2pEnabled,
			nextVideo: () => this.currentLoadOptions.nextVideo,
			previousVideo: () => this.currentLoadOptions.previousVideo
		});
		return {
			html5,
			textTrackSettings: false,
			controls: this.options.controls !== void 0 ? this.options.controls : true,
			loop: this.options.loop !== void 0 ? this.options.loop : false,
			muted: this.options.muted !== void 0 ? this.options.muted : void 0,
			autoplay: this.getAutoPlayValue(this.currentLoadOptions.autoplay),
			poster,
			preload: "none",
			inactivityTimeout: this.options.inactivityTimeout,
			playbackRates: [
				.25,
				.5,
				.75,
				1,
				1.25,
				1.5,
				1.75,
				2,
				2.5,
				3
			],
			plugins,
			controlBar: { children: controlBarOptionsBuilder.getChildrenOptions() },
			language: this.options.language && !isDefaultLocale(this.options.language) ? this.options.language : void 0,
			enableSmoothSeeking: true
		};
	}
	getAutoPlayValue(autoplay) {
		if (autoplay !== true) return false;
		return this.currentLoadOptions.forceAutoplay ? "any" : "play";
	}
	displayNotificationWhenOffline() {
		const offlineNotificationElem = document.createElement("div");
		offlineNotificationElem.classList.add("vjs-peertube-offline-notification");
		offlineNotificationElem.innerText = this.player.localize("You seem to be offline and the video may not work");
		let offlineNotificationElemAdded = false;
		const handleOnline = () => {
			if (!offlineNotificationElemAdded) return;
			this.player.el().removeChild(offlineNotificationElem);
			offlineNotificationElemAdded = false;
			logger$1.info("The browser is online");
		};
		const handleOffline = () => {
			if (offlineNotificationElemAdded) return;
			this.player.el().appendChild(offlineNotificationElem);
			offlineNotificationElemAdded = true;
			logger$1.info("The browser is offline");
		};
		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);
		this.player.on("dispose", () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		});
	}
	getContextMenuOptions() {
		const content = () => {
			const self = this;
			const player = this.player;
			const shortUUID = self.currentLoadOptions.videoShortUUID;
			const isLoopEnabled = player.options_.loop;
			const items = [
				{
					icon: "repeat",
					label: player.localize("Play in loop") + (isLoopEnabled ? "<span class=\"vjs-icon-tick-white\"></span>" : ""),
					listener: function() {
						player.options_.loop = !isLoopEnabled;
					}
				},
				{
					label: player.localize("Copy the video URL"),
					listener: function() {
						copyToClipboard(buildVideoLink({ shortUUID }), player.el());
					}
				},
				{
					label: player.localize("Copy the video URL at the current time"),
					listener: function() {
						copyToClipboard(decorateVideoLink({
							url: buildVideoLink({ shortUUID }),
							startTime: player.currentTime()
						}), player.el());
					}
				},
				{
					icon: "code",
					label: player.localize("Copy embed code"),
					listener: () => {
						copyToClipboard(buildVideoOrPlaylistEmbed({
							embedUrl: self.currentLoadOptions.embedUrl,
							embedTitle: self.currentLoadOptions.embedTitle
						}), player.el());
					}
				}
			];
			items.push({
				icon: "info",
				label: player.localize("Stats for nerds"),
				listener: () => {
					player.stats().show();
				}
			});
			return items.map((i) => ({
				...i,
				label: `<span class="vjs-icon-${i.icon || "link-2"}"></span>` + i.label
			}));
		};
		return { content };
	}
};
//#endregion
var videojs = import_core.default;
export { PeerTubePlayer, cleanupVideoWatch, clearStoredPreferredResolution, getAverageBandwidthInStore, getPlayerSessionId, getStoredLastSubtitle, getStoredMute, getStoredPlaybackRate, getStoredPreferredResolution, getStoredPreferredSubtitle, getStoredTheater, getStoredVideoWatchHistory, getStoredVolume, saveAverageBandwidth, saveLastSubtitle, saveMuteInStore, savePlaybackRateInStore, savePreferredResolution, savePreferredSubtitle, saveTheaterInStore, saveVideoWatchHistory, saveVolumeInStore, videojs };
